//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.1.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AcademicTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getAcademicTitles(personId: number, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetAcademicTitleSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/AcademicTitle/GetAcademicTitles?";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined and cannot be null.");
        else
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcademicTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcademicTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAcademicTitleSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAcademicTitleSearchOutputDto>;
        }));
    }

    protected processGetAcademicTitles(response: HttpResponseBase): Observable<GetAcademicTitleSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAcademicTitleSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAcademicTitle(id: number | undefined): Observable<AcademicTitleDto> {
        let url_ = this.baseUrl + "/api/services/app/AcademicTitle/GetAcademicTitle?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcademicTitleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcademicTitleDto>;
        }));
    }

    protected processGetAcademicTitle(response: HttpResponseBase): Observable<AcademicTitleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcademicTitleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postAcademicTitle(body: CreateAcademicTitleDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AcademicTitle/PostAcademicTitle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPostAcademicTitle(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    putAcademicTitle(id: number | undefined, body: AcademicTitleDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AcademicTitle/PutAcademicTitle?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutAcademicTitle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param reason (optional) 
     * @return Success
     */
    deleteAcademicTitle(id: number | undefined, reason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AcademicTitle/DeleteAcademicTitle?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAcademicTitle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resolveTenantId(body: ResolveTenantIdInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResolveTenantId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processResolveTenantId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendPasswordResetCode(body: SendPasswordResetCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPasswordResetCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordInput | undefined): Observable<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordOutput>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmailActivationLink(body: SendEmailActivationLinkInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailActivationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailActivationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailActivationLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activateEmail(body: ActivateEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    impersonateUser(body: ImpersonateUserInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ImpersonateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processImpersonateUser(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    impersonateTenant(body: ImpersonateTenantInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ImpersonateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processImpersonateTenant(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    delegatedImpersonate(body: DelegatedImpersonateInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/DelegatedImpersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegatedImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegatedImpersonate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processDelegatedImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    backToImpersonator(): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackToImpersonator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackToImpersonator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processBackToImpersonator(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    switchToLinkedAccount(body: SwitchToLinkedAccountInput | undefined): Observable<SwitchToLinkedAccountOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchToLinkedAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchToLinkedAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwitchToLinkedAccountOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwitchToLinkedAccountOutput>;
        }));
    }

    protected processSwitchToLinkedAccount(response: HttpResponseBase): Observable<SwitchToLinkedAccountOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchToLinkedAccountOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdditionalInformationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getForEntity(discriminator: AdditionalInformationDiscriminator, entityId: number): Observable<GetAdditionalInformationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdditionalInformation/GetForEntity?";
        if (discriminator === undefined || discriminator === null)
            throw new Error("The parameter 'discriminator' must be defined and cannot be null.");
        else
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAdditionalInformationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAdditionalInformationDto[]>;
        }));
    }

    protected processGetForEntity(response: HttpResponseBase): Observable<GetAdditionalInformationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAdditionalInformationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetAdditionalInformationDto> {
        let url_ = this.baseUrl + "/api/services/app/AdditionalInformation/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAdditionalInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAdditionalInformationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetAdditionalInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAdditionalInformationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(discriminator: AdditionalInformationDiscriminator, entityId: number, body: AdditionalInformationDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AdditionalInformation/Create?";
        if (discriminator === undefined || discriminator === null)
            throw new Error("The parameter 'discriminator' must be defined and cannot be null.");
        else
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(id: number | undefined, body: AdditionalInformationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdditionalInformation/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdditionalInformation/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    gridSearch(body: AddressSearchInput | undefined): Observable<AddressSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/Address/GridSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGridSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGridSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressSearchOutput>;
        }));
    }

    protected processGridSearch(response: HttpResponseBase): Observable<AddressSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    formSearch(body: FormAddressSearchInput | undefined): Observable<AddressSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/Address/FormSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFormSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFormSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressSearchOutput>;
        }));
    }

    protected processFormSearch(response: HttpResponseBase): Observable<AddressSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AddressAutocompleteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param postCode (optional) 
     * @return Success
     */
    getCitiesByPostCode(postCode: string | undefined): Observable<KeyValuePairOfStringString[]> {
        let url_ = this.baseUrl + "/api/services/app/AddressAutocomplete/GetCitiesByPostCode?";
        if (postCode === null)
            throw new Error("The parameter 'postCode' cannot be null.");
        else if (postCode !== undefined)
            url_ += "postCode=" + encodeURIComponent("" + postCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCitiesByPostCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCitiesByPostCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValuePairOfStringString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValuePairOfStringString[]>;
        }));
    }

    protected processGetCitiesByPostCode(response: HttpResponseBase): Observable<KeyValuePairOfStringString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfStringString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param postCode (optional) 
     * @param cantonAbbreviation (optional) 
     * @return Success
     */
    isPostCodeInCanton(postCode: string | undefined, cantonAbbreviation: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/AddressAutocomplete/IsPostCodeInCanton?";
        if (postCode === null)
            throw new Error("The parameter 'postCode' cannot be null.");
        else if (postCode !== undefined)
            url_ += "postCode=" + encodeURIComponent("" + postCode) + "&";
        if (cantonAbbreviation === null)
            throw new Error("The parameter 'cantonAbbreviation' cannot be null.");
        else if (cantonAbbreviation !== undefined)
            url_ += "cantonAbbreviation=" + encodeURIComponent("" + cantonAbbreviation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsPostCodeInCanton(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsPostCodeInCanton(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsPostCodeInCanton(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cityId (optional) 
     * @param street (optional) 
     * @return Success
     */
    getStreetsByCity(cityId: number | undefined, street: string | undefined): Observable<KeyValuePairOfStringString[]> {
        let url_ = this.baseUrl + "/api/services/app/AddressAutocomplete/GetStreetsByCity?";
        if (cityId === null)
            throw new Error("The parameter 'cityId' cannot be null.");
        else if (cityId !== undefined)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        if (street === null)
            throw new Error("The parameter 'street' cannot be null.");
        else if (street !== undefined)
            url_ += "street=" + encodeURIComponent("" + street) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStreetsByCity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStreetsByCity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValuePairOfStringString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValuePairOfStringString[]>;
        }));
    }

    protected processGetStreetsByCity(response: HttpResponseBase): Observable<KeyValuePairOfStringString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfStringString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param streetId (optional) 
     * @param houseNumber (optional) 
     * @return Success
     */
    getHouseNumbersByStreetId(streetId: number | undefined, houseNumber: string | undefined): Observable<KeyValuePairOfStringString[]> {
        let url_ = this.baseUrl + "/api/services/app/AddressAutocomplete/GetHouseNumbersByStreetId?";
        if (streetId === null)
            throw new Error("The parameter 'streetId' cannot be null.");
        else if (streetId !== undefined)
            url_ += "streetId=" + encodeURIComponent("" + streetId) + "&";
        if (houseNumber === null)
            throw new Error("The parameter 'houseNumber' cannot be null.");
        else if (houseNumber !== undefined)
            url_ += "houseNumber=" + encodeURIComponent("" + houseNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHouseNumbersByStreetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHouseNumbersByStreetId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValuePairOfStringString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValuePairOfStringString[]>;
        }));
    }

    protected processGetHouseNumbersByStreetId(response: HttpResponseBase): Observable<KeyValuePairOfStringString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfStringString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param postCode (optional) 
     * @return Success
     */
    getCantonByPostCode(postCode: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AddressAutocomplete/GetCantonByPostCode?";
        if (postCode === null)
            throw new Error("The parameter 'postCode' cannot be null.");
        else if (postCode !== undefined)
            url_ += "postCode=" + encodeURIComponent("" + postCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCantonByPostCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCantonByPostCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCantonByPostCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdrisBusinessTransactionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param personId (optional) 
     * @param businessId (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getAdrisBusinessTransactions(personId: number | undefined, businessId: number | undefined, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetAdrisBusinessTransactionSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/AdrisBusinessTransaction/GetAdrisBusinessTransactions?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "BusinessId=" + encodeURIComponent("" + businessId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdrisBusinessTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdrisBusinessTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAdrisBusinessTransactionSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAdrisBusinessTransactionSearchOutput>;
        }));
    }

    protected processGetAdrisBusinessTransactions(response: HttpResponseBase): Observable<GetAdrisBusinessTransactionSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAdrisBusinessTransactionSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaAcademicTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateAlaAcademicTitle(body: CreateOrUpdateAlaAcademicTitleInput | undefined): Observable<CreateOrUpdateAlaAcademicTitleOutput> {
        let url_ = this.baseUrl + "/api/services/app/AlaAcademicTitle/CreateOrUpdateAlaAcademicTitle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAlaAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAlaAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateAlaAcademicTitleOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateAlaAcademicTitleOutput>;
        }));
    }

    protected processCreateOrUpdateAlaAcademicTitle(response: HttpResponseBase): Observable<CreateOrUpdateAlaAcademicTitleOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateAlaAcademicTitleOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createBlankAlaAcademicTitle(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AlaAcademicTitle/CreateBlankAlaAcademicTitle?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBlankAlaAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBlankAlaAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateBlankAlaAcademicTitle(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param academicTitleId (optional) 
     * @return Success
     */
    deleteAlaAcademicTitle(caseId: string | undefined, academicTitleId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AlaAcademicTitle/DeleteAlaAcademicTitle?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (academicTitleId === null)
            throw new Error("The parameter 'academicTitleId' cannot be null.");
        else if (academicTitleId !== undefined)
            url_ += "academicTitleId=" + encodeURIComponent("" + academicTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAlaAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAlaAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAlaAcademicTitle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAlaAcademicTitleFiles(body: GetAlaSubItemDocumentsInput | undefined): Observable<AlaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/AlaAcademicTitle/GetAlaAcademicTitleFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlaAcademicTitleFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlaAcademicTitleFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaDocumentsOutput>;
        }));
    }

    protected processGetAlaAcademicTitleFiles(response: HttpResponseBase): Observable<AlaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param alaAcademicTitleId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(alaAcademicTitleId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AlaAcademicTitle/UploadFiles?";
        if (alaAcademicTitleId === null)
            throw new Error("The parameter 'alaAcademicTitleId' cannot be null.");
        else if (alaAcademicTitleId !== undefined)
            url_ += "alaAcademicTitleId=" + encodeURIComponent("" + alaAcademicTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getList(caseId: string | undefined): Observable<AlaAcademicTitleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AlaAcademicTitle/GetList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaAcademicTitleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaAcademicTitleDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<AlaAcademicTitleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlaAcademicTitleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaApplicantContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAlaApplicantContact | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaApplicantContact/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<AlaApplicantContactDto> {
        let url_ = this.baseUrl + "/api/services/app/AlaApplicantContact/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaApplicantContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaApplicantContactDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlaApplicantContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaApplicantContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaApplicantPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    performRegisterCheck(caseId: string | undefined): Observable<AlaApplicantPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/AlaApplicantPerson/PerformRegisterCheck?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPerformRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPerformRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaApplicantPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaApplicantPersonDto>;
        }));
    }

    protected processPerformRegisterCheck(response: HttpResponseBase): Observable<AlaApplicantPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaApplicantPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    acceptRegisterCheck(caseId: string | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaApplicantPerson/AcceptRegisterCheck?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processAcceptRegisterCheck(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<AlaApplicantPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/AlaApplicantPerson/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaApplicantPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaApplicantPersonDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlaApplicantPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaApplicantPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaApplicantPersonExtrServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param gln (optional) 
     * @return Success
     */
    performRegisterCheck(caseId: string | undefined, gln: string | undefined): Observable<AlaApplicantPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/AlaApplicantPersonExtr/PerformRegisterCheck?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPerformRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPerformRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaApplicantPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaApplicantPersonDto>;
        }));
    }

    protected processPerformRegisterCheck(response: HttpResponseBase): Observable<AlaApplicantPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaApplicantPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    acceptRegisterCheck(caseId: string | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaApplicantPersonExtr/AcceptRegisterCheck?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processAcceptRegisterCheck(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<AlaApplicantPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/AlaApplicantPersonExtr/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaApplicantPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaApplicantPersonDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlaApplicantPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaApplicantPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaApplicantSponsorshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAlaApplicantSponsorship | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaApplicantSponsorship/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<AlaApplicantSponsorshipDto> {
        let url_ = this.baseUrl + "/api/services/app/AlaApplicantSponsorship/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaApplicantSponsorshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaApplicantSponsorshipDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlaApplicantSponsorshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaApplicantSponsorshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaBusinessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: AlaBusinessDto[] | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaBusiness/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getList(caseId: string | undefined): Observable<AlaBusinessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AlaBusiness/GetList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaBusinessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaBusinessDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<AlaBusinessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlaBusinessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaBusinessExtrServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAlaBusinessExtr | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaBusinessExtr/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<AlaBusinessExtrDto> {
        let url_ = this.baseUrl + "/api/services/app/AlaBusinessExtr/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaBusinessExtrDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaBusinessExtrDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlaBusinessExtrDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaBusinessExtrDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAlaContact | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaContact/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<AlaContactDto> {
        let url_ = this.baseUrl + "/api/services/app/AlaContact/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaContactDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlaContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaDiplomaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAlaDiploma | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaDiploma/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<AlaDiplomaDto> {
        let url_ = this.baseUrl + "/api/services/app/AlaDiploma/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaDiplomaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaDiplomaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlaDiplomaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaDiplomaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDocuments(body: GetAlaDocumentsInput | undefined): Observable<AlaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/AlaDocument/GetDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaDocumentsOutput>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<AlaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AlaDocument/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFile(body: GetAlaFileInput | undefined): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/AlaDocument/GetFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: AlaStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AlaDocument/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaEmploymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAlaEmploymentInput | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaEmployment/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param levelOfEmployment (optional) 
     * @return Success
     */
    doesNotExceedMaxLevelOfAssistantEmployment(caseId: string | undefined, levelOfEmployment: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/AlaEmployment/DoesNotExceedMaxLevelOfAssistantEmployment?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (levelOfEmployment === null)
            throw new Error("The parameter 'levelOfEmployment' cannot be null.");
        else if (levelOfEmployment !== undefined)
            url_ += "levelOfEmployment=" + encodeURIComponent("" + levelOfEmployment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDoesNotExceedMaxLevelOfAssistantEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDoesNotExceedMaxLevelOfAssistantEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDoesNotExceedMaxLevelOfAssistantEmployment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getList(caseId: string | undefined): Observable<GetAlaEmploymentOutput> {
        let url_ = this.baseUrl + "/api/services/app/AlaEmployment/GetList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAlaEmploymentOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAlaEmploymentOutput>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<GetAlaEmploymentOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAlaEmploymentOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaInvoiceAddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: AlaInvoiceAddressDto | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaInvoiceAddress/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<GetAlaInvoiceAddressOutput> {
        let url_ = this.baseUrl + "/api/services/app/AlaInvoiceAddress/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAlaInvoiceAddressOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAlaInvoiceAddressOutput>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetAlaInvoiceAddressOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAlaInvoiceAddressOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaLanguageSkillServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAlaLanguageSkillInput | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaLanguageSkill/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<AlaLanguageSkillDto> {
        let url_ = this.baseUrl + "/api/services/app/AlaLanguageSkill/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaLanguageSkillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaLanguageSkillDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlaLanguageSkillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaLanguageSkillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaLanguageSkillExtrServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAlaLanguageSkillExtrInput | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaLanguageSkillExtr/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<AlaLanguageSkillExtrDto> {
        let url_ = this.baseUrl + "/api/services/app/AlaLanguageSkillExtr/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaLanguageSkillExtrDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaLanguageSkillExtrDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlaLanguageSkillExtrDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaLanguageSkillExtrDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaMedicalFieldServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateAlaMedicalField(body: CreateOrUpdateAlaMedicalFieldInput | undefined): Observable<CreateOrUpdateAlaMedicalFieldOutput> {
        let url_ = this.baseUrl + "/api/services/app/AlaMedicalField/CreateOrUpdateAlaMedicalField";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAlaMedicalField(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAlaMedicalField(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateAlaMedicalFieldOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateAlaMedicalFieldOutput>;
        }));
    }

    protected processCreateOrUpdateAlaMedicalField(response: HttpResponseBase): Observable<CreateOrUpdateAlaMedicalFieldOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateAlaMedicalFieldOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<AlaMedicalFieldDto> {
        let url_ = this.baseUrl + "/api/services/app/AlaMedicalField/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaMedicalFieldDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaMedicalFieldDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlaMedicalFieldDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaMedicalFieldDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaMedicalFieldDirectorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAlaMedicalFieldDirector | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaMedicalFieldDirector/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<AlaMedicalFieldDirectorDto> {
        let url_ = this.baseUrl + "/api/services/app/AlaMedicalFieldDirector/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaMedicalFieldDirectorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaMedicalFieldDirectorDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlaMedicalFieldDirectorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaMedicalFieldDirectorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlapServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAlap(body: CreateAlaInput | undefined): Observable<CreateAlaOutput> {
        let url_ = this.baseUrl + "/api/services/app/Alap/CreateAlap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAlap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAlap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateAlaOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateAlaOutput>;
        }));
    }

    protected processCreateAlap(response: HttpResponseBase): Observable<CreateAlaOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateAlaOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyAlaps(): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Alap/GetMyAlaps";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyAlaps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyAlaps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetMyAlaps(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNextStatus(caseId: string, status: AlaStatus): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/Alap/GetNextStatus?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getAlapsForPerson(gln: string | undefined): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Alap/GetAlapsForPerson?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlapsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlapsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetAlapsForPerson(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getPersonIdForAla(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Alap/GetPersonIdForAla?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonIdForAla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonIdForAla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPersonIdForAla(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getAlap(caseId: string | undefined): Observable<GetAlaOutput> {
        let url_ = this.baseUrl + "/api/services/app/Alap/GetAlap?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAlaOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAlaOutput>;
        }));
    }

    protected processGetAlap(response: HttpResponseBase): Observable<GetAlaOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAlaOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseAlap(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Alap/ReleaseAlap?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseAlap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseAlap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseAlap(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Alap/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined): Observable<AlaStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/Alap/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<AlaStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAlaPerson | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaPerson/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<AlaPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/AlaPerson/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaPersonDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlaPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaPostgraduateTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateAlaPostgraduateTitles(body: CreateOrUpdateAlaPostgraduateTitleInput | undefined): Observable<CreateOrUpdateAlaPostgraduateTitleOutput> {
        let url_ = this.baseUrl + "/api/services/app/AlaPostgraduateTitle/CreateOrUpdateAlaPostgraduateTitles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAlaPostgraduateTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAlaPostgraduateTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateAlaPostgraduateTitleOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateAlaPostgraduateTitleOutput>;
        }));
    }

    protected processCreateOrUpdateAlaPostgraduateTitles(response: HttpResponseBase): Observable<CreateOrUpdateAlaPostgraduateTitleOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateAlaPostgraduateTitleOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getList(caseId: string | undefined): Observable<AlaPostgraduateTitleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AlaPostgraduateTitle/GetList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaPostgraduateTitleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaPostgraduateTitleDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<AlaPostgraduateTitleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlaPostgraduateTitleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaPreviousEmploymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateAlaPreviousEmployments(body: CreateOrUpdateAlaPreviousEmploymentInput | undefined): Observable<CreateOrUpdateAlaPreviousEmploymentOutput> {
        let url_ = this.baseUrl + "/api/services/app/AlaPreviousEmployment/CreateOrUpdateAlaPreviousEmployments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAlaPreviousEmployments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAlaPreviousEmployments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateAlaPreviousEmploymentOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateAlaPreviousEmploymentOutput>;
        }));
    }

    protected processCreateOrUpdateAlaPreviousEmployments(response: HttpResponseBase): Observable<CreateOrUpdateAlaPreviousEmploymentOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateAlaPreviousEmploymentOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getList(caseId: string | undefined): Observable<AlaPreviousEmploymentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AlaPreviousEmployment/GetList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaPreviousEmploymentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaPreviousEmploymentDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<AlaPreviousEmploymentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlaPreviousEmploymentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlapStatusWizardStepServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param professionId (optional) 
     * @param applicationType (optional) 
     * @return Success
     */
    getAllByProfessionId(professionId: string | undefined, applicationType: ApplicationType | undefined): Observable<AlapStatusWizardStepDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AlapStatusWizardStep/GetAllByProfessionId?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (applicationType === null)
            throw new Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByProfessionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByProfessionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlapStatusWizardStepDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlapStatusWizardStepDto[]>;
        }));
    }

    protected processGetAllByProfessionId(response: HttpResponseBase): Observable<AlapStatusWizardStepDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlapStatusWizardStepDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAlapStatusWizardStepInput | undefined): Observable<AlapStatusWizardStepDto> {
        let url_ = this.baseUrl + "/api/services/app/AlapStatusWizardStep/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlapStatusWizardStepDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlapStatusWizardStepDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AlapStatusWizardStepDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlapStatusWizardStepDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMany(body: UpdateAlapStatusWizardStepsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AlapStatusWizardStep/UpdateMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @param professionId (optional) 
     * @param applicationType (optional) 
     * @return Success
     */
    delete(step: number | undefined, professionId: string | undefined, applicationType: ApplicationType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AlapStatusWizardStep/Delete?";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (applicationType === null)
            throw new Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaRestrictionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateAlaRestrictions(body: CreateOrUpdateAlaRestrictionsInput | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaRestrictions/CreateOrUpdateAlaRestrictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAlaRestrictions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAlaRestrictions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdateAlaRestrictions(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getRestrictions(caseId: string | undefined): Observable<AlaRestrictionOutput> {
        let url_ = this.baseUrl + "/api/services/app/AlaRestrictions/GetRestrictions?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRestrictions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRestrictions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaRestrictionOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaRestrictionOutput>;
        }));
    }

    protected processGetRestrictions(response: HttpResponseBase): Observable<AlaRestrictionOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaRestrictionOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AnswerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 2147483647.
     * @return Success
     */
    getAnswerApplications(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfAnswerApplicationDto> {
        let url_ = this.baseUrl + "/api/services/app/Answer/GetAnswerApplications?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnswerApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnswerApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAnswerApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAnswerApplicationDto>;
        }));
    }

    protected processGetAnswerApplications(response: HttpResponseBase): Observable<PagedResultDtoOfAnswerApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAnswerApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAnswerApplicationDetail(id: number | undefined): Observable<AnswerApplicationDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Answer/GetAnswerApplicationDetail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnswerApplicationDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnswerApplicationDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnswerApplicationDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnswerApplicationDetailDto>;
        }));
    }

    protected processGetAnswerApplicationDetail(response: HttpResponseBase): Observable<AnswerApplicationDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnswerApplicationDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param answerApplicationId (optional) 
     * @param documentId (optional) 
     * @return Success
     */
    getDocument(answerApplicationId: number | undefined, documentId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Answer/GetDocument?";
        if (answerApplicationId === null)
            throw new Error("The parameter 'answerApplicationId' cannot be null.");
        else if (answerApplicationId !== undefined)
            url_ += "answerApplicationId=" + encodeURIComponent("" + answerApplicationId) + "&";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDocument(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param responsibleId (optional) 
     * @return Success
     */
    assignResponsible(id: number | undefined, responsibleId: number | undefined): Observable<AssignAnswerApplicationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Answer/AssignResponsible?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (responsibleId === null)
            throw new Error("The parameter 'responsibleId' cannot be null.");
        else if (responsibleId !== undefined)
            url_ += "responsibleId=" + encodeURIComponent("" + responsibleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignResponsible(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignResponsible(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignAnswerApplicationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignAnswerApplicationOutput>;
        }));
    }

    protected processAssignResponsible(response: HttpResponseBase): Observable<AssignAnswerApplicationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignAnswerApplicationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    assignToMe(id: number | undefined): Observable<AssignAnswerApplicationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Answer/AssignToMe?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignToMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignToMe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignAnswerApplicationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignAnswerApplicationOutput>;
        }));
    }

    protected processAssignToMe(response: HttpResponseBase): Observable<AssignAnswerApplicationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignAnswerApplicationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    unassign(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Answer/Unassign?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassign(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    verify(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Answer/Verify?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerify(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerify(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param reason (optional) 
     * @return Success
     */
    reject(id: number | undefined, reason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Answer/Reject?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AppDocumentDownloadServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadBinaryData(body: AppDocumentDownloadInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AppDocumentDownload/UploadBinaryData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBinaryData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBinaryData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadBinaryData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBinaryData(id: AppDownloadBinaryObjectId | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AppDocumentDownload/GetBinaryData?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBinaryData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBinaryData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetBinaryData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ApplicationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getApplication(caseId: string | undefined): Observable<ApplicationDto> {
        let url_ = this.baseUrl + "/api/services/app/Application/GetApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationDto>;
        }));
    }

    protected processGetApplication(response: HttpResponseBase): Observable<ApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getResultDocuments(caseId: string | undefined): Observable<GetResultDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Application/GetResultDocuments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResultDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResultDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetResultDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetResultDocumentsOutput>;
        }));
    }

    protected processGetResultDocuments(response: HttpResponseBase): Observable<GetResultDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetResultDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadResultDocument(body: GeneralResultDocumentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/UploadResultDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadResultDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadResultDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadResultDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param docId (optional) 
     * @return Success
     */
    deleteResultDocument(caseId: string | undefined, docId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/DeleteResultDocument?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (docId === null)
            throw new Error("The parameter 'docId' cannot be null.");
        else if (docId !== undefined)
            url_ += "docId=" + encodeURIComponent("" + docId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteResultDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteResultDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteResultDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getResultFile(caseId: string, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Application/GetResultFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResultFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResultFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetResultFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getApplicationHistoryStatusDocument(caseId: string, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Application/GetApplicationHistoryStatusDocument?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationHistoryStatusDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationHistoryStatusDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetApplicationHistoryStatusDocument(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getApplicationAuthorityHistoryDocument(caseId: string, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Application/GetApplicationAuthorityHistoryDocument?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationAuthorityHistoryDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationAuthorityHistoryDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetApplicationAuthorityHistoryDocument(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignApplication(body: AssignApplicationInput | undefined): Observable<AssignApplicationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Application/AssignApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignApplicationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignApplicationOutput>;
        }));
    }

    protected processAssignApplication(response: HttpResponseBase): Observable<AssignApplicationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignApplicationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    unassignApplication(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/UnassignApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    startPreEvaluation(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/StartPreEvaluation?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartPreEvaluation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartPreEvaluation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStartPreEvaluation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    reactivateApplication(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/ReactivateApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReactivateApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    startEvaluation(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/StartEvaluation?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartEvaluation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartEvaluation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStartEvaluation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEvaluation(body: EvaluationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/UpdateEvaluation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEvaluation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEvaluation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEvaluation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestForSupplementalInformation(body: RequestForSupplementalInformationInput | undefined): Observable<ApplicationDto> {
        let url_ = this.baseUrl + "/api/services/app/Application/RequestForSupplementalInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestForSupplementalInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestForSupplementalInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationDto>;
        }));
    }

    protected processRequestForSupplementalInformation(response: HttpResponseBase): Observable<ApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setSupplementalInformationReminderDate(body: SetSupplementalInformationReminderDateInput | undefined): Observable<ApplicationDto> {
        let url_ = this.baseUrl + "/api/services/app/Application/SetSupplementalInformationReminderDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSupplementalInformationReminderDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSupplementalInformationReminderDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationDto>;
        }));
    }

    protected processSetSupplementalInformationReminderDate(response: HttpResponseBase): Observable<ApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param ehcCaseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    withdrawApplication(caseId: string | undefined, ehcCaseId: string | undefined, body: WithdrawApplicationInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/WithdrawApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (ehcCaseId === null)
            throw new Error("The parameter 'ehcCaseId' cannot be null.");
        else if (ehcCaseId !== undefined)
            url_ += "ehcCaseId=" + encodeURIComponent("" + ehcCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithdrawApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithdrawApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWithdrawApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    deleteApplication(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/DeleteApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    setApplicationUnderConstruction(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/SetApplicationUnderConstruction?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetApplicationUnderConstruction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetApplicationUnderConstruction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetApplicationUnderConstruction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    formallyEvaluateApplication(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/FormallyEvaluateApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFormallyEvaluateApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFormallyEvaluateApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFormallyEvaluateApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    notConsiderApplication(caseId: string | undefined, body: NotConsiderApplicationInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/NotConsiderApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotConsiderApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotConsiderApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotConsiderApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param stepId (optional) 
     * @return Success
     */
    setStepToReview(caseId: string | undefined, stepId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/SetStepToReview?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (stepId === null)
            throw new Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetStepToReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetStepToReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetStepToReview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSupplementalClaimAnnexFilesOfStep(caseId: string, applicationWizardStep: number): Observable<GeneralDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Application/GetSupplementalClaimAnnexFilesOfStep?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicationWizardStep === undefined || applicationWizardStep === null)
            throw new Error("The parameter 'applicationWizardStep' must be defined and cannot be null.");
        else
            url_ += "ApplicationWizardStep=" + encodeURIComponent("" + applicationWizardStep) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplementalClaimAnnexFilesOfStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplementalClaimAnnexFilesOfStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralDocumentsOutput>;
        }));
    }

    protected processGetSupplementalClaimAnnexFilesOfStep(response: HttpResponseBase): Observable<GeneralDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAuthorityFile(caseId: string, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Application/GetAuthorityFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorityFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorityFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetAuthorityFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param wizardStep (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadAuthorityFiles(wizardStep: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Application/UploadAuthorityFiles?";
        if (wizardStep === null)
            throw new Error("The parameter 'wizardStep' cannot be null.");
        else if (wizardStep !== undefined)
            url_ += "wizardStep=" + encodeURIComponent("" + wizardStep) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAuthorityFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAuthorityFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadAuthorityFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteAuthorityFile(id: number, caseId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/DeleteAuthorityFile?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAuthorityFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAuthorityFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAuthorityFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteAuthorityFiles(wizardStep: number, caseId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/DeleteAuthorityFiles?";
        if (wizardStep === undefined || wizardStep === null)
            throw new Error("The parameter 'wizardStep' must be defined and cannot be null.");
        else
            url_ += "WizardStep=" + encodeURIComponent("" + wizardStep) + "&";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAuthorityFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAuthorityFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAuthorityFiles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getJournalRecords(caseId: string | undefined): Observable<ApplicationJournalRecordDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Application/GetJournalRecords?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJournalRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJournalRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationJournalRecordDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationJournalRecordDto[]>;
        }));
    }

    protected processGetJournalRecords(response: HttpResponseBase): Observable<ApplicationJournalRecordDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationJournalRecordDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createJournalRecord(body: CreateApplicationJournalRecordInput | undefined): Observable<ApplicationJournalRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/Application/CreateJournalRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateJournalRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateJournalRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationJournalRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationJournalRecordDto>;
        }));
    }

    protected processCreateJournalRecord(response: HttpResponseBase): Observable<ApplicationJournalRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationJournalRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param recordId (optional) 
     * @return Success
     */
    deleteJournalRecord(caseId: string | undefined, recordId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/DeleteJournalRecord?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (recordId === null)
            throw new Error("The parameter 'recordId' cannot be null.");
        else if (recordId !== undefined)
            url_ += "RecordId=" + encodeURIComponent("" + recordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteJournalRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJournalRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteJournalRecord(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setApplicationsInSubmitted(body: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/SetApplicationsInSubmitted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetApplicationsInSubmitted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetApplicationsInSubmitted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetApplicationsInSubmitted(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getAdditionalDocumentsForApplication(caseId: string | undefined): Observable<GeneralDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Application/GetAdditionalDocumentsForApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdditionalDocumentsForApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdditionalDocumentsForApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralDocumentsOutput>;
        }));
    }

    protected processGetAdditionalDocumentsForApplication(response: HttpResponseBase): Observable<GeneralDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAdditionalFile(caseId: string, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Application/GetAdditionalFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdditionalFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdditionalFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetAdditionalFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadAdditionalFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Application/UploadAdditionalFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAdditionalFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAdditionalFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadAdditionalFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteAdditionalFile(id: number, caseId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/DeleteAdditionalFile?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAdditionalFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAdditionalFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAdditionalFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    generateGuid(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Application/GenerateGuid";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateGuid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateGuid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateGuid(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ApplicationEmploymentPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ApplicationEmploymentPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationEmploymentPerson/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationEmploymentPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationEmploymentPersonDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApplicationEmploymentPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationEmploymentPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ApplicationEmploymentPersonDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationEmploymentPerson/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAuditLogEntry(id: number | undefined): Observable<AuditLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogEntry?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditLogListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditLogListDto>;
        }));
    }

    protected processGetAuditLogEntry(response: HttpResponseBase): Observable<AuditLogListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditLogListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getAuditLogs(id: number | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAuditLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName === null)
            throw new Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName === null)
            throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo === null)
            throw new Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException === null)
            throw new Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration === null)
            throw new Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration === null)
            throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAuditLogListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAuditLogListDto>;
        }));
    }

    protected processGetAuditLogs(response: HttpResponseBase): Observable<PagedResultDtoOfAuditLogListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAuditLogListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getAuditLogsToExcel(id: number | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName === null)
            throw new Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName === null)
            throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo === null)
            throw new Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException === null)
            throw new Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration === null)
            throw new Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration === null)
            throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAuditLogsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEntityHistoryObjectTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityHistoryObjectTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityHistoryObjectTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityHistoryObjectTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetEntityHistoryObjectTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param entityId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getEntityChanges(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, entityTypeFullName: string | undefined, entityId: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChanges?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }));
    }

    protected processGetEntityChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityTypeFullName (optional) 
     * @param entityId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getEntityTypeChanges(entityTypeFullName: string | undefined, entityId: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityTypeChanges?";
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityTypeChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityTypeChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }));
    }

    protected processGetEntityTypeChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param entityId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getEntityChangesToExcel(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, entityTypeFullName: string | undefined, entityId: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChangesToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChangesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChangesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetEntityChangesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityChangeId (optional) 
     * @return Success
     */
    getEntityPropertyChanges(entityChangeId: number | undefined): Observable<EntityPropertyChangeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityPropertyChanges?";
        if (entityChangeId === null)
            throw new Error("The parameter 'entityChangeId' cannot be null.");
        else if (entityChangeId !== undefined)
            url_ += "entityChangeId=" + encodeURIComponent("" + entityChangeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityPropertyChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityPropertyChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityPropertyChangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityPropertyChangeDto[]>;
        }));
    }

    protected processGetEntityPropertyChanges(response: HttpResponseBase): Observable<EntityPropertyChangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPropertyChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityTypeFullName (optional) 
     * @param entityId (optional) 
     * @return Success
     */
    getDeleteReason(entityTypeFullName: string | undefined, entityId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetDeleteReason?";
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "entityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeleteReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeleteReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDeleteReason(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BankDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getPersonBankDetails(personId: number | undefined): Observable<GetBankDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/BankDetails/GetPersonBankDetails?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonBankDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonBankDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBankDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBankDetailsDto>;
        }));
    }

    protected processGetPersonBankDetails(response: HttpResponseBase): Observable<GetBankDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBankDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @return Success
     */
    getSponsorshipBankDetails(sponsorshipId: number | undefined): Observable<GetBankDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/BankDetails/GetSponsorshipBankDetails?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorshipBankDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorshipBankDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBankDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBankDetailsDto>;
        }));
    }

    protected processGetSponsorshipBankDetails(response: HttpResponseBase): Observable<GetBankDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBankDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    savePersonBankDetails(body: UpdateBankDetailsInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/BankDetails/SavePersonBankDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePersonBankDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePersonBankDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSavePersonBankDetails(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveSponsorshipBankDetails(body: UpdateBankDetailsInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/BankDetails/SaveSponsorshipBankDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSponsorshipBankDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSponsorshipBankDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSaveSponsorshipBankDetails(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BusinessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param isArchived (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getBusinesses(isArchived: boolean | undefined, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetBusinessesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Business/GetBusinesses?";
        if (isArchived === null)
            throw new Error("The parameter 'isArchived' cannot be null.");
        else if (isArchived !== undefined)
            url_ += "IsArchived=" + encodeURIComponent("" + isArchived) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinesses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinesses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBusinessesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBusinessesOutput>;
        }));
    }

    protected processGetBusinesses(response: HttpResponseBase): Observable<GetBusinessesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBusinessesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchBusinessesForSponsorship(body: BusinessSearchInput | undefined): Observable<BusinessSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/Business/SearchBusinessesForSponsorship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchBusinessesForSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchBusinessesForSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessSearchOutput>;
        }));
    }

    protected processSearchBusinessesForSponsorship(response: HttpResponseBase): Observable<BusinessSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusinessSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @return Success
     */
    getBusinessesForSponsorship(sponsorshipId: number | undefined): Observable<BusinessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Business/GetBusinessesForSponsorship?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessesForSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessesForSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessDto[]>;
        }));
    }

    protected processGetBusinessesForSponsorship(response: HttpResponseBase): Observable<BusinessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BusinessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param corporateLicenceId (optional) 
     * @return Success
     */
    getBusinessesForCorporateLicence(corporateLicenceId: number | undefined): Observable<BusinessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Business/GetBusinessesForCorporateLicence?";
        if (corporateLicenceId === null)
            throw new Error("The parameter 'corporateLicenceId' cannot be null.");
        else if (corporateLicenceId !== undefined)
            url_ += "corporateLicenceId=" + encodeURIComponent("" + corporateLicenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessesForCorporateLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessesForCorporateLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessDto[]>;
        }));
    }

    protected processGetBusinessesForCorporateLicence(response: HttpResponseBase): Observable<BusinessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BusinessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    createBlankBusiness(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Business/CreateBlankBusiness";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBlankBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBlankBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateBlankBusiness(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBusiness(body: UpdateBusinessInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Business/UpdateBusiness";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBusiness(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param isArchived (optional) 
     * @return Success
     */
    setArchiveFlag(id: number | undefined, isArchived: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Business/SetArchiveFlag?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isArchived === null)
            throw new Error("The parameter 'isArchived' cannot be null.");
        else if (isArchived !== undefined)
            url_ += "isArchived=" + encodeURIComponent("" + isArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetArchiveFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetArchiveFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetArchiveFlag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param businessId (optional) 
     * @return Success
     */
    getBusinessById(businessId: number | undefined): Observable<BusinessDto> {
        let url_ = this.baseUrl + "/api/services/app/Business/GetBusinessById?";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessDto>;
        }));
    }

    protected processGetBusinessById(response: HttpResponseBase): Observable<BusinessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusinessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBusiness(body: CreateBusinessDto | undefined): Observable<BusinessDto> {
        let url_ = this.baseUrl + "/api/services/app/Business/CreateBusiness";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessDto>;
        }));
    }

    protected processCreateBusiness(response: HttpResponseBase): Observable<BusinessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusinessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @param employmentAddressId (optional) 
     * @return Success
     */
    createBusinessFromEmploymentAddress(sponsorshipId: number | undefined, employmentAddressId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Business/CreateBusinessFromEmploymentAddress?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        if (employmentAddressId === null)
            throw new Error("The parameter 'employmentAddressId' cannot be null.");
        else if (employmentAddressId !== undefined)
            url_ += "employmentAddressId=" + encodeURIComponent("" + employmentAddressId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBusinessFromEmploymentAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBusinessFromEmploymentAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateBusinessFromEmploymentAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employmentAddressId (optional) 
     * @param businessId (optional) 
     * @return Success
     */
    replaceEmploymentAddressWithBusiness(employmentAddressId: number | undefined, businessId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Business/ReplaceEmploymentAddressWithBusiness?";
        if (employmentAddressId === null)
            throw new Error("The parameter 'employmentAddressId' cannot be null.");
        else if (employmentAddressId !== undefined)
            url_ += "employmentAddressId=" + encodeURIComponent("" + employmentAddressId) + "&";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplaceEmploymentAddressWithBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplaceEmploymentAddressWithBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReplaceEmploymentAddressWithBusiness(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param reason (optional) 
     * @return Success
     */
    deleteBusiness(id: number | undefined, reason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Business/DeleteBusiness?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBusiness(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deassignBusinessFromSponsorship(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Business/DeassignBusinessFromSponsorship?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeassignBusinessFromSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeassignBusinessFromSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeassignBusinessFromSponsorship(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAndLinkBusiness(body: CreateAndLinkBusinessInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Business/CreateAndLinkBusiness";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndLinkBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndLinkBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateAndLinkBusiness(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAndLinkBusinessToExpenseHealthCarePersonalLicenceEmployment(body: CreateAndLinkBusinessInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Business/CreateAndLinkBusinessToExpenseHealthCarePersonalLicenceEmployment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndLinkBusinessToExpenseHealthCarePersonalLicenceEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndLinkBusinessToExpenseHealthCarePersonalLicenceEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateAndLinkBusinessToExpenseHealthCarePersonalLicenceEmployment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param businessId (optional) 
     * @param sponsorshipId (optional) 
     * @param employmentAddressToReplaceId (optional) 
     * @return Success
     */
    linkBusinessToSponsorship(businessId: number | undefined, sponsorshipId: number | undefined, employmentAddressToReplaceId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Business/LinkBusinessToSponsorship?";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        if (employmentAddressToReplaceId === null)
            throw new Error("The parameter 'employmentAddressToReplaceId' cannot be null.");
        else if (employmentAddressToReplaceId !== undefined)
            url_ += "employmentAddressToReplaceId=" + encodeURIComponent("" + employmentAddressToReplaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkBusinessToSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkBusinessToSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkBusinessToSponsorship(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param newBusinessId (optional) 
     * @param sponsorshipId (optional) 
     * @param businessToDeleteId (optional) 
     * @return Success
     */
    replaceBusiness(newBusinessId: number | undefined, sponsorshipId: number | undefined, businessToDeleteId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Business/ReplaceBusiness?";
        if (newBusinessId === null)
            throw new Error("The parameter 'newBusinessId' cannot be null.");
        else if (newBusinessId !== undefined)
            url_ += "newBusinessId=" + encodeURIComponent("" + newBusinessId) + "&";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        if (businessToDeleteId === null)
            throw new Error("The parameter 'businessToDeleteId' cannot be null.");
        else if (businessToDeleteId !== undefined)
            url_ += "businessToDeleteId=" + encodeURIComponent("" + businessToDeleteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplaceBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplaceBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReplaceBusiness(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param businessId (optional) 
     * @return Success
     */
    makeBusinessDefinite(businessId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Business/MakeBusinessDefinite?";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMakeBusinessDefinite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMakeBusinessDefinite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMakeBusinessDefinite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getAllCaches(): Observable<ListResultDtoOfCacheDto> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfCacheDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfCacheDto>;
        }));
    }

    protected processGetAllCaches(response: HttpResponseBase): Observable<ListResultDtoOfCacheDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfCacheDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clearCache(body: EntityDtoOfString | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ChatServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getUserChatFriendsWithSettings(): Observable<GetUserChatFriendsWithSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatFriendsWithSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatFriendsWithSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatFriendsWithSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
        }));
    }

    protected processGetUserChatFriendsWithSettings(response: HttpResponseBase): Observable<GetUserChatFriendsWithSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserChatFriendsWithSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) The field UserId must be between 1 and 9.223372036854776E+18.
     * @param minMessageId (optional) 
     * @return Success
     */
    getUserChatMessages(tenantId: number | undefined, userId: number | undefined, minMessageId: number | undefined): Observable<ListResultDtoOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatMessages?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (minMessageId === null)
            throw new Error("The parameter 'minMessageId' cannot be null.");
        else if (minMessageId !== undefined)
            url_ += "MinMessageId=" + encodeURIComponent("" + minMessageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfChatMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfChatMessageDto>;
        }));
    }

    protected processGetUserChatMessages(response: HttpResponseBase): Observable<ListResultDtoOfChatMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfChatMessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markAllUnreadMessagesOfUserAsRead(body: MarkAllUnreadMessagesOfUserAsReadInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllUnreadMessagesOfUserAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAllUnreadMessagesOfUserAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCla(body: CreateClaInput | undefined): Observable<CreateClaOutput> {
        let url_ = this.baseUrl + "/api/services/app/Cla/CreateCla";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateClaOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateClaOutput>;
        }));
    }

    protected processCreateCla(response: HttpResponseBase): Observable<CreateClaOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateClaOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyClas(): Observable<SponsorshipApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cla/GetMyClas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyClas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyClas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SponsorshipApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SponsorshipApplicationSummaryDto[]>;
        }));
    }

    protected processGetMyClas(response: HttpResponseBase): Observable<SponsorshipApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SponsorshipApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNextStatus(caseId: string, status: ClaStatus): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/Cla/GetNextStatus?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setNextStatus(body: GetClaNextStatusInput | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/Cla/SetNextStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processSetNextStatus(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getClasForSponsorship(uid: string): Observable<SponsorshipApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cla/GetClasForSponsorship?";
        if (uid === undefined || uid === null)
            throw new Error("The parameter 'uid' must be defined and cannot be null.");
        else
            url_ += "uid=" + encodeURIComponent("" + uid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClasForSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClasForSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SponsorshipApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SponsorshipApplicationSummaryDto[]>;
        }));
    }

    protected processGetClasForSponsorship(response: HttpResponseBase): Observable<SponsorshipApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SponsorshipApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getCorporateLicenceForCla(caseId: string | undefined): Observable<GetClaCorporateLicenceDto> {
        let url_ = this.baseUrl + "/api/services/app/Cla/GetCorporateLicenceForCla?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCorporateLicenceForCla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCorporateLicenceForCla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetClaCorporateLicenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetClaCorporateLicenceDto>;
        }));
    }

    protected processGetCorporateLicenceForCla(response: HttpResponseBase): Observable<GetClaCorporateLicenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClaCorporateLicenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getCla(caseId: string | undefined): Observable<GetClaOutput> {
        let url_ = this.baseUrl + "/api/services/app/Cla/GetCla?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetClaOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetClaOutput>;
        }));
    }

    protected processGetCla(response: HttpResponseBase): Observable<GetClaOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClaOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @param sponsorshipTypeId (optional) 
     * @param body (optional) 
     * @return Success
     */
    hasLicenceForRenewal(sponsorshipId: number | undefined, sponsorshipTypeId: ApplicationType | undefined, body: ApplicationType | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Cla/HasLicenceForRenewal?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        if (sponsorshipTypeId === null)
            throw new Error("The parameter 'sponsorshipTypeId' cannot be null.");
        else if (sponsorshipTypeId !== undefined)
            url_ += "sponsorshipTypeId=" + encodeURIComponent("" + sponsorshipTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasLicenceForRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasLicenceForRenewal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasLicenceForRenewal(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseCla(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cla/ReleaseCla?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseCla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseCla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseCla(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    hasLinkedCla(caseId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Cla/HasLinkedCla?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasLinkedCla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasLinkedCla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasLinkedCla(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @param releaseAction (optional) 
     * @return Success
     */
    releaseCombinedApplications(caseId: string | undefined, applicantComment: string | undefined, releaseAction: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cla/ReleaseCombinedApplications?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        if (releaseAction === null)
            throw new Error("The parameter 'releaseAction' cannot be null.");
        else if (releaseAction !== undefined)
            url_ += "releaseAction=" + encodeURIComponent("" + releaseAction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseCombinedApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseCombinedApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseCombinedApplications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    setClaOnWaitingAndCreateEhc(caseId: string | undefined, applicantComment: string | undefined): Observable<SetClaOnWaitingAndCreateEhcOutput> {
        let url_ = this.baseUrl + "/api/services/app/Cla/SetClaOnWaitingAndCreateEhc?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetClaOnWaitingAndCreateEhc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetClaOnWaitingAndCreateEhc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetClaOnWaitingAndCreateEhcOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetClaOnWaitingAndCreateEhcOutput>;
        }));
    }

    protected processSetClaOnWaitingAndCreateEhc(response: HttpResponseBase): Observable<SetClaOnWaitingAndCreateEhcOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetClaOnWaitingAndCreateEhcOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Cla/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined): Observable<ClaStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/Cla/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<ClaStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaAcademicTitleAlasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateClaAcademicTitle(body: CreateOrUpdateClaAcademicTitleAlasInput | undefined): Observable<CreateOrUpdateClaAcademicTitleAlasOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaAcademicTitleAlas/CreateOrUpdateClaAcademicTitle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateClaAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateClaAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateClaAcademicTitleAlasOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateClaAcademicTitleAlasOutput>;
        }));
    }

    protected processCreateOrUpdateClaAcademicTitle(response: HttpResponseBase): Observable<CreateOrUpdateClaAcademicTitleAlasOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateClaAcademicTitleAlasOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createBlankClaAcademicTitle(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaAcademicTitleAlas/CreateBlankClaAcademicTitle?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBlankClaAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBlankClaAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateBlankClaAcademicTitle(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param academicTitleId (optional) 
     * @return Success
     */
    deleteClaAcademicTitle(caseId: string | undefined, academicTitleId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClaAcademicTitleAlas/DeleteClaAcademicTitle?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (academicTitleId === null)
            throw new Error("The parameter 'academicTitleId' cannot be null.");
        else if (academicTitleId !== undefined)
            url_ += "academicTitleId=" + encodeURIComponent("" + academicTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteClaAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteClaAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteClaAcademicTitle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getClaAcademicTitleFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaAcademicTitleAlas/GetClaAcademicTitleFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClaAcademicTitleFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClaAcademicTitleFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetClaAcademicTitleFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param claAcademicTitleId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(claAcademicTitleId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaAcademicTitleAlas/UploadFiles?";
        if (claAcademicTitleId === null)
            throw new Error("The parameter 'claAcademicTitleId' cannot be null.");
        else if (claAcademicTitleId !== undefined)
            url_ += "claAcademicTitleId=" + encodeURIComponent("" + claAcademicTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getList(caseId: string | undefined): Observable<ClaAcademicTitleAlasDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaAcademicTitleAlas/GetList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaAcademicTitleAlasDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaAcademicTitleAlasDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ClaAcademicTitleAlasDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaAcademicTitleAlasDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaAidingResourcesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param aidingResourcesId (optional) 
     * @return Success
     */
    createPlaceholderAidingResources(caseId: string | undefined, aidingResourcesId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaAidingResources/CreatePlaceholderAidingResources?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (aidingResourcesId === null)
            throw new Error("The parameter 'aidingResourcesId' cannot be null.");
        else if (aidingResourcesId !== undefined)
            url_ += "AidingResourcesId=" + encodeURIComponent("" + aidingResourcesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderAidingResources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderAidingResources(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderAidingResources(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAidingResourcesList(body: UpdateClaAidingResourcesInput | undefined): Observable<UpdateClaAidingResourcesOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaAidingResources/UpdateAidingResourcesList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAidingResourcesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAidingResourcesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaAidingResourcesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaAidingResourcesOutput>;
        }));
    }

    protected processUpdateAidingResourcesList(response: HttpResponseBase): Observable<UpdateClaAidingResourcesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaAidingResourcesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaAssistantPhysicianServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getAssistantPhysicians(caseId: string | undefined): Observable<ClaAssistantPhysicianDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaAssistantPhysician/GetAssistantPhysicians?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssistantPhysicians(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssistantPhysicians(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaAssistantPhysicianDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaAssistantPhysicianDto[]>;
        }));
    }

    protected processGetAssistantPhysicians(response: HttpResponseBase): Observable<ClaAssistantPhysicianDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaAssistantPhysicianDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createPlaceholderAssistantPhysician(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaAssistantPhysician/CreatePlaceholderAssistantPhysician?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderAssistantPhysician(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderAssistantPhysician(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderAssistantPhysician(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAssistantPhysicians(body: UpdateClaAssistantPhysiciansInput | undefined): Observable<UpdateClaAssistantPhysiciansOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaAssistantPhysician/UpdateAssistantPhysicians";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssistantPhysicians(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssistantPhysicians(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaAssistantPhysiciansOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaAssistantPhysiciansOutput>;
        }));
    }

    protected processUpdateAssistantPhysicians(response: HttpResponseBase): Observable<UpdateClaAssistantPhysiciansOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaAssistantPhysiciansOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaAuthorizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getAuthorization(caseId: string | undefined): Observable<ClaAuthorizationDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaAuthorization/GetAuthorization?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaAuthorizationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaAuthorizationDto>;
        }));
    }

    protected processGetAuthorization(response: HttpResponseBase): Observable<ClaAuthorizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaAuthorizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateAuthorization(body: CreateOrUpdateClaAuthorizationInput | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/ClaAuthorization/CreateOrUpdateAuthorization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAuthorization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAuthorization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processCreateOrUpdateAuthorization(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaBusinessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getBusinesses(caseId: string | undefined): Observable<ClaBusinessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaBusiness/GetBusinesses?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinesses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinesses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaBusinessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaBusinessDto[]>;
        }));
    }

    protected processGetBusinesses(response: HttpResponseBase): Observable<ClaBusinessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaBusinessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createPlaceholderBusiness(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaBusiness/CreatePlaceholderBusiness?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderBusiness(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBusinesses(body: UpdateClaBusinessesInput | undefined): Observable<UpdateClaBusinessesOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaBusiness/UpdateBusinesses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBusinesses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBusinesses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaBusinessesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaBusinessesOutput>;
        }));
    }

    protected processUpdateBusinesses(response: HttpResponseBase): Observable<UpdateClaBusinessesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaBusinessesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getBusinessDirectors(caseId: string | undefined): Observable<ClaBusinessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaBusiness/GetBusinessDirectors?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessDirectors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessDirectors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaBusinessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaBusinessDto[]>;
        }));
    }

    protected processGetBusinessDirectors(response: HttpResponseBase): Observable<ClaBusinessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaBusinessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param businessId (optional) 
     * @return Success
     */
    createPlaceholderBusinessDirector(caseId: string | undefined, businessId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaBusiness/CreatePlaceholderBusinessDirector?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderBusinessDirector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderBusinessDirector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderBusinessDirector(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBusinessDirectors(body: UpdateClaBusinessDirectorsInput | undefined): Observable<UpdateClaBusinessDirectorsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaBusiness/UpdateBusinessDirectors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBusinessDirectors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBusinessDirectors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaBusinessDirectorsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaBusinessDirectorsOutput>;
        }));
    }

    protected processUpdateBusinessDirectors(response: HttpResponseBase): Observable<UpdateClaBusinessDirectorsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaBusinessDirectorsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaBusinessAlasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: ClaBusinessAlasDto[] | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/ClaBusinessAlas/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getList(caseId: string | undefined): Observable<ClaBusinessAlasDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaBusinessAlas/GetList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaBusinessAlasDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaBusinessAlasDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ClaBusinessAlasDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaBusinessAlasDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaBusinessSelectServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getBusinesses(caseId: string | undefined): Observable<ClaSelectedBusinessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaBusinessSelect/GetBusinesses?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinesses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinesses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaSelectedBusinessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaSelectedBusinessDto[]>;
        }));
    }

    protected processGetBusinesses(response: HttpResponseBase): Observable<ClaSelectedBusinessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaSelectedBusinessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateSelectedBusinesses(body: CreateOrUpdateClaSelectedBusinessesInput | undefined): Observable<CreateOrUpdateClaSelectedBusinessesOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaBusinessSelect/CreateOrUpdateSelectedBusinesses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateSelectedBusinesses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateSelectedBusinesses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateClaSelectedBusinessesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateClaSelectedBusinessesOutput>;
        }));
    }

    protected processCreateOrUpdateSelectedBusinesses(response: HttpResponseBase): Observable<CreateOrUpdateClaSelectedBusinessesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateClaSelectedBusinessesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaContactAlasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateClaContactAlasInput | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/ClaContactAlas/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<ClaContactAlasDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaContactAlas/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaContactAlasDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaContactAlasDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ClaContactAlasDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaContactAlasDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaCurrentAssistantsAlasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getList(caseId: string | undefined): Observable<EmploymentWithPersonDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaCurrentAssistantsAlas/GetList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmploymentWithPersonDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmploymentWithPersonDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<EmploymentWithPersonDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmploymentWithPersonDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaDiplomaAlasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateClaDiplomaAlasInput | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/ClaDiplomaAlas/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<ClaDiplomaAlasDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaDiplomaAlas/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDiplomaAlasDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDiplomaAlasDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ClaDiplomaAlasDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDiplomaAlasDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDocuments(body: GetClaDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSponsorshipDirectorFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetSponsorshipDirectorFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorshipDirectorFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorshipDirectorFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetSponsorshipDirectorFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getHeadOfNursingServicesFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetHeadOfNursingServicesFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHeadOfNursingServicesFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHeadOfNursingServicesFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetHeadOfNursingServicesFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getHeadOfNursingServicesRepresentativeFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetHeadOfNursingServicesRepresentativeFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHeadOfNursingServicesRepresentativeFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHeadOfNursingServicesRepresentativeFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetHeadOfNursingServicesRepresentativeFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMedicalFieldDirectorDocuments(body: GetClaDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetMedicalFieldDirectorDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalFieldDirectorDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalFieldDirectorDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetMedicalFieldDirectorDocuments(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMedicalFieldDirectorRepresentativeDocuments(body: GetClaDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetMedicalFieldDirectorRepresentativeDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalFieldDirectorRepresentativeDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalFieldDirectorRepresentativeDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetMedicalFieldDirectorRepresentativeDocuments(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBusinessFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetBusinessFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetBusinessFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBusinessDirectorFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetBusinessDirectorFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessDirectorFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessDirectorFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetBusinessDirectorFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRangeOfServicesFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetRangeOfServicesFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRangeOfServicesFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRangeOfServicesFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetRangeOfServicesFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPersonelFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetPersonelFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonelFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonelFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetPersonelFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getInfrastructureFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetInfrastructureFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfrastructureFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfrastructureFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetInfrastructureFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSecurityFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetSecurityFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSecurityFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecurityFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetSecurityFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMedicalFieldPersonFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetMedicalFieldPersonFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalFieldPersonFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalFieldPersonFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetMedicalFieldPersonFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAssistantPhysicianFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetAssistantPhysicianFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssistantPhysicianFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssistantPhysicianFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetAssistantPhysicianFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRangeOfProductsFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetRangeOfProductsFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRangeOfProductsFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRangeOfProductsFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetRangeOfProductsFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDrugProductionFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetDrugProductionFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDrugProductionFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDrugProductionFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetDrugProductionFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getOnlineDrugSalesFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetOnlineDrugSalesFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnlineDrugSalesFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnlineDrugSalesFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetOnlineDrugSalesFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param directorId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadSponsorshipDirectorFiles(directorId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadSponsorshipDirectorFiles?";
        if (directorId === null)
            throw new Error("The parameter 'directorId' cannot be null.");
        else if (directorId !== undefined)
            url_ += "directorId=" + encodeURIComponent("" + directorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSponsorshipDirectorFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSponsorshipDirectorFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadSponsorshipDirectorFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param headOfNursingServicesId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadHeadOfNursingServicesFiles(headOfNursingServicesId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadHeadOfNursingServicesFiles?";
        if (headOfNursingServicesId === null)
            throw new Error("The parameter 'headOfNursingServicesId' cannot be null.");
        else if (headOfNursingServicesId !== undefined)
            url_ += "headOfNursingServicesId=" + encodeURIComponent("" + headOfNursingServicesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadHeadOfNursingServicesFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadHeadOfNursingServicesFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadHeadOfNursingServicesFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param headOfNursingServicesRepresentativeId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadHeadOfNursingServicesRepresentativeFiles(headOfNursingServicesRepresentativeId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadHeadOfNursingServicesRepresentativeFiles?";
        if (headOfNursingServicesRepresentativeId === null)
            throw new Error("The parameter 'headOfNursingServicesRepresentativeId' cannot be null.");
        else if (headOfNursingServicesRepresentativeId !== undefined)
            url_ += "headOfNursingServicesRepresentativeId=" + encodeURIComponent("" + headOfNursingServicesRepresentativeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadHeadOfNursingServicesRepresentativeFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadHeadOfNursingServicesRepresentativeFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadHeadOfNursingServicesRepresentativeFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadMedicalFieldDirectorFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadMedicalFieldDirectorFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMedicalFieldDirectorFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMedicalFieldDirectorFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadMedicalFieldDirectorFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadMedicalFieldDirectorRepresentativeFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadMedicalFieldDirectorRepresentativeFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMedicalFieldDirectorRepresentativeFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMedicalFieldDirectorRepresentativeFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadMedicalFieldDirectorRepresentativeFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param businessId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadBusinessFiles(businessId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadBusinessFiles?";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBusinessFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBusinessFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadBusinessFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param directorId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadBusinessDirectorFiles(directorId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadBusinessDirectorFiles?";
        if (directorId === null)
            throw new Error("The parameter 'directorId' cannot be null.");
        else if (directorId !== undefined)
            url_ += "directorId=" + encodeURIComponent("" + directorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBusinessDirectorFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBusinessDirectorFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadBusinessDirectorFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param rangeOfServicesId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadRangeOfServicesFiles(rangeOfServicesId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadRangeOfServicesFiles?";
        if (rangeOfServicesId === null)
            throw new Error("The parameter 'rangeOfServicesId' cannot be null.");
        else if (rangeOfServicesId !== undefined)
            url_ += "rangeOfServicesId=" + encodeURIComponent("" + rangeOfServicesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadRangeOfServicesFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadRangeOfServicesFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadRangeOfServicesFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personelId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadPersonelFiles(personelId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadPersonelFiles?";
        if (personelId === null)
            throw new Error("The parameter 'personelId' cannot be null.");
        else if (personelId !== undefined)
            url_ += "personelId=" + encodeURIComponent("" + personelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPersonelFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPersonelFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadPersonelFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param infrastructureId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadInfrastructureFiles(infrastructureId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadInfrastructureFiles?";
        if (infrastructureId === null)
            throw new Error("The parameter 'infrastructureId' cannot be null.");
        else if (infrastructureId !== undefined)
            url_ += "infrastructureId=" + encodeURIComponent("" + infrastructureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadInfrastructureFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadInfrastructureFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadInfrastructureFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param securityId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadSecurityFiles(securityId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadSecurityFiles?";
        if (securityId === null)
            throw new Error("The parameter 'securityId' cannot be null.");
        else if (securityId !== undefined)
            url_ += "securityId=" + encodeURIComponent("" + securityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSecurityFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSecurityFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadSecurityFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param medicalFieldPersonId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadMedicalFieldPersonFiles(medicalFieldPersonId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadMedicalFieldPersonFiles?";
        if (medicalFieldPersonId === null)
            throw new Error("The parameter 'medicalFieldPersonId' cannot be null.");
        else if (medicalFieldPersonId !== undefined)
            url_ += "medicalFieldPersonId=" + encodeURIComponent("" + medicalFieldPersonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMedicalFieldPersonFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMedicalFieldPersonFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadMedicalFieldPersonFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param assistantPhysicianId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadAssistantPhysicianFiles(assistantPhysicianId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadAssistantPhysicianFiles?";
        if (assistantPhysicianId === null)
            throw new Error("The parameter 'assistantPhysicianId' cannot be null.");
        else if (assistantPhysicianId !== undefined)
            url_ += "assistantPhysicianId=" + encodeURIComponent("" + assistantPhysicianId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAssistantPhysicianFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAssistantPhysicianFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadAssistantPhysicianFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param rangeOfProductsId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadRangeOfProductsFiles(rangeOfProductsId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadRangeOfProductsFiles?";
        if (rangeOfProductsId === null)
            throw new Error("The parameter 'rangeOfProductsId' cannot be null.");
        else if (rangeOfProductsId !== undefined)
            url_ += "rangeOfProductsId=" + encodeURIComponent("" + rangeOfProductsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadRangeOfProductsFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadRangeOfProductsFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadRangeOfProductsFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param drugProductionId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadDrugProductionFiles(drugProductionId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadDrugProductionFiles?";
        if (drugProductionId === null)
            throw new Error("The parameter 'drugProductionId' cannot be null.");
        else if (drugProductionId !== undefined)
            url_ += "drugProductionId=" + encodeURIComponent("" + drugProductionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDrugProductionFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDrugProductionFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadDrugProductionFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param businessId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadOnlineDrugSalesFiles(businessId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadOnlineDrugSalesFiles?";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadOnlineDrugSalesFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadOnlineDrugSalesFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadOnlineDrugSalesFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFile(body: GetClaFileInput | undefined): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: ClaStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaDocumentAlasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDocuments(body: GetClaDocumentsAlasInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocumentAlas/GetDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocumentAlas/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFile(body: GetClaFileInput | undefined): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocumentAlas/GetFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: ClaStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocumentAlas/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaDrugChambersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param drugChambersId (optional) 
     * @return Success
     */
    createPlaceholderDrugChambers(caseId: string | undefined, drugChambersId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaDrugChambers/CreatePlaceholderDrugChambers?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (drugChambersId === null)
            throw new Error("The parameter 'drugChambersId' cannot be null.");
        else if (drugChambersId !== undefined)
            url_ += "DrugChambersId=" + encodeURIComponent("" + drugChambersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderDrugChambers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderDrugChambers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderDrugChambers(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDrugChambersList(body: UpdateClaDrugChambersInput | undefined): Observable<UpdateClaDrugChambersOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDrugChambers/UpdateDrugChambersList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDrugChambersList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDrugChambersList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaDrugChambersOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaDrugChambersOutput>;
        }));
    }

    protected processUpdateDrugChambersList(response: HttpResponseBase): Observable<UpdateClaDrugChambersOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaDrugChambersOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaElectronicPatientRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateClaElectronicPatientRecord(body: CreateOrUpdateClaElectronicPatientRecordInput | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/ClaElectronicPatientRecord/CreateOrUpdateClaElectronicPatientRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateClaElectronicPatientRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateClaElectronicPatientRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processCreateOrUpdateClaElectronicPatientRecord(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaEmploymentAlasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateClaEmploymentAlasInput | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/ClaEmploymentAlas/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getList(caseId: string | undefined): Observable<GetClaEmploymentAlasOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaEmploymentAlas/GetList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetClaEmploymentAlasOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetClaEmploymentAlasOutput>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<GetClaEmploymentAlasOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClaEmploymentAlasOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaExternalPointForComplaintsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getExternalPointForComplaints(caseId: string | undefined): Observable<ClaExternalPointForComplaintsDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaExternalPointForComplaints/GetExternalPointForComplaints?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalPointForComplaints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalPointForComplaints(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaExternalPointForComplaintsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaExternalPointForComplaintsDto>;
        }));
    }

    protected processGetExternalPointForComplaints(response: HttpResponseBase): Observable<ClaExternalPointForComplaintsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaExternalPointForComplaintsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateExternalPointForComplaints(body: UpdateClaExternalPointForComplaintsInput | undefined): Observable<UpdateClaExternalPointForComplaintsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaExternalPointForComplaints/UpdateExternalPointForComplaints";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExternalPointForComplaints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExternalPointForComplaints(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaExternalPointForComplaintsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaExternalPointForComplaintsOutput>;
        }));
    }

    protected processUpdateExternalPointForComplaints(response: HttpResponseBase): Observable<UpdateClaExternalPointForComplaintsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaExternalPointForComplaintsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaFloorsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param nursingBedsId (optional) 
     * @return Success
     */
    createPlaceholderFloors(caseId: string | undefined, nursingBedsId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaFloors/CreatePlaceholderFloors?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (nursingBedsId === null)
            throw new Error("The parameter 'nursingBedsId' cannot be null.");
        else if (nursingBedsId !== undefined)
            url_ += "NursingBedsId=" + encodeURIComponent("" + nursingBedsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderFloors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderFloors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderFloors(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFloorsList(body: UpdateClaFloorsInput | undefined): Observable<UpdateClaFloorsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaFloors/UpdateFloorsList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFloorsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFloorsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaFloorsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaFloorsOutput>;
        }));
    }

    protected processUpdateFloorsList(response: HttpResponseBase): Observable<UpdateClaFloorsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaFloorsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaHeadOfNursingServicesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getHeadOfNursingServices(caseId: string | undefined): Observable<ClaHeadOfNursingServicesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaHeadOfNursingServices/GetHeadOfNursingServices?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHeadOfNursingServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHeadOfNursingServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaHeadOfNursingServicesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaHeadOfNursingServicesDto[]>;
        }));
    }

    protected processGetHeadOfNursingServices(response: HttpResponseBase): Observable<ClaHeadOfNursingServicesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaHeadOfNursingServicesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createPlaceholderHeadOfNursingServices(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaHeadOfNursingServices/CreatePlaceholderHeadOfNursingServices?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderHeadOfNursingServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderHeadOfNursingServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderHeadOfNursingServices(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateHeadOfNursingServices(body: UpdateClaHeadOfNursingServicesInput | undefined): Observable<UpdateClaHeadOfNursingServicesOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaHeadOfNursingServices/UpdateHeadOfNursingServices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateHeadOfNursingServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateHeadOfNursingServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaHeadOfNursingServicesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaHeadOfNursingServicesOutput>;
        }));
    }

    protected processUpdateHeadOfNursingServices(response: HttpResponseBase): Observable<UpdateClaHeadOfNursingServicesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaHeadOfNursingServicesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaHeadOfNursingServicesRepresentativeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getHeadOfNursingServicesRepresentative(caseId: string | undefined): Observable<ClaHeadOfNursingServicesRepresentativeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaHeadOfNursingServicesRepresentative/GetHeadOfNursingServicesRepresentative?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHeadOfNursingServicesRepresentative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHeadOfNursingServicesRepresentative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaHeadOfNursingServicesRepresentativeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaHeadOfNursingServicesRepresentativeDto[]>;
        }));
    }

    protected processGetHeadOfNursingServicesRepresentative(response: HttpResponseBase): Observable<ClaHeadOfNursingServicesRepresentativeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaHeadOfNursingServicesRepresentativeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createPlaceholderHeadOfNursingServicesRepresentative(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaHeadOfNursingServicesRepresentative/CreatePlaceholderHeadOfNursingServicesRepresentative?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderHeadOfNursingServicesRepresentative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderHeadOfNursingServicesRepresentative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderHeadOfNursingServicesRepresentative(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateHeadOfNursingServicesRepresentative(body: UpdateClaHeadOfNursingServicesRepresentativeInput | undefined): Observable<UpdateClaHeadOfNursingServicesRepresentativeOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaHeadOfNursingServicesRepresentative/UpdateHeadOfNursingServicesRepresentative";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateHeadOfNursingServicesRepresentative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateHeadOfNursingServicesRepresentative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaHeadOfNursingServicesRepresentativeOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaHeadOfNursingServicesRepresentativeOutput>;
        }));
    }

    protected processUpdateHeadOfNursingServicesRepresentative(response: HttpResponseBase): Observable<UpdateClaHeadOfNursingServicesRepresentativeOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaHeadOfNursingServicesRepresentativeOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaHospitalPharmacyDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateClaHospitalPharmacyDetailsInput | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/ClaHospitalPharmacyDetails/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<ClaHospitalPharmacyDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaHospitalPharmacyDetails/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaHospitalPharmacyDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaHospitalPharmacyDetailsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ClaHospitalPharmacyDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaHospitalPharmacyDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaInfrastructureServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getInfrastructureList(caseId: string | undefined): Observable<ClaBusinessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaInfrastructure/GetInfrastructureList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfrastructureList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfrastructureList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaBusinessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaBusinessDto[]>;
        }));
    }

    protected processGetInfrastructureList(response: HttpResponseBase): Observable<ClaBusinessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaBusinessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateInfrastructureList(body: UpdateClaInfrastructureInput | undefined): Observable<UpdateClaInfrastructureOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaInfrastructure/UpdateInfrastructureList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInfrastructureList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInfrastructureList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaInfrastructureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaInfrastructureOutput>;
        }));
    }

    protected processUpdateInfrastructureList(response: HttpResponseBase): Observable<UpdateClaInfrastructureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaInfrastructureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaInternalSupervisionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getInternalSupervision(caseId: string | undefined): Observable<ClaInternalSupervisionDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaInternalSupervision/GetInternalSupervision?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalSupervision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalSupervision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaInternalSupervisionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaInternalSupervisionDto>;
        }));
    }

    protected processGetInternalSupervision(response: HttpResponseBase): Observable<ClaInternalSupervisionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaInternalSupervisionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateInternalSupervision(body: UpdateClaInternalSupervisionInput | undefined): Observable<UpdateClaInternalSupervisionOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaInternalSupervision/UpdateInternalSupervision";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInternalSupervision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInternalSupervision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaInternalSupervisionOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaInternalSupervisionOutput>;
        }));
    }

    protected processUpdateInternalSupervision(response: HttpResponseBase): Observable<UpdateClaInternalSupervisionOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaInternalSupervisionOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaInvoiceAddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getInvoiceAddress(caseId: string | undefined): Observable<ClaInvoiceAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaInvoiceAddress/GetInvoiceAddress?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaInvoiceAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaInvoiceAddressDto>;
        }));
    }

    protected processGetInvoiceAddress(response: HttpResponseBase): Observable<ClaInvoiceAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaInvoiceAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateClaInvoiceAddress(body: CreateOrUpdateClaInvoiceAddressInput | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/ClaInvoiceAddress/CreateOrUpdateClaInvoiceAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateClaInvoiceAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateClaInvoiceAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processCreateOrUpdateClaInvoiceAddress(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaLanguageSkillAlasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateClaLanguageSkillAlasInput | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/ClaLanguageSkillAlas/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<ClaLanguageSkillAlasDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaLanguageSkillAlas/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaLanguageSkillAlasDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaLanguageSkillAlasDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ClaLanguageSkillAlasDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaLanguageSkillAlasDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaMedicalFieldDirectorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getMedicalFieldDirector(caseId: string | undefined): Observable<ClaMedicalFieldDirectorDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldDirector/GetMedicalFieldDirector?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalFieldDirector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalFieldDirector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaMedicalFieldDirectorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaMedicalFieldDirectorDto>;
        }));
    }

    protected processGetMedicalFieldDirector(response: HttpResponseBase): Observable<ClaMedicalFieldDirectorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaMedicalFieldDirectorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMedicalFieldDirector(body: UpdateClaMedicalFieldDirectorInput | undefined): Observable<UpdateClaMedicalFieldDirectorOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldDirector/UpdateMedicalFieldDirector";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMedicalFieldDirector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMedicalFieldDirector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaMedicalFieldDirectorOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaMedicalFieldDirectorOutput>;
        }));
    }

    protected processUpdateMedicalFieldDirector(response: HttpResponseBase): Observable<UpdateClaMedicalFieldDirectorOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaMedicalFieldDirectorOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaMedicalFieldDirectorRepresentativeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createPlaceholderMedicalFieldDirectorRepresentative(caseId: string | undefined): Observable<ClaMedicalFieldDirectorRepresentativeDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldDirectorRepresentative/CreatePlaceholderMedicalFieldDirectorRepresentative?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderMedicalFieldDirectorRepresentative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderMedicalFieldDirectorRepresentative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaMedicalFieldDirectorRepresentativeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaMedicalFieldDirectorRepresentativeDto>;
        }));
    }

    protected processCreatePlaceholderMedicalFieldDirectorRepresentative(response: HttpResponseBase): Observable<ClaMedicalFieldDirectorRepresentativeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaMedicalFieldDirectorRepresentativeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getFromRenewingCorporateLicence(caseId: string | undefined): Observable<ClaMedicalFieldDirectorRepresentativeDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldDirectorRepresentative/GetFromRenewingCorporateLicence?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFromRenewingCorporateLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFromRenewingCorporateLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaMedicalFieldDirectorRepresentativeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaMedicalFieldDirectorRepresentativeDto>;
        }));
    }

    protected processGetFromRenewingCorporateLicence(response: HttpResponseBase): Observable<ClaMedicalFieldDirectorRepresentativeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaMedicalFieldDirectorRepresentativeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMedicalFieldDirectorRepresentative(body: UpdateClaMedicalFieldDirectorRepresentativeInput | undefined): Observable<UpdateClaMedicalFieldDirectorRepresentativeOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldDirectorRepresentative/UpdateMedicalFieldDirectorRepresentative";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMedicalFieldDirectorRepresentative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMedicalFieldDirectorRepresentative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaMedicalFieldDirectorRepresentativeOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaMedicalFieldDirectorRepresentativeOutput>;
        }));
    }

    protected processUpdateMedicalFieldDirectorRepresentative(response: HttpResponseBase): Observable<UpdateClaMedicalFieldDirectorRepresentativeOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaMedicalFieldDirectorRepresentativeOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaMedicalFieldPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param isEhc (optional) 
     * @return Success
     */
    getMedicalFieldPersons(caseId: string | undefined, isEhc: boolean | undefined): Observable<ClaMedicalFieldPersonDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldPerson/GetMedicalFieldPersons?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (isEhc === null)
            throw new Error("The parameter 'isEhc' cannot be null.");
        else if (isEhc !== undefined)
            url_ += "isEhc=" + encodeURIComponent("" + isEhc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalFieldPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalFieldPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaMedicalFieldPersonDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaMedicalFieldPersonDto[]>;
        }));
    }

    protected processGetMedicalFieldPersons(response: HttpResponseBase): Observable<ClaMedicalFieldPersonDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaMedicalFieldPersonDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param isEhc (optional) 
     * @return Success
     */
    createPlaceholderMedicalFieldPerson(caseId: string | undefined, isEhc: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldPerson/CreatePlaceholderMedicalFieldPerson?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (isEhc === null)
            throw new Error("The parameter 'isEhc' cannot be null.");
        else if (isEhc !== undefined)
            url_ += "isEhc=" + encodeURIComponent("" + isEhc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderMedicalFieldPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderMedicalFieldPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderMedicalFieldPerson(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isEhc (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateMedicalFieldPersons(isEhc: boolean | undefined, body: UpdateClaMedicalFieldPersonsInput | undefined): Observable<UpdateClaMedicalFieldPersonsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldPerson/UpdateMedicalFieldPersons?";
        if (isEhc === null)
            throw new Error("The parameter 'isEhc' cannot be null.");
        else if (isEhc !== undefined)
            url_ += "isEhc=" + encodeURIComponent("" + isEhc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMedicalFieldPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMedicalFieldPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaMedicalFieldPersonsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaMedicalFieldPersonsOutput>;
        }));
    }

    protected processUpdateMedicalFieldPersons(response: HttpResponseBase): Observable<UpdateClaMedicalFieldPersonsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaMedicalFieldPersonsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaMedicalFieldPersonAlasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getMedicalFieldPersonsAlas(caseId: string | undefined): Observable<ClaMedicalFieldPersonAlasDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldPersonAlas/GetMedicalFieldPersonsAlas?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalFieldPersonsAlas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalFieldPersonsAlas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaMedicalFieldPersonAlasDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaMedicalFieldPersonAlasDto[]>;
        }));
    }

    protected processGetMedicalFieldPersonsAlas(response: HttpResponseBase): Observable<ClaMedicalFieldPersonAlasDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaMedicalFieldPersonAlasDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createPlaceholderMedicalFieldPersonAlas(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldPersonAlas/CreatePlaceholderMedicalFieldPersonAlas?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderMedicalFieldPersonAlas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderMedicalFieldPersonAlas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderMedicalFieldPersonAlas(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMedicalFieldPersonsAlas(body: UpdateClaMedicalFieldPersonsAlasInput | undefined): Observable<UpdateClaMedicalFieldPersonsAlasOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldPersonAlas/UpdateMedicalFieldPersonsAlas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMedicalFieldPersonsAlas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMedicalFieldPersonsAlas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaMedicalFieldPersonsAlasOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaMedicalFieldPersonsAlasOutput>;
        }));
    }

    protected processUpdateMedicalFieldPersonsAlas(response: HttpResponseBase): Observable<UpdateClaMedicalFieldPersonsAlasOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaMedicalFieldPersonsAlasOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaMedicalFieldResponsibleForHaemovigilanceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getMedicalFieldResponsibleForHaemovigilance(caseId: string | undefined): Observable<ClaMedicalFieldResponsibleForHaemovigilanceDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldResponsibleForHaemovigilance/GetMedicalFieldResponsibleForHaemovigilance?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalFieldResponsibleForHaemovigilance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalFieldResponsibleForHaemovigilance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaMedicalFieldResponsibleForHaemovigilanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaMedicalFieldResponsibleForHaemovigilanceDto>;
        }));
    }

    protected processGetMedicalFieldResponsibleForHaemovigilance(response: HttpResponseBase): Observable<ClaMedicalFieldResponsibleForHaemovigilanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaMedicalFieldResponsibleForHaemovigilanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getFromRenewingCorporateLicence(caseId: string | undefined): Observable<ClaMedicalFieldResponsibleForHaemovigilanceDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldResponsibleForHaemovigilance/GetFromRenewingCorporateLicence?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFromRenewingCorporateLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFromRenewingCorporateLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaMedicalFieldResponsibleForHaemovigilanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaMedicalFieldResponsibleForHaemovigilanceDto>;
        }));
    }

    protected processGetFromRenewingCorporateLicence(response: HttpResponseBase): Observable<ClaMedicalFieldResponsibleForHaemovigilanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaMedicalFieldResponsibleForHaemovigilanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createPlaceholderMedicalFieldResponsibleForHaemovigilance(caseId: string | undefined): Observable<ClaMedicalFieldResponsibleForHaemovigilanceDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldResponsibleForHaemovigilance/CreatePlaceholderMedicalFieldResponsibleForHaemovigilance?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderMedicalFieldResponsibleForHaemovigilance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderMedicalFieldResponsibleForHaemovigilance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaMedicalFieldResponsibleForHaemovigilanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaMedicalFieldResponsibleForHaemovigilanceDto>;
        }));
    }

    protected processCreatePlaceholderMedicalFieldResponsibleForHaemovigilance(response: HttpResponseBase): Observable<ClaMedicalFieldResponsibleForHaemovigilanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaMedicalFieldResponsibleForHaemovigilanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMedicalFieldResponsibleForHaemovigilance(body: UpdateClaMedicalFieldResponsibleForHaemovigilanceInput | undefined): Observable<UpdateClaMedicalFieldResponsibleForHaemovigilanceOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldResponsibleForHaemovigilance/UpdateMedicalFieldResponsibleForHaemovigilance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMedicalFieldResponsibleForHaemovigilance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMedicalFieldResponsibleForHaemovigilance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaMedicalFieldResponsibleForHaemovigilanceOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaMedicalFieldResponsibleForHaemovigilanceOutput>;
        }));
    }

    protected processUpdateMedicalFieldResponsibleForHaemovigilance(response: HttpResponseBase): Observable<UpdateClaMedicalFieldResponsibleForHaemovigilanceOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaMedicalFieldResponsibleForHaemovigilanceOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaMedicalFieldResponsibleForStorageAndQualityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getMedicalFieldResponsibleForStorageAndQuality(caseId: string | undefined): Observable<ClaMedicalFieldResponsibleForStorageAndQualityDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldResponsibleForStorageAndQuality/GetMedicalFieldResponsibleForStorageAndQuality?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalFieldResponsibleForStorageAndQuality(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalFieldResponsibleForStorageAndQuality(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaMedicalFieldResponsibleForStorageAndQualityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaMedicalFieldResponsibleForStorageAndQualityDto>;
        }));
    }

    protected processGetMedicalFieldResponsibleForStorageAndQuality(response: HttpResponseBase): Observable<ClaMedicalFieldResponsibleForStorageAndQualityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaMedicalFieldResponsibleForStorageAndQualityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getFromRenewingCorporateLicence(caseId: string | undefined): Observable<ClaMedicalFieldResponsibleForStorageAndQualityDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldResponsibleForStorageAndQuality/GetFromRenewingCorporateLicence?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFromRenewingCorporateLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFromRenewingCorporateLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaMedicalFieldResponsibleForStorageAndQualityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaMedicalFieldResponsibleForStorageAndQualityDto>;
        }));
    }

    protected processGetFromRenewingCorporateLicence(response: HttpResponseBase): Observable<ClaMedicalFieldResponsibleForStorageAndQualityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaMedicalFieldResponsibleForStorageAndQualityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createPlaceholderMedicalFieldResponsibleForStorageAndQuality(caseId: string | undefined): Observable<ClaMedicalFieldResponsibleForStorageAndQualityDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldResponsibleForStorageAndQuality/CreatePlaceholderMedicalFieldResponsibleForStorageAndQuality?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderMedicalFieldResponsibleForStorageAndQuality(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderMedicalFieldResponsibleForStorageAndQuality(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaMedicalFieldResponsibleForStorageAndQualityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaMedicalFieldResponsibleForStorageAndQualityDto>;
        }));
    }

    protected processCreatePlaceholderMedicalFieldResponsibleForStorageAndQuality(response: HttpResponseBase): Observable<ClaMedicalFieldResponsibleForStorageAndQualityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaMedicalFieldResponsibleForStorageAndQualityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMedicalFieldResponsibleForStorageAndQuality(body: UpdateClaMedicalFieldResponsibleForStorageAndQualityInput | undefined): Observable<UpdateClaMedicalFieldResponsibleForStorageAndQualityOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldResponsibleForStorageAndQuality/UpdateMedicalFieldResponsibleForStorageAndQuality";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMedicalFieldResponsibleForStorageAndQuality(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMedicalFieldResponsibleForStorageAndQuality(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaMedicalFieldResponsibleForStorageAndQualityOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaMedicalFieldResponsibleForStorageAndQualityOutput>;
        }));
    }

    protected processUpdateMedicalFieldResponsibleForStorageAndQuality(response: HttpResponseBase): Observable<UpdateClaMedicalFieldResponsibleForStorageAndQualityOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaMedicalFieldResponsibleForStorageAndQualityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaNursingBedsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param nursingBedsId (optional) 
     * @return Success
     */
    createPlaceholderNursingBeds(caseId: string | undefined, nursingBedsId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaNursingBeds/CreatePlaceholderNursingBeds?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (nursingBedsId === null)
            throw new Error("The parameter 'nursingBedsId' cannot be null.");
        else if (nursingBedsId !== undefined)
            url_ += "NursingBedsId=" + encodeURIComponent("" + nursingBedsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderNursingBeds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderNursingBeds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderNursingBeds(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateNursingBedsList(body: UpdateClaNursingBedsInput | undefined): Observable<UpdateClaNursingBedsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaNursingBeds/UpdateNursingBedsList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNursingBedsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNursingBedsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaNursingBedsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaNursingBedsOutput>;
        }));
    }

    protected processUpdateNursingBedsList(response: HttpResponseBase): Observable<UpdateClaNursingBedsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaNursingBedsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaPersonAlasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getPersonAlas(caseId: string | undefined): Observable<ClaPersonAlasDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaPersonAlas/GetPersonAlas?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonAlas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonAlas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaPersonAlasDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaPersonAlasDto>;
        }));
    }

    protected processGetPersonAlas(response: HttpResponseBase): Observable<ClaPersonAlasDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaPersonAlasDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePersonAlas(body: UpdateClaPersonAlasInput | undefined): Observable<UpdateClaPersonAlasOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaPersonAlas/UpdatePersonAlas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePersonAlas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePersonAlas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaPersonAlasOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaPersonAlasOutput>;
        }));
    }

    protected processUpdatePersonAlas(response: HttpResponseBase): Observable<UpdateClaPersonAlasOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaPersonAlasOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaPersonelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getPersonelList(caseId: string | undefined): Observable<ClaBusinessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaPersonel/GetPersonelList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonelList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonelList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaBusinessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaBusinessDto[]>;
        }));
    }

    protected processGetPersonelList(response: HttpResponseBase): Observable<ClaBusinessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaBusinessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePersonelList(body: UpdateClaPersonelInput | undefined): Observable<UpdateClaPersonelOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaPersonel/UpdatePersonelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePersonelList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePersonelList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaPersonelOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaPersonelOutput>;
        }));
    }

    protected processUpdatePersonelList(response: HttpResponseBase): Observable<UpdateClaPersonelOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaPersonelOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaQualityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param qualityId (optional) 
     * @return Success
     */
    createPlaceholderQuality(caseId: string | undefined, qualityId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaQuality/CreatePlaceholderQuality?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (qualityId === null)
            throw new Error("The parameter 'qualityId' cannot be null.");
        else if (qualityId !== undefined)
            url_ += "QualityId=" + encodeURIComponent("" + qualityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderQuality(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderQuality(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderQuality(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateQualityList(body: UpdateClaQualityInput | undefined): Observable<UpdateClaQualityOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaQuality/UpdateQualityList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateQualityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQualityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaQualityOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaQualityOutput>;
        }));
    }

    protected processUpdateQualityList(response: HttpResponseBase): Observable<UpdateClaQualityOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaQualityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaQualityRequirementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateClaQualityRequirement(body: CreateOrUpdateClaQualityRequirementInput | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/ClaQualityRequirement/CreateOrUpdateClaQualityRequirement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateClaQualityRequirement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateClaQualityRequirement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processCreateOrUpdateClaQualityRequirement(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaRangeOfServicesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getRangeOfServicesList(caseId: string | undefined): Observable<ClaBusinessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaRangeOfServices/GetRangeOfServicesList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRangeOfServicesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRangeOfServicesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaBusinessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaBusinessDto[]>;
        }));
    }

    protected processGetRangeOfServicesList(response: HttpResponseBase): Observable<ClaBusinessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaBusinessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRangeOfServicesList(body: UpdateClaRangeOfServicesInput | undefined): Observable<UpdateClaRangeOfServicesOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaRangeOfServices/UpdateRangeOfServicesList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRangeOfServicesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRangeOfServicesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaRangeOfServicesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaRangeOfServicesOutput>;
        }));
    }

    protected processUpdateRangeOfServicesList(response: HttpResponseBase): Observable<UpdateClaRangeOfServicesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaRangeOfServicesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaRestrictionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getRestrictions(caseId: string | undefined): Observable<ClaRestrictionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaRestrictions/GetRestrictions?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRestrictions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRestrictions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaRestrictionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaRestrictionDto[]>;
        }));
    }

    protected processGetRestrictions(response: HttpResponseBase): Observable<ClaRestrictionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaRestrictionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateClaRestrictions(body: CreateOrUpdateClaRestrictionsInput | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/ClaRestrictions/CreateOrUpdateClaRestrictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateClaRestrictions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateClaRestrictions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processCreateOrUpdateClaRestrictions(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaRestrictionsAlasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateClaRestrictions(body: CreateOrUpdateClaRestrictionAlasInput | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/ClaRestrictionsAlas/CreateOrUpdateClaRestrictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateClaRestrictions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateClaRestrictions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processCreateOrUpdateClaRestrictions(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getRestrictions(caseId: string | undefined): Observable<ClaRestrictionAlasOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaRestrictionsAlas/GetRestrictions?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRestrictions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRestrictions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaRestrictionAlasOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaRestrictionAlasOutput>;
        }));
    }

    protected processGetRestrictions(response: HttpResponseBase): Observable<ClaRestrictionAlasOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaRestrictionAlasOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaSanitaryFacilitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param sanitaryFacilitiesId (optional) 
     * @return Success
     */
    createPlaceholderSanitaryFacilities(caseId: string | undefined, sanitaryFacilitiesId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaSanitaryFacilities/CreatePlaceholderSanitaryFacilities?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (sanitaryFacilitiesId === null)
            throw new Error("The parameter 'sanitaryFacilitiesId' cannot be null.");
        else if (sanitaryFacilitiesId !== undefined)
            url_ += "SanitaryFacilitiesId=" + encodeURIComponent("" + sanitaryFacilitiesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderSanitaryFacilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderSanitaryFacilities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderSanitaryFacilities(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSanitaryFacilitiesList(body: UpdateClaSanitaryFacilitiesInput | undefined): Observable<UpdateClaSanitaryFacilitiesOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaSanitaryFacilities/UpdateSanitaryFacilitiesList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSanitaryFacilitiesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSanitaryFacilitiesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaSanitaryFacilitiesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaSanitaryFacilitiesOutput>;
        }));
    }

    protected processUpdateSanitaryFacilitiesList(response: HttpResponseBase): Observable<UpdateClaSanitaryFacilitiesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaSanitaryFacilitiesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaSecurityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param securityId (optional) 
     * @return Success
     */
    createPlaceholderSecurity(caseId: string | undefined, securityId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaSecurity/CreatePlaceholderSecurity?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (securityId === null)
            throw new Error("The parameter 'securityId' cannot be null.");
        else if (securityId !== undefined)
            url_ += "SecurityId=" + encodeURIComponent("" + securityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderSecurity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderSecurity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderSecurity(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSecurityList(body: UpdateClaSecurityInput | undefined): Observable<UpdateClaSecurityOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaSecurity/UpdateSecurityList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSecurityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSecurityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaSecurityOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaSecurityOutput>;
        }));
    }

    protected processUpdateSecurityList(response: HttpResponseBase): Observable<UpdateClaSecurityOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaSecurityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaSecurityAndInsuranceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getSecurityAndInsurance(caseId: string | undefined): Observable<ClaSecurityAndInsuranceDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaSecurityAndInsurance/GetSecurityAndInsurance?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSecurityAndInsurance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecurityAndInsurance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaSecurityAndInsuranceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaSecurityAndInsuranceDto>;
        }));
    }

    protected processGetSecurityAndInsurance(response: HttpResponseBase): Observable<ClaSecurityAndInsuranceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaSecurityAndInsuranceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateSecurityAndInsurance(body: CreateOrUpdateClaSecurityAndInsuranceInput | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/ClaSecurityAndInsurance/CreateOrUpdateSecurityAndInsurance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateSecurityAndInsurance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateSecurityAndInsurance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processCreateOrUpdateSecurityAndInsurance(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaServiceAreasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param serviceAreaId (optional) 
     * @return Success
     */
    createPlaceholderServiceArea(caseId: string | undefined, serviceAreaId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaServiceAreas/CreatePlaceholderServiceArea?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (serviceAreaId === null)
            throw new Error("The parameter 'serviceAreaId' cannot be null.");
        else if (serviceAreaId !== undefined)
            url_ += "ServiceAreaId=" + encodeURIComponent("" + serviceAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderServiceArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderServiceArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderServiceArea(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateServiceAreasList(body: UpdateClaServiceAreasInput | undefined): Observable<UpdateClaServiceAreasOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaServiceAreas/UpdateServiceAreasList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateServiceAreasList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateServiceAreasList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaServiceAreasOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaServiceAreasOutput>;
        }));
    }

    protected processUpdateServiceAreasList(response: HttpResponseBase): Observable<UpdateClaServiceAreasOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaServiceAreasOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaSponsorshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateSponsorship(body: CreateOrUpdateClaSponsorshipInput | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/ClaSponsorship/CreateOrUpdateSponsorship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processCreateOrUpdateSponsorship(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getSponsorshipDirectors(caseId: string | undefined): Observable<ClaSponsorshipDirectorDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaSponsorship/GetSponsorshipDirectors?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorshipDirectors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorshipDirectors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaSponsorshipDirectorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaSponsorshipDirectorDto[]>;
        }));
    }

    protected processGetSponsorshipDirectors(response: HttpResponseBase): Observable<ClaSponsorshipDirectorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaSponsorshipDirectorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getDossierSponsorshipDirectors(caseId: string | undefined): Observable<ClaSponsorshipDirectorDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaSponsorship/GetDossierSponsorshipDirectors?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDossierSponsorshipDirectors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDossierSponsorshipDirectors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaSponsorshipDirectorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaSponsorshipDirectorDto[]>;
        }));
    }

    protected processGetDossierSponsorshipDirectors(response: HttpResponseBase): Observable<ClaSponsorshipDirectorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaSponsorshipDirectorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createPlaceholderSponsorshipDirector(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaSponsorship/CreatePlaceholderSponsorshipDirector?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderSponsorshipDirector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderSponsorshipDirector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderSponsorshipDirector(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSponsorshipDirectors(body: UpdateClaSponsorshipDirectorsInput | undefined): Observable<UpdateClaSponsorshipDirectorsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaSponsorship/UpdateSponsorshipDirectors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSponsorshipDirectors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSponsorshipDirectors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaSponsorshipDirectorsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaSponsorshipDirectorsOutput>;
        }));
    }

    protected processUpdateSponsorshipDirectors(response: HttpResponseBase): Observable<UpdateClaSponsorshipDirectorsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaSponsorshipDirectorsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSponsorshipDeputyDirectors(body: UpdateClaSponsorshipDirectorsInput | undefined): Observable<UpdateClaSponsorshipDirectorsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaSponsorship/UpdateSponsorshipDeputyDirectors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSponsorshipDeputyDirectors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSponsorshipDeputyDirectors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaSponsorshipDirectorsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaSponsorshipDirectorsOutput>;
        }));
    }

    protected processUpdateSponsorshipDeputyDirectors(response: HttpResponseBase): Observable<UpdateClaSponsorshipDirectorsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaSponsorshipDirectorsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param sponsorshipDirectorId (optional) 
     * @param gln (optional) 
     * @param professionId (optional) 
     * @return Success
     */
    sponsorshipDirectorRegisterSearch(caseId: string | undefined, sponsorshipDirectorId: number | undefined, gln: string | undefined, professionId: string | undefined): Observable<HealthRegisterIdentificationStatus> {
        let url_ = this.baseUrl + "/api/services/app/ClaSponsorship/SponsorshipDirectorRegisterSearch?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (sponsorshipDirectorId === null)
            throw new Error("The parameter 'sponsorshipDirectorId' cannot be null.");
        else if (sponsorshipDirectorId !== undefined)
            url_ += "sponsorshipDirectorId=" + encodeURIComponent("" + sponsorshipDirectorId) + "&";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSponsorshipDirectorRegisterSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSponsorshipDirectorRegisterSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthRegisterIdentificationStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthRegisterIdentificationStatus>;
        }));
    }

    protected processSponsorshipDirectorRegisterSearch(response: HttpResponseBase): Observable<HealthRegisterIdentificationStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getDossierSponsorship(caseId: string | undefined): Observable<ClaSponsorshipDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaSponsorship/GetDossierSponsorship?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDossierSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDossierSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaSponsorshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaSponsorshipDto>;
        }));
    }

    protected processGetDossierSponsorship(response: HttpResponseBase): Observable<ClaSponsorshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaSponsorshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getDossierCorporateLicences(caseId: string | undefined): Observable<ClaSelectableCorporateLicenceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaSponsorship/GetDossierCorporateLicences?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDossierCorporateLicences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDossierCorporateLicences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaSelectableCorporateLicenceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaSelectableCorporateLicenceDto[]>;
        }));
    }

    protected processGetDossierCorporateLicences(response: HttpResponseBase): Observable<ClaSelectableCorporateLicenceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaSelectableCorporateLicenceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaStatusWizardStepServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param sponsorshipTypeId (optional) 
     * @param applicationType (optional) 
     * @return Success
     */
    getAllBySponsorshipTypeIdAndApplicationType(sponsorshipTypeId: string | undefined, applicationType: ApplicationType | undefined): Observable<ClaStatusWizardStepDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaStatusWizardStep/GetAllBySponsorshipTypeIdAndApplicationType?";
        if (sponsorshipTypeId === null)
            throw new Error("The parameter 'sponsorshipTypeId' cannot be null.");
        else if (sponsorshipTypeId !== undefined)
            url_ += "sponsorshipTypeId=" + encodeURIComponent("" + sponsorshipTypeId) + "&";
        if (applicationType === null)
            throw new Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBySponsorshipTypeIdAndApplicationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBySponsorshipTypeIdAndApplicationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatusWizardStepDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatusWizardStepDto[]>;
        }));
    }

    protected processGetAllBySponsorshipTypeIdAndApplicationType(response: HttpResponseBase): Observable<ClaStatusWizardStepDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaStatusWizardStepDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateClaStatusWizardStepInput | undefined): Observable<ClaStatusWizardStepDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaStatusWizardStep/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatusWizardStepDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatusWizardStepDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ClaStatusWizardStepDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaStatusWizardStepDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMany(body: UpdateClaStatusWizardStepsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClaStatusWizardStep/UpdateMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @param sponsorshipTypeId (optional) 
     * @param applicationType (optional) 
     * @return Success
     */
    delete(step: number | undefined, sponsorshipTypeId: string | undefined, applicationType: ApplicationType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClaStatusWizardStep/Delete?";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        if (sponsorshipTypeId === null)
            throw new Error("The parameter 'sponsorshipTypeId' cannot be null.");
        else if (sponsorshipTypeId !== undefined)
            url_ += "sponsorshipTypeId=" + encodeURIComponent("" + sponsorshipTypeId) + "&";
        if (applicationType === null)
            throw new Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaTrainerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getTrainer(caseId: string | undefined): Observable<ClaTrainerDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaTrainer/GetTrainer?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrainer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaTrainerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaTrainerDto>;
        }));
    }

    protected processGetTrainer(response: HttpResponseBase): Observable<ClaTrainerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaTrainerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createPlaceholderTrainer(caseId: string | undefined): Observable<ClaTrainerDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaTrainer/CreatePlaceholderTrainer?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderTrainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderTrainer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaTrainerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaTrainerDto>;
        }));
    }

    protected processCreatePlaceholderTrainer(response: HttpResponseBase): Observable<ClaTrainerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaTrainerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTrainer(body: UpdateClaTrainerInput | undefined): Observable<UpdateClaTrainerOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaTrainer/UpdateTrainer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTrainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTrainer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaTrainerOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaTrainerOutput>;
        }));
    }

    protected processUpdateTrainer(response: HttpResponseBase): Observable<UpdateClaTrainerOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaTrainerOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaTreatmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param businessId (optional) 
     * @return Success
     */
    createPlaceholderTreatment(caseId: string | undefined, businessId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaTreatment/CreatePlaceholderTreatment?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderTreatment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderTreatment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderTreatment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTreatmentList(body: UpdateClaTreatmentInput | undefined): Observable<UpdateClaTreatmentOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaTreatment/UpdateTreatmentList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTreatmentList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTreatmentList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaTreatmentOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaTreatmentOutput>;
        }));
    }

    protected processUpdateTreatmentList(response: HttpResponseBase): Observable<UpdateClaTreatmentOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaTreatmentOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaVaccinationInPharmacyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateClaVaccinationInPharmacy(body: CreateOrUpdateClaVaccinationInPharmacyInput | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/ClaVaccinationInPharmacy/CreateOrUpdateClaVaccinationInPharmacy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateClaVaccinationInPharmacy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateClaVaccinationInPharmacy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processCreateOrUpdateClaVaccinationInPharmacy(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaWheelchairAccessibilityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param wheelchairAccessibilityId (optional) 
     * @return Success
     */
    createPlaceholderWheelchairAccessibility(caseId: string | undefined, wheelchairAccessibilityId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaWheelchairAccessibility/CreatePlaceholderWheelchairAccessibility?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (wheelchairAccessibilityId === null)
            throw new Error("The parameter 'wheelchairAccessibilityId' cannot be null.");
        else if (wheelchairAccessibilityId !== undefined)
            url_ += "WheelchairAccessibilityId=" + encodeURIComponent("" + wheelchairAccessibilityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderWheelchairAccessibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderWheelchairAccessibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderWheelchairAccessibility(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWheelchairAccessibilityList(body: UpdateClaWheelchairAccessibilityInput | undefined): Observable<UpdateClaWheelchairAccessibilityOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaWheelchairAccessibility/UpdateWheelchairAccessibilityList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWheelchairAccessibilityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWheelchairAccessibilityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaWheelchairAccessibilityOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaWheelchairAccessibilityOutput>;
        }));
    }

    protected processUpdateWheelchairAccessibilityList(response: HttpResponseBase): Observable<UpdateClaWheelchairAccessibilityOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaWheelchairAccessibilityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CodeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getAllCodes(): Observable<CodeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Code/GetAllCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CodeListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CodeListDto[]>;
        }));
    }

    protected processGetAllCodes(response: HttpResponseBase): Observable<CodeListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CodeListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param codeCategory (optional) 
     * @param filter (optional) 
     * @param isSystem (optional) 
     * @param codeSubcategory (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getCodes(codeCategory: CodeCategory | undefined, filter: string | undefined, isSystem: boolean | undefined, codeSubcategory: CodeSubcategory | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfCodeListDto> {
        let url_ = this.baseUrl + "/api/services/app/Code/GetCodes?";
        if (codeCategory === null)
            throw new Error("The parameter 'codeCategory' cannot be null.");
        else if (codeCategory !== undefined)
            url_ += "CodeCategory=" + encodeURIComponent("" + codeCategory) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isSystem === null)
            throw new Error("The parameter 'isSystem' cannot be null.");
        else if (isSystem !== undefined)
            url_ += "IsSystem=" + encodeURIComponent("" + isSystem) + "&";
        if (codeSubcategory === null)
            throw new Error("The parameter 'codeSubcategory' cannot be null.");
        else if (codeSubcategory !== undefined)
            url_ += "CodeSubcategory=" + encodeURIComponent("" + codeSubcategory) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCodeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCodeListDto>;
        }));
    }

    protected processGetCodes(response: HttpResponseBase): Observable<PagedResultDtoOfCodeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCodeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param codeCategory (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param codeSubcategory (optional) 
     * @param isSystem (optional) 
     * @return Success
     */
    getCodesToExcel(codeCategory: CodeCategory | undefined, filter: string | undefined, sorting: string | undefined, codeSubcategory: CodeSubcategory | undefined, isSystem: boolean | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Code/GetCodesToExcel?";
        if (codeCategory === null)
            throw new Error("The parameter 'codeCategory' cannot be null.");
        else if (codeCategory !== undefined)
            url_ += "CodeCategory=" + encodeURIComponent("" + codeCategory) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (codeSubcategory === null)
            throw new Error("The parameter 'codeSubcategory' cannot be null.");
        else if (codeSubcategory !== undefined)
            url_ += "CodeSubcategory=" + encodeURIComponent("" + codeSubcategory) + "&";
        if (isSystem === null)
            throw new Error("The parameter 'isSystem' cannot be null.");
        else if (isSystem !== undefined)
            url_ += "IsSystem=" + encodeURIComponent("" + isSystem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCodesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCodesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetCodesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCodeForEdit(id: string | undefined): Observable<GetCodeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Code/GetCodeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCodeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCodeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCodeForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCodeForEditOutput>;
        }));
    }

    protected processGetCodeForEdit(response: HttpResponseBase): Observable<GetCodeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCodeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateCode(body: CreateOrUpdateCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Code/CreateOrUpdateCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteCode(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Code/DeleteCode?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CogsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCogs(body: CreateCogsApplicationDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Cogs/CreateCogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateCogs(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getCogs(caseId: string | undefined): Observable<GetCogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Cogs/GetCogs?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCogsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCogsOutput>;
        }));
    }

    protected processGetCogs(response: HttpResponseBase): Observable<GetCogsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCogsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyCogss(): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cogs/GetMyCogss";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyCogss(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyCogss(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetMyCogss(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getCogsForPerson(gln: string | undefined): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cogs/GetCogsForPerson?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCogsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCogsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetCogsForPerson(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param status (optional) 
     * @return Success
     */
    getNextStatus(caseId: string | undefined, status: CogsStatus | undefined): Observable<CogsStatus> {
        let url_ = this.baseUrl + "/api/services/app/Cogs/GetNextStatus?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CogsStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CogsStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<CogsStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseCogs(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cogs/ReleaseCogs?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseCogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseCogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseCogs(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param professionId (optional) 
     * @return Success
     */
    getExternalRegisterByProfessionId(professionId: string | undefined): Observable<ExternalSystemEnum> {
        let url_ = this.baseUrl + "/api/services/app/Cogs/GetExternalRegisterByProfessionId?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalRegisterByProfessionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalRegisterByProfessionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalSystemEnum>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalSystemEnum>;
        }));
    }

    protected processGetExternalRegisterByProfessionId(response: HttpResponseBase): Observable<ExternalSystemEnum> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param gln (optional) 
     * @return Success
     */
    updateCogsPersonWithRegisterCheck(caseId: string | undefined, gln: string | undefined): Observable<HealthRegisterIdentificationStatus> {
        let url_ = this.baseUrl + "/api/services/app/Cogs/UpdateCogsPersonWithRegisterCheck?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCogsPersonWithRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCogsPersonWithRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthRegisterIdentificationStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthRegisterIdentificationStatus>;
        }));
    }

    protected processUpdateCogsPersonWithRegisterCheck(response: HttpResponseBase): Observable<HealthRegisterIdentificationStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    acceptRegisterCheck(caseId: string | undefined): Observable<CogsStatus> {
        let url_ = this.baseUrl + "/api/services/app/Cogs/AcceptRegisterCheck?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CogsStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CogsStatus>;
        }));
    }

    protected processAcceptRegisterCheck(response: HttpResponseBase): Observable<CogsStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateCogsContact(body: CreateOrUpdateCogsContactInput | undefined): Observable<CogsStatus> {
        let url_ = this.baseUrl + "/api/services/app/Cogs/CreateOrUpdateCogsContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateCogsContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateCogsContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CogsStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CogsStatus>;
        }));
    }

    protected processCreateOrUpdateCogsContact(response: HttpResponseBase): Observable<CogsStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getDossierContact(gln: string | undefined): Observable<CogsContactDto> {
        let url_ = this.baseUrl + "/api/services/app/Cogs/GetDossierContact?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDossierContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDossierContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CogsContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CogsContactDto>;
        }));
    }

    protected processGetDossierContact(response: HttpResponseBase): Observable<CogsContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CogsContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param languageOfCogsId (optional) 
     * @return Success
     */
    updateLanguageOfCogs(caseId: string | undefined, languageOfCogsId: string | undefined): Observable<CogsStatus> {
        let url_ = this.baseUrl + "/api/services/app/Cogs/UpdateLanguageOfCogs?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (languageOfCogsId === null)
            throw new Error("The parameter 'languageOfCogsId' cannot be null.");
        else if (languageOfCogsId !== undefined)
            url_ += "languageOfCogsId=" + encodeURIComponent("" + languageOfCogsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLanguageOfCogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLanguageOfCogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CogsStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CogsStatus>;
        }));
    }

    protected processUpdateLanguageOfCogs(response: HttpResponseBase): Observable<CogsStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateCogsAdditionalAddress(body: CreateOrUpdateCogsAdditionalAddressInput | undefined): Observable<CogsStatus> {
        let url_ = this.baseUrl + "/api/services/app/Cogs/CreateOrUpdateCogsAdditionalAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateCogsAdditionalAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateCogsAdditionalAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CogsStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CogsStatus>;
        }));
    }

    protected processCreateOrUpdateCogsAdditionalAddress(response: HttpResponseBase): Observable<CogsStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateCogsInvoiceAddress(body: CreateOrUpdateCogsInvoiceAddressInput | undefined): Observable<CogsStatus> {
        let url_ = this.baseUrl + "/api/services/app/Cogs/CreateOrUpdateCogsInvoiceAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateCogsInvoiceAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateCogsInvoiceAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CogsStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CogsStatus>;
        }));
    }

    protected processCreateOrUpdateCogsInvoiceAddress(response: HttpResponseBase): Observable<CogsStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Cogs/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getPersonId(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Cogs/GetPersonId?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPersonId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CommonLookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param onlyFreeItems (optional) 
     * @return Success
     */
    getEditionsForCombobox(onlyFreeItems: boolean | undefined): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>;
        }));
    }

    protected processGetEditionsForCombobox(response: HttpResponseBase): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findUsers(body: FindUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultEditionName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultEditionName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDefaultEditionNameOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDefaultEditionNameOutput>;
        }));
    }

    protected processGetDefaultEditionName(response: HttpResponseBase): Observable<GetDefaultEditionNameOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDefaultEditionNameOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConfigServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getConfig(): Observable<ConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/Config/GetConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigDto>;
        }));
    }

    protected processGetConfig(response: HttpResponseBase): Observable<ConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCurrentUserSetting(body: UpdateCurrentUserSettingInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Config/UpdateCurrentUserSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentUserSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentUserSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentUserSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getExternalSystemCredentials(): Observable<GetExternalSystemCredentials> {
        let url_ = this.baseUrl + "/api/services/app/Config/GetExternalSystemCredentials";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalSystemCredentials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalSystemCredentials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExternalSystemCredentials>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExternalSystemCredentials>;
        }));
    }

    protected processGetExternalSystemCredentials(response: HttpResponseBase): Observable<GetExternalSystemCredentials> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExternalSystemCredentials.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateExternalSystemCertificate(body: CreateOrUpdateExternalSystemCertificateInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Config/CreateOrUpdateExternalSystemCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateExternalSystemCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateExternalSystemCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateExternalSystemCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateExternalSystemCredentials(body: CreateOrUpdateExternalSystemCredentialsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Config/CreateOrUpdateExternalSystemCredentials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateExternalSystemCredentials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateExternalSystemCredentials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateExternalSystemCredentials(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param key (optional) 
     * @param value (optional) 
     * @return Success
     */
    updateMaintenanceSetting(key: string | undefined, value: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Config/UpdateMaintenanceSetting?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMaintenanceSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMaintenanceSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMaintenanceSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMaintenanceConfiguration(): Observable<MaintenanceConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/Config/GetMaintenanceConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaintenanceConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaintenanceConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceConfigDto>;
        }));
    }

    protected processGetMaintenanceConfiguration(response: HttpResponseBase): Observable<MaintenanceConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaintenanceConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param key (optional) 
     * @param value (optional) 
     * @return Success
     */
    updateSironaSetting(key: string | undefined, value: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Config/UpdateSironaSetting?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSironaSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSironaSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSironaSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSironaSettings(): Observable<SironaSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/Config/GetSironaSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSironaSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSironaSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SironaSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SironaSettingDto>;
        }));
    }

    protected processGetSironaSettings(response: HttpResponseBase): Observable<SironaSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SironaSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSironaMutationSettings(): Observable<SironaMutationSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/Config/GetSironaMutationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSironaMutationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSironaMutationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SironaMutationSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SironaMutationSettingDto>;
        }));
    }

    protected processGetSironaMutationSettings(response: HttpResponseBase): Observable<SironaMutationSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SironaMutationSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSironaPrimedocsSettings(): Observable<SironaPrimedocSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/Config/GetSironaPrimedocsSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSironaPrimedocsSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSironaPrimedocsSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SironaPrimedocSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SironaPrimedocSettingDto>;
        }));
    }

    protected processGetSironaPrimedocsSettings(response: HttpResponseBase): Observable<SironaPrimedocSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SironaPrimedocSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDatabaseInfo(): Observable<DatabaseInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Config/GetDatabaseInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDatabaseInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDatabaseInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DatabaseInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DatabaseInfoDto>;
        }));
    }

    protected processGetDatabaseInfo(response: HttpResponseBase): Observable<DatabaseInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DatabaseInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEnvironment(): Observable<EnvironmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Config/GetEnvironment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnvironment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnvironment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnvironmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnvironmentDto>;
        }));
    }

    protected processGetEnvironment(response: HttpResponseBase): Observable<EnvironmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnvironmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CorporateLicenceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchCorporateLicences(body: SearchCorporateLicencesInputDto | undefined): Observable<SearchCorporateLicencesOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/SearchCorporateLicences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCorporateLicences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCorporateLicences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchCorporateLicencesOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchCorporateLicencesOutputDto>;
        }));
    }

    protected processSearchCorporateLicences(response: HttpResponseBase): Observable<SearchCorporateLicencesOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchCorporateLicencesOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @return Success
     */
    getCorporateLicences(sponsorshipId: number | undefined): Observable<GetCorporateLicencesOutput> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/GetCorporateLicences?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCorporateLicences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCorporateLicences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCorporateLicencesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCorporateLicencesOutput>;
        }));
    }

    protected processGetCorporateLicences(response: HttpResponseBase): Observable<GetCorporateLicencesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCorporateLicencesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param businessId (optional) 
     * @return Success
     */
    getCorporateLicencesForBusiness(businessId: number | undefined): Observable<GetCorporateLicencesOutput> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/GetCorporateLicencesForBusiness?";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCorporateLicencesForBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCorporateLicencesForBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCorporateLicencesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCorporateLicencesOutput>;
        }));
    }

    protected processGetCorporateLicencesForBusiness(response: HttpResponseBase): Observable<GetCorporateLicencesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCorporateLicencesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getAssistantAndDelegatedLicencesForAssistantPerson(personId: number | undefined): Observable<CorporateLicenceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/GetAssistantAndDelegatedLicencesForAssistantPerson?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssistantAndDelegatedLicencesForAssistantPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssistantAndDelegatedLicencesForAssistantPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CorporateLicenceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CorporateLicenceDto[]>;
        }));
    }

    protected processGetAssistantAndDelegatedLicencesForAssistantPerson(response: HttpResponseBase): Observable<CorporateLicenceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CorporateLicenceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CorporateLicenceDto> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CorporateLicenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CorporateLicenceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CorporateLicenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CorporateLicenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getActiveResponsibleEmployments(id: number | undefined): Observable<GetEmploymentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/GetActiveResponsibleEmployments?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveResponsibleEmployments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveResponsibleEmployments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmploymentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmploymentDto[]>;
        }));
    }

    protected processGetActiveResponsibleEmployments(response: HttpResponseBase): Observable<GetEmploymentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmploymentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<CorporateLicenceHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CorporateLicenceHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CorporateLicenceHistoryDto[]>;
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<CorporateLicenceHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CorporateLicenceHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCorporateLicenceDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(id: number | undefined, body: UpdateCorporateLicenceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRenewal(body: CreateCorporateLicenceRenewalDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/CreateRenewal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRenewal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateRenewal(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateRenewal(id: number | undefined, body: UpdateCorporateLicenceRenewalDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/UpdateRenewal?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRenewal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRenewal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CorporateLicenceRestrictionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetCorporateLicenceRestrictionDto> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicenceRestriction/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCorporateLicenceRestrictionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCorporateLicenceRestrictionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetCorporateLicenceRestrictionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCorporateLicenceRestrictionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    post(body: CreateCorporateLicenceRestrictionDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicenceRestriction/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    put(id: number | undefined, body: UpdateCorporateLicenceRestrictionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicenceRestriction/Put?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicenceRestriction/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CriminalPenaltyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getAndCreateIfNotExisting(discriminator: CriminalPenaltyDiscriminator, entityId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CriminalPenalty/GetAndCreateIfNotExisting?";
        if (discriminator === undefined || discriminator === null)
            throw new Error("The parameter 'discriminator' must be defined and cannot be null.");
        else
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAndCreateIfNotExisting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAndCreateIfNotExisting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAndCreateIfNotExisting(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getRecords(id_Discriminator: CriminalPenaltyDiscriminator, id_EntityId: number, recordDiscriminator: CriminalPenaltyRecordDiscriminator, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetCriminalPenaltyRecordSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/CriminalPenalty/GetRecords?";
        if (id_Discriminator === undefined || id_Discriminator === null)
            throw new Error("The parameter 'id_Discriminator' must be defined and cannot be null.");
        else
            url_ += "Id.Discriminator=" + encodeURIComponent("" + id_Discriminator) + "&";
        if (id_EntityId === undefined || id_EntityId === null)
            throw new Error("The parameter 'id_EntityId' must be defined and cannot be null.");
        else
            url_ += "Id.EntityId=" + encodeURIComponent("" + id_EntityId) + "&";
        if (recordDiscriminator === undefined || recordDiscriminator === null)
            throw new Error("The parameter 'recordDiscriminator' must be defined and cannot be null.");
        else
            url_ += "RecordDiscriminator=" + encodeURIComponent("" + recordDiscriminator) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCriminalPenaltyRecordSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCriminalPenaltyRecordSearchOutputDto>;
        }));
    }

    protected processGetRecords(response: HttpResponseBase): Observable<GetCriminalPenaltyRecordSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCriminalPenaltyRecordSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRecord(id: number | undefined): Observable<GetCriminalPenaltyRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/CriminalPenalty/GetRecord?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCriminalPenaltyRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCriminalPenaltyRecordDto>;
        }));
    }

    protected processGetRecord(response: HttpResponseBase): Observable<GetCriminalPenaltyRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCriminalPenaltyRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRecord(discriminator: CriminalPenaltyDiscriminator, entityId: number, body: CreateCriminalPenaltyRecordDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CriminalPenalty/CreateRecord?";
        if (discriminator === undefined || discriminator === null)
            throw new Error("The parameter 'discriminator' must be defined and cannot be null.");
        else
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateRecord(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateRecord(id: number | undefined, body: UpdateCriminalPenaltyRecordDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CriminalPenalty/UpdateRecord?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRecord(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    getLicenceApplicationStatisticData(from: DateTime | undefined, to: DateTime | undefined): Observable<LicenceApplicationStatisticDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetLicenceApplicationStatisticData?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicenceApplicationStatisticData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicenceApplicationStatisticData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LicenceApplicationStatisticDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LicenceApplicationStatisticDto>;
        }));
    }

    protected processGetLicenceApplicationStatisticData(response: HttpResponseBase): Observable<LicenceApplicationStatisticDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenceApplicationStatisticDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNumberOfResponsibleLicenceApplications(): Observable<LicenceApplicationResponsibleStatisticDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetNumberOfResponsibleLicenceApplications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfResponsibleLicenceApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfResponsibleLicenceApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LicenceApplicationResponsibleStatisticDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LicenceApplicationResponsibleStatisticDto>;
        }));
    }

    protected processGetNumberOfResponsibleLicenceApplications(response: HttpResponseBase): Observable<LicenceApplicationResponsibleStatisticDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenceApplicationResponsibleStatisticDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param includeCompleted (optional) 
     * @return Success
     */
    getOwnResponsobilityEntities(includeCompleted: boolean | undefined): Observable<OwnResponsobilityEntityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetOwnResponsobilityEntities?";
        if (includeCompleted === null)
            throw new Error("The parameter 'includeCompleted' cannot be null.");
        else if (includeCompleted !== undefined)
            url_ += "includeCompleted=" + encodeURIComponent("" + includeCompleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOwnResponsobilityEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOwnResponsobilityEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OwnResponsobilityEntityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OwnResponsobilityEntityDto[]>;
        }));
    }

    protected processGetOwnResponsobilityEntities(response: HttpResponseBase): Observable<OwnResponsobilityEntityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OwnResponsobilityEntityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DiplomaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getDiplomas(personId: number, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetDiplomaSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/Diploma/GetDiplomas?";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined and cannot be null.");
        else
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiplomas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiplomas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDiplomaSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDiplomaSearchOutput>;
        }));
    }

    protected processGetDiplomas(response: HttpResponseBase): Observable<GetDiplomaSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDiplomaSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param diplomaId (optional) 
     * @return Success
     */
    getDiploma(diplomaId: number | undefined): Observable<DiplomaDto> {
        let url_ = this.baseUrl + "/api/services/app/Diploma/GetDiploma?";
        if (diplomaId === null)
            throw new Error("The parameter 'diplomaId' cannot be null.");
        else if (diplomaId !== undefined)
            url_ += "diplomaId=" + encodeURIComponent("" + diplomaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiploma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiploma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiplomaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiplomaDto>;
        }));
    }

    protected processGetDiploma(response: HttpResponseBase): Observable<DiplomaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiplomaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postDiploma(body: CreateDiplomaDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Diploma/PostDiploma";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostDiploma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostDiploma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPostDiploma(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    putDiploma(id: number | undefined, body: DiplomaDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Diploma/PutDiploma?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutDiploma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutDiploma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutDiploma(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteDiploma(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Diploma/DeleteDiploma?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDiploma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDiploma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDiploma(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DistrictServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getPlzForDistrict(districtCodeId: string, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetDistrictPlzSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/District/GetPlzForDistrict?";
        if (districtCodeId === undefined || districtCodeId === null)
            throw new Error("The parameter 'districtCodeId' must be defined and cannot be null.");
        else
            url_ += "DistrictCodeId=" + encodeURIComponent("" + districtCodeId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlzForDistrict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlzForDistrict(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDistrictPlzSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDistrictPlzSearchOutput>;
        }));
    }

    protected processGetPlzForDistrict(response: HttpResponseBase): Observable<GetDistrictPlzSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDistrictPlzSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param districtId (optional) 
     * @return Success
     */
    getDistrict(districtId: string | undefined): Observable<DistrictDto> {
        let url_ = this.baseUrl + "/api/services/app/District/GetDistrict?";
        if (districtId === null)
            throw new Error("The parameter 'districtId' cannot be null.");
        else if (districtId !== undefined)
            url_ += "districtId=" + encodeURIComponent("" + districtId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistrict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistrict(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DistrictDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DistrictDto>;
        }));
    }

    protected processGetDistrict(response: HttpResponseBase): Observable<DistrictDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DistrictDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postDistrict(body: DistrictDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/District/PostDistrict";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostDistrict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostDistrict(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPostDistrict(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putDistrict(body: DistrictDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/District/PutDistrict";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutDistrict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutDistrict(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutDistrict(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param districtId (optional) 
     * @return Success
     */
    deleteDistrict(districtId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/District/DeleteDistrict?";
        if (districtId === null)
            throw new Error("The parameter 'districtId' cannot be null.");
        else if (districtId !== undefined)
            url_ += "districtId=" + encodeURIComponent("" + districtId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDistrict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDistrict(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDistrict(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param districtId (optional) 
     * @param body (optional) 
     * @return Success
     */
    addPlzToDistrict(districtId: string | undefined, body: DistrictPlzDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/District/AddPlzToDistrict?";
        if (districtId === null)
            throw new Error("The parameter 'districtId' cannot be null.");
        else if (districtId !== undefined)
            url_ += "districtId=" + encodeURIComponent("" + districtId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPlzToDistrict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPlzToDistrict(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddPlzToDistrict(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param districtId (optional) 
     * @param plz (optional) 
     * @return Success
     */
    removePlzFromDistrict(districtId: string | undefined, plz: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/District/RemovePlzFromDistrict?";
        if (districtId === null)
            throw new Error("The parameter 'districtId' cannot be null.");
        else if (districtId !== undefined)
            url_ += "districtId=" + encodeURIComponent("" + districtId) + "&";
        if (plz === null)
            throw new Error("The parameter 'plz' cannot be null.");
        else if (plz !== undefined)
            url_ += "plz=" + encodeURIComponent("" + plz) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemovePlzFromDistrict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemovePlzFromDistrict(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemovePlzFromDistrict(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocumentManagementSystemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: GetDmsSearchInput | undefined): Observable<GetDmsSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDmsSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDmsSearchOutput>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<GetDmsSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDmsSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetDocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDocumentDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDocumentDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(id: number | undefined, body: UpdateDocumentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDocumentFile(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/GetDocumentFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDocumentFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    addLinks(id: number | undefined, body: LinkDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/AddLinks?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddLinks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    removeLink(id: number | undefined, discriminator: string, entityId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/RemoveLink?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (discriminator === undefined || discriminator === null)
            throw new Error("The parameter 'discriminator' must be defined and cannot be null.");
        else
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    sendDocument(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/SendDocument?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    generateWebdavAccessPath(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/GenerateWebdavAccessPath?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateWebdavAccessPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateWebdavAccessPath(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateWebdavAccessPath(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocumentManagementSystemScanImportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFile(body: ScanImportFileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemScanImport/UploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocumentManagementSystemTemplateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: SearchTemplatesInput | undefined): Observable<SearchTemplateOutput> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplate/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchTemplateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchTemplateOutput>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchTemplateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchTemplateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityType (optional) 
     * @param parentEntityId (optional) 
     * @return Success
     */
    getSelectableEntityList(entityType: DmsTemplateSelectableEntityType | undefined, parentEntityId: number | undefined): Observable<DmsTemplateSelectableEntityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplate/GetSelectableEntityList?";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        if (parentEntityId === null)
            throw new Error("The parameter 'parentEntityId' cannot be null.");
        else if (parentEntityId !== undefined)
            url_ += "parentEntityId=" + encodeURIComponent("" + parentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSelectableEntityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSelectableEntityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DmsTemplateSelectableEntityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DmsTemplateSelectableEntityDto[]>;
        }));
    }

    protected processGetSelectableEntityList(response: HttpResponseBase): Observable<DmsTemplateSelectableEntityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DmsTemplateSelectableEntityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generate(body: GenerateDocumentFromTemplateInputDto | undefined): Observable<GenerateDocumentFromTemplateResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplate/Generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenerateDocumentFromTemplateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenerateDocumentFromTemplateResultDto>;
        }));
    }

    protected processGenerate(response: HttpResponseBase): Observable<GenerateDocumentFromTemplateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateDocumentFromTemplateResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateFromTemplateDiscriminator(body: GenerateFromTemplateDiscriminatorInputDto | undefined): Observable<GenerateDocumentFromTemplateResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplate/GenerateFromTemplateDiscriminator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateFromTemplateDiscriminator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateFromTemplateDiscriminator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenerateDocumentFromTemplateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenerateDocumentFromTemplateResultDto>;
        }));
    }

    protected processGenerateFromTemplateDiscriminator(response: HttpResponseBase): Observable<GenerateDocumentFromTemplateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateDocumentFromTemplateResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocumentManagementSystemTemplateAdministrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: SearchTemplatesInput | undefined): Observable<SearchTemplateOutput> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplateAdministration/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchTemplateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchTemplateOutput>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchTemplateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchTemplateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param discriminator (optional) 
     * @return Success
     */
    countTemplates(discriminator: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplateAdministration/CountTemplates?";
        if (discriminator === null)
            throw new Error("The parameter 'discriminator' cannot be null.");
        else if (discriminator !== undefined)
            url_ += "discriminator=" + encodeURIComponent("" + discriminator) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCountTemplates(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplateAdministration/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTemplateDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFile(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplateAdministration/GetFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param discriminator (optional) 
     * @param body (optional) 
     * @return Success
     */
    create(discriminator: string | undefined, body: CreateUpdateTemplateDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplateAdministration/Create?";
        if (discriminator === null)
            throw new Error("The parameter 'discriminator' cannot be null.");
        else if (discriminator !== undefined)
            url_ += "discriminator=" + encodeURIComponent("" + discriminator) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(id: number | undefined, body: CreateUpdateTemplateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplateAdministration/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplateAdministration/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    generateXmlSchema(templateDiscriminator: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplateAdministration/GenerateXmlSchema?";
        if (templateDiscriminator === undefined || templateDiscriminator === null)
            throw new Error("The parameter 'templateDiscriminator' must be defined and cannot be null.");
        else
            url_ += "templateDiscriminator=" + encodeURIComponent("" + templateDiscriminator) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateXmlSchema(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateXmlSchema(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateXmlSchema(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getEditions(): Observable<ListResultDtoOfEditionListDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfEditionListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfEditionListDto>;
        }));
    }

    protected processGetEditions(response: HttpResponseBase): Observable<ListResultDtoOfEditionListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfEditionListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEditionForEdit(id: number | undefined): Observable<GetEditionEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditionEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditionEditOutput>;
        }));
    }

    protected processGetEditionForEdit(response: HttpResponseBase): Observable<GetEditionEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEdition(body: CreateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/CreateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEdition(body: UpdateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/UpdateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteEdition(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveTenantsToAnotherEdition(body: MoveTenantsToAnotherEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/MoveTenantsToAnotherEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveTenantsToAnotherEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveTenantsToAnotherEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveTenantsToAnotherEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectedEditionId (optional) 
     * @param addAllItem (optional) 
     * @param onlyFreeItems (optional) 
     * @return Success
     */
    getEditionComboboxItems(selectedEditionId: number | undefined, addAllItem: boolean | undefined, onlyFreeItems: boolean | undefined): Observable<SubscribableEditionComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId === null)
            throw new Error("The parameter 'selectedEditionId' cannot be null.");
        else if (selectedEditionId !== undefined)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&";
        if (addAllItem === null)
            throw new Error("The parameter 'addAllItem' cannot be null.");
        else if (addAllItem !== undefined)
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&";
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscribableEditionComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscribableEditionComboboxItemDto[]>;
        }));
    }

    protected processGetEditionComboboxItems(response: HttpResponseBase): Observable<SubscribableEditionComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    getTenantCount(editionId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetTenantCount?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTenantCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EducationGrantsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getEducationGrantsForPerson(personId: number | undefined): Observable<EducationGrantsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EducationGrants/GetEducationGrantsForPerson?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducationGrantsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducationGrantsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducationGrantsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducationGrantsDto[]>;
        }));
    }

    protected processGetEducationGrantsForPerson(response: HttpResponseBase): Observable<EducationGrantsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EducationGrantsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEducationGrants(body: EducationGrantsDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/EducationGrants/CreateOrUpdateEducationGrants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEducationGrants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEducationGrants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrUpdateEducationGrants(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEducationGrants(id: number | undefined): Observable<EducationGrants> {
        let url_ = this.baseUrl + "/api/services/app/EducationGrants/GetEducationGrants?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducationGrants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducationGrants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducationGrants>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducationGrants>;
        }));
    }

    protected processGetEducationGrants(response: HttpResponseBase): Observable<EducationGrants> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EducationGrants.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param educationGrantsId (optional) 
     * @return Success
     */
    getEducationCancellationByEducationGrant(educationGrantsId: number | undefined): Observable<EducationCancellationDto> {
        let url_ = this.baseUrl + "/api/services/app/EducationGrants/GetEducationCancellationByEducationGrant?";
        if (educationGrantsId === null)
            throw new Error("The parameter 'educationGrantsId' cannot be null.");
        else if (educationGrantsId !== undefined)
            url_ += "educationGrantsId=" + encodeURIComponent("" + educationGrantsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducationCancellationByEducationGrant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducationCancellationByEducationGrant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducationCancellationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducationCancellationDto>;
        }));
    }

    protected processGetEducationCancellationByEducationGrant(response: HttpResponseBase): Observable<EducationCancellationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EducationCancellationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEducationCancellation(body: EducationCancellationDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/EducationGrants/CreateOrUpdateEducationCancellation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEducationCancellation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEducationCancellation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrUpdateEducationCancellation(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param educationGrantsId (optional) 
     * @return Success
     */
    deleteEducationGrant(educationGrantsId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EducationGrants/DeleteEducationGrant?";
        if (educationGrantsId === null)
            throw new Error("The parameter 'educationGrantsId' cannot be null.");
        else if (educationGrantsId !== undefined)
            url_ += "educationGrantsId=" + encodeURIComponent("" + educationGrantsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEducationGrant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEducationGrant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEducationGrant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEhc(body: CreateEhcApplicationDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/CreateEhc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEhc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEhc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateEhc(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEhc(caseId: string | undefined): Observable<GetEhcOutput> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/GetEhc?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEhcOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEhcOutput>;
        }));
    }

    protected processGetEhc(response: HttpResponseBase): Observable<GetEhcOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEhcOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getName(caseId: string | undefined): Observable<ValueTupleOfStringStringString> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/GetName?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueTupleOfStringStringString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueTupleOfStringStringString>;
        }));
    }

    protected processGetName(response: HttpResponseBase): Observable<ValueTupleOfStringStringString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueTupleOfStringStringString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getExpenseHealthCarePersonalLicenceForEhc(caseId: string | undefined): Observable<GetEhcPersonalLicenceDto> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/GetExpenseHealthCarePersonalLicenceForEhc?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpenseHealthCarePersonalLicenceForEhc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpenseHealthCarePersonalLicenceForEhc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEhcPersonalLicenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEhcPersonalLicenceDto>;
        }));
    }

    protected processGetExpenseHealthCarePersonalLicenceForEhc(response: HttpResponseBase): Observable<GetEhcPersonalLicenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEhcPersonalLicenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getEhcs(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetEhcApplicationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/GetEhcs?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhcs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhcs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEhcApplicationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEhcApplicationsOutput>;
        }));
    }

    protected processGetEhcs(response: HttpResponseBase): Observable<GetEhcApplicationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEhcApplicationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    canGrantEhc(caseId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/CanGrantEhc?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanGrantEhc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanGrantEhc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanGrantEhc(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNextStatus(caseId: string, status: EhcStatus): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/GetNextStatus?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getFirstStep(caseId: string | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/GetFirstStep?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFirstStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirstStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processGetFirstStep(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyEhcs(): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/GetMyEhcs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyEhcs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyEhcs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetMyEhcs(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personGln (optional) 
     * @return Success
     */
    getEhcsForPerson(personGln: string | undefined): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/GetEhcsForPerson?";
        if (personGln === null)
            throw new Error("The parameter 'personGln' cannot be null.");
        else if (personGln !== undefined)
            url_ += "personGln=" + encodeURIComponent("" + personGln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhcsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhcsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetEhcsForPerson(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    withdrawEhc(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/WithdrawEhc?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithdrawEhc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithdrawEhc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWithdrawEhc(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseEhc(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/ReleaseEhc?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseEhc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseEhc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseEhc(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseCombinedApplications(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/ReleaseCombinedApplications?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseCombinedApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseCombinedApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseCombinedApplications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param withdrawLia (optional) 
     * @param releaseLia (optional) 
     * @return Success
     */
    withdrawCombinedApplications(caseId: string | undefined, withdrawLia: boolean | undefined, releaseLia: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/WithdrawCombinedApplications?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (withdrawLia === null)
            throw new Error("The parameter 'withdrawLia' cannot be null.");
        else if (withdrawLia !== undefined)
            url_ += "withdrawLia=" + encodeURIComponent("" + withdrawLia) + "&";
        if (releaseLia === null)
            throw new Error("The parameter 'releaseLia' cannot be null.");
        else if (releaseLia !== undefined)
            url_ += "releaseLia=" + encodeURIComponent("" + releaseLia) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithdrawCombinedApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithdrawCombinedApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWithdrawCombinedApplications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param liaId (optional) 
     * @return Success
     */
    getEhcByLiaId(liaId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/GetEhcByLiaId?";
        if (liaId === null)
            throw new Error("The parameter 'liaId' cannot be null.");
        else if (liaId !== undefined)
            url_ += "liaId=" + encodeURIComponent("" + liaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhcByLiaId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhcByLiaId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEhcByLiaId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param liaId (optional) 
     * @return Success
     */
    getEhcByLiaIdOrNull(liaId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/GetEhcByLiaIdOrNull?";
        if (liaId === null)
            throw new Error("The parameter 'liaId' cannot be null.");
        else if (liaId !== undefined)
            url_ += "liaId=" + encodeURIComponent("" + liaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhcByLiaIdOrNull(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhcByLiaIdOrNull(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEhcByLiaIdOrNull(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined): Observable<EhcStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<EhcStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcCapServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchEhcCap(body: GetEhcCapSearchInput | undefined): Observable<GetEhcCapSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcCap/SearchEhcCap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchEhcCap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchEhcCap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEhcCapSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEhcCapSearchOutput>;
        }));
    }

    protected processSearchEhcCap(response: HttpResponseBase): Observable<GetEhcCapSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEhcCapSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ehcCapId (optional) 
     * @return Success
     */
    getEhcCap(ehcCapId: number | undefined): Observable<EhcCapDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcCap/GetEhcCap?";
        if (ehcCapId === null)
            throw new Error("The parameter 'ehcCapId' cannot be null.");
        else if (ehcCapId !== undefined)
            url_ += "ehcCapId=" + encodeURIComponent("" + ehcCapId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhcCap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhcCap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcCapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcCapDto>;
        }));
    }

    protected processGetEhcCap(response: HttpResponseBase): Observable<EhcCapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EhcCapDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postEhcCap(body: CreateOrUpdateEhcCapDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/EhcCap/PostEhcCap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEhcCap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEhcCap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPostEhcCap(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ehcCapId (optional) 
     * @param body (optional) 
     * @return Success
     */
    putEhcCap(ehcCapId: number | undefined, body: CreateOrUpdateEhcCapDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcCap/PutEhcCap?";
        if (ehcCapId === null)
            throw new Error("The parameter 'ehcCapId' cannot be null.");
        else if (ehcCapId !== undefined)
            url_ += "ehcCapId=" + encodeURIComponent("" + ehcCapId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutEhcCap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutEhcCap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutEhcCap(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ehcCapId (optional) 
     * @return Success
     */
    deleteEhcCap(ehcCapId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcCap/DeleteEhcCap?";
        if (ehcCapId === null)
            throw new Error("The parameter 'ehcCapId' cannot be null.");
        else if (ehcCapId !== undefined)
            url_ += "ehcCapId=" + encodeURIComponent("" + ehcCapId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEhcCap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEhcCap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEhcCap(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param postgraduateTitleId (optional) 
     * @param postCode (optional) 
     * @return Success
     */
    isTitleStopped(postgraduateTitleId: string | undefined, postCode: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/EhcCap/IsTitleStopped?";
        if (postgraduateTitleId === null)
            throw new Error("The parameter 'postgraduateTitleId' cannot be null.");
        else if (postgraduateTitleId !== undefined)
            url_ += "postgraduateTitleId=" + encodeURIComponent("" + postgraduateTitleId) + "&";
        if (postCode === null)
            throw new Error("The parameter 'postCode' cannot be null.");
        else if (postCode !== undefined)
            url_ += "postCode=" + encodeURIComponent("" + postCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTitleStopped(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTitleStopped(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsTitleStopped(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isOneOrMoreTitleStopped(body: GetOneOrMoreTitleStoppedInputDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/EhcCap/IsOneOrMoreTitleStopped";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsOneOrMoreTitleStopped(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsOneOrMoreTitleStopped(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsOneOrMoreTitleStopped(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importEhcCap(body: ImportEhcCapExcelFileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcCap/ImportEhcCap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportEhcCap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportEhcCap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportEhcCap(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcCapWaitListServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchEhcCapWaitList(body: GetEhcCapWaitListSearchInput | undefined): Observable<GetEhcCapWaitListSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcCapWaitList/SearchEhcCapWaitList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchEhcCapWaitList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchEhcCapWaitList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEhcCapWaitListSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEhcCapWaitListSearchOutput>;
        }));
    }

    protected processSearchEhcCapWaitList(response: HttpResponseBase): Observable<GetEhcCapWaitListSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEhcCapWaitListSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEhcCapWaitList(id: number | undefined): Observable<EhcCapWaitListEntryDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcCapWaitList/GetEhcCapWaitList?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhcCapWaitList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhcCapWaitList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcCapWaitListEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcCapWaitListEntryDto>;
        }));
    }

    protected processGetEhcCapWaitList(response: HttpResponseBase): Observable<EhcCapWaitListEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EhcCapWaitListEntryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEhcCapWaitListEntryFromApplication(body: CreateEhcCapWaitListEntryFromApplicationDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/EhcCapWaitList/CreateEhcCapWaitListEntryFromApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEhcCapWaitListEntryFromApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEhcCapWaitListEntryFromApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateEhcCapWaitListEntryFromApplication(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEhcCapWaitListEntry(body: CreateEhcCapWaitListEntryDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/EhcCapWaitList/CreateEhcCapWaitListEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEhcCapWaitListEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEhcCapWaitListEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateEhcCapWaitListEntry(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param reason (optional) 
     * @return Success
     */
    deleteEhcCapWaitListEntry(id: number | undefined, reason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcCapWaitList/DeleteEhcCapWaitListEntry?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEhcCapWaitListEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEhcCapWaitListEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEhcCapWaitListEntry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    notConsiderWithdrawOrRejectApplication(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcCapWaitList/NotConsiderWithdrawOrRejectApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotConsiderWithdrawOrRejectApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotConsiderWithdrawOrRejectApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotConsiderWithdrawOrRejectApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    isApplicationOnEhcCapWaitList(caseId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/EhcCapWaitList/IsApplicationOnEhcCapWaitList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsApplicationOnEhcCapWaitList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsApplicationOnEhcCapWaitList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsApplicationOnEhcCapWaitList(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    isApplicationDeletedFromEhcCapWaitList(caseId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/EhcCapWaitList/IsApplicationDeletedFromEhcCapWaitList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsApplicationDeletedFromEhcCapWaitList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsApplicationDeletedFromEhcCapWaitList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsApplicationDeletedFromEhcCapWaitList(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getLiaContactReadOnly(caseId: string | undefined): Observable<LiaContactDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcContact/GetLiaContactReadOnly?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaContactReadOnly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaContactReadOnly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaContactDto>;
        }));
    }

    protected processGetLiaContactReadOnly(response: HttpResponseBase): Observable<LiaContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getPersonContactReadOnly(caseId: string | undefined): Observable<MySironaPersonContactDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcContact/GetPersonContactReadOnly?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonContactReadOnly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonContactReadOnly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MySironaPersonContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MySironaPersonContactDto>;
        }));
    }

    protected processGetPersonContactReadOnly(response: HttpResponseBase): Observable<MySironaPersonContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MySironaPersonContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    proceedEhcContact(caseId: string | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcContact/ProceedEhcContact?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProceedEhcContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProceedEhcContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processProceedEhcContact(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcContact(body: CreateOrUpdateEhcContactInput | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcContact/CreateOrUpdateEhcContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processCreateOrUpdateEhcContact(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getEhcDocuments(caseId: string, step: EhcStatus | undefined): Observable<EhcDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcDocument/GetEhcDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhcDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhcDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcDocumentsOutput>;
        }));
    }

    protected processGetEhcDocuments(response: HttpResponseBase): Observable<EhcDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EhcDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EhcDocument/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: EhcStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcDocument/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: EhcStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcDocument/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcElectronicPatientRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcElectronicPatientRecord(body: CreateOrUpdateEhcElectronicPatientRecordInput | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcElectronicPatientRecord/CreateOrUpdateEhcElectronicPatientRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcElectronicPatientRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcElectronicPatientRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processCreateOrUpdateEhcElectronicPatientRecord(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getEhcElectronicPatientRecordDocuments(caseId: string, step: EhcStatus | undefined): Observable<EhcDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcElectronicPatientRecord/GetEhcElectronicPatientRecordDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhcElectronicPatientRecordDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhcElectronicPatientRecordDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcDocumentsOutput>;
        }));
    }

    protected processGetEhcElectronicPatientRecordDocuments(response: HttpResponseBase): Observable<EhcDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EhcDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EhcElectronicPatientRecord/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: EhcStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcElectronicPatientRecord/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: EhcStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcElectronicPatientRecord/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcEmploymentOrPostgraduateTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getInitialList(caseId: string | undefined): Observable<EhcEmploymentOrPostgraduateTitleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EhcEmploymentOrPostgraduateTitle/GetInitialList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInitialList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInitialList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcEmploymentOrPostgraduateTitleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcEmploymentOrPostgraduateTitleDto[]>;
        }));
    }

    protected processGetInitialList(response: HttpResponseBase): Observable<EhcEmploymentOrPostgraduateTitleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EhcEmploymentOrPostgraduateTitleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcEmploymentOrPostgraduateTitles(body: CreateOrUpdateEhcEmploymentOrPostgraduateTitleInput | undefined): Observable<CreateOrUpdateEhcEmploymentOrPostgraduateTitlesOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcEmploymentOrPostgraduateTitle/CreateOrUpdateEhcEmploymentOrPostgraduateTitles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcEmploymentOrPostgraduateTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcEmploymentOrPostgraduateTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateEhcEmploymentOrPostgraduateTitlesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateEhcEmploymentOrPostgraduateTitlesOutput>;
        }));
    }

    protected processCreateOrUpdateEhcEmploymentOrPostgraduateTitles(response: HttpResponseBase): Observable<CreateOrUpdateEhcEmploymentOrPostgraduateTitlesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateEhcEmploymentOrPostgraduateTitlesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcInvoiceAddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    ehcInvoiceAddressOk(caseId: string | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcInvoiceAddress/EhcInvoiceAddressOk?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEhcInvoiceAddressOk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEhcInvoiceAddressOk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processEhcInvoiceAddressOk(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcInvoiceAddress(body: CreateOrUpdateEhcInvoiceAddressInput | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcInvoiceAddress/CreateOrUpdateEhcInvoiceAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcInvoiceAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcInvoiceAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processCreateOrUpdateEhcInvoiceAddress(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcLanguageSkillServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcLanguageSkill(body: CreateOrUpdateEhcLanguageSkillInput | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcLanguageSkill/CreateOrUpdateEhcLanguageSkill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcLanguageSkill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcLanguageSkill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processCreateOrUpdateEhcLanguageSkill(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getEhcLanguageSkillDocuments(caseId: string, step: EhcStatus | undefined): Observable<EhcDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcLanguageSkill/GetEhcLanguageSkillDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhcLanguageSkillDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhcLanguageSkillDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcDocumentsOutput>;
        }));
    }

    protected processGetEhcLanguageSkillDocuments(response: HttpResponseBase): Observable<EhcDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EhcDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EhcLanguageSkill/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: EhcStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcLanguageSkill/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: EhcStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcLanguageSkill/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcMedicalFieldServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getPostgraduateTitles(caseId: string | undefined): Observable<MedRegWbtDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EhcMedicalField/GetPostgraduateTitles?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostgraduateTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostgraduateTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedRegWbtDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedRegWbtDto[]>;
        }));
    }

    protected processGetPostgraduateTitles(response: HttpResponseBase): Observable<MedRegWbtDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MedRegWbtDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcMedicalField(body: CreateOrUpdateEhcMedicalFieldInput | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcMedicalField/CreateOrUpdateEhcMedicalField";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcMedicalField(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcMedicalField(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processCreateOrUpdateEhcMedicalField(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcPostgraduateTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getList(caseId: string | undefined): Observable<EhcPostgraduateTitleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EhcPostgraduateTitle/GetList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcPostgraduateTitleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcPostgraduateTitleDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<EhcPostgraduateTitleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EhcPostgraduateTitleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcPostgraduateTitles(body: CreateOrUpdateEhcPostgraduateTitlesInput | undefined): Observable<CreateOrUpdateEhcPostgraduateTitlesOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcPostgraduateTitle/CreateOrUpdateEhcPostgraduateTitles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcPostgraduateTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcPostgraduateTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateEhcPostgraduateTitlesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateEhcPostgraduateTitlesOutput>;
        }));
    }

    protected processCreateOrUpdateEhcPostgraduateTitles(response: HttpResponseBase): Observable<CreateOrUpdateEhcPostgraduateTitlesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateEhcPostgraduateTitlesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcEmployments(body: CreateOrUpdateEhcEmploymentsInput | undefined): Observable<CreateOrUpdateEhcPostgraduateTitlesOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcPostgraduateTitle/CreateOrUpdateEhcEmployments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcEmployments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcEmployments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateEhcPostgraduateTitlesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateEhcPostgraduateTitlesOutput>;
        }));
    }

    protected processCreateOrUpdateEhcEmployments(response: HttpResponseBase): Observable<CreateOrUpdateEhcPostgraduateTitlesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateEhcPostgraduateTitlesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcPracticeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcPractices(body: CreateOrUpdateEhcPracticesInput | undefined): Observable<CreateOrUpdateEhcPracticesOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcPractice/CreateOrUpdateEhcPractices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcPractices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcPractices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateEhcPracticesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateEhcPracticesOutput>;
        }));
    }

    protected processCreateOrUpdateEhcPractices(response: HttpResponseBase): Observable<CreateOrUpdateEhcPracticesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateEhcPracticesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    hasEmploymentOrPostgraduateTitle(caseId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/EhcPractice/HasEmploymentOrPostgraduateTitle?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasEmploymentOrPostgraduateTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasEmploymentOrPostgraduateTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasEmploymentOrPostgraduateTitle(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEhcPractice(caseId: string | undefined): Observable<EhcPracticeDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcPractice/GetEhcPractice?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhcPractice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhcPractice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcPracticeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcPracticeDto>;
        }));
    }

    protected processGetEhcPractice(response: HttpResponseBase): Observable<EhcPracticeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EhcPracticeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param postgraduateTitleId (optional) 
     * @return Success
     */
    createBlankEhcPracticeRecord(caseId: string | undefined, postgraduateTitleId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EhcPractice/CreateBlankEhcPracticeRecord?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (postgraduateTitleId === null)
            throw new Error("The parameter 'postgraduateTitleId' cannot be null.");
        else if (postgraduateTitleId !== undefined)
            url_ += "postgraduateTitleId=" + encodeURIComponent("" + postgraduateTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBlankEhcPracticeRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBlankEhcPracticeRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateBlankEhcPracticeRecord(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param ehcPracticeRecordId (optional) 
     * @return Success
     */
    deleteEhcPracticeRecord(caseId: string | undefined, ehcPracticeRecordId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcPractice/DeleteEhcPracticeRecord?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (ehcPracticeRecordId === null)
            throw new Error("The parameter 'ehcPracticeRecordId' cannot be null.");
        else if (ehcPracticeRecordId !== undefined)
            url_ += "ehcPracticeRecordId=" + encodeURIComponent("" + ehcPracticeRecordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEhcPracticeRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEhcPracticeRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEhcPracticeRecord(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param hasExemptionAccordingArt37Kvg (optional) 
     * @return Success
     */
    getEhcPracticeRecordFiles(caseId: string, hasExemptionAccordingArt37Kvg: boolean | undefined): Observable<EhcDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcPractice/GetEhcPracticeRecordFiles?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (hasExemptionAccordingArt37Kvg === null)
            throw new Error("The parameter 'hasExemptionAccordingArt37Kvg' cannot be null.");
        else if (hasExemptionAccordingArt37Kvg !== undefined)
            url_ += "HasExemptionAccordingArt37Kvg=" + encodeURIComponent("" + hasExemptionAccordingArt37Kvg) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhcPracticeRecordFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhcPracticeRecordFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcDocumentsOutput>;
        }));
    }

    protected processGetEhcPracticeRecordFiles(response: HttpResponseBase): Observable<EhcDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EhcDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ehcPracticeRecordId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(ehcPracticeRecordId: string | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EhcPractice/UploadFiles?";
        if (ehcPracticeRecordId === null)
            throw new Error("The parameter 'ehcPracticeRecordId' cannot be null.");
        else if (ehcPracticeRecordId !== undefined)
            url_ += "ehcPracticeRecordId=" + encodeURIComponent("" + ehcPracticeRecordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: EhcStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcPractice/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: EhcStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcPractice/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcPracticeConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param professionId (optional) 
     * @return Success
     */
    get(professionId: string | undefined): Observable<EhcPracticeConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcPracticeConfiguration/Get?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcPracticeConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcPracticeConfigurationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EhcPracticeConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EhcPracticeConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateEhcPracticeConfigurationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcPracticeConfiguration/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param professionId (optional) 
     * @return Success
     */
    delete(professionId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcPracticeConfiguration/Delete?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcQualityRequirementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcQualityRequirement(body: CreateOrUpdateEhcQualityRequirementInput | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcQualityRequirement/CreateOrUpdateEhcQualityRequirement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcQualityRequirement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcQualityRequirement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processCreateOrUpdateEhcQualityRequirement(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getEhcQualityRequirementDocuments(caseId: string, step: EhcStatus | undefined): Observable<EhcDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcQualityRequirement/GetEhcQualityRequirementDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhcQualityRequirementDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhcQualityRequirementDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcDocumentsOutput>;
        }));
    }

    protected processGetEhcQualityRequirementDocuments(response: HttpResponseBase): Observable<EhcDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EhcDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EhcQualityRequirement/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: EhcStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcQualityRequirement/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: EhcStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcQualityRequirement/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcRegisterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getLegitimatedGlnForRegister(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EhcRegister/GetLegitimatedGlnForRegister?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLegitimatedGlnForRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLegitimatedGlnForRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLegitimatedGlnForRegister(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcRegister(body: CreateOrUpdateEhcRegister | undefined): Observable<CreateOrUpdateEhcRegisterOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcRegister/CreateOrUpdateEhcRegister";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateEhcRegisterOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateEhcRegisterOutputDto>;
        }));
    }

    protected processCreateOrUpdateEhcRegister(response: HttpResponseBase): Observable<CreateOrUpdateEhcRegisterOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateEhcRegisterOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    acceptRegisterCheck(caseId: string | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcRegister/AcceptRegisterCheck?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processAcceptRegisterCheck(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcSelfEmploymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcSelfEmployment(body: CreateOrUpdateEhcSelfEmploymentInput | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcSelfEmployment/CreateOrUpdateEhcSelfEmployment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcSelfEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcSelfEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processCreateOrUpdateEhcSelfEmployment(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcStaffServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcStaff(body: CreateOrUpdateEhcStaffInput | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcStaff/CreateOrUpdateEhcStaff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcStaff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcStaff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processCreateOrUpdateEhcStaff(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcStatusWizardStepServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param professionId (optional) 
     * @param applicationType (optional) 
     * @return Success
     */
    getAllByProfessionId(professionId: string | undefined, applicationType: ApplicationType | undefined): Observable<EhcStatusWizardStepDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EhcStatusWizardStep/GetAllByProfessionId?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (applicationType === null)
            throw new Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByProfessionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByProfessionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatusWizardStepDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatusWizardStepDto[]>;
        }));
    }

    protected processGetAllByProfessionId(response: HttpResponseBase): Observable<EhcStatusWizardStepDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EhcStatusWizardStepDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateEhcStatusWizardStepInput | undefined): Observable<EhcStatusWizardStepDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcStatusWizardStep/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatusWizardStepDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatusWizardStepDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<EhcStatusWizardStepDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EhcStatusWizardStepDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMany(body: UpdateEhcStatusWizardStepsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcStatusWizardStep/UpdateMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @param professionId (optional) 
     * @param applicationType (optional) 
     * @return Success
     */
    delete(step: number | undefined, professionId: string | undefined, applicationType: ApplicationType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcStatusWizardStep/Delete?";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (applicationType === null)
            throw new Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmploymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param personId (optional) 
     * @param sponsorshipId (optional) 
     * @param businessId (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getEmployments(personId: number | undefined, sponsorshipId: number | undefined, businessId: number | undefined, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<EmploymentSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Employment/GetEmployments?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "SponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "BusinessId=" + encodeURIComponent("" + businessId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmploymentSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmploymentSearchOutputDto>;
        }));
    }

    protected processGetEmployments(response: HttpResponseBase): Observable<EmploymentSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmploymentSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @param corporateLicenceId (optional) 
     * @return Success
     */
    getEmploymentsForSponsorship(sponsorshipId: number | undefined, corporateLicenceId: number | undefined): Observable<GetEmploymentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employment/GetEmploymentsForSponsorship?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        if (corporateLicenceId === null)
            throw new Error("The parameter 'corporateLicenceId' cannot be null.");
        else if (corporateLicenceId !== undefined)
            url_ += "corporateLicenceId=" + encodeURIComponent("" + corporateLicenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmploymentsForSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmploymentsForSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmploymentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmploymentDto[]>;
        }));
    }

    protected processGetEmploymentsForSponsorship(response: HttpResponseBase): Observable<GetEmploymentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmploymentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @return Success
     */
    getEmploymentsWithSensitiveDataForSponsorship(sponsorshipId: number | undefined): Observable<GetEmploymentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employment/GetEmploymentsWithSensitiveDataForSponsorship?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmploymentsWithSensitiveDataForSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmploymentsWithSensitiveDataForSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmploymentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmploymentDto[]>;
        }));
    }

    protected processGetEmploymentsWithSensitiveDataForSponsorship(response: HttpResponseBase): Observable<GetEmploymentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmploymentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getActiveMedicalFieldDirectorThatWillBeReplacedOrNull(body: GetActiveMedicalFieldDirectorThatWillBeReplacedInput | undefined): Observable<GetEmploymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Employment/GetActiveMedicalFieldDirectorThatWillBeReplacedOrNull";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveMedicalFieldDirectorThatWillBeReplacedOrNull(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveMedicalFieldDirectorThatWillBeReplacedOrNull(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmploymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmploymentDto>;
        }));
    }

    protected processGetActiveMedicalFieldDirectorThatWillBeReplacedOrNull(response: HttpResponseBase): Observable<GetEmploymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmploymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param typeIds (optional) 
     * @return Success
     */
    getEmploymentsForPerson(personId: number | undefined, typeIds: PersonLicenceType[] | undefined): Observable<GetEmploymentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employment/GetEmploymentsForPerson?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (typeIds === null)
            throw new Error("The parameter 'typeIds' cannot be null.");
        else if (typeIds !== undefined)
            typeIds && typeIds.forEach(item => { url_ += "typeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmploymentsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmploymentsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmploymentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmploymentDto[]>;
        }));
    }

    protected processGetEmploymentsForPerson(response: HttpResponseBase): Observable<GetEmploymentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmploymentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param businessId (optional) 
     * @return Success
     */
    getEmploymentsForBusiness(businessId: number | undefined): Observable<GetEmploymentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employment/GetEmploymentsForBusiness?";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmploymentsForBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmploymentsForBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmploymentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmploymentDto[]>;
        }));
    }

    protected processGetEmploymentsForBusiness(response: HttpResponseBase): Observable<GetEmploymentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmploymentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetEmploymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Employment/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmploymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmploymentDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetEmploymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmploymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLinkedLocalSalesLicenceForEmployment(id: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Employment/GetLinkedLocalSalesLicenceForEmployment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLinkedLocalSalesLicenceForEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkedLocalSalesLicenceForEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetLinkedLocalSalesLicenceForEmployment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateEmploymentDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Employment/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(id: number | undefined, body: UpdateEmploymentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employmentId (optional) 
     * @param personId (optional) 
     * @param licenceId (optional) 
     * @return Success
     */
    linkPersonToEmployment(employmentId: number | undefined, personId: number | undefined, licenceId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/LinkPersonToEmployment?";
        if (employmentId === null)
            throw new Error("The parameter 'employmentId' cannot be null.");
        else if (employmentId !== undefined)
            url_ += "employmentId=" + encodeURIComponent("" + employmentId) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (licenceId === null)
            throw new Error("The parameter 'licenceId' cannot be null.");
        else if (licenceId !== undefined)
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkPersonToEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkPersonToEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkPersonToEmployment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employmentId (optional) 
     * @return Success
     */
    unlinkPersonFromEmployment(employmentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/UnlinkPersonFromEmployment?";
        if (employmentId === null)
            throw new Error("The parameter 'employmentId' cannot be null.");
        else if (employmentId !== undefined)
            url_ += "employmentId=" + encodeURIComponent("" + employmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkPersonFromEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkPersonFromEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkPersonFromEmployment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employmentId (optional) 
     * @param sponsorshipId (optional) 
     * @return Success
     */
    linkSponsorshipToEmployment(employmentId: number | undefined, sponsorshipId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/LinkSponsorshipToEmployment?";
        if (employmentId === null)
            throw new Error("The parameter 'employmentId' cannot be null.");
        else if (employmentId !== undefined)
            url_ += "employmentId=" + encodeURIComponent("" + employmentId) + "&";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkSponsorshipToEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkSponsorshipToEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkSponsorshipToEmployment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employmentId (optional) 
     * @return Success
     */
    unlinkSponsorshipFromEmployment(employmentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/UnlinkSponsorshipFromEmployment?";
        if (employmentId === null)
            throw new Error("The parameter 'employmentId' cannot be null.");
        else if (employmentId !== undefined)
            url_ += "employmentId=" + encodeURIComponent("" + employmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkSponsorshipFromEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkSponsorshipFromEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkSponsorshipFromEmployment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employmentId (optional) 
     * @param businessId (optional) 
     * @return Success
     */
    linkBusinessToExpenseHealthCarePersonalLicenceEmployment(employmentId: number | undefined, businessId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/LinkBusinessToExpenseHealthCarePersonalLicenceEmployment?";
        if (employmentId === null)
            throw new Error("The parameter 'employmentId' cannot be null.");
        else if (employmentId !== undefined)
            url_ += "employmentId=" + encodeURIComponent("" + employmentId) + "&";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkBusinessToExpenseHealthCarePersonalLicenceEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkBusinessToExpenseHealthCarePersonalLicenceEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkBusinessToExpenseHealthCarePersonalLicenceEmployment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employmentId (optional) 
     * @return Success
     */
    unlinkBusinessFromExpenseHealthCarePersonalLicenceEmployment(employmentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/UnlinkBusinessFromExpenseHealthCarePersonalLicenceEmployment?";
        if (employmentId === null)
            throw new Error("The parameter 'employmentId' cannot be null.");
        else if (employmentId !== undefined)
            url_ += "employmentId=" + encodeURIComponent("" + employmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkBusinessFromExpenseHealthCarePersonalLicenceEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkBusinessFromExpenseHealthCarePersonalLicenceEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkBusinessFromExpenseHealthCarePersonalLicenceEmployment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employmentId (optional) 
     * @param businessId (optional) 
     * @return Success
     */
    linkBusinessToEmployment(employmentId: number | undefined, businessId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/LinkBusinessToEmployment?";
        if (employmentId === null)
            throw new Error("The parameter 'employmentId' cannot be null.");
        else if (employmentId !== undefined)
            url_ += "employmentId=" + encodeURIComponent("" + employmentId) + "&";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkBusinessToEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkBusinessToEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkBusinessToEmployment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employmentId (optional) 
     * @return Success
     */
    unlinkBusinessFromEmployment(employmentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/UnlinkBusinessFromEmployment?";
        if (employmentId === null)
            throw new Error("The parameter 'employmentId' cannot be null.");
        else if (employmentId !== undefined)
            url_ += "employmentId=" + encodeURIComponent("" + employmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkBusinessFromEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkBusinessFromEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkBusinessFromEmployment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employmentId (optional) 
     * @return Success
     */
    checkDeletingConditions(employmentId: number | undefined): Observable<EmploymentDeletingConditions> {
        let url_ = this.baseUrl + "/api/services/app/Employment/CheckDeletingConditions?";
        if (employmentId === null)
            throw new Error("The parameter 'employmentId' cannot be null.");
        else if (employmentId !== undefined)
            url_ += "employmentId=" + encodeURIComponent("" + employmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDeletingConditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDeletingConditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmploymentDeletingConditions>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmploymentDeletingConditions>;
        }));
    }

    protected processCheckDeletingConditions(response: HttpResponseBase): Observable<EmploymentDeletingConditions> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmploymentDeletingConditions.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmploymentAddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<EmploymentAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/EmploymentAddress/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmploymentAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmploymentAddressDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EmploymentAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmploymentAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateEmploymentAddressInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmploymentAddress/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileDossierServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: GetFileDossierSearchInput | undefined): Observable<GetFileDossierSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/FileDossier/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFileDossierSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFileDossierSearchOutput>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<GetFileDossierSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFileDossierSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetFileDossierDto> {
        let url_ = this.baseUrl + "/api/services/app/FileDossier/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFileDossierDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFileDossierDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetFileDossierDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFileDossierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param sponsorshipId (optional) 
     * @param body (optional) 
     * @return Success
     */
    create(personId: number | undefined, sponsorshipId: number | undefined, body: CreateOrUpdateFileDossierDto | undefined): Observable<GetFileDossierDto> {
        let url_ = this.baseUrl + "/api/services/app/FileDossier/Create?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFileDossierDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFileDossierDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<GetFileDossierDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFileDossierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(id: number | undefined, body: CreateOrUpdateFileDossierDto | undefined): Observable<GetFileDossierDto> {
        let url_ = this.baseUrl + "/api/services/app/FileDossier/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFileDossierDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFileDossierDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<GetFileDossierDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFileDossierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FileDossier/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param generateXml (optional) 
     * @return Success
     */
    generateZipFileArchive(id: number | undefined, generateXml: boolean | undefined): Observable<GenerateZipFileArchiveOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/FileDossier/GenerateZipFileArchive?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (generateXml === null)
            throw new Error("The parameter 'generateXml' cannot be null.");
        else if (generateXml !== undefined)
            url_ += "generateXml=" + encodeURIComponent("" + generateXml) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateZipFileArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateZipFileArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenerateZipFileArchiveOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenerateZipFileArchiveOutputDto>;
        }));
    }

    protected processGenerateZipFileArchive(response: HttpResponseBase): Observable<GenerateZipFileArchiveOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateZipFileArchiveOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FriendshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFriendshipRequest(body: CreateFriendshipRequestInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FriendDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FriendDto>;
        }));
    }

    protected processCreateFriendshipRequest(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FriendDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFriendshipRequestByUserName(body: CreateFriendshipRequestByUserNameInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequestByUserName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendshipRequestByUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipRequestByUserName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FriendDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FriendDto>;
        }));
    }

    protected processCreateFriendshipRequestByUserName(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FriendDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    blockUser(body: BlockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/BlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unblockUser(body: UnblockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/UnblockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnblockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnblockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnblockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    acceptFriendshipRequest(body: AcceptFriendshipRequestInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/AcceptFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptFriendshipRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcceptFriendshipRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) The field UserId must be between 1 and 9.223372036854776E+18.
     * @param tenantId (optional) 
     * @return Success
     */
    removeFriend(userId: number | undefined, tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/RemoveFriend?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveFriend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveFriend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveFriend(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HealthRegServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    performHealthRegisterCheck(body: PerformHealthRegisterCheckInput | undefined): Observable<HealthRegisterIdentificationStatus> {
        let url_ = this.baseUrl + "/api/services/app/HealthReg/PerformHealthRegisterCheck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPerformHealthRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPerformHealthRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthRegisterIdentificationStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthRegisterIdentificationStatus>;
        }));
    }

    protected processPerformHealthRegisterCheck(response: HttpResponseBase): Observable<HealthRegisterIdentificationStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HealthRegCachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param externalSystem (optional) 
     * @return Success
     */
    getExportCache(externalSystem: ExternalSystemEnum | undefined): Observable<HealthRegExportCacheOutput> {
        let url_ = this.baseUrl + "/api/services/app/HealthRegCaching/GetExportCache?";
        if (externalSystem === null)
            throw new Error("The parameter 'externalSystem' cannot be null.");
        else if (externalSystem !== undefined)
            url_ += "externalSystem=" + encodeURIComponent("" + externalSystem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthRegExportCacheOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthRegExportCacheOutput>;
        }));
    }

    protected processGetExportCache(response: HttpResponseBase): Observable<HealthRegExportCacheOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthRegExportCacheOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importCache(body: HealthRegExportCacheInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/HealthRegCaching/ImportCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processImportCache(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HealthRegisterSnapshotServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param step (optional) 
     * @param index (optional) 
     * @return Success
     */
    getRegisterSnapshotDetailed(caseId: string | undefined, step: number | undefined, index: number | undefined): Observable<HealthRegisterSnapshotResultOfHealthRegisterSnapshotDetailedDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthRegisterSnapshot/GetRegisterSnapshotDetailed?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        if (index === null)
            throw new Error("The parameter 'index' cannot be null.");
        else if (index !== undefined)
            url_ += "index=" + encodeURIComponent("" + index) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegisterSnapshotDetailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegisterSnapshotDetailed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthRegisterSnapshotResultOfHealthRegisterSnapshotDetailedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthRegisterSnapshotResultOfHealthRegisterSnapshotDetailedDto>;
        }));
    }

    protected processGetRegisterSnapshotDetailed(response: HttpResponseBase): Observable<HealthRegisterSnapshotResultOfHealthRegisterSnapshotDetailedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthRegisterSnapshotResultOfHealthRegisterSnapshotDetailedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param step (optional) 
     * @param index (optional) 
     * @return Success
     */
    getRegisterSnapshotPublic(caseId: string | undefined, step: number | undefined, index: number | undefined): Observable<HealthRegisterSnapshotResultOfHealthRegisterSnapshotPublicDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthRegisterSnapshot/GetRegisterSnapshotPublic?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        if (index === null)
            throw new Error("The parameter 'index' cannot be null.");
        else if (index !== undefined)
            url_ += "index=" + encodeURIComponent("" + index) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegisterSnapshotPublic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegisterSnapshotPublic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthRegisterSnapshotResultOfHealthRegisterSnapshotPublicDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthRegisterSnapshotResultOfHealthRegisterSnapshotPublicDto>;
        }));
    }

    protected processGetRegisterSnapshotPublic(response: HttpResponseBase): Observable<HealthRegisterSnapshotResultOfHealthRegisterSnapshotPublicDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthRegisterSnapshotResultOfHealthRegisterSnapshotPublicDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HostDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getTopStatsData(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<TopStatsData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetTopStatsData?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopStatsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopStatsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopStatsData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopStatsData>;
        }));
    }

    protected processGetTopStatsData(response: HttpResponseBase): Observable<TopStatsData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopStatsData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRecentTenantsData(): Observable<GetRecentTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetRecentTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentTenantsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRecentTenantsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRecentTenantsOutput>;
        }));
    }

    protected processGetRecentTenantsData(response: HttpResponseBase): Observable<GetRecentTenantsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecentTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSubscriptionExpiringTenantsData(): Observable<GetExpiringTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetSubscriptionExpiringTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionExpiringTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionExpiringTenantsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExpiringTenantsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExpiringTenantsOutput>;
        }));
    }

    protected processGetSubscriptionExpiringTenantsData(response: HttpResponseBase): Observable<GetExpiringTenantsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExpiringTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param incomeStatisticsDateInterval (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getIncomeStatistics(incomeStatisticsDateInterval: ChartDateInterval | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<GetIncomeStatisticsDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval === null)
            throw new Error("The parameter 'incomeStatisticsDateInterval' cannot be null.");
        else if (incomeStatisticsDateInterval !== undefined)
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomeStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomeStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIncomeStatisticsDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIncomeStatisticsDataOutput>;
        }));
    }

    protected processGetIncomeStatistics(response: HttpResponseBase): Observable<GetIncomeStatisticsDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIncomeStatisticsDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getEditionTenantStatistics(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<GetEditionTenantStatisticsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionTenantStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionTenantStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditionTenantStatisticsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditionTenantStatisticsOutput>;
        }));
    }

    protected processGetEditionTenantStatistics(response: HttpResponseBase): Observable<GetEditionTenantStatisticsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionTenantStatisticsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<HostSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HostSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HostSettingsEditDto>;
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<HostSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HostSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllSettings(body: HostSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEnabledSocialLoginSettings(): Observable<ExternalLoginSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetEnabledSocialLoginSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnabledSocialLoginSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnabledSocialLoginSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginSettingsDto>;
        }));
    }

    protected processGetEnabledSocialLoginSettings(response: HttpResponseBase): Observable<ExternalLoginSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalLoginSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InspectionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchInspections(body: GetInspectionSearchInput | undefined): Observable<GetInspectionSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/SearchInspections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchInspections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchInspections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInspectionSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInspectionSearchOutput>;
        }));
    }

    protected processSearchInspections(response: HttpResponseBase): Observable<GetInspectionSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInspectionSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getInspection(id: number | undefined): Observable<GetInspectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/GetInspection?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInspection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInspection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInspectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInspectionDto>;
        }));
    }

    protected processGetInspection(response: HttpResponseBase): Observable<GetInspectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInspectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param businessId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createInspection(businessId: number | undefined, body: InspectionDetailDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/CreateInspection?";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInspection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInspection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInspection(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteInspection(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/DeleteInspection?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInspection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInspection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteInspection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateInspectionDetail(id: number | undefined, body: InspectionDetailDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/UpdateInspectionDetail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInspectionDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInspectionDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInspectionDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateInspectionPreparation(id: number | undefined, body: InspectionPreparationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/UpdateInspectionPreparation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInspectionPreparation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInspectionPreparation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInspectionPreparation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateInspectionExecution(id: number | undefined, body: InspectionExecutionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/UpdateInspectionExecution?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInspectionExecution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInspectionExecution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInspectionExecution(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateInspectionPostprocessing(id: number | undefined, body: UpdateInspectionPostprocessingInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/UpdateInspectionPostprocessing?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInspectionPostprocessing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInspectionPostprocessing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInspectionPostprocessing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param generateXml (optional) 
     * @return Success
     */
    generateInspectionDocument(id: number | undefined, generateXml: boolean | undefined): Observable<GenerateInspectionDocumentOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Inspection/GenerateInspectionDocument?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (generateXml === null)
            throw new Error("The parameter 'generateXml' cannot be null.");
        else if (generateXml !== undefined)
            url_ += "generateXml=" + encodeURIComponent("" + generateXml) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateInspectionDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateInspectionDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenerateInspectionDocumentOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenerateInspectionDocumentOutputDto>;
        }));
    }

    protected processGenerateInspectionDocument(response: HttpResponseBase): Observable<GenerateInspectionDocumentOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateInspectionDocumentOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InspectorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getInspectors(): Observable<GetInspectorDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Inspector/GetInspectors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInspectors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInspectors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInspectorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInspectorDto[]>;
        }));
    }

    protected processGetInspectors(response: HttpResponseBase): Observable<GetInspectorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetInspectorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InstallServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setup(body: InstallDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Install/Setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAppSettingsJson(): Observable<AppSettingsJsonDto> {
        let url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppSettingsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppSettingsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppSettingsJsonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppSettingsJsonDto>;
        }));
    }

    protected processGetAppSettingsJson(response: HttpResponseBase): Observable<AppSettingsJsonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingsJsonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    checkDatabase(): Observable<CheckDatabaseOutput> {
        let url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckDatabaseOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckDatabaseOutput>;
        }));
    }

    protected processCheckDatabase(response: HttpResponseBase): Observable<CheckDatabaseOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckDatabaseOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getInvoiceInfo(id: number | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processGetInvoiceInfo(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createInvoice(body: CreateInvoiceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JobsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    pause(jobName: string, groupName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/jobs/{groupName}/{jobName}/pause";
        if (jobName === undefined || jobName === null)
            throw new Error("The parameter 'jobName' must be defined.");
        url_ = url_.replace("{jobName}", encodeURIComponent("" + jobName));
        if (groupName === undefined || groupName === null)
            throw new Error("The parameter 'groupName' must be defined.");
        url_ = url_.replace("{groupName}", encodeURIComponent("" + groupName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPause(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPause(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPause(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    resume(jobName: string, groupName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/jobs/{groupName}/{jobName}/resume";
        if (jobName === undefined || jobName === null)
            throw new Error("The parameter 'jobName' must be defined.");
        url_ = url_.replace("{jobName}", encodeURIComponent("" + jobName));
        if (groupName === undefined || groupName === null)
            throw new Error("The parameter 'groupName' must be defined.");
        url_ = url_.replace("{groupName}", encodeURIComponent("" + groupName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResume(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResume(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResume(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    trigger(jobName: string, groupName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/jobs/{groupName}/{jobName}/trigger";
        if (jobName === undefined || jobName === null)
            throw new Error("The parameter 'jobName' must be defined.");
        url_ = url_.replace("{jobName}", encodeURIComponent("" + jobName));
        if (groupName === undefined || groupName === null)
            throw new Error("The parameter 'groupName' must be defined.");
        url_ = url_.replace("{groupName}", encodeURIComponent("" + groupName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrigger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrigger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrigger(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    cancel(jobName: string, groupName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/jobs/{groupName}/{jobName}/cancel";
        if (jobName === undefined || jobName === null)
            throw new Error("The parameter 'jobName' must be defined.");
        url_ = url_.replace("{jobName}", encodeURIComponent("" + jobName));
        if (groupName === undefined || groupName === null)
            throw new Error("The parameter 'groupName' must be defined.");
        url_ = url_.replace("{groupName}", encodeURIComponent("" + groupName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    jobInfoList(): Observable<GetJobInfoListOutput> {
        let url_ = this.baseUrl + "/api/services/jobs/job-info-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processJobInfoList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJobInfoList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetJobInfoListOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetJobInfoListOutput>;
        }));
    }

    protected processJobInfoList(response: HttpResponseBase): Observable<GetJobInfoListOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJobInfoListOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JobOutputFilesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param type (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    search(type: JobOutputFileType | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetJobOutputFilesResult> {
        let url_ = this.baseUrl + "/api/services/job-output-files/search?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetJobOutputFilesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetJobOutputFilesResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<GetJobOutputFilesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJobOutputFilesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    file(id: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/job-output-files/{id}/file";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguagesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguagesOutput>;
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<GetLanguagesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguagesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLanguageForEdit(id: number | undefined): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguageForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguageForEditOutput>;
        }));
    }

    protected processGetLanguageForEdit(response: HttpResponseBase): Observable<GetLanguageForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguageForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLanguage(body: CreateOrUpdateLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteLanguage(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setDefaultLanguage(body: SetDefaultLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefaultLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaultLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDefaultLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param baseLanguageName (optional) 
     * @return Success
     */
    getLanguageTextForEdit(sourceName: string, baseLanguageName: string | undefined, targetLanguageName: string, baseValueKey: string): Observable<LanguageTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTextForEdit?";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (baseLanguageName === null)
            throw new Error("The parameter 'baseLanguageName' cannot be null.");
        else if (baseLanguageName !== undefined)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&";
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&";
        if (baseValueKey === undefined || baseValueKey === null)
            throw new Error("The parameter 'baseValueKey' must be defined and cannot be null.");
        else
            url_ += "BaseValueKey=" + encodeURIComponent("" + baseValueKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageTextForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageTextForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LanguageTextListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LanguageTextListDto>;
        }));
    }

    protected processGetLanguageTextForEdit(response: HttpResponseBase): Observable<LanguageTextListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LanguageTextListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param maxResultCount (optional) The field MaxResultCount must be between 0 and 2147483647.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @param sorting (optional) 
     * @param baseLanguageName (optional) 
     * @param targetValueFilter (optional) 
     * @param filterText (optional) 
     * @return Success
     */
    getLanguageTexts(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined, sourceName: string, baseLanguageName: string | undefined, targetLanguageName: string, targetValueFilter: string | undefined, filterText: string | undefined): Observable<PagedResultDtoOfLanguageTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (baseLanguageName === null)
            throw new Error("The parameter 'baseLanguageName' cannot be null.");
        else if (baseLanguageName !== undefined)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&";
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&";
        if (targetValueFilter === null)
            throw new Error("The parameter 'targetValueFilter' cannot be null.");
        else if (targetValueFilter !== undefined)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&";
        if (filterText === null)
            throw new Error("The parameter 'filterText' cannot be null.");
        else if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageTexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageTexts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
        }));
    }

    protected processGetLanguageTexts(response: HttpResponseBase): Observable<PagedResultDtoOfLanguageTextListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLanguageTextListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTranslationFileValue(sourceName: string, languageName: string, key: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetTranslationFileValue?";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (languageName === undefined || languageName === null)
            throw new Error("The parameter 'languageName' must be defined and cannot be null.");
        else
            url_ += "LanguageName=" + encodeURIComponent("" + languageName) + "&";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined and cannot be null.");
        else
            url_ += "Key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTranslationFileValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTranslationFileValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTranslationFileValue(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLanguageText(body: UpdateLanguageTextInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLanguageText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLanguageText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLanguageText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetLanguageText(body: ResetLanguageTextInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/ResetLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetLanguageText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetLanguageText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetLanguageText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LegServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createLeg(body: ApplicationType | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Leg/CreateLeg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLeg(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLeg(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateLeg(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getLeg(caseId: string | undefined): Observable<GetLegOutput> {
        let url_ = this.baseUrl + "/api/services/app/Leg/GetLeg?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeg(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeg(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLegOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLegOutput>;
        }));
    }

    protected processGetLeg(response: HttpResponseBase): Observable<GetLegOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLegOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyLegs(): Observable<LegDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Leg/GetMyLegs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyLegs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyLegs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LegDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LegDto[]>;
        }));
    }

    protected processGetMyLegs(response: HttpResponseBase): Observable<LegDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LegDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyPersonLegs(): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Leg/GetMyPersonLegs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyPersonLegs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyPersonLegs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetMyPersonLegs(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMySponsorshipLegs(): Observable<SponsorshipApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Leg/GetMySponsorshipLegs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMySponsorshipLegs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMySponsorshipLegs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SponsorshipApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SponsorshipApplicationSummaryDto[]>;
        }));
    }

    protected processGetMySponsorshipLegs(response: HttpResponseBase): Observable<SponsorshipApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SponsorshipApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getLegsForPerson(gln: string | undefined): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Leg/GetLegsForPerson?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLegsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLegsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetLegsForPerson(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param uid (optional) 
     * @return Success
     */
    getLegsForSponsorship(uid: string | undefined): Observable<SponsorshipApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Leg/GetLegsForSponsorship?";
        if (uid === null)
            throw new Error("The parameter 'uid' cannot be null.");
        else if (uid !== undefined)
            url_ += "uid=" + encodeURIComponent("" + uid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLegsForSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLegsForSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SponsorshipApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SponsorshipApplicationSummaryDto[]>;
        }));
    }

    protected processGetLegsForSponsorship(response: HttpResponseBase): Observable<SponsorshipApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SponsorshipApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @param professionId (optional) 
     * @param caseId (optional) 
     * @return Success
     */
    validateGlnForLegitimation(gln: string | undefined, professionId: string | undefined, caseId: string | undefined): Observable<LegRegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Leg/ValidateGlnForLegitimation?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateGlnForLegitimation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateGlnForLegitimation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LegRegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LegRegisterOutput>;
        }));
    }

    protected processValidateGlnForLegitimation(response: HttpResponseBase): Observable<LegRegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LegRegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param status (optional) 
     * @return Success
     */
    getNextStatus(caseId: string | undefined, status: LegStatus | undefined): Observable<LegStatus> {
        let url_ = this.baseUrl + "/api/services/app/Leg/GetNextStatus?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LegStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LegStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<LegStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    acceptRegisterCheck(caseId: string | undefined): Observable<LegStatus> {
        let url_ = this.baseUrl + "/api/services/app/Leg/AcceptRegisterCheck?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LegStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LegStatus>;
        }));
    }

    protected processAcceptRegisterCheck(response: HttpResponseBase): Observable<LegStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param status (optional) 
     * @return Success
     */
    getDocumentsForLeg(caseId: string | undefined, status: LegStatus | undefined): Observable<LegDocumentGroup[]> {
        let url_ = this.baseUrl + "/api/services/app/Leg/GetDocumentsForLeg?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsForLeg(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsForLeg(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LegDocumentGroup[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LegDocumentGroup[]>;
        }));
    }

    protected processGetDocumentsForLeg(response: HttpResponseBase): Observable<LegDocumentGroup[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LegDocumentGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param status (optional) 
     * @param fileId (optional) 
     * @return Success
     */
    getFile(caseId: string | undefined, status: LegStatus | undefined, fileId: number | undefined): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Leg/GetFile?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param status (optional) 
     * @param fileId (optional) 
     * @return Success
     */
    deleteFile(caseId: string | undefined, status: LegStatus | undefined, fileId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Leg/DeleteFile?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Leg/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined): Observable<LegStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/Leg/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LegStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LegStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<LegStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseLeg(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Leg/ReleaseLeg?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseLeg(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseLeg(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseLeg(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param professionId (optional) 
     * @return Success
     */
    getExternalRegisterByProfessionId(professionId: string | undefined): Observable<ExternalSystemEnum> {
        let url_ = this.baseUrl + "/api/services/app/Leg/GetExternalRegisterByProfessionId?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalRegisterByProfessionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalRegisterByProfessionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalSystemEnum>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalSystemEnum>;
        }));
    }

    protected processGetExternalRegisterByProfessionId(response: HttpResponseBase): Observable<ExternalSystemEnum> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getLegApplications(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetLegApplicationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Leg/GetLegApplications?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLegApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLegApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLegApplicationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLegApplicationsOutput>;
        }));
    }

    protected processGetLegApplications(response: HttpResponseBase): Observable<GetLegApplicationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLegApplicationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSponsorship(body: UpdateLegSponsorshipInput | undefined): Observable<LegStatus> {
        let url_ = this.baseUrl + "/api/services/app/Leg/UpdateSponsorship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LegStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LegStatus>;
        }));
    }

    protected processUpdateSponsorship(response: HttpResponseBase): Observable<LegStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Leg/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getPersonId(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Leg/GetPersonId?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPersonId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getSponsorshipId(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Leg/GetSponsorshipId?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorshipId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorshipId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetSponsorshipId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LegitimationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getLegitimationForPerson(personId: number | undefined): Observable<GetLegitimatedUsersDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Legitimation/GetLegitimationForPerson?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLegitimationForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLegitimationForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLegitimatedUsersDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLegitimatedUsersDto[]>;
        }));
    }

    protected processGetLegitimationForPerson(response: HttpResponseBase): Observable<GetLegitimatedUsersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetLegitimatedUsersDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @return Success
     */
    getLegitimationForSponsorship(sponsorshipId: number | undefined): Observable<GetLegitimatedUsersDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Legitimation/GetLegitimationForSponsorship?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLegitimationForSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLegitimationForSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLegitimatedUsersDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLegitimatedUsersDto[]>;
        }));
    }

    protected processGetLegitimationForSponsorship(response: HttpResponseBase): Observable<GetLegitimatedUsersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetLegitimatedUsersDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaAcademicTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaAcademicTitle(body: CreateOrUpdateLiaAcademicTitleInput | undefined): Observable<CreateOrUpdateLiaAcademicTitleOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaAcademicTitle/CreateOrUpdateLiaAcademicTitle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateLiaAcademicTitleOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateLiaAcademicTitleOutput>;
        }));
    }

    protected processCreateOrUpdateLiaAcademicTitle(response: HttpResponseBase): Observable<CreateOrUpdateLiaAcademicTitleOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateLiaAcademicTitleOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createBlankLiaAcademicTitle(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LiaAcademicTitle/CreateBlankLiaAcademicTitle?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBlankLiaAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBlankLiaAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateBlankLiaAcademicTitle(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param academicTitleId (optional) 
     * @return Success
     */
    deleteLiaAcademicTitle(caseId: string | undefined, academicTitleId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaAcademicTitle/DeleteLiaAcademicTitle?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (academicTitleId === null)
            throw new Error("The parameter 'academicTitleId' cannot be null.");
        else if (academicTitleId !== undefined)
            url_ += "academicTitleId=" + encodeURIComponent("" + academicTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLiaAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLiaAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLiaAcademicTitle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getLiaAcademicTitleFiles(caseId: string, step: LiaStatus | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaAcademicTitle/GetLiaAcademicTitleFiles?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaAcademicTitleFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaAcademicTitleFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaAcademicTitleFiles(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param liaAcademicTitleId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(liaAcademicTitleId: string | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaAcademicTitle/UploadFiles?";
        if (liaAcademicTitleId === null)
            throw new Error("The parameter 'liaAcademicTitleId' cannot be null.");
        else if (liaAcademicTitleId !== undefined)
            url_ += "liaAcademicTitleId=" + encodeURIComponent("" + liaAcademicTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaContact(body: CreateOrUpdateLiaContactInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaContact/CreateOrUpdateLiaContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaContact(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLiaContactInWaitingStatus(body: CreateOrUpdateLiaContactInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LiaContact/UpdateLiaContactInWaitingStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLiaContactInWaitingStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLiaContactInWaitingStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateLiaContactInWaitingStatus(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getDocuments(caseId: string, step: LiaStatus | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaDocument/GetDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaDocument/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaDocument/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/LiaDocument/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    fileUploadCompleted(caseId: string | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaDocument/FileUploadCompleted?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileUploadCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileUploadCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processFileUploadCompleted(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getLiaDocuments(caseId: string, step: LiaStatus | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaDocument/GetLiaDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaDocuments(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaEhcLanguageSkillServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaEhcLanguageSkill(body: CreateOrUpdateEhcLanguageSkillInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaEhcLanguageSkill/CreateOrUpdateLiaEhcLanguageSkill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaEhcLanguageSkill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaEhcLanguageSkill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaEhcLanguageSkill(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param hasHighSchoolDiplomaOfLanguageOfActivityRegionId (optional) 
     * @param hasPhysicianDiplomaOfLanguageOfActivityRegionId (optional) 
     * @return Success
     */
    getLiaEhcLanguageSkillDocuments(caseId: string | undefined, hasHighSchoolDiplomaOfLanguageOfActivityRegionId: string | undefined, hasPhysicianDiplomaOfLanguageOfActivityRegionId: string | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaEhcLanguageSkill/GetLiaEhcLanguageSkillDocuments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (hasHighSchoolDiplomaOfLanguageOfActivityRegionId === null)
            throw new Error("The parameter 'hasHighSchoolDiplomaOfLanguageOfActivityRegionId' cannot be null.");
        else if (hasHighSchoolDiplomaOfLanguageOfActivityRegionId !== undefined)
            url_ += "hasHighSchoolDiplomaOfLanguageOfActivityRegionId=" + encodeURIComponent("" + hasHighSchoolDiplomaOfLanguageOfActivityRegionId) + "&";
        if (hasPhysicianDiplomaOfLanguageOfActivityRegionId === null)
            throw new Error("The parameter 'hasPhysicianDiplomaOfLanguageOfActivityRegionId' cannot be null.");
        else if (hasPhysicianDiplomaOfLanguageOfActivityRegionId !== undefined)
            url_ += "hasPhysicianDiplomaOfLanguageOfActivityRegionId=" + encodeURIComponent("" + hasPhysicianDiplomaOfLanguageOfActivityRegionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaEhcLanguageSkillDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaEhcLanguageSkillDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaEhcLanguageSkillDocuments(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaEhcLanguageSkill/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaEhcLanguageSkill/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/LiaEhcLanguageSkill/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaElectronicPatientRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaElectronicPatientRecord(body: CreateOrUpdateEhcElectronicPatientRecordInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaElectronicPatientRecord/CreateOrUpdateLiaElectronicPatientRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaElectronicPatientRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaElectronicPatientRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaElectronicPatientRecord(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaEmploymentOrPostgraduateTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getInitialList(caseId: string | undefined): Observable<EhcEmploymentOrPostgraduateTitleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaEmploymentOrPostgraduateTitle/GetInitialList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInitialList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInitialList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcEmploymentOrPostgraduateTitleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcEmploymentOrPostgraduateTitleDto[]>;
        }));
    }

    protected processGetInitialList(response: HttpResponseBase): Observable<EhcEmploymentOrPostgraduateTitleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EhcEmploymentOrPostgraduateTitleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaEmploymentOrPostgraduateTitles(body: CreateOrUpdateEhcEmploymentOrPostgraduateTitleInput | undefined): Observable<CreateOrUpdateLiaEmploymentOrPostgraduateTitlesOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaEmploymentOrPostgraduateTitle/CreateOrUpdateLiaEmploymentOrPostgraduateTitles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaEmploymentOrPostgraduateTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaEmploymentOrPostgraduateTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateLiaEmploymentOrPostgraduateTitlesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateLiaEmploymentOrPostgraduateTitlesOutput>;
        }));
    }

    protected processCreateOrUpdateLiaEmploymentOrPostgraduateTitles(response: HttpResponseBase): Observable<CreateOrUpdateLiaEmploymentOrPostgraduateTitlesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateLiaEmploymentOrPostgraduateTitlesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    checkLimits(caseId: string | undefined): Observable<EhcEmploymentOrPostgraduateTitleLimitResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaEmploymentOrPostgraduateTitle/CheckLimits?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckLimits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckLimits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcEmploymentOrPostgraduateTitleLimitResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcEmploymentOrPostgraduateTitleLimitResultDto[]>;
        }));
    }

    protected processCheckLimits(response: HttpResponseBase): Observable<EhcEmploymentOrPostgraduateTitleLimitResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EhcEmploymentOrPostgraduateTitleLimitResultDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaEmploymentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaEmployments(body: CreateOrUpdateLiaEmploymentsInput | undefined): Observable<CreateOrUpdateLiaEmploymentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaEmployments/CreateOrUpdateLiaEmployments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaEmployments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaEmployments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateLiaEmploymentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateLiaEmploymentsOutput>;
        }));
    }

    protected processCreateOrUpdateLiaEmployments(response: HttpResponseBase): Observable<CreateOrUpdateLiaEmploymentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateLiaEmploymentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getLiaEmploymentDocuments(caseId: string, step: LiaStatus | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaEmployments/GetLiaEmploymentDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaEmploymentDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaEmploymentDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaEmploymentDocuments(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaEmployments/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaEmployments/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/LiaEmployments/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaEmploymentsWhileWaitingStatus(body: CreateOrUpdateLiaEmploymentsInput | undefined): Observable<CreateOrUpdateLiaEmploymentsInWaitingStatusOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaEmployments/CreateOrUpdateLiaEmploymentsWhileWaitingStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaEmploymentsWhileWaitingStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaEmploymentsWhileWaitingStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateLiaEmploymentsInWaitingStatusOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateLiaEmploymentsInWaitingStatusOutput>;
        }));
    }

    protected processCreateOrUpdateLiaEmploymentsWhileWaitingStatus(response: HttpResponseBase): Observable<CreateOrUpdateLiaEmploymentsInWaitingStatusOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateLiaEmploymentsInWaitingStatusOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaInvoiceAddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaInvoiceAddress(body: CreateOrUpdateLiaInvoiceAddressInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaInvoiceAddress/CreateOrUpdateLiaInvoiceAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaInvoiceAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaInvoiceAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaInvoiceAddress(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaLanguageSkillServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaLanguageSkill(body: CreateOrUpdateLiaLanguageSkillInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaLanguageSkill/CreateOrUpdateLiaLanguageSkill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaLanguageSkill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaLanguageSkill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaLanguageSkill(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getLiaLanguageSkillDocuments(caseId: string, step: LiaStatus | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaLanguageSkill/GetLiaLanguageSkillDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaLanguageSkillDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaLanguageSkillDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaLanguageSkillDocuments(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaLanguageSkill/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaLanguageSkill/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/LiaLanguageSkill/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaPersonWithRegisterCheck(body: CreateOrUpdateLiaPersonWithRegisterCheckInput | undefined): Observable<CreateOrUpdateLiaPersonOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/LiaPerson/CreateOrUpdateLiaPersonWithRegisterCheck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaPersonWithRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaPersonWithRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateLiaPersonOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateLiaPersonOutputDto>;
        }));
    }

    protected processCreateOrUpdateLiaPersonWithRegisterCheck(response: HttpResponseBase): Observable<CreateOrUpdateLiaPersonOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateLiaPersonOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaPersonWithoutRegisterCheck(body: CreateOrUpdateLiaPersonWithoutRegisterCheckInput | undefined): Observable<CreateOrUpdateLiaPersonWithoutRegisterCheckOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/LiaPerson/CreateOrUpdateLiaPersonWithoutRegisterCheck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaPersonWithoutRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaPersonWithoutRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateLiaPersonWithoutRegisterCheckOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateLiaPersonWithoutRegisterCheckOutputDto>;
        }));
    }

    protected processCreateOrUpdateLiaPersonWithoutRegisterCheck(response: HttpResponseBase): Observable<CreateOrUpdateLiaPersonWithoutRegisterCheckOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateLiaPersonWithoutRegisterCheckOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    acceptRegisterCheck(caseId: string | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaPerson/AcceptRegisterCheck?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processAcceptRegisterCheck(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @param hasLicenceInAnotherCanton (optional) 
     * @param nationality (optional) 
     * @param isWithoutRegister (optional) 
     * @return Success
     */
    getLiaPersonDocuments(caseId: string, step: LiaStatus | undefined, hasLicenceInAnotherCanton: boolean | undefined, nationality: string | undefined, isWithoutRegister: boolean | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaPerson/GetLiaPersonDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (hasLicenceInAnotherCanton === null)
            throw new Error("The parameter 'hasLicenceInAnotherCanton' cannot be null.");
        else if (hasLicenceInAnotherCanton !== undefined)
            url_ += "hasLicenceInAnotherCanton=" + encodeURIComponent("" + hasLicenceInAnotherCanton) + "&";
        if (nationality === null)
            throw new Error("The parameter 'nationality' cannot be null.");
        else if (nationality !== undefined)
            url_ += "nationality=" + encodeURIComponent("" + nationality) + "&";
        if (isWithoutRegister === null)
            throw new Error("The parameter 'isWithoutRegister' cannot be null.");
        else if (isWithoutRegister !== undefined)
            url_ += "isWithoutRegister=" + encodeURIComponent("" + isWithoutRegister) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaPersonDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaPersonDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaPersonDocuments(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaPerson/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaPerson/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/LiaPerson/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaPracticeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaPractices(body: CreateOrUpdateLiaPracticesInput | undefined): Observable<CreateOrUpdateLiaPracticesOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaPractice/CreateOrUpdateLiaPractices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaPractices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaPractices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateLiaPracticesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateLiaPracticesOutput>;
        }));
    }

    protected processCreateOrUpdateLiaPractices(response: HttpResponseBase): Observable<CreateOrUpdateLiaPracticesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateLiaPracticesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    hasEmploymentOrPostgraduateTitle(caseId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/LiaPractice/HasEmploymentOrPostgraduateTitle?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasEmploymentOrPostgraduateTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasEmploymentOrPostgraduateTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasEmploymentOrPostgraduateTitle(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getLiaPractice(caseId: string | undefined): Observable<LiaPracticeDto> {
        let url_ = this.baseUrl + "/api/services/app/LiaPractice/GetLiaPractice?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaPractice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaPractice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaPracticeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaPracticeDto>;
        }));
    }

    protected processGetLiaPractice(response: HttpResponseBase): Observable<LiaPracticeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaPracticeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param postgraduateTitleId (optional) 
     * @return Success
     */
    createBlankLiaPracticeRecord(caseId: string | undefined, postgraduateTitleId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LiaPractice/CreateBlankLiaPracticeRecord?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (postgraduateTitleId === null)
            throw new Error("The parameter 'postgraduateTitleId' cannot be null.");
        else if (postgraduateTitleId !== undefined)
            url_ += "postgraduateTitleId=" + encodeURIComponent("" + postgraduateTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBlankLiaPracticeRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBlankLiaPracticeRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateBlankLiaPracticeRecord(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param liaPracticeRecordId (optional) 
     * @return Success
     */
    deleteLiaPracticeRecord(caseId: string | undefined, liaPracticeRecordId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaPractice/DeleteLiaPracticeRecord?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (liaPracticeRecordId === null)
            throw new Error("The parameter 'liaPracticeRecordId' cannot be null.");
        else if (liaPracticeRecordId !== undefined)
            url_ += "liaPracticeRecordId=" + encodeURIComponent("" + liaPracticeRecordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLiaPracticeRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLiaPracticeRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLiaPracticeRecord(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param hasExemptionAccordingArt37Kvg (optional) 
     * @return Success
     */
    getLiaPracticeRecordFiles(caseId: string, hasExemptionAccordingArt37Kvg: boolean | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaPractice/GetLiaPracticeRecordFiles?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (hasExemptionAccordingArt37Kvg === null)
            throw new Error("The parameter 'hasExemptionAccordingArt37Kvg' cannot be null.");
        else if (hasExemptionAccordingArt37Kvg !== undefined)
            url_ += "HasExemptionAccordingArt37Kvg=" + encodeURIComponent("" + hasExemptionAccordingArt37Kvg) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaPracticeRecordFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaPracticeRecordFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaPracticeRecordFiles(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param liaPracticeRecordId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(liaPracticeRecordId: string | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaPractice/UploadFiles?";
        if (liaPracticeRecordId === null)
            throw new Error("The parameter 'liaPracticeRecordId' cannot be null.");
        else if (liaPracticeRecordId !== undefined)
            url_ += "liaPracticeRecordId=" + encodeURIComponent("" + liaPracticeRecordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaPractice/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/LiaPractice/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaProfessionalResponsibilityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    proceed(caseId: string | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaProfessionalResponsibility/Proceed?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processProceed(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getLiaProfessionalResponsibilityFiles(caseId: string, step: LiaStatus | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaProfessionalResponsibility/GetLiaProfessionalResponsibilityFiles?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaProfessionalResponsibilityFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaProfessionalResponsibilityFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaProfessionalResponsibilityFiles(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaProfessionalResponsibility/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaQualityRequirementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaQualityRequirement(body: CreateOrUpdateEhcQualityRequirementInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaQualityRequirement/CreateOrUpdateLiaQualityRequirement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaQualityRequirement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaQualityRequirement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaQualityRequirement(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getLiaQualityRequirementDocuments(caseId: string, step: LiaStatus | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaQualityRequirement/GetLiaQualityRequirementDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaQualityRequirementDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaQualityRequirementDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaQualityRequirementDocuments(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaQualityRequirement/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaRestrictionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaRestrictions(body: CreateOrUpdateLiaRestrictionsInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaRestrictions/CreateOrUpdateLiaRestrictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaRestrictions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaRestrictions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaRestrictions(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @param hasRestrictions (optional) 
     * @param hasConditionalApproval (optional) 
     * @param hasImpairments (optional) 
     * @return Success
     */
    getLiaRestrictionDocuments(caseId: string, step: LiaStatus | undefined, hasRestrictions: boolean | undefined, hasConditionalApproval: boolean | undefined, hasImpairments: boolean | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaRestrictions/GetLiaRestrictionDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (hasRestrictions === null)
            throw new Error("The parameter 'hasRestrictions' cannot be null.");
        else if (hasRestrictions !== undefined)
            url_ += "hasRestrictions=" + encodeURIComponent("" + hasRestrictions) + "&";
        if (hasConditionalApproval === null)
            throw new Error("The parameter 'hasConditionalApproval' cannot be null.");
        else if (hasConditionalApproval !== undefined)
            url_ += "hasConditionalApproval=" + encodeURIComponent("" + hasConditionalApproval) + "&";
        if (hasImpairments === null)
            throw new Error("The parameter 'hasImpairments' cannot be null.");
        else if (hasImpairments !== undefined)
            url_ += "hasImpairments=" + encodeURIComponent("" + hasImpairments) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaRestrictionDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaRestrictionDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaRestrictionDocuments(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaRestrictions/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaRestrictions/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/LiaRestrictions/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaSelfEmploymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaSelfEmployment(body: CreateOrUpdateEhcSelfEmploymentInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaSelfEmployment/CreateOrUpdateLiaSelfEmployment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaSelfEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaSelfEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaSelfEmployment(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaStatusWizardStepServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param professionId (optional) 
     * @param applicationType (optional) 
     * @return Success
     */
    getAllByProfessionId(professionId: string | undefined, applicationType: ApplicationType | undefined): Observable<LiaStatusWizardStepDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaStatusWizardStep/GetAllByProfessionId?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (applicationType === null)
            throw new Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByProfessionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByProfessionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatusWizardStepDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatusWizardStepDto[]>;
        }));
    }

    protected processGetAllByProfessionId(response: HttpResponseBase): Observable<LiaStatusWizardStepDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LiaStatusWizardStepDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateLiaStatusWizardStepInput | undefined): Observable<LiaStatusWizardStepDto> {
        let url_ = this.baseUrl + "/api/services/app/LiaStatusWizardStep/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatusWizardStepDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatusWizardStepDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LiaStatusWizardStepDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaStatusWizardStepDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMany(body: UpdateLiaStatusWizardStepsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaStatusWizardStep/UpdateMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @param professionId (optional) 
     * @param applicationType (optional) 
     * @return Success
     */
    delete(step: number | undefined, professionId: string | undefined, applicationType: ApplicationType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaStatusWizardStep/Delete?";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (applicationType === null)
            throw new Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaTherapyMethodServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateTherapyMethod(body: CreateOrUpdateLiaTherapyMethodInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaTherapyMethod/CreateOrUpdateTherapyMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateTherapyMethod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateTherapyMethod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateTherapyMethod(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getTherapyMethodDocuments(caseId: string, step: LiaStatus | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaTherapyMethod/GetTherapyMethodDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTherapyMethodDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTherapyMethodDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetTherapyMethodDocuments(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaTherapyMethod/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaTherapyMethod/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/LiaTherapyMethod/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createLiaType(body: CreateLiaTypeInput | undefined): Observable<CreateLiaTypeOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/CreateLiaType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLiaType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLiaType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateLiaTypeOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateLiaTypeOutput>;
        }));
    }

    protected processCreateLiaType(response: HttpResponseBase): Observable<CreateLiaTypeOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateLiaTypeOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProfessions(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/GetProfessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetProfessions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param professionId (optional) 
     * @param ehc90Days (optional) 
     * @return Success
     */
    isEligibleForEhc(professionId: string | undefined, ehc90Days: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/IsEligibleForEhc?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (ehc90Days === null)
            throw new Error("The parameter 'ehc90Days' cannot be null.");
        else if (ehc90Days !== undefined)
            url_ += "ehc90Days=" + encodeURIComponent("" + ehc90Days) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsEligibleForEhc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsEligibleForEhc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsEligibleForEhc(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyLias(): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/GetMyLias";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyLias(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyLias(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetMyLias(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNextStatus(caseId: string, status: LiaStatus): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/GetNextStatus?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personGln (optional) 
     * @return Success
     */
    getLiasForPerson(personGln: string | undefined): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/GetLiasForPerson?";
        if (personGln === null)
            throw new Error("The parameter 'personGln' cannot be null.");
        else if (personGln !== undefined)
            url_ += "personGln=" + encodeURIComponent("" + personGln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiasForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiasForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetLiasForPerson(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getProfessionalLicenceForLia(caseId: string | undefined): Observable<ProfessionalLicenceDto> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/getProfessionalLicenceForLia?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalLicenceForLia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalLicenceForLia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionalLicenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionalLicenceDto>;
        }));
    }

    protected processGetProfessionalLicenceForLia(response: HttpResponseBase): Observable<ProfessionalLicenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionalLicenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getLia(caseId: string | undefined): Observable<GetLiaOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/GetLia?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLiaOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLiaOutput>;
        }));
    }

    protected processGetLia(response: HttpResponseBase): Observable<GetLiaOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLiaOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseLia(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/ReleaseLia?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseLia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseLia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseLia(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param professionId (optional) 
     * @return Success
     */
    getExternalRegisterByProfessionId(professionId: string | undefined): Observable<ExternalSystemEnum> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/GetExternalRegisterByProfessionId?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalRegisterByProfessionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalRegisterByProfessionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalSystemEnum>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalSystemEnum>;
        }));
    }

    protected processGetExternalRegisterByProfessionId(response: HttpResponseBase): Observable<ExternalSystemEnum> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getFailedLiaForProfessionAndGln(caseId: string | undefined): Observable<GetLiaOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/GetFailedLiaForProfessionAndGln?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFailedLiaForProfessionAndGln(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFailedLiaForProfessionAndGln(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLiaOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLiaOutput>;
        }));
    }

    protected processGetFailedLiaForProfessionAndGln(response: HttpResponseBase): Observable<GetLiaOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLiaOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    setLiaOnWaitingAndCreateEhc(caseId: string | undefined, applicantComment: string | undefined): Observable<SetLiaOnWaitingAndCreateEhcOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/SetLiaOnWaitingAndCreateEhc?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetLiaOnWaitingAndCreateEhc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetLiaOnWaitingAndCreateEhc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetLiaOnWaitingAndCreateEhcOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetLiaOnWaitingAndCreateEhcOutput>;
        }));
    }

    protected processSetLiaOnWaitingAndCreateEhc(response: HttpResponseBase): Observable<SetLiaOnWaitingAndCreateEhcOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetLiaOnWaitingAndCreateEhcOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined): Observable<LiaStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<LiaStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaVaccinationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaVaccination(body: CreateOrUpdateLiaVaccinationInputDto | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaVaccination/CreateOrUpdateLiaVaccination";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaVaccination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaVaccination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaVaccination(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @param hasRequestedVaccinationLicence (optional) 
     * @return Success
     */
    getLiaVaccinationDocuments(caseId: string, step: LiaStatus | undefined, hasRequestedVaccinationLicence: boolean | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaVaccination/GetLiaVaccinationDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (hasRequestedVaccinationLicence === null)
            throw new Error("The parameter 'hasRequestedVaccinationLicence' cannot be null.");
        else if (hasRequestedVaccinationLicence !== undefined)
            url_ += "hasRequestedVaccinationLicence=" + encodeURIComponent("" + hasRequestedVaccinationLicence) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaVaccinationDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaVaccinationDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaVaccinationDocuments(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaVaccination/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaVaccination/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/LiaVaccination/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LogbookServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: LogbookSearchInput | undefined): Observable<LogbookSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/Logbook/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogbookSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogbookSearchOutput>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<LogbookSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LogbookSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param discriminator (optional) 
     * @param entityId (optional) 
     * @return Success
     */
    exportToExcel(discriminator: LogbookType | undefined, entityId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Logbook/ExportToExcel?";
        if (discriminator === null)
            throw new Error("The parameter 'discriminator' cannot be null.");
        else if (discriminator !== undefined)
            url_ += "discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportToExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetLogbookDto> {
        let url_ = this.baseUrl + "/api/services/app/Logbook/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLogbookDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLogbookDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetLogbookDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLogbookDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param discriminator (optional) 
     * @param entityId (optional) 
     * @param body (optional) 
     * @return Success
     */
    create(discriminator: LogbookType | undefined, entityId: number | undefined, body: CreateOrUpdateLogbookDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Logbook/Create?";
        if (discriminator === null)
            throw new Error("The parameter 'discriminator' cannot be null.");
        else if (discriminator !== undefined)
            url_ += "discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(id: number | undefined, body: CreateOrUpdateLogbookDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Logbook/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Logbook/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LoggedMailServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param textSearch (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getLoggedMails(startDate: DateTime | undefined, endDate: DateTime | undefined, textSearch: string | undefined, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetLoggedMailOutput> {
        let url_ = this.baseUrl + "/api/services/app/LoggedMail/GetLoggedMails?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (textSearch === null)
            throw new Error("The parameter 'textSearch' cannot be null.");
        else if (textSearch !== undefined)
            url_ += "TextSearch=" + encodeURIComponent("" + textSearch) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoggedMails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoggedMails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLoggedMailOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLoggedMailOutput>;
        }));
    }

    protected processGetLoggedMails(response: HttpResponseBase): Observable<GetLoggedMailOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLoggedMailOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMailContentAsEml(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LoggedMail/GetMailContentAsEml?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailContentAsEml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailContentAsEml(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetMailContentAsEml(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MailDistributionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getMailDistributionLists(): Observable<ListResultDtoOfMailDistributionListDto> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/GetMailDistributionLists";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailDistributionLists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailDistributionLists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfMailDistributionListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfMailDistributionListDto>;
        }));
    }

    protected processGetMailDistributionLists(response: HttpResponseBase): Observable<ListResultDtoOfMailDistributionListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfMailDistributionListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getMailDistributionListUsers(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfMailDistributionListUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/GetMailDistributionListUsers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailDistributionListUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailDistributionListUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMailDistributionListUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMailDistributionListUserListDto>;
        }));
    }

    protected processGetMailDistributionListUsers(response: HttpResponseBase): Observable<PagedResultDtoOfMailDistributionListUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMailDistributionListUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getMailDistributionListEmail(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfMailDistributionListEmailListDto> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/GetMailDistributionListEmail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailDistributionListEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailDistributionListEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMailDistributionListEmailListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMailDistributionListEmailListDto>;
        }));
    }

    protected processGetMailDistributionListEmail(response: HttpResponseBase): Observable<PagedResultDtoOfMailDistributionListEmailListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMailDistributionListEmailListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addEmailToMailDistributionList(body: AddEmailToMailDistributionListInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/AddEmailToMailDistributionList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEmailToMailDistributionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEmailToMailDistributionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddEmailToMailDistributionList(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param mailDistributionListId (optional) 
     * @param id (optional) 
     * @return Success
     */
    removeEmailFromMailDistributionList(mailDistributionListId: number | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/RemoveEmailFromMailDistributionList?";
        if (mailDistributionListId === null)
            throw new Error("The parameter 'mailDistributionListId' cannot be null.");
        else if (mailDistributionListId !== undefined)
            url_ += "MailDistributionListId=" + encodeURIComponent("" + mailDistributionListId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveEmailFromMailDistributionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveEmailFromMailDistributionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveEmailFromMailDistributionList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param mailDistributionListId (optional) 
     * @return Success
     */
    getMailDistributionListConfig(mailDistributionListId: number | undefined): Observable<MailDistributionListConfigurationsDto> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/GetMailDistributionListConfig?";
        if (mailDistributionListId === null)
            throw new Error("The parameter 'mailDistributionListId' cannot be null.");
        else if (mailDistributionListId !== undefined)
            url_ += "MailDistributionListId=" + encodeURIComponent("" + mailDistributionListId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailDistributionListConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailDistributionListConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailDistributionListConfigurationsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailDistributionListConfigurationsDto>;
        }));
    }

    protected processGetMailDistributionListConfig(response: HttpResponseBase): Observable<MailDistributionListConfigurationsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailDistributionListConfigurationsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMailDistributionListConfig(body: MailDistributionListConfigurationsDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/UpdateMailDistributionListConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMailDistributionListConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMailDistributionListConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateMailDistributionListConfig(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMailDistributionList(body: CreateMailDistributionListInput | undefined): Observable<MailDistributionListDto> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/CreateMailDistributionList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMailDistributionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMailDistributionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailDistributionListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailDistributionListDto>;
        }));
    }

    protected processCreateMailDistributionList(response: HttpResponseBase): Observable<MailDistributionListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailDistributionListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMailDistributionList(body: UpdateMailDistributionListInput | undefined): Observable<MailDistributionListDto> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/UpdateMailDistributionList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMailDistributionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMailDistributionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailDistributionListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailDistributionListDto>;
        }));
    }

    protected processUpdateMailDistributionList(response: HttpResponseBase): Observable<MailDistributionListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailDistributionListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteMailDistributionList(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/DeleteMailDistributionList?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMailDistributionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMailDistributionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMailDistributionList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userIds (optional) 
     * @param mailDistributionListId (optional) 
     * @return Success
     */
    removeUsersFromMailDistributionList(userIds: number[] | undefined, mailDistributionListId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/RemoveUsersFromMailDistributionList?";
        if (userIds === null)
            throw new Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (mailDistributionListId === null)
            throw new Error("The parameter 'mailDistributionListId' cannot be null.");
        else if (mailDistributionListId !== undefined)
            url_ += "MailDistributionListId=" + encodeURIComponent("" + mailDistributionListId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUsersFromMailDistributionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUsersFromMailDistributionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUsersFromMailDistributionList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUsersToMailDistributionList(body: AddUsersToMailDistributionListInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/AddUsersToMailDistributionList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUsersToMailDistributionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUsersToMailDistributionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddUsersToMailDistributionList(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findAddableUsers(body: FindMailDistributionListDataInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/FindAddableUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindAddableUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindAddableUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindAddableUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MedRegServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    test(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MedReg/Test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getDetailed(personId: number | undefined): Observable<GetMedRegPersonDetailedOutput> {
        let url_ = this.baseUrl + "/api/services/app/MedReg/GetDetailed?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMedRegPersonDetailedOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMedRegPersonDetailedOutput>;
        }));
    }

    protected processGetDetailed(response: HttpResponseBase): Observable<GetMedRegPersonDetailedOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMedRegPersonDetailedOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getDetailedByGln(gln: string | undefined): Observable<GetMedRegPersonDetailedOutput> {
        let url_ = this.baseUrl + "/api/services/app/MedReg/GetDetailedByGln?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailedByGln(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailedByGln(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMedRegPersonDetailedOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMedRegPersonDetailedOutput>;
        }));
    }

    protected processGetDetailedByGln(response: HttpResponseBase): Observable<GetMedRegPersonDetailedOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMedRegPersonDetailedOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    get(personId: number | undefined): Observable<GetMedRegPersonOutput> {
        let url_ = this.baseUrl + "/api/services/app/MedReg/Get?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMedRegPersonOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMedRegPersonOutput>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetMedRegPersonOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMedRegPersonOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getByGln(gln: string | undefined): Observable<GetMedRegPersonOutput> {
        let url_ = this.baseUrl + "/api/services/app/MedReg/GetByGln?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByGln(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByGln(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMedRegPersonOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMedRegPersonOutput>;
        }));
    }

    protected processGetByGln(response: HttpResponseBase): Observable<GetMedRegPersonOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMedRegPersonOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MigrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    run(step: MigrationStep, isForEvidence: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Migration/Run?";
        if (step === undefined || step === null)
            throw new Error("The parameter 'step' must be defined and cannot be null.");
        else
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        if (isForEvidence === undefined || isForEvidence === null)
            throw new Error("The parameter 'isForEvidence' must be defined and cannot be null.");
        else
            url_ += "isForEvidence=" + encodeURIComponent("" + isForEvidence) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRun(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    runAdditional(step: MigrationAdditionalStep): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Migration/RunAdditional?";
        if (step === undefined || step === null)
            throw new Error("The parameter 'step' must be defined and cannot be null.");
        else
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunAdditional(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunAdditional(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRunAdditional(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    isRunning(): Observable<MigrationIsRunningOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Migration/IsRunning";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsRunning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsRunning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MigrationIsRunningOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MigrationIsRunningOutputDto>;
        }));
    }

    protected processIsRunning(response: HttpResponseBase): Observable<MigrationIsRunningOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MigrationIsRunningOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMigrationResult(): Observable<MigrationResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Migration/GetMigrationResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMigrationResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMigrationResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MigrationResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MigrationResultDto>;
        }));
    }

    protected processGetMigrationResult(response: HttpResponseBase): Observable<MigrationResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MigrationResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    removeMigrationResult(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Migration/RemoveMigrationResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveMigrationResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveMigrationResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveMigrationResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    cancel(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Migration/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadBinaryData(body: MigrationBinaryDataInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Migration/UploadBinaryData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBinaryData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBinaryData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadBinaryData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBinaryData(id: MigrationBinaryObjectId | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Migration/GetBinaryData?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBinaryData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBinaryData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetBinaryData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getExcelResults(maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfGetExcelResultData> {
        let url_ = this.baseUrl + "/api/services/app/Migration/GetExcelResults?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExcelResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExcelResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetExcelResultData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetExcelResultData>;
        }));
    }

    protected processGetExcelResults(response: HttpResponseBase): Observable<PagedResultDtoOfGetExcelResultData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetExcelResultData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getExcelResult(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Migration/GetExcelResult?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExcelResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExcelResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetExcelResult(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MunicipalityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param onlyActive (optional) 
     * @return Success
     */
    getAll(onlyActive: boolean | undefined): Observable<GetMunicipalityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Municipality/GetAll?";
        if (onlyActive === null)
            throw new Error("The parameter 'onlyActive' cannot be null.");
        else if (onlyActive !== undefined)
            url_ += "onlyActive=" + encodeURIComponent("" + onlyActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMunicipalityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMunicipalityDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GetMunicipalityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetMunicipalityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMut(body: CreateMutInput | undefined): Observable<CreateMutOutput> {
        let url_ = this.baseUrl + "/api/services/app/Mut/CreateMut";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateMutOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateMutOutput>;
        }));
    }

    protected processCreateMut(response: HttpResponseBase): Observable<CreateMutOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateMutOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkMutConditions(body: CreateMutInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Mut/CheckMutConditions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckMutConditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMutConditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckMutConditions(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyMuts(): Observable<MutationApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Mut/GetMyMuts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyMuts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyMuts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutationApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutationApplicationSummaryDto[]>;
        }));
    }

    protected processGetMyMuts(response: HttpResponseBase): Observable<MutationApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MutationApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNextStatus(caseId: string, status: MutStatus): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/Mut/GetNextStatus?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getMutsForPerson(gln: string | undefined): Observable<MutationApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Mut/GetMutsForPerson?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMutsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMutsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutationApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutationApplicationSummaryDto[]>;
        }));
    }

    protected processGetMutsForPerson(response: HttpResponseBase): Observable<MutationApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MutationApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getMut(caseId: string | undefined): Observable<GetMutOutput> {
        let url_ = this.baseUrl + "/api/services/app/Mut/GetMut?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMutOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMutOutput>;
        }));
    }

    protected processGetMut(response: HttpResponseBase): Observable<GetMutOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMutOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseMut(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Mut/ReleaseMut?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseMut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseMut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseMut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Mut/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined): Observable<MutStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/Mut/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<MutStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMutationTypeConfiguration(type: ApplicationType, mutationTypeId: string): Observable<GetMutationTypeConfigurationOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Mut/GetMutationTypeConfiguration?";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (mutationTypeId === undefined || mutationTypeId === null)
            throw new Error("The parameter 'mutationTypeId' must be defined and cannot be null.");
        else
            url_ += "mutationTypeId=" + encodeURIComponent("" + mutationTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMutationTypeConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMutationTypeConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMutationTypeConfigurationOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMutationTypeConfigurationOutputDto>;
        }));
    }

    protected processGetMutationTypeConfiguration(response: HttpResponseBase): Observable<GetMutationTypeConfigurationOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMutationTypeConfigurationOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMutationTypeConfigurations(): Observable<GetMutationTypeConfigurationOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Mut/GetMutationTypeConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMutationTypeConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMutationTypeConfigurations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMutationTypeConfigurationOutputDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMutationTypeConfigurationOutputDto[]>;
        }));
    }

    protected processGetMutationTypeConfigurations(response: HttpResponseBase): Observable<GetMutationTypeConfigurationOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetMutationTypeConfigurationOutputDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getBusinessesForCorporateLicence(caseId: string | undefined): Observable<BusinessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Mut/GetBusinessesForCorporateLicence?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessesForCorporateLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessesForCorporateLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessDto[]>;
        }));
    }

    protected processGetBusinessesForCorporateLicence(response: HttpResponseBase): Observable<BusinessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BusinessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutAdditionalAcademicTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutAdditionalAcademicTitleDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutAdditionalAcademicTitle/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutAdditionalAcademicTitleDto> {
        let url_ = this.baseUrl + "/api/services/app/MutAdditionalAcademicTitle/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutAdditionalAcademicTitleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutAdditionalAcademicTitleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutAdditionalAcademicTitleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutAdditionalAcademicTitleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutApplicantAdditionalCommentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutApplicantAdditionalCommentsDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutApplicantAdditionalComments/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutApplicantAdditionalCommentsDto> {
        let url_ = this.baseUrl + "/api/services/app/MutApplicantAdditionalComments/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutApplicantAdditionalCommentsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutApplicantAdditionalCommentsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutApplicantAdditionalCommentsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutApplicantAdditionalCommentsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutApplicantBusinessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateUpdateMutApplicantBusinessInput | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutApplicantBusiness/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutApplicantBusinessDto> {
        let url_ = this.baseUrl + "/api/services/app/MutApplicantBusiness/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutApplicantBusinessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutApplicantBusinessDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutApplicantBusinessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutApplicantBusinessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutApplicantContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutApplicantContactDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutApplicantContact/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutApplicantContactDto> {
        let url_ = this.baseUrl + "/api/services/app/MutApplicantContact/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutApplicantContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutApplicantContactDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutApplicantContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutApplicantContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutApplicantPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutApplicantPersonDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutApplicantPerson/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutApplicantPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/MutApplicantPerson/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutApplicantPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutApplicantPersonDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutApplicantPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutApplicantPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutApplicantSponsorshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutApplicantSponsorshipDto> {
        let url_ = this.baseUrl + "/api/services/app/MutApplicantSponsorship/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutApplicantSponsorshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutApplicantSponsorshipDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutApplicantSponsorshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutApplicantSponsorshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutationApplicationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getMutationApplications(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetMutationApplicationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/MutationApplication/GetMutationApplications?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMutationApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMutationApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMutationApplicationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMutationApplicationsOutput>;
        }));
    }

    protected processGetMutationApplications(response: HttpResponseBase): Observable<GetMutationApplicationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMutationApplicationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutBusinessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    saveBusinessCreate(caseId: string | undefined, body: MutBusinessCreateDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutBusiness/SaveBusinessCreate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveBusinessCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveBusinessCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processSaveBusinessCreate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getBusinessCreate(caseId: string | undefined): Observable<MutBusinessCreateDto> {
        let url_ = this.baseUrl + "/api/services/app/MutBusiness/GetBusinessCreate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutBusinessCreateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutBusinessCreateDto>;
        }));
    }

    protected processGetBusinessCreate(response: HttpResponseBase): Observable<MutBusinessCreateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutBusinessCreateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    saveBusinessMove(caseId: string | undefined, body: MutBusinessMoveDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutBusiness/SaveBusinessMove?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveBusinessMove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveBusinessMove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processSaveBusinessMove(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getBusinessMove(caseId: string | undefined): Observable<GetMutBusinessMoveOutput> {
        let url_ = this.baseUrl + "/api/services/app/MutBusiness/GetBusinessMove?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessMove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessMove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMutBusinessMoveOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMutBusinessMoveOutput>;
        }));
    }

    protected processGetBusinessMove(response: HttpResponseBase): Observable<GetMutBusinessMoveOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMutBusinessMoveOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    saveBusinessClosure(caseId: string | undefined, body: MutBusinessClosureDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutBusiness/SaveBusinessClosure?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveBusinessClosure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveBusinessClosure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processSaveBusinessClosure(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getBusinessClosure(caseId: string | undefined): Observable<GetMutBusinessClosureOutput> {
        let url_ = this.baseUrl + "/api/services/app/MutBusiness/GetBusinessClosure?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessClosure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessClosure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMutBusinessClosureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMutBusinessClosureOutput>;
        }));
    }

    protected processGetBusinessClosure(response: HttpResponseBase): Observable<GetMutBusinessClosureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMutBusinessClosureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    saveBusinessBankruptcy(caseId: string | undefined, body: MutBusinessBankruptcyDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutBusiness/SaveBusinessBankruptcy?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveBusinessBankruptcy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveBusinessBankruptcy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processSaveBusinessBankruptcy(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getBusinessBankruptcy(caseId: string | undefined): Observable<GetMutBusinessBankruptcyOutput> {
        let url_ = this.baseUrl + "/api/services/app/MutBusiness/GetBusinessBankruptcy?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessBankruptcy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessBankruptcy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMutBusinessBankruptcyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMutBusinessBankruptcyOutput>;
        }));
    }

    protected processGetBusinessBankruptcy(response: HttpResponseBase): Observable<GetMutBusinessBankruptcyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMutBusinessBankruptcyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDocuments(body: GetMutDocumentsInput | undefined): Observable<MutDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/MutDocument/GetDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutDocumentsOutput>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<MutDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MutDocument/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param directorId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadSponsorshipDirectorCreateFiles(directorId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MutDocument/UploadSponsorshipDirectorCreateFiles?";
        if (directorId === null)
            throw new Error("The parameter 'directorId' cannot be null.");
        else if (directorId !== undefined)
            url_ += "directorId=" + encodeURIComponent("" + directorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSponsorshipDirectorCreateFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSponsorshipDirectorCreateFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadSponsorshipDirectorCreateFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSponsorshipDirectorCreateFiles(body: GetMutSubItemDocumentsInput | undefined): Observable<MutDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/MutDocument/GetSponsorshipDirectorCreateFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorshipDirectorCreateFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorshipDirectorCreateFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutDocumentsOutput>;
        }));
    }

    protected processGetSponsorshipDirectorCreateFiles(response: HttpResponseBase): Observable<MutDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMedicalFieldPersonCreateFiles(body: GetMutSubItemDocumentsInput | undefined): Observable<MutDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/MutDocument/GetMedicalFieldPersonCreateFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalFieldPersonCreateFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalFieldPersonCreateFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutDocumentsOutput>;
        }));
    }

    protected processGetMedicalFieldPersonCreateFiles(response: HttpResponseBase): Observable<MutDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param medicalFieldPersonCreateId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadMedicalFieldPersonCreateFiles(medicalFieldPersonCreateId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MutDocument/UploadMedicalFieldPersonCreateFiles?";
        if (medicalFieldPersonCreateId === null)
            throw new Error("The parameter 'medicalFieldPersonCreateId' cannot be null.");
        else if (medicalFieldPersonCreateId !== undefined)
            url_ += "medicalFieldPersonCreateId=" + encodeURIComponent("" + medicalFieldPersonCreateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMedicalFieldPersonCreateFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMedicalFieldPersonCreateFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadMedicalFieldPersonCreateFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFile(body: GetMutFileInput | undefined): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/MutDocument/GetFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: MutStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MutDocument/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutEmploymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    saveEmploymentCreate(caseId: string | undefined, body: MutEmploymentCreateDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutEmployment/SaveEmploymentCreate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEmploymentCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEmploymentCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processSaveEmploymentCreate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEmploymentCreate(caseId: string | undefined): Observable<MutEmploymentCreateDto> {
        let url_ = this.baseUrl + "/api/services/app/MutEmployment/GetEmploymentCreate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmploymentCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmploymentCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutEmploymentCreateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutEmploymentCreateDto>;
        }));
    }

    protected processGetEmploymentCreate(response: HttpResponseBase): Observable<MutEmploymentCreateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutEmploymentCreateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    saveEmploymentUpdate(caseId: string | undefined, body: MutEmploymentUpdateDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutEmployment/SaveEmploymentUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEmploymentUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEmploymentUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processSaveEmploymentUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEmploymentUpdate(caseId: string | undefined): Observable<GetMutEmploymentUpdateOutput> {
        let url_ = this.baseUrl + "/api/services/app/MutEmployment/GetEmploymentUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmploymentUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmploymentUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMutEmploymentUpdateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMutEmploymentUpdateOutput>;
        }));
    }

    protected processGetEmploymentUpdate(response: HttpResponseBase): Observable<GetMutEmploymentUpdateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMutEmploymentUpdateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    saveEmploymentTerminate(caseId: string | undefined, body: MutEmploymentTerminateDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutEmployment/SaveEmploymentTerminate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEmploymentTerminate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEmploymentTerminate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processSaveEmploymentTerminate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEmploymentTerminate(caseId: string | undefined): Observable<GetMutEmploymentTerminateOutput> {
        let url_ = this.baseUrl + "/api/services/app/MutEmployment/GetEmploymentTerminate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmploymentTerminate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmploymentTerminate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMutEmploymentTerminateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMutEmploymentTerminateOutput>;
        }));
    }

    protected processGetEmploymentTerminate(response: HttpResponseBase): Observable<GetMutEmploymentTerminateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMutEmploymentTerminateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    saveEmploymentTerminateAll(caseId: string | undefined, body: MutEmploymentTerminateAllDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutEmployment/SaveEmploymentTerminateAll?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEmploymentTerminateAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEmploymentTerminateAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processSaveEmploymentTerminateAll(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEmploymentTerminateAll(caseId: string | undefined): Observable<MutEmploymentTerminateAllDto> {
        let url_ = this.baseUrl + "/api/services/app/MutEmployment/GetEmploymentTerminateAll?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmploymentTerminateAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmploymentTerminateAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutEmploymentTerminateAllDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutEmploymentTerminateAllDto>;
        }));
    }

    protected processGetEmploymentTerminateAll(response: HttpResponseBase): Observable<MutEmploymentTerminateAllDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutEmploymentTerminateAllDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutMedicalFieldDirectorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    saveMedicalFieldDirector(caseId: string | undefined, body: MutMedicalFieldDirectorDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutMedicalFieldDirector/SaveMedicalFieldDirector?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMedicalFieldDirector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMedicalFieldDirector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processSaveMedicalFieldDirector(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getMedicalFieldDirector(caseId: string | undefined): Observable<MutMedicalFieldDirectorDto> {
        let url_ = this.baseUrl + "/api/services/app/MutMedicalFieldDirector/GetMedicalFieldDirector?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalFieldDirector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalFieldDirector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutMedicalFieldDirectorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutMedicalFieldDirectorDto>;
        }));
    }

    protected processGetMedicalFieldDirector(response: HttpResponseBase): Observable<MutMedicalFieldDirectorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutMedicalFieldDirectorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    saveMedicalFieldStorageAndQualityDirector(caseId: string | undefined, body: MutMedicalFieldStorageAndQualityDirectorDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutMedicalFieldDirector/SaveMedicalFieldStorageAndQualityDirector?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMedicalFieldStorageAndQualityDirector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMedicalFieldStorageAndQualityDirector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processSaveMedicalFieldStorageAndQualityDirector(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getMedicalFieldStorageAndQualityDirector(caseId: string | undefined): Observable<MutMedicalFieldStorageAndQualityDirectorDto> {
        let url_ = this.baseUrl + "/api/services/app/MutMedicalFieldDirector/GetMedicalFieldStorageAndQualityDirector?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalFieldStorageAndQualityDirector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalFieldStorageAndQualityDirector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutMedicalFieldStorageAndQualityDirectorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutMedicalFieldStorageAndQualityDirectorDto>;
        }));
    }

    protected processGetMedicalFieldStorageAndQualityDirector(response: HttpResponseBase): Observable<MutMedicalFieldStorageAndQualityDirectorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutMedicalFieldStorageAndQualityDirectorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    saveMedicalFieldHaemovigilanceDirector(caseId: string | undefined, body: MutMedicalFieldHaemovigilanceDirectorDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutMedicalFieldDirector/SaveMedicalFieldHaemovigilanceDirector?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMedicalFieldHaemovigilanceDirector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMedicalFieldHaemovigilanceDirector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processSaveMedicalFieldHaemovigilanceDirector(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getMedicalFieldHaemovigilanceDirector(caseId: string | undefined): Observable<MutMedicalFieldHaemovigilanceDirectorDto> {
        let url_ = this.baseUrl + "/api/services/app/MutMedicalFieldDirector/GetMedicalFieldHaemovigilanceDirector?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalFieldHaemovigilanceDirector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalFieldHaemovigilanceDirector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutMedicalFieldHaemovigilanceDirectorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutMedicalFieldHaemovigilanceDirectorDto>;
        }));
    }

    protected processGetMedicalFieldHaemovigilanceDirector(response: HttpResponseBase): Observable<MutMedicalFieldHaemovigilanceDirectorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutMedicalFieldHaemovigilanceDirectorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutMedicalFieldPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    saveMedicalFieldPersonCreateList(caseId: string | undefined, body: MutMedicalFieldPersonCreateDto[] | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutMedicalFieldPerson/SaveMedicalFieldPersonCreateList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMedicalFieldPersonCreateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMedicalFieldPersonCreateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processSaveMedicalFieldPersonCreateList(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createPlaceholderMedicalFieldPersonCreate(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MutMedicalFieldPerson/CreatePlaceholderMedicalFieldPersonCreate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderMedicalFieldPersonCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderMedicalFieldPersonCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderMedicalFieldPersonCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getMedicalFieldPersonCreateList(caseId: string | undefined): Observable<MutMedicalFieldPersonCreateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MutMedicalFieldPerson/GetMedicalFieldPersonCreateList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalFieldPersonCreateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalFieldPersonCreateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutMedicalFieldPersonCreateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutMedicalFieldPersonCreateDto[]>;
        }));
    }

    protected processGetMedicalFieldPersonCreateList(response: HttpResponseBase): Observable<MutMedicalFieldPersonCreateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MutMedicalFieldPersonCreateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    saveMedicalFieldPersonTerminate(caseId: string | undefined, body: CreateOrUpdateMutMedicalFieldPersonTerminateDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutMedicalFieldPerson/SaveMedicalFieldPersonTerminate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMedicalFieldPersonTerminate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMedicalFieldPersonTerminate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processSaveMedicalFieldPersonTerminate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getMedicalFieldPersonTerminate(caseId: string | undefined): Observable<MutMedicalFieldPersonTerminateDto> {
        let url_ = this.baseUrl + "/api/services/app/MutMedicalFieldPerson/GetMedicalFieldPersonTerminate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalFieldPersonTerminate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalFieldPersonTerminate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutMedicalFieldPersonTerminateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutMedicalFieldPersonTerminateDto>;
        }));
    }

    protected processGetMedicalFieldPersonTerminate(response: HttpResponseBase): Observable<MutMedicalFieldPersonTerminateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutMedicalFieldPersonTerminateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateName(caseId: string | undefined, body: MutPersonNameDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutPerson/CreateOrUpdateName?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdateName(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getName(caseId: string | undefined): Observable<MutPersonNameDto> {
        let url_ = this.baseUrl + "/api/services/app/MutPerson/GetName?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutPersonNameDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutPersonNameDto>;
        }));
    }

    protected processGetName(response: HttpResponseBase): Observable<MutPersonNameDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutPersonNameDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateContact(caseId: string | undefined, body: MutPersonContactDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutPerson/CreateOrUpdateContact?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdateContact(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getContact(caseId: string | undefined): Observable<GetMutPersonContactOutput> {
        let url_ = this.baseUrl + "/api/services/app/MutPerson/GetContact?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMutPersonContactOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMutPersonContactOutput>;
        }));
    }

    protected processGetContact(response: HttpResponseBase): Observable<GetMutPersonContactOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMutPersonContactOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutPersonnelChangeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    savePersonnelChange(caseId: string | undefined, body: MutPersonnelChangeDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutPersonnelChange/SavePersonnelChange?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePersonnelChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePersonnelChange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processSavePersonnelChange(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getPersonnelChange(caseId: string | undefined): Observable<MutPersonnelChangeDto> {
        let url_ = this.baseUrl + "/api/services/app/MutPersonnelChange/GetPersonnelChange?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonnelChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonnelChange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutPersonnelChangeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutPersonnelChangeDto>;
        }));
    }

    protected processGetPersonnelChange(response: HttpResponseBase): Observable<MutPersonnelChangeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutPersonnelChangeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutSponsorshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateName(caseId: string | undefined, body: MutSponsorshipNameDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutSponsorship/CreateOrUpdateName?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdateName(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getName(caseId: string | undefined): Observable<GetMutSponsorshipNameOutput> {
        let url_ = this.baseUrl + "/api/services/app/MutSponsorship/GetName?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMutSponsorshipNameOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMutSponsorshipNameOutput>;
        }));
    }

    protected processGetName(response: HttpResponseBase): Observable<GetMutSponsorshipNameOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMutSponsorshipNameOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateAddress(caseId: string | undefined, body: MutSponsorshipAddressDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutSponsorship/CreateOrUpdateAddress?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdateAddress(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getAddress(caseId: string | undefined): Observable<GetMutSponsorshipAddressOutput> {
        let url_ = this.baseUrl + "/api/services/app/MutSponsorship/GetAddress?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMutSponsorshipAddressOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMutSponsorshipAddressOutput>;
        }));
    }

    protected processGetAddress(response: HttpResponseBase): Observable<GetMutSponsorshipAddressOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMutSponsorshipAddressOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateContact(caseId: string | undefined, body: MutSponsorshipContactDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutSponsorship/CreateOrUpdateContact?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdateContact(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getContact(caseId: string | undefined): Observable<GetMutSponsorshipContactOutput> {
        let url_ = this.baseUrl + "/api/services/app/MutSponsorship/GetContact?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMutSponsorshipContactOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMutSponsorshipContactOutput>;
        }));
    }

    protected processGetContact(response: HttpResponseBase): Observable<GetMutSponsorshipContactOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMutSponsorshipContactOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutSponsorshipDirectorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    saveSponsorshipDirectorCreateList(caseId: string | undefined, body: MutSponsorshipDirectorCreateDto[] | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutSponsorshipDirector/SaveSponsorshipDirectorCreateList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSponsorshipDirectorCreateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSponsorshipDirectorCreateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processSaveSponsorshipDirectorCreateList(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createPlaceholderSponsorshipDirectorCreate(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MutSponsorshipDirector/CreatePlaceholderSponsorshipDirectorCreate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderSponsorshipDirectorCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderSponsorshipDirectorCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderSponsorshipDirectorCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getSponsorshipDirectorCreateList(caseId: string | undefined): Observable<MutSponsorshipDirectorCreateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MutSponsorshipDirector/GetSponsorshipDirectorCreateList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorshipDirectorCreateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorshipDirectorCreateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutSponsorshipDirectorCreateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutSponsorshipDirectorCreateDto[]>;
        }));
    }

    protected processGetSponsorshipDirectorCreateList(response: HttpResponseBase): Observable<MutSponsorshipDirectorCreateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MutSponsorshipDirectorCreateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    saveSponsorshipDirectorTerminate(caseId: string | undefined, body: CreateOrUpdateMutSponsorshipDirectorTerminateDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutSponsorshipDirector/SaveSponsorshipDirectorTerminate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSponsorshipDirectorTerminate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSponsorshipDirectorTerminate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processSaveSponsorshipDirectorTerminate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getSponsorshipDirectorTerminate(caseId: string | undefined): Observable<MutSponsorshipDirectorTerminateDto> {
        let url_ = this.baseUrl + "/api/services/app/MutSponsorshipDirector/GetSponsorshipDirectorTerminate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorshipDirectorTerminate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorshipDirectorTerminate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutSponsorshipDirectorTerminateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutSponsorshipDirectorTerminateDto>;
        }));
    }

    protected processGetSponsorshipDirectorTerminate(response: HttpResponseBase): Observable<MutSponsorshipDirectorTerminateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutSponsorshipDirectorTerminateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MySironaDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param documentId (optional) 
     * @param documentLinkDiscriminator (optional) 
     * @param entityId (optional) 
     * @return Success
     */
    getDocument(documentId: number | undefined, documentLinkDiscriminator: string | undefined, entityId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MySironaDocument/GetDocument?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (documentLinkDiscriminator === null)
            throw new Error("The parameter 'documentLinkDiscriminator' cannot be null.");
        else if (documentLinkDiscriminator !== undefined)
            url_ += "documentLinkDiscriminator=" + encodeURIComponent("" + documentLinkDiscriminator) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDocument(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDocumentListForUser(): Observable<MySironaUserDocumentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MySironaDocument/GetDocumentListForUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentListForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentListForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MySironaUserDocumentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MySironaUserDocumentDto[]>;
        }));
    }

    protected processGetDocumentListForUser(response: HttpResponseBase): Observable<MySironaUserDocumentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MySironaUserDocumentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param documentId (optional) 
     * @param documentLinkDiscriminator (optional) 
     * @param entityId (optional) 
     * @return Success
     */
    setDocumentDecreePickupDate(documentId: number | undefined, documentLinkDiscriminator: string | undefined, entityId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MySironaDocument/SetDocumentDecreePickupDate?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (documentLinkDiscriminator === null)
            throw new Error("The parameter 'documentLinkDiscriminator' cannot be null.");
        else if (documentLinkDiscriminator !== undefined)
            url_ += "documentLinkDiscriminator=" + encodeURIComponent("" + documentLinkDiscriminator) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDocumentDecreePickupDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDocumentDecreePickupDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDocumentDecreePickupDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MySironaLegitimationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getLegitimations(): Observable<GetLegitimationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MySironaLegitimation/GetLegitimations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLegitimations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLegitimations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLegitimationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLegitimationDto[]>;
        }));
    }

    protected processGetLegitimations(response: HttpResponseBase): Observable<GetLegitimationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetLegitimationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MySironaNotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param filter (optional) 
     * @param isRead (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 2147483647.
     * @return Success
     */
    getNotifications(filter: string | undefined, isRead: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GetMySironaNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/MySironaNotification/GetNotifications?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isRead === null)
            throw new Error("The parameter 'isRead' cannot be null.");
        else if (isRead !== undefined)
            url_ += "IsRead=" + encodeURIComponent("" + isRead) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMySironaNotificationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMySironaNotificationsOutput>;
        }));
    }

    protected processGetNotifications(response: HttpResponseBase): Observable<GetMySironaNotificationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMySironaNotificationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNotification(id: number | undefined): Observable<MySironaNotificationDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/MySironaNotification/GetNotification?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MySironaNotificationDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MySironaNotificationDetailDto>;
        }));
    }

    protected processGetNotification(response: HttpResponseBase): Observable<MySironaNotificationDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MySironaNotificationDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param notificationId (optional) 
     * @param documentId (optional) 
     * @return Success
     */
    getDocument(notificationId: number | undefined, documentId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MySironaNotification/GetDocument?";
        if (notificationId === null)
            throw new Error("The parameter 'notificationId' cannot be null.");
        else if (notificationId !== undefined)
            url_ += "notificationId=" + encodeURIComponent("" + notificationId) + "&";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDocument(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendResponse(body: SendNotificationResponseInput | undefined): Observable<SendNotificationResponseOutput> {
        let url_ = this.baseUrl + "/api/services/app/MySironaNotification/SendResponse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendNotificationResponseOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendNotificationResponseOutput>;
        }));
    }

    protected processSendResponse(response: HttpResponseBase): Observable<SendNotificationResponseOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendNotificationResponseOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MySironaPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getPersonData(personId: number | undefined): Observable<MySironaGetPersonDataDto> {
        let url_ = this.baseUrl + "/api/services/app/MySironaPerson/GetPersonData?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MySironaGetPersonDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MySironaGetPersonDataDto>;
        }));
    }

    protected processGetPersonData(response: HttpResponseBase): Observable<MySironaGetPersonDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MySironaGetPersonDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getLicencesForPerson(personId: number | undefined): Observable<MySironaGetPersonLicenceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MySironaPerson/GetLicencesForPerson?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicencesForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicencesForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MySironaGetPersonLicenceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MySironaGetPersonLicenceDto[]>;
        }));
    }

    protected processGetLicencesForPerson(response: HttpResponseBase): Observable<MySironaGetPersonLicenceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MySironaGetPersonLicenceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licenceId (optional) 
     * @return Success
     */
    getPersonLicence(licenceId: number | undefined): Observable<MySironaGetPersonLicenceDetailedDto> {
        let url_ = this.baseUrl + "/api/services/app/MySironaPerson/GetPersonLicence?";
        if (licenceId === null)
            throw new Error("The parameter 'licenceId' cannot be null.");
        else if (licenceId !== undefined)
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MySironaGetPersonLicenceDetailedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MySironaGetPersonLicenceDetailedDto>;
        }));
    }

    protected processGetPersonLicence(response: HttpResponseBase): Observable<MySironaGetPersonLicenceDetailedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MySironaGetPersonLicenceDetailedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    hasPersonMutApplications(gln: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MySironaPerson/HasPersonMutApplications?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasPersonMutApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasPersonMutApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processHasPersonMutApplications(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getDiplomasAndPostgraduateTitles(personId: number | undefined): Observable<MySironaGetDiplomaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MySironaPerson/GetDiplomasAndPostgraduateTitles?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiplomasAndPostgraduateTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiplomasAndPostgraduateTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MySironaGetDiplomaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MySironaGetDiplomaDto[]>;
        }));
    }

    protected processGetDiplomasAndPostgraduateTitles(response: HttpResponseBase): Observable<MySironaGetDiplomaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MySironaGetDiplomaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getAcademicTitles(personId: number | undefined): Observable<MySironaGetAcademicTitleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MySironaPerson/GetAcademicTitles?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcademicTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcademicTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MySironaGetAcademicTitleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MySironaGetAcademicTitleDto[]>;
        }));
    }

    protected processGetAcademicTitles(response: HttpResponseBase): Observable<MySironaGetAcademicTitleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MySironaGetAcademicTitleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    createMut(mutationType: string, personId: number): Observable<CreateMutOutput> {
        let url_ = this.baseUrl + "/api/services/app/MySironaPerson/CreateMut?";
        if (mutationType === undefined || mutationType === null)
            throw new Error("The parameter 'mutationType' must be defined and cannot be null.");
        else
            url_ += "mutationType=" + encodeURIComponent("" + mutationType) + "&";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined and cannot be null.");
        else
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateMutOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateMutOutput>;
        }));
    }

    protected processCreateMut(response: HttpResponseBase): Observable<CreateMutOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateMutOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param onlyAdmin (optional) 
     * @return Success
     */
    getLegitimations(personId: number | undefined, onlyAdmin: boolean | undefined): Observable<MySironaLegitimatedUser[]> {
        let url_ = this.baseUrl + "/api/services/app/MySironaPerson/GetLegitimations?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (onlyAdmin === null)
            throw new Error("The parameter 'onlyAdmin' cannot be null.");
        else if (onlyAdmin !== undefined)
            url_ += "onlyAdmin=" + encodeURIComponent("" + onlyAdmin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLegitimations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLegitimations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MySironaLegitimatedUser[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MySironaLegitimatedUser[]>;
        }));
    }

    protected processGetLegitimations(response: HttpResponseBase): Observable<MySironaLegitimatedUser[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MySironaLegitimatedUser.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MySironaSponsorshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param sponsorshipId (optional) 
     * @return Success
     */
    getSponsorshipData(sponsorshipId: number | undefined): Observable<MySironaGetSponsorshipDataDto> {
        let url_ = this.baseUrl + "/api/services/app/MySironaSponsorship/GetSponsorshipData?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorshipData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorshipData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MySironaGetSponsorshipDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MySironaGetSponsorshipDataDto>;
        }));
    }

    protected processGetSponsorshipData(response: HttpResponseBase): Observable<MySironaGetSponsorshipDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MySironaGetSponsorshipDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @param licenceType (optional) 
     * @return Success
     */
    getLicencesForSponsorship(sponsorshipId: number | undefined, licenceType: CorporateLicenceType | undefined): Observable<MySironaGetCorporateLicenceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MySironaSponsorship/GetLicencesForSponsorship?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        if (licenceType === null)
            throw new Error("The parameter 'licenceType' cannot be null.");
        else if (licenceType !== undefined)
            url_ += "licenceType=" + encodeURIComponent("" + licenceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicencesForSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicencesForSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MySironaGetCorporateLicenceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MySironaGetCorporateLicenceDto[]>;
        }));
    }

    protected processGetLicencesForSponsorship(response: HttpResponseBase): Observable<MySironaGetCorporateLicenceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MySironaGetCorporateLicenceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licenceId (optional) 
     * @return Success
     */
    getCorporateLicence(licenceId: number | undefined): Observable<MySironaGetCorporateLicenceDetailedDto> {
        let url_ = this.baseUrl + "/api/services/app/MySironaSponsorship/GetCorporateLicence?";
        if (licenceId === null)
            throw new Error("The parameter 'licenceId' cannot be null.");
        else if (licenceId !== undefined)
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCorporateLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCorporateLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MySironaGetCorporateLicenceDetailedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MySironaGetCorporateLicenceDetailedDto>;
        }));
    }

    protected processGetCorporateLicence(response: HttpResponseBase): Observable<MySironaGetCorporateLicenceDetailedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MySironaGetCorporateLicenceDetailedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @return Success
     */
    hasSponsorshipMutApplications(sponsorshipId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MySironaSponsorship/HasSponsorshipMutApplications?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasSponsorshipMutApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasSponsorshipMutApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processHasSponsorshipMutApplications(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param corporateLicenceId (optional) 
     * @return Success
     */
    createMut(mutationType: string, sponsorshipId: number, corporateLicenceId: number | undefined): Observable<CreateMutOutput> {
        let url_ = this.baseUrl + "/api/services/app/MySironaSponsorship/CreateMut?";
        if (mutationType === undefined || mutationType === null)
            throw new Error("The parameter 'mutationType' must be defined and cannot be null.");
        else
            url_ += "mutationType=" + encodeURIComponent("" + mutationType) + "&";
        if (sponsorshipId === undefined || sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' must be defined and cannot be null.");
        else
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        if (corporateLicenceId === null)
            throw new Error("The parameter 'corporateLicenceId' cannot be null.");
        else if (corporateLicenceId !== undefined)
            url_ += "corporateLicenceId=" + encodeURIComponent("" + corporateLicenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateMutOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateMutOutput>;
        }));
    }

    protected processCreateMut(response: HttpResponseBase): Observable<CreateMutOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateMutOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @param onlyAdmin (optional) 
     * @return Success
     */
    getLegitimations(sponsorshipId: number | undefined, onlyAdmin: boolean | undefined): Observable<MySironaLegitimatedUser[]> {
        let url_ = this.baseUrl + "/api/services/app/MySironaSponsorship/GetLegitimations?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        if (onlyAdmin === null)
            throw new Error("The parameter 'onlyAdmin' cannot be null.");
        else if (onlyAdmin !== undefined)
            url_ += "onlyAdmin=" + encodeURIComponent("" + onlyAdmin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLegitimations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLegitimations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MySironaLegitimatedUser[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MySironaLegitimatedUser[]>;
        }));
    }

    protected processGetLegitimations(response: HttpResponseBase): Observable<MySironaLegitimatedUser[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MySironaLegitimatedUser.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MySironaUserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getUserProfileData(): Observable<GetUserProfileDataDto> {
        let url_ = this.baseUrl + "/api/services/app/MySironaUser/GetUserProfileData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProfileData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProfileData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserProfileDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserProfileDataDto>;
        }));
    }

    protected processGetUserProfileData(response: HttpResponseBase): Observable<GetUserProfileDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserProfileDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getIdentificationStatus(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MySironaUser/GetIdentificationStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIdentificationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIdentificationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetIdentificationStatus(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NarcoticPrescriptionBlockServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: NarcoticPrescriptionBlockSearchInputDto | undefined): Observable<NarcoticPrescriptionBlockSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/NarcoticPrescriptionBlock/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NarcoticPrescriptionBlockSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NarcoticPrescriptionBlockSearchOutputDto>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<NarcoticPrescriptionBlockSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NarcoticPrescriptionBlockSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetNarcoticPrescriptionBlockDto> {
        let url_ = this.baseUrl + "/api/services/app/NarcoticPrescriptionBlock/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNarcoticPrescriptionBlockDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNarcoticPrescriptionBlockDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetNarcoticPrescriptionBlockDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNarcoticPrescriptionBlockDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateNarcoticPrescriptionBlockDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/NarcoticPrescriptionBlock/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(id: number | undefined, body: NarcoticPrescriptionBlockDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NarcoticPrescriptionBlock/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NarcoticPrescriptionBlock/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param narcoticPrescriptionBlockId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createDetailBlocks(narcoticPrescriptionBlockId: number | undefined, body: CreateOrUpdateNarcoticPrescriptionBlockDetailDto[] | undefined): Observable<GetNarcoticPrescriptionBlockDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NarcoticPrescriptionBlock/CreateDetailBlocks?";
        if (narcoticPrescriptionBlockId === null)
            throw new Error("The parameter 'narcoticPrescriptionBlockId' cannot be null.");
        else if (narcoticPrescriptionBlockId !== undefined)
            url_ += "narcoticPrescriptionBlockId=" + encodeURIComponent("" + narcoticPrescriptionBlockId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDetailBlocks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDetailBlocks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNarcoticPrescriptionBlockDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNarcoticPrescriptionBlockDetailDto[]>;
        }));
    }

    protected processCreateDetailBlocks(response: HttpResponseBase): Observable<GetNarcoticPrescriptionBlockDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetNarcoticPrescriptionBlockDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param narcoticPrescriptionBlockId (optional) 
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateDetailBlock(narcoticPrescriptionBlockId: number | undefined, id: number | undefined, body: CreateOrUpdateNarcoticPrescriptionBlockDetailDto | undefined): Observable<GetNarcoticPrescriptionBlockDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NarcoticPrescriptionBlock/UpdateDetailBlock?";
        if (narcoticPrescriptionBlockId === null)
            throw new Error("The parameter 'narcoticPrescriptionBlockId' cannot be null.");
        else if (narcoticPrescriptionBlockId !== undefined)
            url_ += "narcoticPrescriptionBlockId=" + encodeURIComponent("" + narcoticPrescriptionBlockId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDetailBlock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDetailBlock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNarcoticPrescriptionBlockDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNarcoticPrescriptionBlockDetailDto[]>;
        }));
    }

    protected processUpdateDetailBlock(response: HttpResponseBase): Observable<GetNarcoticPrescriptionBlockDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetNarcoticPrescriptionBlockDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param narcoticPrescriptionBlockId (optional) 
     * @param id (optional) 
     * @return Success
     */
    deleteDetailBlock(narcoticPrescriptionBlockId: number | undefined, id: number | undefined): Observable<GetNarcoticPrescriptionBlockDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NarcoticPrescriptionBlock/DeleteDetailBlock?";
        if (narcoticPrescriptionBlockId === null)
            throw new Error("The parameter 'narcoticPrescriptionBlockId' cannot be null.");
        else if (narcoticPrescriptionBlockId !== undefined)
            url_ += "narcoticPrescriptionBlockId=" + encodeURIComponent("" + narcoticPrescriptionBlockId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDetailBlock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDetailBlock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNarcoticPrescriptionBlockDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNarcoticPrescriptionBlockDetailDto[]>;
        }));
    }

    protected processDeleteDetailBlock(response: HttpResponseBase): Observable<GetNarcoticPrescriptionBlockDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetNarcoticPrescriptionBlockDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getEmploymentsForPerson(personId: number | undefined): Observable<GetNarcoticPrescriptionBlockEmploymentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NarcoticPrescriptionBlock/GetEmploymentsForPerson?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmploymentsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmploymentsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNarcoticPrescriptionBlockEmploymentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNarcoticPrescriptionBlockEmploymentDto[]>;
        }));
    }

    protected processGetEmploymentsForPerson(response: HttpResponseBase): Observable<GetNarcoticPrescriptionBlockEmploymentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetNarcoticPrescriptionBlockEmploymentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NaregServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    test(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Nareg/Test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDetailed(personId: number): Observable<GetNaregPersonDetailedOutput> {
        let url_ = this.baseUrl + "/api/services/app/Nareg/GetDetailed?";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined and cannot be null.");
        else
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNaregPersonDetailedOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNaregPersonDetailedOutput>;
        }));
    }

    protected processGetDetailed(response: HttpResponseBase): Observable<GetNaregPersonDetailedOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNaregPersonDetailedOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getDetailedByGln(gln: string | undefined): Observable<GetNaregPersonDetailedOutput> {
        let url_ = this.baseUrl + "/api/services/app/Nareg/GetDetailedByGln?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailedByGln(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailedByGln(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNaregPersonDetailedOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNaregPersonDetailedOutput>;
        }));
    }

    protected processGetDetailedByGln(response: HttpResponseBase): Observable<GetNaregPersonDetailedOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNaregPersonDetailedOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    get(personId: number): Observable<GetNaregPersonOutput> {
        let url_ = this.baseUrl + "/api/services/app/Nareg/Get?";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined and cannot be null.");
        else
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNaregPersonOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNaregPersonOutput>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetNaregPersonOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNaregPersonOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getByGln(gln: string | undefined): Observable<GetNaregPersonOutput> {
        let url_ = this.baseUrl + "/api/services/app/Nareg/GetByGln?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByGln(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByGln(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNaregPersonOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNaregPersonOutput>;
        }));
    }

    protected processGetByGln(response: HttpResponseBase): Observable<GetNaregPersonOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNaregPersonOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NdnServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createNdn(body: CreateNdnApplicationDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Ndn/CreateNdn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNdn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNdn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateNdn(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getNdn(caseId: string | undefined): Observable<GetNdnOutput> {
        let url_ = this.baseUrl + "/api/services/app/Ndn/GetNdn?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNdn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNdn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNdnOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNdnOutput>;
        }));
    }

    protected processGetNdn(response: HttpResponseBase): Observable<GetNdnOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNdnOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyNdns(): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ndn/GetMyNdns";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyNdns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyNdns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetMyNdns(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getNdnsForPerson(gln: string | undefined): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ndn/GetNdnsForPerson?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNdnsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNdnsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetNdnsForPerson(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param status (optional) 
     * @return Success
     */
    getNextStatus(caseId: string | undefined, status: NdnStatus | undefined): Observable<NdnStatus> {
        let url_ = this.baseUrl + "/api/services/app/Ndn/GetNextStatus?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NdnStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NdnStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<NdnStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseNdn(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ndn/ReleaseNdn?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseNdn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseNdn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseNdn(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param professionId (optional) 
     * @return Success
     */
    getExternalRegisterByProfessionId(professionId: string | undefined): Observable<ExternalSystemEnum> {
        let url_ = this.baseUrl + "/api/services/app/Ndn/GetExternalRegisterByProfessionId?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalRegisterByProfessionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalRegisterByProfessionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalSystemEnum>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalSystemEnum>;
        }));
    }

    protected processGetExternalRegisterByProfessionId(response: HttpResponseBase): Observable<ExternalSystemEnum> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param gln (optional) 
     * @param professionId (optional) 
     * @return Success
     */
    updateNdnPersonWithRegisterCheck(caseId: string | undefined, gln: string | undefined, professionId: string | undefined): Observable<HealthRegisterIdentificationStatus> {
        let url_ = this.baseUrl + "/api/services/app/Ndn/UpdateNdnPersonWithRegisterCheck?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNdnPersonWithRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNdnPersonWithRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthRegisterIdentificationStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthRegisterIdentificationStatus>;
        }));
    }

    protected processUpdateNdnPersonWithRegisterCheck(response: HttpResponseBase): Observable<HealthRegisterIdentificationStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    acceptRegisterCheck(body: UpdateNdnPersonInput | undefined): Observable<NdnStatus> {
        let url_ = this.baseUrl + "/api/services/app/Ndn/AcceptRegisterCheck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NdnStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NdnStatus>;
        }));
    }

    protected processAcceptRegisterCheck(response: HttpResponseBase): Observable<NdnStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getDossierContact(gln: string | undefined): Observable<NdnPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/Ndn/GetDossierContact?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDossierContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDossierContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NdnPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NdnPersonDto>;
        }));
    }

    protected processGetDossierContact(response: HttpResponseBase): Observable<NdnPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NdnPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateSubstances(body: CreateOrUpdateSubstancesInput | undefined): Observable<NdnStatus> {
        let url_ = this.baseUrl + "/api/services/app/Ndn/CreateOrUpdateSubstances";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateSubstances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateSubstances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NdnStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NdnStatus>;
        }));
    }

    protected processCreateOrUpdateSubstances(response: HttpResponseBase): Observable<NdnStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param generateXml (optional) 
     * @return Success
     */
    createDeliveryNotesDocument(caseId: string | undefined, generateXml: boolean | undefined): Observable<CreateDeliveryNotesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Ndn/CreateDeliveryNotesDocument?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (generateXml === null)
            throw new Error("The parameter 'generateXml' cannot be null.");
        else if (generateXml !== undefined)
            url_ += "generateXml=" + encodeURIComponent("" + generateXml) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDeliveryNotesDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDeliveryNotesDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateDeliveryNotesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateDeliveryNotesOutput>;
        }));
    }

    protected processCreateDeliveryNotesDocument(response: HttpResponseBase): Observable<CreateDeliveryNotesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateDeliveryNotesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getPersonId(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Ndn/GetPersonId?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPersonId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Ndn/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NdqrServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createNdqr(body: CreateNdqrApplicationDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Ndqr/CreateNdqr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNdqr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNdqr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateNdqr(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getNdqr(caseId: string | undefined): Observable<NdqrDto> {
        let url_ = this.baseUrl + "/api/services/app/Ndqr/GetNdqr?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNdqr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNdqr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NdqrDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NdqrDto>;
        }));
    }

    protected processGetNdqr(response: HttpResponseBase): Observable<NdqrDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NdqrDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyNdqrs(): Observable<NdqrDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ndqr/GetMyNdqrs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyNdqrs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyNdqrs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NdqrDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NdqrDto[]>;
        }));
    }

    protected processGetMyNdqrs(response: HttpResponseBase): Observable<NdqrDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NdqrDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param status (optional) 
     * @return Success
     */
    getNextStatus(caseId: string | undefined, status: NdqrStatus | undefined): Observable<NdqrStatus> {
        let url_ = this.baseUrl + "/api/services/app/Ndqr/GetNextStatus?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NdqrStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NdqrStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<NdqrStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param professionId (optional) 
     * @return Success
     */
    getExternalRegisterByProfessionId(professionId: string | undefined): Observable<ExternalSystemEnum> {
        let url_ = this.baseUrl + "/api/services/app/Ndqr/GetExternalRegisterByProfessionId?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalRegisterByProfessionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalRegisterByProfessionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalSystemEnum>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalSystemEnum>;
        }));
    }

    protected processGetExternalRegisterByProfessionId(response: HttpResponseBase): Observable<ExternalSystemEnum> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseNdrq(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ndqr/ReleaseNdrq?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseNdrq(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseNdrq(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseNdrq(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Ndqr/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NdqrBusinessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param year (optional) 
     * @return Success
     */
    getNumberOfTotalWorkedDays(caseId: string | undefined, year: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/NdqrBusiness/GetNumberOfTotalWorkedDays?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfTotalWorkedDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfTotalWorkedDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumberOfTotalWorkedDays(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateBusiness(caseId: string | undefined, body: NdqrBusinessDto | undefined): Observable<NdqrBusinessOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/NdqrBusiness/CreateOrUpdateBusiness?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NdqrBusinessOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NdqrBusinessOutputDto>;
        }));
    }

    protected processCreateOrUpdateBusiness(response: HttpResponseBase): Observable<NdqrBusinessOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NdqrBusinessOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NdqrRegisterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getLegitimatedGlnForRegister(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/NdqrRegister/GetLegitimatedGlnForRegister?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLegitimatedGlnForRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLegitimatedGlnForRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLegitimatedGlnForRegister(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createOrUpdateEhcRegister(caseId: string | undefined): Observable<CreateOrUpdateNdqrRegisterOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/NdqrRegister/CreateOrUpdateEhcRegister?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateNdqrRegisterOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateNdqrRegisterOutputDto>;
        }));
    }

    protected processCreateOrUpdateEhcRegister(response: HttpResponseBase): Observable<CreateOrUpdateNdqrRegisterOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateNdqrRegisterOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    acceptRegisterCheck(caseId: string | undefined): Observable<NdqrStatus> {
        let url_ = this.baseUrl + "/api/services/app/NdqrRegister/AcceptRegisterCheck?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NdqrStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NdqrStatus>;
        }));
    }

    protected processAcceptRegisterCheck(response: HttpResponseBase): Observable<NdqrStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NiServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createNi(body: CreateNiInput | undefined): Observable<CreateNiOutput> {
        let url_ = this.baseUrl + "/api/services/app/Ni/CreateNi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateNiOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateNiOutput>;
        }));
    }

    protected processCreateNi(response: HttpResponseBase): Observable<CreateNiOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateNiOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getNi(caseId: string | undefined): Observable<NiApplicationDto> {
        let url_ = this.baseUrl + "/api/services/app/Ni/GetNi?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiApplicationDto>;
        }));
    }

    protected processGetNi(response: HttpResponseBase): Observable<NiApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NiApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyNis(): Observable<NiApplicationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ni/GetMyNis";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyNis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyNis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiApplicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiApplicationDto[]>;
        }));
    }

    protected processGetMyNis(response: HttpResponseBase): Observable<NiApplicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NiApplicationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyPersonNis(): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ni/GetMyPersonNis";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyPersonNis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyPersonNis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetMyPersonNis(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMySponsorshipNis(): Observable<SponsorshipApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ni/GetMySponsorshipNis";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMySponsorshipNis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMySponsorshipNis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SponsorshipApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SponsorshipApplicationSummaryDto[]>;
        }));
    }

    protected processGetMySponsorshipNis(response: HttpResponseBase): Observable<SponsorshipApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SponsorshipApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ahv (optional) 
     * @return Success
     */
    getNisForPerson(ahv: string | undefined): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ni/GetNisForPerson?";
        if (ahv === null)
            throw new Error("The parameter 'ahv' cannot be null.");
        else if (ahv !== undefined)
            url_ += "ahv=" + encodeURIComponent("" + ahv) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNisForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNisForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetNisForPerson(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param status (optional) 
     * @return Success
     */
    getNextStatus(caseId: string | undefined, status: NiStatus | undefined): Observable<NiStatus> {
        let url_ = this.baseUrl + "/api/services/app/Ni/GetNextStatus?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<NiStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    setNextStatus(caseId: string | undefined, body: NiStatus | undefined): Observable<NiStatus> {
        let url_ = this.baseUrl + "/api/services/app/Ni/SetNextStatus?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiStatus>;
        }));
    }

    protected processSetNextStatus(response: HttpResponseBase): Observable<NiStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param isTertiaryB (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined, isTertiaryB: boolean | undefined): Observable<NiStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/Ni/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (isTertiaryB === null)
            throw new Error("The parameter 'isTertiaryB' cannot be null.");
        else if (isTertiaryB !== undefined)
            url_ += "isTertiaryB=" + encodeURIComponent("" + isTertiaryB) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<NiStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @param isTertiaryB (optional) 
     * @return Success
     */
    releaseNi(caseId: string | undefined, applicantComment: string | undefined, isTertiaryB: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ni/ReleaseNi?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        if (isTertiaryB === null)
            throw new Error("The parameter 'isTertiaryB' cannot be null.");
        else if (isTertiaryB !== undefined)
            url_ += "isTertiaryB=" + encodeURIComponent("" + isTertiaryB) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseNi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseNi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseNi(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Ni/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getPersonId(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Ni/GetPersonId?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPersonId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getSponsorshipId(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Ni/GetSponsorshipId?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorshipId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorshipId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetSponsorshipId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NiBankDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getBankDetails(caseId: string | undefined): Observable<NiBankDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/NiBankDetails/GetBankDetails?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiBankDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiBankDetailsDto>;
        }));
    }

    protected processGetBankDetails(response: HttpResponseBase): Observable<NiBankDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NiBankDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateBankDetails(body: CreateOrUpdateNiBankDetailsInput | undefined): Observable<NiStatus> {
        let url_ = this.baseUrl + "/api/services/app/NiBankDetails/CreateOrUpdateBankDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateBankDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateBankDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiStatus>;
        }));
    }

    protected processCreateOrUpdateBankDetails(response: HttpResponseBase): Observable<NiStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NiCourseOfferingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getCourseOffering(caseId: string | undefined): Observable<NiCourseOfferingDto> {
        let url_ = this.baseUrl + "/api/services/app/NiCourseOffering/GetCourseOffering?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCourseOffering(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCourseOffering(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiCourseOfferingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiCourseOfferingDto>;
        }));
    }

    protected processGetCourseOffering(response: HttpResponseBase): Observable<NiCourseOfferingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NiCourseOfferingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateCourseOffering(body: CreateOrUpdateNiCourseOfferingInput | undefined): Observable<NiStatus> {
        let url_ = this.baseUrl + "/api/services/app/NiCourseOffering/CreateOrUpdateCourseOffering";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateCourseOffering(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateCourseOffering(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiStatus>;
        }));
    }

    protected processCreateOrUpdateCourseOffering(response: HttpResponseBase): Observable<NiStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NiDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param status (optional) 
     * @param isTertiaryB (optional) 
     * @return Success
     */
    getDocumentsForNi(caseId: string | undefined, status: NiStatus | undefined, isTertiaryB: boolean | undefined): Observable<NiDocumentGroup[]> {
        let url_ = this.baseUrl + "/api/services/app/NiDocument/GetDocumentsForNi?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (isTertiaryB === null)
            throw new Error("The parameter 'isTertiaryB' cannot be null.");
        else if (isTertiaryB !== undefined)
            url_ += "isTertiaryB=" + encodeURIComponent("" + isTertiaryB) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsForNi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsForNi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiDocumentGroup[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiDocumentGroup[]>;
        }));
    }

    protected processGetDocumentsForNi(response: HttpResponseBase): Observable<NiDocumentGroup[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NiDocumentGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param status (optional) 
     * @param fileId (optional) 
     * @return Success
     */
    getFile(caseId: string | undefined, status: NiStatus | undefined, fileId: number | undefined): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/NiDocument/GetFile?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param status (optional) 
     * @param fileId (optional) 
     * @return Success
     */
    deleteFile(caseId: string | undefined, status: NiStatus | undefined, fileId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NiDocument/DeleteFile?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NiDocument/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NiEducationProviderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEducationProvider(caseId: string | undefined): Observable<NiEducationProviderDto> {
        let url_ = this.baseUrl + "/api/services/app/NiEducationProvider/GetEducationProvider?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducationProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducationProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiEducationProviderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiEducationProviderDto>;
        }));
    }

    protected processGetEducationProvider(response: HttpResponseBase): Observable<NiEducationProviderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NiEducationProviderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEducationProvider(body: CreateOrUpdateNiEducationProviderInput | undefined): Observable<NiStatus> {
        let url_ = this.baseUrl + "/api/services/app/NiEducationProvider/CreateOrUpdateEducationProvider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEducationProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEducationProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiStatus>;
        }));
    }

    protected processCreateOrUpdateEducationProvider(response: HttpResponseBase): Observable<NiStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NiPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getPerson(caseId: string | undefined): Observable<NiPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/NiPerson/GetPerson?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiPersonDto>;
        }));
    }

    protected processGetPerson(response: HttpResponseBase): Observable<NiPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NiPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdatePerson(body: CreateOrUpdateNiPersonInput | undefined): Observable<NiStatus> {
        let url_ = this.baseUrl + "/api/services/app/NiPerson/CreateOrUpdatePerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdatePerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdatePerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiStatus>;
        }));
    }

    protected processCreateOrUpdatePerson(response: HttpResponseBase): Observable<NiStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NiPersonContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getPersonContact(caseId: string | undefined): Observable<NiPersonContactDto> {
        let url_ = this.baseUrl + "/api/services/app/NiPersonContact/GetPersonContact?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiPersonContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiPersonContactDto>;
        }));
    }

    protected processGetPersonContact(response: HttpResponseBase): Observable<NiPersonContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NiPersonContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdatePersonContact(body: CreateOrUpdateNiPersonContactInput | undefined): Observable<NiStatus> {
        let url_ = this.baseUrl + "/api/services/app/NiPersonContact/CreateOrUpdatePersonContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdatePersonContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdatePersonContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiStatus>;
        }));
    }

    protected processCreateOrUpdatePersonContact(response: HttpResponseBase): Observable<NiStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NiProfessionalDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getProfessionalDetails(caseId: string | undefined): Observable<NiProfessionalDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/NiProfessionalDetails/GetProfessionalDetails?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiProfessionalDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiProfessionalDetailsDto>;
        }));
    }

    protected processGetProfessionalDetails(response: HttpResponseBase): Observable<NiProfessionalDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NiProfessionalDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateProfessionalDetails(body: CreateOrUpdateNiProfessionalDetailsInput | undefined): Observable<NiStatus> {
        let url_ = this.baseUrl + "/api/services/app/NiProfessionalDetails/CreateOrUpdateProfessionalDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateProfessionalDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateProfessionalDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiStatus>;
        }));
    }

    protected processCreateOrUpdateProfessionalDetails(response: HttpResponseBase): Observable<NiStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NiSponsorshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getSponsorship(caseId: string | undefined): Observable<NiSponsorshipDto> {
        let url_ = this.baseUrl + "/api/services/app/NiSponsorship/GetSponsorship?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiSponsorshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiSponsorshipDto>;
        }));
    }

    protected processGetSponsorship(response: HttpResponseBase): Observable<NiSponsorshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NiSponsorshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateSponsorship(body: CreateOrUpdateNiSponsorshipInput | undefined): Observable<NiStatus> {
        let url_ = this.baseUrl + "/api/services/app/NiSponsorship/CreateOrUpdateSponsorship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiStatus>;
        }));
    }

    protected processCreateOrUpdateSponsorship(response: HttpResponseBase): Observable<NiStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NiSponsorshipContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getSponsorshipContact(caseId: string | undefined): Observable<NiSponsorshipContactDto> {
        let url_ = this.baseUrl + "/api/services/app/NiSponsorshipContact/GetSponsorshipContact?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorshipContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorshipContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiSponsorshipContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiSponsorshipContactDto>;
        }));
    }

    protected processGetSponsorshipContact(response: HttpResponseBase): Observable<NiSponsorshipContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NiSponsorshipContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateSponsorshipContact(body: CreateOrUpdateNiSponsorshipContactInput | undefined): Observable<NiStatus> {
        let url_ = this.baseUrl + "/api/services/app/NiSponsorshipContact/CreateOrUpdateSponsorshipContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateSponsorshipContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateSponsorshipContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NiStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NiStatus>;
        }));
    }

    protected processCreateOrUpdateSponsorshipContact(response: HttpResponseBase): Observable<NiStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param state (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getUserNotifications(state: UserNotificationState | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationsOutput>;
        }));
    }

    protected processGetUserNotifications(response: HttpResponseBase): Observable<GetNotificationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    shouldUserUpdateApp(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Notification/ShouldUserUpdateApp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShouldUserUpdateApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShouldUserUpdateApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processShouldUserUpdateApp(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    setAllAvailableVersionNotificationAsRead(): Observable<SetNotificationAsReadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllAvailableVersionNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllAvailableVersionNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllAvailableVersionNotificationAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetNotificationAsReadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetNotificationAsReadOutput>;
        }));
    }

    protected processSetAllAvailableVersionNotificationAsRead(response: HttpResponseBase): Observable<SetNotificationAsReadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetNotificationAsReadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    setAllNotificationsAsRead(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllNotificationsAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllNotificationsAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAllNotificationsAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setNotificationAsRead(body: EntityDtoOfGuid | undefined): Observable<SetNotificationAsReadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNotificationAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetNotificationAsReadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetNotificationAsReadOutput>;
        }));
    }

    protected processSetNotificationAsRead(response: HttpResponseBase): Observable<SetNotificationAsReadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetNotificationAsReadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationSettingsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationSettingsOutput>;
        }));
    }

    protected processGetNotificationSettings(response: HttpResponseBase): Observable<GetNotificationSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateNotificationSettings(body: UpdateNotificationSettingsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteNotification(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteNotification?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param state (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    deleteAllUserNotifications(state: UserNotificationState | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteAllUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAllUserNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 2147483647.
     * @return Success
     */
    getAllUserForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfMassNotificationUserLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetAllUserForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMassNotificationUserLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMassNotificationUserLookupTableDto>;
        }));
    }

    protected processGetAllUserForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMassNotificationUserLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMassNotificationUserLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 2147483647.
     * @return Success
     */
    getAllOrganizationUnitForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetAllOrganizationUnitForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationUnitForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationUnitForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto>;
        }));
    }

    protected processGetAllOrganizationUnitForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMassNotification(body: CreateMassNotificationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/CreateMassNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMassNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMassNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateMassNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    createNewVersionReleasedNotification(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/CreateNewVersionReleasedNotification";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNewVersionReleasedNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNewVersionReleasedNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateNewVersionReleasedNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllNotifiers(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetAllNotifiers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNotifiers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNotifiers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllNotifiers(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getNotificationsPublishedByUser(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<GetPublishedNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationsPublishedByUser?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationsPublishedByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationsPublishedByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPublishedNotificationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPublishedNotificationsOutput>;
        }));
    }

    protected processGetNotificationsPublishedByUser(response: HttpResponseBase): Observable<GetPublishedNotificationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublishedNotificationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NpboServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createNpbo(body: CreateNpboApplicationDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Npbo/CreateNpbo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNpbo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNpbo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateNpbo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getNpbo(caseId: string | undefined): Observable<NpboDto> {
        let url_ = this.baseUrl + "/api/services/app/Npbo/GetNpbo?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNpbo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNpbo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NpboDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NpboDto>;
        }));
    }

    protected processGetNpbo(response: HttpResponseBase): Observable<NpboDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NpboDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyNpbos(): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Npbo/GetMyNpbos";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyNpbos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyNpbos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetMyNpbos(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getNpbosForPerson(gln: string | undefined): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Npbo/GetNpbosForPerson?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNpbosForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNpbosForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetNpbosForPerson(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseNpbo(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Npbo/ReleaseNpbo?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseNpbo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseNpbo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseNpbo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Npbo/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNextStatus(caseId: string, status: NpboStatus): Observable<NpboStatus> {
        let url_ = this.baseUrl + "/api/services/app/Npbo/GetNextStatus?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NpboStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NpboStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<NpboStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getPersonIdForNpbo(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Npbo/GetPersonIdForNpbo?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonIdForNpbo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonIdForNpbo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPersonIdForNpbo(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NpboAddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getRemoteAddresses(caseId: string | undefined): Observable<NpboRemoteAddressDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NpboAddress/GetRemoteAddresses?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRemoteAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRemoteAddresses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NpboRemoteAddressDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NpboRemoteAddressDto[]>;
        }));
    }

    protected processGetRemoteAddresses(response: HttpResponseBase): Observable<NpboRemoteAddressDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NpboRemoteAddressDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getDefaultData(caseId: string | undefined): Observable<NpboAddressDefaultDataDto> {
        let url_ = this.baseUrl + "/api/services/app/NpboAddress/GetDefaultData?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NpboAddressDefaultDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NpboAddressDefaultDataDto>;
        }));
    }

    protected processGetDefaultData(response: HttpResponseBase): Observable<NpboAddressDefaultDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NpboAddressDefaultDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateAddress(body: CreateOrUpdateNpboAddressInput | undefined): Observable<NpboStatus> {
        let url_ = this.baseUrl + "/api/services/app/NpboAddress/CreateOrUpdateAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NpboStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NpboStatus>;
        }));
    }

    protected processCreateOrUpdateAddress(response: HttpResponseBase): Observable<NpboStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NpboNumberServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateNumber(body: CreateOrUpdateNpboNumberInput | undefined): Observable<NpboStatus> {
        let url_ = this.baseUrl + "/api/services/app/NpboNumber/CreateOrUpdateNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NpboStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NpboStatus>;
        }));
    }

    protected processCreateOrUpdateNumber(response: HttpResponseBase): Observable<NpboStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NpboRegisterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getLegitimatedGlnForRegister(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/NpboRegister/GetLegitimatedGlnForRegister?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLegitimatedGlnForRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLegitimatedGlnForRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLegitimatedGlnForRegister(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createOrUpdateRegister(caseId: string | undefined): Observable<CreateOrUpdateNpboRegisterOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/NpboRegister/CreateOrUpdateRegister?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateNpboRegisterOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateNpboRegisterOutputDto>;
        }));
    }

    protected processCreateOrUpdateRegister(response: HttpResponseBase): Observable<CreateOrUpdateNpboRegisterOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateNpboRegisterOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    acceptRegisterCheck(caseId: string | undefined): Observable<NpboStatus> {
        let url_ = this.baseUrl + "/api/services/app/NpboRegister/AcceptRegisterCheck?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NpboStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NpboStatus>;
        }));
    }

    protected processAcceptRegisterCheck(response: HttpResponseBase): Observable<NpboStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NpfServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    createNpf(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Npf/CreateNpf";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNpf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNpf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateNpf(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getNpf(caseId: string | undefined): Observable<NpfDto> {
        let url_ = this.baseUrl + "/api/services/app/Npf/GetNpf?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNpf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNpf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NpfDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NpfDto>;
        }));
    }

    protected processGetNpf(response: HttpResponseBase): Observable<NpfDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NpfDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyNpfs(): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Npf/GetMyNpfs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyNpfs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyNpfs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetMyNpfs(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getNpfsForPerson(gln: string | undefined): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Npf/GetNpfsForPerson?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNpfsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNpfsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetNpfsForPerson(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param status (optional) 
     * @return Success
     */
    getNextStatus(caseId: string | undefined, status: NpfStatus | undefined): Observable<NpfStatus> {
        let url_ = this.baseUrl + "/api/services/app/Npf/GetNextStatus?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NpfStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NpfStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<NpfStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateContact(caseId: string | undefined, body: NpfContactDto | undefined): Observable<NpfCreateOrUpdateOutputOfNpfContactDto> {
        let url_ = this.baseUrl + "/api/services/app/Npf/CreateOrUpdateContact?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NpfCreateOrUpdateOutputOfNpfContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NpfCreateOrUpdateOutputOfNpfContactDto>;
        }));
    }

    protected processCreateOrUpdateContact(response: HttpResponseBase): Observable<NpfCreateOrUpdateOutputOfNpfContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NpfCreateOrUpdateOutputOfNpfContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdatePrescriptionFraud(caseId: string | undefined, body: NpfPrescriptionFraudDto | undefined): Observable<NpfCreateOrUpdateOutputOfNpfPrescriptionFraudDto> {
        let url_ = this.baseUrl + "/api/services/app/Npf/CreateOrUpdatePrescriptionFraud?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdatePrescriptionFraud(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdatePrescriptionFraud(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NpfCreateOrUpdateOutputOfNpfPrescriptionFraudDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NpfCreateOrUpdateOutputOfNpfPrescriptionFraudDto>;
        }));
    }

    protected processCreateOrUpdatePrescriptionFraud(response: HttpResponseBase): Observable<NpfCreateOrUpdateOutputOfNpfPrescriptionFraudDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NpfCreateOrUpdateOutputOfNpfPrescriptionFraudDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseNpf(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Npf/ReleaseNpf?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseNpf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseNpf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseNpf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getFiles(caseId: string | undefined): Observable<NpfDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Npf/GetFiles?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NpfDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NpfDocumentsOutput>;
        }));
    }

    protected processGetFiles(response: HttpResponseBase): Observable<NpfDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NpfDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param step (optional) 
     * @param id (optional) 
     * @return Success
     */
    getFile(caseId: string | undefined, step: NpfStatus | undefined, id: number | undefined): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Npf/GetFile?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Npf/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param step (optional) 
     * @param id (optional) 
     * @return Success
     */
    deleteFile(caseId: string | undefined, step: NpfStatus | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Npf/DeleteFile?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined): Observable<NpfStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/Npf/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NpfStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NpfStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<NpfStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Npf/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OlaOnlineDrugSalesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    completeOnlineDrugSales(caseId: string | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/OlaOnlineDrugSales/CompleteOnlineDrugSales?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteOnlineDrugSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteOnlineDrugSales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processCompleteOnlineDrugSales(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getOrganizationUnits(): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfOrganizationUnitDto>;
        }));
    }

    protected processGetOrganizationUnits(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) The field Id must be between 1 and 9.223372036854776E+18.
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getOrganizationUnitUsers(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitUserListDto>;
        }));
    }

    protected processGetOrganizationUnitUsers(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) The field Id must be between 1 and 9.223372036854776E+18.
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getOrganizationUnitRoles(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitRoles?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitRoleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitRoleListDto>;
        }));
    }

    protected processGetOrganizationUnitRoles(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) The field Id must be between 1 and 9.223372036854776E+18.
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getOrganizationUnitProfessions(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitProfessionListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitProfessions?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitProfessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitProfessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitProfessionListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitProfessionListDto>;
        }));
    }

    protected processGetOrganizationUnitProfessions(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitProfessionListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitProfessionListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrganizationUnit(body: CreateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processCreateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOrganizationUnit(body: UpdateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processUpdateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveOrganizationUnit(body: MoveOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processMoveOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteOrganizationUnit(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) The field UserId must be between 1 and 9.223372036854776E+18.
     * @param organizationUnitId (optional) The field OrganizationUnitId must be between 1 and 9.223372036854776E+18.
     * @return Success
     */
    removeUserFromOrganizationUnit(userId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUserFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roleId (optional) The field RoleId must be between 1 and 9.223372036854776E+18.
     * @param organizationUnitId (optional) The field OrganizationUnitId must be between 1 and 9.223372036854776E+18.
     * @return Success
     */
    removeRoleFromOrganizationUnit(roleId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveRoleFromOrganizationUnit?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveRoleFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveRoleFromOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveRoleFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param professionId (optional) 
     * @param organizationUnitId (optional) The field OrganizationUnitId must be between 1 and 9.223372036854776E+18.
     * @return Success
     */
    removeProfessionFromOrganizationUnit(professionId: string | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveProfessionFromOrganizationUnit?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "ProfessionId=" + encodeURIComponent("" + professionId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveProfessionFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveProfessionFromOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveProfessionFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUsersToOrganizationUnit(body: UsersToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUsersToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUsersToOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddUsersToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addRolesToOrganizationUnit(body: RolesToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddRolesToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRolesToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRolesToOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddRolesToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addProfessionsToOrganizationUnit(body: ProfessionsToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddProfessionsToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProfessionsToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProfessionsToOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddProfessionsToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findUsers(body: FindOrganizationUnitUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findRoles(body: FindOrganizationUnitRolesInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindRoles(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findProfessions(body: FindOrganizationUnitProfessionsInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindProfessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindProfessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindProfessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindProfessions(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<OrganizationUnitDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrganizationUnitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PendencesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPendence(id: number | undefined): Observable<PendenceDto> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/GetPendence?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendenceDto>;
        }));
    }

    protected processGetPendence(response: HttpResponseBase): Observable<PendenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PendenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPendenceIncludingLinks(id: number | undefined): Observable<PendenceIncludingLinksDto> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/GetPendenceIncludingLinks?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendenceIncludingLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendenceIncludingLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendenceIncludingLinksDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendenceIncludingLinksDto>;
        }));
    }

    protected processGetPendenceIncludingLinks(response: HttpResponseBase): Observable<PendenceIncludingLinksDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PendenceIncludingLinksDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param linkFilter (optional) 
     * @param link_Discriminator (optional) 
     * @param link_EntityId (optional) 
     * @param mustContainReferenceLink (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getPendences(linkFilter: string | undefined, link_Discriminator: string | undefined, link_EntityId: number | undefined, mustContainReferenceLink: boolean | undefined, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetPendencesSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/GetPendences?";
        if (linkFilter === null)
            throw new Error("The parameter 'linkFilter' cannot be null.");
        else if (linkFilter !== undefined)
            url_ += "LinkFilter=" + encodeURIComponent("" + linkFilter) + "&";
        if (link_Discriminator === null)
            throw new Error("The parameter 'link_Discriminator' cannot be null.");
        else if (link_Discriminator !== undefined)
            url_ += "Link.Discriminator=" + encodeURIComponent("" + link_Discriminator) + "&";
        if (link_EntityId === null)
            throw new Error("The parameter 'link_EntityId' cannot be null.");
        else if (link_EntityId !== undefined)
            url_ += "Link.EntityId=" + encodeURIComponent("" + link_EntityId) + "&";
        if (mustContainReferenceLink === null)
            throw new Error("The parameter 'mustContainReferenceLink' cannot be null.");
        else if (mustContainReferenceLink !== undefined)
            url_ += "MustContainReferenceLink=" + encodeURIComponent("" + mustContainReferenceLink) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPendencesSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPendencesSearchOutput>;
        }));
    }

    protected processGetPendences(response: HttpResponseBase): Observable<GetPendencesSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPendencesSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    putPendence(id: number | undefined, body: PendenceDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/PutPendence?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutPendence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutPendence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPutPendence(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param reason (optional) 
     * @return Success
     */
    deletePendence(id: number | undefined, reason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/DeletePendence?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePendence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePendence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePendence(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional) 
     * @param reason (optional) 
     * @return Success
     */
    deletePendences(ids: number[] | undefined, reason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/DeletePendences?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePendences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePendences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePendences(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignPendence(body: AssignPendenceInput | undefined): Observable<AssignPendenceOutput> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/AssignPendence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignPendence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignPendence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignPendenceOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignPendenceOutput>;
        }));
    }

    protected processAssignPendence(response: HttpResponseBase): Observable<AssignPendenceOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignPendenceOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pendenceId (optional) 
     * @return Success
     */
    unassignPendence(pendenceId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/UnassignPendence?";
        if (pendenceId === null)
            throw new Error("The parameter 'pendenceId' cannot be null.");
        else if (pendenceId !== undefined)
            url_ += "pendenceId=" + encodeURIComponent("" + pendenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignPendence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignPendence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignPendence(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completePendences(body: CompletePendencesInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/CompletePendences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompletePendences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletePendences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCompletePendences(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPendence(body: CreatePendenceDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/CreatePendence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePendence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePendence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePendence(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pendenceId (optional) 
     * @return Success
     */
    addLink(pendenceId: number | undefined, body: PendenceLinkDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/AddLink?";
        if (pendenceId === null)
            throw new Error("The parameter 'pendenceId' cannot be null.");
        else if (pendenceId !== undefined)
            url_ += "pendenceId=" + encodeURIComponent("" + pendenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pendenceId (optional) 
     * @param discriminator (optional) 
     * @param entityId (optional) 
     * @return Success
     */
    removeLink(pendenceId: number | undefined, discriminator: string | undefined, entityId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/RemoveLink?";
        if (pendenceId === null)
            throw new Error("The parameter 'pendenceId' cannot be null.");
        else if (pendenceId !== undefined)
            url_ += "pendenceId=" + encodeURIComponent("" + pendenceId) + "&";
        if (discriminator === null)
            throw new Error("The parameter 'discriminator' cannot be null.");
        else if (discriminator !== undefined)
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PeopleApplicationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getPeopleApplications(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetPeopleApplicationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/PeopleApplication/GetPeopleApplications?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPeopleApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeopleApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPeopleApplicationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPeopleApplicationsOutput>;
        }));
    }

    protected processGetPeopleApplications(response: HttpResponseBase): Observable<GetPeopleApplicationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPeopleApplicationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProfessions(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/PeopleApplication/GetProfessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetProfessions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getApplicationTypes(): Observable<ApplicationType[]> {
        let url_ = this.baseUrl + "/api/services/app/PeopleApplication/GetApplicationTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationType[]>;
        }));
    }

    protected processGetApplicationTypes(response: HttpResponseBase): Observable<ApplicationType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PersonDossierServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: PersonSearchDto | undefined): Observable<GetPersonDossierSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonDossierSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonDossierSearchOutput>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<GetPersonDossierSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonDossierSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param loadDiplomas (optional) 
     * @param body (optional) 
     * @return Success
     */
    searchPersonDossiers(loadDiplomas: boolean | undefined, body: PersonSearchDto | undefined): Observable<GetPersonDossierSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/SearchPersonDossiers?";
        if (loadDiplomas === null)
            throw new Error("The parameter 'loadDiplomas' cannot be null.");
        else if (loadDiplomas !== undefined)
            url_ += "loadDiplomas=" + encodeURIComponent("" + loadDiplomas) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchPersonDossiers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchPersonDossiers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonDossierSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonDossierSearchOutput>;
        }));
    }

    protected processSearchPersonDossiers(response: HttpResponseBase): Observable<GetPersonDossierSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonDossierSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getPersonSummary(personId: number | undefined): Observable<PersonDossierSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/GetPersonSummary?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonDossierSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonDossierSummaryDto>;
        }));
    }

    protected processGetPersonSummary(response: HttpResponseBase): Observable<PersonDossierSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonDossierSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getPerson(personId: number | undefined): Observable<GetPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/GetPerson?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonDto>;
        }));
    }

    protected processGetPerson(response: HttpResponseBase): Observable<GetPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPerson(body: CreateOrUpdatePersonDto | undefined): Observable<GetPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/CreatePerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonDto>;
        }));
    }

    protected processCreatePerson(response: HttpResponseBase): Observable<GetPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPersonAndContactFromEmploymentInfo(body: CreatePersonFromEmploymentInfoDto | undefined): Observable<GetPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/CreatePersonAndContactFromEmploymentInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePersonAndContactFromEmploymentInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePersonAndContactFromEmploymentInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonDto>;
        }));
    }

    protected processCreatePersonAndContactFromEmploymentInfo(response: HttpResponseBase): Observable<GetPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPersonAndLinkToEmployment(body: CreatePersonAndLinkToEmploymentInput | undefined): Observable<GetPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/CreatePersonAndLinkToEmployment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePersonAndLinkToEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePersonAndLinkToEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonDto>;
        }));
    }

    protected processCreatePersonAndLinkToEmployment(response: HttpResponseBase): Observable<GetPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPersonFromHealthRegisterInfo(body: CreatePersonFromHealthRegisterInfoDto | undefined): Observable<GetPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/CreatePersonFromHealthRegisterInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePersonFromHealthRegisterInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePersonFromHealthRegisterInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonDto>;
        }));
    }

    protected processCreatePersonFromHealthRegisterInfo(response: HttpResponseBase): Observable<GetPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePerson(personId: number | undefined, body: CreateOrUpdatePersonDto | undefined): Observable<GetPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/UpdatePerson?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonDto>;
        }));
    }

    protected processUpdatePerson(response: HttpResponseBase): Observable<GetPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param isArchived (optional) 
     * @return Success
     */
    setArchiveFlag(personId: number | undefined, isArchived: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/SetArchiveFlag?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (isArchived === null)
            throw new Error("The parameter 'isArchived' cannot be null.");
        else if (isArchived !== undefined)
            url_ += "isArchived=" + encodeURIComponent("" + isArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetArchiveFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetArchiveFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetArchiveFlag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getContact(personId: number | undefined): Observable<ContactDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/GetContact?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactDto>;
        }));
    }

    protected processGetContact(response: HttpResponseBase): Observable<ContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param body (optional) 
     * @return Success
     */
    putContact(personId: number | undefined, body: ContactDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/PutContact?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutContact(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getInvoiceAddress(personId: number | undefined): Observable<InvoiceAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/GetInvoiceAddress?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceAddressDto>;
        }));
    }

    protected processGetInvoiceAddress(response: HttpResponseBase): Observable<InvoiceAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getPersonLicences(personId: number | undefined): Observable<PersonLicenceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/GetPersonLicences?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonLicences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonLicences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonLicenceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonLicenceDto[]>;
        }));
    }

    protected processGetPersonLicences(response: HttpResponseBase): Observable<PersonLicenceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonLicenceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param body (optional) 
     * @return Success
     */
    putInvoiceAddress(personId: number | undefined, body: InvoiceAddressDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/PutInvoiceAddress?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutInvoiceAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutInvoiceAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutInvoiceAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getProfessionsForPerson(personId: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/GetProfessionsForPerson?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetProfessionsForPerson(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PersonLicenceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchPersonLicences(body: SearchPersonLicencesInputDto | undefined): Observable<SearchPersonLicencesOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/SearchPersonLicences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchPersonLicences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchPersonLicences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchPersonLicencesOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchPersonLicencesOutputDto>;
        }));
    }

    protected processSearchPersonLicences(response: HttpResponseBase): Observable<SearchPersonLicencesOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchPersonLicencesOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param typeIds (optional) 
     * @return Success
     */
    getPersonLicences(personId: number | undefined, typeIds: PersonLicenceType[] | undefined): Observable<GetPersonLicencesOutput> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/GetPersonLicences?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (typeIds === null)
            throw new Error("The parameter 'typeIds' cannot be null.");
        else if (typeIds !== undefined)
            typeIds && typeIds.forEach(item => { url_ += "typeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonLicences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonLicences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonLicencesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonLicencesOutput>;
        }));
    }

    protected processGetPersonLicences(response: HttpResponseBase): Observable<GetPersonLicencesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonLicencesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PersonLicenceDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonLicenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonLicenceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PersonLicenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonLicenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<PersonLicenceHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonLicenceHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonLicenceHistoryDto[]>;
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<PersonLicenceHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonLicenceHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getPersonLicencesForAssistantOrDelegatedOrRepresentation(personId: number | undefined): Observable<GetPersonLicencesOutput> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/GetPersonLicencesForAssistantOrDelegatedOrRepresentation?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonLicencesForAssistantOrDelegatedOrRepresentation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonLicencesForAssistantOrDelegatedOrRepresentation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonLicencesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonLicencesOutput>;
        }));
    }

    protected processGetPersonLicencesForAssistantOrDelegatedOrRepresentation(response: HttpResponseBase): Observable<GetPersonLicencesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonLicencesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    post(body: CreatePersonLicenceDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param onlyWithPermissionInUse (optional) 
     * @return Success
     */
    getPersonLicenceTypes(onlyWithPermissionInUse: boolean | undefined): Observable<PersonLicenceType[]> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/GetPersonLicenceTypes?";
        if (onlyWithPermissionInUse === null)
            throw new Error("The parameter 'onlyWithPermissionInUse' cannot be null.");
        else if (onlyWithPermissionInUse !== undefined)
            url_ += "onlyWithPermissionInUse=" + encodeURIComponent("" + onlyWithPermissionInUse) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonLicenceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonLicenceTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonLicenceType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonLicenceType[]>;
        }));
    }

    protected processGetPersonLicenceTypes(response: HttpResponseBase): Observable<PersonLicenceType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    put(id: number | undefined, body: UpdatePersonLicenceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/Put?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRenewal(body: CreatePersonLicenceRenewalDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/CreateRenewal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRenewal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateRenewal(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateRenewal(id: number | undefined, body: UpdatePersonLicenceRenewalDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/UpdateRenewal?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRenewal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRenewal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProfessionalResponsibility(body: PersonLicenceProfessionalResponsibilityDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/CreateProfessionalResponsibility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProfessionalResponsibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProfessionalResponsibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateProfessionalResponsibility(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProfessionalResponsibility(body: PersonLicenceProfessionalResponsibilityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/UpdateProfessionalResponsibility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfessionalResponsibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfessionalResponsibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProfessionalResponsibility(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param responsibilityId (optional) 
     * @return Success
     */
    deleteProfessionalResponsibility(responsibilityId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/DeleteProfessionalResponsibility?";
        if (responsibilityId === null)
            throw new Error("The parameter 'responsibilityId' cannot be null.");
        else if (responsibilityId !== undefined)
            url_ += "responsibilityId=" + encodeURIComponent("" + responsibilityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProfessionalResponsibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProfessionalResponsibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProfessionalResponsibility(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PostgraduateTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getPostgraduateTitles(personId: number, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetPostgraduateTitleSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/PostgraduateTitle/GetPostgraduateTitles?";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined and cannot be null.");
        else
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostgraduateTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostgraduateTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPostgraduateTitleSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPostgraduateTitleSearchOutput>;
        }));
    }

    protected processGetPostgraduateTitles(response: HttpResponseBase): Observable<GetPostgraduateTitleSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPostgraduateTitleSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPostgraduateTitle(id: number | undefined): Observable<PostgraduateTitleDto> {
        let url_ = this.baseUrl + "/api/services/app/PostgraduateTitle/GetPostgraduateTitle?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostgraduateTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostgraduateTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PostgraduateTitleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PostgraduateTitleDto>;
        }));
    }

    protected processGetPostgraduateTitle(response: HttpResponseBase): Observable<PostgraduateTitleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PostgraduateTitleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postPostgraduateTitle(body: CreatePostgraduateTitleDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PostgraduateTitle/PostPostgraduateTitle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPostgraduateTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPostgraduateTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPostPostgraduateTitle(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    putPostgraduateTitle(id: number | undefined, body: PostgraduateTitleDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PostgraduateTitle/PutPostgraduateTitle?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutPostgraduateTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutPostgraduateTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutPostgraduateTitle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param reason (optional) 
     * @return Success
     */
    deletePostgraduateTitle(id: number | undefined, reason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PostgraduateTitle/DeletePostgraduateTitle?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePostgraduateTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePostgraduateTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePostgraduateTitle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PostgraduateTitleProfessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param postgraduateTitleId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(postgraduateTitleId: string | undefined, body: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PostgraduateTitleProfession/CreateOrUpdate?";
        if (postgraduateTitleId === null)
            throw new Error("The parameter 'postgraduateTitleId' cannot be null.");
        else if (postgraduateTitleId !== undefined)
            url_ += "postgraduateTitleId=" + encodeURIComponent("" + postgraduateTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param postgraduateTitleId (optional) 
     * @return Success
     */
    getProfessionsForPostgraduateTitle(postgraduateTitleId: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/PostgraduateTitleProfession/GetProfessionsForPostgraduateTitle?";
        if (postgraduateTitleId === null)
            throw new Error("The parameter 'postgraduateTitleId' cannot be null.");
        else if (postgraduateTitleId !== undefined)
            url_ += "postgraduateTitleId=" + encodeURIComponent("" + postgraduateTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionsForPostgraduateTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionsForPostgraduateTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetProfessionsForPostgraduateTitle(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param professionId (optional) 
     * @return Success
     */
    getPostgraduateTitlesForProfession(professionId: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/PostgraduateTitleProfession/GetPostgraduateTitlesForProfession?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostgraduateTitlesForProfession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostgraduateTitlesForProfession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetPostgraduateTitlesForProfession(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProfessionRegisterAffiliationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param professionId (optional) 
     * @return Success
     */
    get(professionId: string | undefined): Observable<ProfessionRegisterAffiliationDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRegisterAffiliation/Get?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionRegisterAffiliationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionRegisterAffiliationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProfessionRegisterAffiliationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionRegisterAffiliationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<ProfessionRegisterAffiliationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRegisterAffiliation/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionRegisterAffiliationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionRegisterAffiliationDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProfessionRegisterAffiliationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProfessionRegisterAffiliationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ProfessionRegisterAffiliationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRegisterAffiliation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    exportGlobalProfessionConfiguration(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRegisterAffiliation/ExportGlobalProfessionConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportGlobalProfessionConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportGlobalProfessionConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportGlobalProfessionConfiguration(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    importGlobalProfessionConfiguration(body: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRegisterAffiliation/ImportGlobalProfessionConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportGlobalProfessionConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportGlobalProfessionConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportGlobalProfessionConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserProfileForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserProfileForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentUserProfileEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentUserProfileEditDto>;
        }));
    }

    protected processGetCurrentUserProfileForEdit(response: HttpResponseBase): Observable<CurrentUserProfileEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentUserProfileEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    disableGoogleAuthenticator(body: VerifyAuthenticatorCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/DisableGoogleAuthenticator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableGoogleAuthenticator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableGoogleAuthenticator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableGoogleAuthenticator(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    viewRecoveryCodes(body: VerifyAuthenticatorCodeInput | undefined): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ViewRecoveryCodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processViewRecoveryCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processViewRecoveryCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
        }));
    }

    protected processViewRecoveryCodes(response: HttpResponseBase): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    generateGoogleAuthenticatorKey(): Observable<GenerateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GenerateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateGoogleAuthenticatorKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateGoogleAuthenticatorKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenerateGoogleAuthenticatorKeyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenerateGoogleAuthenticatorKeyOutput>;
        }));
    }

    protected processGenerateGoogleAuthenticatorKey(response: HttpResponseBase): Observable<GenerateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateGoogleAuthenticatorKey(body: UpdateGoogleAuthenticatorKeyInput | undefined): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGoogleAuthenticatorKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGoogleAuthenticatorKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
        }));
    }

    protected processUpdateGoogleAuthenticatorKey(response: HttpResponseBase): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendVerificationSms(body: SendVerificationSmsInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendVerificationSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifySmsCode(body: VerifySmsCodeInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifySmsCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifySmsCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerifySmsCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    prepareCollectedData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/PrepareCollectedData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareCollectedData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareCollectedData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPrepareCollectedData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCurrentUserProfile(body: CurrentUserProfileEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProfilePicture(body: UpdateProfilePictureInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProfilePicture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyAuthenticatorCode(body: VerifyAuthenticatorCodeInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifyAuthenticatorCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyAuthenticatorCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyAuthenticatorCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerifyAuthenticatorCode(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPasswordComplexitySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPasswordComplexitySetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPasswordComplexitySettingOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPasswordComplexitySettingOutput>;
        }));
    }

    protected processGetPasswordComplexitySetting(response: HttpResponseBase): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPasswordComplexitySettingOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProfilePicture(): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getFriendProfilePicture(userId: number | undefined, tenantId: number | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetFriendProfilePicture?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFriendProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFriendProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetFriendProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getProfilePictureByUser(userId: number | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureByUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePictureByUser(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PsyRegServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    get(personId: number): Observable<GetPsyRegPersonOutput> {
        let url_ = this.baseUrl + "/api/services/app/PsyReg/Get?";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined and cannot be null.");
        else
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPsyRegPersonOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPsyRegPersonOutput>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetPsyRegPersonOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPsyRegPersonOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getByGln(gln: string | undefined): Observable<GetPsyRegPersonOutput> {
        let url_ = this.baseUrl + "/api/services/app/PsyReg/GetByGln?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByGln(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByGln(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPsyRegPersonOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPsyRegPersonOutput>;
        }));
    }

    protected processGetByGln(response: HttpResponseBase): Observable<GetPsyRegPersonOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPsyRegPersonOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDetailed(personId: number): Observable<GetPsyRegPersonDetailedOutput> {
        let url_ = this.baseUrl + "/api/services/app/PsyReg/GetDetailed?";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined and cannot be null.");
        else
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPsyRegPersonDetailedOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPsyRegPersonDetailedOutput>;
        }));
    }

    protected processGetDetailed(response: HttpResponseBase): Observable<GetPsyRegPersonDetailedOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPsyRegPersonDetailedOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getDetailedByGln(gln: string | undefined): Observable<GetPsyRegPersonDetailedOutput> {
        let url_ = this.baseUrl + "/api/services/app/PsyReg/GetDetailedByGln?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailedByGln(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailedByGln(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPsyRegPersonDetailedOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPsyRegPersonDetailedOutput>;
        }));
    }

    protected processGetDetailedByGln(response: HttpResponseBase): Observable<GetPsyRegPersonDetailedOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPsyRegPersonDetailedOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    test(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PsyReg/Test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class QuarterlyReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param personLicenceId (optional) 
     * @return Success
     */
    getForPersonLicence(personLicenceId: number | undefined): Observable<GetQuartelyReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/QuarterlyReport/GetForPersonLicence?";
        if (personLicenceId === null)
            throw new Error("The parameter 'personLicenceId' cannot be null.");
        else if (personLicenceId !== undefined)
            url_ += "personLicenceId=" + encodeURIComponent("" + personLicenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForPersonLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForPersonLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetQuartelyReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetQuartelyReportDto[]>;
        }));
    }

    protected processGetForPersonLicence(response: HttpResponseBase): Observable<GetQuartelyReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetQuartelyReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RegionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param onlyActive (optional) 
     * @return Success
     */
    getAll(onlyActive: boolean | undefined): Observable<GetRegionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Region/GetAll?";
        if (onlyActive === null)
            throw new Error("The parameter 'onlyActive' cannot be null.");
        else if (onlyActive !== undefined)
            url_ += "onlyActive=" + encodeURIComponent("" + onlyActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRegionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRegionDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GetRegionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetRegionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReminderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: ReminderSearchInput | undefined): Observable<ReminderSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reminder/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReminderSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReminderSearchOutput>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ReminderSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReminderSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetReminderDto> {
        let url_ = this.baseUrl + "/api/services/app/Reminder/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReminderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReminderDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetReminderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReminderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param discriminator (optional) 
     * @param entityId (optional) 
     * @param body (optional) 
     * @return Success
     */
    create(discriminator: ReminderType | undefined, entityId: number | undefined, body: CreateOrUpdateReminderDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Reminder/Create?";
        if (discriminator === null)
            throw new Error("The parameter 'discriminator' cannot be null.");
        else if (discriminator !== undefined)
            url_ += "discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(id: number | undefined, body: CreateOrUpdateReminderDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reminder/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reminder/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RequirementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RequirementDto> {
        let url_ = this.baseUrl + "/api/services/app/Requirement/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequirementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequirementDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RequirementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequirementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateProfessionRequirementInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Requirement/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Requirement/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param professionId (optional) 
     * @param typeId (optional) 
     * @return Success
     */
    getRequirementByProfessionAndType(professionId: string | undefined, typeId: RequirementType | undefined): Observable<RequirementDto> {
        let url_ = this.baseUrl + "/api/services/app/Requirement/GetRequirementByProfessionAndType?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (typeId === null)
            throw new Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequirementByProfessionAndType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequirementByProfessionAndType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequirementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequirementDto>;
        }));
    }

    protected processGetRequirementByProfessionAndType(response: HttpResponseBase): Observable<RequirementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequirementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dummy(body: AtLeastOnePresent | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Requirement/Dummy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDummy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDummy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDummy(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dummy2(body: AtLeastOneEmploymentDefined | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Requirement/Dummy2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDummy2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDummy2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDummy2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dummy3(body: ProfessionLiaEmploymentRequirementType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Requirement/Dummy3";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDummy3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDummy3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDummy3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dummy4(body: ProfessionLiaInvoiceAddressRequirementType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Requirement/Dummy4";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDummy4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDummy4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDummy4(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RequirementGroupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param discriminator (optional) 
     * @param professionIdOrSponsorshipTypeId (optional) 
     * @return Success
     */
    getRequirementGroups(discriminator: RequirementGroupDiscriminator | undefined, professionIdOrSponsorshipTypeId: string | undefined): Observable<GetRequirementGroupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RequirementGroup/GetRequirementGroups?";
        if (discriminator === null)
            throw new Error("The parameter 'discriminator' cannot be null.");
        else if (discriminator !== undefined)
            url_ += "discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (professionIdOrSponsorshipTypeId === null)
            throw new Error("The parameter 'professionIdOrSponsorshipTypeId' cannot be null.");
        else if (professionIdOrSponsorshipTypeId !== undefined)
            url_ += "professionIdOrSponsorshipTypeId=" + encodeURIComponent("" + professionIdOrSponsorshipTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequirementGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequirementGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRequirementGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRequirementGroupDto[]>;
        }));
    }

    protected processGetRequirementGroups(response: HttpResponseBase): Observable<GetRequirementGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetRequirementGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetRequirementGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/RequirementGroup/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRequirementGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRequirementGroupDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetRequirementGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRequirementGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRequirementGroup(body: CreateRequirementGroupDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/RequirementGroup/CreateRequirementGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRequirementGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRequirementGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateRequirementGroup(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateRequirementGroup(id: number | undefined, body: UpdateRequirementGroupDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequirementGroup/UpdateRequirementGroup?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRequirementGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRequirementGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRequirementGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupId (optional) 
     * @return Success
     */
    delete(groupId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequirementGroup/Delete?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param alternativeId (optional) 
     * @return Success
     */
    getAlternative(alternativeId: number | undefined): Observable<RequirementAlternativeDto> {
        let url_ = this.baseUrl + "/api/services/app/RequirementGroup/GetAlternative?";
        if (alternativeId === null)
            throw new Error("The parameter 'alternativeId' cannot be null.");
        else if (alternativeId !== undefined)
            url_ += "alternativeId=" + encodeURIComponent("" + alternativeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlternative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlternative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequirementAlternativeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequirementAlternativeDto>;
        }));
    }

    protected processGetAlternative(response: HttpResponseBase): Observable<RequirementAlternativeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequirementAlternativeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupId (optional) 
     * @return Success
     */
    createAlternative(groupId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/RequirementGroup/CreateAlternative?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAlternative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAlternative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateAlternative(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param alternativeId (optional) 
     * @return Success
     */
    deleteAlternative(alternativeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequirementGroup/DeleteAlternative?";
        if (alternativeId === null)
            throw new Error("The parameter 'alternativeId' cannot be null.");
        else if (alternativeId !== undefined)
            url_ += "alternativeId=" + encodeURIComponent("" + alternativeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAlternative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAlternative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAlternative(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RestrictionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetRestrictionDto> {
        let url_ = this.baseUrl + "/api/services/app/Restriction/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRestrictionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRestrictionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetRestrictionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRestrictionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    post(body: CreateRestrictionDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Restriction/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    put(id: number | undefined, body: UpdateRestrictionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Restriction/Put?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRla(body: CreateRlaInput | undefined): Observable<CreateRlaOutput> {
        let url_ = this.baseUrl + "/api/services/app/Rla/CreateRla";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateRlaOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateRlaOutput>;
        }));
    }

    protected processCreateRla(response: HttpResponseBase): Observable<CreateRlaOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateRlaOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyRlas(): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Rla/GetMyRlas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyRlas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyRlas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetMyRlas(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNextStatus(caseId: string, status: RlaStatus): Observable<RlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/Rla/GetNextStatus?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<RlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getRlasForPerson(gln: string | undefined): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Rla/GetRlasForPerson?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRlasForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRlasForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetRlasForPerson(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getLicenceForRla(caseId: string | undefined): Observable<ProfessionalLicenceDto> {
        let url_ = this.baseUrl + "/api/services/app/Rla/GetLicenceForRla?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicenceForRla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicenceForRla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionalLicenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionalLicenceDto>;
        }));
    }

    protected processGetLicenceForRla(response: HttpResponseBase): Observable<ProfessionalLicenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionalLicenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getRla(caseId: string | undefined): Observable<GetRlaOutput> {
        let url_ = this.baseUrl + "/api/services/app/Rla/GetRla?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRlaOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRlaOutput>;
        }));
    }

    protected processGetRla(response: HttpResponseBase): Observable<GetRlaOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRlaOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseRla(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Rla/ReleaseRla?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseRla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseRla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseRla(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Rla/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined): Observable<RlaStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/Rla/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<RlaStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaAcademicTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateRlaAcademicTitle(body: CreateOrUpdateRlaAcademicTitleInput | undefined): Observable<CreateOrUpdateRlaAcademicTitleOutput> {
        let url_ = this.baseUrl + "/api/services/app/RlaAcademicTitle/CreateOrUpdateRlaAcademicTitle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRlaAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRlaAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateRlaAcademicTitleOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateRlaAcademicTitleOutput>;
        }));
    }

    protected processCreateOrUpdateRlaAcademicTitle(response: HttpResponseBase): Observable<CreateOrUpdateRlaAcademicTitleOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateRlaAcademicTitleOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createBlankRlaAcademicTitle(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/RlaAcademicTitle/CreateBlankRlaAcademicTitle?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBlankRlaAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBlankRlaAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateBlankRlaAcademicTitle(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param academicTitleId (optional) 
     * @return Success
     */
    deleteRlaAcademicTitle(caseId: string | undefined, academicTitleId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RlaAcademicTitle/DeleteRlaAcademicTitle?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (academicTitleId === null)
            throw new Error("The parameter 'academicTitleId' cannot be null.");
        else if (academicTitleId !== undefined)
            url_ += "academicTitleId=" + encodeURIComponent("" + academicTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRlaAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRlaAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRlaAcademicTitle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @param hasImmigratedLastFiveYearsId (optional) 
     * @param hasLicenceInThisCanton (optional) 
     * @return Success
     */
    getRlaAcademicTitleFiles(caseId: string, step: RlaStatus | undefined, hasImmigratedLastFiveYearsId: string | undefined, hasLicenceInThisCanton: boolean | undefined): Observable<RlaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/RlaAcademicTitle/GetRlaAcademicTitleFiles?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (hasImmigratedLastFiveYearsId === null)
            throw new Error("The parameter 'hasImmigratedLastFiveYearsId' cannot be null.");
        else if (hasImmigratedLastFiveYearsId !== undefined)
            url_ += "HasImmigratedLastFiveYearsId=" + encodeURIComponent("" + hasImmigratedLastFiveYearsId) + "&";
        if (hasLicenceInThisCanton === null)
            throw new Error("The parameter 'hasLicenceInThisCanton' cannot be null.");
        else if (hasLicenceInThisCanton !== undefined)
            url_ += "HasLicenceInThisCanton=" + encodeURIComponent("" + hasLicenceInThisCanton) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRlaAcademicTitleFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRlaAcademicTitleFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaDocumentsOutput>;
        }));
    }

    protected processGetRlaAcademicTitleFiles(response: HttpResponseBase): Observable<RlaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RlaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param rlaAcademicTitleId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(rlaAcademicTitleId: string | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RlaAcademicTitle/UploadFiles?";
        if (rlaAcademicTitleId === null)
            throw new Error("The parameter 'rlaAcademicTitleId' cannot be null.");
        else if (rlaAcademicTitleId !== undefined)
            url_ += "rlaAcademicTitleId=" + encodeURIComponent("" + rlaAcademicTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaApplicantContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateRlaApplicantContact | undefined): Observable<RlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/RlaApplicantContact/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<RlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<RlaApplicantContactDto> {
        let url_ = this.baseUrl + "/api/services/app/RlaApplicantContact/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaApplicantContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaApplicantContactDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RlaApplicantContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RlaApplicantContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaApplicantPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param gln (optional) 
     * @return Success
     */
    performRegisterCheck(caseId: string | undefined, gln: string | undefined): Observable<RlaApplicantPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/RlaApplicantPerson/PerformRegisterCheck?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPerformRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPerformRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaApplicantPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaApplicantPersonDto>;
        }));
    }

    protected processPerformRegisterCheck(response: HttpResponseBase): Observable<RlaApplicantPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RlaApplicantPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    acceptRegisterCheck(caseId: string | undefined): Observable<RlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/RlaApplicantPerson/AcceptRegisterCheck?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaStatus>;
        }));
    }

    protected processAcceptRegisterCheck(response: HttpResponseBase): Observable<RlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<RlaApplicantPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/RlaApplicantPerson/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaApplicantPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaApplicantPersonDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RlaApplicantPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RlaApplicantPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaBusinessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: RlaBusinessDto[] | undefined): Observable<RlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/RlaBusiness/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<RlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getList(caseId: string | undefined): Observable<RlaBusinessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RlaBusiness/GetList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaBusinessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaBusinessDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<RlaBusinessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RlaBusinessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDocuments(body: GetRlaDocumentsInput | undefined): Observable<RlaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/RlaDocument/GetDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaDocumentsOutput>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<RlaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RlaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RlaDocument/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFile(body: GetRlaFileInput | undefined): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/RlaDocument/GetFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: RlaStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RlaDocument/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaEmploymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateRlaEmployment(caseId: string | undefined, body: RlaEmploymentDto | undefined): Observable<RlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/RlaEmployment/CreateOrUpdateRlaEmployment?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRlaEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRlaEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaStatus>;
        }));
    }

    protected processCreateOrUpdateRlaEmployment(response: HttpResponseBase): Observable<RlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaInvoiceAddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: RlaInvoiceAddressDto | undefined): Observable<RlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/RlaInvoiceAddress/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<RlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<GetRlaInvoiceAddressOutput> {
        let url_ = this.baseUrl + "/api/services/app/RlaInvoiceAddress/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRlaInvoiceAddressOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRlaInvoiceAddressOutput>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetRlaInvoiceAddressOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRlaInvoiceAddressOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaMedicalFieldDirectorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateRlaMedicalFieldDirector | undefined): Observable<RlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/RlaMedicalFieldDirector/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<RlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<RlaMedicalFieldDirectorDto> {
        let url_ = this.baseUrl + "/api/services/app/RlaMedicalFieldDirector/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaMedicalFieldDirectorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaMedicalFieldDirectorDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RlaMedicalFieldDirectorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RlaMedicalFieldDirectorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateRlaPerson | undefined): Observable<RlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/RlaPerson/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<RlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<RlaPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/RlaPerson/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaPersonDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RlaPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RlaPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaReplacementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: RlaReplacementDto | undefined): Observable<RlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/RlaReplacement/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<RlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<RlaReplacementDto> {
        let url_ = this.baseUrl + "/api/services/app/RlaReplacement/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaReplacementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaReplacementDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RlaReplacementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RlaReplacementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaRestrictionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateRlaRestrictions(body: CreateOrUpdateRlaRestrictionsInput | undefined): Observable<RlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/RlaRestrictions/CreateOrUpdateRlaRestrictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRlaRestrictions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRlaRestrictions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaStatus>;
        }));
    }

    protected processCreateOrUpdateRlaRestrictions(response: HttpResponseBase): Observable<RlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRoles(body: GetRolesInput | undefined): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfRoleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfRoleListDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateRole(body: CreateOrUpdateRoleInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteRole(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SapInvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: SearchInvoicesInput | undefined): Observable<SearchInvoicesOutput> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchInvoicesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchInvoicesOutput>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchInvoicesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchInvoicesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    exportToExcel(filter: string | undefined, sorting: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/ExportToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportToExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @return Success
     */
    get(invoiceId: number | undefined): Observable<SapInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/Get?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapInvoiceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SapInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param sponsorshipId (optional) 
     * @return Success
     */
    getEmpty(personId: number | undefined, sponsorshipId: number | undefined): Observable<SapInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/GetEmpty?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmpty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmpty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapInvoiceDto>;
        }));
    }

    protected processGetEmpty(response: HttpResponseBase): Observable<SapInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOrUpdateSapInvoiceDto | undefined): Observable<SapInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapInvoiceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SapInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(invoiceId: number | undefined, body: CreateOrUpdateSapInvoiceDto | undefined): Observable<SapInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/Update?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapInvoiceDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SapInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @param cancellationReasonId (optional) 
     * @return Success
     */
    cancelInvoice(invoiceId: number | undefined, cancellationReasonId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CancelInvoice?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        if (cancellationReasonId === null)
            throw new Error("The parameter 'cancellationReasonId' cannot be null.");
        else if (cancellationReasonId !== undefined)
            url_ += "cancellationReasonId=" + encodeURIComponent("" + cancellationReasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @param reason (optional) 
     * @return Success
     */
    delete(invoiceId: number | undefined, reason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/Delete?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param measureId (optional) 
     * @return Success
     */
    createInvoiceForPersonDisciplinaryMeasures(measureId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CreateInvoiceForPersonDisciplinaryMeasures?";
        if (measureId === null)
            throw new Error("The parameter 'measureId' cannot be null.");
        else if (measureId !== undefined)
            url_ += "measureId=" + encodeURIComponent("" + measureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoiceForPersonDisciplinaryMeasures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoiceForPersonDisciplinaryMeasures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInvoiceForPersonDisciplinaryMeasures(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licenceId (optional) 
     * @return Success
     */
    createInvoiceForPersonLicence(licenceId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CreateInvoiceForPersonLicence?";
        if (licenceId === null)
            throw new Error("The parameter 'licenceId' cannot be null.");
        else if (licenceId !== undefined)
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoiceForPersonLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoiceForPersonLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInvoiceForPersonLicence(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licenceId (optional) 
     * @return Success
     */
    createInvoiceForPersonLicenceRenewal(licenceId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CreateInvoiceForPersonLicenceRenewal?";
        if (licenceId === null)
            throw new Error("The parameter 'licenceId' cannot be null.");
        else if (licenceId !== undefined)
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoiceForPersonLicenceRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoiceForPersonLicenceRenewal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInvoiceForPersonLicenceRenewal(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param narcoticPrescriptionBlockId (optional) 
     * @return Success
     */
    createInvoiceForNarcoticPrescriptionBlock(narcoticPrescriptionBlockId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CreateInvoiceForNarcoticPrescriptionBlock?";
        if (narcoticPrescriptionBlockId === null)
            throw new Error("The parameter 'narcoticPrescriptionBlockId' cannot be null.");
        else if (narcoticPrescriptionBlockId !== undefined)
            url_ += "narcoticPrescriptionBlockId=" + encodeURIComponent("" + narcoticPrescriptionBlockId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoiceForNarcoticPrescriptionBlock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoiceForNarcoticPrescriptionBlock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInvoiceForNarcoticPrescriptionBlock(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inspectionId (optional) 
     * @return Success
     */
    createInvoiceForInspection(inspectionId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CreateInvoiceForInspection?";
        if (inspectionId === null)
            throw new Error("The parameter 'inspectionId' cannot be null.");
        else if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoiceForInspection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoiceForInspection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInvoiceForInspection(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licenceId (optional) 
     * @return Success
     */
    createInvoiceForCorporateLicence(licenceId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CreateInvoiceForCorporateLicence?";
        if (licenceId === null)
            throw new Error("The parameter 'licenceId' cannot be null.");
        else if (licenceId !== undefined)
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoiceForCorporateLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoiceForCorporateLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInvoiceForCorporateLicence(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licenceId (optional) 
     * @return Success
     */
    createInvoiceForCorporateLicenceRenewal(licenceId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CreateInvoiceForCorporateLicenceRenewal?";
        if (licenceId === null)
            throw new Error("The parameter 'licenceId' cannot be null.");
        else if (licenceId !== undefined)
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoiceForCorporateLicenceRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoiceForCorporateLicenceRenewal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInvoiceForCorporateLicenceRenewal(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @return Success
     */
    releaseInvoice(invoiceId: number | undefined): Observable<SapInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/ReleaseInvoice?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapInvoiceDto>;
        }));
    }

    protected processReleaseInvoice(response: HttpResponseBase): Observable<SapInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchProducts(body: SearchProductsInput | undefined): Observable<SearchProductsOutput> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/SearchProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchProductsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchProductsOutput>;
        }));
    }

    protected processSearchProducts(response: HttpResponseBase): Observable<SearchProductsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchProductsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param onlyActive (optional) 
     * @return Success
     */
    getProducts(onlyActive: boolean | undefined): Observable<SapProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/GetProducts?";
        if (onlyActive === null)
            throw new Error("The parameter 'onlyActive' cannot be null.");
        else if (onlyActive !== undefined)
            url_ += "onlyActive=" + encodeURIComponent("" + onlyActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapProductDto[]>;
        }));
    }

    protected processGetProducts(response: HttpResponseBase): Observable<SapProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SapProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProduct(id: number | undefined): Observable<SapProductDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/GetProduct?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapProductDto>;
        }));
    }

    protected processGetProduct(response: HttpResponseBase): Observable<SapProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateProduct(body: SapProductDto | undefined): Observable<SapProductDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CreateOrUpdateProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapProductDto>;
        }));
    }

    protected processCreateOrUpdateProduct(response: HttpResponseBase): Observable<SapProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteProduct(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/DeleteProduct?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProduct(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchCancellationReasons(body: SearchCancellationReasonsInput | undefined): Observable<SearchCancellationReasonsOutput> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/SearchCancellationReasons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCancellationReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCancellationReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchCancellationReasonsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchCancellationReasonsOutput>;
        }));
    }

    protected processSearchCancellationReasons(response: HttpResponseBase): Observable<SearchCancellationReasonsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchCancellationReasonsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCancellationReasons(): Observable<SapCancellationReasonDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/GetCancellationReasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCancellationReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCancellationReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapCancellationReasonDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapCancellationReasonDto[]>;
        }));
    }

    protected processGetCancellationReasons(response: HttpResponseBase): Observable<SapCancellationReasonDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SapCancellationReasonDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCancellationReason(id: number | undefined): Observable<SapCancellationReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/GetCancellationReason?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCancellationReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCancellationReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapCancellationReasonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapCancellationReasonDto>;
        }));
    }

    protected processGetCancellationReason(response: HttpResponseBase): Observable<SapCancellationReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapCancellationReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateCancellationReason(body: SapCancellationReasonDto | undefined): Observable<SapCancellationReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CreateOrUpdateCancellationReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateCancellationReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateCancellationReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapCancellationReasonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapCancellationReasonDto>;
        }));
    }

    protected processCreateOrUpdateCancellationReason(response: HttpResponseBase): Observable<SapCancellationReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapCancellationReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteCancellationReason(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/DeleteCancellationReason?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCancellationReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCancellationReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCancellationReason(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchContactPersons(body: SearchContactPersonsInput | undefined): Observable<SearchContactPersonsOutput> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/SearchContactPersons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchContactPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchContactPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchContactPersonsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchContactPersonsOutput>;
        }));
    }

    protected processSearchContactPersons(response: HttpResponseBase): Observable<SearchContactPersonsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchContactPersonsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param onlyActive (optional) 
     * @return Success
     */
    getContactPersons(onlyActive: boolean | undefined): Observable<SapContactPersonDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/GetContactPersons?";
        if (onlyActive === null)
            throw new Error("The parameter 'onlyActive' cannot be null.");
        else if (onlyActive !== undefined)
            url_ += "onlyActive=" + encodeURIComponent("" + onlyActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapContactPersonDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapContactPersonDto[]>;
        }));
    }

    protected processGetContactPersons(response: HttpResponseBase): Observable<SapContactPersonDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SapContactPersonDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getContactPerson(id: number | undefined): Observable<SapContactPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/GetContactPerson?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapContactPersonDto>;
        }));
    }

    protected processGetContactPerson(response: HttpResponseBase): Observable<SapContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapContactPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateContactPerson(body: SapContactPersonDto | undefined): Observable<SapContactPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CreateOrUpdateContactPerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateContactPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateContactPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapContactPersonDto>;
        }));
    }

    protected processCreateOrUpdateContactPerson(response: HttpResponseBase): Observable<SapContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapContactPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteContactPerson(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/DeleteContactPerson?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteContactPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteContactPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteContactPerson(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SensitiveDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getHasOngoingLegalProceedingAndCreateIfNotExisting(discriminator: SensitiveDataDiscriminator, entityId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SensitiveData/GetHasOngoingLegalProceedingAndCreateIfNotExisting?";
        if (discriminator === undefined || discriminator === null)
            throw new Error("The parameter 'discriminator' must be defined and cannot be null.");
        else
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHasOngoingLegalProceedingAndCreateIfNotExisting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHasOngoingLegalProceedingAndCreateIfNotExisting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetHasOngoingLegalProceedingAndCreateIfNotExisting(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAndCreateIfNotExisting(discriminator: SensitiveDataDiscriminator, entityId: number): Observable<GetSensitiveDataDto> {
        let url_ = this.baseUrl + "/api/services/app/SensitiveData/GetAndCreateIfNotExisting?";
        if (discriminator === undefined || discriminator === null)
            throw new Error("The parameter 'discriminator' must be defined and cannot be null.");
        else
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAndCreateIfNotExisting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAndCreateIfNotExisting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSensitiveDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSensitiveDataDto>;
        }));
    }

    protected processGetAndCreateIfNotExisting(response: HttpResponseBase): Observable<GetSensitiveDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSensitiveDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSensitiveData(discriminator: SensitiveDataDiscriminator, entityId: number, body: UpdateSensitiveDataDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SensitiveData/UpdateSensitiveData?";
        if (discriminator === undefined || discriminator === null)
            throw new Error("The parameter 'discriminator' must be defined and cannot be null.");
        else
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSensitiveData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSensitiveData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSensitiveData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getRecords(id_Discriminator: SensitiveDataDiscriminator, id_EntityId: number, recordDiscriminator: SensitiveDataRecordDiscriminator, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetSensitiveDataSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/SensitiveData/GetRecords?";
        if (id_Discriminator === undefined || id_Discriminator === null)
            throw new Error("The parameter 'id_Discriminator' must be defined and cannot be null.");
        else
            url_ += "Id.Discriminator=" + encodeURIComponent("" + id_Discriminator) + "&";
        if (id_EntityId === undefined || id_EntityId === null)
            throw new Error("The parameter 'id_EntityId' must be defined and cannot be null.");
        else
            url_ += "Id.EntityId=" + encodeURIComponent("" + id_EntityId) + "&";
        if (recordDiscriminator === undefined || recordDiscriminator === null)
            throw new Error("The parameter 'recordDiscriminator' must be defined and cannot be null.");
        else
            url_ += "RecordDiscriminator=" + encodeURIComponent("" + recordDiscriminator) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSensitiveDataSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSensitiveDataSearchOutputDto>;
        }));
    }

    protected processGetRecords(response: HttpResponseBase): Observable<GetSensitiveDataSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSensitiveDataSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRecord(id: number | undefined): Observable<GetSensitiveDataRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/SensitiveData/GetRecord?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSensitiveDataRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSensitiveDataRecordDto>;
        }));
    }

    protected processGetRecord(response: HttpResponseBase): Observable<GetSensitiveDataRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSensitiveDataRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRecord(discriminator: SensitiveDataDiscriminator, entityId: number, body: CreateSensitiveDataRecordDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SensitiveData/CreateRecord?";
        if (discriminator === undefined || discriminator === null)
            throw new Error("The parameter 'discriminator' must be defined and cannot be null.");
        else
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateRecord(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateRecord(id: number | undefined, body: UpdateSensitiveDataRecordDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SensitiveData/UpdateRecord?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRecord(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param discriminator (optional) 
     * @param entityId (optional) 
     * @return Success
     */
    getRecordCount(discriminator: SensitiveDataDiscriminator | undefined, entityId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SensitiveData/GetRecordCount?";
        if (discriminator === null)
            throw new Error("The parameter 'discriminator' cannot be null.");
        else if (discriminator !== undefined)
            url_ += "discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecordCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecordCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetRecordCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSignInToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSignInToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateUserSignInTokenOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateUserSignInTokenOutput>;
        }));
    }

    protected processUpdateUserSignInToken(response: HttpResponseBase): Observable<UpdateUserSignInTokenOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserSignInTokenOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlapServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSlap(body: CreateSlapInput | undefined): Observable<CreateSlapOutput> {
        let url_ = this.baseUrl + "/api/services/app/Slap/CreateSlap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSlap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSlap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSlapOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSlapOutput>;
        }));
    }

    protected processCreateSlap(response: HttpResponseBase): Observable<CreateSlapOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSlapOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMySlaps(): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Slap/GetMySlaps";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMySlaps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMySlaps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetMySlaps(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNextStatus(caseId: string, status: SlapStatus): Observable<SlapStatus> {
        let url_ = this.baseUrl + "/api/services/app/Slap/GetNextStatus?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<SlapStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getSlapsForPerson(gln: string | undefined): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Slap/GetSlapsForPerson?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSlapsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSlapsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetSlapsForPerson(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getProfessionalLicencePersonIdForSlap(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Slap/getProfessionalLicencePersonIdForSlap?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalLicencePersonIdForSlap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalLicencePersonIdForSlap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetProfessionalLicencePersonIdForSlap(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getSlap(caseId: string | undefined): Observable<GetSlapOutput> {
        let url_ = this.baseUrl + "/api/services/app/Slap/GetSlap?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSlap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSlap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSlapOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSlapOutput>;
        }));
    }

    protected processGetSlap(response: HttpResponseBase): Observable<GetSlapOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSlapOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseSlap(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Slap/ReleaseSlap?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseSlap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseSlap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseSlap(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Slap/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined): Observable<SlapStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/Slap/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<SlapStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlapBusinessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateSlapBusiness | undefined): Observable<SlapStatus> {
        let url_ = this.baseUrl + "/api/services/app/SlapBusiness/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<SlapStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getList(caseId: string | undefined): Observable<SlapBusinessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SlapBusiness/GetList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapBusinessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapBusinessDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<SlapBusinessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SlapBusinessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param id (optional) 
     * @return Success
     */
    removeBusiness(caseId: string | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SlapBusiness/RemoveBusiness?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveBusiness(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlapContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateSlapContact | undefined): Observable<SlapStatus> {
        let url_ = this.baseUrl + "/api/services/app/SlapContact/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<SlapStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<SlapContactDto> {
        let url_ = this.baseUrl + "/api/services/app/SlapContact/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapContactDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SlapContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlapContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlapDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDocuments(body: GetSlapDocumentsInput | undefined): Observable<SlapDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/SlapDocument/GetDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapDocumentsOutput>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<SlapDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlapDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SlapDocument/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFile(body: GetSlapFileInput | undefined): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SlapDocument/GetFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: SlapStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SlapDocument/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlapInvoiceAddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: SlapInvoiceAddressDto | undefined): Observable<SlapStatus> {
        let url_ = this.baseUrl + "/api/services/app/SlapInvoiceAddress/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<SlapStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<GetSlapInvoiceAddressOutput> {
        let url_ = this.baseUrl + "/api/services/app/SlapInvoiceAddress/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSlapInvoiceAddressOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSlapInvoiceAddressOutput>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetSlapInvoiceAddressOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSlapInvoiceAddressOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlapPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    performRegisterCheck(caseId: string | undefined): Observable<SlapPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/SlapPerson/PerformRegisterCheck?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPerformRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPerformRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapPersonDto>;
        }));
    }

    protected processPerformRegisterCheck(response: HttpResponseBase): Observable<SlapPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlapPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    acceptRegisterCheck(caseId: string | undefined): Observable<SlapStatus> {
        let url_ = this.baseUrl + "/api/services/app/SlapPerson/AcceptRegisterCheck?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatus>;
        }));
    }

    protected processAcceptRegisterCheck(response: HttpResponseBase): Observable<SlapStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<SlapPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/SlapPerson/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapPersonDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SlapPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlapPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlapProductPreparationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: SlapProductPreparationDto | undefined): Observable<SlapStatus> {
        let url_ = this.baseUrl + "/api/services/app/SlapProductPreparation/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<SlapStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<SlapProductPreparationDto> {
        let url_ = this.baseUrl + "/api/services/app/SlapProductPreparation/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapProductPreparationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapProductPreparationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SlapProductPreparationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlapProductPreparationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlapRangeOfProductsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: SlapRangeOfProductsDto | undefined): Observable<SlapStatus> {
        let url_ = this.baseUrl + "/api/services/app/SlapRangeOfProducts/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<SlapStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<SlapRangeOfProductsDto> {
        let url_ = this.baseUrl + "/api/services/app/SlapRangeOfProducts/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapRangeOfProductsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapRangeOfProductsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SlapRangeOfProductsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlapRangeOfProductsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlapResponsiblePersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param gln (optional) 
     * @return Success
     */
    performRegisterCheck(caseId: string | undefined, gln: string | undefined): Observable<SlapResponsiblePersonDto> {
        let url_ = this.baseUrl + "/api/services/app/SlapResponsiblePerson/PerformRegisterCheck?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPerformRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPerformRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapResponsiblePersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapResponsiblePersonDto>;
        }));
    }

    protected processPerformRegisterCheck(response: HttpResponseBase): Observable<SlapResponsiblePersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlapResponsiblePersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    acceptRegisterCheck(caseId: string | undefined, body: SlapResponsiblePersonDto | undefined): Observable<SlapStatus> {
        let url_ = this.baseUrl + "/api/services/app/SlapResponsiblePerson/AcceptRegisterCheck?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatus>;
        }));
    }

    protected processAcceptRegisterCheck(response: HttpResponseBase): Observable<SlapStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<SlapResponsiblePersonDto> {
        let url_ = this.baseUrl + "/api/services/app/SlapResponsiblePerson/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapResponsiblePersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapResponsiblePersonDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SlapResponsiblePersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlapResponsiblePersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateResponsiblePerson(caseId: string | undefined, body: SlapResponsiblePersonDto | undefined): Observable<SlapStatus> {
        let url_ = this.baseUrl + "/api/services/app/SlapResponsiblePerson/UpdateResponsiblePerson?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateResponsiblePerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateResponsiblePerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatus>;
        }));
    }

    protected processUpdateResponsiblePerson(response: HttpResponseBase): Observable<SlapStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlapStatusWizardStepServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param professionId (optional) 
     * @param applicationType (optional) 
     * @return Success
     */
    getAllByProfessionIdAndApplicationType(professionId: string | undefined, applicationType: ApplicationType | undefined): Observable<SlapStatusWizardStepDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SlapStatusWizardStep/GetAllByProfessionIdAndApplicationType?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (applicationType === null)
            throw new Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByProfessionIdAndApplicationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByProfessionIdAndApplicationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatusWizardStepDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatusWizardStepDto[]>;
        }));
    }

    protected processGetAllByProfessionIdAndApplicationType(response: HttpResponseBase): Observable<SlapStatusWizardStepDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SlapStatusWizardStepDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSlapStatusWizardStepInput | undefined): Observable<SlapStatusWizardStepDto> {
        let url_ = this.baseUrl + "/api/services/app/SlapStatusWizardStep/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatusWizardStepDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatusWizardStepDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SlapStatusWizardStepDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlapStatusWizardStepDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMany(body: UpdateSlapStatusWizardStepsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SlapStatusWizardStep/UpdateMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @param professionId (optional) 
     * @param applicationType (optional) 
     * @return Success
     */
    delete(step: number | undefined, professionId: string | undefined, applicationType: ApplicationType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SlapStatusWizardStep/Delete?";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (applicationType === null)
            throw new Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlasDrugProductionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getDrugProduction(caseId: string | undefined): Observable<ClaBusinessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SlasDrugProduction/GetDrugProduction?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDrugProduction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDrugProduction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaBusinessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaBusinessDto[]>;
        }));
    }

    protected processGetDrugProduction(response: HttpResponseBase): Observable<ClaBusinessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaBusinessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDrugProductionList(body: UpdateSlasDrugProductionInput | undefined): Observable<UpdateSlasDrugProductionOutput> {
        let url_ = this.baseUrl + "/api/services/app/SlasDrugProduction/UpdateDrugProductionList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDrugProductionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDrugProductionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateSlasDrugProductionOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateSlasDrugProductionOutput>;
        }));
    }

    protected processUpdateDrugProductionList(response: HttpResponseBase): Observable<UpdateSlasDrugProductionOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSlasDrugProductionOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlasDrugProductionThirdPartyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param drugProductionThirdPartyId (optional) 
     * @return Success
     */
    createPlaceholderDrugProductionThirdParty(caseId: string | undefined, drugProductionThirdPartyId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SlasDrugProductionThirdParty/CreatePlaceholderDrugProductionThirdParty?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (drugProductionThirdPartyId === null)
            throw new Error("The parameter 'drugProductionThirdPartyId' cannot be null.");
        else if (drugProductionThirdPartyId !== undefined)
            url_ += "drugProductionThirdPartyId=" + encodeURIComponent("" + drugProductionThirdPartyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderDrugProductionThirdParty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderDrugProductionThirdParty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderDrugProductionThirdParty(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDrugProductionThirdPartyList(body: UpdateSlasDrugProductionThirdPartyInput | undefined): Observable<UpdateSlasDrugProductionThirdPartyOutput> {
        let url_ = this.baseUrl + "/api/services/app/SlasDrugProductionThirdParty/UpdateDrugProductionThirdPartyList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDrugProductionThirdPartyList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDrugProductionThirdPartyList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateSlasDrugProductionThirdPartyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateSlasDrugProductionThirdPartyOutput>;
        }));
    }

    protected processUpdateDrugProductionThirdPartyList(response: HttpResponseBase): Observable<UpdateSlasDrugProductionThirdPartyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSlasDrugProductionThirdPartyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlasLocalDrugSalesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param rangeOfProductsId (optional) 
     * @return Success
     */
    createPlaceholderLocalDrugSales(caseId: string | undefined, rangeOfProductsId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SlasLocalDrugSales/CreatePlaceholderLocalDrugSales?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (rangeOfProductsId === null)
            throw new Error("The parameter 'rangeOfProductsId' cannot be null.");
        else if (rangeOfProductsId !== undefined)
            url_ += "rangeOfProductsId=" + encodeURIComponent("" + rangeOfProductsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderLocalDrugSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderLocalDrugSales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderLocalDrugSales(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLocalDrugSalesList(body: UpdateSlasLocalDrugSalesInput | undefined): Observable<UpdateSlasLocalDrugSalesOutput> {
        let url_ = this.baseUrl + "/api/services/app/SlasLocalDrugSales/UpdateLocalDrugSalesList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLocalDrugSalesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLocalDrugSalesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateSlasLocalDrugSalesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateSlasLocalDrugSalesOutput>;
        }));
    }

    protected processUpdateLocalDrugSalesList(response: HttpResponseBase): Observable<UpdateSlasLocalDrugSalesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSlasLocalDrugSalesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlasProductPreparationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param rangeOfProductsId (optional) 
     * @return Success
     */
    createPlaceholderProductPreparation(caseId: string | undefined, rangeOfProductsId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SlasProductPreparation/CreatePlaceholderProductPreparation?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (rangeOfProductsId === null)
            throw new Error("The parameter 'rangeOfProductsId' cannot be null.");
        else if (rangeOfProductsId !== undefined)
            url_ += "rangeOfProductsId=" + encodeURIComponent("" + rangeOfProductsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderProductPreparation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderProductPreparation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderProductPreparation(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProductPreparationList(body: UpdateSlasProductPreparationInput | undefined): Observable<UpdateSlasProductPreparationOutput> {
        let url_ = this.baseUrl + "/api/services/app/SlasProductPreparation/UpdateProductPreparationList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProductPreparationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductPreparationList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateSlasProductPreparationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateSlasProductPreparationOutput>;
        }));
    }

    protected processUpdateProductPreparationList(response: HttpResponseBase): Observable<UpdateSlasProductPreparationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSlasProductPreparationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlasRangeOfProductsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param rangeOfProductsId (optional) 
     * @return Success
     */
    createPlaceholderRangeOfProducts(caseId: string | undefined, rangeOfProductsId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SlasRangeOfProducts/CreatePlaceholderRangeOfProducts?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (rangeOfProductsId === null)
            throw new Error("The parameter 'rangeOfProductsId' cannot be null.");
        else if (rangeOfProductsId !== undefined)
            url_ += "rangeOfProductsId=" + encodeURIComponent("" + rangeOfProductsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderRangeOfProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderRangeOfProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderRangeOfProducts(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRangeOfProductsList(body: UpdateSlasRangeOfProductsInput | undefined): Observable<UpdateSlasRangeOfProductsOutput> {
        let url_ = this.baseUrl + "/api/services/app/SlasRangeOfProducts/UpdateRangeOfProductsList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRangeOfProductsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRangeOfProductsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateSlasRangeOfProductsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateSlasRangeOfProductsOutput>;
        }));
    }

    protected processUpdateRangeOfProductsList(response: HttpResponseBase): Observable<UpdateSlasRangeOfProductsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSlasRangeOfProductsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SplServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSpl(body: CreateSplInput | undefined): Observable<CreateSplOutput> {
        let url_ = this.baseUrl + "/api/services/app/Spl/CreateSpl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSpl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSpl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSplOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSplOutput>;
        }));
    }

    protected processCreateSpl(response: HttpResponseBase): Observable<CreateSplOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSplOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMySpls(): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Spl/GetMySpls";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMySpls(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMySpls(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetMySpls(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNextStatus(caseId: string, status: SplStatus): Observable<SplStatus> {
        let url_ = this.baseUrl + "/api/services/app/Spl/GetNextStatus?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<SplStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getSplsForPerson(gln: string | undefined): Observable<PersonApplicationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Spl/GetSplsForPerson?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSplsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSplsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonApplicationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonApplicationSummaryDto[]>;
        }));
    }

    protected processGetSplsForPerson(response: HttpResponseBase): Observable<PersonApplicationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonApplicationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getProfessionalLicencePersonIdForSpl(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Spl/GetProfessionalLicencePersonIdForSpl?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalLicencePersonIdForSpl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalLicencePersonIdForSpl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetProfessionalLicencePersonIdForSpl(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getSpl(caseId: string | undefined): Observable<GetSplOutput> {
        let url_ = this.baseUrl + "/api/services/app/Spl/GetSpl?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSplOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSplOutput>;
        }));
    }

    protected processGetSpl(response: HttpResponseBase): Observable<GetSplOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSplOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseSpl(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Spl/ReleaseSpl?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseSpl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseSpl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseSpl(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Spl/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined): Observable<SplStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/Spl/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<SplStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SplDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDocuments(body: GetSplDocumentsInput | undefined): Observable<SplDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/SplDocument/GetDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplDocumentsOutput>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<SplDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SplDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SplDocument/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFile(body: GetSplFileInput | undefined): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SplDocument/GetFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: SplStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SplDocument/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SplNarcoticKnowledgeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: SplNarcoticKnowledgeDto | undefined): Observable<SplStatus> {
        let url_ = this.baseUrl + "/api/services/app/SplNarcoticKnowledge/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<SplStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<SplNarcoticKnowledgeDto> {
        let url_ = this.baseUrl + "/api/services/app/SplNarcoticKnowledge/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplNarcoticKnowledgeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplNarcoticKnowledgeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SplNarcoticKnowledgeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SplNarcoticKnowledgeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SplPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: SplPersonDto | undefined): Observable<SplStatus> {
        let url_ = this.baseUrl + "/api/services/app/SplPerson/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<SplStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<SplPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/SplPerson/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplPersonDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SplPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SplPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SplPostgraduateTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: CreateOrUpdateSplPostgraduateTitlesInput | undefined): Observable<SplStatus> {
        let url_ = this.baseUrl + "/api/services/app/SplPostgraduateTitle/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<SplStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<SplPostgraduateTitleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SplPostgraduateTitle/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplPostgraduateTitleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplPostgraduateTitleDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SplPostgraduateTitleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SplPostgraduateTitleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SponsorshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param isArchived (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getDossiers(isArchived: boolean | undefined, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetSponsorshipDossierSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/GetDossiers?";
        if (isArchived === null)
            throw new Error("The parameter 'isArchived' cannot be null.");
        else if (isArchived !== undefined)
            url_ += "IsArchived=" + encodeURIComponent("" + isArchived) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDossiers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDossiers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSponsorshipDossierSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSponsorshipDossierSearchOutput>;
        }));
    }

    protected processGetDossiers(response: HttpResponseBase): Observable<GetSponsorshipDossierSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSponsorshipDossierSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @return Success
     */
    getSponsorship(sponsorshipId: number | undefined): Observable<GetSponsorshipDto> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/GetSponsorship?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSponsorshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSponsorshipDto>;
        }));
    }

    protected processGetSponsorship(response: HttpResponseBase): Observable<GetSponsorshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSponsorshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<SponsorshipDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SponsorshipDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SponsorshipDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SponsorshipDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SponsorshipDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOrUpdateSponsorshipDto | undefined): Observable<SponsorshipDto> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SponsorshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SponsorshipDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SponsorshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SponsorshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param uid (optional) 
     * @param email (optional) 
     * @param phone (optional) 
     * @return Success
     */
    createSponsorshipFromUidRegisterInfo(uid: string | undefined, email: string | undefined, phone: string | undefined): Observable<SponsorshipDto> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/CreateSponsorshipFromUidRegisterInfo?";
        if (uid === null)
            throw new Error("The parameter 'uid' cannot be null.");
        else if (uid !== undefined)
            url_ += "uid=" + encodeURIComponent("" + uid) + "&";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (phone === null)
            throw new Error("The parameter 'phone' cannot be null.");
        else if (phone !== undefined)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSponsorshipFromUidRegisterInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSponsorshipFromUidRegisterInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SponsorshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SponsorshipDto>;
        }));
    }

    protected processCreateSponsorshipFromUidRegisterInfo(response: HttpResponseBase): Observable<SponsorshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SponsorshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CreateOrUpdateSponsorshipDto | undefined): Observable<GetSponsorshipDto> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSponsorshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSponsorshipDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<GetSponsorshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSponsorshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param isArchived (optional) 
     * @return Success
     */
    setArchiveFlag(id: number | undefined, isArchived: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/SetArchiveFlag?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isArchived === null)
            throw new Error("The parameter 'isArchived' cannot be null.");
        else if (isArchived !== undefined)
            url_ += "isArchived=" + encodeURIComponent("" + isArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetArchiveFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetArchiveFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetArchiveFlag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @return Success
     */
    getInvoiceAddress(sponsorshipId: number | undefined): Observable<SponsorshipInvoiceAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/GetInvoiceAddress?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SponsorshipInvoiceAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SponsorshipInvoiceAddressDto>;
        }));
    }

    protected processGetInvoiceAddress(response: HttpResponseBase): Observable<SponsorshipInvoiceAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SponsorshipInvoiceAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateInvoiceAddress(sponsorshipId: number | undefined, body: SponsorshipInvoiceAddressDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/UpdateInvoiceAddress?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInvoiceAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInvoiceAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInvoiceAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SponsorshipApplicationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getSponsorshipApplications(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetSponsorshipApplicationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/SponsorshipApplication/GetSponsorshipApplications?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorshipApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorshipApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSponsorshipApplicationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSponsorshipApplicationsOutput>;
        }));
    }

    protected processGetSponsorshipApplications(response: HttpResponseBase): Observable<GetSponsorshipApplicationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSponsorshipApplicationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getApplicationTypes(): Observable<ApplicationType[]> {
        let url_ = this.baseUrl + "/api/services/app/SponsorshipApplication/GetApplicationTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationType[]>;
        }));
    }

    protected processGetApplicationTypes(response: HttpResponseBase): Observable<ApplicationType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SponsorshipTypeRegisterAffiliationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getAllActiveAsString(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/SponsorshipTypeRegisterAffiliation/GetAllActiveAsString";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActiveAsString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActiveAsString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllActiveAsString(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllActiveForOlaAsString(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/SponsorshipTypeRegisterAffiliation/GetAllActiveForOlaAsString";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActiveForOlaAsString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActiveForOlaAsString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllActiveForOlaAsString(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllActiveForNlaAsString(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/SponsorshipTypeRegisterAffiliation/GetAllActiveForNlaAsString";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActiveForNlaAsString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActiveForNlaAsString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllActiveForNlaAsString(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllActiveForBlaAsString(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/SponsorshipTypeRegisterAffiliation/GetAllActiveForBlaAsString";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActiveForBlaAsString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActiveForBlaAsString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllActiveForBlaAsString(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllActiveForClaEhcAsString(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/SponsorshipTypeRegisterAffiliation/GetAllActiveForClaEhcAsString";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActiveForClaEhcAsString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActiveForClaEhcAsString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllActiveForClaEhcAsString(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllActiveForAlasAsString(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/SponsorshipTypeRegisterAffiliation/GetAllActiveForAlasAsString";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActiveForAlasAsString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActiveForAlasAsString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllActiveForAlasAsString(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipTypeId (optional) 
     * @return Success
     */
    isEligibleForEhc(sponsorshipTypeId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SponsorshipTypeRegisterAffiliation/IsEligibleForEhc?";
        if (sponsorshipTypeId === null)
            throw new Error("The parameter 'sponsorshipTypeId' cannot be null.");
        else if (sponsorshipTypeId !== undefined)
            url_ += "sponsorshipTypeId=" + encodeURIComponent("" + sponsorshipTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsEligibleForEhc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsEligibleForEhc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsEligibleForEhc(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipTypeId (optional) 
     * @return Success
     */
    get(sponsorshipTypeId: string | undefined): Observable<SponsorshipTypeRegisterAffiliationDto> {
        let url_ = this.baseUrl + "/api/services/app/SponsorshipTypeRegisterAffiliation/Get?";
        if (sponsorshipTypeId === null)
            throw new Error("The parameter 'sponsorshipTypeId' cannot be null.");
        else if (sponsorshipTypeId !== undefined)
            url_ += "sponsorshipTypeId=" + encodeURIComponent("" + sponsorshipTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SponsorshipTypeRegisterAffiliationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SponsorshipTypeRegisterAffiliationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SponsorshipTypeRegisterAffiliationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SponsorshipTypeRegisterAffiliationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<SponsorshipTypeRegisterAffiliationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SponsorshipTypeRegisterAffiliation/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SponsorshipTypeRegisterAffiliationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SponsorshipTypeRegisterAffiliationDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SponsorshipTypeRegisterAffiliationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SponsorshipTypeRegisterAffiliationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: SponsorshipTypeRegisterAffiliationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SponsorshipTypeRegisterAffiliation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    exportGlobalProfessionConfiguration(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SponsorshipTypeRegisterAffiliation/ExportGlobalProfessionConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportGlobalProfessionConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportGlobalProfessionConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportGlobalProfessionConfiguration(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    importGlobalProfessionConfiguration(body: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SponsorshipTypeRegisterAffiliation/ImportGlobalProfessionConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportGlobalProfessionConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportGlobalProfessionConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportGlobalProfessionConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SqlQueryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getQueries(categoryId: string): Observable<GetSqlQueryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SqlQuery/GetQueries?";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined and cannot be null.");
        else
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQueries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQueries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSqlQueryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSqlQueryDto[]>;
        }));
    }

    protected processGetQueries(response: HttpResponseBase): Observable<GetSqlQueryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetSqlQueryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    runQuery(id: number, body: { [key: string]: any; } | undefined): Observable<RunSqlQueryResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SqlQuery/RunQuery?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RunSqlQueryResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RunSqlQueryResultDto>;
        }));
    }

    protected processRunQuery(response: HttpResponseBase): Observable<RunSqlQueryResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RunSqlQueryResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    runQueryAndExportToExcel(id: number, body: { [key: string]: any; } | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SqlQuery/RunQueryAndExportToExcel?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunQueryAndExportToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunQueryAndExportToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRunQueryAndExportToExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    runQueryAndExportToCsv(id: number, body: { [key: string]: any; } | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SqlQuery/RunQueryAndExportToCsv?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunQueryAndExportToCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunQueryAndExportToCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRunQueryAndExportToCsv(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SqlQueryAdministrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: GetSqlQuerySearchInput | undefined): Observable<GetSqlQuerySearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/SqlQueryAdministration/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSqlQuerySearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSqlQuerySearchOutput>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<GetSqlQuerySearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSqlQuerySearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SqlQueryDto> {
        let url_ = this.baseUrl + "/api/services/app/SqlQueryAdministration/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SqlQueryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SqlQueryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SqlQueryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SqlQueryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: SqlQueryDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SqlQueryAdministration/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(id: number | undefined, body: SqlQueryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SqlQueryAdministration/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SqlQueryAdministration/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    analyseQuery(body: string | undefined): Observable<SqlQueryAnalyseResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SqlQueryAdministration/AnalyseQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAnalyseQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAnalyseQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SqlQueryAnalyseResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SqlQueryAnalyseResultDto>;
        }));
    }

    protected processAnalyseQuery(response: HttpResponseBase): Observable<SqlQueryAnalyseResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SqlQueryAnalyseResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SqlQueryEnumServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getEnums(): Observable<SqlQueryEnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SqlQueryEnum/GetEnums";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnums(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnums(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SqlQueryEnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SqlQueryEnumDto[]>;
        }));
    }

    protected processGetEnums(response: HttpResponseBase): Observable<SqlQueryEnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SqlQueryEnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    disableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/DisableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableRecurringPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    enableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/EnableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableRecurringPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param filter (optional) 
     * @param subscriptionEndDateStart (optional) 
     * @param subscriptionEndDateEnd (optional) 
     * @param creationDateStart (optional) 
     * @param creationDateEnd (optional) 
     * @param editionId (optional) 
     * @param editionIdSpecified (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getTenants(filter: string | undefined, subscriptionEndDateStart: DateTime | undefined, subscriptionEndDateEnd: DateTime | undefined, creationDateStart: DateTime | undefined, creationDateEnd: DateTime | undefined, editionId: number | undefined, editionIdSpecified: boolean | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfTenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (subscriptionEndDateStart === null)
            throw new Error("The parameter 'subscriptionEndDateStart' cannot be null.");
        else if (subscriptionEndDateStart !== undefined)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toString() : "") + "&";
        if (subscriptionEndDateEnd === null)
            throw new Error("The parameter 'subscriptionEndDateEnd' cannot be null.");
        else if (subscriptionEndDateEnd !== undefined)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toString() : "") + "&";
        if (creationDateStart === null)
            throw new Error("The parameter 'creationDateStart' cannot be null.");
        else if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toString() : "") + "&";
        if (creationDateEnd === null)
            throw new Error("The parameter 'creationDateEnd' cannot be null.");
        else if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toString() : "") + "&";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&";
        if (editionIdSpecified === null)
            throw new Error("The parameter 'editionIdSpecified' cannot be null.");
        else if (editionIdSpecified !== undefined)
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTenantListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTenantListDto>;
        }));
    }

    protected processGetTenants(response: HttpResponseBase): Observable<PagedResultDtoOfTenantListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTenantListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTenant(body: CreateTenantInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantForEdit(id: number | undefined): Observable<TenantEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantEditDto>;
        }));
    }

    protected processGetTenantForEdit(response: HttpResponseBase): Observable<TenantEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenant(body: TenantEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTenant(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantFeaturesForEdit(id: number | undefined): Observable<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantFeaturesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantFeaturesForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenantFeaturesEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenantFeaturesEditOutput>;
        }));
    }

    protected processGetTenantFeaturesForEdit(response: HttpResponseBase): Observable<GetTenantFeaturesEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTenantFeaturesEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenantFeatures(body: UpdateTenantFeaturesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenantFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenantFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenantFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetTenantSpecificFeatures(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetTenantSpecificFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetTenantSpecificFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetTenantSpecificFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlockTenantAdmin(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockTenantAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockTenantAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockTenantAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantCustomizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param tenantId (optional) 
     * @param extension (optional) 
     * @return Success
     */
    getTenantLogo(skin: string, tenantId: number | undefined, extension: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/TenantCustomization/GetTenantLogo/{skin}/{tenantId}/{extension}?";
        if (skin === undefined || skin === null)
            throw new Error("The parameter 'skin' must be defined.");
        url_ = url_.replace("{skin}", encodeURIComponent("" + skin));
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (extension === null)
            throw new Error("The parameter 'extension' cannot be null.");
        else if (extension !== undefined)
            url_ += "extension=" + encodeURIComponent("" + extension) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetTenantLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantIdCookieServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    setTenantIdCookie(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TenantIdCookie/SetTenantIdCookie?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetTenantIdCookie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetTenantIdCookie(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetTenantIdCookie(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantRegistrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerTenant(body: RegisterTenantInput | undefined): Observable<RegisterTenantOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterTenantOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterTenantOutput>;
        }));
    }

    protected processRegisterTenant(response: HttpResponseBase): Observable<RegisterTenantOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterTenantOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEditionsForSelect(): Observable<EditionsSelectOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionsSelectOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionsSelectOutput>;
        }));
    }

    protected processGetEditionsForSelect(response: HttpResponseBase): Observable<EditionsSelectOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionsSelectOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    getEdition(editionId: number | undefined): Observable<EditionSelectDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionSelectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionSelectDto>;
        }));
    }

    protected processGetEdition(response: HttpResponseBase): Observable<EditionSelectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionSelectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantSettingsEditDto>;
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<TenantSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllSettings(body: TenantSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    clearLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    clearEmailLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearEmailLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearEmailLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearEmailLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearEmailLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    clearCustomCss(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCustomCss(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCustomCss(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCustomCss(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEnabledSocialLoginSettings(): Observable<ExternalLoginSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetEnabledSocialLoginSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnabledSocialLoginSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnabledSocialLoginSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginSettingsDto>;
        }));
    }

    protected processGetEnabledSocialLoginSettings(response: HttpResponseBase): Observable<ExternalLoginSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalLoginSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param defaultTimezoneScope (optional) 
     * @return Success
     */
    getTimezones(defaultTimezoneScope: SettingScopes | undefined): Observable<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope === null)
            throw new Error("The parameter 'defaultTimezoneScope' cannot be null.");
        else if (defaultTimezoneScope !== undefined)
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfNameValueDto>;
        }));
    }

    protected processGetTimezones(response: HttpResponseBase): Observable<ListResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectedTimezoneId (optional) 
     * @return Success
     */
    getTimezoneComboboxItems(selectedTimezoneId: string | undefined): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId === null)
            throw new Error("The parameter 'selectedTimezoneId' cannot be null.");
        else if (selectedTimezoneId !== undefined)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezoneComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezoneComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetTimezoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param returnUrl (optional) 
     * @return Success
     */
    windowsAuthenticate(returnUrl: string | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/WindowsAuthenticate?";
        if (returnUrl === null)
            throw new Error("The parameter 'returnUrl' cannot be null.");
        else if (returnUrl !== undefined)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWindowsAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWindowsAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processWindowsAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param refreshToken (optional) 
     * @return Success
     */
    refreshToken(refreshToken: string | undefined): Observable<RefreshTokenResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/RefreshToken?";
        if (refreshToken === null)
            throw new Error("The parameter 'refreshToken' cannot be null.");
        else if (refreshToken !== undefined)
            url_ += "refreshToken=" + encodeURIComponent("" + refreshToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshTokenResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshTokenResult>;
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<RefreshTokenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    logOut(): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/LogOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTwoFactorAuthCode(body: SendTwoFactorAuthCodeModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTwoFactorAuthCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTwoFactorAuthCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTwoFactorAuthCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param impersonationToken (optional) 
     * @return Success
     */
    impersonatedAuthenticate(impersonationToken: string | undefined): Observable<RefreshTokenResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken === null)
            throw new Error("The parameter 'impersonationToken' cannot be null.");
        else if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonatedAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshTokenResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshTokenResult>;
        }));
    }

    protected processImpersonatedAuthenticate(response: HttpResponseBase): Observable<RefreshTokenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userDelegationId (optional) 
     * @param impersonationToken (optional) 
     * @return Success
     */
    delegatedImpersonatedAuthenticate(userDelegationId: number | undefined, impersonationToken: string | undefined): Observable<RefreshTokenResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/DelegatedImpersonatedAuthenticate?";
        if (userDelegationId === null)
            throw new Error("The parameter 'userDelegationId' cannot be null.");
        else if (userDelegationId !== undefined)
            url_ += "userDelegationId=" + encodeURIComponent("" + userDelegationId) + "&";
        if (impersonationToken === null)
            throw new Error("The parameter 'impersonationToken' cannot be null.");
        else if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegatedImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegatedImpersonatedAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshTokenResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshTokenResult>;
        }));
    }

    protected processDelegatedImpersonatedAuthenticate(response: HttpResponseBase): Observable<RefreshTokenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param switchAccountToken (optional) 
     * @return Success
     */
    linkedAccountAuthenticate(switchAccountToken: string | undefined): Observable<RefreshTokenResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken === null)
            throw new Error("The parameter 'switchAccountToken' cannot be null.");
        else if (switchAccountToken !== undefined)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkedAccountAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkedAccountAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshTokenResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshTokenResult>;
        }));
    }

    protected processLinkedAccountAuthenticate(response: HttpResponseBase): Observable<RefreshTokenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    isRefreshTokenAvailable(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/TokenAuth/IsRefreshTokenAvailable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsRefreshTokenAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsRefreshTokenAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsRefreshTokenAvailable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TraineePersonLicenceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param licenceId (optional) 
     * @return Success
     */
    getTraineeLicence(licenceId: number | undefined): Observable<TraineePersonLicenceDto> {
        let url_ = this.baseUrl + "/api/services/app/TraineePersonLicence/GetTraineeLicence?";
        if (licenceId === null)
            throw new Error("The parameter 'licenceId' cannot be null.");
        else if (licenceId !== undefined)
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTraineeLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTraineeLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TraineePersonLicenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TraineePersonLicenceDto>;
        }));
    }

    protected processGetTraineeLicence(response: HttpResponseBase): Observable<TraineePersonLicenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TraineePersonLicenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licenceId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(licenceId: number | undefined, body: TraineePersonLicenceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TraineePersonLicence/CreateOrUpdate?";
        if (licenceId === null)
            throw new Error("The parameter 'licenceId' cannot be null.");
        else if (licenceId !== undefined)
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TwitterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getRequestToken(): Observable<TwitterGetRequestTokenResponse> {
        let url_ = this.baseUrl + "/api/Twitter/GetRequestToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwitterGetRequestTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwitterGetRequestTokenResponse>;
        }));
    }

    protected processGetRequestToken(response: HttpResponseBase): Observable<TwitterGetRequestTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwitterGetRequestTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @param verifier (optional) 
     * @return Success
     */
    getAccessToken(token: string | undefined, verifier: string | undefined): Observable<TwitterGetAccessTokenResponse> {
        let url_ = this.baseUrl + "/api/Twitter/GetAccessToken?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (verifier === null)
            throw new Error("The parameter 'verifier' cannot be null.");
        else if (verifier !== undefined)
            url_ += "verifier=" + encodeURIComponent("" + verifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwitterGetAccessTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwitterGetAccessTokenResponse>;
        }));
    }

    protected processGetAccessToken(response: HttpResponseBase): Observable<TwitterGetAccessTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwitterGetAccessTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getUiManagementSettings(): Observable<ThemeSettingsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThemeSettingsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThemeSettingsDto[]>;
        }));
    }

    protected processGetUiManagementSettings(response: HttpResponseBase): Observable<ThemeSettingsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThemeSettingsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param themeName (optional) 
     * @return Success
     */
    changeThemeWithDefaultValues(themeName: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/ChangeThemeWithDefaultValues?";
        if (themeName === null)
            throw new Error("The parameter 'themeName' cannot be null.");
        else if (themeName !== undefined)
            url_ += "themeName=" + encodeURIComponent("" + themeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeThemeWithDefaultValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeThemeWithDefaultValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeThemeWithDefaultValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDefaultUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDefaultUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDefaultUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDefaultUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    useSystemDefaultSettings(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUseSystemDefaultSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUseSystemDefaultSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUseSystemDefaultSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isDarkModeActive (optional) 
     * @return Success
     */
    changeDarkModeOfCurrentTheme(isDarkModeActive: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/ChangeDarkModeOfCurrentTheme?";
        if (isDarkModeActive === null)
            throw new Error("The parameter 'isDarkModeActive' cannot be null.");
        else if (isDarkModeActive !== undefined)
            url_ += "isDarkModeActive=" + encodeURIComponent("" + isDarkModeActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeDarkModeOfCurrentTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeDarkModeOfCurrentTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeDarkModeOfCurrentTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UidRegisterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param uid (optional) 
     * @return Success
     */
    getUidEntityByUidNumberOrNull(uid: string | undefined): Observable<UidEntityDto> {
        let url_ = this.baseUrl + "/api/services/app/UidRegister/GetUidEntityByUidNumberOrNull?";
        if (uid === null)
            throw new Error("The parameter 'uid' cannot be null.");
        else if (uid !== undefined)
            url_ += "uid=" + encodeURIComponent("" + uid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUidEntityByUidNumberOrNull(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUidEntityByUidNumberOrNull(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UidEntityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UidEntityDto>;
        }));
    }

    protected processGetUidEntityByUidNumberOrNull(response: HttpResponseBase): Observable<UidEntityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UidEntityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUsers(body: GetUsersInput | undefined): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserListDto>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAuthorityApplicationLiaUsers(): Observable<GetUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAuthorityApplicationLiaUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorityApplicationLiaUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorityApplicationLiaUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserDto[]>;
        }));
    }

    protected processGetAuthorityApplicationLiaUsers(response: HttpResponseBase): Observable<GetUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUserList(): Observable<GetUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserDto[]>;
        }));
    }

    protected processGetUserList(response: HttpResponseBase): Observable<GetUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param permissions (optional) 
     * @param role (optional) 
     * @param onlyLockedUsers (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getUsersToExcel(filter: string | undefined, permissions: string[] | undefined, role: number | undefined, onlyLockedUsers: boolean | undefined, sorting: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permissions === null)
            throw new Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (onlyLockedUsers === null)
            throw new Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetUsersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserForShow(id: number | undefined): Observable<GetUserForShowOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForShow?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForShow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForShow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserForShowOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserForShowOutput>;
        }));
    }

    protected processGetUserForShow(response: HttpResponseBase): Observable<GetUserForShowOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserForShowOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserForEdit(id: number | undefined): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserForEditOutput>;
        }));
    }

    protected processGetUserForEdit(response: HttpResponseBase): Observable<GetUserForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param legitimationId (optional) 
     * @return Success
     */
    deleteLegitimationOfUser(userId: number | undefined, legitimationId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteLegitimationOfUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (legitimationId === null)
            throw new Error("The parameter 'legitimationId' cannot be null.");
        else if (legitimationId !== undefined)
            url_ += "legitimationId=" + encodeURIComponent("" + legitimationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLegitimationOfUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLegitimationOfUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLegitimationOfUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserPermissionsForEdit(id: number | undefined): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermissionsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissionsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserPermissionsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserPermissionsForEditOutput>;
        }));
    }

    protected processGetUserPermissionsForEdit(response: HttpResponseBase): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserPermissionsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetUserSpecificPermissions(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetUserSpecificPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserSpecificPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetUserSpecificPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserPermissions(body: UpdateUserPermissionsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateUser(body: CreateOrUpdateUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteUser(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlockUser(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserDelegationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getDelegatedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined): Observable<PagedResultDtoOfUserDelegationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/GetDelegatedUsers?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelegatedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelegatedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserDelegationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserDelegationDto>;
        }));
    }

    protected processGetDelegatedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserDelegationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserDelegationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    delegateNewUser(body: CreateUserDelegationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/DelegateNewUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegateNewUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegateNewUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelegateNewUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    removeDelegation(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/RemoveDelegation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveDelegation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDelegation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveDelegation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getActiveUserDelegations(): Observable<UserDelegationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/GetActiveUserDelegations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveUserDelegations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveUserDelegations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDelegationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDelegationDto[]>;
        }));
    }

    protected processGetActiveUserDelegations(response: HttpResponseBase): Observable<UserDelegationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDelegationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserLinkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    linkToUser(body: LinkToUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getLinkedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined): Observable<PagedResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLinkedUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLinkedUserDto>;
        }));
    }

    protected processGetLinkedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRecentlyUsedLinkedUsers(): Observable<ListResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentlyUsedLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyUsedLinkedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfLinkedUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfLinkedUserDto>;
        }));
    }

    protected processGetRecentlyUsedLinkedUsers(response: HttpResponseBase): Observable<ListResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlinkUser(body: UnlinkUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserLoginServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param filter (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param result (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getUserLoginAttempts(filter: string | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, result: AbpLoginResultType | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfUserLoginAttemptDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetUserLoginAttempts?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (result === null)
            throw new Error("The parameter 'result' cannot be null.");
        else if (result !== undefined)
            url_ += "Result=" + encodeURIComponent("" + result) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserLoginAttempts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLoginAttempts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserLoginAttemptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserLoginAttemptDto>;
        }));
    }

    protected processGetUserLoginAttempts(response: HttpResponseBase): Observable<PagedResultDtoOfUserLoginAttemptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserLoginAttemptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VisibilityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getVisibility(applicationType: ApplicationType, caseId: string): Observable<GetVisibilityOutput> {
        let url_ = this.baseUrl + "/api/services/app/Visibility/GetVisibility?";
        if (applicationType === undefined || applicationType === null)
            throw new Error("The parameter 'applicationType' must be defined and cannot be null.");
        else
            url_ += "ApplicationType=" + encodeURIComponent("" + applicationType) + "&";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVisibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVisibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetVisibilityOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetVisibilityOutput>;
        }));
    }

    protected processGetVisibility(response: HttpResponseBase): Observable<GetVisibilityOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetVisibilityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param key (optional) 
     * @return Success
     */
    getLatestWebLogs(key: string | undefined): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLatestWebLogsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLatestWebLogsOutput>;
        }));
    }

    protected processGetLatestWebLogs(response: HttpResponseBase): Observable<GetLatestWebLogsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLatestWebLogsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processDownloadWebLogs(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ComboboxItemDto implements IComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class EntityDto implements IEntityDto {
    id!: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDto {
    id: number;
}

export class NameValueDto implements INameValueDto {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export class TwitterGetAccessTokenResponse implements ITwitterGetAccessTokenResponse {
    accessToken!: string | undefined;
    accessTokenSecret!: string | undefined;
    userId!: string | undefined;
    userName!: string | undefined;

    constructor(data?: ITwitterGetAccessTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.accessTokenSecret = _data["accessTokenSecret"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): TwitterGetAccessTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterGetAccessTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["accessTokenSecret"] = this.accessTokenSecret;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data;
    }
}

export interface ITwitterGetAccessTokenResponse {
    accessToken: string | undefined;
    accessTokenSecret: string | undefined;
    userId: string | undefined;
    userName: string | undefined;
}

export class TwitterGetRequestTokenResponse implements ITwitterGetRequestTokenResponse {
    token!: string | undefined;
    secret!: string | undefined;
    confirmed!: boolean;
    redirectUrl!: string | undefined;

    constructor(data?: ITwitterGetRequestTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.secret = _data["secret"];
            this.confirmed = _data["confirmed"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): TwitterGetRequestTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterGetRequestTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["secret"] = this.secret;
        data["confirmed"] = this.confirmed;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface ITwitterGetRequestTokenResponse {
    token: string | undefined;
    secret: string | undefined;
    confirmed: boolean;
    redirectUrl: string | undefined;
}

export enum AbpLoginResultType {
    Success = 1,
    InvalidUserNameOrEmailAddress = 2,
    InvalidPassword = 3,
    UserIsNotActive = 4,
    InvalidTenancyName = 5,
    TenantIsNotActive = 6,
    UserEmailIsNotConfirmed = 7,
    UnknownExternalLogin = 8,
    LockedOut = 9,
    UserPhoneNumberIsNotConfirmed = 10,
    FailedForOtherReason = 11,
}

export class UserClaim implements IUserClaim {
    tenantId!: number | undefined;
    userId!: number;
    claimType!: string | undefined;
    claimValue!: string | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class UserLogin implements IUserLogin {
    tenantId!: number | undefined;
    userId!: number;
    loginProvider!: string;
    providerKey!: string;
    id!: number;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
    id: number;
}

export class UserOrganizationUnit implements IUserOrganizationUnit {
    tenantId!: number | undefined;
    userId!: number;
    organizationUnitId!: number;
    isDeleted!: boolean;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserOrganizationUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.isDeleted = _data["isDeleted"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserOrganizationUnit {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrganizationUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["organizationUnitId"] = this.organizationUnitId;
        data["isDeleted"] = this.isDeleted;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserOrganizationUnit {
    tenantId: number | undefined;
    userId: number;
    organizationUnitId: number;
    isDeleted: boolean;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    userId!: number;
    tenantId!: number | undefined;
    name!: string;
    isGranted!: boolean;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class UserRole implements IUserRole {
    tenantId!: number | undefined;
    userId!: number;
    roleId!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class UserToken implements IUserToken {
    tenantId!: number | undefined;
    userId!: number;
    loginProvider!: string | undefined;
    name!: string | undefined;
    value!: string | undefined;
    expireDate!: DateTime | undefined;
    id!: number;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"] ? DateTime.fromISO(_data["expireDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: DateTime | undefined;
    id: number;
}

export class Setting implements ISetting {
    tenantId!: number | undefined;
    userId!: number | undefined;
    name!: string;
    value!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum SettingScopes {
    Application = 1,
    Tenant = 2,
    User = 4,
    All = 7,
}

export enum EntityChangeType {
    Created = 0,
    Updated = 1,
    Deleted = 2,
}

export class NameValue implements INameValue {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValue {
        data = typeof data === 'object' ? data : {};
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValue {
    name: string | undefined;
    value: string | undefined;
}

export class GetNotificationsCreatedByUserOutput implements IGetNotificationsCreatedByUserOutput {
    notificationName!: string | undefined;
    data!: string | undefined;
    dataTypeName!: string | undefined;
    severity!: NotificationSeverity;
    isPublished!: boolean;
    creationTime!: DateTime;

    constructor(data?: IGetNotificationsCreatedByUserOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationName = _data["notificationName"];
            this.data = _data["data"];
            this.dataTypeName = _data["dataTypeName"];
            this.severity = _data["severity"];
            this.isPublished = _data["isPublished"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNotificationsCreatedByUserOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsCreatedByUserOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationName"] = this.notificationName;
        data["data"] = this.data;
        data["dataTypeName"] = this.dataTypeName;
        data["severity"] = this.severity;
        data["isPublished"] = this.isPublished;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IGetNotificationsCreatedByUserOutput {
    notificationName: string | undefined;
    data: string | undefined;
    dataTypeName: string | undefined;
    severity: NotificationSeverity;
    isPublished: boolean;
    creationTime: DateTime;
}

export class NotificationData implements INotificationData {
    readonly type!: string | undefined;
    properties!: { [key: string]: any; } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).type = _data["type"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        return data;
    }
}

export interface INotificationData {
    type: string | undefined;
    properties: { [key: string]: any; } | undefined;
}

export enum NotificationSeverity {
    Info = 0,
    Success = 1,
    Warn = 2,
    Error = 3,
    Fatal = 4,
}

export class TenantNotification implements ITenantNotification {
    tenantId!: number | undefined;
    notificationName!: string | undefined;
    data!: NotificationData;
    entityType!: string | undefined;
    entityTypeName!: string | undefined;
    entityId!: any | undefined;
    severity!: NotificationSeverity;
    creationTime!: DateTime;
    id!: string;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.notificationName = _data["notificationName"];
            this.data = _data["data"] ? NotificationData.fromJS(_data["data"]) : <any>undefined;
            this.entityType = _data["entityType"];
            this.entityTypeName = _data["entityTypeName"];
            this.entityId = _data["entityId"];
            this.severity = _data["severity"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantNotification {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["entityType"] = this.entityType;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityType: string | undefined;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: DateTime;
    id: string;
}

export class UserNotification implements IUserNotification {
    tenantId!: number | undefined;
    userId!: number;
    state!: UserNotificationState;
    notification!: TenantNotification;
    targetNotifiers!: string | undefined;
    readonly targetNotifiersList!: string[] | undefined;
    id!: string;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.state = _data["state"];
            this.notification = _data["notification"] ? TenantNotification.fromJS(_data["notification"]) : <any>undefined;
            this.targetNotifiers = _data["targetNotifiers"];
            if (Array.isArray(_data["targetNotifiersList"])) {
                (<any>this).targetNotifiersList = [] as any;
                for (let item of _data["targetNotifiersList"])
                    (<any>this).targetNotifiersList!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["targetNotifiers"] = this.targetNotifiers;
        if (Array.isArray(this.targetNotifiersList)) {
            data["targetNotifiersList"] = [];
            for (let item of this.targetNotifiersList)
                data["targetNotifiersList"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IUserNotification {
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    targetNotifiers: string | undefined;
    targetNotifiersList: string[] | undefined;
    id: string;
}

export enum UserNotificationState {
    Unread = 0,
    Read = 1,
}

export class IValueValidator implements IIValueValidator {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (_data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>(<any>this).attributes)![key] = _data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        data = typeof data === 'object' ? data : {};
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        return data;
    }
}

export interface IIValueValidator {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
}

export class IInputType implements IIInputType {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (_data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>(<any>this).attributes)![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IInputType {
        data = typeof data === 'object' ? data : {};
        let result = new IInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIInputType {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
}

export enum AppDownloadBinaryObjectId {
    NiInvoicingRefresherCourseTemplate = 0,
}

export enum ApplicationType {
    Lia = 0,
    LiaRen = 1,
    Ehc = 2,
    Lia90Days = 3,
    Ehc90Days = 4,
    Rla = 5,
    Alap = 6,
    Tla = 7,
    Slap = 8,
    SlapRen = 9,
    RlaLim = 10,
    Cla = 11,
    ClaRen = 12,
    Ola = 13,
    OlaRen = 14,
    Slas = 15,
    SlasRen = 16,
    ClaEhc = 17,
    Alas = 18,
    Nla = 19,
    Abo = 20,
    Sub = 21,
    Mut = 22,
    EhcRen = 23,
    Cogs = 24,
    Ndqr = 25,
    Npbo = 26,
    Ndn = 27,
    Npf = 28,
    LegPerson = 30,
    LegSponsorship = 31,
    NlaRen = 32,
    Bla = 33,
    BlaRen = 34,
    ClaEhcRen = 35,
    AlapExtr = 36,
    Nines = 37,
    LiaAndEhc = 38,
    NinesRen = 39,
    Nifsr = 40,
    Nipc = 41,
    Nito = 42,
    Answer = 43,
    ClaAndEhc = 44,
}

export enum CogsStatus {
    Person = 0,
    Contact = 1,
    Language = 2,
    AdditionalAddressOfService = 3,
    InvoiceAddress = 4,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export enum DmsTemplateSelectableEntityType {
    PersonAddress = 0,
    PersonAcademicTitle = 1,
    PersonDiploma = 2,
    PersonPostgraduateTitle = 3,
    PersonLicence = 4,
    PersonLicenceRenewal = 5,
    PersonLicenceRestriction = 6,
    PersonLicenceAdditionalInformation = 7,
    PersonSensitiveDataRecord = 8,
    PersonCriminalPenaltyRecord = 9,
    PersonEmployment = 10,
    PersonNarcoticPrescriptionBlockDetail = 11,
    SponsorshipEmploymentSponsorshipResponsible = 100,
    SponsorshipEmploymentMedicalFieldResponsible = 101,
    SponsorshipEmploymentMedicalFieldResponsibleDiploma = 102,
    SponsorshipCorporateLicence = 103,
    SponsorshipCorporateLicenceRestriction = 104,
    SponsorshipCorporateLicenceRenewal = 105,
    SponsorshipCorporateLicenceBusiness = 106,
    SponsorshipCorporateLicenceBusinessResponsible = 107,
    SponsorshipAdditionalInformation = 108,
    SponsorshipSensitiveDataRecord = 109,
    SponsorshipCriminalPenaltyRecord = 110,
    SponsorshipEmploymentsOther = 111,
    SponsorshipBusinessesOther = 112,
    AuthorityUser = 200,
    QrCodePerson = 300,
    QrCodeBusiness = 301,
    QrCodeSponsorship = 302,
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
    id!: string;

    constructor(data?: IEntityDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfGuid {
    id: string;
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
    id!: number;

    constructor(data?: IEntityDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfInt64 {
    id: number;
}

export class EntityDtoOfString implements IEntityDtoOfString {
    id!: string | undefined;

    constructor(data?: IEntityDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfString {
    id: string | undefined;
}

export enum ExternalSystemEnum {
    All = 0,
    MedReg = 1,
    Nareg = 2,
    PsyReg = 3,
    None = 4,
    BetReg = 5,
    Uid = 6,
}

export class HealthRegisterSnapshotResultOfHealthRegisterSnapshotDetailedDto implements IHealthRegisterSnapshotResultOfHealthRegisterSnapshotDetailedDto {
    healthRegisterResult!: HealthRegisterIdentificationStatus;
    snapshot!: HealthRegisterSnapshotDetailedDto;

    constructor(data?: IHealthRegisterSnapshotResultOfHealthRegisterSnapshotDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRegisterResult = _data["healthRegisterResult"];
            this.snapshot = _data["snapshot"] ? HealthRegisterSnapshotDetailedDto.fromJS(_data["snapshot"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthRegisterSnapshotResultOfHealthRegisterSnapshotDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterSnapshotResultOfHealthRegisterSnapshotDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRegisterResult"] = this.healthRegisterResult;
        data["snapshot"] = this.snapshot ? this.snapshot.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHealthRegisterSnapshotResultOfHealthRegisterSnapshotDetailedDto {
    healthRegisterResult: HealthRegisterIdentificationStatus;
    snapshot: HealthRegisterSnapshotDetailedDto;
}

export class HealthRegisterSnapshotResultOfHealthRegisterSnapshotPublicDto implements IHealthRegisterSnapshotResultOfHealthRegisterSnapshotPublicDto {
    healthRegisterResult!: HealthRegisterIdentificationStatus;
    snapshot!: HealthRegisterSnapshotPublicDto;

    constructor(data?: IHealthRegisterSnapshotResultOfHealthRegisterSnapshotPublicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRegisterResult = _data["healthRegisterResult"];
            this.snapshot = _data["snapshot"] ? HealthRegisterSnapshotPublicDto.fromJS(_data["snapshot"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthRegisterSnapshotResultOfHealthRegisterSnapshotPublicDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterSnapshotResultOfHealthRegisterSnapshotPublicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRegisterResult"] = this.healthRegisterResult;
        data["snapshot"] = this.snapshot ? this.snapshot.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHealthRegisterSnapshotResultOfHealthRegisterSnapshotPublicDto {
    healthRegisterResult: HealthRegisterIdentificationStatus;
    snapshot: HealthRegisterSnapshotPublicDto;
}

export class KeyValuePairOfStringString implements IKeyValuePairOfStringString {
    key!: string | undefined;
    value!: string | undefined;

    constructor(data?: IKeyValuePairOfStringString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairOfStringString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IKeyValuePairOfStringString {
    key: string | undefined;
    value: string | undefined;
}

export enum LegStatus {
    Person = 0,
    Sponsorship = 1,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export class ListResultDtoOfCacheDto implements IListResultDtoOfCacheDto {
    items!: CacheDto[] | undefined;

    constructor(data?: IListResultDtoOfCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfCacheDto {
    items: CacheDto[] | undefined;
}

export class ListResultDtoOfChatMessageDto implements IListResultDtoOfChatMessageDto {
    items!: ChatMessageDto[] | undefined;

    constructor(data?: IListResultDtoOfChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChatMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[] | undefined;
}

export class ListResultDtoOfEditionListDto implements IListResultDtoOfEditionListDto {
    items!: EditionListDto[] | undefined;

    constructor(data?: IListResultDtoOfEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfEditionListDto {
    items: EditionListDto[] | undefined;
}

export class ListResultDtoOfFlatPermissionWithLevelDto implements IListResultDtoOfFlatPermissionWithLevelDto {
    items!: FlatPermissionWithLevelDto[] | undefined;

    constructor(data?: IListResultDtoOfFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FlatPermissionWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[] | undefined;
}

export class ListResultDtoOfLinkedUserDto implements IListResultDtoOfLinkedUserDto {
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IListResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[] | undefined;
}

export class ListResultDtoOfMailDistributionListDto implements IListResultDtoOfMailDistributionListDto {
    items!: MailDistributionListDto[] | undefined;

    constructor(data?: IListResultDtoOfMailDistributionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MailDistributionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfMailDistributionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfMailDistributionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfMailDistributionListDto {
    items: MailDistributionListDto[] | undefined;
}

export class ListResultDtoOfNameValueDto implements IListResultDtoOfNameValueDto {
    items!: NameValueDto[] | undefined;

    constructor(data?: IListResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfNameValueDto {
    items: NameValueDto[] | undefined;
}

export class ListResultDtoOfOrganizationUnitDto implements IListResultDtoOfOrganizationUnitDto {
    items!: OrganizationUnitDto[] | undefined;

    constructor(data?: IListResultDtoOfOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfOrganizationUnitDto {
    items: OrganizationUnitDto[] | undefined;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;
}

export class ListResultDtoOfSubscribableEditionComboboxItemDto implements IListResultDtoOfSubscribableEditionComboboxItemDto {
    items!: SubscribableEditionComboboxItemDto[] | undefined;

    constructor(data?: IListResultDtoOfSubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[] | undefined;
}

export enum LogbookType {
    Person = 0,
    Sponsorship = 1,
    Business = 2,
}

export enum MigrationAdditionalStep {
    AdditionalStep1 = 0,
}

export enum MigrationBinaryObjectId {
    CodeMappingBepro = 0,
    DuplicateFile = 1,
}

export enum MigrationStep {
    CodeMappingCheck = 0,
    Inspectors = 1,
    BeproUsers = 2,
    People = 3,
    Sponsorships = 4,
    Businesses = 5,
    Employments = 6,
    LogbookEntries = 7,
    Pendences = 8,
    Documents = 9,
    SironaUsers = 10,
}

export enum NdnStatus {
    Person = 0,
    DeliveryNote = 1,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export enum NdqrStatus {
    Register = 0,
    Business = 1,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export enum NiStatus {
    Person = 0,
    PersonContact = 1,
    Sponsorship = 2,
    SponsorshipContact = 3,
    ProfessionalDetails = 4,
    CourseOffering = 5,
    EducationProvider = 6,
    ProofOfCourseCompletion = 7,
    TrainingServices = 8,
    BankDetails = 9,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export class NpfCreateOrUpdateOutputOfNpfContactDto implements INpfCreateOrUpdateOutputOfNpfContactDto {
    status!: NpfStatus;
    data!: NpfContactDto;

    constructor(data?: INpfCreateOrUpdateOutputOfNpfContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.data = _data["data"] ? NpfContactDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NpfCreateOrUpdateOutputOfNpfContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new NpfCreateOrUpdateOutputOfNpfContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface INpfCreateOrUpdateOutputOfNpfContactDto {
    status: NpfStatus;
    data: NpfContactDto;
}

export class NpfCreateOrUpdateOutputOfNpfPrescriptionFraudDto implements INpfCreateOrUpdateOutputOfNpfPrescriptionFraudDto {
    status!: NpfStatus;
    data!: NpfPrescriptionFraudDto;

    constructor(data?: INpfCreateOrUpdateOutputOfNpfPrescriptionFraudDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.data = _data["data"] ? NpfPrescriptionFraudDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NpfCreateOrUpdateOutputOfNpfPrescriptionFraudDto {
        data = typeof data === 'object' ? data : {};
        let result = new NpfCreateOrUpdateOutputOfNpfPrescriptionFraudDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface INpfCreateOrUpdateOutputOfNpfPrescriptionFraudDto {
    status: NpfStatus;
    data: NpfPrescriptionFraudDto;
}

export enum NpfStatus {
    Contact = 0,
    PrescriptionFraud = 1,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export class PagedResultDtoOfAnswerApplicationDto implements IPagedResultDtoOfAnswerApplicationDto {
    totalCount!: number;
    items!: AnswerApplicationDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAnswerApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AnswerApplicationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAnswerApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAnswerApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAnswerApplicationDto {
    totalCount: number;
    items: AnswerApplicationDto[] | undefined;
}

export class PagedResultDtoOfAuditLogListDto implements IPagedResultDtoOfAuditLogListDto {
    totalCount!: number;
    items!: AuditLogListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditLogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAuditLogListDto {
    totalCount: number;
    items: AuditLogListDto[] | undefined;
}

export class PagedResultDtoOfCodeListDto implements IPagedResultDtoOfCodeListDto {
    totalCount!: number;
    items!: CodeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CodeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCodeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCodeListDto {
    totalCount: number;
    items: CodeListDto[] | undefined;
}

export class PagedResultDtoOfEntityChangeListDto implements IPagedResultDtoOfEntityChangeListDto {
    totalCount!: number;
    items!: EntityChangeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EntityChangeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfEntityChangeListDto {
    totalCount: number;
    items: EntityChangeListDto[] | undefined;
}

export class PagedResultDtoOfGetExcelResultData implements IPagedResultDtoOfGetExcelResultData {
    totalCount!: number;
    items!: GetExcelResultData[] | undefined;

    constructor(data?: IPagedResultDtoOfGetExcelResultData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetExcelResultData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetExcelResultData {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetExcelResultData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetExcelResultData {
    totalCount: number;
    items: GetExcelResultData[] | undefined;
}

export class PagedResultDtoOfLanguageTextListDto implements IPagedResultDtoOfLanguageTextListDto {
    totalCount!: number;
    items!: LanguageTextListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LanguageTextListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLanguageTextListDto {
    totalCount: number;
    items: LanguageTextListDto[] | undefined;
}

export class PagedResultDtoOfLinkedUserDto implements IPagedResultDtoOfLinkedUserDto {
    totalCount!: number;
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLinkedUserDto {
    totalCount: number;
    items: LinkedUserDto[] | undefined;
}

export class PagedResultDtoOfMailDistributionListEmailListDto implements IPagedResultDtoOfMailDistributionListEmailListDto {
    totalCount!: number;
    items!: MailDistributionListEmailListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMailDistributionListEmailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MailDistributionListEmailListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMailDistributionListEmailListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMailDistributionListEmailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfMailDistributionListEmailListDto {
    totalCount: number;
    items: MailDistributionListEmailListDto[] | undefined;
}

export class PagedResultDtoOfMailDistributionListUserListDto implements IPagedResultDtoOfMailDistributionListUserListDto {
    totalCount!: number;
    items!: MailDistributionListUserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMailDistributionListUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MailDistributionListUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMailDistributionListUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMailDistributionListUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfMailDistributionListUserListDto {
    totalCount: number;
    items: MailDistributionListUserListDto[] | undefined;
}

export class PagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto implements IPagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto {
    totalCount!: number;
    items!: MassNotificationOrganizationUnitLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MassNotificationOrganizationUnitLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto {
    totalCount: number;
    items: MassNotificationOrganizationUnitLookupTableDto[] | undefined;
}

export class PagedResultDtoOfMassNotificationUserLookupTableDto implements IPagedResultDtoOfMassNotificationUserLookupTableDto {
    totalCount!: number;
    items!: MassNotificationUserLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMassNotificationUserLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MassNotificationUserLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMassNotificationUserLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMassNotificationUserLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfMassNotificationUserLookupTableDto {
    totalCount: number;
    items: MassNotificationUserLookupTableDto[] | undefined;
}

export class PagedResultDtoOfNameValueDto implements IPagedResultDtoOfNameValueDto {
    totalCount!: number;
    items!: NameValueDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfNameValueDto {
    totalCount: number;
    items: NameValueDto[] | undefined;
}

export class PagedResultDtoOfOrganizationUnitProfessionListDto implements IPagedResultDtoOfOrganizationUnitProfessionListDto {
    totalCount!: number;
    items!: OrganizationUnitProfessionListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitProfessionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitProfessionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitProfessionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitProfessionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitProfessionListDto {
    totalCount: number;
    items: OrganizationUnitProfessionListDto[] | undefined;
}

export class PagedResultDtoOfOrganizationUnitRoleListDto implements IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount!: number;
    items!: OrganizationUnitRoleListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitRoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount: number;
    items: OrganizationUnitRoleListDto[] | undefined;
}

export class PagedResultDtoOfOrganizationUnitUserListDto implements IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount!: number;
    items!: OrganizationUnitUserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[] | undefined;
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
    totalCount!: number;
    items!: TenantListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfTenantListDto {
    totalCount: number;
    items: TenantListDto[] | undefined;
}

export class PagedResultDtoOfUserDelegationDto implements IPagedResultDtoOfUserDelegationDto {
    totalCount!: number;
    items!: UserDelegationDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDelegationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserDelegationDto {
    totalCount: number;
    items: UserDelegationDto[] | undefined;
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
    totalCount!: number;
    items!: UserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserListDto {
    totalCount: number;
    items: UserListDto[] | undefined;
}

export class PagedResultDtoOfUserLoginAttemptDto implements IPagedResultDtoOfUserLoginAttemptDto {
    totalCount!: number;
    items!: UserLoginAttemptDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserLoginAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserLoginAttemptDto {
    totalCount: number;
    items: UserLoginAttemptDto[] | undefined;
}

export enum PersonLicenceType {
    ProfessionalLicence = 0,
    ProfessionalNinetyDays = 1,
    ExpenceHealthCareLicence = 2,
    ExpenceHealthCareNinetyDays = 3,
    LocalSalesLicence = 4,
    AssistantLicence = 5,
    TraineeLicence = 6,
    SubstitutionSpecialLicence = 7,
    DelegatedLicencePerson = 8,
    Pensioner = 9,
    ReproductiveMedicineLicence = 11,
    YellowFeverSpecialLicence = 13,
    RepresentationPersonLicence = 15,
    LimitedRepresentationPersonLicence = 16,
    ExtraordinaryAssistantLicence = 17,
}

export enum ReminderType {
    Person = 0,
    Sponsorship = 1,
    Business = 2,
}

export enum RequirementGroupDiscriminator {
    Profession = 0,
    SponsorshipType = 1,
}

export enum RequirementType {
    ProfessionDiploma = 0,
    Degree = 1,
    PostgraduateTitle = 2,
    AtLeastOnePresent = 3,
    IssuedAfter = 4,
    LanguageSkill = 5,
    DiplomaType = 6,
    AtLeastOneLiaEmploymentDefined = 100,
    OnlyPrivateAddressAllowed = 200,
}

export enum SensitiveDataDiscriminator {
    Person = 0,
    Sponsorship = 1,
}

export class AcademicTitle implements IAcademicTitle {
    personId!: number;
    person!: Person;
    title!: string | undefined;
    titleVerified!: string | undefined;
    grantingAuthority!: string | undefined;
    placeOfIssue!: string | undefined;
    country!: Code;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    remarks!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IAcademicTitle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.title = _data["title"];
            this.titleVerified = _data["titleVerified"];
            this.grantingAuthority = _data["grantingAuthority"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.country = _data["country"] ? Code.fromJS(_data["country"]) : <any>undefined;
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AcademicTitle {
        data = typeof data === 'object' ? data : {};
        let result = new AcademicTitle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["titleVerified"] = this.titleVerified;
        data["grantingAuthority"] = this.grantingAuthority;
        data["placeOfIssue"] = this.placeOfIssue;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remarks"] = this.remarks;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAcademicTitle {
    personId: number;
    person: Person;
    title: string | undefined;
    titleVerified: string | undefined;
    grantingAuthority: string | undefined;
    placeOfIssue: string | undefined;
    country: Code;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    remarks: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class AcademicTitleDto implements IAcademicTitleDto {
    title!: string;
    titleVerified!: string | undefined;
    grantingAuthority!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    remarks!: string | undefined;

    constructor(data?: IAcademicTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.titleVerified = _data["titleVerified"];
            this.grantingAuthority = _data["grantingAuthority"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): AcademicTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcademicTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["titleVerified"] = this.titleVerified;
        data["grantingAuthority"] = this.grantingAuthority;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IAcademicTitleDto {
    title: string;
    titleVerified: string | undefined;
    grantingAuthority: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    remarks: string | undefined;
}

export class AcademicTitleSearchResultDto implements IAcademicTitleSearchResultDto {
    id!: number;
    title!: string | undefined;
    grantingAuthority!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;

    constructor(data?: IAcademicTitleSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.grantingAuthority = _data["grantingAuthority"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AcademicTitleSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcademicTitleSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["grantingAuthority"] = this.grantingAuthority;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IAcademicTitleSearchResultDto {
    id: number;
    title: string | undefined;
    grantingAuthority: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
}

export class CreateAcademicTitleDto implements ICreateAcademicTitleDto {
    personId!: number;
    title!: string;
    titleVerified!: string | undefined;
    grantingAuthority!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    remarks!: string | undefined;

    constructor(data?: ICreateAcademicTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.title = _data["title"];
            this.titleVerified = _data["titleVerified"];
            this.grantingAuthority = _data["grantingAuthority"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): CreateAcademicTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAcademicTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["title"] = this.title;
        data["titleVerified"] = this.titleVerified;
        data["grantingAuthority"] = this.grantingAuthority;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface ICreateAcademicTitleDto {
    personId: number;
    title: string;
    titleVerified: string | undefined;
    grantingAuthority: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    remarks: string | undefined;
}

export class GetAcademicTitleSearchOutputDto implements IGetAcademicTitleSearchOutputDto {
    totalCount!: number;
    items!: AcademicTitleSearchResultDto[] | undefined;

    constructor(data?: IGetAcademicTitleSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AcademicTitleSearchResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAcademicTitleSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAcademicTitleSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAcademicTitleSearchOutputDto {
    totalCount: number;
    items: AcademicTitleSearchResultDto[] | undefined;
}

export class AdditionalInformationBusiness implements IAdditionalInformationBusiness {
    business!: Business;
    businessId!: number;
    discriminator!: AdditionalInformationDiscriminator;
    additionalInformationId!: string | undefined;
    date!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    description!: string | undefined;
    statusId!: string | undefined;
    municipalityId!: string | undefined;
    regionId!: string | undefined;
    migrationData!: MigrationData[] | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IAdditionalInformationBusiness) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.business = _data["business"] ? Business.fromJS(_data["business"]) : <any>undefined;
            this.businessId = _data["businessId"];
            this.discriminator = _data["discriminator"];
            this.additionalInformationId = _data["additionalInformationId"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.statusId = _data["statusId"];
            this.municipalityId = _data["municipalityId"];
            this.regionId = _data["regionId"];
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AdditionalInformationBusiness {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalInformationBusiness();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        data["businessId"] = this.businessId;
        data["discriminator"] = this.discriminator;
        data["additionalInformationId"] = this.additionalInformationId;
        data["date"] = this.date ? this.date.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["description"] = this.description;
        data["statusId"] = this.statusId;
        data["municipalityId"] = this.municipalityId;
        data["regionId"] = this.regionId;
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAdditionalInformationBusiness {
    business: Business;
    businessId: number;
    discriminator: AdditionalInformationDiscriminator;
    additionalInformationId: string | undefined;
    date: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    description: string | undefined;
    statusId: string | undefined;
    municipalityId: string | undefined;
    regionId: string | undefined;
    migrationData: MigrationData[] | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum AdditionalInformationDiscriminator {
    Sponsorship = 1,
    Business = 2,
    PersonLicence = 3,
    Person = 4,
}

export class AdditionalInformationPerson implements IAdditionalInformationPerson {
    person!: Person;
    personId!: number;
    discriminator!: AdditionalInformationDiscriminator;
    additionalInformationId!: string | undefined;
    date!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    description!: string | undefined;
    statusId!: string | undefined;
    municipalityId!: string | undefined;
    regionId!: string | undefined;
    migrationData!: MigrationData[] | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IAdditionalInformationPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.personId = _data["personId"];
            this.discriminator = _data["discriminator"];
            this.additionalInformationId = _data["additionalInformationId"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.statusId = _data["statusId"];
            this.municipalityId = _data["municipalityId"];
            this.regionId = _data["regionId"];
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AdditionalInformationPerson {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalInformationPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["discriminator"] = this.discriminator;
        data["additionalInformationId"] = this.additionalInformationId;
        data["date"] = this.date ? this.date.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["description"] = this.description;
        data["statusId"] = this.statusId;
        data["municipalityId"] = this.municipalityId;
        data["regionId"] = this.regionId;
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAdditionalInformationPerson {
    person: Person;
    personId: number;
    discriminator: AdditionalInformationDiscriminator;
    additionalInformationId: string | undefined;
    date: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    description: string | undefined;
    statusId: string | undefined;
    municipalityId: string | undefined;
    regionId: string | undefined;
    migrationData: MigrationData[] | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class AdditionalInformationPersonLicence implements IAdditionalInformationPersonLicence {
    personLicence!: PersonLicence;
    personLicenceId!: number;
    discriminator!: AdditionalInformationDiscriminator;
    additionalInformationId!: string | undefined;
    date!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    description!: string | undefined;
    statusId!: string | undefined;
    municipalityId!: string | undefined;
    regionId!: string | undefined;
    migrationData!: MigrationData[] | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IAdditionalInformationPersonLicence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personLicence = _data["personLicence"] ? PersonLicence.fromJS(_data["personLicence"]) : <any>undefined;
            this.personLicenceId = _data["personLicenceId"];
            this.discriminator = _data["discriminator"];
            this.additionalInformationId = _data["additionalInformationId"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.statusId = _data["statusId"];
            this.municipalityId = _data["municipalityId"];
            this.regionId = _data["regionId"];
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AdditionalInformationPersonLicence {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalInformationPersonLicence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personLicence"] = this.personLicence ? this.personLicence.toJSON() : <any>undefined;
        data["personLicenceId"] = this.personLicenceId;
        data["discriminator"] = this.discriminator;
        data["additionalInformationId"] = this.additionalInformationId;
        data["date"] = this.date ? this.date.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["description"] = this.description;
        data["statusId"] = this.statusId;
        data["municipalityId"] = this.municipalityId;
        data["regionId"] = this.regionId;
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAdditionalInformationPersonLicence {
    personLicence: PersonLicence;
    personLicenceId: number;
    discriminator: AdditionalInformationDiscriminator;
    additionalInformationId: string | undefined;
    date: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    description: string | undefined;
    statusId: string | undefined;
    municipalityId: string | undefined;
    regionId: string | undefined;
    migrationData: MigrationData[] | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class AdditionalInformationSponsorship implements IAdditionalInformationSponsorship {
    sponsorship!: Sponsorship;
    sponsorshipId!: number;
    discriminator!: AdditionalInformationDiscriminator;
    additionalInformationId!: string | undefined;
    date!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    description!: string | undefined;
    statusId!: string | undefined;
    municipalityId!: string | undefined;
    regionId!: string | undefined;
    migrationData!: MigrationData[] | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IAdditionalInformationSponsorship) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorship = _data["sponsorship"] ? Sponsorship.fromJS(_data["sponsorship"]) : <any>undefined;
            this.sponsorshipId = _data["sponsorshipId"];
            this.discriminator = _data["discriminator"];
            this.additionalInformationId = _data["additionalInformationId"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.statusId = _data["statusId"];
            this.municipalityId = _data["municipalityId"];
            this.regionId = _data["regionId"];
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AdditionalInformationSponsorship {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalInformationSponsorship();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        data["sponsorshipId"] = this.sponsorshipId;
        data["discriminator"] = this.discriminator;
        data["additionalInformationId"] = this.additionalInformationId;
        data["date"] = this.date ? this.date.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["description"] = this.description;
        data["statusId"] = this.statusId;
        data["municipalityId"] = this.municipalityId;
        data["regionId"] = this.regionId;
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAdditionalInformationSponsorship {
    sponsorship: Sponsorship;
    sponsorshipId: number;
    discriminator: AdditionalInformationDiscriminator;
    additionalInformationId: string | undefined;
    date: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    description: string | undefined;
    statusId: string | undefined;
    municipalityId: string | undefined;
    regionId: string | undefined;
    migrationData: MigrationData[] | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class AdditionalInformationDto implements IAdditionalInformationDto {
    additionalInformationId!: string;
    date!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    description!: string | undefined;
    statusId!: string;
    municipalityId!: string | undefined;
    regionId!: string | undefined;

    constructor(data?: IAdditionalInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalInformationId = _data["additionalInformationId"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.statusId = _data["statusId"];
            this.municipalityId = _data["municipalityId"];
            this.regionId = _data["regionId"];
        }
    }

    static fromJS(data: any): AdditionalInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalInformationId"] = this.additionalInformationId;
        data["date"] = this.date ? this.date.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["description"] = this.description;
        data["statusId"] = this.statusId;
        data["municipalityId"] = this.municipalityId;
        data["regionId"] = this.regionId;
        return data;
    }
}

export interface IAdditionalInformationDto {
    additionalInformationId: string;
    date: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    description: string | undefined;
    statusId: string;
    municipalityId: string | undefined;
    regionId: string | undefined;
}

export class GetAdditionalInformationDto implements IGetAdditionalInformationDto {
    id!: number;
    additionalInformationId!: string;
    date!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    description!: string | undefined;
    statusId!: string;
    municipalityId!: string | undefined;
    regionId!: string | undefined;

    constructor(data?: IGetAdditionalInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.additionalInformationId = _data["additionalInformationId"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.statusId = _data["statusId"];
            this.municipalityId = _data["municipalityId"];
            this.regionId = _data["regionId"];
        }
    }

    static fromJS(data: any): GetAdditionalInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdditionalInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["additionalInformationId"] = this.additionalInformationId;
        data["date"] = this.date ? this.date.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["description"] = this.description;
        data["statusId"] = this.statusId;
        data["municipalityId"] = this.municipalityId;
        data["regionId"] = this.regionId;
        return data;
    }
}

export interface IGetAdditionalInformationDto {
    id: number;
    additionalInformationId: string;
    date: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    description: string | undefined;
    statusId: string;
    municipalityId: string | undefined;
    regionId: string | undefined;
}

export class AddressSearchDto implements IAddressSearchDto {
    businessId!: number | undefined;
    sponsorshipId!: number | undefined;
    sponsorshipName!: string | undefined;
    addressTypeId!: string | undefined;
    legalFormId!: string | undefined;
    name!: string | undefined;
    additionalName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    gln!: string | undefined;
    bur!: string | undefined;
    uid!: string | undefined;
    isArchived!: boolean;

    constructor(data?: IAddressSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessId = _data["businessId"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.sponsorshipName = _data["sponsorshipName"];
            this.addressTypeId = _data["addressTypeId"];
            this.legalFormId = _data["legalFormId"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.gln = _data["gln"];
            this.bur = _data["bur"];
            this.uid = _data["uid"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): AddressSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessId"] = this.businessId;
        data["sponsorshipId"] = this.sponsorshipId;
        data["sponsorshipName"] = this.sponsorshipName;
        data["addressTypeId"] = this.addressTypeId;
        data["legalFormId"] = this.legalFormId;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["gln"] = this.gln;
        data["bur"] = this.bur;
        data["uid"] = this.uid;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IAddressSearchDto {
    businessId: number | undefined;
    sponsorshipId: number | undefined;
    sponsorshipName: string | undefined;
    addressTypeId: string | undefined;
    legalFormId: string | undefined;
    name: string | undefined;
    additionalName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    gln: string | undefined;
    bur: string | undefined;
    uid: string | undefined;
    isArchived: boolean;
}

export class AddressSearchInput implements IAddressSearchInput {
    isArchived!: boolean | undefined;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IAddressSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isArchived = _data["isArchived"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): AddressSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddressSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isArchived"] = this.isArchived;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IAddressSearchInput {
    isArchived: boolean | undefined;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class AddressSearchOutput implements IAddressSearchOutput {
    totalCount!: number;
    items!: AddressSearchDto[] | undefined;

    constructor(data?: IAddressSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AddressSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddressSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AddressSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddressSearchOutput {
    totalCount: number;
    items: AddressSearchDto[] | undefined;
}

export class FormAddressSearchInput implements IFormAddressSearchInput {
    businessId!: number | undefined;
    sponsorshipId!: number | undefined;
    name!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    addressTypeId!: string | undefined;
    legalFormId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    uid!: string | undefined;
    bur!: string | undefined;
    gln!: string | undefined;
    includeSponsorships!: boolean | undefined;
    includeBusinesses!: boolean | undefined;
    maxResultCount!: number | undefined;
    skipCount!: number | undefined;
    isArchived!: boolean | undefined;

    constructor(data?: IFormAddressSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessId = _data["businessId"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.name = _data["name"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.addressTypeId = _data["addressTypeId"];
            this.legalFormId = _data["legalFormId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.uid = _data["uid"];
            this.bur = _data["bur"];
            this.gln = _data["gln"];
            this.includeSponsorships = _data["includeSponsorships"];
            this.includeBusinesses = _data["includeBusinesses"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): FormAddressSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new FormAddressSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessId"] = this.businessId;
        data["sponsorshipId"] = this.sponsorshipId;
        data["name"] = this.name;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["addressTypeId"] = this.addressTypeId;
        data["legalFormId"] = this.legalFormId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["uid"] = this.uid;
        data["bur"] = this.bur;
        data["gln"] = this.gln;
        data["includeSponsorships"] = this.includeSponsorships;
        data["includeBusinesses"] = this.includeBusinesses;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IFormAddressSearchInput {
    businessId: number | undefined;
    sponsorshipId: number | undefined;
    name: string | undefined;
    sponsorshipTypeId: string | undefined;
    addressTypeId: string | undefined;
    legalFormId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    uid: string | undefined;
    bur: string | undefined;
    gln: string | undefined;
    includeSponsorships: boolean | undefined;
    includeBusinesses: boolean | undefined;
    maxResultCount: number | undefined;
    skipCount: number | undefined;
    isArchived: boolean | undefined;
}

export class InvoiceAddressDetail implements IInvoiceAddressDetail {
    name!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    addressAddition!: string | undefined;
    postOfficeBox!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;

    constructor(data?: IInvoiceAddressDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.addressAddition = _data["addressAddition"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): InvoiceAddressDetail {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceAddressDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["addressAddition"] = this.addressAddition;
        data["postOfficeBox"] = this.postOfficeBox;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        return data;
    }
}

export interface IInvoiceAddressDetail {
    name: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    addressAddition: string | undefined;
    postOfficeBox: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
}

export class InvoiceAddressDetailDto implements IInvoiceAddressDetailDto {
    name!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    addressAddition!: string | undefined;
    postOfficeBox!: string | undefined;
    email!: string | undefined;
    countryId!: string | undefined;

    constructor(data?: IInvoiceAddressDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.addressAddition = _data["addressAddition"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.email = _data["email"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): InvoiceAddressDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceAddressDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["addressAddition"] = this.addressAddition;
        data["postOfficeBox"] = this.postOfficeBox;
        data["email"] = this.email;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface IInvoiceAddressDetailDto {
    name: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    addressAddition: string | undefined;
    postOfficeBox: string | undefined;
    email: string | undefined;
    countryId: string | undefined;
}

export class GetAdrisBusinessTransactionDto implements IGetAdrisBusinessTransactionDto {
    personId!: number | undefined;
    businessId!: number | undefined;
    businessTransactionId!: string | undefined;
    name!: string | undefined;
    type!: string | undefined;
    dateOfCompletion!: DateTime | undefined;
    completionType!: string | undefined;
    registerNumber!: string | undefined;
    creationTime!: DateTime;
    creatorUserFullName!: string | undefined;
    id!: number;

    constructor(data?: IGetAdrisBusinessTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.businessId = _data["businessId"];
            this.businessTransactionId = _data["businessTransactionId"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.dateOfCompletion = _data["dateOfCompletion"] ? DateTime.fromISO(_data["dateOfCompletion"].toString()) : <any>undefined;
            this.completionType = _data["completionType"];
            this.registerNumber = _data["registerNumber"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAdrisBusinessTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdrisBusinessTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["businessId"] = this.businessId;
        data["businessTransactionId"] = this.businessTransactionId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["dateOfCompletion"] = this.dateOfCompletion ? this.dateOfCompletion.toFormat('yyyy-MM-dd') : <any>undefined;
        data["completionType"] = this.completionType;
        data["registerNumber"] = this.registerNumber;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetAdrisBusinessTransactionDto {
    personId: number | undefined;
    businessId: number | undefined;
    businessTransactionId: string | undefined;
    name: string | undefined;
    type: string | undefined;
    dateOfCompletion: DateTime | undefined;
    completionType: string | undefined;
    registerNumber: string | undefined;
    creationTime: DateTime;
    creatorUserFullName: string | undefined;
    id: number;
}

export class GetAdrisBusinessTransactionSearchOutput implements IGetAdrisBusinessTransactionSearchOutput {
    totalCount!: number;
    items!: GetAdrisBusinessTransactionDto[] | undefined;

    constructor(data?: IGetAdrisBusinessTransactionSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAdrisBusinessTransactionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAdrisBusinessTransactionSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdrisBusinessTransactionSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAdrisBusinessTransactionSearchOutput {
    totalCount: number;
    items: GetAdrisBusinessTransactionDto[] | undefined;
}

export class AnswerApplicationDocumentDto implements IAnswerApplicationDocumentDto {
    id!: number;
    name!: string | undefined;
    mimeType!: string | undefined;

    constructor(data?: IAnswerApplicationDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): AnswerApplicationDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerApplicationDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["mimeType"] = this.mimeType;
        return data;
    }
}

export interface IAnswerApplicationDocumentDto {
    id: number;
    name: string | undefined;
    mimeType: string | undefined;
}

export class AnswerApplicationDetailDto implements IAnswerApplicationDetailDto {
    id!: number;
    caseId!: string | undefined;
    statusId!: string | undefined;
    responseText!: string | undefined;
    personId!: number | undefined;
    personName!: string | undefined;
    sponsorshipId!: number | undefined;
    sponsorshipName!: string | undefined;
    responsibleName!: string | undefined;
    creationTime!: DateTime;
    documents!: AnswerApplicationDocumentDto[] | undefined;

    constructor(data?: IAnswerApplicationDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.statusId = _data["statusId"];
            this.responseText = _data["responseText"];
            this.personId = _data["personId"];
            this.personName = _data["personName"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.sponsorshipName = _data["sponsorshipName"];
            this.responsibleName = _data["responsibleName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(AnswerApplicationDocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnswerApplicationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerApplicationDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["statusId"] = this.statusId;
        data["responseText"] = this.responseText;
        data["personId"] = this.personId;
        data["personName"] = this.personName;
        data["sponsorshipId"] = this.sponsorshipId;
        data["sponsorshipName"] = this.sponsorshipName;
        data["responsibleName"] = this.responsibleName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAnswerApplicationDetailDto {
    id: number;
    caseId: string | undefined;
    statusId: string | undefined;
    responseText: string | undefined;
    personId: number | undefined;
    personName: string | undefined;
    sponsorshipId: number | undefined;
    sponsorshipName: string | undefined;
    responsibleName: string | undefined;
    creationTime: DateTime;
    documents: AnswerApplicationDocumentDto[] | undefined;
}

export class AnswerApplicationDto implements IAnswerApplicationDto {
    id!: number;
    caseId!: string | undefined;
    statusId!: string | undefined;
    responseText!: string | undefined;
    personId!: number | undefined;
    personName!: string | undefined;
    sponsorshipId!: number | undefined;
    sponsorshipName!: string | undefined;
    responsibleId!: number | undefined;
    responsibleName!: string | undefined;
    iAmResponsible!: boolean;
    creationTime!: DateTime;

    constructor(data?: IAnswerApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.statusId = _data["statusId"];
            this.responseText = _data["responseText"];
            this.personId = _data["personId"];
            this.personName = _data["personName"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.sponsorshipName = _data["sponsorshipName"];
            this.responsibleId = _data["responsibleId"];
            this.responsibleName = _data["responsibleName"];
            this.iAmResponsible = _data["iAmResponsible"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AnswerApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["statusId"] = this.statusId;
        data["responseText"] = this.responseText;
        data["personId"] = this.personId;
        data["personName"] = this.personName;
        data["sponsorshipId"] = this.sponsorshipId;
        data["sponsorshipName"] = this.sponsorshipName;
        data["responsibleId"] = this.responsibleId;
        data["responsibleName"] = this.responsibleName;
        data["iAmResponsible"] = this.iAmResponsible;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IAnswerApplicationDto {
    id: number;
    caseId: string | undefined;
    statusId: string | undefined;
    responseText: string | undefined;
    personId: number | undefined;
    personName: string | undefined;
    sponsorshipId: number | undefined;
    sponsorshipName: string | undefined;
    responsibleId: number | undefined;
    responsibleName: string | undefined;
    iAmResponsible: boolean;
    creationTime: DateTime;
}

export class AssignAnswerApplicationOutput implements IAssignAnswerApplicationOutput {
    userId!: number | undefined;
    responsible!: string | undefined;

    constructor(data?: IAssignAnswerApplicationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.responsible = _data["responsible"];
        }
    }

    static fromJS(data: any): AssignAnswerApplicationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AssignAnswerApplicationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["responsible"] = this.responsible;
        return data;
    }
}

export interface IAssignAnswerApplicationOutput {
    userId: number | undefined;
    responsible: string | undefined;
}

export class Application implements IApplication {
    user!: User;
    userId!: number;
    backendSystemId!: number | undefined;
    applicantCaseId!: string | undefined;
    caseId!: string;
    type!: ApplicationType;
    status!: ApplicationStatus;
    dateOfStatusChange!: DateTime;
    responsible!: User;
    responsibleId!: number | undefined;
    applicantComment!: string | undefined;
    dateOfDeleteNotificationSent!: DateTime | undefined;
    caseIdSearchable!: string | undefined;
    evaluations!: Evaluation[] | undefined;
    historyStatusEntries!: ApplicationHistoryStatus[] | undefined;
    historyResponsibleEntries!: ApplicationHistoryResponsible[] | undefined;
    supplementalClaims!: ApplicationSupplementalClaim[] | undefined;
    authorityDocuments!: ApplicationAuthorityDocument[] | undefined;
    additionalDocuments!: ApplicationAdditionalDocument[] | undefined;
    legitimation!: Legitimation;
    legitimationId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            this.backendSystemId = _data["backendSystemId"];
            this.applicantCaseId = _data["applicantCaseId"];
            this.caseId = _data["caseId"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.responsible = _data["responsible"] ? User.fromJS(_data["responsible"]) : <any>undefined;
            this.responsibleId = _data["responsibleId"];
            this.applicantComment = _data["applicantComment"];
            this.dateOfDeleteNotificationSent = _data["dateOfDeleteNotificationSent"] ? DateTime.fromISO(_data["dateOfDeleteNotificationSent"].toString()) : <any>undefined;
            this.caseIdSearchable = _data["caseIdSearchable"];
            if (Array.isArray(_data["evaluations"])) {
                this.evaluations = [] as any;
                for (let item of _data["evaluations"])
                    this.evaluations!.push(Evaluation.fromJS(item));
            }
            if (Array.isArray(_data["historyStatusEntries"])) {
                this.historyStatusEntries = [] as any;
                for (let item of _data["historyStatusEntries"])
                    this.historyStatusEntries!.push(ApplicationHistoryStatus.fromJS(item));
            }
            if (Array.isArray(_data["historyResponsibleEntries"])) {
                this.historyResponsibleEntries = [] as any;
                for (let item of _data["historyResponsibleEntries"])
                    this.historyResponsibleEntries!.push(ApplicationHistoryResponsible.fromJS(item));
            }
            if (Array.isArray(_data["supplementalClaims"])) {
                this.supplementalClaims = [] as any;
                for (let item of _data["supplementalClaims"])
                    this.supplementalClaims!.push(ApplicationSupplementalClaim.fromJS(item));
            }
            if (Array.isArray(_data["authorityDocuments"])) {
                this.authorityDocuments = [] as any;
                for (let item of _data["authorityDocuments"])
                    this.authorityDocuments!.push(ApplicationAuthorityDocument.fromJS(item));
            }
            if (Array.isArray(_data["additionalDocuments"])) {
                this.additionalDocuments = [] as any;
                for (let item of _data["additionalDocuments"])
                    this.additionalDocuments!.push(ApplicationAdditionalDocument.fromJS(item));
            }
            this.legitimation = _data["legitimation"] ? Legitimation.fromJS(_data["legitimation"]) : <any>undefined;
            this.legitimationId = _data["legitimationId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Application {
        data = typeof data === 'object' ? data : {};
        let result = new Application();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["backendSystemId"] = this.backendSystemId;
        data["applicantCaseId"] = this.applicantCaseId;
        data["caseId"] = this.caseId;
        data["type"] = this.type;
        data["status"] = this.status;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toString() : <any>undefined;
        data["responsible"] = this.responsible ? this.responsible.toJSON() : <any>undefined;
        data["responsibleId"] = this.responsibleId;
        data["applicantComment"] = this.applicantComment;
        data["dateOfDeleteNotificationSent"] = this.dateOfDeleteNotificationSent ? this.dateOfDeleteNotificationSent.toString() : <any>undefined;
        data["caseIdSearchable"] = this.caseIdSearchable;
        if (Array.isArray(this.evaluations)) {
            data["evaluations"] = [];
            for (let item of this.evaluations)
                data["evaluations"].push(item.toJSON());
        }
        if (Array.isArray(this.historyStatusEntries)) {
            data["historyStatusEntries"] = [];
            for (let item of this.historyStatusEntries)
                data["historyStatusEntries"].push(item.toJSON());
        }
        if (Array.isArray(this.historyResponsibleEntries)) {
            data["historyResponsibleEntries"] = [];
            for (let item of this.historyResponsibleEntries)
                data["historyResponsibleEntries"].push(item.toJSON());
        }
        if (Array.isArray(this.supplementalClaims)) {
            data["supplementalClaims"] = [];
            for (let item of this.supplementalClaims)
                data["supplementalClaims"].push(item.toJSON());
        }
        if (Array.isArray(this.authorityDocuments)) {
            data["authorityDocuments"] = [];
            for (let item of this.authorityDocuments)
                data["authorityDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalDocuments)) {
            data["additionalDocuments"] = [];
            for (let item of this.additionalDocuments)
                data["additionalDocuments"].push(item.toJSON());
        }
        data["legitimation"] = this.legitimation ? this.legitimation.toJSON() : <any>undefined;
        data["legitimationId"] = this.legitimationId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplication {
    user: User;
    userId: number;
    backendSystemId: number | undefined;
    applicantCaseId: string | undefined;
    caseId: string;
    type: ApplicationType;
    status: ApplicationStatus;
    dateOfStatusChange: DateTime;
    responsible: User;
    responsibleId: number | undefined;
    applicantComment: string | undefined;
    dateOfDeleteNotificationSent: DateTime | undefined;
    caseIdSearchable: string | undefined;
    evaluations: Evaluation[] | undefined;
    historyStatusEntries: ApplicationHistoryStatus[] | undefined;
    historyResponsibleEntries: ApplicationHistoryResponsible[] | undefined;
    supplementalClaims: ApplicationSupplementalClaim[] | undefined;
    authorityDocuments: ApplicationAuthorityDocument[] | undefined;
    additionalDocuments: ApplicationAdditionalDocument[] | undefined;
    legitimation: Legitimation;
    legitimationId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ApplicationAdditionalDocument implements IApplicationAdditionalDocument {
    application!: Application;
    applicationId!: number;
    type!: Code;
    typeId!: string | undefined;
    name!: string | undefined;
    mimeHeader!: string | undefined;
    binaryObject!: BinaryObject;
    binaryObjectId!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationAdditionalDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.type = new Code();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : <any>undefined;
            this.applicationId = _data["applicationId"];
            this.type = _data["type"] ? Code.fromJS(_data["type"]) : new Code();
            this.typeId = _data["typeId"];
            this.name = _data["name"];
            this.mimeHeader = _data["mimeHeader"];
            this.binaryObject = _data["binaryObject"] ? BinaryObject.fromJS(_data["binaryObject"]) : <any>undefined;
            this.binaryObjectId = _data["binaryObjectId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationAdditionalDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationAdditionalDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["applicationId"] = this.applicationId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["name"] = this.name;
        data["mimeHeader"] = this.mimeHeader;
        data["binaryObject"] = this.binaryObject ? this.binaryObject.toJSON() : <any>undefined;
        data["binaryObjectId"] = this.binaryObjectId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationAdditionalDocument {
    application: Application;
    applicationId: number;
    type: Code;
    typeId: string | undefined;
    name: string | undefined;
    mimeHeader: string | undefined;
    binaryObject: BinaryObject;
    binaryObjectId: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ApplicationAuthorityDocument implements IApplicationAuthorityDocument {
    application!: Application;
    applicationId!: number;
    applicationType!: ApplicationType;
    applicationTypeWizardStep!: number;
    type!: Code;
    typeId!: string | undefined;
    name!: string | undefined;
    mimeHeader!: string | undefined;
    binaryObject!: BinaryObject;
    binaryObjectId!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationAuthorityDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.type = new Code();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : <any>undefined;
            this.applicationId = _data["applicationId"];
            this.applicationType = _data["applicationType"];
            this.applicationTypeWizardStep = _data["applicationTypeWizardStep"];
            this.type = _data["type"] ? Code.fromJS(_data["type"]) : new Code();
            this.typeId = _data["typeId"];
            this.name = _data["name"];
            this.mimeHeader = _data["mimeHeader"];
            this.binaryObject = _data["binaryObject"] ? BinaryObject.fromJS(_data["binaryObject"]) : <any>undefined;
            this.binaryObjectId = _data["binaryObjectId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationAuthorityDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationAuthorityDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["applicationId"] = this.applicationId;
        data["applicationType"] = this.applicationType;
        data["applicationTypeWizardStep"] = this.applicationTypeWizardStep;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["name"] = this.name;
        data["mimeHeader"] = this.mimeHeader;
        data["binaryObject"] = this.binaryObject ? this.binaryObject.toJSON() : <any>undefined;
        data["binaryObjectId"] = this.binaryObjectId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationAuthorityDocument {
    application: Application;
    applicationId: number;
    applicationType: ApplicationType;
    applicationTypeWizardStep: number;
    type: Code;
    typeId: string | undefined;
    name: string | undefined;
    mimeHeader: string | undefined;
    binaryObject: BinaryObject;
    binaryObjectId: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ApplicationAuthorityHistoryDocument implements IApplicationAuthorityHistoryDocument {
    applicationTypeWizardStep!: number;
    applicationHistoryStatus!: ApplicationHistoryStatus;
    applicationHistoryStatusId!: number;
    type!: Code;
    typeId!: string | undefined;
    name!: string | undefined;
    mimeHeader!: string | undefined;
    binaryObject!: BinaryObject;
    binaryObjectId!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationAuthorityHistoryDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.type = new Code();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationTypeWizardStep = _data["applicationTypeWizardStep"];
            this.applicationHistoryStatus = _data["applicationHistoryStatus"] ? ApplicationHistoryStatus.fromJS(_data["applicationHistoryStatus"]) : <any>undefined;
            this.applicationHistoryStatusId = _data["applicationHistoryStatusId"];
            this.type = _data["type"] ? Code.fromJS(_data["type"]) : new Code();
            this.typeId = _data["typeId"];
            this.name = _data["name"];
            this.mimeHeader = _data["mimeHeader"];
            this.binaryObject = _data["binaryObject"] ? BinaryObject.fromJS(_data["binaryObject"]) : <any>undefined;
            this.binaryObjectId = _data["binaryObjectId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationAuthorityHistoryDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationAuthorityHistoryDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationTypeWizardStep"] = this.applicationTypeWizardStep;
        data["applicationHistoryStatus"] = this.applicationHistoryStatus ? this.applicationHistoryStatus.toJSON() : <any>undefined;
        data["applicationHistoryStatusId"] = this.applicationHistoryStatusId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["name"] = this.name;
        data["mimeHeader"] = this.mimeHeader;
        data["binaryObject"] = this.binaryObject ? this.binaryObject.toJSON() : <any>undefined;
        data["binaryObjectId"] = this.binaryObjectId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationAuthorityHistoryDocument {
    applicationTypeWizardStep: number;
    applicationHistoryStatus: ApplicationHistoryStatus;
    applicationHistoryStatusId: number;
    type: Code;
    typeId: string | undefined;
    name: string | undefined;
    mimeHeader: string | undefined;
    binaryObject: BinaryObject;
    binaryObjectId: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ApplicationHistoryResponsible implements IApplicationHistoryResponsible {
    applicationId!: number;
    application!: Application;
    responsibleId!: number | undefined;
    responsible!: User;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationHistoryResponsible) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : <any>undefined;
            this.responsibleId = _data["responsibleId"];
            this.responsible = _data["responsible"] ? User.fromJS(_data["responsible"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationHistoryResponsible {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationHistoryResponsible();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["responsibleId"] = this.responsibleId;
        data["responsible"] = this.responsible ? this.responsible.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationHistoryResponsible {
    applicationId: number;
    application: Application;
    responsibleId: number | undefined;
    responsible: User;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ApplicationHistoryStatus implements IApplicationHistoryStatus {
    applicationId!: number;
    application!: Application;
    status!: ApplicationStatus;
    message!: string | undefined;
    customStatusText!: string | undefined;
    creatorUser!: User;
    applicationAuthorityHistoryDocuments!: ApplicationAuthorityHistoryDocument[] | undefined;
    supplementalClaims!: ApplicationSupplementalClaim[] | undefined;
    documents!: ApplicationHistoryStatusDocument[] | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationHistoryStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : <any>undefined;
            this.status = _data["status"];
            this.message = _data["message"];
            this.customStatusText = _data["customStatusText"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            if (Array.isArray(_data["applicationAuthorityHistoryDocuments"])) {
                this.applicationAuthorityHistoryDocuments = [] as any;
                for (let item of _data["applicationAuthorityHistoryDocuments"])
                    this.applicationAuthorityHistoryDocuments!.push(ApplicationAuthorityHistoryDocument.fromJS(item));
            }
            if (Array.isArray(_data["supplementalClaims"])) {
                this.supplementalClaims = [] as any;
                for (let item of _data["supplementalClaims"])
                    this.supplementalClaims!.push(ApplicationSupplementalClaim.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(ApplicationHistoryStatusDocument.fromJS(item));
            }
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationHistoryStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationHistoryStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["message"] = this.message;
        data["customStatusText"] = this.customStatusText;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        if (Array.isArray(this.applicationAuthorityHistoryDocuments)) {
            data["applicationAuthorityHistoryDocuments"] = [];
            for (let item of this.applicationAuthorityHistoryDocuments)
                data["applicationAuthorityHistoryDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.supplementalClaims)) {
            data["supplementalClaims"] = [];
            for (let item of this.supplementalClaims)
                data["supplementalClaims"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationHistoryStatus {
    applicationId: number;
    application: Application;
    status: ApplicationStatus;
    message: string | undefined;
    customStatusText: string | undefined;
    creatorUser: User;
    applicationAuthorityHistoryDocuments: ApplicationAuthorityHistoryDocument[] | undefined;
    supplementalClaims: ApplicationSupplementalClaim[] | undefined;
    documents: ApplicationHistoryStatusDocument[] | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ApplicationHistoryStatusDocument implements IApplicationHistoryStatusDocument {
    applicationHistoryStatusId!: number;
    applicationHistoryStatus!: ApplicationHistoryStatus;
    type!: Code;
    typeId!: string | undefined;
    name!: string | undefined;
    mimeHeader!: string | undefined;
    binaryObject!: BinaryObject;
    binaryObjectId!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationHistoryStatusDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.type = new Code();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationHistoryStatusId = _data["applicationHistoryStatusId"];
            this.applicationHistoryStatus = _data["applicationHistoryStatus"] ? ApplicationHistoryStatus.fromJS(_data["applicationHistoryStatus"]) : <any>undefined;
            this.type = _data["type"] ? Code.fromJS(_data["type"]) : new Code();
            this.typeId = _data["typeId"];
            this.name = _data["name"];
            this.mimeHeader = _data["mimeHeader"];
            this.binaryObject = _data["binaryObject"] ? BinaryObject.fromJS(_data["binaryObject"]) : <any>undefined;
            this.binaryObjectId = _data["binaryObjectId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationHistoryStatusDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationHistoryStatusDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationHistoryStatusId"] = this.applicationHistoryStatusId;
        data["applicationHistoryStatus"] = this.applicationHistoryStatus ? this.applicationHistoryStatus.toJSON() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["name"] = this.name;
        data["mimeHeader"] = this.mimeHeader;
        data["binaryObject"] = this.binaryObject ? this.binaryObject.toJSON() : <any>undefined;
        data["binaryObjectId"] = this.binaryObjectId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationHistoryStatusDocument {
    applicationHistoryStatusId: number;
    applicationHistoryStatus: ApplicationHistoryStatus;
    type: Code;
    typeId: string | undefined;
    name: string | undefined;
    mimeHeader: string | undefined;
    binaryObject: BinaryObject;
    binaryObjectId: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum ApplicationStatus {
    UnderConstruction = 0,
    Submitted = 1,
    UnderEvaluation = 2,
    SupplementalClaim = 3,
    FormallyEvaluated = 4,
    Withdrawn = 6,
    UnderPreEvaluation = 9,
    Waiting = 10,
    NotConsidered = 11,
    Waitlist = 12,
}

export class ApplicationSupplementalClaim implements IApplicationSupplementalClaim {
    applicationId!: number;
    application!: Application;
    applicationHistoryStatusId!: number | undefined;
    applicationHistoryStatus!: ApplicationHistoryStatus;
    timeOfNotification!: DateTime | undefined;
    reminderDate!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationSupplementalClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : <any>undefined;
            this.applicationHistoryStatusId = _data["applicationHistoryStatusId"];
            this.applicationHistoryStatus = _data["applicationHistoryStatus"] ? ApplicationHistoryStatus.fromJS(_data["applicationHistoryStatus"]) : <any>undefined;
            this.timeOfNotification = _data["timeOfNotification"] ? DateTime.fromISO(_data["timeOfNotification"].toString()) : <any>undefined;
            this.reminderDate = _data["reminderDate"] ? DateTime.fromISO(_data["reminderDate"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationSupplementalClaim {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationSupplementalClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["applicationHistoryStatusId"] = this.applicationHistoryStatusId;
        data["applicationHistoryStatus"] = this.applicationHistoryStatus ? this.applicationHistoryStatus.toJSON() : <any>undefined;
        data["timeOfNotification"] = this.timeOfNotification ? this.timeOfNotification.toString() : <any>undefined;
        data["reminderDate"] = this.reminderDate ? this.reminderDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationSupplementalClaim {
    applicationId: number;
    application: Application;
    applicationHistoryStatusId: number | undefined;
    applicationHistoryStatus: ApplicationHistoryStatus;
    timeOfNotification: DateTime | undefined;
    reminderDate: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ApplicationVerification implements IApplicationVerification {
    liaApplication!: LiaApplication;
    liaApplicationId!: number;
    type!: VerificationType;
    valid!: boolean;
    comment!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationVerification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaApplication = new LiaApplication();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : new LiaApplication();
            this.liaApplicationId = _data["liaApplicationId"];
            this.type = _data["type"];
            this.valid = _data["valid"];
            this.comment = _data["comment"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationVerification {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationVerification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["liaApplicationId"] = this.liaApplicationId;
        data["type"] = this.type;
        data["valid"] = this.valid;
        data["comment"] = this.comment;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationVerification {
    liaApplication: LiaApplication;
    liaApplicationId: number;
    type: VerificationType;
    valid: boolean;
    comment: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class Evaluation implements IEvaluation {
    application!: Application;
    applicationId!: number;
    step!: number;
    order!: number;
    okay!: Code;
    okayId!: string | undefined;
    comment!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IEvaluation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : <any>undefined;
            this.applicationId = _data["applicationId"];
            this.step = _data["step"];
            this.order = _data["order"];
            this.okay = _data["okay"] ? Code.fromJS(_data["okay"]) : <any>undefined;
            this.okayId = _data["okayId"];
            this.comment = _data["comment"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Evaluation {
        data = typeof data === 'object' ? data : {};
        let result = new Evaluation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["applicationId"] = this.applicationId;
        data["step"] = this.step;
        data["order"] = this.order;
        data["okay"] = this.okay ? this.okay.toJSON() : <any>undefined;
        data["okayId"] = this.okayId;
        data["comment"] = this.comment;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEvaluation {
    application: Application;
    applicationId: number;
    step: number;
    order: number;
    okay: Code;
    okayId: string | undefined;
    comment: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ApplicationContextDto implements IApplicationContextDto {
    labelLanguageKey!: string | undefined;
    valueLanguageKey!: string | undefined;

    constructor(data?: IApplicationContextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labelLanguageKey = _data["labelLanguageKey"];
            this.valueLanguageKey = _data["valueLanguageKey"];
        }
    }

    static fromJS(data: any): ApplicationContextDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationContextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelLanguageKey"] = this.labelLanguageKey;
        data["valueLanguageKey"] = this.valueLanguageKey;
        return data;
    }
}

export interface IApplicationContextDto {
    labelLanguageKey: string | undefined;
    valueLanguageKey: string | undefined;
}

export class ApplicationDto implements IApplicationDto {
    caseId!: string | undefined;
    title!: string | undefined;
    name!: string | undefined;
    username!: string | undefined;
    userEmail!: string | undefined;
    legitimationId!: number | undefined;
    type!: ApplicationType;
    status!: ApplicationStatus;
    dateOfStatusChange!: DateTime;
    responsible!: string | undefined;
    amIResponsible!: boolean;
    applicantComment!: string | undefined;
    submittedCount!: number;
    applicationContext!: ApplicationContextDto[] | undefined;
    evaluations!: EvaluationDto[] | undefined;
    historyEntries!: ApplicationHistoryDto[] | undefined;
    supplementaryClaims!: ApplicationSupplementalClaimDto[] | undefined;
    emailTemplate!: EmailTemplateDto;
    canStartEvaluation!: boolean;
    authorityDocuments!: GeneralDocumentGroupDto[] | undefined;
    id!: number;

    constructor(data?: IApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.title = _data["title"];
            this.name = _data["name"];
            this.username = _data["username"];
            this.userEmail = _data["userEmail"];
            this.legitimationId = _data["legitimationId"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.responsible = _data["responsible"];
            this.amIResponsible = _data["amIResponsible"];
            this.applicantComment = _data["applicantComment"];
            this.submittedCount = _data["submittedCount"];
            if (Array.isArray(_data["applicationContext"])) {
                this.applicationContext = [] as any;
                for (let item of _data["applicationContext"])
                    this.applicationContext!.push(ApplicationContextDto.fromJS(item));
            }
            if (Array.isArray(_data["evaluations"])) {
                this.evaluations = [] as any;
                for (let item of _data["evaluations"])
                    this.evaluations!.push(EvaluationDto.fromJS(item));
            }
            if (Array.isArray(_data["historyEntries"])) {
                this.historyEntries = [] as any;
                for (let item of _data["historyEntries"])
                    this.historyEntries!.push(ApplicationHistoryDto.fromJS(item));
            }
            if (Array.isArray(_data["supplementaryClaims"])) {
                this.supplementaryClaims = [] as any;
                for (let item of _data["supplementaryClaims"])
                    this.supplementaryClaims!.push(ApplicationSupplementalClaimDto.fromJS(item));
            }
            this.emailTemplate = _data["emailTemplate"] ? EmailTemplateDto.fromJS(_data["emailTemplate"]) : <any>undefined;
            this.canStartEvaluation = _data["canStartEvaluation"];
            if (Array.isArray(_data["authorityDocuments"])) {
                this.authorityDocuments = [] as any;
                for (let item of _data["authorityDocuments"])
                    this.authorityDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["title"] = this.title;
        data["name"] = this.name;
        data["username"] = this.username;
        data["userEmail"] = this.userEmail;
        data["legitimationId"] = this.legitimationId;
        data["type"] = this.type;
        data["status"] = this.status;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toString() : <any>undefined;
        data["responsible"] = this.responsible;
        data["amIResponsible"] = this.amIResponsible;
        data["applicantComment"] = this.applicantComment;
        data["submittedCount"] = this.submittedCount;
        if (Array.isArray(this.applicationContext)) {
            data["applicationContext"] = [];
            for (let item of this.applicationContext)
                data["applicationContext"].push(item.toJSON());
        }
        if (Array.isArray(this.evaluations)) {
            data["evaluations"] = [];
            for (let item of this.evaluations)
                data["evaluations"].push(item.toJSON());
        }
        if (Array.isArray(this.historyEntries)) {
            data["historyEntries"] = [];
            for (let item of this.historyEntries)
                data["historyEntries"].push(item.toJSON());
        }
        if (Array.isArray(this.supplementaryClaims)) {
            data["supplementaryClaims"] = [];
            for (let item of this.supplementaryClaims)
                data["supplementaryClaims"].push(item.toJSON());
        }
        data["emailTemplate"] = this.emailTemplate ? this.emailTemplate.toJSON() : <any>undefined;
        data["canStartEvaluation"] = this.canStartEvaluation;
        if (Array.isArray(this.authorityDocuments)) {
            data["authorityDocuments"] = [];
            for (let item of this.authorityDocuments)
                data["authorityDocuments"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationDto {
    caseId: string | undefined;
    title: string | undefined;
    name: string | undefined;
    username: string | undefined;
    userEmail: string | undefined;
    legitimationId: number | undefined;
    type: ApplicationType;
    status: ApplicationStatus;
    dateOfStatusChange: DateTime;
    responsible: string | undefined;
    amIResponsible: boolean;
    applicantComment: string | undefined;
    submittedCount: number;
    applicationContext: ApplicationContextDto[] | undefined;
    evaluations: EvaluationDto[] | undefined;
    historyEntries: ApplicationHistoryDto[] | undefined;
    supplementaryClaims: ApplicationSupplementalClaimDto[] | undefined;
    emailTemplate: EmailTemplateDto;
    canStartEvaluation: boolean;
    authorityDocuments: GeneralDocumentGroupDto[] | undefined;
    id: number;
}

export class ApplicationHistoryDto implements IApplicationHistoryDto {
    status!: ApplicationStatus;
    text!: string | undefined;
    message!: string | undefined;
    messageHeader!: string | undefined;
    date!: DateTime;
    isResponsibleChange!: boolean;
    documents!: GeneralFileInfoDto[] | undefined;
    applicationAuthorityHistoryDocuments!: GeneralFileInfoDto[] | undefined;
    id!: number;

    constructor(data?: IApplicationHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.text = _data["text"];
            this.message = _data["message"];
            this.messageHeader = _data["messageHeader"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.isResponsibleChange = _data["isResponsibleChange"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralFileInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["applicationAuthorityHistoryDocuments"])) {
                this.applicationAuthorityHistoryDocuments = [] as any;
                for (let item of _data["applicationAuthorityHistoryDocuments"])
                    this.applicationAuthorityHistoryDocuments!.push(GeneralFileInfoDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["text"] = this.text;
        data["message"] = this.message;
        data["messageHeader"] = this.messageHeader;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["isResponsibleChange"] = this.isResponsibleChange;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.applicationAuthorityHistoryDocuments)) {
            data["applicationAuthorityHistoryDocuments"] = [];
            for (let item of this.applicationAuthorityHistoryDocuments)
                data["applicationAuthorityHistoryDocuments"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationHistoryDto {
    status: ApplicationStatus;
    text: string | undefined;
    message: string | undefined;
    messageHeader: string | undefined;
    date: DateTime;
    isResponsibleChange: boolean;
    documents: GeneralFileInfoDto[] | undefined;
    applicationAuthorityHistoryDocuments: GeneralFileInfoDto[] | undefined;
    id: number;
}

export class ApplicationJournalRecordDto implements IApplicationJournalRecordDto {
    applicationId!: number;
    message!: string | undefined;
    applicationStatus!: ApplicationStatus;
    wizardStep!: number;
    creationTime!: DateTime | undefined;
    user!: ApplicationJournalUserDto;
    id!: number;

    constructor(data?: IApplicationJournalRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.message = _data["message"];
            this.applicationStatus = _data["applicationStatus"];
            this.wizardStep = _data["wizardStep"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.user = _data["user"] ? ApplicationJournalUserDto.fromJS(_data["user"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationJournalRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationJournalRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["message"] = this.message;
        data["applicationStatus"] = this.applicationStatus;
        data["wizardStep"] = this.wizardStep;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationJournalRecordDto {
    applicationId: number;
    message: string | undefined;
    applicationStatus: ApplicationStatus;
    wizardStep: number;
    creationTime: DateTime | undefined;
    user: ApplicationJournalUserDto;
    id: number;
}

export class ApplicationJournalUserDto implements IApplicationJournalUserDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;

    constructor(data?: IApplicationJournalUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
        }
    }

    static fromJS(data: any): ApplicationJournalUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationJournalUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        return data;
    }
}

export interface IApplicationJournalUserDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
}

export class ApplicationSupplementalClaimDto implements IApplicationSupplementalClaimDto {
    applicationId!: number;
    applicationHistoryStatusId!: number | undefined;
    timeOfNotification!: DateTime | undefined;
    reminderDate!: DateTime | undefined;
    id!: number;

    constructor(data?: IApplicationSupplementalClaimDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.applicationHistoryStatusId = _data["applicationHistoryStatusId"];
            this.timeOfNotification = _data["timeOfNotification"] ? DateTime.fromISO(_data["timeOfNotification"].toString()) : <any>undefined;
            this.reminderDate = _data["reminderDate"] ? DateTime.fromISO(_data["reminderDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationSupplementalClaimDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationSupplementalClaimDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["applicationHistoryStatusId"] = this.applicationHistoryStatusId;
        data["timeOfNotification"] = this.timeOfNotification ? this.timeOfNotification.toString() : <any>undefined;
        data["reminderDate"] = this.reminderDate ? this.reminderDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationSupplementalClaimDto {
    applicationId: number;
    applicationHistoryStatusId: number | undefined;
    timeOfNotification: DateTime | undefined;
    reminderDate: DateTime | undefined;
    id: number;
}

export class AssignApplicationInput implements IAssignApplicationInput {
    caseId!: string;
    userId!: number;

    constructor(data?: IAssignApplicationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AssignApplicationInput {
        data = typeof data === 'object' ? data : {};
        let result = new AssignApplicationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAssignApplicationInput {
    caseId: string;
    userId: number;
}

export class AssignApplicationOutput implements IAssignApplicationOutput {
    responsible!: string | undefined;
    userId!: number | undefined;

    constructor(data?: IAssignApplicationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responsible = _data["responsible"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AssignApplicationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AssignApplicationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responsible"] = this.responsible;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAssignApplicationOutput {
    responsible: string | undefined;
    userId: number | undefined;
}

export enum CompletionStatus {
    Incomplete = 0,
    Complete = 1,
}

export class CreateApplicationJournalRecordInput implements ICreateApplicationJournalRecordInput {
    caseId!: string | undefined;
    message!: string | undefined;
    wizardStep!: number | undefined;

    constructor(data?: ICreateApplicationJournalRecordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.message = _data["message"];
            this.wizardStep = _data["wizardStep"];
        }
    }

    static fromJS(data: any): CreateApplicationJournalRecordInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApplicationJournalRecordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["message"] = this.message;
        data["wizardStep"] = this.wizardStep;
        return data;
    }
}

export interface ICreateApplicationJournalRecordInput {
    caseId: string | undefined;
    message: string | undefined;
    wizardStep: number | undefined;
}

export class EmailTemplateDto implements IEmailTemplateDto {
    languageOfCorrespondenceId!: string | undefined;
    supplementalClaimTemplate!: string | undefined;
    rejectionTemplate!: string | undefined;

    constructor(data?: IEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.supplementalClaimTemplate = _data["supplementalClaimTemplate"];
            this.rejectionTemplate = _data["rejectionTemplate"];
        }
    }

    static fromJS(data: any): EmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["supplementalClaimTemplate"] = this.supplementalClaimTemplate;
        data["rejectionTemplate"] = this.rejectionTemplate;
        return data;
    }
}

export interface IEmailTemplateDto {
    languageOfCorrespondenceId: string | undefined;
    supplementalClaimTemplate: string | undefined;
    rejectionTemplate: string | undefined;
}

export class EvaluationDto implements IEvaluationDto {
    step!: number;
    okayId!: string | undefined;
    order!: number;
    comment!: string | undefined;
    id!: number;

    constructor(data?: IEvaluationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.step = _data["step"];
            this.okayId = _data["okayId"];
            this.order = _data["order"];
            this.comment = _data["comment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EvaluationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step;
        data["okayId"] = this.okayId;
        data["order"] = this.order;
        data["comment"] = this.comment;
        data["id"] = this.id;
        return data;
    }
}

export interface IEvaluationDto {
    step: number;
    okayId: string | undefined;
    order: number;
    comment: string | undefined;
    id: number;
}

export class EvaluationInput implements IEvaluationInput {
    caseId!: string;
    evaluation!: EvaluationDto;

    constructor(data?: IEvaluationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.evaluation = new EvaluationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.evaluation = _data["evaluation"] ? EvaluationDto.fromJS(_data["evaluation"]) : new EvaluationDto();
        }
    }

    static fromJS(data: any): EvaluationInput {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["evaluation"] = this.evaluation ? this.evaluation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEvaluationInput {
    caseId: string;
    evaluation: EvaluationDto;
}

export class GetEhcApplicationsOutput implements IGetEhcApplicationsOutput {
    totalCount!: number;
    items!: EhcSearchDto[] | undefined;

    constructor(data?: IGetEhcApplicationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EhcSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEhcApplicationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEhcApplicationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEhcApplicationsOutput {
    totalCount: number;
    items: EhcSearchDto[] | undefined;
}

export class GetResultDocumentsOutput implements IGetResultDocumentsOutput {
    caseId!: string;
    resultDocuments!: GeneralFileInfoDto[];

    constructor(data?: IGetResultDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.resultDocuments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["resultDocuments"])) {
                this.resultDocuments = [] as any;
                for (let item of _data["resultDocuments"])
                    this.resultDocuments!.push(GeneralFileInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetResultDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetResultDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.resultDocuments)) {
            data["resultDocuments"] = [];
            for (let item of this.resultDocuments)
                data["resultDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetResultDocumentsOutput {
    caseId: string;
    resultDocuments: GeneralFileInfoDto[];
}

export class NotConsiderApplicationInputDto implements INotConsiderApplicationInputDto {
    message!: string;
    documents!: GeneralFileDto[] | undefined;

    constructor(data?: INotConsiderApplicationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotConsiderApplicationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotConsiderApplicationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface INotConsiderApplicationInputDto {
    message: string;
    documents: GeneralFileDto[] | undefined;
}

export class RequestForSupplementalInformationInput implements IRequestForSupplementalInformationInput {
    caseId!: string;
    message!: string | undefined;
    isReminder!: boolean;

    constructor(data?: IRequestForSupplementalInformationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.message = _data["message"];
            this.isReminder = _data["isReminder"];
        }
    }

    static fromJS(data: any): RequestForSupplementalInformationInput {
        data = typeof data === 'object' ? data : {};
        let result = new RequestForSupplementalInformationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["message"] = this.message;
        data["isReminder"] = this.isReminder;
        return data;
    }
}

export interface IRequestForSupplementalInformationInput {
    caseId: string;
    message: string | undefined;
    isReminder: boolean;
}

export class SetSupplementalInformationReminderDateInput implements ISetSupplementalInformationReminderDateInput {
    caseId!: string;
    reminderDate!: DateTime | undefined;

    constructor(data?: ISetSupplementalInformationReminderDateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.reminderDate = _data["reminderDate"] ? DateTime.fromISO(_data["reminderDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SetSupplementalInformationReminderDateInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetSupplementalInformationReminderDateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["reminderDate"] = this.reminderDate ? this.reminderDate.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface ISetSupplementalInformationReminderDateInput {
    caseId: string;
    reminderDate: DateTime | undefined;
}

export class StatusVisibility implements IStatusVisibility {
    status!: number;
    visibility!: TabVisibility;

    constructor(data?: IStatusVisibility) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.visibility = _data["visibility"];
        }
    }

    static fromJS(data: any): StatusVisibility {
        data = typeof data === 'object' ? data : {};
        let result = new StatusVisibility();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["visibility"] = this.visibility;
        return data;
    }
}

export interface IStatusVisibility {
    status: number;
    visibility: TabVisibility;
}

export class WithdrawApplicationInputDto implements IWithdrawApplicationInputDto {
    message!: string | undefined;
    documents!: GeneralFileDto[] | undefined;

    constructor(data?: IWithdrawApplicationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WithdrawApplicationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new WithdrawApplicationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWithdrawApplicationInputDto {
    message: string | undefined;
    documents: GeneralFileDto[] | undefined;
}

export enum VerificationType {
    LiaPerson = 0,
    LiaContactComment = 1,
    LiaRestriction = 2,
    LiaEmployments = 3,
    LiaInvoiceAddress = 4,
    LiaDocuments = 5,
}

export class AlaAcademicTitleDto implements IAlaAcademicTitleDto {
    title!: string | undefined;
    bodyOfIssue!: string | undefined;
    placeOfIssue!: string | undefined;
    countryOfIssueId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    id!: number;

    constructor(data?: IAlaAcademicTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.bodyOfIssue = _data["bodyOfIssue"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryOfIssueId = _data["countryOfIssueId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AlaAcademicTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaAcademicTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["bodyOfIssue"] = this.bodyOfIssue;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryOfIssueId"] = this.countryOfIssueId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IAlaAcademicTitleDto {
    title: string | undefined;
    bodyOfIssue: string | undefined;
    placeOfIssue: string | undefined;
    countryOfIssueId: string | undefined;
    dateOfIssue: DateTime | undefined;
    id: number;
}

export class AlaApplicantContactDto implements IAlaApplicantContactDto {
    titleId!: string;
    languageOfCorrespondenceId!: string | undefined;
    street!: string;
    streetNr!: string | undefined;
    postCode!: string;
    city!: string;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    email!: string;
    phone1!: string;
    phone2!: string | undefined;
    titleAddressSwiss!: string | undefined;
    streetSwiss!: string | undefined;
    streetNrSwiss!: string | undefined;
    postCodeSwiss!: string | undefined;
    citySwiss!: string | undefined;
    postOfficeBoxSwiss!: string | undefined;
    addressAdditionSwiss!: string | undefined;

    constructor(data?: IAlaApplicantContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.titleAddressSwiss = _data["titleAddressSwiss"];
            this.streetSwiss = _data["streetSwiss"];
            this.streetNrSwiss = _data["streetNrSwiss"];
            this.postCodeSwiss = _data["postCodeSwiss"];
            this.citySwiss = _data["citySwiss"];
            this.postOfficeBoxSwiss = _data["postOfficeBoxSwiss"];
            this.addressAdditionSwiss = _data["addressAdditionSwiss"];
        }
    }

    static fromJS(data: any): AlaApplicantContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaApplicantContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["titleAddressSwiss"] = this.titleAddressSwiss;
        data["streetSwiss"] = this.streetSwiss;
        data["streetNrSwiss"] = this.streetNrSwiss;
        data["postCodeSwiss"] = this.postCodeSwiss;
        data["citySwiss"] = this.citySwiss;
        data["postOfficeBoxSwiss"] = this.postOfficeBoxSwiss;
        data["addressAdditionSwiss"] = this.addressAdditionSwiss;
        return data;
    }
}

export interface IAlaApplicantContactDto {
    titleId: string;
    languageOfCorrespondenceId: string | undefined;
    street: string;
    streetNr: string | undefined;
    postCode: string;
    city: string;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    email: string;
    phone1: string;
    phone2: string | undefined;
    titleAddressSwiss: string | undefined;
    streetSwiss: string | undefined;
    streetNrSwiss: string | undefined;
    postCodeSwiss: string | undefined;
    citySwiss: string | undefined;
    postOfficeBoxSwiss: string | undefined;
    addressAdditionSwiss: string | undefined;
}

export class AlaApplicantPersonDto implements IAlaApplicantPersonDto {
    gln!: string | undefined;
    healthRegisterResult!: HealthRegisterIdentificationStatus;
    hasConfirmedData!: boolean;

    constructor(data?: IAlaApplicantPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.healthRegisterResult = _data["healthRegisterResult"];
            this.hasConfirmedData = _data["hasConfirmedData"];
        }
    }

    static fromJS(data: any): AlaApplicantPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaApplicantPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["healthRegisterResult"] = this.healthRegisterResult;
        data["hasConfirmedData"] = this.hasConfirmedData;
        return data;
    }
}

export interface IAlaApplicantPersonDto {
    gln: string | undefined;
    healthRegisterResult: HealthRegisterIdentificationStatus;
    hasConfirmedData: boolean;
}

export class AlaApplicantSponsorshipDto implements IAlaApplicantSponsorshipDto {
    uid!: string;
    name!: string;
    additionalName!: string | undefined;
    legalFormId!: string;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    invoiceEmail!: string | undefined;
    website!: string | undefined;
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IAlaApplicantSponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.invoiceEmail = _data["invoiceEmail"];
            this.website = _data["website"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlaApplicantSponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaApplicantSponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["invoiceEmail"] = this.invoiceEmail;
        data["website"] = this.website;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAlaApplicantSponsorshipDto {
    uid: string;
    name: string;
    additionalName: string | undefined;
    legalFormId: string;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    invoiceEmail: string | undefined;
    website: string | undefined;
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class AlaBusinessDto implements IAlaBusinessDto {
    employmentId!: number | undefined;
    businessId!: number | undefined;
    isAssistanceEmployment!: boolean;
    isMobileEmployment!: boolean;
    name!: string | undefined;
    legalFormId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    countryId!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    id!: number;

    constructor(data?: IAlaBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employmentId = _data["employmentId"];
            this.businessId = _data["businessId"];
            this.isAssistanceEmployment = _data["isAssistanceEmployment"];
            this.isMobileEmployment = _data["isMobileEmployment"];
            this.name = _data["name"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.countryId = _data["countryId"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AlaBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employmentId"] = this.employmentId;
        data["businessId"] = this.businessId;
        data["isAssistanceEmployment"] = this.isAssistanceEmployment;
        data["isMobileEmployment"] = this.isMobileEmployment;
        data["name"] = this.name;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["countryId"] = this.countryId;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["id"] = this.id;
        return data;
    }
}

export interface IAlaBusinessDto {
    employmentId: number | undefined;
    businessId: number | undefined;
    isAssistanceEmployment: boolean;
    isMobileEmployment: boolean;
    name: string | undefined;
    legalFormId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    countryId: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    dateOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    id: number;
}

export class AlaBusinessExtrDto implements IAlaBusinessExtrDto {
    medicalFieldDirectorGln!: string;
    businessName!: string;
    legalFormId!: string | undefined;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    dateOfEmployment!: DateTime;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number;
    postgraduateTitleId!: string;
    healthRegisterResult!: HealthRegisterIdentificationStatus;

    constructor(data?: IAlaBusinessExtrDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalFieldDirectorGln = _data["medicalFieldDirectorGln"];
            this.businessName = _data["businessName"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.healthRegisterResult = _data["healthRegisterResult"];
        }
    }

    static fromJS(data: any): AlaBusinessExtrDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaBusinessExtrDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalFieldDirectorGln"] = this.medicalFieldDirectorGln;
        data["businessName"] = this.businessName;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["healthRegisterResult"] = this.healthRegisterResult;
        return data;
    }
}

export interface IAlaBusinessExtrDto {
    medicalFieldDirectorGln: string;
    businessName: string;
    legalFormId: string | undefined;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    dateOfEmployment: DateTime;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number;
    postgraduateTitleId: string;
    healthRegisterResult: HealthRegisterIdentificationStatus;
}

export class AlaContactDto implements IAlaContactDto {
    titleId!: string;
    languageOfCorrespondenceId!: string | undefined;
    street!: string;
    streetNr!: string | undefined;
    postCode!: string;
    city!: string;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    email!: string;
    phone1!: string;
    phone2!: string | undefined;

    constructor(data?: IAlaContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
        }
    }

    static fromJS(data: any): AlaContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        return data;
    }
}

export interface IAlaContactDto {
    titleId: string;
    languageOfCorrespondenceId: string | undefined;
    street: string;
    streetNr: string | undefined;
    postCode: string;
    city: string;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    email: string;
    phone1: string;
    phone2: string | undefined;
}

export class AlaDiplomaDto implements IAlaDiplomaDto {
    professionId!: string | undefined;
    countryOfIssueId!: string | undefined;
    isInEducationId!: string | undefined;
    postgraduateTitleId!: string | undefined;
    placeOfEducation!: string | undefined;
    assistantGln!: string | undefined;

    constructor(data?: IAlaDiplomaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.countryOfIssueId = _data["countryOfIssueId"];
            this.isInEducationId = _data["isInEducationId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.placeOfEducation = _data["placeOfEducation"];
            this.assistantGln = _data["assistantGln"];
        }
    }

    static fromJS(data: any): AlaDiplomaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaDiplomaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["countryOfIssueId"] = this.countryOfIssueId;
        data["isInEducationId"] = this.isInEducationId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["placeOfEducation"] = this.placeOfEducation;
        data["assistantGln"] = this.assistantGln;
        return data;
    }
}

export interface IAlaDiplomaDto {
    professionId: string | undefined;
    countryOfIssueId: string | undefined;
    isInEducationId: string | undefined;
    postgraduateTitleId: string | undefined;
    placeOfEducation: string | undefined;
    assistantGln: string | undefined;
}

export class AlaDocumentsOutput implements IAlaDocumentsOutput {
    caseId!: string;
    documents!: GeneralDocumentGroupDto[];

    constructor(data?: IAlaDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlaDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AlaDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAlaDocumentsOutput {
    caseId: string;
    documents: GeneralDocumentGroupDto[];
}

export class AlaDto implements IAlaDto {
    application!: ApplicationDto;
    professionId!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    currentStep!: AlaStatus;
    statusId!: AlaStatus;
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IAlaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.professionId = _data["professionId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.currentStep = _data["currentStep"];
            this.statusId = _data["statusId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["professionId"] = this.professionId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["currentStep"] = this.currentStep;
        data["statusId"] = this.statusId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAlaDto {
    application: ApplicationDto;
    professionId: string | undefined;
    sponsorshipTypeId: string | undefined;
    currentStep: AlaStatus;
    statusId: AlaStatus;
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class AlaEmploymentDto implements IAlaEmploymentDto {
    levelOfEmployment!: number;
    dateOfEmployment!: DateTime;
    dateOfEndOfEmployment!: DateTime;
    alaBusiness!: AlaBusinessDto;
    documents!: GeneralDocumentGroupDto[] | undefined;
    id!: number;

    constructor(data?: IAlaEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.alaBusiness = _data["alaBusiness"] ? AlaBusinessDto.fromJS(_data["alaBusiness"]) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AlaEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["alaBusiness"] = this.alaBusiness ? this.alaBusiness.toJSON() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IAlaEmploymentDto {
    levelOfEmployment: number;
    dateOfEmployment: DateTime;
    dateOfEndOfEmployment: DateTime;
    alaBusiness: AlaBusinessDto;
    documents: GeneralDocumentGroupDto[] | undefined;
    id: number;
}

export class AlaInvoiceAddressDto implements IAlaInvoiceAddressDto {
    typeOfAddressId!: string;
    employmentId!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    additionalAddressLine!: string | undefined;

    constructor(data?: IAlaInvoiceAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeOfAddressId = _data["typeOfAddressId"];
            this.employmentId = _data["employmentId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.additionalAddressLine = _data["additionalAddressLine"];
        }
    }

    static fromJS(data: any): AlaInvoiceAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaInvoiceAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOfAddressId"] = this.typeOfAddressId;
        data["employmentId"] = this.employmentId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["additionalAddressLine"] = this.additionalAddressLine;
        return data;
    }
}

export interface IAlaInvoiceAddressDto {
    typeOfAddressId: string;
    employmentId: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    additionalAddressLine: string | undefined;
}

export class AlaLanguageSkillDto implements IAlaLanguageSkillDto {
    languageSkillId!: string;
    comments!: string | undefined;

    constructor(data?: IAlaLanguageSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageSkillId = _data["languageSkillId"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): AlaLanguageSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaLanguageSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageSkillId"] = this.languageSkillId;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IAlaLanguageSkillDto {
    languageSkillId: string;
    comments: string | undefined;
}

export class AlaLanguageSkillExtrDto implements IAlaLanguageSkillExtrDto {
    timeToExamId!: string;

    constructor(data?: IAlaLanguageSkillExtrDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeToExamId = _data["timeToExamId"];
        }
    }

    static fromJS(data: any): AlaLanguageSkillExtrDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaLanguageSkillExtrDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeToExamId"] = this.timeToExamId;
        return data;
    }
}

export interface IAlaLanguageSkillExtrDto {
    timeToExamId: string;
}

export class AlaMedicalFieldDirectorDto implements IAlaMedicalFieldDirectorDto {
    firstName!: string;
    lastName!: string;
    gln!: string;
    licenceTypeId!: string | undefined;
    licenceCantonId!: string | undefined;
    licenceStatusId!: string | undefined;
    activityStatusId!: string | undefined;

    constructor(data?: IAlaMedicalFieldDirectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gln = _data["gln"];
            this.licenceTypeId = _data["licenceTypeId"];
            this.licenceCantonId = _data["licenceCantonId"];
            this.licenceStatusId = _data["licenceStatusId"];
            this.activityStatusId = _data["activityStatusId"];
        }
    }

    static fromJS(data: any): AlaMedicalFieldDirectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaMedicalFieldDirectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gln"] = this.gln;
        data["licenceTypeId"] = this.licenceTypeId;
        data["licenceCantonId"] = this.licenceCantonId;
        data["licenceStatusId"] = this.licenceStatusId;
        data["activityStatusId"] = this.activityStatusId;
        return data;
    }
}

export interface IAlaMedicalFieldDirectorDto {
    firstName: string;
    lastName: string;
    gln: string;
    licenceTypeId: string | undefined;
    licenceCantonId: string | undefined;
    licenceStatusId: string | undefined;
    activityStatusId: string | undefined;
}

export class AlaMedicalFieldDto implements IAlaMedicalFieldDto {
    id!: number | undefined;
    postgraduateTitleId!: string;

    constructor(data?: IAlaMedicalFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
        }
    }

    static fromJS(data: any): AlaMedicalFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaMedicalFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        return data;
    }
}

export interface IAlaMedicalFieldDto {
    id: number | undefined;
    postgraduateTitleId: string;
}

export class AlaPersonDto implements IAlaPersonDto {
    gln!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    birthName!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    genderId!: string | undefined;
    nationality1Id!: string | undefined;
    nationality2Id!: string | undefined;
    placeOfOrigin!: string | undefined;
    ahv!: string | undefined;
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IAlaPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.genderId = _data["genderId"];
            this.nationality1Id = _data["nationality1Id"];
            this.nationality2Id = _data["nationality2Id"];
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.ahv = _data["ahv"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlaPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["genderId"] = this.genderId;
        data["nationality1Id"] = this.nationality1Id;
        data["nationality2Id"] = this.nationality2Id;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["ahv"] = this.ahv;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAlaPersonDto {
    gln: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    birthName: string | undefined;
    dateOfBirth: DateTime | undefined;
    genderId: string | undefined;
    nationality1Id: string | undefined;
    nationality2Id: string | undefined;
    placeOfOrigin: string | undefined;
    ahv: string | undefined;
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class AlaPostgraduateTitleDto implements IAlaPostgraduateTitleDto {
    id!: number | undefined;
    isInGeneralMedicalPractitionerFieldId!: string;
    postgraduateTitleId!: string | undefined;
    startOfEducation!: DateTime | undefined;
    endOfEducation!: DateTime | undefined;
    businessName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;

    constructor(data?: IAlaPostgraduateTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isInGeneralMedicalPractitionerFieldId = _data["isInGeneralMedicalPractitionerFieldId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.startOfEducation = _data["startOfEducation"] ? DateTime.fromISO(_data["startOfEducation"].toString()) : <any>undefined;
            this.endOfEducation = _data["endOfEducation"] ? DateTime.fromISO(_data["endOfEducation"].toString()) : <any>undefined;
            this.businessName = _data["businessName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
        }
    }

    static fromJS(data: any): AlaPostgraduateTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaPostgraduateTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isInGeneralMedicalPractitionerFieldId"] = this.isInGeneralMedicalPractitionerFieldId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["startOfEducation"] = this.startOfEducation ? this.startOfEducation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["endOfEducation"] = this.endOfEducation ? this.endOfEducation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessName"] = this.businessName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        return data;
    }
}

export interface IAlaPostgraduateTitleDto {
    id: number | undefined;
    isInGeneralMedicalPractitionerFieldId: string;
    postgraduateTitleId: string | undefined;
    startOfEducation: DateTime | undefined;
    endOfEducation: DateTime | undefined;
    businessName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
}

export class AlaPreviousEmploymentDto implements IAlaPreviousEmploymentDto {
    id!: number | undefined;
    businessName!: string;
    additionalName!: string | undefined;
    countryId!: string;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    dateOfEmployment!: DateTime;
    dateOfEndOfEmployment!: DateTime;
    levelOfEmployment!: number;
    postgraduateTitleId!: string;

    constructor(data?: IAlaPreviousEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessName = _data["businessName"];
            this.additionalName = _data["additionalName"];
            this.countryId = _data["countryId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
        }
    }

    static fromJS(data: any): AlaPreviousEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaPreviousEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessName"] = this.businessName;
        data["additionalName"] = this.additionalName;
        data["countryId"] = this.countryId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        return data;
    }
}

export interface IAlaPreviousEmploymentDto {
    id: number | undefined;
    businessName: string;
    additionalName: string | undefined;
    countryId: string;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    dateOfEmployment: DateTime;
    dateOfEndOfEmployment: DateTime;
    levelOfEmployment: number;
    postgraduateTitleId: string;
}

export class AlaRestrictionDto implements IAlaRestrictionDto {
    cantonId!: string;
    reason!: string | undefined;
    type!: AlaRestrictionType;

    constructor(data?: IAlaRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantonId = _data["cantonId"];
            this.reason = _data["reason"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): AlaRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantonId"] = this.cantonId;
        data["reason"] = this.reason;
        data["type"] = this.type;
        return data;
    }
}

export interface IAlaRestrictionDto {
    cantonId: string;
    reason: string | undefined;
    type: AlaRestrictionType;
}

export class AlaRestrictionGeneralInformationDto implements IAlaRestrictionGeneralInformationDto {
    hasRestrictionsId!: string | undefined;
    hasOngoingRestrictionProcedureId!: string | undefined;
    hasOngoingLiaRequestInAnotherCantonId!: string | undefined;
    hasAnyImpairmentRelatedToPracticeId!: string | undefined;
    hasJudgementInSwissCriminalRecordId!: string | undefined;

    constructor(data?: IAlaRestrictionGeneralInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasRestrictionsId = _data["hasRestrictionsId"];
            this.hasOngoingRestrictionProcedureId = _data["hasOngoingRestrictionProcedureId"];
            this.hasOngoingLiaRequestInAnotherCantonId = _data["hasOngoingLiaRequestInAnotherCantonId"];
            this.hasAnyImpairmentRelatedToPracticeId = _data["hasAnyImpairmentRelatedToPracticeId"];
            this.hasJudgementInSwissCriminalRecordId = _data["hasJudgementInSwissCriminalRecordId"];
        }
    }

    static fromJS(data: any): AlaRestrictionGeneralInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaRestrictionGeneralInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasRestrictionsId"] = this.hasRestrictionsId;
        data["hasOngoingRestrictionProcedureId"] = this.hasOngoingRestrictionProcedureId;
        data["hasOngoingLiaRequestInAnotherCantonId"] = this.hasOngoingLiaRequestInAnotherCantonId;
        data["hasAnyImpairmentRelatedToPracticeId"] = this.hasAnyImpairmentRelatedToPracticeId;
        data["hasJudgementInSwissCriminalRecordId"] = this.hasJudgementInSwissCriminalRecordId;
        return data;
    }
}

export interface IAlaRestrictionGeneralInformationDto {
    hasRestrictionsId: string | undefined;
    hasOngoingRestrictionProcedureId: string | undefined;
    hasOngoingLiaRequestInAnotherCantonId: string | undefined;
    hasAnyImpairmentRelatedToPracticeId: string | undefined;
    hasJudgementInSwissCriminalRecordId: string | undefined;
}

export class AlaRestrictionOutput implements IAlaRestrictionOutput {
    restrictionGeneralInformation!: AlaRestrictionGeneralInformationDto;
    restrictions!: AlaRestrictionDto[] | undefined;
    assistantGln!: string | undefined;

    constructor(data?: IAlaRestrictionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.restrictionGeneralInformation = _data["restrictionGeneralInformation"] ? AlaRestrictionGeneralInformationDto.fromJS(_data["restrictionGeneralInformation"]) : <any>undefined;
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(AlaRestrictionDto.fromJS(item));
            }
            this.assistantGln = _data["assistantGln"];
        }
    }

    static fromJS(data: any): AlaRestrictionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AlaRestrictionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["restrictionGeneralInformation"] = this.restrictionGeneralInformation ? this.restrictionGeneralInformation.toJSON() : <any>undefined;
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        data["assistantGln"] = this.assistantGln;
        return data;
    }
}

export interface IAlaRestrictionOutput {
    restrictionGeneralInformation: AlaRestrictionGeneralInformationDto;
    restrictions: AlaRestrictionDto[] | undefined;
    assistantGln: string | undefined;
}

export enum AlaRestrictionType {
    CantonalRestriction = 0,
    CantonalOngoingLegalProceedings = 1,
}

export enum AlaStatus {
    ApplicantPerson = 0,
    ApplicantSponsorship = 1,
    MedicalFieldDirector = 2,
    Person = 3,
    Contact = 4,
    Diploma = 5,
    AcademicTitle = 6,
    LanguageSkill = 7,
    MedicalField = 8,
    Business = 9,
    Employment = 10,
    PreviousEmployment = 11,
    Restriction = 12,
    InvoiceAddress = 14,
    ApplicantContact = 15,
    PostgraduateTitle = 16,
    ApplicantPersonExtr = 17,
    LanguageSkillExtr = 18,
    BusinessExtr = 19,
    Release = 97,
    Released = 98,
    FinishReview = 99,
    EndeGelende = 100,
}

export class CreateAlaInput implements ICreateAlaInput {
    applicationType!: ApplicationType;
    legitimationId!: number | undefined;
    professionId!: string | undefined;
    sponsorshipTypeId!: string | undefined;

    constructor(data?: ICreateAlaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationType = _data["applicationType"];
            this.legitimationId = _data["legitimationId"];
            this.professionId = _data["professionId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
        }
    }

    static fromJS(data: any): CreateAlaInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAlaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationType"] = this.applicationType;
        data["legitimationId"] = this.legitimationId;
        data["professionId"] = this.professionId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        return data;
    }
}

export interface ICreateAlaInput {
    applicationType: ApplicationType;
    legitimationId: number | undefined;
    professionId: string | undefined;
    sponsorshipTypeId: string | undefined;
}

export class CreateAlaOutput implements ICreateAlaOutput {
    caseId!: string | undefined;

    constructor(data?: ICreateAlaOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): CreateAlaOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAlaOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface ICreateAlaOutput {
    caseId: string | undefined;
}

export class CreateOrUpdateAlaAcademicTitleInput implements ICreateOrUpdateAlaAcademicTitleInput {
    caseId!: string;
    academicTitles!: AlaAcademicTitleDto[];

    constructor(data?: ICreateOrUpdateAlaAcademicTitleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.academicTitles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["academicTitles"])) {
                this.academicTitles = [] as any;
                for (let item of _data["academicTitles"])
                    this.academicTitles!.push(AlaAcademicTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaAcademicTitleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaAcademicTitleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.academicTitles)) {
            data["academicTitles"] = [];
            for (let item of this.academicTitles)
                data["academicTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateAlaAcademicTitleInput {
    caseId: string;
    academicTitles: AlaAcademicTitleDto[];
}

export class CreateOrUpdateAlaAcademicTitleOutput implements ICreateOrUpdateAlaAcademicTitleOutput {
    status!: AlaStatus;
    academicTitles!: AlaAcademicTitleDto[] | undefined;

    constructor(data?: ICreateOrUpdateAlaAcademicTitleOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["academicTitles"])) {
                this.academicTitles = [] as any;
                for (let item of _data["academicTitles"])
                    this.academicTitles!.push(AlaAcademicTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaAcademicTitleOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaAcademicTitleOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.academicTitles)) {
            data["academicTitles"] = [];
            for (let item of this.academicTitles)
                data["academicTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateAlaAcademicTitleOutput {
    status: AlaStatus;
    academicTitles: AlaAcademicTitleDto[] | undefined;
}

export class CreateOrUpdateAlaApplicantContact implements ICreateOrUpdateAlaApplicantContact {
    caseId!: string;
    contact!: AlaApplicantContactDto;

    constructor(data?: ICreateOrUpdateAlaApplicantContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contact = new AlaApplicantContactDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.contact = _data["contact"] ? AlaApplicantContactDto.fromJS(_data["contact"]) : new AlaApplicantContactDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaApplicantContact {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaApplicantContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateAlaApplicantContact {
    caseId: string;
    contact: AlaApplicantContactDto;
}

export class CreateOrUpdateAlaApplicantSponsorship implements ICreateOrUpdateAlaApplicantSponsorship {
    caseId!: string;
    applicantSponsorship!: AlaApplicantSponsorshipDto;

    constructor(data?: ICreateOrUpdateAlaApplicantSponsorship) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.applicantSponsorship = new AlaApplicantSponsorshipDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.applicantSponsorship = _data["applicantSponsorship"] ? AlaApplicantSponsorshipDto.fromJS(_data["applicantSponsorship"]) : new AlaApplicantSponsorshipDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaApplicantSponsorship {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaApplicantSponsorship();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["applicantSponsorship"] = this.applicantSponsorship ? this.applicantSponsorship.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateAlaApplicantSponsorship {
    caseId: string;
    applicantSponsorship: AlaApplicantSponsorshipDto;
}

export class CreateOrUpdateAlaBusinessExtr implements ICreateOrUpdateAlaBusinessExtr {
    caseId!: string;
    business!: AlaBusinessExtrDto;

    constructor(data?: ICreateOrUpdateAlaBusinessExtr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.business = new AlaBusinessExtrDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.business = _data["business"] ? AlaBusinessExtrDto.fromJS(_data["business"]) : new AlaBusinessExtrDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaBusinessExtr {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaBusinessExtr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateAlaBusinessExtr {
    caseId: string;
    business: AlaBusinessExtrDto;
}

export class CreateOrUpdateAlaContact implements ICreateOrUpdateAlaContact {
    caseId!: string;
    contact!: AlaContactDto;

    constructor(data?: ICreateOrUpdateAlaContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contact = new AlaContactDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.contact = _data["contact"] ? AlaContactDto.fromJS(_data["contact"]) : new AlaContactDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaContact {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateAlaContact {
    caseId: string;
    contact: AlaContactDto;
}

export class CreateOrUpdateAlaDiploma implements ICreateOrUpdateAlaDiploma {
    caseId!: string;
    diploma!: AlaDiplomaDto;

    constructor(data?: ICreateOrUpdateAlaDiploma) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.diploma = new AlaDiplomaDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.diploma = _data["diploma"] ? AlaDiplomaDto.fromJS(_data["diploma"]) : new AlaDiplomaDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaDiploma {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaDiploma();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["diploma"] = this.diploma ? this.diploma.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateAlaDiploma {
    caseId: string;
    diploma: AlaDiplomaDto;
}

export class CreateOrUpdateAlaEmploymentInput implements ICreateOrUpdateAlaEmploymentInput {
    caseId!: string;
    employments!: AlaEmploymentDto[];

    constructor(data?: ICreateOrUpdateAlaEmploymentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.employments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(AlaEmploymentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaEmploymentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaEmploymentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateAlaEmploymentInput {
    caseId: string;
    employments: AlaEmploymentDto[];
}

export class CreateOrUpdateAlaLanguageSkillExtrInput implements ICreateOrUpdateAlaLanguageSkillExtrInput {
    caseId!: string;
    languageSkill!: AlaLanguageSkillExtrDto;

    constructor(data?: ICreateOrUpdateAlaLanguageSkillExtrInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.languageSkill = new AlaLanguageSkillExtrDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.languageSkill = _data["languageSkill"] ? AlaLanguageSkillExtrDto.fromJS(_data["languageSkill"]) : new AlaLanguageSkillExtrDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaLanguageSkillExtrInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaLanguageSkillExtrInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["languageSkill"] = this.languageSkill ? this.languageSkill.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateAlaLanguageSkillExtrInput {
    caseId: string;
    languageSkill: AlaLanguageSkillExtrDto;
}

export class CreateOrUpdateAlaLanguageSkillInput implements ICreateOrUpdateAlaLanguageSkillInput {
    caseId!: string;
    languageSkill!: AlaLanguageSkillDto;

    constructor(data?: ICreateOrUpdateAlaLanguageSkillInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.languageSkill = new AlaLanguageSkillDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.languageSkill = _data["languageSkill"] ? AlaLanguageSkillDto.fromJS(_data["languageSkill"]) : new AlaLanguageSkillDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaLanguageSkillInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaLanguageSkillInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["languageSkill"] = this.languageSkill ? this.languageSkill.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateAlaLanguageSkillInput {
    caseId: string;
    languageSkill: AlaLanguageSkillDto;
}

export class CreateOrUpdateAlaMedicalFieldDirector implements ICreateOrUpdateAlaMedicalFieldDirector {
    caseId!: string;
    medicalFieldDirector!: AlaMedicalFieldDirectorDto;

    constructor(data?: ICreateOrUpdateAlaMedicalFieldDirector) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medicalFieldDirector = new AlaMedicalFieldDirectorDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.medicalFieldDirector = _data["medicalFieldDirector"] ? AlaMedicalFieldDirectorDto.fromJS(_data["medicalFieldDirector"]) : new AlaMedicalFieldDirectorDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaMedicalFieldDirector {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaMedicalFieldDirector();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["medicalFieldDirector"] = this.medicalFieldDirector ? this.medicalFieldDirector.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateAlaMedicalFieldDirector {
    caseId: string;
    medicalFieldDirector: AlaMedicalFieldDirectorDto;
}

export class CreateOrUpdateAlaMedicalFieldInput implements ICreateOrUpdateAlaMedicalFieldInput {
    caseId!: string;
    medicalField!: AlaMedicalFieldDto;

    constructor(data?: ICreateOrUpdateAlaMedicalFieldInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medicalField = new AlaMedicalFieldDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.medicalField = _data["medicalField"] ? AlaMedicalFieldDto.fromJS(_data["medicalField"]) : new AlaMedicalFieldDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaMedicalFieldInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaMedicalFieldInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["medicalField"] = this.medicalField ? this.medicalField.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateAlaMedicalFieldInput {
    caseId: string;
    medicalField: AlaMedicalFieldDto;
}

export class CreateOrUpdateAlaMedicalFieldOutput implements ICreateOrUpdateAlaMedicalFieldOutput {
    status!: AlaStatus;
    medicalField!: AlaMedicalFieldDto;

    constructor(data?: ICreateOrUpdateAlaMedicalFieldOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.medicalField = _data["medicalField"] ? AlaMedicalFieldDto.fromJS(_data["medicalField"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaMedicalFieldOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaMedicalFieldOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["medicalField"] = this.medicalField ? this.medicalField.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateAlaMedicalFieldOutput {
    status: AlaStatus;
    medicalField: AlaMedicalFieldDto;
}

export class CreateOrUpdateAlaPerson implements ICreateOrUpdateAlaPerson {
    caseId!: string;
    person!: AlaPersonDto;

    constructor(data?: ICreateOrUpdateAlaPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.person = new AlaPersonDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.person = _data["person"] ? AlaPersonDto.fromJS(_data["person"]) : new AlaPersonDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaPerson {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateAlaPerson {
    caseId: string;
    person: AlaPersonDto;
}

export class CreateOrUpdateAlaPostgraduateTitleInput implements ICreateOrUpdateAlaPostgraduateTitleInput {
    caseId!: string;
    postgraduateTitles!: AlaPostgraduateTitleDto[];

    constructor(data?: ICreateOrUpdateAlaPostgraduateTitleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.postgraduateTitles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["postgraduateTitles"])) {
                this.postgraduateTitles = [] as any;
                for (let item of _data["postgraduateTitles"])
                    this.postgraduateTitles!.push(AlaPostgraduateTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaPostgraduateTitleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaPostgraduateTitleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.postgraduateTitles)) {
            data["postgraduateTitles"] = [];
            for (let item of this.postgraduateTitles)
                data["postgraduateTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateAlaPostgraduateTitleInput {
    caseId: string;
    postgraduateTitles: AlaPostgraduateTitleDto[];
}

export class CreateOrUpdateAlaPostgraduateTitleOutput implements ICreateOrUpdateAlaPostgraduateTitleOutput {
    status!: AlaStatus;
    postgraduateTitles!: AlaPostgraduateTitleDto[] | undefined;

    constructor(data?: ICreateOrUpdateAlaPostgraduateTitleOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["postgraduateTitles"])) {
                this.postgraduateTitles = [] as any;
                for (let item of _data["postgraduateTitles"])
                    this.postgraduateTitles!.push(AlaPostgraduateTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaPostgraduateTitleOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaPostgraduateTitleOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.postgraduateTitles)) {
            data["postgraduateTitles"] = [];
            for (let item of this.postgraduateTitles)
                data["postgraduateTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateAlaPostgraduateTitleOutput {
    status: AlaStatus;
    postgraduateTitles: AlaPostgraduateTitleDto[] | undefined;
}

export class CreateOrUpdateAlaPreviousEmploymentInput implements ICreateOrUpdateAlaPreviousEmploymentInput {
    caseId!: string;
    previousEmployments!: AlaPreviousEmploymentDto[];

    constructor(data?: ICreateOrUpdateAlaPreviousEmploymentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.previousEmployments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["previousEmployments"])) {
                this.previousEmployments = [] as any;
                for (let item of _data["previousEmployments"])
                    this.previousEmployments!.push(AlaPreviousEmploymentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaPreviousEmploymentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaPreviousEmploymentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.previousEmployments)) {
            data["previousEmployments"] = [];
            for (let item of this.previousEmployments)
                data["previousEmployments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateAlaPreviousEmploymentInput {
    caseId: string;
    previousEmployments: AlaPreviousEmploymentDto[];
}

export class CreateOrUpdateAlaPreviousEmploymentOutput implements ICreateOrUpdateAlaPreviousEmploymentOutput {
    status!: AlaStatus;
    previousEmployments!: AlaPreviousEmploymentDto[] | undefined;

    constructor(data?: ICreateOrUpdateAlaPreviousEmploymentOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["previousEmployments"])) {
                this.previousEmployments = [] as any;
                for (let item of _data["previousEmployments"])
                    this.previousEmployments!.push(AlaPreviousEmploymentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaPreviousEmploymentOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaPreviousEmploymentOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.previousEmployments)) {
            data["previousEmployments"] = [];
            for (let item of this.previousEmployments)
                data["previousEmployments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateAlaPreviousEmploymentOutput {
    status: AlaStatus;
    previousEmployments: AlaPreviousEmploymentDto[] | undefined;
}

export class CreateOrUpdateAlaRestrictionsInput implements ICreateOrUpdateAlaRestrictionsInput {
    caseId!: string;
    restrictions!: AlaRestrictionDto[];
    restrictionGeneralInformation!: AlaRestrictionGeneralInformationDto;

    constructor(data?: ICreateOrUpdateAlaRestrictionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.restrictions = [];
            this.restrictionGeneralInformation = new AlaRestrictionGeneralInformationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(AlaRestrictionDto.fromJS(item));
            }
            this.restrictionGeneralInformation = _data["restrictionGeneralInformation"] ? AlaRestrictionGeneralInformationDto.fromJS(_data["restrictionGeneralInformation"]) : new AlaRestrictionGeneralInformationDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaRestrictionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaRestrictionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        data["restrictionGeneralInformation"] = this.restrictionGeneralInformation ? this.restrictionGeneralInformation.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateAlaRestrictionsInput {
    caseId: string;
    restrictions: AlaRestrictionDto[];
    restrictionGeneralInformation: AlaRestrictionGeneralInformationDto;
}

export class GetAlaDocumentsInput implements IGetAlaDocumentsInput {
    caseId!: string;
    step!: AlaStatus;
    isInEducationId!: string | undefined;
    languageSkillId!: string | undefined;
    hasJudgementInSwissCriminalRecordId!: string | undefined;

    constructor(data?: IGetAlaDocumentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.isInEducationId = _data["isInEducationId"];
            this.languageSkillId = _data["languageSkillId"];
            this.hasJudgementInSwissCriminalRecordId = _data["hasJudgementInSwissCriminalRecordId"];
        }
    }

    static fromJS(data: any): GetAlaDocumentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlaDocumentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["isInEducationId"] = this.isInEducationId;
        data["languageSkillId"] = this.languageSkillId;
        data["hasJudgementInSwissCriminalRecordId"] = this.hasJudgementInSwissCriminalRecordId;
        return data;
    }
}

export interface IGetAlaDocumentsInput {
    caseId: string;
    step: AlaStatus;
    isInEducationId: string | undefined;
    languageSkillId: string | undefined;
    hasJudgementInSwissCriminalRecordId: string | undefined;
}

export class GetAlaEmploymentOutput implements IGetAlaEmploymentOutput {
    employments!: AlaEmploymentDto[] | undefined;

    constructor(data?: IGetAlaEmploymentOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(AlaEmploymentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAlaEmploymentOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlaEmploymentOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAlaEmploymentOutput {
    employments: AlaEmploymentDto[] | undefined;
}

export class GetAlaFileInput implements IGetAlaFileInput {
    caseId!: string;
    step!: AlaStatus;
    id!: number;

    constructor(data?: IGetAlaFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAlaFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlaFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetAlaFileInput {
    caseId: string;
    step: AlaStatus;
    id: number;
}

export class GetAlaInvoiceAddressOutput implements IGetAlaInvoiceAddressOutput {
    invoiceAddress!: AlaInvoiceAddressDto;
    contact!: InvoiceAddressDetailDto;
    employments!: AlaBusinessDto[] | undefined;
    onlyPrivateAddressAllowed!: boolean;
    selectedInvoiceAddressDetail!: InvoiceAddressDetailDto;

    constructor(data?: IGetAlaInvoiceAddressOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceAddress = _data["invoiceAddress"] ? AlaInvoiceAddressDto.fromJS(_data["invoiceAddress"]) : <any>undefined;
            this.contact = _data["contact"] ? InvoiceAddressDetailDto.fromJS(_data["contact"]) : <any>undefined;
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(AlaBusinessDto.fromJS(item));
            }
            this.onlyPrivateAddressAllowed = _data["onlyPrivateAddressAllowed"];
            this.selectedInvoiceAddressDetail = _data["selectedInvoiceAddressDetail"] ? InvoiceAddressDetailDto.fromJS(_data["selectedInvoiceAddressDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAlaInvoiceAddressOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlaInvoiceAddressOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceAddress"] = this.invoiceAddress ? this.invoiceAddress.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        data["onlyPrivateAddressAllowed"] = this.onlyPrivateAddressAllowed;
        data["selectedInvoiceAddressDetail"] = this.selectedInvoiceAddressDetail ? this.selectedInvoiceAddressDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAlaInvoiceAddressOutput {
    invoiceAddress: AlaInvoiceAddressDto;
    contact: InvoiceAddressDetailDto;
    employments: AlaBusinessDto[] | undefined;
    onlyPrivateAddressAllowed: boolean;
    selectedInvoiceAddressDetail: InvoiceAddressDetailDto;
}

export class GetAlaOutput implements IGetAlaOutput {
    ala!: AlaDto;

    constructor(data?: IGetAlaOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ala = _data["ala"] ? AlaDto.fromJS(_data["ala"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAlaOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlaOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ala"] = this.ala ? this.ala.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAlaOutput {
    ala: AlaDto;
}

export class GetAlaSubItemDocumentsInput implements IGetAlaSubItemDocumentsInput {
    subItemId!: number;
    caseId!: string;
    step!: AlaStatus;
    isInEducationId!: string | undefined;
    languageSkillId!: string | undefined;
    hasJudgementInSwissCriminalRecordId!: string | undefined;

    constructor(data?: IGetAlaSubItemDocumentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subItemId = _data["subItemId"];
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.isInEducationId = _data["isInEducationId"];
            this.languageSkillId = _data["languageSkillId"];
            this.hasJudgementInSwissCriminalRecordId = _data["hasJudgementInSwissCriminalRecordId"];
        }
    }

    static fromJS(data: any): GetAlaSubItemDocumentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlaSubItemDocumentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subItemId"] = this.subItemId;
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["isInEducationId"] = this.isInEducationId;
        data["languageSkillId"] = this.languageSkillId;
        data["hasJudgementInSwissCriminalRecordId"] = this.hasJudgementInSwissCriminalRecordId;
        return data;
    }
}

export interface IGetAlaSubItemDocumentsInput {
    subItemId: number;
    caseId: string;
    step: AlaStatus;
    isInEducationId: string | undefined;
    languageSkillId: string | undefined;
    hasJudgementInSwissCriminalRecordId: string | undefined;
}

export class AuditLogListDto implements IAuditLogListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    impersonatorTenantId!: number | undefined;
    impersonatorUserId!: number | undefined;
    serviceName!: string | undefined;
    methodName!: string | undefined;
    parameters!: string | undefined;
    executionTime!: DateTime;
    executionDuration!: number;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    exception!: string | undefined;
    customData!: string | undefined;
    id!: number;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.impersonatorTenantId = _data["impersonatorTenantId"];
            this.impersonatorUserId = _data["impersonatorUserId"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.parameters = _data["parameters"];
            this.executionTime = _data["executionTime"] ? DateTime.fromISO(_data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = _data["executionDuration"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.exception = _data["exception"];
            this.customData = _data["customData"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["id"] = this.id;
        return data;
    }
}

export interface IAuditLogListDto {
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: DateTime;
    executionDuration: number;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
    id: number;
}

export class EntityChangeListDto implements IEntityChangeListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    changeTime!: DateTime;
    entityTypeFullName!: string | undefined;
    entityId!: string | undefined;
    changeType!: EntityChangeType;
    readonly changeTypeName!: string | undefined;
    entityChangeSetId!: number;
    id!: number;

    constructor(data?: IEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.changeTime = _data["changeTime"] ? DateTime.fromISO(_data["changeTime"].toString()) : <any>undefined;
            this.entityTypeFullName = _data["entityTypeFullName"];
            this.entityId = _data["entityId"];
            this.changeType = _data["changeType"];
            (<any>this).changeTypeName = _data["changeTypeName"];
            this.entityChangeSetId = _data["entityChangeSetId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["changeTime"] = this.changeTime ? this.changeTime.toString() : <any>undefined;
        data["entityTypeFullName"] = this.entityTypeFullName;
        data["entityId"] = this.entityId;
        data["changeType"] = this.changeType;
        data["changeTypeName"] = this.changeTypeName;
        data["entityChangeSetId"] = this.entityChangeSetId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityChangeListDto {
    userId: number | undefined;
    userName: string | undefined;
    changeTime: DateTime;
    entityTypeFullName: string | undefined;
    entityId: string | undefined;
    changeType: EntityChangeType;
    changeTypeName: string | undefined;
    entityChangeSetId: number;
    id: number;
}

export class EntityPropertyChangeDto implements IEntityPropertyChangeDto {
    entityChangeId!: number;
    newValue!: string | undefined;
    originalValue!: string | undefined;
    propertyName!: string | undefined;
    propertyTypeFullName!: string | undefined;
    tenantId!: number | undefined;
    id!: number;

    constructor(data?: IEntityPropertyChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityChangeId = _data["entityChangeId"];
            this.newValue = _data["newValue"];
            this.originalValue = _data["originalValue"];
            this.propertyName = _data["propertyName"];
            this.propertyTypeFullName = _data["propertyTypeFullName"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityPropertyChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPropertyChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityChangeId"] = this.entityChangeId;
        data["newValue"] = this.newValue;
        data["originalValue"] = this.originalValue;
        data["propertyName"] = this.propertyName;
        data["propertyTypeFullName"] = this.propertyTypeFullName;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityPropertyChangeDto {
    entityChangeId: number;
    newValue: string | undefined;
    originalValue: string | undefined;
    propertyName: string | undefined;
    propertyTypeFullName: string | undefined;
    tenantId: number | undefined;
    id: number;
}

export class FacebookExternalLoginProviderSettings implements IFacebookExternalLoginProviderSettings {
    appId!: string | undefined;
    appSecret!: string | undefined;

    constructor(data?: IFacebookExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.appSecret = _data["appSecret"];
        }
    }

    static fromJS(data: any): FacebookExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FacebookExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["appSecret"] = this.appSecret;
        return data;
    }
}

export interface IFacebookExternalLoginProviderSettings {
    appId: string | undefined;
    appSecret: string | undefined;
}

export class GoogleExternalLoginProviderSettings implements IGoogleExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    userInfoEndpoint!: string | undefined;

    constructor(data?: IGoogleExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.userInfoEndpoint = _data["userInfoEndpoint"];
        }
    }

    static fromJS(data: any): GoogleExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["userInfoEndpoint"] = this.userInfoEndpoint;
        return data;
    }
}

export interface IGoogleExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
    userInfoEndpoint: string | undefined;
}

export class JsonAutoLoginInfoDto implements IJsonAutoLoginInfoDto {
    idpHint!: string | undefined;
    value!: string | undefined;

    constructor(data?: IJsonAutoLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idpHint = _data["idpHint"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): JsonAutoLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new JsonAutoLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idpHint"] = this.idpHint;
        data["value"] = this.value;
        return data;
    }
}

export interface IJsonAutoLoginInfoDto {
    idpHint: string | undefined;
    value: string | undefined;
}

export class JsonClaimMapDto implements IJsonClaimMapDto {
    claim!: string | undefined;
    key!: string | undefined;

    constructor(data?: IJsonClaimMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claim = _data["claim"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): JsonClaimMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new JsonClaimMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claim"] = this.claim;
        data["key"] = this.key;
        return data;
    }
}

export interface IJsonClaimMapDto {
    claim: string | undefined;
    key: string | undefined;
}

export class MicrosoftExternalLoginProviderSettings implements IMicrosoftExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;

    constructor(data?: IMicrosoftExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
        }
    }

    static fromJS(data: any): MicrosoftExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        return data;
    }
}

export interface IMicrosoftExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
}

export class OpenIdConnectExternalLoginProviderSettings implements IOpenIdConnectExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    authority!: string | undefined;
    tokenEndpoint!: string | undefined;
    loginUrl!: string | undefined;
    validateIssuer!: boolean;
    responseType!: string | undefined;
    useAccessTokenForClaims!: boolean;
    discoveryDocUrl!: string | undefined;
    providerKeyClaim!: string | undefined;
    audClaimForVerification!: string | undefined;
    issuerInDiscoveryDoc!: string | undefined;
    scopes!: string | undefined;

    constructor(data?: IOpenIdConnectExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.authority = _data["authority"];
            this.tokenEndpoint = _data["tokenEndpoint"];
            this.loginUrl = _data["loginUrl"];
            this.validateIssuer = _data["validateIssuer"];
            this.responseType = _data["responseType"];
            this.useAccessTokenForClaims = _data["useAccessTokenForClaims"];
            this.discoveryDocUrl = _data["discoveryDocUrl"];
            this.providerKeyClaim = _data["providerKeyClaim"];
            this.audClaimForVerification = _data["audClaimForVerification"];
            this.issuerInDiscoveryDoc = _data["issuerInDiscoveryDoc"];
            this.scopes = _data["scopes"];
        }
    }

    static fromJS(data: any): OpenIdConnectExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new OpenIdConnectExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["authority"] = this.authority;
        data["tokenEndpoint"] = this.tokenEndpoint;
        data["loginUrl"] = this.loginUrl;
        data["validateIssuer"] = this.validateIssuer;
        data["responseType"] = this.responseType;
        data["useAccessTokenForClaims"] = this.useAccessTokenForClaims;
        data["discoveryDocUrl"] = this.discoveryDocUrl;
        data["providerKeyClaim"] = this.providerKeyClaim;
        data["audClaimForVerification"] = this.audClaimForVerification;
        data["issuerInDiscoveryDoc"] = this.issuerInDiscoveryDoc;
        data["scopes"] = this.scopes;
        return data;
    }
}

export interface IOpenIdConnectExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
    authority: string | undefined;
    tokenEndpoint: string | undefined;
    loginUrl: string | undefined;
    validateIssuer: boolean;
    responseType: string | undefined;
    useAccessTokenForClaims: boolean;
    discoveryDocUrl: string | undefined;
    providerKeyClaim: string | undefined;
    audClaimForVerification: string | undefined;
    issuerInDiscoveryDoc: string | undefined;
    scopes: string | undefined;
}

export class TwitterExternalLoginProviderSettings implements ITwitterExternalLoginProviderSettings {
    consumerKey!: string | undefined;
    consumerSecret!: string | undefined;

    constructor(data?: ITwitterExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumerKey = _data["consumerKey"];
            this.consumerSecret = _data["consumerSecret"];
        }
    }

    static fromJS(data: any): TwitterExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerKey"] = this.consumerKey;
        data["consumerSecret"] = this.consumerSecret;
        return data;
    }
}

export interface ITwitterExternalLoginProviderSettings {
    consumerKey: string | undefined;
    consumerSecret: string | undefined;
}

export class WsFederationExternalLoginProviderSettings implements IWsFederationExternalLoginProviderSettings {
    clientId!: string | undefined;
    tenant!: string | undefined;
    metaDataAddress!: string | undefined;
    wtrealm!: string | undefined;
    authority!: string | undefined;

    constructor(data?: IWsFederationExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.tenant = _data["tenant"];
            this.metaDataAddress = _data["metaDataAddress"];
            this.wtrealm = _data["wtrealm"];
            this.authority = _data["authority"];
        }
    }

    static fromJS(data: any): WsFederationExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new WsFederationExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["tenant"] = this.tenant;
        data["metaDataAddress"] = this.metaDataAddress;
        data["wtrealm"] = this.wtrealm;
        data["authority"] = this.authority;
        return data;
    }
}

export interface IWsFederationExternalLoginProviderSettings {
    clientId: string | undefined;
    tenant: string | undefined;
    metaDataAddress: string | undefined;
    wtrealm: string | undefined;
    authority: string | undefined;
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId!: number;
    confirmationCode!: string | undefined;
    c!: string | undefined;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.confirmationCode = _data["confirmationCode"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data;
    }
}

export interface IActivateEmailInput {
    userId: number;
    confirmationCode: string | undefined;
    c: string | undefined;
}

export class DelegatedImpersonateInput implements IDelegatedImpersonateInput {
    userDelegationId!: number;

    constructor(data?: IDelegatedImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDelegationId = _data["userDelegationId"];
        }
    }

    static fromJS(data: any): DelegatedImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new DelegatedImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDelegationId"] = this.userDelegationId;
        return data;
    }
}

export interface IDelegatedImpersonateInput {
    userDelegationId: number;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.impersonationToken = _data["impersonationToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): ImpersonateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IImpersonateOutput {
    impersonationToken: string | undefined;
    tenancyName: string | undefined;
}

export class ImpersonateTenantInput implements IImpersonateTenantInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IImpersonateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IImpersonateTenantInput {
    tenantId: number | undefined;
    userId: number;
}

export class ImpersonateUserInput implements IImpersonateUserInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IImpersonateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IImpersonateUserInput {
    tenantId: number | undefined;
    userId: number;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName!: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: TenantAvailabilityState;
    tenantId!: number | undefined;
    serverRootAddress!: string | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
            this.serverRootAddress = _data["serverRootAddress"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
    serverRootAddress: string | undefined;
}

export class RefreshTokenResult implements IRefreshTokenResult {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IRefreshTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): RefreshTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IRefreshTokenResult {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class RegisterInput implements IRegisterInput {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse!: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin!: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId!: number;
    resetCode!: string | undefined;
    expireDate!: DateTime;
    password!: string | undefined;
    returnUrl!: string | undefined;
    singleSignIn!: string | undefined;
    c!: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.resetCode = _data["resetCode"];
            this.expireDate = _data["expireDate"] ? DateTime.fromISO(_data["expireDate"].toString()) : <any>undefined;
            this.password = _data["password"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["expireDate"] = this.expireDate ? this.expireDate.toString() : <any>undefined;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["c"] = this.c;
        return data;
    }
}

export interface IResetPasswordInput {
    userId: number;
    resetCode: string | undefined;
    expireDate: DateTime;
    password: string | undefined;
    returnUrl: string | undefined;
    singleSignIn: string | undefined;
    c: string | undefined;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin!: boolean;
    userName!: string | undefined;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean;
    userName: string | undefined;
}

export class ResolveTenantIdInput implements IResolveTenantIdInput {
    c!: string | undefined;

    constructor(data?: IResolveTenantIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResolveTenantIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveTenantIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        return data;
    }
}

export interface IResolveTenantIdInput {
    c: string | undefined;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress!: string;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress!: string;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string;
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
    targetTenantId!: number | undefined;
    targetUserId!: number;

    constructor(data?: ISwitchToLinkedAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetTenantId = _data["targetTenantId"];
            this.targetUserId = _data["targetUserId"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountInput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data;
    }
}

export interface ISwitchToLinkedAccountInput {
    targetTenantId: number | undefined;
    targetUserId: number;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
    switchAccountToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: ISwitchToLinkedAccountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.switchAccountToken = _data["switchAccountToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface ISwitchToLinkedAccountOutput {
    switchAccountToken: string | undefined;
    tenancyName: string | undefined;
}

export enum TenantAvailabilityState {
    Available = 1,
    InActive = 2,
    NotFound = 3,
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    level!: number;
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"];
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionWithLevelDto {
    level: number;
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role!: RoleEditDto;
    grantedPermissionNames!: string[];

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.role = new RoleEditDto();
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : new RoleEditDto();
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetRolesInput implements IGetRolesInput {
    permissions!: string[] | undefined;

    constructor(data?: IGetRolesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRolesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRolesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IGetRolesInput {
    permissions: string[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number | undefined;
    displayName!: string;
    isDefault!: boolean;
    activeDirectoryGroups!: string | undefined;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.isDefault = _data["isDefault"];
            this.activeDirectoryGroups = _data["activeDirectoryGroups"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        data["activeDirectoryGroups"] = this.activeDirectoryGroups;
        return data;
    }
}

export interface IRoleEditDto {
    id: number | undefined;
    displayName: string;
    isDefault: boolean;
    activeDirectoryGroups: string | undefined;
}

export class RoleListDto implements IRoleListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    creationTime!: DateTime;
    id!: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: DateTime;
    id: number;
}

export class CreateUserDelegationDto implements ICreateUserDelegationDto {
    targetUserId!: number;
    startTime!: DateTime;
    endTime!: DateTime;

    constructor(data?: ICreateUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetUserId = _data["targetUserId"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateUserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetUserId"] = this.targetUserId;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        return data;
    }
}

export interface ICreateUserDelegationDto {
    targetUserId: number;
    startTime: DateTime;
    endTime: DateTime;
}

export class UserDelegationDto implements IUserDelegationDto {
    username!: string | undefined;
    startTime!: DateTime;
    endTime!: DateTime;
    id!: number;

    constructor(data?: IUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserDelegationDto {
    username: string | undefined;
    startTime: DateTime;
    endTime: DateTime;
    id: number;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user!: UserEditDto;
    assignedRoleNames!: string[];
    sendActivationEmail!: boolean;
    setRandomPassword!: boolean;
    organizationUnits!: number[] | undefined;

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
            this.assignedRoleNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : new UserEditDto();
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames!.push(item);
            }
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.setRandomPassword = _data["setRandomPassword"];
            if (Array.isArray(_data["organizationUnits"])) {
                this.organizationUnits = [] as any;
                for (let item of _data["organizationUnits"])
                    this.organizationUnits!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (Array.isArray(this.organizationUnits)) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[];
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    organizationUnits: number[] | undefined;
}

export class GetUserDto implements IGetUserDto {
    userId!: number;
    fullName!: string | undefined;

    constructor(data?: IGetUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): GetUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IGetUserDto {
    userId: number;
    fullName: string | undefined;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId!: string | undefined;
    user!: UserEditDto;
    roles!: UserRoleDto[] | undefined;
    allOrganizationUnits!: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits!: string[] | undefined;
    allowedUserNameCharacters!: string | undefined;
    isSMTPSettingsProvided!: boolean;
    legitimations!: GetLegitimationDto[] | undefined;

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePictureId = _data["profilePictureId"];
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleDto.fromJS(item));
            }
            if (Array.isArray(_data["allOrganizationUnits"])) {
                this.allOrganizationUnits = [] as any;
                for (let item of _data["allOrganizationUnits"])
                    this.allOrganizationUnits!.push(OrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["memberedOrganizationUnits"])) {
                this.memberedOrganizationUnits = [] as any;
                for (let item of _data["memberedOrganizationUnits"])
                    this.memberedOrganizationUnits!.push(item);
            }
            this.allowedUserNameCharacters = _data["allowedUserNameCharacters"];
            this.isSMTPSettingsProvided = _data["isSMTPSettingsProvided"];
            if (Array.isArray(_data["legitimations"])) {
                this.legitimations = [] as any;
                for (let item of _data["legitimations"])
                    this.legitimations!.push(GetLegitimationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.allOrganizationUnits)) {
            data["allOrganizationUnits"] = [];
            for (let item of this.allOrganizationUnits)
                data["allOrganizationUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.memberedOrganizationUnits)) {
            data["memberedOrganizationUnits"] = [];
            for (let item of this.memberedOrganizationUnits)
                data["memberedOrganizationUnits"].push(item);
        }
        data["allowedUserNameCharacters"] = this.allowedUserNameCharacters;
        data["isSMTPSettingsProvided"] = this.isSMTPSettingsProvided;
        if (Array.isArray(this.legitimations)) {
            data["legitimations"] = [];
            for (let item of this.legitimations)
                data["legitimations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserForEditOutput {
    profilePictureId: string | undefined;
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;
    allOrganizationUnits: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits: string[] | undefined;
    allowedUserNameCharacters: string | undefined;
    isSMTPSettingsProvided: boolean;
    legitimations: GetLegitimationDto[] | undefined;
}

export class GetUserForShowOutput implements IGetUserForShowOutput {
    user!: UserShowDto;
    roles!: UserRoleDto[] | undefined;

    constructor(data?: IGetUserForShowOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserShowDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserForShowOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForShowOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserForShowOutput {
    user: UserShowDto;
    roles: UserRoleDto[] | undefined;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetUsersInput implements IGetUsersInput {
    filter!: string | undefined;
    permissions!: string[] | undefined;
    role!: number | undefined;
    onlyLockedUsers!: boolean;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IGetUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.role = _data["role"];
            this.onlyLockedUsers = _data["onlyLockedUsers"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["role"] = this.role;
        data["onlyLockedUsers"] = this.onlyLockedUsers;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IGetUsersInput {
    filter: string | undefined;
    permissions: string[] | undefined;
    role: number | undefined;
    onlyLockedUsers: boolean;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class LinkToUserInput implements ILinkToUserInput {
    tenancyName!: string | undefined;
    usernameOrEmailAddress!: string;
    password!: string;

    constructor(data?: ILinkToUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.usernameOrEmailAddress = _data["usernameOrEmailAddress"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LinkToUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new LinkToUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data;
    }
}

export interface ILinkToUserInput {
    tenancyName: string | undefined;
    usernameOrEmailAddress: string;
    password: string;
}

export class LinkedUserDto implements ILinkedUserDto {
    tenantId!: number | undefined;
    tenancyName!: string | undefined;
    username!: string | undefined;
    id!: number;

    constructor(data?: ILinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.username = _data["username"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        data["id"] = this.id;
        return data;
    }
}

export interface ILinkedUserDto {
    tenantId: number | undefined;
    tenancyName: string | undefined;
    username: string | undefined;
    id: number;
}

export class UnlinkUserInput implements IUnlinkUserInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IUnlinkUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UnlinkUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUnlinkUserInput {
    tenantId: number | undefined;
    userId: number;
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id!: number;
    grantedPermissionNames!: string[];

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[];
}

export class UserEditDto implements IUserEditDto {
    id!: number | undefined;
    titleId!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    ahv!: string | undefined;
    password!: string | undefined;
    isActive!: boolean;
    shouldChangePasswordOnNextLogin!: boolean;
    isTwoFactorEnabled!: boolean;
    isLockoutEnabled!: boolean;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titleId = _data["titleId"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.ahv = _data["ahv"];
            this.password = _data["password"];
            this.isActive = _data["isActive"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
        }
    }

    static fromJS(data: any): UserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titleId"] = this.titleId;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["ahv"] = this.ahv;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        return data;
    }
}

export interface IUserEditDto {
    id: number | undefined;
    titleId: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    ahv: string | undefined;
    password: string | undefined;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
}

export class UserListDto implements IUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    lockoutEndDateUtc!: DateTime | undefined;
    phoneNumber!: string | undefined;
    profilePictureId!: string | undefined;
    isEmailConfirmed!: boolean;
    roles!: UserListRoleDto[] | undefined;
    isActive!: boolean;
    creationTime!: DateTime;
    id!: number;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? DateTime.fromISO(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.profilePictureId = _data["profilePictureId"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserListRoleDto.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    lockoutEndDateUtc: DateTime | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[] | undefined;
    isActive: boolean;
    creationTime: DateTime;
    id: number;
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId!: number;
    roleName!: string | undefined;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserListRoleDto {
    roleId: number;
    roleName: string | undefined;
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName!: string | undefined;
    userNameOrEmail!: string | undefined;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    result!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userNameOrEmail = _data["userNameOrEmail"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.result = _data["result"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmail: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: DateTime;
}

export class UserRoleDto implements IUserRoleDto {
    roleId!: number;
    roleName!: string | undefined;
    roleDisplayName!: string | undefined;
    isAssigned!: boolean;
    inheritedFromOrganizationUnit!: boolean;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleDisplayName = _data["roleDisplayName"];
            this.isAssigned = _data["isAssigned"];
            this.inheritedFromOrganizationUnit = _data["inheritedFromOrganizationUnit"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        data["inheritedFromOrganizationUnit"] = this.inheritedFromOrganizationUnit;
        return data;
    }
}

export interface IUserRoleDto {
    roleId: number;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean;
    inheritedFromOrganizationUnit: boolean;
}

export class UserShowDto implements IUserShowDto {
    id!: number | undefined;
    titleId!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    ahv!: string | undefined;
    isActive!: boolean;
    isTwoFactorEnabled!: boolean;
    isLockoutEnabled!: boolean;

    constructor(data?: IUserShowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titleId = _data["titleId"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.ahv = _data["ahv"];
            this.isActive = _data["isActive"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
        }
    }

    static fromJS(data: any): UserShowDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserShowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titleId"] = this.titleId;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["ahv"] = this.ahv;
        data["isActive"] = this.isActive;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        return data;
    }
}

export interface IUserShowDto {
    id: number | undefined;
    titleId: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    ahv: string | undefined;
    isActive: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean;
    timezone!: string | undefined;
    qrCodeSetupImageUrl!: string | undefined;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.timezone = _data["timezone"];
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    timezone: string | undefined;
    qrCodeSetupImageUrl: string | undefined;
    isGoogleAuthenticatorEnabled: boolean;
}

export class GenerateGoogleAuthenticatorKeyOutput implements IGenerateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl!: string | undefined;
    googleAuthenticatorKey!: string | undefined;

    constructor(data?: IGenerateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
            this.googleAuthenticatorKey = _data["googleAuthenticatorKey"];
        }
    }

    static fromJS(data: any): GenerateGoogleAuthenticatorKeyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["googleAuthenticatorKey"] = this.googleAuthenticatorKey;
        return data;
    }
}

export interface IGenerateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string | undefined;
    googleAuthenticatorKey: string | undefined;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
    setting!: PasswordComplexitySetting;

    constructor(data?: IGetPasswordComplexitySettingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.setting = _data["setting"] ? PasswordComplexitySetting.fromJS(_data["setting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPasswordComplexitySettingOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture!: string | undefined;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data;
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string | undefined;
}

export class SendVerificationSmsInputDto implements ISendVerificationSmsInputDto {
    phoneNumber!: string | undefined;

    constructor(data?: ISendVerificationSmsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): SendVerificationSmsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationSmsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ISendVerificationSmsInputDto {
    phoneNumber: string | undefined;
}

export class UpdateGoogleAuthenticatorKeyInput implements IUpdateGoogleAuthenticatorKeyInput {
    googleAuthenticatorKey!: string | undefined;
    authenticatorCode!: string | undefined;

    constructor(data?: IUpdateGoogleAuthenticatorKeyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.googleAuthenticatorKey = _data["googleAuthenticatorKey"];
            this.authenticatorCode = _data["authenticatorCode"];
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGoogleAuthenticatorKeyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["googleAuthenticatorKey"] = this.googleAuthenticatorKey;
        data["authenticatorCode"] = this.authenticatorCode;
        return data;
    }
}

export interface IUpdateGoogleAuthenticatorKeyInput {
    googleAuthenticatorKey: string | undefined;
    authenticatorCode: string | undefined;
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
    recoveryCodes!: string[] | undefined;

    constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recoveryCodes"])) {
                this.recoveryCodes = [] as any;
                for (let item of _data["recoveryCodes"])
                    this.recoveryCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recoveryCodes)) {
            data["recoveryCodes"] = [];
            for (let item of this.recoveryCodes)
                data["recoveryCodes"].push(item);
        }
        return data;
    }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
    recoveryCodes: string[] | undefined;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileToken!: string | undefined;
    useGravatarProfilePicture!: boolean;
    userId!: number | undefined;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
            this.useGravatarProfilePicture = _data["useGravatarProfilePicture"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UpdateProfilePictureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["useGravatarProfilePicture"] = this.useGravatarProfilePicture;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUpdateProfilePictureInput {
    fileToken: string | undefined;
    useGravatarProfilePicture: boolean;
    userId: number | undefined;
}

export class VerifyAuthenticatorCodeInput implements IVerifyAuthenticatorCodeInput {
    code!: string | undefined;
    googleAuthenticatorKey!: string | undefined;

    constructor(data?: IVerifyAuthenticatorCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.googleAuthenticatorKey = _data["googleAuthenticatorKey"];
        }
    }

    static fromJS(data: any): VerifyAuthenticatorCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyAuthenticatorCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["googleAuthenticatorKey"] = this.googleAuthenticatorKey;
        return data;
    }
}

export interface IVerifyAuthenticatorCodeInput {
    code: string | undefined;
    googleAuthenticatorKey: string | undefined;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
    code!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IVerifySmsCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): VerifySmsCodeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IVerifySmsCodeInputDto {
    code: string | undefined;
    phoneNumber: string | undefined;
}

export class User implements IUser {
    profilePictureId!: string | undefined;
    shouldChangePasswordOnNextLogin!: boolean;
    signInTokenExpireTimeUtc!: DateTime | undefined;
    signInToken!: string | undefined;
    googleAuthenticatorKey!: string | undefined;
    recoveryCode!: string | undefined;
    organizationUnits!: UserOrganizationUnit[] | undefined;
    title!: Code;
    titleId!: string | undefined;
    ahv!: string | undefined;
    languageOfCorrespondence!: Code;
    languageOfCorrespondenceId!: string | undefined;
    applicationsUser!: Application[] | undefined;
    applicationsResponsible!: Application[] | undefined;
    legitimations!: Legitimation[] | undefined;
    inspectorOfBusinesses!: Business[] | undefined;
    migrationData!: MigrationData[] | undefined;
    normalizedUserName!: string;
    normalizedEmailAddress!: string;
    concurrencyStamp!: string | undefined;
    tokens!: UserToken[] | undefined;
    deleterUser!: User;
    creatorUser!: User;
    lastModifierUser!: User;
    authenticationSource!: string | undefined;
    userName!: string;
    tenantId!: number | undefined;
    emailAddress!: string;
    name!: string;
    surname!: string;
    readonly fullName!: string | undefined;
    password!: string;
    emailConfirmationCode!: string | undefined;
    passwordResetCode!: string | undefined;
    lockoutEndDateUtc!: DateTime | undefined;
    accessFailedCount!: number;
    isLockoutEnabled!: boolean;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean;
    securityStamp!: string | undefined;
    isTwoFactorEnabled!: boolean;
    logins!: UserLogin[] | undefined;
    roles!: UserRole[] | undefined;
    claims!: UserClaim[] | undefined;
    permissions!: UserPermissionSetting[] | undefined;
    settings!: Setting[] | undefined;
    isEmailConfirmed!: boolean;
    isActive!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePictureId = _data["profilePictureId"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.signInTokenExpireTimeUtc = _data["signInTokenExpireTimeUtc"] ? DateTime.fromISO(_data["signInTokenExpireTimeUtc"].toString()) : <any>undefined;
            this.signInToken = _data["signInToken"];
            this.googleAuthenticatorKey = _data["googleAuthenticatorKey"];
            this.recoveryCode = _data["recoveryCode"];
            if (Array.isArray(_data["organizationUnits"])) {
                this.organizationUnits = [] as any;
                for (let item of _data["organizationUnits"])
                    this.organizationUnits!.push(UserOrganizationUnit.fromJS(item));
            }
            this.title = _data["title"] ? Code.fromJS(_data["title"]) : <any>undefined;
            this.titleId = _data["titleId"];
            this.ahv = _data["ahv"];
            this.languageOfCorrespondence = _data["languageOfCorrespondence"] ? Code.fromJS(_data["languageOfCorrespondence"]) : <any>undefined;
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            if (Array.isArray(_data["applicationsUser"])) {
                this.applicationsUser = [] as any;
                for (let item of _data["applicationsUser"])
                    this.applicationsUser!.push(Application.fromJS(item));
            }
            if (Array.isArray(_data["applicationsResponsible"])) {
                this.applicationsResponsible = [] as any;
                for (let item of _data["applicationsResponsible"])
                    this.applicationsResponsible!.push(Application.fromJS(item));
            }
            if (Array.isArray(_data["legitimations"])) {
                this.legitimations = [] as any;
                for (let item of _data["legitimations"])
                    this.legitimations!.push(Legitimation.fromJS(item));
            }
            if (Array.isArray(_data["inspectorOfBusinesses"])) {
                this.inspectorOfBusinesses = [] as any;
                for (let item of _data["inspectorOfBusinesses"])
                    this.inspectorOfBusinesses!.push(Business.fromJS(item));
            }
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens!.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.authenticationSource = _data["authenticationSource"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            (<any>this).fullName = _data["fullName"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? DateTime.fromISO(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins!.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings!.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["signInTokenExpireTimeUtc"] = this.signInTokenExpireTimeUtc ? this.signInTokenExpireTimeUtc.toString() : <any>undefined;
        data["signInToken"] = this.signInToken;
        data["googleAuthenticatorKey"] = this.googleAuthenticatorKey;
        data["recoveryCode"] = this.recoveryCode;
        if (Array.isArray(this.organizationUnits)) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item.toJSON());
        }
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["titleId"] = this.titleId;
        data["ahv"] = this.ahv;
        data["languageOfCorrespondence"] = this.languageOfCorrespondence ? this.languageOfCorrespondence.toJSON() : <any>undefined;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        if (Array.isArray(this.applicationsUser)) {
            data["applicationsUser"] = [];
            for (let item of this.applicationsUser)
                data["applicationsUser"].push(item.toJSON());
        }
        if (Array.isArray(this.applicationsResponsible)) {
            data["applicationsResponsible"] = [];
            for (let item of this.applicationsResponsible)
                data["applicationsResponsible"].push(item.toJSON());
        }
        if (Array.isArray(this.legitimations)) {
            data["legitimations"] = [];
            for (let item of this.legitimations)
                data["legitimations"].push(item.toJSON());
        }
        if (Array.isArray(this.inspectorOfBusinesses)) {
            data["inspectorOfBusinesses"] = [];
            for (let item of this.inspectorOfBusinesses)
                data["inspectorOfBusinesses"].push(item.toJSON());
        }
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUser {
    profilePictureId: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    signInTokenExpireTimeUtc: DateTime | undefined;
    signInToken: string | undefined;
    googleAuthenticatorKey: string | undefined;
    recoveryCode: string | undefined;
    organizationUnits: UserOrganizationUnit[] | undefined;
    title: Code;
    titleId: string | undefined;
    ahv: string | undefined;
    languageOfCorrespondence: Code;
    languageOfCorrespondenceId: string | undefined;
    applicationsUser: Application[] | undefined;
    applicationsResponsible: Application[] | undefined;
    legitimations: Legitimation[] | undefined;
    inspectorOfBusinesses: Business[] | undefined;
    migrationData: MigrationData[] | undefined;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: DateTime | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class BankDetailsPerson implements IBankDetailsPerson {
    person!: Person;
    personId!: number;
    discriminator!: BankDetailsType;
    accountHolderName!: string | undefined;
    country!: Code;
    countryId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    bankName!: string | undefined;
    iban!: string | undefined;
    bic!: string | undefined;
    gpNumber!: string | undefined;
    isDeleted!: boolean;
    deleterUser!: User;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    creatorUser!: User;
    lastModifierUser!: User;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IBankDetailsPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.personId = _data["personId"];
            this.discriminator = _data["discriminator"];
            this.accountHolderName = _data["accountHolderName"];
            this.country = _data["country"] ? Code.fromJS(_data["country"]) : <any>undefined;
            this.countryId = _data["countryId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.bankName = _data["bankName"];
            this.iban = _data["iban"];
            this.bic = _data["bic"];
            this.gpNumber = _data["gpNumber"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BankDetailsPerson {
        data = typeof data === 'object' ? data : {};
        let result = new BankDetailsPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["discriminator"] = this.discriminator;
        data["accountHolderName"] = this.accountHolderName;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["countryId"] = this.countryId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["bankName"] = this.bankName;
        data["iban"] = this.iban;
        data["bic"] = this.bic;
        data["gpNumber"] = this.gpNumber;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IBankDetailsPerson {
    person: Person;
    personId: number;
    discriminator: BankDetailsType;
    accountHolderName: string | undefined;
    country: Code;
    countryId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    bankName: string | undefined;
    iban: string | undefined;
    bic: string | undefined;
    gpNumber: string | undefined;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class BankDetailsSponsorship implements IBankDetailsSponsorship {
    sponsorship!: Sponsorship;
    sponsorshipId!: number;
    discriminator!: BankDetailsType;
    accountHolderName!: string | undefined;
    country!: Code;
    countryId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    bankName!: string | undefined;
    iban!: string | undefined;
    bic!: string | undefined;
    gpNumber!: string | undefined;
    isDeleted!: boolean;
    deleterUser!: User;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    creatorUser!: User;
    lastModifierUser!: User;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IBankDetailsSponsorship) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorship = _data["sponsorship"] ? Sponsorship.fromJS(_data["sponsorship"]) : <any>undefined;
            this.sponsorshipId = _data["sponsorshipId"];
            this.discriminator = _data["discriminator"];
            this.accountHolderName = _data["accountHolderName"];
            this.country = _data["country"] ? Code.fromJS(_data["country"]) : <any>undefined;
            this.countryId = _data["countryId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.bankName = _data["bankName"];
            this.iban = _data["iban"];
            this.bic = _data["bic"];
            this.gpNumber = _data["gpNumber"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BankDetailsSponsorship {
        data = typeof data === 'object' ? data : {};
        let result = new BankDetailsSponsorship();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        data["sponsorshipId"] = this.sponsorshipId;
        data["discriminator"] = this.discriminator;
        data["accountHolderName"] = this.accountHolderName;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["countryId"] = this.countryId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["bankName"] = this.bankName;
        data["iban"] = this.iban;
        data["bic"] = this.bic;
        data["gpNumber"] = this.gpNumber;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IBankDetailsSponsorship {
    sponsorship: Sponsorship;
    sponsorshipId: number;
    discriminator: BankDetailsType;
    accountHolderName: string | undefined;
    country: Code;
    countryId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    bankName: string | undefined;
    iban: string | undefined;
    bic: string | undefined;
    gpNumber: string | undefined;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum BankDetailsType {
    Person = 0,
    Sponsorship = 1,
}

export class GetBankDetailsDto implements IGetBankDetailsDto {
    accountHolderName!: string | undefined;
    countryId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    bankName!: string | undefined;
    iban!: string | undefined;
    bic!: string | undefined;
    gpNumber!: string | undefined;
    id!: number;

    constructor(data?: IGetBankDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountHolderName = _data["accountHolderName"];
            this.countryId = _data["countryId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.bankName = _data["bankName"];
            this.iban = _data["iban"];
            this.bic = _data["bic"];
            this.gpNumber = _data["gpNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetBankDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountHolderName"] = this.accountHolderName;
        data["countryId"] = this.countryId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["bankName"] = this.bankName;
        data["iban"] = this.iban;
        data["bic"] = this.bic;
        data["gpNumber"] = this.gpNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetBankDetailsDto {
    accountHolderName: string | undefined;
    countryId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    bankName: string | undefined;
    iban: string | undefined;
    bic: string | undefined;
    gpNumber: string | undefined;
    id: number;
}

export class UpdateBankDetailsInput implements IUpdateBankDetailsInput {
    entityId!: number;
    accountHolderName!: string | undefined;
    countryId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    bankName!: string | undefined;
    iban!: string | undefined;
    bic!: string | undefined;
    gpNumber!: string | undefined;

    constructor(data?: IUpdateBankDetailsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.accountHolderName = _data["accountHolderName"];
            this.countryId = _data["countryId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.bankName = _data["bankName"];
            this.iban = _data["iban"];
            this.bic = _data["bic"];
            this.gpNumber = _data["gpNumber"];
        }
    }

    static fromJS(data: any): UpdateBankDetailsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBankDetailsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["accountHolderName"] = this.accountHolderName;
        data["countryId"] = this.countryId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["bankName"] = this.bankName;
        data["iban"] = this.iban;
        data["bic"] = this.bic;
        data["gpNumber"] = this.gpNumber;
        return data;
    }
}

export interface IUpdateBankDetailsInput {
    entityId: number;
    accountHolderName: string | undefined;
    countryId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    bankName: string | undefined;
    iban: string | undefined;
    bic: string | undefined;
    gpNumber: string | undefined;
}

export class Business implements IBusiness {
    sponsorship!: Sponsorship;
    sponsorshipId!: number | undefined;
    typeId!: string | undefined;
    statusId!: string | undefined;
    legalFormId!: string | undefined;
    name!: string | undefined;
    additionalName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    cantonId!: string | undefined;
    municipalityId!: string | undefined;
    regionId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    email2!: string | undefined;
    fax!: string | undefined;
    website!: string | undefined;
    gln!: string | undefined;
    bur!: string | undefined;
    uid!: string | undefined;
    betRegId!: number | undefined;
    healthRegisterSync!: DateTime | undefined;
    dateOfOpening!: DateTime | undefined;
    dateOfClosure!: DateTime | undefined;
    businessHours!: string | undefined;
    comments!: string | undefined;
    isArchived!: boolean;
    additionalInformations!: AdditionalInformationBusiness[] | undefined;
    licences!: CorporateLicence[] | undefined;
    inspectors!: User[] | undefined;
    employments!: Employment[] | undefined;
    documentLinks!: DocumentLinkBusiness[] | undefined;
    sensitiveDataRecords!: SensitiveDataRecordBusiness[] | undefined;
    businessTransfers!: BusinessTransfer[] | undefined;
    logbooks!: LogbookBusiness[] | undefined;
    reminders!: ReminderBusiness[] | undefined;
    inspections!: Inspection[] | undefined;
    migrationData!: MigrationData[] | undefined;
    readonly shortDescription!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IBusiness) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorship = _data["sponsorship"] ? Sponsorship.fromJS(_data["sponsorship"]) : <any>undefined;
            this.sponsorshipId = _data["sponsorshipId"];
            this.typeId = _data["typeId"];
            this.statusId = _data["statusId"];
            this.legalFormId = _data["legalFormId"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.cantonId = _data["cantonId"];
            this.municipalityId = _data["municipalityId"];
            this.regionId = _data["regionId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.gln = _data["gln"];
            this.bur = _data["bur"];
            this.uid = _data["uid"];
            this.betRegId = _data["betRegId"];
            this.healthRegisterSync = _data["healthRegisterSync"] ? DateTime.fromISO(_data["healthRegisterSync"].toString()) : <any>undefined;
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.dateOfClosure = _data["dateOfClosure"] ? DateTime.fromISO(_data["dateOfClosure"].toString()) : <any>undefined;
            this.businessHours = _data["businessHours"];
            this.comments = _data["comments"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["additionalInformations"])) {
                this.additionalInformations = [] as any;
                for (let item of _data["additionalInformations"])
                    this.additionalInformations!.push(AdditionalInformationBusiness.fromJS(item));
            }
            if (Array.isArray(_data["licences"])) {
                this.licences = [] as any;
                for (let item of _data["licences"])
                    this.licences!.push(CorporateLicence.fromJS(item));
            }
            if (Array.isArray(_data["inspectors"])) {
                this.inspectors = [] as any;
                for (let item of _data["inspectors"])
                    this.inspectors!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(Employment.fromJS(item));
            }
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkBusiness.fromJS(item));
            }
            if (Array.isArray(_data["sensitiveDataRecords"])) {
                this.sensitiveDataRecords = [] as any;
                for (let item of _data["sensitiveDataRecords"])
                    this.sensitiveDataRecords!.push(SensitiveDataRecordBusiness.fromJS(item));
            }
            if (Array.isArray(_data["businessTransfers"])) {
                this.businessTransfers = [] as any;
                for (let item of _data["businessTransfers"])
                    this.businessTransfers!.push(BusinessTransfer.fromJS(item));
            }
            if (Array.isArray(_data["logbooks"])) {
                this.logbooks = [] as any;
                for (let item of _data["logbooks"])
                    this.logbooks!.push(LogbookBusiness.fromJS(item));
            }
            if (Array.isArray(_data["reminders"])) {
                this.reminders = [] as any;
                for (let item of _data["reminders"])
                    this.reminders!.push(ReminderBusiness.fromJS(item));
            }
            if (Array.isArray(_data["inspections"])) {
                this.inspections = [] as any;
                for (let item of _data["inspections"])
                    this.inspections!.push(Inspection.fromJS(item));
            }
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            (<any>this).shortDescription = _data["shortDescription"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Business {
        data = typeof data === 'object' ? data : {};
        let result = new Business();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        data["sponsorshipId"] = this.sponsorshipId;
        data["typeId"] = this.typeId;
        data["statusId"] = this.statusId;
        data["legalFormId"] = this.legalFormId;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["cantonId"] = this.cantonId;
        data["municipalityId"] = this.municipalityId;
        data["regionId"] = this.regionId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["gln"] = this.gln;
        data["bur"] = this.bur;
        data["uid"] = this.uid;
        data["betRegId"] = this.betRegId;
        data["healthRegisterSync"] = this.healthRegisterSync ? this.healthRegisterSync.toString() : <any>undefined;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfClosure"] = this.dateOfClosure ? this.dateOfClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessHours"] = this.businessHours;
        data["comments"] = this.comments;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.additionalInformations)) {
            data["additionalInformations"] = [];
            for (let item of this.additionalInformations)
                data["additionalInformations"].push(item.toJSON());
        }
        if (Array.isArray(this.licences)) {
            data["licences"] = [];
            for (let item of this.licences)
                data["licences"].push(item.toJSON());
        }
        if (Array.isArray(this.inspectors)) {
            data["inspectors"] = [];
            for (let item of this.inspectors)
                data["inspectors"].push(item.toJSON());
        }
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.sensitiveDataRecords)) {
            data["sensitiveDataRecords"] = [];
            for (let item of this.sensitiveDataRecords)
                data["sensitiveDataRecords"].push(item.toJSON());
        }
        if (Array.isArray(this.businessTransfers)) {
            data["businessTransfers"] = [];
            for (let item of this.businessTransfers)
                data["businessTransfers"].push(item.toJSON());
        }
        if (Array.isArray(this.logbooks)) {
            data["logbooks"] = [];
            for (let item of this.logbooks)
                data["logbooks"].push(item.toJSON());
        }
        if (Array.isArray(this.reminders)) {
            data["reminders"] = [];
            for (let item of this.reminders)
                data["reminders"].push(item.toJSON());
        }
        if (Array.isArray(this.inspections)) {
            data["inspections"] = [];
            for (let item of this.inspections)
                data["inspections"].push(item.toJSON());
        }
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["shortDescription"] = this.shortDescription;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IBusiness {
    sponsorship: Sponsorship;
    sponsorshipId: number | undefined;
    typeId: string | undefined;
    statusId: string | undefined;
    legalFormId: string | undefined;
    name: string | undefined;
    additionalName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    cantonId: string | undefined;
    municipalityId: string | undefined;
    regionId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    email2: string | undefined;
    fax: string | undefined;
    website: string | undefined;
    gln: string | undefined;
    bur: string | undefined;
    uid: string | undefined;
    betRegId: number | undefined;
    healthRegisterSync: DateTime | undefined;
    dateOfOpening: DateTime | undefined;
    dateOfClosure: DateTime | undefined;
    businessHours: string | undefined;
    comments: string | undefined;
    isArchived: boolean;
    additionalInformations: AdditionalInformationBusiness[] | undefined;
    licences: CorporateLicence[] | undefined;
    inspectors: User[] | undefined;
    employments: Employment[] | undefined;
    documentLinks: DocumentLinkBusiness[] | undefined;
    sensitiveDataRecords: SensitiveDataRecordBusiness[] | undefined;
    businessTransfers: BusinessTransfer[] | undefined;
    logbooks: LogbookBusiness[] | undefined;
    reminders: ReminderBusiness[] | undefined;
    inspections: Inspection[] | undefined;
    migrationData: MigrationData[] | undefined;
    shortDescription: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class BusinessSearchDto implements IBusinessSearchDto {
    sponsorshipId!: number | undefined;
    statusId!: string | undefined;
    businessId!: number | undefined;
    employmentAddressId!: number | undefined;
    addressTypeId!: string | undefined;
    legalFormId!: string | undefined;
    name!: string | undefined;
    additionalName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    gln!: string | undefined;
    bur!: string | undefined;
    id!: number;

    constructor(data?: IBusinessSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipId = _data["sponsorshipId"];
            this.statusId = _data["statusId"];
            this.businessId = _data["businessId"];
            this.employmentAddressId = _data["employmentAddressId"];
            this.addressTypeId = _data["addressTypeId"];
            this.legalFormId = _data["legalFormId"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.gln = _data["gln"];
            this.bur = _data["bur"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BusinessSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipId"] = this.sponsorshipId;
        data["statusId"] = this.statusId;
        data["businessId"] = this.businessId;
        data["employmentAddressId"] = this.employmentAddressId;
        data["addressTypeId"] = this.addressTypeId;
        data["legalFormId"] = this.legalFormId;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["gln"] = this.gln;
        data["bur"] = this.bur;
        data["id"] = this.id;
        return data;
    }
}

export interface IBusinessSearchDto {
    sponsorshipId: number | undefined;
    statusId: string | undefined;
    businessId: number | undefined;
    employmentAddressId: number | undefined;
    addressTypeId: string | undefined;
    legalFormId: string | undefined;
    name: string | undefined;
    additionalName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    gln: string | undefined;
    bur: string | undefined;
    id: number;
}

export class BusinessSearchInput implements IBusinessSearchInput {
    sponsorshipId!: number;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IBusinessSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipId = _data["sponsorshipId"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): BusinessSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipId"] = this.sponsorshipId;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IBusinessSearchInput {
    sponsorshipId: number;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class BusinessSearchOutput implements IBusinessSearchOutput {
    totalCount!: number;
    items!: BusinessSearchDto[] | undefined;

    constructor(data?: IBusinessSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BusinessSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BusinessSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBusinessSearchOutput {
    totalCount: number;
    items: BusinessSearchDto[] | undefined;
}

export class BusinessTransfer implements IBusinessTransfer {
    business!: Business;
    businessId!: number;
    employment!: Employment;
    employmentId!: number;
    type!: HealthRegisterType;
    externalId!: number;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IBusinessTransfer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.business = _data["business"] ? Business.fromJS(_data["business"]) : <any>undefined;
            this.businessId = _data["businessId"];
            this.employment = _data["employment"] ? Employment.fromJS(_data["employment"]) : <any>undefined;
            this.employmentId = _data["employmentId"];
            this.type = _data["type"];
            this.externalId = _data["externalId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BusinessTransfer {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessTransfer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        data["businessId"] = this.businessId;
        data["employment"] = this.employment ? this.employment.toJSON() : <any>undefined;
        data["employmentId"] = this.employmentId;
        data["type"] = this.type;
        data["externalId"] = this.externalId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IBusinessTransfer {
    business: Business;
    businessId: number;
    employment: Employment;
    employmentId: number;
    type: HealthRegisterType;
    externalId: number;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class BusinessAddressDto implements IBusinessAddressDto {
    id!: number;
    name!: string | undefined;
    additionalName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    website!: string | undefined;
    businessHours!: string | undefined;
    dateOfOpening!: DateTime | undefined;
    businessAddressDescription!: string | undefined;

    constructor(data?: IBusinessAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.businessHours = _data["businessHours"];
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.businessAddressDescription = _data["businessAddressDescription"];
        }
    }

    static fromJS(data: any): BusinessAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["website"] = this.website;
        data["businessHours"] = this.businessHours;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessAddressDescription"] = this.businessAddressDescription;
        return data;
    }
}

export interface IBusinessAddressDto {
    id: number;
    name: string | undefined;
    additionalName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    website: string | undefined;
    businessHours: string | undefined;
    dateOfOpening: DateTime | undefined;
    businessAddressDescription: string | undefined;
}

export class BusinessDto implements IBusinessDto {
    sponsorshipId!: number | undefined;
    sponsorshipName!: string | undefined;
    typeId!: string;
    statusId!: string;
    legalFormId!: string | undefined;
    name!: string;
    additionalName!: string | undefined;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    municipalityId!: string | undefined;
    regionId!: string | undefined;
    countryId!: string;
    cantonId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    email2!: string | undefined;
    fax!: string | undefined;
    website!: string | undefined;
    gln!: string | undefined;
    bur!: string | undefined;
    uid!: string | undefined;
    betRegId!: number | undefined;
    comments!: string | undefined;
    dateOfOpening!: DateTime | undefined;
    dateOfClosure!: DateTime | undefined;
    businessHours!: string | undefined;
    isArchived!: boolean;
    inspectors!: number[] | undefined;
    licences!: CorporateLicenceDto[] | undefined;
    employments!: GetEmploymentDto[] | undefined;
    id!: number;

    constructor(data?: IBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipId = _data["sponsorshipId"];
            this.sponsorshipName = _data["sponsorshipName"];
            this.typeId = _data["typeId"];
            this.statusId = _data["statusId"];
            this.legalFormId = _data["legalFormId"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.municipalityId = _data["municipalityId"];
            this.regionId = _data["regionId"];
            this.countryId = _data["countryId"];
            this.cantonId = _data["cantonId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.gln = _data["gln"];
            this.bur = _data["bur"];
            this.uid = _data["uid"];
            this.betRegId = _data["betRegId"];
            this.comments = _data["comments"];
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.dateOfClosure = _data["dateOfClosure"] ? DateTime.fromISO(_data["dateOfClosure"].toString()) : <any>undefined;
            this.businessHours = _data["businessHours"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["inspectors"])) {
                this.inspectors = [] as any;
                for (let item of _data["inspectors"])
                    this.inspectors!.push(item);
            }
            if (Array.isArray(_data["licences"])) {
                this.licences = [] as any;
                for (let item of _data["licences"])
                    this.licences!.push(CorporateLicenceDto.fromJS(item));
            }
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(GetEmploymentDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipId"] = this.sponsorshipId;
        data["sponsorshipName"] = this.sponsorshipName;
        data["typeId"] = this.typeId;
        data["statusId"] = this.statusId;
        data["legalFormId"] = this.legalFormId;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["municipalityId"] = this.municipalityId;
        data["regionId"] = this.regionId;
        data["countryId"] = this.countryId;
        data["cantonId"] = this.cantonId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["gln"] = this.gln;
        data["bur"] = this.bur;
        data["uid"] = this.uid;
        data["betRegId"] = this.betRegId;
        data["comments"] = this.comments;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfClosure"] = this.dateOfClosure ? this.dateOfClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessHours"] = this.businessHours;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.inspectors)) {
            data["inspectors"] = [];
            for (let item of this.inspectors)
                data["inspectors"].push(item);
        }
        if (Array.isArray(this.licences)) {
            data["licences"] = [];
            for (let item of this.licences)
                data["licences"].push(item.toJSON());
        }
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IBusinessDto {
    sponsorshipId: number | undefined;
    sponsorshipName: string | undefined;
    typeId: string;
    statusId: string;
    legalFormId: string | undefined;
    name: string;
    additionalName: string | undefined;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    municipalityId: string | undefined;
    regionId: string | undefined;
    countryId: string;
    cantonId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    email2: string | undefined;
    fax: string | undefined;
    website: string | undefined;
    gln: string | undefined;
    bur: string | undefined;
    uid: string | undefined;
    betRegId: number | undefined;
    comments: string | undefined;
    dateOfOpening: DateTime | undefined;
    dateOfClosure: DateTime | undefined;
    businessHours: string | undefined;
    isArchived: boolean;
    inspectors: number[] | undefined;
    licences: CorporateLicenceDto[] | undefined;
    employments: GetEmploymentDto[] | undefined;
    id: number;
}

export class CreateAndLinkBusinessInput implements ICreateAndLinkBusinessInput {
    employmentId!: number;
    employmentAddress!: EmploymentAddressDto;
    business!: CreateBusinessDto;

    constructor(data?: ICreateAndLinkBusinessInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employmentId = _data["employmentId"];
            this.employmentAddress = _data["employmentAddress"] ? EmploymentAddressDto.fromJS(_data["employmentAddress"]) : <any>undefined;
            this.business = _data["business"] ? CreateBusinessDto.fromJS(_data["business"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateAndLinkBusinessInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAndLinkBusinessInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employmentId"] = this.employmentId;
        data["employmentAddress"] = this.employmentAddress ? this.employmentAddress.toJSON() : <any>undefined;
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateAndLinkBusinessInput {
    employmentId: number;
    employmentAddress: EmploymentAddressDto;
    business: CreateBusinessDto;
}

export class CreateBusinessDto implements ICreateBusinessDto {
    useSponsorshipAddress!: boolean;
    sponsorshipId!: number | undefined;
    typeId!: string | undefined;
    legalFormId!: string | undefined;
    name!: string | undefined;
    additionalName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    cantonId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    email2!: string | undefined;
    fax!: string | undefined;
    website!: string | undefined;
    gln!: string | undefined;
    bur!: string | undefined;
    uid!: string | undefined;
    comments!: string | undefined;
    dateOfOpening!: DateTime | undefined;
    dateOfClosure!: DateTime | undefined;
    businessHours!: string | undefined;
    inspectors!: number[] | undefined;
    id!: number;

    constructor(data?: ICreateBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useSponsorshipAddress = _data["useSponsorshipAddress"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.typeId = _data["typeId"];
            this.legalFormId = _data["legalFormId"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.cantonId = _data["cantonId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.gln = _data["gln"];
            this.bur = _data["bur"];
            this.uid = _data["uid"];
            this.comments = _data["comments"];
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.dateOfClosure = _data["dateOfClosure"] ? DateTime.fromISO(_data["dateOfClosure"].toString()) : <any>undefined;
            this.businessHours = _data["businessHours"];
            if (Array.isArray(_data["inspectors"])) {
                this.inspectors = [] as any;
                for (let item of _data["inspectors"])
                    this.inspectors!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useSponsorshipAddress"] = this.useSponsorshipAddress;
        data["sponsorshipId"] = this.sponsorshipId;
        data["typeId"] = this.typeId;
        data["legalFormId"] = this.legalFormId;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["cantonId"] = this.cantonId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["gln"] = this.gln;
        data["bur"] = this.bur;
        data["uid"] = this.uid;
        data["comments"] = this.comments;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfClosure"] = this.dateOfClosure ? this.dateOfClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessHours"] = this.businessHours;
        if (Array.isArray(this.inspectors)) {
            data["inspectors"] = [];
            for (let item of this.inspectors)
                data["inspectors"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateBusinessDto {
    useSponsorshipAddress: boolean;
    sponsorshipId: number | undefined;
    typeId: string | undefined;
    legalFormId: string | undefined;
    name: string | undefined;
    additionalName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    cantonId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    email2: string | undefined;
    fax: string | undefined;
    website: string | undefined;
    gln: string | undefined;
    bur: string | undefined;
    uid: string | undefined;
    comments: string | undefined;
    dateOfOpening: DateTime | undefined;
    dateOfClosure: DateTime | undefined;
    businessHours: string | undefined;
    inspectors: number[] | undefined;
    id: number;
}

export class GetBusinessDto implements IGetBusinessDto {
    typeId!: string | undefined;
    statusId!: string | undefined;
    name!: string | undefined;
    additionalName!: string | undefined;
    addressAddition!: string | undefined;
    uid!: string | undefined;
    gln!: string | undefined;
    bur!: string | undefined;
    betRegId!: number | undefined;
    legalFormId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    cantonId!: string | undefined;
    postOfficeBox!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    fax!: string | undefined;
    website!: string | undefined;
    dateOfOpening!: DateTime | undefined;
    dateOfClosure!: DateTime | undefined;
    businessHours!: string | undefined;
    comments!: string | undefined;
    inspectors!: number[] | undefined;
    id!: number;

    constructor(data?: IGetBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.statusId = _data["statusId"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.addressAddition = _data["addressAddition"];
            this.uid = _data["uid"];
            this.gln = _data["gln"];
            this.bur = _data["bur"];
            this.betRegId = _data["betRegId"];
            this.legalFormId = _data["legalFormId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.cantonId = _data["cantonId"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.dateOfClosure = _data["dateOfClosure"] ? DateTime.fromISO(_data["dateOfClosure"].toString()) : <any>undefined;
            this.businessHours = _data["businessHours"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["inspectors"])) {
                this.inspectors = [] as any;
                for (let item of _data["inspectors"])
                    this.inspectors!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["statusId"] = this.statusId;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["addressAddition"] = this.addressAddition;
        data["uid"] = this.uid;
        data["gln"] = this.gln;
        data["bur"] = this.bur;
        data["betRegId"] = this.betRegId;
        data["legalFormId"] = this.legalFormId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["cantonId"] = this.cantonId;
        data["postOfficeBox"] = this.postOfficeBox;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfClosure"] = this.dateOfClosure ? this.dateOfClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessHours"] = this.businessHours;
        data["comments"] = this.comments;
        if (Array.isArray(this.inspectors)) {
            data["inspectors"] = [];
            for (let item of this.inspectors)
                data["inspectors"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGetBusinessDto {
    typeId: string | undefined;
    statusId: string | undefined;
    name: string | undefined;
    additionalName: string | undefined;
    addressAddition: string | undefined;
    uid: string | undefined;
    gln: string | undefined;
    bur: string | undefined;
    betRegId: number | undefined;
    legalFormId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    cantonId: string | undefined;
    postOfficeBox: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    fax: string | undefined;
    website: string | undefined;
    dateOfOpening: DateTime | undefined;
    dateOfClosure: DateTime | undefined;
    businessHours: string | undefined;
    comments: string | undefined;
    inspectors: number[] | undefined;
    id: number;
}

export class GetBusinessesOutput implements IGetBusinessesOutput {
    totalCount!: number;
    items!: BusinessDto[] | undefined;

    constructor(data?: IGetBusinessesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBusinessesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBusinessesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBusinessesOutput {
    totalCount: number;
    items: BusinessDto[] | undefined;
}

export class UpdateBusinessInput implements IUpdateBusinessInput {
    typeId!: string;
    legalFormId!: string | undefined;
    name!: string;
    additionalName!: string | undefined;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    cantonId!: string | undefined;
    municipalityId!: string | undefined;
    regionId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    email2!: string | undefined;
    fax!: string | undefined;
    website!: string | undefined;
    gln!: string | undefined;
    bur!: string | undefined;
    uid!: string | undefined;
    comments!: string | undefined;
    dateOfOpening!: DateTime | undefined;
    dateOfClosure!: DateTime | undefined;
    businessHours!: string | undefined;
    inspectors!: number[] | undefined;
    licences!: CorporateLicenceDto[] | undefined;
    employments!: GetEmploymentDto[] | undefined;
    id!: number;

    constructor(data?: IUpdateBusinessInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.legalFormId = _data["legalFormId"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.cantonId = _data["cantonId"];
            this.municipalityId = _data["municipalityId"];
            this.regionId = _data["regionId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.gln = _data["gln"];
            this.bur = _data["bur"];
            this.uid = _data["uid"];
            this.comments = _data["comments"];
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.dateOfClosure = _data["dateOfClosure"] ? DateTime.fromISO(_data["dateOfClosure"].toString()) : <any>undefined;
            this.businessHours = _data["businessHours"];
            if (Array.isArray(_data["inspectors"])) {
                this.inspectors = [] as any;
                for (let item of _data["inspectors"])
                    this.inspectors!.push(item);
            }
            if (Array.isArray(_data["licences"])) {
                this.licences = [] as any;
                for (let item of _data["licences"])
                    this.licences!.push(CorporateLicenceDto.fromJS(item));
            }
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(GetEmploymentDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateBusinessInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBusinessInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["legalFormId"] = this.legalFormId;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["cantonId"] = this.cantonId;
        data["municipalityId"] = this.municipalityId;
        data["regionId"] = this.regionId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["gln"] = this.gln;
        data["bur"] = this.bur;
        data["uid"] = this.uid;
        data["comments"] = this.comments;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfClosure"] = this.dateOfClosure ? this.dateOfClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessHours"] = this.businessHours;
        if (Array.isArray(this.inspectors)) {
            data["inspectors"] = [];
            for (let item of this.inspectors)
                data["inspectors"].push(item);
        }
        if (Array.isArray(this.licences)) {
            data["licences"] = [];
            for (let item of this.licences)
                data["licences"].push(item.toJSON());
        }
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateBusinessInput {
    typeId: string;
    legalFormId: string | undefined;
    name: string;
    additionalName: string | undefined;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    cantonId: string | undefined;
    municipalityId: string | undefined;
    regionId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    email2: string | undefined;
    fax: string | undefined;
    website: string | undefined;
    gln: string | undefined;
    bur: string | undefined;
    uid: string | undefined;
    comments: string | undefined;
    dateOfOpening: DateTime | undefined;
    dateOfClosure: DateTime | undefined;
    businessHours: string | undefined;
    inspectors: number[] | undefined;
    licences: CorporateLicenceDto[] | undefined;
    employments: GetEmploymentDto[] | undefined;
    id: number;
}

export class CacheDto implements ICacheDto {
    name!: string | undefined;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICacheDto {
    name: string | undefined;
}

export enum CogsDeliveryType {
    Original = 1,
    Copy = 2,
}

export class CogsAdditionalAddressDto implements ICogsAdditionalAddressDto {
    nameOfOffice!: string | undefined;
    countryId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    email!: string | undefined;
    deliveryType!: CogsDeliveryType;

    constructor(data?: ICogsAdditionalAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameOfOffice = _data["nameOfOffice"];
            this.countryId = _data["countryId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.email = _data["email"];
            this.deliveryType = _data["deliveryType"];
        }
    }

    static fromJS(data: any): CogsAdditionalAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CogsAdditionalAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameOfOffice"] = this.nameOfOffice;
        data["countryId"] = this.countryId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["email"] = this.email;
        data["deliveryType"] = this.deliveryType;
        return data;
    }
}

export interface ICogsAdditionalAddressDto {
    nameOfOffice: string | undefined;
    countryId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    email: string | undefined;
    deliveryType: CogsDeliveryType;
}

export class CogsContactDto implements ICogsContactDto {
    titleId!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    email1!: string | undefined;
    email2!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    countryId!: string | undefined;

    constructor(data?: ICogsContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.email1 = _data["email1"];
            this.email2 = _data["email2"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): CogsContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new CogsContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["email1"] = this.email1;
        data["email2"] = this.email2;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface ICogsContactDto {
    titleId: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    email1: string | undefined;
    email2: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    countryId: string | undefined;
}

export class CogsDto implements ICogsDto {
    application!: ApplicationDto;
    professionId!: string | undefined;
    currentStep!: CogsStatus;
    languageOfCogsId!: string | undefined;
    cogsPerson!: CogsPersonDto;
    cogsContact!: CogsContactDto;
    cogsAdditionalAddress!: CogsAdditionalAddressDto;
    cogsInvoiceAddress!: CogsInvoiceAddressDto;

    constructor(data?: ICogsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.professionId = _data["professionId"];
            this.currentStep = _data["currentStep"];
            this.languageOfCogsId = _data["languageOfCogsId"];
            this.cogsPerson = _data["cogsPerson"] ? CogsPersonDto.fromJS(_data["cogsPerson"]) : <any>undefined;
            this.cogsContact = _data["cogsContact"] ? CogsContactDto.fromJS(_data["cogsContact"]) : <any>undefined;
            this.cogsAdditionalAddress = _data["cogsAdditionalAddress"] ? CogsAdditionalAddressDto.fromJS(_data["cogsAdditionalAddress"]) : <any>undefined;
            this.cogsInvoiceAddress = _data["cogsInvoiceAddress"] ? CogsInvoiceAddressDto.fromJS(_data["cogsInvoiceAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CogsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CogsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["professionId"] = this.professionId;
        data["currentStep"] = this.currentStep;
        data["languageOfCogsId"] = this.languageOfCogsId;
        data["cogsPerson"] = this.cogsPerson ? this.cogsPerson.toJSON() : <any>undefined;
        data["cogsContact"] = this.cogsContact ? this.cogsContact.toJSON() : <any>undefined;
        data["cogsAdditionalAddress"] = this.cogsAdditionalAddress ? this.cogsAdditionalAddress.toJSON() : <any>undefined;
        data["cogsInvoiceAddress"] = this.cogsInvoiceAddress ? this.cogsInvoiceAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICogsDto {
    application: ApplicationDto;
    professionId: string | undefined;
    currentStep: CogsStatus;
    languageOfCogsId: string | undefined;
    cogsPerson: CogsPersonDto;
    cogsContact: CogsContactDto;
    cogsAdditionalAddress: CogsAdditionalAddressDto;
    cogsInvoiceAddress: CogsInvoiceAddressDto;
}

export class CogsInvoiceAddressDto implements ICogsInvoiceAddressDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    typeOfAddressId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    completionStatus!: CompletionStatus;

    constructor(data?: ICogsInvoiceAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.typeOfAddressId = _data["typeOfAddressId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.completionStatus = _data["completionStatus"];
        }
    }

    static fromJS(data: any): CogsInvoiceAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CogsInvoiceAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["typeOfAddressId"] = this.typeOfAddressId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["completionStatus"] = this.completionStatus;
        return data;
    }
}

export interface ICogsInvoiceAddressDto {
    firstName: string | undefined;
    lastName: string | undefined;
    typeOfAddressId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    completionStatus: CompletionStatus;
}

export class CogsPersonDto implements ICogsPersonDto {
    gln!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    professionId!: string | undefined;
    medRegId!: number | undefined;
    psyRegId!: number | undefined;
    naregId!: number | undefined;
    hasConfirmedData!: boolean | undefined;

    constructor(data?: ICogsPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.professionId = _data["professionId"];
            this.medRegId = _data["medRegId"];
            this.psyRegId = _data["psyRegId"];
            this.naregId = _data["naregId"];
            this.hasConfirmedData = _data["hasConfirmedData"];
        }
    }

    static fromJS(data: any): CogsPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CogsPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["professionId"] = this.professionId;
        data["medRegId"] = this.medRegId;
        data["psyRegId"] = this.psyRegId;
        data["naregId"] = this.naregId;
        data["hasConfirmedData"] = this.hasConfirmedData;
        return data;
    }
}

export interface ICogsPersonDto {
    gln: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    professionId: string | undefined;
    medRegId: number | undefined;
    psyRegId: number | undefined;
    naregId: number | undefined;
    hasConfirmedData: boolean | undefined;
}

export class CreateCogsApplicationDto implements ICreateCogsApplicationDto {
    professionId!: string;
    legitimationId!: number;
    gln!: string | undefined;

    constructor(data?: ICreateCogsApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.legitimationId = _data["legitimationId"];
            this.gln = _data["gln"];
        }
    }

    static fromJS(data: any): CreateCogsApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCogsApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["legitimationId"] = this.legitimationId;
        data["gln"] = this.gln;
        return data;
    }
}

export interface ICreateCogsApplicationDto {
    professionId: string;
    legitimationId: number;
    gln: string | undefined;
}

export class CreateOrUpdateCogsAdditionalAddressInput implements ICreateOrUpdateCogsAdditionalAddressInput {
    caseId!: string;
    cogsAdditionalAddress!: CogsAdditionalAddressDto;

    constructor(data?: ICreateOrUpdateCogsAdditionalAddressInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.cogsAdditionalAddress = new CogsAdditionalAddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.cogsAdditionalAddress = _data["cogsAdditionalAddress"] ? CogsAdditionalAddressDto.fromJS(_data["cogsAdditionalAddress"]) : new CogsAdditionalAddressDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateCogsAdditionalAddressInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCogsAdditionalAddressInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["cogsAdditionalAddress"] = this.cogsAdditionalAddress ? this.cogsAdditionalAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateCogsAdditionalAddressInput {
    caseId: string;
    cogsAdditionalAddress: CogsAdditionalAddressDto;
}

export class CreateOrUpdateCogsContactInput implements ICreateOrUpdateCogsContactInput {
    caseId!: string;
    cogsContact!: CogsContactDto;

    constructor(data?: ICreateOrUpdateCogsContactInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.cogsContact = new CogsContactDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.cogsContact = _data["cogsContact"] ? CogsContactDto.fromJS(_data["cogsContact"]) : new CogsContactDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateCogsContactInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCogsContactInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["cogsContact"] = this.cogsContact ? this.cogsContact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateCogsContactInput {
    caseId: string;
    cogsContact: CogsContactDto;
}

export class CreateOrUpdateCogsInvoiceAddressInput implements ICreateOrUpdateCogsInvoiceAddressInput {
    caseId!: string;
    cogsInvoiceAddress!: CogsInvoiceAddressDto;

    constructor(data?: ICreateOrUpdateCogsInvoiceAddressInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.cogsInvoiceAddress = new CogsInvoiceAddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.cogsInvoiceAddress = _data["cogsInvoiceAddress"] ? CogsInvoiceAddressDto.fromJS(_data["cogsInvoiceAddress"]) : new CogsInvoiceAddressDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateCogsInvoiceAddressInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCogsInvoiceAddressInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["cogsInvoiceAddress"] = this.cogsInvoiceAddress ? this.cogsInvoiceAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateCogsInvoiceAddressInput {
    caseId: string;
    cogsInvoiceAddress: CogsInvoiceAddressDto;
}

export class GetCogsOutput implements IGetCogsOutput {
    cogs!: CogsDto;

    constructor(data?: IGetCogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cogs = _data["cogs"] ? CogsDto.fromJS(_data["cogs"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCogsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cogs"] = this.cogs ? this.cogs.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCogsOutput {
    cogs: CogsDto;
}

export enum ChatMessageReadState {
    Unread = 1,
    Read = 2,
}

export enum ChatSide {
    Sender = 1,
    Receiver = 2,
}

export class ChatMessageDto implements IChatMessageDto {
    userId!: number;
    tenantId!: number | undefined;
    targetUserId!: number;
    targetTenantId!: number | undefined;
    side!: ChatSide;
    readState!: ChatMessageReadState;
    receiverReadState!: ChatMessageReadState;
    message!: string | undefined;
    creationTime!: DateTime;
    sharedMessageId!: string | undefined;
    id!: number;

    constructor(data?: IChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.targetUserId = _data["targetUserId"];
            this.targetTenantId = _data["targetTenantId"];
            this.side = _data["side"];
            this.readState = _data["readState"];
            this.receiverReadState = _data["receiverReadState"];
            this.message = _data["message"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.sharedMessageId = _data["sharedMessageId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["targetUserId"] = this.targetUserId;
        data["targetTenantId"] = this.targetTenantId;
        data["side"] = this.side;
        data["readState"] = this.readState;
        data["receiverReadState"] = this.receiverReadState;
        data["message"] = this.message;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["sharedMessageId"] = this.sharedMessageId;
        data["id"] = this.id;
        return data;
    }
}

export interface IChatMessageDto {
    userId: number;
    tenantId: number | undefined;
    targetUserId: number;
    targetTenantId: number | undefined;
    side: ChatSide;
    readState: ChatMessageReadState;
    receiverReadState: ChatMessageReadState;
    message: string | undefined;
    creationTime: DateTime;
    sharedMessageId: string | undefined;
    id: number;
}

export class GetUserChatFriendsWithSettingsOutput implements IGetUserChatFriendsWithSettingsOutput {
    serverTime!: DateTime;
    friends!: FriendDto[] | undefined;

    constructor(data?: IGetUserChatFriendsWithSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverTime = _data["serverTime"] ? DateTime.fromISO(_data["serverTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["friends"])) {
                this.friends = [] as any;
                for (let item of _data["friends"])
                    this.friends!.push(FriendDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserChatFriendsWithSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserChatFriendsWithSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverTime"] = this.serverTime ? this.serverTime.toString() : <any>undefined;
        if (Array.isArray(this.friends)) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserChatFriendsWithSettingsOutput {
    serverTime: DateTime;
    friends: FriendDto[] | undefined;
}

export class MarkAllUnreadMessagesOfUserAsReadInput implements IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IMarkAllUnreadMessagesOfUserAsReadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): MarkAllUnreadMessagesOfUserAsReadInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number | undefined;
    userId: number;
}

export enum CodeCategory {
    None = 0,
    Profession = 1,
    Diploma = 2,
    Language = 3,
    PostgraduateTitle = 4,
    PgdType = 5,
    Title = 6,
    Document = 7,
    BusinessLegalForm = 8,
    Gender = 10,
    Address = 11,
    LanguageSkillLevel = 12,
    Canton = 13,
    Country = 14,
    ProfessionalLicenceStatus = 15,
    LanguageSkill = 16,
    YesNo = 17,
    IdentificationStatus = 18,
    IdentificationType = 19,
    ProfessionalLicenceType = 20,
    NotifyDaysBeforeEnd = 21,
    LegalBasis = 22,
    EmploymentRole = 23,
    NarcExtent = 24,
    ChangeRequestStatus = 25,
    ChangeRequestType = 26,
    BusinessType = 27,
    Degree = 33,
    EvaluationStatus = 34,
    EhcPracticeDescription = 35,
    ElectronicPatientRecord = 36,
    ApplicationReleaseAction = 37,
    EmploymentType = 39,
    SuccessfulLicenceApplication = 40,
    RestrictionType = 41,
    ProfessionalLicenceActivityStatus = 42,
    PostgraduateTitleType = 43,
    PendenceField = 44,
    PendenceStatus = 45,
    PendenceType = 46,
    SponsorshipType = 47,
    LegalBasisCorporateLicence = 48,
    DmsDocCategory = 49,
    DmsDocType = 50,
    OperatingTheatreType = 51,
    EmploymentStatus = 52,
    BusinessStatus = 53,
    ServiceArea = 54,
    DmsTemplateType = 55,
    PracticeType = 56,
    MutationType = 57,
    EmploymentContractType = 58,
    InvoiceStatus = 59,
    InvoiceDistributionMethod = 61,
    InvoiceContext = 62,
    SqlQueryCategory = 63,
    SensitiveDataDisciplinaryMeasureType = 64,
    InvoiceAddressType = 65,
    CantonalDepartment = 66,
    PreviousEmploymentType = 67,
    AdditionalLicenceInformationPerson = 68,
    AdditionalLicenceInformationSponsorship = 69,
    ProfessionalResponsibilityType = 70,
    EmploymentLocationType = 71,
    District = 74,
    PostgraduateTitleCourseOfEducation = 75,
    EhcSelfEmployment = 76,
    ReproductiveMedicineDetail = 77,
    TitleLetter = 79,
    InvoiceCostCenter = 80,
    InvoiceCostElement = 81,
    InvoiceInternalOrder = 82,
    EhcType = 83,
    LogbookContactType = 84,
    LogbookContext = 85,
    Quarter = 86,
    NarcoticPrescriptionBlockOrderDeliveryOption = 87,
    NarcoticPrescriptionBlockStatus = 88,
    NursingWorkplaceType = 89,
    PracticeEstablishmentType = 90,
    ProfessionalRoleType = 91,
    Municipality = 92,
    Region = 93,
    SponsorshipField = 94,
    SponsorshipRangeOfService = 95,
    InspectionReason = 96,
    InspectionDeficiencyCategory = 97,
    InspectionCheckpoint = 98,
    AdditionalInformationBusiness = 99,
    CogsLanguage = 100,
    LiaEmploymentKind = 101,
    CogsDestination = 102,
    InspectionCantonalDepartment = 103,
    SlapBusinessReasonOfMutation = 104,
    AlaTimeToExam = 105,
    EducationProviderTheory = 106,
    PrevEducation = 107,
    CourseOfStudy = 108,
    Semester = 109,
    ReminderField = 110,
    ReminderSubject = 111,
    ReminderStatus = 112,
    AnswerApplicationStatus = 113,
    LevelOfEducation = 114,
}

export enum CodeSubcategory {
    None = 0,
    DaycareProfession = 1,
    PersonLicenceProfession = 2,
    EhcApplicationReleaseAction = 3,
    ExternalSystemMedReg = 4,
    ExternalSystemPsyReg = 5,
    ExternalSystemNareg = 6,
    EhcApplicationWithdrawAction = 7,
    ClaEhcReleaseAction = 8,
    TertiaryA = 9,
    TertiaryB = 10,
}

export class CodeEditDto implements ICodeEditDto {
    id!: string | undefined;
    codeCategory!: CodeCategory;
    codeSubcategory!: CodeSubcategory;
    isActive!: boolean;
    isSystem!: boolean;
    listIndex!: number | undefined;
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;

    constructor(data?: ICodeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.codeCategory = _data["codeCategory"];
            this.codeSubcategory = _data["codeSubcategory"];
            this.isActive = _data["isActive"];
            this.isSystem = _data["isSystem"];
            this.listIndex = _data["listIndex"];
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
        }
    }

    static fromJS(data: any): CodeEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CodeEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["codeCategory"] = this.codeCategory;
        data["codeSubcategory"] = this.codeSubcategory;
        data["isActive"] = this.isActive;
        data["isSystem"] = this.isSystem;
        data["listIndex"] = this.listIndex;
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        return data;
    }
}

export interface ICodeEditDto {
    id: string | undefined;
    codeCategory: CodeCategory;
    codeSubcategory: CodeSubcategory;
    isActive: boolean;
    isSystem: boolean;
    listIndex: number | undefined;
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
}

export class CodeListDto implements ICodeListDto {
    codeCategory!: CodeCategory;
    codeSubcategory!: CodeSubcategory;
    isActive!: boolean;
    isSystem!: boolean;
    listIndex!: number | undefined;
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    creationTime!: DateTime;
    id!: string | undefined;

    constructor(data?: ICodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeCategory = _data["codeCategory"];
            this.codeSubcategory = _data["codeSubcategory"];
            this.isActive = _data["isActive"];
            this.isSystem = _data["isSystem"];
            this.listIndex = _data["listIndex"];
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CodeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeCategory"] = this.codeCategory;
        data["codeSubcategory"] = this.codeSubcategory;
        data["isActive"] = this.isActive;
        data["isSystem"] = this.isSystem;
        data["listIndex"] = this.listIndex;
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICodeListDto {
    codeCategory: CodeCategory;
    codeSubcategory: CodeSubcategory;
    isActive: boolean;
    isSystem: boolean;
    listIndex: number | undefined;
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    creationTime: DateTime;
    id: string | undefined;
}

export class CreateOrUpdateCodeInput implements ICreateOrUpdateCodeInput {
    code!: CodeEditDto;
    edit!: boolean;

    constructor(data?: ICreateOrUpdateCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.code = new CodeEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] ? CodeEditDto.fromJS(_data["code"]) : new CodeEditDto();
            this.edit = _data["edit"];
        }
    }

    static fromJS(data: any): CreateOrUpdateCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code ? this.code.toJSON() : <any>undefined;
        data["edit"] = this.edit;
        return data;
    }
}

export interface ICreateOrUpdateCodeInput {
    code: CodeEditDto;
    edit: boolean;
}

export class GetCodeForEditOutput implements IGetCodeForEditOutput {
    code!: CodeEditDto;

    constructor(data?: IGetCodeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] ? CodeEditDto.fromJS(_data["code"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCodeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCodeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code ? this.code.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCodeForEditOutput {
    code: CodeEditDto;
}

export class HealthRegisterCodeDto implements IHealthRegisterCodeDto {
    healthRegisterId!: number;
    healthRegisterDescription!: string | undefined;
    sironaId!: string | undefined;

    constructor(data?: IHealthRegisterCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRegisterId = _data["healthRegisterId"];
            this.healthRegisterDescription = _data["healthRegisterDescription"];
            this.sironaId = _data["sironaId"];
        }
    }

    static fromJS(data: any): HealthRegisterCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRegisterId"] = this.healthRegisterId;
        data["healthRegisterDescription"] = this.healthRegisterDescription;
        data["sironaId"] = this.sironaId;
        return data;
    }
}

export interface IHealthRegisterCodeDto {
    healthRegisterId: number;
    healthRegisterDescription: string | undefined;
    sironaId: string | undefined;
}

export class HealthRegisterLabelDto implements IHealthRegisterLabelDto {
    labelDe!: string | undefined;
    labelFr!: string | undefined;
    labelIt!: string | undefined;
    labelEn!: string | undefined;

    constructor(data?: IHealthRegisterLabelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labelDe = _data["labelDe"];
            this.labelFr = _data["labelFr"];
            this.labelIt = _data["labelIt"];
            this.labelEn = _data["labelEn"];
        }
    }

    static fromJS(data: any): HealthRegisterLabelDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterLabelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelDe"] = this.labelDe;
        data["labelFr"] = this.labelFr;
        data["labelIt"] = this.labelIt;
        data["labelEn"] = this.labelEn;
        return data;
    }
}

export interface IHealthRegisterLabelDto {
    labelDe: string | undefined;
    labelFr: string | undefined;
    labelIt: string | undefined;
    labelEn: string | undefined;
}

export class HealthRegisterCode implements IHealthRegisterCode {
    healthRegisterId!: number;
    healthRegisterDescription!: string | undefined;
    sironaId!: string | undefined;

    constructor(data?: IHealthRegisterCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRegisterId = _data["healthRegisterId"];
            this.healthRegisterDescription = _data["healthRegisterDescription"];
            this.sironaId = _data["sironaId"];
        }
    }

    static fromJS(data: any): HealthRegisterCode {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRegisterId"] = this.healthRegisterId;
        data["healthRegisterDescription"] = this.healthRegisterDescription;
        data["sironaId"] = this.sironaId;
        return data;
    }
}

export interface IHealthRegisterCode {
    healthRegisterId: number;
    healthRegisterDescription: string | undefined;
    sironaId: string | undefined;
}

export class ApplicationUploadFilesInput implements IApplicationUploadFilesInput {
    caseId!: string;
    step!: number;
    typeId!: string;
    appendFiles!: boolean;
    files!: GeneralFileDto[];

    constructor(data?: IApplicationUploadFilesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.files = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.typeId = _data["typeId"];
            this.appendFiles = _data["appendFiles"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(GeneralFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApplicationUploadFilesInput {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUploadFilesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["typeId"] = this.typeId;
        data["appendFiles"] = this.appendFiles;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApplicationUploadFilesInput {
    caseId: string;
    step: number;
    typeId: string;
    appendFiles: boolean;
    files: GeneralFileDto[];
}

export class FindUsersInput implements IFindUsersInput {
    tenantId!: number | undefined;
    excludeCurrentUser!: boolean;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.excludeCurrentUser = _data["excludeCurrentUser"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["excludeCurrentUser"] = this.excludeCurrentUser;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindUsersInput {
    tenantId: number | undefined;
    excludeCurrentUser: boolean;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class GeneralFileDto implements IGeneralFileDto {
    file!: string;
    name!: string | undefined;
    typeId!: string | undefined;
    isMandatory!: boolean | undefined;
    additionalProperties!: { [key: string]: string; } | undefined;
    id!: number;

    constructor(data?: IGeneralFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"];
            this.name = _data["name"];
            this.typeId = _data["typeId"];
            this.isMandatory = _data["isMandatory"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GeneralFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file;
        data["name"] = this.name;
        data["typeId"] = this.typeId;
        data["isMandatory"] = this.isMandatory;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGeneralFileDto {
    file: string;
    name: string | undefined;
    typeId: string | undefined;
    isMandatory: boolean | undefined;
    additionalProperties: { [key: string]: string; } | undefined;
    id: number;
}

export class GeneralFileInfoDto implements IGeneralFileInfoDto {
    name!: string | undefined;
    typeId!: string | undefined;
    isMandatory!: boolean | undefined;
    additionalProperties!: { [key: string]: string; } | undefined;
    id!: number;

    constructor(data?: IGeneralFileInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.typeId = _data["typeId"];
            this.isMandatory = _data["isMandatory"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GeneralFileInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralFileInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["typeId"] = this.typeId;
        data["isMandatory"] = this.isMandatory;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGeneralFileInfoDto {
    name: string | undefined;
    typeId: string | undefined;
    isMandatory: boolean | undefined;
    additionalProperties: { [key: string]: string; } | undefined;
    id: number;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name!: string | undefined;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetDefaultEditionNameOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string | undefined;
}

export class GeneralFileInfo implements IGeneralFileInfo {
    id!: number;
    name!: string | undefined;
    typeId!: string | undefined;
    isMandatory!: boolean | undefined;
    additionalProperties!: { [key: string]: string; } | undefined;

    constructor(data?: IGeneralFileInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.typeId = _data["typeId"];
            this.isMandatory = _data["isMandatory"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): GeneralFileInfo {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralFileInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["typeId"] = this.typeId;
        data["isMandatory"] = this.isMandatory;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IGeneralFileInfo {
    id: number;
    name: string | undefined;
    typeId: string | undefined;
    isMandatory: boolean | undefined;
    additionalProperties: { [key: string]: string; } | undefined;
}

export class ConfigDto implements IConfigDto {
    settings!: { [key: string]: string; } | undefined;

    constructor(data?: IConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["settings"]) {
                this.settings = {} as any;
                for (let key in _data["settings"]) {
                    if (_data["settings"].hasOwnProperty(key))
                        (<any>this.settings)![key] = _data["settings"][key];
                }
            }
        }
    }

    static fromJS(data: any): ConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.settings) {
            data["settings"] = {};
            for (let key in this.settings) {
                if (this.settings.hasOwnProperty(key))
                    (<any>data["settings"])[key] = (<any>this.settings)[key];
            }
        }
        return data;
    }
}

export interface IConfigDto {
    settings: { [key: string]: string; } | undefined;
}

export class CreateOrUpdateExternalSystemCertificateInput implements ICreateOrUpdateExternalSystemCertificateInput {
    certificate!: string;
    certificatePassword!: string;
    externalSystemId!: ExternalSystemEnum;

    constructor(data?: ICreateOrUpdateExternalSystemCertificateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.certificate = _data["certificate"];
            this.certificatePassword = _data["certificatePassword"];
            this.externalSystemId = _data["externalSystemId"];
        }
    }

    static fromJS(data: any): CreateOrUpdateExternalSystemCertificateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateExternalSystemCertificateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificate"] = this.certificate;
        data["certificatePassword"] = this.certificatePassword;
        data["externalSystemId"] = this.externalSystemId;
        return data;
    }
}

export interface ICreateOrUpdateExternalSystemCertificateInput {
    certificate: string;
    certificatePassword: string;
    externalSystemId: ExternalSystemEnum;
}

export class CreateOrUpdateExternalSystemCredentialsInput implements ICreateOrUpdateExternalSystemCredentialsInput {
    externalSystemCredentialsList!: ExternalSystemCredentialsDto[] | undefined;

    constructor(data?: ICreateOrUpdateExternalSystemCredentialsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["externalSystemCredentialsList"])) {
                this.externalSystemCredentialsList = [] as any;
                for (let item of _data["externalSystemCredentialsList"])
                    this.externalSystemCredentialsList!.push(ExternalSystemCredentialsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateExternalSystemCredentialsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateExternalSystemCredentialsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.externalSystemCredentialsList)) {
            data["externalSystemCredentialsList"] = [];
            for (let item of this.externalSystemCredentialsList)
                data["externalSystemCredentialsList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateExternalSystemCredentialsInput {
    externalSystemCredentialsList: ExternalSystemCredentialsDto[] | undefined;
}

export class DatabaseInfoDto implements IDatabaseInfoDto {
    serverVersion!: string | undefined;
    appliedMigrations!: string[] | undefined;
    pendingMigrations!: string[] | undefined;

    constructor(data?: IDatabaseInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverVersion = _data["serverVersion"];
            if (Array.isArray(_data["appliedMigrations"])) {
                this.appliedMigrations = [] as any;
                for (let item of _data["appliedMigrations"])
                    this.appliedMigrations!.push(item);
            }
            if (Array.isArray(_data["pendingMigrations"])) {
                this.pendingMigrations = [] as any;
                for (let item of _data["pendingMigrations"])
                    this.pendingMigrations!.push(item);
            }
        }
    }

    static fromJS(data: any): DatabaseInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DatabaseInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverVersion"] = this.serverVersion;
        if (Array.isArray(this.appliedMigrations)) {
            data["appliedMigrations"] = [];
            for (let item of this.appliedMigrations)
                data["appliedMigrations"].push(item);
        }
        if (Array.isArray(this.pendingMigrations)) {
            data["pendingMigrations"] = [];
            for (let item of this.pendingMigrations)
                data["pendingMigrations"].push(item);
        }
        return data;
    }
}

export interface IDatabaseInfoDto {
    serverVersion: string | undefined;
    appliedMigrations: string[] | undefined;
    pendingMigrations: string[] | undefined;
}

export class EnvironmentDto implements IEnvironmentDto {
    version!: string | undefined;
    environment!: string | undefined;
    lastCommitSha!: string | undefined;
    lastCommitShortSha!: string | undefined;
    fullSemVer!: string | undefined;
    releaseDate!: DateTime;
    commitDate!: string | undefined;
    showMaintenanceInfo!: boolean;

    constructor(data?: IEnvironmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.environment = _data["environment"];
            this.lastCommitSha = _data["lastCommitSha"];
            this.lastCommitShortSha = _data["lastCommitShortSha"];
            this.fullSemVer = _data["fullSemVer"];
            this.releaseDate = _data["releaseDate"] ? DateTime.fromISO(_data["releaseDate"].toString()) : <any>undefined;
            this.commitDate = _data["commitDate"];
            this.showMaintenanceInfo = _data["showMaintenanceInfo"];
        }
    }

    static fromJS(data: any): EnvironmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnvironmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["environment"] = this.environment;
        data["lastCommitSha"] = this.lastCommitSha;
        data["lastCommitShortSha"] = this.lastCommitShortSha;
        data["fullSemVer"] = this.fullSemVer;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toString() : <any>undefined;
        data["commitDate"] = this.commitDate;
        data["showMaintenanceInfo"] = this.showMaintenanceInfo;
        return data;
    }
}

export interface IEnvironmentDto {
    version: string | undefined;
    environment: string | undefined;
    lastCommitSha: string | undefined;
    lastCommitShortSha: string | undefined;
    fullSemVer: string | undefined;
    releaseDate: DateTime;
    commitDate: string | undefined;
    showMaintenanceInfo: boolean;
}

export class ExternalSystemCredentialsDto implements IExternalSystemCredentialsDto {
    externalSystemId!: ExternalSystemEnum;
    userName!: string | undefined;
    password!: string | undefined;
    refreshToken!: string | undefined;
    usePartnerService!: boolean;

    constructor(data?: IExternalSystemCredentialsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalSystemId = _data["externalSystemId"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.refreshToken = _data["refreshToken"];
            this.usePartnerService = _data["usePartnerService"];
        }
    }

    static fromJS(data: any): ExternalSystemCredentialsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalSystemCredentialsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalSystemId"] = this.externalSystemId;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["refreshToken"] = this.refreshToken;
        data["usePartnerService"] = this.usePartnerService;
        return data;
    }
}

export interface IExternalSystemCredentialsDto {
    externalSystemId: ExternalSystemEnum;
    userName: string | undefined;
    password: string | undefined;
    refreshToken: string | undefined;
    usePartnerService: boolean;
}

export class ExternalSystemCredentialsOutput implements IExternalSystemCredentialsOutput {
    externalSystemId!: ExternalSystemEnum;
    userName!: string | undefined;
    password!: string | undefined;
    refreshToken!: string | undefined;
    certificate!: SslCertificateDto;
    usePartnerService!: boolean;

    constructor(data?: IExternalSystemCredentialsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalSystemId = _data["externalSystemId"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.refreshToken = _data["refreshToken"];
            this.certificate = _data["certificate"] ? SslCertificateDto.fromJS(_data["certificate"]) : <any>undefined;
            this.usePartnerService = _data["usePartnerService"];
        }
    }

    static fromJS(data: any): ExternalSystemCredentialsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalSystemCredentialsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalSystemId"] = this.externalSystemId;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["refreshToken"] = this.refreshToken;
        data["certificate"] = this.certificate ? this.certificate.toJSON() : <any>undefined;
        data["usePartnerService"] = this.usePartnerService;
        return data;
    }
}

export interface IExternalSystemCredentialsOutput {
    externalSystemId: ExternalSystemEnum;
    userName: string | undefined;
    password: string | undefined;
    refreshToken: string | undefined;
    certificate: SslCertificateDto;
    usePartnerService: boolean;
}

export class GetExternalSystemCredentials implements IGetExternalSystemCredentials {
    externalSystemCredentials!: ExternalSystemCredentialsOutput[] | undefined;

    constructor(data?: IGetExternalSystemCredentials) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["externalSystemCredentials"])) {
                this.externalSystemCredentials = [] as any;
                for (let item of _data["externalSystemCredentials"])
                    this.externalSystemCredentials!.push(ExternalSystemCredentialsOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetExternalSystemCredentials {
        data = typeof data === 'object' ? data : {};
        let result = new GetExternalSystemCredentials();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.externalSystemCredentials)) {
            data["externalSystemCredentials"] = [];
            for (let item of this.externalSystemCredentials)
                data["externalSystemCredentials"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetExternalSystemCredentials {
    externalSystemCredentials: ExternalSystemCredentialsOutput[] | undefined;
}

export class MaintenanceConfigDto implements IMaintenanceConfigDto {
    isMaintenanceBannerEnabled!: boolean;
    disableLiaCreateUntil!: DateTime | undefined;
    disableLiaSubmissionUntil!: DateTime | undefined;
    disableLiaServiceUntil!: DateTime | undefined;
    disableLiaForAuthority!: boolean;
    disableClaCreateUntil!: DateTime | undefined;
    disableClaSubmissionUntil!: DateTime | undefined;
    disableClaServiceUntil!: DateTime | undefined;
    disableClaForAuthority!: boolean;

    constructor(data?: IMaintenanceConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMaintenanceBannerEnabled = _data["isMaintenanceBannerEnabled"];
            this.disableLiaCreateUntil = _data["disableLiaCreateUntil"] ? DateTime.fromISO(_data["disableLiaCreateUntil"].toString()) : <any>undefined;
            this.disableLiaSubmissionUntil = _data["disableLiaSubmissionUntil"] ? DateTime.fromISO(_data["disableLiaSubmissionUntil"].toString()) : <any>undefined;
            this.disableLiaServiceUntil = _data["disableLiaServiceUntil"] ? DateTime.fromISO(_data["disableLiaServiceUntil"].toString()) : <any>undefined;
            this.disableLiaForAuthority = _data["disableLiaForAuthority"];
            this.disableClaCreateUntil = _data["disableClaCreateUntil"] ? DateTime.fromISO(_data["disableClaCreateUntil"].toString()) : <any>undefined;
            this.disableClaSubmissionUntil = _data["disableClaSubmissionUntil"] ? DateTime.fromISO(_data["disableClaSubmissionUntil"].toString()) : <any>undefined;
            this.disableClaServiceUntil = _data["disableClaServiceUntil"] ? DateTime.fromISO(_data["disableClaServiceUntil"].toString()) : <any>undefined;
            this.disableClaForAuthority = _data["disableClaForAuthority"];
        }
    }

    static fromJS(data: any): MaintenanceConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMaintenanceBannerEnabled"] = this.isMaintenanceBannerEnabled;
        data["disableLiaCreateUntil"] = this.disableLiaCreateUntil ? this.disableLiaCreateUntil.toString() : <any>undefined;
        data["disableLiaSubmissionUntil"] = this.disableLiaSubmissionUntil ? this.disableLiaSubmissionUntil.toString() : <any>undefined;
        data["disableLiaServiceUntil"] = this.disableLiaServiceUntil ? this.disableLiaServiceUntil.toString() : <any>undefined;
        data["disableLiaForAuthority"] = this.disableLiaForAuthority;
        data["disableClaCreateUntil"] = this.disableClaCreateUntil ? this.disableClaCreateUntil.toString() : <any>undefined;
        data["disableClaSubmissionUntil"] = this.disableClaSubmissionUntil ? this.disableClaSubmissionUntil.toString() : <any>undefined;
        data["disableClaServiceUntil"] = this.disableClaServiceUntil ? this.disableClaServiceUntil.toString() : <any>undefined;
        data["disableClaForAuthority"] = this.disableClaForAuthority;
        return data;
    }
}

export interface IMaintenanceConfigDto {
    isMaintenanceBannerEnabled: boolean;
    disableLiaCreateUntil: DateTime | undefined;
    disableLiaSubmissionUntil: DateTime | undefined;
    disableLiaServiceUntil: DateTime | undefined;
    disableLiaForAuthority: boolean;
    disableClaCreateUntil: DateTime | undefined;
    disableClaSubmissionUntil: DateTime | undefined;
    disableClaServiceUntil: DateTime | undefined;
    disableClaForAuthority: boolean;
}

export class SironaMutationSettingDto implements ISironaMutationSettingDto {
    personNameAutomaticUpdateOnApproval!: boolean;
    personContactAutomaticUpdateOnApproval!: boolean;
    additionalAcademicTitleAutomaticUpdateOnApproval!: boolean;
    sponsorshipNameAutomaticUpdateOnApproval!: boolean;
    sponsorshipAddressAutomaticUpdateOnApproval!: boolean;
    sponsorshipContactAutomaticUpdateOnApproval!: boolean;

    constructor(data?: ISironaMutationSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personNameAutomaticUpdateOnApproval = _data["personNameAutomaticUpdateOnApproval"];
            this.personContactAutomaticUpdateOnApproval = _data["personContactAutomaticUpdateOnApproval"];
            this.additionalAcademicTitleAutomaticUpdateOnApproval = _data["additionalAcademicTitleAutomaticUpdateOnApproval"];
            this.sponsorshipNameAutomaticUpdateOnApproval = _data["sponsorshipNameAutomaticUpdateOnApproval"];
            this.sponsorshipAddressAutomaticUpdateOnApproval = _data["sponsorshipAddressAutomaticUpdateOnApproval"];
            this.sponsorshipContactAutomaticUpdateOnApproval = _data["sponsorshipContactAutomaticUpdateOnApproval"];
        }
    }

    static fromJS(data: any): SironaMutationSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SironaMutationSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personNameAutomaticUpdateOnApproval"] = this.personNameAutomaticUpdateOnApproval;
        data["personContactAutomaticUpdateOnApproval"] = this.personContactAutomaticUpdateOnApproval;
        data["additionalAcademicTitleAutomaticUpdateOnApproval"] = this.additionalAcademicTitleAutomaticUpdateOnApproval;
        data["sponsorshipNameAutomaticUpdateOnApproval"] = this.sponsorshipNameAutomaticUpdateOnApproval;
        data["sponsorshipAddressAutomaticUpdateOnApproval"] = this.sponsorshipAddressAutomaticUpdateOnApproval;
        data["sponsorshipContactAutomaticUpdateOnApproval"] = this.sponsorshipContactAutomaticUpdateOnApproval;
        return data;
    }
}

export interface ISironaMutationSettingDto {
    personNameAutomaticUpdateOnApproval: boolean;
    personContactAutomaticUpdateOnApproval: boolean;
    additionalAcademicTitleAutomaticUpdateOnApproval: boolean;
    sponsorshipNameAutomaticUpdateOnApproval: boolean;
    sponsorshipAddressAutomaticUpdateOnApproval: boolean;
    sponsorshipContactAutomaticUpdateOnApproval: boolean;
}

export class SironaPrimedocSettingDto implements ISironaPrimedocSettingDto {
    enabled!: boolean;
    server!: string | undefined;
    user!: string | undefined;
    password!: string | undefined;

    constructor(data?: ISironaPrimedocSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.server = _data["server"];
            this.user = _data["user"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): SironaPrimedocSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SironaPrimedocSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["server"] = this.server;
        data["user"] = this.user;
        data["password"] = this.password;
        return data;
    }
}

export interface ISironaPrimedocSettingDto {
    enabled: boolean;
    server: string | undefined;
    user: string | undefined;
    password: string | undefined;
}

export class SironaSettingDto implements ISironaSettingDto {
    disableLanguageOfCorrespondence!: boolean;
    ignoreEmploymentAddressPostCodeHasToBeInCanton!: boolean;
    disableApplicationReactivation!: boolean;
    disableDirectUserPermissionAssignment!: boolean;
    enableApplicationSubmittedNotification!: boolean;
    enableNewSupplementalClaimNotification!: boolean;
    enableSelfEmploymentTypeInEmploymentChangeRequest!: boolean;
    enableIgnoreNaregLicenceInThisCantonLicenceStatus!: boolean;
    enableExtendedEhcQualityRequirement!: boolean;
    enableExemptionAccordingArt37KvgForEhcPractice!: boolean;
    showUsernamePasswordInLoginForm!: boolean;
    showTextSigninWithInLoginForm!: boolean;
    showForgotPasswordInLoginForm!: boolean;
    showEmailActivationInLoginForm!: boolean;
    showRegisterInLoginForm!: boolean;
    showExternalLoginProviderFacebookInLoginForm!: boolean;
    showExternalLoginProviderFacebookInFooter!: boolean;
    showExternalLoginProviderGoogleInLoginForm!: boolean;
    showExternalLoginProviderGoogleInFooter!: boolean;
    showExternalLoginProviderMicrosoftInLoginForm!: boolean;
    showExternalLoginProviderMicrosoftInFooter!: boolean;
    showExternalLoginProviderOpenIdConnectInLoginForm!: boolean;
    showExternalLoginProviderOpenIdConnectInFooter!: boolean;
    showExternalLoginProviderBELoginInLoginForm!: boolean;
    showExternalLoginProviderBELoginInFooter!: boolean;
    showExternalLoginProvidereKontoInLoginForm!: boolean;
    showExternalLoginProvidereKontoInFooter!: boolean;
    showExternalLoginProviderWsFederationInLoginForm!: boolean;
    showExternalLoginProviderWsFederationInFooter!: boolean;
    showExternalLoginProviderTwitterInLoginForm!: boolean;
    showExternalLoginProviderTwitterInFooter!: boolean;
    showExternalLoginProviderKeycloakInLoginForm!: boolean;
    showExternalLoginProviderKeycloakInFooter!: boolean;
    showExternalLoginProviderBlKontoInLoginForm!: boolean;
    showExternalLoginProviderBlKontoInFooter!: boolean;
    allowedFileExtensionsForDocuments!: string | undefined;
    allowedFileExtensionsForApplicationDocuments!: string | undefined;
    maxFileLengthForDocuments!: number;
    enableWindowsAuthentication!: boolean;
    useHealthRegisterCacheForSnapshots!: boolean;
    inspectorRoleId!: number;
    allowedInternalEmailDomains!: string | undefined;

    constructor(data?: ISironaSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disableLanguageOfCorrespondence = _data["disableLanguageOfCorrespondence"];
            this.ignoreEmploymentAddressPostCodeHasToBeInCanton = _data["ignoreEmploymentAddressPostCodeHasToBeInCanton"];
            this.disableApplicationReactivation = _data["disableApplicationReactivation"];
            this.disableDirectUserPermissionAssignment = _data["disableDirectUserPermissionAssignment"];
            this.enableApplicationSubmittedNotification = _data["enableApplicationSubmittedNotification"];
            this.enableNewSupplementalClaimNotification = _data["enableNewSupplementalClaimNotification"];
            this.enableSelfEmploymentTypeInEmploymentChangeRequest = _data["enableSelfEmploymentTypeInEmploymentChangeRequest"];
            this.enableIgnoreNaregLicenceInThisCantonLicenceStatus = _data["enableIgnoreNaregLicenceInThisCantonLicenceStatus"];
            this.enableExtendedEhcQualityRequirement = _data["enableExtendedEhcQualityRequirement"];
            this.enableExemptionAccordingArt37KvgForEhcPractice = _data["enableExemptionAccordingArt37KvgForEhcPractice"];
            this.showUsernamePasswordInLoginForm = _data["showUsernamePasswordInLoginForm"];
            this.showTextSigninWithInLoginForm = _data["showTextSigninWithInLoginForm"];
            this.showForgotPasswordInLoginForm = _data["showForgotPasswordInLoginForm"];
            this.showEmailActivationInLoginForm = _data["showEmailActivationInLoginForm"];
            this.showRegisterInLoginForm = _data["showRegisterInLoginForm"];
            this.showExternalLoginProviderFacebookInLoginForm = _data["showExternalLoginProviderFacebookInLoginForm"];
            this.showExternalLoginProviderFacebookInFooter = _data["showExternalLoginProviderFacebookInFooter"];
            this.showExternalLoginProviderGoogleInLoginForm = _data["showExternalLoginProviderGoogleInLoginForm"];
            this.showExternalLoginProviderGoogleInFooter = _data["showExternalLoginProviderGoogleInFooter"];
            this.showExternalLoginProviderMicrosoftInLoginForm = _data["showExternalLoginProviderMicrosoftInLoginForm"];
            this.showExternalLoginProviderMicrosoftInFooter = _data["showExternalLoginProviderMicrosoftInFooter"];
            this.showExternalLoginProviderOpenIdConnectInLoginForm = _data["showExternalLoginProviderOpenIdConnectInLoginForm"];
            this.showExternalLoginProviderOpenIdConnectInFooter = _data["showExternalLoginProviderOpenIdConnectInFooter"];
            this.showExternalLoginProviderBELoginInLoginForm = _data["showExternalLoginProviderBELoginInLoginForm"];
            this.showExternalLoginProviderBELoginInFooter = _data["showExternalLoginProviderBELoginInFooter"];
            this.showExternalLoginProvidereKontoInLoginForm = _data["showExternalLoginProvidereKontoInLoginForm"];
            this.showExternalLoginProvidereKontoInFooter = _data["showExternalLoginProvidereKontoInFooter"];
            this.showExternalLoginProviderWsFederationInLoginForm = _data["showExternalLoginProviderWsFederationInLoginForm"];
            this.showExternalLoginProviderWsFederationInFooter = _data["showExternalLoginProviderWsFederationInFooter"];
            this.showExternalLoginProviderTwitterInLoginForm = _data["showExternalLoginProviderTwitterInLoginForm"];
            this.showExternalLoginProviderTwitterInFooter = _data["showExternalLoginProviderTwitterInFooter"];
            this.showExternalLoginProviderKeycloakInLoginForm = _data["showExternalLoginProviderKeycloakInLoginForm"];
            this.showExternalLoginProviderKeycloakInFooter = _data["showExternalLoginProviderKeycloakInFooter"];
            this.showExternalLoginProviderBlKontoInLoginForm = _data["showExternalLoginProviderBlKontoInLoginForm"];
            this.showExternalLoginProviderBlKontoInFooter = _data["showExternalLoginProviderBlKontoInFooter"];
            this.allowedFileExtensionsForDocuments = _data["allowedFileExtensionsForDocuments"];
            this.allowedFileExtensionsForApplicationDocuments = _data["allowedFileExtensionsForApplicationDocuments"];
            this.maxFileLengthForDocuments = _data["maxFileLengthForDocuments"];
            this.enableWindowsAuthentication = _data["enableWindowsAuthentication"];
            this.useHealthRegisterCacheForSnapshots = _data["useHealthRegisterCacheForSnapshots"];
            this.inspectorRoleId = _data["inspectorRoleId"];
            this.allowedInternalEmailDomains = _data["allowedInternalEmailDomains"];
        }
    }

    static fromJS(data: any): SironaSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SironaSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disableLanguageOfCorrespondence"] = this.disableLanguageOfCorrespondence;
        data["ignoreEmploymentAddressPostCodeHasToBeInCanton"] = this.ignoreEmploymentAddressPostCodeHasToBeInCanton;
        data["disableApplicationReactivation"] = this.disableApplicationReactivation;
        data["disableDirectUserPermissionAssignment"] = this.disableDirectUserPermissionAssignment;
        data["enableApplicationSubmittedNotification"] = this.enableApplicationSubmittedNotification;
        data["enableNewSupplementalClaimNotification"] = this.enableNewSupplementalClaimNotification;
        data["enableSelfEmploymentTypeInEmploymentChangeRequest"] = this.enableSelfEmploymentTypeInEmploymentChangeRequest;
        data["enableIgnoreNaregLicenceInThisCantonLicenceStatus"] = this.enableIgnoreNaregLicenceInThisCantonLicenceStatus;
        data["enableExtendedEhcQualityRequirement"] = this.enableExtendedEhcQualityRequirement;
        data["enableExemptionAccordingArt37KvgForEhcPractice"] = this.enableExemptionAccordingArt37KvgForEhcPractice;
        data["showUsernamePasswordInLoginForm"] = this.showUsernamePasswordInLoginForm;
        data["showTextSigninWithInLoginForm"] = this.showTextSigninWithInLoginForm;
        data["showForgotPasswordInLoginForm"] = this.showForgotPasswordInLoginForm;
        data["showEmailActivationInLoginForm"] = this.showEmailActivationInLoginForm;
        data["showRegisterInLoginForm"] = this.showRegisterInLoginForm;
        data["showExternalLoginProviderFacebookInLoginForm"] = this.showExternalLoginProviderFacebookInLoginForm;
        data["showExternalLoginProviderFacebookInFooter"] = this.showExternalLoginProviderFacebookInFooter;
        data["showExternalLoginProviderGoogleInLoginForm"] = this.showExternalLoginProviderGoogleInLoginForm;
        data["showExternalLoginProviderGoogleInFooter"] = this.showExternalLoginProviderGoogleInFooter;
        data["showExternalLoginProviderMicrosoftInLoginForm"] = this.showExternalLoginProviderMicrosoftInLoginForm;
        data["showExternalLoginProviderMicrosoftInFooter"] = this.showExternalLoginProviderMicrosoftInFooter;
        data["showExternalLoginProviderOpenIdConnectInLoginForm"] = this.showExternalLoginProviderOpenIdConnectInLoginForm;
        data["showExternalLoginProviderOpenIdConnectInFooter"] = this.showExternalLoginProviderOpenIdConnectInFooter;
        data["showExternalLoginProviderBELoginInLoginForm"] = this.showExternalLoginProviderBELoginInLoginForm;
        data["showExternalLoginProviderBELoginInFooter"] = this.showExternalLoginProviderBELoginInFooter;
        data["showExternalLoginProvidereKontoInLoginForm"] = this.showExternalLoginProvidereKontoInLoginForm;
        data["showExternalLoginProvidereKontoInFooter"] = this.showExternalLoginProvidereKontoInFooter;
        data["showExternalLoginProviderWsFederationInLoginForm"] = this.showExternalLoginProviderWsFederationInLoginForm;
        data["showExternalLoginProviderWsFederationInFooter"] = this.showExternalLoginProviderWsFederationInFooter;
        data["showExternalLoginProviderTwitterInLoginForm"] = this.showExternalLoginProviderTwitterInLoginForm;
        data["showExternalLoginProviderTwitterInFooter"] = this.showExternalLoginProviderTwitterInFooter;
        data["showExternalLoginProviderKeycloakInLoginForm"] = this.showExternalLoginProviderKeycloakInLoginForm;
        data["showExternalLoginProviderKeycloakInFooter"] = this.showExternalLoginProviderKeycloakInFooter;
        data["showExternalLoginProviderBlKontoInLoginForm"] = this.showExternalLoginProviderBlKontoInLoginForm;
        data["showExternalLoginProviderBlKontoInFooter"] = this.showExternalLoginProviderBlKontoInFooter;
        data["allowedFileExtensionsForDocuments"] = this.allowedFileExtensionsForDocuments;
        data["allowedFileExtensionsForApplicationDocuments"] = this.allowedFileExtensionsForApplicationDocuments;
        data["maxFileLengthForDocuments"] = this.maxFileLengthForDocuments;
        data["enableWindowsAuthentication"] = this.enableWindowsAuthentication;
        data["useHealthRegisterCacheForSnapshots"] = this.useHealthRegisterCacheForSnapshots;
        data["inspectorRoleId"] = this.inspectorRoleId;
        data["allowedInternalEmailDomains"] = this.allowedInternalEmailDomains;
        return data;
    }
}

export interface ISironaSettingDto {
    disableLanguageOfCorrespondence: boolean;
    ignoreEmploymentAddressPostCodeHasToBeInCanton: boolean;
    disableApplicationReactivation: boolean;
    disableDirectUserPermissionAssignment: boolean;
    enableApplicationSubmittedNotification: boolean;
    enableNewSupplementalClaimNotification: boolean;
    enableSelfEmploymentTypeInEmploymentChangeRequest: boolean;
    enableIgnoreNaregLicenceInThisCantonLicenceStatus: boolean;
    enableExtendedEhcQualityRequirement: boolean;
    enableExemptionAccordingArt37KvgForEhcPractice: boolean;
    showUsernamePasswordInLoginForm: boolean;
    showTextSigninWithInLoginForm: boolean;
    showForgotPasswordInLoginForm: boolean;
    showEmailActivationInLoginForm: boolean;
    showRegisterInLoginForm: boolean;
    showExternalLoginProviderFacebookInLoginForm: boolean;
    showExternalLoginProviderFacebookInFooter: boolean;
    showExternalLoginProviderGoogleInLoginForm: boolean;
    showExternalLoginProviderGoogleInFooter: boolean;
    showExternalLoginProviderMicrosoftInLoginForm: boolean;
    showExternalLoginProviderMicrosoftInFooter: boolean;
    showExternalLoginProviderOpenIdConnectInLoginForm: boolean;
    showExternalLoginProviderOpenIdConnectInFooter: boolean;
    showExternalLoginProviderBELoginInLoginForm: boolean;
    showExternalLoginProviderBELoginInFooter: boolean;
    showExternalLoginProvidereKontoInLoginForm: boolean;
    showExternalLoginProvidereKontoInFooter: boolean;
    showExternalLoginProviderWsFederationInLoginForm: boolean;
    showExternalLoginProviderWsFederationInFooter: boolean;
    showExternalLoginProviderTwitterInLoginForm: boolean;
    showExternalLoginProviderTwitterInFooter: boolean;
    showExternalLoginProviderKeycloakInLoginForm: boolean;
    showExternalLoginProviderKeycloakInFooter: boolean;
    showExternalLoginProviderBlKontoInLoginForm: boolean;
    showExternalLoginProviderBlKontoInFooter: boolean;
    allowedFileExtensionsForDocuments: string | undefined;
    allowedFileExtensionsForApplicationDocuments: string | undefined;
    maxFileLengthForDocuments: number;
    enableWindowsAuthentication: boolean;
    useHealthRegisterCacheForSnapshots: boolean;
    inspectorRoleId: number;
    allowedInternalEmailDomains: string | undefined;
}

export class SslCertificateDto implements ISslCertificateDto {
    subject!: string | undefined;
    thumbprint!: string | undefined;
    validFrom!: DateTime;
    validTo!: DateTime;
    isValid!: boolean;

    constructor(data?: ISslCertificateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.thumbprint = _data["thumbprint"];
            this.validFrom = _data["validFrom"] ? DateTime.fromISO(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? DateTime.fromISO(_data["validTo"].toString()) : <any>undefined;
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): SslCertificateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SslCertificateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["thumbprint"] = this.thumbprint;
        data["validFrom"] = this.validFrom ? this.validFrom.toString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toString() : <any>undefined;
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface ISslCertificateDto {
    subject: string | undefined;
    thumbprint: string | undefined;
    validFrom: DateTime;
    validTo: DateTime;
    isValid: boolean;
}

export class UpdateCurrentUserSettingInput implements IUpdateCurrentUserSettingInput {
    name!: string;
    value!: string | undefined;

    constructor(data?: IUpdateCurrentUserSettingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateCurrentUserSettingInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCurrentUserSettingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateCurrentUserSettingInput {
    name: string;
    value: string | undefined;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean;
    smtpUseDefaultCredentials!: boolean;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpEnableSsl = _data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class ExternalLoginProviderSettingsEditDto implements IExternalLoginProviderSettingsEditDto {
    facebook_IsDeactivated!: boolean;
    facebook!: FacebookExternalLoginProviderSettings;
    google_IsDeactivated!: boolean;
    google!: GoogleExternalLoginProviderSettings;
    twitter_IsDeactivated!: boolean;
    twitter!: TwitterExternalLoginProviderSettings;
    microsoft_IsDeactivated!: boolean;
    microsoft!: MicrosoftExternalLoginProviderSettings;
    openIdConnect_IsDeactivated!: boolean;
    openIdConnect!: OpenIdConnectExternalLoginProviderSettings;
    openIdConnectClaimsMapping!: JsonClaimMapDto[] | undefined;
    beLogin_IsDeactivated!: boolean;
    beLogin!: OpenIdConnectExternalLoginProviderSettings;
    beLoginClaimsMapping!: JsonClaimMapDto[] | undefined;
    beLoginAutoLoginInfo!: JsonAutoLoginInfoDto[] | undefined;
    beLoginNoAutoLoginInfo!: JsonAutoLoginInfoDto[] | undefined;
    eKonto_IsDeactivated!: boolean;
    eKonto!: OpenIdConnectExternalLoginProviderSettings;
    eKontoClaimsMapping!: JsonClaimMapDto[] | undefined;
    eKontoAutoLoginInfo!: JsonAutoLoginInfoDto[] | undefined;
    eKontoNoAutoLoginInfo!: JsonAutoLoginInfoDto[] | undefined;
    wsFederation_IsDeactivated!: boolean;
    wsFederation!: WsFederationExternalLoginProviderSettings;
    wsFederationClaimsMapping!: JsonClaimMapDto[] | undefined;
    keycloak_IsDeactivated!: boolean;
    keycloak!: OpenIdConnectExternalLoginProviderSettings;
    keycloakClaimsMapping!: JsonClaimMapDto[] | undefined;
    keycloakAutoLoginInfo!: JsonAutoLoginInfoDto[] | undefined;
    keycloakNoAutoLoginInfo!: JsonAutoLoginInfoDto[] | undefined;
    blKonto_IsDeactivated!: boolean;
    blKonto!: OpenIdConnectExternalLoginProviderSettings;
    blKontoClaimsMapping!: JsonClaimMapDto[] | undefined;
    blKontoAutoLoginInfo!: JsonAutoLoginInfoDto[] | undefined;
    blKontoNoAutoLoginInfo!: JsonAutoLoginInfoDto[] | undefined;

    constructor(data?: IExternalLoginProviderSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facebook_IsDeactivated = _data["facebook_IsDeactivated"];
            this.facebook = _data["facebook"] ? FacebookExternalLoginProviderSettings.fromJS(_data["facebook"]) : <any>undefined;
            this.google_IsDeactivated = _data["google_IsDeactivated"];
            this.google = _data["google"] ? GoogleExternalLoginProviderSettings.fromJS(_data["google"]) : <any>undefined;
            this.twitter_IsDeactivated = _data["twitter_IsDeactivated"];
            this.twitter = _data["twitter"] ? TwitterExternalLoginProviderSettings.fromJS(_data["twitter"]) : <any>undefined;
            this.microsoft_IsDeactivated = _data["microsoft_IsDeactivated"];
            this.microsoft = _data["microsoft"] ? MicrosoftExternalLoginProviderSettings.fromJS(_data["microsoft"]) : <any>undefined;
            this.openIdConnect_IsDeactivated = _data["openIdConnect_IsDeactivated"];
            this.openIdConnect = _data["openIdConnect"] ? OpenIdConnectExternalLoginProviderSettings.fromJS(_data["openIdConnect"]) : <any>undefined;
            if (Array.isArray(_data["openIdConnectClaimsMapping"])) {
                this.openIdConnectClaimsMapping = [] as any;
                for (let item of _data["openIdConnectClaimsMapping"])
                    this.openIdConnectClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
            this.beLogin_IsDeactivated = _data["beLogin_IsDeactivated"];
            this.beLogin = _data["beLogin"] ? OpenIdConnectExternalLoginProviderSettings.fromJS(_data["beLogin"]) : <any>undefined;
            if (Array.isArray(_data["beLoginClaimsMapping"])) {
                this.beLoginClaimsMapping = [] as any;
                for (let item of _data["beLoginClaimsMapping"])
                    this.beLoginClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
            if (Array.isArray(_data["beLoginAutoLoginInfo"])) {
                this.beLoginAutoLoginInfo = [] as any;
                for (let item of _data["beLoginAutoLoginInfo"])
                    this.beLoginAutoLoginInfo!.push(JsonAutoLoginInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["beLoginNoAutoLoginInfo"])) {
                this.beLoginNoAutoLoginInfo = [] as any;
                for (let item of _data["beLoginNoAutoLoginInfo"])
                    this.beLoginNoAutoLoginInfo!.push(JsonAutoLoginInfoDto.fromJS(item));
            }
            this.eKonto_IsDeactivated = _data["eKonto_IsDeactivated"];
            this.eKonto = _data["eKonto"] ? OpenIdConnectExternalLoginProviderSettings.fromJS(_data["eKonto"]) : <any>undefined;
            if (Array.isArray(_data["eKontoClaimsMapping"])) {
                this.eKontoClaimsMapping = [] as any;
                for (let item of _data["eKontoClaimsMapping"])
                    this.eKontoClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
            if (Array.isArray(_data["eKontoAutoLoginInfo"])) {
                this.eKontoAutoLoginInfo = [] as any;
                for (let item of _data["eKontoAutoLoginInfo"])
                    this.eKontoAutoLoginInfo!.push(JsonAutoLoginInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["eKontoNoAutoLoginInfo"])) {
                this.eKontoNoAutoLoginInfo = [] as any;
                for (let item of _data["eKontoNoAutoLoginInfo"])
                    this.eKontoNoAutoLoginInfo!.push(JsonAutoLoginInfoDto.fromJS(item));
            }
            this.wsFederation_IsDeactivated = _data["wsFederation_IsDeactivated"];
            this.wsFederation = _data["wsFederation"] ? WsFederationExternalLoginProviderSettings.fromJS(_data["wsFederation"]) : <any>undefined;
            if (Array.isArray(_data["wsFederationClaimsMapping"])) {
                this.wsFederationClaimsMapping = [] as any;
                for (let item of _data["wsFederationClaimsMapping"])
                    this.wsFederationClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
            this.keycloak_IsDeactivated = _data["keycloak_IsDeactivated"];
            this.keycloak = _data["keycloak"] ? OpenIdConnectExternalLoginProviderSettings.fromJS(_data["keycloak"]) : <any>undefined;
            if (Array.isArray(_data["keycloakClaimsMapping"])) {
                this.keycloakClaimsMapping = [] as any;
                for (let item of _data["keycloakClaimsMapping"])
                    this.keycloakClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
            if (Array.isArray(_data["keycloakAutoLoginInfo"])) {
                this.keycloakAutoLoginInfo = [] as any;
                for (let item of _data["keycloakAutoLoginInfo"])
                    this.keycloakAutoLoginInfo!.push(JsonAutoLoginInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["keycloakNoAutoLoginInfo"])) {
                this.keycloakNoAutoLoginInfo = [] as any;
                for (let item of _data["keycloakNoAutoLoginInfo"])
                    this.keycloakNoAutoLoginInfo!.push(JsonAutoLoginInfoDto.fromJS(item));
            }
            this.blKonto_IsDeactivated = _data["blKonto_IsDeactivated"];
            this.blKonto = _data["blKonto"] ? OpenIdConnectExternalLoginProviderSettings.fromJS(_data["blKonto"]) : <any>undefined;
            if (Array.isArray(_data["blKontoClaimsMapping"])) {
                this.blKontoClaimsMapping = [] as any;
                for (let item of _data["blKontoClaimsMapping"])
                    this.blKontoClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
            if (Array.isArray(_data["blKontoAutoLoginInfo"])) {
                this.blKontoAutoLoginInfo = [] as any;
                for (let item of _data["blKontoAutoLoginInfo"])
                    this.blKontoAutoLoginInfo!.push(JsonAutoLoginInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["blKontoNoAutoLoginInfo"])) {
                this.blKontoNoAutoLoginInfo = [] as any;
                for (let item of _data["blKontoNoAutoLoginInfo"])
                    this.blKontoNoAutoLoginInfo!.push(JsonAutoLoginInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facebook_IsDeactivated"] = this.facebook_IsDeactivated;
        data["facebook"] = this.facebook ? this.facebook.toJSON() : <any>undefined;
        data["google_IsDeactivated"] = this.google_IsDeactivated;
        data["google"] = this.google ? this.google.toJSON() : <any>undefined;
        data["twitter_IsDeactivated"] = this.twitter_IsDeactivated;
        data["twitter"] = this.twitter ? this.twitter.toJSON() : <any>undefined;
        data["microsoft_IsDeactivated"] = this.microsoft_IsDeactivated;
        data["microsoft"] = this.microsoft ? this.microsoft.toJSON() : <any>undefined;
        data["openIdConnect_IsDeactivated"] = this.openIdConnect_IsDeactivated;
        data["openIdConnect"] = this.openIdConnect ? this.openIdConnect.toJSON() : <any>undefined;
        if (Array.isArray(this.openIdConnectClaimsMapping)) {
            data["openIdConnectClaimsMapping"] = [];
            for (let item of this.openIdConnectClaimsMapping)
                data["openIdConnectClaimsMapping"].push(item.toJSON());
        }
        data["beLogin_IsDeactivated"] = this.beLogin_IsDeactivated;
        data["beLogin"] = this.beLogin ? this.beLogin.toJSON() : <any>undefined;
        if (Array.isArray(this.beLoginClaimsMapping)) {
            data["beLoginClaimsMapping"] = [];
            for (let item of this.beLoginClaimsMapping)
                data["beLoginClaimsMapping"].push(item.toJSON());
        }
        if (Array.isArray(this.beLoginAutoLoginInfo)) {
            data["beLoginAutoLoginInfo"] = [];
            for (let item of this.beLoginAutoLoginInfo)
                data["beLoginAutoLoginInfo"].push(item.toJSON());
        }
        if (Array.isArray(this.beLoginNoAutoLoginInfo)) {
            data["beLoginNoAutoLoginInfo"] = [];
            for (let item of this.beLoginNoAutoLoginInfo)
                data["beLoginNoAutoLoginInfo"].push(item.toJSON());
        }
        data["eKonto_IsDeactivated"] = this.eKonto_IsDeactivated;
        data["eKonto"] = this.eKonto ? this.eKonto.toJSON() : <any>undefined;
        if (Array.isArray(this.eKontoClaimsMapping)) {
            data["eKontoClaimsMapping"] = [];
            for (let item of this.eKontoClaimsMapping)
                data["eKontoClaimsMapping"].push(item.toJSON());
        }
        if (Array.isArray(this.eKontoAutoLoginInfo)) {
            data["eKontoAutoLoginInfo"] = [];
            for (let item of this.eKontoAutoLoginInfo)
                data["eKontoAutoLoginInfo"].push(item.toJSON());
        }
        if (Array.isArray(this.eKontoNoAutoLoginInfo)) {
            data["eKontoNoAutoLoginInfo"] = [];
            for (let item of this.eKontoNoAutoLoginInfo)
                data["eKontoNoAutoLoginInfo"].push(item.toJSON());
        }
        data["wsFederation_IsDeactivated"] = this.wsFederation_IsDeactivated;
        data["wsFederation"] = this.wsFederation ? this.wsFederation.toJSON() : <any>undefined;
        if (Array.isArray(this.wsFederationClaimsMapping)) {
            data["wsFederationClaimsMapping"] = [];
            for (let item of this.wsFederationClaimsMapping)
                data["wsFederationClaimsMapping"].push(item.toJSON());
        }
        data["keycloak_IsDeactivated"] = this.keycloak_IsDeactivated;
        data["keycloak"] = this.keycloak ? this.keycloak.toJSON() : <any>undefined;
        if (Array.isArray(this.keycloakClaimsMapping)) {
            data["keycloakClaimsMapping"] = [];
            for (let item of this.keycloakClaimsMapping)
                data["keycloakClaimsMapping"].push(item.toJSON());
        }
        if (Array.isArray(this.keycloakAutoLoginInfo)) {
            data["keycloakAutoLoginInfo"] = [];
            for (let item of this.keycloakAutoLoginInfo)
                data["keycloakAutoLoginInfo"].push(item.toJSON());
        }
        if (Array.isArray(this.keycloakNoAutoLoginInfo)) {
            data["keycloakNoAutoLoginInfo"] = [];
            for (let item of this.keycloakNoAutoLoginInfo)
                data["keycloakNoAutoLoginInfo"].push(item.toJSON());
        }
        data["blKonto_IsDeactivated"] = this.blKonto_IsDeactivated;
        data["blKonto"] = this.blKonto ? this.blKonto.toJSON() : <any>undefined;
        if (Array.isArray(this.blKontoClaimsMapping)) {
            data["blKontoClaimsMapping"] = [];
            for (let item of this.blKontoClaimsMapping)
                data["blKontoClaimsMapping"].push(item.toJSON());
        }
        if (Array.isArray(this.blKontoAutoLoginInfo)) {
            data["blKontoAutoLoginInfo"] = [];
            for (let item of this.blKontoAutoLoginInfo)
                data["blKontoAutoLoginInfo"].push(item.toJSON());
        }
        if (Array.isArray(this.blKontoNoAutoLoginInfo)) {
            data["blKontoNoAutoLoginInfo"] = [];
            for (let item of this.blKontoNoAutoLoginInfo)
                data["blKontoNoAutoLoginInfo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExternalLoginProviderSettingsEditDto {
    facebook_IsDeactivated: boolean;
    facebook: FacebookExternalLoginProviderSettings;
    google_IsDeactivated: boolean;
    google: GoogleExternalLoginProviderSettings;
    twitter_IsDeactivated: boolean;
    twitter: TwitterExternalLoginProviderSettings;
    microsoft_IsDeactivated: boolean;
    microsoft: MicrosoftExternalLoginProviderSettings;
    openIdConnect_IsDeactivated: boolean;
    openIdConnect: OpenIdConnectExternalLoginProviderSettings;
    openIdConnectClaimsMapping: JsonClaimMapDto[] | undefined;
    beLogin_IsDeactivated: boolean;
    beLogin: OpenIdConnectExternalLoginProviderSettings;
    beLoginClaimsMapping: JsonClaimMapDto[] | undefined;
    beLoginAutoLoginInfo: JsonAutoLoginInfoDto[] | undefined;
    beLoginNoAutoLoginInfo: JsonAutoLoginInfoDto[] | undefined;
    eKonto_IsDeactivated: boolean;
    eKonto: OpenIdConnectExternalLoginProviderSettings;
    eKontoClaimsMapping: JsonClaimMapDto[] | undefined;
    eKontoAutoLoginInfo: JsonAutoLoginInfoDto[] | undefined;
    eKontoNoAutoLoginInfo: JsonAutoLoginInfoDto[] | undefined;
    wsFederation_IsDeactivated: boolean;
    wsFederation: WsFederationExternalLoginProviderSettings;
    wsFederationClaimsMapping: JsonClaimMapDto[] | undefined;
    keycloak_IsDeactivated: boolean;
    keycloak: OpenIdConnectExternalLoginProviderSettings;
    keycloakClaimsMapping: JsonClaimMapDto[] | undefined;
    keycloakAutoLoginInfo: JsonAutoLoginInfoDto[] | undefined;
    keycloakNoAutoLoginInfo: JsonAutoLoginInfoDto[] | undefined;
    blKonto_IsDeactivated: boolean;
    blKonto: OpenIdConnectExternalLoginProviderSettings;
    blKontoClaimsMapping: JsonClaimMapDto[] | undefined;
    blKontoAutoLoginInfo: JsonAutoLoginInfoDto[] | undefined;
    blKontoNoAutoLoginInfo: JsonAutoLoginInfoDto[] | undefined;
}

export class ExternalLoginSettingsDto implements IExternalLoginSettingsDto {
    enabledSocialLoginSettings!: string[] | undefined;

    constructor(data?: IExternalLoginSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["enabledSocialLoginSettings"])) {
                this.enabledSocialLoginSettings = [] as any;
                for (let item of _data["enabledSocialLoginSettings"])
                    this.enabledSocialLoginSettings!.push(item);
            }
        }
    }

    static fromJS(data: any): ExternalLoginSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.enabledSocialLoginSettings)) {
            data["enabledSocialLoginSettings"] = [];
            for (let item of this.enabledSocialLoginSettings)
                data["enabledSocialLoginSettings"].push(item);
        }
        return data;
    }
}

export interface IExternalLoginSettingsDto {
    enabledSocialLoginSettings: string[] | undefined;
}

export class ThemeFooterSettingsDto implements IThemeFooterSettingsDto {
    fixedFooter!: boolean;

    constructor(data?: IThemeFooterSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedFooter = _data["fixedFooter"];
        }
    }

    static fromJS(data: any): ThemeFooterSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeFooterSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data;
    }
}

export interface IThemeFooterSettingsDto {
    fixedFooter: boolean;
}

export class ThemeHeaderSettingsDto implements IThemeHeaderSettingsDto {
    desktopFixedHeader!: boolean;
    mobileFixedHeader!: boolean;
    headerSkin!: string | undefined;
    minimizeDesktopHeaderType!: string | undefined;

    constructor(data?: IThemeHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desktopFixedHeader = _data["desktopFixedHeader"];
            this.mobileFixedHeader = _data["mobileFixedHeader"];
            this.headerSkin = _data["headerSkin"];
            this.minimizeDesktopHeaderType = _data["minimizeDesktopHeaderType"];
        }
    }

    static fromJS(data: any): ThemeHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["headerSkin"] = this.headerSkin;
        data["minimizeDesktopHeaderType"] = this.minimizeDesktopHeaderType;
        return data;
    }
}

export interface IThemeHeaderSettingsDto {
    desktopFixedHeader: boolean;
    mobileFixedHeader: boolean;
    headerSkin: string | undefined;
    minimizeDesktopHeaderType: string | undefined;
}

export class ThemeLayoutSettingsDto implements IThemeLayoutSettingsDto {
    layoutType!: string | undefined;
    darkMode!: boolean;

    constructor(data?: IThemeLayoutSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layoutType = _data["layoutType"];
            this.darkMode = _data["darkMode"];
        }
    }

    static fromJS(data: any): ThemeLayoutSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeLayoutSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        data["darkMode"] = this.darkMode;
        return data;
    }
}

export interface IThemeLayoutSettingsDto {
    layoutType: string | undefined;
    darkMode: boolean;
}

export class ThemeMenuSettingsDto implements IThemeMenuSettingsDto {
    position!: string | undefined;
    asideSkin!: string | undefined;
    fixedAside!: boolean;
    allowAsideMinimizing!: boolean;
    defaultMinimizedAside!: boolean;
    submenuToggle!: string | undefined;
    searchActive!: boolean;
    enableSecondary!: boolean;
    hoverableAside!: boolean;

    constructor(data?: IThemeMenuSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.asideSkin = _data["asideSkin"];
            this.fixedAside = _data["fixedAside"];
            this.allowAsideMinimizing = _data["allowAsideMinimizing"];
            this.defaultMinimizedAside = _data["defaultMinimizedAside"];
            this.submenuToggle = _data["submenuToggle"];
            this.searchActive = _data["searchActive"];
            this.enableSecondary = _data["enableSecondary"];
            this.hoverableAside = _data["hoverableAside"];
        }
    }

    static fromJS(data: any): ThemeMenuSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeMenuSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["submenuToggle"] = this.submenuToggle;
        data["searchActive"] = this.searchActive;
        data["enableSecondary"] = this.enableSecondary;
        data["hoverableAside"] = this.hoverableAside;
        return data;
    }
}

export interface IThemeMenuSettingsDto {
    position: string | undefined;
    asideSkin: string | undefined;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    submenuToggle: string | undefined;
    searchActive: boolean;
    enableSecondary: boolean;
    hoverableAside: boolean;
}

export class ThemeSettingsDto implements IThemeSettingsDto {
    theme!: string | undefined;
    layout!: ThemeLayoutSettingsDto;
    header!: ThemeHeaderSettingsDto;
    subHeader!: ThemeSubHeaderSettingsDto;
    menu!: ThemeMenuSettingsDto;
    footer!: ThemeFooterSettingsDto;

    constructor(data?: IThemeSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
            this.layout = _data["layout"] ? ThemeLayoutSettingsDto.fromJS(_data["layout"]) : <any>undefined;
            this.header = _data["header"] ? ThemeHeaderSettingsDto.fromJS(_data["header"]) : <any>undefined;
            this.subHeader = _data["subHeader"] ? ThemeSubHeaderSettingsDto.fromJS(_data["subHeader"]) : <any>undefined;
            this.menu = _data["menu"] ? ThemeMenuSettingsDto.fromJS(_data["menu"]) : <any>undefined;
            this.footer = _data["footer"] ? ThemeFooterSettingsDto.fromJS(_data["footer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThemeSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["subHeader"] = this.subHeader ? this.subHeader.toJSON() : <any>undefined;
        data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IThemeSettingsDto {
    theme: string | undefined;
    layout: ThemeLayoutSettingsDto;
    header: ThemeHeaderSettingsDto;
    subHeader: ThemeSubHeaderSettingsDto;
    menu: ThemeMenuSettingsDto;
    footer: ThemeFooterSettingsDto;
}

export class ThemeSubHeaderSettingsDto implements IThemeSubHeaderSettingsDto {
    fixedSubHeader!: boolean;
    subheaderStyle!: string | undefined;
    subheaderSize!: number;
    titleStyle!: string | undefined;
    containerStyle!: string | undefined;
    subContainerStyle!: string | undefined;

    constructor(data?: IThemeSubHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedSubHeader = _data["fixedSubHeader"];
            this.subheaderStyle = _data["subheaderStyle"];
            this.subheaderSize = _data["subheaderSize"];
            this.titleStyle = _data["titleStyle"];
            this.containerStyle = _data["containerStyle"];
            this.subContainerStyle = _data["subContainerStyle"];
        }
    }

    static fromJS(data: any): ThemeSubHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSubHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedSubHeader"] = this.fixedSubHeader;
        data["subheaderStyle"] = this.subheaderStyle;
        data["subheaderSize"] = this.subheaderSize;
        data["titleStyle"] = this.titleStyle;
        data["containerStyle"] = this.containerStyle;
        data["subContainerStyle"] = this.subContainerStyle;
        return data;
    }
}

export interface IThemeSubHeaderSettingsDto {
    fixedSubHeader: boolean;
    subheaderStyle: string | undefined;
    subheaderSize: number;
    titleStyle: string | undefined;
    containerStyle: string | undefined;
    subContainerStyle: string | undefined;
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone!: string | undefined;
    timezoneForComparison!: string | undefined;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timezone = _data["timezone"];
            this.timezoneForComparison = _data["timezoneForComparison"];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data;
    }
}

export interface IGeneralSettingsEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;

    constructor(data?: IHostBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): HostBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data;
    }
}

export interface IHostBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: HostUserManagementSettingsEditDto;
    email!: EmailSettingsEditDto;
    tenantManagement!: TenantManagementSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: HostBillingSettingsEditDto;
    otherSettings!: OtherSettingsEditDto;
    externalLoginProviderSettings!: ExternalLoginProviderSettingsEditDto;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.general = new GeneralSettingsEditDto();
            this.userManagement = new HostUserManagementSettingsEditDto();
            this.email = new EmailSettingsEditDto();
            this.tenantManagement = new TenantManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = _data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = _data["email"] ? EmailSettingsEditDto.fromJS(_data["email"]) : new EmailSettingsEditDto();
            this.tenantManagement = _data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(_data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? HostBillingSettingsEditDto.fromJS(_data["billing"]) : <any>undefined;
            this.otherSettings = _data["otherSettings"] ? OtherSettingsEditDto.fromJS(_data["otherSettings"]) : <any>undefined;
            this.externalLoginProviderSettings = _data["externalLoginProviderSettings"] ? ExternalLoginProviderSettingsEditDto.fromJS(_data["externalLoginProviderSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
        data["externalLoginProviderSettings"] = this.externalLoginProviderSettings ? this.externalLoginProviderSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto;
    otherSettings: OtherSettingsEditDto;
    externalLoginProviderSettings: ExternalLoginProviderSettingsEditDto;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin!: boolean;
    smsVerificationEnabled!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    useCaptchaOnLogin!: boolean;
    allowUsingGravatarProfilePicture!: boolean;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;
    userPasswordSettings!: UserPasswordSettingsEditDto;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = _data["smsVerificationEnabled"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            this.useCaptchaOnLogin = _data["useCaptchaOnLogin"];
            this.allowUsingGravatarProfilePicture = _data["allowUsingGravatarProfilePicture"];
            this.sessionTimeOutSettings = _data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(_data["sessionTimeOutSettings"]) : <any>undefined;
            this.userPasswordSettings = _data["userPasswordSettings"] ? UserPasswordSettingsEditDto.fromJS(_data["userPasswordSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["allowUsingGravatarProfilePicture"] = this.allowUsingGravatarProfilePicture;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : <any>undefined;
        data["userPasswordSettings"] = this.userPasswordSettings ? this.userPasswordSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
    smsVerificationEnabled: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    useCaptchaOnLogin: boolean;
    allowUsingGravatarProfilePicture: boolean;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
    userPasswordSettings: UserPasswordSettingsEditDto;
}

export class OtherSettingsEditDto implements IOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: IOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): OtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    }
}

export interface IOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser!: boolean;
    useDefaultPasswordComplexitySettings!: boolean;
    passwordComplexity!: PasswordComplexitySetting;
    defaultPasswordComplexity!: PasswordComplexitySetting;
    userLockOut!: UserLockOutSettingsEditDto;
    twoFactorLogin!: TwoFactorLoginSettingsEditDto;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowOneConcurrentLoginPerUser = _data["allowOneConcurrentLoginPerUser"];
            this.useDefaultPasswordComplexitySettings = _data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = _data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(_data["passwordComplexity"]) : <any>undefined;
            this.defaultPasswordComplexity = _data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(_data["defaultPasswordComplexity"]) : <any>undefined;
            this.userLockOut = _data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(_data["userLockOut"]) : <any>undefined;
            this.twoFactorLogin = _data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(_data["twoFactorLogin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowOneConcurrentLoginPerUser"] = this.allowOneConcurrentLoginPerUser;
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser: boolean;
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    emailAddress!: string;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendTestEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendTestEmailInput {
    emailAddress: string;
}

export class SessionTimeOutSettingsEditDto implements ISessionTimeOutSettingsEditDto {
    isEnabled!: boolean;
    timeOutSecond!: number;
    showTimeOutNotificationSecond!: number;
    showLockScreenWhenTimedOut!: boolean;

    constructor(data?: ISessionTimeOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.timeOutSecond = _data["timeOutSecond"];
            this.showTimeOutNotificationSecond = _data["showTimeOutNotificationSecond"];
            this.showLockScreenWhenTimedOut = _data["showLockScreenWhenTimedOut"];
        }
    }

    static fromJS(data: any): SessionTimeOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionTimeOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["timeOutSecond"] = this.timeOutSecond;
        data["showTimeOutNotificationSecond"] = this.showTimeOutNotificationSecond;
        data["showLockScreenWhenTimedOut"] = this.showLockScreenWhenTimedOut;
        return data;
    }
}

export interface ISessionTimeOutSettingsEditDto {
    isEnabled: boolean;
    timeOutSecond: number;
    showTimeOutNotificationSecond: number;
    showLockScreenWhenTimedOut: boolean;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredTenantActiveByDefault!: boolean;
    useCaptchaOnRegistration!: boolean;
    defaultEditionId!: number | undefined;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = _data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.defaultEditionId = _data["defaultEditionId"];
        }
    }

    static fromJS(data: any): TenantManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["defaultEditionId"] = this.defaultEditionId;
        return data;
    }
}

export interface ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number | undefined;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication!: boolean;
    isEnabled!: boolean;
    isEmailProviderEnabled!: boolean;
    isSmsProviderEnabled!: boolean;
    isRememberBrowserEnabled!: boolean;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabledForApplication = _data["isEnabledForApplication"];
            this.isEnabled = _data["isEnabled"];
            this.isEmailProviderEnabled = _data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = _data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = _data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
    isGoogleAuthenticatorEnabled: boolean;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled!: boolean;
    maxFailedAccessAttemptsBeforeLockout!: number;
    defaultAccountLockoutSeconds!: number;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = _data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = _data["defaultAccountLockoutSeconds"];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data;
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;
}

export class UserPasswordSettingsEditDto implements IUserPasswordSettingsEditDto {
    enableCheckingLastXPasswordWhenPasswordChange!: boolean;
    checkingLastXPasswordCount!: number;
    enablePasswordExpiration!: boolean;
    passwordExpirationDayCount!: number;
    passwordResetCodeExpirationHours!: number;

    constructor(data?: IUserPasswordSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enableCheckingLastXPasswordWhenPasswordChange = _data["enableCheckingLastXPasswordWhenPasswordChange"];
            this.checkingLastXPasswordCount = _data["checkingLastXPasswordCount"];
            this.enablePasswordExpiration = _data["enablePasswordExpiration"];
            this.passwordExpirationDayCount = _data["passwordExpirationDayCount"];
            this.passwordResetCodeExpirationHours = _data["passwordResetCodeExpirationHours"];
        }
    }

    static fromJS(data: any): UserPasswordSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPasswordSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enableCheckingLastXPasswordWhenPasswordChange"] = this.enableCheckingLastXPasswordWhenPasswordChange;
        data["checkingLastXPasswordCount"] = this.checkingLastXPasswordCount;
        data["enablePasswordExpiration"] = this.enablePasswordExpiration;
        data["passwordExpirationDayCount"] = this.passwordExpirationDayCount;
        data["passwordResetCodeExpirationHours"] = this.passwordResetCodeExpirationHours;
        return data;
    }
}

export interface IUserPasswordSettingsEditDto {
    enableCheckingLastXPasswordWhenPasswordChange: boolean;
    checkingLastXPasswordCount: number;
    enablePasswordExpiration: boolean;
    passwordExpirationDayCount: number;
    passwordResetCodeExpirationHours: number;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled!: boolean;
    isEnabled!: boolean;
    domain!: string | undefined;
    userName!: string | undefined;
    password!: string | undefined;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isModuleEnabled = _data["isModuleEnabled"];
            this.isEnabled = _data["isEnabled"];
            this.domain = _data["domain"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string | undefined;
    userName: string | undefined;
    password: string | undefined;
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;
    taxVatNo!: string | undefined;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
            this.taxVatNo = _data["taxVatNo"];
        }
    }

    static fromJS(data: any): TenantBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data;
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
    taxVatNo: string | undefined;
}

export class TenantEmailSettingsEditDto implements ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings!: boolean;
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean;
    smtpUseDefaultCredentials!: boolean;

    constructor(data?: ITenantEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useHostDefaultEmailSettings = _data["useHostDefaultEmailSettings"];
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpEnableSsl = _data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): TenantEmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useHostDefaultEmailSettings"] = this.useHostDefaultEmailSettings;
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    }
}

export interface ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings: boolean;
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class TenantOtherSettingsEditDto implements ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;
    isChatToggleButtonEnabled!: boolean;
    isHeaderNotificationsEnabled!: boolean;

    constructor(data?: ITenantOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            this.isChatToggleButtonEnabled = _data["isChatToggleButtonEnabled"];
            this.isHeaderNotificationsEnabled = _data["isHeaderNotificationsEnabled"];
        }
    }

    static fromJS(data: any): TenantOtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantOtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["isChatToggleButtonEnabled"] = this.isChatToggleButtonEnabled;
        data["isHeaderNotificationsEnabled"] = this.isHeaderNotificationsEnabled;
        return data;
    }
}

export interface ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
    isChatToggleButtonEnabled: boolean;
    isHeaderNotificationsEnabled: boolean;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: TenantUserManagementSettingsEditDto;
    email!: TenantEmailSettingsEditDto;
    ldap!: LdapSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: TenantBillingSettingsEditDto;
    otherSettings!: TenantOtherSettingsEditDto;
    externalLoginProviderSettings!: ExternalLoginProviderSettingsEditDto;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userManagement = new TenantUserManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : <any>undefined;
            this.userManagement = _data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = _data["email"] ? TenantEmailSettingsEditDto.fromJS(_data["email"]) : <any>undefined;
            this.ldap = _data["ldap"] ? LdapSettingsEditDto.fromJS(_data["ldap"]) : <any>undefined;
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? TenantBillingSettingsEditDto.fromJS(_data["billing"]) : <any>undefined;
            this.otherSettings = _data["otherSettings"] ? TenantOtherSettingsEditDto.fromJS(_data["otherSettings"]) : <any>undefined;
            this.externalLoginProviderSettings = _data["externalLoginProviderSettings"] ? ExternalLoginProviderSettingsEditDto.fromJS(_data["externalLoginProviderSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
        data["externalLoginProviderSettings"] = this.externalLoginProviderSettings ? this.externalLoginProviderSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto;
    email: TenantEmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto;
    otherSettings: TenantOtherSettingsEditDto;
    externalLoginProviderSettings: ExternalLoginProviderSettingsEditDto;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredUserActiveByDefault!: boolean;
    isEmailConfirmationRequiredForLogin!: boolean;
    useCaptchaOnRegistration!: boolean;
    useCaptchaOnLogin!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    allowUsingGravatarProfilePicture!: boolean;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = _data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.useCaptchaOnLogin = _data["useCaptchaOnLogin"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            this.allowUsingGravatarProfilePicture = _data["allowUsingGravatarProfilePicture"];
            this.sessionTimeOutSettings = _data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(_data["sessionTimeOutSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["allowUsingGravatarProfilePicture"] = this.allowUsingGravatarProfilePicture;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;
    useCaptchaOnLogin: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    allowUsingGravatarProfilePicture: boolean;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
}

export class CorporateLicence implements ICorporateLicence {
    naturalKey!: string;
    sponsorship!: Sponsorship;
    sponsorshipId!: number | undefined;
    assistantPerson!: Person;
    assistantPersonId!: number | undefined;
    sponsorshipTypeId!: string | undefined;
    typeId!: CorporateLicenceType;
    statusId!: string | undefined;
    cantonId!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    comments!: string | undefined;
    narcExtent!: string | undefined;
    healthRegisterTransfer!: boolean;
    healthRegisterId!: number | undefined;
    application!: Application;
    applicationId!: number | undefined;
    claApplicationId!: number | undefined;
    sapInvoice!: SapInvoice;
    sapInvoiceId!: number | undefined;
    automaticNotificationAndStatusChange!: boolean;
    vaccinationLicence!: Code;
    vaccinationLicenceId!: string | undefined;
    productionOfCytostaticDrugs!: Code;
    productionOfCytostaticDrugsId!: string | undefined;
    onlineDrugSale!: Code;
    onlineDrugSaleId!: string | undefined;
    productionOfFormulaPreparations!: Code;
    productionOfFormulaPreparationsId!: string | undefined;
    dateOfEndNotification1Sent!: DateTime | undefined;
    dateOfEndNotification2Sent!: DateTime | undefined;
    dateOfPendenceCreated!: DateTime | undefined;
    corporateLicenceRenewals!: CorporateLicenceRenewal[] | undefined;
    businesses!: Business[] | undefined;
    employments!: Employment[] | undefined;
    restrictions!: CorporateLicenceRestriction[] | undefined;
    documentLinks!: DocumentLinkCorporateLicence[] | undefined;
    migrationData!: MigrationData[] | undefined;
    readonly isFinalDecision!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ICorporateLicence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naturalKey = _data["naturalKey"];
            this.sponsorship = _data["sponsorship"] ? Sponsorship.fromJS(_data["sponsorship"]) : <any>undefined;
            this.sponsorshipId = _data["sponsorshipId"];
            this.assistantPerson = _data["assistantPerson"] ? Person.fromJS(_data["assistantPerson"]) : <any>undefined;
            this.assistantPersonId = _data["assistantPersonId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.typeId = _data["typeId"];
            this.statusId = _data["statusId"];
            this.cantonId = _data["cantonId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.comments = _data["comments"];
            this.narcExtent = _data["narcExtent"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.healthRegisterId = _data["healthRegisterId"];
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : <any>undefined;
            this.applicationId = _data["applicationId"];
            this.claApplicationId = _data["claApplicationId"];
            this.sapInvoice = _data["sapInvoice"] ? SapInvoice.fromJS(_data["sapInvoice"]) : <any>undefined;
            this.sapInvoiceId = _data["sapInvoiceId"];
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.vaccinationLicence = _data["vaccinationLicence"] ? Code.fromJS(_data["vaccinationLicence"]) : <any>undefined;
            this.vaccinationLicenceId = _data["vaccinationLicenceId"];
            this.productionOfCytostaticDrugs = _data["productionOfCytostaticDrugs"] ? Code.fromJS(_data["productionOfCytostaticDrugs"]) : <any>undefined;
            this.productionOfCytostaticDrugsId = _data["productionOfCytostaticDrugsId"];
            this.onlineDrugSale = _data["onlineDrugSale"] ? Code.fromJS(_data["onlineDrugSale"]) : <any>undefined;
            this.onlineDrugSaleId = _data["onlineDrugSaleId"];
            this.productionOfFormulaPreparations = _data["productionOfFormulaPreparations"] ? Code.fromJS(_data["productionOfFormulaPreparations"]) : <any>undefined;
            this.productionOfFormulaPreparationsId = _data["productionOfFormulaPreparationsId"];
            this.dateOfEndNotification1Sent = _data["dateOfEndNotification1Sent"] ? DateTime.fromISO(_data["dateOfEndNotification1Sent"].toString()) : <any>undefined;
            this.dateOfEndNotification2Sent = _data["dateOfEndNotification2Sent"] ? DateTime.fromISO(_data["dateOfEndNotification2Sent"].toString()) : <any>undefined;
            this.dateOfPendenceCreated = _data["dateOfPendenceCreated"] ? DateTime.fromISO(_data["dateOfPendenceCreated"].toString()) : <any>undefined;
            if (Array.isArray(_data["corporateLicenceRenewals"])) {
                this.corporateLicenceRenewals = [] as any;
                for (let item of _data["corporateLicenceRenewals"])
                    this.corporateLicenceRenewals!.push(CorporateLicenceRenewal.fromJS(item));
            }
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(Business.fromJS(item));
            }
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(Employment.fromJS(item));
            }
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(CorporateLicenceRestriction.fromJS(item));
            }
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkCorporateLicence.fromJS(item));
            }
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            (<any>this).isFinalDecision = _data["isFinalDecision"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CorporateLicence {
        data = typeof data === 'object' ? data : {};
        let result = new CorporateLicence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naturalKey"] = this.naturalKey;
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        data["sponsorshipId"] = this.sponsorshipId;
        data["assistantPerson"] = this.assistantPerson ? this.assistantPerson.toJSON() : <any>undefined;
        data["assistantPersonId"] = this.assistantPersonId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["typeId"] = this.typeId;
        data["statusId"] = this.statusId;
        data["cantonId"] = this.cantonId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["comments"] = this.comments;
        data["narcExtent"] = this.narcExtent;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["healthRegisterId"] = this.healthRegisterId;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["applicationId"] = this.applicationId;
        data["claApplicationId"] = this.claApplicationId;
        data["sapInvoice"] = this.sapInvoice ? this.sapInvoice.toJSON() : <any>undefined;
        data["sapInvoiceId"] = this.sapInvoiceId;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["vaccinationLicence"] = this.vaccinationLicence ? this.vaccinationLicence.toJSON() : <any>undefined;
        data["vaccinationLicenceId"] = this.vaccinationLicenceId;
        data["productionOfCytostaticDrugs"] = this.productionOfCytostaticDrugs ? this.productionOfCytostaticDrugs.toJSON() : <any>undefined;
        data["productionOfCytostaticDrugsId"] = this.productionOfCytostaticDrugsId;
        data["onlineDrugSale"] = this.onlineDrugSale ? this.onlineDrugSale.toJSON() : <any>undefined;
        data["onlineDrugSaleId"] = this.onlineDrugSaleId;
        data["productionOfFormulaPreparations"] = this.productionOfFormulaPreparations ? this.productionOfFormulaPreparations.toJSON() : <any>undefined;
        data["productionOfFormulaPreparationsId"] = this.productionOfFormulaPreparationsId;
        data["dateOfEndNotification1Sent"] = this.dateOfEndNotification1Sent ? this.dateOfEndNotification1Sent.toString() : <any>undefined;
        data["dateOfEndNotification2Sent"] = this.dateOfEndNotification2Sent ? this.dateOfEndNotification2Sent.toString() : <any>undefined;
        data["dateOfPendenceCreated"] = this.dateOfPendenceCreated ? this.dateOfPendenceCreated.toString() : <any>undefined;
        if (Array.isArray(this.corporateLicenceRenewals)) {
            data["corporateLicenceRenewals"] = [];
            for (let item of this.corporateLicenceRenewals)
                data["corporateLicenceRenewals"].push(item.toJSON());
        }
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isFinalDecision"] = this.isFinalDecision;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICorporateLicence {
    naturalKey: string;
    sponsorship: Sponsorship;
    sponsorshipId: number | undefined;
    assistantPerson: Person;
    assistantPersonId: number | undefined;
    sponsorshipTypeId: string | undefined;
    typeId: CorporateLicenceType;
    statusId: string | undefined;
    cantonId: string | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    comments: string | undefined;
    narcExtent: string | undefined;
    healthRegisterTransfer: boolean;
    healthRegisterId: number | undefined;
    application: Application;
    applicationId: number | undefined;
    claApplicationId: number | undefined;
    sapInvoice: SapInvoice;
    sapInvoiceId: number | undefined;
    automaticNotificationAndStatusChange: boolean;
    vaccinationLicence: Code;
    vaccinationLicenceId: string | undefined;
    productionOfCytostaticDrugs: Code;
    productionOfCytostaticDrugsId: string | undefined;
    onlineDrugSale: Code;
    onlineDrugSaleId: string | undefined;
    productionOfFormulaPreparations: Code;
    productionOfFormulaPreparationsId: string | undefined;
    dateOfEndNotification1Sent: DateTime | undefined;
    dateOfEndNotification2Sent: DateTime | undefined;
    dateOfPendenceCreated: DateTime | undefined;
    corporateLicenceRenewals: CorporateLicenceRenewal[] | undefined;
    businesses: Business[] | undefined;
    employments: Employment[] | undefined;
    restrictions: CorporateLicenceRestriction[] | undefined;
    documentLinks: DocumentLinkCorporateLicence[] | undefined;
    migrationData: MigrationData[] | undefined;
    isFinalDecision: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CorporateLicenceDto implements ICorporateLicenceDto {
    naturalKey!: string | undefined;
    sponsorshipId!: number | undefined;
    sponsorshipName!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    typeId!: CorporateLicenceType;
    statusId!: string | undefined;
    cantonId!: string | undefined;
    assistantPersonId!: number | undefined;
    assistantPersonName!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    comments!: string | undefined;
    narcExtent!: string | undefined;
    healthRegisterTransfer!: boolean;
    healthRegisterId!: number | undefined;
    claApplicationId!: number | undefined;
    sapInvoiceStatusId!: string | undefined;
    dateOfSapInvoiceBilling!: DateTime | undefined;
    automaticNotificationAndStatusChange!: boolean;
    vaccinationLicenceId!: string | undefined;
    productionOfCytostaticDrugsId!: string | undefined;
    onlineDrugSaleId!: string | undefined;
    productionOfFormulaPreparationsId!: string | undefined;
    corporateLicenceRenewals!: CorporateLicenceRenewalDto[] | undefined;
    employments!: GetEmploymentDto[] | undefined;
    businessIds!: number[] | undefined;
    businesses!: GetBusinessDto[] | undefined;
    employmentIds!: number[] | undefined;
    medicalFieldDirectorId!: number | undefined;
    medicalFieldResponsibleForStorageAndQualityId!: number | undefined;
    medicalFieldFieldResponsibleForHaemovigilanceId!: number | undefined;
    restrictions!: CorporateLicenceRestrictionDto[] | undefined;
    licenceDocuments!: GeneralFileInfoDto[] | undefined;
    id!: number;

    constructor(data?: ICorporateLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naturalKey = _data["naturalKey"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.sponsorshipName = _data["sponsorshipName"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.typeId = _data["typeId"];
            this.statusId = _data["statusId"];
            this.cantonId = _data["cantonId"];
            this.assistantPersonId = _data["assistantPersonId"];
            this.assistantPersonName = _data["assistantPersonName"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.comments = _data["comments"];
            this.narcExtent = _data["narcExtent"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.healthRegisterId = _data["healthRegisterId"];
            this.claApplicationId = _data["claApplicationId"];
            this.sapInvoiceStatusId = _data["sapInvoiceStatusId"];
            this.dateOfSapInvoiceBilling = _data["dateOfSapInvoiceBilling"] ? DateTime.fromISO(_data["dateOfSapInvoiceBilling"].toString()) : <any>undefined;
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.vaccinationLicenceId = _data["vaccinationLicenceId"];
            this.productionOfCytostaticDrugsId = _data["productionOfCytostaticDrugsId"];
            this.onlineDrugSaleId = _data["onlineDrugSaleId"];
            this.productionOfFormulaPreparationsId = _data["productionOfFormulaPreparationsId"];
            if (Array.isArray(_data["corporateLicenceRenewals"])) {
                this.corporateLicenceRenewals = [] as any;
                for (let item of _data["corporateLicenceRenewals"])
                    this.corporateLicenceRenewals!.push(CorporateLicenceRenewalDto.fromJS(item));
            }
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(GetEmploymentDto.fromJS(item));
            }
            if (Array.isArray(_data["businessIds"])) {
                this.businessIds = [] as any;
                for (let item of _data["businessIds"])
                    this.businessIds!.push(item);
            }
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(GetBusinessDto.fromJS(item));
            }
            if (Array.isArray(_data["employmentIds"])) {
                this.employmentIds = [] as any;
                for (let item of _data["employmentIds"])
                    this.employmentIds!.push(item);
            }
            this.medicalFieldDirectorId = _data["medicalFieldDirectorId"];
            this.medicalFieldResponsibleForStorageAndQualityId = _data["medicalFieldResponsibleForStorageAndQualityId"];
            this.medicalFieldFieldResponsibleForHaemovigilanceId = _data["medicalFieldFieldResponsibleForHaemovigilanceId"];
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(CorporateLicenceRestrictionDto.fromJS(item));
            }
            if (Array.isArray(_data["licenceDocuments"])) {
                this.licenceDocuments = [] as any;
                for (let item of _data["licenceDocuments"])
                    this.licenceDocuments!.push(GeneralFileInfoDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CorporateLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CorporateLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naturalKey"] = this.naturalKey;
        data["sponsorshipId"] = this.sponsorshipId;
        data["sponsorshipName"] = this.sponsorshipName;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["typeId"] = this.typeId;
        data["statusId"] = this.statusId;
        data["cantonId"] = this.cantonId;
        data["assistantPersonId"] = this.assistantPersonId;
        data["assistantPersonName"] = this.assistantPersonName;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["comments"] = this.comments;
        data["narcExtent"] = this.narcExtent;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["healthRegisterId"] = this.healthRegisterId;
        data["claApplicationId"] = this.claApplicationId;
        data["sapInvoiceStatusId"] = this.sapInvoiceStatusId;
        data["dateOfSapInvoiceBilling"] = this.dateOfSapInvoiceBilling ? this.dateOfSapInvoiceBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["vaccinationLicenceId"] = this.vaccinationLicenceId;
        data["productionOfCytostaticDrugsId"] = this.productionOfCytostaticDrugsId;
        data["onlineDrugSaleId"] = this.onlineDrugSaleId;
        data["productionOfFormulaPreparationsId"] = this.productionOfFormulaPreparationsId;
        if (Array.isArray(this.corporateLicenceRenewals)) {
            data["corporateLicenceRenewals"] = [];
            for (let item of this.corporateLicenceRenewals)
                data["corporateLicenceRenewals"].push(item.toJSON());
        }
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        if (Array.isArray(this.businessIds)) {
            data["businessIds"] = [];
            for (let item of this.businessIds)
                data["businessIds"].push(item);
        }
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        if (Array.isArray(this.employmentIds)) {
            data["employmentIds"] = [];
            for (let item of this.employmentIds)
                data["employmentIds"].push(item);
        }
        data["medicalFieldDirectorId"] = this.medicalFieldDirectorId;
        data["medicalFieldResponsibleForStorageAndQualityId"] = this.medicalFieldResponsibleForStorageAndQualityId;
        data["medicalFieldFieldResponsibleForHaemovigilanceId"] = this.medicalFieldFieldResponsibleForHaemovigilanceId;
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        if (Array.isArray(this.licenceDocuments)) {
            data["licenceDocuments"] = [];
            for (let item of this.licenceDocuments)
                data["licenceDocuments"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICorporateLicenceDto {
    naturalKey: string | undefined;
    sponsorshipId: number | undefined;
    sponsorshipName: string | undefined;
    sponsorshipTypeId: string | undefined;
    typeId: CorporateLicenceType;
    statusId: string | undefined;
    cantonId: string | undefined;
    assistantPersonId: number | undefined;
    assistantPersonName: string | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    comments: string | undefined;
    narcExtent: string | undefined;
    healthRegisterTransfer: boolean;
    healthRegisterId: number | undefined;
    claApplicationId: number | undefined;
    sapInvoiceStatusId: string | undefined;
    dateOfSapInvoiceBilling: DateTime | undefined;
    automaticNotificationAndStatusChange: boolean;
    vaccinationLicenceId: string | undefined;
    productionOfCytostaticDrugsId: string | undefined;
    onlineDrugSaleId: string | undefined;
    productionOfFormulaPreparationsId: string | undefined;
    corporateLicenceRenewals: CorporateLicenceRenewalDto[] | undefined;
    employments: GetEmploymentDto[] | undefined;
    businessIds: number[] | undefined;
    businesses: GetBusinessDto[] | undefined;
    employmentIds: number[] | undefined;
    medicalFieldDirectorId: number | undefined;
    medicalFieldResponsibleForStorageAndQualityId: number | undefined;
    medicalFieldFieldResponsibleForHaemovigilanceId: number | undefined;
    restrictions: CorporateLicenceRestrictionDto[] | undefined;
    licenceDocuments: GeneralFileInfoDto[] | undefined;
    id: number;
}

export class CorporateLicenceRenewal implements ICorporateLicenceRenewal {
    corporateLicenceId!: number;
    corporateLicence!: CorporateLicence;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    comments!: string | undefined;
    sapInvoice!: SapInvoice;
    sapInvoiceId!: number | undefined;
    claApplicationId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ICorporateLicenceRenewal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.corporateLicence = _data["corporateLicence"] ? CorporateLicence.fromJS(_data["corporateLicence"]) : <any>undefined;
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.sapInvoice = _data["sapInvoice"] ? SapInvoice.fromJS(_data["sapInvoice"]) : <any>undefined;
            this.sapInvoiceId = _data["sapInvoiceId"];
            this.claApplicationId = _data["claApplicationId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CorporateLicenceRenewal {
        data = typeof data === 'object' ? data : {};
        let result = new CorporateLicenceRenewal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["corporateLicence"] = this.corporateLicence ? this.corporateLicence.toJSON() : <any>undefined;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["comments"] = this.comments;
        data["sapInvoice"] = this.sapInvoice ? this.sapInvoice.toJSON() : <any>undefined;
        data["sapInvoiceId"] = this.sapInvoiceId;
        data["claApplicationId"] = this.claApplicationId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICorporateLicenceRenewal {
    corporateLicenceId: number;
    corporateLicence: CorporateLicence;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    comments: string | undefined;
    sapInvoice: SapInvoice;
    sapInvoiceId: number | undefined;
    claApplicationId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CorporateLicenceRenewalDto implements ICorporateLicenceRenewalDto {
    corporateLicenceId!: number;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    comments!: string | undefined;
    sapInvoiceStatusId!: string | undefined;
    dateOfSapInvoiceBilling!: DateTime | undefined;
    claApplicationId!: number | undefined;
    id!: number;

    constructor(data?: ICorporateLicenceRenewalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.sapInvoiceStatusId = _data["sapInvoiceStatusId"];
            this.dateOfSapInvoiceBilling = _data["dateOfSapInvoiceBilling"] ? DateTime.fromISO(_data["dateOfSapInvoiceBilling"].toString()) : <any>undefined;
            this.claApplicationId = _data["claApplicationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CorporateLicenceRenewalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CorporateLicenceRenewalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["comments"] = this.comments;
        data["sapInvoiceStatusId"] = this.sapInvoiceStatusId;
        data["dateOfSapInvoiceBilling"] = this.dateOfSapInvoiceBilling ? this.dateOfSapInvoiceBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["claApplicationId"] = this.claApplicationId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICorporateLicenceRenewalDto {
    corporateLicenceId: number;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    comments: string | undefined;
    sapInvoiceStatusId: string | undefined;
    dateOfSapInvoiceBilling: DateTime | undefined;
    claApplicationId: number | undefined;
    id: number;
}

export class CorporateLicenceRestriction implements ICorporateLicenceRestriction {
    licence!: CorporateLicence;
    licenceId!: number;
    typeId!: string | undefined;
    dateOfIssue!: DateTime;
    dateOfEnd!: DateTime | undefined;
    dateOfCompliance!: DateTime | undefined;
    remark!: string | undefined;
    migrationData!: MigrationData[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ICorporateLicenceRestriction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licence = _data["licence"] ? CorporateLicence.fromJS(_data["licence"]) : <any>undefined;
            this.licenceId = _data["licenceId"];
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfCompliance = _data["dateOfCompliance"] ? DateTime.fromISO(_data["dateOfCompliance"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CorporateLicenceRestriction {
        data = typeof data === 'object' ? data : {};
        let result = new CorporateLicenceRestriction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licence"] = this.licence ? this.licence.toJSON() : <any>undefined;
        data["licenceId"] = this.licenceId;
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCompliance"] = this.dateOfCompliance ? this.dateOfCompliance.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICorporateLicenceRestriction {
    licence: CorporateLicence;
    licenceId: number;
    typeId: string | undefined;
    dateOfIssue: DateTime;
    dateOfEnd: DateTime | undefined;
    dateOfCompliance: DateTime | undefined;
    remark: string | undefined;
    migrationData: MigrationData[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CorporateLicenceRestrictionDto implements ICorporateLicenceRestrictionDto {
    typeId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfCompliance!: DateTime | undefined;
    remark!: string | undefined;
    id!: number;

    constructor(data?: ICorporateLicenceRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfCompliance = _data["dateOfCompliance"] ? DateTime.fromISO(_data["dateOfCompliance"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CorporateLicenceRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CorporateLicenceRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCompliance"] = this.dateOfCompliance ? this.dateOfCompliance.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["id"] = this.id;
        return data;
    }
}

export interface ICorporateLicenceRestrictionDto {
    typeId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfCompliance: DateTime | undefined;
    remark: string | undefined;
    id: number;
}

export class CreateCorporateLicenceDto implements ICreateCorporateLicenceDto {
    sponsorshipId!: number;
    sponsorshipTypeId!: string;
    typeId!: CorporateLicenceType;
    cantonId!: string;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;

    constructor(data?: ICreateCorporateLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipId = _data["sponsorshipId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.typeId = _data["typeId"];
            this.cantonId = _data["cantonId"];
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
        }
    }

    static fromJS(data: any): CreateCorporateLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCorporateLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipId"] = this.sponsorshipId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["typeId"] = this.typeId;
        data["cantonId"] = this.cantonId;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        return data;
    }
}

export interface ICreateCorporateLicenceDto {
    sponsorshipId: number;
    sponsorshipTypeId: string;
    typeId: CorporateLicenceType;
    cantonId: string;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
}

export class CreateCorporateLicenceRenewalDto implements ICreateCorporateLicenceRenewalDto {
    corporateLicenceId!: number;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    comments!: string | undefined;

    constructor(data?: ICreateCorporateLicenceRenewalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): CreateCorporateLicenceRenewalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCorporateLicenceRenewalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["comments"] = this.comments;
        return data;
    }
}

export interface ICreateCorporateLicenceRenewalDto {
    corporateLicenceId: number;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    comments: string | undefined;
}

export class GetCorporateLicenceDto implements IGetCorporateLicenceDto {
    sponsorshipId!: number | undefined;
    sponsorshipTypeId!: string | undefined;
    typeId!: CorporateLicenceType;
    statusId!: string | undefined;
    cantonId!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    comments!: string | undefined;
    id!: number;

    constructor(data?: IGetCorporateLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipId = _data["sponsorshipId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.typeId = _data["typeId"];
            this.statusId = _data["statusId"];
            this.cantonId = _data["cantonId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.comments = _data["comments"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCorporateLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCorporateLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipId"] = this.sponsorshipId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["typeId"] = this.typeId;
        data["statusId"] = this.statusId;
        data["cantonId"] = this.cantonId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["comments"] = this.comments;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCorporateLicenceDto {
    sponsorshipId: number | undefined;
    sponsorshipTypeId: string | undefined;
    typeId: CorporateLicenceType;
    statusId: string | undefined;
    cantonId: string | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    comments: string | undefined;
    id: number;
}

export class GetCorporateLicenceRestrictionDto implements IGetCorporateLicenceRestrictionDto {
    typeId!: string;
    dateOfIssue!: DateTime;
    dateOfEnd!: DateTime | undefined;
    dateOfCompliance!: DateTime | undefined;
    remark!: string | undefined;

    constructor(data?: IGetCorporateLicenceRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfCompliance = _data["dateOfCompliance"] ? DateTime.fromISO(_data["dateOfCompliance"].toString()) : <any>undefined;
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): GetCorporateLicenceRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCorporateLicenceRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCompliance"] = this.dateOfCompliance ? this.dateOfCompliance.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IGetCorporateLicenceRestrictionDto {
    typeId: string;
    dateOfIssue: DateTime;
    dateOfEnd: DateTime | undefined;
    dateOfCompliance: DateTime | undefined;
    remark: string | undefined;
}

export class GetCorporateLicencesOutput implements IGetCorporateLicencesOutput {
    items!: CorporateLicenceDto[] | undefined;

    constructor(data?: IGetCorporateLicencesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CorporateLicenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCorporateLicencesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCorporateLicencesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCorporateLicencesOutput {
    items: CorporateLicenceDto[] | undefined;
}

export class CorporateLicenceHistoryDto implements ICorporateLicenceHistoryDto {
    id!: number;
    time!: DateTime;
    reason!: string | undefined;
    userId!: number | undefined;
    entityChangeType!: EntityChangeType;
    propertyChanges!: { [key: string]: HistoryPropertyChange; } | undefined;
    statusId!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    legalBasisId!: string | undefined;
    comments!: string | undefined;
    narcExtent!: string | undefined;

    constructor(data?: ICorporateLicenceHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.time = _data["time"] ? DateTime.fromISO(_data["time"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.userId = _data["userId"];
            this.entityChangeType = _data["entityChangeType"];
            if (_data["propertyChanges"]) {
                this.propertyChanges = {} as any;
                for (let key in _data["propertyChanges"]) {
                    if (_data["propertyChanges"].hasOwnProperty(key))
                        (<any>this.propertyChanges)![key] = _data["propertyChanges"][key];
                }
            }
            this.statusId = _data["statusId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.legalBasisId = _data["legalBasisId"];
            this.comments = _data["comments"];
            this.narcExtent = _data["narcExtent"];
        }
    }

    static fromJS(data: any): CorporateLicenceHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CorporateLicenceHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["time"] = this.time ? this.time.toString() : <any>undefined;
        data["reason"] = this.reason;
        data["userId"] = this.userId;
        data["entityChangeType"] = this.entityChangeType;
        if (this.propertyChanges) {
            data["propertyChanges"] = {};
            for (let key in this.propertyChanges) {
                if (this.propertyChanges.hasOwnProperty(key))
                    (<any>data["propertyChanges"])[key] = (<any>this.propertyChanges)[key];
            }
        }
        data["statusId"] = this.statusId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["legalBasisId"] = this.legalBasisId;
        data["comments"] = this.comments;
        data["narcExtent"] = this.narcExtent;
        return data;
    }
}

export interface ICorporateLicenceHistoryDto {
    id: number;
    time: DateTime;
    reason: string | undefined;
    userId: number | undefined;
    entityChangeType: EntityChangeType;
    propertyChanges: { [key: string]: HistoryPropertyChange; } | undefined;
    statusId: string | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    legalBasisId: string | undefined;
    comments: string | undefined;
    narcExtent: string | undefined;
}

export class SearchCorporateLicenceBusinessDto implements ISearchCorporateLicenceBusinessDto {
    sponsorshipId!: number | undefined;
    statusId!: string | undefined;
    legalFormId!: string | undefined;
    name!: string | undefined;
    additionalName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    gln!: string | undefined;
    bur!: string | undefined;
    id!: number;

    constructor(data?: ISearchCorporateLicenceBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipId = _data["sponsorshipId"];
            this.statusId = _data["statusId"];
            this.legalFormId = _data["legalFormId"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.gln = _data["gln"];
            this.bur = _data["bur"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SearchCorporateLicenceBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCorporateLicenceBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipId"] = this.sponsorshipId;
        data["statusId"] = this.statusId;
        data["legalFormId"] = this.legalFormId;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["gln"] = this.gln;
        data["bur"] = this.bur;
        data["id"] = this.id;
        return data;
    }
}

export interface ISearchCorporateLicenceBusinessDto {
    sponsorshipId: number | undefined;
    statusId: string | undefined;
    legalFormId: string | undefined;
    name: string | undefined;
    additionalName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    gln: string | undefined;
    bur: string | undefined;
    id: number;
}

export class SearchCorporateLicenceDto implements ISearchCorporateLicenceDto {
    naturalKey!: string | undefined;
    sponsorshipId!: number | undefined;
    sponsorshipName!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    typeId!: CorporateLicenceType;
    statusId!: string | undefined;
    cantonId!: string | undefined;
    assistantPersonId!: number | undefined;
    assistantPersonFirstName!: string | undefined;
    assistantPersonLastName!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    comments!: string | undefined;
    healthRegisterTransfer!: boolean;
    healthRegisterId!: number | undefined;
    automaticNotificationAndStatusChange!: boolean;
    businesses!: SearchCorporateLicenceBusinessDto[] | undefined;
    id!: number;

    constructor(data?: ISearchCorporateLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naturalKey = _data["naturalKey"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.sponsorshipName = _data["sponsorshipName"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.typeId = _data["typeId"];
            this.statusId = _data["statusId"];
            this.cantonId = _data["cantonId"];
            this.assistantPersonId = _data["assistantPersonId"];
            this.assistantPersonFirstName = _data["assistantPersonFirstName"];
            this.assistantPersonLastName = _data["assistantPersonLastName"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.comments = _data["comments"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.healthRegisterId = _data["healthRegisterId"];
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(SearchCorporateLicenceBusinessDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SearchCorporateLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCorporateLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naturalKey"] = this.naturalKey;
        data["sponsorshipId"] = this.sponsorshipId;
        data["sponsorshipName"] = this.sponsorshipName;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["typeId"] = this.typeId;
        data["statusId"] = this.statusId;
        data["cantonId"] = this.cantonId;
        data["assistantPersonId"] = this.assistantPersonId;
        data["assistantPersonFirstName"] = this.assistantPersonFirstName;
        data["assistantPersonLastName"] = this.assistantPersonLastName;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["comments"] = this.comments;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["healthRegisterId"] = this.healthRegisterId;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ISearchCorporateLicenceDto {
    naturalKey: string | undefined;
    sponsorshipId: number | undefined;
    sponsorshipName: string | undefined;
    sponsorshipTypeId: string | undefined;
    typeId: CorporateLicenceType;
    statusId: string | undefined;
    cantonId: string | undefined;
    assistantPersonId: number | undefined;
    assistantPersonFirstName: string | undefined;
    assistantPersonLastName: string | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    comments: string | undefined;
    healthRegisterTransfer: boolean;
    healthRegisterId: number | undefined;
    automaticNotificationAndStatusChange: boolean;
    businesses: SearchCorporateLicenceBusinessDto[] | undefined;
    id: number;
}

export class SearchCorporateLicencesInputDto implements ISearchCorporateLicencesInputDto {
    sponsorshipId!: number | undefined;
    personId!: number | undefined;
    businessId!: number | undefined;
    types!: CorporateLicenceType[] | undefined;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: ISearchCorporateLicencesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipId = _data["sponsorshipId"];
            this.personId = _data["personId"];
            this.businessId = _data["businessId"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): SearchCorporateLicencesInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCorporateLicencesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipId"] = this.sponsorshipId;
        data["personId"] = this.personId;
        data["businessId"] = this.businessId;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface ISearchCorporateLicencesInputDto {
    sponsorshipId: number | undefined;
    personId: number | undefined;
    businessId: number | undefined;
    types: CorporateLicenceType[] | undefined;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class SearchCorporateLicencesOutputDto implements ISearchCorporateLicencesOutputDto {
    totalCount!: number;
    items!: SearchCorporateLicenceDto[] | undefined;

    constructor(data?: ISearchCorporateLicencesOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SearchCorporateLicenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchCorporateLicencesOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCorporateLicencesOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchCorporateLicencesOutputDto {
    totalCount: number;
    items: SearchCorporateLicenceDto[] | undefined;
}

export class UpdateCorporateLicenceDto implements IUpdateCorporateLicenceDto {
    sponsorshipTypeId!: string;
    statusId!: string;
    cantonId!: string;
    assistantPersonId!: number | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    comments!: string | undefined;
    narcExtent!: string | undefined;
    businessIds!: number[] | undefined;
    employmentIds!: number[] | undefined;
    medicalFieldDirectorId!: number | undefined;
    automaticNotificationAndStatusChange!: boolean;
    vaccinationLicenceId!: string | undefined;
    productionOfCytostaticDrugsId!: string | undefined;
    onlineDrugSaleId!: string | undefined;
    productionOfFormulaPreparationsId!: string | undefined;

    constructor(data?: IUpdateCorporateLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.statusId = _data["statusId"];
            this.cantonId = _data["cantonId"];
            this.assistantPersonId = _data["assistantPersonId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.comments = _data["comments"];
            this.narcExtent = _data["narcExtent"];
            if (Array.isArray(_data["businessIds"])) {
                this.businessIds = [] as any;
                for (let item of _data["businessIds"])
                    this.businessIds!.push(item);
            }
            if (Array.isArray(_data["employmentIds"])) {
                this.employmentIds = [] as any;
                for (let item of _data["employmentIds"])
                    this.employmentIds!.push(item);
            }
            this.medicalFieldDirectorId = _data["medicalFieldDirectorId"];
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.vaccinationLicenceId = _data["vaccinationLicenceId"];
            this.productionOfCytostaticDrugsId = _data["productionOfCytostaticDrugsId"];
            this.onlineDrugSaleId = _data["onlineDrugSaleId"];
            this.productionOfFormulaPreparationsId = _data["productionOfFormulaPreparationsId"];
        }
    }

    static fromJS(data: any): UpdateCorporateLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCorporateLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["statusId"] = this.statusId;
        data["cantonId"] = this.cantonId;
        data["assistantPersonId"] = this.assistantPersonId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["comments"] = this.comments;
        data["narcExtent"] = this.narcExtent;
        if (Array.isArray(this.businessIds)) {
            data["businessIds"] = [];
            for (let item of this.businessIds)
                data["businessIds"].push(item);
        }
        if (Array.isArray(this.employmentIds)) {
            data["employmentIds"] = [];
            for (let item of this.employmentIds)
                data["employmentIds"].push(item);
        }
        data["medicalFieldDirectorId"] = this.medicalFieldDirectorId;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["vaccinationLicenceId"] = this.vaccinationLicenceId;
        data["productionOfCytostaticDrugsId"] = this.productionOfCytostaticDrugsId;
        data["onlineDrugSaleId"] = this.onlineDrugSaleId;
        data["productionOfFormulaPreparationsId"] = this.productionOfFormulaPreparationsId;
        return data;
    }
}

export interface IUpdateCorporateLicenceDto {
    sponsorshipTypeId: string;
    statusId: string;
    cantonId: string;
    assistantPersonId: number | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    comments: string | undefined;
    narcExtent: string | undefined;
    businessIds: number[] | undefined;
    employmentIds: number[] | undefined;
    medicalFieldDirectorId: number | undefined;
    automaticNotificationAndStatusChange: boolean;
    vaccinationLicenceId: string | undefined;
    productionOfCytostaticDrugsId: string | undefined;
    onlineDrugSaleId: string | undefined;
    productionOfFormulaPreparationsId: string | undefined;
}

export class UpdateCorporateLicenceRenewalDto implements IUpdateCorporateLicenceRenewalDto {
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    comments!: string | undefined;

    constructor(data?: IUpdateCorporateLicenceRenewalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): UpdateCorporateLicenceRenewalDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCorporateLicenceRenewalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IUpdateCorporateLicenceRenewalDto {
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    comments: string | undefined;
}

export class UpdateCorporateLicenceRestrictionDto implements IUpdateCorporateLicenceRestrictionDto {
    typeId!: string;
    dateOfIssue!: DateTime;
    dateOfEnd!: DateTime | undefined;
    dateOfCompliance!: DateTime | undefined;
    remark!: string | undefined;

    constructor(data?: IUpdateCorporateLicenceRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfCompliance = _data["dateOfCompliance"] ? DateTime.fromISO(_data["dateOfCompliance"].toString()) : <any>undefined;
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): UpdateCorporateLicenceRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCorporateLicenceRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCompliance"] = this.dateOfCompliance ? this.dateOfCompliance.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IUpdateCorporateLicenceRestrictionDto {
    typeId: string;
    dateOfIssue: DateTime;
    dateOfEnd: DateTime | undefined;
    dateOfCompliance: DateTime | undefined;
    remark: string | undefined;
}

export class ClaAcademicTitleAlasDto implements IClaAcademicTitleAlasDto {
    title!: string | undefined;
    bodyOfIssue!: string | undefined;
    placeOfIssue!: string | undefined;
    countryOfIssueId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    id!: number;

    constructor(data?: IClaAcademicTitleAlasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.bodyOfIssue = _data["bodyOfIssue"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryOfIssueId = _data["countryOfIssueId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClaAcademicTitleAlasDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaAcademicTitleAlasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["bodyOfIssue"] = this.bodyOfIssue;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryOfIssueId"] = this.countryOfIssueId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IClaAcademicTitleAlasDto {
    title: string | undefined;
    bodyOfIssue: string | undefined;
    placeOfIssue: string | undefined;
    countryOfIssueId: string | undefined;
    dateOfIssue: DateTime | undefined;
    id: number;
}

export class ClaAidingResourcesDto implements IClaAidingResourcesDto {
    id!: number | undefined;
    claBusinessId!: number;
    whatAidingResources!: string | undefined;

    constructor(data?: IClaAidingResourcesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.whatAidingResources = _data["whatAidingResources"];
        }
    }

    static fromJS(data: any): ClaAidingResourcesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaAidingResourcesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["whatAidingResources"] = this.whatAidingResources;
        return data;
    }
}

export interface IClaAidingResourcesDto {
    id: number | undefined;
    claBusinessId: number;
    whatAidingResources: string | undefined;
}

export class ClaAssistantPhysicianDto implements IClaAssistantPhysicianDto {
    id!: number | undefined;
    gln!: string | undefined;
    professionId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    dateOfStart!: DateTime;
    levelOfEmployment!: number;
    postgraduateTitleId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;

    constructor(data?: IClaAssistantPhysicianDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfStart = _data["dateOfStart"] ? DateTime.fromISO(_data["dateOfStart"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ClaAssistantPhysicianDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaAssistantPhysicianDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfStart"] = this.dateOfStart ? this.dateOfStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        return data;
    }
}

export interface IClaAssistantPhysicianDto {
    id: number | undefined;
    gln: string | undefined;
    professionId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    dateOfStart: DateTime;
    levelOfEmployment: number;
    postgraduateTitleId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
}

export class ClaAuthorizationDto implements IClaAuthorizationDto {
    isAuthorizedSignatoryId!: string | undefined;

    constructor(data?: IClaAuthorizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthorizedSignatoryId = _data["isAuthorizedSignatoryId"];
        }
    }

    static fromJS(data: any): ClaAuthorizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaAuthorizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthorizedSignatoryId"] = this.isAuthorizedSignatoryId;
        return data;
    }
}

export interface IClaAuthorizationDto {
    isAuthorizedSignatoryId: string | undefined;
}

export class ClaBusinessAlasDto implements IClaBusinessAlasDto {
    employmentId!: number | undefined;
    businessId!: number | undefined;
    isAssistanceEmployment!: boolean;
    isMobileEmployment!: boolean;
    name!: string | undefined;
    legalFormId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    countryId!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    id!: number;

    constructor(data?: IClaBusinessAlasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employmentId = _data["employmentId"];
            this.businessId = _data["businessId"];
            this.isAssistanceEmployment = _data["isAssistanceEmployment"];
            this.isMobileEmployment = _data["isMobileEmployment"];
            this.name = _data["name"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.countryId = _data["countryId"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClaBusinessAlasDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaBusinessAlasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employmentId"] = this.employmentId;
        data["businessId"] = this.businessId;
        data["isAssistanceEmployment"] = this.isAssistanceEmployment;
        data["isMobileEmployment"] = this.isMobileEmployment;
        data["name"] = this.name;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["countryId"] = this.countryId;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["id"] = this.id;
        return data;
    }
}

export interface IClaBusinessAlasDto {
    employmentId: number | undefined;
    businessId: number | undefined;
    isAssistanceEmployment: boolean;
    isMobileEmployment: boolean;
    name: string | undefined;
    legalFormId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    countryId: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    dateOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    id: number;
}

export class ClaBusinessDirectorDto implements IClaBusinessDirectorDto {
    id!: number;
    claBusinessId!: number;
    isSameAsMedicalFieldManagementId!: string;
    gln!: string | undefined;
    professionId!: string | undefined;
    levelOfEmployment!: number | undefined;
    dateOfStart!: DateTime | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;

    constructor(data?: IClaBusinessDirectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.isSameAsMedicalFieldManagementId = _data["isSameAsMedicalFieldManagementId"];
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfStart = _data["dateOfStart"] ? DateTime.fromISO(_data["dateOfStart"].toString()) : <any>undefined;
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ClaBusinessDirectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaBusinessDirectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["isSameAsMedicalFieldManagementId"] = this.isSameAsMedicalFieldManagementId;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfStart"] = this.dateOfStart ? this.dateOfStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        return data;
    }
}

export interface IClaBusinessDirectorDto {
    id: number;
    claBusinessId: number;
    isSameAsMedicalFieldManagementId: string;
    gln: string | undefined;
    professionId: string | undefined;
    levelOfEmployment: number | undefined;
    dateOfStart: DateTime | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
}

export class ClaBusinessDto implements IClaBusinessDto {
    id!: number | undefined;
    name!: string;
    additionalName!: string | undefined;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    email2!: string | undefined;
    website!: string | undefined;
    gln!: string | undefined;
    bur!: string | undefined;
    dateOfOpening!: DateTime | undefined;
    businessHours!: string | undefined;
    isChangeOfAddress!: string | undefined;
    hasLocalPharmacyId!: string | undefined;
    hasQualitySystemId!: string | undefined;
    hasNoQualitySystemReason!: string | undefined;
    confirmationOfAcknowledgement!: boolean | undefined;
    directors!: ClaBusinessDirectorDto[] | undefined;
    rangeOfServices!: ClaRangeOfServicesDto;
    readonly rangeOfServicesList!: ClaRangeOfServicesDto[] | undefined;
    treatmentItems!: ClaTreatmentDto[] | undefined;
    readonly treatmentsList!: ClaTreatmentDto[] | undefined;
    nursingBeds!: ClaNursingBedsDto;
    readonly nursingBedList!: ClaNursingBedsDto[] | undefined;
    floors!: ClaFloorsDto;
    readonly floorsList!: ClaFloorsDto[] | undefined;
    aidingResources!: ClaAidingResourcesDto;
    readonly aidingResourcesList!: ClaAidingResourcesDto[] | undefined;
    drugChambers!: ClaDrugChambersDto;
    readonly drugChambersList!: ClaDrugChambersDto[] | undefined;
    sanitaryFacilities!: ClaSanitaryFacilitiesDto;
    readonly sanitaryFacilitiesList!: ClaSanitaryFacilitiesDto[] | undefined;
    security!: ClaSecurityDto;
    readonly securityList!: ClaSecurityDto[] | undefined;
    wheelchairAccessibility!: ClaWheelchairAccessibilityDto;
    readonly wheelchairAccessibilityList!: ClaWheelchairAccessibilityDto[] | undefined;
    quality!: ClaQualityDto;
    readonly qualityList!: ClaQualityDto[] | undefined;
    serviceAreas!: ClaServiceAreasDto[] | undefined;
    readonly serviceAreasList!: ClaServiceAreasDto[] | undefined;
    personel!: ClaPersonelDto;
    readonly personelList!: ClaPersonelDto[] | undefined;
    infrastructure!: ClaInfrastructureDto;
    readonly infrastructureList!: ClaInfrastructureDto[] | undefined;
    rangeOfProducts!: SlasRangeOfProductsDto;
    readonly rangeOfProductsList!: SlasRangeOfProductsDto[] | undefined;
    productPreparation!: SlasProductPreparationDto;
    readonly productPreparationList!: SlasProductPreparationDto[] | undefined;
    localDrugSales!: SlasLocalDrugSalesDto;
    readonly localDrugSalesList!: SlasLocalDrugSalesDto[] | undefined;
    drugProduction!: SlasDrugProductionDto;
    readonly drugProductionList!: SlasDrugProductionDto[] | undefined;
    drugProductionThirdParty!: SlasDrugProductionThirdPartyDto;
    readonly drugProductionThirdPartyList!: SlasDrugProductionThirdPartyDto[] | undefined;

    constructor(data?: IClaBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.website = _data["website"];
            this.gln = _data["gln"];
            this.bur = _data["bur"];
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.businessHours = _data["businessHours"];
            this.isChangeOfAddress = _data["isChangeOfAddress"];
            this.hasLocalPharmacyId = _data["hasLocalPharmacyId"];
            this.hasQualitySystemId = _data["hasQualitySystemId"];
            this.hasNoQualitySystemReason = _data["hasNoQualitySystemReason"];
            this.confirmationOfAcknowledgement = _data["confirmationOfAcknowledgement"];
            if (Array.isArray(_data["directors"])) {
                this.directors = [] as any;
                for (let item of _data["directors"])
                    this.directors!.push(ClaBusinessDirectorDto.fromJS(item));
            }
            this.rangeOfServices = _data["rangeOfServices"] ? ClaRangeOfServicesDto.fromJS(_data["rangeOfServices"]) : <any>undefined;
            if (Array.isArray(_data["rangeOfServicesList"])) {
                (<any>this).rangeOfServicesList = [] as any;
                for (let item of _data["rangeOfServicesList"])
                    (<any>this).rangeOfServicesList!.push(ClaRangeOfServicesDto.fromJS(item));
            }
            if (Array.isArray(_data["treatmentItems"])) {
                this.treatmentItems = [] as any;
                for (let item of _data["treatmentItems"])
                    this.treatmentItems!.push(ClaTreatmentDto.fromJS(item));
            }
            if (Array.isArray(_data["treatmentsList"])) {
                (<any>this).treatmentsList = [] as any;
                for (let item of _data["treatmentsList"])
                    (<any>this).treatmentsList!.push(ClaTreatmentDto.fromJS(item));
            }
            this.nursingBeds = _data["nursingBeds"] ? ClaNursingBedsDto.fromJS(_data["nursingBeds"]) : <any>undefined;
            if (Array.isArray(_data["nursingBedList"])) {
                (<any>this).nursingBedList = [] as any;
                for (let item of _data["nursingBedList"])
                    (<any>this).nursingBedList!.push(ClaNursingBedsDto.fromJS(item));
            }
            this.floors = _data["floors"] ? ClaFloorsDto.fromJS(_data["floors"]) : <any>undefined;
            if (Array.isArray(_data["floorsList"])) {
                (<any>this).floorsList = [] as any;
                for (let item of _data["floorsList"])
                    (<any>this).floorsList!.push(ClaFloorsDto.fromJS(item));
            }
            this.aidingResources = _data["aidingResources"] ? ClaAidingResourcesDto.fromJS(_data["aidingResources"]) : <any>undefined;
            if (Array.isArray(_data["aidingResourcesList"])) {
                (<any>this).aidingResourcesList = [] as any;
                for (let item of _data["aidingResourcesList"])
                    (<any>this).aidingResourcesList!.push(ClaAidingResourcesDto.fromJS(item));
            }
            this.drugChambers = _data["drugChambers"] ? ClaDrugChambersDto.fromJS(_data["drugChambers"]) : <any>undefined;
            if (Array.isArray(_data["drugChambersList"])) {
                (<any>this).drugChambersList = [] as any;
                for (let item of _data["drugChambersList"])
                    (<any>this).drugChambersList!.push(ClaDrugChambersDto.fromJS(item));
            }
            this.sanitaryFacilities = _data["sanitaryFacilities"] ? ClaSanitaryFacilitiesDto.fromJS(_data["sanitaryFacilities"]) : <any>undefined;
            if (Array.isArray(_data["sanitaryFacilitiesList"])) {
                (<any>this).sanitaryFacilitiesList = [] as any;
                for (let item of _data["sanitaryFacilitiesList"])
                    (<any>this).sanitaryFacilitiesList!.push(ClaSanitaryFacilitiesDto.fromJS(item));
            }
            this.security = _data["security"] ? ClaSecurityDto.fromJS(_data["security"]) : <any>undefined;
            if (Array.isArray(_data["securityList"])) {
                (<any>this).securityList = [] as any;
                for (let item of _data["securityList"])
                    (<any>this).securityList!.push(ClaSecurityDto.fromJS(item));
            }
            this.wheelchairAccessibility = _data["wheelchairAccessibility"] ? ClaWheelchairAccessibilityDto.fromJS(_data["wheelchairAccessibility"]) : <any>undefined;
            if (Array.isArray(_data["wheelchairAccessibilityList"])) {
                (<any>this).wheelchairAccessibilityList = [] as any;
                for (let item of _data["wheelchairAccessibilityList"])
                    (<any>this).wheelchairAccessibilityList!.push(ClaWheelchairAccessibilityDto.fromJS(item));
            }
            this.quality = _data["quality"] ? ClaQualityDto.fromJS(_data["quality"]) : <any>undefined;
            if (Array.isArray(_data["qualityList"])) {
                (<any>this).qualityList = [] as any;
                for (let item of _data["qualityList"])
                    (<any>this).qualityList!.push(ClaQualityDto.fromJS(item));
            }
            if (Array.isArray(_data["serviceAreas"])) {
                this.serviceAreas = [] as any;
                for (let item of _data["serviceAreas"])
                    this.serviceAreas!.push(ClaServiceAreasDto.fromJS(item));
            }
            if (Array.isArray(_data["serviceAreasList"])) {
                (<any>this).serviceAreasList = [] as any;
                for (let item of _data["serviceAreasList"])
                    (<any>this).serviceAreasList!.push(ClaServiceAreasDto.fromJS(item));
            }
            this.personel = _data["personel"] ? ClaPersonelDto.fromJS(_data["personel"]) : <any>undefined;
            if (Array.isArray(_data["personelList"])) {
                (<any>this).personelList = [] as any;
                for (let item of _data["personelList"])
                    (<any>this).personelList!.push(ClaPersonelDto.fromJS(item));
            }
            this.infrastructure = _data["infrastructure"] ? ClaInfrastructureDto.fromJS(_data["infrastructure"]) : <any>undefined;
            if (Array.isArray(_data["infrastructureList"])) {
                (<any>this).infrastructureList = [] as any;
                for (let item of _data["infrastructureList"])
                    (<any>this).infrastructureList!.push(ClaInfrastructureDto.fromJS(item));
            }
            this.rangeOfProducts = _data["rangeOfProducts"] ? SlasRangeOfProductsDto.fromJS(_data["rangeOfProducts"]) : <any>undefined;
            if (Array.isArray(_data["rangeOfProductsList"])) {
                (<any>this).rangeOfProductsList = [] as any;
                for (let item of _data["rangeOfProductsList"])
                    (<any>this).rangeOfProductsList!.push(SlasRangeOfProductsDto.fromJS(item));
            }
            this.productPreparation = _data["productPreparation"] ? SlasProductPreparationDto.fromJS(_data["productPreparation"]) : <any>undefined;
            if (Array.isArray(_data["productPreparationList"])) {
                (<any>this).productPreparationList = [] as any;
                for (let item of _data["productPreparationList"])
                    (<any>this).productPreparationList!.push(SlasProductPreparationDto.fromJS(item));
            }
            this.localDrugSales = _data["localDrugSales"] ? SlasLocalDrugSalesDto.fromJS(_data["localDrugSales"]) : <any>undefined;
            if (Array.isArray(_data["localDrugSalesList"])) {
                (<any>this).localDrugSalesList = [] as any;
                for (let item of _data["localDrugSalesList"])
                    (<any>this).localDrugSalesList!.push(SlasLocalDrugSalesDto.fromJS(item));
            }
            this.drugProduction = _data["drugProduction"] ? SlasDrugProductionDto.fromJS(_data["drugProduction"]) : <any>undefined;
            if (Array.isArray(_data["drugProductionList"])) {
                (<any>this).drugProductionList = [] as any;
                for (let item of _data["drugProductionList"])
                    (<any>this).drugProductionList!.push(SlasDrugProductionDto.fromJS(item));
            }
            this.drugProductionThirdParty = _data["drugProductionThirdParty"] ? SlasDrugProductionThirdPartyDto.fromJS(_data["drugProductionThirdParty"]) : <any>undefined;
            if (Array.isArray(_data["drugProductionThirdPartyList"])) {
                (<any>this).drugProductionThirdPartyList = [] as any;
                for (let item of _data["drugProductionThirdPartyList"])
                    (<any>this).drugProductionThirdPartyList!.push(SlasDrugProductionThirdPartyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClaBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["website"] = this.website;
        data["gln"] = this.gln;
        data["bur"] = this.bur;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessHours"] = this.businessHours;
        data["isChangeOfAddress"] = this.isChangeOfAddress;
        data["hasLocalPharmacyId"] = this.hasLocalPharmacyId;
        data["hasQualitySystemId"] = this.hasQualitySystemId;
        data["hasNoQualitySystemReason"] = this.hasNoQualitySystemReason;
        data["confirmationOfAcknowledgement"] = this.confirmationOfAcknowledgement;
        if (Array.isArray(this.directors)) {
            data["directors"] = [];
            for (let item of this.directors)
                data["directors"].push(item.toJSON());
        }
        data["rangeOfServices"] = this.rangeOfServices ? this.rangeOfServices.toJSON() : <any>undefined;
        if (Array.isArray(this.rangeOfServicesList)) {
            data["rangeOfServicesList"] = [];
            for (let item of this.rangeOfServicesList)
                data["rangeOfServicesList"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentItems)) {
            data["treatmentItems"] = [];
            for (let item of this.treatmentItems)
                data["treatmentItems"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentsList)) {
            data["treatmentsList"] = [];
            for (let item of this.treatmentsList)
                data["treatmentsList"].push(item.toJSON());
        }
        data["nursingBeds"] = this.nursingBeds ? this.nursingBeds.toJSON() : <any>undefined;
        if (Array.isArray(this.nursingBedList)) {
            data["nursingBedList"] = [];
            for (let item of this.nursingBedList)
                data["nursingBedList"].push(item.toJSON());
        }
        data["floors"] = this.floors ? this.floors.toJSON() : <any>undefined;
        if (Array.isArray(this.floorsList)) {
            data["floorsList"] = [];
            for (let item of this.floorsList)
                data["floorsList"].push(item.toJSON());
        }
        data["aidingResources"] = this.aidingResources ? this.aidingResources.toJSON() : <any>undefined;
        if (Array.isArray(this.aidingResourcesList)) {
            data["aidingResourcesList"] = [];
            for (let item of this.aidingResourcesList)
                data["aidingResourcesList"].push(item.toJSON());
        }
        data["drugChambers"] = this.drugChambers ? this.drugChambers.toJSON() : <any>undefined;
        if (Array.isArray(this.drugChambersList)) {
            data["drugChambersList"] = [];
            for (let item of this.drugChambersList)
                data["drugChambersList"].push(item.toJSON());
        }
        data["sanitaryFacilities"] = this.sanitaryFacilities ? this.sanitaryFacilities.toJSON() : <any>undefined;
        if (Array.isArray(this.sanitaryFacilitiesList)) {
            data["sanitaryFacilitiesList"] = [];
            for (let item of this.sanitaryFacilitiesList)
                data["sanitaryFacilitiesList"].push(item.toJSON());
        }
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        if (Array.isArray(this.securityList)) {
            data["securityList"] = [];
            for (let item of this.securityList)
                data["securityList"].push(item.toJSON());
        }
        data["wheelchairAccessibility"] = this.wheelchairAccessibility ? this.wheelchairAccessibility.toJSON() : <any>undefined;
        if (Array.isArray(this.wheelchairAccessibilityList)) {
            data["wheelchairAccessibilityList"] = [];
            for (let item of this.wheelchairAccessibilityList)
                data["wheelchairAccessibilityList"].push(item.toJSON());
        }
        data["quality"] = this.quality ? this.quality.toJSON() : <any>undefined;
        if (Array.isArray(this.qualityList)) {
            data["qualityList"] = [];
            for (let item of this.qualityList)
                data["qualityList"].push(item.toJSON());
        }
        if (Array.isArray(this.serviceAreas)) {
            data["serviceAreas"] = [];
            for (let item of this.serviceAreas)
                data["serviceAreas"].push(item.toJSON());
        }
        if (Array.isArray(this.serviceAreasList)) {
            data["serviceAreasList"] = [];
            for (let item of this.serviceAreasList)
                data["serviceAreasList"].push(item.toJSON());
        }
        data["personel"] = this.personel ? this.personel.toJSON() : <any>undefined;
        if (Array.isArray(this.personelList)) {
            data["personelList"] = [];
            for (let item of this.personelList)
                data["personelList"].push(item.toJSON());
        }
        data["infrastructure"] = this.infrastructure ? this.infrastructure.toJSON() : <any>undefined;
        if (Array.isArray(this.infrastructureList)) {
            data["infrastructureList"] = [];
            for (let item of this.infrastructureList)
                data["infrastructureList"].push(item.toJSON());
        }
        data["rangeOfProducts"] = this.rangeOfProducts ? this.rangeOfProducts.toJSON() : <any>undefined;
        if (Array.isArray(this.rangeOfProductsList)) {
            data["rangeOfProductsList"] = [];
            for (let item of this.rangeOfProductsList)
                data["rangeOfProductsList"].push(item.toJSON());
        }
        data["productPreparation"] = this.productPreparation ? this.productPreparation.toJSON() : <any>undefined;
        if (Array.isArray(this.productPreparationList)) {
            data["productPreparationList"] = [];
            for (let item of this.productPreparationList)
                data["productPreparationList"].push(item.toJSON());
        }
        data["localDrugSales"] = this.localDrugSales ? this.localDrugSales.toJSON() : <any>undefined;
        if (Array.isArray(this.localDrugSalesList)) {
            data["localDrugSalesList"] = [];
            for (let item of this.localDrugSalesList)
                data["localDrugSalesList"].push(item.toJSON());
        }
        data["drugProduction"] = this.drugProduction ? this.drugProduction.toJSON() : <any>undefined;
        if (Array.isArray(this.drugProductionList)) {
            data["drugProductionList"] = [];
            for (let item of this.drugProductionList)
                data["drugProductionList"].push(item.toJSON());
        }
        data["drugProductionThirdParty"] = this.drugProductionThirdParty ? this.drugProductionThirdParty.toJSON() : <any>undefined;
        if (Array.isArray(this.drugProductionThirdPartyList)) {
            data["drugProductionThirdPartyList"] = [];
            for (let item of this.drugProductionThirdPartyList)
                data["drugProductionThirdPartyList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClaBusinessDto {
    id: number | undefined;
    name: string;
    additionalName: string | undefined;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    email2: string | undefined;
    website: string | undefined;
    gln: string | undefined;
    bur: string | undefined;
    dateOfOpening: DateTime | undefined;
    businessHours: string | undefined;
    isChangeOfAddress: string | undefined;
    hasLocalPharmacyId: string | undefined;
    hasQualitySystemId: string | undefined;
    hasNoQualitySystemReason: string | undefined;
    confirmationOfAcknowledgement: boolean | undefined;
    directors: ClaBusinessDirectorDto[] | undefined;
    rangeOfServices: ClaRangeOfServicesDto;
    rangeOfServicesList: ClaRangeOfServicesDto[] | undefined;
    treatmentItems: ClaTreatmentDto[] | undefined;
    treatmentsList: ClaTreatmentDto[] | undefined;
    nursingBeds: ClaNursingBedsDto;
    nursingBedList: ClaNursingBedsDto[] | undefined;
    floors: ClaFloorsDto;
    floorsList: ClaFloorsDto[] | undefined;
    aidingResources: ClaAidingResourcesDto;
    aidingResourcesList: ClaAidingResourcesDto[] | undefined;
    drugChambers: ClaDrugChambersDto;
    drugChambersList: ClaDrugChambersDto[] | undefined;
    sanitaryFacilities: ClaSanitaryFacilitiesDto;
    sanitaryFacilitiesList: ClaSanitaryFacilitiesDto[] | undefined;
    security: ClaSecurityDto;
    securityList: ClaSecurityDto[] | undefined;
    wheelchairAccessibility: ClaWheelchairAccessibilityDto;
    wheelchairAccessibilityList: ClaWheelchairAccessibilityDto[] | undefined;
    quality: ClaQualityDto;
    qualityList: ClaQualityDto[] | undefined;
    serviceAreas: ClaServiceAreasDto[] | undefined;
    serviceAreasList: ClaServiceAreasDto[] | undefined;
    personel: ClaPersonelDto;
    personelList: ClaPersonelDto[] | undefined;
    infrastructure: ClaInfrastructureDto;
    infrastructureList: ClaInfrastructureDto[] | undefined;
    rangeOfProducts: SlasRangeOfProductsDto;
    rangeOfProductsList: SlasRangeOfProductsDto[] | undefined;
    productPreparation: SlasProductPreparationDto;
    productPreparationList: SlasProductPreparationDto[] | undefined;
    localDrugSales: SlasLocalDrugSalesDto;
    localDrugSalesList: SlasLocalDrugSalesDto[] | undefined;
    drugProduction: SlasDrugProductionDto;
    drugProductionList: SlasDrugProductionDto[] | undefined;
    drugProductionThirdParty: SlasDrugProductionThirdPartyDto;
    drugProductionThirdPartyList: SlasDrugProductionThirdPartyDto[] | undefined;
}

export class ClaContactAlasDto implements IClaContactAlasDto {
    titleId!: string;
    languageOfCorrespondenceId!: string | undefined;
    street!: string;
    streetNr!: string | undefined;
    postCode!: string;
    city!: string;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    email!: string;
    phone1!: string;
    phone2!: string | undefined;

    constructor(data?: IClaContactAlasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
        }
    }

    static fromJS(data: any): ClaContactAlasDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaContactAlasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        return data;
    }
}

export interface IClaContactAlasDto {
    titleId: string;
    languageOfCorrespondenceId: string | undefined;
    street: string;
    streetNr: string | undefined;
    postCode: string;
    city: string;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    email: string;
    phone1: string;
    phone2: string | undefined;
}

export class ClaDiplomaAlasDto implements IClaDiplomaAlasDto {
    professionId!: string;
    countryOfIssueId!: string;
    isInEducationId!: string;
    postgraduateTitleId!: string | undefined;
    placeOfEducation!: string | undefined;
    assistantGln!: string | undefined;

    constructor(data?: IClaDiplomaAlasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.countryOfIssueId = _data["countryOfIssueId"];
            this.isInEducationId = _data["isInEducationId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.placeOfEducation = _data["placeOfEducation"];
            this.assistantGln = _data["assistantGln"];
        }
    }

    static fromJS(data: any): ClaDiplomaAlasDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaDiplomaAlasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["countryOfIssueId"] = this.countryOfIssueId;
        data["isInEducationId"] = this.isInEducationId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["placeOfEducation"] = this.placeOfEducation;
        data["assistantGln"] = this.assistantGln;
        return data;
    }
}

export interface IClaDiplomaAlasDto {
    professionId: string;
    countryOfIssueId: string;
    isInEducationId: string;
    postgraduateTitleId: string | undefined;
    placeOfEducation: string | undefined;
    assistantGln: string | undefined;
}

export class ClaDocumentsOutput implements IClaDocumentsOutput {
    caseId!: string;
    documents!: GeneralDocumentGroupDto[];

    constructor(data?: IClaDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClaDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ClaDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClaDocumentsOutput {
    caseId: string;
    documents: GeneralDocumentGroupDto[];
}

export class ClaDrugChambersDto implements IClaDrugChambersDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasDrugChamberInEverySectionId!: string | undefined;
    hasWashbasinInEveryDrugChamberId!: string | undefined;

    constructor(data?: IClaDrugChambersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasDrugChamberInEverySectionId = _data["hasDrugChamberInEverySectionId"];
            this.hasWashbasinInEveryDrugChamberId = _data["hasWashbasinInEveryDrugChamberId"];
        }
    }

    static fromJS(data: any): ClaDrugChambersDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaDrugChambersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasDrugChamberInEverySectionId"] = this.hasDrugChamberInEverySectionId;
        data["hasWashbasinInEveryDrugChamberId"] = this.hasWashbasinInEveryDrugChamberId;
        return data;
    }
}

export interface IClaDrugChambersDto {
    id: number | undefined;
    claBusinessId: number;
    hasDrugChamberInEverySectionId: string | undefined;
    hasWashbasinInEveryDrugChamberId: string | undefined;
}

export class ClaDto implements IClaDto {
    application!: ApplicationDto;
    sponsorshipTypeId!: string | undefined;
    statusId!: ClaStatus;
    firstStep!: ClaStatus;
    authorization!: ClaAuthorizationDto;
    sponsorship!: ClaSponsorshipDto;
    claQualityRequirement!: ClaQualityRequirementDto;
    claElectronicPatientRecord!: ClaElectronicPatientRecordDto;
    sponsorshipDirectors!: ClaSponsorshipDirectorDto[] | undefined;
    personAlas!: ClaPersonAlasDto;
    medicalFieldDirector!: ClaMedicalFieldDirectorDto;
    medicalFieldDirectorRepresentative!: ClaMedicalFieldDirectorRepresentativeDto;
    medicalFieldResponsibleForStorageAndQuality!: ClaMedicalFieldResponsibleForStorageAndQualityDto;
    medicalFieldResponsibleForHaemovigilance!: ClaMedicalFieldResponsibleForHaemovigilanceDto;
    trainer!: ClaTrainerDto;
    businesses!: ClaBusinessDto[] | undefined;
    selectedBusinesses!: ClaSelectedBusinessDto[] | undefined;
    medicalFieldPersons!: ClaMedicalFieldPersonDto[] | undefined;
    medicalFieldPersonsAlas!: ClaMedicalFieldPersonAlasDto[] | undefined;
    assistantPhysicians!: ClaAssistantPhysicianDto[] | undefined;
    securityAndInsurance!: ClaSecurityAndInsuranceDto;
    restrictions!: ClaRestrictionDto[] | undefined;
    invoiceAddress!: ClaInvoiceAddressDto;
    documents!: GeneralDocumentGroupDto[] | undefined;
    headOfNursingServices!: ClaHeadOfNursingServicesDto[] | undefined;
    headOfNursingServicesRepresentative!: ClaHeadOfNursingServicesRepresentativeDto[] | undefined;
    internalSupervision!: ClaInternalSupervisionDto;
    externalPointForComplaints!: ClaExternalPointForComplaintsDto;
    vaccinationInPharmacy!: ClaVaccinationInPharmacyDto;
    parentSponsorship!: ClaSponsorshipDto;

    constructor(data?: IClaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.statusId = _data["statusId"];
            this.firstStep = _data["firstStep"];
            this.authorization = _data["authorization"] ? ClaAuthorizationDto.fromJS(_data["authorization"]) : <any>undefined;
            this.sponsorship = _data["sponsorship"] ? ClaSponsorshipDto.fromJS(_data["sponsorship"]) : <any>undefined;
            this.claQualityRequirement = _data["claQualityRequirement"] ? ClaQualityRequirementDto.fromJS(_data["claQualityRequirement"]) : <any>undefined;
            this.claElectronicPatientRecord = _data["claElectronicPatientRecord"] ? ClaElectronicPatientRecordDto.fromJS(_data["claElectronicPatientRecord"]) : <any>undefined;
            if (Array.isArray(_data["sponsorshipDirectors"])) {
                this.sponsorshipDirectors = [] as any;
                for (let item of _data["sponsorshipDirectors"])
                    this.sponsorshipDirectors!.push(ClaSponsorshipDirectorDto.fromJS(item));
            }
            this.personAlas = _data["personAlas"] ? ClaPersonAlasDto.fromJS(_data["personAlas"]) : <any>undefined;
            this.medicalFieldDirector = _data["medicalFieldDirector"] ? ClaMedicalFieldDirectorDto.fromJS(_data["medicalFieldDirector"]) : <any>undefined;
            this.medicalFieldDirectorRepresentative = _data["medicalFieldDirectorRepresentative"] ? ClaMedicalFieldDirectorRepresentativeDto.fromJS(_data["medicalFieldDirectorRepresentative"]) : <any>undefined;
            this.medicalFieldResponsibleForStorageAndQuality = _data["medicalFieldResponsibleForStorageAndQuality"] ? ClaMedicalFieldResponsibleForStorageAndQualityDto.fromJS(_data["medicalFieldResponsibleForStorageAndQuality"]) : <any>undefined;
            this.medicalFieldResponsibleForHaemovigilance = _data["medicalFieldResponsibleForHaemovigilance"] ? ClaMedicalFieldResponsibleForHaemovigilanceDto.fromJS(_data["medicalFieldResponsibleForHaemovigilance"]) : <any>undefined;
            this.trainer = _data["trainer"] ? ClaTrainerDto.fromJS(_data["trainer"]) : <any>undefined;
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
            if (Array.isArray(_data["selectedBusinesses"])) {
                this.selectedBusinesses = [] as any;
                for (let item of _data["selectedBusinesses"])
                    this.selectedBusinesses!.push(ClaSelectedBusinessDto.fromJS(item));
            }
            if (Array.isArray(_data["medicalFieldPersons"])) {
                this.medicalFieldPersons = [] as any;
                for (let item of _data["medicalFieldPersons"])
                    this.medicalFieldPersons!.push(ClaMedicalFieldPersonDto.fromJS(item));
            }
            if (Array.isArray(_data["medicalFieldPersonsAlas"])) {
                this.medicalFieldPersonsAlas = [] as any;
                for (let item of _data["medicalFieldPersonsAlas"])
                    this.medicalFieldPersonsAlas!.push(ClaMedicalFieldPersonAlasDto.fromJS(item));
            }
            if (Array.isArray(_data["assistantPhysicians"])) {
                this.assistantPhysicians = [] as any;
                for (let item of _data["assistantPhysicians"])
                    this.assistantPhysicians!.push(ClaAssistantPhysicianDto.fromJS(item));
            }
            this.securityAndInsurance = _data["securityAndInsurance"] ? ClaSecurityAndInsuranceDto.fromJS(_data["securityAndInsurance"]) : <any>undefined;
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(ClaRestrictionDto.fromJS(item));
            }
            this.invoiceAddress = _data["invoiceAddress"] ? ClaInvoiceAddressDto.fromJS(_data["invoiceAddress"]) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["headOfNursingServices"])) {
                this.headOfNursingServices = [] as any;
                for (let item of _data["headOfNursingServices"])
                    this.headOfNursingServices!.push(ClaHeadOfNursingServicesDto.fromJS(item));
            }
            if (Array.isArray(_data["headOfNursingServicesRepresentative"])) {
                this.headOfNursingServicesRepresentative = [] as any;
                for (let item of _data["headOfNursingServicesRepresentative"])
                    this.headOfNursingServicesRepresentative!.push(ClaHeadOfNursingServicesRepresentativeDto.fromJS(item));
            }
            this.internalSupervision = _data["internalSupervision"] ? ClaInternalSupervisionDto.fromJS(_data["internalSupervision"]) : <any>undefined;
            this.externalPointForComplaints = _data["externalPointForComplaints"] ? ClaExternalPointForComplaintsDto.fromJS(_data["externalPointForComplaints"]) : <any>undefined;
            this.vaccinationInPharmacy = _data["vaccinationInPharmacy"] ? ClaVaccinationInPharmacyDto.fromJS(_data["vaccinationInPharmacy"]) : <any>undefined;
            this.parentSponsorship = _data["parentSponsorship"] ? ClaSponsorshipDto.fromJS(_data["parentSponsorship"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["statusId"] = this.statusId;
        data["firstStep"] = this.firstStep;
        data["authorization"] = this.authorization ? this.authorization.toJSON() : <any>undefined;
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        data["claQualityRequirement"] = this.claQualityRequirement ? this.claQualityRequirement.toJSON() : <any>undefined;
        data["claElectronicPatientRecord"] = this.claElectronicPatientRecord ? this.claElectronicPatientRecord.toJSON() : <any>undefined;
        if (Array.isArray(this.sponsorshipDirectors)) {
            data["sponsorshipDirectors"] = [];
            for (let item of this.sponsorshipDirectors)
                data["sponsorshipDirectors"].push(item.toJSON());
        }
        data["personAlas"] = this.personAlas ? this.personAlas.toJSON() : <any>undefined;
        data["medicalFieldDirector"] = this.medicalFieldDirector ? this.medicalFieldDirector.toJSON() : <any>undefined;
        data["medicalFieldDirectorRepresentative"] = this.medicalFieldDirectorRepresentative ? this.medicalFieldDirectorRepresentative.toJSON() : <any>undefined;
        data["medicalFieldResponsibleForStorageAndQuality"] = this.medicalFieldResponsibleForStorageAndQuality ? this.medicalFieldResponsibleForStorageAndQuality.toJSON() : <any>undefined;
        data["medicalFieldResponsibleForHaemovigilance"] = this.medicalFieldResponsibleForHaemovigilance ? this.medicalFieldResponsibleForHaemovigilance.toJSON() : <any>undefined;
        data["trainer"] = this.trainer ? this.trainer.toJSON() : <any>undefined;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        if (Array.isArray(this.selectedBusinesses)) {
            data["selectedBusinesses"] = [];
            for (let item of this.selectedBusinesses)
                data["selectedBusinesses"].push(item.toJSON());
        }
        if (Array.isArray(this.medicalFieldPersons)) {
            data["medicalFieldPersons"] = [];
            for (let item of this.medicalFieldPersons)
                data["medicalFieldPersons"].push(item.toJSON());
        }
        if (Array.isArray(this.medicalFieldPersonsAlas)) {
            data["medicalFieldPersonsAlas"] = [];
            for (let item of this.medicalFieldPersonsAlas)
                data["medicalFieldPersonsAlas"].push(item.toJSON());
        }
        if (Array.isArray(this.assistantPhysicians)) {
            data["assistantPhysicians"] = [];
            for (let item of this.assistantPhysicians)
                data["assistantPhysicians"].push(item.toJSON());
        }
        data["securityAndInsurance"] = this.securityAndInsurance ? this.securityAndInsurance.toJSON() : <any>undefined;
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        data["invoiceAddress"] = this.invoiceAddress ? this.invoiceAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.headOfNursingServices)) {
            data["headOfNursingServices"] = [];
            for (let item of this.headOfNursingServices)
                data["headOfNursingServices"].push(item.toJSON());
        }
        if (Array.isArray(this.headOfNursingServicesRepresentative)) {
            data["headOfNursingServicesRepresentative"] = [];
            for (let item of this.headOfNursingServicesRepresentative)
                data["headOfNursingServicesRepresentative"].push(item.toJSON());
        }
        data["internalSupervision"] = this.internalSupervision ? this.internalSupervision.toJSON() : <any>undefined;
        data["externalPointForComplaints"] = this.externalPointForComplaints ? this.externalPointForComplaints.toJSON() : <any>undefined;
        data["vaccinationInPharmacy"] = this.vaccinationInPharmacy ? this.vaccinationInPharmacy.toJSON() : <any>undefined;
        data["parentSponsorship"] = this.parentSponsorship ? this.parentSponsorship.toJSON() : <any>undefined;
        return data;
    }
}

export interface IClaDto {
    application: ApplicationDto;
    sponsorshipTypeId: string | undefined;
    statusId: ClaStatus;
    firstStep: ClaStatus;
    authorization: ClaAuthorizationDto;
    sponsorship: ClaSponsorshipDto;
    claQualityRequirement: ClaQualityRequirementDto;
    claElectronicPatientRecord: ClaElectronicPatientRecordDto;
    sponsorshipDirectors: ClaSponsorshipDirectorDto[] | undefined;
    personAlas: ClaPersonAlasDto;
    medicalFieldDirector: ClaMedicalFieldDirectorDto;
    medicalFieldDirectorRepresentative: ClaMedicalFieldDirectorRepresentativeDto;
    medicalFieldResponsibleForStorageAndQuality: ClaMedicalFieldResponsibleForStorageAndQualityDto;
    medicalFieldResponsibleForHaemovigilance: ClaMedicalFieldResponsibleForHaemovigilanceDto;
    trainer: ClaTrainerDto;
    businesses: ClaBusinessDto[] | undefined;
    selectedBusinesses: ClaSelectedBusinessDto[] | undefined;
    medicalFieldPersons: ClaMedicalFieldPersonDto[] | undefined;
    medicalFieldPersonsAlas: ClaMedicalFieldPersonAlasDto[] | undefined;
    assistantPhysicians: ClaAssistantPhysicianDto[] | undefined;
    securityAndInsurance: ClaSecurityAndInsuranceDto;
    restrictions: ClaRestrictionDto[] | undefined;
    invoiceAddress: ClaInvoiceAddressDto;
    documents: GeneralDocumentGroupDto[] | undefined;
    headOfNursingServices: ClaHeadOfNursingServicesDto[] | undefined;
    headOfNursingServicesRepresentative: ClaHeadOfNursingServicesRepresentativeDto[] | undefined;
    internalSupervision: ClaInternalSupervisionDto;
    externalPointForComplaints: ClaExternalPointForComplaintsDto;
    vaccinationInPharmacy: ClaVaccinationInPharmacyDto;
    parentSponsorship: ClaSponsorshipDto;
}

export class ClaEmploymentAlasDto implements IClaEmploymentAlasDto {
    levelOfEmployment!: number;
    dateOfEmployment!: DateTime;
    dateOfEndOfEmployment!: DateTime;
    businessAlas!: ClaBusinessAlasDto;
    documents!: GeneralDocumentGroupDto[] | undefined;
    id!: number;

    constructor(data?: IClaEmploymentAlasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.businessAlas = _data["businessAlas"] ? ClaBusinessAlasDto.fromJS(_data["businessAlas"]) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClaEmploymentAlasDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaEmploymentAlasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessAlas"] = this.businessAlas ? this.businessAlas.toJSON() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IClaEmploymentAlasDto {
    levelOfEmployment: number;
    dateOfEmployment: DateTime;
    dateOfEndOfEmployment: DateTime;
    businessAlas: ClaBusinessAlasDto;
    documents: GeneralDocumentGroupDto[] | undefined;
    id: number;
}

export class ClaExternalPointForComplaintsDto implements IClaExternalPointForComplaintsDto {
    id!: number | undefined;
    hasExternalPointForComplaintsBeenDefinedId!: string | undefined;
    nameOfPointOfComplaints!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    comment!: string | undefined;

    constructor(data?: IClaExternalPointForComplaintsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hasExternalPointForComplaintsBeenDefinedId = _data["hasExternalPointForComplaintsBeenDefinedId"];
            this.nameOfPointOfComplaints = _data["nameOfPointOfComplaints"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ClaExternalPointForComplaintsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaExternalPointForComplaintsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hasExternalPointForComplaintsBeenDefinedId"] = this.hasExternalPointForComplaintsBeenDefinedId;
        data["nameOfPointOfComplaints"] = this.nameOfPointOfComplaints;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IClaExternalPointForComplaintsDto {
    id: number | undefined;
    hasExternalPointForComplaintsBeenDefinedId: string | undefined;
    nameOfPointOfComplaints: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    comment: string | undefined;
}

export class ClaFloorsDto implements IClaFloorsDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasTreatmentUnitsOnMoreThanOneFloorId!: string | undefined;
    hasBedElevatorId!: string | undefined;
    hasPersonElevatorId!: string | undefined;
    personElevatorSize!: string | undefined;

    constructor(data?: IClaFloorsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasTreatmentUnitsOnMoreThanOneFloorId = _data["hasTreatmentUnitsOnMoreThanOneFloorId"];
            this.hasBedElevatorId = _data["hasBedElevatorId"];
            this.hasPersonElevatorId = _data["hasPersonElevatorId"];
            this.personElevatorSize = _data["personElevatorSize"];
        }
    }

    static fromJS(data: any): ClaFloorsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaFloorsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasTreatmentUnitsOnMoreThanOneFloorId"] = this.hasTreatmentUnitsOnMoreThanOneFloorId;
        data["hasBedElevatorId"] = this.hasBedElevatorId;
        data["hasPersonElevatorId"] = this.hasPersonElevatorId;
        data["personElevatorSize"] = this.personElevatorSize;
        return data;
    }
}

export interface IClaFloorsDto {
    id: number | undefined;
    claBusinessId: number;
    hasTreatmentUnitsOnMoreThanOneFloorId: string | undefined;
    hasBedElevatorId: string | undefined;
    hasPersonElevatorId: string | undefined;
    personElevatorSize: string | undefined;
}

export class ClaHeadOfNursingServicesDto implements IClaHeadOfNursingServicesDto {
    id!: number | undefined;
    gln!: string | undefined;
    professionId!: string | undefined;
    titleId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    levelOfEmployment!: number | undefined;
    dateOfStart!: DateTime | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email1!: string | undefined;
    email2!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    hasConfirmedOkpBillingOverSponsorship!: boolean | undefined;

    constructor(data?: IClaHeadOfNursingServicesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.titleId = _data["titleId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfStart = _data["dateOfStart"] ? DateTime.fromISO(_data["dateOfStart"].toString()) : <any>undefined;
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email1 = _data["email1"];
            this.email2 = _data["email2"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.hasConfirmedOkpBillingOverSponsorship = _data["hasConfirmedOkpBillingOverSponsorship"];
        }
    }

    static fromJS(data: any): ClaHeadOfNursingServicesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaHeadOfNursingServicesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["titleId"] = this.titleId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfStart"] = this.dateOfStart ? this.dateOfStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email1"] = this.email1;
        data["email2"] = this.email2;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["hasConfirmedOkpBillingOverSponsorship"] = this.hasConfirmedOkpBillingOverSponsorship;
        return data;
    }
}

export interface IClaHeadOfNursingServicesDto {
    id: number | undefined;
    gln: string | undefined;
    professionId: string | undefined;
    titleId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    levelOfEmployment: number | undefined;
    dateOfStart: DateTime | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email1: string | undefined;
    email2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    hasConfirmedOkpBillingOverSponsorship: boolean | undefined;
}

export class ClaHeadOfNursingServicesRepresentativeDto implements IClaHeadOfNursingServicesRepresentativeDto {
    id!: number | undefined;
    gln!: string | undefined;
    professionId!: string | undefined;
    titleId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    levelOfEmployment!: number | undefined;
    dateOfStart!: DateTime | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email1!: string | undefined;
    email2!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    hasConfirmedOkpBillingOverSponsorship!: boolean | undefined;

    constructor(data?: IClaHeadOfNursingServicesRepresentativeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.titleId = _data["titleId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfStart = _data["dateOfStart"] ? DateTime.fromISO(_data["dateOfStart"].toString()) : <any>undefined;
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email1 = _data["email1"];
            this.email2 = _data["email2"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.hasConfirmedOkpBillingOverSponsorship = _data["hasConfirmedOkpBillingOverSponsorship"];
        }
    }

    static fromJS(data: any): ClaHeadOfNursingServicesRepresentativeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaHeadOfNursingServicesRepresentativeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["titleId"] = this.titleId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfStart"] = this.dateOfStart ? this.dateOfStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email1"] = this.email1;
        data["email2"] = this.email2;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["hasConfirmedOkpBillingOverSponsorship"] = this.hasConfirmedOkpBillingOverSponsorship;
        return data;
    }
}

export interface IClaHeadOfNursingServicesRepresentativeDto {
    id: number | undefined;
    gln: string | undefined;
    professionId: string | undefined;
    titleId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    levelOfEmployment: number | undefined;
    dateOfStart: DateTime | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email1: string | undefined;
    email2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    hasConfirmedOkpBillingOverSponsorship: boolean | undefined;
}

export class ClaHospitalPharmacyDetailsDto implements IClaHospitalPharmacyDetailsDto {
    hasFormulaHospitalisDrugProductionId!: string;
    hasDrugProductionThirdPartyId!: string;
    hasCytostaticDrugsProductionId!: string;
    hasQualitySystemId!: string;
    hasNoQualitySystemReason!: string | undefined;

    constructor(data?: IClaHospitalPharmacyDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasFormulaHospitalisDrugProductionId = _data["hasFormulaHospitalisDrugProductionId"];
            this.hasDrugProductionThirdPartyId = _data["hasDrugProductionThirdPartyId"];
            this.hasCytostaticDrugsProductionId = _data["hasCytostaticDrugsProductionId"];
            this.hasQualitySystemId = _data["hasQualitySystemId"];
            this.hasNoQualitySystemReason = _data["hasNoQualitySystemReason"];
        }
    }

    static fromJS(data: any): ClaHospitalPharmacyDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaHospitalPharmacyDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasFormulaHospitalisDrugProductionId"] = this.hasFormulaHospitalisDrugProductionId;
        data["hasDrugProductionThirdPartyId"] = this.hasDrugProductionThirdPartyId;
        data["hasCytostaticDrugsProductionId"] = this.hasCytostaticDrugsProductionId;
        data["hasQualitySystemId"] = this.hasQualitySystemId;
        data["hasNoQualitySystemReason"] = this.hasNoQualitySystemReason;
        return data;
    }
}

export interface IClaHospitalPharmacyDetailsDto {
    hasFormulaHospitalisDrugProductionId: string;
    hasDrugProductionThirdPartyId: string;
    hasCytostaticDrugsProductionId: string;
    hasQualitySystemId: string;
    hasNoQualitySystemReason: string | undefined;
}

export class ClaInfrastructureDto implements IClaInfrastructureDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasSufficientAndSuitableFacilitiesId!: string | undefined;
    plannedFacilitiesMeasures!: string | undefined;
    isEquipmentUpToDateAndInGoodConditionId!: string | undefined;
    plannedEquipmentMeasures!: string | undefined;

    constructor(data?: IClaInfrastructureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasSufficientAndSuitableFacilitiesId = _data["hasSufficientAndSuitableFacilitiesId"];
            this.plannedFacilitiesMeasures = _data["plannedFacilitiesMeasures"];
            this.isEquipmentUpToDateAndInGoodConditionId = _data["isEquipmentUpToDateAndInGoodConditionId"];
            this.plannedEquipmentMeasures = _data["plannedEquipmentMeasures"];
        }
    }

    static fromJS(data: any): ClaInfrastructureDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaInfrastructureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasSufficientAndSuitableFacilitiesId"] = this.hasSufficientAndSuitableFacilitiesId;
        data["plannedFacilitiesMeasures"] = this.plannedFacilitiesMeasures;
        data["isEquipmentUpToDateAndInGoodConditionId"] = this.isEquipmentUpToDateAndInGoodConditionId;
        data["plannedEquipmentMeasures"] = this.plannedEquipmentMeasures;
        return data;
    }
}

export interface IClaInfrastructureDto {
    id: number | undefined;
    claBusinessId: number;
    hasSufficientAndSuitableFacilitiesId: string | undefined;
    plannedFacilitiesMeasures: string | undefined;
    isEquipmentUpToDateAndInGoodConditionId: string | undefined;
    plannedEquipmentMeasures: string | undefined;
}

export class ClaInternalSupervisionDto implements IClaInternalSupervisionDto {
    id!: number | undefined;
    supervisor!: string | undefined;
    isIndependenceGuaranteedId!: string | undefined;

    constructor(data?: IClaInternalSupervisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supervisor = _data["supervisor"];
            this.isIndependenceGuaranteedId = _data["isIndependenceGuaranteedId"];
        }
    }

    static fromJS(data: any): ClaInternalSupervisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaInternalSupervisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supervisor"] = this.supervisor;
        data["isIndependenceGuaranteedId"] = this.isIndependenceGuaranteedId;
        return data;
    }
}

export interface IClaInternalSupervisionDto {
    id: number | undefined;
    supervisor: string | undefined;
    isIndependenceGuaranteedId: string | undefined;
}

export class ClaInvoiceAddressDto implements IClaInvoiceAddressDto {
    salutationId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    typeOfAddressId!: string | undefined;
    businessName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    additionalAddressLine!: string | undefined;
    claBusinessId!: number | undefined;
    completionStatus!: CompletionStatus;

    constructor(data?: IClaInvoiceAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salutationId = _data["salutationId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.typeOfAddressId = _data["typeOfAddressId"];
            this.businessName = _data["businessName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.additionalAddressLine = _data["additionalAddressLine"];
            this.claBusinessId = _data["claBusinessId"];
            this.completionStatus = _data["completionStatus"];
        }
    }

    static fromJS(data: any): ClaInvoiceAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaInvoiceAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salutationId"] = this.salutationId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["typeOfAddressId"] = this.typeOfAddressId;
        data["businessName"] = this.businessName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["additionalAddressLine"] = this.additionalAddressLine;
        data["claBusinessId"] = this.claBusinessId;
        data["completionStatus"] = this.completionStatus;
        return data;
    }
}

export interface IClaInvoiceAddressDto {
    salutationId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    typeOfAddressId: string | undefined;
    businessName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    additionalAddressLine: string | undefined;
    claBusinessId: number | undefined;
    completionStatus: CompletionStatus;
}

export class ClaLanguageSkillAlasDto implements IClaLanguageSkillAlasDto {
    languageSkillId!: string;
    comments!: string | undefined;

    constructor(data?: IClaLanguageSkillAlasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageSkillId = _data["languageSkillId"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): ClaLanguageSkillAlasDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaLanguageSkillAlasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageSkillId"] = this.languageSkillId;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IClaLanguageSkillAlasDto {
    languageSkillId: string;
    comments: string | undefined;
}

export class ClaMedicalFieldDirectorDto implements IClaMedicalFieldDirectorDto {
    id!: number | undefined;
    gln!: string | undefined;
    professionId!: string | undefined;
    titleId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    placeOfOrigin!: string | undefined;
    nationalityId!: string | undefined;
    levelOfEmployment!: number;
    dateOfStart!: DateTime | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    roleInBusiness!: string | undefined;
    doesCriminalRecordContainAConvictionId!: string | undefined;
    hasConfirmedOkpBillingOverSponsorship!: boolean | undefined;

    constructor(data?: IClaMedicalFieldDirectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.titleId = _data["titleId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.nationalityId = _data["nationalityId"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfStart = _data["dateOfStart"] ? DateTime.fromISO(_data["dateOfStart"].toString()) : <any>undefined;
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.roleInBusiness = _data["roleInBusiness"];
            this.doesCriminalRecordContainAConvictionId = _data["doesCriminalRecordContainAConvictionId"];
            this.hasConfirmedOkpBillingOverSponsorship = _data["hasConfirmedOkpBillingOverSponsorship"];
        }
    }

    static fromJS(data: any): ClaMedicalFieldDirectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaMedicalFieldDirectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["titleId"] = this.titleId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["nationalityId"] = this.nationalityId;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfStart"] = this.dateOfStart ? this.dateOfStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["roleInBusiness"] = this.roleInBusiness;
        data["doesCriminalRecordContainAConvictionId"] = this.doesCriminalRecordContainAConvictionId;
        data["hasConfirmedOkpBillingOverSponsorship"] = this.hasConfirmedOkpBillingOverSponsorship;
        return data;
    }
}

export interface IClaMedicalFieldDirectorDto {
    id: number | undefined;
    gln: string | undefined;
    professionId: string | undefined;
    titleId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    dateOfBirth: DateTime | undefined;
    placeOfOrigin: string | undefined;
    nationalityId: string | undefined;
    levelOfEmployment: number;
    dateOfStart: DateTime | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    roleInBusiness: string | undefined;
    doesCriminalRecordContainAConvictionId: string | undefined;
    hasConfirmedOkpBillingOverSponsorship: boolean | undefined;
}

export class ClaMedicalFieldDirectorRepresentativeDto implements IClaMedicalFieldDirectorRepresentativeDto {
    id!: number | undefined;
    gln!: string | undefined;
    professionId!: string | undefined;
    levelOfEmployment!: number;
    dateOfResponsibilityStart!: DateTime | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    hasConfirmedOkpBillingOverSponsorship!: boolean | undefined;

    constructor(data?: IClaMedicalFieldDirectorRepresentativeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfResponsibilityStart = _data["dateOfResponsibilityStart"] ? DateTime.fromISO(_data["dateOfResponsibilityStart"].toString()) : <any>undefined;
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.hasConfirmedOkpBillingOverSponsorship = _data["hasConfirmedOkpBillingOverSponsorship"];
        }
    }

    static fromJS(data: any): ClaMedicalFieldDirectorRepresentativeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaMedicalFieldDirectorRepresentativeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfResponsibilityStart"] = this.dateOfResponsibilityStart ? this.dateOfResponsibilityStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["hasConfirmedOkpBillingOverSponsorship"] = this.hasConfirmedOkpBillingOverSponsorship;
        return data;
    }
}

export interface IClaMedicalFieldDirectorRepresentativeDto {
    id: number | undefined;
    gln: string | undefined;
    professionId: string | undefined;
    levelOfEmployment: number;
    dateOfResponsibilityStart: DateTime | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    hasConfirmedOkpBillingOverSponsorship: boolean | undefined;
}

export class ClaMedicalFieldPersonAlasDto implements IClaMedicalFieldPersonAlasDto {
    id!: number | undefined;
    gln!: string | undefined;
    professionId!: string | undefined;
    levelOfEmployment!: number;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;

    constructor(data?: IClaMedicalFieldPersonAlasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ClaMedicalFieldPersonAlasDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaMedicalFieldPersonAlasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        return data;
    }
}

export interface IClaMedicalFieldPersonAlasDto {
    id: number | undefined;
    gln: string | undefined;
    professionId: string | undefined;
    levelOfEmployment: number;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
}

export class ClaMedicalFieldPersonDto implements IClaMedicalFieldPersonDto {
    id!: number | undefined;
    gln!: string | undefined;
    professionId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    roleText!: string | undefined;
    levelOfEmployment!: number;
    dateOfStart!: DateTime | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;

    constructor(data?: IClaMedicalFieldPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.roleText = _data["roleText"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfStart = _data["dateOfStart"] ? DateTime.fromISO(_data["dateOfStart"].toString()) : <any>undefined;
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ClaMedicalFieldPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaMedicalFieldPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["roleText"] = this.roleText;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfStart"] = this.dateOfStart ? this.dateOfStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        return data;
    }
}

export interface IClaMedicalFieldPersonDto {
    id: number | undefined;
    gln: string | undefined;
    professionId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    dateOfBirth: DateTime | undefined;
    roleText: string | undefined;
    levelOfEmployment: number;
    dateOfStart: DateTime | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
}

export class ClaNursingBedsDto implements IClaNursingBedsDto {
    id!: number | undefined;
    claBusinessId!: number;
    totalNumberOfBeds!: number;
    totalNumberOfEmergencyBeds!: number;
    privateRoomsWithShowerAndToiletAndWashbasin!: number;
    privateRoomsWithToiletAndWashbasin!: number;
    privateRoomsWithWashbasin!: number;
    twinRoomsWithShowerAndToiletAndWashbasin!: number;
    twinRoomsWithToiletAndWashbasin!: number;
    twinRoomsWithWashbasin!: number;
    threeBedRoomsWithShowerAndToiletAndWashbasin!: number;
    threeBedRoomsWithToiletAndWashbasin!: number;
    threeBedRoomsWithWashbasin!: number;
    fourBedRoomsWithShowerAndToiletAndWashbasin!: number;
    fourBedRoomsWithToiletAndWashbasin!: number;
    fourBedRoomsWithWashbasin!: number;

    constructor(data?: IClaNursingBedsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.totalNumberOfBeds = _data["totalNumberOfBeds"];
            this.totalNumberOfEmergencyBeds = _data["totalNumberOfEmergencyBeds"];
            this.privateRoomsWithShowerAndToiletAndWashbasin = _data["privateRoomsWithShowerAndToiletAndWashbasin"];
            this.privateRoomsWithToiletAndWashbasin = _data["privateRoomsWithToiletAndWashbasin"];
            this.privateRoomsWithWashbasin = _data["privateRoomsWithWashbasin"];
            this.twinRoomsWithShowerAndToiletAndWashbasin = _data["twinRoomsWithShowerAndToiletAndWashbasin"];
            this.twinRoomsWithToiletAndWashbasin = _data["twinRoomsWithToiletAndWashbasin"];
            this.twinRoomsWithWashbasin = _data["twinRoomsWithWashbasin"];
            this.threeBedRoomsWithShowerAndToiletAndWashbasin = _data["threeBedRoomsWithShowerAndToiletAndWashbasin"];
            this.threeBedRoomsWithToiletAndWashbasin = _data["threeBedRoomsWithToiletAndWashbasin"];
            this.threeBedRoomsWithWashbasin = _data["threeBedRoomsWithWashbasin"];
            this.fourBedRoomsWithShowerAndToiletAndWashbasin = _data["fourBedRoomsWithShowerAndToiletAndWashbasin"];
            this.fourBedRoomsWithToiletAndWashbasin = _data["fourBedRoomsWithToiletAndWashbasin"];
            this.fourBedRoomsWithWashbasin = _data["fourBedRoomsWithWashbasin"];
        }
    }

    static fromJS(data: any): ClaNursingBedsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaNursingBedsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["totalNumberOfBeds"] = this.totalNumberOfBeds;
        data["totalNumberOfEmergencyBeds"] = this.totalNumberOfEmergencyBeds;
        data["privateRoomsWithShowerAndToiletAndWashbasin"] = this.privateRoomsWithShowerAndToiletAndWashbasin;
        data["privateRoomsWithToiletAndWashbasin"] = this.privateRoomsWithToiletAndWashbasin;
        data["privateRoomsWithWashbasin"] = this.privateRoomsWithWashbasin;
        data["twinRoomsWithShowerAndToiletAndWashbasin"] = this.twinRoomsWithShowerAndToiletAndWashbasin;
        data["twinRoomsWithToiletAndWashbasin"] = this.twinRoomsWithToiletAndWashbasin;
        data["twinRoomsWithWashbasin"] = this.twinRoomsWithWashbasin;
        data["threeBedRoomsWithShowerAndToiletAndWashbasin"] = this.threeBedRoomsWithShowerAndToiletAndWashbasin;
        data["threeBedRoomsWithToiletAndWashbasin"] = this.threeBedRoomsWithToiletAndWashbasin;
        data["threeBedRoomsWithWashbasin"] = this.threeBedRoomsWithWashbasin;
        data["fourBedRoomsWithShowerAndToiletAndWashbasin"] = this.fourBedRoomsWithShowerAndToiletAndWashbasin;
        data["fourBedRoomsWithToiletAndWashbasin"] = this.fourBedRoomsWithToiletAndWashbasin;
        data["fourBedRoomsWithWashbasin"] = this.fourBedRoomsWithWashbasin;
        return data;
    }
}

export interface IClaNursingBedsDto {
    id: number | undefined;
    claBusinessId: number;
    totalNumberOfBeds: number;
    totalNumberOfEmergencyBeds: number;
    privateRoomsWithShowerAndToiletAndWashbasin: number;
    privateRoomsWithToiletAndWashbasin: number;
    privateRoomsWithWashbasin: number;
    twinRoomsWithShowerAndToiletAndWashbasin: number;
    twinRoomsWithToiletAndWashbasin: number;
    twinRoomsWithWashbasin: number;
    threeBedRoomsWithShowerAndToiletAndWashbasin: number;
    threeBedRoomsWithToiletAndWashbasin: number;
    threeBedRoomsWithWashbasin: number;
    fourBedRoomsWithShowerAndToiletAndWashbasin: number;
    fourBedRoomsWithToiletAndWashbasin: number;
    fourBedRoomsWithWashbasin: number;
}

export class ClaPersonAlasDto implements IClaPersonAlasDto {
    id!: number | undefined;
    gln!: string | undefined;
    professionId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    birthName!: string | undefined;
    genderId!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    nationality1Id!: string | undefined;
    nationality2Id!: string | undefined;
    placeOfOrigin!: string | undefined;
    ahv!: string | undefined;

    constructor(data?: IClaPersonAlasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.genderId = _data["genderId"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.nationality1Id = _data["nationality1Id"];
            this.nationality2Id = _data["nationality2Id"];
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.ahv = _data["ahv"];
        }
    }

    static fromJS(data: any): ClaPersonAlasDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaPersonAlasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["genderId"] = this.genderId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["nationality1Id"] = this.nationality1Id;
        data["nationality2Id"] = this.nationality2Id;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["ahv"] = this.ahv;
        return data;
    }
}

export interface IClaPersonAlasDto {
    id: number | undefined;
    gln: string | undefined;
    professionId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    birthName: string | undefined;
    genderId: string | undefined;
    dateOfBirth: DateTime | undefined;
    nationality1Id: string | undefined;
    nationality2Id: string | undefined;
    placeOfOrigin: string | undefined;
    ahv: string | undefined;
}

export class ClaPersonelDto implements IClaPersonelDto {
    id!: number | undefined;
    claBusinessId!: number;
    sponsorshipDirectorFullTimeEquivalent!: number | undefined;
    sponsorshipDirectorTotalNumberOfEmployees!: number | undefined;
    physicianDirectorFullTimeEquivalent!: number | undefined;
    physicianDirectorTotalNumberOfEmployees!: number | undefined;
    physicianFullTimeEquivalent!: number | undefined;
    physicianTotalNumberOfEmployees!: number | undefined;
    midwifeFullTimeEquivalent!: number | undefined;
    midwifeTotalNumberOfEmployees!: number | undefined;
    nursingCareWithDiplomaFullTimeEquivalent!: number | undefined;
    nursingCareWithDiplomaTotalNumberOfEmployees!: number | undefined;
    nursingCareFullTimeEquivalent!: number | undefined;
    nursingCareTotalNumberOfEmployees!: number | undefined;
    nursingCareAssistantFullTimeEquivalent!: number | undefined;
    nursingCareAssistantTotalNumberOfEmployees!: number | undefined;
    therapistFullTimeEquivalent!: number | undefined;
    therapistTotalNumberOfEmployees!: number | undefined;
    radiologyFullTimeEquivalent!: number | undefined;
    radiologyTotalNumberOfEmployees!: number | undefined;
    laboratoryFullTimeEquivalent!: number | undefined;
    laboratoryTotalNumberOfEmployees!: number | undefined;
    surgeryFullTimeEquivalent!: number | undefined;
    surgeryTotalNumberOfEmployees!: number | undefined;
    socialServicesFullTimeEquivalent!: number | undefined;
    socialServicesTotalNumberOfEmployees!: number | undefined;
    hotelAndGastronomyFullTimeEquivalent!: number | undefined;
    hotelAndGastronomyTotalNumberOfEmployees!: number | undefined;
    technicalServicesFullTimeEquivalent!: number | undefined;
    technicalServicesTotalNumberOfEmployees!: number | undefined;
    totalFullTimeEquivalent!: number | undefined;
    totalNumberOfEmployees!: number | undefined;

    constructor(data?: IClaPersonelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.sponsorshipDirectorFullTimeEquivalent = _data["sponsorshipDirectorFullTimeEquivalent"];
            this.sponsorshipDirectorTotalNumberOfEmployees = _data["sponsorshipDirectorTotalNumberOfEmployees"];
            this.physicianDirectorFullTimeEquivalent = _data["physicianDirectorFullTimeEquivalent"];
            this.physicianDirectorTotalNumberOfEmployees = _data["physicianDirectorTotalNumberOfEmployees"];
            this.physicianFullTimeEquivalent = _data["physicianFullTimeEquivalent"];
            this.physicianTotalNumberOfEmployees = _data["physicianTotalNumberOfEmployees"];
            this.midwifeFullTimeEquivalent = _data["midwifeFullTimeEquivalent"];
            this.midwifeTotalNumberOfEmployees = _data["midwifeTotalNumberOfEmployees"];
            this.nursingCareWithDiplomaFullTimeEquivalent = _data["nursingCareWithDiplomaFullTimeEquivalent"];
            this.nursingCareWithDiplomaTotalNumberOfEmployees = _data["nursingCareWithDiplomaTotalNumberOfEmployees"];
            this.nursingCareFullTimeEquivalent = _data["nursingCareFullTimeEquivalent"];
            this.nursingCareTotalNumberOfEmployees = _data["nursingCareTotalNumberOfEmployees"];
            this.nursingCareAssistantFullTimeEquivalent = _data["nursingCareAssistantFullTimeEquivalent"];
            this.nursingCareAssistantTotalNumberOfEmployees = _data["nursingCareAssistantTotalNumberOfEmployees"];
            this.therapistFullTimeEquivalent = _data["therapistFullTimeEquivalent"];
            this.therapistTotalNumberOfEmployees = _data["therapistTotalNumberOfEmployees"];
            this.radiologyFullTimeEquivalent = _data["radiologyFullTimeEquivalent"];
            this.radiologyTotalNumberOfEmployees = _data["radiologyTotalNumberOfEmployees"];
            this.laboratoryFullTimeEquivalent = _data["laboratoryFullTimeEquivalent"];
            this.laboratoryTotalNumberOfEmployees = _data["laboratoryTotalNumberOfEmployees"];
            this.surgeryFullTimeEquivalent = _data["surgeryFullTimeEquivalent"];
            this.surgeryTotalNumberOfEmployees = _data["surgeryTotalNumberOfEmployees"];
            this.socialServicesFullTimeEquivalent = _data["socialServicesFullTimeEquivalent"];
            this.socialServicesTotalNumberOfEmployees = _data["socialServicesTotalNumberOfEmployees"];
            this.hotelAndGastronomyFullTimeEquivalent = _data["hotelAndGastronomyFullTimeEquivalent"];
            this.hotelAndGastronomyTotalNumberOfEmployees = _data["hotelAndGastronomyTotalNumberOfEmployees"];
            this.technicalServicesFullTimeEquivalent = _data["technicalServicesFullTimeEquivalent"];
            this.technicalServicesTotalNumberOfEmployees = _data["technicalServicesTotalNumberOfEmployees"];
            this.totalFullTimeEquivalent = _data["totalFullTimeEquivalent"];
            this.totalNumberOfEmployees = _data["totalNumberOfEmployees"];
        }
    }

    static fromJS(data: any): ClaPersonelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaPersonelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["sponsorshipDirectorFullTimeEquivalent"] = this.sponsorshipDirectorFullTimeEquivalent;
        data["sponsorshipDirectorTotalNumberOfEmployees"] = this.sponsorshipDirectorTotalNumberOfEmployees;
        data["physicianDirectorFullTimeEquivalent"] = this.physicianDirectorFullTimeEquivalent;
        data["physicianDirectorTotalNumberOfEmployees"] = this.physicianDirectorTotalNumberOfEmployees;
        data["physicianFullTimeEquivalent"] = this.physicianFullTimeEquivalent;
        data["physicianTotalNumberOfEmployees"] = this.physicianTotalNumberOfEmployees;
        data["midwifeFullTimeEquivalent"] = this.midwifeFullTimeEquivalent;
        data["midwifeTotalNumberOfEmployees"] = this.midwifeTotalNumberOfEmployees;
        data["nursingCareWithDiplomaFullTimeEquivalent"] = this.nursingCareWithDiplomaFullTimeEquivalent;
        data["nursingCareWithDiplomaTotalNumberOfEmployees"] = this.nursingCareWithDiplomaTotalNumberOfEmployees;
        data["nursingCareFullTimeEquivalent"] = this.nursingCareFullTimeEquivalent;
        data["nursingCareTotalNumberOfEmployees"] = this.nursingCareTotalNumberOfEmployees;
        data["nursingCareAssistantFullTimeEquivalent"] = this.nursingCareAssistantFullTimeEquivalent;
        data["nursingCareAssistantTotalNumberOfEmployees"] = this.nursingCareAssistantTotalNumberOfEmployees;
        data["therapistFullTimeEquivalent"] = this.therapistFullTimeEquivalent;
        data["therapistTotalNumberOfEmployees"] = this.therapistTotalNumberOfEmployees;
        data["radiologyFullTimeEquivalent"] = this.radiologyFullTimeEquivalent;
        data["radiologyTotalNumberOfEmployees"] = this.radiologyTotalNumberOfEmployees;
        data["laboratoryFullTimeEquivalent"] = this.laboratoryFullTimeEquivalent;
        data["laboratoryTotalNumberOfEmployees"] = this.laboratoryTotalNumberOfEmployees;
        data["surgeryFullTimeEquivalent"] = this.surgeryFullTimeEquivalent;
        data["surgeryTotalNumberOfEmployees"] = this.surgeryTotalNumberOfEmployees;
        data["socialServicesFullTimeEquivalent"] = this.socialServicesFullTimeEquivalent;
        data["socialServicesTotalNumberOfEmployees"] = this.socialServicesTotalNumberOfEmployees;
        data["hotelAndGastronomyFullTimeEquivalent"] = this.hotelAndGastronomyFullTimeEquivalent;
        data["hotelAndGastronomyTotalNumberOfEmployees"] = this.hotelAndGastronomyTotalNumberOfEmployees;
        data["technicalServicesFullTimeEquivalent"] = this.technicalServicesFullTimeEquivalent;
        data["technicalServicesTotalNumberOfEmployees"] = this.technicalServicesTotalNumberOfEmployees;
        data["totalFullTimeEquivalent"] = this.totalFullTimeEquivalent;
        data["totalNumberOfEmployees"] = this.totalNumberOfEmployees;
        return data;
    }
}

export interface IClaPersonelDto {
    id: number | undefined;
    claBusinessId: number;
    sponsorshipDirectorFullTimeEquivalent: number | undefined;
    sponsorshipDirectorTotalNumberOfEmployees: number | undefined;
    physicianDirectorFullTimeEquivalent: number | undefined;
    physicianDirectorTotalNumberOfEmployees: number | undefined;
    physicianFullTimeEquivalent: number | undefined;
    physicianTotalNumberOfEmployees: number | undefined;
    midwifeFullTimeEquivalent: number | undefined;
    midwifeTotalNumberOfEmployees: number | undefined;
    nursingCareWithDiplomaFullTimeEquivalent: number | undefined;
    nursingCareWithDiplomaTotalNumberOfEmployees: number | undefined;
    nursingCareFullTimeEquivalent: number | undefined;
    nursingCareTotalNumberOfEmployees: number | undefined;
    nursingCareAssistantFullTimeEquivalent: number | undefined;
    nursingCareAssistantTotalNumberOfEmployees: number | undefined;
    therapistFullTimeEquivalent: number | undefined;
    therapistTotalNumberOfEmployees: number | undefined;
    radiologyFullTimeEquivalent: number | undefined;
    radiologyTotalNumberOfEmployees: number | undefined;
    laboratoryFullTimeEquivalent: number | undefined;
    laboratoryTotalNumberOfEmployees: number | undefined;
    surgeryFullTimeEquivalent: number | undefined;
    surgeryTotalNumberOfEmployees: number | undefined;
    socialServicesFullTimeEquivalent: number | undefined;
    socialServicesTotalNumberOfEmployees: number | undefined;
    hotelAndGastronomyFullTimeEquivalent: number | undefined;
    hotelAndGastronomyTotalNumberOfEmployees: number | undefined;
    technicalServicesFullTimeEquivalent: number | undefined;
    technicalServicesTotalNumberOfEmployees: number | undefined;
    totalFullTimeEquivalent: number | undefined;
    totalNumberOfEmployees: number | undefined;
}

export class ClaQualityDto implements IClaQualityDto {
    id!: number | undefined;
    claBusinessId!: number;
    isParticipantInQualityProgramId!: string | undefined;
    programName!: string | undefined;

    constructor(data?: IClaQualityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.isParticipantInQualityProgramId = _data["isParticipantInQualityProgramId"];
            this.programName = _data["programName"];
        }
    }

    static fromJS(data: any): ClaQualityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaQualityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["isParticipantInQualityProgramId"] = this.isParticipantInQualityProgramId;
        data["programName"] = this.programName;
        return data;
    }
}

export interface IClaQualityDto {
    id: number | undefined;
    claBusinessId: number;
    isParticipantInQualityProgramId: string | undefined;
    programName: string | undefined;
}

export class ClaRangeOfServicesDto implements IClaRangeOfServicesDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasXRayMachineId!: string | undefined;
    hasOperatingTheatresId!: string | undefined;
    numberOfLongTermPlaces!: number | undefined;
    numberOfAcuteAndTransitionalPlaces!: number | undefined;
    numberOfDayNightStructurePlaces!: number | undefined;

    constructor(data?: IClaRangeOfServicesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasXRayMachineId = _data["hasXRayMachineId"];
            this.hasOperatingTheatresId = _data["hasOperatingTheatresId"];
            this.numberOfLongTermPlaces = _data["numberOfLongTermPlaces"];
            this.numberOfAcuteAndTransitionalPlaces = _data["numberOfAcuteAndTransitionalPlaces"];
            this.numberOfDayNightStructurePlaces = _data["numberOfDayNightStructurePlaces"];
        }
    }

    static fromJS(data: any): ClaRangeOfServicesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaRangeOfServicesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasXRayMachineId"] = this.hasXRayMachineId;
        data["hasOperatingTheatresId"] = this.hasOperatingTheatresId;
        data["numberOfLongTermPlaces"] = this.numberOfLongTermPlaces;
        data["numberOfAcuteAndTransitionalPlaces"] = this.numberOfAcuteAndTransitionalPlaces;
        data["numberOfDayNightStructurePlaces"] = this.numberOfDayNightStructurePlaces;
        return data;
    }
}

export interface IClaRangeOfServicesDto {
    id: number | undefined;
    claBusinessId: number;
    hasXRayMachineId: string | undefined;
    hasOperatingTheatresId: string | undefined;
    numberOfLongTermPlaces: number | undefined;
    numberOfAcuteAndTransitionalPlaces: number | undefined;
    numberOfDayNightStructurePlaces: number | undefined;
}

export class ClaRestrictionAlasDto implements IClaRestrictionAlasDto {
    cantonId!: string;
    reason!: string | undefined;
    type!: AlaRestrictionType;

    constructor(data?: IClaRestrictionAlasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantonId = _data["cantonId"];
            this.reason = _data["reason"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ClaRestrictionAlasDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaRestrictionAlasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantonId"] = this.cantonId;
        data["reason"] = this.reason;
        data["type"] = this.type;
        return data;
    }
}

export interface IClaRestrictionAlasDto {
    cantonId: string;
    reason: string | undefined;
    type: AlaRestrictionType;
}

export class ClaRestrictionAlasOutput implements IClaRestrictionAlasOutput {
    restrictionGeneralInformation!: ClaRestrictionGeneralInformationAlasDto;
    restrictions!: ClaRestrictionAlasDto[] | undefined;
    assistantGln!: string | undefined;
    assistantProfessionId!: string | undefined;

    constructor(data?: IClaRestrictionAlasOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.restrictionGeneralInformation = _data["restrictionGeneralInformation"] ? ClaRestrictionGeneralInformationAlasDto.fromJS(_data["restrictionGeneralInformation"]) : <any>undefined;
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(ClaRestrictionAlasDto.fromJS(item));
            }
            this.assistantGln = _data["assistantGln"];
            this.assistantProfessionId = _data["assistantProfessionId"];
        }
    }

    static fromJS(data: any): ClaRestrictionAlasOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ClaRestrictionAlasOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["restrictionGeneralInformation"] = this.restrictionGeneralInformation ? this.restrictionGeneralInformation.toJSON() : <any>undefined;
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        data["assistantGln"] = this.assistantGln;
        data["assistantProfessionId"] = this.assistantProfessionId;
        return data;
    }
}

export interface IClaRestrictionAlasOutput {
    restrictionGeneralInformation: ClaRestrictionGeneralInformationAlasDto;
    restrictions: ClaRestrictionAlasDto[] | undefined;
    assistantGln: string | undefined;
    assistantProfessionId: string | undefined;
}

export class ClaRestrictionDto implements IClaRestrictionDto {
    restrictionType!: ClaRestrictionType;
    cantonId!: string;
    reason!: string | undefined;

    constructor(data?: IClaRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.restrictionType = _data["restrictionType"];
            this.cantonId = _data["cantonId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): ClaRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["restrictionType"] = this.restrictionType;
        data["cantonId"] = this.cantonId;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IClaRestrictionDto {
    restrictionType: ClaRestrictionType;
    cantonId: string;
    reason: string | undefined;
}

export class ClaRestrictionGeneralInformationAlasDto implements IClaRestrictionGeneralInformationAlasDto {
    hasRestrictionsId!: string | undefined;
    hasOngoingRestrictionProcedureId!: string | undefined;
    hasOngoingLiaRequestInAnotherCantonId!: string | undefined;
    hasAnyImpairmentRelatedToPracticeId!: string | undefined;
    hasJudgementInSwissCriminalRecordId!: string | undefined;

    constructor(data?: IClaRestrictionGeneralInformationAlasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasRestrictionsId = _data["hasRestrictionsId"];
            this.hasOngoingRestrictionProcedureId = _data["hasOngoingRestrictionProcedureId"];
            this.hasOngoingLiaRequestInAnotherCantonId = _data["hasOngoingLiaRequestInAnotherCantonId"];
            this.hasAnyImpairmentRelatedToPracticeId = _data["hasAnyImpairmentRelatedToPracticeId"];
            this.hasJudgementInSwissCriminalRecordId = _data["hasJudgementInSwissCriminalRecordId"];
        }
    }

    static fromJS(data: any): ClaRestrictionGeneralInformationAlasDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaRestrictionGeneralInformationAlasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasRestrictionsId"] = this.hasRestrictionsId;
        data["hasOngoingRestrictionProcedureId"] = this.hasOngoingRestrictionProcedureId;
        data["hasOngoingLiaRequestInAnotherCantonId"] = this.hasOngoingLiaRequestInAnotherCantonId;
        data["hasAnyImpairmentRelatedToPracticeId"] = this.hasAnyImpairmentRelatedToPracticeId;
        data["hasJudgementInSwissCriminalRecordId"] = this.hasJudgementInSwissCriminalRecordId;
        return data;
    }
}

export interface IClaRestrictionGeneralInformationAlasDto {
    hasRestrictionsId: string | undefined;
    hasOngoingRestrictionProcedureId: string | undefined;
    hasOngoingLiaRequestInAnotherCantonId: string | undefined;
    hasAnyImpairmentRelatedToPracticeId: string | undefined;
    hasJudgementInSwissCriminalRecordId: string | undefined;
}

export enum ClaRestrictionType {
    RevocationOrProhibition = 0,
    PendingLegalProceedings = 1,
}

export class ClaSanitaryFacilitiesDto implements IClaSanitaryFacilitiesDto {
    id!: number | undefined;
    claBusinessId!: number;
    totalNumberOfToilets!: number;
    numberOfToiletsForDisabled!: number;
    totalNumberOfShowers!: number;
    numberOfShowersForDisabled!: number;
    totalNumberOfTreatmentBaths!: number;
    numberOfTreatmentBathsForDisabled!: number;
    hasSinkRoomOnEveryFloorId!: string | undefined;

    constructor(data?: IClaSanitaryFacilitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.totalNumberOfToilets = _data["totalNumberOfToilets"];
            this.numberOfToiletsForDisabled = _data["numberOfToiletsForDisabled"];
            this.totalNumberOfShowers = _data["totalNumberOfShowers"];
            this.numberOfShowersForDisabled = _data["numberOfShowersForDisabled"];
            this.totalNumberOfTreatmentBaths = _data["totalNumberOfTreatmentBaths"];
            this.numberOfTreatmentBathsForDisabled = _data["numberOfTreatmentBathsForDisabled"];
            this.hasSinkRoomOnEveryFloorId = _data["hasSinkRoomOnEveryFloorId"];
        }
    }

    static fromJS(data: any): ClaSanitaryFacilitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaSanitaryFacilitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["totalNumberOfToilets"] = this.totalNumberOfToilets;
        data["numberOfToiletsForDisabled"] = this.numberOfToiletsForDisabled;
        data["totalNumberOfShowers"] = this.totalNumberOfShowers;
        data["numberOfShowersForDisabled"] = this.numberOfShowersForDisabled;
        data["totalNumberOfTreatmentBaths"] = this.totalNumberOfTreatmentBaths;
        data["numberOfTreatmentBathsForDisabled"] = this.numberOfTreatmentBathsForDisabled;
        data["hasSinkRoomOnEveryFloorId"] = this.hasSinkRoomOnEveryFloorId;
        return data;
    }
}

export interface IClaSanitaryFacilitiesDto {
    id: number | undefined;
    claBusinessId: number;
    totalNumberOfToilets: number;
    numberOfToiletsForDisabled: number;
    totalNumberOfShowers: number;
    numberOfShowersForDisabled: number;
    totalNumberOfTreatmentBaths: number;
    numberOfTreatmentBathsForDisabled: number;
    hasSinkRoomOnEveryFloorId: string | undefined;
}

export class ClaSecurityAndInsuranceDto implements IClaSecurityAndInsuranceDto {
    hasHygieneConceptId!: string | undefined;
    hygieneConceptReason!: string | undefined;
    hasDataProtectionConceptId!: string | undefined;
    dataProtectionConceptReason!: string | undefined;
    hasQualityAssuranceSystemId!: string | undefined;
    qualityAssuranceSystemReason!: string | undefined;
    hasLiabilityInsuranceId!: string | undefined;
    liabilityInsuranceReason!: string | undefined;
    hasSufficientAndSuitableFacilitiesId!: string | undefined;
    sufficientAndSuitableFacilitiesReason!: string | undefined;
    isEquipmentUpToDateAndInGoodConditionId!: string | undefined;
    equipmentUpToDateAndInGoodConditionReason!: string | undefined;
    hasCorporateLicenceInAnotherCantonId!: string | undefined;
    hasResponsiblePersonValidOKPLicence!: boolean | undefined;
    hasFacilitiesAdequateForPharmaceuticalActivities!: boolean | undefined;
    hasHandlingOfNarcotics!: boolean | undefined;
    hasNotificationOfSignificantStructuralChanges!: boolean | undefined;

    constructor(data?: IClaSecurityAndInsuranceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasHygieneConceptId = _data["hasHygieneConceptId"];
            this.hygieneConceptReason = _data["hygieneConceptReason"];
            this.hasDataProtectionConceptId = _data["hasDataProtectionConceptId"];
            this.dataProtectionConceptReason = _data["dataProtectionConceptReason"];
            this.hasQualityAssuranceSystemId = _data["hasQualityAssuranceSystemId"];
            this.qualityAssuranceSystemReason = _data["qualityAssuranceSystemReason"];
            this.hasLiabilityInsuranceId = _data["hasLiabilityInsuranceId"];
            this.liabilityInsuranceReason = _data["liabilityInsuranceReason"];
            this.hasSufficientAndSuitableFacilitiesId = _data["hasSufficientAndSuitableFacilitiesId"];
            this.sufficientAndSuitableFacilitiesReason = _data["sufficientAndSuitableFacilitiesReason"];
            this.isEquipmentUpToDateAndInGoodConditionId = _data["isEquipmentUpToDateAndInGoodConditionId"];
            this.equipmentUpToDateAndInGoodConditionReason = _data["equipmentUpToDateAndInGoodConditionReason"];
            this.hasCorporateLicenceInAnotherCantonId = _data["hasCorporateLicenceInAnotherCantonId"];
            this.hasResponsiblePersonValidOKPLicence = _data["hasResponsiblePersonValidOKPLicence"];
            this.hasFacilitiesAdequateForPharmaceuticalActivities = _data["hasFacilitiesAdequateForPharmaceuticalActivities"];
            this.hasHandlingOfNarcotics = _data["hasHandlingOfNarcotics"];
            this.hasNotificationOfSignificantStructuralChanges = _data["hasNotificationOfSignificantStructuralChanges"];
        }
    }

    static fromJS(data: any): ClaSecurityAndInsuranceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaSecurityAndInsuranceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasHygieneConceptId"] = this.hasHygieneConceptId;
        data["hygieneConceptReason"] = this.hygieneConceptReason;
        data["hasDataProtectionConceptId"] = this.hasDataProtectionConceptId;
        data["dataProtectionConceptReason"] = this.dataProtectionConceptReason;
        data["hasQualityAssuranceSystemId"] = this.hasQualityAssuranceSystemId;
        data["qualityAssuranceSystemReason"] = this.qualityAssuranceSystemReason;
        data["hasLiabilityInsuranceId"] = this.hasLiabilityInsuranceId;
        data["liabilityInsuranceReason"] = this.liabilityInsuranceReason;
        data["hasSufficientAndSuitableFacilitiesId"] = this.hasSufficientAndSuitableFacilitiesId;
        data["sufficientAndSuitableFacilitiesReason"] = this.sufficientAndSuitableFacilitiesReason;
        data["isEquipmentUpToDateAndInGoodConditionId"] = this.isEquipmentUpToDateAndInGoodConditionId;
        data["equipmentUpToDateAndInGoodConditionReason"] = this.equipmentUpToDateAndInGoodConditionReason;
        data["hasCorporateLicenceInAnotherCantonId"] = this.hasCorporateLicenceInAnotherCantonId;
        data["hasResponsiblePersonValidOKPLicence"] = this.hasResponsiblePersonValidOKPLicence;
        data["hasFacilitiesAdequateForPharmaceuticalActivities"] = this.hasFacilitiesAdequateForPharmaceuticalActivities;
        data["hasHandlingOfNarcotics"] = this.hasHandlingOfNarcotics;
        data["hasNotificationOfSignificantStructuralChanges"] = this.hasNotificationOfSignificantStructuralChanges;
        return data;
    }
}

export interface IClaSecurityAndInsuranceDto {
    hasHygieneConceptId: string | undefined;
    hygieneConceptReason: string | undefined;
    hasDataProtectionConceptId: string | undefined;
    dataProtectionConceptReason: string | undefined;
    hasQualityAssuranceSystemId: string | undefined;
    qualityAssuranceSystemReason: string | undefined;
    hasLiabilityInsuranceId: string | undefined;
    liabilityInsuranceReason: string | undefined;
    hasSufficientAndSuitableFacilitiesId: string | undefined;
    sufficientAndSuitableFacilitiesReason: string | undefined;
    isEquipmentUpToDateAndInGoodConditionId: string | undefined;
    equipmentUpToDateAndInGoodConditionReason: string | undefined;
    hasCorporateLicenceInAnotherCantonId: string | undefined;
    hasResponsiblePersonValidOKPLicence: boolean | undefined;
    hasFacilitiesAdequateForPharmaceuticalActivities: boolean | undefined;
    hasHandlingOfNarcotics: boolean | undefined;
    hasNotificationOfSignificantStructuralChanges: boolean | undefined;
}

export class ClaSecurityDto implements IClaSecurityDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasFireAlarmId!: string | undefined;
    hasPatientCallSystemId!: string | undefined;
    hasPowerBackupSystemId!: string | undefined;
    hasClearEmergencyEntranceId!: string | undefined;

    constructor(data?: IClaSecurityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasFireAlarmId = _data["hasFireAlarmId"];
            this.hasPatientCallSystemId = _data["hasPatientCallSystemId"];
            this.hasPowerBackupSystemId = _data["hasPowerBackupSystemId"];
            this.hasClearEmergencyEntranceId = _data["hasClearEmergencyEntranceId"];
        }
    }

    static fromJS(data: any): ClaSecurityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaSecurityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasFireAlarmId"] = this.hasFireAlarmId;
        data["hasPatientCallSystemId"] = this.hasPatientCallSystemId;
        data["hasPowerBackupSystemId"] = this.hasPowerBackupSystemId;
        data["hasClearEmergencyEntranceId"] = this.hasClearEmergencyEntranceId;
        return data;
    }
}

export interface IClaSecurityDto {
    id: number | undefined;
    claBusinessId: number;
    hasFireAlarmId: string | undefined;
    hasPatientCallSystemId: string | undefined;
    hasPowerBackupSystemId: string | undefined;
    hasClearEmergencyEntranceId: string | undefined;
}

export class ClaSelectableCorporateLicenceBusinessDto implements IClaSelectableCorporateLicenceBusinessDto {
    name!: string | undefined;
    additionalName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    cantonId!: string | undefined;
    id!: number;

    constructor(data?: IClaSelectableCorporateLicenceBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.cantonId = _data["cantonId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClaSelectableCorporateLicenceBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaSelectableCorporateLicenceBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["cantonId"] = this.cantonId;
        data["id"] = this.id;
        return data;
    }
}

export interface IClaSelectableCorporateLicenceBusinessDto {
    name: string | undefined;
    additionalName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    cantonId: string | undefined;
    id: number;
}

export class ClaSelectableCorporateLicenceDto implements IClaSelectableCorporateLicenceDto {
    sponsorshipTypeId!: string | undefined;
    businesses!: ClaSelectableCorporateLicenceBusinessDto[] | undefined;
    id!: number;

    constructor(data?: IClaSelectableCorporateLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaSelectableCorporateLicenceBusinessDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClaSelectableCorporateLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaSelectableCorporateLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IClaSelectableCorporateLicenceDto {
    sponsorshipTypeId: string | undefined;
    businesses: ClaSelectableCorporateLicenceBusinessDto[] | undefined;
    id: number;
}

export class ClaSelectedBusinessDto implements IClaSelectedBusinessDto {
    id!: number;
    name!: string | undefined;
    additionalName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    website!: string | undefined;
    gln!: string | undefined;
    bur!: string | undefined;
    dateOfOpening!: DateTime | undefined;
    businessHours!: string | undefined;
    isSelected!: boolean;
    isFromLinkedApp!: boolean;

    constructor(data?: IClaSelectedBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.gln = _data["gln"];
            this.bur = _data["bur"];
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.businessHours = _data["businessHours"];
            this.isSelected = _data["isSelected"];
            this.isFromLinkedApp = _data["isFromLinkedApp"];
        }
    }

    static fromJS(data: any): ClaSelectedBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaSelectedBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["website"] = this.website;
        data["gln"] = this.gln;
        data["bur"] = this.bur;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessHours"] = this.businessHours;
        data["isSelected"] = this.isSelected;
        data["isFromLinkedApp"] = this.isFromLinkedApp;
        return data;
    }
}

export interface IClaSelectedBusinessDto {
    id: number;
    name: string | undefined;
    additionalName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    website: string | undefined;
    gln: string | undefined;
    bur: string | undefined;
    dateOfOpening: DateTime | undefined;
    businessHours: string | undefined;
    isSelected: boolean;
    isFromLinkedApp: boolean;
}

export class ClaServiceAreasDto implements IClaServiceAreasDto {
    id!: number | undefined;
    claBusinessId!: number;
    typeId!: string | undefined;

    constructor(data?: IClaServiceAreasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.typeId = _data["typeId"];
        }
    }

    static fromJS(data: any): ClaServiceAreasDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaServiceAreasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["typeId"] = this.typeId;
        return data;
    }
}

export interface IClaServiceAreasDto {
    id: number | undefined;
    claBusinessId: number;
    typeId: string | undefined;
}

export class ClaSponsorshipDirectorDto implements IClaSponsorshipDirectorDto {
    id!: number | undefined;
    gln!: string | undefined;
    professionId!: string | undefined;
    titleId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    levelOfEmployment!: number | undefined;
    dateOfStart!: DateTime | undefined;
    doesCriminalRecordContainAConvictionId!: string | undefined;
    physicalPresentId!: string | undefined;
    jobSpecificPrincipleId!: string | undefined;

    constructor(data?: IClaSponsorshipDirectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.titleId = _data["titleId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfStart = _data["dateOfStart"] ? DateTime.fromISO(_data["dateOfStart"].toString()) : <any>undefined;
            this.doesCriminalRecordContainAConvictionId = _data["doesCriminalRecordContainAConvictionId"];
            this.physicalPresentId = _data["physicalPresentId"];
            this.jobSpecificPrincipleId = _data["jobSpecificPrincipleId"];
        }
    }

    static fromJS(data: any): ClaSponsorshipDirectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaSponsorshipDirectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["titleId"] = this.titleId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfStart"] = this.dateOfStart ? this.dateOfStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["doesCriminalRecordContainAConvictionId"] = this.doesCriminalRecordContainAConvictionId;
        data["physicalPresentId"] = this.physicalPresentId;
        data["jobSpecificPrincipleId"] = this.jobSpecificPrincipleId;
        return data;
    }
}

export interface IClaSponsorshipDirectorDto {
    id: number | undefined;
    gln: string | undefined;
    professionId: string | undefined;
    titleId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    dateOfBirth: DateTime | undefined;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    levelOfEmployment: number | undefined;
    dateOfStart: DateTime | undefined;
    doesCriminalRecordContainAConvictionId: string | undefined;
    physicalPresentId: string | undefined;
    jobSpecificPrincipleId: string | undefined;
}

export class ClaSponsorshipDto implements IClaSponsorshipDto {
    uid!: string | undefined;
    name!: string;
    additionalName!: string | undefined;
    legalFormId!: string;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    phone1!: string;
    phone2!: string | undefined;
    email!: string;
    website!: string | undefined;
    hasLicenceInAnotherCantonId!: string | undefined;
    hasOngoingClaRequestInAnotherCantonId!: string | undefined;
    ongoingClaRequestCantonId!: string | undefined;
    firstNameOfPresident!: string | undefined;
    lastNameOfPresident!: string | undefined;
    emailOfPresident!: string | undefined;
    reason!: string | undefined;
    corporateLicenceId!: number | undefined;
    hasConfirmedData!: boolean | undefined;
    completionStatus!: CompletionStatus;

    constructor(data?: IClaSponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.hasLicenceInAnotherCantonId = _data["hasLicenceInAnotherCantonId"];
            this.hasOngoingClaRequestInAnotherCantonId = _data["hasOngoingClaRequestInAnotherCantonId"];
            this.ongoingClaRequestCantonId = _data["ongoingClaRequestCantonId"];
            this.firstNameOfPresident = _data["firstNameOfPresident"];
            this.lastNameOfPresident = _data["lastNameOfPresident"];
            this.emailOfPresident = _data["emailOfPresident"];
            this.reason = _data["reason"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.hasConfirmedData = _data["hasConfirmedData"];
            this.completionStatus = _data["completionStatus"];
        }
    }

    static fromJS(data: any): ClaSponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaSponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["website"] = this.website;
        data["hasLicenceInAnotherCantonId"] = this.hasLicenceInAnotherCantonId;
        data["hasOngoingClaRequestInAnotherCantonId"] = this.hasOngoingClaRequestInAnotherCantonId;
        data["ongoingClaRequestCantonId"] = this.ongoingClaRequestCantonId;
        data["firstNameOfPresident"] = this.firstNameOfPresident;
        data["lastNameOfPresident"] = this.lastNameOfPresident;
        data["emailOfPresident"] = this.emailOfPresident;
        data["reason"] = this.reason;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["hasConfirmedData"] = this.hasConfirmedData;
        data["completionStatus"] = this.completionStatus;
        return data;
    }
}

export interface IClaSponsorshipDto {
    uid: string | undefined;
    name: string;
    additionalName: string | undefined;
    legalFormId: string;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    phone1: string;
    phone2: string | undefined;
    email: string;
    website: string | undefined;
    hasLicenceInAnotherCantonId: string | undefined;
    hasOngoingClaRequestInAnotherCantonId: string | undefined;
    ongoingClaRequestCantonId: string | undefined;
    firstNameOfPresident: string | undefined;
    lastNameOfPresident: string | undefined;
    emailOfPresident: string | undefined;
    reason: string | undefined;
    corporateLicenceId: number | undefined;
    hasConfirmedData: boolean | undefined;
    completionStatus: CompletionStatus;
}

export enum ClaStatus {
    Sponsorship = 0,
    Business = 1,
    SponsorshipDirectors = 2,
    MedicalFieldDirector = 3,
    BusinessDirectors = 4,
    InvoiceAddress = 5,
    AssistantPhysicians = 6,
    MedicalFieldPerson = 7,
    Infrastructure = 9,
    Personel = 10,
    RangeOfServices = 11,
    MedicalFieldDirectorRepresentative = 14,
    ServiceArea = 15,
    Treatment = 16,
    NursingBeds = 17,
    Floors = 18,
    WheelchairAccessibility = 19,
    SanitaryFacilities = 20,
    DrugChambers = 21,
    Security = 22,
    AidingResources = 23,
    Quality = 25,
    RangeOfProducts = 26,
    ProductPreparation = 27,
    LocalDrugSales = 28,
    DrugProduction = 29,
    DrugProductionThirdParty = 30,
    OnlineDrugSales = 31,
    MedicalFieldResponsibleForHaemovigilance = 32,
    MedicalFieldResponsibleForStorageAndQuality = 33,
    SponsorshipDeputyDirectors = 34,
    QualityRequirement = 35,
    ElectronicPatientRecord = 36,
    Authorization = 37,
    MedicalFieldPersonAlas = 38,
    BusinessSelect = 39,
    Trainer = 40,
    PersonAlas = 41,
    ContactAlas = 42,
    AcademicTitleAlas = 43,
    LanguageSkillAlas = 44,
    RestrictionAlas = 45,
    EmploymentAlas = 46,
    DiplomaAlas = 47,
    SecurityAndInsurance = 49,
    Restriction = 50,
    MedicalFieldPersonEhc = 51,
    BusinessAlas = 52,
    MedicalFieldPersonLongTermCare = 53,
    CurrentAssistantsAlas = 54,
    HeadOfNursingServices = 55,
    InternalSupervision = 56,
    ExternalPointForComplaints = 57,
    HospitalPharmacyDetails = 58,
    VaccinationInPharmacy = 59,
    HeadOfNursingServicesRepresentative = 60,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export class ClaTreatmentDto implements IClaTreatmentDto {
    id!: number | undefined;
    claBusinessId!: number;
    treatmentTypeId!: EnumTreatmentType;
    amount!: string;
    services!: string;

    constructor(data?: IClaTreatmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.treatmentTypeId = _data["treatmentTypeId"];
            this.amount = _data["amount"];
            this.services = _data["services"];
        }
    }

    static fromJS(data: any): ClaTreatmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaTreatmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["treatmentTypeId"] = this.treatmentTypeId;
        data["amount"] = this.amount;
        data["services"] = this.services;
        return data;
    }
}

export interface IClaTreatmentDto {
    id: number | undefined;
    claBusinessId: number;
    treatmentTypeId: EnumTreatmentType;
    amount: string;
    services: string;
}

export class ClaWheelchairAccessibilityDto implements IClaWheelchairAccessibilityDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasWheelchairAccessibleBuildingEntrancesId!: string | undefined;
    hasWheelchairAccessiblePatientAreaId!: string | undefined;

    constructor(data?: IClaWheelchairAccessibilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasWheelchairAccessibleBuildingEntrancesId = _data["hasWheelchairAccessibleBuildingEntrancesId"];
            this.hasWheelchairAccessiblePatientAreaId = _data["hasWheelchairAccessiblePatientAreaId"];
        }
    }

    static fromJS(data: any): ClaWheelchairAccessibilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaWheelchairAccessibilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasWheelchairAccessibleBuildingEntrancesId"] = this.hasWheelchairAccessibleBuildingEntrancesId;
        data["hasWheelchairAccessiblePatientAreaId"] = this.hasWheelchairAccessiblePatientAreaId;
        return data;
    }
}

export interface IClaWheelchairAccessibilityDto {
    id: number | undefined;
    claBusinessId: number;
    hasWheelchairAccessibleBuildingEntrancesId: string | undefined;
    hasWheelchairAccessiblePatientAreaId: string | undefined;
}

export enum CorporateLicenceType {
    CorporateLicence = 0,
    LocalSalesLicence = 1,
    OnlineSalesLicence = 2,
    ExpenseHealthCareLicence = 3,
    AssistantLicence = 4,
    DelegatedLicence = 5,
    BloodstorageLicence = 6,
    NarcoticLicence = 7,
    OtherLicence = 8,
    ManufacturingLicence = 9,
    NursingInitiativeTrainingObligation = 10,
}

export class CreateClaInput implements ICreateClaInput {
    applicationTypeId!: ApplicationType;
    sponsorshipTypeId!: string;
    legitimationId!: number | undefined;
    uid!: string | undefined;
    renewedLicenceId!: number | undefined;

    constructor(data?: ICreateClaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationTypeId = _data["applicationTypeId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.legitimationId = _data["legitimationId"];
            this.uid = _data["uid"];
            this.renewedLicenceId = _data["renewedLicenceId"];
        }
    }

    static fromJS(data: any): CreateClaInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationTypeId"] = this.applicationTypeId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["legitimationId"] = this.legitimationId;
        data["uid"] = this.uid;
        data["renewedLicenceId"] = this.renewedLicenceId;
        return data;
    }
}

export interface ICreateClaInput {
    applicationTypeId: ApplicationType;
    sponsorshipTypeId: string;
    legitimationId: number | undefined;
    uid: string | undefined;
    renewedLicenceId: number | undefined;
}

export class CreateClaOutput implements ICreateClaOutput {
    caseId!: string | undefined;

    constructor(data?: ICreateClaOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): CreateClaOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClaOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface ICreateClaOutput {
    caseId: string | undefined;
}

export class CreateOrUpdateClaAcademicTitleAlasInput implements ICreateOrUpdateClaAcademicTitleAlasInput {
    caseId!: string;
    academicTitles!: ClaAcademicTitleAlasDto[];

    constructor(data?: ICreateOrUpdateClaAcademicTitleAlasInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.academicTitles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["academicTitles"])) {
                this.academicTitles = [] as any;
                for (let item of _data["academicTitles"])
                    this.academicTitles!.push(ClaAcademicTitleAlasDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateClaAcademicTitleAlasInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaAcademicTitleAlasInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.academicTitles)) {
            data["academicTitles"] = [];
            for (let item of this.academicTitles)
                data["academicTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateClaAcademicTitleAlasInput {
    caseId: string;
    academicTitles: ClaAcademicTitleAlasDto[];
}

export class CreateOrUpdateClaAcademicTitleAlasOutput implements ICreateOrUpdateClaAcademicTitleAlasOutput {
    status!: ClaStatus;
    academicTitles!: ClaAcademicTitleAlasDto[] | undefined;

    constructor(data?: ICreateOrUpdateClaAcademicTitleAlasOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["academicTitles"])) {
                this.academicTitles = [] as any;
                for (let item of _data["academicTitles"])
                    this.academicTitles!.push(ClaAcademicTitleAlasDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateClaAcademicTitleAlasOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaAcademicTitleAlasOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.academicTitles)) {
            data["academicTitles"] = [];
            for (let item of this.academicTitles)
                data["academicTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateClaAcademicTitleAlasOutput {
    status: ClaStatus;
    academicTitles: ClaAcademicTitleAlasDto[] | undefined;
}

export class CreateOrUpdateClaAuthorizationInput implements ICreateOrUpdateClaAuthorizationInput {
    caseId!: string;
    authorization!: ClaAuthorizationDto;

    constructor(data?: ICreateOrUpdateClaAuthorizationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.authorization = new ClaAuthorizationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.authorization = _data["authorization"] ? ClaAuthorizationDto.fromJS(_data["authorization"]) : new ClaAuthorizationDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateClaAuthorizationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaAuthorizationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["authorization"] = this.authorization ? this.authorization.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateClaAuthorizationInput {
    caseId: string;
    authorization: ClaAuthorizationDto;
}

export class CreateOrUpdateClaContactAlasInput implements ICreateOrUpdateClaContactAlasInput {
    caseId!: string;
    contact!: ClaContactAlasDto;

    constructor(data?: ICreateOrUpdateClaContactAlasInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contact = new ClaContactAlasDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.contact = _data["contact"] ? ClaContactAlasDto.fromJS(_data["contact"]) : new ClaContactAlasDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateClaContactAlasInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaContactAlasInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateClaContactAlasInput {
    caseId: string;
    contact: ClaContactAlasDto;
}

export class CreateOrUpdateClaDiplomaAlasInput implements ICreateOrUpdateClaDiplomaAlasInput {
    caseId!: string;
    diploma!: ClaDiplomaAlasDto;

    constructor(data?: ICreateOrUpdateClaDiplomaAlasInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.diploma = new ClaDiplomaAlasDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.diploma = _data["diploma"] ? ClaDiplomaAlasDto.fromJS(_data["diploma"]) : new ClaDiplomaAlasDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateClaDiplomaAlasInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaDiplomaAlasInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["diploma"] = this.diploma ? this.diploma.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateClaDiplomaAlasInput {
    caseId: string;
    diploma: ClaDiplomaAlasDto;
}

export class CreateOrUpdateClaEmploymentAlasInput implements ICreateOrUpdateClaEmploymentAlasInput {
    caseId!: string;
    employments!: ClaEmploymentAlasDto[];

    constructor(data?: ICreateOrUpdateClaEmploymentAlasInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.employments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(ClaEmploymentAlasDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateClaEmploymentAlasInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaEmploymentAlasInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateClaEmploymentAlasInput {
    caseId: string;
    employments: ClaEmploymentAlasDto[];
}

export class CreateOrUpdateClaHospitalPharmacyDetailsInput implements ICreateOrUpdateClaHospitalPharmacyDetailsInput {
    caseId!: string;
    hospitalPharmacyDetails!: ClaHospitalPharmacyDetailsDto;

    constructor(data?: ICreateOrUpdateClaHospitalPharmacyDetailsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.hospitalPharmacyDetails = new ClaHospitalPharmacyDetailsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.hospitalPharmacyDetails = _data["hospitalPharmacyDetails"] ? ClaHospitalPharmacyDetailsDto.fromJS(_data["hospitalPharmacyDetails"]) : new ClaHospitalPharmacyDetailsDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateClaHospitalPharmacyDetailsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaHospitalPharmacyDetailsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["hospitalPharmacyDetails"] = this.hospitalPharmacyDetails ? this.hospitalPharmacyDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateClaHospitalPharmacyDetailsInput {
    caseId: string;
    hospitalPharmacyDetails: ClaHospitalPharmacyDetailsDto;
}

export class CreateOrUpdateClaInvoiceAddressInput implements ICreateOrUpdateClaInvoiceAddressInput {
    caseId!: string;
    claInvoiceAddress!: ClaInvoiceAddressDto;

    constructor(data?: ICreateOrUpdateClaInvoiceAddressInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.claInvoiceAddress = new ClaInvoiceAddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.claInvoiceAddress = _data["claInvoiceAddress"] ? ClaInvoiceAddressDto.fromJS(_data["claInvoiceAddress"]) : new ClaInvoiceAddressDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateClaInvoiceAddressInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaInvoiceAddressInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["claInvoiceAddress"] = this.claInvoiceAddress ? this.claInvoiceAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateClaInvoiceAddressInput {
    caseId: string;
    claInvoiceAddress: ClaInvoiceAddressDto;
}

export class CreateOrUpdateClaLanguageSkillAlasInput implements ICreateOrUpdateClaLanguageSkillAlasInput {
    caseId!: string;
    languageSkill!: ClaLanguageSkillAlasDto;

    constructor(data?: ICreateOrUpdateClaLanguageSkillAlasInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.languageSkill = new ClaLanguageSkillAlasDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.languageSkill = _data["languageSkill"] ? ClaLanguageSkillAlasDto.fromJS(_data["languageSkill"]) : new ClaLanguageSkillAlasDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateClaLanguageSkillAlasInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaLanguageSkillAlasInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["languageSkill"] = this.languageSkill ? this.languageSkill.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateClaLanguageSkillAlasInput {
    caseId: string;
    languageSkill: ClaLanguageSkillAlasDto;
}

export class CreateOrUpdateClaRestrictionAlasInput implements ICreateOrUpdateClaRestrictionAlasInput {
    caseId!: string;
    restrictions!: ClaRestrictionAlasDto[];
    restrictionGeneralInformation!: ClaRestrictionGeneralInformationAlasDto;

    constructor(data?: ICreateOrUpdateClaRestrictionAlasInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.restrictions = [];
            this.restrictionGeneralInformation = new ClaRestrictionGeneralInformationAlasDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(ClaRestrictionAlasDto.fromJS(item));
            }
            this.restrictionGeneralInformation = _data["restrictionGeneralInformation"] ? ClaRestrictionGeneralInformationAlasDto.fromJS(_data["restrictionGeneralInformation"]) : new ClaRestrictionGeneralInformationAlasDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateClaRestrictionAlasInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaRestrictionAlasInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        data["restrictionGeneralInformation"] = this.restrictionGeneralInformation ? this.restrictionGeneralInformation.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateClaRestrictionAlasInput {
    caseId: string;
    restrictions: ClaRestrictionAlasDto[];
    restrictionGeneralInformation: ClaRestrictionGeneralInformationAlasDto;
}

export class CreateOrUpdateClaRestrictionsInput implements ICreateOrUpdateClaRestrictionsInput {
    caseId!: string;
    claRestrictions!: ClaRestrictionDto[];

    constructor(data?: ICreateOrUpdateClaRestrictionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.claRestrictions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["claRestrictions"])) {
                this.claRestrictions = [] as any;
                for (let item of _data["claRestrictions"])
                    this.claRestrictions!.push(ClaRestrictionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateClaRestrictionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaRestrictionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.claRestrictions)) {
            data["claRestrictions"] = [];
            for (let item of this.claRestrictions)
                data["claRestrictions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateClaRestrictionsInput {
    caseId: string;
    claRestrictions: ClaRestrictionDto[];
}

export class CreateOrUpdateClaSecurityAndInsuranceInput implements ICreateOrUpdateClaSecurityAndInsuranceInput {
    caseId!: string;
    securityAndInsurance!: ClaSecurityAndInsuranceDto;

    constructor(data?: ICreateOrUpdateClaSecurityAndInsuranceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.securityAndInsurance = new ClaSecurityAndInsuranceDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.securityAndInsurance = _data["securityAndInsurance"] ? ClaSecurityAndInsuranceDto.fromJS(_data["securityAndInsurance"]) : new ClaSecurityAndInsuranceDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateClaSecurityAndInsuranceInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaSecurityAndInsuranceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["securityAndInsurance"] = this.securityAndInsurance ? this.securityAndInsurance.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateClaSecurityAndInsuranceInput {
    caseId: string;
    securityAndInsurance: ClaSecurityAndInsuranceDto;
}

export class CreateOrUpdateClaSelectedBusinessesInput implements ICreateOrUpdateClaSelectedBusinessesInput {
    caseId!: string;
    selectedBusinesses!: ClaSelectedBusinessDto[];

    constructor(data?: ICreateOrUpdateClaSelectedBusinessesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectedBusinesses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["selectedBusinesses"])) {
                this.selectedBusinesses = [] as any;
                for (let item of _data["selectedBusinesses"])
                    this.selectedBusinesses!.push(ClaSelectedBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateClaSelectedBusinessesInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaSelectedBusinessesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.selectedBusinesses)) {
            data["selectedBusinesses"] = [];
            for (let item of this.selectedBusinesses)
                data["selectedBusinesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateClaSelectedBusinessesInput {
    caseId: string;
    selectedBusinesses: ClaSelectedBusinessDto[];
}

export class CreateOrUpdateClaSelectedBusinessesOutput implements ICreateOrUpdateClaSelectedBusinessesOutput {
    status!: ClaStatus;
    selectedBusinesses!: ClaSelectedBusinessDto[] | undefined;

    constructor(data?: ICreateOrUpdateClaSelectedBusinessesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["selectedBusinesses"])) {
                this.selectedBusinesses = [] as any;
                for (let item of _data["selectedBusinesses"])
                    this.selectedBusinesses!.push(ClaSelectedBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateClaSelectedBusinessesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaSelectedBusinessesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.selectedBusinesses)) {
            data["selectedBusinesses"] = [];
            for (let item of this.selectedBusinesses)
                data["selectedBusinesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateClaSelectedBusinessesOutput {
    status: ClaStatus;
    selectedBusinesses: ClaSelectedBusinessDto[] | undefined;
}

export class CreateOrUpdateClaSponsorshipInput implements ICreateOrUpdateClaSponsorshipInput {
    caseId!: string;
    sponsorship!: ClaSponsorshipDto;

    constructor(data?: ICreateOrUpdateClaSponsorshipInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sponsorship = new ClaSponsorshipDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.sponsorship = _data["sponsorship"] ? ClaSponsorshipDto.fromJS(_data["sponsorship"]) : new ClaSponsorshipDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateClaSponsorshipInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaSponsorshipInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateClaSponsorshipInput {
    caseId: string;
    sponsorship: ClaSponsorshipDto;
}

export class ClaElectronicPatientRecordDto implements IClaElectronicPatientRecordDto {
    membershipInCertifiedCommunityId!: string;
    membershipNoneReason!: string | undefined;

    constructor(data?: IClaElectronicPatientRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.membershipInCertifiedCommunityId = _data["membershipInCertifiedCommunityId"];
            this.membershipNoneReason = _data["membershipNoneReason"];
        }
    }

    static fromJS(data: any): ClaElectronicPatientRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaElectronicPatientRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["membershipInCertifiedCommunityId"] = this.membershipInCertifiedCommunityId;
        data["membershipNoneReason"] = this.membershipNoneReason;
        return data;
    }
}

export interface IClaElectronicPatientRecordDto {
    membershipInCertifiedCommunityId: string;
    membershipNoneReason: string | undefined;
}

export class CreateOrUpdateClaElectronicPatientRecordInput implements ICreateOrUpdateClaElectronicPatientRecordInput {
    caseId!: string;
    claElectronicPatientRecord!: ClaElectronicPatientRecordDto;

    constructor(data?: ICreateOrUpdateClaElectronicPatientRecordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.claElectronicPatientRecord = new ClaElectronicPatientRecordDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.claElectronicPatientRecord = _data["claElectronicPatientRecord"] ? ClaElectronicPatientRecordDto.fromJS(_data["claElectronicPatientRecord"]) : new ClaElectronicPatientRecordDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateClaElectronicPatientRecordInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaElectronicPatientRecordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["claElectronicPatientRecord"] = this.claElectronicPatientRecord ? this.claElectronicPatientRecord.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateClaElectronicPatientRecordInput {
    caseId: string;
    claElectronicPatientRecord: ClaElectronicPatientRecordDto;
}

export enum EnumTreatmentType {
    EmergencyStations = 0,
    TreatmentUnits = 1,
    OutpatientClinics = 2,
    OP1 = 3,
    OP2 = 4,
    OP3 = 5,
    SterialisationUnits = 6,
    BirthgivingUnits = 7,
    IntensiveCareUnits = 8,
    IMCUnits = 9,
    RecoveryUnits = 10,
    LaboratoryUnits = 11,
    XRayUnits = 12,
    PharmacyUnits = 13,
    OtherUnit = 14,
}

export class GetClaCorporateLicenceDto implements IGetClaCorporateLicenceDto {
    licenceId!: number | undefined;
    sponsorshipId!: number | undefined;

    constructor(data?: IGetClaCorporateLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceId = _data["licenceId"];
            this.sponsorshipId = _data["sponsorshipId"];
        }
    }

    static fromJS(data: any): GetClaCorporateLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetClaCorporateLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceId"] = this.licenceId;
        data["sponsorshipId"] = this.sponsorshipId;
        return data;
    }
}

export interface IGetClaCorporateLicenceDto {
    licenceId: number | undefined;
    sponsorshipId: number | undefined;
}

export class GetClaDocumentsAlasInput implements IGetClaDocumentsAlasInput {
    caseId!: string;
    step!: ClaStatus;
    isInEducationId!: string | undefined;
    languageSkillId!: string | undefined;
    hasJudgementInSwissCriminalRecordId!: string | undefined;
    hasGln!: boolean | undefined;

    constructor(data?: IGetClaDocumentsAlasInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.isInEducationId = _data["isInEducationId"];
            this.languageSkillId = _data["languageSkillId"];
            this.hasJudgementInSwissCriminalRecordId = _data["hasJudgementInSwissCriminalRecordId"];
            this.hasGln = _data["hasGln"];
        }
    }

    static fromJS(data: any): GetClaDocumentsAlasInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetClaDocumentsAlasInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["isInEducationId"] = this.isInEducationId;
        data["languageSkillId"] = this.languageSkillId;
        data["hasJudgementInSwissCriminalRecordId"] = this.hasJudgementInSwissCriminalRecordId;
        data["hasGln"] = this.hasGln;
        return data;
    }
}

export interface IGetClaDocumentsAlasInput {
    caseId: string;
    step: ClaStatus;
    isInEducationId: string | undefined;
    languageSkillId: string | undefined;
    hasJudgementInSwissCriminalRecordId: string | undefined;
    hasGln: boolean | undefined;
}

export class GetClaDocumentsInput implements IGetClaDocumentsInput {
    caseId!: string;
    step!: ClaStatus;
    hasGln!: boolean | undefined;
    hasCorporateLicenceInAnotherCantonId!: string | undefined;
    hasAppliedForProfessionalLicenceId!: string | undefined;
    doesCriminalRecordContainAConvictionId!: string | undefined;
    isAuthorizedSignatoryId!: string | undefined;
    hasClaInAnotherCantonId!: string | undefined;

    constructor(data?: IGetClaDocumentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.hasGln = _data["hasGln"];
            this.hasCorporateLicenceInAnotherCantonId = _data["hasCorporateLicenceInAnotherCantonId"];
            this.hasAppliedForProfessionalLicenceId = _data["hasAppliedForProfessionalLicenceId"];
            this.doesCriminalRecordContainAConvictionId = _data["doesCriminalRecordContainAConvictionId"];
            this.isAuthorizedSignatoryId = _data["isAuthorizedSignatoryId"];
            this.hasClaInAnotherCantonId = _data["hasClaInAnotherCantonId"];
        }
    }

    static fromJS(data: any): GetClaDocumentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetClaDocumentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["hasGln"] = this.hasGln;
        data["hasCorporateLicenceInAnotherCantonId"] = this.hasCorporateLicenceInAnotherCantonId;
        data["hasAppliedForProfessionalLicenceId"] = this.hasAppliedForProfessionalLicenceId;
        data["doesCriminalRecordContainAConvictionId"] = this.doesCriminalRecordContainAConvictionId;
        data["isAuthorizedSignatoryId"] = this.isAuthorizedSignatoryId;
        data["hasClaInAnotherCantonId"] = this.hasClaInAnotherCantonId;
        return data;
    }
}

export interface IGetClaDocumentsInput {
    caseId: string;
    step: ClaStatus;
    hasGln: boolean | undefined;
    hasCorporateLicenceInAnotherCantonId: string | undefined;
    hasAppliedForProfessionalLicenceId: string | undefined;
    doesCriminalRecordContainAConvictionId: string | undefined;
    isAuthorizedSignatoryId: string | undefined;
    hasClaInAnotherCantonId: string | undefined;
}

export class GetClaEmploymentAlasOutput implements IGetClaEmploymentAlasOutput {
    employments!: ClaEmploymentAlasDto[] | undefined;

    constructor(data?: IGetClaEmploymentAlasOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(ClaEmploymentAlasDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetClaEmploymentAlasOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetClaEmploymentAlasOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetClaEmploymentAlasOutput {
    employments: ClaEmploymentAlasDto[] | undefined;
}

export class GetClaFileInput implements IGetClaFileInput {
    caseId!: string;
    step!: ClaStatus;
    id!: number;

    constructor(data?: IGetClaFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetClaFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetClaFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetClaFileInput {
    caseId: string;
    step: ClaStatus;
    id: number;
}

export class GetClaNextStatusInput implements IGetClaNextStatusInput {
    caseId!: string;
    status!: ClaStatus;

    constructor(data?: IGetClaNextStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetClaNextStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetClaNextStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetClaNextStatusInput {
    caseId: string;
    status: ClaStatus;
}

export class GetClaOutput implements IGetClaOutput {
    cla!: ClaDto;

    constructor(data?: IGetClaOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cla = _data["cla"] ? ClaDto.fromJS(_data["cla"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetClaOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetClaOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cla"] = this.cla ? this.cla.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetClaOutput {
    cla: ClaDto;
}

export class GetClaSubItemDocumentsInput implements IGetClaSubItemDocumentsInput {
    subItemId!: number;
    hasXRayMachineId!: string | undefined;
    hasOperatingTheatresId!: string | undefined;
    hasAssistantsLicenceId!: string | undefined;
    hasConstructionalMeasuresId!: string | undefined;
    caseId!: string;
    step!: ClaStatus;
    hasGln!: boolean | undefined;
    hasCorporateLicenceInAnotherCantonId!: string | undefined;
    hasAppliedForProfessionalLicenceId!: string | undefined;
    doesCriminalRecordContainAConvictionId!: string | undefined;
    isAuthorizedSignatoryId!: string | undefined;
    hasClaInAnotherCantonId!: string | undefined;

    constructor(data?: IGetClaSubItemDocumentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subItemId = _data["subItemId"];
            this.hasXRayMachineId = _data["hasXRayMachineId"];
            this.hasOperatingTheatresId = _data["hasOperatingTheatresId"];
            this.hasAssistantsLicenceId = _data["hasAssistantsLicenceId"];
            this.hasConstructionalMeasuresId = _data["hasConstructionalMeasuresId"];
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.hasGln = _data["hasGln"];
            this.hasCorporateLicenceInAnotherCantonId = _data["hasCorporateLicenceInAnotherCantonId"];
            this.hasAppliedForProfessionalLicenceId = _data["hasAppliedForProfessionalLicenceId"];
            this.doesCriminalRecordContainAConvictionId = _data["doesCriminalRecordContainAConvictionId"];
            this.isAuthorizedSignatoryId = _data["isAuthorizedSignatoryId"];
            this.hasClaInAnotherCantonId = _data["hasClaInAnotherCantonId"];
        }
    }

    static fromJS(data: any): GetClaSubItemDocumentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetClaSubItemDocumentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subItemId"] = this.subItemId;
        data["hasXRayMachineId"] = this.hasXRayMachineId;
        data["hasOperatingTheatresId"] = this.hasOperatingTheatresId;
        data["hasAssistantsLicenceId"] = this.hasAssistantsLicenceId;
        data["hasConstructionalMeasuresId"] = this.hasConstructionalMeasuresId;
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["hasGln"] = this.hasGln;
        data["hasCorporateLicenceInAnotherCantonId"] = this.hasCorporateLicenceInAnotherCantonId;
        data["hasAppliedForProfessionalLicenceId"] = this.hasAppliedForProfessionalLicenceId;
        data["doesCriminalRecordContainAConvictionId"] = this.doesCriminalRecordContainAConvictionId;
        data["isAuthorizedSignatoryId"] = this.isAuthorizedSignatoryId;
        data["hasClaInAnotherCantonId"] = this.hasClaInAnotherCantonId;
        return data;
    }
}

export interface IGetClaSubItemDocumentsInput {
    subItemId: number;
    hasXRayMachineId: string | undefined;
    hasOperatingTheatresId: string | undefined;
    hasAssistantsLicenceId: string | undefined;
    hasConstructionalMeasuresId: string | undefined;
    caseId: string;
    step: ClaStatus;
    hasGln: boolean | undefined;
    hasCorporateLicenceInAnotherCantonId: string | undefined;
    hasAppliedForProfessionalLicenceId: string | undefined;
    doesCriminalRecordContainAConvictionId: string | undefined;
    isAuthorizedSignatoryId: string | undefined;
    hasClaInAnotherCantonId: string | undefined;
}

export class ClaMedicalFieldResponsibleForHaemovigilanceDto implements IClaMedicalFieldResponsibleForHaemovigilanceDto {
    gln!: string | undefined;
    professionId!: string | undefined;
    levelOfEmployment!: number;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    dateOfStart!: DateTime | undefined;
    roleInBusiness!: string | undefined;

    constructor(data?: IClaMedicalFieldResponsibleForHaemovigilanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.dateOfStart = _data["dateOfStart"] ? DateTime.fromISO(_data["dateOfStart"].toString()) : <any>undefined;
            this.roleInBusiness = _data["roleInBusiness"];
        }
    }

    static fromJS(data: any): ClaMedicalFieldResponsibleForHaemovigilanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaMedicalFieldResponsibleForHaemovigilanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["dateOfStart"] = this.dateOfStart ? this.dateOfStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["roleInBusiness"] = this.roleInBusiness;
        return data;
    }
}

export interface IClaMedicalFieldResponsibleForHaemovigilanceDto {
    gln: string | undefined;
    professionId: string | undefined;
    levelOfEmployment: number;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    dateOfStart: DateTime | undefined;
    roleInBusiness: string | undefined;
}

export class UpdateClaMedicalFieldResponsibleForHaemovigilanceInput implements IUpdateClaMedicalFieldResponsibleForHaemovigilanceInput {
    caseId!: string;
    medicalFieldResponsibleForHaemovigilance!: ClaMedicalFieldResponsibleForHaemovigilanceDto;

    constructor(data?: IUpdateClaMedicalFieldResponsibleForHaemovigilanceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medicalFieldResponsibleForHaemovigilance = new ClaMedicalFieldResponsibleForHaemovigilanceDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.medicalFieldResponsibleForHaemovigilance = _data["medicalFieldResponsibleForHaemovigilance"] ? ClaMedicalFieldResponsibleForHaemovigilanceDto.fromJS(_data["medicalFieldResponsibleForHaemovigilance"]) : new ClaMedicalFieldResponsibleForHaemovigilanceDto();
        }
    }

    static fromJS(data: any): UpdateClaMedicalFieldResponsibleForHaemovigilanceInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaMedicalFieldResponsibleForHaemovigilanceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["medicalFieldResponsibleForHaemovigilance"] = this.medicalFieldResponsibleForHaemovigilance ? this.medicalFieldResponsibleForHaemovigilance.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaMedicalFieldResponsibleForHaemovigilanceInput {
    caseId: string;
    medicalFieldResponsibleForHaemovigilance: ClaMedicalFieldResponsibleForHaemovigilanceDto;
}

export class UpdateClaMedicalFieldResponsibleForHaemovigilanceOutput implements IUpdateClaMedicalFieldResponsibleForHaemovigilanceOutput {
    status!: ClaStatus;
    medicalFieldResponsibleForHaemovigilance!: ClaMedicalFieldResponsibleForHaemovigilanceDto;

    constructor(data?: IUpdateClaMedicalFieldResponsibleForHaemovigilanceOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.medicalFieldResponsibleForHaemovigilance = _data["medicalFieldResponsibleForHaemovigilance"] ? ClaMedicalFieldResponsibleForHaemovigilanceDto.fromJS(_data["medicalFieldResponsibleForHaemovigilance"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateClaMedicalFieldResponsibleForHaemovigilanceOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaMedicalFieldResponsibleForHaemovigilanceOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["medicalFieldResponsibleForHaemovigilance"] = this.medicalFieldResponsibleForHaemovigilance ? this.medicalFieldResponsibleForHaemovigilance.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaMedicalFieldResponsibleForHaemovigilanceOutput {
    status: ClaStatus;
    medicalFieldResponsibleForHaemovigilance: ClaMedicalFieldResponsibleForHaemovigilanceDto;
}

export class ClaMedicalFieldResponsibleForStorageAndQualityDto implements IClaMedicalFieldResponsibleForStorageAndQualityDto {
    gln!: string | undefined;
    professionId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    levelOfEmployment!: number | undefined;
    dateOfStart!: DateTime | undefined;
    roleInBusiness!: string | undefined;
    profession!: string | undefined;

    constructor(data?: IClaMedicalFieldResponsibleForStorageAndQualityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfStart = _data["dateOfStart"] ? DateTime.fromISO(_data["dateOfStart"].toString()) : <any>undefined;
            this.roleInBusiness = _data["roleInBusiness"];
            this.profession = _data["profession"];
        }
    }

    static fromJS(data: any): ClaMedicalFieldResponsibleForStorageAndQualityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaMedicalFieldResponsibleForStorageAndQualityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfStart"] = this.dateOfStart ? this.dateOfStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["roleInBusiness"] = this.roleInBusiness;
        data["profession"] = this.profession;
        return data;
    }
}

export interface IClaMedicalFieldResponsibleForStorageAndQualityDto {
    gln: string | undefined;
    professionId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    levelOfEmployment: number | undefined;
    dateOfStart: DateTime | undefined;
    roleInBusiness: string | undefined;
    profession: string | undefined;
}

export class UpdateClaMedicalFieldResponsibleForStorageAndQualityInput implements IUpdateClaMedicalFieldResponsibleForStorageAndQualityInput {
    caseId!: string;
    medicalFieldResponsibleForStorageAndQuality!: ClaMedicalFieldResponsibleForStorageAndQualityDto;

    constructor(data?: IUpdateClaMedicalFieldResponsibleForStorageAndQualityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medicalFieldResponsibleForStorageAndQuality = new ClaMedicalFieldResponsibleForStorageAndQualityDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.medicalFieldResponsibleForStorageAndQuality = _data["medicalFieldResponsibleForStorageAndQuality"] ? ClaMedicalFieldResponsibleForStorageAndQualityDto.fromJS(_data["medicalFieldResponsibleForStorageAndQuality"]) : new ClaMedicalFieldResponsibleForStorageAndQualityDto();
        }
    }

    static fromJS(data: any): UpdateClaMedicalFieldResponsibleForStorageAndQualityInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaMedicalFieldResponsibleForStorageAndQualityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["medicalFieldResponsibleForStorageAndQuality"] = this.medicalFieldResponsibleForStorageAndQuality ? this.medicalFieldResponsibleForStorageAndQuality.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaMedicalFieldResponsibleForStorageAndQualityInput {
    caseId: string;
    medicalFieldResponsibleForStorageAndQuality: ClaMedicalFieldResponsibleForStorageAndQualityDto;
}

export class UpdateClaMedicalFieldResponsibleForStorageAndQualityOutput implements IUpdateClaMedicalFieldResponsibleForStorageAndQualityOutput {
    status!: ClaStatus;
    medicalFieldResponsibleForStorageAndQuality!: ClaMedicalFieldResponsibleForStorageAndQualityDto;

    constructor(data?: IUpdateClaMedicalFieldResponsibleForStorageAndQualityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.medicalFieldResponsibleForStorageAndQuality = _data["medicalFieldResponsibleForStorageAndQuality"] ? ClaMedicalFieldResponsibleForStorageAndQualityDto.fromJS(_data["medicalFieldResponsibleForStorageAndQuality"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateClaMedicalFieldResponsibleForStorageAndQualityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaMedicalFieldResponsibleForStorageAndQualityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["medicalFieldResponsibleForStorageAndQuality"] = this.medicalFieldResponsibleForStorageAndQuality ? this.medicalFieldResponsibleForStorageAndQuality.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaMedicalFieldResponsibleForStorageAndQualityOutput {
    status: ClaStatus;
    medicalFieldResponsibleForStorageAndQuality: ClaMedicalFieldResponsibleForStorageAndQualityDto;
}

export class ClaQualityRequirementDto implements IClaQualityRequirementDto {
    hasQualifiedStaffId!: string;
    qualifiedStaffDetails!: string | undefined;
    hasQualityManagementSystemId!: string;
    qualityManagementSystemDetails!: string | undefined;
    hasReportingAndLearningSystemId!: string;
    reportingAndLearningSystemDetails!: string | undefined;
    hasQualityMeasurementId!: string;
    qualityMeasurementDetails!: string | undefined;

    constructor(data?: IClaQualityRequirementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasQualifiedStaffId = _data["hasQualifiedStaffId"];
            this.qualifiedStaffDetails = _data["qualifiedStaffDetails"];
            this.hasQualityManagementSystemId = _data["hasQualityManagementSystemId"];
            this.qualityManagementSystemDetails = _data["qualityManagementSystemDetails"];
            this.hasReportingAndLearningSystemId = _data["hasReportingAndLearningSystemId"];
            this.reportingAndLearningSystemDetails = _data["reportingAndLearningSystemDetails"];
            this.hasQualityMeasurementId = _data["hasQualityMeasurementId"];
            this.qualityMeasurementDetails = _data["qualityMeasurementDetails"];
        }
    }

    static fromJS(data: any): ClaQualityRequirementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaQualityRequirementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasQualifiedStaffId"] = this.hasQualifiedStaffId;
        data["qualifiedStaffDetails"] = this.qualifiedStaffDetails;
        data["hasQualityManagementSystemId"] = this.hasQualityManagementSystemId;
        data["qualityManagementSystemDetails"] = this.qualityManagementSystemDetails;
        data["hasReportingAndLearningSystemId"] = this.hasReportingAndLearningSystemId;
        data["reportingAndLearningSystemDetails"] = this.reportingAndLearningSystemDetails;
        data["hasQualityMeasurementId"] = this.hasQualityMeasurementId;
        data["qualityMeasurementDetails"] = this.qualityMeasurementDetails;
        return data;
    }
}

export interface IClaQualityRequirementDto {
    hasQualifiedStaffId: string;
    qualifiedStaffDetails: string | undefined;
    hasQualityManagementSystemId: string;
    qualityManagementSystemDetails: string | undefined;
    hasReportingAndLearningSystemId: string;
    reportingAndLearningSystemDetails: string | undefined;
    hasQualityMeasurementId: string;
    qualityMeasurementDetails: string | undefined;
}

export class CreateOrUpdateClaQualityRequirementInput implements ICreateOrUpdateClaQualityRequirementInput {
    caseId!: string;
    claQualityRequirement!: ClaQualityRequirementDto;

    constructor(data?: ICreateOrUpdateClaQualityRequirementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.claQualityRequirement = new ClaQualityRequirementDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.claQualityRequirement = _data["claQualityRequirement"] ? ClaQualityRequirementDto.fromJS(_data["claQualityRequirement"]) : new ClaQualityRequirementDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateClaQualityRequirementInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaQualityRequirementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["claQualityRequirement"] = this.claQualityRequirement ? this.claQualityRequirement.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateClaQualityRequirementInput {
    caseId: string;
    claQualityRequirement: ClaQualityRequirementDto;
}

export class SetClaOnWaitingAndCreateEhcOutput implements ISetClaOnWaitingAndCreateEhcOutput {
    step!: ClaStatus;
    caseId!: string | undefined;

    constructor(data?: ISetClaOnWaitingAndCreateEhcOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.step = _data["step"];
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): SetClaOnWaitingAndCreateEhcOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SetClaOnWaitingAndCreateEhcOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step;
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface ISetClaOnWaitingAndCreateEhcOutput {
    step: ClaStatus;
    caseId: string | undefined;
}

export class SlasDrugProductionDto implements ISlasDrugProductionDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasFormulaMagistralisDrugProductionId!: string | undefined;
    hasFormulaOfficinalisDrugProductionId!: string;
    hasOwnFormulaDrugProductionId!: string;
    hasOwnFormulaSmallDrugProductionId!: string | undefined;
    hasOutsourcedDrugProductionId!: string | undefined;
    hasFormulaHospitalisDrugProductionId!: string | undefined;

    constructor(data?: ISlasDrugProductionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasFormulaMagistralisDrugProductionId = _data["hasFormulaMagistralisDrugProductionId"];
            this.hasFormulaOfficinalisDrugProductionId = _data["hasFormulaOfficinalisDrugProductionId"];
            this.hasOwnFormulaDrugProductionId = _data["hasOwnFormulaDrugProductionId"];
            this.hasOwnFormulaSmallDrugProductionId = _data["hasOwnFormulaSmallDrugProductionId"];
            this.hasOutsourcedDrugProductionId = _data["hasOutsourcedDrugProductionId"];
            this.hasFormulaHospitalisDrugProductionId = _data["hasFormulaHospitalisDrugProductionId"];
        }
    }

    static fromJS(data: any): SlasDrugProductionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlasDrugProductionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasFormulaMagistralisDrugProductionId"] = this.hasFormulaMagistralisDrugProductionId;
        data["hasFormulaOfficinalisDrugProductionId"] = this.hasFormulaOfficinalisDrugProductionId;
        data["hasOwnFormulaDrugProductionId"] = this.hasOwnFormulaDrugProductionId;
        data["hasOwnFormulaSmallDrugProductionId"] = this.hasOwnFormulaSmallDrugProductionId;
        data["hasOutsourcedDrugProductionId"] = this.hasOutsourcedDrugProductionId;
        data["hasFormulaHospitalisDrugProductionId"] = this.hasFormulaHospitalisDrugProductionId;
        return data;
    }
}

export interface ISlasDrugProductionDto {
    id: number | undefined;
    claBusinessId: number;
    hasFormulaMagistralisDrugProductionId: string | undefined;
    hasFormulaOfficinalisDrugProductionId: string;
    hasOwnFormulaDrugProductionId: string;
    hasOwnFormulaSmallDrugProductionId: string | undefined;
    hasOutsourcedDrugProductionId: string | undefined;
    hasFormulaHospitalisDrugProductionId: string | undefined;
}

export class SlasDrugProductionThirdPartyDto implements ISlasDrugProductionThirdPartyDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasOutsourcedDrugProductionId!: string;

    constructor(data?: ISlasDrugProductionThirdPartyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasOutsourcedDrugProductionId = _data["hasOutsourcedDrugProductionId"];
        }
    }

    static fromJS(data: any): SlasDrugProductionThirdPartyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlasDrugProductionThirdPartyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasOutsourcedDrugProductionId"] = this.hasOutsourcedDrugProductionId;
        return data;
    }
}

export interface ISlasDrugProductionThirdPartyDto {
    id: number | undefined;
    claBusinessId: number;
    hasOutsourcedDrugProductionId: string;
}

export class SlasLocalDrugSalesDto implements ISlasLocalDrugSalesDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasDrugSalesId!: string;

    constructor(data?: ISlasLocalDrugSalesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasDrugSalesId = _data["hasDrugSalesId"];
        }
    }

    static fromJS(data: any): SlasLocalDrugSalesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlasLocalDrugSalesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasDrugSalesId"] = this.hasDrugSalesId;
        return data;
    }
}

export interface ISlasLocalDrugSalesDto {
    id: number | undefined;
    claBusinessId: number;
    hasDrugSalesId: string;
}

export class SlasProductPreparationDto implements ISlasProductPreparationDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasLocalPreparationId!: string;
    hasExternalPreparationId!: string;
    hasUseOfDisposablesId!: string;

    constructor(data?: ISlasProductPreparationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasLocalPreparationId = _data["hasLocalPreparationId"];
            this.hasExternalPreparationId = _data["hasExternalPreparationId"];
            this.hasUseOfDisposablesId = _data["hasUseOfDisposablesId"];
        }
    }

    static fromJS(data: any): SlasProductPreparationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlasProductPreparationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasLocalPreparationId"] = this.hasLocalPreparationId;
        data["hasExternalPreparationId"] = this.hasExternalPreparationId;
        data["hasUseOfDisposablesId"] = this.hasUseOfDisposablesId;
        return data;
    }
}

export interface ISlasProductPreparationDto {
    id: number | undefined;
    claBusinessId: number;
    hasLocalPreparationId: string;
    hasExternalPreparationId: string;
    hasUseOfDisposablesId: string;
}

export class SlasRangeOfProductsDto implements ISlasRangeOfProductsDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasOnlyLimitedId!: string;
    hasRefrigeratorRequiredId!: string;
    hasNarcoticsId!: string;
    hasPsychotropicsId!: string;

    constructor(data?: ISlasRangeOfProductsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasOnlyLimitedId = _data["hasOnlyLimitedId"];
            this.hasRefrigeratorRequiredId = _data["hasRefrigeratorRequiredId"];
            this.hasNarcoticsId = _data["hasNarcoticsId"];
            this.hasPsychotropicsId = _data["hasPsychotropicsId"];
        }
    }

    static fromJS(data: any): SlasRangeOfProductsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlasRangeOfProductsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasOnlyLimitedId"] = this.hasOnlyLimitedId;
        data["hasRefrigeratorRequiredId"] = this.hasRefrigeratorRequiredId;
        data["hasNarcoticsId"] = this.hasNarcoticsId;
        data["hasPsychotropicsId"] = this.hasPsychotropicsId;
        return data;
    }
}

export interface ISlasRangeOfProductsDto {
    id: number | undefined;
    claBusinessId: number;
    hasOnlyLimitedId: string;
    hasRefrigeratorRequiredId: string;
    hasNarcoticsId: string;
    hasPsychotropicsId: string;
}

export class ClaTrainerDto implements IClaTrainerDto {
    id!: number | undefined;
    gln!: string;
    professionId!: string;
    levelOfEmployment!: number;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;

    constructor(data?: IClaTrainerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ClaTrainerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaTrainerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        return data;
    }
}

export interface IClaTrainerDto {
    id: number | undefined;
    gln: string;
    professionId: string;
    levelOfEmployment: number;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
}

export class UpdateClaTrainerInput implements IUpdateClaTrainerInput {
    caseId!: string;
    trainer!: ClaTrainerDto;

    constructor(data?: IUpdateClaTrainerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.trainer = new ClaTrainerDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.trainer = _data["trainer"] ? ClaTrainerDto.fromJS(_data["trainer"]) : new ClaTrainerDto();
        }
    }

    static fromJS(data: any): UpdateClaTrainerInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaTrainerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["trainer"] = this.trainer ? this.trainer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaTrainerInput {
    caseId: string;
    trainer: ClaTrainerDto;
}

export class UpdateClaTrainerOutput implements IUpdateClaTrainerOutput {
    status!: ClaStatus;
    trainer!: ClaTrainerDto;

    constructor(data?: IUpdateClaTrainerOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.trainer = _data["trainer"] ? ClaTrainerDto.fromJS(_data["trainer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateClaTrainerOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaTrainerOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["trainer"] = this.trainer ? this.trainer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaTrainerOutput {
    status: ClaStatus;
    trainer: ClaTrainerDto;
}

export class UpdateClaAidingResourcesInput implements IUpdateClaAidingResourcesInput {
    caseId!: string;
    aidingResourcesList!: ClaAidingResourcesDto[];

    constructor(data?: IUpdateClaAidingResourcesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.aidingResourcesList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["aidingResourcesList"])) {
                this.aidingResourcesList = [] as any;
                for (let item of _data["aidingResourcesList"])
                    this.aidingResourcesList!.push(ClaAidingResourcesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaAidingResourcesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaAidingResourcesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.aidingResourcesList)) {
            data["aidingResourcesList"] = [];
            for (let item of this.aidingResourcesList)
                data["aidingResourcesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaAidingResourcesInput {
    caseId: string;
    aidingResourcesList: ClaAidingResourcesDto[];
}

export class UpdateClaAidingResourcesOutput implements IUpdateClaAidingResourcesOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaAidingResourcesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaAidingResourcesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaAidingResourcesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaAidingResourcesOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaAssistantPhysiciansInput implements IUpdateClaAssistantPhysiciansInput {
    caseId!: string;
    assistantPhysicians!: ClaAssistantPhysicianDto[];

    constructor(data?: IUpdateClaAssistantPhysiciansInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.assistantPhysicians = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["assistantPhysicians"])) {
                this.assistantPhysicians = [] as any;
                for (let item of _data["assistantPhysicians"])
                    this.assistantPhysicians!.push(ClaAssistantPhysicianDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaAssistantPhysiciansInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaAssistantPhysiciansInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.assistantPhysicians)) {
            data["assistantPhysicians"] = [];
            for (let item of this.assistantPhysicians)
                data["assistantPhysicians"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaAssistantPhysiciansInput {
    caseId: string;
    assistantPhysicians: ClaAssistantPhysicianDto[];
}

export class UpdateClaAssistantPhysiciansOutput implements IUpdateClaAssistantPhysiciansOutput {
    status!: ClaStatus;
    assistantPhysicians!: ClaAssistantPhysicianDto[] | undefined;

    constructor(data?: IUpdateClaAssistantPhysiciansOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["assistantPhysicians"])) {
                this.assistantPhysicians = [] as any;
                for (let item of _data["assistantPhysicians"])
                    this.assistantPhysicians!.push(ClaAssistantPhysicianDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaAssistantPhysiciansOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaAssistantPhysiciansOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.assistantPhysicians)) {
            data["assistantPhysicians"] = [];
            for (let item of this.assistantPhysicians)
                data["assistantPhysicians"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaAssistantPhysiciansOutput {
    status: ClaStatus;
    assistantPhysicians: ClaAssistantPhysicianDto[] | undefined;
}

export class UpdateClaBusinessDirectorsInput implements IUpdateClaBusinessDirectorsInput {
    caseId!: string;
    directors!: ClaBusinessDirectorDto[];

    constructor(data?: IUpdateClaBusinessDirectorsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.directors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["directors"])) {
                this.directors = [] as any;
                for (let item of _data["directors"])
                    this.directors!.push(ClaBusinessDirectorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaBusinessDirectorsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaBusinessDirectorsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.directors)) {
            data["directors"] = [];
            for (let item of this.directors)
                data["directors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaBusinessDirectorsInput {
    caseId: string;
    directors: ClaBusinessDirectorDto[];
}

export class UpdateClaBusinessDirectorsOutput implements IUpdateClaBusinessDirectorsOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaBusinessDirectorsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaBusinessDirectorsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaBusinessDirectorsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaBusinessDirectorsOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaBusinessesInput implements IUpdateClaBusinessesInput {
    caseId!: string;
    businesses!: ClaBusinessDto[];

    constructor(data?: IUpdateClaBusinessesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.businesses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaBusinessesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaBusinessesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaBusinessesInput {
    caseId: string;
    businesses: ClaBusinessDto[];
}

export class UpdateClaBusinessesOutput implements IUpdateClaBusinessesOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaBusinessesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaBusinessesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaBusinessesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaBusinessesOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaDrugChambersInput implements IUpdateClaDrugChambersInput {
    caseId!: string;
    drugChambersList!: ClaDrugChambersDto[];

    constructor(data?: IUpdateClaDrugChambersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.drugChambersList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["drugChambersList"])) {
                this.drugChambersList = [] as any;
                for (let item of _data["drugChambersList"])
                    this.drugChambersList!.push(ClaDrugChambersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaDrugChambersInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaDrugChambersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.drugChambersList)) {
            data["drugChambersList"] = [];
            for (let item of this.drugChambersList)
                data["drugChambersList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaDrugChambersInput {
    caseId: string;
    drugChambersList: ClaDrugChambersDto[];
}

export class UpdateClaDrugChambersOutput implements IUpdateClaDrugChambersOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaDrugChambersOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaDrugChambersOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaDrugChambersOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaDrugChambersOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaExternalPointForComplaintsInput implements IUpdateClaExternalPointForComplaintsInput {
    caseId!: string;
    externalPointForComplaints!: ClaExternalPointForComplaintsDto;

    constructor(data?: IUpdateClaExternalPointForComplaintsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.externalPointForComplaints = new ClaExternalPointForComplaintsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.externalPointForComplaints = _data["externalPointForComplaints"] ? ClaExternalPointForComplaintsDto.fromJS(_data["externalPointForComplaints"]) : new ClaExternalPointForComplaintsDto();
        }
    }

    static fromJS(data: any): UpdateClaExternalPointForComplaintsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaExternalPointForComplaintsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["externalPointForComplaints"] = this.externalPointForComplaints ? this.externalPointForComplaints.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaExternalPointForComplaintsInput {
    caseId: string;
    externalPointForComplaints: ClaExternalPointForComplaintsDto;
}

export class UpdateClaExternalPointForComplaintsOutput implements IUpdateClaExternalPointForComplaintsOutput {
    status!: ClaStatus;
    externalPointForComplaints!: ClaExternalPointForComplaintsDto;

    constructor(data?: IUpdateClaExternalPointForComplaintsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.externalPointForComplaints = _data["externalPointForComplaints"] ? ClaExternalPointForComplaintsDto.fromJS(_data["externalPointForComplaints"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateClaExternalPointForComplaintsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaExternalPointForComplaintsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["externalPointForComplaints"] = this.externalPointForComplaints ? this.externalPointForComplaints.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaExternalPointForComplaintsOutput {
    status: ClaStatus;
    externalPointForComplaints: ClaExternalPointForComplaintsDto;
}

export class UpdateClaFloorsInput implements IUpdateClaFloorsInput {
    caseId!: string;
    floorsList!: ClaFloorsDto[];

    constructor(data?: IUpdateClaFloorsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.floorsList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["floorsList"])) {
                this.floorsList = [] as any;
                for (let item of _data["floorsList"])
                    this.floorsList!.push(ClaFloorsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaFloorsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaFloorsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.floorsList)) {
            data["floorsList"] = [];
            for (let item of this.floorsList)
                data["floorsList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaFloorsInput {
    caseId: string;
    floorsList: ClaFloorsDto[];
}

export class UpdateClaFloorsOutput implements IUpdateClaFloorsOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaFloorsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaFloorsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaFloorsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaFloorsOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaHeadOfNursingServicesInput implements IUpdateClaHeadOfNursingServicesInput {
    caseId!: string;
    headOfNursingServices!: ClaHeadOfNursingServicesDto[];

    constructor(data?: IUpdateClaHeadOfNursingServicesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.headOfNursingServices = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["headOfNursingServices"])) {
                this.headOfNursingServices = [] as any;
                for (let item of _data["headOfNursingServices"])
                    this.headOfNursingServices!.push(ClaHeadOfNursingServicesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaHeadOfNursingServicesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaHeadOfNursingServicesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.headOfNursingServices)) {
            data["headOfNursingServices"] = [];
            for (let item of this.headOfNursingServices)
                data["headOfNursingServices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaHeadOfNursingServicesInput {
    caseId: string;
    headOfNursingServices: ClaHeadOfNursingServicesDto[];
}

export class UpdateClaHeadOfNursingServicesOutput implements IUpdateClaHeadOfNursingServicesOutput {
    status!: ClaStatus;
    headOfNursingServices!: ClaHeadOfNursingServicesDto[] | undefined;

    constructor(data?: IUpdateClaHeadOfNursingServicesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["headOfNursingServices"])) {
                this.headOfNursingServices = [] as any;
                for (let item of _data["headOfNursingServices"])
                    this.headOfNursingServices!.push(ClaHeadOfNursingServicesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaHeadOfNursingServicesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaHeadOfNursingServicesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.headOfNursingServices)) {
            data["headOfNursingServices"] = [];
            for (let item of this.headOfNursingServices)
                data["headOfNursingServices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaHeadOfNursingServicesOutput {
    status: ClaStatus;
    headOfNursingServices: ClaHeadOfNursingServicesDto[] | undefined;
}

export class UpdateClaHeadOfNursingServicesRepresentativeInput implements IUpdateClaHeadOfNursingServicesRepresentativeInput {
    caseId!: string;
    headOfNursingServicesRepresentative!: ClaHeadOfNursingServicesRepresentativeDto[];

    constructor(data?: IUpdateClaHeadOfNursingServicesRepresentativeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.headOfNursingServicesRepresentative = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["headOfNursingServicesRepresentative"])) {
                this.headOfNursingServicesRepresentative = [] as any;
                for (let item of _data["headOfNursingServicesRepresentative"])
                    this.headOfNursingServicesRepresentative!.push(ClaHeadOfNursingServicesRepresentativeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaHeadOfNursingServicesRepresentativeInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaHeadOfNursingServicesRepresentativeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.headOfNursingServicesRepresentative)) {
            data["headOfNursingServicesRepresentative"] = [];
            for (let item of this.headOfNursingServicesRepresentative)
                data["headOfNursingServicesRepresentative"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaHeadOfNursingServicesRepresentativeInput {
    caseId: string;
    headOfNursingServicesRepresentative: ClaHeadOfNursingServicesRepresentativeDto[];
}

export class UpdateClaHeadOfNursingServicesRepresentativeOutput implements IUpdateClaHeadOfNursingServicesRepresentativeOutput {
    status!: ClaStatus;
    headOfNursingServicesRepresentative!: ClaHeadOfNursingServicesRepresentativeDto[] | undefined;

    constructor(data?: IUpdateClaHeadOfNursingServicesRepresentativeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["headOfNursingServicesRepresentative"])) {
                this.headOfNursingServicesRepresentative = [] as any;
                for (let item of _data["headOfNursingServicesRepresentative"])
                    this.headOfNursingServicesRepresentative!.push(ClaHeadOfNursingServicesRepresentativeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaHeadOfNursingServicesRepresentativeOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaHeadOfNursingServicesRepresentativeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.headOfNursingServicesRepresentative)) {
            data["headOfNursingServicesRepresentative"] = [];
            for (let item of this.headOfNursingServicesRepresentative)
                data["headOfNursingServicesRepresentative"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaHeadOfNursingServicesRepresentativeOutput {
    status: ClaStatus;
    headOfNursingServicesRepresentative: ClaHeadOfNursingServicesRepresentativeDto[] | undefined;
}

export class UpdateClaInfrastructureInput implements IUpdateClaInfrastructureInput {
    caseId!: string;
    infrastructureList!: ClaInfrastructureDto[];

    constructor(data?: IUpdateClaInfrastructureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.infrastructureList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["infrastructureList"])) {
                this.infrastructureList = [] as any;
                for (let item of _data["infrastructureList"])
                    this.infrastructureList!.push(ClaInfrastructureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaInfrastructureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaInfrastructureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.infrastructureList)) {
            data["infrastructureList"] = [];
            for (let item of this.infrastructureList)
                data["infrastructureList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaInfrastructureInput {
    caseId: string;
    infrastructureList: ClaInfrastructureDto[];
}

export class UpdateClaInfrastructureOutput implements IUpdateClaInfrastructureOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaInfrastructureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaInfrastructureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaInfrastructureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaInfrastructureOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaInternalSupervisionInput implements IUpdateClaInternalSupervisionInput {
    caseId!: string;
    internalSupervision!: ClaInternalSupervisionDto;

    constructor(data?: IUpdateClaInternalSupervisionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.internalSupervision = new ClaInternalSupervisionDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.internalSupervision = _data["internalSupervision"] ? ClaInternalSupervisionDto.fromJS(_data["internalSupervision"]) : new ClaInternalSupervisionDto();
        }
    }

    static fromJS(data: any): UpdateClaInternalSupervisionInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaInternalSupervisionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["internalSupervision"] = this.internalSupervision ? this.internalSupervision.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaInternalSupervisionInput {
    caseId: string;
    internalSupervision: ClaInternalSupervisionDto;
}

export class UpdateClaInternalSupervisionOutput implements IUpdateClaInternalSupervisionOutput {
    status!: ClaStatus;
    internalSupervision!: ClaInternalSupervisionDto;

    constructor(data?: IUpdateClaInternalSupervisionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.internalSupervision = _data["internalSupervision"] ? ClaInternalSupervisionDto.fromJS(_data["internalSupervision"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateClaInternalSupervisionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaInternalSupervisionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["internalSupervision"] = this.internalSupervision ? this.internalSupervision.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaInternalSupervisionOutput {
    status: ClaStatus;
    internalSupervision: ClaInternalSupervisionDto;
}

export class UpdateClaMedicalFieldDirectorInput implements IUpdateClaMedicalFieldDirectorInput {
    caseId!: string;
    medicalFieldDirector!: ClaMedicalFieldDirectorDto;

    constructor(data?: IUpdateClaMedicalFieldDirectorInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medicalFieldDirector = new ClaMedicalFieldDirectorDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.medicalFieldDirector = _data["medicalFieldDirector"] ? ClaMedicalFieldDirectorDto.fromJS(_data["medicalFieldDirector"]) : new ClaMedicalFieldDirectorDto();
        }
    }

    static fromJS(data: any): UpdateClaMedicalFieldDirectorInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaMedicalFieldDirectorInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["medicalFieldDirector"] = this.medicalFieldDirector ? this.medicalFieldDirector.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaMedicalFieldDirectorInput {
    caseId: string;
    medicalFieldDirector: ClaMedicalFieldDirectorDto;
}

export class UpdateClaMedicalFieldDirectorOutput implements IUpdateClaMedicalFieldDirectorOutput {
    status!: ClaStatus;
    medicalFieldDirector!: ClaMedicalFieldDirectorDto;

    constructor(data?: IUpdateClaMedicalFieldDirectorOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.medicalFieldDirector = _data["medicalFieldDirector"] ? ClaMedicalFieldDirectorDto.fromJS(_data["medicalFieldDirector"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateClaMedicalFieldDirectorOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaMedicalFieldDirectorOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["medicalFieldDirector"] = this.medicalFieldDirector ? this.medicalFieldDirector.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaMedicalFieldDirectorOutput {
    status: ClaStatus;
    medicalFieldDirector: ClaMedicalFieldDirectorDto;
}

export class UpdateClaMedicalFieldDirectorRepresentativeInput implements IUpdateClaMedicalFieldDirectorRepresentativeInput {
    caseId!: string;
    medicalFieldDirectorRepresentative!: ClaMedicalFieldDirectorRepresentativeDto;

    constructor(data?: IUpdateClaMedicalFieldDirectorRepresentativeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medicalFieldDirectorRepresentative = new ClaMedicalFieldDirectorRepresentativeDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.medicalFieldDirectorRepresentative = _data["medicalFieldDirectorRepresentative"] ? ClaMedicalFieldDirectorRepresentativeDto.fromJS(_data["medicalFieldDirectorRepresentative"]) : new ClaMedicalFieldDirectorRepresentativeDto();
        }
    }

    static fromJS(data: any): UpdateClaMedicalFieldDirectorRepresentativeInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaMedicalFieldDirectorRepresentativeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["medicalFieldDirectorRepresentative"] = this.medicalFieldDirectorRepresentative ? this.medicalFieldDirectorRepresentative.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaMedicalFieldDirectorRepresentativeInput {
    caseId: string;
    medicalFieldDirectorRepresentative: ClaMedicalFieldDirectorRepresentativeDto;
}

export class UpdateClaMedicalFieldDirectorRepresentativeOutput implements IUpdateClaMedicalFieldDirectorRepresentativeOutput {
    status!: ClaStatus;
    medicalFieldDirectorRepresentative!: ClaMedicalFieldDirectorRepresentativeDto;

    constructor(data?: IUpdateClaMedicalFieldDirectorRepresentativeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.medicalFieldDirectorRepresentative = _data["medicalFieldDirectorRepresentative"] ? ClaMedicalFieldDirectorRepresentativeDto.fromJS(_data["medicalFieldDirectorRepresentative"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateClaMedicalFieldDirectorRepresentativeOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaMedicalFieldDirectorRepresentativeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["medicalFieldDirectorRepresentative"] = this.medicalFieldDirectorRepresentative ? this.medicalFieldDirectorRepresentative.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaMedicalFieldDirectorRepresentativeOutput {
    status: ClaStatus;
    medicalFieldDirectorRepresentative: ClaMedicalFieldDirectorRepresentativeDto;
}

export class UpdateClaMedicalFieldPersonsAlasInput implements IUpdateClaMedicalFieldPersonsAlasInput {
    caseId!: string;
    medicalFieldPersonsAlas!: ClaMedicalFieldPersonAlasDto[];

    constructor(data?: IUpdateClaMedicalFieldPersonsAlasInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medicalFieldPersonsAlas = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["medicalFieldPersonsAlas"])) {
                this.medicalFieldPersonsAlas = [] as any;
                for (let item of _data["medicalFieldPersonsAlas"])
                    this.medicalFieldPersonsAlas!.push(ClaMedicalFieldPersonAlasDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaMedicalFieldPersonsAlasInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaMedicalFieldPersonsAlasInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.medicalFieldPersonsAlas)) {
            data["medicalFieldPersonsAlas"] = [];
            for (let item of this.medicalFieldPersonsAlas)
                data["medicalFieldPersonsAlas"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaMedicalFieldPersonsAlasInput {
    caseId: string;
    medicalFieldPersonsAlas: ClaMedicalFieldPersonAlasDto[];
}

export class UpdateClaMedicalFieldPersonsAlasOutput implements IUpdateClaMedicalFieldPersonsAlasOutput {
    status!: ClaStatus;
    medicalFieldPersonsAlas!: ClaMedicalFieldPersonAlasDto[] | undefined;

    constructor(data?: IUpdateClaMedicalFieldPersonsAlasOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["medicalFieldPersonsAlas"])) {
                this.medicalFieldPersonsAlas = [] as any;
                for (let item of _data["medicalFieldPersonsAlas"])
                    this.medicalFieldPersonsAlas!.push(ClaMedicalFieldPersonAlasDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaMedicalFieldPersonsAlasOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaMedicalFieldPersonsAlasOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.medicalFieldPersonsAlas)) {
            data["medicalFieldPersonsAlas"] = [];
            for (let item of this.medicalFieldPersonsAlas)
                data["medicalFieldPersonsAlas"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaMedicalFieldPersonsAlasOutput {
    status: ClaStatus;
    medicalFieldPersonsAlas: ClaMedicalFieldPersonAlasDto[] | undefined;
}

export class UpdateClaMedicalFieldPersonsInput implements IUpdateClaMedicalFieldPersonsInput {
    caseId!: string;
    medicalFieldPersons!: ClaMedicalFieldPersonDto[];

    constructor(data?: IUpdateClaMedicalFieldPersonsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medicalFieldPersons = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["medicalFieldPersons"])) {
                this.medicalFieldPersons = [] as any;
                for (let item of _data["medicalFieldPersons"])
                    this.medicalFieldPersons!.push(ClaMedicalFieldPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaMedicalFieldPersonsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaMedicalFieldPersonsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.medicalFieldPersons)) {
            data["medicalFieldPersons"] = [];
            for (let item of this.medicalFieldPersons)
                data["medicalFieldPersons"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaMedicalFieldPersonsInput {
    caseId: string;
    medicalFieldPersons: ClaMedicalFieldPersonDto[];
}

export class UpdateClaMedicalFieldPersonsOutput implements IUpdateClaMedicalFieldPersonsOutput {
    status!: ClaStatus;
    medicalFieldPersons!: ClaMedicalFieldPersonDto[] | undefined;

    constructor(data?: IUpdateClaMedicalFieldPersonsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["medicalFieldPersons"])) {
                this.medicalFieldPersons = [] as any;
                for (let item of _data["medicalFieldPersons"])
                    this.medicalFieldPersons!.push(ClaMedicalFieldPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaMedicalFieldPersonsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaMedicalFieldPersonsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.medicalFieldPersons)) {
            data["medicalFieldPersons"] = [];
            for (let item of this.medicalFieldPersons)
                data["medicalFieldPersons"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaMedicalFieldPersonsOutput {
    status: ClaStatus;
    medicalFieldPersons: ClaMedicalFieldPersonDto[] | undefined;
}

export class UpdateClaNursingBedsInput implements IUpdateClaNursingBedsInput {
    caseId!: string;
    nursingBedsList!: ClaNursingBedsDto[];

    constructor(data?: IUpdateClaNursingBedsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.nursingBedsList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["nursingBedsList"])) {
                this.nursingBedsList = [] as any;
                for (let item of _data["nursingBedsList"])
                    this.nursingBedsList!.push(ClaNursingBedsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaNursingBedsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaNursingBedsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.nursingBedsList)) {
            data["nursingBedsList"] = [];
            for (let item of this.nursingBedsList)
                data["nursingBedsList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaNursingBedsInput {
    caseId: string;
    nursingBedsList: ClaNursingBedsDto[];
}

export class UpdateClaNursingBedsOutput implements IUpdateClaNursingBedsOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaNursingBedsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaNursingBedsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaNursingBedsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaNursingBedsOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaPersonAlasInput implements IUpdateClaPersonAlasInput {
    caseId!: string;
    personAlas!: ClaPersonAlasDto;

    constructor(data?: IUpdateClaPersonAlasInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.personAlas = new ClaPersonAlasDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.personAlas = _data["personAlas"] ? ClaPersonAlasDto.fromJS(_data["personAlas"]) : new ClaPersonAlasDto();
        }
    }

    static fromJS(data: any): UpdateClaPersonAlasInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaPersonAlasInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["personAlas"] = this.personAlas ? this.personAlas.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaPersonAlasInput {
    caseId: string;
    personAlas: ClaPersonAlasDto;
}

export class UpdateClaPersonAlasOutput implements IUpdateClaPersonAlasOutput {
    status!: ClaStatus;
    personAlas!: ClaPersonAlasDto;

    constructor(data?: IUpdateClaPersonAlasOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.personAlas = _data["personAlas"] ? ClaPersonAlasDto.fromJS(_data["personAlas"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateClaPersonAlasOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaPersonAlasOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["personAlas"] = this.personAlas ? this.personAlas.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaPersonAlasOutput {
    status: ClaStatus;
    personAlas: ClaPersonAlasDto;
}

export class UpdateClaPersonelInput implements IUpdateClaPersonelInput {
    caseId!: string;
    personelList!: ClaPersonelDto[];

    constructor(data?: IUpdateClaPersonelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.personelList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["personelList"])) {
                this.personelList = [] as any;
                for (let item of _data["personelList"])
                    this.personelList!.push(ClaPersonelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaPersonelInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaPersonelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.personelList)) {
            data["personelList"] = [];
            for (let item of this.personelList)
                data["personelList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaPersonelInput {
    caseId: string;
    personelList: ClaPersonelDto[];
}

export class UpdateClaPersonelOutput implements IUpdateClaPersonelOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaPersonelOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaPersonelOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaPersonelOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaPersonelOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaQualityInput implements IUpdateClaQualityInput {
    caseId!: string;
    qualityList!: ClaQualityDto[];

    constructor(data?: IUpdateClaQualityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.qualityList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["qualityList"])) {
                this.qualityList = [] as any;
                for (let item of _data["qualityList"])
                    this.qualityList!.push(ClaQualityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaQualityInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaQualityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.qualityList)) {
            data["qualityList"] = [];
            for (let item of this.qualityList)
                data["qualityList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaQualityInput {
    caseId: string;
    qualityList: ClaQualityDto[];
}

export class UpdateClaQualityOutput implements IUpdateClaQualityOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaQualityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaQualityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaQualityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaQualityOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaRangeOfServicesInput implements IUpdateClaRangeOfServicesInput {
    caseId!: string;
    rangeOfServicesList!: ClaRangeOfServicesDto[];

    constructor(data?: IUpdateClaRangeOfServicesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rangeOfServicesList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["rangeOfServicesList"])) {
                this.rangeOfServicesList = [] as any;
                for (let item of _data["rangeOfServicesList"])
                    this.rangeOfServicesList!.push(ClaRangeOfServicesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaRangeOfServicesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaRangeOfServicesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.rangeOfServicesList)) {
            data["rangeOfServicesList"] = [];
            for (let item of this.rangeOfServicesList)
                data["rangeOfServicesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaRangeOfServicesInput {
    caseId: string;
    rangeOfServicesList: ClaRangeOfServicesDto[];
}

export class UpdateClaRangeOfServicesOutput implements IUpdateClaRangeOfServicesOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaRangeOfServicesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaRangeOfServicesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaRangeOfServicesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaRangeOfServicesOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaSanitaryFacilitiesInput implements IUpdateClaSanitaryFacilitiesInput {
    caseId!: string;
    sanitaryFacilitiesList!: ClaSanitaryFacilitiesDto[];

    constructor(data?: IUpdateClaSanitaryFacilitiesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sanitaryFacilitiesList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["sanitaryFacilitiesList"])) {
                this.sanitaryFacilitiesList = [] as any;
                for (let item of _data["sanitaryFacilitiesList"])
                    this.sanitaryFacilitiesList!.push(ClaSanitaryFacilitiesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaSanitaryFacilitiesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaSanitaryFacilitiesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.sanitaryFacilitiesList)) {
            data["sanitaryFacilitiesList"] = [];
            for (let item of this.sanitaryFacilitiesList)
                data["sanitaryFacilitiesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaSanitaryFacilitiesInput {
    caseId: string;
    sanitaryFacilitiesList: ClaSanitaryFacilitiesDto[];
}

export class UpdateClaSanitaryFacilitiesOutput implements IUpdateClaSanitaryFacilitiesOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaSanitaryFacilitiesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaSanitaryFacilitiesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaSanitaryFacilitiesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaSanitaryFacilitiesOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaSecurityInput implements IUpdateClaSecurityInput {
    caseId!: string;
    securityList!: ClaSecurityDto[];

    constructor(data?: IUpdateClaSecurityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.securityList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["securityList"])) {
                this.securityList = [] as any;
                for (let item of _data["securityList"])
                    this.securityList!.push(ClaSecurityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaSecurityInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaSecurityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.securityList)) {
            data["securityList"] = [];
            for (let item of this.securityList)
                data["securityList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaSecurityInput {
    caseId: string;
    securityList: ClaSecurityDto[];
}

export class UpdateClaSecurityOutput implements IUpdateClaSecurityOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaSecurityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaSecurityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaSecurityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaSecurityOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaServiceAreasInput implements IUpdateClaServiceAreasInput {
    caseId!: string;
    serviceAreasList!: ClaServiceAreasDto[];

    constructor(data?: IUpdateClaServiceAreasInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.serviceAreasList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["serviceAreasList"])) {
                this.serviceAreasList = [] as any;
                for (let item of _data["serviceAreasList"])
                    this.serviceAreasList!.push(ClaServiceAreasDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaServiceAreasInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaServiceAreasInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.serviceAreasList)) {
            data["serviceAreasList"] = [];
            for (let item of this.serviceAreasList)
                data["serviceAreasList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaServiceAreasInput {
    caseId: string;
    serviceAreasList: ClaServiceAreasDto[];
}

export class UpdateClaServiceAreasOutput implements IUpdateClaServiceAreasOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaServiceAreasOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaServiceAreasOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaServiceAreasOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaServiceAreasOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaSponsorshipDirectorsInput implements IUpdateClaSponsorshipDirectorsInput {
    caseId!: string;
    sponsorshipDirectors!: ClaSponsorshipDirectorDto[];

    constructor(data?: IUpdateClaSponsorshipDirectorsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sponsorshipDirectors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["sponsorshipDirectors"])) {
                this.sponsorshipDirectors = [] as any;
                for (let item of _data["sponsorshipDirectors"])
                    this.sponsorshipDirectors!.push(ClaSponsorshipDirectorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaSponsorshipDirectorsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaSponsorshipDirectorsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.sponsorshipDirectors)) {
            data["sponsorshipDirectors"] = [];
            for (let item of this.sponsorshipDirectors)
                data["sponsorshipDirectors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaSponsorshipDirectorsInput {
    caseId: string;
    sponsorshipDirectors: ClaSponsorshipDirectorDto[];
}

export class UpdateClaSponsorshipDirectorsOutput implements IUpdateClaSponsorshipDirectorsOutput {
    status!: ClaStatus;
    directors!: ClaSponsorshipDirectorDto[] | undefined;

    constructor(data?: IUpdateClaSponsorshipDirectorsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["directors"])) {
                this.directors = [] as any;
                for (let item of _data["directors"])
                    this.directors!.push(ClaSponsorshipDirectorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaSponsorshipDirectorsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaSponsorshipDirectorsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.directors)) {
            data["directors"] = [];
            for (let item of this.directors)
                data["directors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaSponsorshipDirectorsOutput {
    status: ClaStatus;
    directors: ClaSponsorshipDirectorDto[] | undefined;
}

export class UpdateClaTreatmentInput implements IUpdateClaTreatmentInput {
    caseId!: string;
    treatmentList!: ClaTreatmentDto[];

    constructor(data?: IUpdateClaTreatmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.treatmentList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["treatmentList"])) {
                this.treatmentList = [] as any;
                for (let item of _data["treatmentList"])
                    this.treatmentList!.push(ClaTreatmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaTreatmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaTreatmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.treatmentList)) {
            data["treatmentList"] = [];
            for (let item of this.treatmentList)
                data["treatmentList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaTreatmentInput {
    caseId: string;
    treatmentList: ClaTreatmentDto[];
}

export class UpdateClaTreatmentOutput implements IUpdateClaTreatmentOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaTreatmentOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaTreatmentOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaTreatmentOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaTreatmentOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaWheelchairAccessibilityInput implements IUpdateClaWheelchairAccessibilityInput {
    caseId!: string;
    wheelchairAccessibilityList!: ClaWheelchairAccessibilityDto[];

    constructor(data?: IUpdateClaWheelchairAccessibilityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.wheelchairAccessibilityList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["wheelchairAccessibilityList"])) {
                this.wheelchairAccessibilityList = [] as any;
                for (let item of _data["wheelchairAccessibilityList"])
                    this.wheelchairAccessibilityList!.push(ClaWheelchairAccessibilityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaWheelchairAccessibilityInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaWheelchairAccessibilityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.wheelchairAccessibilityList)) {
            data["wheelchairAccessibilityList"] = [];
            for (let item of this.wheelchairAccessibilityList)
                data["wheelchairAccessibilityList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaWheelchairAccessibilityInput {
    caseId: string;
    wheelchairAccessibilityList: ClaWheelchairAccessibilityDto[];
}

export class UpdateClaWheelchairAccessibilityOutput implements IUpdateClaWheelchairAccessibilityOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaWheelchairAccessibilityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaWheelchairAccessibilityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaWheelchairAccessibilityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaWheelchairAccessibilityOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateSlasDrugProductionInput implements IUpdateSlasDrugProductionInput {
    caseId!: string;
    drugProductionList!: SlasDrugProductionDto[];

    constructor(data?: IUpdateSlasDrugProductionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.drugProductionList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["drugProductionList"])) {
                this.drugProductionList = [] as any;
                for (let item of _data["drugProductionList"])
                    this.drugProductionList!.push(SlasDrugProductionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasDrugProductionInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasDrugProductionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.drugProductionList)) {
            data["drugProductionList"] = [];
            for (let item of this.drugProductionList)
                data["drugProductionList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasDrugProductionInput {
    caseId: string;
    drugProductionList: SlasDrugProductionDto[];
}

export class UpdateSlasDrugProductionOutput implements IUpdateSlasDrugProductionOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateSlasDrugProductionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasDrugProductionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasDrugProductionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasDrugProductionOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateSlasDrugProductionThirdPartyInput implements IUpdateSlasDrugProductionThirdPartyInput {
    caseId!: string;
    drugProductionThirdPartyList!: SlasDrugProductionThirdPartyDto[];

    constructor(data?: IUpdateSlasDrugProductionThirdPartyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.drugProductionThirdPartyList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["drugProductionThirdPartyList"])) {
                this.drugProductionThirdPartyList = [] as any;
                for (let item of _data["drugProductionThirdPartyList"])
                    this.drugProductionThirdPartyList!.push(SlasDrugProductionThirdPartyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasDrugProductionThirdPartyInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasDrugProductionThirdPartyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.drugProductionThirdPartyList)) {
            data["drugProductionThirdPartyList"] = [];
            for (let item of this.drugProductionThirdPartyList)
                data["drugProductionThirdPartyList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasDrugProductionThirdPartyInput {
    caseId: string;
    drugProductionThirdPartyList: SlasDrugProductionThirdPartyDto[];
}

export class UpdateSlasDrugProductionThirdPartyOutput implements IUpdateSlasDrugProductionThirdPartyOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateSlasDrugProductionThirdPartyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasDrugProductionThirdPartyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasDrugProductionThirdPartyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasDrugProductionThirdPartyOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateSlasLocalDrugSalesInput implements IUpdateSlasLocalDrugSalesInput {
    caseId!: string;
    localDrugSalesList!: SlasLocalDrugSalesDto[];

    constructor(data?: IUpdateSlasLocalDrugSalesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.localDrugSalesList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["localDrugSalesList"])) {
                this.localDrugSalesList = [] as any;
                for (let item of _data["localDrugSalesList"])
                    this.localDrugSalesList!.push(SlasLocalDrugSalesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasLocalDrugSalesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasLocalDrugSalesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.localDrugSalesList)) {
            data["localDrugSalesList"] = [];
            for (let item of this.localDrugSalesList)
                data["localDrugSalesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasLocalDrugSalesInput {
    caseId: string;
    localDrugSalesList: SlasLocalDrugSalesDto[];
}

export class UpdateSlasLocalDrugSalesOutput implements IUpdateSlasLocalDrugSalesOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateSlasLocalDrugSalesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasLocalDrugSalesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasLocalDrugSalesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasLocalDrugSalesOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateSlasProductPreparationInput implements IUpdateSlasProductPreparationInput {
    caseId!: string;
    productPreparationList!: SlasProductPreparationDto[];

    constructor(data?: IUpdateSlasProductPreparationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productPreparationList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["productPreparationList"])) {
                this.productPreparationList = [] as any;
                for (let item of _data["productPreparationList"])
                    this.productPreparationList!.push(SlasProductPreparationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasProductPreparationInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasProductPreparationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.productPreparationList)) {
            data["productPreparationList"] = [];
            for (let item of this.productPreparationList)
                data["productPreparationList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasProductPreparationInput {
    caseId: string;
    productPreparationList: SlasProductPreparationDto[];
}

export class UpdateSlasProductPreparationOutput implements IUpdateSlasProductPreparationOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateSlasProductPreparationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasProductPreparationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasProductPreparationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasProductPreparationOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateSlasRangeOfProductsInput implements IUpdateSlasRangeOfProductsInput {
    caseId!: string;
    rangeOfProductsList!: SlasRangeOfProductsDto[];

    constructor(data?: IUpdateSlasRangeOfProductsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rangeOfProductsList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["rangeOfProductsList"])) {
                this.rangeOfProductsList = [] as any;
                for (let item of _data["rangeOfProductsList"])
                    this.rangeOfProductsList!.push(SlasRangeOfProductsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasRangeOfProductsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasRangeOfProductsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.rangeOfProductsList)) {
            data["rangeOfProductsList"] = [];
            for (let item of this.rangeOfProductsList)
                data["rangeOfProductsList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasRangeOfProductsInput {
    caseId: string;
    rangeOfProductsList: SlasRangeOfProductsDto[];
}

export class UpdateSlasRangeOfProductsOutput implements IUpdateSlasRangeOfProductsOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateSlasRangeOfProductsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasRangeOfProductsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasRangeOfProductsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasRangeOfProductsOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class ClaVaccinationInPharmacyDto implements IClaVaccinationInPharmacyDto {
    vaccinationPlannedId!: string;
    hasPrivateAreaId!: string | undefined;
    hasEquipmentForAnaphylaticReactionId!: string | undefined;
    hasVaccinationProcessPlanId!: string | undefined;
    hasPotentialTransmissionPlanId!: string | undefined;
    hasVaccinationProcessDocumentationId!: string | undefined;
    hasVaccinationInsuranceId!: string | undefined;
    hasVaccinationLicenceId!: string | undefined;

    constructor(data?: IClaVaccinationInPharmacyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vaccinationPlannedId = _data["vaccinationPlannedId"];
            this.hasPrivateAreaId = _data["hasPrivateAreaId"];
            this.hasEquipmentForAnaphylaticReactionId = _data["hasEquipmentForAnaphylaticReactionId"];
            this.hasVaccinationProcessPlanId = _data["hasVaccinationProcessPlanId"];
            this.hasPotentialTransmissionPlanId = _data["hasPotentialTransmissionPlanId"];
            this.hasVaccinationProcessDocumentationId = _data["hasVaccinationProcessDocumentationId"];
            this.hasVaccinationInsuranceId = _data["hasVaccinationInsuranceId"];
            this.hasVaccinationLicenceId = _data["hasVaccinationLicenceId"];
        }
    }

    static fromJS(data: any): ClaVaccinationInPharmacyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaVaccinationInPharmacyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vaccinationPlannedId"] = this.vaccinationPlannedId;
        data["hasPrivateAreaId"] = this.hasPrivateAreaId;
        data["hasEquipmentForAnaphylaticReactionId"] = this.hasEquipmentForAnaphylaticReactionId;
        data["hasVaccinationProcessPlanId"] = this.hasVaccinationProcessPlanId;
        data["hasPotentialTransmissionPlanId"] = this.hasPotentialTransmissionPlanId;
        data["hasVaccinationProcessDocumentationId"] = this.hasVaccinationProcessDocumentationId;
        data["hasVaccinationInsuranceId"] = this.hasVaccinationInsuranceId;
        data["hasVaccinationLicenceId"] = this.hasVaccinationLicenceId;
        return data;
    }
}

export interface IClaVaccinationInPharmacyDto {
    vaccinationPlannedId: string;
    hasPrivateAreaId: string | undefined;
    hasEquipmentForAnaphylaticReactionId: string | undefined;
    hasVaccinationProcessPlanId: string | undefined;
    hasPotentialTransmissionPlanId: string | undefined;
    hasVaccinationProcessDocumentationId: string | undefined;
    hasVaccinationInsuranceId: string | undefined;
    hasVaccinationLicenceId: string | undefined;
}

export class CreateOrUpdateClaVaccinationInPharmacyInput implements ICreateOrUpdateClaVaccinationInPharmacyInput {
    caseId!: string;
    claVaccinationInPharmacy!: ClaVaccinationInPharmacyDto;

    constructor(data?: ICreateOrUpdateClaVaccinationInPharmacyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.claVaccinationInPharmacy = new ClaVaccinationInPharmacyDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.claVaccinationInPharmacy = _data["claVaccinationInPharmacy"] ? ClaVaccinationInPharmacyDto.fromJS(_data["claVaccinationInPharmacy"]) : new ClaVaccinationInPharmacyDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateClaVaccinationInPharmacyInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaVaccinationInPharmacyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["claVaccinationInPharmacy"] = this.claVaccinationInPharmacy ? this.claVaccinationInPharmacy.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateClaVaccinationInPharmacyInput {
    caseId: string;
    claVaccinationInPharmacy: ClaVaccinationInPharmacyDto;
}

export enum CriminalPenaltyDiscriminator {
    Person = 0,
    Sponsorship = 1,
}

export enum CriminalPenaltyRecordDiscriminator {
    Person = 0,
    Sponsorship = 1,
}

export class GetCriminalPenaltyRecordSearchOutputDto implements IGetCriminalPenaltyRecordSearchOutputDto {
    totalCount!: number;
    items!: GetCriminalPenaltyRecordDto[] | undefined;

    constructor(data?: IGetCriminalPenaltyRecordSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCriminalPenaltyRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCriminalPenaltyRecordSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCriminalPenaltyRecordSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCriminalPenaltyRecordSearchOutputDto {
    totalCount: number;
    items: GetCriminalPenaltyRecordDto[] | undefined;
}

export class CreateCriminalPenaltyRecordDto implements ICreateCriminalPenaltyRecordDto {
    discriminator!: CriminalPenaltyRecordDiscriminator;
    type!: string | undefined;
    relevantForLicenceId!: string | undefined;
    ongoingLegalProceeding!: boolean;
    dateOfCriminalPenalty!: DateTime | undefined;
    dateOfLegalForce!: DateTime | undefined;
    dateOfInformation!: DateTime | undefined;
    informationSource!: string | undefined;
    reason!: string | undefined;
    remark!: string | undefined;
    professionId!: string | undefined;
    dateOfDeletionFromTheCriminalRecord!: DateTime | undefined;
    corporateLicenceId!: number | undefined;
    sponsorshipTypeId!: string | undefined;

    constructor(data?: ICreateCriminalPenaltyRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.type = _data["type"];
            this.relevantForLicenceId = _data["relevantForLicenceId"];
            this.ongoingLegalProceeding = _data["ongoingLegalProceeding"];
            this.dateOfCriminalPenalty = _data["dateOfCriminalPenalty"] ? DateTime.fromISO(_data["dateOfCriminalPenalty"].toString()) : <any>undefined;
            this.dateOfLegalForce = _data["dateOfLegalForce"] ? DateTime.fromISO(_data["dateOfLegalForce"].toString()) : <any>undefined;
            this.dateOfInformation = _data["dateOfInformation"] ? DateTime.fromISO(_data["dateOfInformation"].toString()) : <any>undefined;
            this.informationSource = _data["informationSource"];
            this.reason = _data["reason"];
            this.remark = _data["remark"];
            this.professionId = _data["professionId"];
            this.dateOfDeletionFromTheCriminalRecord = _data["dateOfDeletionFromTheCriminalRecord"] ? DateTime.fromISO(_data["dateOfDeletionFromTheCriminalRecord"].toString()) : <any>undefined;
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
        }
    }

    static fromJS(data: any): CreateCriminalPenaltyRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCriminalPenaltyRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["type"] = this.type;
        data["relevantForLicenceId"] = this.relevantForLicenceId;
        data["ongoingLegalProceeding"] = this.ongoingLegalProceeding;
        data["dateOfCriminalPenalty"] = this.dateOfCriminalPenalty ? this.dateOfCriminalPenalty.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfLegalForce"] = this.dateOfLegalForce ? this.dateOfLegalForce.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInformation"] = this.dateOfInformation ? this.dateOfInformation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["informationSource"] = this.informationSource;
        data["reason"] = this.reason;
        data["remark"] = this.remark;
        data["professionId"] = this.professionId;
        data["dateOfDeletionFromTheCriminalRecord"] = this.dateOfDeletionFromTheCriminalRecord ? this.dateOfDeletionFromTheCriminalRecord.toFormat('yyyy-MM-dd') : <any>undefined;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        return data;
    }
}

export interface ICreateCriminalPenaltyRecordDto {
    discriminator: CriminalPenaltyRecordDiscriminator;
    type: string | undefined;
    relevantForLicenceId: string | undefined;
    ongoingLegalProceeding: boolean;
    dateOfCriminalPenalty: DateTime | undefined;
    dateOfLegalForce: DateTime | undefined;
    dateOfInformation: DateTime | undefined;
    informationSource: string | undefined;
    reason: string | undefined;
    remark: string | undefined;
    professionId: string | undefined;
    dateOfDeletionFromTheCriminalRecord: DateTime | undefined;
    corporateLicenceId: number | undefined;
    sponsorshipTypeId: string | undefined;
}

export class GetCriminalPenaltyRecordDto implements IGetCriminalPenaltyRecordDto {
    id!: number;
    discriminator!: CriminalPenaltyRecordDiscriminator;
    type!: string | undefined;
    relevantForLicenceId!: string | undefined;
    ongoingLegalProceeding!: boolean;
    dateOfCriminalPenalty!: DateTime | undefined;
    dateOfLegalForce!: DateTime | undefined;
    dateOfInformation!: DateTime | undefined;
    informationSource!: string | undefined;
    reason!: string | undefined;
    remark!: string | undefined;
    professionId!: string | undefined;
    dateOfDeletionFromTheCriminalRecord!: DateTime | undefined;
    corporateLicenceId!: number | undefined;
    sponsorshipTypeId!: string | undefined;

    constructor(data?: IGetCriminalPenaltyRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.discriminator = _data["discriminator"];
            this.type = _data["type"];
            this.relevantForLicenceId = _data["relevantForLicenceId"];
            this.ongoingLegalProceeding = _data["ongoingLegalProceeding"];
            this.dateOfCriminalPenalty = _data["dateOfCriminalPenalty"] ? DateTime.fromISO(_data["dateOfCriminalPenalty"].toString()) : <any>undefined;
            this.dateOfLegalForce = _data["dateOfLegalForce"] ? DateTime.fromISO(_data["dateOfLegalForce"].toString()) : <any>undefined;
            this.dateOfInformation = _data["dateOfInformation"] ? DateTime.fromISO(_data["dateOfInformation"].toString()) : <any>undefined;
            this.informationSource = _data["informationSource"];
            this.reason = _data["reason"];
            this.remark = _data["remark"];
            this.professionId = _data["professionId"];
            this.dateOfDeletionFromTheCriminalRecord = _data["dateOfDeletionFromTheCriminalRecord"] ? DateTime.fromISO(_data["dateOfDeletionFromTheCriminalRecord"].toString()) : <any>undefined;
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
        }
    }

    static fromJS(data: any): GetCriminalPenaltyRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCriminalPenaltyRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["discriminator"] = this.discriminator;
        data["type"] = this.type;
        data["relevantForLicenceId"] = this.relevantForLicenceId;
        data["ongoingLegalProceeding"] = this.ongoingLegalProceeding;
        data["dateOfCriminalPenalty"] = this.dateOfCriminalPenalty ? this.dateOfCriminalPenalty.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfLegalForce"] = this.dateOfLegalForce ? this.dateOfLegalForce.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInformation"] = this.dateOfInformation ? this.dateOfInformation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["informationSource"] = this.informationSource;
        data["reason"] = this.reason;
        data["remark"] = this.remark;
        data["professionId"] = this.professionId;
        data["dateOfDeletionFromTheCriminalRecord"] = this.dateOfDeletionFromTheCriminalRecord ? this.dateOfDeletionFromTheCriminalRecord.toFormat('yyyy-MM-dd') : <any>undefined;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        return data;
    }
}

export interface IGetCriminalPenaltyRecordDto {
    id: number;
    discriminator: CriminalPenaltyRecordDiscriminator;
    type: string | undefined;
    relevantForLicenceId: string | undefined;
    ongoingLegalProceeding: boolean;
    dateOfCriminalPenalty: DateTime | undefined;
    dateOfLegalForce: DateTime | undefined;
    dateOfInformation: DateTime | undefined;
    informationSource: string | undefined;
    reason: string | undefined;
    remark: string | undefined;
    professionId: string | undefined;
    dateOfDeletionFromTheCriminalRecord: DateTime | undefined;
    corporateLicenceId: number | undefined;
    sponsorshipTypeId: string | undefined;
}

export class UpdateCriminalPenaltyRecordDto implements IUpdateCriminalPenaltyRecordDto {
    type!: string | undefined;
    relevantForLicenceId!: string | undefined;
    ongoingLegalProceeding!: boolean;
    dateOfCriminalPenalty!: DateTime | undefined;
    dateOfLegalForce!: DateTime | undefined;
    dateOfInformation!: DateTime | undefined;
    informationSource!: string | undefined;
    reason!: string | undefined;
    remark!: string | undefined;
    professionId!: string | undefined;
    dateOfDeletionFromTheCriminalRecord!: DateTime | undefined;
    corporateLicenceId!: number | undefined;
    sponsorshipTypeId!: string | undefined;

    constructor(data?: IUpdateCriminalPenaltyRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.relevantForLicenceId = _data["relevantForLicenceId"];
            this.ongoingLegalProceeding = _data["ongoingLegalProceeding"];
            this.dateOfCriminalPenalty = _data["dateOfCriminalPenalty"] ? DateTime.fromISO(_data["dateOfCriminalPenalty"].toString()) : <any>undefined;
            this.dateOfLegalForce = _data["dateOfLegalForce"] ? DateTime.fromISO(_data["dateOfLegalForce"].toString()) : <any>undefined;
            this.dateOfInformation = _data["dateOfInformation"] ? DateTime.fromISO(_data["dateOfInformation"].toString()) : <any>undefined;
            this.informationSource = _data["informationSource"];
            this.reason = _data["reason"];
            this.remark = _data["remark"];
            this.professionId = _data["professionId"];
            this.dateOfDeletionFromTheCriminalRecord = _data["dateOfDeletionFromTheCriminalRecord"] ? DateTime.fromISO(_data["dateOfDeletionFromTheCriminalRecord"].toString()) : <any>undefined;
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
        }
    }

    static fromJS(data: any): UpdateCriminalPenaltyRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCriminalPenaltyRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["relevantForLicenceId"] = this.relevantForLicenceId;
        data["ongoingLegalProceeding"] = this.ongoingLegalProceeding;
        data["dateOfCriminalPenalty"] = this.dateOfCriminalPenalty ? this.dateOfCriminalPenalty.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfLegalForce"] = this.dateOfLegalForce ? this.dateOfLegalForce.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInformation"] = this.dateOfInformation ? this.dateOfInformation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["informationSource"] = this.informationSource;
        data["reason"] = this.reason;
        data["remark"] = this.remark;
        data["professionId"] = this.professionId;
        data["dateOfDeletionFromTheCriminalRecord"] = this.dateOfDeletionFromTheCriminalRecord ? this.dateOfDeletionFromTheCriminalRecord.toFormat('yyyy-MM-dd') : <any>undefined;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        return data;
    }
}

export interface IUpdateCriminalPenaltyRecordDto {
    type: string | undefined;
    relevantForLicenceId: string | undefined;
    ongoingLegalProceeding: boolean;
    dateOfCriminalPenalty: DateTime | undefined;
    dateOfLegalForce: DateTime | undefined;
    dateOfInformation: DateTime | undefined;
    informationSource: string | undefined;
    reason: string | undefined;
    remark: string | undefined;
    professionId: string | undefined;
    dateOfDeletionFromTheCriminalRecord: DateTime | undefined;
    corporateLicenceId: number | undefined;
    sponsorshipTypeId: string | undefined;
}

export class LicenceApplicationResponsibleStatisticDto implements ILicenceApplicationResponsibleStatisticDto {
    submitted!: number;
    underEvaluation!: number;
    formallyEvaluated!: number;
    underSupplementalClaim!: number;

    constructor(data?: ILicenceApplicationResponsibleStatisticDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submitted = _data["submitted"];
            this.underEvaluation = _data["underEvaluation"];
            this.formallyEvaluated = _data["formallyEvaluated"];
            this.underSupplementalClaim = _data["underSupplementalClaim"];
        }
    }

    static fromJS(data: any): LicenceApplicationResponsibleStatisticDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceApplicationResponsibleStatisticDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submitted"] = this.submitted;
        data["underEvaluation"] = this.underEvaluation;
        data["formallyEvaluated"] = this.formallyEvaluated;
        data["underSupplementalClaim"] = this.underSupplementalClaim;
        return data;
    }
}

export interface ILicenceApplicationResponsibleStatisticDto {
    submitted: number;
    underEvaluation: number;
    formallyEvaluated: number;
    underSupplementalClaim: number;
}

export class LicenceApplicationStatisticDto implements ILicenceApplicationStatisticDto {
    date!: DateTime[] | undefined;
    submitted!: number[] | undefined;
    underEvaluation!: number[] | undefined;
    formallyEvaluated!: number[] | undefined;
    underSupplementalClaim!: number[] | undefined;
    granted!: number[] | undefined;
    denied!: number[] | undefined;

    constructor(data?: ILicenceApplicationStatisticDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["date"])) {
                this.date = [] as any;
                for (let item of _data["date"])
                    this.date!.push(DateTime.fromISO(item));
            }
            if (Array.isArray(_data["submitted"])) {
                this.submitted = [] as any;
                for (let item of _data["submitted"])
                    this.submitted!.push(item);
            }
            if (Array.isArray(_data["underEvaluation"])) {
                this.underEvaluation = [] as any;
                for (let item of _data["underEvaluation"])
                    this.underEvaluation!.push(item);
            }
            if (Array.isArray(_data["formallyEvaluated"])) {
                this.formallyEvaluated = [] as any;
                for (let item of _data["formallyEvaluated"])
                    this.formallyEvaluated!.push(item);
            }
            if (Array.isArray(_data["underSupplementalClaim"])) {
                this.underSupplementalClaim = [] as any;
                for (let item of _data["underSupplementalClaim"])
                    this.underSupplementalClaim!.push(item);
            }
            if (Array.isArray(_data["granted"])) {
                this.granted = [] as any;
                for (let item of _data["granted"])
                    this.granted!.push(item);
            }
            if (Array.isArray(_data["denied"])) {
                this.denied = [] as any;
                for (let item of _data["denied"])
                    this.denied!.push(item);
            }
        }
    }

    static fromJS(data: any): LicenceApplicationStatisticDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceApplicationStatisticDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.date)) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item.toString());
        }
        if (Array.isArray(this.submitted)) {
            data["submitted"] = [];
            for (let item of this.submitted)
                data["submitted"].push(item);
        }
        if (Array.isArray(this.underEvaluation)) {
            data["underEvaluation"] = [];
            for (let item of this.underEvaluation)
                data["underEvaluation"].push(item);
        }
        if (Array.isArray(this.formallyEvaluated)) {
            data["formallyEvaluated"] = [];
            for (let item of this.formallyEvaluated)
                data["formallyEvaluated"].push(item);
        }
        if (Array.isArray(this.underSupplementalClaim)) {
            data["underSupplementalClaim"] = [];
            for (let item of this.underSupplementalClaim)
                data["underSupplementalClaim"].push(item);
        }
        if (Array.isArray(this.granted)) {
            data["granted"] = [];
            for (let item of this.granted)
                data["granted"].push(item);
        }
        if (Array.isArray(this.denied)) {
            data["denied"] = [];
            for (let item of this.denied)
                data["denied"].push(item);
        }
        return data;
    }
}

export interface ILicenceApplicationStatisticDto {
    date: DateTime[] | undefined;
    submitted: number[] | undefined;
    underEvaluation: number[] | undefined;
    formallyEvaluated: number[] | undefined;
    underSupplementalClaim: number[] | undefined;
    granted: number[] | undefined;
    denied: number[] | undefined;
}

export class OwnResponsobilityEntityDto implements IOwnResponsobilityEntityDto {
    id!: number;
    caseId!: string | undefined;
    type!: OwnResponsobilityEntityType;
    designator!: string | undefined;
    email!: string | undefined;
    additionalInformation!: string | undefined;
    applicationStatus!: ApplicationStatus;
    identificationStatus!: string | undefined;
    dateOfStatusChange!: DateTime;

    constructor(data?: IOwnResponsobilityEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.type = _data["type"];
            this.designator = _data["designator"];
            this.email = _data["email"];
            this.additionalInformation = _data["additionalInformation"];
            this.applicationStatus = _data["applicationStatus"];
            this.identificationStatus = _data["identificationStatus"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OwnResponsobilityEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new OwnResponsobilityEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["type"] = this.type;
        data["designator"] = this.designator;
        data["email"] = this.email;
        data["additionalInformation"] = this.additionalInformation;
        data["applicationStatus"] = this.applicationStatus;
        data["identificationStatus"] = this.identificationStatus;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toString() : <any>undefined;
        return data;
    }
}

export interface IOwnResponsobilityEntityDto {
    id: number;
    caseId: string | undefined;
    type: OwnResponsobilityEntityType;
    designator: string | undefined;
    email: string | undefined;
    additionalInformation: string | undefined;
    applicationStatus: ApplicationStatus;
    identificationStatus: string | undefined;
    dateOfStatusChange: DateTime;
}

export enum OwnResponsobilityEntityType {
    Lia = 0,
    Identification = 1,
}

export class DetailsDto implements IDetailsDto {
    detailId!: string | undefined;

    constructor(data?: IDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.detailId = _data["detailId"];
        }
    }

    static fromJS(data: any): DetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detailId"] = this.detailId;
        return data;
    }
}

export interface IDetailsDto {
    detailId: string | undefined;
}

export class PersonLicenceDetails implements IPersonLicenceDetails {
    detailId!: string | undefined;
    personLicence!: PersonLicence;
    personLicenceId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IPersonLicenceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.detailId = _data["detailId"];
            this.personLicence = _data["personLicence"] ? PersonLicence.fromJS(_data["personLicence"]) : <any>undefined;
            this.personLicenceId = _data["personLicenceId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PersonLicenceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PersonLicenceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detailId"] = this.detailId;
        data["personLicence"] = this.personLicence ? this.personLicence.toJSON() : <any>undefined;
        data["personLicenceId"] = this.personLicenceId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPersonLicenceDetails {
    detailId: string | undefined;
    personLicence: PersonLicence;
    personLicenceId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class Diploma implements IDiploma {
    personId!: number;
    person!: Person;
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    overwriteWithHealthRegisterData!: boolean;
    profession!: Code;
    professionId!: string | undefined;
    nonHealthRegProfession!: string | undefined;
    type!: Code;
    typeId!: string | undefined;
    placeOfIssue!: string | undefined;
    country!: Code;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    placeOfRecognition!: string | undefined;
    recognitionAuthority!: string | undefined;
    dateOfRegistration!: DateTime | undefined;
    registerNumber!: string | undefined;
    dateOfEquivalence!: DateTime | undefined;
    remark!: string | undefined;
    migrationData!: MigrationData[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDiploma) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.type = new Code();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.overwriteWithHealthRegisterData = _data["overwriteWithHealthRegisterData"];
            this.profession = _data["profession"] ? Code.fromJS(_data["profession"]) : <any>undefined;
            this.professionId = _data["professionId"];
            this.nonHealthRegProfession = _data["nonHealthRegProfession"];
            this.type = _data["type"] ? Code.fromJS(_data["type"]) : new Code();
            this.typeId = _data["typeId"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.country = _data["country"] ? Code.fromJS(_data["country"]) : <any>undefined;
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.placeOfRecognition = _data["placeOfRecognition"];
            this.recognitionAuthority = _data["recognitionAuthority"];
            this.dateOfRegistration = _data["dateOfRegistration"] ? DateTime.fromISO(_data["dateOfRegistration"].toString()) : <any>undefined;
            this.registerNumber = _data["registerNumber"];
            this.dateOfEquivalence = _data["dateOfEquivalence"] ? DateTime.fromISO(_data["dateOfEquivalence"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Diploma {
        data = typeof data === 'object' ? data : {};
        let result = new Diploma();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["overwriteWithHealthRegisterData"] = this.overwriteWithHealthRegisterData;
        data["profession"] = this.profession ? this.profession.toJSON() : <any>undefined;
        data["professionId"] = this.professionId;
        data["nonHealthRegProfession"] = this.nonHealthRegProfession;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["placeOfIssue"] = this.placeOfIssue;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfRecognition"] = this.placeOfRecognition;
        data["recognitionAuthority"] = this.recognitionAuthority;
        data["dateOfRegistration"] = this.dateOfRegistration ? this.dateOfRegistration.toFormat('yyyy-MM-dd') : <any>undefined;
        data["registerNumber"] = this.registerNumber;
        data["dateOfEquivalence"] = this.dateOfEquivalence ? this.dateOfEquivalence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiploma {
    personId: number;
    person: Person;
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    overwriteWithHealthRegisterData: boolean;
    profession: Code;
    professionId: string | undefined;
    nonHealthRegProfession: string | undefined;
    type: Code;
    typeId: string | undefined;
    placeOfIssue: string | undefined;
    country: Code;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    placeOfRecognition: string | undefined;
    recognitionAuthority: string | undefined;
    dateOfRegistration: DateTime | undefined;
    registerNumber: string | undefined;
    dateOfEquivalence: DateTime | undefined;
    remark: string | undefined;
    migrationData: MigrationData[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CreateDiplomaDto implements ICreateDiplomaDto {
    personId!: number;
    professionId!: string;
    nonHealthRegProfession!: string | undefined;
    typeId!: string;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    placeOfRecognition!: string | undefined;
    recognitionAuthority!: string | undefined;
    dateOfRegistration!: DateTime | undefined;
    registerNumber!: string | undefined;
    dateOfEquivalence!: DateTime | undefined;
    overwriteWithHealthRegisterData!: boolean;
    remark!: string | undefined;

    constructor(data?: ICreateDiplomaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.professionId = _data["professionId"];
            this.nonHealthRegProfession = _data["nonHealthRegProfession"];
            this.typeId = _data["typeId"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.placeOfRecognition = _data["placeOfRecognition"];
            this.recognitionAuthority = _data["recognitionAuthority"];
            this.dateOfRegistration = _data["dateOfRegistration"] ? DateTime.fromISO(_data["dateOfRegistration"].toString()) : <any>undefined;
            this.registerNumber = _data["registerNumber"];
            this.dateOfEquivalence = _data["dateOfEquivalence"] ? DateTime.fromISO(_data["dateOfEquivalence"].toString()) : <any>undefined;
            this.overwriteWithHealthRegisterData = _data["overwriteWithHealthRegisterData"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): CreateDiplomaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDiplomaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["professionId"] = this.professionId;
        data["nonHealthRegProfession"] = this.nonHealthRegProfession;
        data["typeId"] = this.typeId;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfRecognition"] = this.placeOfRecognition;
        data["recognitionAuthority"] = this.recognitionAuthority;
        data["dateOfRegistration"] = this.dateOfRegistration ? this.dateOfRegistration.toFormat('yyyy-MM-dd') : <any>undefined;
        data["registerNumber"] = this.registerNumber;
        data["dateOfEquivalence"] = this.dateOfEquivalence ? this.dateOfEquivalence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["overwriteWithHealthRegisterData"] = this.overwriteWithHealthRegisterData;
        data["remark"] = this.remark;
        return data;
    }
}

export interface ICreateDiplomaDto {
    personId: number;
    professionId: string;
    nonHealthRegProfession: string | undefined;
    typeId: string;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    placeOfRecognition: string | undefined;
    recognitionAuthority: string | undefined;
    dateOfRegistration: DateTime | undefined;
    registerNumber: string | undefined;
    dateOfEquivalence: DateTime | undefined;
    overwriteWithHealthRegisterData: boolean;
    remark: string | undefined;
}

export class DiplomaDto implements IDiplomaDto {
    professionId!: string;
    nonHealthRegProfession!: string | undefined;
    typeId!: string;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    placeOfRecognition!: string | undefined;
    recognitionAuthority!: string | undefined;
    dateOfRegistration!: DateTime | undefined;
    registerNumber!: string | undefined;
    dateOfEquivalence!: DateTime | undefined;
    overwriteWithHealthRegisterData!: boolean;
    remark!: string | undefined;

    constructor(data?: IDiplomaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.nonHealthRegProfession = _data["nonHealthRegProfession"];
            this.typeId = _data["typeId"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.placeOfRecognition = _data["placeOfRecognition"];
            this.recognitionAuthority = _data["recognitionAuthority"];
            this.dateOfRegistration = _data["dateOfRegistration"] ? DateTime.fromISO(_data["dateOfRegistration"].toString()) : <any>undefined;
            this.registerNumber = _data["registerNumber"];
            this.dateOfEquivalence = _data["dateOfEquivalence"] ? DateTime.fromISO(_data["dateOfEquivalence"].toString()) : <any>undefined;
            this.overwriteWithHealthRegisterData = _data["overwriteWithHealthRegisterData"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): DiplomaDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiplomaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["nonHealthRegProfession"] = this.nonHealthRegProfession;
        data["typeId"] = this.typeId;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfRecognition"] = this.placeOfRecognition;
        data["recognitionAuthority"] = this.recognitionAuthority;
        data["dateOfRegistration"] = this.dateOfRegistration ? this.dateOfRegistration.toFormat('yyyy-MM-dd') : <any>undefined;
        data["registerNumber"] = this.registerNumber;
        data["dateOfEquivalence"] = this.dateOfEquivalence ? this.dateOfEquivalence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["overwriteWithHealthRegisterData"] = this.overwriteWithHealthRegisterData;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IDiplomaDto {
    professionId: string;
    nonHealthRegProfession: string | undefined;
    typeId: string;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    placeOfRecognition: string | undefined;
    recognitionAuthority: string | undefined;
    dateOfRegistration: DateTime | undefined;
    registerNumber: string | undefined;
    dateOfEquivalence: DateTime | undefined;
    overwriteWithHealthRegisterData: boolean;
    remark: string | undefined;
}

export class DiplomaSearchResultDto implements IDiplomaSearchResultDto {
    id!: number;
    professionId!: string | undefined;
    nonHealthRegProfession!: string | undefined;
    typeId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    remark!: string | undefined;

    constructor(data?: IDiplomaSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.professionId = _data["professionId"];
            this.nonHealthRegProfession = _data["nonHealthRegProfession"];
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): DiplomaSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiplomaSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["professionId"] = this.professionId;
        data["nonHealthRegProfession"] = this.nonHealthRegProfession;
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IDiplomaSearchResultDto {
    id: number;
    professionId: string | undefined;
    nonHealthRegProfession: string | undefined;
    typeId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    remark: string | undefined;
}

export class GetDiplomaSearchOutput implements IGetDiplomaSearchOutput {
    totalCount!: number;
    items!: DiplomaSearchResultDto[] | undefined;

    constructor(data?: IGetDiplomaSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DiplomaSearchResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDiplomaSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiplomaSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDiplomaSearchOutput {
    totalCount: number;
    items: DiplomaSearchResultDto[] | undefined;
}

export class CreateDocumentDto implements ICreateDocumentDto {
    typeId!: string | undefined;
    categoryId!: string | undefined;
    name!: string;
    description!: string | undefined;
    dateOfReceipt!: DateTime;
    datedFrom!: DateTime | undefined;
    data!: string;
    links!: LinkDto[];

    constructor(data?: ICreateDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.links = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.dateOfReceipt = _data["dateOfReceipt"] ? DateTime.fromISO(_data["dateOfReceipt"].toString()) : <any>undefined;
            this.datedFrom = _data["datedFrom"] ? DateTime.fromISO(_data["datedFrom"].toString()) : <any>undefined;
            this.data = _data["data"];
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(LinkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["dateOfReceipt"] = this.dateOfReceipt ? this.dateOfReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datedFrom"] = this.datedFrom ? this.datedFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        data["data"] = this.data;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateDocumentDto {
    typeId: string | undefined;
    categoryId: string | undefined;
    name: string;
    description: string | undefined;
    dateOfReceipt: DateTime;
    datedFrom: DateTime | undefined;
    data: string;
    links: LinkDto[];
}

export class DmsLinkDescriptionDto implements IDmsLinkDescriptionDto {
    entityId!: number;
    discriminator!: string | undefined;
    description!: string | undefined;
    additionalData!: { [key: string]: any; } | undefined;

    constructor(data?: IDmsLinkDescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.discriminator = _data["discriminator"];
            this.description = _data["description"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (<any>this.additionalData)![key] = _data["additionalData"][key];
                }
            }
        }
    }

    static fromJS(data: any): DmsLinkDescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DmsLinkDescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["discriminator"] = this.discriminator;
        data["description"] = this.description;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (<any>data["additionalData"])[key] = (<any>this.additionalData)[key];
            }
        }
        return data;
    }
}

export interface IDmsLinkDescriptionDto {
    entityId: number;
    discriminator: string | undefined;
    description: string | undefined;
    additionalData: { [key: string]: any; } | undefined;
}

export class DmsSearchResultDto implements IDmsSearchResultDto {
    externalId!: string | undefined;
    typeId!: string | undefined;
    categoryId!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    context!: string | undefined;
    dateOfReceipt!: DateTime;
    datedFrom!: DateTime | undefined;
    mimeHeader!: string | undefined;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: DateTime;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    decreeDateOfSend!: DateTime | undefined;
    links!: DmsLinkDescriptionDto[] | undefined;
    id!: number;

    constructor(data?: IDmsSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.typeId = _data["typeId"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.context = _data["context"];
            this.dateOfReceipt = _data["dateOfReceipt"] ? DateTime.fromISO(_data["dateOfReceipt"].toString()) : <any>undefined;
            this.datedFrom = _data["datedFrom"] ? DateTime.fromISO(_data["datedFrom"].toString()) : <any>undefined;
            this.mimeHeader = _data["mimeHeader"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.decreeDateOfSend = _data["decreeDateOfSend"] ? DateTime.fromISO(_data["decreeDateOfSend"].toString()) : <any>undefined;
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(DmsLinkDescriptionDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DmsSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DmsSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["typeId"] = this.typeId;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["context"] = this.context;
        data["dateOfReceipt"] = this.dateOfReceipt ? this.dateOfReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datedFrom"] = this.datedFrom ? this.datedFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        data["mimeHeader"] = this.mimeHeader;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toFormat('yyyy-MM-dd') : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toFormat('yyyy-MM-dd') : <any>undefined;
        data["decreeDateOfSend"] = this.decreeDateOfSend ? this.decreeDateOfSend.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IDmsSearchResultDto {
    externalId: string | undefined;
    typeId: string | undefined;
    categoryId: string | undefined;
    name: string | undefined;
    description: string | undefined;
    context: string | undefined;
    dateOfReceipt: DateTime;
    datedFrom: DateTime | undefined;
    mimeHeader: string | undefined;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: DateTime;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: DateTime | undefined;
    decreeDateOfSend: DateTime | undefined;
    links: DmsLinkDescriptionDto[] | undefined;
    id: number;
}

export class DocumentDecreeDto implements IDocumentDecreeDto {
    dateOfSend!: DateTime | undefined;
    dateOfDeliveryReceipt!: DateTime | undefined;
    dateOfPickupReceipt!: DateTime | undefined;
    dateOfExpirationReceipt!: DateTime | undefined;

    constructor(data?: IDocumentDecreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfSend = _data["dateOfSend"] ? DateTime.fromISO(_data["dateOfSend"].toString()) : <any>undefined;
            this.dateOfDeliveryReceipt = _data["dateOfDeliveryReceipt"] ? DateTime.fromISO(_data["dateOfDeliveryReceipt"].toString()) : <any>undefined;
            this.dateOfPickupReceipt = _data["dateOfPickupReceipt"] ? DateTime.fromISO(_data["dateOfPickupReceipt"].toString()) : <any>undefined;
            this.dateOfExpirationReceipt = _data["dateOfExpirationReceipt"] ? DateTime.fromISO(_data["dateOfExpirationReceipt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentDecreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDecreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfSend"] = this.dateOfSend ? this.dateOfSend.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDeliveryReceipt"] = this.dateOfDeliveryReceipt ? this.dateOfDeliveryReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfPickupReceipt"] = this.dateOfPickupReceipt ? this.dateOfPickupReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfExpirationReceipt"] = this.dateOfExpirationReceipt ? this.dateOfExpirationReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IDocumentDecreeDto {
    dateOfSend: DateTime | undefined;
    dateOfDeliveryReceipt: DateTime | undefined;
    dateOfPickupReceipt: DateTime | undefined;
    dateOfExpirationReceipt: DateTime | undefined;
}

export class GetDmsSearchInput implements IGetDmsSearchInput {
    fullTextSearch!: string | undefined;
    link!: LinkDto;
    mustContainReferenceLink!: boolean;
    documentIdsToExclude!: number[] | undefined;
    allowedTypeIds!: string[] | undefined;
    entitySearchDiscriminator!: string | undefined;
    entitySearchTerm!: string | undefined;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IGetDmsSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullTextSearch = _data["fullTextSearch"];
            this.link = _data["link"] ? LinkDto.fromJS(_data["link"]) : <any>undefined;
            this.mustContainReferenceLink = _data["mustContainReferenceLink"];
            if (Array.isArray(_data["documentIdsToExclude"])) {
                this.documentIdsToExclude = [] as any;
                for (let item of _data["documentIdsToExclude"])
                    this.documentIdsToExclude!.push(item);
            }
            if (Array.isArray(_data["allowedTypeIds"])) {
                this.allowedTypeIds = [] as any;
                for (let item of _data["allowedTypeIds"])
                    this.allowedTypeIds!.push(item);
            }
            this.entitySearchDiscriminator = _data["entitySearchDiscriminator"];
            this.entitySearchTerm = _data["entitySearchTerm"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetDmsSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDmsSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullTextSearch"] = this.fullTextSearch;
        data["link"] = this.link ? this.link.toJSON() : <any>undefined;
        data["mustContainReferenceLink"] = this.mustContainReferenceLink;
        if (Array.isArray(this.documentIdsToExclude)) {
            data["documentIdsToExclude"] = [];
            for (let item of this.documentIdsToExclude)
                data["documentIdsToExclude"].push(item);
        }
        if (Array.isArray(this.allowedTypeIds)) {
            data["allowedTypeIds"] = [];
            for (let item of this.allowedTypeIds)
                data["allowedTypeIds"].push(item);
        }
        data["entitySearchDiscriminator"] = this.entitySearchDiscriminator;
        data["entitySearchTerm"] = this.entitySearchTerm;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IGetDmsSearchInput {
    fullTextSearch: string | undefined;
    link: LinkDto;
    mustContainReferenceLink: boolean;
    documentIdsToExclude: number[] | undefined;
    allowedTypeIds: string[] | undefined;
    entitySearchDiscriminator: string | undefined;
    entitySearchTerm: string | undefined;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class GetDmsSearchOutput implements IGetDmsSearchOutput {
    totalCount!: number;
    items!: DmsSearchResultDto[] | undefined;

    constructor(data?: IGetDmsSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DmsSearchResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDmsSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDmsSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDmsSearchOutput {
    totalCount: number;
    items: DmsSearchResultDto[] | undefined;
}

export class GetDocumentDto implements IGetDocumentDto {
    externalId!: string | undefined;
    typeId!: string | undefined;
    categoryId!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    context!: string | undefined;
    dateOfReceipt!: DateTime;
    datedFrom!: DateTime | undefined;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: DateTime;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    decree!: DocumentDecreeDto;
    mimeType!: string | undefined;
    links!: DmsLinkDescriptionDto[] | undefined;
    id!: number;

    constructor(data?: IGetDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.typeId = _data["typeId"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.context = _data["context"];
            this.dateOfReceipt = _data["dateOfReceipt"] ? DateTime.fromISO(_data["dateOfReceipt"].toString()) : <any>undefined;
            this.datedFrom = _data["datedFrom"] ? DateTime.fromISO(_data["datedFrom"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.decree = _data["decree"] ? DocumentDecreeDto.fromJS(_data["decree"]) : <any>undefined;
            this.mimeType = _data["mimeType"];
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(DmsLinkDescriptionDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["typeId"] = this.typeId;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["context"] = this.context;
        data["dateOfReceipt"] = this.dateOfReceipt ? this.dateOfReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datedFrom"] = this.datedFrom ? this.datedFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["decree"] = this.decree ? this.decree.toJSON() : <any>undefined;
        data["mimeType"] = this.mimeType;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGetDocumentDto {
    externalId: string | undefined;
    typeId: string | undefined;
    categoryId: string | undefined;
    name: string | undefined;
    description: string | undefined;
    context: string | undefined;
    dateOfReceipt: DateTime;
    datedFrom: DateTime | undefined;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: DateTime;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: DateTime | undefined;
    decree: DocumentDecreeDto;
    mimeType: string | undefined;
    links: DmsLinkDescriptionDto[] | undefined;
    id: number;
}

export class LinkDto implements ILinkDto {
    discriminator!: string;
    entityId!: number;

    constructor(data?: ILinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any): LinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["entityId"] = this.entityId;
        return data;
    }
}

export interface ILinkDto {
    discriminator: string;
    entityId: number;
}

export class ScanImportFileDto implements IScanImportFileDto {
    filename!: string;
    file!: string;

    constructor(data?: IScanImportFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["filename"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): ScanImportFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScanImportFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["file"] = this.file;
        return data;
    }
}

export interface IScanImportFileDto {
    filename: string;
    file: string;
}

export class CreateUpdateFileDto implements ICreateUpdateFileDto {
    filename!: string;
    file!: string;

    constructor(data?: ICreateUpdateFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["filename"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): CreateUpdateFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["file"] = this.file;
        return data;
    }
}

export interface ICreateUpdateFileDto {
    filename: string;
    file: string;
}

export class CreateUpdateTemplateDto implements ICreateUpdateTemplateDto {
    typeId!: string | undefined;
    designation!: string;
    professionId!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    externalTemplateId!: string | undefined;
    file!: CreateUpdateFileDto;

    constructor(data?: ICreateUpdateTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.designation = _data["designation"];
            this.professionId = _data["professionId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.externalTemplateId = _data["externalTemplateId"];
            this.file = _data["file"] ? CreateUpdateFileDto.fromJS(_data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateUpdateTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["designation"] = this.designation;
        data["professionId"] = this.professionId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["externalTemplateId"] = this.externalTemplateId;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateUpdateTemplateDto {
    typeId: string | undefined;
    designation: string;
    professionId: string | undefined;
    sponsorshipTypeId: string | undefined;
    externalTemplateId: string | undefined;
    file: CreateUpdateFileDto;
}

export class DmsTemplateEntityDto implements IDmsTemplateEntityDto {
    id!: number;
    type!: string | undefined;
    selectableEntityType!: DmsTemplateSelectableEntityType;
    subEntities!: DmsTemplateEntityDto[] | undefined;

    constructor(data?: IDmsTemplateEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.selectableEntityType = _data["selectableEntityType"];
            if (Array.isArray(_data["subEntities"])) {
                this.subEntities = [] as any;
                for (let item of _data["subEntities"])
                    this.subEntities!.push(DmsTemplateEntityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DmsTemplateEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new DmsTemplateEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["selectableEntityType"] = this.selectableEntityType;
        if (Array.isArray(this.subEntities)) {
            data["subEntities"] = [];
            for (let item of this.subEntities)
                data["subEntities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDmsTemplateEntityDto {
    id: number;
    type: string | undefined;
    selectableEntityType: DmsTemplateSelectableEntityType;
    subEntities: DmsTemplateEntityDto[] | undefined;
}

export class DmsTemplateSelectableEntityDto implements IDmsTemplateSelectableEntityDto {
    entity!: DmsTemplateEntityDto;
    description!: string | undefined;

    constructor(data?: IDmsTemplateSelectableEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entity = _data["entity"] ? DmsTemplateEntityDto.fromJS(_data["entity"]) : <any>undefined;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DmsTemplateSelectableEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new DmsTemplateSelectableEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["description"] = this.description;
        return data;
    }
}

export interface IDmsTemplateSelectableEntityDto {
    entity: DmsTemplateEntityDto;
    description: string | undefined;
}

export class GenerateDocumentFromTemplateInputDto implements IGenerateDocumentFromTemplateInputDto {
    documentTemplateId!: number;
    selectedEntities!: DmsTemplateEntityDto[];
    links!: LinkDto[];
    generatePreviewXml!: boolean;

    constructor(data?: IGenerateDocumentFromTemplateInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectedEntities = [];
            this.links = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTemplateId = _data["documentTemplateId"];
            if (Array.isArray(_data["selectedEntities"])) {
                this.selectedEntities = [] as any;
                for (let item of _data["selectedEntities"])
                    this.selectedEntities!.push(DmsTemplateEntityDto.fromJS(item));
            }
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(LinkDto.fromJS(item));
            }
            this.generatePreviewXml = _data["generatePreviewXml"];
        }
    }

    static fromJS(data: any): GenerateDocumentFromTemplateInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateDocumentFromTemplateInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTemplateId"] = this.documentTemplateId;
        if (Array.isArray(this.selectedEntities)) {
            data["selectedEntities"] = [];
            for (let item of this.selectedEntities)
                data["selectedEntities"].push(item.toJSON());
        }
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        data["generatePreviewXml"] = this.generatePreviewXml;
        return data;
    }
}

export interface IGenerateDocumentFromTemplateInputDto {
    documentTemplateId: number;
    selectedEntities: DmsTemplateEntityDto[];
    links: LinkDto[];
    generatePreviewXml: boolean;
}

export class GenerateDocumentFromTemplateResultDto implements IGenerateDocumentFromTemplateResultDto {
    documentId!: number;
    xmlData!: string | undefined;

    constructor(data?: IGenerateDocumentFromTemplateResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.xmlData = _data["xmlData"];
        }
    }

    static fromJS(data: any): GenerateDocumentFromTemplateResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateDocumentFromTemplateResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["xmlData"] = this.xmlData;
        return data;
    }
}

export interface IGenerateDocumentFromTemplateResultDto {
    documentId: number;
    xmlData: string | undefined;
}

export class GenerateFromTemplateDiscriminatorInputDto implements IGenerateFromTemplateDiscriminatorInputDto {
    documentTemplateDiscriminator!: string;
    selectedEntities!: DmsTemplateEntityDto[] | undefined;
    links!: LinkDto[];
    generatePreviewXml!: boolean;

    constructor(data?: IGenerateFromTemplateDiscriminatorInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.links = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTemplateDiscriminator = _data["documentTemplateDiscriminator"];
            if (Array.isArray(_data["selectedEntities"])) {
                this.selectedEntities = [] as any;
                for (let item of _data["selectedEntities"])
                    this.selectedEntities!.push(DmsTemplateEntityDto.fromJS(item));
            }
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(LinkDto.fromJS(item));
            }
            this.generatePreviewXml = _data["generatePreviewXml"];
        }
    }

    static fromJS(data: any): GenerateFromTemplateDiscriminatorInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateFromTemplateDiscriminatorInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTemplateDiscriminator"] = this.documentTemplateDiscriminator;
        if (Array.isArray(this.selectedEntities)) {
            data["selectedEntities"] = [];
            for (let item of this.selectedEntities)
                data["selectedEntities"].push(item.toJSON());
        }
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        data["generatePreviewXml"] = this.generatePreviewXml;
        return data;
    }
}

export interface IGenerateFromTemplateDiscriminatorInputDto {
    documentTemplateDiscriminator: string;
    selectedEntities: DmsTemplateEntityDto[] | undefined;
    links: LinkDto[];
    generatePreviewXml: boolean;
}

export class GetTemplateDto implements IGetTemplateDto {
    discriminator!: string | undefined;
    typeId!: string | undefined;
    designation!: string;
    name!: string | undefined;
    mimeHeader!: string | undefined;
    externalTemplateId!: string | undefined;
    professionId!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    creationTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    id!: number;

    constructor(data?: IGetTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.typeId = _data["typeId"];
            this.designation = _data["designation"];
            this.name = _data["name"];
            this.mimeHeader = _data["mimeHeader"];
            this.externalTemplateId = _data["externalTemplateId"];
            this.professionId = _data["professionId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["typeId"] = this.typeId;
        data["designation"] = this.designation;
        data["name"] = this.name;
        data["mimeHeader"] = this.mimeHeader;
        data["externalTemplateId"] = this.externalTemplateId;
        data["professionId"] = this.professionId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetTemplateDto {
    discriminator: string | undefined;
    typeId: string | undefined;
    designation: string;
    name: string | undefined;
    mimeHeader: string | undefined;
    externalTemplateId: string | undefined;
    professionId: string | undefined;
    sponsorshipTypeId: string | undefined;
    creationTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    id: number;
}

export class SearchTemplateOutput implements ISearchTemplateOutput {
    totalCount!: number;
    items!: GetTemplateDto[] | undefined;

    constructor(data?: ISearchTemplateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTemplateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchTemplateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTemplateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchTemplateOutput {
    totalCount: number;
    items: GetTemplateDto[] | undefined;
}

export class SearchTemplatesInput implements ISearchTemplatesInput {
    discriminator!: string;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: ISearchTemplatesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): SearchTemplatesInput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTemplatesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface ISearchTemplatesInput {
    discriminator: string;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class UpdateDocumentDto implements IUpdateDocumentDto {
    typeId!: string | undefined;
    categoryId!: string | undefined;
    name!: string;
    description!: string | undefined;
    dateOfReceipt!: DateTime;
    datedFrom!: DateTime | undefined;

    constructor(data?: IUpdateDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.dateOfReceipt = _data["dateOfReceipt"] ? DateTime.fromISO(_data["dateOfReceipt"].toString()) : <any>undefined;
            this.datedFrom = _data["datedFrom"] ? DateTime.fromISO(_data["datedFrom"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["dateOfReceipt"] = this.dateOfReceipt ? this.dateOfReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datedFrom"] = this.datedFrom ? this.datedFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IUpdateDocumentDto {
    typeId: string | undefined;
    categoryId: string | undefined;
    name: string;
    description: string | undefined;
    dateOfReceipt: DateTime;
    datedFrom: DateTime | undefined;
}

export class Document implements IDocument {
    type!: Code;
    typeId!: string | undefined;
    category!: Code;
    categoryId!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    dateOfReceipt!: DateTime;
    datedFrom!: DateTime | undefined;
    context!: string | undefined;
    externalId!: string;
    decree!: DocumentDecree;
    documentLinks!: DocumentLink[] | undefined;
    documentVersions!: DocumentVersion[] | undefined;
    migrationData!: MigrationData[] | undefined;
    isDeleted!: boolean;
    deleterUser!: User;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    creatorUser!: User;
    lastModifierUser!: User;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] ? Code.fromJS(_data["type"]) : <any>undefined;
            this.typeId = _data["typeId"];
            this.category = _data["category"] ? Code.fromJS(_data["category"]) : <any>undefined;
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.dateOfReceipt = _data["dateOfReceipt"] ? DateTime.fromISO(_data["dateOfReceipt"].toString()) : <any>undefined;
            this.datedFrom = _data["datedFrom"] ? DateTime.fromISO(_data["datedFrom"].toString()) : <any>undefined;
            this.context = _data["context"];
            this.externalId = _data["externalId"];
            this.decree = _data["decree"] ? DocumentDecree.fromJS(_data["decree"]) : <any>undefined;
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLink.fromJS(item));
            }
            if (Array.isArray(_data["documentVersions"])) {
                this.documentVersions = [] as any;
                for (let item of _data["documentVersions"])
                    this.documentVersions!.push(DocumentVersion.fromJS(item));
            }
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["dateOfReceipt"] = this.dateOfReceipt ? this.dateOfReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datedFrom"] = this.datedFrom ? this.datedFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        data["context"] = this.context;
        data["externalId"] = this.externalId;
        data["decree"] = this.decree ? this.decree.toJSON() : <any>undefined;
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.documentVersions)) {
            data["documentVersions"] = [];
            for (let item of this.documentVersions)
                data["documentVersions"].push(item.toJSON());
        }
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDocument {
    type: Code;
    typeId: string | undefined;
    category: Code;
    categoryId: string | undefined;
    name: string | undefined;
    description: string | undefined;
    dateOfReceipt: DateTime;
    datedFrom: DateTime | undefined;
    context: string | undefined;
    externalId: string;
    decree: DocumentDecree;
    documentLinks: DocumentLink[] | undefined;
    documentVersions: DocumentVersion[] | undefined;
    migrationData: MigrationData[] | undefined;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class DocumentDecree implements IDocumentDecree {
    applicationId!: number | undefined;
    application!: Application;
    dateOfSend!: DateTime | undefined;
    dateOfDeliveryReceipt!: DateTime | undefined;
    dateOfPickupReceipt!: DateTime | undefined;
    dateOfExpirationReceipt!: DateTime | undefined;

    constructor(data?: IDocumentDecree) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : <any>undefined;
            this.dateOfSend = _data["dateOfSend"] ? DateTime.fromISO(_data["dateOfSend"].toString()) : <any>undefined;
            this.dateOfDeliveryReceipt = _data["dateOfDeliveryReceipt"] ? DateTime.fromISO(_data["dateOfDeliveryReceipt"].toString()) : <any>undefined;
            this.dateOfPickupReceipt = _data["dateOfPickupReceipt"] ? DateTime.fromISO(_data["dateOfPickupReceipt"].toString()) : <any>undefined;
            this.dateOfExpirationReceipt = _data["dateOfExpirationReceipt"] ? DateTime.fromISO(_data["dateOfExpirationReceipt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentDecree {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDecree();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["dateOfSend"] = this.dateOfSend ? this.dateOfSend.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDeliveryReceipt"] = this.dateOfDeliveryReceipt ? this.dateOfDeliveryReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfPickupReceipt"] = this.dateOfPickupReceipt ? this.dateOfPickupReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfExpirationReceipt"] = this.dateOfExpirationReceipt ? this.dateOfExpirationReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IDocumentDecree {
    applicationId: number | undefined;
    application: Application;
    dateOfSend: DateTime | undefined;
    dateOfDeliveryReceipt: DateTime | undefined;
    dateOfPickupReceipt: DateTime | undefined;
    dateOfExpirationReceipt: DateTime | undefined;
}

export class DocumentVersion implements IDocumentVersion {
    mimeHeader!: string | undefined;
    document!: Document;
    documentId!: number;
    binaryObject!: BinaryObject;
    binaryObjectId!: string;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDocumentVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mimeHeader = _data["mimeHeader"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.documentId = _data["documentId"];
            this.binaryObject = _data["binaryObject"] ? BinaryObject.fromJS(_data["binaryObject"]) : <any>undefined;
            this.binaryObjectId = _data["binaryObjectId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentVersion {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mimeHeader"] = this.mimeHeader;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        data["binaryObject"] = this.binaryObject ? this.binaryObject.toJSON() : <any>undefined;
        data["binaryObjectId"] = this.binaryObjectId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDocumentVersion {
    mimeHeader: string | undefined;
    document: Document;
    documentId: number;
    binaryObject: BinaryObject;
    binaryObjectId: string;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class DocumentLink implements IDocumentLink {
    discriminator!: string | undefined;
    document!: Document;
    documentId!: number;
    readonly entityId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDocumentLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.documentId = _data["documentId"];
            (<any>this).entityId = _data["entityId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentLink {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        data["entityId"] = this.entityId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDocumentLink {
    discriminator: string | undefined;
    document: Document;
    documentId: number;
    entityId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class DocumentLinkBusiness implements IDocumentLinkBusiness {
    business!: Business;
    businessId!: number;
    discriminator!: string | undefined;
    document!: Document;
    documentId!: number;
    readonly entityId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDocumentLinkBusiness) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.business = _data["business"] ? Business.fromJS(_data["business"]) : <any>undefined;
            this.businessId = _data["businessId"];
            this.discriminator = _data["discriminator"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.documentId = _data["documentId"];
            (<any>this).entityId = _data["entityId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentLinkBusiness {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLinkBusiness();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        data["businessId"] = this.businessId;
        data["discriminator"] = this.discriminator;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        data["entityId"] = this.entityId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDocumentLinkBusiness {
    business: Business;
    businessId: number;
    discriminator: string | undefined;
    document: Document;
    documentId: number;
    entityId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class DocumentLinkCorporateLicence implements IDocumentLinkCorporateLicence {
    corporateLicence!: CorporateLicence;
    corporateLicenceId!: number;
    discriminator!: string | undefined;
    document!: Document;
    documentId!: number;
    readonly entityId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDocumentLinkCorporateLicence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.corporateLicence = _data["corporateLicence"] ? CorporateLicence.fromJS(_data["corporateLicence"]) : <any>undefined;
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.discriminator = _data["discriminator"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.documentId = _data["documentId"];
            (<any>this).entityId = _data["entityId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentLinkCorporateLicence {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLinkCorporateLicence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["corporateLicence"] = this.corporateLicence ? this.corporateLicence.toJSON() : <any>undefined;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["discriminator"] = this.discriminator;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        data["entityId"] = this.entityId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDocumentLinkCorporateLicence {
    corporateLicence: CorporateLicence;
    corporateLicenceId: number;
    discriminator: string | undefined;
    document: Document;
    documentId: number;
    entityId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class DocumentLinkEducationGrants implements IDocumentLinkEducationGrants {
    educationGrants!: EducationGrants;
    educationGrantsId!: number;
    discriminator!: string | undefined;
    document!: Document;
    documentId!: number;
    readonly entityId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDocumentLinkEducationGrants) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.educationGrants = _data["educationGrants"] ? EducationGrants.fromJS(_data["educationGrants"]) : <any>undefined;
            this.educationGrantsId = _data["educationGrantsId"];
            this.discriminator = _data["discriminator"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.documentId = _data["documentId"];
            (<any>this).entityId = _data["entityId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentLinkEducationGrants {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLinkEducationGrants();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["educationGrants"] = this.educationGrants ? this.educationGrants.toJSON() : <any>undefined;
        data["educationGrantsId"] = this.educationGrantsId;
        data["discriminator"] = this.discriminator;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        data["entityId"] = this.entityId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDocumentLinkEducationGrants {
    educationGrants: EducationGrants;
    educationGrantsId: number;
    discriminator: string | undefined;
    document: Document;
    documentId: number;
    entityId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class DocumentLinkInspection implements IDocumentLinkInspection {
    inspection!: Inspection;
    inspectionId!: number;
    discriminator!: string | undefined;
    document!: Document;
    documentId!: number;
    readonly entityId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDocumentLinkInspection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspection = _data["inspection"] ? Inspection.fromJS(_data["inspection"]) : <any>undefined;
            this.inspectionId = _data["inspectionId"];
            this.discriminator = _data["discriminator"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.documentId = _data["documentId"];
            (<any>this).entityId = _data["entityId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentLinkInspection {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLinkInspection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspection"] = this.inspection ? this.inspection.toJSON() : <any>undefined;
        data["inspectionId"] = this.inspectionId;
        data["discriminator"] = this.discriminator;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        data["entityId"] = this.entityId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDocumentLinkInspection {
    inspection: Inspection;
    inspectionId: number;
    discriminator: string | undefined;
    document: Document;
    documentId: number;
    entityId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class DocumentLinkLogbook implements IDocumentLinkLogbook {
    logbook!: LogbookBaseEntity;
    logbookId!: number;
    discriminator!: string | undefined;
    document!: Document;
    documentId!: number;
    readonly entityId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDocumentLinkLogbook) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logbook = _data["logbook"] ? LogbookBaseEntity.fromJS(_data["logbook"]) : <any>undefined;
            this.logbookId = _data["logbookId"];
            this.discriminator = _data["discriminator"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.documentId = _data["documentId"];
            (<any>this).entityId = _data["entityId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentLinkLogbook {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLinkLogbook();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logbook"] = this.logbook ? this.logbook.toJSON() : <any>undefined;
        data["logbookId"] = this.logbookId;
        data["discriminator"] = this.discriminator;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        data["entityId"] = this.entityId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDocumentLinkLogbook {
    logbook: LogbookBaseEntity;
    logbookId: number;
    discriminator: string | undefined;
    document: Document;
    documentId: number;
    entityId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class DocumentLinkPerson implements IDocumentLinkPerson {
    person!: Person;
    personId!: number;
    discriminator!: string | undefined;
    document!: Document;
    documentId!: number;
    readonly entityId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDocumentLinkPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.personId = _data["personId"];
            this.discriminator = _data["discriminator"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.documentId = _data["documentId"];
            (<any>this).entityId = _data["entityId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentLinkPerson {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLinkPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["discriminator"] = this.discriminator;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        data["entityId"] = this.entityId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDocumentLinkPerson {
    person: Person;
    personId: number;
    discriminator: string | undefined;
    document: Document;
    documentId: number;
    entityId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class DocumentLinkPersonLicence implements IDocumentLinkPersonLicence {
    personLicence!: PersonLicence;
    personLicenceId!: number;
    discriminator!: string | undefined;
    document!: Document;
    documentId!: number;
    readonly entityId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDocumentLinkPersonLicence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personLicence = _data["personLicence"] ? PersonLicence.fromJS(_data["personLicence"]) : <any>undefined;
            this.personLicenceId = _data["personLicenceId"];
            this.discriminator = _data["discriminator"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.documentId = _data["documentId"];
            (<any>this).entityId = _data["entityId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentLinkPersonLicence {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLinkPersonLicence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personLicence"] = this.personLicence ? this.personLicence.toJSON() : <any>undefined;
        data["personLicenceId"] = this.personLicenceId;
        data["discriminator"] = this.discriminator;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        data["entityId"] = this.entityId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDocumentLinkPersonLicence {
    personLicence: PersonLicence;
    personLicenceId: number;
    discriminator: string | undefined;
    document: Document;
    documentId: number;
    entityId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class DocumentLinkSapInvoice implements IDocumentLinkSapInvoice {
    sapInvoice!: SapInvoice;
    sapInvoiceId!: number;
    discriminator!: string | undefined;
    document!: Document;
    documentId!: number;
    readonly entityId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDocumentLinkSapInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sapInvoice = _data["sapInvoice"] ? SapInvoice.fromJS(_data["sapInvoice"]) : <any>undefined;
            this.sapInvoiceId = _data["sapInvoiceId"];
            this.discriminator = _data["discriminator"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.documentId = _data["documentId"];
            (<any>this).entityId = _data["entityId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentLinkSapInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLinkSapInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sapInvoice"] = this.sapInvoice ? this.sapInvoice.toJSON() : <any>undefined;
        data["sapInvoiceId"] = this.sapInvoiceId;
        data["discriminator"] = this.discriminator;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        data["entityId"] = this.entityId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDocumentLinkSapInvoice {
    sapInvoice: SapInvoice;
    sapInvoiceId: number;
    discriminator: string | undefined;
    document: Document;
    documentId: number;
    entityId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class DocumentLinkSensitiveData implements IDocumentLinkSensitiveData {
    sensitiveData!: SensitiveData;
    sensitiveDataId!: number;
    discriminator!: string | undefined;
    document!: Document;
    documentId!: number;
    readonly entityId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDocumentLinkSensitiveData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sensitiveData = _data["sensitiveData"] ? SensitiveData.fromJS(_data["sensitiveData"]) : <any>undefined;
            this.sensitiveDataId = _data["sensitiveDataId"];
            this.discriminator = _data["discriminator"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.documentId = _data["documentId"];
            (<any>this).entityId = _data["entityId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentLinkSensitiveData {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLinkSensitiveData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sensitiveData"] = this.sensitiveData ? this.sensitiveData.toJSON() : <any>undefined;
        data["sensitiveDataId"] = this.sensitiveDataId;
        data["discriminator"] = this.discriminator;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        data["entityId"] = this.entityId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDocumentLinkSensitiveData {
    sensitiveData: SensitiveData;
    sensitiveDataId: number;
    discriminator: string | undefined;
    document: Document;
    documentId: number;
    entityId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class DocumentLinkSensitiveDataRecord implements IDocumentLinkSensitiveDataRecord {
    sensitiveDataRecord!: SensitiveDataRecord;
    sensitiveDataRecordId!: number;
    discriminator!: string | undefined;
    document!: Document;
    documentId!: number;
    readonly entityId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDocumentLinkSensitiveDataRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sensitiveDataRecord = _data["sensitiveDataRecord"] ? SensitiveDataRecord.fromJS(_data["sensitiveDataRecord"]) : <any>undefined;
            this.sensitiveDataRecordId = _data["sensitiveDataRecordId"];
            this.discriminator = _data["discriminator"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.documentId = _data["documentId"];
            (<any>this).entityId = _data["entityId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentLinkSensitiveDataRecord {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLinkSensitiveDataRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sensitiveDataRecord"] = this.sensitiveDataRecord ? this.sensitiveDataRecord.toJSON() : <any>undefined;
        data["sensitiveDataRecordId"] = this.sensitiveDataRecordId;
        data["discriminator"] = this.discriminator;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        data["entityId"] = this.entityId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDocumentLinkSensitiveDataRecord {
    sensitiveDataRecord: SensitiveDataRecord;
    sensitiveDataRecordId: number;
    discriminator: string | undefined;
    document: Document;
    documentId: number;
    entityId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class DocumentLinkSponsorship implements IDocumentLinkSponsorship {
    sponsorship!: Sponsorship;
    sponsorshipId!: number;
    discriminator!: string | undefined;
    document!: Document;
    documentId!: number;
    readonly entityId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDocumentLinkSponsorship) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorship = _data["sponsorship"] ? Sponsorship.fromJS(_data["sponsorship"]) : <any>undefined;
            this.sponsorshipId = _data["sponsorshipId"];
            this.discriminator = _data["discriminator"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.documentId = _data["documentId"];
            (<any>this).entityId = _data["entityId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentLinkSponsorship {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLinkSponsorship();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        data["sponsorshipId"] = this.sponsorshipId;
        data["discriminator"] = this.discriminator;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        data["entityId"] = this.entityId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDocumentLinkSponsorship {
    sponsorship: Sponsorship;
    sponsorshipId: number;
    discriminator: string | undefined;
    document: Document;
    documentId: number;
    entityId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class AppDocumentDownloadInput implements IAppDocumentDownloadInput {
    id!: AppDownloadBinaryObjectId;
    file!: string | undefined;
    description!: string | undefined;
    fileExtension!: string | undefined;

    constructor(data?: IAppDocumentDownloadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.file = _data["file"];
            this.description = _data["description"];
            this.fileExtension = _data["fileExtension"];
        }
    }

    static fromJS(data: any): AppDocumentDownloadInput {
        data = typeof data === 'object' ? data : {};
        let result = new AppDocumentDownloadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["file"] = this.file;
        data["description"] = this.description;
        data["fileExtension"] = this.fileExtension;
        return data;
    }
}

export interface IAppDocumentDownloadInput {
    id: AppDownloadBinaryObjectId;
    file: string | undefined;
    description: string | undefined;
    fileExtension: string | undefined;
}

export class GeneralDocumentsOutput implements IGeneralDocumentsOutput {
    caseId!: string;
    documents!: GeneralDocumentGroupDto[];

    constructor(data?: IGeneralDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeneralDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGeneralDocumentsOutput {
    caseId: string;
    documents: GeneralDocumentGroupDto[];
}

export class FileDto implements IFileDto {
    fileName!: string;
    fileType!: string | undefined;
    fileToken!: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string | undefined;
    fileToken: string;
}

export class GeneralDocumentGroupDto implements IGeneralDocumentGroupDto {
    typeId!: string | undefined;
    isMandatory!: boolean | undefined;
    info!: string | undefined;
    files!: GeneralFileInfoDto[] | undefined;
    id!: number;

    constructor(data?: IGeneralDocumentGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.isMandatory = _data["isMandatory"];
            this.info = _data["info"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(GeneralFileInfoDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GeneralDocumentGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralDocumentGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["isMandatory"] = this.isMandatory;
        data["info"] = this.info;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGeneralDocumentGroupDto {
    typeId: string | undefined;
    isMandatory: boolean | undefined;
    info: string | undefined;
    files: GeneralFileInfoDto[] | undefined;
    id: number;
}

export class GeneralResultDocumentInput implements IGeneralResultDocumentInput {
    caseId!: string;
    typeId!: string;
    document!: GeneralFileDto;

    constructor(data?: IGeneralResultDocumentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.document = new GeneralFileDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.typeId = _data["typeId"];
            this.document = _data["document"] ? GeneralFileDto.fromJS(_data["document"]) : new GeneralFileDto();
        }
    }

    static fromJS(data: any): GeneralResultDocumentInput {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralResultDocumentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["typeId"] = this.typeId;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGeneralResultDocumentInput {
    caseId: string;
    typeId: string;
    document: GeneralFileDto;
}

export class OndAddressTelWebDto implements IOndAddressTelWebDto {
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    countryId!: string | undefined;
    addressAddition!: string | undefined;
    postOfficeBox!: string | undefined;
    email!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    website!: string | undefined;

    constructor(data?: IOndAddressTelWebDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.countryId = _data["countryId"];
            this.addressAddition = _data["addressAddition"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.website = _data["website"];
        }
    }

    static fromJS(data: any): OndAddressTelWebDto {
        data = typeof data === 'object' ? data : {};
        let result = new OndAddressTelWebDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["countryId"] = this.countryId;
        data["addressAddition"] = this.addressAddition;
        data["postOfficeBox"] = this.postOfficeBox;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["website"] = this.website;
        return data;
    }
}

export interface IOndAddressTelWebDto {
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    countryId: string | undefined;
    addressAddition: string | undefined;
    postOfficeBox: string | undefined;
    email: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    website: string | undefined;
}

export class OndBusinessDto implements IOndBusinessDto {
    businessName!: string | undefined;
    additionalName!: string | undefined;
    bur!: string | undefined;
    gln!: string | undefined;
    address!: OndAddressTelWebDto;
    dateOfOpening!: DateTime | undefined;
    dateOfClosure!: DateTime | undefined;
    businessHours!: string | undefined;

    constructor(data?: IOndBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessName = _data["businessName"];
            this.additionalName = _data["additionalName"];
            this.bur = _data["bur"];
            this.gln = _data["gln"];
            this.address = _data["address"] ? OndAddressTelWebDto.fromJS(_data["address"]) : <any>undefined;
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.dateOfClosure = _data["dateOfClosure"] ? DateTime.fromISO(_data["dateOfClosure"].toString()) : <any>undefined;
            this.businessHours = _data["businessHours"];
        }
    }

    static fromJS(data: any): OndBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new OndBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessName"] = this.businessName;
        data["additionalName"] = this.additionalName;
        data["bur"] = this.bur;
        data["gln"] = this.gln;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfClosure"] = this.dateOfClosure ? this.dateOfClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessHours"] = this.businessHours;
        return data;
    }
}

export interface IOndBusinessDto {
    businessName: string | undefined;
    additionalName: string | undefined;
    bur: string | undefined;
    gln: string | undefined;
    address: OndAddressTelWebDto;
    dateOfOpening: DateTime | undefined;
    dateOfClosure: DateTime | undefined;
    businessHours: string | undefined;
}

export class CreateEditionDto implements ICreateEditionDto {
    edition!: EditionCreateDto;
    featureValues!: NameValueDto[];

    constructor(data?: ICreateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionCreateDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionCreateDto.fromJS(_data["edition"]) : new EditionCreateDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateEditionDto {
    edition: EditionCreateDto;
    featureValues: NameValueDto[];
}

export class EditionCreateDto implements IEditionCreateDto {
    id!: number | undefined;
    displayName!: string;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionCreateDto {
    id: number | undefined;
    displayName: string;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    expiringEditionId: number | undefined;
}

export class EditionEditDto implements IEditionEditDto {
    id!: number | undefined;
    displayName!: string;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionEditDto {
    id: number | undefined;
    displayName: string;
    expiringEditionId: number | undefined;
}

export class EditionListDto implements IEditionListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    trialDayCount!: number | undefined;
    expiringEditionDisplayName!: string | undefined;
    id!: number;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.trialDayCount = _data["trialDayCount"];
            this.expiringEditionDisplayName = _data["expiringEditionDisplayName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["trialDayCount"] = this.trialDayCount;
        data["expiringEditionDisplayName"] = this.expiringEditionDisplayName;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionListDto {
    name: string | undefined;
    displayName: string | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    waitingDayAfterExpire: number | undefined;
    trialDayCount: number | undefined;
    expiringEditionDisplayName: string | undefined;
    id: number;
}

export class EditionSelectDto implements IEditionSelectDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    expiringEditionId!: number | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    isFree!: boolean;

    constructor(data?: IEditionSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.isFree = _data["isFree"];
        }
    }

    static fromJS(data: any): EditionSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        return data;
    }
}

export interface IEditionSelectDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    expiringEditionId: number | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    isFree: boolean;
}

export class EditionWithFeaturesDto implements IEditionWithFeaturesDto {
    edition!: EditionSelectDto;
    featureValues!: NameValueDto[] | undefined;

    constructor(data?: IEditionWithFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionSelectDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionWithFeaturesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditionWithFeaturesDto {
    edition: EditionSelectDto;
    featureValues: NameValueDto[] | undefined;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name!: string | undefined;
    attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;
    itemSource!: LocalizableComboboxItemSourceDto;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["attributes"]) {
                this.attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>this.attributes)![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
            this.itemSource = _data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(_data["itemSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeatureInputTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFeatureInputTypeDto {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: FeatureInputTypeDto;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? FeatureInputTypeDto.fromJS(_data["inputType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: FeatureInputTypeDto;
}

export class FlatFeatureSelectDto implements IFlatFeatureSelectDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: IInputType;
    textHtmlColor!: string | undefined;

    constructor(data?: IFlatFeatureSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? IInputType.fromJS(_data["inputType"]) : <any>undefined;
            this.textHtmlColor = _data["textHtmlColor"];
        }
    }

    static fromJS(data: any): FlatFeatureSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        data["textHtmlColor"] = this.textHtmlColor;
        return data;
    }
}

export interface IFlatFeatureSelectDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: IInputType;
    textHtmlColor: string | undefined;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetEditionEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): LocalizableComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface ILocalizableComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items!: LocalizableComboboxItemDto[] | undefined;

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LocalizableComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizableComboboxItemSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[] | undefined;
}

export class MoveTenantsToAnotherEditionDto implements IMoveTenantsToAnotherEditionDto {
    sourceEditionId!: number;
    targetEditionId!: number;

    constructor(data?: IMoveTenantsToAnotherEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceEditionId = _data["sourceEditionId"];
            this.targetEditionId = _data["targetEditionId"];
        }
    }

    static fromJS(data: any): MoveTenantsToAnotherEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveTenantsToAnotherEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceEditionId"] = this.sourceEditionId;
        data["targetEditionId"] = this.targetEditionId;
        return data;
    }
}

export interface IMoveTenantsToAnotherEditionDto {
    sourceEditionId: number;
    targetEditionId: number;
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
    isFree!: boolean | undefined;
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: ISubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFree = _data["isFree"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): SubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface ISubscribableEditionComboboxItemDto {
    isFree: boolean | undefined;
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class UpdateEditionDto implements IUpdateEditionDto {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionEditDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : new EditionEditDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
}

export class EducationCancellationDto implements IEducationCancellationDto {
    educationGrantsId!: number | undefined;
    typeId!: EducationGrantsStatus;
    dateOfNotification!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    dateOfResumption!: DateTime | undefined;
    reasonForCancellation!: string | undefined;
    documentsSubmitted!: EducationGrantsDocumentsSubmitted;
    numberOfWeeksFundedBeforeAbortion!: string | undefined;
    totalGrantsToDateBeforeAbortion!: string | undefined;
    numberOfWeeksFundedAfterAbortion!: string | undefined;
    totalGrantsToDateAfterAbortion!: string | undefined;
    totalAmountToBeRepaid!: string | undefined;
    numberOfInstallments!: string | undefined;
    amountOfInstallments!: string | undefined;
    dateForwardedInvoicing!: DateTime | undefined;
    dateOfFinalInstallment!: DateTime | undefined;
    referenceNumber!: string | undefined;
    dateOfInvoice!: DateTime | undefined;
    remark!: string | undefined;
    id!: number;

    constructor(data?: IEducationCancellationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.educationGrantsId = _data["educationGrantsId"];
            this.typeId = _data["typeId"];
            this.dateOfNotification = _data["dateOfNotification"] ? DateTime.fromISO(_data["dateOfNotification"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.dateOfResumption = _data["dateOfResumption"] ? DateTime.fromISO(_data["dateOfResumption"].toString()) : <any>undefined;
            this.reasonForCancellation = _data["reasonForCancellation"];
            this.documentsSubmitted = _data["documentsSubmitted"];
            this.numberOfWeeksFundedBeforeAbortion = _data["numberOfWeeksFundedBeforeAbortion"];
            this.totalGrantsToDateBeforeAbortion = _data["totalGrantsToDateBeforeAbortion"];
            this.numberOfWeeksFundedAfterAbortion = _data["numberOfWeeksFundedAfterAbortion"];
            this.totalGrantsToDateAfterAbortion = _data["totalGrantsToDateAfterAbortion"];
            this.totalAmountToBeRepaid = _data["totalAmountToBeRepaid"];
            this.numberOfInstallments = _data["numberOfInstallments"];
            this.amountOfInstallments = _data["amountOfInstallments"];
            this.dateForwardedInvoicing = _data["dateForwardedInvoicing"] ? DateTime.fromISO(_data["dateForwardedInvoicing"].toString()) : <any>undefined;
            this.dateOfFinalInstallment = _data["dateOfFinalInstallment"] ? DateTime.fromISO(_data["dateOfFinalInstallment"].toString()) : <any>undefined;
            this.referenceNumber = _data["referenceNumber"];
            this.dateOfInvoice = _data["dateOfInvoice"] ? DateTime.fromISO(_data["dateOfInvoice"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EducationCancellationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EducationCancellationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["educationGrantsId"] = this.educationGrantsId;
        data["typeId"] = this.typeId;
        data["dateOfNotification"] = this.dateOfNotification ? this.dateOfNotification.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfResumption"] = this.dateOfResumption ? this.dateOfResumption.toFormat('yyyy-MM-dd') : <any>undefined;
        data["reasonForCancellation"] = this.reasonForCancellation;
        data["documentsSubmitted"] = this.documentsSubmitted;
        data["numberOfWeeksFundedBeforeAbortion"] = this.numberOfWeeksFundedBeforeAbortion;
        data["totalGrantsToDateBeforeAbortion"] = this.totalGrantsToDateBeforeAbortion;
        data["numberOfWeeksFundedAfterAbortion"] = this.numberOfWeeksFundedAfterAbortion;
        data["totalGrantsToDateAfterAbortion"] = this.totalGrantsToDateAfterAbortion;
        data["totalAmountToBeRepaid"] = this.totalAmountToBeRepaid;
        data["numberOfInstallments"] = this.numberOfInstallments;
        data["amountOfInstallments"] = this.amountOfInstallments;
        data["dateForwardedInvoicing"] = this.dateForwardedInvoicing ? this.dateForwardedInvoicing.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfFinalInstallment"] = this.dateOfFinalInstallment ? this.dateOfFinalInstallment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["referenceNumber"] = this.referenceNumber;
        data["dateOfInvoice"] = this.dateOfInvoice ? this.dateOfInvoice.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["id"] = this.id;
        return data;
    }
}

export interface IEducationCancellationDto {
    educationGrantsId: number | undefined;
    typeId: EducationGrantsStatus;
    dateOfNotification: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    dateOfResumption: DateTime | undefined;
    reasonForCancellation: string | undefined;
    documentsSubmitted: EducationGrantsDocumentsSubmitted;
    numberOfWeeksFundedBeforeAbortion: string | undefined;
    totalGrantsToDateBeforeAbortion: string | undefined;
    numberOfWeeksFundedAfterAbortion: string | undefined;
    totalGrantsToDateAfterAbortion: string | undefined;
    totalAmountToBeRepaid: string | undefined;
    numberOfInstallments: string | undefined;
    amountOfInstallments: string | undefined;
    dateForwardedInvoicing: DateTime | undefined;
    dateOfFinalInstallment: DateTime | undefined;
    referenceNumber: string | undefined;
    dateOfInvoice: DateTime | undefined;
    remark: string | undefined;
    id: number;
}

export class EducationGrantsDto implements IEducationGrantsDto {
    personId!: number;
    type!: EducationGrantsType;
    status!: EducationGrantsStatus;
    dateOfStatusChange!: DateTime | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    courseStartDate!: DateTime | undefined;
    courseEndDate!: DateTime | undefined;
    dateOfCompletionOfCommitment!: DateTime | undefined;
    apprenticeshipCompany!: string | undefined;
    educationProviderTheoryId!: string | undefined;
    educationProviderName!: string | undefined;
    levelOfEducationId!: string | undefined;
    prevEducationId!: string | undefined;
    startSemester!: string | undefined;
    courseOfStudyId!: string | undefined;
    otherCourseOfStudy!: string | undefined;
    minimumGrants!: string | undefined;
    amountEducationGrants!: string | undefined;
    totalGrantsToDate!: string | undefined;
    numberOfSemestersFundedToDate!: string | undefined;
    courseName!: string | undefined;
    semesterId!: string | undefined;
    enrolmentConfirmationDate!: DateTime | undefined;
    remark!: string | undefined;
    agreementNumber!: string | undefined;
    naturalKey!: string | undefined;
    canBeDeleted!: boolean;
    id!: number;

    constructor(data?: IEducationGrantsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.courseStartDate = _data["courseStartDate"] ? DateTime.fromISO(_data["courseStartDate"].toString()) : <any>undefined;
            this.courseEndDate = _data["courseEndDate"] ? DateTime.fromISO(_data["courseEndDate"].toString()) : <any>undefined;
            this.dateOfCompletionOfCommitment = _data["dateOfCompletionOfCommitment"] ? DateTime.fromISO(_data["dateOfCompletionOfCommitment"].toString()) : <any>undefined;
            this.apprenticeshipCompany = _data["apprenticeshipCompany"];
            this.educationProviderTheoryId = _data["educationProviderTheoryId"];
            this.educationProviderName = _data["educationProviderName"];
            this.levelOfEducationId = _data["levelOfEducationId"];
            this.prevEducationId = _data["prevEducationId"];
            this.startSemester = _data["startSemester"];
            this.courseOfStudyId = _data["courseOfStudyId"];
            this.otherCourseOfStudy = _data["otherCourseOfStudy"];
            this.minimumGrants = _data["minimumGrants"];
            this.amountEducationGrants = _data["amountEducationGrants"];
            this.totalGrantsToDate = _data["totalGrantsToDate"];
            this.numberOfSemestersFundedToDate = _data["numberOfSemestersFundedToDate"];
            this.courseName = _data["courseName"];
            this.semesterId = _data["semesterId"];
            this.enrolmentConfirmationDate = _data["enrolmentConfirmationDate"] ? DateTime.fromISO(_data["enrolmentConfirmationDate"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.agreementNumber = _data["agreementNumber"];
            this.naturalKey = _data["naturalKey"];
            this.canBeDeleted = _data["canBeDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EducationGrantsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EducationGrantsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["type"] = this.type;
        data["status"] = this.status;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["courseStartDate"] = this.courseStartDate ? this.courseStartDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["courseEndDate"] = this.courseEndDate ? this.courseEndDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCompletionOfCommitment"] = this.dateOfCompletionOfCommitment ? this.dateOfCompletionOfCommitment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["apprenticeshipCompany"] = this.apprenticeshipCompany;
        data["educationProviderTheoryId"] = this.educationProviderTheoryId;
        data["educationProviderName"] = this.educationProviderName;
        data["levelOfEducationId"] = this.levelOfEducationId;
        data["prevEducationId"] = this.prevEducationId;
        data["startSemester"] = this.startSemester;
        data["courseOfStudyId"] = this.courseOfStudyId;
        data["otherCourseOfStudy"] = this.otherCourseOfStudy;
        data["minimumGrants"] = this.minimumGrants;
        data["amountEducationGrants"] = this.amountEducationGrants;
        data["totalGrantsToDate"] = this.totalGrantsToDate;
        data["numberOfSemestersFundedToDate"] = this.numberOfSemestersFundedToDate;
        data["courseName"] = this.courseName;
        data["semesterId"] = this.semesterId;
        data["enrolmentConfirmationDate"] = this.enrolmentConfirmationDate ? this.enrolmentConfirmationDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["agreementNumber"] = this.agreementNumber;
        data["naturalKey"] = this.naturalKey;
        data["canBeDeleted"] = this.canBeDeleted;
        data["id"] = this.id;
        return data;
    }
}

export interface IEducationGrantsDto {
    personId: number;
    type: EducationGrantsType;
    status: EducationGrantsStatus;
    dateOfStatusChange: DateTime | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    courseStartDate: DateTime | undefined;
    courseEndDate: DateTime | undefined;
    dateOfCompletionOfCommitment: DateTime | undefined;
    apprenticeshipCompany: string | undefined;
    educationProviderTheoryId: string | undefined;
    educationProviderName: string | undefined;
    levelOfEducationId: string | undefined;
    prevEducationId: string | undefined;
    startSemester: string | undefined;
    courseOfStudyId: string | undefined;
    otherCourseOfStudy: string | undefined;
    minimumGrants: string | undefined;
    amountEducationGrants: string | undefined;
    totalGrantsToDate: string | undefined;
    numberOfSemestersFundedToDate: string | undefined;
    courseName: string | undefined;
    semesterId: string | undefined;
    enrolmentConfirmationDate: DateTime | undefined;
    remark: string | undefined;
    agreementNumber: string | undefined;
    naturalKey: string | undefined;
    canBeDeleted: boolean;
    id: number;
}

export class EducationGrants implements IEducationGrants {
    person!: Person;
    personId!: number;
    type!: EducationGrantsType;
    status!: EducationGrantsStatus;
    dateOfStatusChange!: DateTime | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    courseEndDate!: DateTime | undefined;
    dateOfCompletionOfCommitment!: DateTime | undefined;
    apprenticeshipCompany!: string | undefined;
    educationProviderTheory!: Code;
    educationProviderTheoryId!: string | undefined;
    educationProviderName!: string | undefined;
    levelOfEducation!: Code;
    levelOfEducationId!: string | undefined;
    prevEducation!: Code;
    prevEducationId!: string | undefined;
    startSemester!: string | undefined;
    startDate!: DateTime | undefined;
    courseOfStudy!: Code;
    courseOfStudyId!: string | undefined;
    otherCourseOfStudy!: string | undefined;
    minimumGrants!: string | undefined;
    amountEducationGrants!: string | undefined;
    totalGrantsToDate!: string | undefined;
    numberOfSemestersFundedToDate!: string | undefined;
    courseName!: string | undefined;
    semester!: Code;
    semesterId!: string | undefined;
    remark!: string | undefined;
    enrolmentConfirmationDate!: DateTime | undefined;
    agreementNumber!: string | undefined;
    naturalKey!: string | undefined;
    canton!: Code;
    cantonId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    addressAddition!: string | undefined;
    courseStartDate!: DateTime | undefined;
    courseFees!: string | undefined;
    canBeDeleted!: boolean;
    documentLinks!: DocumentLinkEducationGrants[] | undefined;
    pendences!: PendenceLinkEducationGrants[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IEducationGrants) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.personId = _data["personId"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.courseEndDate = _data["courseEndDate"] ? DateTime.fromISO(_data["courseEndDate"].toString()) : <any>undefined;
            this.dateOfCompletionOfCommitment = _data["dateOfCompletionOfCommitment"] ? DateTime.fromISO(_data["dateOfCompletionOfCommitment"].toString()) : <any>undefined;
            this.apprenticeshipCompany = _data["apprenticeshipCompany"];
            this.educationProviderTheory = _data["educationProviderTheory"] ? Code.fromJS(_data["educationProviderTheory"]) : <any>undefined;
            this.educationProviderTheoryId = _data["educationProviderTheoryId"];
            this.educationProviderName = _data["educationProviderName"];
            this.levelOfEducation = _data["levelOfEducation"] ? Code.fromJS(_data["levelOfEducation"]) : <any>undefined;
            this.levelOfEducationId = _data["levelOfEducationId"];
            this.prevEducation = _data["prevEducation"] ? Code.fromJS(_data["prevEducation"]) : <any>undefined;
            this.prevEducationId = _data["prevEducationId"];
            this.startSemester = _data["startSemester"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.courseOfStudy = _data["courseOfStudy"] ? Code.fromJS(_data["courseOfStudy"]) : <any>undefined;
            this.courseOfStudyId = _data["courseOfStudyId"];
            this.otherCourseOfStudy = _data["otherCourseOfStudy"];
            this.minimumGrants = _data["minimumGrants"];
            this.amountEducationGrants = _data["amountEducationGrants"];
            this.totalGrantsToDate = _data["totalGrantsToDate"];
            this.numberOfSemestersFundedToDate = _data["numberOfSemestersFundedToDate"];
            this.courseName = _data["courseName"];
            this.semester = _data["semester"] ? Code.fromJS(_data["semester"]) : <any>undefined;
            this.semesterId = _data["semesterId"];
            this.remark = _data["remark"];
            this.enrolmentConfirmationDate = _data["enrolmentConfirmationDate"] ? DateTime.fromISO(_data["enrolmentConfirmationDate"].toString()) : <any>undefined;
            this.agreementNumber = _data["agreementNumber"];
            this.naturalKey = _data["naturalKey"];
            this.canton = _data["canton"] ? Code.fromJS(_data["canton"]) : <any>undefined;
            this.cantonId = _data["cantonId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.addressAddition = _data["addressAddition"];
            this.courseStartDate = _data["courseStartDate"] ? DateTime.fromISO(_data["courseStartDate"].toString()) : <any>undefined;
            this.courseFees = _data["courseFees"];
            this.canBeDeleted = _data["canBeDeleted"];
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkEducationGrants.fromJS(item));
            }
            if (Array.isArray(_data["pendences"])) {
                this.pendences = [] as any;
                for (let item of _data["pendences"])
                    this.pendences!.push(PendenceLinkEducationGrants.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EducationGrants {
        data = typeof data === 'object' ? data : {};
        let result = new EducationGrants();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["type"] = this.type;
        data["status"] = this.status;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["courseEndDate"] = this.courseEndDate ? this.courseEndDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCompletionOfCommitment"] = this.dateOfCompletionOfCommitment ? this.dateOfCompletionOfCommitment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["apprenticeshipCompany"] = this.apprenticeshipCompany;
        data["educationProviderTheory"] = this.educationProviderTheory ? this.educationProviderTheory.toJSON() : <any>undefined;
        data["educationProviderTheoryId"] = this.educationProviderTheoryId;
        data["educationProviderName"] = this.educationProviderName;
        data["levelOfEducation"] = this.levelOfEducation ? this.levelOfEducation.toJSON() : <any>undefined;
        data["levelOfEducationId"] = this.levelOfEducationId;
        data["prevEducation"] = this.prevEducation ? this.prevEducation.toJSON() : <any>undefined;
        data["prevEducationId"] = this.prevEducationId;
        data["startSemester"] = this.startSemester;
        data["startDate"] = this.startDate ? this.startDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["courseOfStudy"] = this.courseOfStudy ? this.courseOfStudy.toJSON() : <any>undefined;
        data["courseOfStudyId"] = this.courseOfStudyId;
        data["otherCourseOfStudy"] = this.otherCourseOfStudy;
        data["minimumGrants"] = this.minimumGrants;
        data["amountEducationGrants"] = this.amountEducationGrants;
        data["totalGrantsToDate"] = this.totalGrantsToDate;
        data["numberOfSemestersFundedToDate"] = this.numberOfSemestersFundedToDate;
        data["courseName"] = this.courseName;
        data["semester"] = this.semester ? this.semester.toJSON() : <any>undefined;
        data["semesterId"] = this.semesterId;
        data["remark"] = this.remark;
        data["enrolmentConfirmationDate"] = this.enrolmentConfirmationDate ? this.enrolmentConfirmationDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["agreementNumber"] = this.agreementNumber;
        data["naturalKey"] = this.naturalKey;
        data["canton"] = this.canton ? this.canton.toJSON() : <any>undefined;
        data["cantonId"] = this.cantonId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["addressAddition"] = this.addressAddition;
        data["courseStartDate"] = this.courseStartDate ? this.courseStartDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["courseFees"] = this.courseFees;
        data["canBeDeleted"] = this.canBeDeleted;
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.pendences)) {
            data["pendences"] = [];
            for (let item of this.pendences)
                data["pendences"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEducationGrants {
    person: Person;
    personId: number;
    type: EducationGrantsType;
    status: EducationGrantsStatus;
    dateOfStatusChange: DateTime | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    courseEndDate: DateTime | undefined;
    dateOfCompletionOfCommitment: DateTime | undefined;
    apprenticeshipCompany: string | undefined;
    educationProviderTheory: Code;
    educationProviderTheoryId: string | undefined;
    educationProviderName: string | undefined;
    levelOfEducation: Code;
    levelOfEducationId: string | undefined;
    prevEducation: Code;
    prevEducationId: string | undefined;
    startSemester: string | undefined;
    startDate: DateTime | undefined;
    courseOfStudy: Code;
    courseOfStudyId: string | undefined;
    otherCourseOfStudy: string | undefined;
    minimumGrants: string | undefined;
    amountEducationGrants: string | undefined;
    totalGrantsToDate: string | undefined;
    numberOfSemestersFundedToDate: string | undefined;
    courseName: string | undefined;
    semester: Code;
    semesterId: string | undefined;
    remark: string | undefined;
    enrolmentConfirmationDate: DateTime | undefined;
    agreementNumber: string | undefined;
    naturalKey: string | undefined;
    canton: Code;
    cantonId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    addressAddition: string | undefined;
    courseStartDate: DateTime | undefined;
    courseFees: string | undefined;
    canBeDeleted: boolean;
    documentLinks: DocumentLinkEducationGrants[] | undefined;
    pendences: PendenceLinkEducationGrants[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum EducationGrantsDocumentsSubmitted {
    PersonalDetailsAndStudy = 0,
    ConfirmationTheoryProvider = 1,
}

export enum EducationGrantsStatus {
    UnderConstruction = 0,
    CompletedStudies = 2,
    OverallMeasureCompleted = 3,
    RejectedDecisionIssued = 4,
    StudyAborted = 5,
    StudyInterrupted = 6,
    RepaymentDecisionIssued = 7,
    CoverSheetSentToFDAFDL = 8,
    RepaymentProcessCompleted = 9,
    PaymentApprovedInWorkflowG1 = 10,
    PaymentApprovedInWorkflowG2 = 11,
    PaymentRejectedInWorkflowG1 = 12,
    PaymentRejectedInWorkflowG2 = 13,
    AbvIssued = 14,
    AbvReturned = 15,
    AbvCanBeCreated = 16,
    ApplicationWithdrawn = 17,
    InvoiceGDDPFDelivered = 18,
}

export enum EducationGrantsType {
    Students = 0,
    ReEntrySupport = 1,
}

export class CreateEhcCapWaitListEntryDto implements ICreateEhcCapWaitListEntryDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    personId!: number | undefined;
    dateOfApplication!: DateTime | undefined;
    titles!: CreateEhcCapWaitListTitleDto[] | undefined;

    constructor(data?: ICreateEhcCapWaitListEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.personId = _data["personId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(CreateEhcCapWaitListTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEhcCapWaitListEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEhcCapWaitListEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["personId"] = this.personId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateEhcCapWaitListEntryDto {
    firstName: string | undefined;
    lastName: string | undefined;
    personId: number | undefined;
    dateOfApplication: DateTime | undefined;
    titles: CreateEhcCapWaitListTitleDto[] | undefined;
}

export class CreateEhcCapWaitListEntryFromApplicationDto implements ICreateEhcCapWaitListEntryFromApplicationDto {
    caseId!: string | undefined;

    constructor(data?: ICreateEhcCapWaitListEntryFromApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): CreateEhcCapWaitListEntryFromApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEhcCapWaitListEntryFromApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface ICreateEhcCapWaitListEntryFromApplicationDto {
    caseId: string | undefined;
}

export class CreateEhcCapWaitListTitleDto implements ICreateEhcCapWaitListTitleDto {
    postgraduateTitleId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    districtId!: string | undefined;
    levelOfEmployment!: number | undefined;

    constructor(data?: ICreateEhcCapWaitListTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.districtId = _data["districtId"];
            this.levelOfEmployment = _data["levelOfEmployment"];
        }
    }

    static fromJS(data: any): CreateEhcCapWaitListTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEhcCapWaitListTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["districtId"] = this.districtId;
        data["levelOfEmployment"] = this.levelOfEmployment;
        return data;
    }
}

export interface ICreateEhcCapWaitListTitleDto {
    postgraduateTitleId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    districtId: string | undefined;
    levelOfEmployment: number | undefined;
}

export class CreateOrUpdateEhcCapDto implements ICreateOrUpdateEhcCapDto {
    postgraduateTitleId!: string | undefined;
    maxFullTimeEquivalentCanton!: number | undefined;
    ehcCapDistricts!: EhcCapDistrictDto[] | undefined;

    constructor(data?: ICreateOrUpdateEhcCapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.maxFullTimeEquivalentCanton = _data["maxFullTimeEquivalentCanton"];
            if (Array.isArray(_data["ehcCapDistricts"])) {
                this.ehcCapDistricts = [] as any;
                for (let item of _data["ehcCapDistricts"])
                    this.ehcCapDistricts!.push(EhcCapDistrictDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcCapDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcCapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["maxFullTimeEquivalentCanton"] = this.maxFullTimeEquivalentCanton;
        if (Array.isArray(this.ehcCapDistricts)) {
            data["ehcCapDistricts"] = [];
            for (let item of this.ehcCapDistricts)
                data["ehcCapDistricts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateEhcCapDto {
    postgraduateTitleId: string | undefined;
    maxFullTimeEquivalentCanton: number | undefined;
    ehcCapDistricts: EhcCapDistrictDto[] | undefined;
}

export class DistrictDto implements IDistrictDto {
    districtCodeId!: string | undefined;
    plz!: DistrictPlzDto[] | undefined;

    constructor(data?: IDistrictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.districtCodeId = _data["districtCodeId"];
            if (Array.isArray(_data["plz"])) {
                this.plz = [] as any;
                for (let item of _data["plz"])
                    this.plz!.push(DistrictPlzDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DistrictDto {
        data = typeof data === 'object' ? data : {};
        let result = new DistrictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["districtCodeId"] = this.districtCodeId;
        if (Array.isArray(this.plz)) {
            data["plz"] = [];
            for (let item of this.plz)
                data["plz"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDistrictDto {
    districtCodeId: string | undefined;
    plz: DistrictPlzDto[] | undefined;
}

export class DistrictPlzDto implements IDistrictPlzDto {
    plz!: number;

    constructor(data?: IDistrictPlzDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plz = _data["plz"];
        }
    }

    static fromJS(data: any): DistrictPlzDto {
        data = typeof data === 'object' ? data : {};
        let result = new DistrictPlzDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plz"] = this.plz;
        return data;
    }
}

export interface IDistrictPlzDto {
    plz: number;
}

export class EhcCapDistrictDto implements IEhcCapDistrictDto {
    districtId!: string | undefined;
    maxFullTimeEquivalent!: number;

    constructor(data?: IEhcCapDistrictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.districtId = _data["districtId"];
            this.maxFullTimeEquivalent = _data["maxFullTimeEquivalent"];
        }
    }

    static fromJS(data: any): EhcCapDistrictDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcCapDistrictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["districtId"] = this.districtId;
        data["maxFullTimeEquivalent"] = this.maxFullTimeEquivalent;
        return data;
    }
}

export interface IEhcCapDistrictDto {
    districtId: string | undefined;
    maxFullTimeEquivalent: number;
}

export class EhcCapDto implements IEhcCapDto {
    postgraduateTitleId!: string | undefined;
    maxFullTimeEquivalentCanton!: number | undefined;
    ehcCapDistricts!: EhcCapDistrictDto[] | undefined;
    id!: number;

    constructor(data?: IEhcCapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.maxFullTimeEquivalentCanton = _data["maxFullTimeEquivalentCanton"];
            if (Array.isArray(_data["ehcCapDistricts"])) {
                this.ehcCapDistricts = [] as any;
                for (let item of _data["ehcCapDistricts"])
                    this.ehcCapDistricts!.push(EhcCapDistrictDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EhcCapDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcCapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["maxFullTimeEquivalentCanton"] = this.maxFullTimeEquivalentCanton;
        if (Array.isArray(this.ehcCapDistricts)) {
            data["ehcCapDistricts"] = [];
            for (let item of this.ehcCapDistricts)
                data["ehcCapDistricts"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IEhcCapDto {
    postgraduateTitleId: string | undefined;
    maxFullTimeEquivalentCanton: number | undefined;
    ehcCapDistricts: EhcCapDistrictDto[] | undefined;
    id: number;
}

export class EhcCapWaitListEntryDto implements IEhcCapWaitListEntryDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    caseId!: string | undefined;
    personId!: number | undefined;
    dateOfApplication!: DateTime | undefined;
    titles!: EhcCapWaitListTitleDto[] | undefined;
    id!: number;

    constructor(data?: IEhcCapWaitListEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.caseId = _data["caseId"];
            this.personId = _data["personId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(EhcCapWaitListTitleDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EhcCapWaitListEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcCapWaitListEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["caseId"] = this.caseId;
        data["personId"] = this.personId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IEhcCapWaitListEntryDto {
    firstName: string | undefined;
    lastName: string | undefined;
    caseId: string | undefined;
    personId: number | undefined;
    dateOfApplication: DateTime | undefined;
    titles: EhcCapWaitListTitleDto[] | undefined;
    id: number;
}

export class EhcCapWaitListTitleDto implements IEhcCapWaitListTitleDto {
    postgraduateTitleId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    districtId!: string | undefined;
    levelOfEmployment!: number | undefined;
    id!: number;

    constructor(data?: IEhcCapWaitListTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.districtId = _data["districtId"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EhcCapWaitListTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcCapWaitListTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["districtId"] = this.districtId;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["id"] = this.id;
        return data;
    }
}

export interface IEhcCapWaitListTitleDto {
    postgraduateTitleId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    districtId: string | undefined;
    levelOfEmployment: number | undefined;
    id: number;
}

export class GetDistrictPlzSearchOutput implements IGetDistrictPlzSearchOutput {
    totalCount!: number;
    items!: DistrictPlzDto[] | undefined;

    constructor(data?: IGetDistrictPlzSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DistrictPlzDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDistrictPlzSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDistrictPlzSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDistrictPlzSearchOutput {
    totalCount: number;
    items: DistrictPlzDto[] | undefined;
}

export class GetEhcCapSearchInput implements IGetEhcCapSearchInput {
    postgraduateTitleId!: string | undefined;
    districtId!: string | undefined;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IGetEhcCapSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.districtId = _data["districtId"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetEhcCapSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEhcCapSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["districtId"] = this.districtId;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IGetEhcCapSearchInput {
    postgraduateTitleId: string | undefined;
    districtId: string | undefined;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class GetEhcCapSearchOutput implements IGetEhcCapSearchOutput {
    totalCount!: number;
    items!: EhcCapDto[] | undefined;

    constructor(data?: IGetEhcCapSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EhcCapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEhcCapSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEhcCapSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEhcCapSearchOutput {
    totalCount: number;
    items: EhcCapDto[] | undefined;
}

export class GetEhcCapWaitListSearchInput implements IGetEhcCapWaitListSearchInput {
    nameFilter!: string | undefined;
    titleFilter!: string | undefined;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IGetEhcCapWaitListSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameFilter = _data["nameFilter"];
            this.titleFilter = _data["titleFilter"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetEhcCapWaitListSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEhcCapWaitListSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameFilter"] = this.nameFilter;
        data["titleFilter"] = this.titleFilter;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IGetEhcCapWaitListSearchInput {
    nameFilter: string | undefined;
    titleFilter: string | undefined;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class GetEhcCapWaitListSearchOutput implements IGetEhcCapWaitListSearchOutput {
    totalCount!: number;
    items!: EhcCapWaitListEntryDto[] | undefined;

    constructor(data?: IGetEhcCapWaitListSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EhcCapWaitListEntryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEhcCapWaitListSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEhcCapWaitListSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEhcCapWaitListSearchOutput {
    totalCount: number;
    items: EhcCapWaitListEntryDto[] | undefined;
}

export class GetOneOrMoreTitleStoppedDto implements IGetOneOrMoreTitleStoppedDto {
    postgraduateTitleId!: string | undefined;
    postCode!: number | undefined;

    constructor(data?: IGetOneOrMoreTitleStoppedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.postCode = _data["postCode"];
        }
    }

    static fromJS(data: any): GetOneOrMoreTitleStoppedDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOneOrMoreTitleStoppedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["postCode"] = this.postCode;
        return data;
    }
}

export interface IGetOneOrMoreTitleStoppedDto {
    postgraduateTitleId: string | undefined;
    postCode: number | undefined;
}

export class GetOneOrMoreTitleStoppedInputDto implements IGetOneOrMoreTitleStoppedInputDto {
    titles!: GetOneOrMoreTitleStoppedDto[] | undefined;

    constructor(data?: IGetOneOrMoreTitleStoppedInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(GetOneOrMoreTitleStoppedDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOneOrMoreTitleStoppedInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOneOrMoreTitleStoppedInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOneOrMoreTitleStoppedInputDto {
    titles: GetOneOrMoreTitleStoppedDto[] | undefined;
}

export class ImportEhcCapExcelFileDto implements IImportEhcCapExcelFileDto {
    filename!: string;
    file!: string;

    constructor(data?: IImportEhcCapExcelFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["filename"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): ImportEhcCapExcelFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportEhcCapExcelFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["file"] = this.file;
        return data;
    }
}

export interface IImportEhcCapExcelFileDto {
    filename: string;
    file: string;
}

export class ApplicationEmploymentPerson implements IApplicationEmploymentPerson {
    employment!: Employment;
    gln!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    professionId!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationEmploymentPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employment = _data["employment"] ? Employment.fromJS(_data["employment"]) : <any>undefined;
            this.gln = _data["gln"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.professionId = _data["professionId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationEmploymentPerson {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationEmploymentPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employment"] = this.employment ? this.employment.toJSON() : <any>undefined;
        data["gln"] = this.gln;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["professionId"] = this.professionId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationEmploymentPerson {
    employment: Employment;
    gln: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    professionId: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CreateEmploymentDto implements ICreateEmploymentDto {
    personId!: number | undefined;
    sponsorshipId!: number | undefined;
    businessId!: number | undefined;
    corporateLicenceId!: number | undefined;
    personLicenceId!: number | undefined;
    statusId!: string | undefined;
    locationTypeId!: string | undefined;
    roleId!: string | undefined;
    roleText!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    authorisationSelfDispensationId!: string | undefined;
    authorisationSelfDispensationRemark!: string | undefined;
    remark!: string | undefined;
    selfEmploymentId!: string | undefined;
    isMobileEmployment!: boolean;
    healthRegisterTransfer!: boolean;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;

    constructor(data?: ICreateEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.businessId = _data["businessId"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.personLicenceId = _data["personLicenceId"];
            this.statusId = _data["statusId"];
            this.locationTypeId = _data["locationTypeId"];
            this.roleId = _data["roleId"];
            this.roleText = _data["roleText"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.authorisationSelfDispensationId = _data["authorisationSelfDispensationId"];
            this.authorisationSelfDispensationRemark = _data["authorisationSelfDispensationRemark"];
            this.remark = _data["remark"];
            this.selfEmploymentId = _data["selfEmploymentId"];
            this.isMobileEmployment = _data["isMobileEmployment"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["sponsorshipId"] = this.sponsorshipId;
        data["businessId"] = this.businessId;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["personLicenceId"] = this.personLicenceId;
        data["statusId"] = this.statusId;
        data["locationTypeId"] = this.locationTypeId;
        data["roleId"] = this.roleId;
        data["roleText"] = this.roleText;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["authorisationSelfDispensationId"] = this.authorisationSelfDispensationId;
        data["authorisationSelfDispensationRemark"] = this.authorisationSelfDispensationRemark;
        data["remark"] = this.remark;
        data["selfEmploymentId"] = this.selfEmploymentId;
        data["isMobileEmployment"] = this.isMobileEmployment;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        return data;
    }
}

export interface ICreateEmploymentDto {
    personId: number | undefined;
    sponsorshipId: number | undefined;
    businessId: number | undefined;
    corporateLicenceId: number | undefined;
    personLicenceId: number | undefined;
    statusId: string | undefined;
    locationTypeId: string | undefined;
    roleId: string | undefined;
    roleText: string | undefined;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    authorisationSelfDispensationId: string | undefined;
    authorisationSelfDispensationRemark: string | undefined;
    remark: string | undefined;
    selfEmploymentId: string | undefined;
    isMobileEmployment: boolean;
    healthRegisterTransfer: boolean;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
}

export class EmploymentSearchOutputDto implements IEmploymentSearchOutputDto {
    totalCount!: number;
    items!: EmploymentSearchResultDto[] | undefined;

    constructor(data?: IEmploymentSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EmploymentSearchResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmploymentSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmploymentSearchOutputDto {
    totalCount: number;
    items: EmploymentSearchResultDto[] | undefined;
}

export class EmploymentSearchResultDto implements IEmploymentSearchResultDto {
    personId!: number | undefined;
    businessId!: number | undefined;
    sponsorshipId!: number | undefined;
    personLicenceType!: PersonLicenceType;
    personLicenceId!: number | undefined;
    corporateLicenceId!: number | undefined;
    corporateLicenceTypeId!: CorporateLicenceType;
    corporateLicenceSponsorshipTypeId!: string | undefined;
    corporateLicenceStatusId!: string | undefined;
    statusId!: string | undefined;
    isMobileEmployment!: boolean;
    businessName!: string | undefined;
    personName!: string | undefined;
    roleId!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    id!: number;

    constructor(data?: IEmploymentSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.businessId = _data["businessId"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.personLicenceType = _data["personLicenceType"];
            this.personLicenceId = _data["personLicenceId"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.corporateLicenceTypeId = _data["corporateLicenceTypeId"];
            this.corporateLicenceSponsorshipTypeId = _data["corporateLicenceSponsorshipTypeId"];
            this.corporateLicenceStatusId = _data["corporateLicenceStatusId"];
            this.statusId = _data["statusId"];
            this.isMobileEmployment = _data["isMobileEmployment"];
            this.businessName = _data["businessName"];
            this.personName = _data["personName"];
            this.roleId = _data["roleId"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmploymentSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["businessId"] = this.businessId;
        data["sponsorshipId"] = this.sponsorshipId;
        data["personLicenceType"] = this.personLicenceType;
        data["personLicenceId"] = this.personLicenceId;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["corporateLicenceTypeId"] = this.corporateLicenceTypeId;
        data["corporateLicenceSponsorshipTypeId"] = this.corporateLicenceSponsorshipTypeId;
        data["corporateLicenceStatusId"] = this.corporateLicenceStatusId;
        data["statusId"] = this.statusId;
        data["isMobileEmployment"] = this.isMobileEmployment;
        data["businessName"] = this.businessName;
        data["personName"] = this.personName;
        data["roleId"] = this.roleId;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["id"] = this.id;
        return data;
    }
}

export interface IEmploymentSearchResultDto {
    personId: number | undefined;
    businessId: number | undefined;
    sponsorshipId: number | undefined;
    personLicenceType: PersonLicenceType;
    personLicenceId: number | undefined;
    corporateLicenceId: number | undefined;
    corporateLicenceTypeId: CorporateLicenceType;
    corporateLicenceSponsorshipTypeId: string | undefined;
    corporateLicenceStatusId: string | undefined;
    statusId: string | undefined;
    isMobileEmployment: boolean;
    businessName: string | undefined;
    personName: string | undefined;
    roleId: string | undefined;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    id: number;
}

export class GetActiveMedicalFieldDirectorThatWillBeReplacedInput implements IGetActiveMedicalFieldDirectorThatWillBeReplacedInput {
    id!: number;
    corporateLicenceId!: number;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;

    constructor(data?: IGetActiveMedicalFieldDirectorThatWillBeReplacedInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetActiveMedicalFieldDirectorThatWillBeReplacedInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetActiveMedicalFieldDirectorThatWillBeReplacedInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IGetActiveMedicalFieldDirectorThatWillBeReplacedInput {
    id: number;
    corporateLicenceId: number;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
}

export class GetEmploymentDto implements IGetEmploymentDto {
    statusId!: string | undefined;
    locationTypeId!: string | undefined;
    roleId!: string | undefined;
    roleText!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    authorisationSelfDispensationId!: string | undefined;
    authorisationSelfDispensationRemark!: string | undefined;
    remark!: string | undefined;
    selfEmploymentId!: string | undefined;
    isMobileEmployment!: boolean;
    healthRegisterTransfer!: boolean;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    healthRegisterSync!: DateTime | undefined;
    sponsorshipId!: number | undefined;
    sponsorship!: GetSponsorshipDto;
    businessId!: number | undefined;
    business!: GetBusinessDto;
    corporateLicenceId!: number | undefined;
    corporateLicence!: GetCorporateLicenceDto;
    personId!: number | undefined;
    person!: EmploymentPersonDto;
    personLicenceId!: number | undefined;
    personLicence!: GetPersonLicenceDto;
    liaEmployment!: LiaEmploymentDto;
    liaEmploymentId!: number | undefined;
    employmentAddress!: EmploymentAddressDto;
    employmentAddressId!: number | undefined;
    applicationEmploymentPerson!: ApplicationEmploymentPersonDto;
    applicationEmploymentPersonId!: number | undefined;
    id!: number;

    constructor(data?: IGetEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusId = _data["statusId"];
            this.locationTypeId = _data["locationTypeId"];
            this.roleId = _data["roleId"];
            this.roleText = _data["roleText"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.authorisationSelfDispensationId = _data["authorisationSelfDispensationId"];
            this.authorisationSelfDispensationRemark = _data["authorisationSelfDispensationRemark"];
            this.remark = _data["remark"];
            this.selfEmploymentId = _data["selfEmploymentId"];
            this.isMobileEmployment = _data["isMobileEmployment"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.healthRegisterSync = _data["healthRegisterSync"] ? DateTime.fromISO(_data["healthRegisterSync"].toString()) : <any>undefined;
            this.sponsorshipId = _data["sponsorshipId"];
            this.sponsorship = _data["sponsorship"] ? GetSponsorshipDto.fromJS(_data["sponsorship"]) : <any>undefined;
            this.businessId = _data["businessId"];
            this.business = _data["business"] ? GetBusinessDto.fromJS(_data["business"]) : <any>undefined;
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.corporateLicence = _data["corporateLicence"] ? GetCorporateLicenceDto.fromJS(_data["corporateLicence"]) : <any>undefined;
            this.personId = _data["personId"];
            this.person = _data["person"] ? EmploymentPersonDto.fromJS(_data["person"]) : <any>undefined;
            this.personLicenceId = _data["personLicenceId"];
            this.personLicence = _data["personLicence"] ? GetPersonLicenceDto.fromJS(_data["personLicence"]) : <any>undefined;
            this.liaEmployment = _data["liaEmployment"] ? LiaEmploymentDto.fromJS(_data["liaEmployment"]) : <any>undefined;
            this.liaEmploymentId = _data["liaEmploymentId"];
            this.employmentAddress = _data["employmentAddress"] ? EmploymentAddressDto.fromJS(_data["employmentAddress"]) : <any>undefined;
            this.employmentAddressId = _data["employmentAddressId"];
            this.applicationEmploymentPerson = _data["applicationEmploymentPerson"] ? ApplicationEmploymentPersonDto.fromJS(_data["applicationEmploymentPerson"]) : <any>undefined;
            this.applicationEmploymentPersonId = _data["applicationEmploymentPersonId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusId"] = this.statusId;
        data["locationTypeId"] = this.locationTypeId;
        data["roleId"] = this.roleId;
        data["roleText"] = this.roleText;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["authorisationSelfDispensationId"] = this.authorisationSelfDispensationId;
        data["authorisationSelfDispensationRemark"] = this.authorisationSelfDispensationRemark;
        data["remark"] = this.remark;
        data["selfEmploymentId"] = this.selfEmploymentId;
        data["isMobileEmployment"] = this.isMobileEmployment;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["healthRegisterSync"] = this.healthRegisterSync ? this.healthRegisterSync.toString() : <any>undefined;
        data["sponsorshipId"] = this.sponsorshipId;
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        data["businessId"] = this.businessId;
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["corporateLicence"] = this.corporateLicence ? this.corporateLicence.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personLicenceId"] = this.personLicenceId;
        data["personLicence"] = this.personLicence ? this.personLicence.toJSON() : <any>undefined;
        data["liaEmployment"] = this.liaEmployment ? this.liaEmployment.toJSON() : <any>undefined;
        data["liaEmploymentId"] = this.liaEmploymentId;
        data["employmentAddress"] = this.employmentAddress ? this.employmentAddress.toJSON() : <any>undefined;
        data["employmentAddressId"] = this.employmentAddressId;
        data["applicationEmploymentPerson"] = this.applicationEmploymentPerson ? this.applicationEmploymentPerson.toJSON() : <any>undefined;
        data["applicationEmploymentPersonId"] = this.applicationEmploymentPersonId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetEmploymentDto {
    statusId: string | undefined;
    locationTypeId: string | undefined;
    roleId: string | undefined;
    roleText: string | undefined;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    authorisationSelfDispensationId: string | undefined;
    authorisationSelfDispensationRemark: string | undefined;
    remark: string | undefined;
    selfEmploymentId: string | undefined;
    isMobileEmployment: boolean;
    healthRegisterTransfer: boolean;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    healthRegisterSync: DateTime | undefined;
    sponsorshipId: number | undefined;
    sponsorship: GetSponsorshipDto;
    businessId: number | undefined;
    business: GetBusinessDto;
    corporateLicenceId: number | undefined;
    corporateLicence: GetCorporateLicenceDto;
    personId: number | undefined;
    person: EmploymentPersonDto;
    personLicenceId: number | undefined;
    personLicence: GetPersonLicenceDto;
    liaEmployment: LiaEmploymentDto;
    liaEmploymentId: number | undefined;
    employmentAddress: EmploymentAddressDto;
    employmentAddressId: number | undefined;
    applicationEmploymentPerson: ApplicationEmploymentPersonDto;
    applicationEmploymentPersonId: number | undefined;
    id: number;
}

export class UpdateEmploymentDto implements IUpdateEmploymentDto {
    sponsorshipId!: number | undefined;
    businessId!: number | undefined;
    corporateLicenceId!: number | undefined;
    personLicenceId!: number | undefined;
    statusId!: string | undefined;
    locationTypeId!: string | undefined;
    roleId!: string | undefined;
    roleText!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    authorisationSelfDispensationId!: string | undefined;
    authorisationSelfDispensationRemark!: string | undefined;
    remark!: string | undefined;
    selfEmploymentId!: string | undefined;
    isMobileEmployment!: boolean;
    healthRegisterTransfer!: boolean;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;

    constructor(data?: IUpdateEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipId = _data["sponsorshipId"];
            this.businessId = _data["businessId"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.personLicenceId = _data["personLicenceId"];
            this.statusId = _data["statusId"];
            this.locationTypeId = _data["locationTypeId"];
            this.roleId = _data["roleId"];
            this.roleText = _data["roleText"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.authorisationSelfDispensationId = _data["authorisationSelfDispensationId"];
            this.authorisationSelfDispensationRemark = _data["authorisationSelfDispensationRemark"];
            this.remark = _data["remark"];
            this.selfEmploymentId = _data["selfEmploymentId"];
            this.isMobileEmployment = _data["isMobileEmployment"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UpdateEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipId"] = this.sponsorshipId;
        data["businessId"] = this.businessId;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["personLicenceId"] = this.personLicenceId;
        data["statusId"] = this.statusId;
        data["locationTypeId"] = this.locationTypeId;
        data["roleId"] = this.roleId;
        data["roleText"] = this.roleText;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["authorisationSelfDispensationId"] = this.authorisationSelfDispensationId;
        data["authorisationSelfDispensationRemark"] = this.authorisationSelfDispensationRemark;
        data["remark"] = this.remark;
        data["selfEmploymentId"] = this.selfEmploymentId;
        data["isMobileEmployment"] = this.isMobileEmployment;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        return data;
    }
}

export interface IUpdateEmploymentDto {
    sponsorshipId: number | undefined;
    businessId: number | undefined;
    corporateLicenceId: number | undefined;
    personLicenceId: number | undefined;
    statusId: string | undefined;
    locationTypeId: string | undefined;
    roleId: string | undefined;
    roleText: string | undefined;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    authorisationSelfDispensationId: string | undefined;
    authorisationSelfDispensationRemark: string | undefined;
    remark: string | undefined;
    selfEmploymentId: string | undefined;
    isMobileEmployment: boolean;
    healthRegisterTransfer: boolean;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
}

export class Employment implements IEmployment {
    sponsorship!: Sponsorship;
    sponsorshipId!: number | undefined;
    business!: Business;
    businessId!: number | undefined;
    personLicence!: PersonLicence;
    personLicenceId!: number | undefined;
    corporateLicence!: CorporateLicence;
    corporateLicenceId!: number | undefined;
    person!: Person;
    personId!: number | undefined;
    statusId!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    locationTypeId!: string | undefined;
    roleId!: string | undefined;
    roleText!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    authorisationSelfDispensationId!: string | undefined;
    authorisationSelfDispensationRemark!: string | undefined;
    remark!: string | undefined;
    isMobileEmployment!: boolean;
    healthRegisterTransfer!: boolean;
    healthRegisterSync!: DateTime | undefined;
    betRegTransfer!: EmploymentBetRegTransfer;
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    selfEmploymentId!: string | undefined;
    liaEmployment!: LiaEmployment;
    liaEmploymentId!: number | undefined;
    employmentAddress!: EmploymentAddress;
    applicationEmploymentPerson!: ApplicationEmploymentPerson;
    businessTransfers!: BusinessTransfer[] | undefined;
    migrationData!: MigrationData[] | undefined;
    readonly isActive!: boolean;
    invoiceAddressDetail!: InvoiceAddressDetail;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IEmployment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorship = _data["sponsorship"] ? Sponsorship.fromJS(_data["sponsorship"]) : <any>undefined;
            this.sponsorshipId = _data["sponsorshipId"];
            this.business = _data["business"] ? Business.fromJS(_data["business"]) : <any>undefined;
            this.businessId = _data["businessId"];
            this.personLicence = _data["personLicence"] ? PersonLicence.fromJS(_data["personLicence"]) : <any>undefined;
            this.personLicenceId = _data["personLicenceId"];
            this.corporateLicence = _data["corporateLicence"] ? CorporateLicence.fromJS(_data["corporateLicence"]) : <any>undefined;
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.personId = _data["personId"];
            this.statusId = _data["statusId"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.locationTypeId = _data["locationTypeId"];
            this.roleId = _data["roleId"];
            this.roleText = _data["roleText"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.authorisationSelfDispensationId = _data["authorisationSelfDispensationId"];
            this.authorisationSelfDispensationRemark = _data["authorisationSelfDispensationRemark"];
            this.remark = _data["remark"];
            this.isMobileEmployment = _data["isMobileEmployment"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.healthRegisterSync = _data["healthRegisterSync"] ? DateTime.fromISO(_data["healthRegisterSync"].toString()) : <any>undefined;
            this.betRegTransfer = _data["betRegTransfer"] ? EmploymentBetRegTransfer.fromJS(_data["betRegTransfer"]) : <any>undefined;
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.selfEmploymentId = _data["selfEmploymentId"];
            this.liaEmployment = _data["liaEmployment"] ? LiaEmployment.fromJS(_data["liaEmployment"]) : <any>undefined;
            this.liaEmploymentId = _data["liaEmploymentId"];
            this.employmentAddress = _data["employmentAddress"] ? EmploymentAddress.fromJS(_data["employmentAddress"]) : <any>undefined;
            this.applicationEmploymentPerson = _data["applicationEmploymentPerson"] ? ApplicationEmploymentPerson.fromJS(_data["applicationEmploymentPerson"]) : <any>undefined;
            if (Array.isArray(_data["businessTransfers"])) {
                this.businessTransfers = [] as any;
                for (let item of _data["businessTransfers"])
                    this.businessTransfers!.push(BusinessTransfer.fromJS(item));
            }
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            (<any>this).isActive = _data["isActive"];
            this.invoiceAddressDetail = _data["invoiceAddressDetail"] ? InvoiceAddressDetail.fromJS(_data["invoiceAddressDetail"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Employment {
        data = typeof data === 'object' ? data : {};
        let result = new Employment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        data["sponsorshipId"] = this.sponsorshipId;
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        data["businessId"] = this.businessId;
        data["personLicence"] = this.personLicence ? this.personLicence.toJSON() : <any>undefined;
        data["personLicenceId"] = this.personLicenceId;
        data["corporateLicence"] = this.corporateLicence ? this.corporateLicence.toJSON() : <any>undefined;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["statusId"] = this.statusId;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["locationTypeId"] = this.locationTypeId;
        data["roleId"] = this.roleId;
        data["roleText"] = this.roleText;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["authorisationSelfDispensationId"] = this.authorisationSelfDispensationId;
        data["authorisationSelfDispensationRemark"] = this.authorisationSelfDispensationRemark;
        data["remark"] = this.remark;
        data["isMobileEmployment"] = this.isMobileEmployment;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["healthRegisterSync"] = this.healthRegisterSync ? this.healthRegisterSync.toString() : <any>undefined;
        data["betRegTransfer"] = this.betRegTransfer ? this.betRegTransfer.toJSON() : <any>undefined;
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["selfEmploymentId"] = this.selfEmploymentId;
        data["liaEmployment"] = this.liaEmployment ? this.liaEmployment.toJSON() : <any>undefined;
        data["liaEmploymentId"] = this.liaEmploymentId;
        data["employmentAddress"] = this.employmentAddress ? this.employmentAddress.toJSON() : <any>undefined;
        data["applicationEmploymentPerson"] = this.applicationEmploymentPerson ? this.applicationEmploymentPerson.toJSON() : <any>undefined;
        if (Array.isArray(this.businessTransfers)) {
            data["businessTransfers"] = [];
            for (let item of this.businessTransfers)
                data["businessTransfers"].push(item.toJSON());
        }
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        data["invoiceAddressDetail"] = this.invoiceAddressDetail ? this.invoiceAddressDetail.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEmployment {
    sponsorship: Sponsorship;
    sponsorshipId: number | undefined;
    business: Business;
    businessId: number | undefined;
    personLicence: PersonLicence;
    personLicenceId: number | undefined;
    corporateLicence: CorporateLicence;
    corporateLicenceId: number | undefined;
    person: Person;
    personId: number | undefined;
    statusId: string | undefined;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    locationTypeId: string | undefined;
    roleId: string | undefined;
    roleText: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    authorisationSelfDispensationId: string | undefined;
    authorisationSelfDispensationRemark: string | undefined;
    remark: string | undefined;
    isMobileEmployment: boolean;
    healthRegisterTransfer: boolean;
    healthRegisterSync: DateTime | undefined;
    betRegTransfer: EmploymentBetRegTransfer;
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    selfEmploymentId: string | undefined;
    liaEmployment: LiaEmployment;
    liaEmploymentId: number | undefined;
    employmentAddress: EmploymentAddress;
    applicationEmploymentPerson: ApplicationEmploymentPerson;
    businessTransfers: BusinessTransfer[] | undefined;
    migrationData: MigrationData[] | undefined;
    isActive: boolean;
    invoiceAddressDetail: InvoiceAddressDetail;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class EmploymentAddress implements IEmploymentAddress {
    employment!: Employment;
    employmentId!: number | undefined;
    type!: Code;
    typeId!: string | undefined;
    status!: Code;
    statusId!: string | undefined;
    businessName!: string | undefined;
    additionalName!: string | undefined;
    legalForm!: Code;
    legalFormId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    country!: Code;
    countryId!: string | undefined;
    postOfficeBox!: string | undefined;
    addressSupplement!: string | undefined;
    phone!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    website!: string | undefined;
    medicalPracticeTakeoverDetails!: string | undefined;
    medicalGroupPracticeDetails!: string | undefined;
    dateOfOpening!: DateTime | undefined;
    dateOfClosure!: DateTime | undefined;
    businessHours!: string | undefined;
    bur!: string | undefined;
    gln!: string | undefined;
    comments!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IEmploymentAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employment = _data["employment"] ? Employment.fromJS(_data["employment"]) : <any>undefined;
            this.employmentId = _data["employmentId"];
            this.type = _data["type"] ? Code.fromJS(_data["type"]) : <any>undefined;
            this.typeId = _data["typeId"];
            this.status = _data["status"] ? Code.fromJS(_data["status"]) : <any>undefined;
            this.statusId = _data["statusId"];
            this.businessName = _data["businessName"];
            this.additionalName = _data["additionalName"];
            this.legalForm = _data["legalForm"] ? Code.fromJS(_data["legalForm"]) : <any>undefined;
            this.legalFormId = _data["legalFormId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.country = _data["country"] ? Code.fromJS(_data["country"]) : <any>undefined;
            this.countryId = _data["countryId"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressSupplement = _data["addressSupplement"];
            this.phone = _data["phone"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.medicalPracticeTakeoverDetails = _data["medicalPracticeTakeoverDetails"];
            this.medicalGroupPracticeDetails = _data["medicalGroupPracticeDetails"];
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.dateOfClosure = _data["dateOfClosure"] ? DateTime.fromISO(_data["dateOfClosure"].toString()) : <any>undefined;
            this.businessHours = _data["businessHours"];
            this.bur = _data["bur"];
            this.gln = _data["gln"];
            this.comments = _data["comments"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmploymentAddress {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employment"] = this.employment ? this.employment.toJSON() : <any>undefined;
        data["employmentId"] = this.employmentId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["statusId"] = this.statusId;
        data["businessName"] = this.businessName;
        data["additionalName"] = this.additionalName;
        data["legalForm"] = this.legalForm ? this.legalForm.toJSON() : <any>undefined;
        data["legalFormId"] = this.legalFormId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["countryId"] = this.countryId;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressSupplement"] = this.addressSupplement;
        data["phone"] = this.phone;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["website"] = this.website;
        data["medicalPracticeTakeoverDetails"] = this.medicalPracticeTakeoverDetails;
        data["medicalGroupPracticeDetails"] = this.medicalGroupPracticeDetails;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfClosure"] = this.dateOfClosure ? this.dateOfClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessHours"] = this.businessHours;
        data["bur"] = this.bur;
        data["gln"] = this.gln;
        data["comments"] = this.comments;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEmploymentAddress {
    employment: Employment;
    employmentId: number | undefined;
    type: Code;
    typeId: string | undefined;
    status: Code;
    statusId: string | undefined;
    businessName: string | undefined;
    additionalName: string | undefined;
    legalForm: Code;
    legalFormId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    country: Code;
    countryId: string | undefined;
    postOfficeBox: string | undefined;
    addressSupplement: string | undefined;
    phone: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    website: string | undefined;
    medicalPracticeTakeoverDetails: string | undefined;
    medicalGroupPracticeDetails: string | undefined;
    dateOfOpening: DateTime | undefined;
    dateOfClosure: DateTime | undefined;
    businessHours: string | undefined;
    bur: string | undefined;
    gln: string | undefined;
    comments: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class EmploymentBetRegTransfer implements IEmploymentBetRegTransfer {
    personMedRegBMId!: number | undefined;
    isMedicalPerson!: boolean;
    healthRegisterSync!: DateTime | undefined;

    constructor(data?: IEmploymentBetRegTransfer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personMedRegBMId = _data["personMedRegBMId"];
            this.isMedicalPerson = _data["isMedicalPerson"];
            this.healthRegisterSync = _data["healthRegisterSync"] ? DateTime.fromISO(_data["healthRegisterSync"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmploymentBetRegTransfer {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentBetRegTransfer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personMedRegBMId"] = this.personMedRegBMId;
        data["isMedicalPerson"] = this.isMedicalPerson;
        data["healthRegisterSync"] = this.healthRegisterSync ? this.healthRegisterSync.toString() : <any>undefined;
        return data;
    }
}

export interface IEmploymentBetRegTransfer {
    personMedRegBMId: number | undefined;
    isMedicalPerson: boolean;
    healthRegisterSync: DateTime | undefined;
}

export class EmploymentDeletingConditions implements IEmploymentDeletingConditions {
    hasBusiness!: boolean;
    isLinkedWithCorporateLicence!: boolean;

    constructor(data?: IEmploymentDeletingConditions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasBusiness = _data["hasBusiness"];
            this.isLinkedWithCorporateLicence = _data["isLinkedWithCorporateLicence"];
        }
    }

    static fromJS(data: any): EmploymentDeletingConditions {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentDeletingConditions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasBusiness"] = this.hasBusiness;
        data["isLinkedWithCorporateLicence"] = this.isLinkedWithCorporateLicence;
        return data;
    }
}

export interface IEmploymentDeletingConditions {
    hasBusiness: boolean;
    isLinkedWithCorporateLicence: boolean;
}

export class UpdateEmploymentAddressInput implements IUpdateEmploymentAddressInput {
    employmentAddress!: EmploymentAddressDto;

    constructor(data?: IUpdateEmploymentAddressInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employmentAddress = _data["employmentAddress"] ? EmploymentAddressDto.fromJS(_data["employmentAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateEmploymentAddressInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmploymentAddressInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employmentAddress"] = this.employmentAddress ? this.employmentAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateEmploymentAddressInput {
    employmentAddress: EmploymentAddressDto;
}

export class CreateOrUpdateEhcContactInput implements ICreateOrUpdateEhcContactInput {
    caseId!: string;
    ehcContact!: EhcContactDto;

    constructor(data?: ICreateOrUpdateEhcContactInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcContact = new EhcContactDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcContact = _data["ehcContact"] ? EhcContactDto.fromJS(_data["ehcContact"]) : new EhcContactDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcContactInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcContactInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcContact"] = this.ehcContact ? this.ehcContact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcContactInput {
    caseId: string;
    ehcContact: EhcContactDto;
}

export class EhcContactDto implements IEhcContactDto {
    titleId!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    street!: string;
    streetNr!: string | undefined;
    postCode!: string;
    city!: string;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    titleAddressSwiss!: string | undefined;
    streetSwiss!: string | undefined;
    streetNrSwiss!: string | undefined;
    postCodeSwiss!: string | undefined;
    citySwiss!: string | undefined;
    postOfficeBoxSwiss!: string | undefined;
    addressSupplementSwiss!: string | undefined;

    constructor(data?: IEhcContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.titleAddressSwiss = _data["titleAddressSwiss"];
            this.streetSwiss = _data["streetSwiss"];
            this.streetNrSwiss = _data["streetNrSwiss"];
            this.postCodeSwiss = _data["postCodeSwiss"];
            this.citySwiss = _data["citySwiss"];
            this.postOfficeBoxSwiss = _data["postOfficeBoxSwiss"];
            this.addressSupplementSwiss = _data["addressSupplementSwiss"];
        }
    }

    static fromJS(data: any): EhcContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["titleAddressSwiss"] = this.titleAddressSwiss;
        data["streetSwiss"] = this.streetSwiss;
        data["streetNrSwiss"] = this.streetNrSwiss;
        data["postCodeSwiss"] = this.postCodeSwiss;
        data["citySwiss"] = this.citySwiss;
        data["postOfficeBoxSwiss"] = this.postOfficeBoxSwiss;
        data["addressSupplementSwiss"] = this.addressSupplementSwiss;
        return data;
    }
}

export interface IEhcContactDto {
    titleId: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    street: string;
    streetNr: string | undefined;
    postCode: string;
    city: string;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    titleAddressSwiss: string | undefined;
    streetSwiss: string | undefined;
    streetNrSwiss: string | undefined;
    postCodeSwiss: string | undefined;
    citySwiss: string | undefined;
    postOfficeBoxSwiss: string | undefined;
    addressSupplementSwiss: string | undefined;
}

export class CreateEhcApplicationDto implements ICreateEhcApplicationDto {
    professionId!: string;
    applicationType!: ApplicationType;
    legitimationId!: number;

    constructor(data?: ICreateEhcApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.applicationType = _data["applicationType"];
            this.legitimationId = _data["legitimationId"];
        }
    }

    static fromJS(data: any): CreateEhcApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEhcApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["applicationType"] = this.applicationType;
        data["legitimationId"] = this.legitimationId;
        return data;
    }
}

export interface ICreateEhcApplicationDto {
    professionId: string;
    applicationType: ApplicationType;
    legitimationId: number;
}

export class EhcDocumentsOutput implements IEhcDocumentsOutput {
    caseId!: string;
    ehcDocuments!: GeneralDocumentGroupDto[];

    constructor(data?: IEhcDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcDocuments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["ehcDocuments"])) {
                this.ehcDocuments = [] as any;
                for (let item of _data["ehcDocuments"])
                    this.ehcDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EhcDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EhcDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.ehcDocuments)) {
            data["ehcDocuments"] = [];
            for (let item of this.ehcDocuments)
                data["ehcDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEhcDocumentsOutput {
    caseId: string;
    ehcDocuments: GeneralDocumentGroupDto[];
}

export class EhcDto implements IEhcDto {
    application!: ApplicationDto;
    professionId!: string | undefined;
    personLicenceId!: number | undefined;
    liaApplicationId!: number | undefined;
    liaCaseId!: string | undefined;
    currentStep!: EhcStatus;
    firstStep!: EhcStatus;
    ehcSelfEmployment!: EhcSelfEmploymentDto;
    ehcRegister!: EhcRegisterDto;
    ehcMedicalField!: EhcMedicalFieldDto;
    ehcLanguageSkill!: EhcLanguageSkillDto;
    ehcPractice!: EhcPracticeDto;
    ehcPostgraduateTitles!: EhcPostgraduateTitleDto[] | undefined;
    ehcEmploymentOrPostgraduateTitles!: EhcEmploymentOrPostgraduateTitleDto[] | undefined;
    ehcElectronicPatientRecord!: EhcElectronicPatientRecordDto;
    ehcQualityRequirement!: EhcQualityRequirementDto;
    ehcStaff!: EhcStaffDto;
    ehcContact!: EhcContactDto;
    ehcEmployments!: EhcEmploymentOutput;
    ehcInvoiceAddress!: EhcInvoiceAddressDto;
    hasLiaApplicationInWaitingStatus!: boolean;
    ehcDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IEhcDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.professionId = _data["professionId"];
            this.personLicenceId = _data["personLicenceId"];
            this.liaApplicationId = _data["liaApplicationId"];
            this.liaCaseId = _data["liaCaseId"];
            this.currentStep = _data["currentStep"];
            this.firstStep = _data["firstStep"];
            this.ehcSelfEmployment = _data["ehcSelfEmployment"] ? EhcSelfEmploymentDto.fromJS(_data["ehcSelfEmployment"]) : <any>undefined;
            this.ehcRegister = _data["ehcRegister"] ? EhcRegisterDto.fromJS(_data["ehcRegister"]) : <any>undefined;
            this.ehcMedicalField = _data["ehcMedicalField"] ? EhcMedicalFieldDto.fromJS(_data["ehcMedicalField"]) : <any>undefined;
            this.ehcLanguageSkill = _data["ehcLanguageSkill"] ? EhcLanguageSkillDto.fromJS(_data["ehcLanguageSkill"]) : <any>undefined;
            this.ehcPractice = _data["ehcPractice"] ? EhcPracticeDto.fromJS(_data["ehcPractice"]) : <any>undefined;
            if (Array.isArray(_data["ehcPostgraduateTitles"])) {
                this.ehcPostgraduateTitles = [] as any;
                for (let item of _data["ehcPostgraduateTitles"])
                    this.ehcPostgraduateTitles!.push(EhcPostgraduateTitleDto.fromJS(item));
            }
            if (Array.isArray(_data["ehcEmploymentOrPostgraduateTitles"])) {
                this.ehcEmploymentOrPostgraduateTitles = [] as any;
                for (let item of _data["ehcEmploymentOrPostgraduateTitles"])
                    this.ehcEmploymentOrPostgraduateTitles!.push(EhcEmploymentOrPostgraduateTitleDto.fromJS(item));
            }
            this.ehcElectronicPatientRecord = _data["ehcElectronicPatientRecord"] ? EhcElectronicPatientRecordDto.fromJS(_data["ehcElectronicPatientRecord"]) : <any>undefined;
            this.ehcQualityRequirement = _data["ehcQualityRequirement"] ? EhcQualityRequirementDto.fromJS(_data["ehcQualityRequirement"]) : <any>undefined;
            this.ehcStaff = _data["ehcStaff"] ? EhcStaffDto.fromJS(_data["ehcStaff"]) : <any>undefined;
            this.ehcContact = _data["ehcContact"] ? EhcContactDto.fromJS(_data["ehcContact"]) : <any>undefined;
            this.ehcEmployments = _data["ehcEmployments"] ? EhcEmploymentOutput.fromJS(_data["ehcEmployments"]) : <any>undefined;
            this.ehcInvoiceAddress = _data["ehcInvoiceAddress"] ? EhcInvoiceAddressDto.fromJS(_data["ehcInvoiceAddress"]) : <any>undefined;
            this.hasLiaApplicationInWaitingStatus = _data["hasLiaApplicationInWaitingStatus"];
            if (Array.isArray(_data["ehcDocuments"])) {
                this.ehcDocuments = [] as any;
                for (let item of _data["ehcDocuments"])
                    this.ehcDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EhcDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["professionId"] = this.professionId;
        data["personLicenceId"] = this.personLicenceId;
        data["liaApplicationId"] = this.liaApplicationId;
        data["liaCaseId"] = this.liaCaseId;
        data["currentStep"] = this.currentStep;
        data["firstStep"] = this.firstStep;
        data["ehcSelfEmployment"] = this.ehcSelfEmployment ? this.ehcSelfEmployment.toJSON() : <any>undefined;
        data["ehcRegister"] = this.ehcRegister ? this.ehcRegister.toJSON() : <any>undefined;
        data["ehcMedicalField"] = this.ehcMedicalField ? this.ehcMedicalField.toJSON() : <any>undefined;
        data["ehcLanguageSkill"] = this.ehcLanguageSkill ? this.ehcLanguageSkill.toJSON() : <any>undefined;
        data["ehcPractice"] = this.ehcPractice ? this.ehcPractice.toJSON() : <any>undefined;
        if (Array.isArray(this.ehcPostgraduateTitles)) {
            data["ehcPostgraduateTitles"] = [];
            for (let item of this.ehcPostgraduateTitles)
                data["ehcPostgraduateTitles"].push(item.toJSON());
        }
        if (Array.isArray(this.ehcEmploymentOrPostgraduateTitles)) {
            data["ehcEmploymentOrPostgraduateTitles"] = [];
            for (let item of this.ehcEmploymentOrPostgraduateTitles)
                data["ehcEmploymentOrPostgraduateTitles"].push(item.toJSON());
        }
        data["ehcElectronicPatientRecord"] = this.ehcElectronicPatientRecord ? this.ehcElectronicPatientRecord.toJSON() : <any>undefined;
        data["ehcQualityRequirement"] = this.ehcQualityRequirement ? this.ehcQualityRequirement.toJSON() : <any>undefined;
        data["ehcStaff"] = this.ehcStaff ? this.ehcStaff.toJSON() : <any>undefined;
        data["ehcContact"] = this.ehcContact ? this.ehcContact.toJSON() : <any>undefined;
        data["ehcEmployments"] = this.ehcEmployments ? this.ehcEmployments.toJSON() : <any>undefined;
        data["ehcInvoiceAddress"] = this.ehcInvoiceAddress ? this.ehcInvoiceAddress.toJSON() : <any>undefined;
        data["hasLiaApplicationInWaitingStatus"] = this.hasLiaApplicationInWaitingStatus;
        if (Array.isArray(this.ehcDocuments)) {
            data["ehcDocuments"] = [];
            for (let item of this.ehcDocuments)
                data["ehcDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEhcDto {
    application: ApplicationDto;
    professionId: string | undefined;
    personLicenceId: number | undefined;
    liaApplicationId: number | undefined;
    liaCaseId: string | undefined;
    currentStep: EhcStatus;
    firstStep: EhcStatus;
    ehcSelfEmployment: EhcSelfEmploymentDto;
    ehcRegister: EhcRegisterDto;
    ehcMedicalField: EhcMedicalFieldDto;
    ehcLanguageSkill: EhcLanguageSkillDto;
    ehcPractice: EhcPracticeDto;
    ehcPostgraduateTitles: EhcPostgraduateTitleDto[] | undefined;
    ehcEmploymentOrPostgraduateTitles: EhcEmploymentOrPostgraduateTitleDto[] | undefined;
    ehcElectronicPatientRecord: EhcElectronicPatientRecordDto;
    ehcQualityRequirement: EhcQualityRequirementDto;
    ehcStaff: EhcStaffDto;
    ehcContact: EhcContactDto;
    ehcEmployments: EhcEmploymentOutput;
    ehcInvoiceAddress: EhcInvoiceAddressDto;
    hasLiaApplicationInWaitingStatus: boolean;
    ehcDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class EhcSearchDto implements IEhcSearchDto {
    id!: number;
    caseId!: string | undefined;
    caseIdSearchable!: string | undefined;
    fullName!: string | undefined;
    userFullName!: string | undefined;
    userEmail!: string | undefined;
    professionId!: string | undefined;
    status!: ApplicationStatus;
    dateOfStatusChange!: DateTime;
    responsibleId!: number | undefined;
    responsibleFullName!: string | undefined;
    iAmResponsible!: boolean;

    constructor(data?: IEhcSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.caseIdSearchable = _data["caseIdSearchable"];
            this.fullName = _data["fullName"];
            this.userFullName = _data["userFullName"];
            this.userEmail = _data["userEmail"];
            this.professionId = _data["professionId"];
            this.status = _data["status"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.responsibleId = _data["responsibleId"];
            this.responsibleFullName = _data["responsibleFullName"];
            this.iAmResponsible = _data["iAmResponsible"];
        }
    }

    static fromJS(data: any): EhcSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["caseIdSearchable"] = this.caseIdSearchable;
        data["fullName"] = this.fullName;
        data["userFullName"] = this.userFullName;
        data["userEmail"] = this.userEmail;
        data["professionId"] = this.professionId;
        data["status"] = this.status;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toFormat('yyyy-MM-dd') : <any>undefined;
        data["responsibleId"] = this.responsibleId;
        data["responsibleFullName"] = this.responsibleFullName;
        data["iAmResponsible"] = this.iAmResponsible;
        return data;
    }
}

export interface IEhcSearchDto {
    id: number;
    caseId: string | undefined;
    caseIdSearchable: string | undefined;
    fullName: string | undefined;
    userFullName: string | undefined;
    userEmail: string | undefined;
    professionId: string | undefined;
    status: ApplicationStatus;
    dateOfStatusChange: DateTime;
    responsibleId: number | undefined;
    responsibleFullName: string | undefined;
    iAmResponsible: boolean;
}

export enum EhcStatus {
    SelfEmployment = 0,
    Register = 1,
    MedicalField = 2,
    LanguageSkill = 3,
    Practice = 4,
    ElectronicPatientRecord = 5,
    QualityRequirement = 6,
    Contact = 7,
    Employment = 8,
    InvoiceAddress = 9,
    Staff = 14,
    PostgraduateTitle = 16,
    EmploymentOrPostgraduateTitle = 17,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export class CreateOrUpdateEhcElectronicPatientRecordInput implements ICreateOrUpdateEhcElectronicPatientRecordInput {
    caseId!: string;
    ehcElectronicPatientRecord!: EhcElectronicPatientRecordDto;

    constructor(data?: ICreateOrUpdateEhcElectronicPatientRecordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcElectronicPatientRecord = new EhcElectronicPatientRecordDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcElectronicPatientRecord = _data["ehcElectronicPatientRecord"] ? EhcElectronicPatientRecordDto.fromJS(_data["ehcElectronicPatientRecord"]) : new EhcElectronicPatientRecordDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcElectronicPatientRecordInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcElectronicPatientRecordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcElectronicPatientRecord"] = this.ehcElectronicPatientRecord ? this.ehcElectronicPatientRecord.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcElectronicPatientRecordInput {
    caseId: string;
    ehcElectronicPatientRecord: EhcElectronicPatientRecordDto;
}

export class EhcElectronicPatientRecordDto implements IEhcElectronicPatientRecordDto {
    membershipInCertifiedCommunityId!: string;
    membershipNoneReason!: string | undefined;
    electronicPatientRecordDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IEhcElectronicPatientRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.membershipInCertifiedCommunityId = _data["membershipInCertifiedCommunityId"];
            this.membershipNoneReason = _data["membershipNoneReason"];
            if (Array.isArray(_data["electronicPatientRecordDocuments"])) {
                this.electronicPatientRecordDocuments = [] as any;
                for (let item of _data["electronicPatientRecordDocuments"])
                    this.electronicPatientRecordDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EhcElectronicPatientRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcElectronicPatientRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["membershipInCertifiedCommunityId"] = this.membershipInCertifiedCommunityId;
        data["membershipNoneReason"] = this.membershipNoneReason;
        if (Array.isArray(this.electronicPatientRecordDocuments)) {
            data["electronicPatientRecordDocuments"] = [];
            for (let item of this.electronicPatientRecordDocuments)
                data["electronicPatientRecordDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEhcElectronicPatientRecordDto {
    membershipInCertifiedCommunityId: string;
    membershipNoneReason: string | undefined;
    electronicPatientRecordDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class CreateOrUpdateEhcEmploymentsInput implements ICreateOrUpdateEhcEmploymentsInput {
    caseId!: string;
    postgraduateTitleEmployments!: EhcEmploymentsDto[] | undefined;

    constructor(data?: ICreateOrUpdateEhcEmploymentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["postgraduateTitleEmployments"])) {
                this.postgraduateTitleEmployments = [] as any;
                for (let item of _data["postgraduateTitleEmployments"])
                    this.postgraduateTitleEmployments!.push(EhcEmploymentsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcEmploymentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcEmploymentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.postgraduateTitleEmployments)) {
            data["postgraduateTitleEmployments"] = [];
            for (let item of this.postgraduateTitleEmployments)
                data["postgraduateTitleEmployments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateEhcEmploymentsInput {
    caseId: string;
    postgraduateTitleEmployments: EhcEmploymentsDto[] | undefined;
}

export class EhcEmploymentDto implements IEhcEmploymentDto {
    id!: number | undefined;
    ehcPostgraduateTitleId!: number;
    startOfEmployment!: DateTime;
    endOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number;
    isMobile!: boolean;
    businessName!: string | undefined;
    additionalName!: string | undefined;
    legalFormId!: string | undefined;
    street!: string;
    streetNr!: string | undefined;
    postCode!: string;
    city!: string;
    postOfficeBox!: string | undefined;
    addressSupplement!: string | undefined;
    phone!: string;
    phone2!: string | undefined;
    email!: string | undefined;
    website!: string | undefined;
    medicalPracticeTakeoverDetails!: string | undefined;
    medicalGroupPracticeDetails!: string | undefined;

    constructor(data?: IEhcEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ehcPostgraduateTitleId = _data["ehcPostgraduateTitleId"];
            this.startOfEmployment = _data["startOfEmployment"] ? DateTime.fromISO(_data["startOfEmployment"].toString()) : <any>undefined;
            this.endOfEmployment = _data["endOfEmployment"] ? DateTime.fromISO(_data["endOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.isMobile = _data["isMobile"];
            this.businessName = _data["businessName"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressSupplement = _data["addressSupplement"];
            this.phone = _data["phone"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.medicalPracticeTakeoverDetails = _data["medicalPracticeTakeoverDetails"];
            this.medicalGroupPracticeDetails = _data["medicalGroupPracticeDetails"];
        }
    }

    static fromJS(data: any): EhcEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ehcPostgraduateTitleId"] = this.ehcPostgraduateTitleId;
        data["startOfEmployment"] = this.startOfEmployment ? this.startOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["endOfEmployment"] = this.endOfEmployment ? this.endOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["isMobile"] = this.isMobile;
        data["businessName"] = this.businessName;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressSupplement"] = this.addressSupplement;
        data["phone"] = this.phone;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["website"] = this.website;
        data["medicalPracticeTakeoverDetails"] = this.medicalPracticeTakeoverDetails;
        data["medicalGroupPracticeDetails"] = this.medicalGroupPracticeDetails;
        return data;
    }
}

export interface IEhcEmploymentDto {
    id: number | undefined;
    ehcPostgraduateTitleId: number;
    startOfEmployment: DateTime;
    endOfEmployment: DateTime | undefined;
    levelOfEmployment: number;
    isMobile: boolean;
    businessName: string | undefined;
    additionalName: string | undefined;
    legalFormId: string | undefined;
    street: string;
    streetNr: string | undefined;
    postCode: string;
    city: string;
    postOfficeBox: string | undefined;
    addressSupplement: string | undefined;
    phone: string;
    phone2: string | undefined;
    email: string | undefined;
    website: string | undefined;
    medicalPracticeTakeoverDetails: string | undefined;
    medicalGroupPracticeDetails: string | undefined;
}

export class EhcEmploymentOutput implements IEhcEmploymentOutput {
    employments!: EhcEmploymentDto[] | undefined;
    mobileEmployments!: EhcMobileEmploymentBDto[] | undefined;

    constructor(data?: IEhcEmploymentOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(EhcEmploymentDto.fromJS(item));
            }
            if (Array.isArray(_data["mobileEmployments"])) {
                this.mobileEmployments = [] as any;
                for (let item of _data["mobileEmployments"])
                    this.mobileEmployments!.push(EhcMobileEmploymentBDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EhcEmploymentOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EhcEmploymentOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        if (Array.isArray(this.mobileEmployments)) {
            data["mobileEmployments"] = [];
            for (let item of this.mobileEmployments)
                data["mobileEmployments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEhcEmploymentOutput {
    employments: EhcEmploymentDto[] | undefined;
    mobileEmployments: EhcMobileEmploymentBDto[] | undefined;
}

export class EhcEmploymentsDto implements IEhcEmploymentsDto {
    postgraduateTitleId!: number;
    mobileEmployment!: EhcMobileEmploymentBDto;
    employments!: EhcEmploymentDto[] | undefined;

    constructor(data?: IEhcEmploymentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.mobileEmployment = _data["mobileEmployment"] ? EhcMobileEmploymentBDto.fromJS(_data["mobileEmployment"]) : <any>undefined;
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(EhcEmploymentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EhcEmploymentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcEmploymentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["mobileEmployment"] = this.mobileEmployment ? this.mobileEmployment.toJSON() : <any>undefined;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEhcEmploymentsDto {
    postgraduateTitleId: number;
    mobileEmployment: EhcMobileEmploymentBDto;
    employments: EhcEmploymentDto[] | undefined;
}

export class EhcMobileEmploymentBDto implements IEhcMobileEmploymentBDto {
    id!: number | undefined;
    startOfEmployment!: DateTime;
    endOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number;

    constructor(data?: IEhcMobileEmploymentBDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startOfEmployment = _data["startOfEmployment"] ? DateTime.fromISO(_data["startOfEmployment"].toString()) : <any>undefined;
            this.endOfEmployment = _data["endOfEmployment"] ? DateTime.fromISO(_data["endOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
        }
    }

    static fromJS(data: any): EhcMobileEmploymentBDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcMobileEmploymentBDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startOfEmployment"] = this.startOfEmployment ? this.startOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["endOfEmployment"] = this.endOfEmployment ? this.endOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        return data;
    }
}

export interface IEhcMobileEmploymentBDto {
    id: number | undefined;
    startOfEmployment: DateTime;
    endOfEmployment: DateTime | undefined;
    levelOfEmployment: number;
}

export class CreateOrUpdateEhcEmploymentOrPostgraduateTitleInput implements ICreateOrUpdateEhcEmploymentOrPostgraduateTitleInput {
    caseId!: string;
    ehcEmploymentOrPostgraduateTitles!: EhcEmploymentOrPostgraduateTitleDto[] | undefined;

    constructor(data?: ICreateOrUpdateEhcEmploymentOrPostgraduateTitleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["ehcEmploymentOrPostgraduateTitles"])) {
                this.ehcEmploymentOrPostgraduateTitles = [] as any;
                for (let item of _data["ehcEmploymentOrPostgraduateTitles"])
                    this.ehcEmploymentOrPostgraduateTitles!.push(EhcEmploymentOrPostgraduateTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcEmploymentOrPostgraduateTitleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcEmploymentOrPostgraduateTitleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.ehcEmploymentOrPostgraduateTitles)) {
            data["ehcEmploymentOrPostgraduateTitles"] = [];
            for (let item of this.ehcEmploymentOrPostgraduateTitles)
                data["ehcEmploymentOrPostgraduateTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateEhcEmploymentOrPostgraduateTitleInput {
    caseId: string;
    ehcEmploymentOrPostgraduateTitles: EhcEmploymentOrPostgraduateTitleDto[] | undefined;
}

export class CreateOrUpdateEhcEmploymentOrPostgraduateTitlesOutput implements ICreateOrUpdateEhcEmploymentOrPostgraduateTitlesOutput {
    status!: EhcStatus;
    ehcEmploymentOrPostgraduateTitles!: EhcEmploymentOrPostgraduateTitleDto[] | undefined;

    constructor(data?: ICreateOrUpdateEhcEmploymentOrPostgraduateTitlesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["ehcEmploymentOrPostgraduateTitles"])) {
                this.ehcEmploymentOrPostgraduateTitles = [] as any;
                for (let item of _data["ehcEmploymentOrPostgraduateTitles"])
                    this.ehcEmploymentOrPostgraduateTitles!.push(EhcEmploymentOrPostgraduateTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcEmploymentOrPostgraduateTitlesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcEmploymentOrPostgraduateTitlesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.ehcEmploymentOrPostgraduateTitles)) {
            data["ehcEmploymentOrPostgraduateTitles"] = [];
            for (let item of this.ehcEmploymentOrPostgraduateTitles)
                data["ehcEmploymentOrPostgraduateTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateEhcEmploymentOrPostgraduateTitlesOutput {
    status: EhcStatus;
    ehcEmploymentOrPostgraduateTitles: EhcEmploymentOrPostgraduateTitleDto[] | undefined;
}

export class EhcEmploymentOrPostgraduateTitleDto implements IEhcEmploymentOrPostgraduateTitleDto {
    isMarked!: boolean;
    levelOfEmployment!: number | undefined;
    ehcLevelOfEmployment!: number | undefined;
    postgraduateTitleId!: string | undefined;
    businessName!: string | undefined;
    legalFormId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    isMobileEmployment!: boolean;

    constructor(data?: IEhcEmploymentOrPostgraduateTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMarked = _data["isMarked"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.ehcLevelOfEmployment = _data["ehcLevelOfEmployment"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.businessName = _data["businessName"];
            this.legalFormId = _data["legalFormId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.isMobileEmployment = _data["isMobileEmployment"];
        }
    }

    static fromJS(data: any): EhcEmploymentOrPostgraduateTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcEmploymentOrPostgraduateTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMarked"] = this.isMarked;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["ehcLevelOfEmployment"] = this.ehcLevelOfEmployment;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["businessName"] = this.businessName;
        data["legalFormId"] = this.legalFormId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["isMobileEmployment"] = this.isMobileEmployment;
        return data;
    }
}

export interface IEhcEmploymentOrPostgraduateTitleDto {
    isMarked: boolean;
    levelOfEmployment: number | undefined;
    ehcLevelOfEmployment: number | undefined;
    postgraduateTitleId: string | undefined;
    businessName: string | undefined;
    legalFormId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    isMobileEmployment: boolean;
}

export class EhcEmploymentOrPostgraduateTitleLimitResultDto implements IEhcEmploymentOrPostgraduateTitleLimitResultDto {
    postgraduateTitleId!: string | undefined;
    regionId!: string | undefined;
    limitReached!: boolean;

    constructor(data?: IEhcEmploymentOrPostgraduateTitleLimitResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.regionId = _data["regionId"];
            this.limitReached = _data["limitReached"];
        }
    }

    static fromJS(data: any): EhcEmploymentOrPostgraduateTitleLimitResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcEmploymentOrPostgraduateTitleLimitResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["regionId"] = this.regionId;
        data["limitReached"] = this.limitReached;
        return data;
    }
}

export interface IEhcEmploymentOrPostgraduateTitleLimitResultDto {
    postgraduateTitleId: string | undefined;
    regionId: string | undefined;
    limitReached: boolean;
}

export class GetEhcOutput implements IGetEhcOutput {
    ehc!: EhcDto;

    constructor(data?: IGetEhcOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ehc = _data["ehc"] ? EhcDto.fromJS(_data["ehc"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEhcOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEhcOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ehc"] = this.ehc ? this.ehc.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEhcOutput {
    ehc: EhcDto;
}

export class CreateOrUpdateEhcInvoiceAddressInput implements ICreateOrUpdateEhcInvoiceAddressInput {
    caseId!: string;
    ehcInvoiceAddress!: EhcInvoiceAddressDto;

    constructor(data?: ICreateOrUpdateEhcInvoiceAddressInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcInvoiceAddress = new EhcInvoiceAddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcInvoiceAddress = _data["ehcInvoiceAddress"] ? EhcInvoiceAddressDto.fromJS(_data["ehcInvoiceAddress"]) : new EhcInvoiceAddressDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcInvoiceAddressInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcInvoiceAddressInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcInvoiceAddress"] = this.ehcInvoiceAddress ? this.ehcInvoiceAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcInvoiceAddressInput {
    caseId: string;
    ehcInvoiceAddress: EhcInvoiceAddressDto;
}

export class EhcInvoiceAddressDto implements IEhcInvoiceAddressDto {
    typeOfAddressId!: string | undefined;
    ehcEmploymentId!: number | undefined;
    name!: string | undefined;
    titleId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    addressAddition!: string | undefined;
    postOfficeBox!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    completionStatus!: CompletionStatus;

    constructor(data?: IEhcInvoiceAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeOfAddressId = _data["typeOfAddressId"];
            this.ehcEmploymentId = _data["ehcEmploymentId"];
            this.name = _data["name"];
            this.titleId = _data["titleId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.addressAddition = _data["addressAddition"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.completionStatus = _data["completionStatus"];
        }
    }

    static fromJS(data: any): EhcInvoiceAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcInvoiceAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOfAddressId"] = this.typeOfAddressId;
        data["ehcEmploymentId"] = this.ehcEmploymentId;
        data["name"] = this.name;
        data["titleId"] = this.titleId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["addressAddition"] = this.addressAddition;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["completionStatus"] = this.completionStatus;
        return data;
    }
}

export interface IEhcInvoiceAddressDto {
    typeOfAddressId: string | undefined;
    ehcEmploymentId: number | undefined;
    name: string | undefined;
    titleId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    addressAddition: string | undefined;
    postOfficeBox: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    completionStatus: CompletionStatus;
}

export class CreateOrUpdateEhcLanguageSkillInput implements ICreateOrUpdateEhcLanguageSkillInput {
    caseId!: string;
    ehcLanguageSkill!: EhcLanguageSkillDto;

    constructor(data?: ICreateOrUpdateEhcLanguageSkillInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcLanguageSkill = new EhcLanguageSkillDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcLanguageSkill = _data["ehcLanguageSkill"] ? EhcLanguageSkillDto.fromJS(_data["ehcLanguageSkill"]) : new EhcLanguageSkillDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcLanguageSkillInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcLanguageSkillInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcLanguageSkill"] = this.ehcLanguageSkill ? this.ehcLanguageSkill.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcLanguageSkillInput {
    caseId: string;
    ehcLanguageSkill: EhcLanguageSkillDto;
}

export class EhcLanguageSkillDto implements IEhcLanguageSkillDto {
    hasHighSchoolDiplomaOfLanguageOfActivityRegionId!: string;
    hasPhysicianDiplomaOfLanguageOfActivityRegionId!: string | undefined;
    languageSkillDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IEhcLanguageSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasHighSchoolDiplomaOfLanguageOfActivityRegionId = _data["hasHighSchoolDiplomaOfLanguageOfActivityRegionId"];
            this.hasPhysicianDiplomaOfLanguageOfActivityRegionId = _data["hasPhysicianDiplomaOfLanguageOfActivityRegionId"];
            if (Array.isArray(_data["languageSkillDocuments"])) {
                this.languageSkillDocuments = [] as any;
                for (let item of _data["languageSkillDocuments"])
                    this.languageSkillDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EhcLanguageSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcLanguageSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasHighSchoolDiplomaOfLanguageOfActivityRegionId"] = this.hasHighSchoolDiplomaOfLanguageOfActivityRegionId;
        data["hasPhysicianDiplomaOfLanguageOfActivityRegionId"] = this.hasPhysicianDiplomaOfLanguageOfActivityRegionId;
        if (Array.isArray(this.languageSkillDocuments)) {
            data["languageSkillDocuments"] = [];
            for (let item of this.languageSkillDocuments)
                data["languageSkillDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEhcLanguageSkillDto {
    hasHighSchoolDiplomaOfLanguageOfActivityRegionId: string;
    hasPhysicianDiplomaOfLanguageOfActivityRegionId: string | undefined;
    languageSkillDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class CreateOrUpdateEhcMedicalFieldInput implements ICreateOrUpdateEhcMedicalFieldInput {
    caseId!: string;
    ehcMedicalField!: EhcMedicalFieldDto;

    constructor(data?: ICreateOrUpdateEhcMedicalFieldInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcMedicalField = new EhcMedicalFieldDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcMedicalField = _data["ehcMedicalField"] ? EhcMedicalFieldDto.fromJS(_data["ehcMedicalField"]) : new EhcMedicalFieldDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcMedicalFieldInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcMedicalFieldInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcMedicalField"] = this.ehcMedicalField ? this.ehcMedicalField.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcMedicalFieldInput {
    caseId: string;
    ehcMedicalField: EhcMedicalFieldDto;
}

export class EhcMedicalFieldDto implements IEhcMedicalFieldDto {
    medicalFieldId!: string;

    constructor(data?: IEhcMedicalFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalFieldId = _data["medicalFieldId"];
        }
    }

    static fromJS(data: any): EhcMedicalFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcMedicalFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalFieldId"] = this.medicalFieldId;
        return data;
    }
}

export interface IEhcMedicalFieldDto {
    medicalFieldId: string;
}

export class CreateOrUpdateEhcPostgraduateTitlesInput implements ICreateOrUpdateEhcPostgraduateTitlesInput {
    caseId!: string;
    ehcPostgraduateTitles!: EhcPostgraduateTitleDto[] | undefined;

    constructor(data?: ICreateOrUpdateEhcPostgraduateTitlesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["ehcPostgraduateTitles"])) {
                this.ehcPostgraduateTitles = [] as any;
                for (let item of _data["ehcPostgraduateTitles"])
                    this.ehcPostgraduateTitles!.push(EhcPostgraduateTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcPostgraduateTitlesInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcPostgraduateTitlesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.ehcPostgraduateTitles)) {
            data["ehcPostgraduateTitles"] = [];
            for (let item of this.ehcPostgraduateTitles)
                data["ehcPostgraduateTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateEhcPostgraduateTitlesInput {
    caseId: string;
    ehcPostgraduateTitles: EhcPostgraduateTitleDto[] | undefined;
}

export class CreateOrUpdateEhcPostgraduateTitlesOutput implements ICreateOrUpdateEhcPostgraduateTitlesOutput {
    status!: EhcStatus;
    ehcPostgraduateTitles!: EhcPostgraduateTitleDto[] | undefined;

    constructor(data?: ICreateOrUpdateEhcPostgraduateTitlesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["ehcPostgraduateTitles"])) {
                this.ehcPostgraduateTitles = [] as any;
                for (let item of _data["ehcPostgraduateTitles"])
                    this.ehcPostgraduateTitles!.push(EhcPostgraduateTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcPostgraduateTitlesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcPostgraduateTitlesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.ehcPostgraduateTitles)) {
            data["ehcPostgraduateTitles"] = [];
            for (let item of this.ehcPostgraduateTitles)
                data["ehcPostgraduateTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateEhcPostgraduateTitlesOutput {
    status: EhcStatus;
    ehcPostgraduateTitles: EhcPostgraduateTitleDto[] | undefined;
}

export class EhcPostgraduateTitleDto implements IEhcPostgraduateTitleDto {
    id!: number | undefined;
    titleId!: string | undefined;
    typeId!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    comment!: string | undefined;
    ehcMobileEmployment!: EhcMobileEmploymentBDto;
    ehcEmployment!: EhcEmploymentDto[] | undefined;

    constructor(data?: IEhcPostgraduateTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titleId = _data["titleId"];
            this.typeId = _data["typeId"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.ehcMobileEmployment = _data["ehcMobileEmployment"] ? EhcMobileEmploymentBDto.fromJS(_data["ehcMobileEmployment"]) : <any>undefined;
            if (Array.isArray(_data["ehcEmployment"])) {
                this.ehcEmployment = [] as any;
                for (let item of _data["ehcEmployment"])
                    this.ehcEmployment!.push(EhcEmploymentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EhcPostgraduateTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcPostgraduateTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titleId"] = this.titleId;
        data["typeId"] = this.typeId;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["comment"] = this.comment;
        data["ehcMobileEmployment"] = this.ehcMobileEmployment ? this.ehcMobileEmployment.toJSON() : <any>undefined;
        if (Array.isArray(this.ehcEmployment)) {
            data["ehcEmployment"] = [];
            for (let item of this.ehcEmployment)
                data["ehcEmployment"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEhcPostgraduateTitleDto {
    id: number | undefined;
    titleId: string | undefined;
    typeId: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    comment: string | undefined;
    ehcMobileEmployment: EhcMobileEmploymentBDto;
    ehcEmployment: EhcEmploymentDto[] | undefined;
}

export class CreateOrUpdateEhcPracticesInput implements ICreateOrUpdateEhcPracticesInput {
    caseId!: string;
    ehcPractice!: EhcPracticeDto;

    constructor(data?: ICreateOrUpdateEhcPracticesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcPractice = new EhcPracticeDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcPractice = _data["ehcPractice"] ? EhcPracticeDto.fromJS(_data["ehcPractice"]) : new EhcPracticeDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcPracticesInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcPracticesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcPractice"] = this.ehcPractice ? this.ehcPractice.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcPracticesInput {
    caseId: string;
    ehcPractice: EhcPracticeDto;
}

export class CreateOrUpdateEhcPracticesOutput implements ICreateOrUpdateEhcPracticesOutput {
    status!: EhcStatus;
    ehcPractice!: EhcPracticeDto;

    constructor(data?: ICreateOrUpdateEhcPracticesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.ehcPractice = _data["ehcPractice"] ? EhcPracticeDto.fromJS(_data["ehcPractice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcPracticesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcPracticesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["ehcPractice"] = this.ehcPractice ? this.ehcPractice.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcPracticesOutput {
    status: EhcStatus;
    ehcPractice: EhcPracticeDto;
}

export class EhcPracticeConfigSnapshotDto implements IEhcPracticeConfigSnapshotDto {
    minimumDurationInDays!: number;
    ignoreMinimumDuration!: boolean;
    ehcPracticeDescriptionPreLabel1!: string | undefined;
    ehcPracticeDescription1Id!: string | undefined;
    ehcPracticeDescriptionPreLabel2!: string | undefined;
    ehcPracticeDescription2Id!: string | undefined;
    ehcPracticeDescriptionPreLabel3!: string | undefined;
    ehcPracticeDescription3Id!: string | undefined;
    ehcPracticeDescriptionPreLabel4!: string | undefined;
    ehcPracticeDescription4Id!: string | undefined;
    ehcPracticeDescriptionPreLabel5!: string | undefined;
    ehcPracticeDescription5Id!: string | undefined;
    ehcPracticeRecordDescriptionPreLabel1!: string | undefined;
    ehcPracticeRecordDescription1Id!: string | undefined;
    ehcPracticeRecordDescriptionPreLabel2!: string | undefined;
    ehcPracticeRecordDescription2Id!: string | undefined;
    ehcPracticeRecordDescriptionPreLabel3!: string | undefined;
    ehcPracticeRecordDescription3Id!: string | undefined;
    ehcPracticeRecordDescriptionPreLabel4!: string | undefined;
    ehcPracticeRecordDescription4Id!: string | undefined;
    ehcPracticeRecordDescriptionPreLabel5!: string | undefined;
    ehcPracticeRecordDescription5Id!: string | undefined;

    constructor(data?: IEhcPracticeConfigSnapshotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumDurationInDays = _data["minimumDurationInDays"];
            this.ignoreMinimumDuration = _data["ignoreMinimumDuration"];
            this.ehcPracticeDescriptionPreLabel1 = _data["ehcPracticeDescriptionPreLabel1"];
            this.ehcPracticeDescription1Id = _data["ehcPracticeDescription1Id"];
            this.ehcPracticeDescriptionPreLabel2 = _data["ehcPracticeDescriptionPreLabel2"];
            this.ehcPracticeDescription2Id = _data["ehcPracticeDescription2Id"];
            this.ehcPracticeDescriptionPreLabel3 = _data["ehcPracticeDescriptionPreLabel3"];
            this.ehcPracticeDescription3Id = _data["ehcPracticeDescription3Id"];
            this.ehcPracticeDescriptionPreLabel4 = _data["ehcPracticeDescriptionPreLabel4"];
            this.ehcPracticeDescription4Id = _data["ehcPracticeDescription4Id"];
            this.ehcPracticeDescriptionPreLabel5 = _data["ehcPracticeDescriptionPreLabel5"];
            this.ehcPracticeDescription5Id = _data["ehcPracticeDescription5Id"];
            this.ehcPracticeRecordDescriptionPreLabel1 = _data["ehcPracticeRecordDescriptionPreLabel1"];
            this.ehcPracticeRecordDescription1Id = _data["ehcPracticeRecordDescription1Id"];
            this.ehcPracticeRecordDescriptionPreLabel2 = _data["ehcPracticeRecordDescriptionPreLabel2"];
            this.ehcPracticeRecordDescription2Id = _data["ehcPracticeRecordDescription2Id"];
            this.ehcPracticeRecordDescriptionPreLabel3 = _data["ehcPracticeRecordDescriptionPreLabel3"];
            this.ehcPracticeRecordDescription3Id = _data["ehcPracticeRecordDescription3Id"];
            this.ehcPracticeRecordDescriptionPreLabel4 = _data["ehcPracticeRecordDescriptionPreLabel4"];
            this.ehcPracticeRecordDescription4Id = _data["ehcPracticeRecordDescription4Id"];
            this.ehcPracticeRecordDescriptionPreLabel5 = _data["ehcPracticeRecordDescriptionPreLabel5"];
            this.ehcPracticeRecordDescription5Id = _data["ehcPracticeRecordDescription5Id"];
        }
    }

    static fromJS(data: any): EhcPracticeConfigSnapshotDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcPracticeConfigSnapshotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumDurationInDays"] = this.minimumDurationInDays;
        data["ignoreMinimumDuration"] = this.ignoreMinimumDuration;
        data["ehcPracticeDescriptionPreLabel1"] = this.ehcPracticeDescriptionPreLabel1;
        data["ehcPracticeDescription1Id"] = this.ehcPracticeDescription1Id;
        data["ehcPracticeDescriptionPreLabel2"] = this.ehcPracticeDescriptionPreLabel2;
        data["ehcPracticeDescription2Id"] = this.ehcPracticeDescription2Id;
        data["ehcPracticeDescriptionPreLabel3"] = this.ehcPracticeDescriptionPreLabel3;
        data["ehcPracticeDescription3Id"] = this.ehcPracticeDescription3Id;
        data["ehcPracticeDescriptionPreLabel4"] = this.ehcPracticeDescriptionPreLabel4;
        data["ehcPracticeDescription4Id"] = this.ehcPracticeDescription4Id;
        data["ehcPracticeDescriptionPreLabel5"] = this.ehcPracticeDescriptionPreLabel5;
        data["ehcPracticeDescription5Id"] = this.ehcPracticeDescription5Id;
        data["ehcPracticeRecordDescriptionPreLabel1"] = this.ehcPracticeRecordDescriptionPreLabel1;
        data["ehcPracticeRecordDescription1Id"] = this.ehcPracticeRecordDescription1Id;
        data["ehcPracticeRecordDescriptionPreLabel2"] = this.ehcPracticeRecordDescriptionPreLabel2;
        data["ehcPracticeRecordDescription2Id"] = this.ehcPracticeRecordDescription2Id;
        data["ehcPracticeRecordDescriptionPreLabel3"] = this.ehcPracticeRecordDescriptionPreLabel3;
        data["ehcPracticeRecordDescription3Id"] = this.ehcPracticeRecordDescription3Id;
        data["ehcPracticeRecordDescriptionPreLabel4"] = this.ehcPracticeRecordDescriptionPreLabel4;
        data["ehcPracticeRecordDescription4Id"] = this.ehcPracticeRecordDescription4Id;
        data["ehcPracticeRecordDescriptionPreLabel5"] = this.ehcPracticeRecordDescriptionPreLabel5;
        data["ehcPracticeRecordDescription5Id"] = this.ehcPracticeRecordDescription5Id;
        return data;
    }
}

export interface IEhcPracticeConfigSnapshotDto {
    minimumDurationInDays: number;
    ignoreMinimumDuration: boolean;
    ehcPracticeDescriptionPreLabel1: string | undefined;
    ehcPracticeDescription1Id: string | undefined;
    ehcPracticeDescriptionPreLabel2: string | undefined;
    ehcPracticeDescription2Id: string | undefined;
    ehcPracticeDescriptionPreLabel3: string | undefined;
    ehcPracticeDescription3Id: string | undefined;
    ehcPracticeDescriptionPreLabel4: string | undefined;
    ehcPracticeDescription4Id: string | undefined;
    ehcPracticeDescriptionPreLabel5: string | undefined;
    ehcPracticeDescription5Id: string | undefined;
    ehcPracticeRecordDescriptionPreLabel1: string | undefined;
    ehcPracticeRecordDescription1Id: string | undefined;
    ehcPracticeRecordDescriptionPreLabel2: string | undefined;
    ehcPracticeRecordDescription2Id: string | undefined;
    ehcPracticeRecordDescriptionPreLabel3: string | undefined;
    ehcPracticeRecordDescription3Id: string | undefined;
    ehcPracticeRecordDescriptionPreLabel4: string | undefined;
    ehcPracticeRecordDescription4Id: string | undefined;
    ehcPracticeRecordDescriptionPreLabel5: string | undefined;
    ehcPracticeRecordDescription5Id: string | undefined;
}

export class EhcPracticeDto implements IEhcPracticeDto {
    ehcSelectedPracticeDescriptionId!: string | undefined;
    ehcPracticeRecords!: EhcPracticeRecordDto[] | undefined;
    ehcPracticeConfigSnapshot!: EhcPracticeConfigSnapshotDto;
    exemptionAccordingArt37Kvg!: boolean | undefined;
    ehcPracticeRecordDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IEhcPracticeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ehcSelectedPracticeDescriptionId = _data["ehcSelectedPracticeDescriptionId"];
            if (Array.isArray(_data["ehcPracticeRecords"])) {
                this.ehcPracticeRecords = [] as any;
                for (let item of _data["ehcPracticeRecords"])
                    this.ehcPracticeRecords!.push(EhcPracticeRecordDto.fromJS(item));
            }
            this.ehcPracticeConfigSnapshot = _data["ehcPracticeConfigSnapshot"] ? EhcPracticeConfigSnapshotDto.fromJS(_data["ehcPracticeConfigSnapshot"]) : <any>undefined;
            this.exemptionAccordingArt37Kvg = _data["exemptionAccordingArt37Kvg"];
            if (Array.isArray(_data["ehcPracticeRecordDocuments"])) {
                this.ehcPracticeRecordDocuments = [] as any;
                for (let item of _data["ehcPracticeRecordDocuments"])
                    this.ehcPracticeRecordDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EhcPracticeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcPracticeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ehcSelectedPracticeDescriptionId"] = this.ehcSelectedPracticeDescriptionId;
        if (Array.isArray(this.ehcPracticeRecords)) {
            data["ehcPracticeRecords"] = [];
            for (let item of this.ehcPracticeRecords)
                data["ehcPracticeRecords"].push(item.toJSON());
        }
        data["ehcPracticeConfigSnapshot"] = this.ehcPracticeConfigSnapshot ? this.ehcPracticeConfigSnapshot.toJSON() : <any>undefined;
        data["exemptionAccordingArt37Kvg"] = this.exemptionAccordingArt37Kvg;
        if (Array.isArray(this.ehcPracticeRecordDocuments)) {
            data["ehcPracticeRecordDocuments"] = [];
            for (let item of this.ehcPracticeRecordDocuments)
                data["ehcPracticeRecordDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEhcPracticeDto {
    ehcSelectedPracticeDescriptionId: string | undefined;
    ehcPracticeRecords: EhcPracticeRecordDto[] | undefined;
    ehcPracticeConfigSnapshot: EhcPracticeConfigSnapshotDto;
    exemptionAccordingArt37Kvg: boolean | undefined;
    ehcPracticeRecordDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class EhcPracticeRecordDto implements IEhcPracticeRecordDto {
    id!: string;
    businessName!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number;
    ehcSelectedPracticeRecordDescriptionId!: string | undefined;
    postgraduateTitleId!: string | undefined;
    exemptionAccordingArt37Kvg!: boolean;

    constructor(data?: IEhcPracticeRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessName = _data["businessName"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.ehcSelectedPracticeRecordDescriptionId = _data["ehcSelectedPracticeRecordDescriptionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.exemptionAccordingArt37Kvg = _data["exemptionAccordingArt37Kvg"];
        }
    }

    static fromJS(data: any): EhcPracticeRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcPracticeRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessName"] = this.businessName;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["ehcSelectedPracticeRecordDescriptionId"] = this.ehcSelectedPracticeRecordDescriptionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["exemptionAccordingArt37Kvg"] = this.exemptionAccordingArt37Kvg;
        return data;
    }
}

export interface IEhcPracticeRecordDto {
    id: string;
    businessName: string | undefined;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number;
    ehcSelectedPracticeRecordDescriptionId: string | undefined;
    postgraduateTitleId: string | undefined;
    exemptionAccordingArt37Kvg: boolean;
}

export class CreateOrUpdateEhcQualityRequirementInput implements ICreateOrUpdateEhcQualityRequirementInput {
    caseId!: string;
    ehcQualityRequirement!: EhcQualityRequirementDto;

    constructor(data?: ICreateOrUpdateEhcQualityRequirementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcQualityRequirement = new EhcQualityRequirementDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcQualityRequirement = _data["ehcQualityRequirement"] ? EhcQualityRequirementDto.fromJS(_data["ehcQualityRequirement"]) : new EhcQualityRequirementDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcQualityRequirementInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcQualityRequirementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcQualityRequirement"] = this.ehcQualityRequirement ? this.ehcQualityRequirement.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcQualityRequirementInput {
    caseId: string;
    ehcQualityRequirement: EhcQualityRequirementDto;
}

export class EhcQualityRequirementDto implements IEhcQualityRequirementDto {
    hasQualifiedStaffId!: string;
    qualifiedStaffDetails!: string | undefined;
    hasQualityManagementSystemId!: string;
    qualityManagementSystemDetails!: string | undefined;
    hasReportingAndLearningSystemId!: string;
    reportingAndLearningSystemDetails!: string | undefined;
    hasQualityMeasurementId!: string;
    qualityMeasurementDetails!: string | undefined;

    constructor(data?: IEhcQualityRequirementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasQualifiedStaffId = _data["hasQualifiedStaffId"];
            this.qualifiedStaffDetails = _data["qualifiedStaffDetails"];
            this.hasQualityManagementSystemId = _data["hasQualityManagementSystemId"];
            this.qualityManagementSystemDetails = _data["qualityManagementSystemDetails"];
            this.hasReportingAndLearningSystemId = _data["hasReportingAndLearningSystemId"];
            this.reportingAndLearningSystemDetails = _data["reportingAndLearningSystemDetails"];
            this.hasQualityMeasurementId = _data["hasQualityMeasurementId"];
            this.qualityMeasurementDetails = _data["qualityMeasurementDetails"];
        }
    }

    static fromJS(data: any): EhcQualityRequirementDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcQualityRequirementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasQualifiedStaffId"] = this.hasQualifiedStaffId;
        data["qualifiedStaffDetails"] = this.qualifiedStaffDetails;
        data["hasQualityManagementSystemId"] = this.hasQualityManagementSystemId;
        data["qualityManagementSystemDetails"] = this.qualityManagementSystemDetails;
        data["hasReportingAndLearningSystemId"] = this.hasReportingAndLearningSystemId;
        data["reportingAndLearningSystemDetails"] = this.reportingAndLearningSystemDetails;
        data["hasQualityMeasurementId"] = this.hasQualityMeasurementId;
        data["qualityMeasurementDetails"] = this.qualityMeasurementDetails;
        return data;
    }
}

export interface IEhcQualityRequirementDto {
    hasQualifiedStaffId: string;
    qualifiedStaffDetails: string | undefined;
    hasQualityManagementSystemId: string;
    qualityManagementSystemDetails: string | undefined;
    hasReportingAndLearningSystemId: string;
    reportingAndLearningSystemDetails: string | undefined;
    hasQualityMeasurementId: string;
    qualityMeasurementDetails: string | undefined;
}

export class CreateOrUpdateEhcRegister implements ICreateOrUpdateEhcRegister {
    caseId!: string;
    gln!: string;

    constructor(data?: ICreateOrUpdateEhcRegister) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.gln = _data["gln"];
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcRegister {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcRegister();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["gln"] = this.gln;
        return data;
    }
}

export interface ICreateOrUpdateEhcRegister {
    caseId: string;
    gln: string;
}

export class CreateOrUpdateEhcRegisterOutputDto implements ICreateOrUpdateEhcRegisterOutputDto {
    healthRegisterIdentificationStatus!: HealthRegisterIdentificationStatus;
    healthRegisterSystem!: ExternalSystemEnum;
    healthRegisterId!: number | undefined;
    ehcRegister!: EhcRegisterDto;

    constructor(data?: ICreateOrUpdateEhcRegisterOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRegisterIdentificationStatus = _data["healthRegisterIdentificationStatus"];
            this.healthRegisterSystem = _data["healthRegisterSystem"];
            this.healthRegisterId = _data["healthRegisterId"];
            this.ehcRegister = _data["ehcRegister"] ? EhcRegisterDto.fromJS(_data["ehcRegister"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcRegisterOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcRegisterOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRegisterIdentificationStatus"] = this.healthRegisterIdentificationStatus;
        data["healthRegisterSystem"] = this.healthRegisterSystem;
        data["healthRegisterId"] = this.healthRegisterId;
        data["ehcRegister"] = this.ehcRegister ? this.ehcRegister.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcRegisterOutputDto {
    healthRegisterIdentificationStatus: HealthRegisterIdentificationStatus;
    healthRegisterSystem: ExternalSystemEnum;
    healthRegisterId: number | undefined;
    ehcRegister: EhcRegisterDto;
}

export class EhcRegisterDto implements IEhcRegisterDto {
    gln!: string | undefined;
    healthRegisterResult!: HealthRegisterIdentificationStatus;
    hasConfirmedData!: boolean | undefined;
    medRegId!: number | undefined;
    psyRegId!: number | undefined;
    naregId!: number | undefined;

    constructor(data?: IEhcRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.healthRegisterResult = _data["healthRegisterResult"];
            this.hasConfirmedData = _data["hasConfirmedData"];
            this.medRegId = _data["medRegId"];
            this.psyRegId = _data["psyRegId"];
            this.naregId = _data["naregId"];
        }
    }

    static fromJS(data: any): EhcRegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcRegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["healthRegisterResult"] = this.healthRegisterResult;
        data["hasConfirmedData"] = this.hasConfirmedData;
        data["medRegId"] = this.medRegId;
        data["psyRegId"] = this.psyRegId;
        data["naregId"] = this.naregId;
        return data;
    }
}

export interface IEhcRegisterDto {
    gln: string | undefined;
    healthRegisterResult: HealthRegisterIdentificationStatus;
    hasConfirmedData: boolean | undefined;
    medRegId: number | undefined;
    psyRegId: number | undefined;
    naregId: number | undefined;
}

export class CreateOrUpdateEhcSelfEmploymentInput implements ICreateOrUpdateEhcSelfEmploymentInput {
    caseId!: string;
    ehcSelfEmployment!: EhcSelfEmploymentDto;

    constructor(data?: ICreateOrUpdateEhcSelfEmploymentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcSelfEmployment = new EhcSelfEmploymentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcSelfEmployment = _data["ehcSelfEmployment"] ? EhcSelfEmploymentDto.fromJS(_data["ehcSelfEmployment"]) : new EhcSelfEmploymentDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcSelfEmploymentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcSelfEmploymentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcSelfEmployment"] = this.ehcSelfEmployment ? this.ehcSelfEmployment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcSelfEmploymentInput {
    caseId: string;
    ehcSelfEmployment: EhcSelfEmploymentDto;
}

export class EhcSelfEmploymentDto implements IEhcSelfEmploymentDto {
    isSelfEmployedId!: string;

    constructor(data?: IEhcSelfEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSelfEmployedId = _data["isSelfEmployedId"];
        }
    }

    static fromJS(data: any): EhcSelfEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcSelfEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSelfEmployedId"] = this.isSelfEmployedId;
        return data;
    }
}

export interface IEhcSelfEmploymentDto {
    isSelfEmployedId: string;
}

export class SetLiaOnWaitingAndCreateEhcOutput implements ISetLiaOnWaitingAndCreateEhcOutput {
    ehcCaseId!: string | undefined;
    ehcStatus!: EhcStatus;

    constructor(data?: ISetLiaOnWaitingAndCreateEhcOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ehcCaseId = _data["ehcCaseId"];
            this.ehcStatus = _data["ehcStatus"];
        }
    }

    static fromJS(data: any): SetLiaOnWaitingAndCreateEhcOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SetLiaOnWaitingAndCreateEhcOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ehcCaseId"] = this.ehcCaseId;
        data["ehcStatus"] = this.ehcStatus;
        return data;
    }
}

export interface ISetLiaOnWaitingAndCreateEhcOutput {
    ehcCaseId: string | undefined;
    ehcStatus: EhcStatus;
}

export class CreateOrUpdateEhcStaffInput implements ICreateOrUpdateEhcStaffInput {
    caseId!: string;
    ehcStaff!: EhcStaffDto;

    constructor(data?: ICreateOrUpdateEhcStaffInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcStaff = new EhcStaffDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcStaff = _data["ehcStaff"] ? EhcStaffDto.fromJS(_data["ehcStaff"]) : new EhcStaffDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcStaffInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcStaffInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcStaff"] = this.ehcStaff ? this.ehcStaff.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcStaffInput {
    caseId: string;
    ehcStaff: EhcStaffDto;
}

export class EhcStaffDto implements IEhcStaffDto {
    qualifiedStaffDetails!: string | undefined;
    noQualifiedStaffDetails!: string | undefined;

    constructor(data?: IEhcStaffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualifiedStaffDetails = _data["qualifiedStaffDetails"];
            this.noQualifiedStaffDetails = _data["noQualifiedStaffDetails"];
        }
    }

    static fromJS(data: any): EhcStaffDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcStaffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualifiedStaffDetails"] = this.qualifiedStaffDetails;
        data["noQualifiedStaffDetails"] = this.noQualifiedStaffDetails;
        return data;
    }
}

export interface IEhcStaffDto {
    qualifiedStaffDetails: string | undefined;
    noQualifiedStaffDetails: string | undefined;
}

export class CreateOrUpdateFileDossierDto implements ICreateOrUpdateFileDossierDto {
    name!: string;
    items!: FileDossierItemDto[] | undefined;

    constructor(data?: ICreateOrUpdateFileDossierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FileDossierItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateFileDossierDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateFileDossierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateFileDossierDto {
    name: string;
    items: FileDossierItemDto[] | undefined;
}

export class FileDossierItemDto implements IFileDossierItemDto {
    order!: number;
    name!: string | undefined;
    datedFrom!: DateTime;
    isDatedFromSet!: boolean;
    documentId!: number | undefined;
    readonly isPlaceholder!: boolean;
    id!: number | undefined;

    constructor(data?: IFileDossierItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.name = _data["name"];
            this.datedFrom = _data["datedFrom"] ? DateTime.fromISO(_data["datedFrom"].toString()) : <any>undefined;
            this.isDatedFromSet = _data["isDatedFromSet"];
            this.documentId = _data["documentId"];
            (<any>this).isPlaceholder = _data["isPlaceholder"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FileDossierItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDossierItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["name"] = this.name;
        data["datedFrom"] = this.datedFrom ? this.datedFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        data["isDatedFromSet"] = this.isDatedFromSet;
        data["documentId"] = this.documentId;
        data["isPlaceholder"] = this.isPlaceholder;
        data["id"] = this.id;
        return data;
    }
}

export interface IFileDossierItemDto {
    order: number;
    name: string | undefined;
    datedFrom: DateTime;
    isDatedFromSet: boolean;
    documentId: number | undefined;
    isPlaceholder: boolean;
    id: number | undefined;
}

export class FileDossierSearchResultDto implements IFileDossierSearchResultDto {
    id!: number;
    name!: string | undefined;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IFileDossierSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FileDossierSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDossierSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IFileDossierSearchResultDto {
    id: number;
    name: string | undefined;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: DateTime;
}

export class GenerateZipFileArchiveOutputDto implements IGenerateZipFileArchiveOutputDto {
    documentIdZipArchive!: number;
    documentIdFileDossier!: number;
    xmlData!: string | undefined;

    constructor(data?: IGenerateZipFileArchiveOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentIdZipArchive = _data["documentIdZipArchive"];
            this.documentIdFileDossier = _data["documentIdFileDossier"];
            this.xmlData = _data["xmlData"];
        }
    }

    static fromJS(data: any): GenerateZipFileArchiveOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateZipFileArchiveOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentIdZipArchive"] = this.documentIdZipArchive;
        data["documentIdFileDossier"] = this.documentIdFileDossier;
        data["xmlData"] = this.xmlData;
        return data;
    }
}

export interface IGenerateZipFileArchiveOutputDto {
    documentIdZipArchive: number;
    documentIdFileDossier: number;
    xmlData: string | undefined;
}

export class GetFileDossierDto implements IGetFileDossierDto {
    name!: string | undefined;
    items!: FileDossierItemDto[] | undefined;
    id!: number;

    constructor(data?: IGetFileDossierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FileDossierItemDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetFileDossierDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileDossierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGetFileDossierDto {
    name: string | undefined;
    items: FileDossierItemDto[] | undefined;
    id: number;
}

export class GetFileDossierSearchInput implements IGetFileDossierSearchInput {
    personId!: number | undefined;
    sponsorshipId!: number | undefined;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IGetFileDossierSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetFileDossierSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileDossierSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["sponsorshipId"] = this.sponsorshipId;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IGetFileDossierSearchInput {
    personId: number | undefined;
    sponsorshipId: number | undefined;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class GetFileDossierSearchOutput implements IGetFileDossierSearchOutput {
    totalCount!: number;
    items!: FileDossierSearchResultDto[] | undefined;

    constructor(data?: IGetFileDossierSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FileDossierSearchResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFileDossierSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileDossierSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFileDossierSearchOutput {
    totalCount: number;
    items: FileDossierSearchResultDto[] | undefined;
}

export class Code implements ICode {
    codeCategory!: number;
    subcategory!: number | undefined;
    isActive!: boolean;
    isSystem!: boolean;
    listIndex!: number | undefined;
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    backendSystemId!: number | undefined;
    extensionData!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: string | undefined;

    constructor(data?: ICode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeCategory = _data["codeCategory"];
            this.subcategory = _data["subcategory"];
            this.isActive = _data["isActive"];
            this.isSystem = _data["isSystem"];
            this.listIndex = _data["listIndex"];
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.backendSystemId = _data["backendSystemId"];
            this.extensionData = _data["extensionData"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Code {
        data = typeof data === 'object' ? data : {};
        let result = new Code();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeCategory"] = this.codeCategory;
        data["subcategory"] = this.subcategory;
        data["isActive"] = this.isActive;
        data["isSystem"] = this.isSystem;
        data["listIndex"] = this.listIndex;
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["backendSystemId"] = this.backendSystemId;
        data["extensionData"] = this.extensionData;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICode {
    codeCategory: number;
    subcategory: number | undefined;
    isActive: boolean;
    isSystem: boolean;
    listIndex: number | undefined;
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    backendSystemId: number | undefined;
    extensionData: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: string | undefined;
}

export enum SqlParameterType {
    Integer = 0,
    String = 1,
    Date = 2,
    Code = 3,
    Enum = 4,
}

export class AcceptFriendshipRequestInput implements IAcceptFriendshipRequestInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IAcceptFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AcceptFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAcceptFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class BlockUserInput implements IBlockUserInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IBlockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): BlockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new BlockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IBlockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class CreateFriendshipRequestByUserNameInput implements ICreateFriendshipRequestByUserNameInput {
    tenancyName!: string;
    userName!: string | undefined;

    constructor(data?: ICreateFriendshipRequestByUserNameInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestByUserNameInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestByUserNameInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        return data;
    }
}

export interface ICreateFriendshipRequestByUserNameInput {
    tenancyName: string;
    userName: string | undefined;
}

export class CreateFriendshipRequestInput implements ICreateFriendshipRequestInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: ICreateFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class FriendDto implements IFriendDto {
    friendUserId!: number;
    friendTenantId!: number | undefined;
    friendUserName!: string | undefined;
    friendTenancyName!: string | undefined;
    friendProfilePictureId!: string | undefined;
    unreadMessageCount!: number;
    isOnline!: boolean;
    state!: FriendshipState;

    constructor(data?: IFriendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.friendUserId = _data["friendUserId"];
            this.friendTenantId = _data["friendTenantId"];
            this.friendUserName = _data["friendUserName"];
            this.friendTenancyName = _data["friendTenancyName"];
            this.friendProfilePictureId = _data["friendProfilePictureId"];
            this.unreadMessageCount = _data["unreadMessageCount"];
            this.isOnline = _data["isOnline"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): FriendDto {
        data = typeof data === 'object' ? data : {};
        let result = new FriendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserName"] = this.friendUserName;
        data["friendTenancyName"] = this.friendTenancyName;
        data["friendProfilePictureId"] = this.friendProfilePictureId;
        data["unreadMessageCount"] = this.unreadMessageCount;
        data["isOnline"] = this.isOnline;
        data["state"] = this.state;
        return data;
    }
}

export interface IFriendDto {
    friendUserId: number;
    friendTenantId: number | undefined;
    friendUserName: string | undefined;
    friendTenancyName: string | undefined;
    friendProfilePictureId: string | undefined;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendshipState;
}

export class UnblockUserInput implements IUnblockUserInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IUnblockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): UnblockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnblockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IUnblockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export enum FriendshipState {
    Accepted = 1,
    Blocked = 2,
}

export class PerformHealthRegisterCheckInput implements IPerformHealthRegisterCheckInput {
    gln!: string;
    professionId!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    applicationType!: ApplicationType;
    step!: number;

    constructor(data?: IPerformHealthRegisterCheckInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.applicationType = _data["applicationType"];
            this.step = _data["step"];
        }
    }

    static fromJS(data: any): PerformHealthRegisterCheckInput {
        data = typeof data === 'object' ? data : {};
        let result = new PerformHealthRegisterCheckInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["applicationType"] = this.applicationType;
        data["step"] = this.step;
        return data;
    }
}

export interface IPerformHealthRegisterCheckInput {
    gln: string;
    professionId: string | undefined;
    sponsorshipTypeId: string | undefined;
    applicationType: ApplicationType;
    step: number;
}

export class HealthRegExportCacheInput implements IHealthRegExportCacheInput {
    externalSystem!: ExternalSystemEnum;
    file!: string;

    constructor(data?: IHealthRegExportCacheInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalSystem = _data["externalSystem"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): HealthRegExportCacheInput {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegExportCacheInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalSystem"] = this.externalSystem;
        data["file"] = this.file;
        return data;
    }
}

export interface IHealthRegExportCacheInput {
    externalSystem: ExternalSystemEnum;
    file: string;
}

export class HealthRegExportCacheOutput implements IHealthRegExportCacheOutput {
    file!: string | undefined;

    constructor(data?: IHealthRegExportCacheOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): HealthRegExportCacheOutput {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegExportCacheOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file;
        return data;
    }
}

export interface IHealthRegExportCacheOutput {
    file: string | undefined;
}

export class HealthRegisterSnapshotCodeDto implements IHealthRegisterSnapshotCodeDto {
    healthRegisterId!: number;
    healthRegisterDescriptions!: string | undefined;
    sironaId!: string | undefined;

    constructor(data?: IHealthRegisterSnapshotCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRegisterId = _data["healthRegisterId"];
            this.healthRegisterDescriptions = _data["healthRegisterDescriptions"];
            this.sironaId = _data["sironaId"];
        }
    }

    static fromJS(data: any): HealthRegisterSnapshotCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterSnapshotCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRegisterId"] = this.healthRegisterId;
        data["healthRegisterDescriptions"] = this.healthRegisterDescriptions;
        data["sironaId"] = this.sironaId;
        return data;
    }
}

export interface IHealthRegisterSnapshotCodeDto {
    healthRegisterId: number;
    healthRegisterDescriptions: string | undefined;
    sironaId: string | undefined;
}

export class HealthRegisterSnapshotDetailedDto implements IHealthRegisterSnapshotDetailedDto {
    ahv!: string | undefined;
    uid!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    placeOfOrigin!: string | undefined;
    hasSensitiveData!: boolean;
    creationTime!: DateTime;
    healthRegisterType!: HealthRegisterType;
    externalRegisterId!: number;
    medRegId!: number | undefined;
    psyRegId!: number | undefined;
    naregId!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    originalName!: string | undefined;
    gln!: string | undefined;
    yearOfBirth!: number | undefined;
    gender!: HealthRegisterSnapshotCodeDto;
    country1!: HealthRegisterSnapshotCodeDto;
    country2!: HealthRegisterSnapshotCodeDto;
    languageSkills!: HealthRegisterSnapshotCodeDto[] | undefined;
    diplomas!: HealthRegisterSnapshotDiplomaDto[] | undefined;
    postgraduateTitles!: HealthRegisterSnapshotPostgraduateTitleDto[] | undefined;
    licences!: HealthRegisterSnapshotLicenceDto[] | undefined;

    constructor(data?: IHealthRegisterSnapshotDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ahv = _data["ahv"];
            this.uid = _data["uid"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.hasSensitiveData = _data["hasSensitiveData"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.healthRegisterType = _data["healthRegisterType"];
            this.externalRegisterId = _data["externalRegisterId"];
            this.medRegId = _data["medRegId"];
            this.psyRegId = _data["psyRegId"];
            this.naregId = _data["naregId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.originalName = _data["originalName"];
            this.gln = _data["gln"];
            this.yearOfBirth = _data["yearOfBirth"];
            this.gender = _data["gender"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["gender"]) : <any>undefined;
            this.country1 = _data["country1"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["country1"]) : <any>undefined;
            this.country2 = _data["country2"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["country2"]) : <any>undefined;
            if (Array.isArray(_data["languageSkills"])) {
                this.languageSkills = [] as any;
                for (let item of _data["languageSkills"])
                    this.languageSkills!.push(HealthRegisterSnapshotCodeDto.fromJS(item));
            }
            if (Array.isArray(_data["diplomas"])) {
                this.diplomas = [] as any;
                for (let item of _data["diplomas"])
                    this.diplomas!.push(HealthRegisterSnapshotDiplomaDto.fromJS(item));
            }
            if (Array.isArray(_data["postgraduateTitles"])) {
                this.postgraduateTitles = [] as any;
                for (let item of _data["postgraduateTitles"])
                    this.postgraduateTitles!.push(HealthRegisterSnapshotPostgraduateTitleDto.fromJS(item));
            }
            if (Array.isArray(_data["licences"])) {
                this.licences = [] as any;
                for (let item of _data["licences"])
                    this.licences!.push(HealthRegisterSnapshotLicenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HealthRegisterSnapshotDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterSnapshotDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ahv"] = this.ahv;
        data["uid"] = this.uid;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["hasSensitiveData"] = this.hasSensitiveData;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["healthRegisterType"] = this.healthRegisterType;
        data["externalRegisterId"] = this.externalRegisterId;
        data["medRegId"] = this.medRegId;
        data["psyRegId"] = this.psyRegId;
        data["naregId"] = this.naregId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["originalName"] = this.originalName;
        data["gln"] = this.gln;
        data["yearOfBirth"] = this.yearOfBirth;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["country1"] = this.country1 ? this.country1.toJSON() : <any>undefined;
        data["country2"] = this.country2 ? this.country2.toJSON() : <any>undefined;
        if (Array.isArray(this.languageSkills)) {
            data["languageSkills"] = [];
            for (let item of this.languageSkills)
                data["languageSkills"].push(item.toJSON());
        }
        if (Array.isArray(this.diplomas)) {
            data["diplomas"] = [];
            for (let item of this.diplomas)
                data["diplomas"].push(item.toJSON());
        }
        if (Array.isArray(this.postgraduateTitles)) {
            data["postgraduateTitles"] = [];
            for (let item of this.postgraduateTitles)
                data["postgraduateTitles"].push(item.toJSON());
        }
        if (Array.isArray(this.licences)) {
            data["licences"] = [];
            for (let item of this.licences)
                data["licences"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHealthRegisterSnapshotDetailedDto {
    ahv: string | undefined;
    uid: string | undefined;
    dateOfBirth: DateTime | undefined;
    placeOfOrigin: string | undefined;
    hasSensitiveData: boolean;
    creationTime: DateTime;
    healthRegisterType: HealthRegisterType;
    externalRegisterId: number;
    medRegId: number | undefined;
    psyRegId: number | undefined;
    naregId: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    originalName: string | undefined;
    gln: string | undefined;
    yearOfBirth: number | undefined;
    gender: HealthRegisterSnapshotCodeDto;
    country1: HealthRegisterSnapshotCodeDto;
    country2: HealthRegisterSnapshotCodeDto;
    languageSkills: HealthRegisterSnapshotCodeDto[] | undefined;
    diplomas: HealthRegisterSnapshotDiplomaDto[] | undefined;
    postgraduateTitles: HealthRegisterSnapshotPostgraduateTitleDto[] | undefined;
    licences: HealthRegisterSnapshotLicenceDto[] | undefined;
}

export class HealthRegisterSnapshotDiplomaDto implements IHealthRegisterSnapshotDiplomaDto {
    externalId!: number;
    profession!: HealthRegisterSnapshotCodeDto;
    diplomaType!: HealthRegisterSnapshotCodeDto;
    country!: HealthRegisterSnapshotCodeDto;
    placeOfIssue!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    dateOfEquivalence!: DateTime | undefined;
    dateOfRegistration!: DateTime | undefined;

    constructor(data?: IHealthRegisterSnapshotDiplomaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.profession = _data["profession"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["profession"]) : <any>undefined;
            this.diplomaType = _data["diplomaType"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["diplomaType"]) : <any>undefined;
            this.country = _data["country"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["country"]) : <any>undefined;
            this.placeOfIssue = _data["placeOfIssue"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.dateOfEquivalence = _data["dateOfEquivalence"] ? DateTime.fromISO(_data["dateOfEquivalence"].toString()) : <any>undefined;
            this.dateOfRegistration = _data["dateOfRegistration"] ? DateTime.fromISO(_data["dateOfRegistration"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthRegisterSnapshotDiplomaDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterSnapshotDiplomaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["profession"] = this.profession ? this.profession.toJSON() : <any>undefined;
        data["diplomaType"] = this.diplomaType ? this.diplomaType.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["placeOfIssue"] = this.placeOfIssue;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEquivalence"] = this.dateOfEquivalence ? this.dateOfEquivalence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRegistration"] = this.dateOfRegistration ? this.dateOfRegistration.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IHealthRegisterSnapshotDiplomaDto {
    externalId: number;
    profession: HealthRegisterSnapshotCodeDto;
    diplomaType: HealthRegisterSnapshotCodeDto;
    country: HealthRegisterSnapshotCodeDto;
    placeOfIssue: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    dateOfEquivalence: DateTime | undefined;
    dateOfRegistration: DateTime | undefined;
}

export class HealthRegisterSnapshotLicenceDto implements IHealthRegisterSnapshotLicenceDto {
    externalId!: number;
    licenceType!: HealthRegisterSnapshotCodeDto;
    canton!: HealthRegisterSnapshotCodeDto;
    status!: HealthRegisterSnapshotCodeDto;
    activity!: HealthRegisterSnapshotCodeDto;
    profession!: HealthRegisterSnapshotCodeDto;
    legalBasisLicence!: HealthRegisterSnapshotCodeDto;
    register!: HealthRegisterSnapshotCodeDto;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfActivity!: DateTime | undefined;
    dateOfPracticeOpening!: DateTime | undefined;
    dateOfPracticeClosure!: DateTime | undefined;
    languageSkills!: HealthRegisterSnapshotCodeDto[] | undefined;

    constructor(data?: IHealthRegisterSnapshotLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.licenceType = _data["licenceType"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["licenceType"]) : <any>undefined;
            this.canton = _data["canton"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["canton"]) : <any>undefined;
            this.status = _data["status"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["status"]) : <any>undefined;
            this.activity = _data["activity"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["activity"]) : <any>undefined;
            this.profession = _data["profession"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["profession"]) : <any>undefined;
            this.legalBasisLicence = _data["legalBasisLicence"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["legalBasisLicence"]) : <any>undefined;
            this.register = _data["register"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["register"]) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfActivity = _data["dateOfActivity"] ? DateTime.fromISO(_data["dateOfActivity"].toString()) : <any>undefined;
            this.dateOfPracticeOpening = _data["dateOfPracticeOpening"] ? DateTime.fromISO(_data["dateOfPracticeOpening"].toString()) : <any>undefined;
            this.dateOfPracticeClosure = _data["dateOfPracticeClosure"] ? DateTime.fromISO(_data["dateOfPracticeClosure"].toString()) : <any>undefined;
            if (Array.isArray(_data["languageSkills"])) {
                this.languageSkills = [] as any;
                for (let item of _data["languageSkills"])
                    this.languageSkills!.push(HealthRegisterSnapshotCodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HealthRegisterSnapshotLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterSnapshotLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["licenceType"] = this.licenceType ? this.licenceType.toJSON() : <any>undefined;
        data["canton"] = this.canton ? this.canton.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["profession"] = this.profession ? this.profession.toJSON() : <any>undefined;
        data["legalBasisLicence"] = this.legalBasisLicence ? this.legalBasisLicence.toJSON() : <any>undefined;
        data["register"] = this.register ? this.register.toJSON() : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfActivity"] = this.dateOfActivity ? this.dateOfActivity.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfPracticeOpening"] = this.dateOfPracticeOpening ? this.dateOfPracticeOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfPracticeClosure"] = this.dateOfPracticeClosure ? this.dateOfPracticeClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.languageSkills)) {
            data["languageSkills"] = [];
            for (let item of this.languageSkills)
                data["languageSkills"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHealthRegisterSnapshotLicenceDto {
    externalId: number;
    licenceType: HealthRegisterSnapshotCodeDto;
    canton: HealthRegisterSnapshotCodeDto;
    status: HealthRegisterSnapshotCodeDto;
    activity: HealthRegisterSnapshotCodeDto;
    profession: HealthRegisterSnapshotCodeDto;
    legalBasisLicence: HealthRegisterSnapshotCodeDto;
    register: HealthRegisterSnapshotCodeDto;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfActivity: DateTime | undefined;
    dateOfPracticeOpening: DateTime | undefined;
    dateOfPracticeClosure: DateTime | undefined;
    languageSkills: HealthRegisterSnapshotCodeDto[] | undefined;
}

export class HealthRegisterSnapshotPostgraduateTitleDto implements IHealthRegisterSnapshotPostgraduateTitleDto {
    externalId!: number;
    isPrivatePostgraduateTitle!: boolean;
    title!: HealthRegisterSnapshotCodeDto;
    type!: HealthRegisterSnapshotCodeDto;
    organisation!: string | undefined;
    placeOfIssue!: string | undefined;
    country!: HealthRegisterSnapshotCodeDto;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    dateOfEquivalence!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    placeOfRecognition!: string | undefined;
    recognitionAuthority!: string | undefined;
    courseOfEducation!: HealthRegisterSnapshotCodeDto;

    constructor(data?: IHealthRegisterSnapshotPostgraduateTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.isPrivatePostgraduateTitle = _data["isPrivatePostgraduateTitle"];
            this.title = _data["title"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["title"]) : <any>undefined;
            this.type = _data["type"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["type"]) : <any>undefined;
            this.organisation = _data["organisation"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.country = _data["country"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["country"]) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.dateOfEquivalence = _data["dateOfEquivalence"] ? DateTime.fromISO(_data["dateOfEquivalence"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.placeOfRecognition = _data["placeOfRecognition"];
            this.recognitionAuthority = _data["recognitionAuthority"];
            this.courseOfEducation = _data["courseOfEducation"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["courseOfEducation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthRegisterSnapshotPostgraduateTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterSnapshotPostgraduateTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["isPrivatePostgraduateTitle"] = this.isPrivatePostgraduateTitle;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["organisation"] = this.organisation;
        data["placeOfIssue"] = this.placeOfIssue;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEquivalence"] = this.dateOfEquivalence ? this.dateOfEquivalence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfRecognition"] = this.placeOfRecognition;
        data["recognitionAuthority"] = this.recognitionAuthority;
        data["courseOfEducation"] = this.courseOfEducation ? this.courseOfEducation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHealthRegisterSnapshotPostgraduateTitleDto {
    externalId: number;
    isPrivatePostgraduateTitle: boolean;
    title: HealthRegisterSnapshotCodeDto;
    type: HealthRegisterSnapshotCodeDto;
    organisation: string | undefined;
    placeOfIssue: string | undefined;
    country: HealthRegisterSnapshotCodeDto;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    dateOfEquivalence: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    placeOfRecognition: string | undefined;
    recognitionAuthority: string | undefined;
    courseOfEducation: HealthRegisterSnapshotCodeDto;
}

export class HealthRegisterSnapshotPublicDto implements IHealthRegisterSnapshotPublicDto {
    creationTime!: DateTime;
    healthRegisterType!: HealthRegisterType;
    externalRegisterId!: number;
    medRegId!: number | undefined;
    psyRegId!: number | undefined;
    naregId!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    originalName!: string | undefined;
    gln!: string | undefined;
    yearOfBirth!: number | undefined;
    gender!: HealthRegisterSnapshotCodeDto;
    country1!: HealthRegisterSnapshotCodeDto;
    country2!: HealthRegisterSnapshotCodeDto;
    languageSkills!: HealthRegisterSnapshotCodeDto[] | undefined;
    diplomas!: HealthRegisterSnapshotDiplomaDto[] | undefined;
    postgraduateTitles!: HealthRegisterSnapshotPostgraduateTitleDto[] | undefined;
    licences!: HealthRegisterSnapshotLicenceDto[] | undefined;

    constructor(data?: IHealthRegisterSnapshotPublicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.healthRegisterType = _data["healthRegisterType"];
            this.externalRegisterId = _data["externalRegisterId"];
            this.medRegId = _data["medRegId"];
            this.psyRegId = _data["psyRegId"];
            this.naregId = _data["naregId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.originalName = _data["originalName"];
            this.gln = _data["gln"];
            this.yearOfBirth = _data["yearOfBirth"];
            this.gender = _data["gender"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["gender"]) : <any>undefined;
            this.country1 = _data["country1"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["country1"]) : <any>undefined;
            this.country2 = _data["country2"] ? HealthRegisterSnapshotCodeDto.fromJS(_data["country2"]) : <any>undefined;
            if (Array.isArray(_data["languageSkills"])) {
                this.languageSkills = [] as any;
                for (let item of _data["languageSkills"])
                    this.languageSkills!.push(HealthRegisterSnapshotCodeDto.fromJS(item));
            }
            if (Array.isArray(_data["diplomas"])) {
                this.diplomas = [] as any;
                for (let item of _data["diplomas"])
                    this.diplomas!.push(HealthRegisterSnapshotDiplomaDto.fromJS(item));
            }
            if (Array.isArray(_data["postgraduateTitles"])) {
                this.postgraduateTitles = [] as any;
                for (let item of _data["postgraduateTitles"])
                    this.postgraduateTitles!.push(HealthRegisterSnapshotPostgraduateTitleDto.fromJS(item));
            }
            if (Array.isArray(_data["licences"])) {
                this.licences = [] as any;
                for (let item of _data["licences"])
                    this.licences!.push(HealthRegisterSnapshotLicenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HealthRegisterSnapshotPublicDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterSnapshotPublicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["healthRegisterType"] = this.healthRegisterType;
        data["externalRegisterId"] = this.externalRegisterId;
        data["medRegId"] = this.medRegId;
        data["psyRegId"] = this.psyRegId;
        data["naregId"] = this.naregId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["originalName"] = this.originalName;
        data["gln"] = this.gln;
        data["yearOfBirth"] = this.yearOfBirth;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["country1"] = this.country1 ? this.country1.toJSON() : <any>undefined;
        data["country2"] = this.country2 ? this.country2.toJSON() : <any>undefined;
        if (Array.isArray(this.languageSkills)) {
            data["languageSkills"] = [];
            for (let item of this.languageSkills)
                data["languageSkills"].push(item.toJSON());
        }
        if (Array.isArray(this.diplomas)) {
            data["diplomas"] = [];
            for (let item of this.diplomas)
                data["diplomas"].push(item.toJSON());
        }
        if (Array.isArray(this.postgraduateTitles)) {
            data["postgraduateTitles"] = [];
            for (let item of this.postgraduateTitles)
                data["postgraduateTitles"].push(item.toJSON());
        }
        if (Array.isArray(this.licences)) {
            data["licences"] = [];
            for (let item of this.licences)
                data["licences"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHealthRegisterSnapshotPublicDto {
    creationTime: DateTime;
    healthRegisterType: HealthRegisterType;
    externalRegisterId: number;
    medRegId: number | undefined;
    psyRegId: number | undefined;
    naregId: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    originalName: string | undefined;
    gln: string | undefined;
    yearOfBirth: number | undefined;
    gender: HealthRegisterSnapshotCodeDto;
    country1: HealthRegisterSnapshotCodeDto;
    country2: HealthRegisterSnapshotCodeDto;
    languageSkills: HealthRegisterSnapshotCodeDto[] | undefined;
    diplomas: HealthRegisterSnapshotDiplomaDto[] | undefined;
    postgraduateTitles: HealthRegisterSnapshotPostgraduateTitleDto[] | undefined;
    licences: HealthRegisterSnapshotLicenceDto[] | undefined;
}

export enum HealthRegisterType {
    MedReg = 0,
    Nareg = 1,
    PsyReg = 2,
}

export class HealthRegisterSnapshot implements IHealthRegisterSnapshot {
    healthRegisterType!: HealthRegisterType;
    externalRegisterId!: number;
    readonly medRegId!: number | undefined;
    readonly psyRegId!: number | undefined;
    readonly naregId!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    originalName!: string | undefined;
    gln!: string | undefined;
    ahv!: string | undefined;
    uid!: string | undefined;
    placeOfOrigin!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    readonly yearOfBirth!: number | undefined;
    dateOfDeath!: DateTime | undefined;
    hasSensitiveData!: boolean;
    gender!: HealthRegisterSnapshotCode;
    correspondenceLanguage!: HealthRegisterSnapshotCode;
    country1!: HealthRegisterSnapshotCode;
    country2!: HealthRegisterSnapshotCode;
    register!: HealthRegisterSnapshotCode;
    languageSkills!: HealthRegisterSnapshotCode[] | undefined;
    diplomas!: HealthRegisterSnapshotDiploma[] | undefined;
    postgraduateTitles!: HealthRegisterSnapshotPostgraduateTitle[] | undefined;
    licences!: HealthRegisterSnapshotLicence[] | undefined;
    serializedData!: string;
    extensionData!: string | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IHealthRegisterSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRegisterType = _data["healthRegisterType"];
            this.externalRegisterId = _data["externalRegisterId"];
            (<any>this).medRegId = _data["medRegId"];
            (<any>this).psyRegId = _data["psyRegId"];
            (<any>this).naregId = _data["naregId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.originalName = _data["originalName"];
            this.gln = _data["gln"];
            this.ahv = _data["ahv"];
            this.uid = _data["uid"];
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            (<any>this).yearOfBirth = _data["yearOfBirth"];
            this.dateOfDeath = _data["dateOfDeath"] ? DateTime.fromISO(_data["dateOfDeath"].toString()) : <any>undefined;
            this.hasSensitiveData = _data["hasSensitiveData"];
            this.gender = _data["gender"] ? HealthRegisterSnapshotCode.fromJS(_data["gender"]) : <any>undefined;
            this.correspondenceLanguage = _data["correspondenceLanguage"] ? HealthRegisterSnapshotCode.fromJS(_data["correspondenceLanguage"]) : <any>undefined;
            this.country1 = _data["country1"] ? HealthRegisterSnapshotCode.fromJS(_data["country1"]) : <any>undefined;
            this.country2 = _data["country2"] ? HealthRegisterSnapshotCode.fromJS(_data["country2"]) : <any>undefined;
            this.register = _data["register"] ? HealthRegisterSnapshotCode.fromJS(_data["register"]) : <any>undefined;
            if (Array.isArray(_data["languageSkills"])) {
                this.languageSkills = [] as any;
                for (let item of _data["languageSkills"])
                    this.languageSkills!.push(HealthRegisterSnapshotCode.fromJS(item));
            }
            if (Array.isArray(_data["diplomas"])) {
                this.diplomas = [] as any;
                for (let item of _data["diplomas"])
                    this.diplomas!.push(HealthRegisterSnapshotDiploma.fromJS(item));
            }
            if (Array.isArray(_data["postgraduateTitles"])) {
                this.postgraduateTitles = [] as any;
                for (let item of _data["postgraduateTitles"])
                    this.postgraduateTitles!.push(HealthRegisterSnapshotPostgraduateTitle.fromJS(item));
            }
            if (Array.isArray(_data["licences"])) {
                this.licences = [] as any;
                for (let item of _data["licences"])
                    this.licences!.push(HealthRegisterSnapshotLicence.fromJS(item));
            }
            this.serializedData = _data["serializedData"];
            this.extensionData = _data["extensionData"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HealthRegisterSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRegisterType"] = this.healthRegisterType;
        data["externalRegisterId"] = this.externalRegisterId;
        data["medRegId"] = this.medRegId;
        data["psyRegId"] = this.psyRegId;
        data["naregId"] = this.naregId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["originalName"] = this.originalName;
        data["gln"] = this.gln;
        data["ahv"] = this.ahv;
        data["uid"] = this.uid;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["yearOfBirth"] = this.yearOfBirth;
        data["dateOfDeath"] = this.dateOfDeath ? this.dateOfDeath.toFormat('yyyy-MM-dd') : <any>undefined;
        data["hasSensitiveData"] = this.hasSensitiveData;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["correspondenceLanguage"] = this.correspondenceLanguage ? this.correspondenceLanguage.toJSON() : <any>undefined;
        data["country1"] = this.country1 ? this.country1.toJSON() : <any>undefined;
        data["country2"] = this.country2 ? this.country2.toJSON() : <any>undefined;
        data["register"] = this.register ? this.register.toJSON() : <any>undefined;
        if (Array.isArray(this.languageSkills)) {
            data["languageSkills"] = [];
            for (let item of this.languageSkills)
                data["languageSkills"].push(item.toJSON());
        }
        if (Array.isArray(this.diplomas)) {
            data["diplomas"] = [];
            for (let item of this.diplomas)
                data["diplomas"].push(item.toJSON());
        }
        if (Array.isArray(this.postgraduateTitles)) {
            data["postgraduateTitles"] = [];
            for (let item of this.postgraduateTitles)
                data["postgraduateTitles"].push(item.toJSON());
        }
        if (Array.isArray(this.licences)) {
            data["licences"] = [];
            for (let item of this.licences)
                data["licences"].push(item.toJSON());
        }
        data["serializedData"] = this.serializedData;
        data["extensionData"] = this.extensionData;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IHealthRegisterSnapshot {
    healthRegisterType: HealthRegisterType;
    externalRegisterId: number;
    medRegId: number | undefined;
    psyRegId: number | undefined;
    naregId: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    originalName: string | undefined;
    gln: string | undefined;
    ahv: string | undefined;
    uid: string | undefined;
    placeOfOrigin: string | undefined;
    dateOfBirth: DateTime | undefined;
    yearOfBirth: number | undefined;
    dateOfDeath: DateTime | undefined;
    hasSensitiveData: boolean;
    gender: HealthRegisterSnapshotCode;
    correspondenceLanguage: HealthRegisterSnapshotCode;
    country1: HealthRegisterSnapshotCode;
    country2: HealthRegisterSnapshotCode;
    register: HealthRegisterSnapshotCode;
    languageSkills: HealthRegisterSnapshotCode[] | undefined;
    diplomas: HealthRegisterSnapshotDiploma[] | undefined;
    postgraduateTitles: HealthRegisterSnapshotPostgraduateTitle[] | undefined;
    licences: HealthRegisterSnapshotLicence[] | undefined;
    serializedData: string;
    extensionData: string | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class HealthRegisterSnapshotAddress implements IHealthRegisterSnapshotAddress {
    externalId!: number;
    type!: HealthRegisterSnapshotCode;
    legalForm!: HealthRegisterSnapshotCode;
    register!: HealthRegisterSnapshotCode;
    correspondenceLanguage!: HealthRegisterSnapshotCode;
    soleProprietorship!: HealthRegisterSnapshotCode;
    selfDispensation!: HealthRegisterSnapshotCode;
    selfDispensationRemark!: string | undefined;
    uidEstablishment!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    name!: string | undefined;
    additionalName1!: string | undefined;
    additionalName2!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    mobile!: string | undefined;
    fax!: string | undefined;
    email!: string | undefined;
    remark!: string | undefined;

    constructor(data?: IHealthRegisterSnapshotAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.type = _data["type"] ? HealthRegisterSnapshotCode.fromJS(_data["type"]) : <any>undefined;
            this.legalForm = _data["legalForm"] ? HealthRegisterSnapshotCode.fromJS(_data["legalForm"]) : <any>undefined;
            this.register = _data["register"] ? HealthRegisterSnapshotCode.fromJS(_data["register"]) : <any>undefined;
            this.correspondenceLanguage = _data["correspondenceLanguage"] ? HealthRegisterSnapshotCode.fromJS(_data["correspondenceLanguage"]) : <any>undefined;
            this.soleProprietorship = _data["soleProprietorship"] ? HealthRegisterSnapshotCode.fromJS(_data["soleProprietorship"]) : <any>undefined;
            this.selfDispensation = _data["selfDispensation"] ? HealthRegisterSnapshotCode.fromJS(_data["selfDispensation"]) : <any>undefined;
            this.selfDispensationRemark = _data["selfDispensationRemark"];
            this.uidEstablishment = _data["uidEstablishment"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.name = _data["name"];
            this.additionalName1 = _data["additionalName1"];
            this.additionalName2 = _data["additionalName2"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.mobile = _data["mobile"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): HealthRegisterSnapshotAddress {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterSnapshotAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["legalForm"] = this.legalForm ? this.legalForm.toJSON() : <any>undefined;
        data["register"] = this.register ? this.register.toJSON() : <any>undefined;
        data["correspondenceLanguage"] = this.correspondenceLanguage ? this.correspondenceLanguage.toJSON() : <any>undefined;
        data["soleProprietorship"] = this.soleProprietorship ? this.soleProprietorship.toJSON() : <any>undefined;
        data["selfDispensation"] = this.selfDispensation ? this.selfDispensation.toJSON() : <any>undefined;
        data["selfDispensationRemark"] = this.selfDispensationRemark;
        data["uidEstablishment"] = this.uidEstablishment;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["name"] = this.name;
        data["additionalName1"] = this.additionalName1;
        data["additionalName2"] = this.additionalName2;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["mobile"] = this.mobile;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IHealthRegisterSnapshotAddress {
    externalId: number;
    type: HealthRegisterSnapshotCode;
    legalForm: HealthRegisterSnapshotCode;
    register: HealthRegisterSnapshotCode;
    correspondenceLanguage: HealthRegisterSnapshotCode;
    soleProprietorship: HealthRegisterSnapshotCode;
    selfDispensation: HealthRegisterSnapshotCode;
    selfDispensationRemark: string | undefined;
    uidEstablishment: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    name: string | undefined;
    additionalName1: string | undefined;
    additionalName2: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    mobile: string | undefined;
    fax: string | undefined;
    email: string | undefined;
    remark: string | undefined;
}

export class HealthRegisterSnapshotCode implements IHealthRegisterSnapshotCode {
    healthRegisterId!: number;
    healthRegisterDescriptions!: string | undefined;
    sironaId!: string | undefined;
    sirona!: Code;

    constructor(data?: IHealthRegisterSnapshotCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRegisterId = _data["healthRegisterId"];
            this.healthRegisterDescriptions = _data["healthRegisterDescriptions"];
            this.sironaId = _data["sironaId"];
            this.sirona = _data["sirona"] ? Code.fromJS(_data["sirona"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthRegisterSnapshotCode {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterSnapshotCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRegisterId"] = this.healthRegisterId;
        data["healthRegisterDescriptions"] = this.healthRegisterDescriptions;
        data["sironaId"] = this.sironaId;
        data["sirona"] = this.sirona ? this.sirona.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHealthRegisterSnapshotCode {
    healthRegisterId: number;
    healthRegisterDescriptions: string | undefined;
    sironaId: string | undefined;
    sirona: Code;
}

export class HealthRegisterSnapshotDiploma implements IHealthRegisterSnapshotDiploma {
    externalId!: number;
    profession!: HealthRegisterSnapshotCode;
    diplomaType!: HealthRegisterSnapshotCode;
    country!: HealthRegisterSnapshotCode;
    placeOfIssue!: string | undefined;
    srkRegisterId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    dateOfEquivalence!: DateTime | undefined;
    dateOfRegistration!: DateTime | undefined;
    register!: HealthRegisterSnapshotCode;

    constructor(data?: IHealthRegisterSnapshotDiploma) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.profession = _data["profession"] ? HealthRegisterSnapshotCode.fromJS(_data["profession"]) : <any>undefined;
            this.diplomaType = _data["diplomaType"] ? HealthRegisterSnapshotCode.fromJS(_data["diplomaType"]) : <any>undefined;
            this.country = _data["country"] ? HealthRegisterSnapshotCode.fromJS(_data["country"]) : <any>undefined;
            this.placeOfIssue = _data["placeOfIssue"];
            this.srkRegisterId = _data["srkRegisterId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.dateOfEquivalence = _data["dateOfEquivalence"] ? DateTime.fromISO(_data["dateOfEquivalence"].toString()) : <any>undefined;
            this.dateOfRegistration = _data["dateOfRegistration"] ? DateTime.fromISO(_data["dateOfRegistration"].toString()) : <any>undefined;
            this.register = _data["register"] ? HealthRegisterSnapshotCode.fromJS(_data["register"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthRegisterSnapshotDiploma {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterSnapshotDiploma();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["profession"] = this.profession ? this.profession.toJSON() : <any>undefined;
        data["diplomaType"] = this.diplomaType ? this.diplomaType.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["placeOfIssue"] = this.placeOfIssue;
        data["srkRegisterId"] = this.srkRegisterId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEquivalence"] = this.dateOfEquivalence ? this.dateOfEquivalence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRegistration"] = this.dateOfRegistration ? this.dateOfRegistration.toFormat('yyyy-MM-dd') : <any>undefined;
        data["register"] = this.register ? this.register.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHealthRegisterSnapshotDiploma {
    externalId: number;
    profession: HealthRegisterSnapshotCode;
    diplomaType: HealthRegisterSnapshotCode;
    country: HealthRegisterSnapshotCode;
    placeOfIssue: string | undefined;
    srkRegisterId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    dateOfEquivalence: DateTime | undefined;
    dateOfRegistration: DateTime | undefined;
    register: HealthRegisterSnapshotCode;
}

export class HealthRegisterSnapshotLicence implements IHealthRegisterSnapshotLicence {
    externalId!: number;
    licenceType!: HealthRegisterSnapshotCode;
    canton!: HealthRegisterSnapshotCode;
    status!: HealthRegisterSnapshotCode;
    activity!: HealthRegisterSnapshotCode;
    profession!: HealthRegisterSnapshotCode;
    legalBasisLicence!: HealthRegisterSnapshotCode;
    register!: HealthRegisterSnapshotCode;
    remark!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfActivity!: DateTime | undefined;
    dateOfPracticeOpening!: DateTime | undefined;
    dateOfPracticeClosure!: DateTime | undefined;
    dateOfReport!: DateTime | undefined;
    numberOfApprovedDays!: number | undefined;
    yearOfValidity!: number | undefined;
    reachedAllDays!: boolean | undefined;
    authorisationNarcotic!: HealthRegisterSnapshotCode;
    authorisationNarcoticRemarks!: string | undefined;
    authorisationEhc!: HealthRegisterSnapshotCode;
    addresses!: HealthRegisterSnapshotAddress[] | undefined;
    restrictions!: HealthRegisterSnapshotRestriction[] | undefined;
    languageSkills!: HealthRegisterSnapshotCode[] | undefined;

    constructor(data?: IHealthRegisterSnapshotLicence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.licenceType = _data["licenceType"] ? HealthRegisterSnapshotCode.fromJS(_data["licenceType"]) : <any>undefined;
            this.canton = _data["canton"] ? HealthRegisterSnapshotCode.fromJS(_data["canton"]) : <any>undefined;
            this.status = _data["status"] ? HealthRegisterSnapshotCode.fromJS(_data["status"]) : <any>undefined;
            this.activity = _data["activity"] ? HealthRegisterSnapshotCode.fromJS(_data["activity"]) : <any>undefined;
            this.profession = _data["profession"] ? HealthRegisterSnapshotCode.fromJS(_data["profession"]) : <any>undefined;
            this.legalBasisLicence = _data["legalBasisLicence"] ? HealthRegisterSnapshotCode.fromJS(_data["legalBasisLicence"]) : <any>undefined;
            this.register = _data["register"] ? HealthRegisterSnapshotCode.fromJS(_data["register"]) : <any>undefined;
            this.remark = _data["remark"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfActivity = _data["dateOfActivity"] ? DateTime.fromISO(_data["dateOfActivity"].toString()) : <any>undefined;
            this.dateOfPracticeOpening = _data["dateOfPracticeOpening"] ? DateTime.fromISO(_data["dateOfPracticeOpening"].toString()) : <any>undefined;
            this.dateOfPracticeClosure = _data["dateOfPracticeClosure"] ? DateTime.fromISO(_data["dateOfPracticeClosure"].toString()) : <any>undefined;
            this.dateOfReport = _data["dateOfReport"] ? DateTime.fromISO(_data["dateOfReport"].toString()) : <any>undefined;
            this.numberOfApprovedDays = _data["numberOfApprovedDays"];
            this.yearOfValidity = _data["yearOfValidity"];
            this.reachedAllDays = _data["reachedAllDays"];
            this.authorisationNarcotic = _data["authorisationNarcotic"] ? HealthRegisterSnapshotCode.fromJS(_data["authorisationNarcotic"]) : <any>undefined;
            this.authorisationNarcoticRemarks = _data["authorisationNarcoticRemarks"];
            this.authorisationEhc = _data["authorisationEhc"] ? HealthRegisterSnapshotCode.fromJS(_data["authorisationEhc"]) : <any>undefined;
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(HealthRegisterSnapshotAddress.fromJS(item));
            }
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(HealthRegisterSnapshotRestriction.fromJS(item));
            }
            if (Array.isArray(_data["languageSkills"])) {
                this.languageSkills = [] as any;
                for (let item of _data["languageSkills"])
                    this.languageSkills!.push(HealthRegisterSnapshotCode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HealthRegisterSnapshotLicence {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterSnapshotLicence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["licenceType"] = this.licenceType ? this.licenceType.toJSON() : <any>undefined;
        data["canton"] = this.canton ? this.canton.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["profession"] = this.profession ? this.profession.toJSON() : <any>undefined;
        data["legalBasisLicence"] = this.legalBasisLicence ? this.legalBasisLicence.toJSON() : <any>undefined;
        data["register"] = this.register ? this.register.toJSON() : <any>undefined;
        data["remark"] = this.remark;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfActivity"] = this.dateOfActivity ? this.dateOfActivity.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfPracticeOpening"] = this.dateOfPracticeOpening ? this.dateOfPracticeOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfPracticeClosure"] = this.dateOfPracticeClosure ? this.dateOfPracticeClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfReport"] = this.dateOfReport ? this.dateOfReport.toFormat('yyyy-MM-dd') : <any>undefined;
        data["numberOfApprovedDays"] = this.numberOfApprovedDays;
        data["yearOfValidity"] = this.yearOfValidity;
        data["reachedAllDays"] = this.reachedAllDays;
        data["authorisationNarcotic"] = this.authorisationNarcotic ? this.authorisationNarcotic.toJSON() : <any>undefined;
        data["authorisationNarcoticRemarks"] = this.authorisationNarcoticRemarks;
        data["authorisationEhc"] = this.authorisationEhc ? this.authorisationEhc.toJSON() : <any>undefined;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        if (Array.isArray(this.languageSkills)) {
            data["languageSkills"] = [];
            for (let item of this.languageSkills)
                data["languageSkills"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHealthRegisterSnapshotLicence {
    externalId: number;
    licenceType: HealthRegisterSnapshotCode;
    canton: HealthRegisterSnapshotCode;
    status: HealthRegisterSnapshotCode;
    activity: HealthRegisterSnapshotCode;
    profession: HealthRegisterSnapshotCode;
    legalBasisLicence: HealthRegisterSnapshotCode;
    register: HealthRegisterSnapshotCode;
    remark: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfActivity: DateTime | undefined;
    dateOfPracticeOpening: DateTime | undefined;
    dateOfPracticeClosure: DateTime | undefined;
    dateOfReport: DateTime | undefined;
    numberOfApprovedDays: number | undefined;
    yearOfValidity: number | undefined;
    reachedAllDays: boolean | undefined;
    authorisationNarcotic: HealthRegisterSnapshotCode;
    authorisationNarcoticRemarks: string | undefined;
    authorisationEhc: HealthRegisterSnapshotCode;
    addresses: HealthRegisterSnapshotAddress[] | undefined;
    restrictions: HealthRegisterSnapshotRestriction[] | undefined;
    languageSkills: HealthRegisterSnapshotCode[] | undefined;
}

export class HealthRegisterSnapshotPostgraduateTitle implements IHealthRegisterSnapshotPostgraduateTitle {
    externalId!: number;
    isPrivatePostgraduateTitle!: boolean;
    title!: HealthRegisterSnapshotCode;
    type!: HealthRegisterSnapshotCode;
    kind!: HealthRegisterSnapshotCode;
    organisation!: string | undefined;
    placeOfIssue!: string | undefined;
    country!: HealthRegisterSnapshotCode;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    dateOfEquivalence!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    placeOfRecognition!: string | undefined;
    recognitionAuthority!: string | undefined;
    courseOfEducation!: HealthRegisterSnapshotCode;

    constructor(data?: IHealthRegisterSnapshotPostgraduateTitle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.isPrivatePostgraduateTitle = _data["isPrivatePostgraduateTitle"];
            this.title = _data["title"] ? HealthRegisterSnapshotCode.fromJS(_data["title"]) : <any>undefined;
            this.type = _data["type"] ? HealthRegisterSnapshotCode.fromJS(_data["type"]) : <any>undefined;
            this.kind = _data["kind"] ? HealthRegisterSnapshotCode.fromJS(_data["kind"]) : <any>undefined;
            this.organisation = _data["organisation"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.country = _data["country"] ? HealthRegisterSnapshotCode.fromJS(_data["country"]) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.dateOfEquivalence = _data["dateOfEquivalence"] ? DateTime.fromISO(_data["dateOfEquivalence"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.placeOfRecognition = _data["placeOfRecognition"];
            this.recognitionAuthority = _data["recognitionAuthority"];
            this.courseOfEducation = _data["courseOfEducation"] ? HealthRegisterSnapshotCode.fromJS(_data["courseOfEducation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthRegisterSnapshotPostgraduateTitle {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterSnapshotPostgraduateTitle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["isPrivatePostgraduateTitle"] = this.isPrivatePostgraduateTitle;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["kind"] = this.kind ? this.kind.toJSON() : <any>undefined;
        data["organisation"] = this.organisation;
        data["placeOfIssue"] = this.placeOfIssue;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEquivalence"] = this.dateOfEquivalence ? this.dateOfEquivalence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfRecognition"] = this.placeOfRecognition;
        data["recognitionAuthority"] = this.recognitionAuthority;
        data["courseOfEducation"] = this.courseOfEducation ? this.courseOfEducation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHealthRegisterSnapshotPostgraduateTitle {
    externalId: number;
    isPrivatePostgraduateTitle: boolean;
    title: HealthRegisterSnapshotCode;
    type: HealthRegisterSnapshotCode;
    kind: HealthRegisterSnapshotCode;
    organisation: string | undefined;
    placeOfIssue: string | undefined;
    country: HealthRegisterSnapshotCode;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    dateOfEquivalence: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    placeOfRecognition: string | undefined;
    recognitionAuthority: string | undefined;
    courseOfEducation: HealthRegisterSnapshotCode;
}

export class HealthRegisterSnapshotRestriction implements IHealthRegisterSnapshotRestriction {
    externalId!: number;
    type!: HealthRegisterSnapshotCode;
    description!: string | undefined;
    dateOfDecision!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    register!: HealthRegisterSnapshotCode;

    constructor(data?: IHealthRegisterSnapshotRestriction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.type = _data["type"] ? HealthRegisterSnapshotCode.fromJS(_data["type"]) : <any>undefined;
            this.description = _data["description"];
            this.dateOfDecision = _data["dateOfDecision"] ? DateTime.fromISO(_data["dateOfDecision"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.register = _data["register"] ? HealthRegisterSnapshotCode.fromJS(_data["register"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthRegisterSnapshotRestriction {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterSnapshotRestriction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["dateOfDecision"] = this.dateOfDecision ? this.dateOfDecision.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["register"] = this.register ? this.register.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHealthRegisterSnapshotRestriction {
    externalId: number;
    type: HealthRegisterSnapshotCode;
    description: string | undefined;
    dateOfDecision: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    register: HealthRegisterSnapshotCode;
}

export enum HistoryPropertyChange {
    NoChange = 0,
    Insert = 1,
    Change = 2,
    Delete = 3,
}

export class InspectionDetail implements IInspectionDetail {
    cantonalDepartments!: InspectionCode[] | undefined;
    inspectors!: InspectionUser[] | undefined;
    drugSample!: Code;
    drugSampleId!: string | undefined;
    medicalProducts!: Code;
    medicalProductsId!: string | undefined;
    dateOfDeadline1!: DateTime | undefined;
    dateOfDeadline2!: DateTime | undefined;
    dateOfDeadline3!: DateTime | undefined;
    dateOfPartEnforcement!: DateTime | undefined;
    dateOfProtocolRelease!: DateTime | undefined;
    overallDeficiencyCategory!: Code;
    overallDeficiencyCategoryId!: string | undefined;
    remark!: string | undefined;

    constructor(data?: IInspectionDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cantonalDepartments"])) {
                this.cantonalDepartments = [] as any;
                for (let item of _data["cantonalDepartments"])
                    this.cantonalDepartments!.push(InspectionCode.fromJS(item));
            }
            if (Array.isArray(_data["inspectors"])) {
                this.inspectors = [] as any;
                for (let item of _data["inspectors"])
                    this.inspectors!.push(InspectionUser.fromJS(item));
            }
            this.drugSample = _data["drugSample"] ? Code.fromJS(_data["drugSample"]) : <any>undefined;
            this.drugSampleId = _data["drugSampleId"];
            this.medicalProducts = _data["medicalProducts"] ? Code.fromJS(_data["medicalProducts"]) : <any>undefined;
            this.medicalProductsId = _data["medicalProductsId"];
            this.dateOfDeadline1 = _data["dateOfDeadline1"] ? DateTime.fromISO(_data["dateOfDeadline1"].toString()) : <any>undefined;
            this.dateOfDeadline2 = _data["dateOfDeadline2"] ? DateTime.fromISO(_data["dateOfDeadline2"].toString()) : <any>undefined;
            this.dateOfDeadline3 = _data["dateOfDeadline3"] ? DateTime.fromISO(_data["dateOfDeadline3"].toString()) : <any>undefined;
            this.dateOfPartEnforcement = _data["dateOfPartEnforcement"] ? DateTime.fromISO(_data["dateOfPartEnforcement"].toString()) : <any>undefined;
            this.dateOfProtocolRelease = _data["dateOfProtocolRelease"] ? DateTime.fromISO(_data["dateOfProtocolRelease"].toString()) : <any>undefined;
            this.overallDeficiencyCategory = _data["overallDeficiencyCategory"] ? Code.fromJS(_data["overallDeficiencyCategory"]) : <any>undefined;
            this.overallDeficiencyCategoryId = _data["overallDeficiencyCategoryId"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): InspectionDetail {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cantonalDepartments)) {
            data["cantonalDepartments"] = [];
            for (let item of this.cantonalDepartments)
                data["cantonalDepartments"].push(item.toJSON());
        }
        if (Array.isArray(this.inspectors)) {
            data["inspectors"] = [];
            for (let item of this.inspectors)
                data["inspectors"].push(item.toJSON());
        }
        data["drugSample"] = this.drugSample ? this.drugSample.toJSON() : <any>undefined;
        data["drugSampleId"] = this.drugSampleId;
        data["medicalProducts"] = this.medicalProducts ? this.medicalProducts.toJSON() : <any>undefined;
        data["medicalProductsId"] = this.medicalProductsId;
        data["dateOfDeadline1"] = this.dateOfDeadline1 ? this.dateOfDeadline1.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDeadline2"] = this.dateOfDeadline2 ? this.dateOfDeadline2.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDeadline3"] = this.dateOfDeadline3 ? this.dateOfDeadline3.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfPartEnforcement"] = this.dateOfPartEnforcement ? this.dateOfPartEnforcement.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfProtocolRelease"] = this.dateOfProtocolRelease ? this.dateOfProtocolRelease.toFormat('yyyy-MM-dd') : <any>undefined;
        data["overallDeficiencyCategory"] = this.overallDeficiencyCategory ? this.overallDeficiencyCategory.toJSON() : <any>undefined;
        data["overallDeficiencyCategoryId"] = this.overallDeficiencyCategoryId;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IInspectionDetail {
    cantonalDepartments: InspectionCode[] | undefined;
    inspectors: InspectionUser[] | undefined;
    drugSample: Code;
    drugSampleId: string | undefined;
    medicalProducts: Code;
    medicalProductsId: string | undefined;
    dateOfDeadline1: DateTime | undefined;
    dateOfDeadline2: DateTime | undefined;
    dateOfDeadline3: DateTime | undefined;
    dateOfPartEnforcement: DateTime | undefined;
    dateOfProtocolRelease: DateTime | undefined;
    overallDeficiencyCategory: Code;
    overallDeficiencyCategoryId: string | undefined;
    remark: string | undefined;
}

export class InspectionUser implements IInspectionUser {
    user!: User;
    userId!: number;

    constructor(data?: IInspectionUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new User();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : new User();
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): InspectionUser {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IInspectionUser {
    user: User;
    userId: number;
}

export class GenerateInspectionDocumentOutputDto implements IGenerateInspectionDocumentOutputDto {
    documentId!: number;
    xmlData!: string | undefined;

    constructor(data?: IGenerateInspectionDocumentOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.xmlData = _data["xmlData"];
        }
    }

    static fromJS(data: any): GenerateInspectionDocumentOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateInspectionDocumentOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["xmlData"] = this.xmlData;
        return data;
    }
}

export interface IGenerateInspectionDocumentOutputDto {
    documentId: number;
    xmlData: string | undefined;
}

export class GetInspectionDto implements IGetInspectionDto {
    businessId!: number;
    businessSponsorshipId!: number | undefined;
    detail!: InspectionDetailDto;
    preparation!: InspectionPreparationDto;
    execution!: InspectionExecutionDto;
    postprocessing!: InspectionPostprocessingDto;
    sapInvoiceId!: number | undefined;
    id!: number;

    constructor(data?: IGetInspectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessId = _data["businessId"];
            this.businessSponsorshipId = _data["businessSponsorshipId"];
            this.detail = _data["detail"] ? InspectionDetailDto.fromJS(_data["detail"]) : <any>undefined;
            this.preparation = _data["preparation"] ? InspectionPreparationDto.fromJS(_data["preparation"]) : <any>undefined;
            this.execution = _data["execution"] ? InspectionExecutionDto.fromJS(_data["execution"]) : <any>undefined;
            this.postprocessing = _data["postprocessing"] ? InspectionPostprocessingDto.fromJS(_data["postprocessing"]) : <any>undefined;
            this.sapInvoiceId = _data["sapInvoiceId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetInspectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInspectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessId"] = this.businessId;
        data["businessSponsorshipId"] = this.businessSponsorshipId;
        data["detail"] = this.detail ? this.detail.toJSON() : <any>undefined;
        data["preparation"] = this.preparation ? this.preparation.toJSON() : <any>undefined;
        data["execution"] = this.execution ? this.execution.toJSON() : <any>undefined;
        data["postprocessing"] = this.postprocessing ? this.postprocessing.toJSON() : <any>undefined;
        data["sapInvoiceId"] = this.sapInvoiceId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetInspectionDto {
    businessId: number;
    businessSponsorshipId: number | undefined;
    detail: InspectionDetailDto;
    preparation: InspectionPreparationDto;
    execution: InspectionExecutionDto;
    postprocessing: InspectionPostprocessingDto;
    sapInvoiceId: number | undefined;
    id: number;
}

export class GetInspectionSearchInput implements IGetInspectionSearchInput {
    businessId!: number;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IGetInspectionSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessId = _data["businessId"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetInspectionSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetInspectionSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessId"] = this.businessId;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IGetInspectionSearchInput {
    businessId: number;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class GetInspectionSearchOutput implements IGetInspectionSearchOutput {
    totalCount!: number;
    items!: InspectionSearchResultDto[] | undefined;

    constructor(data?: IGetInspectionSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InspectionSearchResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInspectionSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetInspectionSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetInspectionSearchOutput {
    totalCount: number;
    items: InspectionSearchResultDto[] | undefined;
}

export class GetInspectorDto implements IGetInspectorDto {
    fullName!: string | undefined;
    id!: number;

    constructor(data?: IGetInspectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetInspectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInspectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetInspectorDto {
    fullName: string | undefined;
    id: number;
}

export class InspectionCheckpointDto implements IInspectionCheckpointDto {
    checkpoint!: string;
    checked!: boolean;

    constructor(data?: IInspectionCheckpointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkpoint = _data["checkpoint"];
            this.checked = _data["checked"];
        }
    }

    static fromJS(data: any): InspectionCheckpointDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionCheckpointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkpoint"] = this.checkpoint;
        data["checked"] = this.checked;
        return data;
    }
}

export interface IInspectionCheckpointDto {
    checkpoint: string;
    checked: boolean;
}

export class InspectionDeficiencyDto implements IInspectionDeficiencyDto {
    deficiency!: string;
    categoryId!: string;
    remark!: string | undefined;
    followUpInspectionId!: string | undefined;

    constructor(data?: IInspectionDeficiencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deficiency = _data["deficiency"];
            this.categoryId = _data["categoryId"];
            this.remark = _data["remark"];
            this.followUpInspectionId = _data["followUpInspectionId"];
        }
    }

    static fromJS(data: any): InspectionDeficiencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionDeficiencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deficiency"] = this.deficiency;
        data["categoryId"] = this.categoryId;
        data["remark"] = this.remark;
        data["followUpInspectionId"] = this.followUpInspectionId;
        return data;
    }
}

export interface IInspectionDeficiencyDto {
    deficiency: string;
    categoryId: string;
    remark: string | undefined;
    followUpInspectionId: string | undefined;
}

export class InspectionDetailDto implements IInspectionDetailDto {
    cantonalDepartments!: string[] | undefined;
    inspectors!: number[] | undefined;
    drugSampleId!: string | undefined;
    medicalProductsId!: string | undefined;
    dateOfDeadline1!: DateTime | undefined;
    dateOfDeadline2!: DateTime | undefined;
    dateOfDeadline3!: DateTime | undefined;
    dateOfPartEnforcement!: DateTime | undefined;
    dateOfProtocolRelease!: DateTime | undefined;
    overallDeficiencyCategoryId!: string | undefined;
    remark!: string | undefined;

    constructor(data?: IInspectionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cantonalDepartments"])) {
                this.cantonalDepartments = [] as any;
                for (let item of _data["cantonalDepartments"])
                    this.cantonalDepartments!.push(item);
            }
            if (Array.isArray(_data["inspectors"])) {
                this.inspectors = [] as any;
                for (let item of _data["inspectors"])
                    this.inspectors!.push(item);
            }
            this.drugSampleId = _data["drugSampleId"];
            this.medicalProductsId = _data["medicalProductsId"];
            this.dateOfDeadline1 = _data["dateOfDeadline1"] ? DateTime.fromISO(_data["dateOfDeadline1"].toString()) : <any>undefined;
            this.dateOfDeadline2 = _data["dateOfDeadline2"] ? DateTime.fromISO(_data["dateOfDeadline2"].toString()) : <any>undefined;
            this.dateOfDeadline3 = _data["dateOfDeadline3"] ? DateTime.fromISO(_data["dateOfDeadline3"].toString()) : <any>undefined;
            this.dateOfPartEnforcement = _data["dateOfPartEnforcement"] ? DateTime.fromISO(_data["dateOfPartEnforcement"].toString()) : <any>undefined;
            this.dateOfProtocolRelease = _data["dateOfProtocolRelease"] ? DateTime.fromISO(_data["dateOfProtocolRelease"].toString()) : <any>undefined;
            this.overallDeficiencyCategoryId = _data["overallDeficiencyCategoryId"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): InspectionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cantonalDepartments)) {
            data["cantonalDepartments"] = [];
            for (let item of this.cantonalDepartments)
                data["cantonalDepartments"].push(item);
        }
        if (Array.isArray(this.inspectors)) {
            data["inspectors"] = [];
            for (let item of this.inspectors)
                data["inspectors"].push(item);
        }
        data["drugSampleId"] = this.drugSampleId;
        data["medicalProductsId"] = this.medicalProductsId;
        data["dateOfDeadline1"] = this.dateOfDeadline1 ? this.dateOfDeadline1.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDeadline2"] = this.dateOfDeadline2 ? this.dateOfDeadline2.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDeadline3"] = this.dateOfDeadline3 ? this.dateOfDeadline3.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfPartEnforcement"] = this.dateOfPartEnforcement ? this.dateOfPartEnforcement.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfProtocolRelease"] = this.dateOfProtocolRelease ? this.dateOfProtocolRelease.toFormat('yyyy-MM-dd') : <any>undefined;
        data["overallDeficiencyCategoryId"] = this.overallDeficiencyCategoryId;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IInspectionDetailDto {
    cantonalDepartments: string[] | undefined;
    inspectors: number[] | undefined;
    drugSampleId: string | undefined;
    medicalProductsId: string | undefined;
    dateOfDeadline1: DateTime | undefined;
    dateOfDeadline2: DateTime | undefined;
    dateOfDeadline3: DateTime | undefined;
    dateOfPartEnforcement: DateTime | undefined;
    dateOfProtocolRelease: DateTime | undefined;
    overallDeficiencyCategoryId: string | undefined;
    remark: string | undefined;
}

export class InspectionExecutionDto implements IInspectionExecutionDto {
    checkpoints!: InspectionCheckpointDto[];
    deficiencies!: InspectionDeficiencyDto[] | undefined;
    remark!: string | undefined;

    constructor(data?: IInspectionExecutionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.checkpoints = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["checkpoints"])) {
                this.checkpoints = [] as any;
                for (let item of _data["checkpoints"])
                    this.checkpoints!.push(InspectionCheckpointDto.fromJS(item));
            }
            if (Array.isArray(_data["deficiencies"])) {
                this.deficiencies = [] as any;
                for (let item of _data["deficiencies"])
                    this.deficiencies!.push(InspectionDeficiencyDto.fromJS(item));
            }
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): InspectionExecutionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionExecutionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.checkpoints)) {
            data["checkpoints"] = [];
            for (let item of this.checkpoints)
                data["checkpoints"].push(item.toJSON());
        }
        if (Array.isArray(this.deficiencies)) {
            data["deficiencies"] = [];
            for (let item of this.deficiencies)
                data["deficiencies"].push(item.toJSON());
        }
        data["remark"] = this.remark;
        return data;
    }
}

export interface IInspectionExecutionDto {
    checkpoints: InspectionCheckpointDto[];
    deficiencies: InspectionDeficiencyDto[] | undefined;
    remark: string | undefined;
}

export class InspectionPostprocessingDto implements IInspectionPostprocessingDto {
    dateOfInspectionFinished!: DateTime | undefined;
    finalBriefing!: string | undefined;
    remark!: string | undefined;

    constructor(data?: IInspectionPostprocessingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfInspectionFinished = _data["dateOfInspectionFinished"] ? DateTime.fromISO(_data["dateOfInspectionFinished"].toString()) : <any>undefined;
            this.finalBriefing = _data["finalBriefing"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): InspectionPostprocessingDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionPostprocessingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfInspectionFinished"] = this.dateOfInspectionFinished ? this.dateOfInspectionFinished.toFormat('yyyy-MM-dd') : <any>undefined;
        data["finalBriefing"] = this.finalBriefing;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IInspectionPostprocessingDto {
    dateOfInspectionFinished: DateTime | undefined;
    finalBriefing: string | undefined;
    remark: string | undefined;
}

export class InspectionPreparationDto implements IInspectionPreparationDto {
    dateOfPlanned!: DateTime | undefined;
    dateOfExecution!: DateTime | undefined;
    dateOfConfirmationSent!: DateTime | undefined;
    reasons!: string[] | undefined;
    notesPreliminaryDiscussion!: string | undefined;
    remark!: string | undefined;

    constructor(data?: IInspectionPreparationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfPlanned = _data["dateOfPlanned"] ? DateTime.fromISO(_data["dateOfPlanned"].toString()) : <any>undefined;
            this.dateOfExecution = _data["dateOfExecution"] ? DateTime.fromISO(_data["dateOfExecution"].toString()) : <any>undefined;
            this.dateOfConfirmationSent = _data["dateOfConfirmationSent"] ? DateTime.fromISO(_data["dateOfConfirmationSent"].toString()) : <any>undefined;
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(item);
            }
            this.notesPreliminaryDiscussion = _data["notesPreliminaryDiscussion"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): InspectionPreparationDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionPreparationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfPlanned"] = this.dateOfPlanned ? this.dateOfPlanned.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfExecution"] = this.dateOfExecution ? this.dateOfExecution.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfConfirmationSent"] = this.dateOfConfirmationSent ? this.dateOfConfirmationSent.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item);
        }
        data["notesPreliminaryDiscussion"] = this.notesPreliminaryDiscussion;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IInspectionPreparationDto {
    dateOfPlanned: DateTime | undefined;
    dateOfExecution: DateTime | undefined;
    dateOfConfirmationSent: DateTime | undefined;
    reasons: string[] | undefined;
    notesPreliminaryDiscussion: string | undefined;
    remark: string | undefined;
}

export class InspectionSearchResultDto implements IInspectionSearchResultDto {
    preparationReasons!: string[] | undefined;
    preparationDateOfPlanned!: DateTime | undefined;
    preparationDateOfExecution!: DateTime | undefined;
    detailCantonalDepartments!: string[] | undefined;
    inspectors!: string[] | undefined;
    id!: number;

    constructor(data?: IInspectionSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["preparationReasons"])) {
                this.preparationReasons = [] as any;
                for (let item of _data["preparationReasons"])
                    this.preparationReasons!.push(item);
            }
            this.preparationDateOfPlanned = _data["preparationDateOfPlanned"] ? DateTime.fromISO(_data["preparationDateOfPlanned"].toString()) : <any>undefined;
            this.preparationDateOfExecution = _data["preparationDateOfExecution"] ? DateTime.fromISO(_data["preparationDateOfExecution"].toString()) : <any>undefined;
            if (Array.isArray(_data["detailCantonalDepartments"])) {
                this.detailCantonalDepartments = [] as any;
                for (let item of _data["detailCantonalDepartments"])
                    this.detailCantonalDepartments!.push(item);
            }
            if (Array.isArray(_data["inspectors"])) {
                this.inspectors = [] as any;
                for (let item of _data["inspectors"])
                    this.inspectors!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InspectionSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.preparationReasons)) {
            data["preparationReasons"] = [];
            for (let item of this.preparationReasons)
                data["preparationReasons"].push(item);
        }
        data["preparationDateOfPlanned"] = this.preparationDateOfPlanned ? this.preparationDateOfPlanned.toFormat('yyyy-MM-dd') : <any>undefined;
        data["preparationDateOfExecution"] = this.preparationDateOfExecution ? this.preparationDateOfExecution.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.detailCantonalDepartments)) {
            data["detailCantonalDepartments"] = [];
            for (let item of this.detailCantonalDepartments)
                data["detailCantonalDepartments"].push(item);
        }
        if (Array.isArray(this.inspectors)) {
            data["inspectors"] = [];
            for (let item of this.inspectors)
                data["inspectors"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IInspectionSearchResultDto {
    preparationReasons: string[] | undefined;
    preparationDateOfPlanned: DateTime | undefined;
    preparationDateOfExecution: DateTime | undefined;
    detailCantonalDepartments: string[] | undefined;
    inspectors: string[] | undefined;
    id: number;
}

export class UpdateInspectionPostprocessingInputDto implements IUpdateInspectionPostprocessingInputDto {
    postprocessing!: InspectionPostprocessingDto;
    deficiencies!: InspectionDeficiencyDto[];

    constructor(data?: IUpdateInspectionPostprocessingInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.postprocessing = new InspectionPostprocessingDto();
            this.deficiencies = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postprocessing = _data["postprocessing"] ? InspectionPostprocessingDto.fromJS(_data["postprocessing"]) : new InspectionPostprocessingDto();
            if (Array.isArray(_data["deficiencies"])) {
                this.deficiencies = [] as any;
                for (let item of _data["deficiencies"])
                    this.deficiencies!.push(InspectionDeficiencyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateInspectionPostprocessingInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInspectionPostprocessingInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postprocessing"] = this.postprocessing ? this.postprocessing.toJSON() : <any>undefined;
        if (Array.isArray(this.deficiencies)) {
            data["deficiencies"] = [];
            for (let item of this.deficiencies)
                data["deficiencies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateInspectionPostprocessingInputDto {
    postprocessing: InspectionPostprocessingDto;
    deficiencies: InspectionDeficiencyDto[];
}

export class InspectionCheckpoint implements IInspectionCheckpoint {
    checkpoint!: string;
    checked!: boolean;

    constructor(data?: IInspectionCheckpoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkpoint = _data["checkpoint"];
            this.checked = _data["checked"];
        }
    }

    static fromJS(data: any): InspectionCheckpoint {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionCheckpoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkpoint"] = this.checkpoint;
        data["checked"] = this.checked;
        return data;
    }
}

export interface IInspectionCheckpoint {
    checkpoint: string;
    checked: boolean;
}

export class InspectionDeficiency implements IInspectionDeficiency {
    deficiency!: string;
    category!: Code;
    categoryId!: string | undefined;
    remark!: string | undefined;
    followUpInspection!: Code;
    followUpInspectionId!: string | undefined;

    constructor(data?: IInspectionDeficiency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.category = new Code();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deficiency = _data["deficiency"];
            this.category = _data["category"] ? Code.fromJS(_data["category"]) : new Code();
            this.categoryId = _data["categoryId"];
            this.remark = _data["remark"];
            this.followUpInspection = _data["followUpInspection"] ? Code.fromJS(_data["followUpInspection"]) : <any>undefined;
            this.followUpInspectionId = _data["followUpInspectionId"];
        }
    }

    static fromJS(data: any): InspectionDeficiency {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionDeficiency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deficiency"] = this.deficiency;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["categoryId"] = this.categoryId;
        data["remark"] = this.remark;
        data["followUpInspection"] = this.followUpInspection ? this.followUpInspection.toJSON() : <any>undefined;
        data["followUpInspectionId"] = this.followUpInspectionId;
        return data;
    }
}

export interface IInspectionDeficiency {
    deficiency: string;
    category: Code;
    categoryId: string | undefined;
    remark: string | undefined;
    followUpInspection: Code;
    followUpInspectionId: string | undefined;
}

export class InspectionExecution implements IInspectionExecution {
    checkpoints!: InspectionCheckpoint[] | undefined;
    deficiencies!: InspectionDeficiency[] | undefined;
    remark!: string | undefined;

    constructor(data?: IInspectionExecution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["checkpoints"])) {
                this.checkpoints = [] as any;
                for (let item of _data["checkpoints"])
                    this.checkpoints!.push(InspectionCheckpoint.fromJS(item));
            }
            if (Array.isArray(_data["deficiencies"])) {
                this.deficiencies = [] as any;
                for (let item of _data["deficiencies"])
                    this.deficiencies!.push(InspectionDeficiency.fromJS(item));
            }
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): InspectionExecution {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionExecution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.checkpoints)) {
            data["checkpoints"] = [];
            for (let item of this.checkpoints)
                data["checkpoints"].push(item.toJSON());
        }
        if (Array.isArray(this.deficiencies)) {
            data["deficiencies"] = [];
            for (let item of this.deficiencies)
                data["deficiencies"].push(item.toJSON());
        }
        data["remark"] = this.remark;
        return data;
    }
}

export interface IInspectionExecution {
    checkpoints: InspectionCheckpoint[] | undefined;
    deficiencies: InspectionDeficiency[] | undefined;
    remark: string | undefined;
}

export class Inspection implements IInspection {
    business!: Business;
    businessId!: number;
    detail!: InspectionDetail;
    preparation!: InspectionPreparation;
    execution!: InspectionExecution;
    postprocessing!: InspectionPostprocessing;
    sapInvoice!: SapInvoice;
    sapInvoiceId!: number | undefined;
    documentLinks!: DocumentLinkInspection[] | undefined;
    migrationData!: MigrationData[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IInspection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.business = _data["business"] ? Business.fromJS(_data["business"]) : <any>undefined;
            this.businessId = _data["businessId"];
            this.detail = _data["detail"] ? InspectionDetail.fromJS(_data["detail"]) : <any>undefined;
            this.preparation = _data["preparation"] ? InspectionPreparation.fromJS(_data["preparation"]) : <any>undefined;
            this.execution = _data["execution"] ? InspectionExecution.fromJS(_data["execution"]) : <any>undefined;
            this.postprocessing = _data["postprocessing"] ? InspectionPostprocessing.fromJS(_data["postprocessing"]) : <any>undefined;
            this.sapInvoice = _data["sapInvoice"] ? SapInvoice.fromJS(_data["sapInvoice"]) : <any>undefined;
            this.sapInvoiceId = _data["sapInvoiceId"];
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkInspection.fromJS(item));
            }
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Inspection {
        data = typeof data === 'object' ? data : {};
        let result = new Inspection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        data["businessId"] = this.businessId;
        data["detail"] = this.detail ? this.detail.toJSON() : <any>undefined;
        data["preparation"] = this.preparation ? this.preparation.toJSON() : <any>undefined;
        data["execution"] = this.execution ? this.execution.toJSON() : <any>undefined;
        data["postprocessing"] = this.postprocessing ? this.postprocessing.toJSON() : <any>undefined;
        data["sapInvoice"] = this.sapInvoice ? this.sapInvoice.toJSON() : <any>undefined;
        data["sapInvoiceId"] = this.sapInvoiceId;
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IInspection {
    business: Business;
    businessId: number;
    detail: InspectionDetail;
    preparation: InspectionPreparation;
    execution: InspectionExecution;
    postprocessing: InspectionPostprocessing;
    sapInvoice: SapInvoice;
    sapInvoiceId: number | undefined;
    documentLinks: DocumentLinkInspection[] | undefined;
    migrationData: MigrationData[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class InspectionCode implements IInspectionCode {
    code!: Code;
    codeId!: string | undefined;

    constructor(data?: IInspectionCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.code = new Code();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] ? Code.fromJS(_data["code"]) : new Code();
            this.codeId = _data["codeId"];
        }
    }

    static fromJS(data: any): InspectionCode {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code ? this.code.toJSON() : <any>undefined;
        data["codeId"] = this.codeId;
        return data;
    }
}

export interface IInspectionCode {
    code: Code;
    codeId: string | undefined;
}

export class InspectionPostprocessing implements IInspectionPostprocessing {
    dateOfInspectionFinished!: DateTime | undefined;
    finalBriefing!: string | undefined;
    remark!: string | undefined;

    constructor(data?: IInspectionPostprocessing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfInspectionFinished = _data["dateOfInspectionFinished"] ? DateTime.fromISO(_data["dateOfInspectionFinished"].toString()) : <any>undefined;
            this.finalBriefing = _data["finalBriefing"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): InspectionPostprocessing {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionPostprocessing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfInspectionFinished"] = this.dateOfInspectionFinished ? this.dateOfInspectionFinished.toFormat('yyyy-MM-dd') : <any>undefined;
        data["finalBriefing"] = this.finalBriefing;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IInspectionPostprocessing {
    dateOfInspectionFinished: DateTime | undefined;
    finalBriefing: string | undefined;
    remark: string | undefined;
}

export class InspectionPreparation implements IInspectionPreparation {
    dateOfPlanned!: DateTime | undefined;
    dateOfExecution!: DateTime | undefined;
    dateOfConfirmationSent!: DateTime | undefined;
    reasons!: InspectionCode[] | undefined;
    notesPreliminaryDiscussion!: string | undefined;
    remark!: string | undefined;

    constructor(data?: IInspectionPreparation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfPlanned = _data["dateOfPlanned"] ? DateTime.fromISO(_data["dateOfPlanned"].toString()) : <any>undefined;
            this.dateOfExecution = _data["dateOfExecution"] ? DateTime.fromISO(_data["dateOfExecution"].toString()) : <any>undefined;
            this.dateOfConfirmationSent = _data["dateOfConfirmationSent"] ? DateTime.fromISO(_data["dateOfConfirmationSent"].toString()) : <any>undefined;
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(InspectionCode.fromJS(item));
            }
            this.notesPreliminaryDiscussion = _data["notesPreliminaryDiscussion"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): InspectionPreparation {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionPreparation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfPlanned"] = this.dateOfPlanned ? this.dateOfPlanned.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfExecution"] = this.dateOfExecution ? this.dateOfExecution.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfConfirmationSent"] = this.dateOfConfirmationSent ? this.dateOfConfirmationSent.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item.toJSON());
        }
        data["notesPreliminaryDiscussion"] = this.notesPreliminaryDiscussion;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IInspectionPreparation {
    dateOfPlanned: DateTime | undefined;
    dateOfExecution: DateTime | undefined;
    dateOfConfirmationSent: DateTime | undefined;
    reasons: InspectionCode[] | undefined;
    notesPreliminaryDiscussion: string | undefined;
    remark: string | undefined;
}

export class AppSettingsJsonDto implements IAppSettingsJsonDto {
    webSiteUrl!: string | undefined;
    serverSiteUrl!: string | undefined;
    languages!: NameValue[] | undefined;

    constructor(data?: IAppSettingsJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webSiteUrl = _data["webSiteUrl"];
            this.serverSiteUrl = _data["serverSiteUrl"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(NameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppSettingsJsonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverSiteUrl"] = this.serverSiteUrl;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAppSettingsJsonDto {
    webSiteUrl: string | undefined;
    serverSiteUrl: string | undefined;
    languages: NameValue[] | undefined;
}

export class CheckDatabaseOutput implements ICheckDatabaseOutput {
    isDatabaseExist!: boolean;

    constructor(data?: ICheckDatabaseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDatabaseExist = _data["isDatabaseExist"];
        }
    }

    static fromJS(data: any): CheckDatabaseOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDatabaseExist"] = this.isDatabaseExist;
        return data;
    }
}

export interface ICheckDatabaseOutput {
    isDatabaseExist: boolean;
}

export class InstallDto implements IInstallDto {
    connectionString!: string;
    adminPassword!: string;
    webSiteUrl!: string;
    serverUrl!: string | undefined;
    defaultLanguage!: string;
    smtpSettings!: EmailSettingsEditDto;
    billInfo!: HostBillingSettingsEditDto;

    constructor(data?: IInstallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionString = _data["connectionString"];
            this.adminPassword = _data["adminPassword"];
            this.webSiteUrl = _data["webSiteUrl"];
            this.serverUrl = _data["serverUrl"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.smtpSettings = _data["smtpSettings"] ? EmailSettingsEditDto.fromJS(_data["smtpSettings"]) : <any>undefined;
            this.billInfo = _data["billInfo"] ? HostBillingSettingsEditDto.fromJS(_data["billInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstallDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["adminPassword"] = this.adminPassword;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverUrl"] = this.serverUrl;
        data["defaultLanguage"] = this.defaultLanguage;
        data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : <any>undefined;
        data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string | undefined;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto;
    billInfo: HostBillingSettingsEditDto;
}

export class GetJobInfoListOutput implements IGetJobInfoListOutput {
    items!: JobInfoDto[] | undefined;

    constructor(data?: IGetJobInfoListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(JobInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJobInfoListOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetJobInfoListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJobInfoListOutput {
    items: JobInfoDto[] | undefined;
}

export class GetJobOutputFilesResult implements IGetJobOutputFilesResult {
    totalCount!: number;
    items!: JobOutputFileDto[] | undefined;

    constructor(data?: IGetJobOutputFilesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(JobOutputFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJobOutputFilesResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetJobOutputFilesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJobOutputFilesResult {
    totalCount: number;
    items: JobOutputFileDto[] | undefined;
}

export class JobInfoDto implements IJobInfoDto {
    group!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    lastRun!: LastRunInfoDto;

    constructor(data?: IJobInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.lastRun = _data["lastRun"] ? LastRunInfoDto.fromJS(_data["lastRun"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JobInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        data["name"] = this.name;
        data["description"] = this.description;
        data["lastRun"] = this.lastRun ? this.lastRun.toJSON() : <any>undefined;
        return data;
    }
}

export interface IJobInfoDto {
    group: string | undefined;
    name: string | undefined;
    description: string | undefined;
    lastRun: LastRunInfoDto;
}

export class JobOutputFileDto implements IJobOutputFileDto {
    id!: number;
    creationTime!: DateTime;
    type!: JobOutputFileType;
    typeTranslated!: string | undefined;
    mimeHeader!: string | undefined;

    constructor(data?: IJobOutputFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.typeTranslated = _data["typeTranslated"];
            this.mimeHeader = _data["mimeHeader"];
        }
    }

    static fromJS(data: any): JobOutputFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobOutputFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["type"] = this.type;
        data["typeTranslated"] = this.typeTranslated;
        data["mimeHeader"] = this.mimeHeader;
        return data;
    }
}

export interface IJobOutputFileDto {
    id: number;
    creationTime: DateTime;
    type: JobOutputFileType;
    typeTranslated: string | undefined;
    mimeHeader: string | undefined;
}

export class LastRunInfoDto implements ILastRunInfoDto {
    fired!: DateTime;
    successful!: boolean;
    exception!: any | undefined;

    constructor(data?: ILastRunInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fired = _data["fired"] ? DateTime.fromISO(_data["fired"].toString()) : <any>undefined;
            this.successful = _data["successful"];
            this.exception = _data["exception"];
        }
    }

    static fromJS(data: any): LastRunInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new LastRunInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fired"] = this.fired ? this.fired.toString() : <any>undefined;
        data["successful"] = this.successful;
        data["exception"] = this.exception;
        return data;
    }
}

export interface ILastRunInfoDto {
    fired: DateTime;
    successful: boolean;
    exception: any | undefined;
}

export enum JobOutputFileType {
    MedRegTransmission = 0,
    PsyRegTransmission = 1,
    NaregTransmission = 2,
    BetRegTransmission = 3,
}

export class GetLegitimatedUsersDto implements IGetLegitimatedUsersDto {
    fullName!: string | undefined;
    email!: string | undefined;
    role!: LegitimationRole;
    id!: number;

    constructor(data?: IGetLegitimatedUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetLegitimatedUsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLegitimatedUsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["role"] = this.role;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetLegitimatedUsersDto {
    fullName: string | undefined;
    email: string | undefined;
    role: LegitimationRole;
    id: number;
}

export class GetLegitimationDto implements IGetLegitimationDto {
    discriminator!: LegitimationType;
    userId!: number;
    role!: LegitimationRole;
    person!: LegitimationPersonDto;
    sponsorship!: LegitimationSponsorshipDto;
    id!: number;

    constructor(data?: IGetLegitimationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.userId = _data["userId"];
            this.role = _data["role"];
            this.person = _data["person"] ? LegitimationPersonDto.fromJS(_data["person"]) : <any>undefined;
            this.sponsorship = _data["sponsorship"] ? LegitimationSponsorshipDto.fromJS(_data["sponsorship"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetLegitimationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLegitimationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["userId"] = this.userId;
        data["role"] = this.role;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetLegitimationDto {
    discriminator: LegitimationType;
    userId: number;
    role: LegitimationRole;
    person: LegitimationPersonDto;
    sponsorship: LegitimationSponsorshipDto;
    id: number;
}

export class LegitimationPersonDto implements ILegitimationPersonDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    gln!: string | undefined;
    contactStreet!: string | undefined;
    contactStreetNr!: string | undefined;
    contactPostOfficeBox!: string | undefined;
    contactPostCode!: string | undefined;
    contactCity!: string | undefined;
    contactCountryId!: string | undefined;
    id!: number;

    constructor(data?: ILegitimationPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gln = _data["gln"];
            this.contactStreet = _data["contactStreet"];
            this.contactStreetNr = _data["contactStreetNr"];
            this.contactPostOfficeBox = _data["contactPostOfficeBox"];
            this.contactPostCode = _data["contactPostCode"];
            this.contactCity = _data["contactCity"];
            this.contactCountryId = _data["contactCountryId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LegitimationPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new LegitimationPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gln"] = this.gln;
        data["contactStreet"] = this.contactStreet;
        data["contactStreetNr"] = this.contactStreetNr;
        data["contactPostOfficeBox"] = this.contactPostOfficeBox;
        data["contactPostCode"] = this.contactPostCode;
        data["contactCity"] = this.contactCity;
        data["contactCountryId"] = this.contactCountryId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILegitimationPersonDto {
    firstName: string | undefined;
    lastName: string | undefined;
    gln: string | undefined;
    contactStreet: string | undefined;
    contactStreetNr: string | undefined;
    contactPostOfficeBox: string | undefined;
    contactPostCode: string | undefined;
    contactCity: string | undefined;
    contactCountryId: string | undefined;
    id: number;
}

export class LegitimationSponsorshipDto implements ILegitimationSponsorshipDto {
    name!: string | undefined;
    uid!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    id!: number;

    constructor(data?: ILegitimationSponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.uid = _data["uid"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LegitimationSponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new LegitimationSponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["uid"] = this.uid;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["id"] = this.id;
        return data;
    }
}

export interface ILegitimationSponsorshipDto {
    name: string | undefined;
    uid: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    id: number;
}

export class Legitimation implements ILegitimation {
    discriminator!: LegitimationType;
    user!: User;
    readonly userId!: number;
    role!: LegitimationRole;
    applications!: Application[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILegitimation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            (<any>this).userId = _data["userId"];
            this.role = _data["role"];
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(Application.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Legitimation {
        data = typeof data === 'object' ? data : {};
        let result = new Legitimation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["role"] = this.role;
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILegitimation {
    discriminator: LegitimationType;
    user: User;
    userId: number;
    role: LegitimationRole;
    applications: Application[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LegitimationPerson implements ILegitimationPerson {
    person!: Person;
    personId!: number;
    discriminator!: LegitimationType;
    user!: User;
    readonly userId!: number;
    role!: LegitimationRole;
    applications!: Application[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILegitimationPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.personId = _data["personId"];
            this.discriminator = _data["discriminator"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            (<any>this).userId = _data["userId"];
            this.role = _data["role"];
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(Application.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LegitimationPerson {
        data = typeof data === 'object' ? data : {};
        let result = new LegitimationPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["discriminator"] = this.discriminator;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["role"] = this.role;
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILegitimationPerson {
    person: Person;
    personId: number;
    discriminator: LegitimationType;
    user: User;
    userId: number;
    role: LegitimationRole;
    applications: Application[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum LegitimationRole {
    Admin = 0,
    User = 1,
}

export class LegitimationSponsorship implements ILegitimationSponsorship {
    sponsorship!: Sponsorship;
    sponsorshipId!: number;
    discriminator!: LegitimationType;
    user!: User;
    readonly userId!: number;
    role!: LegitimationRole;
    applications!: Application[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILegitimationSponsorship) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorship = _data["sponsorship"] ? Sponsorship.fromJS(_data["sponsorship"]) : <any>undefined;
            this.sponsorshipId = _data["sponsorshipId"];
            this.discriminator = _data["discriminator"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            (<any>this).userId = _data["userId"];
            this.role = _data["role"];
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(Application.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LegitimationSponsorship {
        data = typeof data === 'object' ? data : {};
        let result = new LegitimationSponsorship();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        data["sponsorshipId"] = this.sponsorshipId;
        data["discriminator"] = this.discriminator;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["role"] = this.role;
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILegitimationSponsorship {
    sponsorship: Sponsorship;
    sponsorshipId: number;
    discriminator: LegitimationType;
    user: User;
    userId: number;
    role: LegitimationRole;
    applications: Application[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum LegitimationType {
    Person = 0,
    Sponsorship = 1,
}

export class GetLegApplicationsOutput implements IGetLegApplicationsOutput {
    totalCount!: number;
    items!: LegApplicationSearchDto[] | undefined;

    constructor(data?: IGetLegApplicationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LegApplicationSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLegApplicationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLegApplicationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLegApplicationsOutput {
    totalCount: number;
    items: LegApplicationSearchDto[] | undefined;
}

export class GetLegOutput implements IGetLegOutput {
    leg!: LegDto;

    constructor(data?: IGetLegOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leg = _data["leg"] ? LegDto.fromJS(_data["leg"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLegOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLegOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leg"] = this.leg ? this.leg.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetLegOutput {
    leg: LegDto;
}

export class LegApplicationSearchDto implements ILegApplicationSearchDto {
    id!: number;
    responsibleId!: number | undefined;
    responsibleFullName!: string | undefined;
    iAmResponsible!: boolean;
    caseId!: string | undefined;
    caseIdSearchable!: string | undefined;
    userFullName!: string | undefined;
    userEmail!: string | undefined;
    glnUid!: string | undefined;
    professionId!: string | undefined;
    serviceprovider!: string | undefined;
    type!: number;
    status!: ApplicationStatus;
    dateOfStatusChange!: DateTime;
    submittedCount!: number;
    submittedDate!: DateTime | undefined;
    lastSubmittedDate!: DateTime | undefined;

    constructor(data?: ILegApplicationSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.responsibleId = _data["responsibleId"];
            this.responsibleFullName = _data["responsibleFullName"];
            this.iAmResponsible = _data["iAmResponsible"];
            this.caseId = _data["caseId"];
            this.caseIdSearchable = _data["caseIdSearchable"];
            this.userFullName = _data["userFullName"];
            this.userEmail = _data["userEmail"];
            this.glnUid = _data["glnUid"];
            this.professionId = _data["professionId"];
            this.serviceprovider = _data["serviceprovider"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.submittedCount = _data["submittedCount"];
            this.submittedDate = _data["submittedDate"] ? DateTime.fromISO(_data["submittedDate"].toString()) : <any>undefined;
            this.lastSubmittedDate = _data["lastSubmittedDate"] ? DateTime.fromISO(_data["lastSubmittedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LegApplicationSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new LegApplicationSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["responsibleId"] = this.responsibleId;
        data["responsibleFullName"] = this.responsibleFullName;
        data["iAmResponsible"] = this.iAmResponsible;
        data["caseId"] = this.caseId;
        data["caseIdSearchable"] = this.caseIdSearchable;
        data["userFullName"] = this.userFullName;
        data["userEmail"] = this.userEmail;
        data["glnUid"] = this.glnUid;
        data["professionId"] = this.professionId;
        data["serviceprovider"] = this.serviceprovider;
        data["type"] = this.type;
        data["status"] = this.status;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toString() : <any>undefined;
        data["submittedCount"] = this.submittedCount;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toString() : <any>undefined;
        data["lastSubmittedDate"] = this.lastSubmittedDate ? this.lastSubmittedDate.toString() : <any>undefined;
        return data;
    }
}

export interface ILegApplicationSearchDto {
    id: number;
    responsibleId: number | undefined;
    responsibleFullName: string | undefined;
    iAmResponsible: boolean;
    caseId: string | undefined;
    caseIdSearchable: string | undefined;
    userFullName: string | undefined;
    userEmail: string | undefined;
    glnUid: string | undefined;
    professionId: string | undefined;
    serviceprovider: string | undefined;
    type: number;
    status: ApplicationStatus;
    dateOfStatusChange: DateTime;
    submittedCount: number;
    submittedDate: DateTime | undefined;
    lastSubmittedDate: DateTime | undefined;
}

export class LegDto implements ILegDto {
    application!: ApplicationDto;
    currentStep!: LegStatus;
    legPerson!: LegPersonDto;
    legSponsorship!: LegSponsorshipDto;
    legDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILegDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.currentStep = _data["currentStep"];
            this.legPerson = _data["legPerson"] ? LegPersonDto.fromJS(_data["legPerson"]) : <any>undefined;
            this.legSponsorship = _data["legSponsorship"] ? LegSponsorshipDto.fromJS(_data["legSponsorship"]) : <any>undefined;
            if (Array.isArray(_data["legDocuments"])) {
                this.legDocuments = [] as any;
                for (let item of _data["legDocuments"])
                    this.legDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LegDto {
        data = typeof data === 'object' ? data : {};
        let result = new LegDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["currentStep"] = this.currentStep;
        data["legPerson"] = this.legPerson ? this.legPerson.toJSON() : <any>undefined;
        data["legSponsorship"] = this.legSponsorship ? this.legSponsorship.toJSON() : <any>undefined;
        if (Array.isArray(this.legDocuments)) {
            data["legDocuments"] = [];
            for (let item of this.legDocuments)
                data["legDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILegDto {
    application: ApplicationDto;
    currentStep: LegStatus;
    legPerson: LegPersonDto;
    legSponsorship: LegSponsorshipDto;
    legDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class LegPersonDto implements ILegPersonDto {
    gln!: string | undefined;
    professionId!: string | undefined;
    medRegId!: number | undefined;
    psyRegId!: number | undefined;
    naregId!: number | undefined;
    hasConfirmedData!: boolean | undefined;

    constructor(data?: ILegPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.medRegId = _data["medRegId"];
            this.psyRegId = _data["psyRegId"];
            this.naregId = _data["naregId"];
            this.hasConfirmedData = _data["hasConfirmedData"];
        }
    }

    static fromJS(data: any): LegPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new LegPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["medRegId"] = this.medRegId;
        data["psyRegId"] = this.psyRegId;
        data["naregId"] = this.naregId;
        data["hasConfirmedData"] = this.hasConfirmedData;
        return data;
    }
}

export interface ILegPersonDto {
    gln: string | undefined;
    professionId: string | undefined;
    medRegId: number | undefined;
    psyRegId: number | undefined;
    naregId: number | undefined;
    hasConfirmedData: boolean | undefined;
}

export class LegRegisterOutput implements ILegRegisterOutput {
    healthRegisterIdentificationStatus!: HealthRegisterIdentificationStatus;
    healthRegisterSystem!: ExternalSystemEnum;
    healthRegisterId!: number;

    constructor(data?: ILegRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRegisterIdentificationStatus = _data["healthRegisterIdentificationStatus"];
            this.healthRegisterSystem = _data["healthRegisterSystem"];
            this.healthRegisterId = _data["healthRegisterId"];
        }
    }

    static fromJS(data: any): LegRegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LegRegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRegisterIdentificationStatus"] = this.healthRegisterIdentificationStatus;
        data["healthRegisterSystem"] = this.healthRegisterSystem;
        data["healthRegisterId"] = this.healthRegisterId;
        return data;
    }
}

export interface ILegRegisterOutput {
    healthRegisterIdentificationStatus: HealthRegisterIdentificationStatus;
    healthRegisterSystem: ExternalSystemEnum;
    healthRegisterId: number;
}

export class LegSponsorshipDto implements ILegSponsorshipDto {
    uid!: string | undefined;
    name!: string | undefined;
    legalFormId!: string | undefined;
    additionalName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    cantonId!: string | undefined;
    countryId!: string | undefined;
    hasConfirmedData!: boolean | undefined;

    constructor(data?: ILegSponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.name = _data["name"];
            this.legalFormId = _data["legalFormId"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.cantonId = _data["cantonId"];
            this.countryId = _data["countryId"];
            this.hasConfirmedData = _data["hasConfirmedData"];
        }
    }

    static fromJS(data: any): LegSponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new LegSponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["name"] = this.name;
        data["legalFormId"] = this.legalFormId;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["cantonId"] = this.cantonId;
        data["countryId"] = this.countryId;
        data["hasConfirmedData"] = this.hasConfirmedData;
        return data;
    }
}

export interface ILegSponsorshipDto {
    uid: string | undefined;
    name: string | undefined;
    legalFormId: string | undefined;
    additionalName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    cantonId: string | undefined;
    countryId: string | undefined;
    hasConfirmedData: boolean | undefined;
}

export class UpdateLegSponsorshipInput implements IUpdateLegSponsorshipInput {
    caseId!: string | undefined;
    legSponsorship!: LegSponsorshipDto;

    constructor(data?: IUpdateLegSponsorshipInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.legSponsorship = _data["legSponsorship"] ? LegSponsorshipDto.fromJS(_data["legSponsorship"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateLegSponsorshipInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLegSponsorshipInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["legSponsorship"] = this.legSponsorship ? this.legSponsorship.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateLegSponsorshipInput {
    caseId: string | undefined;
    legSponsorship: LegSponsorshipDto;
}

export class LegDocumentGroup implements ILegDocumentGroup {
    id!: number;
    typeId!: string | undefined;
    isMandatory!: boolean | undefined;
    info!: string | undefined;
    files!: GeneralFileInfo[] | undefined;

    constructor(data?: ILegDocumentGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeId = _data["typeId"];
            this.isMandatory = _data["isMandatory"];
            this.info = _data["info"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(GeneralFileInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LegDocumentGroup {
        data = typeof data === 'object' ? data : {};
        let result = new LegDocumentGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        data["isMandatory"] = this.isMandatory;
        data["info"] = this.info;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILegDocumentGroup {
    id: number;
    typeId: string | undefined;
    isMandatory: boolean | undefined;
    info: string | undefined;
    files: GeneralFileInfo[] | undefined;
}

export class CreateOrUpdateLiaAcademicTitleInput implements ICreateOrUpdateLiaAcademicTitleInput {
    caseId!: string;
    liaAcademicTitles!: LiaAcademicTitleDto[];

    constructor(data?: ICreateOrUpdateLiaAcademicTitleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaAcademicTitles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["liaAcademicTitles"])) {
                this.liaAcademicTitles = [] as any;
                for (let item of _data["liaAcademicTitles"])
                    this.liaAcademicTitles!.push(LiaAcademicTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaAcademicTitleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaAcademicTitleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.liaAcademicTitles)) {
            data["liaAcademicTitles"] = [];
            for (let item of this.liaAcademicTitles)
                data["liaAcademicTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateLiaAcademicTitleInput {
    caseId: string;
    liaAcademicTitles: LiaAcademicTitleDto[];
}

export class CreateOrUpdateLiaAcademicTitleOutput implements ICreateOrUpdateLiaAcademicTitleOutput {
    status!: LiaStatus;
    liaAcademicTitles!: LiaAcademicTitleDto[] | undefined;

    constructor(data?: ICreateOrUpdateLiaAcademicTitleOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["liaAcademicTitles"])) {
                this.liaAcademicTitles = [] as any;
                for (let item of _data["liaAcademicTitles"])
                    this.liaAcademicTitles!.push(LiaAcademicTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaAcademicTitleOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaAcademicTitleOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.liaAcademicTitles)) {
            data["liaAcademicTitles"] = [];
            for (let item of this.liaAcademicTitles)
                data["liaAcademicTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateLiaAcademicTitleOutput {
    status: LiaStatus;
    liaAcademicTitles: LiaAcademicTitleDto[] | undefined;
}

export class LiaAcademicTitleDto implements ILiaAcademicTitleDto {
    id!: string;
    liaApplicationId!: number;
    title!: string | undefined;
    bodyOfIssue!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;

    constructor(data?: ILiaAcademicTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.liaApplicationId = _data["liaApplicationId"];
            this.title = _data["title"];
            this.bodyOfIssue = _data["bodyOfIssue"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LiaAcademicTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaAcademicTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["liaApplicationId"] = this.liaApplicationId;
        data["title"] = this.title;
        data["bodyOfIssue"] = this.bodyOfIssue;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface ILiaAcademicTitleDto {
    id: string;
    liaApplicationId: number;
    title: string | undefined;
    bodyOfIssue: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
}

export class LiaAcademicTitlesOutput implements ILiaAcademicTitlesOutput {
    titles!: LiaAcademicTitleDto[] | undefined;
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaAcademicTitlesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(LiaAcademicTitleDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaAcademicTitlesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LiaAcademicTitlesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaAcademicTitlesOutput {
    titles: LiaAcademicTitleDto[] | undefined;
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class CreateOrUpdateLiaContactInput implements ICreateOrUpdateLiaContactInput {
    caseId!: string;
    liaContact!: LiaContactDto;

    constructor(data?: ICreateOrUpdateLiaContactInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaContact = new LiaContactDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.liaContact = _data["liaContact"] ? LiaContactDto.fromJS(_data["liaContact"]) : new LiaContactDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaContactInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaContactInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["liaContact"] = this.liaContact ? this.liaContact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaContactInput {
    caseId: string;
    liaContact: LiaContactDto;
}

export class LiaContactDto implements ILiaContactDto {
    titleId!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    street!: string;
    streetNr!: string | undefined;
    postCode!: string;
    city!: string;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    email!: string;
    email2!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    titleAddressSwiss!: string | undefined;
    streetSwiss!: string | undefined;
    streetNrSwiss!: string | undefined;
    postCodeSwiss!: string | undefined;
    citySwiss!: string | undefined;
    postOfficeBoxSwiss!: string | undefined;
    addressAdditionSwiss!: string | undefined;

    constructor(data?: ILiaContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.titleAddressSwiss = _data["titleAddressSwiss"];
            this.streetSwiss = _data["streetSwiss"];
            this.streetNrSwiss = _data["streetNrSwiss"];
            this.postCodeSwiss = _data["postCodeSwiss"];
            this.citySwiss = _data["citySwiss"];
            this.postOfficeBoxSwiss = _data["postOfficeBoxSwiss"];
            this.addressAdditionSwiss = _data["addressAdditionSwiss"];
        }
    }

    static fromJS(data: any): LiaContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["titleAddressSwiss"] = this.titleAddressSwiss;
        data["streetSwiss"] = this.streetSwiss;
        data["streetNrSwiss"] = this.streetNrSwiss;
        data["postCodeSwiss"] = this.postCodeSwiss;
        data["citySwiss"] = this.citySwiss;
        data["postOfficeBoxSwiss"] = this.postOfficeBoxSwiss;
        data["addressAdditionSwiss"] = this.addressAdditionSwiss;
        return data;
    }
}

export interface ILiaContactDto {
    titleId: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    street: string;
    streetNr: string | undefined;
    postCode: string;
    city: string;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    email: string;
    email2: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    titleAddressSwiss: string | undefined;
    streetSwiss: string | undefined;
    streetNrSwiss: string | undefined;
    postCodeSwiss: string | undefined;
    citySwiss: string | undefined;
    postOfficeBoxSwiss: string | undefined;
    addressAdditionSwiss: string | undefined;
}

export class LiaDocumentsOutput implements ILiaDocumentsOutput {
    caseId!: string;
    liaDocuments!: GeneralDocumentGroupDto[];

    constructor(data?: ILiaDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaDocuments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["liaDocuments"])) {
                this.liaDocuments = [] as any;
                for (let item of _data["liaDocuments"])
                    this.liaDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LiaDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.liaDocuments)) {
            data["liaDocuments"] = [];
            for (let item of this.liaDocuments)
                data["liaDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaDocumentsOutput {
    caseId: string;
    liaDocuments: GeneralDocumentGroupDto[];
}

export class GetLiaOutput implements IGetLiaOutput {
    lia!: LiaDto;

    constructor(data?: IGetLiaOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lia = _data["lia"] ? LiaDto.fromJS(_data["lia"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLiaOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLiaOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lia"] = this.lia ? this.lia.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetLiaOutput {
    lia: LiaDto;
}

export class LiaDto implements ILiaDto {
    application!: ApplicationDto;
    professionId!: string | undefined;
    currentStep!: LiaStatus;
    ehcConfirmationId!: string | undefined;
    liaPerson!: LiaPersonDto;
    liaContact!: LiaContactDto;
    liaLanguageSkill!: LiaLanguageSkillDto;
    liaAcademicTitles!: LiaAcademicTitlesOutput;
    liaRestrictions!: LiaRestrictionOutput;
    liaEmployments!: LiaEmploymentOutput;
    liaInvoiceAddress!: LiaInvoiceAddressDto;
    liaVaccination!: LiaVaccinationOutputDto;
    liaSelfEmployment!: EhcSelfEmploymentDto;
    liaEhcLanguageSkill!: EhcLanguageSkillDto;
    liaElectronicPatientRecord!: EhcElectronicPatientRecordDto;
    liaPractice!: LiaPracticeDto;
    liaQualityRequirement!: EhcQualityRequirementDto;
    liaEmploymentOrPostgraduateTitles!: EhcEmploymentOrPostgraduateTitleDto[] | undefined;
    liaProfessionalResponsibilityOutput!: LiaProfessionalResponsibilityOutput;
    liaTherapyMethod!: LiaTherapyMethodDto;
    liaDocuments!: GeneralDocumentGroupDto[] | undefined;
    numberOfLinkedEhcApplications!: number;
    statusOfLinkedApplications!: ApplicationStatus[] | undefined;

    constructor(data?: ILiaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.professionId = _data["professionId"];
            this.currentStep = _data["currentStep"];
            this.ehcConfirmationId = _data["ehcConfirmationId"];
            this.liaPerson = _data["liaPerson"] ? LiaPersonDto.fromJS(_data["liaPerson"]) : <any>undefined;
            this.liaContact = _data["liaContact"] ? LiaContactDto.fromJS(_data["liaContact"]) : <any>undefined;
            this.liaLanguageSkill = _data["liaLanguageSkill"] ? LiaLanguageSkillDto.fromJS(_data["liaLanguageSkill"]) : <any>undefined;
            this.liaAcademicTitles = _data["liaAcademicTitles"] ? LiaAcademicTitlesOutput.fromJS(_data["liaAcademicTitles"]) : <any>undefined;
            this.liaRestrictions = _data["liaRestrictions"] ? LiaRestrictionOutput.fromJS(_data["liaRestrictions"]) : <any>undefined;
            this.liaEmployments = _data["liaEmployments"] ? LiaEmploymentOutput.fromJS(_data["liaEmployments"]) : <any>undefined;
            this.liaInvoiceAddress = _data["liaInvoiceAddress"] ? LiaInvoiceAddressDto.fromJS(_data["liaInvoiceAddress"]) : <any>undefined;
            this.liaVaccination = _data["liaVaccination"] ? LiaVaccinationOutputDto.fromJS(_data["liaVaccination"]) : <any>undefined;
            this.liaSelfEmployment = _data["liaSelfEmployment"] ? EhcSelfEmploymentDto.fromJS(_data["liaSelfEmployment"]) : <any>undefined;
            this.liaEhcLanguageSkill = _data["liaEhcLanguageSkill"] ? EhcLanguageSkillDto.fromJS(_data["liaEhcLanguageSkill"]) : <any>undefined;
            this.liaElectronicPatientRecord = _data["liaElectronicPatientRecord"] ? EhcElectronicPatientRecordDto.fromJS(_data["liaElectronicPatientRecord"]) : <any>undefined;
            this.liaPractice = _data["liaPractice"] ? LiaPracticeDto.fromJS(_data["liaPractice"]) : <any>undefined;
            this.liaQualityRequirement = _data["liaQualityRequirement"] ? EhcQualityRequirementDto.fromJS(_data["liaQualityRequirement"]) : <any>undefined;
            if (Array.isArray(_data["liaEmploymentOrPostgraduateTitles"])) {
                this.liaEmploymentOrPostgraduateTitles = [] as any;
                for (let item of _data["liaEmploymentOrPostgraduateTitles"])
                    this.liaEmploymentOrPostgraduateTitles!.push(EhcEmploymentOrPostgraduateTitleDto.fromJS(item));
            }
            this.liaProfessionalResponsibilityOutput = _data["liaProfessionalResponsibilityOutput"] ? LiaProfessionalResponsibilityOutput.fromJS(_data["liaProfessionalResponsibilityOutput"]) : <any>undefined;
            this.liaTherapyMethod = _data["liaTherapyMethod"] ? LiaTherapyMethodDto.fromJS(_data["liaTherapyMethod"]) : <any>undefined;
            if (Array.isArray(_data["liaDocuments"])) {
                this.liaDocuments = [] as any;
                for (let item of _data["liaDocuments"])
                    this.liaDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
            this.numberOfLinkedEhcApplications = _data["numberOfLinkedEhcApplications"];
            if (Array.isArray(_data["statusOfLinkedApplications"])) {
                this.statusOfLinkedApplications = [] as any;
                for (let item of _data["statusOfLinkedApplications"])
                    this.statusOfLinkedApplications!.push(item);
            }
        }
    }

    static fromJS(data: any): LiaDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["professionId"] = this.professionId;
        data["currentStep"] = this.currentStep;
        data["ehcConfirmationId"] = this.ehcConfirmationId;
        data["liaPerson"] = this.liaPerson ? this.liaPerson.toJSON() : <any>undefined;
        data["liaContact"] = this.liaContact ? this.liaContact.toJSON() : <any>undefined;
        data["liaLanguageSkill"] = this.liaLanguageSkill ? this.liaLanguageSkill.toJSON() : <any>undefined;
        data["liaAcademicTitles"] = this.liaAcademicTitles ? this.liaAcademicTitles.toJSON() : <any>undefined;
        data["liaRestrictions"] = this.liaRestrictions ? this.liaRestrictions.toJSON() : <any>undefined;
        data["liaEmployments"] = this.liaEmployments ? this.liaEmployments.toJSON() : <any>undefined;
        data["liaInvoiceAddress"] = this.liaInvoiceAddress ? this.liaInvoiceAddress.toJSON() : <any>undefined;
        data["liaVaccination"] = this.liaVaccination ? this.liaVaccination.toJSON() : <any>undefined;
        data["liaSelfEmployment"] = this.liaSelfEmployment ? this.liaSelfEmployment.toJSON() : <any>undefined;
        data["liaEhcLanguageSkill"] = this.liaEhcLanguageSkill ? this.liaEhcLanguageSkill.toJSON() : <any>undefined;
        data["liaElectronicPatientRecord"] = this.liaElectronicPatientRecord ? this.liaElectronicPatientRecord.toJSON() : <any>undefined;
        data["liaPractice"] = this.liaPractice ? this.liaPractice.toJSON() : <any>undefined;
        data["liaQualityRequirement"] = this.liaQualityRequirement ? this.liaQualityRequirement.toJSON() : <any>undefined;
        if (Array.isArray(this.liaEmploymentOrPostgraduateTitles)) {
            data["liaEmploymentOrPostgraduateTitles"] = [];
            for (let item of this.liaEmploymentOrPostgraduateTitles)
                data["liaEmploymentOrPostgraduateTitles"].push(item.toJSON());
        }
        data["liaProfessionalResponsibilityOutput"] = this.liaProfessionalResponsibilityOutput ? this.liaProfessionalResponsibilityOutput.toJSON() : <any>undefined;
        data["liaTherapyMethod"] = this.liaTherapyMethod ? this.liaTherapyMethod.toJSON() : <any>undefined;
        if (Array.isArray(this.liaDocuments)) {
            data["liaDocuments"] = [];
            for (let item of this.liaDocuments)
                data["liaDocuments"].push(item.toJSON());
        }
        data["numberOfLinkedEhcApplications"] = this.numberOfLinkedEhcApplications;
        if (Array.isArray(this.statusOfLinkedApplications)) {
            data["statusOfLinkedApplications"] = [];
            for (let item of this.statusOfLinkedApplications)
                data["statusOfLinkedApplications"].push(item);
        }
        return data;
    }
}

export interface ILiaDto {
    application: ApplicationDto;
    professionId: string | undefined;
    currentStep: LiaStatus;
    ehcConfirmationId: string | undefined;
    liaPerson: LiaPersonDto;
    liaContact: LiaContactDto;
    liaLanguageSkill: LiaLanguageSkillDto;
    liaAcademicTitles: LiaAcademicTitlesOutput;
    liaRestrictions: LiaRestrictionOutput;
    liaEmployments: LiaEmploymentOutput;
    liaInvoiceAddress: LiaInvoiceAddressDto;
    liaVaccination: LiaVaccinationOutputDto;
    liaSelfEmployment: EhcSelfEmploymentDto;
    liaEhcLanguageSkill: EhcLanguageSkillDto;
    liaElectronicPatientRecord: EhcElectronicPatientRecordDto;
    liaPractice: LiaPracticeDto;
    liaQualityRequirement: EhcQualityRequirementDto;
    liaEmploymentOrPostgraduateTitles: EhcEmploymentOrPostgraduateTitleDto[] | undefined;
    liaProfessionalResponsibilityOutput: LiaProfessionalResponsibilityOutput;
    liaTherapyMethod: LiaTherapyMethodDto;
    liaDocuments: GeneralDocumentGroupDto[] | undefined;
    numberOfLinkedEhcApplications: number;
    statusOfLinkedApplications: ApplicationStatus[] | undefined;
}

export class ApplicationEmploymentPersonDto implements IApplicationEmploymentPersonDto {
    employmentId!: number | undefined;
    expenseHealthCareCorporateLicenceEmploymentId!: number | undefined;
    gln!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    professionId!: string | undefined;
    id!: number;

    constructor(data?: IApplicationEmploymentPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employmentId = _data["employmentId"];
            this.expenseHealthCareCorporateLicenceEmploymentId = _data["expenseHealthCareCorporateLicenceEmploymentId"];
            this.gln = _data["gln"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.professionId = _data["professionId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationEmploymentPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationEmploymentPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employmentId"] = this.employmentId;
        data["expenseHealthCareCorporateLicenceEmploymentId"] = this.expenseHealthCareCorporateLicenceEmploymentId;
        data["gln"] = this.gln;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["professionId"] = this.professionId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationEmploymentPersonDto {
    employmentId: number | undefined;
    expenseHealthCareCorporateLicenceEmploymentId: number | undefined;
    gln: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    professionId: string | undefined;
    id: number;
}

export class CreateOrUpdateLiaEmploymentsInWaitingStatusOutput implements ICreateOrUpdateLiaEmploymentsInWaitingStatusOutput {
    ehcCaseId!: string | undefined;
    liaEmployments!: LiaEmploymentDto[] | undefined;
    liaMobileEmployment!: LiaMobileEmploymentDto;
    isNewInvoiceAddressRequired!: boolean;

    constructor(data?: ICreateOrUpdateLiaEmploymentsInWaitingStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ehcCaseId = _data["ehcCaseId"];
            if (Array.isArray(_data["liaEmployments"])) {
                this.liaEmployments = [] as any;
                for (let item of _data["liaEmployments"])
                    this.liaEmployments!.push(LiaEmploymentDto.fromJS(item));
            }
            this.liaMobileEmployment = _data["liaMobileEmployment"] ? LiaMobileEmploymentDto.fromJS(_data["liaMobileEmployment"]) : <any>undefined;
            this.isNewInvoiceAddressRequired = _data["isNewInvoiceAddressRequired"];
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaEmploymentsInWaitingStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaEmploymentsInWaitingStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ehcCaseId"] = this.ehcCaseId;
        if (Array.isArray(this.liaEmployments)) {
            data["liaEmployments"] = [];
            for (let item of this.liaEmployments)
                data["liaEmployments"].push(item.toJSON());
        }
        data["liaMobileEmployment"] = this.liaMobileEmployment ? this.liaMobileEmployment.toJSON() : <any>undefined;
        data["isNewInvoiceAddressRequired"] = this.isNewInvoiceAddressRequired;
        return data;
    }
}

export interface ICreateOrUpdateLiaEmploymentsInWaitingStatusOutput {
    ehcCaseId: string | undefined;
    liaEmployments: LiaEmploymentDto[] | undefined;
    liaMobileEmployment: LiaMobileEmploymentDto;
    isNewInvoiceAddressRequired: boolean;
}

export class CreateOrUpdateLiaEmploymentsInput implements ICreateOrUpdateLiaEmploymentsInput {
    caseId!: string;
    liaEmployments!: LiaEmploymentDto[] | undefined;
    mobileEmployment!: LiaMobileEmploymentDto;

    constructor(data?: ICreateOrUpdateLiaEmploymentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.mobileEmployment = new LiaMobileEmploymentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["liaEmployments"])) {
                this.liaEmployments = [] as any;
                for (let item of _data["liaEmployments"])
                    this.liaEmployments!.push(LiaEmploymentDto.fromJS(item));
            }
            this.mobileEmployment = _data["mobileEmployment"] ? LiaMobileEmploymentDto.fromJS(_data["mobileEmployment"]) : new LiaMobileEmploymentDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaEmploymentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaEmploymentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.liaEmployments)) {
            data["liaEmployments"] = [];
            for (let item of this.liaEmployments)
                data["liaEmployments"].push(item.toJSON());
        }
        data["mobileEmployment"] = this.mobileEmployment ? this.mobileEmployment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaEmploymentsInput {
    caseId: string;
    liaEmployments: LiaEmploymentDto[] | undefined;
    mobileEmployment: LiaMobileEmploymentDto;
}

export class CreateOrUpdateLiaEmploymentsOutput implements ICreateOrUpdateLiaEmploymentsOutput {
    status!: LiaStatus;
    liaEmployments!: LiaEmploymentDto[] | undefined;
    liaMobileEmployment!: LiaMobileEmploymentDto;

    constructor(data?: ICreateOrUpdateLiaEmploymentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["liaEmployments"])) {
                this.liaEmployments = [] as any;
                for (let item of _data["liaEmployments"])
                    this.liaEmployments!.push(LiaEmploymentDto.fromJS(item));
            }
            this.liaMobileEmployment = _data["liaMobileEmployment"] ? LiaMobileEmploymentDto.fromJS(_data["liaMobileEmployment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaEmploymentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaEmploymentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.liaEmployments)) {
            data["liaEmployments"] = [];
            for (let item of this.liaEmployments)
                data["liaEmployments"].push(item.toJSON());
        }
        data["liaMobileEmployment"] = this.liaMobileEmployment ? this.liaMobileEmployment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaEmploymentsOutput {
    status: LiaStatus;
    liaEmployments: LiaEmploymentDto[] | undefined;
    liaMobileEmployment: LiaMobileEmploymentDto;
}

export class EmploymentAddressDto implements IEmploymentAddressDto {
    employmentId!: number | undefined;
    expenseHealthCarePersonalLicenceEmploymentId!: number | undefined;
    statusId!: string | undefined;
    typeId!: string | undefined;
    businessName!: string | undefined;
    gln!: string | undefined;
    bur!: string | undefined;
    additionalName!: string | undefined;
    legalFormId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    postOfficeBox!: string | undefined;
    addressSupplement!: string | undefined;
    countryId!: string | undefined;
    phone!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    website!: string | undefined;
    dateOfOpening!: DateTime | undefined;
    dateOfClosure!: DateTime | undefined;
    businessHours!: string | undefined;
    medicalPracticeTakeoverDetails!: string | undefined;
    medicalGroupPracticeDetails!: string | undefined;
    comments!: string | undefined;
    id!: number;

    constructor(data?: IEmploymentAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employmentId = _data["employmentId"];
            this.expenseHealthCarePersonalLicenceEmploymentId = _data["expenseHealthCarePersonalLicenceEmploymentId"];
            this.statusId = _data["statusId"];
            this.typeId = _data["typeId"];
            this.businessName = _data["businessName"];
            this.gln = _data["gln"];
            this.bur = _data["bur"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressSupplement = _data["addressSupplement"];
            this.countryId = _data["countryId"];
            this.phone = _data["phone"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.dateOfClosure = _data["dateOfClosure"] ? DateTime.fromISO(_data["dateOfClosure"].toString()) : <any>undefined;
            this.businessHours = _data["businessHours"];
            this.medicalPracticeTakeoverDetails = _data["medicalPracticeTakeoverDetails"];
            this.medicalGroupPracticeDetails = _data["medicalGroupPracticeDetails"];
            this.comments = _data["comments"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmploymentAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employmentId"] = this.employmentId;
        data["expenseHealthCarePersonalLicenceEmploymentId"] = this.expenseHealthCarePersonalLicenceEmploymentId;
        data["statusId"] = this.statusId;
        data["typeId"] = this.typeId;
        data["businessName"] = this.businessName;
        data["gln"] = this.gln;
        data["bur"] = this.bur;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressSupplement"] = this.addressSupplement;
        data["countryId"] = this.countryId;
        data["phone"] = this.phone;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["website"] = this.website;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfClosure"] = this.dateOfClosure ? this.dateOfClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessHours"] = this.businessHours;
        data["medicalPracticeTakeoverDetails"] = this.medicalPracticeTakeoverDetails;
        data["medicalGroupPracticeDetails"] = this.medicalGroupPracticeDetails;
        data["comments"] = this.comments;
        data["id"] = this.id;
        return data;
    }
}

export interface IEmploymentAddressDto {
    employmentId: number | undefined;
    expenseHealthCarePersonalLicenceEmploymentId: number | undefined;
    statusId: string | undefined;
    typeId: string | undefined;
    businessName: string | undefined;
    gln: string | undefined;
    bur: string | undefined;
    additionalName: string | undefined;
    legalFormId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    postOfficeBox: string | undefined;
    addressSupplement: string | undefined;
    countryId: string | undefined;
    phone: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    website: string | undefined;
    dateOfOpening: DateTime | undefined;
    dateOfClosure: DateTime | undefined;
    businessHours: string | undefined;
    medicalPracticeTakeoverDetails: string | undefined;
    medicalGroupPracticeDetails: string | undefined;
    comments: string | undefined;
    id: number;
}

export class LiaEmploymentDto implements ILiaEmploymentDto {
    id!: number | undefined;
    typeId!: string | undefined;
    businessName!: string;
    legalFormId!: string;
    street!: string;
    streetNr!: string | undefined;
    postCode!: string;
    city!: string;
    postOfficeBox!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    phone!: string;
    email!: string;
    dateOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    isMarkedForEhc!: boolean;

    constructor(data?: ILiaEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeId = _data["typeId"];
            this.businessName = _data["businessName"];
            this.legalFormId = _data["legalFormId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.isMarkedForEhc = _data["isMarkedForEhc"];
        }
    }

    static fromJS(data: any): LiaEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        data["businessName"] = this.businessName;
        data["legalFormId"] = this.legalFormId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["isMarkedForEhc"] = this.isMarkedForEhc;
        return data;
    }
}

export interface ILiaEmploymentDto {
    id: number | undefined;
    typeId: string | undefined;
    businessName: string;
    legalFormId: string;
    street: string;
    streetNr: string | undefined;
    postCode: string;
    city: string;
    postOfficeBox: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    phone: string;
    email: string;
    dateOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    isMarkedForEhc: boolean;
}

export class LiaEmploymentOutput implements ILiaEmploymentOutput {
    employments!: LiaEmploymentDto[] | undefined;
    mobileEmployment!: LiaMobileEmploymentDto;
    employmentDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaEmploymentOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(LiaEmploymentDto.fromJS(item));
            }
            this.mobileEmployment = _data["mobileEmployment"] ? LiaMobileEmploymentDto.fromJS(_data["mobileEmployment"]) : <any>undefined;
            if (Array.isArray(_data["employmentDocuments"])) {
                this.employmentDocuments = [] as any;
                for (let item of _data["employmentDocuments"])
                    this.employmentDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaEmploymentOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LiaEmploymentOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        data["mobileEmployment"] = this.mobileEmployment ? this.mobileEmployment.toJSON() : <any>undefined;
        if (Array.isArray(this.employmentDocuments)) {
            data["employmentDocuments"] = [];
            for (let item of this.employmentDocuments)
                data["employmentDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaEmploymentOutput {
    employments: LiaEmploymentDto[] | undefined;
    mobileEmployment: LiaMobileEmploymentDto;
    employmentDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class LiaMobileEmploymentDto implements ILiaMobileEmploymentDto {
    hasMobileEmployment!: boolean;
    startDateOfMobileEmployment!: DateTime | undefined;
    levelOfMobileEmployment!: number | undefined;
    kindIdOfMobileEmployment!: string | undefined;

    constructor(data?: ILiaMobileEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasMobileEmployment = _data["hasMobileEmployment"];
            this.startDateOfMobileEmployment = _data["startDateOfMobileEmployment"] ? DateTime.fromISO(_data["startDateOfMobileEmployment"].toString()) : <any>undefined;
            this.levelOfMobileEmployment = _data["levelOfMobileEmployment"];
            this.kindIdOfMobileEmployment = _data["kindIdOfMobileEmployment"];
        }
    }

    static fromJS(data: any): LiaMobileEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaMobileEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasMobileEmployment"] = this.hasMobileEmployment;
        data["startDateOfMobileEmployment"] = this.startDateOfMobileEmployment ? this.startDateOfMobileEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfMobileEmployment"] = this.levelOfMobileEmployment;
        data["kindIdOfMobileEmployment"] = this.kindIdOfMobileEmployment;
        return data;
    }
}

export interface ILiaMobileEmploymentDto {
    hasMobileEmployment: boolean;
    startDateOfMobileEmployment: DateTime | undefined;
    levelOfMobileEmployment: number | undefined;
    kindIdOfMobileEmployment: string | undefined;
}

export class CreateOrUpdateLiaEmploymentOrPostgraduateTitlesOutput implements ICreateOrUpdateLiaEmploymentOrPostgraduateTitlesOutput {
    status!: LiaStatus;
    ehcEmploymentOrPostgraduateTitles!: EhcEmploymentOrPostgraduateTitleDto[] | undefined;

    constructor(data?: ICreateOrUpdateLiaEmploymentOrPostgraduateTitlesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["ehcEmploymentOrPostgraduateTitles"])) {
                this.ehcEmploymentOrPostgraduateTitles = [] as any;
                for (let item of _data["ehcEmploymentOrPostgraduateTitles"])
                    this.ehcEmploymentOrPostgraduateTitles!.push(EhcEmploymentOrPostgraduateTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaEmploymentOrPostgraduateTitlesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaEmploymentOrPostgraduateTitlesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.ehcEmploymentOrPostgraduateTitles)) {
            data["ehcEmploymentOrPostgraduateTitles"] = [];
            for (let item of this.ehcEmploymentOrPostgraduateTitles)
                data["ehcEmploymentOrPostgraduateTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateLiaEmploymentOrPostgraduateTitlesOutput {
    status: LiaStatus;
    ehcEmploymentOrPostgraduateTitles: EhcEmploymentOrPostgraduateTitleDto[] | undefined;
}

export class CreateOrUpdateLiaInvoiceAddressInput implements ICreateOrUpdateLiaInvoiceAddressInput {
    caseId!: string;
    liaInvoiceAddress!: LiaInvoiceAddressDto;

    constructor(data?: ICreateOrUpdateLiaInvoiceAddressInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaInvoiceAddress = new LiaInvoiceAddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.liaInvoiceAddress = _data["liaInvoiceAddress"] ? LiaInvoiceAddressDto.fromJS(_data["liaInvoiceAddress"]) : new LiaInvoiceAddressDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaInvoiceAddressInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaInvoiceAddressInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["liaInvoiceAddress"] = this.liaInvoiceAddress ? this.liaInvoiceAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaInvoiceAddressInput {
    caseId: string;
    liaInvoiceAddress: LiaInvoiceAddressDto;
}

export class LiaInvoiceAddressDto implements ILiaInvoiceAddressDto {
    typeOfAddressId!: string | undefined;
    name!: string | undefined;
    title!: Code;
    titleId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    liaEmploymentId!: number | undefined;
    addressAddition!: string | undefined;
    completionStatus!: CompletionStatus;

    constructor(data?: ILiaInvoiceAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeOfAddressId = _data["typeOfAddressId"];
            this.name = _data["name"];
            this.title = _data["title"] ? Code.fromJS(_data["title"]) : <any>undefined;
            this.titleId = _data["titleId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.liaEmploymentId = _data["liaEmploymentId"];
            this.addressAddition = _data["addressAddition"];
            this.completionStatus = _data["completionStatus"];
        }
    }

    static fromJS(data: any): LiaInvoiceAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaInvoiceAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOfAddressId"] = this.typeOfAddressId;
        data["name"] = this.name;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["titleId"] = this.titleId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["liaEmploymentId"] = this.liaEmploymentId;
        data["addressAddition"] = this.addressAddition;
        data["completionStatus"] = this.completionStatus;
        return data;
    }
}

export interface ILiaInvoiceAddressDto {
    typeOfAddressId: string | undefined;
    name: string | undefined;
    title: Code;
    titleId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    liaEmploymentId: number | undefined;
    addressAddition: string | undefined;
    completionStatus: CompletionStatus;
}

export class CreateOrUpdateLiaLanguageSkillInput implements ICreateOrUpdateLiaLanguageSkillInput {
    caseId!: string | undefined;
    liaLanguageSkill!: LiaLanguageSkillDto;

    constructor(data?: ICreateOrUpdateLiaLanguageSkillInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.liaLanguageSkill = _data["liaLanguageSkill"] ? LiaLanguageSkillDto.fromJS(_data["liaLanguageSkill"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaLanguageSkillInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaLanguageSkillInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["liaLanguageSkill"] = this.liaLanguageSkill ? this.liaLanguageSkill.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaLanguageSkillInput {
    caseId: string | undefined;
    liaLanguageSkill: LiaLanguageSkillDto;
}

export class LiaLanguageSkillDto implements ILiaLanguageSkillDto {
    languageSkillId!: string;
    educationLanguageId!: string | undefined;
    comments!: string | undefined;
    languageSkillDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaLanguageSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageSkillId = _data["languageSkillId"];
            this.educationLanguageId = _data["educationLanguageId"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["languageSkillDocuments"])) {
                this.languageSkillDocuments = [] as any;
                for (let item of _data["languageSkillDocuments"])
                    this.languageSkillDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaLanguageSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaLanguageSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageSkillId"] = this.languageSkillId;
        data["educationLanguageId"] = this.educationLanguageId;
        data["comments"] = this.comments;
        if (Array.isArray(this.languageSkillDocuments)) {
            data["languageSkillDocuments"] = [];
            for (let item of this.languageSkillDocuments)
                data["languageSkillDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaLanguageSkillDto {
    languageSkillId: string;
    educationLanguageId: string | undefined;
    comments: string | undefined;
    languageSkillDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class LiaAcademicTitle implements ILiaAcademicTitle {
    id!: string;
    liaApplication!: LiaApplication;
    liaApplicationId!: number;
    title!: string | undefined;
    bodyOfIssue!: string | undefined;
    placeOfIssue!: string | undefined;
    country!: Code;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    liaAcademicTitleDocuments!: LiaAcademicTitleDocument[] | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;

    constructor(data?: ILiaAcademicTitle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : <any>undefined;
            this.liaApplicationId = _data["liaApplicationId"];
            this.title = _data["title"];
            this.bodyOfIssue = _data["bodyOfIssue"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.country = _data["country"] ? Code.fromJS(_data["country"]) : <any>undefined;
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            if (Array.isArray(_data["liaAcademicTitleDocuments"])) {
                this.liaAcademicTitleDocuments = [] as any;
                for (let item of _data["liaAcademicTitleDocuments"])
                    this.liaAcademicTitleDocuments!.push(LiaAcademicTitleDocument.fromJS(item));
            }
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): LiaAcademicTitle {
        data = typeof data === 'object' ? data : {};
        let result = new LiaAcademicTitle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["liaApplicationId"] = this.liaApplicationId;
        data["title"] = this.title;
        data["bodyOfIssue"] = this.bodyOfIssue;
        data["placeOfIssue"] = this.placeOfIssue;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.liaAcademicTitleDocuments)) {
            data["liaAcademicTitleDocuments"] = [];
            for (let item of this.liaAcademicTitleDocuments)
                data["liaAcademicTitleDocuments"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data;
    }
}

export interface ILiaAcademicTitle {
    id: string;
    liaApplication: LiaApplication;
    liaApplicationId: number;
    title: string | undefined;
    bodyOfIssue: string | undefined;
    placeOfIssue: string | undefined;
    country: Code;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    liaAcademicTitleDocuments: LiaAcademicTitleDocument[] | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
}

export class LiaAcademicTitleDocument implements ILiaAcademicTitleDocument {
    liaAcademicTitle!: LiaAcademicTitle;
    liaAcademicTitleId!: string;
    liaApplication!: LiaApplication;
    liaApplicationId!: number;
    step!: LiaStatus;
    type!: Code;
    typeId!: string | undefined;
    name!: string | undefined;
    mimeHeader!: string | undefined;
    binaryObject!: BinaryObject;
    binaryObjectId!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaAcademicTitleDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaAcademicTitle = new LiaAcademicTitle();
            this.liaApplication = new LiaApplication();
            this.type = new Code();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaAcademicTitle = _data["liaAcademicTitle"] ? LiaAcademicTitle.fromJS(_data["liaAcademicTitle"]) : new LiaAcademicTitle();
            this.liaAcademicTitleId = _data["liaAcademicTitleId"];
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : new LiaApplication();
            this.liaApplicationId = _data["liaApplicationId"];
            this.step = _data["step"];
            this.type = _data["type"] ? Code.fromJS(_data["type"]) : new Code();
            this.typeId = _data["typeId"];
            this.name = _data["name"];
            this.mimeHeader = _data["mimeHeader"];
            this.binaryObject = _data["binaryObject"] ? BinaryObject.fromJS(_data["binaryObject"]) : <any>undefined;
            this.binaryObjectId = _data["binaryObjectId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaAcademicTitleDocument {
        data = typeof data === 'object' ? data : {};
        let result = new LiaAcademicTitleDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaAcademicTitle"] = this.liaAcademicTitle ? this.liaAcademicTitle.toJSON() : <any>undefined;
        data["liaAcademicTitleId"] = this.liaAcademicTitleId;
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["liaApplicationId"] = this.liaApplicationId;
        data["step"] = this.step;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["name"] = this.name;
        data["mimeHeader"] = this.mimeHeader;
        data["binaryObject"] = this.binaryObject ? this.binaryObject.toJSON() : <any>undefined;
        data["binaryObjectId"] = this.binaryObjectId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaAcademicTitleDocument {
    liaAcademicTitle: LiaAcademicTitle;
    liaAcademicTitleId: string;
    liaApplication: LiaApplication;
    liaApplicationId: number;
    step: LiaStatus;
    type: Code;
    typeId: string | undefined;
    name: string | undefined;
    mimeHeader: string | undefined;
    binaryObject: BinaryObject;
    binaryObjectId: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LiaApplication implements ILiaApplication {
    application!: Application;
    applicationVerifications!: ApplicationVerification[] | undefined;
    liaPerson!: LiaPerson;
    liaContact!: LiaContact;
    liaRestrictions!: LiaRestriction[] | undefined;
    liaRestrictionGeneralInformation!: LiaRestrictionGeneralInformation;
    liaInvoiceAddress!: LiaInvoiceAddress;
    liaDocuments!: LiaDocument[] | undefined;
    liaResultDocuments!: LiaResultDocument[] | undefined;
    liaLanguageSkill!: LiaLanguageSkill;
    liaEhcLanguageSkill!: LiaEhcLanguageSkill;
    liaPractice!: LiaPractice;
    liaElectronicPatientRecord!: LiaElectronicPatientRecord;
    liaQualityRequirement!: LiaQualityRequirement;
    liaEmploymentOrPostgraduateTitles!: LiaEmploymentOrPostgraduateTitle[] | undefined;
    liaAcademicTitles!: LiaAcademicTitle[] | undefined;
    liaVaccination!: LiaVaccination;
    liaEmployments!: LiaEmployment[] | undefined;
    liaMobileEmployment!: LiaMobileEmployment;
    liaSelfEmployment!: LiaSelfEmployment;
    liaTherapyMethod!: LiaTherapyMethod;
    profession!: Code;
    professionId!: string | undefined;
    status!: LiaStatus;
    ehcConfirmation!: Code;
    ehcConfirmationId!: string | undefined;
    dateOfDeleteNotification!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.profession = new Code();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : <any>undefined;
            if (Array.isArray(_data["applicationVerifications"])) {
                this.applicationVerifications = [] as any;
                for (let item of _data["applicationVerifications"])
                    this.applicationVerifications!.push(ApplicationVerification.fromJS(item));
            }
            this.liaPerson = _data["liaPerson"] ? LiaPerson.fromJS(_data["liaPerson"]) : <any>undefined;
            this.liaContact = _data["liaContact"] ? LiaContact.fromJS(_data["liaContact"]) : <any>undefined;
            if (Array.isArray(_data["liaRestrictions"])) {
                this.liaRestrictions = [] as any;
                for (let item of _data["liaRestrictions"])
                    this.liaRestrictions!.push(LiaRestriction.fromJS(item));
            }
            this.liaRestrictionGeneralInformation = _data["liaRestrictionGeneralInformation"] ? LiaRestrictionGeneralInformation.fromJS(_data["liaRestrictionGeneralInformation"]) : <any>undefined;
            this.liaInvoiceAddress = _data["liaInvoiceAddress"] ? LiaInvoiceAddress.fromJS(_data["liaInvoiceAddress"]) : <any>undefined;
            if (Array.isArray(_data["liaDocuments"])) {
                this.liaDocuments = [] as any;
                for (let item of _data["liaDocuments"])
                    this.liaDocuments!.push(LiaDocument.fromJS(item));
            }
            if (Array.isArray(_data["liaResultDocuments"])) {
                this.liaResultDocuments = [] as any;
                for (let item of _data["liaResultDocuments"])
                    this.liaResultDocuments!.push(LiaResultDocument.fromJS(item));
            }
            this.liaLanguageSkill = _data["liaLanguageSkill"] ? LiaLanguageSkill.fromJS(_data["liaLanguageSkill"]) : <any>undefined;
            this.liaEhcLanguageSkill = _data["liaEhcLanguageSkill"] ? LiaEhcLanguageSkill.fromJS(_data["liaEhcLanguageSkill"]) : <any>undefined;
            this.liaPractice = _data["liaPractice"] ? LiaPractice.fromJS(_data["liaPractice"]) : <any>undefined;
            this.liaElectronicPatientRecord = _data["liaElectronicPatientRecord"] ? LiaElectronicPatientRecord.fromJS(_data["liaElectronicPatientRecord"]) : <any>undefined;
            this.liaQualityRequirement = _data["liaQualityRequirement"] ? LiaQualityRequirement.fromJS(_data["liaQualityRequirement"]) : <any>undefined;
            if (Array.isArray(_data["liaEmploymentOrPostgraduateTitles"])) {
                this.liaEmploymentOrPostgraduateTitles = [] as any;
                for (let item of _data["liaEmploymentOrPostgraduateTitles"])
                    this.liaEmploymentOrPostgraduateTitles!.push(LiaEmploymentOrPostgraduateTitle.fromJS(item));
            }
            if (Array.isArray(_data["liaAcademicTitles"])) {
                this.liaAcademicTitles = [] as any;
                for (let item of _data["liaAcademicTitles"])
                    this.liaAcademicTitles!.push(LiaAcademicTitle.fromJS(item));
            }
            this.liaVaccination = _data["liaVaccination"] ? LiaVaccination.fromJS(_data["liaVaccination"]) : <any>undefined;
            if (Array.isArray(_data["liaEmployments"])) {
                this.liaEmployments = [] as any;
                for (let item of _data["liaEmployments"])
                    this.liaEmployments!.push(LiaEmployment.fromJS(item));
            }
            this.liaMobileEmployment = _data["liaMobileEmployment"] ? LiaMobileEmployment.fromJS(_data["liaMobileEmployment"]) : <any>undefined;
            this.liaSelfEmployment = _data["liaSelfEmployment"] ? LiaSelfEmployment.fromJS(_data["liaSelfEmployment"]) : <any>undefined;
            this.liaTherapyMethod = _data["liaTherapyMethod"] ? LiaTherapyMethod.fromJS(_data["liaTherapyMethod"]) : <any>undefined;
            this.profession = _data["profession"] ? Code.fromJS(_data["profession"]) : new Code();
            this.professionId = _data["professionId"];
            this.status = _data["status"];
            this.ehcConfirmation = _data["ehcConfirmation"] ? Code.fromJS(_data["ehcConfirmation"]) : <any>undefined;
            this.ehcConfirmationId = _data["ehcConfirmationId"];
            this.dateOfDeleteNotification = _data["dateOfDeleteNotification"] ? DateTime.fromISO(_data["dateOfDeleteNotification"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaApplication {
        data = typeof data === 'object' ? data : {};
        let result = new LiaApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        if (Array.isArray(this.applicationVerifications)) {
            data["applicationVerifications"] = [];
            for (let item of this.applicationVerifications)
                data["applicationVerifications"].push(item.toJSON());
        }
        data["liaPerson"] = this.liaPerson ? this.liaPerson.toJSON() : <any>undefined;
        data["liaContact"] = this.liaContact ? this.liaContact.toJSON() : <any>undefined;
        if (Array.isArray(this.liaRestrictions)) {
            data["liaRestrictions"] = [];
            for (let item of this.liaRestrictions)
                data["liaRestrictions"].push(item.toJSON());
        }
        data["liaRestrictionGeneralInformation"] = this.liaRestrictionGeneralInformation ? this.liaRestrictionGeneralInformation.toJSON() : <any>undefined;
        data["liaInvoiceAddress"] = this.liaInvoiceAddress ? this.liaInvoiceAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.liaDocuments)) {
            data["liaDocuments"] = [];
            for (let item of this.liaDocuments)
                data["liaDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.liaResultDocuments)) {
            data["liaResultDocuments"] = [];
            for (let item of this.liaResultDocuments)
                data["liaResultDocuments"].push(item.toJSON());
        }
        data["liaLanguageSkill"] = this.liaLanguageSkill ? this.liaLanguageSkill.toJSON() : <any>undefined;
        data["liaEhcLanguageSkill"] = this.liaEhcLanguageSkill ? this.liaEhcLanguageSkill.toJSON() : <any>undefined;
        data["liaPractice"] = this.liaPractice ? this.liaPractice.toJSON() : <any>undefined;
        data["liaElectronicPatientRecord"] = this.liaElectronicPatientRecord ? this.liaElectronicPatientRecord.toJSON() : <any>undefined;
        data["liaQualityRequirement"] = this.liaQualityRequirement ? this.liaQualityRequirement.toJSON() : <any>undefined;
        if (Array.isArray(this.liaEmploymentOrPostgraduateTitles)) {
            data["liaEmploymentOrPostgraduateTitles"] = [];
            for (let item of this.liaEmploymentOrPostgraduateTitles)
                data["liaEmploymentOrPostgraduateTitles"].push(item.toJSON());
        }
        if (Array.isArray(this.liaAcademicTitles)) {
            data["liaAcademicTitles"] = [];
            for (let item of this.liaAcademicTitles)
                data["liaAcademicTitles"].push(item.toJSON());
        }
        data["liaVaccination"] = this.liaVaccination ? this.liaVaccination.toJSON() : <any>undefined;
        if (Array.isArray(this.liaEmployments)) {
            data["liaEmployments"] = [];
            for (let item of this.liaEmployments)
                data["liaEmployments"].push(item.toJSON());
        }
        data["liaMobileEmployment"] = this.liaMobileEmployment ? this.liaMobileEmployment.toJSON() : <any>undefined;
        data["liaSelfEmployment"] = this.liaSelfEmployment ? this.liaSelfEmployment.toJSON() : <any>undefined;
        data["liaTherapyMethod"] = this.liaTherapyMethod ? this.liaTherapyMethod.toJSON() : <any>undefined;
        data["profession"] = this.profession ? this.profession.toJSON() : <any>undefined;
        data["professionId"] = this.professionId;
        data["status"] = this.status;
        data["ehcConfirmation"] = this.ehcConfirmation ? this.ehcConfirmation.toJSON() : <any>undefined;
        data["ehcConfirmationId"] = this.ehcConfirmationId;
        data["dateOfDeleteNotification"] = this.dateOfDeleteNotification ? this.dateOfDeleteNotification.toFormat('yyyy-MM-dd') : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaApplication {
    application: Application;
    applicationVerifications: ApplicationVerification[] | undefined;
    liaPerson: LiaPerson;
    liaContact: LiaContact;
    liaRestrictions: LiaRestriction[] | undefined;
    liaRestrictionGeneralInformation: LiaRestrictionGeneralInformation;
    liaInvoiceAddress: LiaInvoiceAddress;
    liaDocuments: LiaDocument[] | undefined;
    liaResultDocuments: LiaResultDocument[] | undefined;
    liaLanguageSkill: LiaLanguageSkill;
    liaEhcLanguageSkill: LiaEhcLanguageSkill;
    liaPractice: LiaPractice;
    liaElectronicPatientRecord: LiaElectronicPatientRecord;
    liaQualityRequirement: LiaQualityRequirement;
    liaEmploymentOrPostgraduateTitles: LiaEmploymentOrPostgraduateTitle[] | undefined;
    liaAcademicTitles: LiaAcademicTitle[] | undefined;
    liaVaccination: LiaVaccination;
    liaEmployments: LiaEmployment[] | undefined;
    liaMobileEmployment: LiaMobileEmployment;
    liaSelfEmployment: LiaSelfEmployment;
    liaTherapyMethod: LiaTherapyMethod;
    profession: Code;
    professionId: string | undefined;
    status: LiaStatus;
    ehcConfirmation: Code;
    ehcConfirmationId: string | undefined;
    dateOfDeleteNotification: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LiaContact implements ILiaContact {
    liaApplication!: LiaApplication;
    title!: Code;
    titleId!: string | undefined;
    languageOfCorrespondence!: Code;
    languageOfCorrespondenceId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    email!: string | undefined;
    email2!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    country!: Code;
    countryId!: string | undefined;
    titleAddressSwiss!: string | undefined;
    streetSwiss!: string | undefined;
    streetNrSwiss!: string | undefined;
    postCodeSwiss!: string | undefined;
    citySwiss!: string | undefined;
    postOfficeBoxSwiss!: string | undefined;
    addressAdditionSwiss!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : <any>undefined;
            this.title = _data["title"] ? Code.fromJS(_data["title"]) : <any>undefined;
            this.titleId = _data["titleId"];
            this.languageOfCorrespondence = _data["languageOfCorrespondence"] ? Code.fromJS(_data["languageOfCorrespondence"]) : <any>undefined;
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.country = _data["country"] ? Code.fromJS(_data["country"]) : <any>undefined;
            this.countryId = _data["countryId"];
            this.titleAddressSwiss = _data["titleAddressSwiss"];
            this.streetSwiss = _data["streetSwiss"];
            this.streetNrSwiss = _data["streetNrSwiss"];
            this.postCodeSwiss = _data["postCodeSwiss"];
            this.citySwiss = _data["citySwiss"];
            this.postOfficeBoxSwiss = _data["postOfficeBoxSwiss"];
            this.addressAdditionSwiss = _data["addressAdditionSwiss"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaContact {
        data = typeof data === 'object' ? data : {};
        let result = new LiaContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["titleId"] = this.titleId;
        data["languageOfCorrespondence"] = this.languageOfCorrespondence ? this.languageOfCorrespondence.toJSON() : <any>undefined;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["countryId"] = this.countryId;
        data["titleAddressSwiss"] = this.titleAddressSwiss;
        data["streetSwiss"] = this.streetSwiss;
        data["streetNrSwiss"] = this.streetNrSwiss;
        data["postCodeSwiss"] = this.postCodeSwiss;
        data["citySwiss"] = this.citySwiss;
        data["postOfficeBoxSwiss"] = this.postOfficeBoxSwiss;
        data["addressAdditionSwiss"] = this.addressAdditionSwiss;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaContact {
    liaApplication: LiaApplication;
    title: Code;
    titleId: string | undefined;
    languageOfCorrespondence: Code;
    languageOfCorrespondenceId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    email: string | undefined;
    email2: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    country: Code;
    countryId: string | undefined;
    titleAddressSwiss: string | undefined;
    streetSwiss: string | undefined;
    streetNrSwiss: string | undefined;
    postCodeSwiss: string | undefined;
    citySwiss: string | undefined;
    postOfficeBoxSwiss: string | undefined;
    addressAdditionSwiss: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LiaDocument implements ILiaDocument {
    liaApplication!: LiaApplication;
    liaApplicationId!: number;
    step!: LiaStatus;
    type!: Code;
    typeId!: string | undefined;
    name!: string | undefined;
    mimeHeader!: string | undefined;
    binaryObject!: BinaryObject;
    binaryObjectId!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaApplication = new LiaApplication();
            this.type = new Code();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : new LiaApplication();
            this.liaApplicationId = _data["liaApplicationId"];
            this.step = _data["step"];
            this.type = _data["type"] ? Code.fromJS(_data["type"]) : new Code();
            this.typeId = _data["typeId"];
            this.name = _data["name"];
            this.mimeHeader = _data["mimeHeader"];
            this.binaryObject = _data["binaryObject"] ? BinaryObject.fromJS(_data["binaryObject"]) : <any>undefined;
            this.binaryObjectId = _data["binaryObjectId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaDocument {
        data = typeof data === 'object' ? data : {};
        let result = new LiaDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["liaApplicationId"] = this.liaApplicationId;
        data["step"] = this.step;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["name"] = this.name;
        data["mimeHeader"] = this.mimeHeader;
        data["binaryObject"] = this.binaryObject ? this.binaryObject.toJSON() : <any>undefined;
        data["binaryObjectId"] = this.binaryObjectId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaDocument {
    liaApplication: LiaApplication;
    liaApplicationId: number;
    step: LiaStatus;
    type: Code;
    typeId: string | undefined;
    name: string | undefined;
    mimeHeader: string | undefined;
    binaryObject: BinaryObject;
    binaryObjectId: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LiaEhcLanguageSkill implements ILiaEhcLanguageSkill {
    liaApplication!: LiaApplication;
    hasHighSchoolDiplomaOfLanguageOfActivityRegionId!: string | undefined;
    hasPhysicianDiplomaOfLanguageOfActivityRegionId!: string | undefined;
    comments!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaEhcLanguageSkill) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : <any>undefined;
            this.hasHighSchoolDiplomaOfLanguageOfActivityRegionId = _data["hasHighSchoolDiplomaOfLanguageOfActivityRegionId"];
            this.hasPhysicianDiplomaOfLanguageOfActivityRegionId = _data["hasPhysicianDiplomaOfLanguageOfActivityRegionId"];
            this.comments = _data["comments"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaEhcLanguageSkill {
        data = typeof data === 'object' ? data : {};
        let result = new LiaEhcLanguageSkill();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["hasHighSchoolDiplomaOfLanguageOfActivityRegionId"] = this.hasHighSchoolDiplomaOfLanguageOfActivityRegionId;
        data["hasPhysicianDiplomaOfLanguageOfActivityRegionId"] = this.hasPhysicianDiplomaOfLanguageOfActivityRegionId;
        data["comments"] = this.comments;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaEhcLanguageSkill {
    liaApplication: LiaApplication;
    hasHighSchoolDiplomaOfLanguageOfActivityRegionId: string | undefined;
    hasPhysicianDiplomaOfLanguageOfActivityRegionId: string | undefined;
    comments: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LiaElectronicPatientRecord implements ILiaElectronicPatientRecord {
    liaApplication!: LiaApplication;
    membershipInCertifiedCommunity!: Code;
    membershipInCertifiedCommunityId!: string | undefined;
    membershipNoneReason!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaElectronicPatientRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : <any>undefined;
            this.membershipInCertifiedCommunity = _data["membershipInCertifiedCommunity"] ? Code.fromJS(_data["membershipInCertifiedCommunity"]) : <any>undefined;
            this.membershipInCertifiedCommunityId = _data["membershipInCertifiedCommunityId"];
            this.membershipNoneReason = _data["membershipNoneReason"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaElectronicPatientRecord {
        data = typeof data === 'object' ? data : {};
        let result = new LiaElectronicPatientRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["membershipInCertifiedCommunity"] = this.membershipInCertifiedCommunity ? this.membershipInCertifiedCommunity.toJSON() : <any>undefined;
        data["membershipInCertifiedCommunityId"] = this.membershipInCertifiedCommunityId;
        data["membershipNoneReason"] = this.membershipNoneReason;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaElectronicPatientRecord {
    liaApplication: LiaApplication;
    membershipInCertifiedCommunity: Code;
    membershipInCertifiedCommunityId: string | undefined;
    membershipNoneReason: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LiaEmployment implements ILiaEmployment {
    liaApplication!: LiaApplication;
    liaApplicationId!: number;
    type!: Code;
    typeId!: string | undefined;
    businessName!: string | undefined;
    legalForm!: Code;
    legalFormId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    postOfficeBox!: string | undefined;
    languageOfCorrespondence!: Code;
    languageOfCorrespondenceId!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    isStationary!: boolean | undefined;
    startDateOfStationaryEmployment!: DateTime | undefined;
    levelOfStationaryEmployment!: number | undefined;
    isSpitalAmbulatory!: boolean | undefined;
    startDateOfSpitalAmbulatoryEmployment!: DateTime | undefined;
    levelOfSpitalAmbulatoryEmployment!: number | undefined;
    isDoctorsOfficeAmbulatory!: boolean | undefined;
    startDateOfDoctorsOfficeAmbulatoryEmployment!: DateTime | undefined;
    levelOfDoctorsOfficeAmbulatoryEmployment!: number | undefined;
    website!: string | undefined;
    practiceEstablishmentType!: Code;
    practiceEstablishmentTypeId!: string | undefined;
    practiceEstablishmentTypeDetails!: string | undefined;
    doesAmbulatoryWork!: Code;
    doesAmbulatoryWorkId!: string | undefined;
    doesAmbulatoryWorkDetails!: string | undefined;
    professionalRoleType!: Code;
    professionalRoleTypeId!: string | undefined;
    nursingWorkplaceType!: Code;
    nursingWorkplaceTypeId!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaEmployment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : <any>undefined;
            this.liaApplicationId = _data["liaApplicationId"];
            this.type = _data["type"] ? Code.fromJS(_data["type"]) : <any>undefined;
            this.typeId = _data["typeId"];
            this.businessName = _data["businessName"];
            this.legalForm = _data["legalForm"] ? Code.fromJS(_data["legalForm"]) : <any>undefined;
            this.legalFormId = _data["legalFormId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.languageOfCorrespondence = _data["languageOfCorrespondence"] ? Code.fromJS(_data["languageOfCorrespondence"]) : <any>undefined;
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.isStationary = _data["isStationary"];
            this.startDateOfStationaryEmployment = _data["startDateOfStationaryEmployment"] ? DateTime.fromISO(_data["startDateOfStationaryEmployment"].toString()) : <any>undefined;
            this.levelOfStationaryEmployment = _data["levelOfStationaryEmployment"];
            this.isSpitalAmbulatory = _data["isSpitalAmbulatory"];
            this.startDateOfSpitalAmbulatoryEmployment = _data["startDateOfSpitalAmbulatoryEmployment"] ? DateTime.fromISO(_data["startDateOfSpitalAmbulatoryEmployment"].toString()) : <any>undefined;
            this.levelOfSpitalAmbulatoryEmployment = _data["levelOfSpitalAmbulatoryEmployment"];
            this.isDoctorsOfficeAmbulatory = _data["isDoctorsOfficeAmbulatory"];
            this.startDateOfDoctorsOfficeAmbulatoryEmployment = _data["startDateOfDoctorsOfficeAmbulatoryEmployment"] ? DateTime.fromISO(_data["startDateOfDoctorsOfficeAmbulatoryEmployment"].toString()) : <any>undefined;
            this.levelOfDoctorsOfficeAmbulatoryEmployment = _data["levelOfDoctorsOfficeAmbulatoryEmployment"];
            this.website = _data["website"];
            this.practiceEstablishmentType = _data["practiceEstablishmentType"] ? Code.fromJS(_data["practiceEstablishmentType"]) : <any>undefined;
            this.practiceEstablishmentTypeId = _data["practiceEstablishmentTypeId"];
            this.practiceEstablishmentTypeDetails = _data["practiceEstablishmentTypeDetails"];
            this.doesAmbulatoryWork = _data["doesAmbulatoryWork"] ? Code.fromJS(_data["doesAmbulatoryWork"]) : <any>undefined;
            this.doesAmbulatoryWorkId = _data["doesAmbulatoryWorkId"];
            this.doesAmbulatoryWorkDetails = _data["doesAmbulatoryWorkDetails"];
            this.professionalRoleType = _data["professionalRoleType"] ? Code.fromJS(_data["professionalRoleType"]) : <any>undefined;
            this.professionalRoleTypeId = _data["professionalRoleTypeId"];
            this.nursingWorkplaceType = _data["nursingWorkplaceType"] ? Code.fromJS(_data["nursingWorkplaceType"]) : <any>undefined;
            this.nursingWorkplaceTypeId = _data["nursingWorkplaceTypeId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaEmployment {
        data = typeof data === 'object' ? data : {};
        let result = new LiaEmployment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["liaApplicationId"] = this.liaApplicationId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["businessName"] = this.businessName;
        data["legalForm"] = this.legalForm ? this.legalForm.toJSON() : <any>undefined;
        data["legalFormId"] = this.legalFormId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["languageOfCorrespondence"] = this.languageOfCorrespondence ? this.languageOfCorrespondence.toJSON() : <any>undefined;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["isStationary"] = this.isStationary;
        data["startDateOfStationaryEmployment"] = this.startDateOfStationaryEmployment ? this.startDateOfStationaryEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfStationaryEmployment"] = this.levelOfStationaryEmployment;
        data["isSpitalAmbulatory"] = this.isSpitalAmbulatory;
        data["startDateOfSpitalAmbulatoryEmployment"] = this.startDateOfSpitalAmbulatoryEmployment ? this.startDateOfSpitalAmbulatoryEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfSpitalAmbulatoryEmployment"] = this.levelOfSpitalAmbulatoryEmployment;
        data["isDoctorsOfficeAmbulatory"] = this.isDoctorsOfficeAmbulatory;
        data["startDateOfDoctorsOfficeAmbulatoryEmployment"] = this.startDateOfDoctorsOfficeAmbulatoryEmployment ? this.startDateOfDoctorsOfficeAmbulatoryEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfDoctorsOfficeAmbulatoryEmployment"] = this.levelOfDoctorsOfficeAmbulatoryEmployment;
        data["website"] = this.website;
        data["practiceEstablishmentType"] = this.practiceEstablishmentType ? this.practiceEstablishmentType.toJSON() : <any>undefined;
        data["practiceEstablishmentTypeId"] = this.practiceEstablishmentTypeId;
        data["practiceEstablishmentTypeDetails"] = this.practiceEstablishmentTypeDetails;
        data["doesAmbulatoryWork"] = this.doesAmbulatoryWork ? this.doesAmbulatoryWork.toJSON() : <any>undefined;
        data["doesAmbulatoryWorkId"] = this.doesAmbulatoryWorkId;
        data["doesAmbulatoryWorkDetails"] = this.doesAmbulatoryWorkDetails;
        data["professionalRoleType"] = this.professionalRoleType ? this.professionalRoleType.toJSON() : <any>undefined;
        data["professionalRoleTypeId"] = this.professionalRoleTypeId;
        data["nursingWorkplaceType"] = this.nursingWorkplaceType ? this.nursingWorkplaceType.toJSON() : <any>undefined;
        data["nursingWorkplaceTypeId"] = this.nursingWorkplaceTypeId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaEmployment {
    liaApplication: LiaApplication;
    liaApplicationId: number;
    type: Code;
    typeId: string | undefined;
    businessName: string | undefined;
    legalForm: Code;
    legalFormId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    postOfficeBox: string | undefined;
    languageOfCorrespondence: Code;
    languageOfCorrespondenceId: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    dateOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    isStationary: boolean | undefined;
    startDateOfStationaryEmployment: DateTime | undefined;
    levelOfStationaryEmployment: number | undefined;
    isSpitalAmbulatory: boolean | undefined;
    startDateOfSpitalAmbulatoryEmployment: DateTime | undefined;
    levelOfSpitalAmbulatoryEmployment: number | undefined;
    isDoctorsOfficeAmbulatory: boolean | undefined;
    startDateOfDoctorsOfficeAmbulatoryEmployment: DateTime | undefined;
    levelOfDoctorsOfficeAmbulatoryEmployment: number | undefined;
    website: string | undefined;
    practiceEstablishmentType: Code;
    practiceEstablishmentTypeId: string | undefined;
    practiceEstablishmentTypeDetails: string | undefined;
    doesAmbulatoryWork: Code;
    doesAmbulatoryWorkId: string | undefined;
    doesAmbulatoryWorkDetails: string | undefined;
    professionalRoleType: Code;
    professionalRoleTypeId: string | undefined;
    nursingWorkplaceType: Code;
    nursingWorkplaceTypeId: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LiaEmploymentOrPostgraduateTitle implements ILiaEmploymentOrPostgraduateTitle {
    liaApplication!: LiaApplication;
    liaApplicationId!: number;
    isMarked!: boolean;
    ehcLevelOfEmployment!: number | undefined;
    levelOfEmployment!: number | undefined;
    postgraduateTitleId!: string | undefined;
    businessName!: string | undefined;
    legalFormId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    isMobileEmployment!: boolean;
    regionId!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaEmploymentOrPostgraduateTitle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : <any>undefined;
            this.liaApplicationId = _data["liaApplicationId"];
            this.isMarked = _data["isMarked"];
            this.ehcLevelOfEmployment = _data["ehcLevelOfEmployment"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.businessName = _data["businessName"];
            this.legalFormId = _data["legalFormId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.isMobileEmployment = _data["isMobileEmployment"];
            this.regionId = _data["regionId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaEmploymentOrPostgraduateTitle {
        data = typeof data === 'object' ? data : {};
        let result = new LiaEmploymentOrPostgraduateTitle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["liaApplicationId"] = this.liaApplicationId;
        data["isMarked"] = this.isMarked;
        data["ehcLevelOfEmployment"] = this.ehcLevelOfEmployment;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["businessName"] = this.businessName;
        data["legalFormId"] = this.legalFormId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["isMobileEmployment"] = this.isMobileEmployment;
        data["regionId"] = this.regionId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaEmploymentOrPostgraduateTitle {
    liaApplication: LiaApplication;
    liaApplicationId: number;
    isMarked: boolean;
    ehcLevelOfEmployment: number | undefined;
    levelOfEmployment: number | undefined;
    postgraduateTitleId: string | undefined;
    businessName: string | undefined;
    legalFormId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    isMobileEmployment: boolean;
    regionId: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LiaInvoiceAddress implements ILiaInvoiceAddress {
    liaApplication!: LiaApplication;
    name!: string | undefined;
    title!: Code;
    titleId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    typeOfAddressId!: string;
    languageOfCorrespondence!: Code;
    languageOfCorrespondenceId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    country!: Code;
    countryId!: string | undefined;
    email!: string | undefined;
    liaEmployment!: LiaEmployment;
    liaEmploymentId!: number | undefined;
    addressAddition!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaInvoiceAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : <any>undefined;
            this.name = _data["name"];
            this.title = _data["title"] ? Code.fromJS(_data["title"]) : <any>undefined;
            this.titleId = _data["titleId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.typeOfAddressId = _data["typeOfAddressId"];
            this.languageOfCorrespondence = _data["languageOfCorrespondence"] ? Code.fromJS(_data["languageOfCorrespondence"]) : <any>undefined;
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.country = _data["country"] ? Code.fromJS(_data["country"]) : <any>undefined;
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.liaEmployment = _data["liaEmployment"] ? LiaEmployment.fromJS(_data["liaEmployment"]) : <any>undefined;
            this.liaEmploymentId = _data["liaEmploymentId"];
            this.addressAddition = _data["addressAddition"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaInvoiceAddress {
        data = typeof data === 'object' ? data : {};
        let result = new LiaInvoiceAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["titleId"] = this.titleId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["typeOfAddressId"] = this.typeOfAddressId;
        data["languageOfCorrespondence"] = this.languageOfCorrespondence ? this.languageOfCorrespondence.toJSON() : <any>undefined;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["liaEmployment"] = this.liaEmployment ? this.liaEmployment.toJSON() : <any>undefined;
        data["liaEmploymentId"] = this.liaEmploymentId;
        data["addressAddition"] = this.addressAddition;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaInvoiceAddress {
    liaApplication: LiaApplication;
    name: string | undefined;
    title: Code;
    titleId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    typeOfAddressId: string;
    languageOfCorrespondence: Code;
    languageOfCorrespondenceId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    country: Code;
    countryId: string | undefined;
    email: string | undefined;
    liaEmployment: LiaEmployment;
    liaEmploymentId: number | undefined;
    addressAddition: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LiaLanguageSkill implements ILiaLanguageSkill {
    liaApplication!: LiaApplication;
    languageSkill!: Code;
    languageSkillId!: string;
    educationLanguage!: Code;
    educationLanguageId!: string | undefined;
    comments!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaLanguageSkill) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : <any>undefined;
            this.languageSkill = _data["languageSkill"] ? Code.fromJS(_data["languageSkill"]) : <any>undefined;
            this.languageSkillId = _data["languageSkillId"];
            this.educationLanguage = _data["educationLanguage"] ? Code.fromJS(_data["educationLanguage"]) : <any>undefined;
            this.educationLanguageId = _data["educationLanguageId"];
            this.comments = _data["comments"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaLanguageSkill {
        data = typeof data === 'object' ? data : {};
        let result = new LiaLanguageSkill();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["languageSkill"] = this.languageSkill ? this.languageSkill.toJSON() : <any>undefined;
        data["languageSkillId"] = this.languageSkillId;
        data["educationLanguage"] = this.educationLanguage ? this.educationLanguage.toJSON() : <any>undefined;
        data["educationLanguageId"] = this.educationLanguageId;
        data["comments"] = this.comments;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaLanguageSkill {
    liaApplication: LiaApplication;
    languageSkill: Code;
    languageSkillId: string;
    educationLanguage: Code;
    educationLanguageId: string | undefined;
    comments: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LiaMobileEmployment implements ILiaMobileEmployment {
    liaApplication!: LiaApplication;
    hasMobileEmployment!: boolean;
    startDateOfMobileEmployment!: DateTime | undefined;
    levelOfMobileEmployment!: number | undefined;
    kindId!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaMobileEmployment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : <any>undefined;
            this.hasMobileEmployment = _data["hasMobileEmployment"];
            this.startDateOfMobileEmployment = _data["startDateOfMobileEmployment"] ? DateTime.fromISO(_data["startDateOfMobileEmployment"].toString()) : <any>undefined;
            this.levelOfMobileEmployment = _data["levelOfMobileEmployment"];
            this.kindId = _data["kindId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaMobileEmployment {
        data = typeof data === 'object' ? data : {};
        let result = new LiaMobileEmployment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["hasMobileEmployment"] = this.hasMobileEmployment;
        data["startDateOfMobileEmployment"] = this.startDateOfMobileEmployment ? this.startDateOfMobileEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfMobileEmployment"] = this.levelOfMobileEmployment;
        data["kindId"] = this.kindId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaMobileEmployment {
    liaApplication: LiaApplication;
    hasMobileEmployment: boolean;
    startDateOfMobileEmployment: DateTime | undefined;
    levelOfMobileEmployment: number | undefined;
    kindId: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LiaPerson implements ILiaPerson {
    liaApplication!: LiaApplication;
    firstName!: string;
    lastName!: string;
    birthName!: string | undefined;
    gender!: Code;
    genderId!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    nationality1!: Code;
    nationality1Id!: string | undefined;
    nationality2!: Code;
    nationality2Id!: string | undefined;
    placeOfOrigin!: string | undefined;
    residencePermit!: boolean | undefined;
    hasLicenceInAnotherCanton!: Code;
    hasLicenceInAnotherCantonId!: string | undefined;
    hasConfirmedData!: boolean | undefined;
    dateOfResidencePermit!: DateTime | undefined;
    gln!: string | undefined;
    ahv!: string | undefined;
    zsr!: string | undefined;
    uid!: string | undefined;
    medRegId!: number | undefined;
    psyRegId!: number | undefined;
    naregId!: number | undefined;
    healthRegisterSnapshot!: HealthRegisterSnapshot;
    healthRegisterSnapshotId!: number | undefined;
    readonly isAnyHealthRegisterIdAvailable!: boolean;
    healthRegisterResult!: HealthRegisterIdentificationStatus;
    readonly fullName!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.gender = _data["gender"] ? Code.fromJS(_data["gender"]) : <any>undefined;
            this.genderId = _data["genderId"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.nationality1 = _data["nationality1"] ? Code.fromJS(_data["nationality1"]) : <any>undefined;
            this.nationality1Id = _data["nationality1Id"];
            this.nationality2 = _data["nationality2"] ? Code.fromJS(_data["nationality2"]) : <any>undefined;
            this.nationality2Id = _data["nationality2Id"];
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.residencePermit = _data["residencePermit"];
            this.hasLicenceInAnotherCanton = _data["hasLicenceInAnotherCanton"] ? Code.fromJS(_data["hasLicenceInAnotherCanton"]) : <any>undefined;
            this.hasLicenceInAnotherCantonId = _data["hasLicenceInAnotherCantonId"];
            this.hasConfirmedData = _data["hasConfirmedData"];
            this.dateOfResidencePermit = _data["dateOfResidencePermit"] ? DateTime.fromISO(_data["dateOfResidencePermit"].toString()) : <any>undefined;
            this.gln = _data["gln"];
            this.ahv = _data["ahv"];
            this.zsr = _data["zsr"];
            this.uid = _data["uid"];
            this.medRegId = _data["medRegId"];
            this.psyRegId = _data["psyRegId"];
            this.naregId = _data["naregId"];
            this.healthRegisterSnapshot = _data["healthRegisterSnapshot"] ? HealthRegisterSnapshot.fromJS(_data["healthRegisterSnapshot"]) : <any>undefined;
            this.healthRegisterSnapshotId = _data["healthRegisterSnapshotId"];
            (<any>this).isAnyHealthRegisterIdAvailable = _data["isAnyHealthRegisterIdAvailable"];
            this.healthRegisterResult = _data["healthRegisterResult"];
            (<any>this).fullName = _data["fullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaPerson {
        data = typeof data === 'object' ? data : {};
        let result = new LiaPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["genderId"] = this.genderId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["nationality1"] = this.nationality1 ? this.nationality1.toJSON() : <any>undefined;
        data["nationality1Id"] = this.nationality1Id;
        data["nationality2"] = this.nationality2 ? this.nationality2.toJSON() : <any>undefined;
        data["nationality2Id"] = this.nationality2Id;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["residencePermit"] = this.residencePermit;
        data["hasLicenceInAnotherCanton"] = this.hasLicenceInAnotherCanton ? this.hasLicenceInAnotherCanton.toJSON() : <any>undefined;
        data["hasLicenceInAnotherCantonId"] = this.hasLicenceInAnotherCantonId;
        data["hasConfirmedData"] = this.hasConfirmedData;
        data["dateOfResidencePermit"] = this.dateOfResidencePermit ? this.dateOfResidencePermit.toFormat('yyyy-MM-dd') : <any>undefined;
        data["gln"] = this.gln;
        data["ahv"] = this.ahv;
        data["zsr"] = this.zsr;
        data["uid"] = this.uid;
        data["medRegId"] = this.medRegId;
        data["psyRegId"] = this.psyRegId;
        data["naregId"] = this.naregId;
        data["healthRegisterSnapshot"] = this.healthRegisterSnapshot ? this.healthRegisterSnapshot.toJSON() : <any>undefined;
        data["healthRegisterSnapshotId"] = this.healthRegisterSnapshotId;
        data["isAnyHealthRegisterIdAvailable"] = this.isAnyHealthRegisterIdAvailable;
        data["healthRegisterResult"] = this.healthRegisterResult;
        data["fullName"] = this.fullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaPerson {
    liaApplication: LiaApplication;
    firstName: string;
    lastName: string;
    birthName: string | undefined;
    gender: Code;
    genderId: string | undefined;
    dateOfBirth: DateTime | undefined;
    nationality1: Code;
    nationality1Id: string | undefined;
    nationality2: Code;
    nationality2Id: string | undefined;
    placeOfOrigin: string | undefined;
    residencePermit: boolean | undefined;
    hasLicenceInAnotherCanton: Code;
    hasLicenceInAnotherCantonId: string | undefined;
    hasConfirmedData: boolean | undefined;
    dateOfResidencePermit: DateTime | undefined;
    gln: string | undefined;
    ahv: string | undefined;
    zsr: string | undefined;
    uid: string | undefined;
    medRegId: number | undefined;
    psyRegId: number | undefined;
    naregId: number | undefined;
    healthRegisterSnapshot: HealthRegisterSnapshot;
    healthRegisterSnapshotId: number | undefined;
    isAnyHealthRegisterIdAvailable: boolean;
    healthRegisterResult: HealthRegisterIdentificationStatus;
    fullName: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LiaPractice implements ILiaPractice {
    liaApplication!: LiaApplication;
    liaApplicationId!: number;
    liaSelectedPracticeDescription!: Code;
    liaSelectedPracticeDescriptionId!: string | undefined;
    liaPracticeRecords!: LiaPracticeRecord[] | undefined;
    liaPracticeConfigSnapshot!: LiaPracticeConfigSnapshot;
    liaPracticeConfigSnapshotId!: number;
    exemptionAccordingArt37Kvg!: boolean | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaPractice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : <any>undefined;
            this.liaApplicationId = _data["liaApplicationId"];
            this.liaSelectedPracticeDescription = _data["liaSelectedPracticeDescription"] ? Code.fromJS(_data["liaSelectedPracticeDescription"]) : <any>undefined;
            this.liaSelectedPracticeDescriptionId = _data["liaSelectedPracticeDescriptionId"];
            if (Array.isArray(_data["liaPracticeRecords"])) {
                this.liaPracticeRecords = [] as any;
                for (let item of _data["liaPracticeRecords"])
                    this.liaPracticeRecords!.push(LiaPracticeRecord.fromJS(item));
            }
            this.liaPracticeConfigSnapshot = _data["liaPracticeConfigSnapshot"] ? LiaPracticeConfigSnapshot.fromJS(_data["liaPracticeConfigSnapshot"]) : <any>undefined;
            this.liaPracticeConfigSnapshotId = _data["liaPracticeConfigSnapshotId"];
            this.exemptionAccordingArt37Kvg = _data["exemptionAccordingArt37Kvg"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaPractice {
        data = typeof data === 'object' ? data : {};
        let result = new LiaPractice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["liaApplicationId"] = this.liaApplicationId;
        data["liaSelectedPracticeDescription"] = this.liaSelectedPracticeDescription ? this.liaSelectedPracticeDescription.toJSON() : <any>undefined;
        data["liaSelectedPracticeDescriptionId"] = this.liaSelectedPracticeDescriptionId;
        if (Array.isArray(this.liaPracticeRecords)) {
            data["liaPracticeRecords"] = [];
            for (let item of this.liaPracticeRecords)
                data["liaPracticeRecords"].push(item.toJSON());
        }
        data["liaPracticeConfigSnapshot"] = this.liaPracticeConfigSnapshot ? this.liaPracticeConfigSnapshot.toJSON() : <any>undefined;
        data["liaPracticeConfigSnapshotId"] = this.liaPracticeConfigSnapshotId;
        data["exemptionAccordingArt37Kvg"] = this.exemptionAccordingArt37Kvg;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaPractice {
    liaApplication: LiaApplication;
    liaApplicationId: number;
    liaSelectedPracticeDescription: Code;
    liaSelectedPracticeDescriptionId: string | undefined;
    liaPracticeRecords: LiaPracticeRecord[] | undefined;
    liaPracticeConfigSnapshot: LiaPracticeConfigSnapshot;
    liaPracticeConfigSnapshotId: number;
    exemptionAccordingArt37Kvg: boolean | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LiaPracticeConfigSnapshot implements ILiaPracticeConfigSnapshot {
    minimumDurationInDays!: number;
    ignoreMinimumDuration!: boolean;
    liaPracticeDescriptionPreLabel1!: string | undefined;
    liaPracticeDescription1!: Code;
    liaPracticeDescription1Id!: string | undefined;
    liaPracticeDescriptionPreLabel2!: string | undefined;
    liaPracticeDescription2!: Code;
    liaPracticeDescription2Id!: string | undefined;
    liaPracticeDescriptionPreLabel3!: string | undefined;
    liaPracticeDescription3!: Code;
    liaPracticeDescription3Id!: string | undefined;
    liaPracticeDescriptionPreLabel4!: string | undefined;
    liaPracticeDescription4!: Code;
    liaPracticeDescription4Id!: string | undefined;
    liaPracticeDescriptionPreLabel5!: string | undefined;
    liaPracticeDescription5!: Code;
    liaPracticeDescription5Id!: string | undefined;
    liaPracticeRecordDescriptionPreLabel1!: string | undefined;
    liaPracticeRecordDescription1!: Code;
    liaPracticeRecordDescription1Id!: string | undefined;
    liaPracticeRecordDescriptionPreLabel2!: string | undefined;
    liaPracticeRecordDescription2!: Code;
    liaPracticeRecordDescription2Id!: string | undefined;
    liaPracticeRecordDescriptionPreLabel3!: string | undefined;
    liaPracticeRecordDescription3!: Code;
    liaPracticeRecordDescription3Id!: string | undefined;
    liaPracticeRecordDescriptionPreLabel4!: string | undefined;
    liaPracticeRecordDescription4!: Code;
    liaPracticeRecordDescription4Id!: string | undefined;
    liaPracticeRecordDescriptionPreLabel5!: string | undefined;
    liaPracticeRecordDescription5!: Code;
    liaPracticeRecordDescription5Id!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaPracticeConfigSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumDurationInDays = _data["minimumDurationInDays"];
            this.ignoreMinimumDuration = _data["ignoreMinimumDuration"];
            this.liaPracticeDescriptionPreLabel1 = _data["liaPracticeDescriptionPreLabel1"];
            this.liaPracticeDescription1 = _data["liaPracticeDescription1"] ? Code.fromJS(_data["liaPracticeDescription1"]) : <any>undefined;
            this.liaPracticeDescription1Id = _data["liaPracticeDescription1Id"];
            this.liaPracticeDescriptionPreLabel2 = _data["liaPracticeDescriptionPreLabel2"];
            this.liaPracticeDescription2 = _data["liaPracticeDescription2"] ? Code.fromJS(_data["liaPracticeDescription2"]) : <any>undefined;
            this.liaPracticeDescription2Id = _data["liaPracticeDescription2Id"];
            this.liaPracticeDescriptionPreLabel3 = _data["liaPracticeDescriptionPreLabel3"];
            this.liaPracticeDescription3 = _data["liaPracticeDescription3"] ? Code.fromJS(_data["liaPracticeDescription3"]) : <any>undefined;
            this.liaPracticeDescription3Id = _data["liaPracticeDescription3Id"];
            this.liaPracticeDescriptionPreLabel4 = _data["liaPracticeDescriptionPreLabel4"];
            this.liaPracticeDescription4 = _data["liaPracticeDescription4"] ? Code.fromJS(_data["liaPracticeDescription4"]) : <any>undefined;
            this.liaPracticeDescription4Id = _data["liaPracticeDescription4Id"];
            this.liaPracticeDescriptionPreLabel5 = _data["liaPracticeDescriptionPreLabel5"];
            this.liaPracticeDescription5 = _data["liaPracticeDescription5"] ? Code.fromJS(_data["liaPracticeDescription5"]) : <any>undefined;
            this.liaPracticeDescription5Id = _data["liaPracticeDescription5Id"];
            this.liaPracticeRecordDescriptionPreLabel1 = _data["liaPracticeRecordDescriptionPreLabel1"];
            this.liaPracticeRecordDescription1 = _data["liaPracticeRecordDescription1"] ? Code.fromJS(_data["liaPracticeRecordDescription1"]) : <any>undefined;
            this.liaPracticeRecordDescription1Id = _data["liaPracticeRecordDescription1Id"];
            this.liaPracticeRecordDescriptionPreLabel2 = _data["liaPracticeRecordDescriptionPreLabel2"];
            this.liaPracticeRecordDescription2 = _data["liaPracticeRecordDescription2"] ? Code.fromJS(_data["liaPracticeRecordDescription2"]) : <any>undefined;
            this.liaPracticeRecordDescription2Id = _data["liaPracticeRecordDescription2Id"];
            this.liaPracticeRecordDescriptionPreLabel3 = _data["liaPracticeRecordDescriptionPreLabel3"];
            this.liaPracticeRecordDescription3 = _data["liaPracticeRecordDescription3"] ? Code.fromJS(_data["liaPracticeRecordDescription3"]) : <any>undefined;
            this.liaPracticeRecordDescription3Id = _data["liaPracticeRecordDescription3Id"];
            this.liaPracticeRecordDescriptionPreLabel4 = _data["liaPracticeRecordDescriptionPreLabel4"];
            this.liaPracticeRecordDescription4 = _data["liaPracticeRecordDescription4"] ? Code.fromJS(_data["liaPracticeRecordDescription4"]) : <any>undefined;
            this.liaPracticeRecordDescription4Id = _data["liaPracticeRecordDescription4Id"];
            this.liaPracticeRecordDescriptionPreLabel5 = _data["liaPracticeRecordDescriptionPreLabel5"];
            this.liaPracticeRecordDescription5 = _data["liaPracticeRecordDescription5"] ? Code.fromJS(_data["liaPracticeRecordDescription5"]) : <any>undefined;
            this.liaPracticeRecordDescription5Id = _data["liaPracticeRecordDescription5Id"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaPracticeConfigSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new LiaPracticeConfigSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumDurationInDays"] = this.minimumDurationInDays;
        data["ignoreMinimumDuration"] = this.ignoreMinimumDuration;
        data["liaPracticeDescriptionPreLabel1"] = this.liaPracticeDescriptionPreLabel1;
        data["liaPracticeDescription1"] = this.liaPracticeDescription1 ? this.liaPracticeDescription1.toJSON() : <any>undefined;
        data["liaPracticeDescription1Id"] = this.liaPracticeDescription1Id;
        data["liaPracticeDescriptionPreLabel2"] = this.liaPracticeDescriptionPreLabel2;
        data["liaPracticeDescription2"] = this.liaPracticeDescription2 ? this.liaPracticeDescription2.toJSON() : <any>undefined;
        data["liaPracticeDescription2Id"] = this.liaPracticeDescription2Id;
        data["liaPracticeDescriptionPreLabel3"] = this.liaPracticeDescriptionPreLabel3;
        data["liaPracticeDescription3"] = this.liaPracticeDescription3 ? this.liaPracticeDescription3.toJSON() : <any>undefined;
        data["liaPracticeDescription3Id"] = this.liaPracticeDescription3Id;
        data["liaPracticeDescriptionPreLabel4"] = this.liaPracticeDescriptionPreLabel4;
        data["liaPracticeDescription4"] = this.liaPracticeDescription4 ? this.liaPracticeDescription4.toJSON() : <any>undefined;
        data["liaPracticeDescription4Id"] = this.liaPracticeDescription4Id;
        data["liaPracticeDescriptionPreLabel5"] = this.liaPracticeDescriptionPreLabel5;
        data["liaPracticeDescription5"] = this.liaPracticeDescription5 ? this.liaPracticeDescription5.toJSON() : <any>undefined;
        data["liaPracticeDescription5Id"] = this.liaPracticeDescription5Id;
        data["liaPracticeRecordDescriptionPreLabel1"] = this.liaPracticeRecordDescriptionPreLabel1;
        data["liaPracticeRecordDescription1"] = this.liaPracticeRecordDescription1 ? this.liaPracticeRecordDescription1.toJSON() : <any>undefined;
        data["liaPracticeRecordDescription1Id"] = this.liaPracticeRecordDescription1Id;
        data["liaPracticeRecordDescriptionPreLabel2"] = this.liaPracticeRecordDescriptionPreLabel2;
        data["liaPracticeRecordDescription2"] = this.liaPracticeRecordDescription2 ? this.liaPracticeRecordDescription2.toJSON() : <any>undefined;
        data["liaPracticeRecordDescription2Id"] = this.liaPracticeRecordDescription2Id;
        data["liaPracticeRecordDescriptionPreLabel3"] = this.liaPracticeRecordDescriptionPreLabel3;
        data["liaPracticeRecordDescription3"] = this.liaPracticeRecordDescription3 ? this.liaPracticeRecordDescription3.toJSON() : <any>undefined;
        data["liaPracticeRecordDescription3Id"] = this.liaPracticeRecordDescription3Id;
        data["liaPracticeRecordDescriptionPreLabel4"] = this.liaPracticeRecordDescriptionPreLabel4;
        data["liaPracticeRecordDescription4"] = this.liaPracticeRecordDescription4 ? this.liaPracticeRecordDescription4.toJSON() : <any>undefined;
        data["liaPracticeRecordDescription4Id"] = this.liaPracticeRecordDescription4Id;
        data["liaPracticeRecordDescriptionPreLabel5"] = this.liaPracticeRecordDescriptionPreLabel5;
        data["liaPracticeRecordDescription5"] = this.liaPracticeRecordDescription5 ? this.liaPracticeRecordDescription5.toJSON() : <any>undefined;
        data["liaPracticeRecordDescription5Id"] = this.liaPracticeRecordDescription5Id;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaPracticeConfigSnapshot {
    minimumDurationInDays: number;
    ignoreMinimumDuration: boolean;
    liaPracticeDescriptionPreLabel1: string | undefined;
    liaPracticeDescription1: Code;
    liaPracticeDescription1Id: string | undefined;
    liaPracticeDescriptionPreLabel2: string | undefined;
    liaPracticeDescription2: Code;
    liaPracticeDescription2Id: string | undefined;
    liaPracticeDescriptionPreLabel3: string | undefined;
    liaPracticeDescription3: Code;
    liaPracticeDescription3Id: string | undefined;
    liaPracticeDescriptionPreLabel4: string | undefined;
    liaPracticeDescription4: Code;
    liaPracticeDescription4Id: string | undefined;
    liaPracticeDescriptionPreLabel5: string | undefined;
    liaPracticeDescription5: Code;
    liaPracticeDescription5Id: string | undefined;
    liaPracticeRecordDescriptionPreLabel1: string | undefined;
    liaPracticeRecordDescription1: Code;
    liaPracticeRecordDescription1Id: string | undefined;
    liaPracticeRecordDescriptionPreLabel2: string | undefined;
    liaPracticeRecordDescription2: Code;
    liaPracticeRecordDescription2Id: string | undefined;
    liaPracticeRecordDescriptionPreLabel3: string | undefined;
    liaPracticeRecordDescription3: Code;
    liaPracticeRecordDescription3Id: string | undefined;
    liaPracticeRecordDescriptionPreLabel4: string | undefined;
    liaPracticeRecordDescription4: Code;
    liaPracticeRecordDescription4Id: string | undefined;
    liaPracticeRecordDescriptionPreLabel5: string | undefined;
    liaPracticeRecordDescription5: Code;
    liaPracticeRecordDescription5Id: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LiaPracticeDto implements ILiaPracticeDto {
    ehcSelectedPracticeDescriptionId!: string | undefined;
    liaPracticeRecords!: EhcPracticeRecordDto[] | undefined;
    ehcPracticeConfigSnapshot!: EhcPracticeConfigSnapshotDto;
    exemptionAccordingArt37Kvg!: boolean | undefined;
    liaPracticeRecordDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaPracticeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ehcSelectedPracticeDescriptionId = _data["ehcSelectedPracticeDescriptionId"];
            if (Array.isArray(_data["liaPracticeRecords"])) {
                this.liaPracticeRecords = [] as any;
                for (let item of _data["liaPracticeRecords"])
                    this.liaPracticeRecords!.push(EhcPracticeRecordDto.fromJS(item));
            }
            this.ehcPracticeConfigSnapshot = _data["ehcPracticeConfigSnapshot"] ? EhcPracticeConfigSnapshotDto.fromJS(_data["ehcPracticeConfigSnapshot"]) : <any>undefined;
            this.exemptionAccordingArt37Kvg = _data["exemptionAccordingArt37Kvg"];
            if (Array.isArray(_data["liaPracticeRecordDocuments"])) {
                this.liaPracticeRecordDocuments = [] as any;
                for (let item of _data["liaPracticeRecordDocuments"])
                    this.liaPracticeRecordDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaPracticeDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaPracticeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ehcSelectedPracticeDescriptionId"] = this.ehcSelectedPracticeDescriptionId;
        if (Array.isArray(this.liaPracticeRecords)) {
            data["liaPracticeRecords"] = [];
            for (let item of this.liaPracticeRecords)
                data["liaPracticeRecords"].push(item.toJSON());
        }
        data["ehcPracticeConfigSnapshot"] = this.ehcPracticeConfigSnapshot ? this.ehcPracticeConfigSnapshot.toJSON() : <any>undefined;
        data["exemptionAccordingArt37Kvg"] = this.exemptionAccordingArt37Kvg;
        if (Array.isArray(this.liaPracticeRecordDocuments)) {
            data["liaPracticeRecordDocuments"] = [];
            for (let item of this.liaPracticeRecordDocuments)
                data["liaPracticeRecordDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaPracticeDto {
    ehcSelectedPracticeDescriptionId: string | undefined;
    liaPracticeRecords: EhcPracticeRecordDto[] | undefined;
    ehcPracticeConfigSnapshot: EhcPracticeConfigSnapshotDto;
    exemptionAccordingArt37Kvg: boolean | undefined;
    liaPracticeRecordDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class LiaPracticeRecord implements ILiaPracticeRecord {
    id!: string;
    businessName!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number;
    liaSelectedPracticeRecordDescription!: Code;
    liaSelectedPracticeRecordDescriptionId!: string | undefined;
    liaPractice!: LiaPractice;
    liaPracticeId!: number;
    liaPracticeRecordDocuments!: LiaPracticeRecordDocument[] | undefined;
    postgraduateTitle!: Code;
    postgraduateTitleId!: string | undefined;
    exemptionAccordingArt37Kvg!: boolean | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;

    constructor(data?: ILiaPracticeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessName = _data["businessName"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.liaSelectedPracticeRecordDescription = _data["liaSelectedPracticeRecordDescription"] ? Code.fromJS(_data["liaSelectedPracticeRecordDescription"]) : <any>undefined;
            this.liaSelectedPracticeRecordDescriptionId = _data["liaSelectedPracticeRecordDescriptionId"];
            this.liaPractice = _data["liaPractice"] ? LiaPractice.fromJS(_data["liaPractice"]) : <any>undefined;
            this.liaPracticeId = _data["liaPracticeId"];
            if (Array.isArray(_data["liaPracticeRecordDocuments"])) {
                this.liaPracticeRecordDocuments = [] as any;
                for (let item of _data["liaPracticeRecordDocuments"])
                    this.liaPracticeRecordDocuments!.push(LiaPracticeRecordDocument.fromJS(item));
            }
            this.postgraduateTitle = _data["postgraduateTitle"] ? Code.fromJS(_data["postgraduateTitle"]) : <any>undefined;
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.exemptionAccordingArt37Kvg = _data["exemptionAccordingArt37Kvg"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): LiaPracticeRecord {
        data = typeof data === 'object' ? data : {};
        let result = new LiaPracticeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessName"] = this.businessName;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["liaSelectedPracticeRecordDescription"] = this.liaSelectedPracticeRecordDescription ? this.liaSelectedPracticeRecordDescription.toJSON() : <any>undefined;
        data["liaSelectedPracticeRecordDescriptionId"] = this.liaSelectedPracticeRecordDescriptionId;
        data["liaPractice"] = this.liaPractice ? this.liaPractice.toJSON() : <any>undefined;
        data["liaPracticeId"] = this.liaPracticeId;
        if (Array.isArray(this.liaPracticeRecordDocuments)) {
            data["liaPracticeRecordDocuments"] = [];
            for (let item of this.liaPracticeRecordDocuments)
                data["liaPracticeRecordDocuments"].push(item.toJSON());
        }
        data["postgraduateTitle"] = this.postgraduateTitle ? this.postgraduateTitle.toJSON() : <any>undefined;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["exemptionAccordingArt37Kvg"] = this.exemptionAccordingArt37Kvg;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data;
    }
}

export interface ILiaPracticeRecord {
    id: string;
    businessName: string | undefined;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number;
    liaSelectedPracticeRecordDescription: Code;
    liaSelectedPracticeRecordDescriptionId: string | undefined;
    liaPractice: LiaPractice;
    liaPracticeId: number;
    liaPracticeRecordDocuments: LiaPracticeRecordDocument[] | undefined;
    postgraduateTitle: Code;
    postgraduateTitleId: string | undefined;
    exemptionAccordingArt37Kvg: boolean | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
}

export class LiaPracticeRecordDocument implements ILiaPracticeRecordDocument {
    liaPracticeRecordId!: string;
    liaApplication!: LiaApplication;
    liaApplicationId!: number;
    step!: LiaStatus;
    type!: Code;
    typeId!: string | undefined;
    name!: string | undefined;
    mimeHeader!: string | undefined;
    binaryObject!: BinaryObject;
    binaryObjectId!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaPracticeRecordDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaApplication = new LiaApplication();
            this.type = new Code();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaPracticeRecordId = _data["liaPracticeRecordId"];
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : new LiaApplication();
            this.liaApplicationId = _data["liaApplicationId"];
            this.step = _data["step"];
            this.type = _data["type"] ? Code.fromJS(_data["type"]) : new Code();
            this.typeId = _data["typeId"];
            this.name = _data["name"];
            this.mimeHeader = _data["mimeHeader"];
            this.binaryObject = _data["binaryObject"] ? BinaryObject.fromJS(_data["binaryObject"]) : <any>undefined;
            this.binaryObjectId = _data["binaryObjectId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaPracticeRecordDocument {
        data = typeof data === 'object' ? data : {};
        let result = new LiaPracticeRecordDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaPracticeRecordId"] = this.liaPracticeRecordId;
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["liaApplicationId"] = this.liaApplicationId;
        data["step"] = this.step;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["name"] = this.name;
        data["mimeHeader"] = this.mimeHeader;
        data["binaryObject"] = this.binaryObject ? this.binaryObject.toJSON() : <any>undefined;
        data["binaryObjectId"] = this.binaryObjectId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaPracticeRecordDocument {
    liaPracticeRecordId: string;
    liaApplication: LiaApplication;
    liaApplicationId: number;
    step: LiaStatus;
    type: Code;
    typeId: string | undefined;
    name: string | undefined;
    mimeHeader: string | undefined;
    binaryObject: BinaryObject;
    binaryObjectId: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LiaProfessionalResponsibilityOutput implements ILiaProfessionalResponsibilityOutput {
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaProfessionalResponsibilityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaProfessionalResponsibilityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LiaProfessionalResponsibilityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaProfessionalResponsibilityOutput {
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class LiaQualityRequirement implements ILiaQualityRequirement {
    liaApplication!: LiaApplication;
    hasQualifiedStaff!: Code;
    hasQualifiedStaffId!: string;
    qualifiedStaffDetails!: string | undefined;
    hasQualityManagementSystem!: Code;
    hasQualityManagementSystemId!: string;
    qualityManagementSystemDetails!: string | undefined;
    hasReportingAndLearningSystem!: Code;
    hasReportingAndLearningSystemId!: string;
    reportingAndLearningSystemDetails!: string | undefined;
    hasQualityMeasurement!: Code;
    hasQualityMeasurementId!: string;
    qualityMeasurementDetails!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaQualityRequirement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : <any>undefined;
            this.hasQualifiedStaff = _data["hasQualifiedStaff"] ? Code.fromJS(_data["hasQualifiedStaff"]) : <any>undefined;
            this.hasQualifiedStaffId = _data["hasQualifiedStaffId"];
            this.qualifiedStaffDetails = _data["qualifiedStaffDetails"];
            this.hasQualityManagementSystem = _data["hasQualityManagementSystem"] ? Code.fromJS(_data["hasQualityManagementSystem"]) : <any>undefined;
            this.hasQualityManagementSystemId = _data["hasQualityManagementSystemId"];
            this.qualityManagementSystemDetails = _data["qualityManagementSystemDetails"];
            this.hasReportingAndLearningSystem = _data["hasReportingAndLearningSystem"] ? Code.fromJS(_data["hasReportingAndLearningSystem"]) : <any>undefined;
            this.hasReportingAndLearningSystemId = _data["hasReportingAndLearningSystemId"];
            this.reportingAndLearningSystemDetails = _data["reportingAndLearningSystemDetails"];
            this.hasQualityMeasurement = _data["hasQualityMeasurement"] ? Code.fromJS(_data["hasQualityMeasurement"]) : <any>undefined;
            this.hasQualityMeasurementId = _data["hasQualityMeasurementId"];
            this.qualityMeasurementDetails = _data["qualityMeasurementDetails"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaQualityRequirement {
        data = typeof data === 'object' ? data : {};
        let result = new LiaQualityRequirement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["hasQualifiedStaff"] = this.hasQualifiedStaff ? this.hasQualifiedStaff.toJSON() : <any>undefined;
        data["hasQualifiedStaffId"] = this.hasQualifiedStaffId;
        data["qualifiedStaffDetails"] = this.qualifiedStaffDetails;
        data["hasQualityManagementSystem"] = this.hasQualityManagementSystem ? this.hasQualityManagementSystem.toJSON() : <any>undefined;
        data["hasQualityManagementSystemId"] = this.hasQualityManagementSystemId;
        data["qualityManagementSystemDetails"] = this.qualityManagementSystemDetails;
        data["hasReportingAndLearningSystem"] = this.hasReportingAndLearningSystem ? this.hasReportingAndLearningSystem.toJSON() : <any>undefined;
        data["hasReportingAndLearningSystemId"] = this.hasReportingAndLearningSystemId;
        data["reportingAndLearningSystemDetails"] = this.reportingAndLearningSystemDetails;
        data["hasQualityMeasurement"] = this.hasQualityMeasurement ? this.hasQualityMeasurement.toJSON() : <any>undefined;
        data["hasQualityMeasurementId"] = this.hasQualityMeasurementId;
        data["qualityMeasurementDetails"] = this.qualityMeasurementDetails;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaQualityRequirement {
    liaApplication: LiaApplication;
    hasQualifiedStaff: Code;
    hasQualifiedStaffId: string;
    qualifiedStaffDetails: string | undefined;
    hasQualityManagementSystem: Code;
    hasQualityManagementSystemId: string;
    qualityManagementSystemDetails: string | undefined;
    hasReportingAndLearningSystem: Code;
    hasReportingAndLearningSystemId: string;
    reportingAndLearningSystemDetails: string | undefined;
    hasQualityMeasurement: Code;
    hasQualityMeasurementId: string;
    qualityMeasurementDetails: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LiaRestriction implements ILiaRestriction {
    liaApplication!: LiaApplication;
    liaApplicationId!: number;
    restrictionType!: LiaRestrictionType;
    canton!: Code;
    cantonId!: string | undefined;
    reason!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaRestriction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.canton = new Code();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : <any>undefined;
            this.liaApplicationId = _data["liaApplicationId"];
            this.restrictionType = _data["restrictionType"];
            this.canton = _data["canton"] ? Code.fromJS(_data["canton"]) : new Code();
            this.cantonId = _data["cantonId"];
            this.reason = _data["reason"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaRestriction {
        data = typeof data === 'object' ? data : {};
        let result = new LiaRestriction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["liaApplicationId"] = this.liaApplicationId;
        data["restrictionType"] = this.restrictionType;
        data["canton"] = this.canton ? this.canton.toJSON() : <any>undefined;
        data["cantonId"] = this.cantonId;
        data["reason"] = this.reason;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaRestriction {
    liaApplication: LiaApplication;
    liaApplicationId: number;
    restrictionType: LiaRestrictionType;
    canton: Code;
    cantonId: string | undefined;
    reason: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LiaRestrictionGeneralInformation implements ILiaRestrictionGeneralInformation {
    liaApplication!: LiaApplication;
    hasRevocationOrProhibition!: Code;
    hasRevocationOrProhibitionId!: string | undefined;
    hasConditionalApproval!: Code;
    hasConditionalApprovalId!: string | undefined;
    hasImpairment!: Code;
    hasImpairmentId!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaRestrictionGeneralInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : <any>undefined;
            this.hasRevocationOrProhibition = _data["hasRevocationOrProhibition"] ? Code.fromJS(_data["hasRevocationOrProhibition"]) : <any>undefined;
            this.hasRevocationOrProhibitionId = _data["hasRevocationOrProhibitionId"];
            this.hasConditionalApproval = _data["hasConditionalApproval"] ? Code.fromJS(_data["hasConditionalApproval"]) : <any>undefined;
            this.hasConditionalApprovalId = _data["hasConditionalApprovalId"];
            this.hasImpairment = _data["hasImpairment"] ? Code.fromJS(_data["hasImpairment"]) : <any>undefined;
            this.hasImpairmentId = _data["hasImpairmentId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaRestrictionGeneralInformation {
        data = typeof data === 'object' ? data : {};
        let result = new LiaRestrictionGeneralInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["hasRevocationOrProhibition"] = this.hasRevocationOrProhibition ? this.hasRevocationOrProhibition.toJSON() : <any>undefined;
        data["hasRevocationOrProhibitionId"] = this.hasRevocationOrProhibitionId;
        data["hasConditionalApproval"] = this.hasConditionalApproval ? this.hasConditionalApproval.toJSON() : <any>undefined;
        data["hasConditionalApprovalId"] = this.hasConditionalApprovalId;
        data["hasImpairment"] = this.hasImpairment ? this.hasImpairment.toJSON() : <any>undefined;
        data["hasImpairmentId"] = this.hasImpairmentId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaRestrictionGeneralInformation {
    liaApplication: LiaApplication;
    hasRevocationOrProhibition: Code;
    hasRevocationOrProhibitionId: string | undefined;
    hasConditionalApproval: Code;
    hasConditionalApprovalId: string | undefined;
    hasImpairment: Code;
    hasImpairmentId: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum LiaRestrictionType {
    RevocationOrProhibition = 0,
    ConditionalApproval = 1,
    Impairment = 2,
}

export class LiaResultDocument implements ILiaResultDocument {
    liaApplication!: LiaApplication;
    liaApplicationId!: number;
    type!: Code;
    typeId!: string | undefined;
    name!: string | undefined;
    mimeHeader!: string | undefined;
    binaryObject!: BinaryObject;
    binaryObjectId!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaResultDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaApplication = new LiaApplication();
            this.type = new Code();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : new LiaApplication();
            this.liaApplicationId = _data["liaApplicationId"];
            this.type = _data["type"] ? Code.fromJS(_data["type"]) : new Code();
            this.typeId = _data["typeId"];
            this.name = _data["name"];
            this.mimeHeader = _data["mimeHeader"];
            this.binaryObject = _data["binaryObject"] ? BinaryObject.fromJS(_data["binaryObject"]) : <any>undefined;
            this.binaryObjectId = _data["binaryObjectId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaResultDocument {
        data = typeof data === 'object' ? data : {};
        let result = new LiaResultDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["liaApplicationId"] = this.liaApplicationId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["name"] = this.name;
        data["mimeHeader"] = this.mimeHeader;
        data["binaryObject"] = this.binaryObject ? this.binaryObject.toJSON() : <any>undefined;
        data["binaryObjectId"] = this.binaryObjectId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaResultDocument {
    liaApplication: LiaApplication;
    liaApplicationId: number;
    type: Code;
    typeId: string | undefined;
    name: string | undefined;
    mimeHeader: string | undefined;
    binaryObject: BinaryObject;
    binaryObjectId: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LiaSelfEmployment implements ILiaSelfEmployment {
    liaApplication!: LiaApplication;
    isSelfEmployedId!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaSelfEmployment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : <any>undefined;
            this.isSelfEmployedId = _data["isSelfEmployedId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaSelfEmployment {
        data = typeof data === 'object' ? data : {};
        let result = new LiaSelfEmployment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["isSelfEmployedId"] = this.isSelfEmployedId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaSelfEmployment {
    liaApplication: LiaApplication;
    isSelfEmployedId: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum LiaStatus {
    Person = 0,
    Contact = 2,
    Restriction = 3,
    Employment = 5,
    InvoiceAddress = 6,
    Document = 7,
    LanguageSkill = 8,
    AcademicTitle = 10,
    EmploymentB = 11,
    Vaccination = 19,
    TherapyMethod = 20,
    ProfessionalResponsibility = 21,
    SelfEmployment = 51,
    EhcLanguageSkill = 52,
    EmploymentOrPostgraduateTitle = 53,
    ElectronicPatientRecord = 54,
    Practice = 55,
    QualityRequirement = 56,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export class LiaTherapyMethod implements ILiaTherapyMethod {
    liaApplication!: LiaApplication;
    methods!: string | undefined;
    remedies!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaTherapyMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : <any>undefined;
            this.methods = _data["methods"];
            this.remedies = _data["remedies"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaTherapyMethod {
        data = typeof data === 'object' ? data : {};
        let result = new LiaTherapyMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["methods"] = this.methods;
        data["remedies"] = this.remedies;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaTherapyMethod {
    liaApplication: LiaApplication;
    methods: string | undefined;
    remedies: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CreateOrUpdateLiaTherapyMethodInput implements ICreateOrUpdateLiaTherapyMethodInput {
    caseId!: string;
    liaTherapyMethod!: LiaTherapyMethodDto;

    constructor(data?: ICreateOrUpdateLiaTherapyMethodInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.liaTherapyMethod = _data["liaTherapyMethod"] ? LiaTherapyMethodDto.fromJS(_data["liaTherapyMethod"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaTherapyMethodInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaTherapyMethodInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["liaTherapyMethod"] = this.liaTherapyMethod ? this.liaTherapyMethod.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaTherapyMethodInput {
    caseId: string;
    liaTherapyMethod: LiaTherapyMethodDto;
}

export class LiaTherapyMethodDto implements ILiaTherapyMethodDto {
    methods!: string | undefined;
    remedies!: string | undefined;
    therapyMethodDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaTherapyMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.methods = _data["methods"];
            this.remedies = _data["remedies"];
            if (Array.isArray(_data["therapyMethodDocuments"])) {
                this.therapyMethodDocuments = [] as any;
                for (let item of _data["therapyMethodDocuments"])
                    this.therapyMethodDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaTherapyMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaTherapyMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["methods"] = this.methods;
        data["remedies"] = this.remedies;
        if (Array.isArray(this.therapyMethodDocuments)) {
            data["therapyMethodDocuments"] = [];
            for (let item of this.therapyMethodDocuments)
                data["therapyMethodDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaTherapyMethodDto {
    methods: string | undefined;
    remedies: string | undefined;
    therapyMethodDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class LiaVaccination implements ILiaVaccination {
    liaApplication!: LiaApplication;
    requestVaccinationLicence!: Code;
    requestVaccinationLicenceId!: string | undefined;
    confirmVaccinationRequirementsRead!: boolean;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILiaVaccination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.requestVaccinationLicence = new Code();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplication = _data["liaApplication"] ? LiaApplication.fromJS(_data["liaApplication"]) : <any>undefined;
            this.requestVaccinationLicence = _data["requestVaccinationLicence"] ? Code.fromJS(_data["requestVaccinationLicence"]) : new Code();
            this.requestVaccinationLicenceId = _data["requestVaccinationLicenceId"];
            this.confirmVaccinationRequirementsRead = _data["confirmVaccinationRequirementsRead"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaVaccination {
        data = typeof data === 'object' ? data : {};
        let result = new LiaVaccination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplication"] = this.liaApplication ? this.liaApplication.toJSON() : <any>undefined;
        data["requestVaccinationLicence"] = this.requestVaccinationLicence ? this.requestVaccinationLicence.toJSON() : <any>undefined;
        data["requestVaccinationLicenceId"] = this.requestVaccinationLicenceId;
        data["confirmVaccinationRequirementsRead"] = this.confirmVaccinationRequirementsRead;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaVaccination {
    liaApplication: LiaApplication;
    requestVaccinationLicence: Code;
    requestVaccinationLicenceId: string | undefined;
    confirmVaccinationRequirementsRead: boolean;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CreateOrUpdateLiaPersonOutputDto implements ICreateOrUpdateLiaPersonOutputDto {
    healthRegisterIdentificationStatus!: HealthRegisterIdentificationStatus;
    healthRegisterSystem!: ExternalSystemEnum;
    healthRegisterId!: number | undefined;
    liaPerson!: LiaPersonDto;

    constructor(data?: ICreateOrUpdateLiaPersonOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRegisterIdentificationStatus = _data["healthRegisterIdentificationStatus"];
            this.healthRegisterSystem = _data["healthRegisterSystem"];
            this.healthRegisterId = _data["healthRegisterId"];
            this.liaPerson = _data["liaPerson"] ? LiaPersonDto.fromJS(_data["liaPerson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaPersonOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaPersonOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRegisterIdentificationStatus"] = this.healthRegisterIdentificationStatus;
        data["healthRegisterSystem"] = this.healthRegisterSystem;
        data["healthRegisterId"] = this.healthRegisterId;
        data["liaPerson"] = this.liaPerson ? this.liaPerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaPersonOutputDto {
    healthRegisterIdentificationStatus: HealthRegisterIdentificationStatus;
    healthRegisterSystem: ExternalSystemEnum;
    healthRegisterId: number | undefined;
    liaPerson: LiaPersonDto;
}

export class CreateOrUpdateLiaPersonWithRegisterCheckInput implements ICreateOrUpdateLiaPersonWithRegisterCheckInput {
    caseId!: string;
    gln!: string;

    constructor(data?: ICreateOrUpdateLiaPersonWithRegisterCheckInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.gln = _data["gln"];
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaPersonWithRegisterCheckInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaPersonWithRegisterCheckInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["gln"] = this.gln;
        return data;
    }
}

export interface ICreateOrUpdateLiaPersonWithRegisterCheckInput {
    caseId: string;
    gln: string;
}

export class CreateOrUpdateLiaPersonWithoutRegisterCheckInput implements ICreateOrUpdateLiaPersonWithoutRegisterCheckInput {
    caseId!: string;
    liaPerson!: LiaPersonWithoutRegisterCheckDto;

    constructor(data?: ICreateOrUpdateLiaPersonWithoutRegisterCheckInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaPerson = new LiaPersonWithoutRegisterCheckDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.liaPerson = _data["liaPerson"] ? LiaPersonWithoutRegisterCheckDto.fromJS(_data["liaPerson"]) : new LiaPersonWithoutRegisterCheckDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaPersonWithoutRegisterCheckInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaPersonWithoutRegisterCheckInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["liaPerson"] = this.liaPerson ? this.liaPerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaPersonWithoutRegisterCheckInput {
    caseId: string;
    liaPerson: LiaPersonWithoutRegisterCheckDto;
}

export class CreateOrUpdateLiaPersonWithoutRegisterCheckOutputDto implements ICreateOrUpdateLiaPersonWithoutRegisterCheckOutputDto {
    liaPerson!: LiaPersonWithoutRegisterCheckDto;
    status!: LiaStatus;

    constructor(data?: ICreateOrUpdateLiaPersonWithoutRegisterCheckOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaPerson = _data["liaPerson"] ? LiaPersonWithoutRegisterCheckDto.fromJS(_data["liaPerson"]) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaPersonWithoutRegisterCheckOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaPersonWithoutRegisterCheckOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaPerson"] = this.liaPerson ? this.liaPerson.toJSON() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface ICreateOrUpdateLiaPersonWithoutRegisterCheckOutputDto {
    liaPerson: LiaPersonWithoutRegisterCheckDto;
    status: LiaStatus;
}

export class LiaPersonDto implements ILiaPersonDto {
    firstName!: string;
    lastName!: string;
    birthName!: string | undefined;
    genderId!: string | undefined;
    nationality1Id!: string | undefined;
    nationality2Id!: string | undefined;
    residencePermit!: boolean | undefined;
    dateOfResidencePermit!: DateTime | undefined;
    gln!: string | undefined;
    zsr!: string | undefined;
    uid!: string | undefined;
    hasConfirmedData!: boolean | undefined;
    hasLicenceInAnotherCantonId!: string | undefined;
    medRegId!: number | undefined;
    psyRegId!: number | undefined;
    naregId!: number | undefined;
    healthRegisterResult!: HealthRegisterIdentificationStatus;
    personDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.genderId = _data["genderId"];
            this.nationality1Id = _data["nationality1Id"];
            this.nationality2Id = _data["nationality2Id"];
            this.residencePermit = _data["residencePermit"];
            this.dateOfResidencePermit = _data["dateOfResidencePermit"] ? DateTime.fromISO(_data["dateOfResidencePermit"].toString()) : <any>undefined;
            this.gln = _data["gln"];
            this.zsr = _data["zsr"];
            this.uid = _data["uid"];
            this.hasConfirmedData = _data["hasConfirmedData"];
            this.hasLicenceInAnotherCantonId = _data["hasLicenceInAnotherCantonId"];
            this.medRegId = _data["medRegId"];
            this.psyRegId = _data["psyRegId"];
            this.naregId = _data["naregId"];
            this.healthRegisterResult = _data["healthRegisterResult"];
            if (Array.isArray(_data["personDocuments"])) {
                this.personDocuments = [] as any;
                for (let item of _data["personDocuments"])
                    this.personDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["genderId"] = this.genderId;
        data["nationality1Id"] = this.nationality1Id;
        data["nationality2Id"] = this.nationality2Id;
        data["residencePermit"] = this.residencePermit;
        data["dateOfResidencePermit"] = this.dateOfResidencePermit ? this.dateOfResidencePermit.toFormat('yyyy-MM-dd') : <any>undefined;
        data["gln"] = this.gln;
        data["zsr"] = this.zsr;
        data["uid"] = this.uid;
        data["hasConfirmedData"] = this.hasConfirmedData;
        data["hasLicenceInAnotherCantonId"] = this.hasLicenceInAnotherCantonId;
        data["medRegId"] = this.medRegId;
        data["psyRegId"] = this.psyRegId;
        data["naregId"] = this.naregId;
        data["healthRegisterResult"] = this.healthRegisterResult;
        if (Array.isArray(this.personDocuments)) {
            data["personDocuments"] = [];
            for (let item of this.personDocuments)
                data["personDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaPersonDto {
    firstName: string;
    lastName: string;
    birthName: string | undefined;
    genderId: string | undefined;
    nationality1Id: string | undefined;
    nationality2Id: string | undefined;
    residencePermit: boolean | undefined;
    dateOfResidencePermit: DateTime | undefined;
    gln: string | undefined;
    zsr: string | undefined;
    uid: string | undefined;
    hasConfirmedData: boolean | undefined;
    hasLicenceInAnotherCantonId: string | undefined;
    medRegId: number | undefined;
    psyRegId: number | undefined;
    naregId: number | undefined;
    healthRegisterResult: HealthRegisterIdentificationStatus;
    personDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class LiaPersonWithoutRegisterCheckDto implements ILiaPersonWithoutRegisterCheckDto {
    dateOfBirth!: DateTime | undefined;
    ahv!: string | undefined;
    placeOfOrigin!: string | undefined;
    firstName!: string;
    lastName!: string;
    birthName!: string | undefined;
    genderId!: string | undefined;
    nationality1Id!: string | undefined;
    nationality2Id!: string | undefined;
    residencePermit!: boolean | undefined;
    dateOfResidencePermit!: DateTime | undefined;
    gln!: string | undefined;
    zsr!: string | undefined;
    uid!: string | undefined;
    hasConfirmedData!: boolean | undefined;
    hasLicenceInAnotherCantonId!: string | undefined;
    medRegId!: number | undefined;
    psyRegId!: number | undefined;
    naregId!: number | undefined;
    healthRegisterResult!: HealthRegisterIdentificationStatus;
    personDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaPersonWithoutRegisterCheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.ahv = _data["ahv"];
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.genderId = _data["genderId"];
            this.nationality1Id = _data["nationality1Id"];
            this.nationality2Id = _data["nationality2Id"];
            this.residencePermit = _data["residencePermit"];
            this.dateOfResidencePermit = _data["dateOfResidencePermit"] ? DateTime.fromISO(_data["dateOfResidencePermit"].toString()) : <any>undefined;
            this.gln = _data["gln"];
            this.zsr = _data["zsr"];
            this.uid = _data["uid"];
            this.hasConfirmedData = _data["hasConfirmedData"];
            this.hasLicenceInAnotherCantonId = _data["hasLicenceInAnotherCantonId"];
            this.medRegId = _data["medRegId"];
            this.psyRegId = _data["psyRegId"];
            this.naregId = _data["naregId"];
            this.healthRegisterResult = _data["healthRegisterResult"];
            if (Array.isArray(_data["personDocuments"])) {
                this.personDocuments = [] as any;
                for (let item of _data["personDocuments"])
                    this.personDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaPersonWithoutRegisterCheckDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaPersonWithoutRegisterCheckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["ahv"] = this.ahv;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["genderId"] = this.genderId;
        data["nationality1Id"] = this.nationality1Id;
        data["nationality2Id"] = this.nationality2Id;
        data["residencePermit"] = this.residencePermit;
        data["dateOfResidencePermit"] = this.dateOfResidencePermit ? this.dateOfResidencePermit.toFormat('yyyy-MM-dd') : <any>undefined;
        data["gln"] = this.gln;
        data["zsr"] = this.zsr;
        data["uid"] = this.uid;
        data["hasConfirmedData"] = this.hasConfirmedData;
        data["hasLicenceInAnotherCantonId"] = this.hasLicenceInAnotherCantonId;
        data["medRegId"] = this.medRegId;
        data["psyRegId"] = this.psyRegId;
        data["naregId"] = this.naregId;
        data["healthRegisterResult"] = this.healthRegisterResult;
        if (Array.isArray(this.personDocuments)) {
            data["personDocuments"] = [];
            for (let item of this.personDocuments)
                data["personDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaPersonWithoutRegisterCheckDto {
    dateOfBirth: DateTime | undefined;
    ahv: string | undefined;
    placeOfOrigin: string | undefined;
    firstName: string;
    lastName: string;
    birthName: string | undefined;
    genderId: string | undefined;
    nationality1Id: string | undefined;
    nationality2Id: string | undefined;
    residencePermit: boolean | undefined;
    dateOfResidencePermit: DateTime | undefined;
    gln: string | undefined;
    zsr: string | undefined;
    uid: string | undefined;
    hasConfirmedData: boolean | undefined;
    hasLicenceInAnotherCantonId: string | undefined;
    medRegId: number | undefined;
    psyRegId: number | undefined;
    naregId: number | undefined;
    healthRegisterResult: HealthRegisterIdentificationStatus;
    personDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class CreateOrUpdateLiaPracticesInput implements ICreateOrUpdateLiaPracticesInput {
    caseId!: string;
    liaPractice!: LiaPracticeDto;

    constructor(data?: ICreateOrUpdateLiaPracticesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaPractice = new LiaPracticeDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.liaPractice = _data["liaPractice"] ? LiaPracticeDto.fromJS(_data["liaPractice"]) : new LiaPracticeDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaPracticesInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaPracticesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["liaPractice"] = this.liaPractice ? this.liaPractice.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaPracticesInput {
    caseId: string;
    liaPractice: LiaPracticeDto;
}

export class CreateOrUpdateLiaPracticesOutput implements ICreateOrUpdateLiaPracticesOutput {
    status!: LiaStatus;
    liaPractice!: LiaPracticeDto;

    constructor(data?: ICreateOrUpdateLiaPracticesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.liaPractice = _data["liaPractice"] ? LiaPracticeDto.fromJS(_data["liaPractice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaPracticesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaPracticesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["liaPractice"] = this.liaPractice ? this.liaPractice.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaPracticesOutput {
    status: LiaStatus;
    liaPractice: LiaPracticeDto;
}

export class CreateOrUpdateLiaRestrictionsInput implements ICreateOrUpdateLiaRestrictionsInput {
    caseId!: string;
    liaRestrictions!: LiaRestrictionDto[];
    generalInformation!: LiaRestrictionGeneralInformationDto;

    constructor(data?: ICreateOrUpdateLiaRestrictionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaRestrictions = [];
            this.generalInformation = new LiaRestrictionGeneralInformationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["liaRestrictions"])) {
                this.liaRestrictions = [] as any;
                for (let item of _data["liaRestrictions"])
                    this.liaRestrictions!.push(LiaRestrictionDto.fromJS(item));
            }
            this.generalInformation = _data["generalInformation"] ? LiaRestrictionGeneralInformationDto.fromJS(_data["generalInformation"]) : new LiaRestrictionGeneralInformationDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaRestrictionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaRestrictionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.liaRestrictions)) {
            data["liaRestrictions"] = [];
            for (let item of this.liaRestrictions)
                data["liaRestrictions"].push(item.toJSON());
        }
        data["generalInformation"] = this.generalInformation ? this.generalInformation.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaRestrictionsInput {
    caseId: string;
    liaRestrictions: LiaRestrictionDto[];
    generalInformation: LiaRestrictionGeneralInformationDto;
}

export class LiaRestrictionDto implements ILiaRestrictionDto {
    restrictionType!: LiaRestrictionType;
    cantonId!: string;
    reason!: string | undefined;

    constructor(data?: ILiaRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.restrictionType = _data["restrictionType"];
            this.cantonId = _data["cantonId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): LiaRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["restrictionType"] = this.restrictionType;
        data["cantonId"] = this.cantonId;
        data["reason"] = this.reason;
        return data;
    }
}

export interface ILiaRestrictionDto {
    restrictionType: LiaRestrictionType;
    cantonId: string;
    reason: string | undefined;
}

export class LiaRestrictionGeneralInformationDto implements ILiaRestrictionGeneralInformationDto {
    hasRevocationOrProhibitionId!: string | undefined;
    hasConditionalApprovalId!: string | undefined;
    hasImpairmentId!: string | undefined;

    constructor(data?: ILiaRestrictionGeneralInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasRevocationOrProhibitionId = _data["hasRevocationOrProhibitionId"];
            this.hasConditionalApprovalId = _data["hasConditionalApprovalId"];
            this.hasImpairmentId = _data["hasImpairmentId"];
        }
    }

    static fromJS(data: any): LiaRestrictionGeneralInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaRestrictionGeneralInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasRevocationOrProhibitionId"] = this.hasRevocationOrProhibitionId;
        data["hasConditionalApprovalId"] = this.hasConditionalApprovalId;
        data["hasImpairmentId"] = this.hasImpairmentId;
        return data;
    }
}

export interface ILiaRestrictionGeneralInformationDto {
    hasRevocationOrProhibitionId: string | undefined;
    hasConditionalApprovalId: string | undefined;
    hasImpairmentId: string | undefined;
}

export class LiaRestrictionOutput implements ILiaRestrictionOutput {
    restrictions!: LiaRestrictionDto[] | undefined;
    generalInformation!: LiaRestrictionGeneralInformationDto;
    restrictionDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaRestrictionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(LiaRestrictionDto.fromJS(item));
            }
            this.generalInformation = _data["generalInformation"] ? LiaRestrictionGeneralInformationDto.fromJS(_data["generalInformation"]) : <any>undefined;
            if (Array.isArray(_data["restrictionDocuments"])) {
                this.restrictionDocuments = [] as any;
                for (let item of _data["restrictionDocuments"])
                    this.restrictionDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaRestrictionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LiaRestrictionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        data["generalInformation"] = this.generalInformation ? this.generalInformation.toJSON() : <any>undefined;
        if (Array.isArray(this.restrictionDocuments)) {
            data["restrictionDocuments"] = [];
            for (let item of this.restrictionDocuments)
                data["restrictionDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaRestrictionOutput {
    restrictions: LiaRestrictionDto[] | undefined;
    generalInformation: LiaRestrictionGeneralInformationDto;
    restrictionDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class CreateLiaTypeInput implements ICreateLiaTypeInput {
    applicationTypeId!: ApplicationType;
    professionId!: string;

    constructor(data?: ICreateLiaTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationTypeId = _data["applicationTypeId"];
            this.professionId = _data["professionId"];
        }
    }

    static fromJS(data: any): CreateLiaTypeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLiaTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationTypeId"] = this.applicationTypeId;
        data["professionId"] = this.professionId;
        return data;
    }
}

export interface ICreateLiaTypeInput {
    applicationTypeId: ApplicationType;
    professionId: string;
}

export class CreateLiaTypeOutput implements ICreateLiaTypeOutput {
    caseId!: string | undefined;

    constructor(data?: ICreateLiaTypeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): CreateLiaTypeOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLiaTypeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface ICreateLiaTypeOutput {
    caseId: string | undefined;
}

export class GetEhcPersonalLicenceDto implements IGetEhcPersonalLicenceDto {
    licenceId!: number | undefined;
    personId!: number | undefined;

    constructor(data?: IGetEhcPersonalLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceId = _data["licenceId"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): GetEhcPersonalLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEhcPersonalLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceId"] = this.licenceId;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IGetEhcPersonalLicenceDto {
    licenceId: number | undefined;
    personId: number | undefined;
}

export class CreateOrUpdateLiaVaccinationInputDto implements ICreateOrUpdateLiaVaccinationInputDto {
    caseId!: string;
    liaVaccination!: LiaVaccinationDto;

    constructor(data?: ICreateOrUpdateLiaVaccinationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaVaccination = new LiaVaccinationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.liaVaccination = _data["liaVaccination"] ? LiaVaccinationDto.fromJS(_data["liaVaccination"]) : new LiaVaccinationDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaVaccinationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaVaccinationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["liaVaccination"] = this.liaVaccination ? this.liaVaccination.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaVaccinationInputDto {
    caseId: string;
    liaVaccination: LiaVaccinationDto;
}

export class LiaVaccinationDto implements ILiaVaccinationDto {
    requestVaccinationLicenceId!: string | undefined;
    confirmVaccinationRequirementsRead!: boolean;

    constructor(data?: ILiaVaccinationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestVaccinationLicenceId = _data["requestVaccinationLicenceId"];
            this.confirmVaccinationRequirementsRead = _data["confirmVaccinationRequirementsRead"];
        }
    }

    static fromJS(data: any): LiaVaccinationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaVaccinationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestVaccinationLicenceId"] = this.requestVaccinationLicenceId;
        data["confirmVaccinationRequirementsRead"] = this.confirmVaccinationRequirementsRead;
        return data;
    }
}

export interface ILiaVaccinationDto {
    requestVaccinationLicenceId: string | undefined;
    confirmVaccinationRequirementsRead: boolean;
}

export class LiaVaccinationOutputDto implements ILiaVaccinationOutputDto {
    vaccination!: LiaVaccinationDto;
    vaccinationDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaVaccinationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vaccination = _data["vaccination"] ? LiaVaccinationDto.fromJS(_data["vaccination"]) : <any>undefined;
            if (Array.isArray(_data["vaccinationDocuments"])) {
                this.vaccinationDocuments = [] as any;
                for (let item of _data["vaccinationDocuments"])
                    this.vaccinationDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaVaccinationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaVaccinationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vaccination"] = this.vaccination ? this.vaccination.toJSON() : <any>undefined;
        if (Array.isArray(this.vaccinationDocuments)) {
            data["vaccinationDocuments"] = [];
            for (let item of this.vaccinationDocuments)
                data["vaccinationDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaVaccinationOutputDto {
    vaccination: LiaVaccinationDto;
    vaccinationDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
    id!: number | undefined;
    name!: string;
    icon!: string | undefined;
    isEnabled!: boolean;

    constructor(data?: IApplicationLanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): ApplicationLanguageEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IApplicationLanguageEditDto {
    id: number | undefined;
    name: string;
    icon: string | undefined;
    isEnabled: boolean;
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
    tenantId!: number | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    icon!: string | undefined;
    isDisabled!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.icon = _data["icon"];
            this.isDisabled = _data["isDisabled"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationLanguageListDto {
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language!: ApplicationLanguageEditDto;

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.language = new ApplicationLanguageEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : new ApplicationLanguageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language!: ApplicationLanguageEditDto;
    languageNames!: ComboboxItemDto[] | undefined;
    flags!: ComboboxItemDto[] | undefined;

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : <any>undefined;
            if (Array.isArray(_data["languageNames"])) {
                this.languageNames = [] as any;
                for (let item of _data["languageNames"])
                    this.languageNames!.push(ComboboxItemDto.fromJS(item));
            }
            if (Array.isArray(_data["flags"])) {
                this.flags = [] as any;
                for (let item of _data["flags"])
                    this.flags!.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        if (Array.isArray(this.languageNames)) {
            data["languageNames"] = [];
            for (let item of this.languageNames)
                data["languageNames"].push(item.toJSON());
        }
        if (Array.isArray(this.flags)) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[] | undefined;
    flags: ComboboxItemDto[] | undefined;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    defaultLanguageName!: string | undefined;
    items!: ApplicationLanguageListDto[] | undefined;

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultLanguageName = _data["defaultLanguageName"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApplicationLanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguagesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageName"] = this.defaultLanguageName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguagesOutput {
    defaultLanguageName: string | undefined;
    items: ApplicationLanguageListDto[] | undefined;
}

export class LanguageTextListDto implements ILanguageTextListDto {
    key!: string | undefined;
    baseValue!: string | undefined;
    targetValue!: string | undefined;
    isCustomised!: boolean;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.baseValue = _data["baseValue"];
            this.targetValue = _data["targetValue"];
            this.isCustomised = _data["isCustomised"];
        }
    }

    static fromJS(data: any): LanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        data["isCustomised"] = this.isCustomised;
        return data;
    }
}

export interface ILanguageTextListDto {
    key: string | undefined;
    baseValue: string | undefined;
    targetValue: string | undefined;
    isCustomised: boolean;
}

export class ResetLanguageTextInput implements IResetLanguageTextInput {
    languageName!: string;
    sourceName!: string;
    key!: string;

    constructor(data?: IResetLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
            this.sourceName = _data["sourceName"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): ResetLanguageTextInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        return data;
    }
}

export interface IResetLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name!: string;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SetDefaultLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ISetDefaultLanguageInput {
    name: string;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName!: string;
    sourceName!: string;
    key!: string;
    value!: string;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
            this.sourceName = _data["sourceName"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateLanguageTextInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;
}

export class CreateOrUpdateLogbookDto implements ICreateOrUpdateLogbookDto {
    date!: DateTime;
    contactTypeId!: string;
    contextId!: string | undefined;
    subject!: string;
    contactPerson!: string | undefined;
    description!: string;
    documentId!: number | undefined;

    constructor(data?: ICreateOrUpdateLogbookDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.contactTypeId = _data["contactTypeId"];
            this.contextId = _data["contextId"];
            this.subject = _data["subject"];
            this.contactPerson = _data["contactPerson"];
            this.description = _data["description"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): CreateOrUpdateLogbookDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLogbookDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toFormat('yyyy-MM-dd') : <any>undefined;
        data["contactTypeId"] = this.contactTypeId;
        data["contextId"] = this.contextId;
        data["subject"] = this.subject;
        data["contactPerson"] = this.contactPerson;
        data["description"] = this.description;
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface ICreateOrUpdateLogbookDto {
    date: DateTime;
    contactTypeId: string;
    contextId: string | undefined;
    subject: string;
    contactPerson: string | undefined;
    description: string;
    documentId: number | undefined;
}

export class GetLogbookDto implements IGetLogbookDto {
    date!: DateTime;
    contactTypeId!: string | undefined;
    contextId!: string | undefined;
    subject!: string | undefined;
    contactPerson!: string | undefined;
    description!: string | undefined;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: DateTime;
    numberOfPendences!: number;
    document!: LogbookDocumentDto;
    id!: number;

    constructor(data?: IGetLogbookDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.contactTypeId = _data["contactTypeId"];
            this.contextId = _data["contextId"];
            this.subject = _data["subject"];
            this.contactPerson = _data["contactPerson"];
            this.description = _data["description"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.numberOfPendences = _data["numberOfPendences"];
            this.document = _data["document"] ? LogbookDocumentDto.fromJS(_data["document"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetLogbookDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLogbookDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toFormat('yyyy-MM-dd') : <any>undefined;
        data["contactTypeId"] = this.contactTypeId;
        data["contextId"] = this.contextId;
        data["subject"] = this.subject;
        data["contactPerson"] = this.contactPerson;
        data["description"] = this.description;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toFormat('yyyy-MM-dd') : <any>undefined;
        data["numberOfPendences"] = this.numberOfPendences;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetLogbookDto {
    date: DateTime;
    contactTypeId: string | undefined;
    contextId: string | undefined;
    subject: string | undefined;
    contactPerson: string | undefined;
    description: string | undefined;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: DateTime;
    numberOfPendences: number;
    document: LogbookDocumentDto;
    id: number;
}

export class LogbookDocumentDto implements ILogbookDocumentDto {
    id!: number;
    name!: string | undefined;
    mimeType!: string | undefined;

    constructor(data?: ILogbookDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): LogbookDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogbookDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["mimeType"] = this.mimeType;
        return data;
    }
}

export interface ILogbookDocumentDto {
    id: number;
    name: string | undefined;
    mimeType: string | undefined;
}

export class LogbookSearchInput implements ILogbookSearchInput {
    discriminator!: LogbookType;
    entityId!: number;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: ILogbookSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.entityId = _data["entityId"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): LogbookSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new LogbookSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["entityId"] = this.entityId;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface ILogbookSearchInput {
    discriminator: LogbookType;
    entityId: number;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class LogbookSearchOutput implements ILogbookSearchOutput {
    totalCount!: number;
    items!: GetLogbookDto[] | undefined;

    constructor(data?: ILogbookSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetLogbookDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LogbookSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LogbookSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILogbookSearchOutput {
    totalCount: number;
    items: GetLogbookDto[] | undefined;
}

export class LogbookBaseEntity implements ILogbookBaseEntity {
    discriminator!: LogbookType;
    date!: DateTime;
    contactTypeId!: string;
    contextId!: string | undefined;
    subject!: string;
    contactPerson!: string | undefined;
    description!: string;
    documentLinks!: DocumentLinkLogbook[] | undefined;
    pendences!: PendenceLinkLogbook[] | undefined;
    migrationData!: MigrationData[] | undefined;
    isDeleted!: boolean;
    deleterUser!: User;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    creatorUser!: User;
    lastModifierUser!: User;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILogbookBaseEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.contactTypeId = _data["contactTypeId"];
            this.contextId = _data["contextId"];
            this.subject = _data["subject"];
            this.contactPerson = _data["contactPerson"];
            this.description = _data["description"];
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkLogbook.fromJS(item));
            }
            if (Array.isArray(_data["pendences"])) {
                this.pendences = [] as any;
                for (let item of _data["pendences"])
                    this.pendences!.push(PendenceLinkLogbook.fromJS(item));
            }
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LogbookBaseEntity {
        data = typeof data === 'object' ? data : {};
        let result = new LogbookBaseEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["date"] = this.date ? this.date.toFormat('yyyy-MM-dd') : <any>undefined;
        data["contactTypeId"] = this.contactTypeId;
        data["contextId"] = this.contextId;
        data["subject"] = this.subject;
        data["contactPerson"] = this.contactPerson;
        data["description"] = this.description;
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.pendences)) {
            data["pendences"] = [];
            for (let item of this.pendences)
                data["pendences"].push(item.toJSON());
        }
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILogbookBaseEntity {
    discriminator: LogbookType;
    date: DateTime;
    contactTypeId: string;
    contextId: string | undefined;
    subject: string;
    contactPerson: string | undefined;
    description: string;
    documentLinks: DocumentLinkLogbook[] | undefined;
    pendences: PendenceLinkLogbook[] | undefined;
    migrationData: MigrationData[] | undefined;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LogbookBusiness implements ILogbookBusiness {
    business!: Business;
    businessId!: number;
    discriminator!: LogbookType;
    date!: DateTime;
    contactTypeId!: string;
    contextId!: string | undefined;
    subject!: string;
    contactPerson!: string | undefined;
    description!: string;
    documentLinks!: DocumentLinkLogbook[] | undefined;
    pendences!: PendenceLinkLogbook[] | undefined;
    migrationData!: MigrationData[] | undefined;
    isDeleted!: boolean;
    deleterUser!: User;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    creatorUser!: User;
    lastModifierUser!: User;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILogbookBusiness) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.business = _data["business"] ? Business.fromJS(_data["business"]) : <any>undefined;
            this.businessId = _data["businessId"];
            this.discriminator = _data["discriminator"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.contactTypeId = _data["contactTypeId"];
            this.contextId = _data["contextId"];
            this.subject = _data["subject"];
            this.contactPerson = _data["contactPerson"];
            this.description = _data["description"];
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkLogbook.fromJS(item));
            }
            if (Array.isArray(_data["pendences"])) {
                this.pendences = [] as any;
                for (let item of _data["pendences"])
                    this.pendences!.push(PendenceLinkLogbook.fromJS(item));
            }
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LogbookBusiness {
        data = typeof data === 'object' ? data : {};
        let result = new LogbookBusiness();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        data["businessId"] = this.businessId;
        data["discriminator"] = this.discriminator;
        data["date"] = this.date ? this.date.toFormat('yyyy-MM-dd') : <any>undefined;
        data["contactTypeId"] = this.contactTypeId;
        data["contextId"] = this.contextId;
        data["subject"] = this.subject;
        data["contactPerson"] = this.contactPerson;
        data["description"] = this.description;
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.pendences)) {
            data["pendences"] = [];
            for (let item of this.pendences)
                data["pendences"].push(item.toJSON());
        }
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILogbookBusiness {
    business: Business;
    businessId: number;
    discriminator: LogbookType;
    date: DateTime;
    contactTypeId: string;
    contextId: string | undefined;
    subject: string;
    contactPerson: string | undefined;
    description: string;
    documentLinks: DocumentLinkLogbook[] | undefined;
    pendences: PendenceLinkLogbook[] | undefined;
    migrationData: MigrationData[] | undefined;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LogbookPerson implements ILogbookPerson {
    person!: Person;
    personId!: number;
    discriminator!: LogbookType;
    date!: DateTime;
    contactTypeId!: string;
    contextId!: string | undefined;
    subject!: string;
    contactPerson!: string | undefined;
    description!: string;
    documentLinks!: DocumentLinkLogbook[] | undefined;
    pendences!: PendenceLinkLogbook[] | undefined;
    migrationData!: MigrationData[] | undefined;
    isDeleted!: boolean;
    deleterUser!: User;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    creatorUser!: User;
    lastModifierUser!: User;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILogbookPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.personId = _data["personId"];
            this.discriminator = _data["discriminator"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.contactTypeId = _data["contactTypeId"];
            this.contextId = _data["contextId"];
            this.subject = _data["subject"];
            this.contactPerson = _data["contactPerson"];
            this.description = _data["description"];
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkLogbook.fromJS(item));
            }
            if (Array.isArray(_data["pendences"])) {
                this.pendences = [] as any;
                for (let item of _data["pendences"])
                    this.pendences!.push(PendenceLinkLogbook.fromJS(item));
            }
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LogbookPerson {
        data = typeof data === 'object' ? data : {};
        let result = new LogbookPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["discriminator"] = this.discriminator;
        data["date"] = this.date ? this.date.toFormat('yyyy-MM-dd') : <any>undefined;
        data["contactTypeId"] = this.contactTypeId;
        data["contextId"] = this.contextId;
        data["subject"] = this.subject;
        data["contactPerson"] = this.contactPerson;
        data["description"] = this.description;
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.pendences)) {
            data["pendences"] = [];
            for (let item of this.pendences)
                data["pendences"].push(item.toJSON());
        }
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILogbookPerson {
    person: Person;
    personId: number;
    discriminator: LogbookType;
    date: DateTime;
    contactTypeId: string;
    contextId: string | undefined;
    subject: string;
    contactPerson: string | undefined;
    description: string;
    documentLinks: DocumentLinkLogbook[] | undefined;
    pendences: PendenceLinkLogbook[] | undefined;
    migrationData: MigrationData[] | undefined;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LogbookSponsorship implements ILogbookSponsorship {
    sponsorship!: Sponsorship;
    sponsorshipId!: number;
    discriminator!: LogbookType;
    date!: DateTime;
    contactTypeId!: string;
    contextId!: string | undefined;
    subject!: string;
    contactPerson!: string | undefined;
    description!: string;
    documentLinks!: DocumentLinkLogbook[] | undefined;
    pendences!: PendenceLinkLogbook[] | undefined;
    migrationData!: MigrationData[] | undefined;
    isDeleted!: boolean;
    deleterUser!: User;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    creatorUser!: User;
    lastModifierUser!: User;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILogbookSponsorship) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorship = _data["sponsorship"] ? Sponsorship.fromJS(_data["sponsorship"]) : <any>undefined;
            this.sponsorshipId = _data["sponsorshipId"];
            this.discriminator = _data["discriminator"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.contactTypeId = _data["contactTypeId"];
            this.contextId = _data["contextId"];
            this.subject = _data["subject"];
            this.contactPerson = _data["contactPerson"];
            this.description = _data["description"];
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkLogbook.fromJS(item));
            }
            if (Array.isArray(_data["pendences"])) {
                this.pendences = [] as any;
                for (let item of _data["pendences"])
                    this.pendences!.push(PendenceLinkLogbook.fromJS(item));
            }
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LogbookSponsorship {
        data = typeof data === 'object' ? data : {};
        let result = new LogbookSponsorship();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        data["sponsorshipId"] = this.sponsorshipId;
        data["discriminator"] = this.discriminator;
        data["date"] = this.date ? this.date.toFormat('yyyy-MM-dd') : <any>undefined;
        data["contactTypeId"] = this.contactTypeId;
        data["contextId"] = this.contextId;
        data["subject"] = this.subject;
        data["contactPerson"] = this.contactPerson;
        data["description"] = this.description;
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.pendences)) {
            data["pendences"] = [];
            for (let item of this.pendences)
                data["pendences"].push(item.toJSON());
        }
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILogbookSponsorship {
    sponsorship: Sponsorship;
    sponsorshipId: number;
    discriminator: LogbookType;
    date: DateTime;
    contactTypeId: string;
    contextId: string | undefined;
    subject: string;
    contactPerson: string | undefined;
    description: string;
    documentLinks: DocumentLinkLogbook[] | undefined;
    pendences: PendenceLinkLogbook[] | undefined;
    migrationData: MigrationData[] | undefined;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines!: string[] | undefined;

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["latestWebLogLines"])) {
                this.latestWebLogLines = [] as any;
                for (let item of _data["latestWebLogLines"])
                    this.latestWebLogLines!.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latestWebLogLines)) {
            data["latestWebLogLines"] = [];
            for (let item of this.latestWebLogLines)
                data["latestWebLogLines"].push(item);
        }
        return data;
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;
}

export class GetLoggedMailOutput implements IGetLoggedMailOutput {
    totalCount!: number;
    items!: LoggedMailDto[] | undefined;

    constructor(data?: IGetLoggedMailOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LoggedMailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLoggedMailOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLoggedMailOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLoggedMailOutput {
    totalCount: number;
    items: LoggedMailDto[] | undefined;
}

export class LoggedMailAddressDto implements ILoggedMailAddressDto {
    address!: string | undefined;
    displayName!: string | undefined;

    constructor(data?: ILoggedMailAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): LoggedMailAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoggedMailAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ILoggedMailAddressDto {
    address: string | undefined;
    displayName: string | undefined;
}

export class LoggedMailDto implements ILoggedMailDto {
    creationTime!: DateTime;
    subject!: string | undefined;
    body!: string | undefined;
    to!: LoggedMailAddressDto[] | undefined;
    carbonCopy!: LoggedMailAddressDto[] | undefined;
    id!: string;

    constructor(data?: ILoggedMailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.subject = _data["subject"];
            this.body = _data["body"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(LoggedMailAddressDto.fromJS(item));
            }
            if (Array.isArray(_data["carbonCopy"])) {
                this.carbonCopy = [] as any;
                for (let item of _data["carbonCopy"])
                    this.carbonCopy!.push(LoggedMailAddressDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LoggedMailDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoggedMailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["subject"] = this.subject;
        data["body"] = this.body;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item.toJSON());
        }
        if (Array.isArray(this.carbonCopy)) {
            data["carbonCopy"] = [];
            for (let item of this.carbonCopy)
                data["carbonCopy"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ILoggedMailDto {
    creationTime: DateTime;
    subject: string | undefined;
    body: string | undefined;
    to: LoggedMailAddressDto[] | undefined;
    carbonCopy: LoggedMailAddressDto[] | undefined;
    id: string;
}

export class AddEmailToMailDistributionListInput implements IAddEmailToMailDistributionListInput {
    mailDistributionListId!: number;
    name!: string | undefined;
    emailAddress!: string | undefined;

    constructor(data?: IAddEmailToMailDistributionListInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailDistributionListId = _data["mailDistributionListId"];
            this.name = _data["name"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): AddEmailToMailDistributionListInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddEmailToMailDistributionListInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailDistributionListId"] = this.mailDistributionListId;
        data["name"] = this.name;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IAddEmailToMailDistributionListInput {
    mailDistributionListId: number;
    name: string | undefined;
    emailAddress: string | undefined;
}

export class AddUsersToMailDistributionListInput implements IAddUsersToMailDistributionListInput {
    userIds!: number[] | undefined;
    mailDistributionListId!: number;

    constructor(data?: IAddUsersToMailDistributionListInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.mailDistributionListId = _data["mailDistributionListId"];
        }
    }

    static fromJS(data: any): AddUsersToMailDistributionListInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddUsersToMailDistributionListInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["mailDistributionListId"] = this.mailDistributionListId;
        return data;
    }
}

export interface IAddUsersToMailDistributionListInput {
    userIds: number[] | undefined;
    mailDistributionListId: number;
}

export class CreateMailDistributionListInput implements ICreateMailDistributionListInput {
    displayName!: string;

    constructor(data?: ICreateMailDistributionListInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CreateMailDistributionListInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMailDistributionListInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICreateMailDistributionListInput {
    displayName: string;
}

export class FindMailDistributionListDataInput implements IFindMailDistributionListDataInput {
    mailDistributionListId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindMailDistributionListDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailDistributionListId = _data["mailDistributionListId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindMailDistributionListDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindMailDistributionListDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailDistributionListId"] = this.mailDistributionListId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindMailDistributionListDataInput {
    mailDistributionListId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class MailDistributionListConfigurationsDto implements IMailDistributionListConfigurationsDto {
    mailDistributionListId!: number;
    eventType!: MailDistributionEventType[] | undefined;

    constructor(data?: IMailDistributionListConfigurationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailDistributionListId = _data["mailDistributionListId"];
            if (Array.isArray(_data["eventType"])) {
                this.eventType = [] as any;
                for (let item of _data["eventType"])
                    this.eventType!.push(item);
            }
        }
    }

    static fromJS(data: any): MailDistributionListConfigurationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailDistributionListConfigurationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailDistributionListId"] = this.mailDistributionListId;
        if (Array.isArray(this.eventType)) {
            data["eventType"] = [];
            for (let item of this.eventType)
                data["eventType"].push(item);
        }
        return data;
    }
}

export interface IMailDistributionListConfigurationsDto {
    mailDistributionListId: number;
    eventType: MailDistributionEventType[] | undefined;
}

export class MailDistributionListDto implements IMailDistributionListDto {
    displayName!: string | undefined;
    memberCount!: number;
    emailCount!: number;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IMailDistributionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.memberCount = _data["memberCount"];
            this.emailCount = _data["emailCount"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MailDistributionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailDistributionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["emailCount"] = this.emailCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMailDistributionListDto {
    displayName: string | undefined;
    memberCount: number;
    emailCount: number;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class MailDistributionListEmailListDto implements IMailDistributionListEmailListDto {
    name!: string | undefined;
    emailAddress!: string | undefined;
    id!: number;

    constructor(data?: IMailDistributionListEmailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.emailAddress = _data["emailAddress"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MailDistributionListEmailListDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailDistributionListEmailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["emailAddress"] = this.emailAddress;
        data["id"] = this.id;
        return data;
    }
}

export interface IMailDistributionListEmailListDto {
    name: string | undefined;
    emailAddress: string | undefined;
    id: number;
}

export class MailDistributionListUserListDto implements IMailDistributionListUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    id!: number;

    constructor(data?: IMailDistributionListUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MailDistributionListUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailDistributionListUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMailDistributionListUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    id: number;
}

export class UpdateMailDistributionListInput implements IUpdateMailDistributionListInput {
    id!: number;
    displayName!: string;

    constructor(data?: IUpdateMailDistributionListInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UpdateMailDistributionListInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMailDistributionListInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUpdateMailDistributionListInput {
    id: number;
    displayName: string;
}

export enum MailDistributionEventType {
    DefaultPendenceReminder = 1,
}

export class MailDistributionList implements IMailDistributionList {
    displayName!: string | undefined;
    configurations!: MailDistributionListConfiguration[] | undefined;
    members!: MailDistributionListEntry[] | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IMailDistributionList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["configurations"])) {
                this.configurations = [] as any;
                for (let item of _data["configurations"])
                    this.configurations!.push(MailDistributionListConfiguration.fromJS(item));
            }
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(MailDistributionListEntry.fromJS(item));
            }
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MailDistributionList {
        data = typeof data === 'object' ? data : {};
        let result = new MailDistributionList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        if (Array.isArray(this.configurations)) {
            data["configurations"] = [];
            for (let item of this.configurations)
                data["configurations"].push(item.toJSON());
        }
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMailDistributionList {
    displayName: string | undefined;
    configurations: MailDistributionListConfiguration[] | undefined;
    members: MailDistributionListEntry[] | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class MailDistributionListConfiguration implements IMailDistributionListConfiguration {
    mailDistributionListId!: number;
    eventType!: MailDistributionEventType;
    id!: number;

    constructor(data?: IMailDistributionListConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailDistributionListId = _data["mailDistributionListId"];
            this.eventType = _data["eventType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MailDistributionListConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new MailDistributionListConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailDistributionListId"] = this.mailDistributionListId;
        data["eventType"] = this.eventType;
        data["id"] = this.id;
        return data;
    }
}

export interface IMailDistributionListConfiguration {
    mailDistributionListId: number;
    eventType: MailDistributionEventType;
    id: number;
}

export class MailDistributionListEntry implements IMailDistributionListEntry {
    mailDistributionListId!: number;
    id!: number;

    constructor(data?: IMailDistributionListEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailDistributionListId = _data["mailDistributionListId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MailDistributionListEntry {
        data = typeof data === 'object' ? data : {};
        let result = new MailDistributionListEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailDistributionListId"] = this.mailDistributionListId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMailDistributionListEntry {
    mailDistributionListId: number;
    id: number;
}

export class GetMedRegPersonDetailedOutput implements IGetMedRegPersonDetailedOutput {
    medRegWholePerson!: MedRegWholePersonDetailedDto;

    constructor(data?: IGetMedRegPersonDetailedOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medRegWholePerson = _data["medRegWholePerson"] ? MedRegWholePersonDetailedDto.fromJS(_data["medRegWholePerson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMedRegPersonDetailedOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedRegPersonDetailedOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medRegWholePerson"] = this.medRegWholePerson ? this.medRegWholePerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMedRegPersonDetailedOutput {
    medRegWholePerson: MedRegWholePersonDetailedDto;
}

export class GetMedRegPersonOutput implements IGetMedRegPersonOutput {
    medRegWholePerson!: MedRegWholePersonDto;

    constructor(data?: IGetMedRegPersonOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medRegWholePerson = _data["medRegWholePerson"] ? MedRegWholePersonDto.fromJS(_data["medRegWholePerson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMedRegPersonOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedRegPersonOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medRegWholePerson"] = this.medRegWholePerson ? this.medRegWholePerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMedRegPersonOutput {
    medRegWholePerson: MedRegWholePersonDto;
}

export class MedRegAuflageEinschraenkungDto implements IMedRegAuflageEinschraenkungDto {
    typ!: HealthRegisterCodeDto;
    readonly datumEntscheid!: DateTime | undefined;
    readonly datumBefristung!: DateTime | undefined;
    readonly beschreibung!: string | undefined;
    readonly bezeichnung!: string | undefined;
    id!: number;

    constructor(data?: IMedRegAuflageEinschraenkungDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typ = _data["typ"] ? HealthRegisterCodeDto.fromJS(_data["typ"]) : <any>undefined;
            (<any>this).datumEntscheid = _data["datumEntscheid"] ? DateTime.fromISO(_data["datumEntscheid"].toString()) : <any>undefined;
            (<any>this).datumBefristung = _data["datumBefristung"] ? DateTime.fromISO(_data["datumBefristung"].toString()) : <any>undefined;
            (<any>this).beschreibung = _data["beschreibung"];
            (<any>this).bezeichnung = _data["bezeichnung"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedRegAuflageEinschraenkungDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegAuflageEinschraenkungDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typ"] = this.typ ? this.typ.toJSON() : <any>undefined;
        data["datumEntscheid"] = this.datumEntscheid ? this.datumEntscheid.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datumBefristung"] = this.datumBefristung ? this.datumBefristung.toFormat('yyyy-MM-dd') : <any>undefined;
        data["beschreibung"] = this.beschreibung;
        data["bezeichnung"] = this.bezeichnung;
        data["id"] = this.id;
        return data;
    }
}

export interface IMedRegAuflageEinschraenkungDto {
    typ: HealthRegisterCodeDto;
    datumEntscheid: DateTime | undefined;
    datumBefristung: DateTime | undefined;
    beschreibung: string | undefined;
    bezeichnung: string | undefined;
    id: number;
}

export class MedRegBeschaeftigungDto implements IMedRegBeschaeftigungDto {
    typ!: HealthRegisterCodeDto;
    readonly betriebsname!: string | undefined;
    einzelunternehmerIn!: HealthRegisterCodeDto;
    rechtsformJuristischePerson!: HealthRegisterCodeDto;
    readonly uidNumberJuristischePerson!: string | undefined;
    readonly idRole!: string | undefined;
    readonly strasse!: string | undefined;
    readonly hausnummer!: string | undefined;
    readonly plz!: string | undefined;
    readonly ort!: string | undefined;
    readonly zusatz1!: string | undefined;
    readonly zusatz2!: string | undefined;
    readonly telefon!: string | undefined;
    readonly telefon2!: string | undefined;
    readonly mobil!: string | undefined;
    readonly fax!: string | undefined;
    readonly eMail!: string | undefined;
    readonly beschreibung!: string | undefined;
    readonly bemerkungen!: string | undefined;
    selbstdispensationsbewilligung!: HealthRegisterCodeDto;
    readonly selbstdispensationBemerkung!: string | undefined;
    id!: number;

    constructor(data?: IMedRegBeschaeftigungDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typ = _data["typ"] ? HealthRegisterCodeDto.fromJS(_data["typ"]) : <any>undefined;
            (<any>this).betriebsname = _data["betriebsname"];
            this.einzelunternehmerIn = _data["einzelunternehmerIn"] ? HealthRegisterCodeDto.fromJS(_data["einzelunternehmerIn"]) : <any>undefined;
            this.rechtsformJuristischePerson = _data["rechtsformJuristischePerson"] ? HealthRegisterCodeDto.fromJS(_data["rechtsformJuristischePerson"]) : <any>undefined;
            (<any>this).uidNumberJuristischePerson = _data["uidNumberJuristischePerson"];
            (<any>this).idRole = _data["idRole"];
            (<any>this).strasse = _data["strasse"];
            (<any>this).hausnummer = _data["hausnummer"];
            (<any>this).plz = _data["plz"];
            (<any>this).ort = _data["ort"];
            (<any>this).zusatz1 = _data["zusatz1"];
            (<any>this).zusatz2 = _data["zusatz2"];
            (<any>this).telefon = _data["telefon"];
            (<any>this).telefon2 = _data["telefon2"];
            (<any>this).mobil = _data["mobil"];
            (<any>this).fax = _data["fax"];
            (<any>this).eMail = _data["eMail"];
            (<any>this).beschreibung = _data["beschreibung"];
            (<any>this).bemerkungen = _data["bemerkungen"];
            this.selbstdispensationsbewilligung = _data["selbstdispensationsbewilligung"] ? HealthRegisterCodeDto.fromJS(_data["selbstdispensationsbewilligung"]) : <any>undefined;
            (<any>this).selbstdispensationBemerkung = _data["selbstdispensationBemerkung"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedRegBeschaeftigungDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegBeschaeftigungDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typ"] = this.typ ? this.typ.toJSON() : <any>undefined;
        data["betriebsname"] = this.betriebsname;
        data["einzelunternehmerIn"] = this.einzelunternehmerIn ? this.einzelunternehmerIn.toJSON() : <any>undefined;
        data["rechtsformJuristischePerson"] = this.rechtsformJuristischePerson ? this.rechtsformJuristischePerson.toJSON() : <any>undefined;
        data["uidNumberJuristischePerson"] = this.uidNumberJuristischePerson;
        data["idRole"] = this.idRole;
        data["strasse"] = this.strasse;
        data["hausnummer"] = this.hausnummer;
        data["plz"] = this.plz;
        data["ort"] = this.ort;
        data["zusatz1"] = this.zusatz1;
        data["zusatz2"] = this.zusatz2;
        data["telefon"] = this.telefon;
        data["telefon2"] = this.telefon2;
        data["mobil"] = this.mobil;
        data["fax"] = this.fax;
        data["eMail"] = this.eMail;
        data["beschreibung"] = this.beschreibung;
        data["bemerkungen"] = this.bemerkungen;
        data["selbstdispensationsbewilligung"] = this.selbstdispensationsbewilligung ? this.selbstdispensationsbewilligung.toJSON() : <any>undefined;
        data["selbstdispensationBemerkung"] = this.selbstdispensationBemerkung;
        data["id"] = this.id;
        return data;
    }
}

export interface IMedRegBeschaeftigungDto {
    typ: HealthRegisterCodeDto;
    betriebsname: string | undefined;
    einzelunternehmerIn: HealthRegisterCodeDto;
    rechtsformJuristischePerson: HealthRegisterCodeDto;
    uidNumberJuristischePerson: string | undefined;
    idRole: string | undefined;
    strasse: string | undefined;
    hausnummer: string | undefined;
    plz: string | undefined;
    ort: string | undefined;
    zusatz1: string | undefined;
    zusatz2: string | undefined;
    telefon: string | undefined;
    telefon2: string | undefined;
    mobil: string | undefined;
    fax: string | undefined;
    eMail: string | undefined;
    beschreibung: string | undefined;
    bemerkungen: string | undefined;
    selbstdispensationsbewilligung: HealthRegisterCodeDto;
    selbstdispensationBemerkung: string | undefined;
    id: number;
}

export class MedRegBewilligungDto implements IMedRegBewilligungDto {
    typ!: HealthRegisterCodeDto;
    diplomArt!: HealthRegisterCodeDto;
    kanton!: HealthRegisterCodeDto;
    status!: HealthRegisterCodeDto;
    dienstleistungserbringerStatus!: HealthRegisterCodeDto;
    readonly datumEntscheid!: DateTime | undefined;
    datumBefristung!: DateTime | undefined;
    readonly bewilligungBefristungBenachrichtigungId!: number | undefined;
    datumPraxiseroeffnung!: DateTime | undefined;
    readonly datumPraxisaufgabe!: DateTime | undefined;
    readonly beschreibung!: string | undefined;
    readonly bemerkung!: string | undefined;
    readonly kantBerechtigungKvgId!: number;
    btmUmfang!: HealthRegisterCodeDto;
    readonly btmBemerkung!: string | undefined;
    aktivitaet!: HealthRegisterCodeDto;
    aktivitaetLabel!: HealthRegisterLabelDto;
    readonly datumAktivitaet!: DateTime | undefined;
    medRegBeschaeftigungen!: MedRegBeschaeftigungDto[] | undefined;
    medRegAuflagenEinschraenkungen!: MedRegAuflageEinschraenkungDto[] | undefined;
    id!: number;

    constructor(data?: IMedRegBewilligungDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typ = _data["typ"] ? HealthRegisterCodeDto.fromJS(_data["typ"]) : <any>undefined;
            this.diplomArt = _data["diplomArt"] ? HealthRegisterCodeDto.fromJS(_data["diplomArt"]) : <any>undefined;
            this.kanton = _data["kanton"] ? HealthRegisterCodeDto.fromJS(_data["kanton"]) : <any>undefined;
            this.status = _data["status"] ? HealthRegisterCodeDto.fromJS(_data["status"]) : <any>undefined;
            this.dienstleistungserbringerStatus = _data["dienstleistungserbringerStatus"] ? HealthRegisterCodeDto.fromJS(_data["dienstleistungserbringerStatus"]) : <any>undefined;
            (<any>this).datumEntscheid = _data["datumEntscheid"] ? DateTime.fromISO(_data["datumEntscheid"].toString()) : <any>undefined;
            this.datumBefristung = _data["datumBefristung"] ? DateTime.fromISO(_data["datumBefristung"].toString()) : <any>undefined;
            (<any>this).bewilligungBefristungBenachrichtigungId = _data["bewilligungBefristungBenachrichtigungId"];
            this.datumPraxiseroeffnung = _data["datumPraxiseroeffnung"] ? DateTime.fromISO(_data["datumPraxiseroeffnung"].toString()) : <any>undefined;
            (<any>this).datumPraxisaufgabe = _data["datumPraxisaufgabe"] ? DateTime.fromISO(_data["datumPraxisaufgabe"].toString()) : <any>undefined;
            (<any>this).beschreibung = _data["beschreibung"];
            (<any>this).bemerkung = _data["bemerkung"];
            (<any>this).kantBerechtigungKvgId = _data["kantBerechtigungKvgId"];
            this.btmUmfang = _data["btmUmfang"] ? HealthRegisterCodeDto.fromJS(_data["btmUmfang"]) : <any>undefined;
            (<any>this).btmBemerkung = _data["btmBemerkung"];
            this.aktivitaet = _data["aktivitaet"] ? HealthRegisterCodeDto.fromJS(_data["aktivitaet"]) : <any>undefined;
            this.aktivitaetLabel = _data["aktivitaetLabel"] ? HealthRegisterLabelDto.fromJS(_data["aktivitaetLabel"]) : <any>undefined;
            (<any>this).datumAktivitaet = _data["datumAktivitaet"] ? DateTime.fromISO(_data["datumAktivitaet"].toString()) : <any>undefined;
            if (Array.isArray(_data["medRegBeschaeftigungen"])) {
                this.medRegBeschaeftigungen = [] as any;
                for (let item of _data["medRegBeschaeftigungen"])
                    this.medRegBeschaeftigungen!.push(MedRegBeschaeftigungDto.fromJS(item));
            }
            if (Array.isArray(_data["medRegAuflagenEinschraenkungen"])) {
                this.medRegAuflagenEinschraenkungen = [] as any;
                for (let item of _data["medRegAuflagenEinschraenkungen"])
                    this.medRegAuflagenEinschraenkungen!.push(MedRegAuflageEinschraenkungDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedRegBewilligungDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegBewilligungDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typ"] = this.typ ? this.typ.toJSON() : <any>undefined;
        data["diplomArt"] = this.diplomArt ? this.diplomArt.toJSON() : <any>undefined;
        data["kanton"] = this.kanton ? this.kanton.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["dienstleistungserbringerStatus"] = this.dienstleistungserbringerStatus ? this.dienstleistungserbringerStatus.toJSON() : <any>undefined;
        data["datumEntscheid"] = this.datumEntscheid ? this.datumEntscheid.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datumBefristung"] = this.datumBefristung ? this.datumBefristung.toFormat('yyyy-MM-dd') : <any>undefined;
        data["bewilligungBefristungBenachrichtigungId"] = this.bewilligungBefristungBenachrichtigungId;
        data["datumPraxiseroeffnung"] = this.datumPraxiseroeffnung ? this.datumPraxiseroeffnung.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datumPraxisaufgabe"] = this.datumPraxisaufgabe ? this.datumPraxisaufgabe.toFormat('yyyy-MM-dd') : <any>undefined;
        data["beschreibung"] = this.beschreibung;
        data["bemerkung"] = this.bemerkung;
        data["kantBerechtigungKvgId"] = this.kantBerechtigungKvgId;
        data["btmUmfang"] = this.btmUmfang ? this.btmUmfang.toJSON() : <any>undefined;
        data["btmBemerkung"] = this.btmBemerkung;
        data["aktivitaet"] = this.aktivitaet ? this.aktivitaet.toJSON() : <any>undefined;
        data["aktivitaetLabel"] = this.aktivitaetLabel ? this.aktivitaetLabel.toJSON() : <any>undefined;
        data["datumAktivitaet"] = this.datumAktivitaet ? this.datumAktivitaet.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.medRegBeschaeftigungen)) {
            data["medRegBeschaeftigungen"] = [];
            for (let item of this.medRegBeschaeftigungen)
                data["medRegBeschaeftigungen"].push(item.toJSON());
        }
        if (Array.isArray(this.medRegAuflagenEinschraenkungen)) {
            data["medRegAuflagenEinschraenkungen"] = [];
            for (let item of this.medRegAuflagenEinschraenkungen)
                data["medRegAuflagenEinschraenkungen"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IMedRegBewilligungDto {
    typ: HealthRegisterCodeDto;
    diplomArt: HealthRegisterCodeDto;
    kanton: HealthRegisterCodeDto;
    status: HealthRegisterCodeDto;
    dienstleistungserbringerStatus: HealthRegisterCodeDto;
    datumEntscheid: DateTime | undefined;
    datumBefristung: DateTime | undefined;
    bewilligungBefristungBenachrichtigungId: number | undefined;
    datumPraxiseroeffnung: DateTime | undefined;
    datumPraxisaufgabe: DateTime | undefined;
    beschreibung: string | undefined;
    bemerkung: string | undefined;
    kantBerechtigungKvgId: number;
    btmUmfang: HealthRegisterCodeDto;
    btmBemerkung: string | undefined;
    aktivitaet: HealthRegisterCodeDto;
    aktivitaetLabel: HealthRegisterLabelDto;
    datumAktivitaet: DateTime | undefined;
    medRegBeschaeftigungen: MedRegBeschaeftigungDto[] | undefined;
    medRegAuflagenEinschraenkungen: MedRegAuflageEinschraenkungDto[] | undefined;
    id: number;
}

export class MedRegDiplomDto implements IMedRegDiplomDto {
    art!: HealthRegisterCodeDto;
    typ!: HealthRegisterCodeDto;
    readonly datumErteilung!: DateTime | undefined;
    readonly ortErteilung!: string | undefined;
    land!: HealthRegisterCodeDto;
    readonly datumAnerkennungCH!: DateTime | undefined;
    readonly datumGleichwertigkeit!: DateTime | undefined;
    readonly medizinalpersonId!: number | undefined;
    medRegBewilligungen!: MedRegBewilligungDto[] | undefined;
    id!: number;

    constructor(data?: IMedRegDiplomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.art = _data["art"] ? HealthRegisterCodeDto.fromJS(_data["art"]) : <any>undefined;
            this.typ = _data["typ"] ? HealthRegisterCodeDto.fromJS(_data["typ"]) : <any>undefined;
            (<any>this).datumErteilung = _data["datumErteilung"] ? DateTime.fromISO(_data["datumErteilung"].toString()) : <any>undefined;
            (<any>this).ortErteilung = _data["ortErteilung"];
            this.land = _data["land"] ? HealthRegisterCodeDto.fromJS(_data["land"]) : <any>undefined;
            (<any>this).datumAnerkennungCH = _data["datumAnerkennungCH"] ? DateTime.fromISO(_data["datumAnerkennungCH"].toString()) : <any>undefined;
            (<any>this).datumGleichwertigkeit = _data["datumGleichwertigkeit"] ? DateTime.fromISO(_data["datumGleichwertigkeit"].toString()) : <any>undefined;
            (<any>this).medizinalpersonId = _data["medizinalpersonId"];
            if (Array.isArray(_data["medRegBewilligungen"])) {
                this.medRegBewilligungen = [] as any;
                for (let item of _data["medRegBewilligungen"])
                    this.medRegBewilligungen!.push(MedRegBewilligungDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedRegDiplomDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegDiplomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["art"] = this.art ? this.art.toJSON() : <any>undefined;
        data["typ"] = this.typ ? this.typ.toJSON() : <any>undefined;
        data["datumErteilung"] = this.datumErteilung ? this.datumErteilung.toFormat('yyyy-MM-dd') : <any>undefined;
        data["ortErteilung"] = this.ortErteilung;
        data["land"] = this.land ? this.land.toJSON() : <any>undefined;
        data["datumAnerkennungCH"] = this.datumAnerkennungCH ? this.datumAnerkennungCH.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datumGleichwertigkeit"] = this.datumGleichwertigkeit ? this.datumGleichwertigkeit.toFormat('yyyy-MM-dd') : <any>undefined;
        data["medizinalpersonId"] = this.medizinalpersonId;
        if (Array.isArray(this.medRegBewilligungen)) {
            data["medRegBewilligungen"] = [];
            for (let item of this.medRegBewilligungen)
                data["medRegBewilligungen"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IMedRegDiplomDto {
    art: HealthRegisterCodeDto;
    typ: HealthRegisterCodeDto;
    datumErteilung: DateTime | undefined;
    ortErteilung: string | undefined;
    land: HealthRegisterCodeDto;
    datumAnerkennungCH: DateTime | undefined;
    datumGleichwertigkeit: DateTime | undefined;
    medizinalpersonId: number | undefined;
    medRegBewilligungen: MedRegBewilligungDto[] | undefined;
    id: number;
}

export class MedRegPersonDetailedDto implements IMedRegPersonDetailedDto {
    ahvNr!: string | undefined;
    ledigerName!: string | undefined;
    heimatort!: string | undefined;
    korrespondenzsprache!: HealthRegisterCodeDto;
    geburtsdatum!: DateTime | undefined;
    sterbedatum!: DateTime | undefined;
    weitereInfoVorhanden!: boolean | undefined;
    schuetzenswertGemKantRecht!: boolean | undefined;
    loeschdatum!: DateTime | undefined;
    anonymisierungsdatum!: DateTime | undefined;
    cantonalLicenceRestrictions!: string[] | undefined;
    uidStatus!: number | undefined;
    uidOrganisation!: number | undefined;
    uidAnfragedatum!: DateTime | undefined;
    dataOwner!: number | undefined;
    gln!: string | undefined;
    nachname!: string | undefined;
    vorname!: string | undefined;
    uidNumber!: string | undefined;
    geschlecht!: HealthRegisterCodeDto;
    geburtsjahr!: string | undefined;
    nationalitaet1!: HealthRegisterCodeDto;
    nationalitaet2!: HealthRegisterCodeDto;
    sprachkompetenzen!: HealthRegisterCodeDto[] | undefined;
    id!: number;

    constructor(data?: IMedRegPersonDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ahvNr = _data["ahvNr"];
            this.ledigerName = _data["ledigerName"];
            this.heimatort = _data["heimatort"];
            this.korrespondenzsprache = _data["korrespondenzsprache"] ? HealthRegisterCodeDto.fromJS(_data["korrespondenzsprache"]) : <any>undefined;
            this.geburtsdatum = _data["geburtsdatum"] ? DateTime.fromISO(_data["geburtsdatum"].toString()) : <any>undefined;
            this.sterbedatum = _data["sterbedatum"] ? DateTime.fromISO(_data["sterbedatum"].toString()) : <any>undefined;
            this.weitereInfoVorhanden = _data["weitereInfoVorhanden"];
            this.schuetzenswertGemKantRecht = _data["schuetzenswertGemKantRecht"];
            this.loeschdatum = _data["loeschdatum"] ? DateTime.fromISO(_data["loeschdatum"].toString()) : <any>undefined;
            this.anonymisierungsdatum = _data["anonymisierungsdatum"] ? DateTime.fromISO(_data["anonymisierungsdatum"].toString()) : <any>undefined;
            if (Array.isArray(_data["cantonalLicenceRestrictions"])) {
                this.cantonalLicenceRestrictions = [] as any;
                for (let item of _data["cantonalLicenceRestrictions"])
                    this.cantonalLicenceRestrictions!.push(item);
            }
            this.uidStatus = _data["uidStatus"];
            this.uidOrganisation = _data["uidOrganisation"];
            this.uidAnfragedatum = _data["uidAnfragedatum"] ? DateTime.fromISO(_data["uidAnfragedatum"].toString()) : <any>undefined;
            this.dataOwner = _data["dataOwner"];
            this.gln = _data["gln"];
            this.nachname = _data["nachname"];
            this.vorname = _data["vorname"];
            this.uidNumber = _data["uidNumber"];
            this.geschlecht = _data["geschlecht"] ? HealthRegisterCodeDto.fromJS(_data["geschlecht"]) : <any>undefined;
            this.geburtsjahr = _data["geburtsjahr"];
            this.nationalitaet1 = _data["nationalitaet1"] ? HealthRegisterCodeDto.fromJS(_data["nationalitaet1"]) : <any>undefined;
            this.nationalitaet2 = _data["nationalitaet2"] ? HealthRegisterCodeDto.fromJS(_data["nationalitaet2"]) : <any>undefined;
            if (Array.isArray(_data["sprachkompetenzen"])) {
                this.sprachkompetenzen = [] as any;
                for (let item of _data["sprachkompetenzen"])
                    this.sprachkompetenzen!.push(HealthRegisterCodeDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedRegPersonDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegPersonDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ahvNr"] = this.ahvNr;
        data["ledigerName"] = this.ledigerName;
        data["heimatort"] = this.heimatort;
        data["korrespondenzsprache"] = this.korrespondenzsprache ? this.korrespondenzsprache.toJSON() : <any>undefined;
        data["geburtsdatum"] = this.geburtsdatum ? this.geburtsdatum.toFormat('yyyy-MM-dd') : <any>undefined;
        data["sterbedatum"] = this.sterbedatum ? this.sterbedatum.toFormat('yyyy-MM-dd') : <any>undefined;
        data["weitereInfoVorhanden"] = this.weitereInfoVorhanden;
        data["schuetzenswertGemKantRecht"] = this.schuetzenswertGemKantRecht;
        data["loeschdatum"] = this.loeschdatum ? this.loeschdatum.toFormat('yyyy-MM-dd') : <any>undefined;
        data["anonymisierungsdatum"] = this.anonymisierungsdatum ? this.anonymisierungsdatum.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.cantonalLicenceRestrictions)) {
            data["cantonalLicenceRestrictions"] = [];
            for (let item of this.cantonalLicenceRestrictions)
                data["cantonalLicenceRestrictions"].push(item);
        }
        data["uidStatus"] = this.uidStatus;
        data["uidOrganisation"] = this.uidOrganisation;
        data["uidAnfragedatum"] = this.uidAnfragedatum ? this.uidAnfragedatum.toString() : <any>undefined;
        data["dataOwner"] = this.dataOwner;
        data["gln"] = this.gln;
        data["nachname"] = this.nachname;
        data["vorname"] = this.vorname;
        data["uidNumber"] = this.uidNumber;
        data["geschlecht"] = this.geschlecht ? this.geschlecht.toJSON() : <any>undefined;
        data["geburtsjahr"] = this.geburtsjahr;
        data["nationalitaet1"] = this.nationalitaet1 ? this.nationalitaet1.toJSON() : <any>undefined;
        data["nationalitaet2"] = this.nationalitaet2 ? this.nationalitaet2.toJSON() : <any>undefined;
        if (Array.isArray(this.sprachkompetenzen)) {
            data["sprachkompetenzen"] = [];
            for (let item of this.sprachkompetenzen)
                data["sprachkompetenzen"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IMedRegPersonDetailedDto {
    ahvNr: string | undefined;
    ledigerName: string | undefined;
    heimatort: string | undefined;
    korrespondenzsprache: HealthRegisterCodeDto;
    geburtsdatum: DateTime | undefined;
    sterbedatum: DateTime | undefined;
    weitereInfoVorhanden: boolean | undefined;
    schuetzenswertGemKantRecht: boolean | undefined;
    loeschdatum: DateTime | undefined;
    anonymisierungsdatum: DateTime | undefined;
    cantonalLicenceRestrictions: string[] | undefined;
    uidStatus: number | undefined;
    uidOrganisation: number | undefined;
    uidAnfragedatum: DateTime | undefined;
    dataOwner: number | undefined;
    gln: string | undefined;
    nachname: string | undefined;
    vorname: string | undefined;
    uidNumber: string | undefined;
    geschlecht: HealthRegisterCodeDto;
    geburtsjahr: string | undefined;
    nationalitaet1: HealthRegisterCodeDto;
    nationalitaet2: HealthRegisterCodeDto;
    sprachkompetenzen: HealthRegisterCodeDto[] | undefined;
    id: number;
}

export class MedRegPersonDto implements IMedRegPersonDto {
    gln!: string | undefined;
    nachname!: string | undefined;
    vorname!: string | undefined;
    uidNumber!: string | undefined;
    geschlecht!: HealthRegisterCodeDto;
    geburtsjahr!: string | undefined;
    nationalitaet1!: HealthRegisterCodeDto;
    nationalitaet2!: HealthRegisterCodeDto;
    sprachkompetenzen!: HealthRegisterCodeDto[] | undefined;
    id!: number;

    constructor(data?: IMedRegPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.nachname = _data["nachname"];
            this.vorname = _data["vorname"];
            this.uidNumber = _data["uidNumber"];
            this.geschlecht = _data["geschlecht"] ? HealthRegisterCodeDto.fromJS(_data["geschlecht"]) : <any>undefined;
            this.geburtsjahr = _data["geburtsjahr"];
            this.nationalitaet1 = _data["nationalitaet1"] ? HealthRegisterCodeDto.fromJS(_data["nationalitaet1"]) : <any>undefined;
            this.nationalitaet2 = _data["nationalitaet2"] ? HealthRegisterCodeDto.fromJS(_data["nationalitaet2"]) : <any>undefined;
            if (Array.isArray(_data["sprachkompetenzen"])) {
                this.sprachkompetenzen = [] as any;
                for (let item of _data["sprachkompetenzen"])
                    this.sprachkompetenzen!.push(HealthRegisterCodeDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedRegPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["nachname"] = this.nachname;
        data["vorname"] = this.vorname;
        data["uidNumber"] = this.uidNumber;
        data["geschlecht"] = this.geschlecht ? this.geschlecht.toJSON() : <any>undefined;
        data["geburtsjahr"] = this.geburtsjahr;
        data["nationalitaet1"] = this.nationalitaet1 ? this.nationalitaet1.toJSON() : <any>undefined;
        data["nationalitaet2"] = this.nationalitaet2 ? this.nationalitaet2.toJSON() : <any>undefined;
        if (Array.isArray(this.sprachkompetenzen)) {
            data["sprachkompetenzen"] = [];
            for (let item of this.sprachkompetenzen)
                data["sprachkompetenzen"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IMedRegPersonDto {
    gln: string | undefined;
    nachname: string | undefined;
    vorname: string | undefined;
    uidNumber: string | undefined;
    geschlecht: HealthRegisterCodeDto;
    geburtsjahr: string | undefined;
    nationalitaet1: HealthRegisterCodeDto;
    nationalitaet2: HealthRegisterCodeDto;
    sprachkompetenzen: HealthRegisterCodeDto[] | undefined;
    id: number;
}

export class MedRegPwbDto implements IMedRegPwbDto {
    art!: HealthRegisterCodeDto;
    typ!: HealthRegisterCodeDto;
    readonly datumErteilung!: DateTime | undefined;
    readonly medizinalpersonId!: number | undefined;
    id!: number;

    constructor(data?: IMedRegPwbDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.art = _data["art"] ? HealthRegisterCodeDto.fromJS(_data["art"]) : <any>undefined;
            this.typ = _data["typ"] ? HealthRegisterCodeDto.fromJS(_data["typ"]) : <any>undefined;
            (<any>this).datumErteilung = _data["datumErteilung"] ? DateTime.fromISO(_data["datumErteilung"].toString()) : <any>undefined;
            (<any>this).medizinalpersonId = _data["medizinalpersonId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedRegPwbDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegPwbDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["art"] = this.art ? this.art.toJSON() : <any>undefined;
        data["typ"] = this.typ ? this.typ.toJSON() : <any>undefined;
        data["datumErteilung"] = this.datumErteilung ? this.datumErteilung.toFormat('yyyy-MM-dd') : <any>undefined;
        data["medizinalpersonId"] = this.medizinalpersonId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMedRegPwbDto {
    art: HealthRegisterCodeDto;
    typ: HealthRegisterCodeDto;
    datumErteilung: DateTime | undefined;
    medizinalpersonId: number | undefined;
    id: number;
}

export class MedRegWbtDto implements IMedRegWbtDto {
    art!: HealthRegisterCodeDto;
    typ!: HealthRegisterCodeDto;
    readonly datumErteilung!: DateTime | undefined;
    readonly ortErteilung!: string | undefined;
    land!: HealthRegisterCodeDto;
    readonly datumAnerkennungCH!: DateTime | undefined;
    readonly datumGleichwertigkeit!: DateTime | undefined;
    readonly medizinalpersonId!: number | undefined;
    weiterbildungsartLabel!: HealthRegisterLabelDto;
    weiterbildungstypLabel!: HealthRegisterLabelDto;
    id!: number;

    constructor(data?: IMedRegWbtDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.art = _data["art"] ? HealthRegisterCodeDto.fromJS(_data["art"]) : <any>undefined;
            this.typ = _data["typ"] ? HealthRegisterCodeDto.fromJS(_data["typ"]) : <any>undefined;
            (<any>this).datumErteilung = _data["datumErteilung"] ? DateTime.fromISO(_data["datumErteilung"].toString()) : <any>undefined;
            (<any>this).ortErteilung = _data["ortErteilung"];
            this.land = _data["land"] ? HealthRegisterCodeDto.fromJS(_data["land"]) : <any>undefined;
            (<any>this).datumAnerkennungCH = _data["datumAnerkennungCH"] ? DateTime.fromISO(_data["datumAnerkennungCH"].toString()) : <any>undefined;
            (<any>this).datumGleichwertigkeit = _data["datumGleichwertigkeit"] ? DateTime.fromISO(_data["datumGleichwertigkeit"].toString()) : <any>undefined;
            (<any>this).medizinalpersonId = _data["medizinalpersonId"];
            this.weiterbildungsartLabel = _data["weiterbildungsartLabel"] ? HealthRegisterLabelDto.fromJS(_data["weiterbildungsartLabel"]) : <any>undefined;
            this.weiterbildungstypLabel = _data["weiterbildungstypLabel"] ? HealthRegisterLabelDto.fromJS(_data["weiterbildungstypLabel"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedRegWbtDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegWbtDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["art"] = this.art ? this.art.toJSON() : <any>undefined;
        data["typ"] = this.typ ? this.typ.toJSON() : <any>undefined;
        data["datumErteilung"] = this.datumErteilung ? this.datumErteilung.toFormat('yyyy-MM-dd') : <any>undefined;
        data["ortErteilung"] = this.ortErteilung;
        data["land"] = this.land ? this.land.toJSON() : <any>undefined;
        data["datumAnerkennungCH"] = this.datumAnerkennungCH ? this.datumAnerkennungCH.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datumGleichwertigkeit"] = this.datumGleichwertigkeit ? this.datumGleichwertigkeit.toFormat('yyyy-MM-dd') : <any>undefined;
        data["medizinalpersonId"] = this.medizinalpersonId;
        data["weiterbildungsartLabel"] = this.weiterbildungsartLabel ? this.weiterbildungsartLabel.toJSON() : <any>undefined;
        data["weiterbildungstypLabel"] = this.weiterbildungstypLabel ? this.weiterbildungstypLabel.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IMedRegWbtDto {
    art: HealthRegisterCodeDto;
    typ: HealthRegisterCodeDto;
    datumErteilung: DateTime | undefined;
    ortErteilung: string | undefined;
    land: HealthRegisterCodeDto;
    datumAnerkennungCH: DateTime | undefined;
    datumGleichwertigkeit: DateTime | undefined;
    medizinalpersonId: number | undefined;
    weiterbildungsartLabel: HealthRegisterLabelDto;
    weiterbildungstypLabel: HealthRegisterLabelDto;
    id: number;
}

export class MedRegWholePersonDetailedDto implements IMedRegWholePersonDetailedDto {
    person!: MedRegPersonDetailedDto;
    medRegDiplome!: MedRegDiplomDto[] | undefined;
    medRegPwbs!: MedRegPwbDto[] | undefined;
    medRegWbts!: MedRegWbtDto[] | undefined;
    queryTime!: DateTime | undefined;

    constructor(data?: IMedRegWholePersonDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.person = _data["person"] ? MedRegPersonDetailedDto.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["medRegDiplome"])) {
                this.medRegDiplome = [] as any;
                for (let item of _data["medRegDiplome"])
                    this.medRegDiplome!.push(MedRegDiplomDto.fromJS(item));
            }
            if (Array.isArray(_data["medRegPwbs"])) {
                this.medRegPwbs = [] as any;
                for (let item of _data["medRegPwbs"])
                    this.medRegPwbs!.push(MedRegPwbDto.fromJS(item));
            }
            if (Array.isArray(_data["medRegWbts"])) {
                this.medRegWbts = [] as any;
                for (let item of _data["medRegWbts"])
                    this.medRegWbts!.push(MedRegWbtDto.fromJS(item));
            }
            this.queryTime = _data["queryTime"] ? DateTime.fromISO(_data["queryTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MedRegWholePersonDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegWholePersonDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.medRegDiplome)) {
            data["medRegDiplome"] = [];
            for (let item of this.medRegDiplome)
                data["medRegDiplome"].push(item.toJSON());
        }
        if (Array.isArray(this.medRegPwbs)) {
            data["medRegPwbs"] = [];
            for (let item of this.medRegPwbs)
                data["medRegPwbs"].push(item.toJSON());
        }
        if (Array.isArray(this.medRegWbts)) {
            data["medRegWbts"] = [];
            for (let item of this.medRegWbts)
                data["medRegWbts"].push(item.toJSON());
        }
        data["queryTime"] = this.queryTime ? this.queryTime.toString() : <any>undefined;
        return data;
    }
}

export interface IMedRegWholePersonDetailedDto {
    person: MedRegPersonDetailedDto;
    medRegDiplome: MedRegDiplomDto[] | undefined;
    medRegPwbs: MedRegPwbDto[] | undefined;
    medRegWbts: MedRegWbtDto[] | undefined;
    queryTime: DateTime | undefined;
}

export class MedRegWholePersonDto implements IMedRegWholePersonDto {
    person!: MedRegPersonDto;
    medRegDiplome!: MedRegDiplomDto[] | undefined;
    medRegPwbs!: MedRegPwbDto[] | undefined;
    medRegWbts!: MedRegWbtDto[] | undefined;
    queryTime!: DateTime | undefined;

    constructor(data?: IMedRegWholePersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.person = _data["person"] ? MedRegPersonDto.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["medRegDiplome"])) {
                this.medRegDiplome = [] as any;
                for (let item of _data["medRegDiplome"])
                    this.medRegDiplome!.push(MedRegDiplomDto.fromJS(item));
            }
            if (Array.isArray(_data["medRegPwbs"])) {
                this.medRegPwbs = [] as any;
                for (let item of _data["medRegPwbs"])
                    this.medRegPwbs!.push(MedRegPwbDto.fromJS(item));
            }
            if (Array.isArray(_data["medRegWbts"])) {
                this.medRegWbts = [] as any;
                for (let item of _data["medRegWbts"])
                    this.medRegWbts!.push(MedRegWbtDto.fromJS(item));
            }
            this.queryTime = _data["queryTime"] ? DateTime.fromISO(_data["queryTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MedRegWholePersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegWholePersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.medRegDiplome)) {
            data["medRegDiplome"] = [];
            for (let item of this.medRegDiplome)
                data["medRegDiplome"].push(item.toJSON());
        }
        if (Array.isArray(this.medRegPwbs)) {
            data["medRegPwbs"] = [];
            for (let item of this.medRegPwbs)
                data["medRegPwbs"].push(item.toJSON());
        }
        if (Array.isArray(this.medRegWbts)) {
            data["medRegWbts"] = [];
            for (let item of this.medRegWbts)
                data["medRegWbts"].push(item.toJSON());
        }
        data["queryTime"] = this.queryTime ? this.queryTime.toString() : <any>undefined;
        return data;
    }
}

export interface IMedRegWholePersonDto {
    person: MedRegPersonDto;
    medRegDiplome: MedRegDiplomDto[] | undefined;
    medRegPwbs: MedRegPwbDto[] | undefined;
    medRegWbts: MedRegWbtDto[] | undefined;
    queryTime: DateTime | undefined;
}

export class GetExcelResultData implements IGetExcelResultData {
    name!: string | undefined;
    creationTime!: DateTime;
    isForEvidence!: boolean | undefined;
    step!: MigrationStep;
    additionalStep!: MigrationAdditionalStep;
    id!: number;

    constructor(data?: IGetExcelResultData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.isForEvidence = _data["isForEvidence"];
            this.step = _data["step"];
            this.additionalStep = _data["additionalStep"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetExcelResultData {
        data = typeof data === 'object' ? data : {};
        let result = new GetExcelResultData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["isForEvidence"] = this.isForEvidence;
        data["step"] = this.step;
        data["additionalStep"] = this.additionalStep;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetExcelResultData {
    name: string | undefined;
    creationTime: DateTime;
    isForEvidence: boolean | undefined;
    step: MigrationStep;
    additionalStep: MigrationAdditionalStep;
    id: number;
}

export class MigrationBinaryDataInputDto implements IMigrationBinaryDataInputDto {
    id!: MigrationBinaryObjectId;
    file!: string;

    constructor(data?: IMigrationBinaryDataInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): MigrationBinaryDataInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationBinaryDataInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["file"] = this.file;
        return data;
    }
}

export interface IMigrationBinaryDataInputDto {
    id: MigrationBinaryObjectId;
    file: string;
}

export class MigrationIsRunningOutputDto implements IMigrationIsRunningOutputDto {
    isRunning!: boolean;
    progress!: number | undefined;

    constructor(data?: IMigrationIsRunningOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isRunning = _data["isRunning"];
            this.progress = _data["progress"];
        }
    }

    static fromJS(data: any): MigrationIsRunningOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationIsRunningOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRunning"] = this.isRunning;
        data["progress"] = this.progress;
        return data;
    }
}

export interface IMigrationIsRunningOutputDto {
    isRunning: boolean;
    progress: number | undefined;
}

export class MigrationResultDto implements IMigrationResultDto {
    resultAvailable!: boolean;
    total!: number | undefined;
    numberOfSuccess!: number | undefined;
    numberOfErrors!: number | undefined;
    excelResultId!: number | undefined;
    hasException!: boolean;
    exceptionMessage!: string | undefined;

    constructor(data?: IMigrationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultAvailable = _data["resultAvailable"];
            this.total = _data["total"];
            this.numberOfSuccess = _data["numberOfSuccess"];
            this.numberOfErrors = _data["numberOfErrors"];
            this.excelResultId = _data["excelResultId"];
            this.hasException = _data["hasException"];
            this.exceptionMessage = _data["exceptionMessage"];
        }
    }

    static fromJS(data: any): MigrationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultAvailable"] = this.resultAvailable;
        data["total"] = this.total;
        data["numberOfSuccess"] = this.numberOfSuccess;
        data["numberOfErrors"] = this.numberOfErrors;
        data["excelResultId"] = this.excelResultId;
        data["hasException"] = this.hasException;
        data["exceptionMessage"] = this.exceptionMessage;
        return data;
    }
}

export interface IMigrationResultDto {
    resultAvailable: boolean;
    total: number | undefined;
    numberOfSuccess: number | undefined;
    numberOfErrors: number | undefined;
    excelResultId: number | undefined;
    hasException: boolean;
    exceptionMessage: string | undefined;
}

export class MigrationData implements IMigrationData {
    source!: MigrationSource;
    remoteId!: number;
    flags!: MigrationDataFlags;
    migrationTime!: DateTime;
    userId!: number | undefined;
    personId!: number | undefined;
    diplomaId!: number | undefined;
    postgraduateTitleId!: number | undefined;
    documentId!: number | undefined;
    pendenceId!: number | undefined;
    sponsorshipId!: number | undefined;
    personLicenceId!: number | undefined;
    personLicenceRestrictionId!: number | undefined;
    corporateLicenceId!: number | undefined;
    corporateLicenceRestrictionId!: number | undefined;
    businessId!: number | undefined;
    employmentId!: number | undefined;
    sensitiveDataRecordId!: number | undefined;
    inspectionId!: number | undefined;
    logbookBaseEntryId!: number | undefined;
    additionalInfoId!: number | undefined;
    id!: number;

    constructor(data?: IMigrationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.remoteId = _data["remoteId"];
            this.flags = _data["flags"];
            this.migrationTime = _data["migrationTime"] ? DateTime.fromISO(_data["migrationTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.personId = _data["personId"];
            this.diplomaId = _data["diplomaId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.documentId = _data["documentId"];
            this.pendenceId = _data["pendenceId"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.personLicenceId = _data["personLicenceId"];
            this.personLicenceRestrictionId = _data["personLicenceRestrictionId"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.corporateLicenceRestrictionId = _data["corporateLicenceRestrictionId"];
            this.businessId = _data["businessId"];
            this.employmentId = _data["employmentId"];
            this.sensitiveDataRecordId = _data["sensitiveDataRecordId"];
            this.inspectionId = _data["inspectionId"];
            this.logbookBaseEntryId = _data["logbookBaseEntryId"];
            this.additionalInfoId = _data["additionalInfoId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MigrationData {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["remoteId"] = this.remoteId;
        data["flags"] = this.flags;
        data["migrationTime"] = this.migrationTime ? this.migrationTime.toString() : <any>undefined;
        data["userId"] = this.userId;
        data["personId"] = this.personId;
        data["diplomaId"] = this.diplomaId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["documentId"] = this.documentId;
        data["pendenceId"] = this.pendenceId;
        data["sponsorshipId"] = this.sponsorshipId;
        data["personLicenceId"] = this.personLicenceId;
        data["personLicenceRestrictionId"] = this.personLicenceRestrictionId;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["corporateLicenceRestrictionId"] = this.corporateLicenceRestrictionId;
        data["businessId"] = this.businessId;
        data["employmentId"] = this.employmentId;
        data["sensitiveDataRecordId"] = this.sensitiveDataRecordId;
        data["inspectionId"] = this.inspectionId;
        data["logbookBaseEntryId"] = this.logbookBaseEntryId;
        data["additionalInfoId"] = this.additionalInfoId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMigrationData {
    source: MigrationSource;
    remoteId: number;
    flags: MigrationDataFlags;
    migrationTime: DateTime;
    userId: number | undefined;
    personId: number | undefined;
    diplomaId: number | undefined;
    postgraduateTitleId: number | undefined;
    documentId: number | undefined;
    pendenceId: number | undefined;
    sponsorshipId: number | undefined;
    personLicenceId: number | undefined;
    personLicenceRestrictionId: number | undefined;
    corporateLicenceId: number | undefined;
    corporateLicenceRestrictionId: number | undefined;
    businessId: number | undefined;
    employmentId: number | undefined;
    sensitiveDataRecordId: number | undefined;
    inspectionId: number | undefined;
    logbookBaseEntryId: number | undefined;
    additionalInfoId: number | undefined;
    id: number;
}

export enum MigrationDataFlags {
    None = 0,
    NewSponsorship = 1,
    EhcLicence = 2,
    Inspectors = 4,
    PersonLicenceToCorporateLicence = 8,
    CorporateLicenceMutation = 16,
    AdditionalCorporateLicenceMutation1 = 32,
    AdditionalCorporateLicenceMutation2 = 64,
}

export enum MigrationSource {
    Bepro = 0,
    Sirona = 1,
}

export class CreateInvoiceDto implements ICreateInvoiceDto {
    subscriptionPaymentId!: number;

    constructor(data?: ICreateInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionPaymentId = _data["subscriptionPaymentId"];
        }
    }

    static fromJS(data: any): CreateInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPaymentId"] = this.subscriptionPaymentId;
        return data;
    }
}

export interface ICreateInvoiceDto {
    subscriptionPaymentId: number;
}

export class InvoiceDto implements IInvoiceDto {
    amount!: number;
    editionDisplayName!: string | undefined;
    invoiceNo!: string | undefined;
    invoiceDate!: DateTime;
    tenantLegalName!: string | undefined;
    tenantAddress!: string[] | undefined;
    tenantTaxNo!: string | undefined;
    hostLegalName!: string | undefined;
    hostAddress!: string[] | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.invoiceNo = _data["invoiceNo"];
            this.invoiceDate = _data["invoiceDate"] ? DateTime.fromISO(_data["invoiceDate"].toString()) : <any>undefined;
            this.tenantLegalName = _data["tenantLegalName"];
            if (Array.isArray(_data["tenantAddress"])) {
                this.tenantAddress = [] as any;
                for (let item of _data["tenantAddress"])
                    this.tenantAddress!.push(item);
            }
            this.tenantTaxNo = _data["tenantTaxNo"];
            this.hostLegalName = _data["hostLegalName"];
            if (Array.isArray(_data["hostAddress"])) {
                this.hostAddress = [] as any;
                for (let item of _data["hostAddress"])
                    this.hostAddress!.push(item);
            }
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toString() : <any>undefined;
        data["tenantLegalName"] = this.tenantLegalName;
        if (Array.isArray(this.tenantAddress)) {
            data["tenantAddress"] = [];
            for (let item of this.tenantAddress)
                data["tenantAddress"].push(item);
        }
        data["tenantTaxNo"] = this.tenantTaxNo;
        data["hostLegalName"] = this.hostLegalName;
        if (Array.isArray(this.hostAddress)) {
            data["hostAddress"] = [];
            for (let item of this.hostAddress)
                data["hostAddress"].push(item);
        }
        return data;
    }
}

export interface IInvoiceDto {
    amount: number;
    editionDisplayName: string | undefined;
    invoiceNo: string | undefined;
    invoiceDate: DateTime;
    tenantLegalName: string | undefined;
    tenantAddress: string[] | undefined;
    tenantTaxNo: string | undefined;
    hostLegalName: string | undefined;
    hostAddress: string[] | undefined;
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminName!: string | undefined;
    adminSurname!: string | undefined;
    adminPassword!: string | undefined;
    connectionString!: string | undefined;
    shouldChangePasswordOnNextLogin!: boolean;
    sendActivationEmail!: boolean;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminName = _data["adminName"];
            this.adminSurname = _data["adminSurname"];
            this.adminPassword = _data["adminPassword"];
            this.connectionString = _data["connectionString"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
        }
    }

    static fromJS(data: any): CreateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminName"] = this.adminName;
        data["adminSurname"] = this.adminSurname;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        return data;
    }
}

export interface ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminName: string | undefined;
    adminSurname: string | undefined;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
}

export class EditionsSelectOutput implements IEditionsSelectOutput {
    allFeatures!: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures!: EditionWithFeaturesDto[] | undefined;

    constructor(data?: IEditionsSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allFeatures"])) {
                this.allFeatures = [] as any;
                for (let item of _data["allFeatures"])
                    this.allFeatures!.push(FlatFeatureSelectDto.fromJS(item));
            }
            if (Array.isArray(_data["editionsWithFeatures"])) {
                this.editionsWithFeatures = [] as any;
                for (let item of _data["editionsWithFeatures"])
                    this.editionsWithFeatures!.push(EditionWithFeaturesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionsSelectOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EditionsSelectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allFeatures)) {
            data["allFeatures"] = [];
            for (let item of this.allFeatures)
                data["allFeatures"].push(item.toJSON());
        }
        if (Array.isArray(this.editionsWithFeatures)) {
            data["editionsWithFeatures"] = [];
            for (let item of this.editionsWithFeatures)
                data["editionsWithFeatures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures: EditionWithFeaturesDto[] | undefined;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class RegisterTenantInput implements IRegisterTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminName!: string | undefined;
    adminSurname!: string | undefined;
    adminPassword!: string | undefined;
    captchaResponse!: string | undefined;
    subscriptionStartType!: SubscriptionStartType;
    editionId!: number | undefined;

    constructor(data?: IRegisterTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminName = _data["adminName"];
            this.adminSurname = _data["adminSurname"];
            this.adminPassword = _data["adminPassword"];
            this.captchaResponse = _data["captchaResponse"];
            this.subscriptionStartType = _data["subscriptionStartType"];
            this.editionId = _data["editionId"];
        }
    }

    static fromJS(data: any): RegisterTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminName"] = this.adminName;
        data["adminSurname"] = this.adminSurname;
        data["adminPassword"] = this.adminPassword;
        data["captchaResponse"] = this.captchaResponse;
        data["subscriptionStartType"] = this.subscriptionStartType;
        data["editionId"] = this.editionId;
        return data;
    }
}

export interface IRegisterTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminName: string | undefined;
    adminSurname: string | undefined;
    adminPassword: string | undefined;
    captchaResponse: string | undefined;
    subscriptionStartType: SubscriptionStartType;
    editionId: number | undefined;
}

export class RegisterTenantOutput implements IRegisterTenantOutput {
    tenantId!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    isTenantActive!: boolean;
    isActive!: boolean;
    isEmailConfirmationRequired!: boolean;

    constructor(data?: IRegisterTenantOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.isTenantActive = _data["isTenantActive"];
            this.isActive = _data["isActive"];
            this.isEmailConfirmationRequired = _data["isEmailConfirmationRequired"];
        }
    }

    static fromJS(data: any): RegisterTenantOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        return data;
    }
}

export interface IRegisterTenantOutput {
    tenantId: number;
    tenancyName: string | undefined;
    name: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    isTenantActive: boolean;
    isActive: boolean;
    isEmailConfirmationRequired: boolean;
}

export class TenantEditDto implements ITenantEditDto {
    tenancyName!: string;
    name!: string;
    connectionString!: string | undefined;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;
    id!: number;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantEditDto {
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
    id: number;
}

export class TenantListDto implements ITenantListDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    editionDisplayName!: string | undefined;
    connectionString!: string | undefined;
    isActive!: boolean;
    creationTime!: DateTime;
    subscriptionEndDateUtc!: DateTime | undefined;
    editionId!: number | undefined;
    isInTrialPeriod!: boolean;
    id!: number;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.editionId = _data["editionId"];
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantListDto {
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean;
    creationTime: DateTime;
    subscriptionEndDateUtc: DateTime | undefined;
    editionId: number | undefined;
    isInTrialPeriod: boolean;
    id: number;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id!: number;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[];
}

export enum ChartDateInterval {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class ExpiringTenant implements IExpiringTenant {
    tenantName!: string | undefined;
    remainingDayCount!: number;

    constructor(data?: IExpiringTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantName = _data["tenantName"];
            this.remainingDayCount = _data["remainingDayCount"];
        }
    }

    static fromJS(data: any): ExpiringTenant {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data;
    }
}

export interface IExpiringTenant {
    tenantName: string | undefined;
    remainingDayCount: number;
}

export class GetEditionTenantStatisticsOutput implements IGetEditionTenantStatisticsOutput {
    editionStatistics!: TenantEdition[] | undefined;

    constructor(data?: IGetEditionTenantStatisticsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["editionStatistics"])) {
                this.editionStatistics = [] as any;
                for (let item of _data["editionStatistics"])
                    this.editionStatistics!.push(TenantEdition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionTenantStatisticsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionTenantStatisticsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.editionStatistics)) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[] | undefined;
}

export class GetExpiringTenantsOutput implements IGetExpiringTenantsOutput {
    expiringTenants!: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount!: number;
    maxExpiringTenantsShownCount!: number;
    subscriptionEndDateStart!: DateTime;
    subscriptionEndDateEnd!: DateTime;

    constructor(data?: IGetExpiringTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["expiringTenants"])) {
                this.expiringTenants = [] as any;
                for (let item of _data["expiringTenants"])
                    this.expiringTenants!.push(ExpiringTenant.fromJS(item));
            }
            this.subscriptionEndAlertDayCount = _data["subscriptionEndAlertDayCount"];
            this.maxExpiringTenantsShownCount = _data["maxExpiringTenantsShownCount"];
            this.subscriptionEndDateStart = _data["subscriptionEndDateStart"] ? DateTime.fromISO(_data["subscriptionEndDateStart"].toString()) : <any>undefined;
            this.subscriptionEndDateEnd = _data["subscriptionEndDateEnd"] ? DateTime.fromISO(_data["subscriptionEndDateEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetExpiringTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpiringTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expiringTenants)) {
            data["expiringTenants"] = [];
            for (let item of this.expiringTenants)
                data["expiringTenants"].push(item.toJSON());
        }
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toString() : <any>undefined;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toString() : <any>undefined;
        return data;
    }
}

export interface IGetExpiringTenantsOutput {
    expiringTenants: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount: number;
    maxExpiringTenantsShownCount: number;
    subscriptionEndDateStart: DateTime;
    subscriptionEndDateEnd: DateTime;
}

export class GetIncomeStatisticsDataOutput implements IGetIncomeStatisticsDataOutput {
    incomeStatistics!: IncomeStastistic[] | undefined;

    constructor(data?: IGetIncomeStatisticsDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["incomeStatistics"])) {
                this.incomeStatistics = [] as any;
                for (let item of _data["incomeStatistics"])
                    this.incomeStatistics!.push(IncomeStastistic.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIncomeStatisticsDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncomeStatisticsDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incomeStatistics)) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[] | undefined;
}

export class GetRecentTenantsOutput implements IGetRecentTenantsOutput {
    recentTenantsDayCount!: number;
    maxRecentTenantsShownCount!: number;
    tenantCreationStartDate!: DateTime;
    recentTenants!: RecentTenant[] | undefined;

    constructor(data?: IGetRecentTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recentTenantsDayCount = _data["recentTenantsDayCount"];
            this.maxRecentTenantsShownCount = _data["maxRecentTenantsShownCount"];
            this.tenantCreationStartDate = _data["tenantCreationStartDate"] ? DateTime.fromISO(_data["tenantCreationStartDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["recentTenants"])) {
                this.recentTenants = [] as any;
                for (let item of _data["recentTenants"])
                    this.recentTenants!.push(RecentTenant.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRecentTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecentTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toString() : <any>undefined;
        if (Array.isArray(this.recentTenants)) {
            data["recentTenants"] = [];
            for (let item of this.recentTenants)
                data["recentTenants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRecentTenantsOutput {
    recentTenantsDayCount: number;
    maxRecentTenantsShownCount: number;
    tenantCreationStartDate: DateTime;
    recentTenants: RecentTenant[] | undefined;
}

export class IncomeStastistic implements IIncomeStastistic {
    label!: string | undefined;
    date!: DateTime;
    amount!: number;

    constructor(data?: IIncomeStastistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): IncomeStastistic {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeStastistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IIncomeStastistic {
    label: string | undefined;
    date: DateTime;
    amount: number;
}

export class RecentTenant implements IRecentTenant {
    id!: number;
    name!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IRecentTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecentTenant {
        data = typeof data === 'object' ? data : {};
        let result = new RecentTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IRecentTenant {
    id: number;
    name: string | undefined;
    creationTime: DateTime;
}

export class TenantEdition implements ITenantEdition {
    label!: string | undefined;
    value!: number;

    constructor(data?: ITenantEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TenantEdition {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEdition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface ITenantEdition {
    label: string | undefined;
    value: number;
}

export class TopStatsData implements ITopStatsData {
    newTenantsCount!: number;
    newSubscriptionAmount!: number;
    dashboardPlaceholder1!: number;
    dashboardPlaceholder2!: number;

    constructor(data?: ITopStatsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newTenantsCount = _data["newTenantsCount"];
            this.newSubscriptionAmount = _data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = _data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = _data["dashboardPlaceholder2"];
        }
    }

    static fromJS(data: any): TopStatsData {
        data = typeof data === 'object' ? data : {};
        let result = new TopStatsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        return data;
    }
}

export interface ITopStatsData {
    newTenantsCount: number;
    newSubscriptionAmount: number;
    dashboardPlaceholder1: number;
    dashboardPlaceholder2: number;
}

export enum PaymentPeriodType {
    Daily = 1,
    Weekly = 7,
    Monthly = 30,
    Annual = 365,
}

export enum SubscriptionPaymentType {
    Manual = 0,
    RecurringAutomatic = 1,
    RecurringManual = 2,
}

export enum SubscriptionStartType {
    Free = 1,
    Trial = 2,
    Paid = 3,
}

export class GetMunicipalityDto implements IGetMunicipalityDto {
    internalNumber!: number | undefined;
    bfsNumber!: string | undefined;
    postCodes!: string[] | undefined;
    codeIsActive!: boolean;
    id!: string | undefined;

    constructor(data?: IGetMunicipalityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalNumber = _data["internalNumber"];
            this.bfsNumber = _data["bfsNumber"];
            if (Array.isArray(_data["postCodes"])) {
                this.postCodes = [] as any;
                for (let item of _data["postCodes"])
                    this.postCodes!.push(item);
            }
            this.codeIsActive = _data["codeIsActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetMunicipalityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMunicipalityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalNumber"] = this.internalNumber;
        data["bfsNumber"] = this.bfsNumber;
        if (Array.isArray(this.postCodes)) {
            data["postCodes"] = [];
            for (let item of this.postCodes)
                data["postCodes"].push(item);
        }
        data["codeIsActive"] = this.codeIsActive;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetMunicipalityDto {
    internalNumber: number | undefined;
    bfsNumber: string | undefined;
    postCodes: string[] | undefined;
    codeIsActive: boolean;
    id: string | undefined;
}

export class MutPersonnelChangeDto implements IMutPersonnelChangeDto {
    id!: number | undefined;
    employmentId!: number;
    dateOfCurrentResponsibilityEnd!: DateTime;
    dateOfNewResponsibilityStart!: DateTime;
    gln!: string;
    professionId!: string;
    email!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    levelOfEmployment!: number;
    employments!: EmploymentWithPersonDto[] | undefined;

    constructor(data?: IMutPersonnelChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employmentId = _data["employmentId"];
            this.dateOfCurrentResponsibilityEnd = _data["dateOfCurrentResponsibilityEnd"] ? DateTime.fromISO(_data["dateOfCurrentResponsibilityEnd"].toString()) : <any>undefined;
            this.dateOfNewResponsibilityStart = _data["dateOfNewResponsibilityStart"] ? DateTime.fromISO(_data["dateOfNewResponsibilityStart"].toString()) : <any>undefined;
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(EmploymentWithPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MutPersonnelChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutPersonnelChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employmentId"] = this.employmentId;
        data["dateOfCurrentResponsibilityEnd"] = this.dateOfCurrentResponsibilityEnd ? this.dateOfCurrentResponsibilityEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNewResponsibilityStart"] = this.dateOfNewResponsibilityStart ? this.dateOfNewResponsibilityStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["levelOfEmployment"] = this.levelOfEmployment;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMutPersonnelChangeDto {
    id: number | undefined;
    employmentId: number;
    dateOfCurrentResponsibilityEnd: DateTime;
    dateOfNewResponsibilityStart: DateTime;
    gln: string;
    professionId: string;
    email: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    levelOfEmployment: number;
    employments: EmploymentWithPersonDto[] | undefined;
}

export class CreateMutInput implements ICreateMutInput {
    mutationTypeId!: string;
    corporateLicenceId!: number | undefined;
    legitimationId!: number;

    constructor(data?: ICreateMutInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mutationTypeId = _data["mutationTypeId"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.legitimationId = _data["legitimationId"];
        }
    }

    static fromJS(data: any): CreateMutInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMutInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mutationTypeId"] = this.mutationTypeId;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["legitimationId"] = this.legitimationId;
        return data;
    }
}

export interface ICreateMutInput {
    mutationTypeId: string;
    corporateLicenceId: number | undefined;
    legitimationId: number;
}

export class CreateMutOutput implements ICreateMutOutput {
    caseId!: string | undefined;
    statusId!: MutStatus;

    constructor(data?: ICreateMutOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): CreateMutOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMutOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface ICreateMutOutput {
    caseId: string | undefined;
    statusId: MutStatus;
}

export class CreateOrUpdateMutMedicalFieldPersonTerminateDto implements ICreateOrUpdateMutMedicalFieldPersonTerminateDto {
    id!: number | undefined;
    dateOfEndOfEmployment!: DateTime;
    reason!: string | undefined;
    selectedEmploymentIds!: number[] | undefined;

    constructor(data?: ICreateOrUpdateMutMedicalFieldPersonTerminateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            if (Array.isArray(_data["selectedEmploymentIds"])) {
                this.selectedEmploymentIds = [] as any;
                for (let item of _data["selectedEmploymentIds"])
                    this.selectedEmploymentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateMutMedicalFieldPersonTerminateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMutMedicalFieldPersonTerminateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["reason"] = this.reason;
        if (Array.isArray(this.selectedEmploymentIds)) {
            data["selectedEmploymentIds"] = [];
            for (let item of this.selectedEmploymentIds)
                data["selectedEmploymentIds"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateMutMedicalFieldPersonTerminateDto {
    id: number | undefined;
    dateOfEndOfEmployment: DateTime;
    reason: string | undefined;
    selectedEmploymentIds: number[] | undefined;
}

export class CreateOrUpdateMutSponsorshipDirectorTerminateDto implements ICreateOrUpdateMutSponsorshipDirectorTerminateDto {
    id!: number | undefined;
    dateOfEndOfEmployment!: DateTime;
    reason!: string | undefined;
    selectedEmploymentIds!: number[] | undefined;

    constructor(data?: ICreateOrUpdateMutSponsorshipDirectorTerminateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            if (Array.isArray(_data["selectedEmploymentIds"])) {
                this.selectedEmploymentIds = [] as any;
                for (let item of _data["selectedEmploymentIds"])
                    this.selectedEmploymentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateMutSponsorshipDirectorTerminateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMutSponsorshipDirectorTerminateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["reason"] = this.reason;
        if (Array.isArray(this.selectedEmploymentIds)) {
            data["selectedEmploymentIds"] = [];
            for (let item of this.selectedEmploymentIds)
                data["selectedEmploymentIds"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateMutSponsorshipDirectorTerminateDto {
    id: number | undefined;
    dateOfEndOfEmployment: DateTime;
    reason: string | undefined;
    selectedEmploymentIds: number[] | undefined;
}

export class CreateUpdateMutApplicantBusinessInput implements ICreateUpdateMutApplicantBusinessInput {
    caseId!: string;
    mutApplicantBusiness!: MutApplicantBusinessDto;

    constructor(data?: ICreateUpdateMutApplicantBusinessInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.mutApplicantBusiness = new MutApplicantBusinessDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.mutApplicantBusiness = _data["mutApplicantBusiness"] ? MutApplicantBusinessDto.fromJS(_data["mutApplicantBusiness"]) : new MutApplicantBusinessDto();
        }
    }

    static fromJS(data: any): CreateUpdateMutApplicantBusinessInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateMutApplicantBusinessInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["mutApplicantBusiness"] = this.mutApplicantBusiness ? this.mutApplicantBusiness.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateUpdateMutApplicantBusinessInput {
    caseId: string;
    mutApplicantBusiness: MutApplicantBusinessDto;
}

export class GetMutBusinessBankruptcyOutput implements IGetMutBusinessBankruptcyOutput {
    businessBankruptcy!: MutBusinessBankruptcyDto;
    businesses!: BusinessAddressDto[] | undefined;

    constructor(data?: IGetMutBusinessBankruptcyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessBankruptcy = _data["businessBankruptcy"] ? MutBusinessBankruptcyDto.fromJS(_data["businessBankruptcy"]) : <any>undefined;
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(BusinessAddressDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMutBusinessBankruptcyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutBusinessBankruptcyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessBankruptcy"] = this.businessBankruptcy ? this.businessBankruptcy.toJSON() : <any>undefined;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMutBusinessBankruptcyOutput {
    businessBankruptcy: MutBusinessBankruptcyDto;
    businesses: BusinessAddressDto[] | undefined;
}

export class GetMutBusinessClosureOutput implements IGetMutBusinessClosureOutput {
    businessClosure!: MutBusinessClosureDto;
    businesses!: BusinessAddressDto[] | undefined;

    constructor(data?: IGetMutBusinessClosureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessClosure = _data["businessClosure"] ? MutBusinessClosureDto.fromJS(_data["businessClosure"]) : <any>undefined;
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(BusinessAddressDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMutBusinessClosureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutBusinessClosureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessClosure"] = this.businessClosure ? this.businessClosure.toJSON() : <any>undefined;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMutBusinessClosureOutput {
    businessClosure: MutBusinessClosureDto;
    businesses: BusinessAddressDto[] | undefined;
}

export class GetMutBusinessMoveOutput implements IGetMutBusinessMoveOutput {
    businessMove!: MutBusinessMoveDto;
    businesses!: BusinessAddressDto[] | undefined;

    constructor(data?: IGetMutBusinessMoveOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessMove = _data["businessMove"] ? MutBusinessMoveDto.fromJS(_data["businessMove"]) : <any>undefined;
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(BusinessAddressDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMutBusinessMoveOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutBusinessMoveOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessMove"] = this.businessMove ? this.businessMove.toJSON() : <any>undefined;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMutBusinessMoveOutput {
    businessMove: MutBusinessMoveDto;
    businesses: BusinessAddressDto[] | undefined;
}

export class GetMutDocumentsInput implements IGetMutDocumentsInput {
    caseId!: string;
    step!: MutStatus;

    constructor(data?: IGetMutDocumentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
        }
    }

    static fromJS(data: any): GetMutDocumentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutDocumentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        return data;
    }
}

export interface IGetMutDocumentsInput {
    caseId: string;
    step: MutStatus;
}

export class GetMutEmploymentTerminateOutput implements IGetMutEmploymentTerminateOutput {
    employmentTerminate!: MutEmploymentTerminateDto;
    employments!: EmploymentWithAddressDto[] | undefined;

    constructor(data?: IGetMutEmploymentTerminateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employmentTerminate = _data["employmentTerminate"] ? MutEmploymentTerminateDto.fromJS(_data["employmentTerminate"]) : <any>undefined;
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(EmploymentWithAddressDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMutEmploymentTerminateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutEmploymentTerminateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employmentTerminate"] = this.employmentTerminate ? this.employmentTerminate.toJSON() : <any>undefined;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMutEmploymentTerminateOutput {
    employmentTerminate: MutEmploymentTerminateDto;
    employments: EmploymentWithAddressDto[] | undefined;
}

export class GetMutEmploymentUpdateOutput implements IGetMutEmploymentUpdateOutput {
    employmentUpdate!: MutEmploymentUpdateDto;
    employments!: EmploymentWithAddressDto[] | undefined;

    constructor(data?: IGetMutEmploymentUpdateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employmentUpdate = _data["employmentUpdate"] ? MutEmploymentUpdateDto.fromJS(_data["employmentUpdate"]) : <any>undefined;
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(EmploymentWithAddressDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMutEmploymentUpdateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutEmploymentUpdateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employmentUpdate"] = this.employmentUpdate ? this.employmentUpdate.toJSON() : <any>undefined;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMutEmploymentUpdateOutput {
    employmentUpdate: MutEmploymentUpdateDto;
    employments: EmploymentWithAddressDto[] | undefined;
}

export class GetMutFileInput implements IGetMutFileInput {
    caseId!: string;
    step!: MutStatus;
    id!: number;

    constructor(data?: IGetMutFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetMutFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetMutFileInput {
    caseId: string;
    step: MutStatus;
    id: number;
}

export class GetMutOutput implements IGetMutOutput {
    mut!: MutDto;
    automaticUpdateOnApproval!: boolean;

    constructor(data?: IGetMutOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mut = _data["mut"] ? MutDto.fromJS(_data["mut"]) : <any>undefined;
            this.automaticUpdateOnApproval = _data["automaticUpdateOnApproval"];
        }
    }

    static fromJS(data: any): GetMutOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mut"] = this.mut ? this.mut.toJSON() : <any>undefined;
        data["automaticUpdateOnApproval"] = this.automaticUpdateOnApproval;
        return data;
    }
}

export interface IGetMutOutput {
    mut: MutDto;
    automaticUpdateOnApproval: boolean;
}

export class GetMutPersonContactOutput implements IGetMutPersonContactOutput {
    newContact!: MutPersonContactDto;
    oldContact!: MutPersonContactDto;

    constructor(data?: IGetMutPersonContactOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newContact = _data["newContact"] ? MutPersonContactDto.fromJS(_data["newContact"]) : <any>undefined;
            this.oldContact = _data["oldContact"] ? MutPersonContactDto.fromJS(_data["oldContact"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMutPersonContactOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutPersonContactOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newContact"] = this.newContact ? this.newContact.toJSON() : <any>undefined;
        data["oldContact"] = this.oldContact ? this.oldContact.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMutPersonContactOutput {
    newContact: MutPersonContactDto;
    oldContact: MutPersonContactDto;
}

export class GetMutSponsorshipAddressOutput implements IGetMutSponsorshipAddressOutput {
    newAddress!: MutSponsorshipAddressDto;
    oldAddress!: MutSponsorshipAddressDto;

    constructor(data?: IGetMutSponsorshipAddressOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newAddress = _data["newAddress"] ? MutSponsorshipAddressDto.fromJS(_data["newAddress"]) : <any>undefined;
            this.oldAddress = _data["oldAddress"] ? MutSponsorshipAddressDto.fromJS(_data["oldAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMutSponsorshipAddressOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutSponsorshipAddressOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newAddress"] = this.newAddress ? this.newAddress.toJSON() : <any>undefined;
        data["oldAddress"] = this.oldAddress ? this.oldAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMutSponsorshipAddressOutput {
    newAddress: MutSponsorshipAddressDto;
    oldAddress: MutSponsorshipAddressDto;
}

export class GetMutSponsorshipContactOutput implements IGetMutSponsorshipContactOutput {
    newContact!: MutSponsorshipContactDto;
    oldContact!: MutSponsorshipContactDto;

    constructor(data?: IGetMutSponsorshipContactOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newContact = _data["newContact"] ? MutSponsorshipContactDto.fromJS(_data["newContact"]) : <any>undefined;
            this.oldContact = _data["oldContact"] ? MutSponsorshipContactDto.fromJS(_data["oldContact"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMutSponsorshipContactOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutSponsorshipContactOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newContact"] = this.newContact ? this.newContact.toJSON() : <any>undefined;
        data["oldContact"] = this.oldContact ? this.oldContact.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMutSponsorshipContactOutput {
    newContact: MutSponsorshipContactDto;
    oldContact: MutSponsorshipContactDto;
}

export class GetMutSponsorshipNameOutput implements IGetMutSponsorshipNameOutput {
    newName!: MutSponsorshipNameDto;
    oldName!: MutSponsorshipNameDto;

    constructor(data?: IGetMutSponsorshipNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newName = _data["newName"] ? MutSponsorshipNameDto.fromJS(_data["newName"]) : <any>undefined;
            this.oldName = _data["oldName"] ? MutSponsorshipNameDto.fromJS(_data["oldName"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMutSponsorshipNameOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutSponsorshipNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newName"] = this.newName ? this.newName.toJSON() : <any>undefined;
        data["oldName"] = this.oldName ? this.oldName.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMutSponsorshipNameOutput {
    newName: MutSponsorshipNameDto;
    oldName: MutSponsorshipNameDto;
}

export class GetMutSubItemDocumentsInput implements IGetMutSubItemDocumentsInput {
    subItemId!: number;
    hasGln!: boolean | undefined;
    caseId!: string;
    step!: MutStatus;

    constructor(data?: IGetMutSubItemDocumentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subItemId = _data["subItemId"];
            this.hasGln = _data["hasGln"];
            this.caseId = _data["caseId"];
            this.step = _data["step"];
        }
    }

    static fromJS(data: any): GetMutSubItemDocumentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutSubItemDocumentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subItemId"] = this.subItemId;
        data["hasGln"] = this.hasGln;
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        return data;
    }
}

export interface IGetMutSubItemDocumentsInput {
    subItemId: number;
    hasGln: boolean | undefined;
    caseId: string;
    step: MutStatus;
}

export class GetMutationApplicationsOutput implements IGetMutationApplicationsOutput {
    totalCount!: number;
    items!: MutationApplicationSearchDto[] | undefined;

    constructor(data?: IGetMutationApplicationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MutationApplicationSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMutationApplicationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutationApplicationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMutationApplicationsOutput {
    totalCount: number;
    items: MutationApplicationSearchDto[] | undefined;
}

export class GetMutationTypeConfigurationOutputDto implements IGetMutationTypeConfigurationOutputDto {
    mutationTypeId!: string | undefined;
    needsCorporateLicence!: boolean;
    firstStep!: MutStatus;
    isForPerson!: boolean;
    isForBusiness!: boolean;
    isForSponsorship!: boolean;

    constructor(data?: IGetMutationTypeConfigurationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mutationTypeId = _data["mutationTypeId"];
            this.needsCorporateLicence = _data["needsCorporateLicence"];
            this.firstStep = _data["firstStep"];
            this.isForPerson = _data["isForPerson"];
            this.isForBusiness = _data["isForBusiness"];
            this.isForSponsorship = _data["isForSponsorship"];
        }
    }

    static fromJS(data: any): GetMutationTypeConfigurationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutationTypeConfigurationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mutationTypeId"] = this.mutationTypeId;
        data["needsCorporateLicence"] = this.needsCorporateLicence;
        data["firstStep"] = this.firstStep;
        data["isForPerson"] = this.isForPerson;
        data["isForBusiness"] = this.isForBusiness;
        data["isForSponsorship"] = this.isForSponsorship;
        return data;
    }
}

export interface IGetMutationTypeConfigurationOutputDto {
    mutationTypeId: string | undefined;
    needsCorporateLicence: boolean;
    firstStep: MutStatus;
    isForPerson: boolean;
    isForBusiness: boolean;
    isForSponsorship: boolean;
}

export class MutAdditionalAcademicTitleDto implements IMutAdditionalAcademicTitleDto {
    id!: number | undefined;
    title!: string;
    bodyOfIssue!: string | undefined;
    placeOfIssue!: string | undefined;
    countryOfIssueId!: string | undefined;
    dateOfIssue!: DateTime;

    constructor(data?: IMutAdditionalAcademicTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.bodyOfIssue = _data["bodyOfIssue"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryOfIssueId = _data["countryOfIssueId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MutAdditionalAcademicTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutAdditionalAcademicTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["bodyOfIssue"] = this.bodyOfIssue;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryOfIssueId"] = this.countryOfIssueId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IMutAdditionalAcademicTitleDto {
    id: number | undefined;
    title: string;
    bodyOfIssue: string | undefined;
    placeOfIssue: string | undefined;
    countryOfIssueId: string | undefined;
    dateOfIssue: DateTime;
}

export class MutApplicantAdditionalCommentsDto implements IMutApplicantAdditionalCommentsDto {
    id!: number | undefined;
    additionalComments!: string | undefined;
    dateValidFrom!: DateTime | undefined;

    constructor(data?: IMutApplicantAdditionalCommentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.additionalComments = _data["additionalComments"];
            this.dateValidFrom = _data["dateValidFrom"] ? DateTime.fromISO(_data["dateValidFrom"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MutApplicantAdditionalCommentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutApplicantAdditionalCommentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["additionalComments"] = this.additionalComments;
        data["dateValidFrom"] = this.dateValidFrom ? this.dateValidFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IMutApplicantAdditionalCommentsDto {
    id: number | undefined;
    additionalComments: string | undefined;
    dateValidFrom: DateTime | undefined;
}

export class MutApplicantBusinessDto implements IMutApplicantBusinessDto {
    id!: number | undefined;
    business!: OndBusinessDto;

    constructor(data?: IMutApplicantBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.business = _data["business"] ? OndBusinessDto.fromJS(_data["business"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MutApplicantBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutApplicantBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMutApplicantBusinessDto {
    id: number | undefined;
    business: OndBusinessDto;
}

export class MutApplicantContactDto implements IMutApplicantContactDto {
    id!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    readonly fullName!: string | undefined;

    constructor(data?: IMutApplicantContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): MutApplicantContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutApplicantContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IMutApplicantContactDto {
    id: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    fullName: string | undefined;
}

export class MutApplicantPersonDto implements IMutApplicantPersonDto {
    id!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    gln!: string | undefined;
    professionId!: string | undefined;
    readonly fullName!: string | undefined;

    constructor(data?: IMutApplicantPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): MutApplicantPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutApplicantPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IMutApplicantPersonDto {
    id: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    gln: string | undefined;
    professionId: string | undefined;
    fullName: string | undefined;
}

export class MutApplicantSponsorshipDto implements IMutApplicantSponsorshipDto {
    id!: number | undefined;
    uid!: string | undefined;
    name!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;

    constructor(data?: IMutApplicantSponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uid = _data["uid"];
            this.name = _data["name"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
        }
    }

    static fromJS(data: any): MutApplicantSponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutApplicantSponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uid"] = this.uid;
        data["name"] = this.name;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        return data;
    }
}

export interface IMutApplicantSponsorshipDto {
    id: number | undefined;
    uid: string | undefined;
    name: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
}

export class MutBusinessBankruptcyDto implements IMutBusinessBankruptcyDto {
    id!: number | undefined;
    businessId!: number;
    dateOfBankruptcy!: DateTime;
    dateOfClosure!: DateTime;

    constructor(data?: IMutBusinessBankruptcyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessId = _data["businessId"];
            this.dateOfBankruptcy = _data["dateOfBankruptcy"] ? DateTime.fromISO(_data["dateOfBankruptcy"].toString()) : <any>undefined;
            this.dateOfClosure = _data["dateOfClosure"] ? DateTime.fromISO(_data["dateOfClosure"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MutBusinessBankruptcyDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutBusinessBankruptcyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessId"] = this.businessId;
        data["dateOfBankruptcy"] = this.dateOfBankruptcy ? this.dateOfBankruptcy.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfClosure"] = this.dateOfClosure ? this.dateOfClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IMutBusinessBankruptcyDto {
    id: number | undefined;
    businessId: number;
    dateOfBankruptcy: DateTime;
    dateOfClosure: DateTime;
}

export class MutBusinessClosureDto implements IMutBusinessClosureDto {
    id!: number | undefined;
    businessId!: number;
    dateOfClosure!: DateTime;
    reason!: string | undefined;

    constructor(data?: IMutBusinessClosureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessId = _data["businessId"];
            this.dateOfClosure = _data["dateOfClosure"] ? DateTime.fromISO(_data["dateOfClosure"].toString()) : <any>undefined;
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): MutBusinessClosureDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutBusinessClosureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessId"] = this.businessId;
        data["dateOfClosure"] = this.dateOfClosure ? this.dateOfClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IMutBusinessClosureDto {
    id: number | undefined;
    businessId: number;
    dateOfClosure: DateTime;
    reason: string | undefined;
}

export class MutBusinessCreateDto implements IMutBusinessCreateDto {
    id!: number | undefined;
    name!: string;
    legalFormId!: string;
    additionalName!: string | undefined;
    bur!: string | undefined;
    uid!: string | undefined;
    gln!: string | undefined;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    phone!: string;
    email!: string;
    website!: string | undefined;
    businessHours!: string | undefined;
    dateOfOpening!: DateTime;

    constructor(data?: IMutBusinessCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.legalFormId = _data["legalFormId"];
            this.additionalName = _data["additionalName"];
            this.bur = _data["bur"];
            this.uid = _data["uid"];
            this.gln = _data["gln"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.businessHours = _data["businessHours"];
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MutBusinessCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutBusinessCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["legalFormId"] = this.legalFormId;
        data["additionalName"] = this.additionalName;
        data["bur"] = this.bur;
        data["uid"] = this.uid;
        data["gln"] = this.gln;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["website"] = this.website;
        data["businessHours"] = this.businessHours;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IMutBusinessCreateDto {
    id: number | undefined;
    name: string;
    legalFormId: string;
    additionalName: string | undefined;
    bur: string | undefined;
    uid: string | undefined;
    gln: string | undefined;
    postCode: string;
    city: string;
    street: string;
    streetNr: string;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    phone: string;
    email: string;
    website: string | undefined;
    businessHours: string | undefined;
    dateOfOpening: DateTime;
}

export class MutBusinessMoveDto implements IMutBusinessMoveDto {
    id!: number | undefined;
    businessId!: number | undefined;
    postCode!: string;
    postCodeChanged!: boolean;
    city!: string;
    cityChanged!: boolean;
    street!: string;
    streetChanged!: boolean;
    streetNr!: string;
    streetNrChanged!: boolean;
    postOfficeBox!: string | undefined;
    postOfficeBoxChanged!: boolean;
    addressAddition!: string | undefined;
    addressAdditionChanged!: boolean;
    phone!: string;
    phoneChanged!: boolean;
    email!: string;
    emailChanged!: boolean;
    website!: string | undefined;
    websiteChanged!: boolean;
    businessHours!: string | undefined;
    businessHoursChanged!: boolean;
    dateOfOpening!: DateTime;
    dateOfOpeningChanged!: boolean;

    constructor(data?: IMutBusinessMoveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessId = _data["businessId"];
            this.postCode = _data["postCode"];
            this.postCodeChanged = _data["postCodeChanged"];
            this.city = _data["city"];
            this.cityChanged = _data["cityChanged"];
            this.street = _data["street"];
            this.streetChanged = _data["streetChanged"];
            this.streetNr = _data["streetNr"];
            this.streetNrChanged = _data["streetNrChanged"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postOfficeBoxChanged = _data["postOfficeBoxChanged"];
            this.addressAddition = _data["addressAddition"];
            this.addressAdditionChanged = _data["addressAdditionChanged"];
            this.phone = _data["phone"];
            this.phoneChanged = _data["phoneChanged"];
            this.email = _data["email"];
            this.emailChanged = _data["emailChanged"];
            this.website = _data["website"];
            this.websiteChanged = _data["websiteChanged"];
            this.businessHours = _data["businessHours"];
            this.businessHoursChanged = _data["businessHoursChanged"];
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.dateOfOpeningChanged = _data["dateOfOpeningChanged"];
        }
    }

    static fromJS(data: any): MutBusinessMoveDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutBusinessMoveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessId"] = this.businessId;
        data["postCode"] = this.postCode;
        data["postCodeChanged"] = this.postCodeChanged;
        data["city"] = this.city;
        data["cityChanged"] = this.cityChanged;
        data["street"] = this.street;
        data["streetChanged"] = this.streetChanged;
        data["streetNr"] = this.streetNr;
        data["streetNrChanged"] = this.streetNrChanged;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postOfficeBoxChanged"] = this.postOfficeBoxChanged;
        data["addressAddition"] = this.addressAddition;
        data["addressAdditionChanged"] = this.addressAdditionChanged;
        data["phone"] = this.phone;
        data["phoneChanged"] = this.phoneChanged;
        data["email"] = this.email;
        data["emailChanged"] = this.emailChanged;
        data["website"] = this.website;
        data["websiteChanged"] = this.websiteChanged;
        data["businessHours"] = this.businessHours;
        data["businessHoursChanged"] = this.businessHoursChanged;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfOpeningChanged"] = this.dateOfOpeningChanged;
        return data;
    }
}

export interface IMutBusinessMoveDto {
    id: number | undefined;
    businessId: number | undefined;
    postCode: string;
    postCodeChanged: boolean;
    city: string;
    cityChanged: boolean;
    street: string;
    streetChanged: boolean;
    streetNr: string;
    streetNrChanged: boolean;
    postOfficeBox: string | undefined;
    postOfficeBoxChanged: boolean;
    addressAddition: string | undefined;
    addressAdditionChanged: boolean;
    phone: string;
    phoneChanged: boolean;
    email: string;
    emailChanged: boolean;
    website: string | undefined;
    websiteChanged: boolean;
    businessHours: string | undefined;
    businessHoursChanged: boolean;
    dateOfOpening: DateTime;
    dateOfOpeningChanged: boolean;
}

export class MutDocumentsOutput implements IMutDocumentsOutput {
    caseId!: string;
    documents!: GeneralDocumentGroupDto[];

    constructor(data?: IMutDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MutDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new MutDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMutDocumentsOutput {
    caseId: string;
    documents: GeneralDocumentGroupDto[];
}

export class MutDto implements IMutDto {
    application!: ApplicationDto;
    mutationTypeId!: string | undefined;
    corporateLicenceId!: number | undefined;
    sponsorshipTypeId!: string | undefined;
    sponsorshipId!: number | undefined;
    statusId!: MutStatus;
    firstStep!: MutStatus;

    constructor(data?: IMutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.mutationTypeId = _data["mutationTypeId"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.statusId = _data["statusId"];
            this.firstStep = _data["firstStep"];
        }
    }

    static fromJS(data: any): MutDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["mutationTypeId"] = this.mutationTypeId;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["sponsorshipId"] = this.sponsorshipId;
        data["statusId"] = this.statusId;
        data["firstStep"] = this.firstStep;
        return data;
    }
}

export interface IMutDto {
    application: ApplicationDto;
    mutationTypeId: string | undefined;
    corporateLicenceId: number | undefined;
    sponsorshipTypeId: string | undefined;
    sponsorshipId: number | undefined;
    statusId: MutStatus;
    firstStep: MutStatus;
}

export class MutEmploymentCreateDto implements IMutEmploymentCreateDto {
    id!: number | undefined;
    name!: string;
    legalFormId!: string;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    phone!: string;
    email!: string;
    dateOfEmployment!: DateTime;
    levelOfEmployment!: number;
    roleId!: string;

    constructor(data?: IMutEmploymentCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): MutEmploymentCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutEmploymentCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IMutEmploymentCreateDto {
    id: number | undefined;
    name: string;
    legalFormId: string;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    phone: string;
    email: string;
    dateOfEmployment: DateTime;
    levelOfEmployment: number;
    roleId: string;
}

export class MutEmploymentTerminateAllDto implements IMutEmploymentTerminateAllDto {
    id!: number | undefined;
    dateOfEndOfEmployment!: DateTime;
    reason!: string | undefined;

    constructor(data?: IMutEmploymentTerminateAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): MutEmploymentTerminateAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutEmploymentTerminateAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IMutEmploymentTerminateAllDto {
    id: number | undefined;
    dateOfEndOfEmployment: DateTime;
    reason: string | undefined;
}

export class MutEmploymentTerminateDto implements IMutEmploymentTerminateDto {
    id!: number | undefined;
    employmentId!: number;
    dateOfEndOfEmployment!: DateTime;
    reason!: string | undefined;

    constructor(data?: IMutEmploymentTerminateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employmentId = _data["employmentId"];
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): MutEmploymentTerminateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutEmploymentTerminateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employmentId"] = this.employmentId;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IMutEmploymentTerminateDto {
    id: number | undefined;
    employmentId: number;
    dateOfEndOfEmployment: DateTime;
    reason: string | undefined;
}

export class MutEmploymentUpdateDto implements IMutEmploymentUpdateDto {
    id!: number | undefined;
    employmentId!: number;
    name!: string;
    nameChanged!: boolean;
    legalFormId!: string;
    legalFormIdChanged!: boolean;
    postCode!: string;
    postCodeChanged!: boolean;
    city!: string;
    cityChanged!: boolean;
    street!: string;
    streetChanged!: boolean;
    streetNr!: string | undefined;
    streetNrChanged!: boolean;
    postOfficeBox!: string | undefined;
    postOfficeBoxChanged!: boolean;
    languageOfCorrespondenceId!: string | undefined;
    languageOfCorrespondenceIdChanged!: boolean;
    phone!: string;
    phoneChanged!: boolean;
    email!: string;
    emailChanged!: boolean;
    dateOfEmployment!: DateTime;
    dateOfEmploymentChanged!: boolean;
    levelOfEmployment!: number;
    levelOfEmploymentChanged!: boolean;
    roleId!: string;
    roleIdChanged!: boolean;

    constructor(data?: IMutEmploymentUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employmentId = _data["employmentId"];
            this.name = _data["name"];
            this.nameChanged = _data["nameChanged"];
            this.legalFormId = _data["legalFormId"];
            this.legalFormIdChanged = _data["legalFormIdChanged"];
            this.postCode = _data["postCode"];
            this.postCodeChanged = _data["postCodeChanged"];
            this.city = _data["city"];
            this.cityChanged = _data["cityChanged"];
            this.street = _data["street"];
            this.streetChanged = _data["streetChanged"];
            this.streetNr = _data["streetNr"];
            this.streetNrChanged = _data["streetNrChanged"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postOfficeBoxChanged = _data["postOfficeBoxChanged"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.languageOfCorrespondenceIdChanged = _data["languageOfCorrespondenceIdChanged"];
            this.phone = _data["phone"];
            this.phoneChanged = _data["phoneChanged"];
            this.email = _data["email"];
            this.emailChanged = _data["emailChanged"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEmploymentChanged = _data["dateOfEmploymentChanged"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.levelOfEmploymentChanged = _data["levelOfEmploymentChanged"];
            this.roleId = _data["roleId"];
            this.roleIdChanged = _data["roleIdChanged"];
        }
    }

    static fromJS(data: any): MutEmploymentUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutEmploymentUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employmentId"] = this.employmentId;
        data["name"] = this.name;
        data["nameChanged"] = this.nameChanged;
        data["legalFormId"] = this.legalFormId;
        data["legalFormIdChanged"] = this.legalFormIdChanged;
        data["postCode"] = this.postCode;
        data["postCodeChanged"] = this.postCodeChanged;
        data["city"] = this.city;
        data["cityChanged"] = this.cityChanged;
        data["street"] = this.street;
        data["streetChanged"] = this.streetChanged;
        data["streetNr"] = this.streetNr;
        data["streetNrChanged"] = this.streetNrChanged;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postOfficeBoxChanged"] = this.postOfficeBoxChanged;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["languageOfCorrespondenceIdChanged"] = this.languageOfCorrespondenceIdChanged;
        data["phone"] = this.phone;
        data["phoneChanged"] = this.phoneChanged;
        data["email"] = this.email;
        data["emailChanged"] = this.emailChanged;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEmploymentChanged"] = this.dateOfEmploymentChanged;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["levelOfEmploymentChanged"] = this.levelOfEmploymentChanged;
        data["roleId"] = this.roleId;
        data["roleIdChanged"] = this.roleIdChanged;
        return data;
    }
}

export interface IMutEmploymentUpdateDto {
    id: number | undefined;
    employmentId: number;
    name: string;
    nameChanged: boolean;
    legalFormId: string;
    legalFormIdChanged: boolean;
    postCode: string;
    postCodeChanged: boolean;
    city: string;
    cityChanged: boolean;
    street: string;
    streetChanged: boolean;
    streetNr: string | undefined;
    streetNrChanged: boolean;
    postOfficeBox: string | undefined;
    postOfficeBoxChanged: boolean;
    languageOfCorrespondenceId: string | undefined;
    languageOfCorrespondenceIdChanged: boolean;
    phone: string;
    phoneChanged: boolean;
    email: string;
    emailChanged: boolean;
    dateOfEmployment: DateTime;
    dateOfEmploymentChanged: boolean;
    levelOfEmployment: number;
    levelOfEmploymentChanged: boolean;
    roleId: string;
    roleIdChanged: boolean;
}

export class MutMedicalFieldDirectorDto implements IMutMedicalFieldDirectorDto {
    id!: number | undefined;
    dateOfCurrentResponsibilityEnd!: DateTime;
    dateOfNewResponsibilityStart!: DateTime;
    gln!: string;
    professionId!: string;
    email!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    levelOfEmployment!: number;
    employments!: EmploymentWithPersonDto[] | undefined;

    constructor(data?: IMutMedicalFieldDirectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateOfCurrentResponsibilityEnd = _data["dateOfCurrentResponsibilityEnd"] ? DateTime.fromISO(_data["dateOfCurrentResponsibilityEnd"].toString()) : <any>undefined;
            this.dateOfNewResponsibilityStart = _data["dateOfNewResponsibilityStart"] ? DateTime.fromISO(_data["dateOfNewResponsibilityStart"].toString()) : <any>undefined;
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(EmploymentWithPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MutMedicalFieldDirectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutMedicalFieldDirectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateOfCurrentResponsibilityEnd"] = this.dateOfCurrentResponsibilityEnd ? this.dateOfCurrentResponsibilityEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNewResponsibilityStart"] = this.dateOfNewResponsibilityStart ? this.dateOfNewResponsibilityStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["levelOfEmployment"] = this.levelOfEmployment;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMutMedicalFieldDirectorDto {
    id: number | undefined;
    dateOfCurrentResponsibilityEnd: DateTime;
    dateOfNewResponsibilityStart: DateTime;
    gln: string;
    professionId: string;
    email: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    levelOfEmployment: number;
    employments: EmploymentWithPersonDto[] | undefined;
}

export class MutMedicalFieldHaemovigilanceDirectorDto implements IMutMedicalFieldHaemovigilanceDirectorDto {
    id!: number | undefined;
    dateOfCurrentResponsibilityEnd!: DateTime;
    dateOfNewResponsibilityStart!: DateTime;
    gln!: string;
    professionId!: string;
    email!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    levelOfEmployment!: number;
    employments!: EmploymentWithPersonDto[] | undefined;

    constructor(data?: IMutMedicalFieldHaemovigilanceDirectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateOfCurrentResponsibilityEnd = _data["dateOfCurrentResponsibilityEnd"] ? DateTime.fromISO(_data["dateOfCurrentResponsibilityEnd"].toString()) : <any>undefined;
            this.dateOfNewResponsibilityStart = _data["dateOfNewResponsibilityStart"] ? DateTime.fromISO(_data["dateOfNewResponsibilityStart"].toString()) : <any>undefined;
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(EmploymentWithPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MutMedicalFieldHaemovigilanceDirectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutMedicalFieldHaemovigilanceDirectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateOfCurrentResponsibilityEnd"] = this.dateOfCurrentResponsibilityEnd ? this.dateOfCurrentResponsibilityEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNewResponsibilityStart"] = this.dateOfNewResponsibilityStart ? this.dateOfNewResponsibilityStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["levelOfEmployment"] = this.levelOfEmployment;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMutMedicalFieldHaemovigilanceDirectorDto {
    id: number | undefined;
    dateOfCurrentResponsibilityEnd: DateTime;
    dateOfNewResponsibilityStart: DateTime;
    gln: string;
    professionId: string;
    email: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    levelOfEmployment: number;
    employments: EmploymentWithPersonDto[] | undefined;
}

export class MutMedicalFieldPersonCreateDto implements IMutMedicalFieldPersonCreateDto {
    id!: number | undefined;
    gln!: string | undefined;
    professionId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    roleText!: string | undefined;
    levelOfEmployment!: number;
    dateOfStart!: DateTime;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;

    constructor(data?: IMutMedicalFieldPersonCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.roleText = _data["roleText"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfStart = _data["dateOfStart"] ? DateTime.fromISO(_data["dateOfStart"].toString()) : <any>undefined;
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): MutMedicalFieldPersonCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutMedicalFieldPersonCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["roleText"] = this.roleText;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfStart"] = this.dateOfStart ? this.dateOfStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        return data;
    }
}

export interface IMutMedicalFieldPersonCreateDto {
    id: number | undefined;
    gln: string | undefined;
    professionId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    roleText: string | undefined;
    levelOfEmployment: number;
    dateOfStart: DateTime;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
}

export class MutMedicalFieldPersonTerminateDto implements IMutMedicalFieldPersonTerminateDto {
    id!: number | undefined;
    dateOfEndOfEmployment!: DateTime;
    reason!: string | undefined;
    employments!: SelectableEmploymentWithPersonDto[] | undefined;

    constructor(data?: IMutMedicalFieldPersonTerminateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(SelectableEmploymentWithPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MutMedicalFieldPersonTerminateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutMedicalFieldPersonTerminateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["reason"] = this.reason;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMutMedicalFieldPersonTerminateDto {
    id: number | undefined;
    dateOfEndOfEmployment: DateTime;
    reason: string | undefined;
    employments: SelectableEmploymentWithPersonDto[] | undefined;
}

export class MutMedicalFieldStorageAndQualityDirectorDto implements IMutMedicalFieldStorageAndQualityDirectorDto {
    id!: number | undefined;
    dateOfCurrentResponsibilityEnd!: DateTime;
    dateOfNewResponsibilityStart!: DateTime;
    gln!: string;
    professionId!: string;
    email!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    levelOfEmployment!: number;
    employments!: EmploymentWithPersonDto[] | undefined;

    constructor(data?: IMutMedicalFieldStorageAndQualityDirectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateOfCurrentResponsibilityEnd = _data["dateOfCurrentResponsibilityEnd"] ? DateTime.fromISO(_data["dateOfCurrentResponsibilityEnd"].toString()) : <any>undefined;
            this.dateOfNewResponsibilityStart = _data["dateOfNewResponsibilityStart"] ? DateTime.fromISO(_data["dateOfNewResponsibilityStart"].toString()) : <any>undefined;
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(EmploymentWithPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MutMedicalFieldStorageAndQualityDirectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutMedicalFieldStorageAndQualityDirectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateOfCurrentResponsibilityEnd"] = this.dateOfCurrentResponsibilityEnd ? this.dateOfCurrentResponsibilityEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNewResponsibilityStart"] = this.dateOfNewResponsibilityStart ? this.dateOfNewResponsibilityStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["levelOfEmployment"] = this.levelOfEmployment;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMutMedicalFieldStorageAndQualityDirectorDto {
    id: number | undefined;
    dateOfCurrentResponsibilityEnd: DateTime;
    dateOfNewResponsibilityStart: DateTime;
    gln: string;
    professionId: string;
    email: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    levelOfEmployment: number;
    employments: EmploymentWithPersonDto[] | undefined;
}

export class MutPersonContactDto implements IMutPersonContactDto {
    id!: number | undefined;
    titleId!: string | undefined;
    titleIdChanged!: boolean;
    languageOfCorrespondenceId!: string | undefined;
    languageOfCorrespondenceIdChanged!: boolean;
    countryId!: string | undefined;
    countryIdChanged!: boolean;
    street!: string;
    streetChanged!: boolean;
    streetNr!: string | undefined;
    streetNrChanged!: boolean;
    postCode!: string;
    postCodeChanged!: boolean;
    city!: string;
    cityChanged!: boolean;
    postOfficeBox!: string | undefined;
    postOfficeBoxChanged!: boolean;
    addressAddition!: string | undefined;
    addressAdditionChanged!: boolean;
    email1!: string | undefined;
    email1Changed!: boolean;
    email2!: string | undefined;
    email2Changed!: boolean;
    phone1!: string | undefined;
    phone1Changed!: boolean;
    phone2!: string | undefined;
    phone2Changed!: boolean;

    constructor(data?: IMutPersonContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titleId = _data["titleId"];
            this.titleIdChanged = _data["titleIdChanged"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.languageOfCorrespondenceIdChanged = _data["languageOfCorrespondenceIdChanged"];
            this.countryId = _data["countryId"];
            this.countryIdChanged = _data["countryIdChanged"];
            this.street = _data["street"];
            this.streetChanged = _data["streetChanged"];
            this.streetNr = _data["streetNr"];
            this.streetNrChanged = _data["streetNrChanged"];
            this.postCode = _data["postCode"];
            this.postCodeChanged = _data["postCodeChanged"];
            this.city = _data["city"];
            this.cityChanged = _data["cityChanged"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postOfficeBoxChanged = _data["postOfficeBoxChanged"];
            this.addressAddition = _data["addressAddition"];
            this.addressAdditionChanged = _data["addressAdditionChanged"];
            this.email1 = _data["email1"];
            this.email1Changed = _data["email1Changed"];
            this.email2 = _data["email2"];
            this.email2Changed = _data["email2Changed"];
            this.phone1 = _data["phone1"];
            this.phone1Changed = _data["phone1Changed"];
            this.phone2 = _data["phone2"];
            this.phone2Changed = _data["phone2Changed"];
        }
    }

    static fromJS(data: any): MutPersonContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutPersonContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titleId"] = this.titleId;
        data["titleIdChanged"] = this.titleIdChanged;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["languageOfCorrespondenceIdChanged"] = this.languageOfCorrespondenceIdChanged;
        data["countryId"] = this.countryId;
        data["countryIdChanged"] = this.countryIdChanged;
        data["street"] = this.street;
        data["streetChanged"] = this.streetChanged;
        data["streetNr"] = this.streetNr;
        data["streetNrChanged"] = this.streetNrChanged;
        data["postCode"] = this.postCode;
        data["postCodeChanged"] = this.postCodeChanged;
        data["city"] = this.city;
        data["cityChanged"] = this.cityChanged;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postOfficeBoxChanged"] = this.postOfficeBoxChanged;
        data["addressAddition"] = this.addressAddition;
        data["addressAdditionChanged"] = this.addressAdditionChanged;
        data["email1"] = this.email1;
        data["email1Changed"] = this.email1Changed;
        data["email2"] = this.email2;
        data["email2Changed"] = this.email2Changed;
        data["phone1"] = this.phone1;
        data["phone1Changed"] = this.phone1Changed;
        data["phone2"] = this.phone2;
        data["phone2Changed"] = this.phone2Changed;
        return data;
    }
}

export interface IMutPersonContactDto {
    id: number | undefined;
    titleId: string | undefined;
    titleIdChanged: boolean;
    languageOfCorrespondenceId: string | undefined;
    languageOfCorrespondenceIdChanged: boolean;
    countryId: string | undefined;
    countryIdChanged: boolean;
    street: string;
    streetChanged: boolean;
    streetNr: string | undefined;
    streetNrChanged: boolean;
    postCode: string;
    postCodeChanged: boolean;
    city: string;
    cityChanged: boolean;
    postOfficeBox: string | undefined;
    postOfficeBoxChanged: boolean;
    addressAddition: string | undefined;
    addressAdditionChanged: boolean;
    email1: string | undefined;
    email1Changed: boolean;
    email2: string | undefined;
    email2Changed: boolean;
    phone1: string | undefined;
    phone1Changed: boolean;
    phone2: string | undefined;
    phone2Changed: boolean;
}

export class MutPersonNameDto implements IMutPersonNameDto {
    id!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    readonly fullName!: string | undefined;

    constructor(data?: IMutPersonNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): MutPersonNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutPersonNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IMutPersonNameDto {
    id: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fullName: string | undefined;
}

export class MutSponsorshipAddressDto implements IMutSponsorshipAddressDto {
    name!: string | undefined;
    legalFormId!: string | undefined;
    uid!: string | undefined;
    postCode!: string;
    postCodeChanged!: boolean;
    city!: string;
    cityChanged!: boolean;
    street!: string;
    streetChanged!: boolean;
    streetNr!: string | undefined;
    streetNrChanged!: boolean;
    postOfficeBox!: string | undefined;
    postOfficeBoxChanged!: boolean;

    constructor(data?: IMutSponsorshipAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.legalFormId = _data["legalFormId"];
            this.uid = _data["uid"];
            this.postCode = _data["postCode"];
            this.postCodeChanged = _data["postCodeChanged"];
            this.city = _data["city"];
            this.cityChanged = _data["cityChanged"];
            this.street = _data["street"];
            this.streetChanged = _data["streetChanged"];
            this.streetNr = _data["streetNr"];
            this.streetNrChanged = _data["streetNrChanged"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postOfficeBoxChanged = _data["postOfficeBoxChanged"];
        }
    }

    static fromJS(data: any): MutSponsorshipAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutSponsorshipAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["legalFormId"] = this.legalFormId;
        data["uid"] = this.uid;
        data["postCode"] = this.postCode;
        data["postCodeChanged"] = this.postCodeChanged;
        data["city"] = this.city;
        data["cityChanged"] = this.cityChanged;
        data["street"] = this.street;
        data["streetChanged"] = this.streetChanged;
        data["streetNr"] = this.streetNr;
        data["streetNrChanged"] = this.streetNrChanged;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postOfficeBoxChanged"] = this.postOfficeBoxChanged;
        return data;
    }
}

export interface IMutSponsorshipAddressDto {
    name: string | undefined;
    legalFormId: string | undefined;
    uid: string | undefined;
    postCode: string;
    postCodeChanged: boolean;
    city: string;
    cityChanged: boolean;
    street: string;
    streetChanged: boolean;
    streetNr: string | undefined;
    streetNrChanged: boolean;
    postOfficeBox: string | undefined;
    postOfficeBoxChanged: boolean;
}

export class MutSponsorshipContactDto implements IMutSponsorshipContactDto {
    languageOfCorrespondenceId!: string | undefined;
    languageOfCorrespondenceIdChanged!: boolean;
    phone1!: string;
    phone1Changed!: boolean;
    phone2!: string | undefined;
    phone2Changed!: boolean;
    email1!: string;
    email1Changed!: boolean;
    email2!: string | undefined;
    email2Changed!: boolean;

    constructor(data?: IMutSponsorshipContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.languageOfCorrespondenceIdChanged = _data["languageOfCorrespondenceIdChanged"];
            this.phone1 = _data["phone1"];
            this.phone1Changed = _data["phone1Changed"];
            this.phone2 = _data["phone2"];
            this.phone2Changed = _data["phone2Changed"];
            this.email1 = _data["email1"];
            this.email1Changed = _data["email1Changed"];
            this.email2 = _data["email2"];
            this.email2Changed = _data["email2Changed"];
        }
    }

    static fromJS(data: any): MutSponsorshipContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutSponsorshipContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["languageOfCorrespondenceIdChanged"] = this.languageOfCorrespondenceIdChanged;
        data["phone1"] = this.phone1;
        data["phone1Changed"] = this.phone1Changed;
        data["phone2"] = this.phone2;
        data["phone2Changed"] = this.phone2Changed;
        data["email1"] = this.email1;
        data["email1Changed"] = this.email1Changed;
        data["email2"] = this.email2;
        data["email2Changed"] = this.email2Changed;
        return data;
    }
}

export interface IMutSponsorshipContactDto {
    languageOfCorrespondenceId: string | undefined;
    languageOfCorrespondenceIdChanged: boolean;
    phone1: string;
    phone1Changed: boolean;
    phone2: string | undefined;
    phone2Changed: boolean;
    email1: string;
    email1Changed: boolean;
    email2: string | undefined;
    email2Changed: boolean;
}

export class MutSponsorshipDirectorCreateDto implements IMutSponsorshipDirectorCreateDto {
    id!: number | undefined;
    gln!: string | undefined;
    professionId!: string | undefined;
    titleId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    businessId!: number | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    levelOfEmployment!: number;
    dateOfStart!: DateTime;

    constructor(data?: IMutSponsorshipDirectorCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.titleId = _data["titleId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.businessId = _data["businessId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfStart = _data["dateOfStart"] ? DateTime.fromISO(_data["dateOfStart"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MutSponsorshipDirectorCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutSponsorshipDirectorCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["titleId"] = this.titleId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["businessId"] = this.businessId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfStart"] = this.dateOfStart ? this.dateOfStart.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IMutSponsorshipDirectorCreateDto {
    id: number | undefined;
    gln: string | undefined;
    professionId: string | undefined;
    titleId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    businessId: number | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    levelOfEmployment: number;
    dateOfStart: DateTime;
}

export class MutSponsorshipDirectorTerminateDto implements IMutSponsorshipDirectorTerminateDto {
    id!: number | undefined;
    dateOfEndOfEmployment!: DateTime;
    reason!: string | undefined;
    employments!: SelectableEmploymentWithPersonDto[] | undefined;

    constructor(data?: IMutSponsorshipDirectorTerminateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(SelectableEmploymentWithPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MutSponsorshipDirectorTerminateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutSponsorshipDirectorTerminateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["reason"] = this.reason;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMutSponsorshipDirectorTerminateDto {
    id: number | undefined;
    dateOfEndOfEmployment: DateTime;
    reason: string | undefined;
    employments: SelectableEmploymentWithPersonDto[] | undefined;
}

export class MutSponsorshipNameDto implements IMutSponsorshipNameDto {
    id!: number | undefined;
    name!: string;
    nameChanged!: boolean;
    legalFormId!: string;
    legalFormIdChanged!: boolean;
    oldLegalFormId!: string | undefined;
    uid!: string | undefined;
    uidChanged!: boolean;
    oldUid!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;

    constructor(data?: IMutSponsorshipNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameChanged = _data["nameChanged"];
            this.legalFormId = _data["legalFormId"];
            this.legalFormIdChanged = _data["legalFormIdChanged"];
            this.oldLegalFormId = _data["oldLegalFormId"];
            this.uid = _data["uid"];
            this.uidChanged = _data["uidChanged"];
            this.oldUid = _data["oldUid"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
        }
    }

    static fromJS(data: any): MutSponsorshipNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutSponsorshipNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameChanged"] = this.nameChanged;
        data["legalFormId"] = this.legalFormId;
        data["legalFormIdChanged"] = this.legalFormIdChanged;
        data["oldLegalFormId"] = this.oldLegalFormId;
        data["uid"] = this.uid;
        data["uidChanged"] = this.uidChanged;
        data["oldUid"] = this.oldUid;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        return data;
    }
}

export interface IMutSponsorshipNameDto {
    id: number | undefined;
    name: string;
    nameChanged: boolean;
    legalFormId: string;
    legalFormIdChanged: boolean;
    oldLegalFormId: string | undefined;
    uid: string | undefined;
    uidChanged: boolean;
    oldUid: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
}

export enum MutStatus {
    ApplicantPerson = 0,
    ApplicantSponsorship = 1,
    ApplicantBusiness = 2,
    BusinessCreate = 4,
    BusinessClosure = 5,
    BusinessMove = 6,
    AdditionalAcademicTitle = 7,
    EmploymentCreate = 9,
    EmploymentTerminate = 10,
    MedicalFieldDirector = 17,
    BusinessDirector = 18,
    PersonName = 21,
    PersonContact = 22,
    SponsorshipName = 23,
    SponsorshipAddress = 24,
    SponsorshipContact = 25,
    EmploymentUpdate = 26,
    EmploymentTerminateAll = 27,
    BusinessBankruptcy = 28,
    MedicalFieldPersonCreate = 29,
    MedicalFieldPersonTerminate = 30,
    SponsorshipDirectorCreate = 31,
    SponsorshipDirectorTerminate = 32,
    MedicalFieldStorageAndQualityDirector = 33,
    MedicalFieldHaemovigilanceDirector = 34,
    PersonnelChange = 44,
    ApplicantAdditionalComments = 80,
    ApplicantContact = 81,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export class MutationApplicationSearchDto implements IMutationApplicationSearchDto {
    id!: number;
    responsibleId!: number | undefined;
    responsibleFullName!: string | undefined;
    iAmResponsible!: boolean;
    caseId!: string | undefined;
    caseIdSearchable!: string | undefined;
    userFullName!: string | undefined;
    userEmail!: string | undefined;
    mutationName!: string | undefined;
    glnUid!: string | undefined;
    professionId!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    mutationTypeId!: string | undefined;
    type!: number;
    status!: ApplicationStatus;
    dateOfStatusChange!: DateTime;
    submittedCount!: number;
    submittedDate!: DateTime | undefined;
    lastSubmittedDate!: DateTime | undefined;

    constructor(data?: IMutationApplicationSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.responsibleId = _data["responsibleId"];
            this.responsibleFullName = _data["responsibleFullName"];
            this.iAmResponsible = _data["iAmResponsible"];
            this.caseId = _data["caseId"];
            this.caseIdSearchable = _data["caseIdSearchable"];
            this.userFullName = _data["userFullName"];
            this.userEmail = _data["userEmail"];
            this.mutationName = _data["mutationName"];
            this.glnUid = _data["glnUid"];
            this.professionId = _data["professionId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.mutationTypeId = _data["mutationTypeId"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.submittedCount = _data["submittedCount"];
            this.submittedDate = _data["submittedDate"] ? DateTime.fromISO(_data["submittedDate"].toString()) : <any>undefined;
            this.lastSubmittedDate = _data["lastSubmittedDate"] ? DateTime.fromISO(_data["lastSubmittedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MutationApplicationSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutationApplicationSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["responsibleId"] = this.responsibleId;
        data["responsibleFullName"] = this.responsibleFullName;
        data["iAmResponsible"] = this.iAmResponsible;
        data["caseId"] = this.caseId;
        data["caseIdSearchable"] = this.caseIdSearchable;
        data["userFullName"] = this.userFullName;
        data["userEmail"] = this.userEmail;
        data["mutationName"] = this.mutationName;
        data["glnUid"] = this.glnUid;
        data["professionId"] = this.professionId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["mutationTypeId"] = this.mutationTypeId;
        data["type"] = this.type;
        data["status"] = this.status;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toString() : <any>undefined;
        data["submittedCount"] = this.submittedCount;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toString() : <any>undefined;
        data["lastSubmittedDate"] = this.lastSubmittedDate ? this.lastSubmittedDate.toString() : <any>undefined;
        return data;
    }
}

export interface IMutationApplicationSearchDto {
    id: number;
    responsibleId: number | undefined;
    responsibleFullName: string | undefined;
    iAmResponsible: boolean;
    caseId: string | undefined;
    caseIdSearchable: string | undefined;
    userFullName: string | undefined;
    userEmail: string | undefined;
    mutationName: string | undefined;
    glnUid: string | undefined;
    professionId: string | undefined;
    sponsorshipTypeId: string | undefined;
    mutationTypeId: string | undefined;
    type: number;
    status: ApplicationStatus;
    dateOfStatusChange: DateTime;
    submittedCount: number;
    submittedDate: DateTime | undefined;
    lastSubmittedDate: DateTime | undefined;
}

export class MutationApplicationSummaryDto implements IMutationApplicationSummaryDto {
    applicationType!: ApplicationType;
    applicationStatus!: ApplicationStatus;
    mutationTypeId!: string | undefined;
    dateOfStatusChange!: DateTime;
    caseId!: string | undefined;
    name!: string | undefined;
    professionId!: string | undefined;
    gln!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    uid!: string | undefined;

    constructor(data?: IMutationApplicationSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationType = _data["applicationType"];
            this.applicationStatus = _data["applicationStatus"];
            this.mutationTypeId = _data["mutationTypeId"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.caseId = _data["caseId"];
            this.name = _data["name"];
            this.professionId = _data["professionId"];
            this.gln = _data["gln"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.uid = _data["uid"];
        }
    }

    static fromJS(data: any): MutationApplicationSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutationApplicationSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationType"] = this.applicationType;
        data["applicationStatus"] = this.applicationStatus;
        data["mutationTypeId"] = this.mutationTypeId;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toString() : <any>undefined;
        data["caseId"] = this.caseId;
        data["name"] = this.name;
        data["professionId"] = this.professionId;
        data["gln"] = this.gln;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["uid"] = this.uid;
        return data;
    }
}

export interface IMutationApplicationSummaryDto {
    applicationType: ApplicationType;
    applicationStatus: ApplicationStatus;
    mutationTypeId: string | undefined;
    dateOfStatusChange: DateTime;
    caseId: string | undefined;
    name: string | undefined;
    professionId: string | undefined;
    gln: string | undefined;
    sponsorshipTypeId: string | undefined;
    uid: string | undefined;
}

export class MySironaBusinessDto implements IMySironaBusinessDto {
    name!: string | undefined;
    additionalName!: string | undefined;
    legalFormId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    cantonId!: string | undefined;
    id!: number;

    constructor(data?: IMySironaBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.cantonId = _data["cantonId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MySironaBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new MySironaBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["cantonId"] = this.cantonId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMySironaBusinessDto {
    name: string | undefined;
    additionalName: string | undefined;
    legalFormId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    cantonId: string | undefined;
    id: number;
}

export class MySironaDocumentDto implements IMySironaDocumentDto {
    typeId!: string | undefined;
    categoryId!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    dateOfReceipt!: DateTime;
    datedFrom!: DateTime | undefined;
    mimeType!: string | undefined;
    id!: number;

    constructor(data?: IMySironaDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.dateOfReceipt = _data["dateOfReceipt"] ? DateTime.fromISO(_data["dateOfReceipt"].toString()) : <any>undefined;
            this.datedFrom = _data["datedFrom"] ? DateTime.fromISO(_data["datedFrom"].toString()) : <any>undefined;
            this.mimeType = _data["mimeType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MySironaDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MySironaDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["dateOfReceipt"] = this.dateOfReceipt ? this.dateOfReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datedFrom"] = this.datedFrom ? this.datedFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        data["mimeType"] = this.mimeType;
        data["id"] = this.id;
        return data;
    }
}

export interface IMySironaDocumentDto {
    typeId: string | undefined;
    categoryId: string | undefined;
    name: string | undefined;
    description: string | undefined;
    dateOfReceipt: DateTime;
    datedFrom: DateTime | undefined;
    mimeType: string | undefined;
    id: number;
}

export class MySironaEmploymentAddressDto implements IMySironaEmploymentAddressDto {
    name!: string | undefined;
    additionalName!: string | undefined;
    legalFormId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    cantonId!: string | undefined;

    constructor(data?: IMySironaEmploymentAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.cantonId = _data["cantonId"];
        }
    }

    static fromJS(data: any): MySironaEmploymentAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new MySironaEmploymentAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["cantonId"] = this.cantonId;
        return data;
    }
}

export interface IMySironaEmploymentAddressDto {
    name: string | undefined;
    additionalName: string | undefined;
    legalFormId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    cantonId: string | undefined;
}

export class MySironaEmploymentDto implements IMySironaEmploymentDto {
    statusId!: string | undefined;
    person!: MySironaGetPersonDataDto;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    locationTypeId!: string | undefined;
    roleId!: string | undefined;
    roleText!: string | undefined;
    address!: MySironaEmploymentAddressDto;
    isMobileEmployment!: boolean;
    id!: number;

    constructor(data?: IMySironaEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusId = _data["statusId"];
            this.person = _data["person"] ? MySironaGetPersonDataDto.fromJS(_data["person"]) : <any>undefined;
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.locationTypeId = _data["locationTypeId"];
            this.roleId = _data["roleId"];
            this.roleText = _data["roleText"];
            this.address = _data["address"] ? MySironaEmploymentAddressDto.fromJS(_data["address"]) : <any>undefined;
            this.isMobileEmployment = _data["isMobileEmployment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MySironaEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MySironaEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusId"] = this.statusId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["locationTypeId"] = this.locationTypeId;
        data["roleId"] = this.roleId;
        data["roleText"] = this.roleText;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["isMobileEmployment"] = this.isMobileEmployment;
        data["id"] = this.id;
        return data;
    }
}

export interface IMySironaEmploymentDto {
    statusId: string | undefined;
    person: MySironaGetPersonDataDto;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    locationTypeId: string | undefined;
    roleId: string | undefined;
    roleText: string | undefined;
    address: MySironaEmploymentAddressDto;
    isMobileEmployment: boolean;
    id: number;
}

export class MySironaLegitimatedUser implements IMySironaLegitimatedUser {
    legitimationId!: number;
    discriminator!: LegitimationType;
    userId!: number;
    role!: LegitimationRole;
    isDeleted!: boolean;
    name!: string | undefined;
    surname!: string | undefined;
    emailAddress!: string | undefined;

    constructor(data?: IMySironaLegitimatedUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legitimationId = _data["legitimationId"];
            this.discriminator = _data["discriminator"];
            this.userId = _data["userId"];
            this.role = _data["role"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): MySironaLegitimatedUser {
        data = typeof data === 'object' ? data : {};
        let result = new MySironaLegitimatedUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legitimationId"] = this.legitimationId;
        data["discriminator"] = this.discriminator;
        data["userId"] = this.userId;
        data["role"] = this.role;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IMySironaLegitimatedUser {
    legitimationId: number;
    discriminator: LegitimationType;
    userId: number;
    role: LegitimationRole;
    isDeleted: boolean;
    name: string | undefined;
    surname: string | undefined;
    emailAddress: string | undefined;
}

export class MySironaUserDocumentDto implements IMySironaUserDocumentDto {
    document!: MySironaDocumentDto;
    entityDiscriminator!: string | undefined;
    entityId!: number;
    entityGlnOrUid!: string | undefined;
    entityName!: string | undefined;

    constructor(data?: IMySironaUserDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document = _data["document"] ? MySironaDocumentDto.fromJS(_data["document"]) : <any>undefined;
            this.entityDiscriminator = _data["entityDiscriminator"];
            this.entityId = _data["entityId"];
            this.entityGlnOrUid = _data["entityGlnOrUid"];
            this.entityName = _data["entityName"];
        }
    }

    static fromJS(data: any): MySironaUserDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MySironaUserDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["entityDiscriminator"] = this.entityDiscriminator;
        data["entityId"] = this.entityId;
        data["entityGlnOrUid"] = this.entityGlnOrUid;
        data["entityName"] = this.entityName;
        return data;
    }
}

export interface IMySironaUserDocumentDto {
    document: MySironaDocumentDto;
    entityDiscriminator: string | undefined;
    entityId: number;
    entityGlnOrUid: string | undefined;
    entityName: string | undefined;
}

export class GetMySironaNotificationsOutput implements IGetMySironaNotificationsOutput {
    totalCount!: number;
    items!: MySironaNotificationDto[] | undefined;

    constructor(data?: IGetMySironaNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MySironaNotificationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMySironaNotificationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMySironaNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMySironaNotificationsOutput {
    totalCount: number;
    items: MySironaNotificationDto[] | undefined;
}

export class MySironaNotificationDetailDto implements IMySironaNotificationDetailDto {
    receivedDate!: DateTime;
    subject!: string | undefined;
    body!: string | undefined;
    dossierOrDocument!: string | undefined;
    isRead!: boolean;
    readDate!: DateTime | undefined;
    type!: NotificationType;
    sourceEntityId!: number | undefined;
    sourceEntityDiscriminator!: string | undefined;
    personId!: number | undefined;
    personName!: string | undefined;
    sponsorshipId!: number | undefined;
    sponsorshipName!: string | undefined;
    documents!: MySironaNotificationDocumentDto[] | undefined;
    canReply!: boolean;
    responseDate!: DateTime | undefined;
    id!: number;

    constructor(data?: IMySironaNotificationDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receivedDate = _data["receivedDate"] ? DateTime.fromISO(_data["receivedDate"].toString()) : <any>undefined;
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.dossierOrDocument = _data["dossierOrDocument"];
            this.isRead = _data["isRead"];
            this.readDate = _data["readDate"] ? DateTime.fromISO(_data["readDate"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.sourceEntityId = _data["sourceEntityId"];
            this.sourceEntityDiscriminator = _data["sourceEntityDiscriminator"];
            this.personId = _data["personId"];
            this.personName = _data["personName"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.sponsorshipName = _data["sponsorshipName"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(MySironaNotificationDocumentDto.fromJS(item));
            }
            this.canReply = _data["canReply"];
            this.responseDate = _data["responseDate"] ? DateTime.fromISO(_data["responseDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MySironaNotificationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new MySironaNotificationDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toString() : <any>undefined;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["dossierOrDocument"] = this.dossierOrDocument;
        data["isRead"] = this.isRead;
        data["readDate"] = this.readDate ? this.readDate.toString() : <any>undefined;
        data["type"] = this.type;
        data["sourceEntityId"] = this.sourceEntityId;
        data["sourceEntityDiscriminator"] = this.sourceEntityDiscriminator;
        data["personId"] = this.personId;
        data["personName"] = this.personName;
        data["sponsorshipId"] = this.sponsorshipId;
        data["sponsorshipName"] = this.sponsorshipName;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["canReply"] = this.canReply;
        data["responseDate"] = this.responseDate ? this.responseDate.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IMySironaNotificationDetailDto {
    receivedDate: DateTime;
    subject: string | undefined;
    body: string | undefined;
    dossierOrDocument: string | undefined;
    isRead: boolean;
    readDate: DateTime | undefined;
    type: NotificationType;
    sourceEntityId: number | undefined;
    sourceEntityDiscriminator: string | undefined;
    personId: number | undefined;
    personName: string | undefined;
    sponsorshipId: number | undefined;
    sponsorshipName: string | undefined;
    documents: MySironaNotificationDocumentDto[] | undefined;
    canReply: boolean;
    responseDate: DateTime | undefined;
    id: number;
}

export class MySironaNotificationDocumentDto implements IMySironaNotificationDocumentDto {
    name!: string | undefined;
    typeId!: string | undefined;
    mimeType!: string | undefined;
    dateOfReceipt!: DateTime | undefined;
    id!: number;

    constructor(data?: IMySironaNotificationDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.typeId = _data["typeId"];
            this.mimeType = _data["mimeType"];
            this.dateOfReceipt = _data["dateOfReceipt"] ? DateTime.fromISO(_data["dateOfReceipt"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MySironaNotificationDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MySironaNotificationDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["typeId"] = this.typeId;
        data["mimeType"] = this.mimeType;
        data["dateOfReceipt"] = this.dateOfReceipt ? this.dateOfReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IMySironaNotificationDocumentDto {
    name: string | undefined;
    typeId: string | undefined;
    mimeType: string | undefined;
    dateOfReceipt: DateTime | undefined;
    id: number;
}

export class MySironaNotificationDto implements IMySironaNotificationDto {
    receivedDate!: DateTime;
    subject!: string | undefined;
    dossierOrDocument!: string | undefined;
    isRead!: boolean;
    readDate!: DateTime | undefined;
    type!: NotificationType;
    personId!: number | undefined;
    personName!: string | undefined;
    sponsorshipId!: number | undefined;
    sponsorshipName!: string | undefined;
    id!: number;

    constructor(data?: IMySironaNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receivedDate = _data["receivedDate"] ? DateTime.fromISO(_data["receivedDate"].toString()) : <any>undefined;
            this.subject = _data["subject"];
            this.dossierOrDocument = _data["dossierOrDocument"];
            this.isRead = _data["isRead"];
            this.readDate = _data["readDate"] ? DateTime.fromISO(_data["readDate"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.personId = _data["personId"];
            this.personName = _data["personName"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.sponsorshipName = _data["sponsorshipName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MySironaNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MySironaNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toString() : <any>undefined;
        data["subject"] = this.subject;
        data["dossierOrDocument"] = this.dossierOrDocument;
        data["isRead"] = this.isRead;
        data["readDate"] = this.readDate ? this.readDate.toString() : <any>undefined;
        data["type"] = this.type;
        data["personId"] = this.personId;
        data["personName"] = this.personName;
        data["sponsorshipId"] = this.sponsorshipId;
        data["sponsorshipName"] = this.sponsorshipName;
        data["id"] = this.id;
        return data;
    }
}

export interface IMySironaNotificationDto {
    receivedDate: DateTime;
    subject: string | undefined;
    dossierOrDocument: string | undefined;
    isRead: boolean;
    readDate: DateTime | undefined;
    type: NotificationType;
    personId: number | undefined;
    personName: string | undefined;
    sponsorshipId: number | undefined;
    sponsorshipName: string | undefined;
    id: number;
}

export class SendNotificationAttachmentInput implements ISendNotificationAttachmentInput {
    name!: string;
    file!: string;

    constructor(data?: ISendNotificationAttachmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): SendNotificationAttachmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendNotificationAttachmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["file"] = this.file;
        return data;
    }
}

export interface ISendNotificationAttachmentInput {
    name: string;
    file: string;
}

export class SendNotificationResponseInput implements ISendNotificationResponseInput {
    notificationId!: number;
    responseText!: string;
    attachments!: SendNotificationAttachmentInput[] | undefined;

    constructor(data?: ISendNotificationResponseInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationId = _data["notificationId"];
            this.responseText = _data["responseText"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(SendNotificationAttachmentInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendNotificationResponseInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendNotificationResponseInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationId"] = this.notificationId;
        data["responseText"] = this.responseText;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISendNotificationResponseInput {
    notificationId: number;
    responseText: string;
    attachments: SendNotificationAttachmentInput[] | undefined;
}

export class SendNotificationResponseOutput implements ISendNotificationResponseOutput {
    applicationCreated!: boolean;
    answerApplicationId!: number | undefined;
    caseId!: string | undefined;

    constructor(data?: ISendNotificationResponseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationCreated = _data["applicationCreated"];
            this.answerApplicationId = _data["answerApplicationId"];
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): SendNotificationResponseOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SendNotificationResponseOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationCreated"] = this.applicationCreated;
        data["answerApplicationId"] = this.answerApplicationId;
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface ISendNotificationResponseOutput {
    applicationCreated: boolean;
    answerApplicationId: number | undefined;
    caseId: string | undefined;
}

export class MySironaGetAcademicTitleDto implements IMySironaGetAcademicTitleDto {
    title!: string | undefined;
    grantingAuthority!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    id!: number;

    constructor(data?: IMySironaGetAcademicTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.grantingAuthority = _data["grantingAuthority"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MySironaGetAcademicTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new MySironaGetAcademicTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["grantingAuthority"] = this.grantingAuthority;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IMySironaGetAcademicTitleDto {
    title: string | undefined;
    grantingAuthority: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    id: number;
}

export class MySironaGetDiplomaDto implements IMySironaGetDiplomaDto {
    titleId!: string | undefined;
    typeId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    id!: number;

    constructor(data?: IMySironaGetDiplomaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MySironaGetDiplomaDto {
        data = typeof data === 'object' ? data : {};
        let result = new MySironaGetDiplomaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMySironaGetDiplomaDto {
    titleId: string | undefined;
    typeId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    id: number;
}

export class MySironaGetPersonDataDto implements IMySironaGetPersonDataDto {
    legitimationId!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    gln!: string | undefined;
    contact!: MySironaPersonContactDto;
    id!: number;

    constructor(data?: IMySironaGetPersonDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legitimationId = _data["legitimationId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gln = _data["gln"];
            this.contact = _data["contact"] ? MySironaPersonContactDto.fromJS(_data["contact"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MySironaGetPersonDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new MySironaGetPersonDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legitimationId"] = this.legitimationId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gln"] = this.gln;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IMySironaGetPersonDataDto {
    legitimationId: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    gln: string | undefined;
    contact: MySironaPersonContactDto;
    id: number;
}

export class MySironaGetPersonLicenceDetailedDto implements IMySironaGetPersonLicenceDetailedDto {
    naturalKey!: string | undefined;
    discriminator!: PersonLicenceType;
    personId!: number;
    professionId!: string | undefined;
    postgraduateTitleId!: string | undefined;
    statusId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    employments!: MySironaEmploymentDto[] | undefined;
    documents!: MySironaDocumentDto[] | undefined;
    id!: number;

    constructor(data?: IMySironaGetPersonLicenceDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naturalKey = _data["naturalKey"];
            this.discriminator = _data["discriminator"];
            this.personId = _data["personId"];
            this.professionId = _data["professionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.statusId = _data["statusId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(MySironaEmploymentDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(MySironaDocumentDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MySironaGetPersonLicenceDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new MySironaGetPersonLicenceDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naturalKey"] = this.naturalKey;
        data["discriminator"] = this.discriminator;
        data["personId"] = this.personId;
        data["professionId"] = this.professionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["statusId"] = this.statusId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IMySironaGetPersonLicenceDetailedDto {
    naturalKey: string | undefined;
    discriminator: PersonLicenceType;
    personId: number;
    professionId: string | undefined;
    postgraduateTitleId: string | undefined;
    statusId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    employments: MySironaEmploymentDto[] | undefined;
    documents: MySironaDocumentDto[] | undefined;
    id: number;
}

export class MySironaGetPersonLicenceDto implements IMySironaGetPersonLicenceDto {
    naturalKey!: string | undefined;
    discriminator!: PersonLicenceType;
    personId!: number;
    professionId!: string | undefined;
    postgraduateTitleId!: string | undefined;
    statusId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    id!: number;

    constructor(data?: IMySironaGetPersonLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naturalKey = _data["naturalKey"];
            this.discriminator = _data["discriminator"];
            this.personId = _data["personId"];
            this.professionId = _data["professionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.statusId = _data["statusId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MySironaGetPersonLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new MySironaGetPersonLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naturalKey"] = this.naturalKey;
        data["discriminator"] = this.discriminator;
        data["personId"] = this.personId;
        data["professionId"] = this.professionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["statusId"] = this.statusId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IMySironaGetPersonLicenceDto {
    naturalKey: string | undefined;
    discriminator: PersonLicenceType;
    personId: number;
    professionId: string | undefined;
    postgraduateTitleId: string | undefined;
    statusId: string | undefined;
    dateOfIssue: DateTime | undefined;
    id: number;
}

export class MySironaPersonContactDto implements IMySironaPersonContactDto {
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    email2!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    titleId!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;

    constructor(data?: IMySironaPersonContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.titleId = _data["titleId"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
        }
    }

    static fromJS(data: any): MySironaPersonContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new MySironaPersonContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["titleId"] = this.titleId;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        return data;
    }
}

export interface IMySironaPersonContactDto {
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    email2: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    titleId: string | undefined;
    languageOfCorrespondenceId: string | undefined;
}

export class MySironaGetCorporateLicenceDetailedAssistantDto implements IMySironaGetCorporateLicenceDetailedAssistantDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    birthName!: string | undefined;
    genderId!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    id!: number;

    constructor(data?: IMySironaGetCorporateLicenceDetailedAssistantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.genderId = _data["genderId"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MySironaGetCorporateLicenceDetailedAssistantDto {
        data = typeof data === 'object' ? data : {};
        let result = new MySironaGetCorporateLicenceDetailedAssistantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["genderId"] = this.genderId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IMySironaGetCorporateLicenceDetailedAssistantDto {
    firstName: string | undefined;
    lastName: string | undefined;
    birthName: string | undefined;
    genderId: string | undefined;
    dateOfBirth: DateTime | undefined;
    id: number;
}

export class MySironaGetCorporateLicenceDetailedDto implements IMySironaGetCorporateLicenceDetailedDto {
    naturalKey!: string | undefined;
    sponsorshipId!: number;
    sponsorshipTypeId!: string | undefined;
    typeId!: CorporateLicenceType;
    statusId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    assistantPerson!: MySironaGetCorporateLicenceDetailedAssistantDto;
    businesses!: MySironaBusinessDto[] | undefined;
    employments!: MySironaEmploymentDto[] | undefined;
    documents!: MySironaDocumentDto[] | undefined;
    id!: number;

    constructor(data?: IMySironaGetCorporateLicenceDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naturalKey = _data["naturalKey"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.typeId = _data["typeId"];
            this.statusId = _data["statusId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.assistantPerson = _data["assistantPerson"] ? MySironaGetCorporateLicenceDetailedAssistantDto.fromJS(_data["assistantPerson"]) : <any>undefined;
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(MySironaBusinessDto.fromJS(item));
            }
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(MySironaEmploymentDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(MySironaDocumentDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MySironaGetCorporateLicenceDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new MySironaGetCorporateLicenceDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naturalKey"] = this.naturalKey;
        data["sponsorshipId"] = this.sponsorshipId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["typeId"] = this.typeId;
        data["statusId"] = this.statusId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["assistantPerson"] = this.assistantPerson ? this.assistantPerson.toJSON() : <any>undefined;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IMySironaGetCorporateLicenceDetailedDto {
    naturalKey: string | undefined;
    sponsorshipId: number;
    sponsorshipTypeId: string | undefined;
    typeId: CorporateLicenceType;
    statusId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    assistantPerson: MySironaGetCorporateLicenceDetailedAssistantDto;
    businesses: MySironaBusinessDto[] | undefined;
    employments: MySironaEmploymentDto[] | undefined;
    documents: MySironaDocumentDto[] | undefined;
    id: number;
}

export class MySironaGetCorporateLicenceDto implements IMySironaGetCorporateLicenceDto {
    naturalKey!: string | undefined;
    sponsorshipId!: number;
    sponsorshipTypeId!: string | undefined;
    typeId!: CorporateLicenceType;
    statusId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    businesses!: MySironaBusinessDto[] | undefined;
    id!: number;

    constructor(data?: IMySironaGetCorporateLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naturalKey = _data["naturalKey"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.typeId = _data["typeId"];
            this.statusId = _data["statusId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(MySironaBusinessDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MySironaGetCorporateLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new MySironaGetCorporateLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naturalKey"] = this.naturalKey;
        data["sponsorshipId"] = this.sponsorshipId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["typeId"] = this.typeId;
        data["statusId"] = this.statusId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IMySironaGetCorporateLicenceDto {
    naturalKey: string | undefined;
    sponsorshipId: number;
    sponsorshipTypeId: string | undefined;
    typeId: CorporateLicenceType;
    statusId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    businesses: MySironaBusinessDto[] | undefined;
    id: number;
}

export class MySironaGetSponsorshipDataDto implements IMySironaGetSponsorshipDataDto {
    legitimationId!: number | undefined;
    name!: string | undefined;
    additionalName!: string | undefined;
    legalFormId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    cantonId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    uid!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    id!: number;

    constructor(data?: IMySironaGetSponsorshipDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legitimationId = _data["legitimationId"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.cantonId = _data["cantonId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.uid = _data["uid"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MySironaGetSponsorshipDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new MySironaGetSponsorshipDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legitimationId"] = this.legitimationId;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["cantonId"] = this.cantonId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["uid"] = this.uid;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMySironaGetSponsorshipDataDto {
    legitimationId: number | undefined;
    name: string | undefined;
    additionalName: string | undefined;
    legalFormId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    cantonId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    uid: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    id: number;
}

export class GetUserProfileDataDto implements IGetUserProfileDataDto {
    titleId!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    ahv!: string | undefined;
    phoneNumber!: string | undefined;
    emailAddress!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    isEmailConfirmed!: boolean;
    id!: number;

    constructor(data?: IGetUserProfileDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.ahv = _data["ahv"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetUserProfileDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserProfileDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["ahv"] = this.ahv;
        data["phoneNumber"] = this.phoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetUserProfileDataDto {
    titleId: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    ahv: string | undefined;
    phoneNumber: string | undefined;
    emailAddress: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    isEmailConfirmed: boolean;
    id: number;
}

export class CreateDeliveryNotesOutput implements ICreateDeliveryNotesOutput {
    document!: string | undefined;
    xmlData!: string | undefined;

    constructor(data?: ICreateDeliveryNotesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document = _data["document"];
            this.xmlData = _data["xmlData"];
        }
    }

    static fromJS(data: any): CreateDeliveryNotesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDeliveryNotesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document;
        data["xmlData"] = this.xmlData;
        return data;
    }
}

export interface ICreateDeliveryNotesOutput {
    document: string | undefined;
    xmlData: string | undefined;
}

export class CreateNdnApplicationDto implements ICreateNdnApplicationDto {
    professionId!: string | undefined;
    legitimationId!: number | undefined;
    gln!: string | undefined;

    constructor(data?: ICreateNdnApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.legitimationId = _data["legitimationId"];
            this.gln = _data["gln"];
        }
    }

    static fromJS(data: any): CreateNdnApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNdnApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["legitimationId"] = this.legitimationId;
        data["gln"] = this.gln;
        return data;
    }
}

export interface ICreateNdnApplicationDto {
    professionId: string | undefined;
    legitimationId: number | undefined;
    gln: string | undefined;
}

export class CreateOrUpdateSubstancesInput implements ICreateOrUpdateSubstancesInput {
    caseId!: string | undefined;
    ndnSubstances!: NdnSubstanceDto[] | undefined;
    returnedByPatients!: boolean;

    constructor(data?: ICreateOrUpdateSubstancesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["ndnSubstances"])) {
                this.ndnSubstances = [] as any;
                for (let item of _data["ndnSubstances"])
                    this.ndnSubstances!.push(NdnSubstanceDto.fromJS(item));
            }
            this.returnedByPatients = _data["returnedByPatients"];
        }
    }

    static fromJS(data: any): CreateOrUpdateSubstancesInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSubstancesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.ndnSubstances)) {
            data["ndnSubstances"] = [];
            for (let item of this.ndnSubstances)
                data["ndnSubstances"].push(item.toJSON());
        }
        data["returnedByPatients"] = this.returnedByPatients;
        return data;
    }
}

export interface ICreateOrUpdateSubstancesInput {
    caseId: string | undefined;
    ndnSubstances: NdnSubstanceDto[] | undefined;
    returnedByPatients: boolean;
}

export class GetNdnOutput implements IGetNdnOutput {
    ndn!: NdnDto;

    constructor(data?: IGetNdnOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ndn = _data["ndn"] ? NdnDto.fromJS(_data["ndn"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNdnOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNdnOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ndn"] = this.ndn ? this.ndn.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetNdnOutput {
    ndn: NdnDto;
}

export enum NdnDisposeReason {
    ProductRangeStreamlining = 0,
    ExpirationDateExceeded = 1,
}

export class NdnDto implements INdnDto {
    application!: ApplicationDto;
    ndnPerson!: NdnPersonDto;
    ndnSubstances!: NdnSubstanceDto[] | undefined;
    returnedByPatients!: boolean;
    currentStep!: NdnStatus;

    constructor(data?: INdnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.ndnPerson = _data["ndnPerson"] ? NdnPersonDto.fromJS(_data["ndnPerson"]) : <any>undefined;
            if (Array.isArray(_data["ndnSubstances"])) {
                this.ndnSubstances = [] as any;
                for (let item of _data["ndnSubstances"])
                    this.ndnSubstances!.push(NdnSubstanceDto.fromJS(item));
            }
            this.returnedByPatients = _data["returnedByPatients"];
            this.currentStep = _data["currentStep"];
        }
    }

    static fromJS(data: any): NdnDto {
        data = typeof data === 'object' ? data : {};
        let result = new NdnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["ndnPerson"] = this.ndnPerson ? this.ndnPerson.toJSON() : <any>undefined;
        if (Array.isArray(this.ndnSubstances)) {
            data["ndnSubstances"] = [];
            for (let item of this.ndnSubstances)
                data["ndnSubstances"].push(item.toJSON());
        }
        data["returnedByPatients"] = this.returnedByPatients;
        data["currentStep"] = this.currentStep;
        return data;
    }
}

export interface INdnDto {
    application: ApplicationDto;
    ndnPerson: NdnPersonDto;
    ndnSubstances: NdnSubstanceDto[] | undefined;
    returnedByPatients: boolean;
    currentStep: NdnStatus;
}

export class NdnPersonDto implements INdnPersonDto {
    gln!: string | undefined;
    professionId!: string | undefined;
    medRegId!: number | undefined;
    psyRegId!: number | undefined;
    naregId!: number | undefined;
    hasConfirmedData!: boolean | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    titleId!: string | undefined;
    nameOfOffice!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    email1!: string | undefined;
    email2!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    countryId!: string | undefined;

    constructor(data?: INdnPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.medRegId = _data["medRegId"];
            this.psyRegId = _data["psyRegId"];
            this.naregId = _data["naregId"];
            this.hasConfirmedData = _data["hasConfirmedData"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.titleId = _data["titleId"];
            this.nameOfOffice = _data["nameOfOffice"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.email1 = _data["email1"];
            this.email2 = _data["email2"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): NdnPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new NdnPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["medRegId"] = this.medRegId;
        data["psyRegId"] = this.psyRegId;
        data["naregId"] = this.naregId;
        data["hasConfirmedData"] = this.hasConfirmedData;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["titleId"] = this.titleId;
        data["nameOfOffice"] = this.nameOfOffice;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["email1"] = this.email1;
        data["email2"] = this.email2;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface INdnPersonDto {
    gln: string | undefined;
    professionId: string | undefined;
    medRegId: number | undefined;
    psyRegId: number | undefined;
    naregId: number | undefined;
    hasConfirmedData: boolean | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    titleId: string | undefined;
    nameOfOffice: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    email1: string | undefined;
    email2: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    countryId: string | undefined;
}

export class NdnSubstanceDto implements INdnSubstanceDto {
    id!: number | undefined;
    ndnApplicationId!: number;
    substanceName!: string | undefined;
    dosage!: string | undefined;
    packagingSize!: string | undefined;
    amount!: string | undefined;
    disposeReason!: NdnDisposeReason;

    constructor(data?: INdnSubstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ndnApplicationId = _data["ndnApplicationId"];
            this.substanceName = _data["substanceName"];
            this.dosage = _data["dosage"];
            this.packagingSize = _data["packagingSize"];
            this.amount = _data["amount"];
            this.disposeReason = _data["disposeReason"];
        }
    }

    static fromJS(data: any): NdnSubstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new NdnSubstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ndnApplicationId"] = this.ndnApplicationId;
        data["substanceName"] = this.substanceName;
        data["dosage"] = this.dosage;
        data["packagingSize"] = this.packagingSize;
        data["amount"] = this.amount;
        data["disposeReason"] = this.disposeReason;
        return data;
    }
}

export interface INdnSubstanceDto {
    id: number | undefined;
    ndnApplicationId: number;
    substanceName: string | undefined;
    dosage: string | undefined;
    packagingSize: string | undefined;
    amount: string | undefined;
    disposeReason: NdnDisposeReason;
}

export class UpdateNdnPersonInput implements IUpdateNdnPersonInput {
    caseId!: string | undefined;
    ndnPerson!: NdnPersonDto;

    constructor(data?: IUpdateNdnPersonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ndnPerson = _data["ndnPerson"] ? NdnPersonDto.fromJS(_data["ndnPerson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateNdnPersonInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNdnPersonInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ndnPerson"] = this.ndnPerson ? this.ndnPerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateNdnPersonInput {
    caseId: string | undefined;
    ndnPerson: NdnPersonDto;
}

export class CreateNarcoticPrescriptionBlockDto implements ICreateNarcoticPrescriptionBlockDto {
    personId!: number;
    dateOfOrdering!: DateTime;
    dateOfShipping!: DateTime | undefined;
    issuerUserId!: number;
    employmentOrderId!: number | undefined;
    orderAlternativeAddress!: NarcoticPrescriptionBlockAddressDto;
    orderDeliveryOptionId!: string;
    employmentShippingId!: number | undefined;
    shippingAlternativeAddress!: NarcoticPrescriptionBlockAddressDto;

    constructor(data?: ICreateNarcoticPrescriptionBlockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.dateOfOrdering = _data["dateOfOrdering"] ? DateTime.fromISO(_data["dateOfOrdering"].toString()) : <any>undefined;
            this.dateOfShipping = _data["dateOfShipping"] ? DateTime.fromISO(_data["dateOfShipping"].toString()) : <any>undefined;
            this.issuerUserId = _data["issuerUserId"];
            this.employmentOrderId = _data["employmentOrderId"];
            this.orderAlternativeAddress = _data["orderAlternativeAddress"] ? NarcoticPrescriptionBlockAddressDto.fromJS(_data["orderAlternativeAddress"]) : <any>undefined;
            this.orderDeliveryOptionId = _data["orderDeliveryOptionId"];
            this.employmentShippingId = _data["employmentShippingId"];
            this.shippingAlternativeAddress = _data["shippingAlternativeAddress"] ? NarcoticPrescriptionBlockAddressDto.fromJS(_data["shippingAlternativeAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateNarcoticPrescriptionBlockDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNarcoticPrescriptionBlockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["dateOfOrdering"] = this.dateOfOrdering ? this.dateOfOrdering.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfShipping"] = this.dateOfShipping ? this.dateOfShipping.toFormat('yyyy-MM-dd') : <any>undefined;
        data["issuerUserId"] = this.issuerUserId;
        data["employmentOrderId"] = this.employmentOrderId;
        data["orderAlternativeAddress"] = this.orderAlternativeAddress ? this.orderAlternativeAddress.toJSON() : <any>undefined;
        data["orderDeliveryOptionId"] = this.orderDeliveryOptionId;
        data["employmentShippingId"] = this.employmentShippingId;
        data["shippingAlternativeAddress"] = this.shippingAlternativeAddress ? this.shippingAlternativeAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateNarcoticPrescriptionBlockDto {
    personId: number;
    dateOfOrdering: DateTime;
    dateOfShipping: DateTime | undefined;
    issuerUserId: number;
    employmentOrderId: number | undefined;
    orderAlternativeAddress: NarcoticPrescriptionBlockAddressDto;
    orderDeliveryOptionId: string;
    employmentShippingId: number | undefined;
    shippingAlternativeAddress: NarcoticPrescriptionBlockAddressDto;
}

export class CreateOrUpdateNarcoticPrescriptionBlockDetailDto implements ICreateOrUpdateNarcoticPrescriptionBlockDetailDto {
    firstRecipeNumber!: string | undefined;
    lastRecipeNumber!: string | undefined;
    statusId!: string;
    dateOfStatusChange!: DateTime | undefined;
    remark!: string | undefined;

    constructor(data?: ICreateOrUpdateNarcoticPrescriptionBlockDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstRecipeNumber = _data["firstRecipeNumber"];
            this.lastRecipeNumber = _data["lastRecipeNumber"];
            this.statusId = _data["statusId"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): CreateOrUpdateNarcoticPrescriptionBlockDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateNarcoticPrescriptionBlockDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstRecipeNumber"] = this.firstRecipeNumber;
        data["lastRecipeNumber"] = this.lastRecipeNumber;
        data["statusId"] = this.statusId;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        return data;
    }
}

export interface ICreateOrUpdateNarcoticPrescriptionBlockDetailDto {
    firstRecipeNumber: string | undefined;
    lastRecipeNumber: string | undefined;
    statusId: string;
    dateOfStatusChange: DateTime | undefined;
    remark: string | undefined;
}

export class GetNarcoticPrescriptionBlockDetailDto implements IGetNarcoticPrescriptionBlockDetailDto {
    firstRecipeNumber!: string | undefined;
    lastRecipeNumber!: string | undefined;
    statusId!: string | undefined;
    dateOfStatusChange!: DateTime | undefined;
    remark!: string | undefined;
    id!: number;

    constructor(data?: IGetNarcoticPrescriptionBlockDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstRecipeNumber = _data["firstRecipeNumber"];
            this.lastRecipeNumber = _data["lastRecipeNumber"];
            this.statusId = _data["statusId"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetNarcoticPrescriptionBlockDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNarcoticPrescriptionBlockDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstRecipeNumber"] = this.firstRecipeNumber;
        data["lastRecipeNumber"] = this.lastRecipeNumber;
        data["statusId"] = this.statusId;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetNarcoticPrescriptionBlockDetailDto {
    firstRecipeNumber: string | undefined;
    lastRecipeNumber: string | undefined;
    statusId: string | undefined;
    dateOfStatusChange: DateTime | undefined;
    remark: string | undefined;
    id: number;
}

export class GetNarcoticPrescriptionBlockDto implements IGetNarcoticPrescriptionBlockDto {
    personId!: number;
    dateOfOrdering!: DateTime | undefined;
    dateOfShipping!: DateTime | undefined;
    issuerUserId!: number | undefined;
    blockDetails!: GetNarcoticPrescriptionBlockDetailDto[] | undefined;
    employmentOrderId!: number | undefined;
    orderAlternativeAddress!: NarcoticPrescriptionBlockAddressDto;
    orderDeliveryOptionId!: string | undefined;
    employmentShippingId!: number | undefined;
    shippingAlternativeAddress!: NarcoticPrescriptionBlockAddressDto;
    sapInvoiceId!: number | undefined;
    id!: number;

    constructor(data?: IGetNarcoticPrescriptionBlockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.dateOfOrdering = _data["dateOfOrdering"] ? DateTime.fromISO(_data["dateOfOrdering"].toString()) : <any>undefined;
            this.dateOfShipping = _data["dateOfShipping"] ? DateTime.fromISO(_data["dateOfShipping"].toString()) : <any>undefined;
            this.issuerUserId = _data["issuerUserId"];
            if (Array.isArray(_data["blockDetails"])) {
                this.blockDetails = [] as any;
                for (let item of _data["blockDetails"])
                    this.blockDetails!.push(GetNarcoticPrescriptionBlockDetailDto.fromJS(item));
            }
            this.employmentOrderId = _data["employmentOrderId"];
            this.orderAlternativeAddress = _data["orderAlternativeAddress"] ? NarcoticPrescriptionBlockAddressDto.fromJS(_data["orderAlternativeAddress"]) : <any>undefined;
            this.orderDeliveryOptionId = _data["orderDeliveryOptionId"];
            this.employmentShippingId = _data["employmentShippingId"];
            this.shippingAlternativeAddress = _data["shippingAlternativeAddress"] ? NarcoticPrescriptionBlockAddressDto.fromJS(_data["shippingAlternativeAddress"]) : <any>undefined;
            this.sapInvoiceId = _data["sapInvoiceId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetNarcoticPrescriptionBlockDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNarcoticPrescriptionBlockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["dateOfOrdering"] = this.dateOfOrdering ? this.dateOfOrdering.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfShipping"] = this.dateOfShipping ? this.dateOfShipping.toFormat('yyyy-MM-dd') : <any>undefined;
        data["issuerUserId"] = this.issuerUserId;
        if (Array.isArray(this.blockDetails)) {
            data["blockDetails"] = [];
            for (let item of this.blockDetails)
                data["blockDetails"].push(item.toJSON());
        }
        data["employmentOrderId"] = this.employmentOrderId;
        data["orderAlternativeAddress"] = this.orderAlternativeAddress ? this.orderAlternativeAddress.toJSON() : <any>undefined;
        data["orderDeliveryOptionId"] = this.orderDeliveryOptionId;
        data["employmentShippingId"] = this.employmentShippingId;
        data["shippingAlternativeAddress"] = this.shippingAlternativeAddress ? this.shippingAlternativeAddress.toJSON() : <any>undefined;
        data["sapInvoiceId"] = this.sapInvoiceId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetNarcoticPrescriptionBlockDto {
    personId: number;
    dateOfOrdering: DateTime | undefined;
    dateOfShipping: DateTime | undefined;
    issuerUserId: number | undefined;
    blockDetails: GetNarcoticPrescriptionBlockDetailDto[] | undefined;
    employmentOrderId: number | undefined;
    orderAlternativeAddress: NarcoticPrescriptionBlockAddressDto;
    orderDeliveryOptionId: string | undefined;
    employmentShippingId: number | undefined;
    shippingAlternativeAddress: NarcoticPrescriptionBlockAddressDto;
    sapInvoiceId: number | undefined;
    id: number;
}

export class GetNarcoticPrescriptionBlockEmploymentDto implements IGetNarcoticPrescriptionBlockEmploymentDto {
    employmentId!: number;
    titleId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    businessName!: string | undefined;
    businessName2!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;

    constructor(data?: IGetNarcoticPrescriptionBlockEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employmentId = _data["employmentId"];
            this.titleId = _data["titleId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.businessName = _data["businessName"];
            this.businessName2 = _data["businessName2"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
        }
    }

    static fromJS(data: any): GetNarcoticPrescriptionBlockEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNarcoticPrescriptionBlockEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employmentId"] = this.employmentId;
        data["titleId"] = this.titleId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["businessName"] = this.businessName;
        data["businessName2"] = this.businessName2;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        return data;
    }
}

export interface IGetNarcoticPrescriptionBlockEmploymentDto {
    employmentId: number;
    titleId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    businessName: string | undefined;
    businessName2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
}

export class NarcoticPrescriptionBlockAddressDto implements INarcoticPrescriptionBlockAddressDto {
    titleId!: string | undefined;
    firstName!: string;
    lastName!: string;
    businessName!: string | undefined;
    businessName2!: string | undefined;
    postCode!: string;
    city!: string | undefined;
    street!: string;
    streetNr!: string | undefined;

    constructor(data?: INarcoticPrescriptionBlockAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.businessName = _data["businessName"];
            this.businessName2 = _data["businessName2"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
        }
    }

    static fromJS(data: any): NarcoticPrescriptionBlockAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new NarcoticPrescriptionBlockAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["businessName"] = this.businessName;
        data["businessName2"] = this.businessName2;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        return data;
    }
}

export interface INarcoticPrescriptionBlockAddressDto {
    titleId: string | undefined;
    firstName: string;
    lastName: string;
    businessName: string | undefined;
    businessName2: string | undefined;
    postCode: string;
    city: string | undefined;
    street: string;
    streetNr: string | undefined;
}

export class NarcoticPrescriptionBlockDto implements INarcoticPrescriptionBlockDto {
    dateOfOrdering!: DateTime;
    dateOfShipping!: DateTime | undefined;
    issuerUserId!: number;
    employmentOrderId!: number | undefined;
    orderAlternativeAddress!: NarcoticPrescriptionBlockAddressDto;
    orderDeliveryOptionId!: string;
    employmentShippingId!: number | undefined;
    shippingAlternativeAddress!: NarcoticPrescriptionBlockAddressDto;

    constructor(data?: INarcoticPrescriptionBlockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfOrdering = _data["dateOfOrdering"] ? DateTime.fromISO(_data["dateOfOrdering"].toString()) : <any>undefined;
            this.dateOfShipping = _data["dateOfShipping"] ? DateTime.fromISO(_data["dateOfShipping"].toString()) : <any>undefined;
            this.issuerUserId = _data["issuerUserId"];
            this.employmentOrderId = _data["employmentOrderId"];
            this.orderAlternativeAddress = _data["orderAlternativeAddress"] ? NarcoticPrescriptionBlockAddressDto.fromJS(_data["orderAlternativeAddress"]) : <any>undefined;
            this.orderDeliveryOptionId = _data["orderDeliveryOptionId"];
            this.employmentShippingId = _data["employmentShippingId"];
            this.shippingAlternativeAddress = _data["shippingAlternativeAddress"] ? NarcoticPrescriptionBlockAddressDto.fromJS(_data["shippingAlternativeAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NarcoticPrescriptionBlockDto {
        data = typeof data === 'object' ? data : {};
        let result = new NarcoticPrescriptionBlockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfOrdering"] = this.dateOfOrdering ? this.dateOfOrdering.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfShipping"] = this.dateOfShipping ? this.dateOfShipping.toFormat('yyyy-MM-dd') : <any>undefined;
        data["issuerUserId"] = this.issuerUserId;
        data["employmentOrderId"] = this.employmentOrderId;
        data["orderAlternativeAddress"] = this.orderAlternativeAddress ? this.orderAlternativeAddress.toJSON() : <any>undefined;
        data["orderDeliveryOptionId"] = this.orderDeliveryOptionId;
        data["employmentShippingId"] = this.employmentShippingId;
        data["shippingAlternativeAddress"] = this.shippingAlternativeAddress ? this.shippingAlternativeAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface INarcoticPrescriptionBlockDto {
    dateOfOrdering: DateTime;
    dateOfShipping: DateTime | undefined;
    issuerUserId: number;
    employmentOrderId: number | undefined;
    orderAlternativeAddress: NarcoticPrescriptionBlockAddressDto;
    orderDeliveryOptionId: string;
    employmentShippingId: number | undefined;
    shippingAlternativeAddress: NarcoticPrescriptionBlockAddressDto;
}

export class NarcoticPrescriptionBlockSearchInputDto implements INarcoticPrescriptionBlockSearchInputDto {
    personId!: number;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: INarcoticPrescriptionBlockSearchInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): NarcoticPrescriptionBlockSearchInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new NarcoticPrescriptionBlockSearchInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface INarcoticPrescriptionBlockSearchInputDto {
    personId: number;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class NarcoticPrescriptionBlockSearchOutputDto implements INarcoticPrescriptionBlockSearchOutputDto {
    totalCount!: number;
    items!: GetNarcoticPrescriptionBlockDto[] | undefined;

    constructor(data?: INarcoticPrescriptionBlockSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetNarcoticPrescriptionBlockDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NarcoticPrescriptionBlockSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new NarcoticPrescriptionBlockSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface INarcoticPrescriptionBlockSearchOutputDto {
    totalCount: number;
    items: GetNarcoticPrescriptionBlockDto[] | undefined;
}

export class NarcoticPrescriptionBlock implements INarcoticPrescriptionBlock {
    personId!: number;
    person!: Person;
    dateOfOrdering!: DateTime | undefined;
    dateOfShipping!: DateTime | undefined;
    issuerUserId!: number | undefined;
    issuerUser!: User;
    blockDetails!: NarcoticPrescriptionBlockDetail[] | undefined;
    employmentOrder!: Employment;
    employmentOrderId!: number | undefined;
    orderAlternativeAddress!: NarcoticPrescriptionBlockAddress;
    orderDeliveryOptionId!: string | undefined;
    employmentShipping!: Employment;
    employmentShippingId!: number | undefined;
    shippingAlternativeAddress!: NarcoticPrescriptionBlockAddress;
    sapInvoice!: SapInvoice;
    sapInvoiceId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: INarcoticPrescriptionBlock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.dateOfOrdering = _data["dateOfOrdering"] ? DateTime.fromISO(_data["dateOfOrdering"].toString()) : <any>undefined;
            this.dateOfShipping = _data["dateOfShipping"] ? DateTime.fromISO(_data["dateOfShipping"].toString()) : <any>undefined;
            this.issuerUserId = _data["issuerUserId"];
            this.issuerUser = _data["issuerUser"] ? User.fromJS(_data["issuerUser"]) : <any>undefined;
            if (Array.isArray(_data["blockDetails"])) {
                this.blockDetails = [] as any;
                for (let item of _data["blockDetails"])
                    this.blockDetails!.push(NarcoticPrescriptionBlockDetail.fromJS(item));
            }
            this.employmentOrder = _data["employmentOrder"] ? Employment.fromJS(_data["employmentOrder"]) : <any>undefined;
            this.employmentOrderId = _data["employmentOrderId"];
            this.orderAlternativeAddress = _data["orderAlternativeAddress"] ? NarcoticPrescriptionBlockAddress.fromJS(_data["orderAlternativeAddress"]) : <any>undefined;
            this.orderDeliveryOptionId = _data["orderDeliveryOptionId"];
            this.employmentShipping = _data["employmentShipping"] ? Employment.fromJS(_data["employmentShipping"]) : <any>undefined;
            this.employmentShippingId = _data["employmentShippingId"];
            this.shippingAlternativeAddress = _data["shippingAlternativeAddress"] ? NarcoticPrescriptionBlockAddress.fromJS(_data["shippingAlternativeAddress"]) : <any>undefined;
            this.sapInvoice = _data["sapInvoice"] ? SapInvoice.fromJS(_data["sapInvoice"]) : <any>undefined;
            this.sapInvoiceId = _data["sapInvoiceId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NarcoticPrescriptionBlock {
        data = typeof data === 'object' ? data : {};
        let result = new NarcoticPrescriptionBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["dateOfOrdering"] = this.dateOfOrdering ? this.dateOfOrdering.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfShipping"] = this.dateOfShipping ? this.dateOfShipping.toFormat('yyyy-MM-dd') : <any>undefined;
        data["issuerUserId"] = this.issuerUserId;
        data["issuerUser"] = this.issuerUser ? this.issuerUser.toJSON() : <any>undefined;
        if (Array.isArray(this.blockDetails)) {
            data["blockDetails"] = [];
            for (let item of this.blockDetails)
                data["blockDetails"].push(item.toJSON());
        }
        data["employmentOrder"] = this.employmentOrder ? this.employmentOrder.toJSON() : <any>undefined;
        data["employmentOrderId"] = this.employmentOrderId;
        data["orderAlternativeAddress"] = this.orderAlternativeAddress ? this.orderAlternativeAddress.toJSON() : <any>undefined;
        data["orderDeliveryOptionId"] = this.orderDeliveryOptionId;
        data["employmentShipping"] = this.employmentShipping ? this.employmentShipping.toJSON() : <any>undefined;
        data["employmentShippingId"] = this.employmentShippingId;
        data["shippingAlternativeAddress"] = this.shippingAlternativeAddress ? this.shippingAlternativeAddress.toJSON() : <any>undefined;
        data["sapInvoice"] = this.sapInvoice ? this.sapInvoice.toJSON() : <any>undefined;
        data["sapInvoiceId"] = this.sapInvoiceId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface INarcoticPrescriptionBlock {
    personId: number;
    person: Person;
    dateOfOrdering: DateTime | undefined;
    dateOfShipping: DateTime | undefined;
    issuerUserId: number | undefined;
    issuerUser: User;
    blockDetails: NarcoticPrescriptionBlockDetail[] | undefined;
    employmentOrder: Employment;
    employmentOrderId: number | undefined;
    orderAlternativeAddress: NarcoticPrescriptionBlockAddress;
    orderDeliveryOptionId: string | undefined;
    employmentShipping: Employment;
    employmentShippingId: number | undefined;
    shippingAlternativeAddress: NarcoticPrescriptionBlockAddress;
    sapInvoice: SapInvoice;
    sapInvoiceId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class NarcoticPrescriptionBlockAddress implements INarcoticPrescriptionBlockAddress {
    titleId!: string | undefined;
    firstName!: string;
    lastName!: string;
    businessName!: string | undefined;
    businessName2!: string | undefined;
    postCode!: string;
    city!: string | undefined;
    street!: string;
    streetNr!: string | undefined;

    constructor(data?: INarcoticPrescriptionBlockAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.businessName = _data["businessName"];
            this.businessName2 = _data["businessName2"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
        }
    }

    static fromJS(data: any): NarcoticPrescriptionBlockAddress {
        data = typeof data === 'object' ? data : {};
        let result = new NarcoticPrescriptionBlockAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["businessName"] = this.businessName;
        data["businessName2"] = this.businessName2;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        return data;
    }
}

export interface INarcoticPrescriptionBlockAddress {
    titleId: string | undefined;
    firstName: string;
    lastName: string;
    businessName: string | undefined;
    businessName2: string | undefined;
    postCode: string;
    city: string | undefined;
    street: string;
    streetNr: string | undefined;
}

export class NarcoticPrescriptionBlockDetail implements INarcoticPrescriptionBlockDetail {
    id!: number;
    narcoticPrescriptionBlockId!: number;
    narcoticPrescriptionBlock!: NarcoticPrescriptionBlock;
    firstRecipeNumber!: string | undefined;
    lastRecipeNumber!: string | undefined;
    statusId!: string | undefined;
    dateOfStatusChange!: DateTime | undefined;
    remark!: string | undefined;

    constructor(data?: INarcoticPrescriptionBlockDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.narcoticPrescriptionBlockId = _data["narcoticPrescriptionBlockId"];
            this.narcoticPrescriptionBlock = _data["narcoticPrescriptionBlock"] ? NarcoticPrescriptionBlock.fromJS(_data["narcoticPrescriptionBlock"]) : <any>undefined;
            this.firstRecipeNumber = _data["firstRecipeNumber"];
            this.lastRecipeNumber = _data["lastRecipeNumber"];
            this.statusId = _data["statusId"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): NarcoticPrescriptionBlockDetail {
        data = typeof data === 'object' ? data : {};
        let result = new NarcoticPrescriptionBlockDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["narcoticPrescriptionBlockId"] = this.narcoticPrescriptionBlockId;
        data["narcoticPrescriptionBlock"] = this.narcoticPrescriptionBlock ? this.narcoticPrescriptionBlock.toJSON() : <any>undefined;
        data["firstRecipeNumber"] = this.firstRecipeNumber;
        data["lastRecipeNumber"] = this.lastRecipeNumber;
        data["statusId"] = this.statusId;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        return data;
    }
}

export interface INarcoticPrescriptionBlockDetail {
    id: number;
    narcoticPrescriptionBlockId: number;
    narcoticPrescriptionBlock: NarcoticPrescriptionBlock;
    firstRecipeNumber: string | undefined;
    lastRecipeNumber: string | undefined;
    statusId: string | undefined;
    dateOfStatusChange: DateTime | undefined;
    remark: string | undefined;
}

export class CreateNpboApplicationDto implements ICreateNpboApplicationDto {
    professionId!: string;
    legitimationId!: number;

    constructor(data?: ICreateNpboApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.legitimationId = _data["legitimationId"];
        }
    }

    static fromJS(data: any): CreateNpboApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNpboApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["legitimationId"] = this.legitimationId;
        return data;
    }
}

export interface ICreateNpboApplicationDto {
    professionId: string;
    legitimationId: number;
}

export class CreateOrUpdateNpboAddressInput implements ICreateOrUpdateNpboAddressInput {
    caseId!: string;
    address!: NpboAddressDto;

    constructor(data?: ICreateOrUpdateNpboAddressInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.address = new NpboAddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.address = _data["address"] ? NpboAddressDto.fromJS(_data["address"]) : new NpboAddressDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateNpboAddressInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateNpboAddressInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateNpboAddressInput {
    caseId: string;
    address: NpboAddressDto;
}

export class CreateOrUpdateNpboNumberInput implements ICreateOrUpdateNpboNumberInput {
    caseId!: string;
    number!: NpboNumberDto;

    constructor(data?: ICreateOrUpdateNpboNumberInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.number = new NpboNumberDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.number = _data["number"] ? NpboNumberDto.fromJS(_data["number"]) : new NpboNumberDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateNpboNumberInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateNpboNumberInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["number"] = this.number ? this.number.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateNpboNumberInput {
    caseId: string;
    number: NpboNumberDto;
}

export class CreateOrUpdateNpboRegisterOutputDto implements ICreateOrUpdateNpboRegisterOutputDto {
    healthRegisterIdentificationStatus!: HealthRegisterIdentificationStatus;
    healthRegisterSystem!: ExternalSystemEnum;
    healthRegisterId!: number | undefined;
    register!: NpboRegisterDto;

    constructor(data?: ICreateOrUpdateNpboRegisterOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRegisterIdentificationStatus = _data["healthRegisterIdentificationStatus"];
            this.healthRegisterSystem = _data["healthRegisterSystem"];
            this.healthRegisterId = _data["healthRegisterId"];
            this.register = _data["register"] ? NpboRegisterDto.fromJS(_data["register"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateNpboRegisterOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateNpboRegisterOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRegisterIdentificationStatus"] = this.healthRegisterIdentificationStatus;
        data["healthRegisterSystem"] = this.healthRegisterSystem;
        data["healthRegisterId"] = this.healthRegisterId;
        data["register"] = this.register ? this.register.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateNpboRegisterOutputDto {
    healthRegisterIdentificationStatus: HealthRegisterIdentificationStatus;
    healthRegisterSystem: ExternalSystemEnum;
    healthRegisterId: number | undefined;
    register: NpboRegisterDto;
}

export class NpboAddressDefaultDataDto implements INpboAddressDefaultDataDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    titleId!: string | undefined;

    constructor(data?: INpboAddressDefaultDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.titleId = _data["titleId"];
        }
    }

    static fromJS(data: any): NpboAddressDefaultDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new NpboAddressDefaultDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["titleId"] = this.titleId;
        return data;
    }
}

export interface INpboAddressDefaultDataDto {
    firstName: string | undefined;
    lastName: string | undefined;
    titleId: string | undefined;
}

export class NpboAddressDto implements INpboAddressDto {
    titleId!: string;
    firstName!: string;
    lastName!: string;
    remoteAddressId!: number | undefined;
    countryId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    reason!: string | undefined;

    constructor(data?: INpboAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.remoteAddressId = _data["remoteAddressId"];
            this.countryId = _data["countryId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): NpboAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new NpboAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["remoteAddressId"] = this.remoteAddressId;
        data["countryId"] = this.countryId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["reason"] = this.reason;
        return data;
    }
}

export interface INpboAddressDto {
    titleId: string;
    firstName: string;
    lastName: string;
    remoteAddressId: number | undefined;
    countryId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    reason: string | undefined;
}

export class NpboDto implements INpboDto {
    application!: ApplicationDto;
    currentStep!: NpboStatus;
    professionId!: string | undefined;
    register!: NpboRegisterDto;
    address!: NpboAddressDto;
    number!: NpboNumberDto;

    constructor(data?: INpboDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.currentStep = _data["currentStep"];
            this.professionId = _data["professionId"];
            this.register = _data["register"] ? NpboRegisterDto.fromJS(_data["register"]) : <any>undefined;
            this.address = _data["address"] ? NpboAddressDto.fromJS(_data["address"]) : <any>undefined;
            this.number = _data["number"] ? NpboNumberDto.fromJS(_data["number"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NpboDto {
        data = typeof data === 'object' ? data : {};
        let result = new NpboDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["currentStep"] = this.currentStep;
        data["professionId"] = this.professionId;
        data["register"] = this.register ? this.register.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["number"] = this.number ? this.number.toJSON() : <any>undefined;
        return data;
    }
}

export interface INpboDto {
    application: ApplicationDto;
    currentStep: NpboStatus;
    professionId: string | undefined;
    register: NpboRegisterDto;
    address: NpboAddressDto;
    number: NpboNumberDto;
}

export class NpboNumberDto implements INpboNumberDto {
    number!: number;

    constructor(data?: INpboNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): NpboNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new NpboNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        return data;
    }
}

export interface INpboNumberDto {
    number: number;
}

export class NpboRegisterDto implements INpboRegisterDto {
    gln!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    birthName!: string | undefined;
    genderId!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    healthRegisterResult!: HealthRegisterIdentificationStatus;
    medRegId!: number | undefined;
    psyRegId!: number | undefined;
    naregId!: number | undefined;
    hasConfirmedData!: boolean | undefined;

    constructor(data?: INpboRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.genderId = _data["genderId"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.healthRegisterResult = _data["healthRegisterResult"];
            this.medRegId = _data["medRegId"];
            this.psyRegId = _data["psyRegId"];
            this.naregId = _data["naregId"];
            this.hasConfirmedData = _data["hasConfirmedData"];
        }
    }

    static fromJS(data: any): NpboRegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new NpboRegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["genderId"] = this.genderId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["healthRegisterResult"] = this.healthRegisterResult;
        data["medRegId"] = this.medRegId;
        data["psyRegId"] = this.psyRegId;
        data["naregId"] = this.naregId;
        data["hasConfirmedData"] = this.hasConfirmedData;
        return data;
    }
}

export interface INpboRegisterDto {
    gln: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    birthName: string | undefined;
    genderId: string | undefined;
    dateOfBirth: DateTime | undefined;
    healthRegisterResult: HealthRegisterIdentificationStatus;
    medRegId: number | undefined;
    psyRegId: number | undefined;
    naregId: number | undefined;
    hasConfirmedData: boolean | undefined;
}

export class NpboRemoteAddressDto implements INpboRemoteAddressDto {
    id!: number;
    label!: string | undefined;

    constructor(data?: INpboRemoteAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): NpboRemoteAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new NpboRemoteAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        return data;
    }
}

export interface INpboRemoteAddressDto {
    id: number;
    label: string | undefined;
}

export enum NpboStatus {
    Register = 0,
    Address = 1,
    Number = 2,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export class NpfContactDto implements INpfContactDto {
    gln!: string | undefined;
    professionId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    titleId!: string;
    businessName!: string | undefined;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string;
    email2!: string | undefined;

    constructor(data?: INpfContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.titleId = _data["titleId"];
            this.businessName = _data["businessName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
        }
    }

    static fromJS(data: any): NpfContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new NpfContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["titleId"] = this.titleId;
        data["businessName"] = this.businessName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["email2"] = this.email2;
        return data;
    }
}

export interface INpfContactDto {
    gln: string | undefined;
    professionId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    titleId: string;
    businessName: string | undefined;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string;
    email2: string | undefined;
}

export class NpfDocumentsOutput implements INpfDocumentsOutput {
    caseId!: string;
    documents!: GeneralDocumentGroupDto[];

    constructor(data?: INpfDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NpfDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new NpfDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface INpfDocumentsOutput {
    caseId: string;
    documents: GeneralDocumentGroupDto[];
}

export class NpfDto implements INpfDto {
    application!: ApplicationDto;
    contact!: NpfContactDto;
    prescriptionFraud!: NpfPrescriptionFraudDto;
    currentStep!: NpfStatus;

    constructor(data?: INpfDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.contact = _data["contact"] ? NpfContactDto.fromJS(_data["contact"]) : <any>undefined;
            this.prescriptionFraud = _data["prescriptionFraud"] ? NpfPrescriptionFraudDto.fromJS(_data["prescriptionFraud"]) : <any>undefined;
            this.currentStep = _data["currentStep"];
        }
    }

    static fromJS(data: any): NpfDto {
        data = typeof data === 'object' ? data : {};
        let result = new NpfDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["prescriptionFraud"] = this.prescriptionFraud ? this.prescriptionFraud.toJSON() : <any>undefined;
        data["currentStep"] = this.currentStep;
        return data;
    }
}

export interface INpfDto {
    application: ApplicationDto;
    contact: NpfContactDto;
    prescriptionFraud: NpfPrescriptionFraudDto;
    currentStep: NpfStatus;
}

export class NpfPrescriptionFraudDto implements INpfPrescriptionFraudDto {
    prescriptionPrescribingPhysician!: string;
    prescriptionBusinessName!: string;
    prescriptionPostCode!: string;
    prescriptionCity!: string;
    prescriptionStreet!: string;
    prescriptionStreetNr!: string | undefined;
    prescriptionAddressAddition!: string | undefined;
    prescriptionCountryId!: string;
    prescriptionCantonId!: string;
    prescriptionSignatureAvailableId!: string;
    prescriptionStampAvailableId!: string;
    prescriptionPersonFirstName!: string;
    prescriptionPersonLastName!: string;
    prescriptionPersonDateOfBirth!: DateTime;
    prescriptionPersonGenderId!: string;
    prescriptionPersonCountryId!: string | undefined;
    prescriptionPersonPostCode!: string | undefined;
    prescriptionPersonCity!: string | undefined;
    prescriptionPersonStreet!: string | undefined;
    prescriptionPersonStreetNr!: string | undefined;
    substanceName!: string;
    dosage!: string;
    contactedId!: string;
    confirmedId!: string;
    executedId!: string;
    remark!: string | undefined;

    constructor(data?: INpfPrescriptionFraudDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionPrescribingPhysician = _data["prescriptionPrescribingPhysician"];
            this.prescriptionBusinessName = _data["prescriptionBusinessName"];
            this.prescriptionPostCode = _data["prescriptionPostCode"];
            this.prescriptionCity = _data["prescriptionCity"];
            this.prescriptionStreet = _data["prescriptionStreet"];
            this.prescriptionStreetNr = _data["prescriptionStreetNr"];
            this.prescriptionAddressAddition = _data["prescriptionAddressAddition"];
            this.prescriptionCountryId = _data["prescriptionCountryId"];
            this.prescriptionCantonId = _data["prescriptionCantonId"];
            this.prescriptionSignatureAvailableId = _data["prescriptionSignatureAvailableId"];
            this.prescriptionStampAvailableId = _data["prescriptionStampAvailableId"];
            this.prescriptionPersonFirstName = _data["prescriptionPersonFirstName"];
            this.prescriptionPersonLastName = _data["prescriptionPersonLastName"];
            this.prescriptionPersonDateOfBirth = _data["prescriptionPersonDateOfBirth"] ? DateTime.fromISO(_data["prescriptionPersonDateOfBirth"].toString()) : <any>undefined;
            this.prescriptionPersonGenderId = _data["prescriptionPersonGenderId"];
            this.prescriptionPersonCountryId = _data["prescriptionPersonCountryId"];
            this.prescriptionPersonPostCode = _data["prescriptionPersonPostCode"];
            this.prescriptionPersonCity = _data["prescriptionPersonCity"];
            this.prescriptionPersonStreet = _data["prescriptionPersonStreet"];
            this.prescriptionPersonStreetNr = _data["prescriptionPersonStreetNr"];
            this.substanceName = _data["substanceName"];
            this.dosage = _data["dosage"];
            this.contactedId = _data["contactedId"];
            this.confirmedId = _data["confirmedId"];
            this.executedId = _data["executedId"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): NpfPrescriptionFraudDto {
        data = typeof data === 'object' ? data : {};
        let result = new NpfPrescriptionFraudDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionPrescribingPhysician"] = this.prescriptionPrescribingPhysician;
        data["prescriptionBusinessName"] = this.prescriptionBusinessName;
        data["prescriptionPostCode"] = this.prescriptionPostCode;
        data["prescriptionCity"] = this.prescriptionCity;
        data["prescriptionStreet"] = this.prescriptionStreet;
        data["prescriptionStreetNr"] = this.prescriptionStreetNr;
        data["prescriptionAddressAddition"] = this.prescriptionAddressAddition;
        data["prescriptionCountryId"] = this.prescriptionCountryId;
        data["prescriptionCantonId"] = this.prescriptionCantonId;
        data["prescriptionSignatureAvailableId"] = this.prescriptionSignatureAvailableId;
        data["prescriptionStampAvailableId"] = this.prescriptionStampAvailableId;
        data["prescriptionPersonFirstName"] = this.prescriptionPersonFirstName;
        data["prescriptionPersonLastName"] = this.prescriptionPersonLastName;
        data["prescriptionPersonDateOfBirth"] = this.prescriptionPersonDateOfBirth ? this.prescriptionPersonDateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["prescriptionPersonGenderId"] = this.prescriptionPersonGenderId;
        data["prescriptionPersonCountryId"] = this.prescriptionPersonCountryId;
        data["prescriptionPersonPostCode"] = this.prescriptionPersonPostCode;
        data["prescriptionPersonCity"] = this.prescriptionPersonCity;
        data["prescriptionPersonStreet"] = this.prescriptionPersonStreet;
        data["prescriptionPersonStreetNr"] = this.prescriptionPersonStreetNr;
        data["substanceName"] = this.substanceName;
        data["dosage"] = this.dosage;
        data["contactedId"] = this.contactedId;
        data["confirmedId"] = this.confirmedId;
        data["executedId"] = this.executedId;
        data["remark"] = this.remark;
        return data;
    }
}

export interface INpfPrescriptionFraudDto {
    prescriptionPrescribingPhysician: string;
    prescriptionBusinessName: string;
    prescriptionPostCode: string;
    prescriptionCity: string;
    prescriptionStreet: string;
    prescriptionStreetNr: string | undefined;
    prescriptionAddressAddition: string | undefined;
    prescriptionCountryId: string;
    prescriptionCantonId: string;
    prescriptionSignatureAvailableId: string;
    prescriptionStampAvailableId: string;
    prescriptionPersonFirstName: string;
    prescriptionPersonLastName: string;
    prescriptionPersonDateOfBirth: DateTime;
    prescriptionPersonGenderId: string;
    prescriptionPersonCountryId: string | undefined;
    prescriptionPersonPostCode: string | undefined;
    prescriptionPersonCity: string | undefined;
    prescriptionPersonStreet: string | undefined;
    prescriptionPersonStreetNr: string | undefined;
    substanceName: string;
    dosage: string;
    contactedId: string;
    confirmedId: string;
    executedId: string;
    remark: string | undefined;
}

export class GetNaregPersonDetailedOutput implements IGetNaregPersonDetailedOutput {
    naregPerson!: NaregPersonDetailedDto;

    constructor(data?: IGetNaregPersonDetailedOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naregPerson = _data["naregPerson"] ? NaregPersonDetailedDto.fromJS(_data["naregPerson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNaregPersonDetailedOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNaregPersonDetailedOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naregPerson"] = this.naregPerson ? this.naregPerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetNaregPersonDetailedOutput {
    naregPerson: NaregPersonDetailedDto;
}

export class GetNaregPersonOutput implements IGetNaregPersonOutput {
    naregPerson!: NaregPersonDto;

    constructor(data?: IGetNaregPersonOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naregPerson = _data["naregPerson"] ? NaregPersonDto.fromJS(_data["naregPerson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNaregPersonOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNaregPersonOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naregPerson"] = this.naregPerson ? this.naregPerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetNaregPersonOutput {
    naregPerson: NaregPersonDto;
}

export class NaregAddressDto implements INaregAddressDto {
    id!: number;
    type!: HealthRegisterCodeDto;
    legalForm!: HealthRegisterCodeDto;
    register!: HealthRegisterCodeDto;
    correspondenceLanguage!: HealthRegisterCodeDto;
    soleProprietorship!: HealthRegisterCodeDto;
    licenceId!: number | undefined;
    uidEstablishment!: string | undefined;
    street!: string | undefined;
    zip!: string | undefined;
    place!: string | undefined;
    supplement1!: string | undefined;
    supplement2!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    mobile!: string | undefined;
    email!: string | undefined;
    dateOfCreation!: DateTime | undefined;
    dateOfMutation!: DateTime | undefined;

    constructor(data?: INaregAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"] ? HealthRegisterCodeDto.fromJS(_data["type"]) : <any>undefined;
            this.legalForm = _data["legalForm"] ? HealthRegisterCodeDto.fromJS(_data["legalForm"]) : <any>undefined;
            this.register = _data["register"] ? HealthRegisterCodeDto.fromJS(_data["register"]) : <any>undefined;
            this.correspondenceLanguage = _data["correspondenceLanguage"] ? HealthRegisterCodeDto.fromJS(_data["correspondenceLanguage"]) : <any>undefined;
            this.soleProprietorship = _data["soleProprietorship"] ? HealthRegisterCodeDto.fromJS(_data["soleProprietorship"]) : <any>undefined;
            this.licenceId = _data["licenceId"];
            this.uidEstablishment = _data["uidEstablishment"];
            this.street = _data["street"];
            this.zip = _data["zip"];
            this.place = _data["place"];
            this.supplement1 = _data["supplement1"];
            this.supplement2 = _data["supplement2"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.mobile = _data["mobile"];
            this.email = _data["email"];
            this.dateOfCreation = _data["dateOfCreation"] ? DateTime.fromISO(_data["dateOfCreation"].toString()) : <any>undefined;
            this.dateOfMutation = _data["dateOfMutation"] ? DateTime.fromISO(_data["dateOfMutation"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NaregAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new NaregAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["legalForm"] = this.legalForm ? this.legalForm.toJSON() : <any>undefined;
        data["register"] = this.register ? this.register.toJSON() : <any>undefined;
        data["correspondenceLanguage"] = this.correspondenceLanguage ? this.correspondenceLanguage.toJSON() : <any>undefined;
        data["soleProprietorship"] = this.soleProprietorship ? this.soleProprietorship.toJSON() : <any>undefined;
        data["licenceId"] = this.licenceId;
        data["uidEstablishment"] = this.uidEstablishment;
        data["street"] = this.street;
        data["zip"] = this.zip;
        data["place"] = this.place;
        data["supplement1"] = this.supplement1;
        data["supplement2"] = this.supplement2;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["mobile"] = this.mobile;
        data["email"] = this.email;
        data["dateOfCreation"] = this.dateOfCreation ? this.dateOfCreation.toString() : <any>undefined;
        data["dateOfMutation"] = this.dateOfMutation ? this.dateOfMutation.toString() : <any>undefined;
        return data;
    }
}

export interface INaregAddressDto {
    id: number;
    type: HealthRegisterCodeDto;
    legalForm: HealthRegisterCodeDto;
    register: HealthRegisterCodeDto;
    correspondenceLanguage: HealthRegisterCodeDto;
    soleProprietorship: HealthRegisterCodeDto;
    licenceId: number | undefined;
    uidEstablishment: string | undefined;
    street: string | undefined;
    zip: string | undefined;
    place: string | undefined;
    supplement1: string | undefined;
    supplement2: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    mobile: string | undefined;
    email: string | undefined;
    dateOfCreation: DateTime | undefined;
    dateOfMutation: DateTime | undefined;
}

export class NaregDiplomDto implements INaregDiplomDto {
    id!: number;
    srkRegisterId!: string | undefined;
    country!: HealthRegisterCodeDto;
    diplomaType!: HealthRegisterCodeDto;
    profession!: HealthRegisterCodeDto;
    register!: HealthRegisterCodeDto;
    dateOfCreation!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    dateOfMutation!: DateTime | undefined;

    constructor(data?: INaregDiplomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.srkRegisterId = _data["srkRegisterId"];
            this.country = _data["country"] ? HealthRegisterCodeDto.fromJS(_data["country"]) : <any>undefined;
            this.diplomaType = _data["diplomaType"] ? HealthRegisterCodeDto.fromJS(_data["diplomaType"]) : <any>undefined;
            this.profession = _data["profession"] ? HealthRegisterCodeDto.fromJS(_data["profession"]) : <any>undefined;
            this.register = _data["register"] ? HealthRegisterCodeDto.fromJS(_data["register"]) : <any>undefined;
            this.dateOfCreation = _data["dateOfCreation"] ? DateTime.fromISO(_data["dateOfCreation"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.dateOfMutation = _data["dateOfMutation"] ? DateTime.fromISO(_data["dateOfMutation"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NaregDiplomDto {
        data = typeof data === 'object' ? data : {};
        let result = new NaregDiplomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["srkRegisterId"] = this.srkRegisterId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["diplomaType"] = this.diplomaType ? this.diplomaType.toJSON() : <any>undefined;
        data["profession"] = this.profession ? this.profession.toJSON() : <any>undefined;
        data["register"] = this.register ? this.register.toJSON() : <any>undefined;
        data["dateOfCreation"] = this.dateOfCreation ? this.dateOfCreation.toString() : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfMutation"] = this.dateOfMutation ? this.dateOfMutation.toString() : <any>undefined;
        return data;
    }
}

export interface INaregDiplomDto {
    id: number;
    srkRegisterId: string | undefined;
    country: HealthRegisterCodeDto;
    diplomaType: HealthRegisterCodeDto;
    profession: HealthRegisterCodeDto;
    register: HealthRegisterCodeDto;
    dateOfCreation: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    dateOfMutation: DateTime | undefined;
}

export class NaregLicenceDto implements INaregLicenceDto {
    id!: number;
    canton!: HealthRegisterCodeDto;
    status!: HealthRegisterCodeDto;
    licenceType!: HealthRegisterCodeDto;
    profession!: HealthRegisterCodeDto;
    legalBasisLicence!: HealthRegisterCodeDto;
    register!: HealthRegisterCodeDto;
    remark!: string | undefined;
    yearOfValidity!: number | undefined;
    dateOfCreation!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfMutation!: DateTime | undefined;
    addresses!: NaregAddressDto[] | undefined;
    restrictions!: NaregRestrictionDto[] | undefined;
    description!: string | undefined;

    constructor(data?: INaregLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.canton = _data["canton"] ? HealthRegisterCodeDto.fromJS(_data["canton"]) : <any>undefined;
            this.status = _data["status"] ? HealthRegisterCodeDto.fromJS(_data["status"]) : <any>undefined;
            this.licenceType = _data["licenceType"] ? HealthRegisterCodeDto.fromJS(_data["licenceType"]) : <any>undefined;
            this.profession = _data["profession"] ? HealthRegisterCodeDto.fromJS(_data["profession"]) : <any>undefined;
            this.legalBasisLicence = _data["legalBasisLicence"] ? HealthRegisterCodeDto.fromJS(_data["legalBasisLicence"]) : <any>undefined;
            this.register = _data["register"] ? HealthRegisterCodeDto.fromJS(_data["register"]) : <any>undefined;
            this.remark = _data["remark"];
            this.yearOfValidity = _data["yearOfValidity"];
            this.dateOfCreation = _data["dateOfCreation"] ? DateTime.fromISO(_data["dateOfCreation"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfMutation = _data["dateOfMutation"] ? DateTime.fromISO(_data["dateOfMutation"].toString()) : <any>undefined;
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(NaregAddressDto.fromJS(item));
            }
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(NaregRestrictionDto.fromJS(item));
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): NaregLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new NaregLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["canton"] = this.canton ? this.canton.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["licenceType"] = this.licenceType ? this.licenceType.toJSON() : <any>undefined;
        data["profession"] = this.profession ? this.profession.toJSON() : <any>undefined;
        data["legalBasisLicence"] = this.legalBasisLicence ? this.legalBasisLicence.toJSON() : <any>undefined;
        data["register"] = this.register ? this.register.toJSON() : <any>undefined;
        data["remark"] = this.remark;
        data["yearOfValidity"] = this.yearOfValidity;
        data["dateOfCreation"] = this.dateOfCreation ? this.dateOfCreation.toString() : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfMutation"] = this.dateOfMutation ? this.dateOfMutation.toString() : <any>undefined;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        data["description"] = this.description;
        return data;
    }
}

export interface INaregLicenceDto {
    id: number;
    canton: HealthRegisterCodeDto;
    status: HealthRegisterCodeDto;
    licenceType: HealthRegisterCodeDto;
    profession: HealthRegisterCodeDto;
    legalBasisLicence: HealthRegisterCodeDto;
    register: HealthRegisterCodeDto;
    remark: string | undefined;
    yearOfValidity: number | undefined;
    dateOfCreation: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfMutation: DateTime | undefined;
    addresses: NaregAddressDto[] | undefined;
    restrictions: NaregRestrictionDto[] | undefined;
    description: string | undefined;
}

export class NaregPersonDetailedDto implements INaregPersonDetailedDto {
    ahv!: string | undefined;
    uid!: string | undefined;
    sexId!: HealthRegisterCodeDto;
    dateOfBirth!: DateTime | undefined;
    dateOfDeath!: DateTime | undefined;
    naregSensitiveData!: NaregSensitiveDataDto[] | undefined;
    placeOfOrigin!: string | undefined;
    cantonalLicenceRestrictions!: string[] | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    originalName!: string | undefined;
    gln!: string | undefined;
    correspondenceLanguage!: HealthRegisterCodeDto;
    country1!: HealthRegisterCodeDto;
    country2!: HealthRegisterCodeDto;
    naregDiploms!: NaregDiplomDto[] | undefined;
    naregLicences!: NaregLicenceDto[] | undefined;
    birthYear!: string | undefined;
    queryTime!: DateTime | undefined;
    id!: number;

    constructor(data?: INaregPersonDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ahv = _data["ahv"];
            this.uid = _data["uid"];
            this.sexId = _data["sexId"] ? HealthRegisterCodeDto.fromJS(_data["sexId"]) : <any>undefined;
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.dateOfDeath = _data["dateOfDeath"] ? DateTime.fromISO(_data["dateOfDeath"].toString()) : <any>undefined;
            if (Array.isArray(_data["naregSensitiveData"])) {
                this.naregSensitiveData = [] as any;
                for (let item of _data["naregSensitiveData"])
                    this.naregSensitiveData!.push(NaregSensitiveDataDto.fromJS(item));
            }
            this.placeOfOrigin = _data["placeOfOrigin"];
            if (Array.isArray(_data["cantonalLicenceRestrictions"])) {
                this.cantonalLicenceRestrictions = [] as any;
                for (let item of _data["cantonalLicenceRestrictions"])
                    this.cantonalLicenceRestrictions!.push(item);
            }
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.originalName = _data["originalName"];
            this.gln = _data["gln"];
            this.correspondenceLanguage = _data["correspondenceLanguage"] ? HealthRegisterCodeDto.fromJS(_data["correspondenceLanguage"]) : <any>undefined;
            this.country1 = _data["country1"] ? HealthRegisterCodeDto.fromJS(_data["country1"]) : <any>undefined;
            this.country2 = _data["country2"] ? HealthRegisterCodeDto.fromJS(_data["country2"]) : <any>undefined;
            if (Array.isArray(_data["naregDiploms"])) {
                this.naregDiploms = [] as any;
                for (let item of _data["naregDiploms"])
                    this.naregDiploms!.push(NaregDiplomDto.fromJS(item));
            }
            if (Array.isArray(_data["naregLicences"])) {
                this.naregLicences = [] as any;
                for (let item of _data["naregLicences"])
                    this.naregLicences!.push(NaregLicenceDto.fromJS(item));
            }
            this.birthYear = _data["birthYear"];
            this.queryTime = _data["queryTime"] ? DateTime.fromISO(_data["queryTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NaregPersonDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new NaregPersonDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ahv"] = this.ahv;
        data["uid"] = this.uid;
        data["sexId"] = this.sexId ? this.sexId.toJSON() : <any>undefined;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDeath"] = this.dateOfDeath ? this.dateOfDeath.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.naregSensitiveData)) {
            data["naregSensitiveData"] = [];
            for (let item of this.naregSensitiveData)
                data["naregSensitiveData"].push(item.toJSON());
        }
        data["placeOfOrigin"] = this.placeOfOrigin;
        if (Array.isArray(this.cantonalLicenceRestrictions)) {
            data["cantonalLicenceRestrictions"] = [];
            for (let item of this.cantonalLicenceRestrictions)
                data["cantonalLicenceRestrictions"].push(item);
        }
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["originalName"] = this.originalName;
        data["gln"] = this.gln;
        data["correspondenceLanguage"] = this.correspondenceLanguage ? this.correspondenceLanguage.toJSON() : <any>undefined;
        data["country1"] = this.country1 ? this.country1.toJSON() : <any>undefined;
        data["country2"] = this.country2 ? this.country2.toJSON() : <any>undefined;
        if (Array.isArray(this.naregDiploms)) {
            data["naregDiploms"] = [];
            for (let item of this.naregDiploms)
                data["naregDiploms"].push(item.toJSON());
        }
        if (Array.isArray(this.naregLicences)) {
            data["naregLicences"] = [];
            for (let item of this.naregLicences)
                data["naregLicences"].push(item.toJSON());
        }
        data["birthYear"] = this.birthYear;
        data["queryTime"] = this.queryTime ? this.queryTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface INaregPersonDetailedDto {
    ahv: string | undefined;
    uid: string | undefined;
    sexId: HealthRegisterCodeDto;
    dateOfBirth: DateTime | undefined;
    dateOfDeath: DateTime | undefined;
    naregSensitiveData: NaregSensitiveDataDto[] | undefined;
    placeOfOrigin: string | undefined;
    cantonalLicenceRestrictions: string[] | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    originalName: string | undefined;
    gln: string | undefined;
    correspondenceLanguage: HealthRegisterCodeDto;
    country1: HealthRegisterCodeDto;
    country2: HealthRegisterCodeDto;
    naregDiploms: NaregDiplomDto[] | undefined;
    naregLicences: NaregLicenceDto[] | undefined;
    birthYear: string | undefined;
    queryTime: DateTime | undefined;
    id: number;
}

export class NaregPersonDto implements INaregPersonDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    originalName!: string | undefined;
    gln!: string | undefined;
    correspondenceLanguage!: HealthRegisterCodeDto;
    country1!: HealthRegisterCodeDto;
    country2!: HealthRegisterCodeDto;
    naregDiploms!: NaregDiplomDto[] | undefined;
    naregLicences!: NaregLicenceDto[] | undefined;
    birthYear!: string | undefined;
    queryTime!: DateTime | undefined;
    id!: number;

    constructor(data?: INaregPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.originalName = _data["originalName"];
            this.gln = _data["gln"];
            this.correspondenceLanguage = _data["correspondenceLanguage"] ? HealthRegisterCodeDto.fromJS(_data["correspondenceLanguage"]) : <any>undefined;
            this.country1 = _data["country1"] ? HealthRegisterCodeDto.fromJS(_data["country1"]) : <any>undefined;
            this.country2 = _data["country2"] ? HealthRegisterCodeDto.fromJS(_data["country2"]) : <any>undefined;
            if (Array.isArray(_data["naregDiploms"])) {
                this.naregDiploms = [] as any;
                for (let item of _data["naregDiploms"])
                    this.naregDiploms!.push(NaregDiplomDto.fromJS(item));
            }
            if (Array.isArray(_data["naregLicences"])) {
                this.naregLicences = [] as any;
                for (let item of _data["naregLicences"])
                    this.naregLicences!.push(NaregLicenceDto.fromJS(item));
            }
            this.birthYear = _data["birthYear"];
            this.queryTime = _data["queryTime"] ? DateTime.fromISO(_data["queryTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NaregPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new NaregPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["originalName"] = this.originalName;
        data["gln"] = this.gln;
        data["correspondenceLanguage"] = this.correspondenceLanguage ? this.correspondenceLanguage.toJSON() : <any>undefined;
        data["country1"] = this.country1 ? this.country1.toJSON() : <any>undefined;
        data["country2"] = this.country2 ? this.country2.toJSON() : <any>undefined;
        if (Array.isArray(this.naregDiploms)) {
            data["naregDiploms"] = [];
            for (let item of this.naregDiploms)
                data["naregDiploms"].push(item.toJSON());
        }
        if (Array.isArray(this.naregLicences)) {
            data["naregLicences"] = [];
            for (let item of this.naregLicences)
                data["naregLicences"].push(item.toJSON());
        }
        data["birthYear"] = this.birthYear;
        data["queryTime"] = this.queryTime ? this.queryTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface INaregPersonDto {
    firstName: string | undefined;
    lastName: string | undefined;
    originalName: string | undefined;
    gln: string | undefined;
    correspondenceLanguage: HealthRegisterCodeDto;
    country1: HealthRegisterCodeDto;
    country2: HealthRegisterCodeDto;
    naregDiploms: NaregDiplomDto[] | undefined;
    naregLicences: NaregLicenceDto[] | undefined;
    birthYear: string | undefined;
    queryTime: DateTime | undefined;
    id: number;
}

export class NaregRestrictionDto implements INaregRestrictionDto {
    id!: number;
    licenceId!: number;
    restrictionType!: HealthRegisterCodeDto;
    description!: string | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfDecision!: DateTime | undefined;

    constructor(data?: INaregRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licenceId = _data["licenceId"];
            this.restrictionType = _data["restrictionType"] ? HealthRegisterCodeDto.fromJS(_data["restrictionType"]) : <any>undefined;
            this.description = _data["description"];
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfDecision = _data["dateOfDecision"] ? DateTime.fromISO(_data["dateOfDecision"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NaregRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NaregRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licenceId"] = this.licenceId;
        data["restrictionType"] = this.restrictionType ? this.restrictionType.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecision"] = this.dateOfDecision ? this.dateOfDecision.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface INaregRestrictionDto {
    id: number;
    licenceId: number;
    restrictionType: HealthRegisterCodeDto;
    description: string | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfDecision: DateTime | undefined;
}

export class NaregSensitiveDataDto implements INaregSensitiveDataDto {
    id!: number;
    isDeleted!: boolean;
    deletionDate!: DateTime | undefined;
    code!: HealthRegisterCodeDto;
    legalBasis!: HealthRegisterCodeDto;

    constructor(data?: INaregSensitiveDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.deletionDate = _data["deletionDate"] ? DateTime.fromISO(_data["deletionDate"].toString()) : <any>undefined;
            this.code = _data["code"] ? HealthRegisterCodeDto.fromJS(_data["code"]) : <any>undefined;
            this.legalBasis = _data["legalBasis"] ? HealthRegisterCodeDto.fromJS(_data["legalBasis"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NaregSensitiveDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new NaregSensitiveDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["code"] = this.code ? this.code.toJSON() : <any>undefined;
        data["legalBasis"] = this.legalBasis ? this.legalBasis.toJSON() : <any>undefined;
        return data;
    }
}

export interface INaregSensitiveDataDto {
    id: number;
    isDeleted: boolean;
    deletionDate: DateTime | undefined;
    code: HealthRegisterCodeDto;
    legalBasis: HealthRegisterCodeDto;
}

export class CreateNdqrApplicationDto implements ICreateNdqrApplicationDto {
    professionId!: string;
    legitimationId!: number;

    constructor(data?: ICreateNdqrApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.legitimationId = _data["legitimationId"];
        }
    }

    static fromJS(data: any): CreateNdqrApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNdqrApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["legitimationId"] = this.legitimationId;
        return data;
    }
}

export interface ICreateNdqrApplicationDto {
    professionId: string;
    legitimationId: number;
}

export class CreateOrUpdateNdqrRegisterOutputDto implements ICreateOrUpdateNdqrRegisterOutputDto {
    healthRegisterIdentificationStatus!: HealthRegisterIdentificationStatus;
    healthRegisterSystem!: ExternalSystemEnum;
    healthRegisterId!: number | undefined;
    register!: NdqrRegisterDto;

    constructor(data?: ICreateOrUpdateNdqrRegisterOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRegisterIdentificationStatus = _data["healthRegisterIdentificationStatus"];
            this.healthRegisterSystem = _data["healthRegisterSystem"];
            this.healthRegisterId = _data["healthRegisterId"];
            this.register = _data["register"] ? NdqrRegisterDto.fromJS(_data["register"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateNdqrRegisterOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateNdqrRegisterOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRegisterIdentificationStatus"] = this.healthRegisterIdentificationStatus;
        data["healthRegisterSystem"] = this.healthRegisterSystem;
        data["healthRegisterId"] = this.healthRegisterId;
        data["register"] = this.register ? this.register.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateNdqrRegisterOutputDto {
    healthRegisterIdentificationStatus: HealthRegisterIdentificationStatus;
    healthRegisterSystem: ExternalSystemEnum;
    healthRegisterId: number | undefined;
    register: NdqrRegisterDto;
}

export class NdqrBusinessDto implements INdqrBusinessDto {
    quarterId!: string | undefined;
    year!: number;
    records!: NdqrBusinessRecordDto[] | undefined;

    constructor(data?: INdqrBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quarterId = _data["quarterId"];
            this.year = _data["year"];
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(NdqrBusinessRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NdqrBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new NdqrBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quarterId"] = this.quarterId;
        data["year"] = this.year;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        return data;
    }
}

export interface INdqrBusinessDto {
    quarterId: string | undefined;
    year: number;
    records: NdqrBusinessRecordDto[] | undefined;
}

export class NdqrBusinessOutputDto implements INdqrBusinessOutputDto {
    status!: NdqrStatus;
    business!: NdqrBusinessDto;

    constructor(data?: INdqrBusinessOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.business = _data["business"] ? NdqrBusinessDto.fromJS(_data["business"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NdqrBusinessOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new NdqrBusinessOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        return data;
    }
}

export interface INdqrBusinessOutputDto {
    status: NdqrStatus;
    business: NdqrBusinessDto;
}

export class NdqrBusinessRecordDto implements INdqrBusinessRecordDto {
    name!: string;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    startDate!: DateTime;
    endDate!: DateTime;
    daysWorked!: number;

    constructor(data?: INdqrBusinessRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.daysWorked = _data["daysWorked"];
        }
    }

    static fromJS(data: any): NdqrBusinessRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new NdqrBusinessRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["startDate"] = this.startDate ? this.startDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["daysWorked"] = this.daysWorked;
        return data;
    }
}

export interface INdqrBusinessRecordDto {
    name: string;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    startDate: DateTime;
    endDate: DateTime;
    daysWorked: number;
}

export class NdqrDto implements INdqrDto {
    application!: ApplicationDto;
    currentStep!: NdqrStatus;
    professionId!: string | undefined;
    register!: NdqrRegisterDto;
    business!: NdqrBusinessDto;

    constructor(data?: INdqrDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.currentStep = _data["currentStep"];
            this.professionId = _data["professionId"];
            this.register = _data["register"] ? NdqrRegisterDto.fromJS(_data["register"]) : <any>undefined;
            this.business = _data["business"] ? NdqrBusinessDto.fromJS(_data["business"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NdqrDto {
        data = typeof data === 'object' ? data : {};
        let result = new NdqrDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["currentStep"] = this.currentStep;
        data["professionId"] = this.professionId;
        data["register"] = this.register ? this.register.toJSON() : <any>undefined;
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        return data;
    }
}

export interface INdqrDto {
    application: ApplicationDto;
    currentStep: NdqrStatus;
    professionId: string | undefined;
    register: NdqrRegisterDto;
    business: NdqrBusinessDto;
}

export class NdqrRegisterDto implements INdqrRegisterDto {
    gln!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    genderId!: string | undefined;
    nationality1Id!: string | undefined;
    nationality2Id!: string | undefined;
    healthRegisterResult!: HealthRegisterIdentificationStatus;
    medRegId!: number | undefined;
    psyRegId!: number | undefined;
    naregId!: number | undefined;
    hasConfirmedData!: boolean | undefined;

    constructor(data?: INdqrRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.genderId = _data["genderId"];
            this.nationality1Id = _data["nationality1Id"];
            this.nationality2Id = _data["nationality2Id"];
            this.healthRegisterResult = _data["healthRegisterResult"];
            this.medRegId = _data["medRegId"];
            this.psyRegId = _data["psyRegId"];
            this.naregId = _data["naregId"];
            this.hasConfirmedData = _data["hasConfirmedData"];
        }
    }

    static fromJS(data: any): NdqrRegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new NdqrRegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["genderId"] = this.genderId;
        data["nationality1Id"] = this.nationality1Id;
        data["nationality2Id"] = this.nationality2Id;
        data["healthRegisterResult"] = this.healthRegisterResult;
        data["medRegId"] = this.medRegId;
        data["psyRegId"] = this.psyRegId;
        data["naregId"] = this.naregId;
        data["hasConfirmedData"] = this.hasConfirmedData;
        return data;
    }
}

export interface INdqrRegisterDto {
    gln: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    genderId: string | undefined;
    nationality1Id: string | undefined;
    nationality2Id: string | undefined;
    healthRegisterResult: HealthRegisterIdentificationStatus;
    medRegId: number | undefined;
    psyRegId: number | undefined;
    naregId: number | undefined;
    hasConfirmedData: boolean | undefined;
}

export enum NotificationType {
    General = 0,
    Reminder = 1,
    ApplicationStatus = 2,
    Document = 3,
}

export class CreateMassNotificationInput implements ICreateMassNotificationInput {
    message!: string | undefined;
    severity!: NotificationSeverity;
    userIds!: number[] | undefined;
    organizationUnitIds!: number[] | undefined;
    targetNotifiers!: string[] | undefined;

    constructor(data?: ICreateMassNotificationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.severity = _data["severity"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            if (Array.isArray(_data["organizationUnitIds"])) {
                this.organizationUnitIds = [] as any;
                for (let item of _data["organizationUnitIds"])
                    this.organizationUnitIds!.push(item);
            }
            if (Array.isArray(_data["targetNotifiers"])) {
                this.targetNotifiers = [] as any;
                for (let item of _data["targetNotifiers"])
                    this.targetNotifiers!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateMassNotificationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMassNotificationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["severity"] = this.severity;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        if (Array.isArray(this.organizationUnitIds)) {
            data["organizationUnitIds"] = [];
            for (let item of this.organizationUnitIds)
                data["organizationUnitIds"].push(item);
        }
        if (Array.isArray(this.targetNotifiers)) {
            data["targetNotifiers"] = [];
            for (let item of this.targetNotifiers)
                data["targetNotifiers"].push(item);
        }
        return data;
    }
}

export interface ICreateMassNotificationInput {
    message: string | undefined;
    severity: NotificationSeverity;
    userIds: number[] | undefined;
    organizationUnitIds: number[] | undefined;
    targetNotifiers: string[] | undefined;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionWithDisplayNameDto[] | undefined;

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    unreadCount!: number;
    totalCount!: number;
    items!: UserNotification[] | undefined;

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unreadCount = _data["unreadCount"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNotificationsOutput {
    unreadCount: number;
    totalCount: number;
    items: UserNotification[] | undefined;
}

export class GetPublishedNotificationsOutput implements IGetPublishedNotificationsOutput {
    totalCount!: number;
    items!: GetNotificationsCreatedByUserOutput[] | undefined;

    constructor(data?: IGetPublishedNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetNotificationsCreatedByUserOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPublishedNotificationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublishedNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPublishedNotificationsOutput {
    totalCount: number;
    items: GetNotificationsCreatedByUserOutput[] | undefined;
}

export class MassNotificationOrganizationUnitLookupTableDto implements IMassNotificationOrganizationUnitLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMassNotificationOrganizationUnitLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MassNotificationOrganizationUnitLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MassNotificationOrganizationUnitLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMassNotificationOrganizationUnitLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MassNotificationUserLookupTableDto implements IMassNotificationUserLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMassNotificationUserLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MassNotificationUserLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MassNotificationUserLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMassNotificationUserLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name!: string;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    displayName!: string | undefined;
    description!: string | undefined;
    name!: string;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    displayName: string | undefined;
    description: string | undefined;
    name: string;
    isSubscribed: boolean;
}

export class SetNotificationAsReadOutput implements ISetNotificationAsReadOutput {
    success!: boolean;

    constructor(data?: ISetNotificationAsReadOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SetNotificationAsReadOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SetNotificationAsReadOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface ISetNotificationAsReadOutput {
    success: boolean;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionDto[] | undefined;

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[] | undefined;
}

export class CreateNiInput implements ICreateNiInput {
    applicationType!: ApplicationType;
    legitimationId!: number | undefined;

    constructor(data?: ICreateNiInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationType = _data["applicationType"];
            this.legitimationId = _data["legitimationId"];
        }
    }

    static fromJS(data: any): CreateNiInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNiInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationType"] = this.applicationType;
        data["legitimationId"] = this.legitimationId;
        return data;
    }
}

export interface ICreateNiInput {
    applicationType: ApplicationType;
    legitimationId: number | undefined;
}

export class CreateNiOutput implements ICreateNiOutput {
    caseId!: string | undefined;
    firstStep!: NiStatus;

    constructor(data?: ICreateNiOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.firstStep = _data["firstStep"];
        }
    }

    static fromJS(data: any): CreateNiOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNiOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["firstStep"] = this.firstStep;
        return data;
    }
}

export interface ICreateNiOutput {
    caseId: string | undefined;
    firstStep: NiStatus;
}

export class CreateOrUpdateNiBankDetailsInput implements ICreateOrUpdateNiBankDetailsInput {
    caseId!: string | undefined;
    niBankDetails!: NiBankDetailsDto;

    constructor(data?: ICreateOrUpdateNiBankDetailsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.niBankDetails = _data["niBankDetails"] ? NiBankDetailsDto.fromJS(_data["niBankDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateNiBankDetailsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateNiBankDetailsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["niBankDetails"] = this.niBankDetails ? this.niBankDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateNiBankDetailsInput {
    caseId: string | undefined;
    niBankDetails: NiBankDetailsDto;
}

export class CreateOrUpdateNiCourseOfferingInput implements ICreateOrUpdateNiCourseOfferingInput {
    caseId!: string | undefined;
    niCourseOffering!: NiCourseOfferingDto;

    constructor(data?: ICreateOrUpdateNiCourseOfferingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.niCourseOffering = _data["niCourseOffering"] ? NiCourseOfferingDto.fromJS(_data["niCourseOffering"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateNiCourseOfferingInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateNiCourseOfferingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["niCourseOffering"] = this.niCourseOffering ? this.niCourseOffering.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateNiCourseOfferingInput {
    caseId: string | undefined;
    niCourseOffering: NiCourseOfferingDto;
}

export class CreateOrUpdateNiEducationProviderInput implements ICreateOrUpdateNiEducationProviderInput {
    caseId!: string | undefined;
    niEducationProvider!: NiEducationProviderDto;

    constructor(data?: ICreateOrUpdateNiEducationProviderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.niEducationProvider = _data["niEducationProvider"] ? NiEducationProviderDto.fromJS(_data["niEducationProvider"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateNiEducationProviderInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateNiEducationProviderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["niEducationProvider"] = this.niEducationProvider ? this.niEducationProvider.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateNiEducationProviderInput {
    caseId: string | undefined;
    niEducationProvider: NiEducationProviderDto;
}

export class CreateOrUpdateNiPersonContactInput implements ICreateOrUpdateNiPersonContactInput {
    caseId!: string | undefined;
    niPersonContact!: NiPersonContactDto;

    constructor(data?: ICreateOrUpdateNiPersonContactInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.niPersonContact = _data["niPersonContact"] ? NiPersonContactDto.fromJS(_data["niPersonContact"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateNiPersonContactInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateNiPersonContactInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["niPersonContact"] = this.niPersonContact ? this.niPersonContact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateNiPersonContactInput {
    caseId: string | undefined;
    niPersonContact: NiPersonContactDto;
}

export class CreateOrUpdateNiPersonInput implements ICreateOrUpdateNiPersonInput {
    caseId!: string | undefined;
    niPerson!: NiPersonDto;

    constructor(data?: ICreateOrUpdateNiPersonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.niPerson = _data["niPerson"] ? NiPersonDto.fromJS(_data["niPerson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateNiPersonInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateNiPersonInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["niPerson"] = this.niPerson ? this.niPerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateNiPersonInput {
    caseId: string | undefined;
    niPerson: NiPersonDto;
}

export class CreateOrUpdateNiProfessionalDetailsInput implements ICreateOrUpdateNiProfessionalDetailsInput {
    caseId!: string | undefined;
    niProfessionalDetails!: NiProfessionalDetailsDto;

    constructor(data?: ICreateOrUpdateNiProfessionalDetailsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.niProfessionalDetails = _data["niProfessionalDetails"] ? NiProfessionalDetailsDto.fromJS(_data["niProfessionalDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateNiProfessionalDetailsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateNiProfessionalDetailsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["niProfessionalDetails"] = this.niProfessionalDetails ? this.niProfessionalDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateNiProfessionalDetailsInput {
    caseId: string | undefined;
    niProfessionalDetails: NiProfessionalDetailsDto;
}

export class CreateOrUpdateNiSponsorshipContactInput implements ICreateOrUpdateNiSponsorshipContactInput {
    caseId!: string | undefined;
    niSponsorshipContact!: NiSponsorshipContactDto;

    constructor(data?: ICreateOrUpdateNiSponsorshipContactInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.niSponsorshipContact = _data["niSponsorshipContact"] ? NiSponsorshipContactDto.fromJS(_data["niSponsorshipContact"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateNiSponsorshipContactInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateNiSponsorshipContactInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["niSponsorshipContact"] = this.niSponsorshipContact ? this.niSponsorshipContact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateNiSponsorshipContactInput {
    caseId: string | undefined;
    niSponsorshipContact: NiSponsorshipContactDto;
}

export class CreateOrUpdateNiSponsorshipInput implements ICreateOrUpdateNiSponsorshipInput {
    caseId!: string | undefined;
    niSponsorship!: NiSponsorshipDto;

    constructor(data?: ICreateOrUpdateNiSponsorshipInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.niSponsorship = _data["niSponsorship"] ? NiSponsorshipDto.fromJS(_data["niSponsorship"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateNiSponsorshipInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateNiSponsorshipInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["niSponsorship"] = this.niSponsorship ? this.niSponsorship.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateNiSponsorshipInput {
    caseId: string | undefined;
    niSponsorship: NiSponsorshipDto;
}

export class NiApplicationDto implements INiApplicationDto {
    application!: ApplicationDto;
    currentStep!: NiStatus;
    niPerson!: NiPersonDto;
    niPersonContact!: NiPersonContactDto;
    niSponsorship!: NiSponsorshipDto;
    niSponsorshipContact!: NiSponsorshipContactDto;
    niProfessionalDetails!: NiProfessionalDetailsDto;
    niCourseOffering!: NiCourseOfferingDto;
    niEducationProvider!: NiEducationProviderDto;
    niBankDetails!: NiBankDetailsDto;
    niDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: INiApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.currentStep = _data["currentStep"];
            this.niPerson = _data["niPerson"] ? NiPersonDto.fromJS(_data["niPerson"]) : <any>undefined;
            this.niPersonContact = _data["niPersonContact"] ? NiPersonContactDto.fromJS(_data["niPersonContact"]) : <any>undefined;
            this.niSponsorship = _data["niSponsorship"] ? NiSponsorshipDto.fromJS(_data["niSponsorship"]) : <any>undefined;
            this.niSponsorshipContact = _data["niSponsorshipContact"] ? NiSponsorshipContactDto.fromJS(_data["niSponsorshipContact"]) : <any>undefined;
            this.niProfessionalDetails = _data["niProfessionalDetails"] ? NiProfessionalDetailsDto.fromJS(_data["niProfessionalDetails"]) : <any>undefined;
            this.niCourseOffering = _data["niCourseOffering"] ? NiCourseOfferingDto.fromJS(_data["niCourseOffering"]) : <any>undefined;
            this.niEducationProvider = _data["niEducationProvider"] ? NiEducationProviderDto.fromJS(_data["niEducationProvider"]) : <any>undefined;
            this.niBankDetails = _data["niBankDetails"] ? NiBankDetailsDto.fromJS(_data["niBankDetails"]) : <any>undefined;
            if (Array.isArray(_data["niDocuments"])) {
                this.niDocuments = [] as any;
                for (let item of _data["niDocuments"])
                    this.niDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NiApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NiApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["currentStep"] = this.currentStep;
        data["niPerson"] = this.niPerson ? this.niPerson.toJSON() : <any>undefined;
        data["niPersonContact"] = this.niPersonContact ? this.niPersonContact.toJSON() : <any>undefined;
        data["niSponsorship"] = this.niSponsorship ? this.niSponsorship.toJSON() : <any>undefined;
        data["niSponsorshipContact"] = this.niSponsorshipContact ? this.niSponsorshipContact.toJSON() : <any>undefined;
        data["niProfessionalDetails"] = this.niProfessionalDetails ? this.niProfessionalDetails.toJSON() : <any>undefined;
        data["niCourseOffering"] = this.niCourseOffering ? this.niCourseOffering.toJSON() : <any>undefined;
        data["niEducationProvider"] = this.niEducationProvider ? this.niEducationProvider.toJSON() : <any>undefined;
        data["niBankDetails"] = this.niBankDetails ? this.niBankDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.niDocuments)) {
            data["niDocuments"] = [];
            for (let item of this.niDocuments)
                data["niDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface INiApplicationDto {
    application: ApplicationDto;
    currentStep: NiStatus;
    niPerson: NiPersonDto;
    niPersonContact: NiPersonContactDto;
    niSponsorship: NiSponsorshipDto;
    niSponsorshipContact: NiSponsorshipContactDto;
    niProfessionalDetails: NiProfessionalDetailsDto;
    niCourseOffering: NiCourseOfferingDto;
    niEducationProvider: NiEducationProviderDto;
    niBankDetails: NiBankDetailsDto;
    niDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class NiBankDetailsDto implements INiBankDetailsDto {
    accountHolderName!: string | undefined;
    countryId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    bankName!: string | undefined;
    iban!: string | undefined;
    bic!: string | undefined;

    constructor(data?: INiBankDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountHolderName = _data["accountHolderName"];
            this.countryId = _data["countryId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.bankName = _data["bankName"];
            this.iban = _data["iban"];
            this.bic = _data["bic"];
        }
    }

    static fromJS(data: any): NiBankDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NiBankDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountHolderName"] = this.accountHolderName;
        data["countryId"] = this.countryId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["bankName"] = this.bankName;
        data["iban"] = this.iban;
        data["bic"] = this.bic;
        return data;
    }
}

export interface INiBankDetailsDto {
    accountHolderName: string | undefined;
    countryId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    bankName: string | undefined;
    iban: string | undefined;
    bic: string | undefined;
}

export class NiCourseOfferingDto implements INiCourseOfferingDto {
    courseName!: string | undefined;
    courseProvider!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    addressAddition!: string | undefined;
    courseStartDate!: DateTime | undefined;
    courseEndDate!: DateTime | undefined;
    courseFees!: string | undefined;

    constructor(data?: INiCourseOfferingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseName = _data["courseName"];
            this.courseProvider = _data["courseProvider"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.addressAddition = _data["addressAddition"];
            this.courseStartDate = _data["courseStartDate"] ? DateTime.fromISO(_data["courseStartDate"].toString()) : <any>undefined;
            this.courseEndDate = _data["courseEndDate"] ? DateTime.fromISO(_data["courseEndDate"].toString()) : <any>undefined;
            this.courseFees = _data["courseFees"];
        }
    }

    static fromJS(data: any): NiCourseOfferingDto {
        data = typeof data === 'object' ? data : {};
        let result = new NiCourseOfferingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseName"] = this.courseName;
        data["courseProvider"] = this.courseProvider;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["addressAddition"] = this.addressAddition;
        data["courseStartDate"] = this.courseStartDate ? this.courseStartDate.toString() : <any>undefined;
        data["courseEndDate"] = this.courseEndDate ? this.courseEndDate.toString() : <any>undefined;
        data["courseFees"] = this.courseFees;
        return data;
    }
}

export interface INiCourseOfferingDto {
    courseName: string | undefined;
    courseProvider: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    addressAddition: string | undefined;
    courseStartDate: DateTime | undefined;
    courseEndDate: DateTime | undefined;
    courseFees: string | undefined;
}

export class NiEducationProviderDto implements INiEducationProviderDto {
    educationProviderTheoryId!: string | undefined;
    educationProviderName!: string | undefined;
    cantonId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    prevEducationId!: string | undefined;
    courseOfStudyId!: string | undefined;
    otherCourseOfStudy!: string | undefined;
    courseStartDate!: DateTime | undefined;
    courseEndDate!: DateTime | undefined;
    semesterId!: string | undefined;

    constructor(data?: INiEducationProviderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.educationProviderTheoryId = _data["educationProviderTheoryId"];
            this.educationProviderName = _data["educationProviderName"];
            this.cantonId = _data["cantonId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.prevEducationId = _data["prevEducationId"];
            this.courseOfStudyId = _data["courseOfStudyId"];
            this.otherCourseOfStudy = _data["otherCourseOfStudy"];
            this.courseStartDate = _data["courseStartDate"] ? DateTime.fromISO(_data["courseStartDate"].toString()) : <any>undefined;
            this.courseEndDate = _data["courseEndDate"] ? DateTime.fromISO(_data["courseEndDate"].toString()) : <any>undefined;
            this.semesterId = _data["semesterId"];
        }
    }

    static fromJS(data: any): NiEducationProviderDto {
        data = typeof data === 'object' ? data : {};
        let result = new NiEducationProviderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["educationProviderTheoryId"] = this.educationProviderTheoryId;
        data["educationProviderName"] = this.educationProviderName;
        data["cantonId"] = this.cantonId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["prevEducationId"] = this.prevEducationId;
        data["courseOfStudyId"] = this.courseOfStudyId;
        data["otherCourseOfStudy"] = this.otherCourseOfStudy;
        data["courseStartDate"] = this.courseStartDate ? this.courseStartDate.toString() : <any>undefined;
        data["courseEndDate"] = this.courseEndDate ? this.courseEndDate.toString() : <any>undefined;
        data["semesterId"] = this.semesterId;
        return data;
    }
}

export interface INiEducationProviderDto {
    educationProviderTheoryId: string | undefined;
    educationProviderName: string | undefined;
    cantonId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    prevEducationId: string | undefined;
    courseOfStudyId: string | undefined;
    otherCourseOfStudy: string | undefined;
    courseStartDate: DateTime | undefined;
    courseEndDate: DateTime | undefined;
    semesterId: string | undefined;
}

export class NiPersonContactDto implements INiPersonContactDto {
    titleId!: string | undefined;
    countryId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    addressAddition!: string | undefined;
    postOfficeBox!: string | undefined;
    email!: string | undefined;
    email2!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    titleAddressSwiss!: string | undefined;
    postCodeSwiss!: string | undefined;
    citySwiss!: string | undefined;
    streetSwiss!: string | undefined;
    streetNrSwiss!: string | undefined;
    addressAdditionSwiss!: string | undefined;
    postOfficeBoxSwiss!: string | undefined;

    constructor(data?: INiPersonContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.countryId = _data["countryId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.addressAddition = _data["addressAddition"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.titleAddressSwiss = _data["titleAddressSwiss"];
            this.postCodeSwiss = _data["postCodeSwiss"];
            this.citySwiss = _data["citySwiss"];
            this.streetSwiss = _data["streetSwiss"];
            this.streetNrSwiss = _data["streetNrSwiss"];
            this.addressAdditionSwiss = _data["addressAdditionSwiss"];
            this.postOfficeBoxSwiss = _data["postOfficeBoxSwiss"];
        }
    }

    static fromJS(data: any): NiPersonContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new NiPersonContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["countryId"] = this.countryId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["addressAddition"] = this.addressAddition;
        data["postOfficeBox"] = this.postOfficeBox;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["titleAddressSwiss"] = this.titleAddressSwiss;
        data["postCodeSwiss"] = this.postCodeSwiss;
        data["citySwiss"] = this.citySwiss;
        data["streetSwiss"] = this.streetSwiss;
        data["streetNrSwiss"] = this.streetNrSwiss;
        data["addressAdditionSwiss"] = this.addressAdditionSwiss;
        data["postOfficeBoxSwiss"] = this.postOfficeBoxSwiss;
        return data;
    }
}

export interface INiPersonContactDto {
    titleId: string | undefined;
    countryId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    addressAddition: string | undefined;
    postOfficeBox: string | undefined;
    email: string | undefined;
    email2: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    titleAddressSwiss: string | undefined;
    postCodeSwiss: string | undefined;
    citySwiss: string | undefined;
    streetSwiss: string | undefined;
    streetNrSwiss: string | undefined;
    addressAdditionSwiss: string | undefined;
    postOfficeBoxSwiss: string | undefined;
}

export class NiPersonDto implements INiPersonDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    previousName!: string | undefined;
    genderId!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    nationality1Id!: string | undefined;
    nationality2Id!: string | undefined;
    placeOfOrigin!: string | undefined;
    ahv!: string | undefined;
    gln!: string | undefined;

    constructor(data?: INiPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.previousName = _data["previousName"];
            this.genderId = _data["genderId"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.nationality1Id = _data["nationality1Id"];
            this.nationality2Id = _data["nationality2Id"];
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.ahv = _data["ahv"];
            this.gln = _data["gln"];
        }
    }

    static fromJS(data: any): NiPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new NiPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["previousName"] = this.previousName;
        data["genderId"] = this.genderId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["nationality1Id"] = this.nationality1Id;
        data["nationality2Id"] = this.nationality2Id;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["ahv"] = this.ahv;
        data["gln"] = this.gln;
        return data;
    }
}

export interface INiPersonDto {
    firstName: string | undefined;
    lastName: string | undefined;
    previousName: string | undefined;
    genderId: string | undefined;
    dateOfBirth: DateTime | undefined;
    nationality1Id: string | undefined;
    nationality2Id: string | undefined;
    placeOfOrigin: string | undefined;
    ahv: string | undefined;
    gln: string | undefined;
}

export class NiProfessionalDetailsDto implements INiProfessionalDetailsDto {
    lastJob!: DateTime | undefined;
    reasonForLeaving!: string | undefined;
    reasonForReturning!: string | undefined;
    employerKnown!: boolean | undefined;
    employerName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;

    constructor(data?: INiProfessionalDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastJob = _data["lastJob"] ? DateTime.fromISO(_data["lastJob"].toString()) : <any>undefined;
            this.reasonForLeaving = _data["reasonForLeaving"];
            this.reasonForReturning = _data["reasonForReturning"];
            this.employerKnown = _data["employerKnown"];
            this.employerName = _data["employerName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
        }
    }

    static fromJS(data: any): NiProfessionalDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NiProfessionalDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastJob"] = this.lastJob ? this.lastJob.toString() : <any>undefined;
        data["reasonForLeaving"] = this.reasonForLeaving;
        data["reasonForReturning"] = this.reasonForReturning;
        data["employerKnown"] = this.employerKnown;
        data["employerName"] = this.employerName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        return data;
    }
}

export interface INiProfessionalDetailsDto {
    lastJob: DateTime | undefined;
    reasonForLeaving: string | undefined;
    reasonForReturning: string | undefined;
    employerKnown: boolean | undefined;
    employerName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    dateOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
}

export class NiSponsorshipContactDto implements INiSponsorshipContactDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    email2!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;

    constructor(data?: INiSponsorshipContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
        }
    }

    static fromJS(data: any): NiSponsorshipContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new NiSponsorshipContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        return data;
    }
}

export interface INiSponsorshipContactDto {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    email2: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
}

export class NiSponsorshipDto implements INiSponsorshipDto {
    uid!: string | undefined;
    sponsorshipName!: string | undefined;
    businessName!: string | undefined;
    additionalName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    addressAddition!: string | undefined;

    constructor(data?: INiSponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.sponsorshipName = _data["sponsorshipName"];
            this.businessName = _data["businessName"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.addressAddition = _data["addressAddition"];
        }
    }

    static fromJS(data: any): NiSponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new NiSponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["sponsorshipName"] = this.sponsorshipName;
        data["businessName"] = this.businessName;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["addressAddition"] = this.addressAddition;
        return data;
    }
}

export interface INiSponsorshipDto {
    uid: string | undefined;
    sponsorshipName: string | undefined;
    businessName: string | undefined;
    additionalName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    addressAddition: string | undefined;
}

export class NiDocumentGroup implements INiDocumentGroup {
    id!: number;
    typeId!: string | undefined;
    isMandatory!: boolean;
    info!: string | undefined;
    files!: GeneralFileInfo[] | undefined;

    constructor(data?: INiDocumentGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeId = _data["typeId"];
            this.isMandatory = _data["isMandatory"];
            this.info = _data["info"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(GeneralFileInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NiDocumentGroup {
        data = typeof data === 'object' ? data : {};
        let result = new NiDocumentGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        data["isMandatory"] = this.isMandatory;
        data["info"] = this.info;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface INiDocumentGroup {
    id: number;
    typeId: string | undefined;
    isMandatory: boolean;
    info: string | undefined;
    files: GeneralFileInfo[] | undefined;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
    parentId!: number | undefined;
    displayName!: string;

    constructor(data?: ICreateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICreateOrganizationUnitInput {
    parentId: number | undefined;
    displayName: string;
}

export class FindOrganizationUnitProfessionsInput implements IFindOrganizationUnitProfessionsInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitProfessionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitProfessionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitProfessionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindOrganizationUnitProfessionsInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class FindOrganizationUnitRolesInput implements IFindOrganizationUnitRolesInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitRolesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitRolesInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitRolesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindOrganizationUnitRolesInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class FindOrganizationUnitUsersInput implements IFindOrganizationUnitUsersInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindOrganizationUnitUsersInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id!: number;
    newParentId!: number | undefined;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newParentId = _data["newParentId"];
        }
    }

    static fromJS(data: any): MoveOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data;
    }
}

export interface IMoveOrganizationUnitInput {
    id: number;
    newParentId: number | undefined;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    parentId!: number | undefined;
    code!: string | undefined;
    displayName!: string | undefined;
    memberCount!: number;
    roleCount!: number;
    professionCount!: number;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.memberCount = _data["memberCount"];
            this.roleCount = _data["roleCount"];
            this.professionCount = _data["professionCount"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["roleCount"] = this.roleCount;
        data["professionCount"] = this.professionCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitDto {
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number;
    roleCount: number;
    professionCount: number;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class OrganizationUnitProfessionListDto implements IOrganizationUnitProfessionListDto {
    displayName!: string | undefined;
    name!: string | undefined;
    addedTime!: DateTime;
    id!: number;

    constructor(data?: IOrganizationUnitProfessionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.name = _data["name"];
            this.addedTime = _data["addedTime"] ? DateTime.fromISO(_data["addedTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitProfessionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitProfessionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        data["addedTime"] = this.addedTime ? this.addedTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitProfessionListDto {
    displayName: string | undefined;
    name: string | undefined;
    addedTime: DateTime;
    id: number;
}

export class OrganizationUnitRoleListDto implements IOrganizationUnitRoleListDto {
    displayName!: string | undefined;
    name!: string | undefined;
    addedTime!: DateTime;
    id!: number;

    constructor(data?: IOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.name = _data["name"];
            this.addedTime = _data["addedTime"] ? DateTime.fromISO(_data["addedTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        data["addedTime"] = this.addedTime ? this.addedTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitRoleListDto {
    displayName: string | undefined;
    name: string | undefined;
    addedTime: DateTime;
    id: number;
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    addedTime!: DateTime;
    id!: number;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.addedTime = _data["addedTime"] ? DateTime.fromISO(_data["addedTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["addedTime"] = this.addedTime ? this.addedTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    addedTime: DateTime;
    id: number;
}

export class ProfessionsToOrganizationUnitInput implements IProfessionsToOrganizationUnitInput {
    professionIds!: string[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IProfessionsToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["professionIds"])) {
                this.professionIds = [] as any;
                for (let item of _data["professionIds"])
                    this.professionIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): ProfessionsToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionsToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.professionIds)) {
            data["professionIds"] = [];
            for (let item of this.professionIds)
                data["professionIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IProfessionsToOrganizationUnitInput {
    professionIds: string[] | undefined;
    organizationUnitId: number;
}

export class RolesToOrganizationUnitInput implements IRolesToOrganizationUnitInput {
    roleIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IRolesToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): RolesToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new RolesToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IRolesToOrganizationUnitInput {
    roleIds: number[] | undefined;
    organizationUnitId: number;
}

export class UpdateOrganizationUnitInput implements IUpdateOrganizationUnitInput {
    id!: number;
    displayName!: string;

    constructor(data?: IUpdateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUpdateOrganizationUnitInput {
    id: number;
    displayName: string;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
    userIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IUsersToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UsersToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IUsersToOrganizationUnitInput {
    userIds: number[] | undefined;
    organizationUnitId: number;
}

export class AssignPendenceInput implements IAssignPendenceInput {
    pendenceId!: number;
    userId!: number;

    constructor(data?: IAssignPendenceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendenceId = _data["pendenceId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AssignPendenceInput {
        data = typeof data === 'object' ? data : {};
        let result = new AssignPendenceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendenceId"] = this.pendenceId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAssignPendenceInput {
    pendenceId: number;
    userId: number;
}

export class AssignPendenceOutput implements IAssignPendenceOutput {
    responsible!: string | undefined;
    userId!: number | undefined;

    constructor(data?: IAssignPendenceOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responsible = _data["responsible"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AssignPendenceOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AssignPendenceOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responsible"] = this.responsible;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAssignPendenceOutput {
    responsible: string | undefined;
    userId: number | undefined;
}

export class CompletePendencesInput implements ICompletePendencesInput {
    pendenceIds!: number[];

    constructor(data?: ICompletePendencesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pendenceIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pendenceIds"])) {
                this.pendenceIds = [] as any;
                for (let item of _data["pendenceIds"])
                    this.pendenceIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CompletePendencesInput {
        data = typeof data === 'object' ? data : {};
        let result = new CompletePendencesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pendenceIds)) {
            data["pendenceIds"] = [];
            for (let item of this.pendenceIds)
                data["pendenceIds"].push(item);
        }
        return data;
    }
}

export interface ICompletePendencesInput {
    pendenceIds: number[];
}

export class CreatePendenceDto implements ICreatePendenceDto {
    links!: PendenceLinkDto[];
    fieldId!: string;
    creationDate!: DateTime;
    responsibleId!: number | undefined;
    creatorUserId!: number | undefined;
    completorId!: number | undefined;
    statusId!: string;
    dueDate!: DateTime | undefined;
    rememberDate!: DateTime | undefined;
    completeDate!: DateTime | undefined;
    typeId!: string;
    sendReminderEmailToResponsible!: boolean;
    reminderMailDistributionListIds!: number[];
    description!: string | undefined;

    constructor(data?: ICreatePendenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.links = [];
            this.reminderMailDistributionListIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(PendenceLinkDto.fromJS(item));
            }
            this.fieldId = _data["fieldId"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.responsibleId = _data["responsibleId"];
            this.creatorUserId = _data["creatorUserId"];
            this.completorId = _data["completorId"];
            this.statusId = _data["statusId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.rememberDate = _data["rememberDate"] ? DateTime.fromISO(_data["rememberDate"].toString()) : <any>undefined;
            this.completeDate = _data["completeDate"] ? DateTime.fromISO(_data["completeDate"].toString()) : <any>undefined;
            this.typeId = _data["typeId"];
            this.sendReminderEmailToResponsible = _data["sendReminderEmailToResponsible"];
            if (Array.isArray(_data["reminderMailDistributionListIds"])) {
                this.reminderMailDistributionListIds = [] as any;
                for (let item of _data["reminderMailDistributionListIds"])
                    this.reminderMailDistributionListIds!.push(item);
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreatePendenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePendenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        data["fieldId"] = this.fieldId;
        data["creationDate"] = this.creationDate ? this.creationDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["responsibleId"] = this.responsibleId;
        data["creatorUserId"] = this.creatorUserId;
        data["completorId"] = this.completorId;
        data["statusId"] = this.statusId;
        data["dueDate"] = this.dueDate ? this.dueDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["rememberDate"] = this.rememberDate ? this.rememberDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["completeDate"] = this.completeDate ? this.completeDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["typeId"] = this.typeId;
        data["sendReminderEmailToResponsible"] = this.sendReminderEmailToResponsible;
        if (Array.isArray(this.reminderMailDistributionListIds)) {
            data["reminderMailDistributionListIds"] = [];
            for (let item of this.reminderMailDistributionListIds)
                data["reminderMailDistributionListIds"].push(item);
        }
        data["description"] = this.description;
        return data;
    }
}

export interface ICreatePendenceDto {
    links: PendenceLinkDto[];
    fieldId: string;
    creationDate: DateTime;
    responsibleId: number | undefined;
    creatorUserId: number | undefined;
    completorId: number | undefined;
    statusId: string;
    dueDate: DateTime | undefined;
    rememberDate: DateTime | undefined;
    completeDate: DateTime | undefined;
    typeId: string;
    sendReminderEmailToResponsible: boolean;
    reminderMailDistributionListIds: number[];
    description: string | undefined;
}

export class GetPendencesSearchOutput implements IGetPendencesSearchOutput {
    totalCount!: number;
    items!: PendencesSearchResultDto[] | undefined;

    constructor(data?: IGetPendencesSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PendencesSearchResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPendencesSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPendencesSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPendencesSearchOutput {
    totalCount: number;
    items: PendencesSearchResultDto[] | undefined;
}

export class PendenceDto implements IPendenceDto {
    fieldId!: string;
    creationDate!: DateTime;
    responsibleId!: number | undefined;
    creatorUserId!: number | undefined;
    completorId!: number | undefined;
    statusId!: string;
    dueDate!: DateTime | undefined;
    rememberDate!: DateTime | undefined;
    completeDate!: DateTime | undefined;
    typeId!: string;
    sendReminderEmailToResponsible!: boolean;
    reminderMailDistributionListIds!: number[];
    description!: string | undefined;

    constructor(data?: IPendenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reminderMailDistributionListIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.responsibleId = _data["responsibleId"];
            this.creatorUserId = _data["creatorUserId"];
            this.completorId = _data["completorId"];
            this.statusId = _data["statusId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.rememberDate = _data["rememberDate"] ? DateTime.fromISO(_data["rememberDate"].toString()) : <any>undefined;
            this.completeDate = _data["completeDate"] ? DateTime.fromISO(_data["completeDate"].toString()) : <any>undefined;
            this.typeId = _data["typeId"];
            this.sendReminderEmailToResponsible = _data["sendReminderEmailToResponsible"];
            if (Array.isArray(_data["reminderMailDistributionListIds"])) {
                this.reminderMailDistributionListIds = [] as any;
                for (let item of _data["reminderMailDistributionListIds"])
                    this.reminderMailDistributionListIds!.push(item);
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PendenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["creationDate"] = this.creationDate ? this.creationDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["responsibleId"] = this.responsibleId;
        data["creatorUserId"] = this.creatorUserId;
        data["completorId"] = this.completorId;
        data["statusId"] = this.statusId;
        data["dueDate"] = this.dueDate ? this.dueDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["rememberDate"] = this.rememberDate ? this.rememberDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["completeDate"] = this.completeDate ? this.completeDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["typeId"] = this.typeId;
        data["sendReminderEmailToResponsible"] = this.sendReminderEmailToResponsible;
        if (Array.isArray(this.reminderMailDistributionListIds)) {
            data["reminderMailDistributionListIds"] = [];
            for (let item of this.reminderMailDistributionListIds)
                data["reminderMailDistributionListIds"].push(item);
        }
        data["description"] = this.description;
        return data;
    }
}

export interface IPendenceDto {
    fieldId: string;
    creationDate: DateTime;
    responsibleId: number | undefined;
    creatorUserId: number | undefined;
    completorId: number | undefined;
    statusId: string;
    dueDate: DateTime | undefined;
    rememberDate: DateTime | undefined;
    completeDate: DateTime | undefined;
    typeId: string;
    sendReminderEmailToResponsible: boolean;
    reminderMailDistributionListIds: number[];
    description: string | undefined;
}

export class PendenceIncludingLinksDto implements IPendenceIncludingLinksDto {
    links!: PendenceLinkDescriptionDto[] | undefined;
    fieldId!: string;
    creationDate!: DateTime;
    responsibleId!: number | undefined;
    creatorUserId!: number | undefined;
    completorId!: number | undefined;
    statusId!: string;
    dueDate!: DateTime | undefined;
    rememberDate!: DateTime | undefined;
    completeDate!: DateTime | undefined;
    typeId!: string;
    sendReminderEmailToResponsible!: boolean;
    reminderMailDistributionListIds!: number[];
    description!: string | undefined;

    constructor(data?: IPendenceIncludingLinksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reminderMailDistributionListIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(PendenceLinkDescriptionDto.fromJS(item));
            }
            this.fieldId = _data["fieldId"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.responsibleId = _data["responsibleId"];
            this.creatorUserId = _data["creatorUserId"];
            this.completorId = _data["completorId"];
            this.statusId = _data["statusId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.rememberDate = _data["rememberDate"] ? DateTime.fromISO(_data["rememberDate"].toString()) : <any>undefined;
            this.completeDate = _data["completeDate"] ? DateTime.fromISO(_data["completeDate"].toString()) : <any>undefined;
            this.typeId = _data["typeId"];
            this.sendReminderEmailToResponsible = _data["sendReminderEmailToResponsible"];
            if (Array.isArray(_data["reminderMailDistributionListIds"])) {
                this.reminderMailDistributionListIds = [] as any;
                for (let item of _data["reminderMailDistributionListIds"])
                    this.reminderMailDistributionListIds!.push(item);
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PendenceIncludingLinksDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendenceIncludingLinksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        data["fieldId"] = this.fieldId;
        data["creationDate"] = this.creationDate ? this.creationDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["responsibleId"] = this.responsibleId;
        data["creatorUserId"] = this.creatorUserId;
        data["completorId"] = this.completorId;
        data["statusId"] = this.statusId;
        data["dueDate"] = this.dueDate ? this.dueDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["rememberDate"] = this.rememberDate ? this.rememberDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["completeDate"] = this.completeDate ? this.completeDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["typeId"] = this.typeId;
        data["sendReminderEmailToResponsible"] = this.sendReminderEmailToResponsible;
        if (Array.isArray(this.reminderMailDistributionListIds)) {
            data["reminderMailDistributionListIds"] = [];
            for (let item of this.reminderMailDistributionListIds)
                data["reminderMailDistributionListIds"].push(item);
        }
        data["description"] = this.description;
        return data;
    }
}

export interface IPendenceIncludingLinksDto {
    links: PendenceLinkDescriptionDto[] | undefined;
    fieldId: string;
    creationDate: DateTime;
    responsibleId: number | undefined;
    creatorUserId: number | undefined;
    completorId: number | undefined;
    statusId: string;
    dueDate: DateTime | undefined;
    rememberDate: DateTime | undefined;
    completeDate: DateTime | undefined;
    typeId: string;
    sendReminderEmailToResponsible: boolean;
    reminderMailDistributionListIds: number[];
    description: string | undefined;
}

export class PendenceLinkDescriptionDto implements IPendenceLinkDescriptionDto {
    discriminator!: string | undefined;
    entityId!: number;
    description!: string | undefined;
    additionalData!: { [key: string]: any; } | undefined;

    constructor(data?: IPendenceLinkDescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.entityId = _data["entityId"];
            this.description = _data["description"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (<any>this.additionalData)![key] = _data["additionalData"][key];
                }
            }
        }
    }

    static fromJS(data: any): PendenceLinkDescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendenceLinkDescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["entityId"] = this.entityId;
        data["description"] = this.description;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (<any>data["additionalData"])[key] = (<any>this.additionalData)[key];
            }
        }
        return data;
    }
}

export interface IPendenceLinkDescriptionDto {
    discriminator: string | undefined;
    entityId: number;
    description: string | undefined;
    additionalData: { [key: string]: any; } | undefined;
}

export class PendenceLinkDto implements IPendenceLinkDto {
    discriminator!: string | undefined;
    entityId!: number;

    constructor(data?: IPendenceLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any): PendenceLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendenceLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["entityId"] = this.entityId;
        return data;
    }
}

export interface IPendenceLinkDto {
    discriminator: string | undefined;
    entityId: number;
}

export class PendencesSearchResultDto implements IPendencesSearchResultDto {
    id!: number;
    responsibleId!: number | undefined;
    responsibleFullName!: string | undefined;
    description!: string | undefined;
    fieldId!: string | undefined;
    statusId!: string | undefined;
    typeId!: string | undefined;
    responsibleCheck!: boolean;
    creatorUserId!: number | undefined;
    completorId!: number | undefined;
    creationDate!: DateTime;
    dueDate!: DateTime | undefined;
    rememberDate!: DateTime | undefined;
    completeDate!: DateTime | undefined;
    links!: PendenceLinkDescriptionDto[] | undefined;

    constructor(data?: IPendencesSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.responsibleId = _data["responsibleId"];
            this.responsibleFullName = _data["responsibleFullName"];
            this.description = _data["description"];
            this.fieldId = _data["fieldId"];
            this.statusId = _data["statusId"];
            this.typeId = _data["typeId"];
            this.responsibleCheck = _data["responsibleCheck"];
            this.creatorUserId = _data["creatorUserId"];
            this.completorId = _data["completorId"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.rememberDate = _data["rememberDate"] ? DateTime.fromISO(_data["rememberDate"].toString()) : <any>undefined;
            this.completeDate = _data["completeDate"] ? DateTime.fromISO(_data["completeDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(PendenceLinkDescriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PendencesSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendencesSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["responsibleId"] = this.responsibleId;
        data["responsibleFullName"] = this.responsibleFullName;
        data["description"] = this.description;
        data["fieldId"] = this.fieldId;
        data["statusId"] = this.statusId;
        data["typeId"] = this.typeId;
        data["responsibleCheck"] = this.responsibleCheck;
        data["creatorUserId"] = this.creatorUserId;
        data["completorId"] = this.completorId;
        data["creationDate"] = this.creationDate ? this.creationDate.toString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["rememberDate"] = this.rememberDate ? this.rememberDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["completeDate"] = this.completeDate ? this.completeDate.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPendencesSearchResultDto {
    id: number;
    responsibleId: number | undefined;
    responsibleFullName: string | undefined;
    description: string | undefined;
    fieldId: string | undefined;
    statusId: string | undefined;
    typeId: string | undefined;
    responsibleCheck: boolean;
    creatorUserId: number | undefined;
    completorId: number | undefined;
    creationDate: DateTime;
    dueDate: DateTime | undefined;
    rememberDate: DateTime | undefined;
    completeDate: DateTime | undefined;
    links: PendenceLinkDescriptionDto[] | undefined;
}

export class Pendence implements IPendence {
    fieldId!: string | undefined;
    creationDate!: DateTime;
    responsibleId!: number | undefined;
    responsible!: User;
    statusId!: string | undefined;
    dueDate!: DateTime | undefined;
    rememberDate!: DateTime | undefined;
    completeDate!: DateTime | undefined;
    typeId!: string | undefined;
    sendReminderEmailToResponsible!: boolean;
    description!: string | undefined;
    completorId!: number | undefined;
    completor!: User;
    emailReminderSent!: boolean;
    pendenceLinks!: PendenceLink[] | undefined;
    reminderMailDistributionLists!: MailDistributionList[] | undefined;
    migrationData!: MigrationData[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IPendence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.responsibleId = _data["responsibleId"];
            this.responsible = _data["responsible"] ? User.fromJS(_data["responsible"]) : <any>undefined;
            this.statusId = _data["statusId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.rememberDate = _data["rememberDate"] ? DateTime.fromISO(_data["rememberDate"].toString()) : <any>undefined;
            this.completeDate = _data["completeDate"] ? DateTime.fromISO(_data["completeDate"].toString()) : <any>undefined;
            this.typeId = _data["typeId"];
            this.sendReminderEmailToResponsible = _data["sendReminderEmailToResponsible"];
            this.description = _data["description"];
            this.completorId = _data["completorId"];
            this.completor = _data["completor"] ? User.fromJS(_data["completor"]) : <any>undefined;
            this.emailReminderSent = _data["emailReminderSent"];
            if (Array.isArray(_data["pendenceLinks"])) {
                this.pendenceLinks = [] as any;
                for (let item of _data["pendenceLinks"])
                    this.pendenceLinks!.push(PendenceLink.fromJS(item));
            }
            if (Array.isArray(_data["reminderMailDistributionLists"])) {
                this.reminderMailDistributionLists = [] as any;
                for (let item of _data["reminderMailDistributionLists"])
                    this.reminderMailDistributionLists!.push(MailDistributionList.fromJS(item));
            }
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Pendence {
        data = typeof data === 'object' ? data : {};
        let result = new Pendence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["creationDate"] = this.creationDate ? this.creationDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["responsibleId"] = this.responsibleId;
        data["responsible"] = this.responsible ? this.responsible.toJSON() : <any>undefined;
        data["statusId"] = this.statusId;
        data["dueDate"] = this.dueDate ? this.dueDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["rememberDate"] = this.rememberDate ? this.rememberDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["completeDate"] = this.completeDate ? this.completeDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["typeId"] = this.typeId;
        data["sendReminderEmailToResponsible"] = this.sendReminderEmailToResponsible;
        data["description"] = this.description;
        data["completorId"] = this.completorId;
        data["completor"] = this.completor ? this.completor.toJSON() : <any>undefined;
        data["emailReminderSent"] = this.emailReminderSent;
        if (Array.isArray(this.pendenceLinks)) {
            data["pendenceLinks"] = [];
            for (let item of this.pendenceLinks)
                data["pendenceLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.reminderMailDistributionLists)) {
            data["reminderMailDistributionLists"] = [];
            for (let item of this.reminderMailDistributionLists)
                data["reminderMailDistributionLists"].push(item.toJSON());
        }
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPendence {
    fieldId: string | undefined;
    creationDate: DateTime;
    responsibleId: number | undefined;
    responsible: User;
    statusId: string | undefined;
    dueDate: DateTime | undefined;
    rememberDate: DateTime | undefined;
    completeDate: DateTime | undefined;
    typeId: string | undefined;
    sendReminderEmailToResponsible: boolean;
    description: string | undefined;
    completorId: number | undefined;
    completor: User;
    emailReminderSent: boolean;
    pendenceLinks: PendenceLink[] | undefined;
    reminderMailDistributionLists: MailDistributionList[] | undefined;
    migrationData: MigrationData[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class PendenceLink implements IPendenceLink {
    discriminator!: string | undefined;
    pendence!: Pendence;
    pendenceId!: number;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IPendenceLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.pendence = _data["pendence"] ? Pendence.fromJS(_data["pendence"]) : <any>undefined;
            this.pendenceId = _data["pendenceId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PendenceLink {
        data = typeof data === 'object' ? data : {};
        let result = new PendenceLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["pendence"] = this.pendence ? this.pendence.toJSON() : <any>undefined;
        data["pendenceId"] = this.pendenceId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPendenceLink {
    discriminator: string | undefined;
    pendence: Pendence;
    pendenceId: number;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class PendenceLinkEducationGrants implements IPendenceLinkEducationGrants {
    educationGrants!: EducationGrants;
    educationGrantsId!: number;
    discriminator!: string | undefined;
    pendence!: Pendence;
    pendenceId!: number;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IPendenceLinkEducationGrants) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.educationGrants = _data["educationGrants"] ? EducationGrants.fromJS(_data["educationGrants"]) : <any>undefined;
            this.educationGrantsId = _data["educationGrantsId"];
            this.discriminator = _data["discriminator"];
            this.pendence = _data["pendence"] ? Pendence.fromJS(_data["pendence"]) : <any>undefined;
            this.pendenceId = _data["pendenceId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PendenceLinkEducationGrants {
        data = typeof data === 'object' ? data : {};
        let result = new PendenceLinkEducationGrants();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["educationGrants"] = this.educationGrants ? this.educationGrants.toJSON() : <any>undefined;
        data["educationGrantsId"] = this.educationGrantsId;
        data["discriminator"] = this.discriminator;
        data["pendence"] = this.pendence ? this.pendence.toJSON() : <any>undefined;
        data["pendenceId"] = this.pendenceId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPendenceLinkEducationGrants {
    educationGrants: EducationGrants;
    educationGrantsId: number;
    discriminator: string | undefined;
    pendence: Pendence;
    pendenceId: number;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class PendenceLinkLogbook implements IPendenceLinkLogbook {
    logbook!: LogbookBaseEntity;
    logbookId!: number;
    discriminator!: string | undefined;
    pendence!: Pendence;
    pendenceId!: number;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IPendenceLinkLogbook) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logbook = _data["logbook"] ? LogbookBaseEntity.fromJS(_data["logbook"]) : <any>undefined;
            this.logbookId = _data["logbookId"];
            this.discriminator = _data["discriminator"];
            this.pendence = _data["pendence"] ? Pendence.fromJS(_data["pendence"]) : <any>undefined;
            this.pendenceId = _data["pendenceId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PendenceLinkLogbook {
        data = typeof data === 'object' ? data : {};
        let result = new PendenceLinkLogbook();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logbook"] = this.logbook ? this.logbook.toJSON() : <any>undefined;
        data["logbookId"] = this.logbookId;
        data["discriminator"] = this.discriminator;
        data["pendence"] = this.pendence ? this.pendence.toJSON() : <any>undefined;
        data["pendenceId"] = this.pendenceId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPendenceLinkLogbook {
    logbook: LogbookBaseEntity;
    logbookId: number;
    discriminator: string | undefined;
    pendence: Pendence;
    pendenceId: number;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class PendenceLinkPerson implements IPendenceLinkPerson {
    person!: Person;
    personId!: number;
    discriminator!: string | undefined;
    pendence!: Pendence;
    pendenceId!: number;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IPendenceLinkPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.personId = _data["personId"];
            this.discriminator = _data["discriminator"];
            this.pendence = _data["pendence"] ? Pendence.fromJS(_data["pendence"]) : <any>undefined;
            this.pendenceId = _data["pendenceId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PendenceLinkPerson {
        data = typeof data === 'object' ? data : {};
        let result = new PendenceLinkPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["discriminator"] = this.discriminator;
        data["pendence"] = this.pendence ? this.pendence.toJSON() : <any>undefined;
        data["pendenceId"] = this.pendenceId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPendenceLinkPerson {
    person: Person;
    personId: number;
    discriminator: string | undefined;
    pendence: Pendence;
    pendenceId: number;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class PendenceLinkSponsorship implements IPendenceLinkSponsorship {
    sponsorship!: Sponsorship;
    sponsorshipId!: number;
    discriminator!: string | undefined;
    pendence!: Pendence;
    pendenceId!: number;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IPendenceLinkSponsorship) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorship = _data["sponsorship"] ? Sponsorship.fromJS(_data["sponsorship"]) : <any>undefined;
            this.sponsorshipId = _data["sponsorshipId"];
            this.discriminator = _data["discriminator"];
            this.pendence = _data["pendence"] ? Pendence.fromJS(_data["pendence"]) : <any>undefined;
            this.pendenceId = _data["pendenceId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PendenceLinkSponsorship {
        data = typeof data === 'object' ? data : {};
        let result = new PendenceLinkSponsorship();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        data["sponsorshipId"] = this.sponsorshipId;
        data["discriminator"] = this.discriminator;
        data["pendence"] = this.pendence ? this.pendence.toJSON() : <any>undefined;
        data["pendenceId"] = this.pendenceId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPendenceLinkSponsorship {
    sponsorship: Sponsorship;
    sponsorshipId: number;
    discriminator: string | undefined;
    pendence: Pendence;
    pendenceId: number;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class GetPeopleApplicationsOutput implements IGetPeopleApplicationsOutput {
    totalCount!: number;
    items!: PersonApplicationSearchDto[] | undefined;

    constructor(data?: IGetPeopleApplicationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PersonApplicationSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPeopleApplicationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPeopleApplicationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPeopleApplicationsOutput {
    totalCount: number;
    items: PersonApplicationSearchDto[] | undefined;
}

export class PersonApplicationSearchDto implements IPersonApplicationSearchDto {
    id!: number;
    type!: number;
    caseId!: string | undefined;
    caseIdSearchable!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    fullName!: string | undefined;
    userFullName!: string | undefined;
    userEmail!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    professionId!: string | undefined;
    status!: ApplicationStatus;
    dateOfStatusChange!: DateTime;
    responsibleId!: number | undefined;
    responsibleFullName!: string | undefined;
    iAmResponsible!: boolean;
    submittedCount!: number;
    submittedDate!: DateTime | undefined;
    lastSubmittedDate!: DateTime | undefined;
    requestedOrGrantedLicenceId!: number | undefined;

    constructor(data?: IPersonApplicationSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.caseId = _data["caseId"];
            this.caseIdSearchable = _data["caseIdSearchable"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.userFullName = _data["userFullName"];
            this.userEmail = _data["userEmail"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.professionId = _data["professionId"];
            this.status = _data["status"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.responsibleId = _data["responsibleId"];
            this.responsibleFullName = _data["responsibleFullName"];
            this.iAmResponsible = _data["iAmResponsible"];
            this.submittedCount = _data["submittedCount"];
            this.submittedDate = _data["submittedDate"] ? DateTime.fromISO(_data["submittedDate"].toString()) : <any>undefined;
            this.lastSubmittedDate = _data["lastSubmittedDate"] ? DateTime.fromISO(_data["lastSubmittedDate"].toString()) : <any>undefined;
            this.requestedOrGrantedLicenceId = _data["requestedOrGrantedLicenceId"];
        }
    }

    static fromJS(data: any): PersonApplicationSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonApplicationSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["caseId"] = this.caseId;
        data["caseIdSearchable"] = this.caseIdSearchable;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["userFullName"] = this.userFullName;
        data["userEmail"] = this.userEmail;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["professionId"] = this.professionId;
        data["status"] = this.status;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toString() : <any>undefined;
        data["responsibleId"] = this.responsibleId;
        data["responsibleFullName"] = this.responsibleFullName;
        data["iAmResponsible"] = this.iAmResponsible;
        data["submittedCount"] = this.submittedCount;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toString() : <any>undefined;
        data["lastSubmittedDate"] = this.lastSubmittedDate ? this.lastSubmittedDate.toString() : <any>undefined;
        data["requestedOrGrantedLicenceId"] = this.requestedOrGrantedLicenceId;
        return data;
    }
}

export interface IPersonApplicationSearchDto {
    id: number;
    type: number;
    caseId: string | undefined;
    caseIdSearchable: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fullName: string | undefined;
    userFullName: string | undefined;
    userEmail: string | undefined;
    dateOfBirth: DateTime | undefined;
    professionId: string | undefined;
    status: ApplicationStatus;
    dateOfStatusChange: DateTime;
    responsibleId: number | undefined;
    responsibleFullName: string | undefined;
    iAmResponsible: boolean;
    submittedCount: number;
    submittedDate: DateTime | undefined;
    lastSubmittedDate: DateTime | undefined;
    requestedOrGrantedLicenceId: number | undefined;
}

export class PersonApplicationSummaryDto implements IPersonApplicationSummaryDto {
    applicationType!: ApplicationType;
    applicationStatus!: ApplicationStatus;
    dateOfStatusChange!: DateTime;
    caseId!: string | undefined;
    professionId!: string | undefined;
    name!: string | undefined;
    gln!: string | undefined;

    constructor(data?: IPersonApplicationSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationType = _data["applicationType"];
            this.applicationStatus = _data["applicationStatus"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.caseId = _data["caseId"];
            this.professionId = _data["professionId"];
            this.name = _data["name"];
            this.gln = _data["gln"];
        }
    }

    static fromJS(data: any): PersonApplicationSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonApplicationSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationType"] = this.applicationType;
        data["applicationStatus"] = this.applicationStatus;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toString() : <any>undefined;
        data["caseId"] = this.caseId;
        data["professionId"] = this.professionId;
        data["name"] = this.name;
        data["gln"] = this.gln;
        return data;
    }
}

export interface IPersonApplicationSummaryDto {
    applicationType: ApplicationType;
    applicationStatus: ApplicationStatus;
    dateOfStatusChange: DateTime;
    caseId: string | undefined;
    professionId: string | undefined;
    name: string | undefined;
    gln: string | undefined;
}

export class Contact implements IContact {
    personId!: number;
    person!: Person;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    addressAddition!: string | undefined;
    country!: Code;
    countryId!: string | undefined;
    municipality!: Code;
    municipalityId!: string | undefined;
    region!: Code;
    regionId!: string | undefined;
    email!: string | undefined;
    email2!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    title!: Code;
    titleId!: string | undefined;
    titleLetter!: Code;
    titleLetterId!: string | undefined;
    languageOfCorrespondence!: Code;
    languageOfCorrespondenceId!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.addressAddition = _data["addressAddition"];
            this.country = _data["country"] ? Code.fromJS(_data["country"]) : <any>undefined;
            this.countryId = _data["countryId"];
            this.municipality = _data["municipality"] ? Code.fromJS(_data["municipality"]) : <any>undefined;
            this.municipalityId = _data["municipalityId"];
            this.region = _data["region"] ? Code.fromJS(_data["region"]) : <any>undefined;
            this.regionId = _data["regionId"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.title = _data["title"] ? Code.fromJS(_data["title"]) : <any>undefined;
            this.titleId = _data["titleId"];
            this.titleLetter = _data["titleLetter"] ? Code.fromJS(_data["titleLetter"]) : <any>undefined;
            this.titleLetterId = _data["titleLetterId"];
            this.languageOfCorrespondence = _data["languageOfCorrespondence"] ? Code.fromJS(_data["languageOfCorrespondence"]) : <any>undefined;
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["addressAddition"] = this.addressAddition;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["countryId"] = this.countryId;
        data["municipality"] = this.municipality ? this.municipality.toJSON() : <any>undefined;
        data["municipalityId"] = this.municipalityId;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        data["regionId"] = this.regionId;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["titleId"] = this.titleId;
        data["titleLetter"] = this.titleLetter ? this.titleLetter.toJSON() : <any>undefined;
        data["titleLetterId"] = this.titleLetterId;
        data["languageOfCorrespondence"] = this.languageOfCorrespondence ? this.languageOfCorrespondence.toJSON() : <any>undefined;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IContact {
    personId: number;
    person: Person;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    addressAddition: string | undefined;
    country: Code;
    countryId: string | undefined;
    municipality: Code;
    municipalityId: string | undefined;
    region: Code;
    regionId: string | undefined;
    email: string | undefined;
    email2: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    title: Code;
    titleId: string | undefined;
    titleLetter: Code;
    titleLetterId: string | undefined;
    languageOfCorrespondence: Code;
    languageOfCorrespondenceId: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ContactDto implements IContactDto {
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    addressAddition!: string | undefined;
    email!: string | undefined;
    email2!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    titleId!: string | undefined;
    titleLetterId!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    municipalityId!: string | undefined;
    regionId!: string | undefined;

    constructor(data?: IContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.addressAddition = _data["addressAddition"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.titleId = _data["titleId"];
            this.titleLetterId = _data["titleLetterId"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.municipalityId = _data["municipalityId"];
            this.regionId = _data["regionId"];
        }
    }

    static fromJS(data: any): ContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["addressAddition"] = this.addressAddition;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["titleId"] = this.titleId;
        data["titleLetterId"] = this.titleLetterId;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["municipalityId"] = this.municipalityId;
        data["regionId"] = this.regionId;
        return data;
    }
}

export interface IContactDto {
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    addressAddition: string | undefined;
    email: string | undefined;
    email2: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    titleId: string | undefined;
    titleLetterId: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    municipalityId: string | undefined;
    regionId: string | undefined;
}

export class CreateOrUpdatePersonDto implements ICreateOrUpdatePersonDto {
    id!: number;
    firstName!: string;
    lastName!: string;
    birthName!: string | undefined;
    genderId!: string;
    dateOfBirth!: DateTime;
    dateOfDeath!: DateTime | undefined;
    nationality1Id!: string;
    nationality2Id!: string | undefined;
    placeOfOrigin!: string | undefined;
    gln!: string | undefined;
    ahv!: string | undefined;
    uid!: string | undefined;
    comments!: string | undefined;
    languageSkillCodeIds!: string[] | undefined;

    constructor(data?: ICreateOrUpdatePersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.genderId = _data["genderId"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.dateOfDeath = _data["dateOfDeath"] ? DateTime.fromISO(_data["dateOfDeath"].toString()) : <any>undefined;
            this.nationality1Id = _data["nationality1Id"];
            this.nationality2Id = _data["nationality2Id"];
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.gln = _data["gln"];
            this.ahv = _data["ahv"];
            this.uid = _data["uid"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["languageSkillCodeIds"])) {
                this.languageSkillCodeIds = [] as any;
                for (let item of _data["languageSkillCodeIds"])
                    this.languageSkillCodeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdatePersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["genderId"] = this.genderId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDeath"] = this.dateOfDeath ? this.dateOfDeath.toFormat('yyyy-MM-dd') : <any>undefined;
        data["nationality1Id"] = this.nationality1Id;
        data["nationality2Id"] = this.nationality2Id;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["gln"] = this.gln;
        data["ahv"] = this.ahv;
        data["uid"] = this.uid;
        data["comments"] = this.comments;
        if (Array.isArray(this.languageSkillCodeIds)) {
            data["languageSkillCodeIds"] = [];
            for (let item of this.languageSkillCodeIds)
                data["languageSkillCodeIds"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdatePersonDto {
    id: number;
    firstName: string;
    lastName: string;
    birthName: string | undefined;
    genderId: string;
    dateOfBirth: DateTime;
    dateOfDeath: DateTime | undefined;
    nationality1Id: string;
    nationality2Id: string | undefined;
    placeOfOrigin: string | undefined;
    gln: string | undefined;
    ahv: string | undefined;
    uid: string | undefined;
    comments: string | undefined;
    languageSkillCodeIds: string[] | undefined;
}

export class CreatePersonAndLinkToEmploymentInput implements ICreatePersonAndLinkToEmploymentInput {
    employmentId!: number;
    person!: EmploymentPersonDto;

    constructor(data?: ICreatePersonAndLinkToEmploymentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employmentId = _data["employmentId"];
            this.person = _data["person"] ? EmploymentPersonDto.fromJS(_data["person"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreatePersonAndLinkToEmploymentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonAndLinkToEmploymentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employmentId"] = this.employmentId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreatePersonAndLinkToEmploymentInput {
    employmentId: number;
    person: EmploymentPersonDto;
}

export class CreatePersonFromEmploymentInfoDto implements ICreatePersonFromEmploymentInfoDto {
    gln!: string | undefined;
    professionId!: string | undefined;
    firstName!: string;
    lastName!: string;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;

    constructor(data?: ICreatePersonFromEmploymentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
        }
    }

    static fromJS(data: any): CreatePersonFromEmploymentInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonFromEmploymentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        return data;
    }
}

export interface ICreatePersonFromEmploymentInfoDto {
    gln: string | undefined;
    professionId: string | undefined;
    firstName: string;
    lastName: string;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
}

export class CreatePersonFromHealthRegisterInfoDto implements ICreatePersonFromHealthRegisterInfoDto {
    professionId!: string;
    gln!: string;

    constructor(data?: ICreatePersonFromHealthRegisterInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.gln = _data["gln"];
        }
    }

    static fromJS(data: any): CreatePersonFromHealthRegisterInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonFromHealthRegisterInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["gln"] = this.gln;
        return data;
    }
}

export interface ICreatePersonFromHealthRegisterInfoDto {
    professionId: string;
    gln: string;
}

export class EmploymentPersonDto implements IEmploymentPersonDto {
    id!: number;
    firstName!: string | undefined;
    lastName!: string | undefined;
    gln!: string | undefined;
    email!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;

    constructor(data?: IEmploymentPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gln = _data["gln"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
        }
    }

    static fromJS(data: any): EmploymentPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gln"] = this.gln;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        return data;
    }
}

export interface IEmploymentPersonDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    gln: string | undefined;
    email: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
}

export class EmploymentWithAddressDto implements IEmploymentWithAddressDto {
    id!: number;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    roleId!: string | undefined;
    isMobileEmployment!: boolean;
    name!: string | undefined;
    legalFormId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    businessAddressDescription!: string | undefined;

    constructor(data?: IEmploymentWithAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.roleId = _data["roleId"];
            this.isMobileEmployment = _data["isMobileEmployment"];
            this.name = _data["name"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.businessAddressDescription = _data["businessAddressDescription"];
        }
    }

    static fromJS(data: any): EmploymentWithAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentWithAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["roleId"] = this.roleId;
        data["isMobileEmployment"] = this.isMobileEmployment;
        data["name"] = this.name;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["businessAddressDescription"] = this.businessAddressDescription;
        return data;
    }
}

export interface IEmploymentWithAddressDto {
    id: number;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    roleId: string | undefined;
    isMobileEmployment: boolean;
    name: string | undefined;
    legalFormId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    businessAddressDescription: string | undefined;
}

export class EmploymentWithPersonDto implements IEmploymentWithPersonDto {
    id!: number;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    roleId!: string | undefined;
    businessName!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    readonly fullName!: string | undefined;

    constructor(data?: IEmploymentWithPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.roleId = _data["roleId"];
            this.businessName = _data["businessName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): EmploymentWithPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentWithPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["roleId"] = this.roleId;
        data["businessName"] = this.businessName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IEmploymentWithPersonDto {
    id: number;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    roleId: string | undefined;
    businessName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fullName: string | undefined;
}

export class GetPersonDto implements IGetPersonDto {
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    id!: number;
    firstName!: string;
    lastName!: string;
    birthName!: string | undefined;
    genderId!: string;
    dateOfBirth!: DateTime;
    dateOfDeath!: DateTime | undefined;
    nationality1Id!: string;
    nationality2Id!: string | undefined;
    placeOfOrigin!: string | undefined;
    gln!: string | undefined;
    ahv!: string | undefined;
    uid!: string | undefined;
    comments!: string | undefined;
    languageSkillCodeIds!: string[] | undefined;

    constructor(data?: IGetPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.genderId = _data["genderId"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.dateOfDeath = _data["dateOfDeath"] ? DateTime.fromISO(_data["dateOfDeath"].toString()) : <any>undefined;
            this.nationality1Id = _data["nationality1Id"];
            this.nationality2Id = _data["nationality2Id"];
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.gln = _data["gln"];
            this.ahv = _data["ahv"];
            this.uid = _data["uid"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["languageSkillCodeIds"])) {
                this.languageSkillCodeIds = [] as any;
                for (let item of _data["languageSkillCodeIds"])
                    this.languageSkillCodeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["genderId"] = this.genderId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDeath"] = this.dateOfDeath ? this.dateOfDeath.toFormat('yyyy-MM-dd') : <any>undefined;
        data["nationality1Id"] = this.nationality1Id;
        data["nationality2Id"] = this.nationality2Id;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["gln"] = this.gln;
        data["ahv"] = this.ahv;
        data["uid"] = this.uid;
        data["comments"] = this.comments;
        if (Array.isArray(this.languageSkillCodeIds)) {
            data["languageSkillCodeIds"] = [];
            for (let item of this.languageSkillCodeIds)
                data["languageSkillCodeIds"].push(item);
        }
        return data;
    }
}

export interface IGetPersonDto {
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    id: number;
    firstName: string;
    lastName: string;
    birthName: string | undefined;
    genderId: string;
    dateOfBirth: DateTime;
    dateOfDeath: DateTime | undefined;
    nationality1Id: string;
    nationality2Id: string | undefined;
    placeOfOrigin: string | undefined;
    gln: string | undefined;
    ahv: string | undefined;
    uid: string | undefined;
    comments: string | undefined;
    languageSkillCodeIds: string[] | undefined;
}

export class InvoiceAddressDto implements IInvoiceAddressDto {
    name!: string | undefined;
    titleId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    addressAddition!: string | undefined;
    postOfficeBox!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;

    constructor(data?: IInvoiceAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.titleId = _data["titleId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.addressAddition = _data["addressAddition"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): InvoiceAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["titleId"] = this.titleId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["addressAddition"] = this.addressAddition;
        data["postOfficeBox"] = this.postOfficeBox;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        return data;
    }
}

export interface IInvoiceAddressDto {
    name: string | undefined;
    titleId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    addressAddition: string | undefined;
    postOfficeBox: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
}

export class PersonSearchDto implements IPersonSearchDto {
    id!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    professionIds!: string[] | undefined;
    genderId!: string | undefined;
    ahv!: string | undefined;
    gln!: string | undefined;
    email!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    cantonId!: string | undefined;
    countryId!: string | undefined;
    isArchived!: boolean | undefined;
    sorting!: string | undefined;
    filter!: string | undefined;
    skipCount!: number;
    maxResultCount!: number;

    constructor(data?: IPersonSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            if (Array.isArray(_data["professionIds"])) {
                this.professionIds = [] as any;
                for (let item of _data["professionIds"])
                    this.professionIds!.push(item);
            }
            this.genderId = _data["genderId"];
            this.ahv = _data["ahv"];
            this.gln = _data["gln"];
            this.email = _data["email"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.cantonId = _data["cantonId"];
            this.countryId = _data["countryId"];
            this.isArchived = _data["isArchived"];
            this.sorting = _data["sorting"];
            this.filter = _data["filter"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): PersonSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.professionIds)) {
            data["professionIds"] = [];
            for (let item of this.professionIds)
                data["professionIds"].push(item);
        }
        data["genderId"] = this.genderId;
        data["ahv"] = this.ahv;
        data["gln"] = this.gln;
        data["email"] = this.email;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["cantonId"] = this.cantonId;
        data["countryId"] = this.countryId;
        data["isArchived"] = this.isArchived;
        data["sorting"] = this.sorting;
        data["filter"] = this.filter;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IPersonSearchDto {
    id: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    dateOfBirth: DateTime | undefined;
    professionIds: string[] | undefined;
    genderId: string | undefined;
    ahv: string | undefined;
    gln: string | undefined;
    email: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    cantonId: string | undefined;
    countryId: string | undefined;
    isArchived: boolean | undefined;
    sorting: string | undefined;
    filter: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class ProfessionalLicenceDto implements IProfessionalLicenceDto {
    caseId!: string | undefined;
    userId!: number;
    professionId!: string;
    statusId!: string;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfNinetyDaysStart!: DateTime | undefined;
    dateOfNinetyDaysEnd!: DateTime | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    remark!: string | undefined;
    personId!: number;
    person!: EmploymentPersonDto;
    documents!: DocumentDto[] | undefined;
    id!: number;

    constructor(data?: IProfessionalLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.userId = _data["userId"];
            this.professionId = _data["professionId"];
            this.statusId = _data["statusId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfNinetyDaysStart = _data["dateOfNinetyDaysStart"] ? DateTime.fromISO(_data["dateOfNinetyDaysStart"].toString()) : <any>undefined;
            this.dateOfNinetyDaysEnd = _data["dateOfNinetyDaysEnd"] ? DateTime.fromISO(_data["dateOfNinetyDaysEnd"].toString()) : <any>undefined;
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.remark = _data["remark"];
            this.personId = _data["personId"];
            this.person = _data["person"] ? EmploymentPersonDto.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfessionalLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["userId"] = this.userId;
        data["professionId"] = this.professionId;
        data["statusId"] = this.statusId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysStart"] = this.dateOfNinetyDaysStart ? this.dateOfNinetyDaysStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysEnd"] = this.dateOfNinetyDaysEnd ? this.dateOfNinetyDaysEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["remark"] = this.remark;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IProfessionalLicenceDto {
    caseId: string | undefined;
    userId: number;
    professionId: string;
    statusId: string;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfNinetyDaysStart: DateTime | undefined;
    dateOfNinetyDaysEnd: DateTime | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    remark: string | undefined;
    personId: number;
    person: EmploymentPersonDto;
    documents: DocumentDto[] | undefined;
    id: number;
}

export class SelectableEmploymentWithPersonDto implements ISelectableEmploymentWithPersonDto {
    isSelected!: boolean;
    id!: number;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    roleId!: string | undefined;
    businessName!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    readonly fullName!: string | undefined;

    constructor(data?: ISelectableEmploymentWithPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSelected = _data["isSelected"];
            this.id = _data["id"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.roleId = _data["roleId"];
            this.businessName = _data["businessName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): SelectableEmploymentWithPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectableEmploymentWithPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSelected"] = this.isSelected;
        data["id"] = this.id;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["roleId"] = this.roleId;
        data["businessName"] = this.businessName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface ISelectableEmploymentWithPersonDto {
    isSelected: boolean;
    id: number;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    roleId: string | undefined;
    businessName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fullName: string | undefined;
}

export class InvoiceAddress implements IInvoiceAddress {
    personId!: number;
    person!: Person;
    name!: string | undefined;
    title!: Code;
    titleId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    addressAddition!: string | undefined;
    postOfficeBox!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    readonly isValid!: boolean;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IInvoiceAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.name = _data["name"];
            this.title = _data["title"] ? Code.fromJS(_data["title"]) : <any>undefined;
            this.titleId = _data["titleId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.addressAddition = _data["addressAddition"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            (<any>this).isValid = _data["isValid"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InvoiceAddress {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["titleId"] = this.titleId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["addressAddition"] = this.addressAddition;
        data["postOfficeBox"] = this.postOfficeBox;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["isValid"] = this.isValid;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IInvoiceAddress {
    personId: number;
    person: Person;
    name: string | undefined;
    title: Code;
    titleId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    addressAddition: string | undefined;
    postOfficeBox: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    isValid: boolean;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class LanguageSkill implements ILanguageSkill {
    personId!: number;
    langSkill!: Code;
    langSkillId!: string;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILanguageSkill) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.langSkill = _data["langSkill"] ? Code.fromJS(_data["langSkill"]) : <any>undefined;
            this.langSkillId = _data["langSkillId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LanguageSkill {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageSkill();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["langSkill"] = this.langSkill ? this.langSkill.toJSON() : <any>undefined;
        data["langSkillId"] = this.langSkillId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILanguageSkill {
    personId: number;
    langSkill: Code;
    langSkillId: string;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class Person implements IPerson {
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    backendSystemId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    birthName!: string | undefined;
    gender!: Code;
    genderId!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    dateOfDeath!: DateTime | undefined;
    nationality1!: Code;
    nationality1Id!: string | undefined;
    nationality2!: Code;
    nationality2Id!: string | undefined;
    placeOfOrigin!: string | undefined;
    gln!: string | undefined;
    ahv!: string | undefined;
    uid!: string | undefined;
    comments!: string | undefined;
    isArchived!: boolean;
    contact!: Contact;
    invoiceAddress!: InvoiceAddress;
    academicTitles!: AcademicTitle[] | undefined;
    orderedSapInvoices!: SapInvoice[] | undefined;
    pendences!: PendenceLinkPerson[] | undefined;
    languageSkills!: LanguageSkill[] | undefined;
    personLicences!: PersonLicence[] | undefined;
    personLicencesForAssistant!: AssistantPersonLicence[] | undefined;
    personLicencesExtraordinaryForAssistant!: ExtraordinaryAssistantPersonLicence[] | undefined;
    personDelegatedLicences!: DelegatedPersonLicence[] | undefined;
    personRepresentationLicences!: RepresentationPersonLicence[] | undefined;
    limitedPersonRepresentationLicences!: LimitedRepresentationPersonLicence[] | undefined;
    corporateLicencesForAssistant!: CorporateLicence[] | undefined;
    employments!: Employment[] | undefined;
    documentLinks!: DocumentLinkPerson[] | undefined;
    diplomas!: Diploma[] | undefined;
    postgraduateTitles!: PostgraduateTitle[] | undefined;
    legitimations!: LegitimationPerson[] | undefined;
    logbooks!: LogbookPerson[] | undefined;
    reminders!: ReminderPerson[] | undefined;
    bankDetails!: BankDetailsPerson;
    educationGrants!: EducationGrants[] | undefined;
    narcoticPrescriptionBlocks!: NarcoticPrescriptionBlock[] | undefined;
    additionalInformations!: AdditionalInformationPerson[] | undefined;
    migrationData!: MigrationData[] | undefined;
    readonly hasValidInvoiceAddress!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.backendSystemId = _data["backendSystemId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.gender = _data["gender"] ? Code.fromJS(_data["gender"]) : <any>undefined;
            this.genderId = _data["genderId"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.dateOfDeath = _data["dateOfDeath"] ? DateTime.fromISO(_data["dateOfDeath"].toString()) : <any>undefined;
            this.nationality1 = _data["nationality1"] ? Code.fromJS(_data["nationality1"]) : <any>undefined;
            this.nationality1Id = _data["nationality1Id"];
            this.nationality2 = _data["nationality2"] ? Code.fromJS(_data["nationality2"]) : <any>undefined;
            this.nationality2Id = _data["nationality2Id"];
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.gln = _data["gln"];
            this.ahv = _data["ahv"];
            this.uid = _data["uid"];
            this.comments = _data["comments"];
            this.isArchived = _data["isArchived"];
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
            this.invoiceAddress = _data["invoiceAddress"] ? InvoiceAddress.fromJS(_data["invoiceAddress"]) : <any>undefined;
            if (Array.isArray(_data["academicTitles"])) {
                this.academicTitles = [] as any;
                for (let item of _data["academicTitles"])
                    this.academicTitles!.push(AcademicTitle.fromJS(item));
            }
            if (Array.isArray(_data["orderedSapInvoices"])) {
                this.orderedSapInvoices = [] as any;
                for (let item of _data["orderedSapInvoices"])
                    this.orderedSapInvoices!.push(SapInvoice.fromJS(item));
            }
            if (Array.isArray(_data["pendences"])) {
                this.pendences = [] as any;
                for (let item of _data["pendences"])
                    this.pendences!.push(PendenceLinkPerson.fromJS(item));
            }
            if (Array.isArray(_data["languageSkills"])) {
                this.languageSkills = [] as any;
                for (let item of _data["languageSkills"])
                    this.languageSkills!.push(LanguageSkill.fromJS(item));
            }
            if (Array.isArray(_data["personLicences"])) {
                this.personLicences = [] as any;
                for (let item of _data["personLicences"])
                    this.personLicences!.push(PersonLicence.fromJS(item));
            }
            if (Array.isArray(_data["personLicencesForAssistant"])) {
                this.personLicencesForAssistant = [] as any;
                for (let item of _data["personLicencesForAssistant"])
                    this.personLicencesForAssistant!.push(AssistantPersonLicence.fromJS(item));
            }
            if (Array.isArray(_data["personLicencesExtraordinaryForAssistant"])) {
                this.personLicencesExtraordinaryForAssistant = [] as any;
                for (let item of _data["personLicencesExtraordinaryForAssistant"])
                    this.personLicencesExtraordinaryForAssistant!.push(ExtraordinaryAssistantPersonLicence.fromJS(item));
            }
            if (Array.isArray(_data["personDelegatedLicences"])) {
                this.personDelegatedLicences = [] as any;
                for (let item of _data["personDelegatedLicences"])
                    this.personDelegatedLicences!.push(DelegatedPersonLicence.fromJS(item));
            }
            if (Array.isArray(_data["personRepresentationLicences"])) {
                this.personRepresentationLicences = [] as any;
                for (let item of _data["personRepresentationLicences"])
                    this.personRepresentationLicences!.push(RepresentationPersonLicence.fromJS(item));
            }
            if (Array.isArray(_data["limitedPersonRepresentationLicences"])) {
                this.limitedPersonRepresentationLicences = [] as any;
                for (let item of _data["limitedPersonRepresentationLicences"])
                    this.limitedPersonRepresentationLicences!.push(LimitedRepresentationPersonLicence.fromJS(item));
            }
            if (Array.isArray(_data["corporateLicencesForAssistant"])) {
                this.corporateLicencesForAssistant = [] as any;
                for (let item of _data["corporateLicencesForAssistant"])
                    this.corporateLicencesForAssistant!.push(CorporateLicence.fromJS(item));
            }
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(Employment.fromJS(item));
            }
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkPerson.fromJS(item));
            }
            if (Array.isArray(_data["diplomas"])) {
                this.diplomas = [] as any;
                for (let item of _data["diplomas"])
                    this.diplomas!.push(Diploma.fromJS(item));
            }
            if (Array.isArray(_data["postgraduateTitles"])) {
                this.postgraduateTitles = [] as any;
                for (let item of _data["postgraduateTitles"])
                    this.postgraduateTitles!.push(PostgraduateTitle.fromJS(item));
            }
            if (Array.isArray(_data["legitimations"])) {
                this.legitimations = [] as any;
                for (let item of _data["legitimations"])
                    this.legitimations!.push(LegitimationPerson.fromJS(item));
            }
            if (Array.isArray(_data["logbooks"])) {
                this.logbooks = [] as any;
                for (let item of _data["logbooks"])
                    this.logbooks!.push(LogbookPerson.fromJS(item));
            }
            if (Array.isArray(_data["reminders"])) {
                this.reminders = [] as any;
                for (let item of _data["reminders"])
                    this.reminders!.push(ReminderPerson.fromJS(item));
            }
            this.bankDetails = _data["bankDetails"] ? BankDetailsPerson.fromJS(_data["bankDetails"]) : <any>undefined;
            if (Array.isArray(_data["educationGrants"])) {
                this.educationGrants = [] as any;
                for (let item of _data["educationGrants"])
                    this.educationGrants!.push(EducationGrants.fromJS(item));
            }
            if (Array.isArray(_data["narcoticPrescriptionBlocks"])) {
                this.narcoticPrescriptionBlocks = [] as any;
                for (let item of _data["narcoticPrescriptionBlocks"])
                    this.narcoticPrescriptionBlocks!.push(NarcoticPrescriptionBlock.fromJS(item));
            }
            if (Array.isArray(_data["additionalInformations"])) {
                this.additionalInformations = [] as any;
                for (let item of _data["additionalInformations"])
                    this.additionalInformations!.push(AdditionalInformationPerson.fromJS(item));
            }
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            (<any>this).hasValidInvoiceAddress = _data["hasValidInvoiceAddress"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Person {
        data = typeof data === 'object' ? data : {};
        let result = new Person();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["backendSystemId"] = this.backendSystemId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["genderId"] = this.genderId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDeath"] = this.dateOfDeath ? this.dateOfDeath.toFormat('yyyy-MM-dd') : <any>undefined;
        data["nationality1"] = this.nationality1 ? this.nationality1.toJSON() : <any>undefined;
        data["nationality1Id"] = this.nationality1Id;
        data["nationality2"] = this.nationality2 ? this.nationality2.toJSON() : <any>undefined;
        data["nationality2Id"] = this.nationality2Id;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["gln"] = this.gln;
        data["ahv"] = this.ahv;
        data["uid"] = this.uid;
        data["comments"] = this.comments;
        data["isArchived"] = this.isArchived;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["invoiceAddress"] = this.invoiceAddress ? this.invoiceAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.academicTitles)) {
            data["academicTitles"] = [];
            for (let item of this.academicTitles)
                data["academicTitles"].push(item.toJSON());
        }
        if (Array.isArray(this.orderedSapInvoices)) {
            data["orderedSapInvoices"] = [];
            for (let item of this.orderedSapInvoices)
                data["orderedSapInvoices"].push(item.toJSON());
        }
        if (Array.isArray(this.pendences)) {
            data["pendences"] = [];
            for (let item of this.pendences)
                data["pendences"].push(item.toJSON());
        }
        if (Array.isArray(this.languageSkills)) {
            data["languageSkills"] = [];
            for (let item of this.languageSkills)
                data["languageSkills"].push(item.toJSON());
        }
        if (Array.isArray(this.personLicences)) {
            data["personLicences"] = [];
            for (let item of this.personLicences)
                data["personLicences"].push(item.toJSON());
        }
        if (Array.isArray(this.personLicencesForAssistant)) {
            data["personLicencesForAssistant"] = [];
            for (let item of this.personLicencesForAssistant)
                data["personLicencesForAssistant"].push(item.toJSON());
        }
        if (Array.isArray(this.personLicencesExtraordinaryForAssistant)) {
            data["personLicencesExtraordinaryForAssistant"] = [];
            for (let item of this.personLicencesExtraordinaryForAssistant)
                data["personLicencesExtraordinaryForAssistant"].push(item.toJSON());
        }
        if (Array.isArray(this.personDelegatedLicences)) {
            data["personDelegatedLicences"] = [];
            for (let item of this.personDelegatedLicences)
                data["personDelegatedLicences"].push(item.toJSON());
        }
        if (Array.isArray(this.personRepresentationLicences)) {
            data["personRepresentationLicences"] = [];
            for (let item of this.personRepresentationLicences)
                data["personRepresentationLicences"].push(item.toJSON());
        }
        if (Array.isArray(this.limitedPersonRepresentationLicences)) {
            data["limitedPersonRepresentationLicences"] = [];
            for (let item of this.limitedPersonRepresentationLicences)
                data["limitedPersonRepresentationLicences"].push(item.toJSON());
        }
        if (Array.isArray(this.corporateLicencesForAssistant)) {
            data["corporateLicencesForAssistant"] = [];
            for (let item of this.corporateLicencesForAssistant)
                data["corporateLicencesForAssistant"].push(item.toJSON());
        }
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.diplomas)) {
            data["diplomas"] = [];
            for (let item of this.diplomas)
                data["diplomas"].push(item.toJSON());
        }
        if (Array.isArray(this.postgraduateTitles)) {
            data["postgraduateTitles"] = [];
            for (let item of this.postgraduateTitles)
                data["postgraduateTitles"].push(item.toJSON());
        }
        if (Array.isArray(this.legitimations)) {
            data["legitimations"] = [];
            for (let item of this.legitimations)
                data["legitimations"].push(item.toJSON());
        }
        if (Array.isArray(this.logbooks)) {
            data["logbooks"] = [];
            for (let item of this.logbooks)
                data["logbooks"].push(item.toJSON());
        }
        if (Array.isArray(this.reminders)) {
            data["reminders"] = [];
            for (let item of this.reminders)
                data["reminders"].push(item.toJSON());
        }
        data["bankDetails"] = this.bankDetails ? this.bankDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.educationGrants)) {
            data["educationGrants"] = [];
            for (let item of this.educationGrants)
                data["educationGrants"].push(item.toJSON());
        }
        if (Array.isArray(this.narcoticPrescriptionBlocks)) {
            data["narcoticPrescriptionBlocks"] = [];
            for (let item of this.narcoticPrescriptionBlocks)
                data["narcoticPrescriptionBlocks"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalInformations)) {
            data["additionalInformations"] = [];
            for (let item of this.additionalInformations)
                data["additionalInformations"].push(item.toJSON());
        }
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["hasValidInvoiceAddress"] = this.hasValidInvoiceAddress;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPerson {
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    backendSystemId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    birthName: string | undefined;
    gender: Code;
    genderId: string | undefined;
    dateOfBirth: DateTime | undefined;
    dateOfDeath: DateTime | undefined;
    nationality1: Code;
    nationality1Id: string | undefined;
    nationality2: Code;
    nationality2Id: string | undefined;
    placeOfOrigin: string | undefined;
    gln: string | undefined;
    ahv: string | undefined;
    uid: string | undefined;
    comments: string | undefined;
    isArchived: boolean;
    contact: Contact;
    invoiceAddress: InvoiceAddress;
    academicTitles: AcademicTitle[] | undefined;
    orderedSapInvoices: SapInvoice[] | undefined;
    pendences: PendenceLinkPerson[] | undefined;
    languageSkills: LanguageSkill[] | undefined;
    personLicences: PersonLicence[] | undefined;
    personLicencesForAssistant: AssistantPersonLicence[] | undefined;
    personLicencesExtraordinaryForAssistant: ExtraordinaryAssistantPersonLicence[] | undefined;
    personDelegatedLicences: DelegatedPersonLicence[] | undefined;
    personRepresentationLicences: RepresentationPersonLicence[] | undefined;
    limitedPersonRepresentationLicences: LimitedRepresentationPersonLicence[] | undefined;
    corporateLicencesForAssistant: CorporateLicence[] | undefined;
    employments: Employment[] | undefined;
    documentLinks: DocumentLinkPerson[] | undefined;
    diplomas: Diploma[] | undefined;
    postgraduateTitles: PostgraduateTitle[] | undefined;
    legitimations: LegitimationPerson[] | undefined;
    logbooks: LogbookPerson[] | undefined;
    reminders: ReminderPerson[] | undefined;
    bankDetails: BankDetailsPerson;
    educationGrants: EducationGrants[] | undefined;
    narcoticPrescriptionBlocks: NarcoticPrescriptionBlock[] | undefined;
    additionalInformations: AdditionalInformationPerson[] | undefined;
    migrationData: MigrationData[] | undefined;
    hasValidInvoiceAddress: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class GetPersonDossierSearchOutput implements IGetPersonDossierSearchOutput {
    totalCount!: number;
    items!: PersonDossierSearchDto[] | undefined;

    constructor(data?: IGetPersonDossierSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PersonDossierSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPersonDossierSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonDossierSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPersonDossierSearchOutput {
    totalCount: number;
    items: PersonDossierSearchDto[] | undefined;
}

export class PersonDossierSearchDto implements IPersonDossierSearchDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    fullName!: string | undefined;
    birthName!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    professionIds!: string | undefined;
    genderId!: string | undefined;
    gln!: string | undefined;
    ahv!: string | undefined;
    email!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    isArchived!: boolean;
    id!: number;

    constructor(data?: IPersonDossierSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.birthName = _data["birthName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.professionIds = _data["professionIds"];
            this.genderId = _data["genderId"];
            this.gln = _data["gln"];
            this.ahv = _data["ahv"];
            this.email = _data["email"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.isArchived = _data["isArchived"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PersonDossierSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonDossierSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["birthName"] = this.birthName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["professionIds"] = this.professionIds;
        data["genderId"] = this.genderId;
        data["gln"] = this.gln;
        data["ahv"] = this.ahv;
        data["email"] = this.email;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["isArchived"] = this.isArchived;
        data["id"] = this.id;
        return data;
    }
}

export interface IPersonDossierSearchDto {
    firstName: string | undefined;
    lastName: string | undefined;
    fullName: string | undefined;
    birthName: string | undefined;
    dateOfBirth: DateTime | undefined;
    professionIds: string | undefined;
    genderId: string | undefined;
    gln: string | undefined;
    ahv: string | undefined;
    email: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    isArchived: boolean;
    id: number;
}

export class PersonDossierSummaryDto implements IPersonDossierSummaryDto {
    id!: number;
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    backendSystemId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    birthName!: string | undefined;
    genderId!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    dateOfDeath!: DateTime | undefined;
    nationality1Id!: string | undefined;
    nationality2Id!: string | undefined;
    placeOfOrigin!: string | undefined;
    gln!: string | undefined;
    ahv!: string | undefined;
    uid!: string | undefined;
    isArchived!: boolean;
    contactStreet!: string | undefined;
    contactStreetNr!: string | undefined;
    contactPostOfficeBox!: string | undefined;
    contactPostCode!: string | undefined;
    contactCity!: string | undefined;
    contactCountryId!: string | undefined;
    contactEmail!: string | undefined;
    contactPhone1!: string | undefined;
    contactPhone2!: string | undefined;
    invoiceAddressStreet!: string | undefined;
    invoiceAddressStreetNr!: string | undefined;
    invoiceAddressPostOfficeBox!: string | undefined;
    invoiceAddressPostCode!: string | undefined;
    invoiceAddressCity!: string | undefined;
    invoiceAddressCountryId!: string | undefined;
    invoiceAddressEmail!: string | undefined;

    constructor(data?: IPersonDossierSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.backendSystemId = _data["backendSystemId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.genderId = _data["genderId"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.dateOfDeath = _data["dateOfDeath"] ? DateTime.fromISO(_data["dateOfDeath"].toString()) : <any>undefined;
            this.nationality1Id = _data["nationality1Id"];
            this.nationality2Id = _data["nationality2Id"];
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.gln = _data["gln"];
            this.ahv = _data["ahv"];
            this.uid = _data["uid"];
            this.isArchived = _data["isArchived"];
            this.contactStreet = _data["contactStreet"];
            this.contactStreetNr = _data["contactStreetNr"];
            this.contactPostOfficeBox = _data["contactPostOfficeBox"];
            this.contactPostCode = _data["contactPostCode"];
            this.contactCity = _data["contactCity"];
            this.contactCountryId = _data["contactCountryId"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone1 = _data["contactPhone1"];
            this.contactPhone2 = _data["contactPhone2"];
            this.invoiceAddressStreet = _data["invoiceAddressStreet"];
            this.invoiceAddressStreetNr = _data["invoiceAddressStreetNr"];
            this.invoiceAddressPostOfficeBox = _data["invoiceAddressPostOfficeBox"];
            this.invoiceAddressPostCode = _data["invoiceAddressPostCode"];
            this.invoiceAddressCity = _data["invoiceAddressCity"];
            this.invoiceAddressCountryId = _data["invoiceAddressCountryId"];
            this.invoiceAddressEmail = _data["invoiceAddressEmail"];
        }
    }

    static fromJS(data: any): PersonDossierSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonDossierSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["backendSystemId"] = this.backendSystemId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["genderId"] = this.genderId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDeath"] = this.dateOfDeath ? this.dateOfDeath.toFormat('yyyy-MM-dd') : <any>undefined;
        data["nationality1Id"] = this.nationality1Id;
        data["nationality2Id"] = this.nationality2Id;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["gln"] = this.gln;
        data["ahv"] = this.ahv;
        data["uid"] = this.uid;
        data["isArchived"] = this.isArchived;
        data["contactStreet"] = this.contactStreet;
        data["contactStreetNr"] = this.contactStreetNr;
        data["contactPostOfficeBox"] = this.contactPostOfficeBox;
        data["contactPostCode"] = this.contactPostCode;
        data["contactCity"] = this.contactCity;
        data["contactCountryId"] = this.contactCountryId;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone1"] = this.contactPhone1;
        data["contactPhone2"] = this.contactPhone2;
        data["invoiceAddressStreet"] = this.invoiceAddressStreet;
        data["invoiceAddressStreetNr"] = this.invoiceAddressStreetNr;
        data["invoiceAddressPostOfficeBox"] = this.invoiceAddressPostOfficeBox;
        data["invoiceAddressPostCode"] = this.invoiceAddressPostCode;
        data["invoiceAddressCity"] = this.invoiceAddressCity;
        data["invoiceAddressCountryId"] = this.invoiceAddressCountryId;
        data["invoiceAddressEmail"] = this.invoiceAddressEmail;
        return data;
    }
}

export interface IPersonDossierSummaryDto {
    id: number;
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    backendSystemId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    birthName: string | undefined;
    genderId: string | undefined;
    dateOfBirth: DateTime | undefined;
    dateOfDeath: DateTime | undefined;
    nationality1Id: string | undefined;
    nationality2Id: string | undefined;
    placeOfOrigin: string | undefined;
    gln: string | undefined;
    ahv: string | undefined;
    uid: string | undefined;
    isArchived: boolean;
    contactStreet: string | undefined;
    contactStreetNr: string | undefined;
    contactPostOfficeBox: string | undefined;
    contactPostCode: string | undefined;
    contactCity: string | undefined;
    contactCountryId: string | undefined;
    contactEmail: string | undefined;
    contactPhone1: string | undefined;
    contactPhone2: string | undefined;
    invoiceAddressStreet: string | undefined;
    invoiceAddressStreetNr: string | undefined;
    invoiceAddressPostOfficeBox: string | undefined;
    invoiceAddressPostCode: string | undefined;
    invoiceAddressCity: string | undefined;
    invoiceAddressCountryId: string | undefined;
    invoiceAddressEmail: string | undefined;
}

export class AssistantPersonLicence implements IAssistantPersonLicence {
    assistantPerson!: Person;
    assistantPersonId!: number | undefined;
    dateOfAssistanceStart!: DateTime | undefined;
    dateOfProvisoryAssistanceEnd!: DateTime | undefined;
    levelOfWork!: number | undefined;
    assistanceBusiness!: Business;
    assistanceBusinessId!: number | undefined;
    discriminator!: PersonLicenceType;
    person!: Person;
    personId!: number;
    naturalKey!: string;
    professionId!: string | undefined;
    postgraduateTitleId!: string | undefined;
    statusId!: string | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfNinetyDaysStart!: DateTime | undefined;
    dateOfNinetyDaysEnd!: DateTime | undefined;
    remark!: string | undefined;
    authorisationNarcoticId!: string | undefined;
    authorisationNarcoticRemarks!: string | undefined;
    healthRegisterTransfer!: boolean;
    healthRegisterSync!: DateTime | undefined;
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    licencedBusiness!: Business;
    licencedBusinessId!: number | undefined;
    sapInvoice!: SapInvoice;
    sapInvoiceId!: number | undefined;
    automaticNotificationAndStatusChange!: boolean;
    vaccinationLicenceId!: string | undefined;
    dateOfIssueVaccinationLicence!: DateTime | undefined;
    dateOfEndNotification1Sent!: DateTime | undefined;
    dateOfEndNotification2Sent!: DateTime | undefined;
    dateOfPendenceCreated!: DateTime | undefined;
    employments!: Employment[] | undefined;
    restrictions!: Restriction[] | undefined;
    renewals!: ProfessionalLicenceRenewal[] | undefined;
    documentLinks!: DocumentLinkPersonLicence[] | undefined;
    additionalLicenceInformations!: AdditionalInformationPersonLicence[] | undefined;
    professionalResponsibilities!: ProfessionalResponsibility[] | undefined;
    quarterlyReports!: QuarterlyReport[] | undefined;
    application!: Application;
    applicationId!: number | undefined;
    ehcTypeId!: string | undefined;
    details!: PersonLicenceDetails[] | undefined;
    readonly isFinalDecision!: boolean;
    migrationData!: MigrationData[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IAssistantPersonLicence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assistantPerson = _data["assistantPerson"] ? Person.fromJS(_data["assistantPerson"]) : <any>undefined;
            this.assistantPersonId = _data["assistantPersonId"];
            this.dateOfAssistanceStart = _data["dateOfAssistanceStart"] ? DateTime.fromISO(_data["dateOfAssistanceStart"].toString()) : <any>undefined;
            this.dateOfProvisoryAssistanceEnd = _data["dateOfProvisoryAssistanceEnd"] ? DateTime.fromISO(_data["dateOfProvisoryAssistanceEnd"].toString()) : <any>undefined;
            this.levelOfWork = _data["levelOfWork"];
            this.assistanceBusiness = _data["assistanceBusiness"] ? Business.fromJS(_data["assistanceBusiness"]) : <any>undefined;
            this.assistanceBusinessId = _data["assistanceBusinessId"];
            this.discriminator = _data["discriminator"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.personId = _data["personId"];
            this.naturalKey = _data["naturalKey"];
            this.professionId = _data["professionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.statusId = _data["statusId"];
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfNinetyDaysStart = _data["dateOfNinetyDaysStart"] ? DateTime.fromISO(_data["dateOfNinetyDaysStart"].toString()) : <any>undefined;
            this.dateOfNinetyDaysEnd = _data["dateOfNinetyDaysEnd"] ? DateTime.fromISO(_data["dateOfNinetyDaysEnd"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.authorisationNarcoticId = _data["authorisationNarcoticId"];
            this.authorisationNarcoticRemarks = _data["authorisationNarcoticRemarks"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.healthRegisterSync = _data["healthRegisterSync"] ? DateTime.fromISO(_data["healthRegisterSync"].toString()) : <any>undefined;
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.licencedBusiness = _data["licencedBusiness"] ? Business.fromJS(_data["licencedBusiness"]) : <any>undefined;
            this.licencedBusinessId = _data["licencedBusinessId"];
            this.sapInvoice = _data["sapInvoice"] ? SapInvoice.fromJS(_data["sapInvoice"]) : <any>undefined;
            this.sapInvoiceId = _data["sapInvoiceId"];
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.vaccinationLicenceId = _data["vaccinationLicenceId"];
            this.dateOfIssueVaccinationLicence = _data["dateOfIssueVaccinationLicence"] ? DateTime.fromISO(_data["dateOfIssueVaccinationLicence"].toString()) : <any>undefined;
            this.dateOfEndNotification1Sent = _data["dateOfEndNotification1Sent"] ? DateTime.fromISO(_data["dateOfEndNotification1Sent"].toString()) : <any>undefined;
            this.dateOfEndNotification2Sent = _data["dateOfEndNotification2Sent"] ? DateTime.fromISO(_data["dateOfEndNotification2Sent"].toString()) : <any>undefined;
            this.dateOfPendenceCreated = _data["dateOfPendenceCreated"] ? DateTime.fromISO(_data["dateOfPendenceCreated"].toString()) : <any>undefined;
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(Employment.fromJS(item));
            }
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(Restriction.fromJS(item));
            }
            if (Array.isArray(_data["renewals"])) {
                this.renewals = [] as any;
                for (let item of _data["renewals"])
                    this.renewals!.push(ProfessionalLicenceRenewal.fromJS(item));
            }
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkPersonLicence.fromJS(item));
            }
            if (Array.isArray(_data["additionalLicenceInformations"])) {
                this.additionalLicenceInformations = [] as any;
                for (let item of _data["additionalLicenceInformations"])
                    this.additionalLicenceInformations!.push(AdditionalInformationPersonLicence.fromJS(item));
            }
            if (Array.isArray(_data["professionalResponsibilities"])) {
                this.professionalResponsibilities = [] as any;
                for (let item of _data["professionalResponsibilities"])
                    this.professionalResponsibilities!.push(ProfessionalResponsibility.fromJS(item));
            }
            if (Array.isArray(_data["quarterlyReports"])) {
                this.quarterlyReports = [] as any;
                for (let item of _data["quarterlyReports"])
                    this.quarterlyReports!.push(QuarterlyReport.fromJS(item));
            }
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : <any>undefined;
            this.applicationId = _data["applicationId"];
            this.ehcTypeId = _data["ehcTypeId"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(PersonLicenceDetails.fromJS(item));
            }
            (<any>this).isFinalDecision = _data["isFinalDecision"];
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssistantPersonLicence {
        data = typeof data === 'object' ? data : {};
        let result = new AssistantPersonLicence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistantPerson"] = this.assistantPerson ? this.assistantPerson.toJSON() : <any>undefined;
        data["assistantPersonId"] = this.assistantPersonId;
        data["dateOfAssistanceStart"] = this.dateOfAssistanceStart ? this.dateOfAssistanceStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfProvisoryAssistanceEnd"] = this.dateOfProvisoryAssistanceEnd ? this.dateOfProvisoryAssistanceEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfWork"] = this.levelOfWork;
        data["assistanceBusiness"] = this.assistanceBusiness ? this.assistanceBusiness.toJSON() : <any>undefined;
        data["assistanceBusinessId"] = this.assistanceBusinessId;
        data["discriminator"] = this.discriminator;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["naturalKey"] = this.naturalKey;
        data["professionId"] = this.professionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["statusId"] = this.statusId;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysStart"] = this.dateOfNinetyDaysStart ? this.dateOfNinetyDaysStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysEnd"] = this.dateOfNinetyDaysEnd ? this.dateOfNinetyDaysEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["authorisationNarcoticId"] = this.authorisationNarcoticId;
        data["authorisationNarcoticRemarks"] = this.authorisationNarcoticRemarks;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["healthRegisterSync"] = this.healthRegisterSync ? this.healthRegisterSync.toString() : <any>undefined;
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["licencedBusiness"] = this.licencedBusiness ? this.licencedBusiness.toJSON() : <any>undefined;
        data["licencedBusinessId"] = this.licencedBusinessId;
        data["sapInvoice"] = this.sapInvoice ? this.sapInvoice.toJSON() : <any>undefined;
        data["sapInvoiceId"] = this.sapInvoiceId;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["vaccinationLicenceId"] = this.vaccinationLicenceId;
        data["dateOfIssueVaccinationLicence"] = this.dateOfIssueVaccinationLicence ? this.dateOfIssueVaccinationLicence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndNotification1Sent"] = this.dateOfEndNotification1Sent ? this.dateOfEndNotification1Sent.toString() : <any>undefined;
        data["dateOfEndNotification2Sent"] = this.dateOfEndNotification2Sent ? this.dateOfEndNotification2Sent.toString() : <any>undefined;
        data["dateOfPendenceCreated"] = this.dateOfPendenceCreated ? this.dateOfPendenceCreated.toString() : <any>undefined;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        if (Array.isArray(this.renewals)) {
            data["renewals"] = [];
            for (let item of this.renewals)
                data["renewals"].push(item.toJSON());
        }
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalLicenceInformations)) {
            data["additionalLicenceInformations"] = [];
            for (let item of this.additionalLicenceInformations)
                data["additionalLicenceInformations"].push(item.toJSON());
        }
        if (Array.isArray(this.professionalResponsibilities)) {
            data["professionalResponsibilities"] = [];
            for (let item of this.professionalResponsibilities)
                data["professionalResponsibilities"].push(item.toJSON());
        }
        if (Array.isArray(this.quarterlyReports)) {
            data["quarterlyReports"] = [];
            for (let item of this.quarterlyReports)
                data["quarterlyReports"].push(item.toJSON());
        }
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["applicationId"] = this.applicationId;
        data["ehcTypeId"] = this.ehcTypeId;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["isFinalDecision"] = this.isFinalDecision;
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAssistantPersonLicence {
    assistantPerson: Person;
    assistantPersonId: number | undefined;
    dateOfAssistanceStart: DateTime | undefined;
    dateOfProvisoryAssistanceEnd: DateTime | undefined;
    levelOfWork: number | undefined;
    assistanceBusiness: Business;
    assistanceBusinessId: number | undefined;
    discriminator: PersonLicenceType;
    person: Person;
    personId: number;
    naturalKey: string;
    professionId: string | undefined;
    postgraduateTitleId: string | undefined;
    statusId: string | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfNinetyDaysStart: DateTime | undefined;
    dateOfNinetyDaysEnd: DateTime | undefined;
    remark: string | undefined;
    authorisationNarcoticId: string | undefined;
    authorisationNarcoticRemarks: string | undefined;
    healthRegisterTransfer: boolean;
    healthRegisterSync: DateTime | undefined;
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    licencedBusiness: Business;
    licencedBusinessId: number | undefined;
    sapInvoice: SapInvoice;
    sapInvoiceId: number | undefined;
    automaticNotificationAndStatusChange: boolean;
    vaccinationLicenceId: string | undefined;
    dateOfIssueVaccinationLicence: DateTime | undefined;
    dateOfEndNotification1Sent: DateTime | undefined;
    dateOfEndNotification2Sent: DateTime | undefined;
    dateOfPendenceCreated: DateTime | undefined;
    employments: Employment[] | undefined;
    restrictions: Restriction[] | undefined;
    renewals: ProfessionalLicenceRenewal[] | undefined;
    documentLinks: DocumentLinkPersonLicence[] | undefined;
    additionalLicenceInformations: AdditionalInformationPersonLicence[] | undefined;
    professionalResponsibilities: ProfessionalResponsibility[] | undefined;
    quarterlyReports: QuarterlyReport[] | undefined;
    application: Application;
    applicationId: number | undefined;
    ehcTypeId: string | undefined;
    details: PersonLicenceDetails[] | undefined;
    isFinalDecision: boolean;
    migrationData: MigrationData[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ExtraordinaryAssistantPersonLicence implements IExtraordinaryAssistantPersonLicence {
    extraordinaryAssistantPerson!: Person;
    extraordinaryAssistantPersonId!: number | undefined;
    discriminator!: PersonLicenceType;
    person!: Person;
    personId!: number;
    naturalKey!: string;
    professionId!: string | undefined;
    postgraduateTitleId!: string | undefined;
    statusId!: string | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfNinetyDaysStart!: DateTime | undefined;
    dateOfNinetyDaysEnd!: DateTime | undefined;
    remark!: string | undefined;
    authorisationNarcoticId!: string | undefined;
    authorisationNarcoticRemarks!: string | undefined;
    healthRegisterTransfer!: boolean;
    healthRegisterSync!: DateTime | undefined;
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    licencedBusiness!: Business;
    licencedBusinessId!: number | undefined;
    sapInvoice!: SapInvoice;
    sapInvoiceId!: number | undefined;
    automaticNotificationAndStatusChange!: boolean;
    vaccinationLicenceId!: string | undefined;
    dateOfIssueVaccinationLicence!: DateTime | undefined;
    dateOfEndNotification1Sent!: DateTime | undefined;
    dateOfEndNotification2Sent!: DateTime | undefined;
    dateOfPendenceCreated!: DateTime | undefined;
    employments!: Employment[] | undefined;
    restrictions!: Restriction[] | undefined;
    renewals!: ProfessionalLicenceRenewal[] | undefined;
    documentLinks!: DocumentLinkPersonLicence[] | undefined;
    additionalLicenceInformations!: AdditionalInformationPersonLicence[] | undefined;
    professionalResponsibilities!: ProfessionalResponsibility[] | undefined;
    quarterlyReports!: QuarterlyReport[] | undefined;
    application!: Application;
    applicationId!: number | undefined;
    ehcTypeId!: string | undefined;
    details!: PersonLicenceDetails[] | undefined;
    readonly isFinalDecision!: boolean;
    migrationData!: MigrationData[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IExtraordinaryAssistantPersonLicence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extraordinaryAssistantPerson = _data["extraordinaryAssistantPerson"] ? Person.fromJS(_data["extraordinaryAssistantPerson"]) : <any>undefined;
            this.extraordinaryAssistantPersonId = _data["extraordinaryAssistantPersonId"];
            this.discriminator = _data["discriminator"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.personId = _data["personId"];
            this.naturalKey = _data["naturalKey"];
            this.professionId = _data["professionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.statusId = _data["statusId"];
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfNinetyDaysStart = _data["dateOfNinetyDaysStart"] ? DateTime.fromISO(_data["dateOfNinetyDaysStart"].toString()) : <any>undefined;
            this.dateOfNinetyDaysEnd = _data["dateOfNinetyDaysEnd"] ? DateTime.fromISO(_data["dateOfNinetyDaysEnd"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.authorisationNarcoticId = _data["authorisationNarcoticId"];
            this.authorisationNarcoticRemarks = _data["authorisationNarcoticRemarks"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.healthRegisterSync = _data["healthRegisterSync"] ? DateTime.fromISO(_data["healthRegisterSync"].toString()) : <any>undefined;
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.licencedBusiness = _data["licencedBusiness"] ? Business.fromJS(_data["licencedBusiness"]) : <any>undefined;
            this.licencedBusinessId = _data["licencedBusinessId"];
            this.sapInvoice = _data["sapInvoice"] ? SapInvoice.fromJS(_data["sapInvoice"]) : <any>undefined;
            this.sapInvoiceId = _data["sapInvoiceId"];
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.vaccinationLicenceId = _data["vaccinationLicenceId"];
            this.dateOfIssueVaccinationLicence = _data["dateOfIssueVaccinationLicence"] ? DateTime.fromISO(_data["dateOfIssueVaccinationLicence"].toString()) : <any>undefined;
            this.dateOfEndNotification1Sent = _data["dateOfEndNotification1Sent"] ? DateTime.fromISO(_data["dateOfEndNotification1Sent"].toString()) : <any>undefined;
            this.dateOfEndNotification2Sent = _data["dateOfEndNotification2Sent"] ? DateTime.fromISO(_data["dateOfEndNotification2Sent"].toString()) : <any>undefined;
            this.dateOfPendenceCreated = _data["dateOfPendenceCreated"] ? DateTime.fromISO(_data["dateOfPendenceCreated"].toString()) : <any>undefined;
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(Employment.fromJS(item));
            }
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(Restriction.fromJS(item));
            }
            if (Array.isArray(_data["renewals"])) {
                this.renewals = [] as any;
                for (let item of _data["renewals"])
                    this.renewals!.push(ProfessionalLicenceRenewal.fromJS(item));
            }
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkPersonLicence.fromJS(item));
            }
            if (Array.isArray(_data["additionalLicenceInformations"])) {
                this.additionalLicenceInformations = [] as any;
                for (let item of _data["additionalLicenceInformations"])
                    this.additionalLicenceInformations!.push(AdditionalInformationPersonLicence.fromJS(item));
            }
            if (Array.isArray(_data["professionalResponsibilities"])) {
                this.professionalResponsibilities = [] as any;
                for (let item of _data["professionalResponsibilities"])
                    this.professionalResponsibilities!.push(ProfessionalResponsibility.fromJS(item));
            }
            if (Array.isArray(_data["quarterlyReports"])) {
                this.quarterlyReports = [] as any;
                for (let item of _data["quarterlyReports"])
                    this.quarterlyReports!.push(QuarterlyReport.fromJS(item));
            }
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : <any>undefined;
            this.applicationId = _data["applicationId"];
            this.ehcTypeId = _data["ehcTypeId"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(PersonLicenceDetails.fromJS(item));
            }
            (<any>this).isFinalDecision = _data["isFinalDecision"];
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExtraordinaryAssistantPersonLicence {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraordinaryAssistantPersonLicence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extraordinaryAssistantPerson"] = this.extraordinaryAssistantPerson ? this.extraordinaryAssistantPerson.toJSON() : <any>undefined;
        data["extraordinaryAssistantPersonId"] = this.extraordinaryAssistantPersonId;
        data["discriminator"] = this.discriminator;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["naturalKey"] = this.naturalKey;
        data["professionId"] = this.professionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["statusId"] = this.statusId;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysStart"] = this.dateOfNinetyDaysStart ? this.dateOfNinetyDaysStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysEnd"] = this.dateOfNinetyDaysEnd ? this.dateOfNinetyDaysEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["authorisationNarcoticId"] = this.authorisationNarcoticId;
        data["authorisationNarcoticRemarks"] = this.authorisationNarcoticRemarks;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["healthRegisterSync"] = this.healthRegisterSync ? this.healthRegisterSync.toString() : <any>undefined;
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["licencedBusiness"] = this.licencedBusiness ? this.licencedBusiness.toJSON() : <any>undefined;
        data["licencedBusinessId"] = this.licencedBusinessId;
        data["sapInvoice"] = this.sapInvoice ? this.sapInvoice.toJSON() : <any>undefined;
        data["sapInvoiceId"] = this.sapInvoiceId;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["vaccinationLicenceId"] = this.vaccinationLicenceId;
        data["dateOfIssueVaccinationLicence"] = this.dateOfIssueVaccinationLicence ? this.dateOfIssueVaccinationLicence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndNotification1Sent"] = this.dateOfEndNotification1Sent ? this.dateOfEndNotification1Sent.toString() : <any>undefined;
        data["dateOfEndNotification2Sent"] = this.dateOfEndNotification2Sent ? this.dateOfEndNotification2Sent.toString() : <any>undefined;
        data["dateOfPendenceCreated"] = this.dateOfPendenceCreated ? this.dateOfPendenceCreated.toString() : <any>undefined;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        if (Array.isArray(this.renewals)) {
            data["renewals"] = [];
            for (let item of this.renewals)
                data["renewals"].push(item.toJSON());
        }
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalLicenceInformations)) {
            data["additionalLicenceInformations"] = [];
            for (let item of this.additionalLicenceInformations)
                data["additionalLicenceInformations"].push(item.toJSON());
        }
        if (Array.isArray(this.professionalResponsibilities)) {
            data["professionalResponsibilities"] = [];
            for (let item of this.professionalResponsibilities)
                data["professionalResponsibilities"].push(item.toJSON());
        }
        if (Array.isArray(this.quarterlyReports)) {
            data["quarterlyReports"] = [];
            for (let item of this.quarterlyReports)
                data["quarterlyReports"].push(item.toJSON());
        }
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["applicationId"] = this.applicationId;
        data["ehcTypeId"] = this.ehcTypeId;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["isFinalDecision"] = this.isFinalDecision;
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IExtraordinaryAssistantPersonLicence {
    extraordinaryAssistantPerson: Person;
    extraordinaryAssistantPersonId: number | undefined;
    discriminator: PersonLicenceType;
    person: Person;
    personId: number;
    naturalKey: string;
    professionId: string | undefined;
    postgraduateTitleId: string | undefined;
    statusId: string | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfNinetyDaysStart: DateTime | undefined;
    dateOfNinetyDaysEnd: DateTime | undefined;
    remark: string | undefined;
    authorisationNarcoticId: string | undefined;
    authorisationNarcoticRemarks: string | undefined;
    healthRegisterTransfer: boolean;
    healthRegisterSync: DateTime | undefined;
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    licencedBusiness: Business;
    licencedBusinessId: number | undefined;
    sapInvoice: SapInvoice;
    sapInvoiceId: number | undefined;
    automaticNotificationAndStatusChange: boolean;
    vaccinationLicenceId: string | undefined;
    dateOfIssueVaccinationLicence: DateTime | undefined;
    dateOfEndNotification1Sent: DateTime | undefined;
    dateOfEndNotification2Sent: DateTime | undefined;
    dateOfPendenceCreated: DateTime | undefined;
    employments: Employment[] | undefined;
    restrictions: Restriction[] | undefined;
    renewals: ProfessionalLicenceRenewal[] | undefined;
    documentLinks: DocumentLinkPersonLicence[] | undefined;
    additionalLicenceInformations: AdditionalInformationPersonLicence[] | undefined;
    professionalResponsibilities: ProfessionalResponsibility[] | undefined;
    quarterlyReports: QuarterlyReport[] | undefined;
    application: Application;
    applicationId: number | undefined;
    ehcTypeId: string | undefined;
    details: PersonLicenceDetails[] | undefined;
    isFinalDecision: boolean;
    migrationData: MigrationData[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class DelegatedPersonLicence implements IDelegatedPersonLicence {
    delegatedPerson!: Person;
    delegatedPersonId!: number | undefined;
    discriminator!: PersonLicenceType;
    person!: Person;
    personId!: number;
    naturalKey!: string;
    professionId!: string | undefined;
    postgraduateTitleId!: string | undefined;
    statusId!: string | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfNinetyDaysStart!: DateTime | undefined;
    dateOfNinetyDaysEnd!: DateTime | undefined;
    remark!: string | undefined;
    authorisationNarcoticId!: string | undefined;
    authorisationNarcoticRemarks!: string | undefined;
    healthRegisterTransfer!: boolean;
    healthRegisterSync!: DateTime | undefined;
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    licencedBusiness!: Business;
    licencedBusinessId!: number | undefined;
    sapInvoice!: SapInvoice;
    sapInvoiceId!: number | undefined;
    automaticNotificationAndStatusChange!: boolean;
    vaccinationLicenceId!: string | undefined;
    dateOfIssueVaccinationLicence!: DateTime | undefined;
    dateOfEndNotification1Sent!: DateTime | undefined;
    dateOfEndNotification2Sent!: DateTime | undefined;
    dateOfPendenceCreated!: DateTime | undefined;
    employments!: Employment[] | undefined;
    restrictions!: Restriction[] | undefined;
    renewals!: ProfessionalLicenceRenewal[] | undefined;
    documentLinks!: DocumentLinkPersonLicence[] | undefined;
    additionalLicenceInformations!: AdditionalInformationPersonLicence[] | undefined;
    professionalResponsibilities!: ProfessionalResponsibility[] | undefined;
    quarterlyReports!: QuarterlyReport[] | undefined;
    application!: Application;
    applicationId!: number | undefined;
    ehcTypeId!: string | undefined;
    details!: PersonLicenceDetails[] | undefined;
    readonly isFinalDecision!: boolean;
    migrationData!: MigrationData[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDelegatedPersonLicence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delegatedPerson = _data["delegatedPerson"] ? Person.fromJS(_data["delegatedPerson"]) : <any>undefined;
            this.delegatedPersonId = _data["delegatedPersonId"];
            this.discriminator = _data["discriminator"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.personId = _data["personId"];
            this.naturalKey = _data["naturalKey"];
            this.professionId = _data["professionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.statusId = _data["statusId"];
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfNinetyDaysStart = _data["dateOfNinetyDaysStart"] ? DateTime.fromISO(_data["dateOfNinetyDaysStart"].toString()) : <any>undefined;
            this.dateOfNinetyDaysEnd = _data["dateOfNinetyDaysEnd"] ? DateTime.fromISO(_data["dateOfNinetyDaysEnd"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.authorisationNarcoticId = _data["authorisationNarcoticId"];
            this.authorisationNarcoticRemarks = _data["authorisationNarcoticRemarks"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.healthRegisterSync = _data["healthRegisterSync"] ? DateTime.fromISO(_data["healthRegisterSync"].toString()) : <any>undefined;
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.licencedBusiness = _data["licencedBusiness"] ? Business.fromJS(_data["licencedBusiness"]) : <any>undefined;
            this.licencedBusinessId = _data["licencedBusinessId"];
            this.sapInvoice = _data["sapInvoice"] ? SapInvoice.fromJS(_data["sapInvoice"]) : <any>undefined;
            this.sapInvoiceId = _data["sapInvoiceId"];
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.vaccinationLicenceId = _data["vaccinationLicenceId"];
            this.dateOfIssueVaccinationLicence = _data["dateOfIssueVaccinationLicence"] ? DateTime.fromISO(_data["dateOfIssueVaccinationLicence"].toString()) : <any>undefined;
            this.dateOfEndNotification1Sent = _data["dateOfEndNotification1Sent"] ? DateTime.fromISO(_data["dateOfEndNotification1Sent"].toString()) : <any>undefined;
            this.dateOfEndNotification2Sent = _data["dateOfEndNotification2Sent"] ? DateTime.fromISO(_data["dateOfEndNotification2Sent"].toString()) : <any>undefined;
            this.dateOfPendenceCreated = _data["dateOfPendenceCreated"] ? DateTime.fromISO(_data["dateOfPendenceCreated"].toString()) : <any>undefined;
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(Employment.fromJS(item));
            }
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(Restriction.fromJS(item));
            }
            if (Array.isArray(_data["renewals"])) {
                this.renewals = [] as any;
                for (let item of _data["renewals"])
                    this.renewals!.push(ProfessionalLicenceRenewal.fromJS(item));
            }
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkPersonLicence.fromJS(item));
            }
            if (Array.isArray(_data["additionalLicenceInformations"])) {
                this.additionalLicenceInformations = [] as any;
                for (let item of _data["additionalLicenceInformations"])
                    this.additionalLicenceInformations!.push(AdditionalInformationPersonLicence.fromJS(item));
            }
            if (Array.isArray(_data["professionalResponsibilities"])) {
                this.professionalResponsibilities = [] as any;
                for (let item of _data["professionalResponsibilities"])
                    this.professionalResponsibilities!.push(ProfessionalResponsibility.fromJS(item));
            }
            if (Array.isArray(_data["quarterlyReports"])) {
                this.quarterlyReports = [] as any;
                for (let item of _data["quarterlyReports"])
                    this.quarterlyReports!.push(QuarterlyReport.fromJS(item));
            }
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : <any>undefined;
            this.applicationId = _data["applicationId"];
            this.ehcTypeId = _data["ehcTypeId"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(PersonLicenceDetails.fromJS(item));
            }
            (<any>this).isFinalDecision = _data["isFinalDecision"];
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DelegatedPersonLicence {
        data = typeof data === 'object' ? data : {};
        let result = new DelegatedPersonLicence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delegatedPerson"] = this.delegatedPerson ? this.delegatedPerson.toJSON() : <any>undefined;
        data["delegatedPersonId"] = this.delegatedPersonId;
        data["discriminator"] = this.discriminator;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["naturalKey"] = this.naturalKey;
        data["professionId"] = this.professionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["statusId"] = this.statusId;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysStart"] = this.dateOfNinetyDaysStart ? this.dateOfNinetyDaysStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysEnd"] = this.dateOfNinetyDaysEnd ? this.dateOfNinetyDaysEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["authorisationNarcoticId"] = this.authorisationNarcoticId;
        data["authorisationNarcoticRemarks"] = this.authorisationNarcoticRemarks;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["healthRegisterSync"] = this.healthRegisterSync ? this.healthRegisterSync.toString() : <any>undefined;
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["licencedBusiness"] = this.licencedBusiness ? this.licencedBusiness.toJSON() : <any>undefined;
        data["licencedBusinessId"] = this.licencedBusinessId;
        data["sapInvoice"] = this.sapInvoice ? this.sapInvoice.toJSON() : <any>undefined;
        data["sapInvoiceId"] = this.sapInvoiceId;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["vaccinationLicenceId"] = this.vaccinationLicenceId;
        data["dateOfIssueVaccinationLicence"] = this.dateOfIssueVaccinationLicence ? this.dateOfIssueVaccinationLicence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndNotification1Sent"] = this.dateOfEndNotification1Sent ? this.dateOfEndNotification1Sent.toString() : <any>undefined;
        data["dateOfEndNotification2Sent"] = this.dateOfEndNotification2Sent ? this.dateOfEndNotification2Sent.toString() : <any>undefined;
        data["dateOfPendenceCreated"] = this.dateOfPendenceCreated ? this.dateOfPendenceCreated.toString() : <any>undefined;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        if (Array.isArray(this.renewals)) {
            data["renewals"] = [];
            for (let item of this.renewals)
                data["renewals"].push(item.toJSON());
        }
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalLicenceInformations)) {
            data["additionalLicenceInformations"] = [];
            for (let item of this.additionalLicenceInformations)
                data["additionalLicenceInformations"].push(item.toJSON());
        }
        if (Array.isArray(this.professionalResponsibilities)) {
            data["professionalResponsibilities"] = [];
            for (let item of this.professionalResponsibilities)
                data["professionalResponsibilities"].push(item.toJSON());
        }
        if (Array.isArray(this.quarterlyReports)) {
            data["quarterlyReports"] = [];
            for (let item of this.quarterlyReports)
                data["quarterlyReports"].push(item.toJSON());
        }
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["applicationId"] = this.applicationId;
        data["ehcTypeId"] = this.ehcTypeId;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["isFinalDecision"] = this.isFinalDecision;
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDelegatedPersonLicence {
    delegatedPerson: Person;
    delegatedPersonId: number | undefined;
    discriminator: PersonLicenceType;
    person: Person;
    personId: number;
    naturalKey: string;
    professionId: string | undefined;
    postgraduateTitleId: string | undefined;
    statusId: string | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfNinetyDaysStart: DateTime | undefined;
    dateOfNinetyDaysEnd: DateTime | undefined;
    remark: string | undefined;
    authorisationNarcoticId: string | undefined;
    authorisationNarcoticRemarks: string | undefined;
    healthRegisterTransfer: boolean;
    healthRegisterSync: DateTime | undefined;
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    licencedBusiness: Business;
    licencedBusinessId: number | undefined;
    sapInvoice: SapInvoice;
    sapInvoiceId: number | undefined;
    automaticNotificationAndStatusChange: boolean;
    vaccinationLicenceId: string | undefined;
    dateOfIssueVaccinationLicence: DateTime | undefined;
    dateOfEndNotification1Sent: DateTime | undefined;
    dateOfEndNotification2Sent: DateTime | undefined;
    dateOfPendenceCreated: DateTime | undefined;
    employments: Employment[] | undefined;
    restrictions: Restriction[] | undefined;
    renewals: ProfessionalLicenceRenewal[] | undefined;
    documentLinks: DocumentLinkPersonLicence[] | undefined;
    additionalLicenceInformations: AdditionalInformationPersonLicence[] | undefined;
    professionalResponsibilities: ProfessionalResponsibility[] | undefined;
    quarterlyReports: QuarterlyReport[] | undefined;
    application: Application;
    applicationId: number | undefined;
    ehcTypeId: string | undefined;
    details: PersonLicenceDetails[] | undefined;
    isFinalDecision: boolean;
    migrationData: MigrationData[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CreatePersonLicenceDto implements ICreatePersonLicenceDto {
    personId!: number;
    discriminator!: PersonLicenceType;
    professionId!: string | undefined;
    postgraduateTitleId!: string | undefined;
    ehcTypeId!: string | undefined;

    constructor(data?: ICreatePersonLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.discriminator = _data["discriminator"];
            this.professionId = _data["professionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.ehcTypeId = _data["ehcTypeId"];
        }
    }

    static fromJS(data: any): CreatePersonLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["discriminator"] = this.discriminator;
        data["professionId"] = this.professionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["ehcTypeId"] = this.ehcTypeId;
        return data;
    }
}

export interface ICreatePersonLicenceDto {
    personId: number;
    discriminator: PersonLicenceType;
    professionId: string | undefined;
    postgraduateTitleId: string | undefined;
    ehcTypeId: string | undefined;
}

export class CreatePersonLicenceRenewalDto implements ICreatePersonLicenceRenewalDto {
    personLicenceId!: number;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    remark!: string | undefined;

    constructor(data?: ICreatePersonLicenceRenewalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personLicenceId = _data["personLicenceId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): CreatePersonLicenceRenewalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonLicenceRenewalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personLicenceId"] = this.personLicenceId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        return data;
    }
}

export interface ICreatePersonLicenceRenewalDto {
    personLicenceId: number;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    remark: string | undefined;
}

export class GetPersonLicenceDto implements IGetPersonLicenceDto {
    discriminator!: PersonLicenceType;
    personId!: number;
    person!: EmploymentPersonDto;
    personFirstName!: string | undefined;
    personLastName!: string | undefined;
    assistantPersonFirstName!: string | undefined;
    assistantPersonLastName!: string | undefined;
    representationPersonFirstName!: string | undefined;
    representationPersonLastName!: string | undefined;
    professionId!: string | undefined;
    postgraduateTitleId!: string | undefined;
    ehcTypeId!: string | undefined;
    statusId!: string;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    licencedBusinessId!: number | undefined;
    assistantPersonId!: number | undefined;
    parentLicenceId!: number | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfNinetyDaysStart!: DateTime | undefined;
    dateOfNinetyDaysEnd!: DateTime | undefined;
    authorisationNarcoticId!: string | undefined;
    authorisationNarcoticRemarks!: string | undefined;
    remark!: string | undefined;
    details!: DetailsDto[] | undefined;
    healthRegisterTransfer!: boolean;
    dateOfRepresentationStart!: DateTime | undefined;
    dateOfProvisoryRepresentationEnd!: DateTime | undefined;
    levelOfWork!: number | undefined;
    representationBusinessId!: number | undefined;
    representationPersonId!: number | undefined;
    automaticNotificationAndStatusChange!: boolean;
    vaccinationLicenceId!: string | undefined;
    dateOfIssueVaccinationLicence!: DateTime | undefined;
    dateOfAssistanceStart!: DateTime | undefined;
    dateOfProvisoryAssistanceEnd!: DateTime | undefined;
    assistanceBusinessId!: number | undefined;

    constructor(data?: IGetPersonLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.personId = _data["personId"];
            this.person = _data["person"] ? EmploymentPersonDto.fromJS(_data["person"]) : <any>undefined;
            this.personFirstName = _data["personFirstName"];
            this.personLastName = _data["personLastName"];
            this.assistantPersonFirstName = _data["assistantPersonFirstName"];
            this.assistantPersonLastName = _data["assistantPersonLastName"];
            this.representationPersonFirstName = _data["representationPersonFirstName"];
            this.representationPersonLastName = _data["representationPersonLastName"];
            this.professionId = _data["professionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.ehcTypeId = _data["ehcTypeId"];
            this.statusId = _data["statusId"];
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.licencedBusinessId = _data["licencedBusinessId"];
            this.assistantPersonId = _data["assistantPersonId"];
            this.parentLicenceId = _data["parentLicenceId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfNinetyDaysStart = _data["dateOfNinetyDaysStart"] ? DateTime.fromISO(_data["dateOfNinetyDaysStart"].toString()) : <any>undefined;
            this.dateOfNinetyDaysEnd = _data["dateOfNinetyDaysEnd"] ? DateTime.fromISO(_data["dateOfNinetyDaysEnd"].toString()) : <any>undefined;
            this.authorisationNarcoticId = _data["authorisationNarcoticId"];
            this.authorisationNarcoticRemarks = _data["authorisationNarcoticRemarks"];
            this.remark = _data["remark"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(DetailsDto.fromJS(item));
            }
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.dateOfRepresentationStart = _data["dateOfRepresentationStart"] ? DateTime.fromISO(_data["dateOfRepresentationStart"].toString()) : <any>undefined;
            this.dateOfProvisoryRepresentationEnd = _data["dateOfProvisoryRepresentationEnd"] ? DateTime.fromISO(_data["dateOfProvisoryRepresentationEnd"].toString()) : <any>undefined;
            this.levelOfWork = _data["levelOfWork"];
            this.representationBusinessId = _data["representationBusinessId"];
            this.representationPersonId = _data["representationPersonId"];
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.vaccinationLicenceId = _data["vaccinationLicenceId"];
            this.dateOfIssueVaccinationLicence = _data["dateOfIssueVaccinationLicence"] ? DateTime.fromISO(_data["dateOfIssueVaccinationLicence"].toString()) : <any>undefined;
            this.dateOfAssistanceStart = _data["dateOfAssistanceStart"] ? DateTime.fromISO(_data["dateOfAssistanceStart"].toString()) : <any>undefined;
            this.dateOfProvisoryAssistanceEnd = _data["dateOfProvisoryAssistanceEnd"] ? DateTime.fromISO(_data["dateOfProvisoryAssistanceEnd"].toString()) : <any>undefined;
            this.assistanceBusinessId = _data["assistanceBusinessId"];
        }
    }

    static fromJS(data: any): GetPersonLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personFirstName"] = this.personFirstName;
        data["personLastName"] = this.personLastName;
        data["assistantPersonFirstName"] = this.assistantPersonFirstName;
        data["assistantPersonLastName"] = this.assistantPersonLastName;
        data["representationPersonFirstName"] = this.representationPersonFirstName;
        data["representationPersonLastName"] = this.representationPersonLastName;
        data["professionId"] = this.professionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["ehcTypeId"] = this.ehcTypeId;
        data["statusId"] = this.statusId;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["licencedBusinessId"] = this.licencedBusinessId;
        data["assistantPersonId"] = this.assistantPersonId;
        data["parentLicenceId"] = this.parentLicenceId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysStart"] = this.dateOfNinetyDaysStart ? this.dateOfNinetyDaysStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysEnd"] = this.dateOfNinetyDaysEnd ? this.dateOfNinetyDaysEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["authorisationNarcoticId"] = this.authorisationNarcoticId;
        data["authorisationNarcoticRemarks"] = this.authorisationNarcoticRemarks;
        data["remark"] = this.remark;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["dateOfRepresentationStart"] = this.dateOfRepresentationStart ? this.dateOfRepresentationStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfProvisoryRepresentationEnd"] = this.dateOfProvisoryRepresentationEnd ? this.dateOfProvisoryRepresentationEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfWork"] = this.levelOfWork;
        data["representationBusinessId"] = this.representationBusinessId;
        data["representationPersonId"] = this.representationPersonId;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["vaccinationLicenceId"] = this.vaccinationLicenceId;
        data["dateOfIssueVaccinationLicence"] = this.dateOfIssueVaccinationLicence ? this.dateOfIssueVaccinationLicence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfAssistanceStart"] = this.dateOfAssistanceStart ? this.dateOfAssistanceStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfProvisoryAssistanceEnd"] = this.dateOfProvisoryAssistanceEnd ? this.dateOfProvisoryAssistanceEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["assistanceBusinessId"] = this.assistanceBusinessId;
        return data;
    }
}

export interface IGetPersonLicenceDto {
    discriminator: PersonLicenceType;
    personId: number;
    person: EmploymentPersonDto;
    personFirstName: string | undefined;
    personLastName: string | undefined;
    assistantPersonFirstName: string | undefined;
    assistantPersonLastName: string | undefined;
    representationPersonFirstName: string | undefined;
    representationPersonLastName: string | undefined;
    professionId: string | undefined;
    postgraduateTitleId: string | undefined;
    ehcTypeId: string | undefined;
    statusId: string;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    licencedBusinessId: number | undefined;
    assistantPersonId: number | undefined;
    parentLicenceId: number | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfNinetyDaysStart: DateTime | undefined;
    dateOfNinetyDaysEnd: DateTime | undefined;
    authorisationNarcoticId: string | undefined;
    authorisationNarcoticRemarks: string | undefined;
    remark: string | undefined;
    details: DetailsDto[] | undefined;
    healthRegisterTransfer: boolean;
    dateOfRepresentationStart: DateTime | undefined;
    dateOfProvisoryRepresentationEnd: DateTime | undefined;
    levelOfWork: number | undefined;
    representationBusinessId: number | undefined;
    representationPersonId: number | undefined;
    automaticNotificationAndStatusChange: boolean;
    vaccinationLicenceId: string | undefined;
    dateOfIssueVaccinationLicence: DateTime | undefined;
    dateOfAssistanceStart: DateTime | undefined;
    dateOfProvisoryAssistanceEnd: DateTime | undefined;
    assistanceBusinessId: number | undefined;
}

export class GetPersonLicencesOutput implements IGetPersonLicencesOutput {
    items!: PersonLicenceDto[] | undefined;

    constructor(data?: IGetPersonLicencesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PersonLicenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPersonLicencesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonLicencesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPersonLicencesOutput {
    items: PersonLicenceDto[] | undefined;
}

export class PersonLicenceHistoryDto implements IPersonLicenceHistoryDto {
    id!: number;
    time!: DateTime;
    reason!: string | undefined;
    userId!: number | undefined;
    entityChangeType!: EntityChangeType;
    propertyChanges!: { [key: string]: HistoryPropertyChange; } | undefined;
    statusId!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    legalBasisId!: string | undefined;
    remark!: string | undefined;
    authorisationNarcoticId!: string | undefined;
    authorisationNarcoticRemarks!: string | undefined;

    constructor(data?: IPersonLicenceHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.time = _data["time"] ? DateTime.fromISO(_data["time"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.userId = _data["userId"];
            this.entityChangeType = _data["entityChangeType"];
            if (_data["propertyChanges"]) {
                this.propertyChanges = {} as any;
                for (let key in _data["propertyChanges"]) {
                    if (_data["propertyChanges"].hasOwnProperty(key))
                        (<any>this.propertyChanges)![key] = _data["propertyChanges"][key];
                }
            }
            this.statusId = _data["statusId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.legalBasisId = _data["legalBasisId"];
            this.remark = _data["remark"];
            this.authorisationNarcoticId = _data["authorisationNarcoticId"];
            this.authorisationNarcoticRemarks = _data["authorisationNarcoticRemarks"];
        }
    }

    static fromJS(data: any): PersonLicenceHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonLicenceHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["time"] = this.time ? this.time.toString() : <any>undefined;
        data["reason"] = this.reason;
        data["userId"] = this.userId;
        data["entityChangeType"] = this.entityChangeType;
        if (this.propertyChanges) {
            data["propertyChanges"] = {};
            for (let key in this.propertyChanges) {
                if (this.propertyChanges.hasOwnProperty(key))
                    (<any>data["propertyChanges"])[key] = (<any>this.propertyChanges)[key];
            }
        }
        data["statusId"] = this.statusId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["legalBasisId"] = this.legalBasisId;
        data["remark"] = this.remark;
        data["authorisationNarcoticId"] = this.authorisationNarcoticId;
        data["authorisationNarcoticRemarks"] = this.authorisationNarcoticRemarks;
        return data;
    }
}

export interface IPersonLicenceHistoryDto {
    id: number;
    time: DateTime;
    reason: string | undefined;
    userId: number | undefined;
    entityChangeType: EntityChangeType;
    propertyChanges: { [key: string]: HistoryPropertyChange; } | undefined;
    statusId: string | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    legalBasisId: string | undefined;
    remark: string | undefined;
    authorisationNarcoticId: string | undefined;
    authorisationNarcoticRemarks: string | undefined;
}

export class PersonLicenceDto implements IPersonLicenceDto {
    naturalKey!: string | undefined;
    personId!: number;
    person!: EmploymentPersonDto;
    personFirstName!: string | undefined;
    personLastName!: string | undefined;
    discriminator!: PersonLicenceType;
    ehcTypeId!: string | undefined;
    professionId!: string;
    postgraduateTitleId!: string | undefined;
    statusId!: string;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    business!: GetBusinessDto;
    licencedBusinessId!: number | undefined;
    assistantPersonId!: number | undefined;
    assistantPersonFirstName!: string | undefined;
    assistantPersonLastName!: string | undefined;
    delegatedPersonId!: number | undefined;
    delegatedPersonFirstName!: string | undefined;
    delegatedPersonLastName!: string | undefined;
    parentLicenceId!: number | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfNinetyDaysStart!: DateTime | undefined;
    dateOfNinetyDaysEnd!: DateTime | undefined;
    details!: DetailsDto[] | undefined;
    authorisationNarcoticId!: string | undefined;
    authorisationNarcoticRemarks!: string | undefined;
    remark!: string | undefined;
    healthRegisterTransfer!: boolean;
    healthRegisterSync!: DateTime | undefined;
    sapInvoiceStatusId!: string | undefined;
    dateOfSapInvoiceBilling!: DateTime | undefined;
    automaticNotificationAndStatusChange!: boolean;
    vaccinationLicenceId!: string | undefined;
    dateOfIssueVaccinationLicence!: DateTime | undefined;
    dateOfRepresentationStart!: DateTime | undefined;
    dateOfProvisoryRepresentationEnd!: DateTime | undefined;
    dateOfAssistanceStart!: DateTime | undefined;
    dateOfProvisoryAssistanceEnd!: DateTime | undefined;
    assistanceBusinessId!: number | undefined;
    levelOfWork!: number | undefined;
    representationBusinessId!: number | undefined;
    representationPersonId!: number | undefined;
    representationPersonFirstName!: string | undefined;
    representationPersonLastName!: string | undefined;
    representationReasonId!: string | undefined;
    representationAdditionalReason!: string | undefined;
    renewals!: PersonLicenceRenewalDto[] | undefined;
    professionalResponsibilities!: PersonLicenceProfessionalResponsibilityDto[] | undefined;
    employments!: GetEmploymentDto[] | undefined;
    restrictions!: ProfessionalLicenceRestrictionDto[] | undefined;
    id!: number;

    constructor(data?: IPersonLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naturalKey = _data["naturalKey"];
            this.personId = _data["personId"];
            this.person = _data["person"] ? EmploymentPersonDto.fromJS(_data["person"]) : <any>undefined;
            this.personFirstName = _data["personFirstName"];
            this.personLastName = _data["personLastName"];
            this.discriminator = _data["discriminator"];
            this.ehcTypeId = _data["ehcTypeId"];
            this.professionId = _data["professionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.statusId = _data["statusId"];
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.business = _data["business"] ? GetBusinessDto.fromJS(_data["business"]) : <any>undefined;
            this.licencedBusinessId = _data["licencedBusinessId"];
            this.assistantPersonId = _data["assistantPersonId"];
            this.assistantPersonFirstName = _data["assistantPersonFirstName"];
            this.assistantPersonLastName = _data["assistantPersonLastName"];
            this.delegatedPersonId = _data["delegatedPersonId"];
            this.delegatedPersonFirstName = _data["delegatedPersonFirstName"];
            this.delegatedPersonLastName = _data["delegatedPersonLastName"];
            this.parentLicenceId = _data["parentLicenceId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfNinetyDaysStart = _data["dateOfNinetyDaysStart"] ? DateTime.fromISO(_data["dateOfNinetyDaysStart"].toString()) : <any>undefined;
            this.dateOfNinetyDaysEnd = _data["dateOfNinetyDaysEnd"] ? DateTime.fromISO(_data["dateOfNinetyDaysEnd"].toString()) : <any>undefined;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(DetailsDto.fromJS(item));
            }
            this.authorisationNarcoticId = _data["authorisationNarcoticId"];
            this.authorisationNarcoticRemarks = _data["authorisationNarcoticRemarks"];
            this.remark = _data["remark"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.healthRegisterSync = _data["healthRegisterSync"] ? DateTime.fromISO(_data["healthRegisterSync"].toString()) : <any>undefined;
            this.sapInvoiceStatusId = _data["sapInvoiceStatusId"];
            this.dateOfSapInvoiceBilling = _data["dateOfSapInvoiceBilling"] ? DateTime.fromISO(_data["dateOfSapInvoiceBilling"].toString()) : <any>undefined;
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.vaccinationLicenceId = _data["vaccinationLicenceId"];
            this.dateOfIssueVaccinationLicence = _data["dateOfIssueVaccinationLicence"] ? DateTime.fromISO(_data["dateOfIssueVaccinationLicence"].toString()) : <any>undefined;
            this.dateOfRepresentationStart = _data["dateOfRepresentationStart"] ? DateTime.fromISO(_data["dateOfRepresentationStart"].toString()) : <any>undefined;
            this.dateOfProvisoryRepresentationEnd = _data["dateOfProvisoryRepresentationEnd"] ? DateTime.fromISO(_data["dateOfProvisoryRepresentationEnd"].toString()) : <any>undefined;
            this.dateOfAssistanceStart = _data["dateOfAssistanceStart"] ? DateTime.fromISO(_data["dateOfAssistanceStart"].toString()) : <any>undefined;
            this.dateOfProvisoryAssistanceEnd = _data["dateOfProvisoryAssistanceEnd"] ? DateTime.fromISO(_data["dateOfProvisoryAssistanceEnd"].toString()) : <any>undefined;
            this.assistanceBusinessId = _data["assistanceBusinessId"];
            this.levelOfWork = _data["levelOfWork"];
            this.representationBusinessId = _data["representationBusinessId"];
            this.representationPersonId = _data["representationPersonId"];
            this.representationPersonFirstName = _data["representationPersonFirstName"];
            this.representationPersonLastName = _data["representationPersonLastName"];
            this.representationReasonId = _data["representationReasonId"];
            this.representationAdditionalReason = _data["representationAdditionalReason"];
            if (Array.isArray(_data["renewals"])) {
                this.renewals = [] as any;
                for (let item of _data["renewals"])
                    this.renewals!.push(PersonLicenceRenewalDto.fromJS(item));
            }
            if (Array.isArray(_data["professionalResponsibilities"])) {
                this.professionalResponsibilities = [] as any;
                for (let item of _data["professionalResponsibilities"])
                    this.professionalResponsibilities!.push(PersonLicenceProfessionalResponsibilityDto.fromJS(item));
            }
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(GetEmploymentDto.fromJS(item));
            }
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(ProfessionalLicenceRestrictionDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PersonLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naturalKey"] = this.naturalKey;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personFirstName"] = this.personFirstName;
        data["personLastName"] = this.personLastName;
        data["discriminator"] = this.discriminator;
        data["ehcTypeId"] = this.ehcTypeId;
        data["professionId"] = this.professionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["statusId"] = this.statusId;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        data["licencedBusinessId"] = this.licencedBusinessId;
        data["assistantPersonId"] = this.assistantPersonId;
        data["assistantPersonFirstName"] = this.assistantPersonFirstName;
        data["assistantPersonLastName"] = this.assistantPersonLastName;
        data["delegatedPersonId"] = this.delegatedPersonId;
        data["delegatedPersonFirstName"] = this.delegatedPersonFirstName;
        data["delegatedPersonLastName"] = this.delegatedPersonLastName;
        data["parentLicenceId"] = this.parentLicenceId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysStart"] = this.dateOfNinetyDaysStart ? this.dateOfNinetyDaysStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysEnd"] = this.dateOfNinetyDaysEnd ? this.dateOfNinetyDaysEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["authorisationNarcoticId"] = this.authorisationNarcoticId;
        data["authorisationNarcoticRemarks"] = this.authorisationNarcoticRemarks;
        data["remark"] = this.remark;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["healthRegisterSync"] = this.healthRegisterSync ? this.healthRegisterSync.toString() : <any>undefined;
        data["sapInvoiceStatusId"] = this.sapInvoiceStatusId;
        data["dateOfSapInvoiceBilling"] = this.dateOfSapInvoiceBilling ? this.dateOfSapInvoiceBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["vaccinationLicenceId"] = this.vaccinationLicenceId;
        data["dateOfIssueVaccinationLicence"] = this.dateOfIssueVaccinationLicence ? this.dateOfIssueVaccinationLicence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRepresentationStart"] = this.dateOfRepresentationStart ? this.dateOfRepresentationStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfProvisoryRepresentationEnd"] = this.dateOfProvisoryRepresentationEnd ? this.dateOfProvisoryRepresentationEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfAssistanceStart"] = this.dateOfAssistanceStart ? this.dateOfAssistanceStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfProvisoryAssistanceEnd"] = this.dateOfProvisoryAssistanceEnd ? this.dateOfProvisoryAssistanceEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["assistanceBusinessId"] = this.assistanceBusinessId;
        data["levelOfWork"] = this.levelOfWork;
        data["representationBusinessId"] = this.representationBusinessId;
        data["representationPersonId"] = this.representationPersonId;
        data["representationPersonFirstName"] = this.representationPersonFirstName;
        data["representationPersonLastName"] = this.representationPersonLastName;
        data["representationReasonId"] = this.representationReasonId;
        data["representationAdditionalReason"] = this.representationAdditionalReason;
        if (Array.isArray(this.renewals)) {
            data["renewals"] = [];
            for (let item of this.renewals)
                data["renewals"].push(item.toJSON());
        }
        if (Array.isArray(this.professionalResponsibilities)) {
            data["professionalResponsibilities"] = [];
            for (let item of this.professionalResponsibilities)
                data["professionalResponsibilities"].push(item.toJSON());
        }
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IPersonLicenceDto {
    naturalKey: string | undefined;
    personId: number;
    person: EmploymentPersonDto;
    personFirstName: string | undefined;
    personLastName: string | undefined;
    discriminator: PersonLicenceType;
    ehcTypeId: string | undefined;
    professionId: string;
    postgraduateTitleId: string | undefined;
    statusId: string;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    business: GetBusinessDto;
    licencedBusinessId: number | undefined;
    assistantPersonId: number | undefined;
    assistantPersonFirstName: string | undefined;
    assistantPersonLastName: string | undefined;
    delegatedPersonId: number | undefined;
    delegatedPersonFirstName: string | undefined;
    delegatedPersonLastName: string | undefined;
    parentLicenceId: number | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfNinetyDaysStart: DateTime | undefined;
    dateOfNinetyDaysEnd: DateTime | undefined;
    details: DetailsDto[] | undefined;
    authorisationNarcoticId: string | undefined;
    authorisationNarcoticRemarks: string | undefined;
    remark: string | undefined;
    healthRegisterTransfer: boolean;
    healthRegisterSync: DateTime | undefined;
    sapInvoiceStatusId: string | undefined;
    dateOfSapInvoiceBilling: DateTime | undefined;
    automaticNotificationAndStatusChange: boolean;
    vaccinationLicenceId: string | undefined;
    dateOfIssueVaccinationLicence: DateTime | undefined;
    dateOfRepresentationStart: DateTime | undefined;
    dateOfProvisoryRepresentationEnd: DateTime | undefined;
    dateOfAssistanceStart: DateTime | undefined;
    dateOfProvisoryAssistanceEnd: DateTime | undefined;
    assistanceBusinessId: number | undefined;
    levelOfWork: number | undefined;
    representationBusinessId: number | undefined;
    representationPersonId: number | undefined;
    representationPersonFirstName: string | undefined;
    representationPersonLastName: string | undefined;
    representationReasonId: string | undefined;
    representationAdditionalReason: string | undefined;
    renewals: PersonLicenceRenewalDto[] | undefined;
    professionalResponsibilities: PersonLicenceProfessionalResponsibilityDto[] | undefined;
    employments: GetEmploymentDto[] | undefined;
    restrictions: ProfessionalLicenceRestrictionDto[] | undefined;
    id: number;
}

export class PersonLicenceProfessionalResponsibilityDto implements IPersonLicenceProfessionalResponsibilityDto {
    personLicenceId!: number;
    typeId!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfProofRequested!: DateTime | undefined;
    id!: number;

    constructor(data?: IPersonLicenceProfessionalResponsibilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personLicenceId = _data["personLicenceId"];
            this.typeId = _data["typeId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfProofRequested = _data["dateOfProofRequested"] ? DateTime.fromISO(_data["dateOfProofRequested"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PersonLicenceProfessionalResponsibilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonLicenceProfessionalResponsibilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personLicenceId"] = this.personLicenceId;
        data["typeId"] = this.typeId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfProofRequested"] = this.dateOfProofRequested ? this.dateOfProofRequested.toFormat('yyyy-MM-dd') : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IPersonLicenceProfessionalResponsibilityDto {
    personLicenceId: number;
    typeId: string | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfProofRequested: DateTime | undefined;
    id: number;
}

export class PersonLicenceRenewalDto implements IPersonLicenceRenewalDto {
    personLicenceId!: number;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    remark!: string | undefined;
    sapInvoiceStatusId!: string | undefined;
    dateOfSapInvoiceBilling!: DateTime | undefined;
    applicationId!: number | undefined;
    id!: number;

    constructor(data?: IPersonLicenceRenewalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personLicenceId = _data["personLicenceId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.sapInvoiceStatusId = _data["sapInvoiceStatusId"];
            this.dateOfSapInvoiceBilling = _data["dateOfSapInvoiceBilling"] ? DateTime.fromISO(_data["dateOfSapInvoiceBilling"].toString()) : <any>undefined;
            this.applicationId = _data["applicationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PersonLicenceRenewalDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonLicenceRenewalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personLicenceId"] = this.personLicenceId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["sapInvoiceStatusId"] = this.sapInvoiceStatusId;
        data["dateOfSapInvoiceBilling"] = this.dateOfSapInvoiceBilling ? this.dateOfSapInvoiceBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["applicationId"] = this.applicationId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPersonLicenceRenewalDto {
    personLicenceId: number;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    remark: string | undefined;
    sapInvoiceStatusId: string | undefined;
    dateOfSapInvoiceBilling: DateTime | undefined;
    applicationId: number | undefined;
    id: number;
}

export class SearchPersonLicenceDto implements ISearchPersonLicenceDto {
    naturalKey!: string | undefined;
    personId!: number;
    personFirstName!: string | undefined;
    personLastName!: string | undefined;
    personGln!: string | undefined;
    discriminator!: PersonLicenceType;
    professionId!: string | undefined;
    postgraduateTitleId!: string | undefined;
    statusId!: string | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    assistantPersonId!: number | undefined;
    assistantPersonFirstName!: string | undefined;
    assistantPersonLastName!: string | undefined;
    assistantPersonGln!: string | undefined;
    delegatedPersonId!: number | undefined;
    delegatedPersonFirstName!: string | undefined;
    delegatedPersonLastName!: string | undefined;
    delegatedPersonGln!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfNinetyDaysStart!: DateTime | undefined;
    dateOfNinetyDaysEnd!: DateTime | undefined;
    authorisationNarcoticId!: string | undefined;
    authorisationNarcoticRemarks!: string | undefined;
    remark!: string | undefined;
    healthRegisterTransfer!: boolean;
    healthRegisterSync!: DateTime | undefined;
    automaticNotificationAndStatusChange!: boolean;
    id!: number;

    constructor(data?: ISearchPersonLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naturalKey = _data["naturalKey"];
            this.personId = _data["personId"];
            this.personFirstName = _data["personFirstName"];
            this.personLastName = _data["personLastName"];
            this.personGln = _data["personGln"];
            this.discriminator = _data["discriminator"];
            this.professionId = _data["professionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.statusId = _data["statusId"];
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.assistantPersonId = _data["assistantPersonId"];
            this.assistantPersonFirstName = _data["assistantPersonFirstName"];
            this.assistantPersonLastName = _data["assistantPersonLastName"];
            this.assistantPersonGln = _data["assistantPersonGln"];
            this.delegatedPersonId = _data["delegatedPersonId"];
            this.delegatedPersonFirstName = _data["delegatedPersonFirstName"];
            this.delegatedPersonLastName = _data["delegatedPersonLastName"];
            this.delegatedPersonGln = _data["delegatedPersonGln"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfNinetyDaysStart = _data["dateOfNinetyDaysStart"] ? DateTime.fromISO(_data["dateOfNinetyDaysStart"].toString()) : <any>undefined;
            this.dateOfNinetyDaysEnd = _data["dateOfNinetyDaysEnd"] ? DateTime.fromISO(_data["dateOfNinetyDaysEnd"].toString()) : <any>undefined;
            this.authorisationNarcoticId = _data["authorisationNarcoticId"];
            this.authorisationNarcoticRemarks = _data["authorisationNarcoticRemarks"];
            this.remark = _data["remark"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.healthRegisterSync = _data["healthRegisterSync"] ? DateTime.fromISO(_data["healthRegisterSync"].toString()) : <any>undefined;
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SearchPersonLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPersonLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naturalKey"] = this.naturalKey;
        data["personId"] = this.personId;
        data["personFirstName"] = this.personFirstName;
        data["personLastName"] = this.personLastName;
        data["personGln"] = this.personGln;
        data["discriminator"] = this.discriminator;
        data["professionId"] = this.professionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["statusId"] = this.statusId;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["assistantPersonId"] = this.assistantPersonId;
        data["assistantPersonFirstName"] = this.assistantPersonFirstName;
        data["assistantPersonLastName"] = this.assistantPersonLastName;
        data["assistantPersonGln"] = this.assistantPersonGln;
        data["delegatedPersonId"] = this.delegatedPersonId;
        data["delegatedPersonFirstName"] = this.delegatedPersonFirstName;
        data["delegatedPersonLastName"] = this.delegatedPersonLastName;
        data["delegatedPersonGln"] = this.delegatedPersonGln;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysStart"] = this.dateOfNinetyDaysStart ? this.dateOfNinetyDaysStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysEnd"] = this.dateOfNinetyDaysEnd ? this.dateOfNinetyDaysEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["authorisationNarcoticId"] = this.authorisationNarcoticId;
        data["authorisationNarcoticRemarks"] = this.authorisationNarcoticRemarks;
        data["remark"] = this.remark;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["healthRegisterSync"] = this.healthRegisterSync ? this.healthRegisterSync.toString() : <any>undefined;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["id"] = this.id;
        return data;
    }
}

export interface ISearchPersonLicenceDto {
    naturalKey: string | undefined;
    personId: number;
    personFirstName: string | undefined;
    personLastName: string | undefined;
    personGln: string | undefined;
    discriminator: PersonLicenceType;
    professionId: string | undefined;
    postgraduateTitleId: string | undefined;
    statusId: string | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    assistantPersonId: number | undefined;
    assistantPersonFirstName: string | undefined;
    assistantPersonLastName: string | undefined;
    assistantPersonGln: string | undefined;
    delegatedPersonId: number | undefined;
    delegatedPersonFirstName: string | undefined;
    delegatedPersonLastName: string | undefined;
    delegatedPersonGln: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfNinetyDaysStart: DateTime | undefined;
    dateOfNinetyDaysEnd: DateTime | undefined;
    authorisationNarcoticId: string | undefined;
    authorisationNarcoticRemarks: string | undefined;
    remark: string | undefined;
    healthRegisterTransfer: boolean;
    healthRegisterSync: DateTime | undefined;
    automaticNotificationAndStatusChange: boolean;
    id: number;
}

export class SearchPersonLicencesInputDto implements ISearchPersonLicencesInputDto {
    personId!: number;
    types!: PersonLicenceType[];
    isOwner!: boolean;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: ISearchPersonLicencesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.types = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            this.isOwner = _data["isOwner"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): SearchPersonLicencesInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPersonLicencesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        data["isOwner"] = this.isOwner;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface ISearchPersonLicencesInputDto {
    personId: number;
    types: PersonLicenceType[];
    isOwner: boolean;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class SearchPersonLicencesOutputDto implements ISearchPersonLicencesOutputDto {
    totalCount!: number;
    items!: SearchPersonLicenceDto[] | undefined;

    constructor(data?: ISearchPersonLicencesOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SearchPersonLicenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchPersonLicencesOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPersonLicencesOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchPersonLicencesOutputDto {
    totalCount: number;
    items: SearchPersonLicenceDto[] | undefined;
}

export class UpdatePersonLicenceDto implements IUpdatePersonLicenceDto {
    professionId!: string | undefined;
    postgraduateTitleId!: string | undefined;
    ehcTypeId!: string | undefined;
    statusId!: string;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    licencedBusinessId!: number | undefined;
    assistantPersonId!: number | undefined;
    parentLicenceId!: number | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfNinetyDaysStart!: DateTime | undefined;
    dateOfNinetyDaysEnd!: DateTime | undefined;
    authorisationNarcoticId!: string | undefined;
    authorisationNarcoticRemarks!: string | undefined;
    remark!: string | undefined;
    details!: DetailsDto[] | undefined;
    healthRegisterTransfer!: boolean;
    dateOfRepresentationStart!: DateTime | undefined;
    dateOfProvisoryRepresentationEnd!: DateTime | undefined;
    levelOfWork!: number | undefined;
    representationBusinessId!: number | undefined;
    representationPersonId!: number | undefined;
    automaticNotificationAndStatusChange!: boolean;
    vaccinationLicenceId!: string | undefined;
    dateOfIssueVaccinationLicence!: DateTime | undefined;
    dateOfAssistanceStart!: DateTime | undefined;
    dateOfProvisoryAssistanceEnd!: DateTime | undefined;
    assistanceBusinessId!: number | undefined;

    constructor(data?: IUpdatePersonLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.ehcTypeId = _data["ehcTypeId"];
            this.statusId = _data["statusId"];
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.licencedBusinessId = _data["licencedBusinessId"];
            this.assistantPersonId = _data["assistantPersonId"];
            this.parentLicenceId = _data["parentLicenceId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfNinetyDaysStart = _data["dateOfNinetyDaysStart"] ? DateTime.fromISO(_data["dateOfNinetyDaysStart"].toString()) : <any>undefined;
            this.dateOfNinetyDaysEnd = _data["dateOfNinetyDaysEnd"] ? DateTime.fromISO(_data["dateOfNinetyDaysEnd"].toString()) : <any>undefined;
            this.authorisationNarcoticId = _data["authorisationNarcoticId"];
            this.authorisationNarcoticRemarks = _data["authorisationNarcoticRemarks"];
            this.remark = _data["remark"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(DetailsDto.fromJS(item));
            }
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.dateOfRepresentationStart = _data["dateOfRepresentationStart"] ? DateTime.fromISO(_data["dateOfRepresentationStart"].toString()) : <any>undefined;
            this.dateOfProvisoryRepresentationEnd = _data["dateOfProvisoryRepresentationEnd"] ? DateTime.fromISO(_data["dateOfProvisoryRepresentationEnd"].toString()) : <any>undefined;
            this.levelOfWork = _data["levelOfWork"];
            this.representationBusinessId = _data["representationBusinessId"];
            this.representationPersonId = _data["representationPersonId"];
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.vaccinationLicenceId = _data["vaccinationLicenceId"];
            this.dateOfIssueVaccinationLicence = _data["dateOfIssueVaccinationLicence"] ? DateTime.fromISO(_data["dateOfIssueVaccinationLicence"].toString()) : <any>undefined;
            this.dateOfAssistanceStart = _data["dateOfAssistanceStart"] ? DateTime.fromISO(_data["dateOfAssistanceStart"].toString()) : <any>undefined;
            this.dateOfProvisoryAssistanceEnd = _data["dateOfProvisoryAssistanceEnd"] ? DateTime.fromISO(_data["dateOfProvisoryAssistanceEnd"].toString()) : <any>undefined;
            this.assistanceBusinessId = _data["assistanceBusinessId"];
        }
    }

    static fromJS(data: any): UpdatePersonLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["ehcTypeId"] = this.ehcTypeId;
        data["statusId"] = this.statusId;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["licencedBusinessId"] = this.licencedBusinessId;
        data["assistantPersonId"] = this.assistantPersonId;
        data["parentLicenceId"] = this.parentLicenceId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysStart"] = this.dateOfNinetyDaysStart ? this.dateOfNinetyDaysStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysEnd"] = this.dateOfNinetyDaysEnd ? this.dateOfNinetyDaysEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["authorisationNarcoticId"] = this.authorisationNarcoticId;
        data["authorisationNarcoticRemarks"] = this.authorisationNarcoticRemarks;
        data["remark"] = this.remark;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["dateOfRepresentationStart"] = this.dateOfRepresentationStart ? this.dateOfRepresentationStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfProvisoryRepresentationEnd"] = this.dateOfProvisoryRepresentationEnd ? this.dateOfProvisoryRepresentationEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfWork"] = this.levelOfWork;
        data["representationBusinessId"] = this.representationBusinessId;
        data["representationPersonId"] = this.representationPersonId;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["vaccinationLicenceId"] = this.vaccinationLicenceId;
        data["dateOfIssueVaccinationLicence"] = this.dateOfIssueVaccinationLicence ? this.dateOfIssueVaccinationLicence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfAssistanceStart"] = this.dateOfAssistanceStart ? this.dateOfAssistanceStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfProvisoryAssistanceEnd"] = this.dateOfProvisoryAssistanceEnd ? this.dateOfProvisoryAssistanceEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["assistanceBusinessId"] = this.assistanceBusinessId;
        return data;
    }
}

export interface IUpdatePersonLicenceDto {
    professionId: string | undefined;
    postgraduateTitleId: string | undefined;
    ehcTypeId: string | undefined;
    statusId: string;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    licencedBusinessId: number | undefined;
    assistantPersonId: number | undefined;
    parentLicenceId: number | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfNinetyDaysStart: DateTime | undefined;
    dateOfNinetyDaysEnd: DateTime | undefined;
    authorisationNarcoticId: string | undefined;
    authorisationNarcoticRemarks: string | undefined;
    remark: string | undefined;
    details: DetailsDto[] | undefined;
    healthRegisterTransfer: boolean;
    dateOfRepresentationStart: DateTime | undefined;
    dateOfProvisoryRepresentationEnd: DateTime | undefined;
    levelOfWork: number | undefined;
    representationBusinessId: number | undefined;
    representationPersonId: number | undefined;
    automaticNotificationAndStatusChange: boolean;
    vaccinationLicenceId: string | undefined;
    dateOfIssueVaccinationLicence: DateTime | undefined;
    dateOfAssistanceStart: DateTime | undefined;
    dateOfProvisoryAssistanceEnd: DateTime | undefined;
    assistanceBusinessId: number | undefined;
}

export class UpdatePersonLicenceRenewalDto implements IUpdatePersonLicenceRenewalDto {
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    remark!: string | undefined;

    constructor(data?: IUpdatePersonLicenceRenewalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): UpdatePersonLicenceRenewalDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonLicenceRenewalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IUpdatePersonLicenceRenewalDto {
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    remark: string | undefined;
}

export class LimitedRepresentationPersonLicence implements ILimitedRepresentationPersonLicence {
    representationPerson!: Person;
    representationPersonId!: number | undefined;
    discriminator!: PersonLicenceType;
    person!: Person;
    personId!: number;
    naturalKey!: string;
    professionId!: string | undefined;
    postgraduateTitleId!: string | undefined;
    statusId!: string | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfNinetyDaysStart!: DateTime | undefined;
    dateOfNinetyDaysEnd!: DateTime | undefined;
    remark!: string | undefined;
    authorisationNarcoticId!: string | undefined;
    authorisationNarcoticRemarks!: string | undefined;
    healthRegisterTransfer!: boolean;
    healthRegisterSync!: DateTime | undefined;
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    licencedBusiness!: Business;
    licencedBusinessId!: number | undefined;
    sapInvoice!: SapInvoice;
    sapInvoiceId!: number | undefined;
    automaticNotificationAndStatusChange!: boolean;
    vaccinationLicenceId!: string | undefined;
    dateOfIssueVaccinationLicence!: DateTime | undefined;
    dateOfEndNotification1Sent!: DateTime | undefined;
    dateOfEndNotification2Sent!: DateTime | undefined;
    dateOfPendenceCreated!: DateTime | undefined;
    employments!: Employment[] | undefined;
    restrictions!: Restriction[] | undefined;
    renewals!: ProfessionalLicenceRenewal[] | undefined;
    documentLinks!: DocumentLinkPersonLicence[] | undefined;
    additionalLicenceInformations!: AdditionalInformationPersonLicence[] | undefined;
    professionalResponsibilities!: ProfessionalResponsibility[] | undefined;
    quarterlyReports!: QuarterlyReport[] | undefined;
    application!: Application;
    applicationId!: number | undefined;
    ehcTypeId!: string | undefined;
    details!: PersonLicenceDetails[] | undefined;
    readonly isFinalDecision!: boolean;
    migrationData!: MigrationData[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILimitedRepresentationPersonLicence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.representationPerson = _data["representationPerson"] ? Person.fromJS(_data["representationPerson"]) : <any>undefined;
            this.representationPersonId = _data["representationPersonId"];
            this.discriminator = _data["discriminator"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.personId = _data["personId"];
            this.naturalKey = _data["naturalKey"];
            this.professionId = _data["professionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.statusId = _data["statusId"];
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfNinetyDaysStart = _data["dateOfNinetyDaysStart"] ? DateTime.fromISO(_data["dateOfNinetyDaysStart"].toString()) : <any>undefined;
            this.dateOfNinetyDaysEnd = _data["dateOfNinetyDaysEnd"] ? DateTime.fromISO(_data["dateOfNinetyDaysEnd"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.authorisationNarcoticId = _data["authorisationNarcoticId"];
            this.authorisationNarcoticRemarks = _data["authorisationNarcoticRemarks"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.healthRegisterSync = _data["healthRegisterSync"] ? DateTime.fromISO(_data["healthRegisterSync"].toString()) : <any>undefined;
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.licencedBusiness = _data["licencedBusiness"] ? Business.fromJS(_data["licencedBusiness"]) : <any>undefined;
            this.licencedBusinessId = _data["licencedBusinessId"];
            this.sapInvoice = _data["sapInvoice"] ? SapInvoice.fromJS(_data["sapInvoice"]) : <any>undefined;
            this.sapInvoiceId = _data["sapInvoiceId"];
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.vaccinationLicenceId = _data["vaccinationLicenceId"];
            this.dateOfIssueVaccinationLicence = _data["dateOfIssueVaccinationLicence"] ? DateTime.fromISO(_data["dateOfIssueVaccinationLicence"].toString()) : <any>undefined;
            this.dateOfEndNotification1Sent = _data["dateOfEndNotification1Sent"] ? DateTime.fromISO(_data["dateOfEndNotification1Sent"].toString()) : <any>undefined;
            this.dateOfEndNotification2Sent = _data["dateOfEndNotification2Sent"] ? DateTime.fromISO(_data["dateOfEndNotification2Sent"].toString()) : <any>undefined;
            this.dateOfPendenceCreated = _data["dateOfPendenceCreated"] ? DateTime.fromISO(_data["dateOfPendenceCreated"].toString()) : <any>undefined;
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(Employment.fromJS(item));
            }
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(Restriction.fromJS(item));
            }
            if (Array.isArray(_data["renewals"])) {
                this.renewals = [] as any;
                for (let item of _data["renewals"])
                    this.renewals!.push(ProfessionalLicenceRenewal.fromJS(item));
            }
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkPersonLicence.fromJS(item));
            }
            if (Array.isArray(_data["additionalLicenceInformations"])) {
                this.additionalLicenceInformations = [] as any;
                for (let item of _data["additionalLicenceInformations"])
                    this.additionalLicenceInformations!.push(AdditionalInformationPersonLicence.fromJS(item));
            }
            if (Array.isArray(_data["professionalResponsibilities"])) {
                this.professionalResponsibilities = [] as any;
                for (let item of _data["professionalResponsibilities"])
                    this.professionalResponsibilities!.push(ProfessionalResponsibility.fromJS(item));
            }
            if (Array.isArray(_data["quarterlyReports"])) {
                this.quarterlyReports = [] as any;
                for (let item of _data["quarterlyReports"])
                    this.quarterlyReports!.push(QuarterlyReport.fromJS(item));
            }
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : <any>undefined;
            this.applicationId = _data["applicationId"];
            this.ehcTypeId = _data["ehcTypeId"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(PersonLicenceDetails.fromJS(item));
            }
            (<any>this).isFinalDecision = _data["isFinalDecision"];
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LimitedRepresentationPersonLicence {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedRepresentationPersonLicence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["representationPerson"] = this.representationPerson ? this.representationPerson.toJSON() : <any>undefined;
        data["representationPersonId"] = this.representationPersonId;
        data["discriminator"] = this.discriminator;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["naturalKey"] = this.naturalKey;
        data["professionId"] = this.professionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["statusId"] = this.statusId;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysStart"] = this.dateOfNinetyDaysStart ? this.dateOfNinetyDaysStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysEnd"] = this.dateOfNinetyDaysEnd ? this.dateOfNinetyDaysEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["authorisationNarcoticId"] = this.authorisationNarcoticId;
        data["authorisationNarcoticRemarks"] = this.authorisationNarcoticRemarks;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["healthRegisterSync"] = this.healthRegisterSync ? this.healthRegisterSync.toString() : <any>undefined;
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["licencedBusiness"] = this.licencedBusiness ? this.licencedBusiness.toJSON() : <any>undefined;
        data["licencedBusinessId"] = this.licencedBusinessId;
        data["sapInvoice"] = this.sapInvoice ? this.sapInvoice.toJSON() : <any>undefined;
        data["sapInvoiceId"] = this.sapInvoiceId;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["vaccinationLicenceId"] = this.vaccinationLicenceId;
        data["dateOfIssueVaccinationLicence"] = this.dateOfIssueVaccinationLicence ? this.dateOfIssueVaccinationLicence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndNotification1Sent"] = this.dateOfEndNotification1Sent ? this.dateOfEndNotification1Sent.toString() : <any>undefined;
        data["dateOfEndNotification2Sent"] = this.dateOfEndNotification2Sent ? this.dateOfEndNotification2Sent.toString() : <any>undefined;
        data["dateOfPendenceCreated"] = this.dateOfPendenceCreated ? this.dateOfPendenceCreated.toString() : <any>undefined;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        if (Array.isArray(this.renewals)) {
            data["renewals"] = [];
            for (let item of this.renewals)
                data["renewals"].push(item.toJSON());
        }
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalLicenceInformations)) {
            data["additionalLicenceInformations"] = [];
            for (let item of this.additionalLicenceInformations)
                data["additionalLicenceInformations"].push(item.toJSON());
        }
        if (Array.isArray(this.professionalResponsibilities)) {
            data["professionalResponsibilities"] = [];
            for (let item of this.professionalResponsibilities)
                data["professionalResponsibilities"].push(item.toJSON());
        }
        if (Array.isArray(this.quarterlyReports)) {
            data["quarterlyReports"] = [];
            for (let item of this.quarterlyReports)
                data["quarterlyReports"].push(item.toJSON());
        }
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["applicationId"] = this.applicationId;
        data["ehcTypeId"] = this.ehcTypeId;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["isFinalDecision"] = this.isFinalDecision;
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILimitedRepresentationPersonLicence {
    representationPerson: Person;
    representationPersonId: number | undefined;
    discriminator: PersonLicenceType;
    person: Person;
    personId: number;
    naturalKey: string;
    professionId: string | undefined;
    postgraduateTitleId: string | undefined;
    statusId: string | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfNinetyDaysStart: DateTime | undefined;
    dateOfNinetyDaysEnd: DateTime | undefined;
    remark: string | undefined;
    authorisationNarcoticId: string | undefined;
    authorisationNarcoticRemarks: string | undefined;
    healthRegisterTransfer: boolean;
    healthRegisterSync: DateTime | undefined;
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    licencedBusiness: Business;
    licencedBusinessId: number | undefined;
    sapInvoice: SapInvoice;
    sapInvoiceId: number | undefined;
    automaticNotificationAndStatusChange: boolean;
    vaccinationLicenceId: string | undefined;
    dateOfIssueVaccinationLicence: DateTime | undefined;
    dateOfEndNotification1Sent: DateTime | undefined;
    dateOfEndNotification2Sent: DateTime | undefined;
    dateOfPendenceCreated: DateTime | undefined;
    employments: Employment[] | undefined;
    restrictions: Restriction[] | undefined;
    renewals: ProfessionalLicenceRenewal[] | undefined;
    documentLinks: DocumentLinkPersonLicence[] | undefined;
    additionalLicenceInformations: AdditionalInformationPersonLicence[] | undefined;
    professionalResponsibilities: ProfessionalResponsibility[] | undefined;
    quarterlyReports: QuarterlyReport[] | undefined;
    application: Application;
    applicationId: number | undefined;
    ehcTypeId: string | undefined;
    details: PersonLicenceDetails[] | undefined;
    isFinalDecision: boolean;
    migrationData: MigrationData[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class PersonLicence implements IPersonLicence {
    discriminator!: PersonLicenceType;
    person!: Person;
    personId!: number;
    naturalKey!: string;
    professionId!: string | undefined;
    postgraduateTitleId!: string | undefined;
    statusId!: string | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfNinetyDaysStart!: DateTime | undefined;
    dateOfNinetyDaysEnd!: DateTime | undefined;
    remark!: string | undefined;
    authorisationNarcoticId!: string | undefined;
    authorisationNarcoticRemarks!: string | undefined;
    healthRegisterTransfer!: boolean;
    healthRegisterSync!: DateTime | undefined;
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    licencedBusiness!: Business;
    licencedBusinessId!: number | undefined;
    sapInvoice!: SapInvoice;
    sapInvoiceId!: number | undefined;
    automaticNotificationAndStatusChange!: boolean;
    vaccinationLicenceId!: string | undefined;
    dateOfIssueVaccinationLicence!: DateTime | undefined;
    dateOfEndNotification1Sent!: DateTime | undefined;
    dateOfEndNotification2Sent!: DateTime | undefined;
    dateOfPendenceCreated!: DateTime | undefined;
    employments!: Employment[] | undefined;
    restrictions!: Restriction[] | undefined;
    renewals!: ProfessionalLicenceRenewal[] | undefined;
    documentLinks!: DocumentLinkPersonLicence[] | undefined;
    additionalLicenceInformations!: AdditionalInformationPersonLicence[] | undefined;
    professionalResponsibilities!: ProfessionalResponsibility[] | undefined;
    quarterlyReports!: QuarterlyReport[] | undefined;
    application!: Application;
    applicationId!: number | undefined;
    ehcTypeId!: string | undefined;
    details!: PersonLicenceDetails[] | undefined;
    readonly isFinalDecision!: boolean;
    migrationData!: MigrationData[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IPersonLicence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.personId = _data["personId"];
            this.naturalKey = _data["naturalKey"];
            this.professionId = _data["professionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.statusId = _data["statusId"];
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfNinetyDaysStart = _data["dateOfNinetyDaysStart"] ? DateTime.fromISO(_data["dateOfNinetyDaysStart"].toString()) : <any>undefined;
            this.dateOfNinetyDaysEnd = _data["dateOfNinetyDaysEnd"] ? DateTime.fromISO(_data["dateOfNinetyDaysEnd"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.authorisationNarcoticId = _data["authorisationNarcoticId"];
            this.authorisationNarcoticRemarks = _data["authorisationNarcoticRemarks"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.healthRegisterSync = _data["healthRegisterSync"] ? DateTime.fromISO(_data["healthRegisterSync"].toString()) : <any>undefined;
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.licencedBusiness = _data["licencedBusiness"] ? Business.fromJS(_data["licencedBusiness"]) : <any>undefined;
            this.licencedBusinessId = _data["licencedBusinessId"];
            this.sapInvoice = _data["sapInvoice"] ? SapInvoice.fromJS(_data["sapInvoice"]) : <any>undefined;
            this.sapInvoiceId = _data["sapInvoiceId"];
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.vaccinationLicenceId = _data["vaccinationLicenceId"];
            this.dateOfIssueVaccinationLicence = _data["dateOfIssueVaccinationLicence"] ? DateTime.fromISO(_data["dateOfIssueVaccinationLicence"].toString()) : <any>undefined;
            this.dateOfEndNotification1Sent = _data["dateOfEndNotification1Sent"] ? DateTime.fromISO(_data["dateOfEndNotification1Sent"].toString()) : <any>undefined;
            this.dateOfEndNotification2Sent = _data["dateOfEndNotification2Sent"] ? DateTime.fromISO(_data["dateOfEndNotification2Sent"].toString()) : <any>undefined;
            this.dateOfPendenceCreated = _data["dateOfPendenceCreated"] ? DateTime.fromISO(_data["dateOfPendenceCreated"].toString()) : <any>undefined;
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(Employment.fromJS(item));
            }
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(Restriction.fromJS(item));
            }
            if (Array.isArray(_data["renewals"])) {
                this.renewals = [] as any;
                for (let item of _data["renewals"])
                    this.renewals!.push(ProfessionalLicenceRenewal.fromJS(item));
            }
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkPersonLicence.fromJS(item));
            }
            if (Array.isArray(_data["additionalLicenceInformations"])) {
                this.additionalLicenceInformations = [] as any;
                for (let item of _data["additionalLicenceInformations"])
                    this.additionalLicenceInformations!.push(AdditionalInformationPersonLicence.fromJS(item));
            }
            if (Array.isArray(_data["professionalResponsibilities"])) {
                this.professionalResponsibilities = [] as any;
                for (let item of _data["professionalResponsibilities"])
                    this.professionalResponsibilities!.push(ProfessionalResponsibility.fromJS(item));
            }
            if (Array.isArray(_data["quarterlyReports"])) {
                this.quarterlyReports = [] as any;
                for (let item of _data["quarterlyReports"])
                    this.quarterlyReports!.push(QuarterlyReport.fromJS(item));
            }
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : <any>undefined;
            this.applicationId = _data["applicationId"];
            this.ehcTypeId = _data["ehcTypeId"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(PersonLicenceDetails.fromJS(item));
            }
            (<any>this).isFinalDecision = _data["isFinalDecision"];
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PersonLicence {
        data = typeof data === 'object' ? data : {};
        let result = new PersonLicence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["naturalKey"] = this.naturalKey;
        data["professionId"] = this.professionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["statusId"] = this.statusId;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysStart"] = this.dateOfNinetyDaysStart ? this.dateOfNinetyDaysStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysEnd"] = this.dateOfNinetyDaysEnd ? this.dateOfNinetyDaysEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["authorisationNarcoticId"] = this.authorisationNarcoticId;
        data["authorisationNarcoticRemarks"] = this.authorisationNarcoticRemarks;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["healthRegisterSync"] = this.healthRegisterSync ? this.healthRegisterSync.toString() : <any>undefined;
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["licencedBusiness"] = this.licencedBusiness ? this.licencedBusiness.toJSON() : <any>undefined;
        data["licencedBusinessId"] = this.licencedBusinessId;
        data["sapInvoice"] = this.sapInvoice ? this.sapInvoice.toJSON() : <any>undefined;
        data["sapInvoiceId"] = this.sapInvoiceId;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["vaccinationLicenceId"] = this.vaccinationLicenceId;
        data["dateOfIssueVaccinationLicence"] = this.dateOfIssueVaccinationLicence ? this.dateOfIssueVaccinationLicence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndNotification1Sent"] = this.dateOfEndNotification1Sent ? this.dateOfEndNotification1Sent.toString() : <any>undefined;
        data["dateOfEndNotification2Sent"] = this.dateOfEndNotification2Sent ? this.dateOfEndNotification2Sent.toString() : <any>undefined;
        data["dateOfPendenceCreated"] = this.dateOfPendenceCreated ? this.dateOfPendenceCreated.toString() : <any>undefined;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        if (Array.isArray(this.renewals)) {
            data["renewals"] = [];
            for (let item of this.renewals)
                data["renewals"].push(item.toJSON());
        }
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalLicenceInformations)) {
            data["additionalLicenceInformations"] = [];
            for (let item of this.additionalLicenceInformations)
                data["additionalLicenceInformations"].push(item.toJSON());
        }
        if (Array.isArray(this.professionalResponsibilities)) {
            data["professionalResponsibilities"] = [];
            for (let item of this.professionalResponsibilities)
                data["professionalResponsibilities"].push(item.toJSON());
        }
        if (Array.isArray(this.quarterlyReports)) {
            data["quarterlyReports"] = [];
            for (let item of this.quarterlyReports)
                data["quarterlyReports"].push(item.toJSON());
        }
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["applicationId"] = this.applicationId;
        data["ehcTypeId"] = this.ehcTypeId;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["isFinalDecision"] = this.isFinalDecision;
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPersonLicence {
    discriminator: PersonLicenceType;
    person: Person;
    personId: number;
    naturalKey: string;
    professionId: string | undefined;
    postgraduateTitleId: string | undefined;
    statusId: string | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfNinetyDaysStart: DateTime | undefined;
    dateOfNinetyDaysEnd: DateTime | undefined;
    remark: string | undefined;
    authorisationNarcoticId: string | undefined;
    authorisationNarcoticRemarks: string | undefined;
    healthRegisterTransfer: boolean;
    healthRegisterSync: DateTime | undefined;
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    licencedBusiness: Business;
    licencedBusinessId: number | undefined;
    sapInvoice: SapInvoice;
    sapInvoiceId: number | undefined;
    automaticNotificationAndStatusChange: boolean;
    vaccinationLicenceId: string | undefined;
    dateOfIssueVaccinationLicence: DateTime | undefined;
    dateOfEndNotification1Sent: DateTime | undefined;
    dateOfEndNotification2Sent: DateTime | undefined;
    dateOfPendenceCreated: DateTime | undefined;
    employments: Employment[] | undefined;
    restrictions: Restriction[] | undefined;
    renewals: ProfessionalLicenceRenewal[] | undefined;
    documentLinks: DocumentLinkPersonLicence[] | undefined;
    additionalLicenceInformations: AdditionalInformationPersonLicence[] | undefined;
    professionalResponsibilities: ProfessionalResponsibility[] | undefined;
    quarterlyReports: QuarterlyReport[] | undefined;
    application: Application;
    applicationId: number | undefined;
    ehcTypeId: string | undefined;
    details: PersonLicenceDetails[] | undefined;
    isFinalDecision: boolean;
    migrationData: MigrationData[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class QuarterlyReport implements IQuarterlyReport {
    personLicenceId!: number;
    personLicence!: PersonLicence;
    dateOfReport!: DateTime;
    quarterId!: string | undefined;
    year!: number;
    businesses!: QuarterlyReportBusiness[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IQuarterlyReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personLicenceId = _data["personLicenceId"];
            this.personLicence = _data["personLicence"] ? PersonLicence.fromJS(_data["personLicence"]) : <any>undefined;
            this.dateOfReport = _data["dateOfReport"] ? DateTime.fromISO(_data["dateOfReport"].toString()) : <any>undefined;
            this.quarterId = _data["quarterId"];
            this.year = _data["year"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(QuarterlyReportBusiness.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QuarterlyReport {
        data = typeof data === 'object' ? data : {};
        let result = new QuarterlyReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personLicenceId"] = this.personLicenceId;
        data["personLicence"] = this.personLicence ? this.personLicence.toJSON() : <any>undefined;
        data["dateOfReport"] = this.dateOfReport ? this.dateOfReport.toFormat('yyyy-MM-dd') : <any>undefined;
        data["quarterId"] = this.quarterId;
        data["year"] = this.year;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IQuarterlyReport {
    personLicenceId: number;
    personLicence: PersonLicence;
    dateOfReport: DateTime;
    quarterId: string | undefined;
    year: number;
    businesses: QuarterlyReportBusiness[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class QuarterlyReportBusiness implements IQuarterlyReportBusiness {
    name!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    startDate!: DateTime;
    endDate!: DateTime;
    daysWorked!: number;

    constructor(data?: IQuarterlyReportBusiness) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.daysWorked = _data["daysWorked"];
        }
    }

    static fromJS(data: any): QuarterlyReportBusiness {
        data = typeof data === 'object' ? data : {};
        let result = new QuarterlyReportBusiness();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["startDate"] = this.startDate ? this.startDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["daysWorked"] = this.daysWorked;
        return data;
    }
}

export interface IQuarterlyReportBusiness {
    name: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    startDate: DateTime;
    endDate: DateTime;
    daysWorked: number;
}

export class ProfessionalLicenceRenewal implements IProfessionalLicenceRenewal {
    personLicenceId!: number;
    personLicence!: PersonLicence;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    remark!: string | undefined;
    applicationId!: number | undefined;
    sapInvoice!: SapInvoice;
    sapInvoiceId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IProfessionalLicenceRenewal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personLicenceId = _data["personLicenceId"];
            this.personLicence = _data["personLicence"] ? PersonLicence.fromJS(_data["personLicence"]) : <any>undefined;
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.applicationId = _data["applicationId"];
            this.sapInvoice = _data["sapInvoice"] ? SapInvoice.fromJS(_data["sapInvoice"]) : <any>undefined;
            this.sapInvoiceId = _data["sapInvoiceId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfessionalLicenceRenewal {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalLicenceRenewal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personLicenceId"] = this.personLicenceId;
        data["personLicence"] = this.personLicence ? this.personLicence.toJSON() : <any>undefined;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["applicationId"] = this.applicationId;
        data["sapInvoice"] = this.sapInvoice ? this.sapInvoice.toJSON() : <any>undefined;
        data["sapInvoiceId"] = this.sapInvoiceId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IProfessionalLicenceRenewal {
    personLicenceId: number;
    personLicence: PersonLicence;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    remark: string | undefined;
    applicationId: number | undefined;
    sapInvoice: SapInvoice;
    sapInvoiceId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class RepresentationPersonLicence implements IRepresentationPersonLicence {
    dateOfRepresentationStart!: DateTime | undefined;
    dateOfProvisoryRepresentationEnd!: DateTime | undefined;
    levelOfWork!: number | undefined;
    representationBusiness!: Business;
    representationBusinessId!: number | undefined;
    representationPerson!: Person;
    representationPersonId!: number | undefined;
    discriminator!: PersonLicenceType;
    person!: Person;
    personId!: number;
    naturalKey!: string;
    professionId!: string | undefined;
    postgraduateTitleId!: string | undefined;
    statusId!: string | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfNinetyDaysStart!: DateTime | undefined;
    dateOfNinetyDaysEnd!: DateTime | undefined;
    remark!: string | undefined;
    authorisationNarcoticId!: string | undefined;
    authorisationNarcoticRemarks!: string | undefined;
    healthRegisterTransfer!: boolean;
    healthRegisterSync!: DateTime | undefined;
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    licencedBusiness!: Business;
    licencedBusinessId!: number | undefined;
    sapInvoice!: SapInvoice;
    sapInvoiceId!: number | undefined;
    automaticNotificationAndStatusChange!: boolean;
    vaccinationLicenceId!: string | undefined;
    dateOfIssueVaccinationLicence!: DateTime | undefined;
    dateOfEndNotification1Sent!: DateTime | undefined;
    dateOfEndNotification2Sent!: DateTime | undefined;
    dateOfPendenceCreated!: DateTime | undefined;
    employments!: Employment[] | undefined;
    restrictions!: Restriction[] | undefined;
    renewals!: ProfessionalLicenceRenewal[] | undefined;
    documentLinks!: DocumentLinkPersonLicence[] | undefined;
    additionalLicenceInformations!: AdditionalInformationPersonLicence[] | undefined;
    professionalResponsibilities!: ProfessionalResponsibility[] | undefined;
    quarterlyReports!: QuarterlyReport[] | undefined;
    application!: Application;
    applicationId!: number | undefined;
    ehcTypeId!: string | undefined;
    details!: PersonLicenceDetails[] | undefined;
    readonly isFinalDecision!: boolean;
    migrationData!: MigrationData[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IRepresentationPersonLicence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfRepresentationStart = _data["dateOfRepresentationStart"] ? DateTime.fromISO(_data["dateOfRepresentationStart"].toString()) : <any>undefined;
            this.dateOfProvisoryRepresentationEnd = _data["dateOfProvisoryRepresentationEnd"] ? DateTime.fromISO(_data["dateOfProvisoryRepresentationEnd"].toString()) : <any>undefined;
            this.levelOfWork = _data["levelOfWork"];
            this.representationBusiness = _data["representationBusiness"] ? Business.fromJS(_data["representationBusiness"]) : <any>undefined;
            this.representationBusinessId = _data["representationBusinessId"];
            this.representationPerson = _data["representationPerson"] ? Person.fromJS(_data["representationPerson"]) : <any>undefined;
            this.representationPersonId = _data["representationPersonId"];
            this.discriminator = _data["discriminator"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.personId = _data["personId"];
            this.naturalKey = _data["naturalKey"];
            this.professionId = _data["professionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.statusId = _data["statusId"];
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfNinetyDaysStart = _data["dateOfNinetyDaysStart"] ? DateTime.fromISO(_data["dateOfNinetyDaysStart"].toString()) : <any>undefined;
            this.dateOfNinetyDaysEnd = _data["dateOfNinetyDaysEnd"] ? DateTime.fromISO(_data["dateOfNinetyDaysEnd"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.authorisationNarcoticId = _data["authorisationNarcoticId"];
            this.authorisationNarcoticRemarks = _data["authorisationNarcoticRemarks"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.healthRegisterSync = _data["healthRegisterSync"] ? DateTime.fromISO(_data["healthRegisterSync"].toString()) : <any>undefined;
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.licencedBusiness = _data["licencedBusiness"] ? Business.fromJS(_data["licencedBusiness"]) : <any>undefined;
            this.licencedBusinessId = _data["licencedBusinessId"];
            this.sapInvoice = _data["sapInvoice"] ? SapInvoice.fromJS(_data["sapInvoice"]) : <any>undefined;
            this.sapInvoiceId = _data["sapInvoiceId"];
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.vaccinationLicenceId = _data["vaccinationLicenceId"];
            this.dateOfIssueVaccinationLicence = _data["dateOfIssueVaccinationLicence"] ? DateTime.fromISO(_data["dateOfIssueVaccinationLicence"].toString()) : <any>undefined;
            this.dateOfEndNotification1Sent = _data["dateOfEndNotification1Sent"] ? DateTime.fromISO(_data["dateOfEndNotification1Sent"].toString()) : <any>undefined;
            this.dateOfEndNotification2Sent = _data["dateOfEndNotification2Sent"] ? DateTime.fromISO(_data["dateOfEndNotification2Sent"].toString()) : <any>undefined;
            this.dateOfPendenceCreated = _data["dateOfPendenceCreated"] ? DateTime.fromISO(_data["dateOfPendenceCreated"].toString()) : <any>undefined;
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(Employment.fromJS(item));
            }
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(Restriction.fromJS(item));
            }
            if (Array.isArray(_data["renewals"])) {
                this.renewals = [] as any;
                for (let item of _data["renewals"])
                    this.renewals!.push(ProfessionalLicenceRenewal.fromJS(item));
            }
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkPersonLicence.fromJS(item));
            }
            if (Array.isArray(_data["additionalLicenceInformations"])) {
                this.additionalLicenceInformations = [] as any;
                for (let item of _data["additionalLicenceInformations"])
                    this.additionalLicenceInformations!.push(AdditionalInformationPersonLicence.fromJS(item));
            }
            if (Array.isArray(_data["professionalResponsibilities"])) {
                this.professionalResponsibilities = [] as any;
                for (let item of _data["professionalResponsibilities"])
                    this.professionalResponsibilities!.push(ProfessionalResponsibility.fromJS(item));
            }
            if (Array.isArray(_data["quarterlyReports"])) {
                this.quarterlyReports = [] as any;
                for (let item of _data["quarterlyReports"])
                    this.quarterlyReports!.push(QuarterlyReport.fromJS(item));
            }
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : <any>undefined;
            this.applicationId = _data["applicationId"];
            this.ehcTypeId = _data["ehcTypeId"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(PersonLicenceDetails.fromJS(item));
            }
            (<any>this).isFinalDecision = _data["isFinalDecision"];
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RepresentationPersonLicence {
        data = typeof data === 'object' ? data : {};
        let result = new RepresentationPersonLicence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfRepresentationStart"] = this.dateOfRepresentationStart ? this.dateOfRepresentationStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfProvisoryRepresentationEnd"] = this.dateOfProvisoryRepresentationEnd ? this.dateOfProvisoryRepresentationEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfWork"] = this.levelOfWork;
        data["representationBusiness"] = this.representationBusiness ? this.representationBusiness.toJSON() : <any>undefined;
        data["representationBusinessId"] = this.representationBusinessId;
        data["representationPerson"] = this.representationPerson ? this.representationPerson.toJSON() : <any>undefined;
        data["representationPersonId"] = this.representationPersonId;
        data["discriminator"] = this.discriminator;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["naturalKey"] = this.naturalKey;
        data["professionId"] = this.professionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["statusId"] = this.statusId;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysStart"] = this.dateOfNinetyDaysStart ? this.dateOfNinetyDaysStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysEnd"] = this.dateOfNinetyDaysEnd ? this.dateOfNinetyDaysEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["authorisationNarcoticId"] = this.authorisationNarcoticId;
        data["authorisationNarcoticRemarks"] = this.authorisationNarcoticRemarks;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["healthRegisterSync"] = this.healthRegisterSync ? this.healthRegisterSync.toString() : <any>undefined;
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["licencedBusiness"] = this.licencedBusiness ? this.licencedBusiness.toJSON() : <any>undefined;
        data["licencedBusinessId"] = this.licencedBusinessId;
        data["sapInvoice"] = this.sapInvoice ? this.sapInvoice.toJSON() : <any>undefined;
        data["sapInvoiceId"] = this.sapInvoiceId;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["vaccinationLicenceId"] = this.vaccinationLicenceId;
        data["dateOfIssueVaccinationLicence"] = this.dateOfIssueVaccinationLicence ? this.dateOfIssueVaccinationLicence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndNotification1Sent"] = this.dateOfEndNotification1Sent ? this.dateOfEndNotification1Sent.toString() : <any>undefined;
        data["dateOfEndNotification2Sent"] = this.dateOfEndNotification2Sent ? this.dateOfEndNotification2Sent.toString() : <any>undefined;
        data["dateOfPendenceCreated"] = this.dateOfPendenceCreated ? this.dateOfPendenceCreated.toString() : <any>undefined;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        if (Array.isArray(this.renewals)) {
            data["renewals"] = [];
            for (let item of this.renewals)
                data["renewals"].push(item.toJSON());
        }
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalLicenceInformations)) {
            data["additionalLicenceInformations"] = [];
            for (let item of this.additionalLicenceInformations)
                data["additionalLicenceInformations"].push(item.toJSON());
        }
        if (Array.isArray(this.professionalResponsibilities)) {
            data["professionalResponsibilities"] = [];
            for (let item of this.professionalResponsibilities)
                data["professionalResponsibilities"].push(item.toJSON());
        }
        if (Array.isArray(this.quarterlyReports)) {
            data["quarterlyReports"] = [];
            for (let item of this.quarterlyReports)
                data["quarterlyReports"].push(item.toJSON());
        }
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["applicationId"] = this.applicationId;
        data["ehcTypeId"] = this.ehcTypeId;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["isFinalDecision"] = this.isFinalDecision;
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRepresentationPersonLicence {
    dateOfRepresentationStart: DateTime | undefined;
    dateOfProvisoryRepresentationEnd: DateTime | undefined;
    levelOfWork: number | undefined;
    representationBusiness: Business;
    representationBusinessId: number | undefined;
    representationPerson: Person;
    representationPersonId: number | undefined;
    discriminator: PersonLicenceType;
    person: Person;
    personId: number;
    naturalKey: string;
    professionId: string | undefined;
    postgraduateTitleId: string | undefined;
    statusId: string | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfNinetyDaysStart: DateTime | undefined;
    dateOfNinetyDaysEnd: DateTime | undefined;
    remark: string | undefined;
    authorisationNarcoticId: string | undefined;
    authorisationNarcoticRemarks: string | undefined;
    healthRegisterTransfer: boolean;
    healthRegisterSync: DateTime | undefined;
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    licencedBusiness: Business;
    licencedBusinessId: number | undefined;
    sapInvoice: SapInvoice;
    sapInvoiceId: number | undefined;
    automaticNotificationAndStatusChange: boolean;
    vaccinationLicenceId: string | undefined;
    dateOfIssueVaccinationLicence: DateTime | undefined;
    dateOfEndNotification1Sent: DateTime | undefined;
    dateOfEndNotification2Sent: DateTime | undefined;
    dateOfPendenceCreated: DateTime | undefined;
    employments: Employment[] | undefined;
    restrictions: Restriction[] | undefined;
    renewals: ProfessionalLicenceRenewal[] | undefined;
    documentLinks: DocumentLinkPersonLicence[] | undefined;
    additionalLicenceInformations: AdditionalInformationPersonLicence[] | undefined;
    professionalResponsibilities: ProfessionalResponsibility[] | undefined;
    quarterlyReports: QuarterlyReport[] | undefined;
    application: Application;
    applicationId: number | undefined;
    ehcTypeId: string | undefined;
    details: PersonLicenceDetails[] | undefined;
    isFinalDecision: boolean;
    migrationData: MigrationData[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ProfessionalResponsibility implements IProfessionalResponsibility {
    personLicenceId!: number;
    personLicence!: PersonLicence;
    typeId!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfProofRequested!: DateTime | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IProfessionalResponsibility) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personLicenceId = _data["personLicenceId"];
            this.personLicence = _data["personLicence"] ? PersonLicence.fromJS(_data["personLicence"]) : <any>undefined;
            this.typeId = _data["typeId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfProofRequested = _data["dateOfProofRequested"] ? DateTime.fromISO(_data["dateOfProofRequested"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfessionalResponsibility {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalResponsibility();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personLicenceId"] = this.personLicenceId;
        data["personLicence"] = this.personLicence ? this.personLicence.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfProofRequested"] = this.dateOfProofRequested ? this.dateOfProofRequested.toFormat('yyyy-MM-dd') : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IProfessionalResponsibility {
    personLicenceId: number;
    personLicence: PersonLicence;
    typeId: string | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfProofRequested: DateTime | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class Restriction implements IRestriction {
    personLicence!: PersonLicence;
    personLicenceId!: number | undefined;
    typeId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfCompliance!: DateTime | undefined;
    remark!: string | undefined;
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    healthRegisterTransfer!: boolean;
    healthRegisterSync!: DateTime | undefined;
    migrationData!: MigrationData[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IRestriction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personLicence = _data["personLicence"] ? PersonLicence.fromJS(_data["personLicence"]) : <any>undefined;
            this.personLicenceId = _data["personLicenceId"];
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfCompliance = _data["dateOfCompliance"] ? DateTime.fromISO(_data["dateOfCompliance"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.healthRegisterSync = _data["healthRegisterSync"] ? DateTime.fromISO(_data["healthRegisterSync"].toString()) : <any>undefined;
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Restriction {
        data = typeof data === 'object' ? data : {};
        let result = new Restriction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personLicence"] = this.personLicence ? this.personLicence.toJSON() : <any>undefined;
        data["personLicenceId"] = this.personLicenceId;
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCompliance"] = this.dateOfCompliance ? this.dateOfCompliance.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["healthRegisterSync"] = this.healthRegisterSync ? this.healthRegisterSync.toString() : <any>undefined;
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRestriction {
    personLicence: PersonLicence;
    personLicenceId: number | undefined;
    typeId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfCompliance: DateTime | undefined;
    remark: string | undefined;
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    healthRegisterTransfer: boolean;
    healthRegisterSync: DateTime | undefined;
    migrationData: MigrationData[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class TraineePersonLicenceDto implements ITraineePersonLicenceDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    birthName!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    genderId!: string | undefined;
    nationalityId!: string | undefined;
    email!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    bachelorNameOfUniversity!: string | undefined;
    bachelorPlaceOfIssue!: string | undefined;
    bachelorCountryId!: string | undefined;
    bachelorDateOfDegree!: DateTime | undefined;
    bachelorEnrolledForMasterDegreeSince!: DateTime | undefined;
    bachelorNumberOfCreditPointsMasterDegree!: string | undefined;

    constructor(data?: ITraineePersonLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.genderId = _data["genderId"];
            this.nationalityId = _data["nationalityId"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.bachelorNameOfUniversity = _data["bachelorNameOfUniversity"];
            this.bachelorPlaceOfIssue = _data["bachelorPlaceOfIssue"];
            this.bachelorCountryId = _data["bachelorCountryId"];
            this.bachelorDateOfDegree = _data["bachelorDateOfDegree"] ? DateTime.fromISO(_data["bachelorDateOfDegree"].toString()) : <any>undefined;
            this.bachelorEnrolledForMasterDegreeSince = _data["bachelorEnrolledForMasterDegreeSince"] ? DateTime.fromISO(_data["bachelorEnrolledForMasterDegreeSince"].toString()) : <any>undefined;
            this.bachelorNumberOfCreditPointsMasterDegree = _data["bachelorNumberOfCreditPointsMasterDegree"];
        }
    }

    static fromJS(data: any): TraineePersonLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TraineePersonLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["genderId"] = this.genderId;
        data["nationalityId"] = this.nationalityId;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["bachelorNameOfUniversity"] = this.bachelorNameOfUniversity;
        data["bachelorPlaceOfIssue"] = this.bachelorPlaceOfIssue;
        data["bachelorCountryId"] = this.bachelorCountryId;
        data["bachelorDateOfDegree"] = this.bachelorDateOfDegree ? this.bachelorDateOfDegree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["bachelorEnrolledForMasterDegreeSince"] = this.bachelorEnrolledForMasterDegreeSince ? this.bachelorEnrolledForMasterDegreeSince.toFormat('yyyy-MM-dd') : <any>undefined;
        data["bachelorNumberOfCreditPointsMasterDegree"] = this.bachelorNumberOfCreditPointsMasterDegree;
        return data;
    }
}

export interface ITraineePersonLicenceDto {
    firstName: string | undefined;
    lastName: string | undefined;
    birthName: string | undefined;
    dateOfBirth: DateTime | undefined;
    genderId: string | undefined;
    nationalityId: string | undefined;
    email: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    bachelorNameOfUniversity: string | undefined;
    bachelorPlaceOfIssue: string | undefined;
    bachelorCountryId: string | undefined;
    bachelorDateOfDegree: DateTime | undefined;
    bachelorEnrolledForMasterDegreeSince: DateTime | undefined;
    bachelorNumberOfCreditPointsMasterDegree: string | undefined;
}

export class CreatePostgraduateTitleDto implements ICreatePostgraduateTitleDto {
    personId!: number;
    titleId!: string;
    typeId!: string | undefined;
    organisation!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    issuingAuthority!: string | undefined;
    dateOfRecognition!: DateTime | undefined;
    placeOfRecognition!: string | undefined;
    recognitionAuthority!: string | undefined;
    dateOfEquivalence!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    verifiedBy!: string | undefined;
    specialKnowledgeBasis!: string | undefined;
    remarks!: string | undefined;
    overwriteWithHealthRegisterData!: boolean;
    courseOfEducationId!: string | undefined;

    constructor(data?: ICreatePostgraduateTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.titleId = _data["titleId"];
            this.typeId = _data["typeId"];
            this.organisation = _data["organisation"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.issuingAuthority = _data["issuingAuthority"];
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.placeOfRecognition = _data["placeOfRecognition"];
            this.recognitionAuthority = _data["recognitionAuthority"];
            this.dateOfEquivalence = _data["dateOfEquivalence"] ? DateTime.fromISO(_data["dateOfEquivalence"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.verifiedBy = _data["verifiedBy"];
            this.specialKnowledgeBasis = _data["specialKnowledgeBasis"];
            this.remarks = _data["remarks"];
            this.overwriteWithHealthRegisterData = _data["overwriteWithHealthRegisterData"];
            this.courseOfEducationId = _data["courseOfEducationId"];
        }
    }

    static fromJS(data: any): CreatePostgraduateTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePostgraduateTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["titleId"] = this.titleId;
        data["typeId"] = this.typeId;
        data["organisation"] = this.organisation;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["issuingAuthority"] = this.issuingAuthority;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfRecognition"] = this.placeOfRecognition;
        data["recognitionAuthority"] = this.recognitionAuthority;
        data["dateOfEquivalence"] = this.dateOfEquivalence ? this.dateOfEquivalence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["verifiedBy"] = this.verifiedBy;
        data["specialKnowledgeBasis"] = this.specialKnowledgeBasis;
        data["remarks"] = this.remarks;
        data["overwriteWithHealthRegisterData"] = this.overwriteWithHealthRegisterData;
        data["courseOfEducationId"] = this.courseOfEducationId;
        return data;
    }
}

export interface ICreatePostgraduateTitleDto {
    personId: number;
    titleId: string;
    typeId: string | undefined;
    organisation: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    issuingAuthority: string | undefined;
    dateOfRecognition: DateTime | undefined;
    placeOfRecognition: string | undefined;
    recognitionAuthority: string | undefined;
    dateOfEquivalence: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    verifiedBy: string | undefined;
    specialKnowledgeBasis: string | undefined;
    remarks: string | undefined;
    overwriteWithHealthRegisterData: boolean;
    courseOfEducationId: string | undefined;
}

export class GetPostgraduateTitleSearchOutput implements IGetPostgraduateTitleSearchOutput {
    totalCount!: number;
    items!: PostgraduateTitleSearchResultDto[] | undefined;

    constructor(data?: IGetPostgraduateTitleSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PostgraduateTitleSearchResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPostgraduateTitleSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPostgraduateTitleSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPostgraduateTitleSearchOutput {
    totalCount: number;
    items: PostgraduateTitleSearchResultDto[] | undefined;
}

export class PostgraduateTitleDto implements IPostgraduateTitleDto {
    titleId!: string;
    typeId!: string | undefined;
    organisation!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    issuingAuthority!: string | undefined;
    dateOfRecognition!: DateTime | undefined;
    placeOfRecognition!: string | undefined;
    recognitionAuthority!: string | undefined;
    dateOfEquivalence!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    verifiedBy!: string | undefined;
    specialKnowledgeBasis!: string | undefined;
    remarks!: string | undefined;
    overwriteWithHealthRegisterData!: boolean;
    courseOfEducationId!: string | undefined;

    constructor(data?: IPostgraduateTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.typeId = _data["typeId"];
            this.organisation = _data["organisation"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.issuingAuthority = _data["issuingAuthority"];
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.placeOfRecognition = _data["placeOfRecognition"];
            this.recognitionAuthority = _data["recognitionAuthority"];
            this.dateOfEquivalence = _data["dateOfEquivalence"] ? DateTime.fromISO(_data["dateOfEquivalence"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.verifiedBy = _data["verifiedBy"];
            this.specialKnowledgeBasis = _data["specialKnowledgeBasis"];
            this.remarks = _data["remarks"];
            this.overwriteWithHealthRegisterData = _data["overwriteWithHealthRegisterData"];
            this.courseOfEducationId = _data["courseOfEducationId"];
        }
    }

    static fromJS(data: any): PostgraduateTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostgraduateTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["typeId"] = this.typeId;
        data["organisation"] = this.organisation;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["issuingAuthority"] = this.issuingAuthority;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfRecognition"] = this.placeOfRecognition;
        data["recognitionAuthority"] = this.recognitionAuthority;
        data["dateOfEquivalence"] = this.dateOfEquivalence ? this.dateOfEquivalence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["verifiedBy"] = this.verifiedBy;
        data["specialKnowledgeBasis"] = this.specialKnowledgeBasis;
        data["remarks"] = this.remarks;
        data["overwriteWithHealthRegisterData"] = this.overwriteWithHealthRegisterData;
        data["courseOfEducationId"] = this.courseOfEducationId;
        return data;
    }
}

export interface IPostgraduateTitleDto {
    titleId: string;
    typeId: string | undefined;
    organisation: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    issuingAuthority: string | undefined;
    dateOfRecognition: DateTime | undefined;
    placeOfRecognition: string | undefined;
    recognitionAuthority: string | undefined;
    dateOfEquivalence: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    verifiedBy: string | undefined;
    specialKnowledgeBasis: string | undefined;
    remarks: string | undefined;
    overwriteWithHealthRegisterData: boolean;
    courseOfEducationId: string | undefined;
}

export class PostgraduateTitleSearchResultDto implements IPostgraduateTitleSearchResultDto {
    id!: number;
    titleId!: string | undefined;
    typeId!: string | undefined;
    organisation!: string | undefined;
    placeOfIssue!: string | undefined;
    issuingAuthority!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    placeOfRecognition!: string | undefined;
    recognitionAuthority!: string | undefined;
    dateOfEquivalence!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;

    constructor(data?: IPostgraduateTitleSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titleId = _data["titleId"];
            this.typeId = _data["typeId"];
            this.organisation = _data["organisation"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.issuingAuthority = _data["issuingAuthority"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.placeOfRecognition = _data["placeOfRecognition"];
            this.recognitionAuthority = _data["recognitionAuthority"];
            this.dateOfEquivalence = _data["dateOfEquivalence"] ? DateTime.fromISO(_data["dateOfEquivalence"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PostgraduateTitleSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostgraduateTitleSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titleId"] = this.titleId;
        data["typeId"] = this.typeId;
        data["organisation"] = this.organisation;
        data["placeOfIssue"] = this.placeOfIssue;
        data["issuingAuthority"] = this.issuingAuthority;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfRecognition"] = this.placeOfRecognition;
        data["recognitionAuthority"] = this.recognitionAuthority;
        data["dateOfEquivalence"] = this.dateOfEquivalence ? this.dateOfEquivalence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IPostgraduateTitleSearchResultDto {
    id: number;
    titleId: string | undefined;
    typeId: string | undefined;
    organisation: string | undefined;
    placeOfIssue: string | undefined;
    issuingAuthority: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    placeOfRecognition: string | undefined;
    recognitionAuthority: string | undefined;
    dateOfEquivalence: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
}

export class PostgraduateTitle implements IPostgraduateTitle {
    personId!: number;
    person!: Person;
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    overwriteWithHealthRegisterData!: boolean;
    isPrivatePostgraduateTitle!: boolean;
    title!: Code;
    titleId!: string | undefined;
    type!: Code;
    typeId!: string | undefined;
    organisation!: string | undefined;
    placeOfIssue!: string | undefined;
    issuingAuthority!: string | undefined;
    country!: Code;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    placeOfRecognition!: string | undefined;
    recognitionAuthority!: string | undefined;
    dateOfEquivalence!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    verifiedBy!: string | undefined;
    specialKnowledgeBasis!: string | undefined;
    remarks!: string | undefined;
    courseOfEducation!: Code;
    courseOfEducationId!: string | undefined;
    migrationData!: MigrationData[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IPostgraduateTitle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.overwriteWithHealthRegisterData = _data["overwriteWithHealthRegisterData"];
            this.isPrivatePostgraduateTitle = _data["isPrivatePostgraduateTitle"];
            this.title = _data["title"] ? Code.fromJS(_data["title"]) : <any>undefined;
            this.titleId = _data["titleId"];
            this.type = _data["type"] ? Code.fromJS(_data["type"]) : <any>undefined;
            this.typeId = _data["typeId"];
            this.organisation = _data["organisation"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.issuingAuthority = _data["issuingAuthority"];
            this.country = _data["country"] ? Code.fromJS(_data["country"]) : <any>undefined;
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.placeOfRecognition = _data["placeOfRecognition"];
            this.recognitionAuthority = _data["recognitionAuthority"];
            this.dateOfEquivalence = _data["dateOfEquivalence"] ? DateTime.fromISO(_data["dateOfEquivalence"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.verifiedBy = _data["verifiedBy"];
            this.specialKnowledgeBasis = _data["specialKnowledgeBasis"];
            this.remarks = _data["remarks"];
            this.courseOfEducation = _data["courseOfEducation"] ? Code.fromJS(_data["courseOfEducation"]) : <any>undefined;
            this.courseOfEducationId = _data["courseOfEducationId"];
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PostgraduateTitle {
        data = typeof data === 'object' ? data : {};
        let result = new PostgraduateTitle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["overwriteWithHealthRegisterData"] = this.overwriteWithHealthRegisterData;
        data["isPrivatePostgraduateTitle"] = this.isPrivatePostgraduateTitle;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["titleId"] = this.titleId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["organisation"] = this.organisation;
        data["placeOfIssue"] = this.placeOfIssue;
        data["issuingAuthority"] = this.issuingAuthority;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfRecognition"] = this.placeOfRecognition;
        data["recognitionAuthority"] = this.recognitionAuthority;
        data["dateOfEquivalence"] = this.dateOfEquivalence ? this.dateOfEquivalence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["verifiedBy"] = this.verifiedBy;
        data["specialKnowledgeBasis"] = this.specialKnowledgeBasis;
        data["remarks"] = this.remarks;
        data["courseOfEducation"] = this.courseOfEducation ? this.courseOfEducation.toJSON() : <any>undefined;
        data["courseOfEducationId"] = this.courseOfEducationId;
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPostgraduateTitle {
    personId: number;
    person: Person;
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    overwriteWithHealthRegisterData: boolean;
    isPrivatePostgraduateTitle: boolean;
    title: Code;
    titleId: string | undefined;
    type: Code;
    typeId: string | undefined;
    organisation: string | undefined;
    placeOfIssue: string | undefined;
    issuingAuthority: string | undefined;
    country: Code;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    placeOfRecognition: string | undefined;
    recognitionAuthority: string | undefined;
    dateOfEquivalence: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    verifiedBy: string | undefined;
    specialKnowledgeBasis: string | undefined;
    remarks: string | undefined;
    courseOfEducation: Code;
    courseOfEducationId: string | undefined;
    migrationData: MigrationData[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CreateOrUpdateSlapBusiness implements ICreateOrUpdateSlapBusiness {
    caseId!: string;
    reasonOfMutation!: string | undefined;
    dateOfMutation!: DateTime | undefined;
    businesses!: SlapBusinessDto[] | undefined;

    constructor(data?: ICreateOrUpdateSlapBusiness) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.reasonOfMutation = _data["reasonOfMutation"];
            this.dateOfMutation = _data["dateOfMutation"] ? DateTime.fromISO(_data["dateOfMutation"].toString()) : <any>undefined;
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(SlapBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateSlapBusiness {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSlapBusiness();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["reasonOfMutation"] = this.reasonOfMutation;
        data["dateOfMutation"] = this.dateOfMutation ? this.dateOfMutation.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateSlapBusiness {
    caseId: string;
    reasonOfMutation: string | undefined;
    dateOfMutation: DateTime | undefined;
    businesses: SlapBusinessDto[] | undefined;
}

export class CreateOrUpdateSlapContact implements ICreateOrUpdateSlapContact {
    caseId!: string;
    contact!: SlapContactDto;

    constructor(data?: ICreateOrUpdateSlapContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contact = new SlapContactDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.contact = _data["contact"] ? SlapContactDto.fromJS(_data["contact"]) : new SlapContactDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateSlapContact {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSlapContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateSlapContact {
    caseId: string;
    contact: SlapContactDto;
}

export class CreateSlapInput implements ICreateSlapInput {
    applicationType!: ApplicationType;
    legitimationId!: number;
    professionId!: string;

    constructor(data?: ICreateSlapInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationType = _data["applicationType"];
            this.legitimationId = _data["legitimationId"];
            this.professionId = _data["professionId"];
        }
    }

    static fromJS(data: any): CreateSlapInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSlapInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationType"] = this.applicationType;
        data["legitimationId"] = this.legitimationId;
        data["professionId"] = this.professionId;
        return data;
    }
}

export interface ICreateSlapInput {
    applicationType: ApplicationType;
    legitimationId: number;
    professionId: string;
}

export class CreateSlapOutput implements ICreateSlapOutput {
    caseId!: string | undefined;

    constructor(data?: ICreateSlapOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): CreateSlapOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSlapOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface ICreateSlapOutput {
    caseId: string | undefined;
}

export class GetSlapDocumentsInput implements IGetSlapDocumentsInput {
    caseId!: string;
    step!: SlapStatus;

    constructor(data?: IGetSlapDocumentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
        }
    }

    static fromJS(data: any): GetSlapDocumentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSlapDocumentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        return data;
    }
}

export interface IGetSlapDocumentsInput {
    caseId: string;
    step: SlapStatus;
}

export class GetSlapFileInput implements IGetSlapFileInput {
    caseId!: string;
    step!: SlapStatus;
    id!: number;

    constructor(data?: IGetSlapFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetSlapFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSlapFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetSlapFileInput {
    caseId: string;
    step: SlapStatus;
    id: number;
}

export class GetSlapInvoiceAddressOutput implements IGetSlapInvoiceAddressOutput {
    invoiceAddress!: SlapInvoiceAddressDto;
    contact!: InvoiceAddressDetailDto;
    employments!: SlapBusinessDto[] | undefined;
    onlyPrivateAddressAllowed!: boolean;
    selectedInvoiceAddressDetail!: InvoiceAddressDetailDto;

    constructor(data?: IGetSlapInvoiceAddressOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceAddress = _data["invoiceAddress"] ? SlapInvoiceAddressDto.fromJS(_data["invoiceAddress"]) : <any>undefined;
            this.contact = _data["contact"] ? InvoiceAddressDetailDto.fromJS(_data["contact"]) : <any>undefined;
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(SlapBusinessDto.fromJS(item));
            }
            this.onlyPrivateAddressAllowed = _data["onlyPrivateAddressAllowed"];
            this.selectedInvoiceAddressDetail = _data["selectedInvoiceAddressDetail"] ? InvoiceAddressDetailDto.fromJS(_data["selectedInvoiceAddressDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSlapInvoiceAddressOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSlapInvoiceAddressOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceAddress"] = this.invoiceAddress ? this.invoiceAddress.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        data["onlyPrivateAddressAllowed"] = this.onlyPrivateAddressAllowed;
        data["selectedInvoiceAddressDetail"] = this.selectedInvoiceAddressDetail ? this.selectedInvoiceAddressDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSlapInvoiceAddressOutput {
    invoiceAddress: SlapInvoiceAddressDto;
    contact: InvoiceAddressDetailDto;
    employments: SlapBusinessDto[] | undefined;
    onlyPrivateAddressAllowed: boolean;
    selectedInvoiceAddressDetail: InvoiceAddressDetailDto;
}

export class GetSlapOutput implements IGetSlapOutput {
    slap!: SlapDto;

    constructor(data?: IGetSlapOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.slap = _data["slap"] ? SlapDto.fromJS(_data["slap"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSlapOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSlapOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slap"] = this.slap ? this.slap.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSlapOutput {
    slap: SlapDto;
}

export class SlapBusinessDto implements ISlapBusinessDto {
    id!: number | undefined;
    employmentId!: number | undefined;
    businessId!: number | undefined;
    isPrivatePharmacyEmployment!: boolean;
    isMobileEmployment!: boolean;
    name!: string | undefined;
    legalFormId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    countryId!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    hasQAS!: string | undefined;

    constructor(data?: ISlapBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employmentId = _data["employmentId"];
            this.businessId = _data["businessId"];
            this.isPrivatePharmacyEmployment = _data["isPrivatePharmacyEmployment"];
            this.isMobileEmployment = _data["isMobileEmployment"];
            this.name = _data["name"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.countryId = _data["countryId"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.hasQAS = _data["hasQAS"];
        }
    }

    static fromJS(data: any): SlapBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlapBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employmentId"] = this.employmentId;
        data["businessId"] = this.businessId;
        data["isPrivatePharmacyEmployment"] = this.isPrivatePharmacyEmployment;
        data["isMobileEmployment"] = this.isMobileEmployment;
        data["name"] = this.name;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["countryId"] = this.countryId;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["hasQAS"] = this.hasQAS;
        return data;
    }
}

export interface ISlapBusinessDto {
    id: number | undefined;
    employmentId: number | undefined;
    businessId: number | undefined;
    isPrivatePharmacyEmployment: boolean;
    isMobileEmployment: boolean;
    name: string | undefined;
    legalFormId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    countryId: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    dateOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    hasQAS: string | undefined;
}

export class SlapContactDto implements ISlapContactDto {
    titleId!: string;
    languageOfCorrespondenceId!: string | undefined;
    street!: string;
    streetNr!: string | undefined;
    postCode!: string;
    city!: string;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    email!: string;
    phone1!: string;
    phone2!: string | undefined;
    titleAddressSwiss!: string | undefined;
    streetSwiss!: string | undefined;
    streetNrSwiss!: string | undefined;
    postCodeSwiss!: string | undefined;
    citySwiss!: string | undefined;
    postOfficeBoxSwiss!: string | undefined;
    addressAdditionSwiss!: string | undefined;

    constructor(data?: ISlapContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.titleAddressSwiss = _data["titleAddressSwiss"];
            this.streetSwiss = _data["streetSwiss"];
            this.streetNrSwiss = _data["streetNrSwiss"];
            this.postCodeSwiss = _data["postCodeSwiss"];
            this.citySwiss = _data["citySwiss"];
            this.postOfficeBoxSwiss = _data["postOfficeBoxSwiss"];
            this.addressAdditionSwiss = _data["addressAdditionSwiss"];
        }
    }

    static fromJS(data: any): SlapContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlapContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["titleAddressSwiss"] = this.titleAddressSwiss;
        data["streetSwiss"] = this.streetSwiss;
        data["streetNrSwiss"] = this.streetNrSwiss;
        data["postCodeSwiss"] = this.postCodeSwiss;
        data["citySwiss"] = this.citySwiss;
        data["postOfficeBoxSwiss"] = this.postOfficeBoxSwiss;
        data["addressAdditionSwiss"] = this.addressAdditionSwiss;
        return data;
    }
}

export interface ISlapContactDto {
    titleId: string;
    languageOfCorrespondenceId: string | undefined;
    street: string;
    streetNr: string | undefined;
    postCode: string;
    city: string;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    email: string;
    phone1: string;
    phone2: string | undefined;
    titleAddressSwiss: string | undefined;
    streetSwiss: string | undefined;
    streetNrSwiss: string | undefined;
    postCodeSwiss: string | undefined;
    citySwiss: string | undefined;
    postOfficeBoxSwiss: string | undefined;
    addressAdditionSwiss: string | undefined;
}

export class SlapDocumentsOutput implements ISlapDocumentsOutput {
    caseId!: string;
    documents!: GeneralDocumentGroupDto[];

    constructor(data?: ISlapDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SlapDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SlapDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISlapDocumentsOutput {
    caseId: string;
    documents: GeneralDocumentGroupDto[];
}

export class SlapDto implements ISlapDto {
    application!: ApplicationDto;
    professionId!: string | undefined;
    statusId!: SlapStatus;
    person!: SlapPersonDto;
    responsiblePerson!: SlapResponsiblePersonDto;
    contact!: SlapContactDto;
    reasonOfMutation!: string | undefined;
    dateOfMutation!: DateTime | undefined;
    businesses!: SlapBusinessDto[] | undefined;
    rangeOfProducts!: SlapRangeOfProductsDto;
    productPreparation!: SlapProductPreparationDto;
    invoiceAddress!: SlapInvoiceAddressDto;
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ISlapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.professionId = _data["professionId"];
            this.statusId = _data["statusId"];
            this.person = _data["person"] ? SlapPersonDto.fromJS(_data["person"]) : <any>undefined;
            this.responsiblePerson = _data["responsiblePerson"] ? SlapResponsiblePersonDto.fromJS(_data["responsiblePerson"]) : <any>undefined;
            this.contact = _data["contact"] ? SlapContactDto.fromJS(_data["contact"]) : <any>undefined;
            this.reasonOfMutation = _data["reasonOfMutation"];
            this.dateOfMutation = _data["dateOfMutation"] ? DateTime.fromISO(_data["dateOfMutation"].toString()) : <any>undefined;
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(SlapBusinessDto.fromJS(item));
            }
            this.rangeOfProducts = _data["rangeOfProducts"] ? SlapRangeOfProductsDto.fromJS(_data["rangeOfProducts"]) : <any>undefined;
            this.productPreparation = _data["productPreparation"] ? SlapProductPreparationDto.fromJS(_data["productPreparation"]) : <any>undefined;
            this.invoiceAddress = _data["invoiceAddress"] ? SlapInvoiceAddressDto.fromJS(_data["invoiceAddress"]) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SlapDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["professionId"] = this.professionId;
        data["statusId"] = this.statusId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["responsiblePerson"] = this.responsiblePerson ? this.responsiblePerson.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["reasonOfMutation"] = this.reasonOfMutation;
        data["dateOfMutation"] = this.dateOfMutation ? this.dateOfMutation.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        data["rangeOfProducts"] = this.rangeOfProducts ? this.rangeOfProducts.toJSON() : <any>undefined;
        data["productPreparation"] = this.productPreparation ? this.productPreparation.toJSON() : <any>undefined;
        data["invoiceAddress"] = this.invoiceAddress ? this.invoiceAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISlapDto {
    application: ApplicationDto;
    professionId: string | undefined;
    statusId: SlapStatus;
    person: SlapPersonDto;
    responsiblePerson: SlapResponsiblePersonDto;
    contact: SlapContactDto;
    reasonOfMutation: string | undefined;
    dateOfMutation: DateTime | undefined;
    businesses: SlapBusinessDto[] | undefined;
    rangeOfProducts: SlapRangeOfProductsDto;
    productPreparation: SlapProductPreparationDto;
    invoiceAddress: SlapInvoiceAddressDto;
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class SlapInvoiceAddressDto implements ISlapInvoiceAddressDto {
    typeOfAddressId!: string;
    employmentId!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    additionalAddressLine!: string | undefined;

    constructor(data?: ISlapInvoiceAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeOfAddressId = _data["typeOfAddressId"];
            this.employmentId = _data["employmentId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.additionalAddressLine = _data["additionalAddressLine"];
        }
    }

    static fromJS(data: any): SlapInvoiceAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlapInvoiceAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOfAddressId"] = this.typeOfAddressId;
        data["employmentId"] = this.employmentId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["additionalAddressLine"] = this.additionalAddressLine;
        return data;
    }
}

export interface ISlapInvoiceAddressDto {
    typeOfAddressId: string;
    employmentId: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    additionalAddressLine: string | undefined;
}

export class SlapPersonDto implements ISlapPersonDto {
    gln!: string | undefined;
    healthRegisterResult!: HealthRegisterIdentificationStatus;
    hasConfirmedData!: boolean;

    constructor(data?: ISlapPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.healthRegisterResult = _data["healthRegisterResult"];
            this.hasConfirmedData = _data["hasConfirmedData"];
        }
    }

    static fromJS(data: any): SlapPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlapPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["healthRegisterResult"] = this.healthRegisterResult;
        data["hasConfirmedData"] = this.hasConfirmedData;
        return data;
    }
}

export interface ISlapPersonDto {
    gln: string | undefined;
    healthRegisterResult: HealthRegisterIdentificationStatus;
    hasConfirmedData: boolean;
}

export class SlapProductPreparationDto implements ISlapProductPreparationDto {
    id!: number | undefined;
    hasLocalPreparationId!: string;
    hasExternalPreparationId!: string;
    hasUseOfDisposablesId!: string;

    constructor(data?: ISlapProductPreparationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hasLocalPreparationId = _data["hasLocalPreparationId"];
            this.hasExternalPreparationId = _data["hasExternalPreparationId"];
            this.hasUseOfDisposablesId = _data["hasUseOfDisposablesId"];
        }
    }

    static fromJS(data: any): SlapProductPreparationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlapProductPreparationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hasLocalPreparationId"] = this.hasLocalPreparationId;
        data["hasExternalPreparationId"] = this.hasExternalPreparationId;
        data["hasUseOfDisposablesId"] = this.hasUseOfDisposablesId;
        return data;
    }
}

export interface ISlapProductPreparationDto {
    id: number | undefined;
    hasLocalPreparationId: string;
    hasExternalPreparationId: string;
    hasUseOfDisposablesId: string;
}

export class SlapRangeOfProductsDto implements ISlapRangeOfProductsDto {
    id!: number | undefined;
    hasOnlyLimitedId!: string | undefined;
    hasRefrigeratorRequiredId!: string | undefined;
    hasNarcoticsId!: string | undefined;
    hasPsychotropicsId!: string | undefined;

    constructor(data?: ISlapRangeOfProductsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hasOnlyLimitedId = _data["hasOnlyLimitedId"];
            this.hasRefrigeratorRequiredId = _data["hasRefrigeratorRequiredId"];
            this.hasNarcoticsId = _data["hasNarcoticsId"];
            this.hasPsychotropicsId = _data["hasPsychotropicsId"];
        }
    }

    static fromJS(data: any): SlapRangeOfProductsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlapRangeOfProductsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hasOnlyLimitedId"] = this.hasOnlyLimitedId;
        data["hasRefrigeratorRequiredId"] = this.hasRefrigeratorRequiredId;
        data["hasNarcoticsId"] = this.hasNarcoticsId;
        data["hasPsychotropicsId"] = this.hasPsychotropicsId;
        return data;
    }
}

export interface ISlapRangeOfProductsDto {
    id: number | undefined;
    hasOnlyLimitedId: string | undefined;
    hasRefrigeratorRequiredId: string | undefined;
    hasNarcoticsId: string | undefined;
    hasPsychotropicsId: string | undefined;
}

export class SlapResponsiblePersonDto implements ISlapResponsiblePersonDto {
    typeOfPractice!: string | undefined;
    gln!: string | undefined;
    healthRegisterResult!: HealthRegisterIdentificationStatus;
    hasConfirmedData!: boolean | undefined;
    function!: string | undefined;
    levelOfEmployment!: number | undefined;
    dateOfStart!: DateTime | undefined;

    constructor(data?: ISlapResponsiblePersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeOfPractice = _data["typeOfPractice"];
            this.gln = _data["gln"];
            this.healthRegisterResult = _data["healthRegisterResult"];
            this.hasConfirmedData = _data["hasConfirmedData"];
            this.function = _data["function"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfStart = _data["dateOfStart"] ? DateTime.fromISO(_data["dateOfStart"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SlapResponsiblePersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlapResponsiblePersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOfPractice"] = this.typeOfPractice;
        data["gln"] = this.gln;
        data["healthRegisterResult"] = this.healthRegisterResult;
        data["hasConfirmedData"] = this.hasConfirmedData;
        data["function"] = this.function;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfStart"] = this.dateOfStart ? this.dateOfStart.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface ISlapResponsiblePersonDto {
    typeOfPractice: string | undefined;
    gln: string | undefined;
    healthRegisterResult: HealthRegisterIdentificationStatus;
    hasConfirmedData: boolean | undefined;
    function: string | undefined;
    levelOfEmployment: number | undefined;
    dateOfStart: DateTime | undefined;
}

export enum SlapStatus {
    Person = 0,
    Business = 1,
    RangeOfProducts = 3,
    ProductPreparation = 4,
    InvoiceAddress = 5,
    Contact = 6,
    ResponsiblePerson = 7,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export class ProfessionalLicenceRestrictionDto implements IProfessionalLicenceRestrictionDto {
    typeId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    id!: number;

    constructor(data?: IProfessionalLicenceRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfessionalLicenceRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalLicenceRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IProfessionalLicenceRestrictionDto {
    typeId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    id: number;
}

export class GetPsyRegPersonDetailedOutput implements IGetPsyRegPersonDetailedOutput {
    psyRegPerson!: PsyRegPersonDetailedDto;

    constructor(data?: IGetPsyRegPersonDetailedOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.psyRegPerson = _data["psyRegPerson"] ? PsyRegPersonDetailedDto.fromJS(_data["psyRegPerson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPsyRegPersonDetailedOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPsyRegPersonDetailedOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psyRegPerson"] = this.psyRegPerson ? this.psyRegPerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPsyRegPersonDetailedOutput {
    psyRegPerson: PsyRegPersonDetailedDto;
}

export class GetPsyRegPersonOutput implements IGetPsyRegPersonOutput {
    psyRegPerson!: PsyRegPersonDto;

    constructor(data?: IGetPsyRegPersonOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.psyRegPerson = _data["psyRegPerson"] ? PsyRegPersonDto.fromJS(_data["psyRegPerson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPsyRegPersonOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPsyRegPersonOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psyRegPerson"] = this.psyRegPerson ? this.psyRegPerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPsyRegPersonOutput {
    psyRegPerson: PsyRegPersonDto;
}

export class PsyRegAuthorisationDto implements IPsyRegAuthorisationDto {
    id!: number;
    personId!: number;
    profession!: string | undefined;
    licenceType!: PersonLicenceType;
    licenceStatus!: HealthRegisterCodeDto;
    canton!: HealthRegisterCodeDto;
    decisionDate!: DateTime | undefined;
    limitationDate!: DateTime | undefined;
    rechtsgrundlage!: HealthRegisterCodeDto;
    comment!: string | undefined;
    languageCompetences!: string | undefined;
    languageSkills!: HealthRegisterCode[] | undefined;

    constructor(data?: IPsyRegAuthorisationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.profession = _data["profession"];
            this.licenceType = _data["licenceType"];
            this.licenceStatus = _data["licenceStatus"] ? HealthRegisterCodeDto.fromJS(_data["licenceStatus"]) : <any>undefined;
            this.canton = _data["canton"] ? HealthRegisterCodeDto.fromJS(_data["canton"]) : <any>undefined;
            this.decisionDate = _data["decisionDate"] ? DateTime.fromISO(_data["decisionDate"].toString()) : <any>undefined;
            this.limitationDate = _data["limitationDate"] ? DateTime.fromISO(_data["limitationDate"].toString()) : <any>undefined;
            this.rechtsgrundlage = _data["rechtsgrundlage"] ? HealthRegisterCodeDto.fromJS(_data["rechtsgrundlage"]) : <any>undefined;
            this.comment = _data["comment"];
            this.languageCompetences = _data["languageCompetences"];
            if (Array.isArray(_data["languageSkills"])) {
                this.languageSkills = [] as any;
                for (let item of _data["languageSkills"])
                    this.languageSkills!.push(HealthRegisterCode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PsyRegAuthorisationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PsyRegAuthorisationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["profession"] = this.profession;
        data["licenceType"] = this.licenceType;
        data["licenceStatus"] = this.licenceStatus ? this.licenceStatus.toJSON() : <any>undefined;
        data["canton"] = this.canton ? this.canton.toJSON() : <any>undefined;
        data["decisionDate"] = this.decisionDate ? this.decisionDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["limitationDate"] = this.limitationDate ? this.limitationDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["rechtsgrundlage"] = this.rechtsgrundlage ? this.rechtsgrundlage.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        data["languageCompetences"] = this.languageCompetences;
        if (Array.isArray(this.languageSkills)) {
            data["languageSkills"] = [];
            for (let item of this.languageSkills)
                data["languageSkills"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPsyRegAuthorisationDto {
    id: number;
    personId: number;
    profession: string | undefined;
    licenceType: PersonLicenceType;
    licenceStatus: HealthRegisterCodeDto;
    canton: HealthRegisterCodeDto;
    decisionDate: DateTime | undefined;
    limitationDate: DateTime | undefined;
    rechtsgrundlage: HealthRegisterCodeDto;
    comment: string | undefined;
    languageCompetences: string | undefined;
    languageSkills: HealthRegisterCode[] | undefined;
}

export class PsyRegEducationDto implements IPsyRegEducationDto {
    id!: number;
    personId!: number;
    name!: string | undefined;
    firstname!: string | undefined;
    typeId!: string | undefined;
    profession!: HealthRegisterCodeDto;
    issuingPlace!: string | undefined;
    issuingCountry!: HealthRegisterCodeDto;
    postgraduateKindLabel!: HealthRegisterLabelDto;
    issuingDate!: DateTime | undefined;
    recognitionDate!: DateTime | undefined;
    kind!: HealthRegisterCode;
    courseOfEducationId!: HealthRegisterCodeDto;
    organizationOfIssuance!: string | undefined;
    isPostgraduateTitle!: boolean;

    constructor(data?: IPsyRegEducationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.name = _data["name"];
            this.firstname = _data["firstname"];
            this.typeId = _data["typeId"];
            this.profession = _data["profession"] ? HealthRegisterCodeDto.fromJS(_data["profession"]) : <any>undefined;
            this.issuingPlace = _data["issuingPlace"];
            this.issuingCountry = _data["issuingCountry"] ? HealthRegisterCodeDto.fromJS(_data["issuingCountry"]) : <any>undefined;
            this.postgraduateKindLabel = _data["postgraduateKindLabel"] ? HealthRegisterLabelDto.fromJS(_data["postgraduateKindLabel"]) : <any>undefined;
            this.issuingDate = _data["issuingDate"] ? DateTime.fromISO(_data["issuingDate"].toString()) : <any>undefined;
            this.recognitionDate = _data["recognitionDate"] ? DateTime.fromISO(_data["recognitionDate"].toString()) : <any>undefined;
            this.kind = _data["kind"] ? HealthRegisterCode.fromJS(_data["kind"]) : <any>undefined;
            this.courseOfEducationId = _data["courseOfEducationId"] ? HealthRegisterCodeDto.fromJS(_data["courseOfEducationId"]) : <any>undefined;
            this.organizationOfIssuance = _data["organizationOfIssuance"];
            this.isPostgraduateTitle = _data["isPostgraduateTitle"];
        }
    }

    static fromJS(data: any): PsyRegEducationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PsyRegEducationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        data["typeId"] = this.typeId;
        data["profession"] = this.profession ? this.profession.toJSON() : <any>undefined;
        data["issuingPlace"] = this.issuingPlace;
        data["issuingCountry"] = this.issuingCountry ? this.issuingCountry.toJSON() : <any>undefined;
        data["postgraduateKindLabel"] = this.postgraduateKindLabel ? this.postgraduateKindLabel.toJSON() : <any>undefined;
        data["issuingDate"] = this.issuingDate ? this.issuingDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["recognitionDate"] = this.recognitionDate ? this.recognitionDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["kind"] = this.kind ? this.kind.toJSON() : <any>undefined;
        data["courseOfEducationId"] = this.courseOfEducationId ? this.courseOfEducationId.toJSON() : <any>undefined;
        data["organizationOfIssuance"] = this.organizationOfIssuance;
        data["isPostgraduateTitle"] = this.isPostgraduateTitle;
        return data;
    }
}

export interface IPsyRegEducationDto {
    id: number;
    personId: number;
    name: string | undefined;
    firstname: string | undefined;
    typeId: string | undefined;
    profession: HealthRegisterCodeDto;
    issuingPlace: string | undefined;
    issuingCountry: HealthRegisterCodeDto;
    postgraduateKindLabel: HealthRegisterLabelDto;
    issuingDate: DateTime | undefined;
    recognitionDate: DateTime | undefined;
    kind: HealthRegisterCode;
    courseOfEducationId: HealthRegisterCodeDto;
    organizationOfIssuance: string | undefined;
    isPostgraduateTitle: boolean;
}

export class PsyRegPersonDetailedDto implements IPsyRegPersonDetailedDto {
    gender!: HealthRegisterCodeDto;
    birthdate!: DateTime | undefined;
    dateOfDeath!: DateTime | undefined;
    dataDeservingProtection!: boolean | undefined;
    cantonalLicenceRestrictions!: string[] | undefined;
    languageOfCorrespondence!: HealthRegisterCodeDto;
    name!: string | undefined;
    firstName!: string | undefined;
    gln!: string | undefined;
    birthYear!: string | undefined;
    psyRegAuthorisations!: PsyRegAuthorisationDto[] | undefined;
    psyRegEducations!: PsyRegEducationDto[] | undefined;
    nationality1!: HealthRegisterCodeDto;
    nationality2!: HealthRegisterCodeDto;
    queryTime!: DateTime | undefined;
    languageSkills!: HealthRegisterCode[] | undefined;
    id!: number;

    constructor(data?: IPsyRegPersonDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gender = _data["gender"] ? HealthRegisterCodeDto.fromJS(_data["gender"]) : <any>undefined;
            this.birthdate = _data["birthdate"] ? DateTime.fromISO(_data["birthdate"].toString()) : <any>undefined;
            this.dateOfDeath = _data["dateOfDeath"] ? DateTime.fromISO(_data["dateOfDeath"].toString()) : <any>undefined;
            this.dataDeservingProtection = _data["dataDeservingProtection"];
            if (Array.isArray(_data["cantonalLicenceRestrictions"])) {
                this.cantonalLicenceRestrictions = [] as any;
                for (let item of _data["cantonalLicenceRestrictions"])
                    this.cantonalLicenceRestrictions!.push(item);
            }
            this.languageOfCorrespondence = _data["languageOfCorrespondence"] ? HealthRegisterCodeDto.fromJS(_data["languageOfCorrespondence"]) : <any>undefined;
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.gln = _data["gln"];
            this.birthYear = _data["birthYear"];
            if (Array.isArray(_data["psyRegAuthorisations"])) {
                this.psyRegAuthorisations = [] as any;
                for (let item of _data["psyRegAuthorisations"])
                    this.psyRegAuthorisations!.push(PsyRegAuthorisationDto.fromJS(item));
            }
            if (Array.isArray(_data["psyRegEducations"])) {
                this.psyRegEducations = [] as any;
                for (let item of _data["psyRegEducations"])
                    this.psyRegEducations!.push(PsyRegEducationDto.fromJS(item));
            }
            this.nationality1 = _data["nationality1"] ? HealthRegisterCodeDto.fromJS(_data["nationality1"]) : <any>undefined;
            this.nationality2 = _data["nationality2"] ? HealthRegisterCodeDto.fromJS(_data["nationality2"]) : <any>undefined;
            this.queryTime = _data["queryTime"] ? DateTime.fromISO(_data["queryTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["languageSkills"])) {
                this.languageSkills = [] as any;
                for (let item of _data["languageSkills"])
                    this.languageSkills!.push(HealthRegisterCode.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PsyRegPersonDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new PsyRegPersonDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["birthdate"] = this.birthdate ? this.birthdate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDeath"] = this.dateOfDeath ? this.dateOfDeath.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dataDeservingProtection"] = this.dataDeservingProtection;
        if (Array.isArray(this.cantonalLicenceRestrictions)) {
            data["cantonalLicenceRestrictions"] = [];
            for (let item of this.cantonalLicenceRestrictions)
                data["cantonalLicenceRestrictions"].push(item);
        }
        data["languageOfCorrespondence"] = this.languageOfCorrespondence ? this.languageOfCorrespondence.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["gln"] = this.gln;
        data["birthYear"] = this.birthYear;
        if (Array.isArray(this.psyRegAuthorisations)) {
            data["psyRegAuthorisations"] = [];
            for (let item of this.psyRegAuthorisations)
                data["psyRegAuthorisations"].push(item.toJSON());
        }
        if (Array.isArray(this.psyRegEducations)) {
            data["psyRegEducations"] = [];
            for (let item of this.psyRegEducations)
                data["psyRegEducations"].push(item.toJSON());
        }
        data["nationality1"] = this.nationality1 ? this.nationality1.toJSON() : <any>undefined;
        data["nationality2"] = this.nationality2 ? this.nationality2.toJSON() : <any>undefined;
        data["queryTime"] = this.queryTime ? this.queryTime.toString() : <any>undefined;
        if (Array.isArray(this.languageSkills)) {
            data["languageSkills"] = [];
            for (let item of this.languageSkills)
                data["languageSkills"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IPsyRegPersonDetailedDto {
    gender: HealthRegisterCodeDto;
    birthdate: DateTime | undefined;
    dateOfDeath: DateTime | undefined;
    dataDeservingProtection: boolean | undefined;
    cantonalLicenceRestrictions: string[] | undefined;
    languageOfCorrespondence: HealthRegisterCodeDto;
    name: string | undefined;
    firstName: string | undefined;
    gln: string | undefined;
    birthYear: string | undefined;
    psyRegAuthorisations: PsyRegAuthorisationDto[] | undefined;
    psyRegEducations: PsyRegEducationDto[] | undefined;
    nationality1: HealthRegisterCodeDto;
    nationality2: HealthRegisterCodeDto;
    queryTime: DateTime | undefined;
    languageSkills: HealthRegisterCode[] | undefined;
    id: number;
}

export class PsyRegPersonDto implements IPsyRegPersonDto {
    name!: string | undefined;
    firstName!: string | undefined;
    gln!: string | undefined;
    birthYear!: string | undefined;
    psyRegAuthorisations!: PsyRegAuthorisationDto[] | undefined;
    psyRegEducations!: PsyRegEducationDto[] | undefined;
    nationality1!: HealthRegisterCodeDto;
    nationality2!: HealthRegisterCodeDto;
    queryTime!: DateTime | undefined;
    languageSkills!: HealthRegisterCode[] | undefined;
    id!: number;

    constructor(data?: IPsyRegPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.gln = _data["gln"];
            this.birthYear = _data["birthYear"];
            if (Array.isArray(_data["psyRegAuthorisations"])) {
                this.psyRegAuthorisations = [] as any;
                for (let item of _data["psyRegAuthorisations"])
                    this.psyRegAuthorisations!.push(PsyRegAuthorisationDto.fromJS(item));
            }
            if (Array.isArray(_data["psyRegEducations"])) {
                this.psyRegEducations = [] as any;
                for (let item of _data["psyRegEducations"])
                    this.psyRegEducations!.push(PsyRegEducationDto.fromJS(item));
            }
            this.nationality1 = _data["nationality1"] ? HealthRegisterCodeDto.fromJS(_data["nationality1"]) : <any>undefined;
            this.nationality2 = _data["nationality2"] ? HealthRegisterCodeDto.fromJS(_data["nationality2"]) : <any>undefined;
            this.queryTime = _data["queryTime"] ? DateTime.fromISO(_data["queryTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["languageSkills"])) {
                this.languageSkills = [] as any;
                for (let item of _data["languageSkills"])
                    this.languageSkills!.push(HealthRegisterCode.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PsyRegPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new PsyRegPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["gln"] = this.gln;
        data["birthYear"] = this.birthYear;
        if (Array.isArray(this.psyRegAuthorisations)) {
            data["psyRegAuthorisations"] = [];
            for (let item of this.psyRegAuthorisations)
                data["psyRegAuthorisations"].push(item.toJSON());
        }
        if (Array.isArray(this.psyRegEducations)) {
            data["psyRegEducations"] = [];
            for (let item of this.psyRegEducations)
                data["psyRegEducations"].push(item.toJSON());
        }
        data["nationality1"] = this.nationality1 ? this.nationality1.toJSON() : <any>undefined;
        data["nationality2"] = this.nationality2 ? this.nationality2.toJSON() : <any>undefined;
        data["queryTime"] = this.queryTime ? this.queryTime.toString() : <any>undefined;
        if (Array.isArray(this.languageSkills)) {
            data["languageSkills"] = [];
            for (let item of this.languageSkills)
                data["languageSkills"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IPsyRegPersonDto {
    name: string | undefined;
    firstName: string | undefined;
    gln: string | undefined;
    birthYear: string | undefined;
    psyRegAuthorisations: PsyRegAuthorisationDto[] | undefined;
    psyRegEducations: PsyRegEducationDto[] | undefined;
    nationality1: HealthRegisterCodeDto;
    nationality2: HealthRegisterCodeDto;
    queryTime: DateTime | undefined;
    languageSkills: HealthRegisterCode[] | undefined;
    id: number;
}

export class GetQuartelyReportDto implements IGetQuartelyReportDto {
    personLicenceId!: number;
    dateOfReport!: DateTime;
    quarterId!: string | undefined;
    year!: number;
    businesses!: GetQuarterlyReportBusinessDto[] | undefined;
    getTotalNumberOfWorkedDays!: number;
    id!: number;

    constructor(data?: IGetQuartelyReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personLicenceId = _data["personLicenceId"];
            this.dateOfReport = _data["dateOfReport"] ? DateTime.fromISO(_data["dateOfReport"].toString()) : <any>undefined;
            this.quarterId = _data["quarterId"];
            this.year = _data["year"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(GetQuarterlyReportBusinessDto.fromJS(item));
            }
            this.getTotalNumberOfWorkedDays = _data["getTotalNumberOfWorkedDays"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetQuartelyReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuartelyReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personLicenceId"] = this.personLicenceId;
        data["dateOfReport"] = this.dateOfReport ? this.dateOfReport.toFormat('yyyy-MM-dd') : <any>undefined;
        data["quarterId"] = this.quarterId;
        data["year"] = this.year;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        data["getTotalNumberOfWorkedDays"] = this.getTotalNumberOfWorkedDays;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetQuartelyReportDto {
    personLicenceId: number;
    dateOfReport: DateTime;
    quarterId: string | undefined;
    year: number;
    businesses: GetQuarterlyReportBusinessDto[] | undefined;
    getTotalNumberOfWorkedDays: number;
    id: number;
}

export class GetQuarterlyReportBusinessDto implements IGetQuarterlyReportBusinessDto {
    name!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    startDate!: DateTime;
    endDate!: DateTime;
    daysWorked!: number;

    constructor(data?: IGetQuarterlyReportBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.daysWorked = _data["daysWorked"];
        }
    }

    static fromJS(data: any): GetQuarterlyReportBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuarterlyReportBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["startDate"] = this.startDate ? this.startDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["daysWorked"] = this.daysWorked;
        return data;
    }
}

export interface IGetQuarterlyReportBusinessDto {
    name: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    startDate: DateTime;
    endDate: DateTime;
    daysWorked: number;
}

export class GetRegionDto implements IGetRegionDto {
    internalNumber!: number | undefined;
    bfsNumbers!: string[] | undefined;
    codeIsActive!: boolean;
    id!: string | undefined;

    constructor(data?: IGetRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalNumber = _data["internalNumber"];
            if (Array.isArray(_data["bfsNumbers"])) {
                this.bfsNumbers = [] as any;
                for (let item of _data["bfsNumbers"])
                    this.bfsNumbers!.push(item);
            }
            this.codeIsActive = _data["codeIsActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetRegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalNumber"] = this.internalNumber;
        if (Array.isArray(this.bfsNumbers)) {
            data["bfsNumbers"] = [];
            for (let item of this.bfsNumbers)
                data["bfsNumbers"].push(item);
        }
        data["codeIsActive"] = this.codeIsActive;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetRegionDto {
    internalNumber: number | undefined;
    bfsNumbers: string[] | undefined;
    codeIsActive: boolean;
    id: string | undefined;
}

export class DocumentLinkReminder implements IDocumentLinkReminder {
    reminder!: Reminder;
    reminderId!: number;
    discriminator!: string | undefined;
    document!: Document;
    documentId!: number;
    readonly entityId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDocumentLinkReminder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reminder = _data["reminder"] ? Reminder.fromJS(_data["reminder"]) : <any>undefined;
            this.reminderId = _data["reminderId"];
            this.discriminator = _data["discriminator"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.documentId = _data["documentId"];
            (<any>this).entityId = _data["entityId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentLinkReminder {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLinkReminder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reminder"] = this.reminder ? this.reminder.toJSON() : <any>undefined;
        data["reminderId"] = this.reminderId;
        data["discriminator"] = this.discriminator;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        data["entityId"] = this.entityId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDocumentLinkReminder {
    reminder: Reminder;
    reminderId: number;
    discriminator: string | undefined;
    document: Document;
    documentId: number;
    entityId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CreateOrUpdateReminderDto implements ICreateOrUpdateReminderDto {
    fieldId!: string | undefined;
    subjectId!: string;
    message!: string | undefined;
    rememberDate!: DateTime | undefined;
    sentDate!: DateTime | undefined;
    statusId!: string | undefined;
    documentIds!: number[] | undefined;

    constructor(data?: ICreateOrUpdateReminderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.subjectId = _data["subjectId"];
            this.message = _data["message"];
            this.rememberDate = _data["rememberDate"] ? DateTime.fromISO(_data["rememberDate"].toString()) : <any>undefined;
            this.sentDate = _data["sentDate"] ? DateTime.fromISO(_data["sentDate"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateReminderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateReminderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["subjectId"] = this.subjectId;
        data["message"] = this.message;
        data["rememberDate"] = this.rememberDate ? this.rememberDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["sentDate"] = this.sentDate ? this.sentDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["statusId"] = this.statusId;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateReminderDto {
    fieldId: string | undefined;
    subjectId: string;
    message: string | undefined;
    rememberDate: DateTime | undefined;
    sentDate: DateTime | undefined;
    statusId: string | undefined;
    documentIds: number[] | undefined;
}

export class GetReminderDto implements IGetReminderDto {
    fieldId!: string | undefined;
    subjectId!: string | undefined;
    message!: string | undefined;
    rememberDate!: DateTime | undefined;
    statusId!: string | undefined;
    emailReminderSent!: boolean;
    sentDate!: DateTime | undefined;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: DateTime;
    numberOfPendences!: number;
    documents!: ReminderDocumentDto[] | undefined;
    id!: number;

    constructor(data?: IGetReminderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.subjectId = _data["subjectId"];
            this.message = _data["message"];
            this.rememberDate = _data["rememberDate"] ? DateTime.fromISO(_data["rememberDate"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.emailReminderSent = _data["emailReminderSent"];
            this.sentDate = _data["sentDate"] ? DateTime.fromISO(_data["sentDate"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.numberOfPendences = _data["numberOfPendences"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(ReminderDocumentDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetReminderDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetReminderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["subjectId"] = this.subjectId;
        data["message"] = this.message;
        data["rememberDate"] = this.rememberDate ? this.rememberDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["statusId"] = this.statusId;
        data["emailReminderSent"] = this.emailReminderSent;
        data["sentDate"] = this.sentDate ? this.sentDate.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["numberOfPendences"] = this.numberOfPendences;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGetReminderDto {
    fieldId: string | undefined;
    subjectId: string | undefined;
    message: string | undefined;
    rememberDate: DateTime | undefined;
    statusId: string | undefined;
    emailReminderSent: boolean;
    sentDate: DateTime | undefined;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: DateTime;
    numberOfPendences: number;
    documents: ReminderDocumentDto[] | undefined;
    id: number;
}

export class ReminderDocumentDto implements IReminderDocumentDto {
    id!: number;
    name!: string | undefined;
    mimeType!: string | undefined;
    categoryId!: string | undefined;
    typeId!: string | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IReminderDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.mimeType = _data["mimeType"];
            this.categoryId = _data["categoryId"];
            this.typeId = _data["typeId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReminderDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["mimeType"] = this.mimeType;
        data["categoryId"] = this.categoryId;
        data["typeId"] = this.typeId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IReminderDocumentDto {
    id: number;
    name: string | undefined;
    mimeType: string | undefined;
    categoryId: string | undefined;
    typeId: string | undefined;
    creatorUserFullName: string | undefined;
    creationTime: DateTime;
}

export class ReminderSearchInput implements IReminderSearchInput {
    discriminator!: ReminderType;
    entityId!: number;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IReminderSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.entityId = _data["entityId"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): ReminderSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["entityId"] = this.entityId;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IReminderSearchInput {
    discriminator: ReminderType;
    entityId: number;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class ReminderSearchOutput implements IReminderSearchOutput {
    totalCount!: number;
    items!: GetReminderDto[] | undefined;

    constructor(data?: IReminderSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetReminderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReminderSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReminderSearchOutput {
    totalCount: number;
    items: GetReminderDto[] | undefined;
}

export class PendenceLinkReminder implements IPendenceLinkReminder {
    reminder!: Reminder;
    reminderId!: number;
    discriminator!: string | undefined;
    pendence!: Pendence;
    pendenceId!: number;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IPendenceLinkReminder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reminder = _data["reminder"] ? Reminder.fromJS(_data["reminder"]) : <any>undefined;
            this.reminderId = _data["reminderId"];
            this.discriminator = _data["discriminator"];
            this.pendence = _data["pendence"] ? Pendence.fromJS(_data["pendence"]) : <any>undefined;
            this.pendenceId = _data["pendenceId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PendenceLinkReminder {
        data = typeof data === 'object' ? data : {};
        let result = new PendenceLinkReminder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reminder"] = this.reminder ? this.reminder.toJSON() : <any>undefined;
        data["reminderId"] = this.reminderId;
        data["discriminator"] = this.discriminator;
        data["pendence"] = this.pendence ? this.pendence.toJSON() : <any>undefined;
        data["pendenceId"] = this.pendenceId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPendenceLinkReminder {
    reminder: Reminder;
    reminderId: number;
    discriminator: string | undefined;
    pendence: Pendence;
    pendenceId: number;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class Reminder implements IReminder {
    fieldId!: string | undefined;
    subjectId!: string | undefined;
    message!: string | undefined;
    rememberDate!: DateTime | undefined;
    statusId!: string | undefined;
    sendReminderEmailToResponsible!: boolean;
    emailReminderSent!: boolean;
    sentDate!: DateTime | undefined;
    documentLinks!: DocumentLinkReminder[] | undefined;
    pendences!: PendenceLinkReminder[] | undefined;
    discriminator!: ReminderType;
    isDeleted!: boolean;
    deleterUser!: User;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    creatorUser!: User;
    lastModifierUser!: User;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IReminder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.subjectId = _data["subjectId"];
            this.message = _data["message"];
            this.rememberDate = _data["rememberDate"] ? DateTime.fromISO(_data["rememberDate"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.sendReminderEmailToResponsible = _data["sendReminderEmailToResponsible"];
            this.emailReminderSent = _data["emailReminderSent"];
            this.sentDate = _data["sentDate"] ? DateTime.fromISO(_data["sentDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkReminder.fromJS(item));
            }
            if (Array.isArray(_data["pendences"])) {
                this.pendences = [] as any;
                for (let item of _data["pendences"])
                    this.pendences!.push(PendenceLinkReminder.fromJS(item));
            }
            this.discriminator = _data["discriminator"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Reminder {
        data = typeof data === 'object' ? data : {};
        let result = new Reminder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["subjectId"] = this.subjectId;
        data["message"] = this.message;
        data["rememberDate"] = this.rememberDate ? this.rememberDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["statusId"] = this.statusId;
        data["sendReminderEmailToResponsible"] = this.sendReminderEmailToResponsible;
        data["emailReminderSent"] = this.emailReminderSent;
        data["sentDate"] = this.sentDate ? this.sentDate.toString() : <any>undefined;
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.pendences)) {
            data["pendences"] = [];
            for (let item of this.pendences)
                data["pendences"].push(item.toJSON());
        }
        data["discriminator"] = this.discriminator;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IReminder {
    fieldId: string | undefined;
    subjectId: string | undefined;
    message: string | undefined;
    rememberDate: DateTime | undefined;
    statusId: string | undefined;
    sendReminderEmailToResponsible: boolean;
    emailReminderSent: boolean;
    sentDate: DateTime | undefined;
    documentLinks: DocumentLinkReminder[] | undefined;
    pendences: PendenceLinkReminder[] | undefined;
    discriminator: ReminderType;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ReminderBusiness implements IReminderBusiness {
    business!: Business;
    businessId!: number;
    fieldId!: string | undefined;
    subjectId!: string | undefined;
    message!: string | undefined;
    rememberDate!: DateTime | undefined;
    statusId!: string | undefined;
    sendReminderEmailToResponsible!: boolean;
    emailReminderSent!: boolean;
    sentDate!: DateTime | undefined;
    documentLinks!: DocumentLinkReminder[] | undefined;
    pendences!: PendenceLinkReminder[] | undefined;
    discriminator!: ReminderType;
    isDeleted!: boolean;
    deleterUser!: User;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    creatorUser!: User;
    lastModifierUser!: User;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IReminderBusiness) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.business = _data["business"] ? Business.fromJS(_data["business"]) : <any>undefined;
            this.businessId = _data["businessId"];
            this.fieldId = _data["fieldId"];
            this.subjectId = _data["subjectId"];
            this.message = _data["message"];
            this.rememberDate = _data["rememberDate"] ? DateTime.fromISO(_data["rememberDate"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.sendReminderEmailToResponsible = _data["sendReminderEmailToResponsible"];
            this.emailReminderSent = _data["emailReminderSent"];
            this.sentDate = _data["sentDate"] ? DateTime.fromISO(_data["sentDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkReminder.fromJS(item));
            }
            if (Array.isArray(_data["pendences"])) {
                this.pendences = [] as any;
                for (let item of _data["pendences"])
                    this.pendences!.push(PendenceLinkReminder.fromJS(item));
            }
            this.discriminator = _data["discriminator"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReminderBusiness {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderBusiness();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        data["businessId"] = this.businessId;
        data["fieldId"] = this.fieldId;
        data["subjectId"] = this.subjectId;
        data["message"] = this.message;
        data["rememberDate"] = this.rememberDate ? this.rememberDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["statusId"] = this.statusId;
        data["sendReminderEmailToResponsible"] = this.sendReminderEmailToResponsible;
        data["emailReminderSent"] = this.emailReminderSent;
        data["sentDate"] = this.sentDate ? this.sentDate.toString() : <any>undefined;
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.pendences)) {
            data["pendences"] = [];
            for (let item of this.pendences)
                data["pendences"].push(item.toJSON());
        }
        data["discriminator"] = this.discriminator;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IReminderBusiness {
    business: Business;
    businessId: number;
    fieldId: string | undefined;
    subjectId: string | undefined;
    message: string | undefined;
    rememberDate: DateTime | undefined;
    statusId: string | undefined;
    sendReminderEmailToResponsible: boolean;
    emailReminderSent: boolean;
    sentDate: DateTime | undefined;
    documentLinks: DocumentLinkReminder[] | undefined;
    pendences: PendenceLinkReminder[] | undefined;
    discriminator: ReminderType;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ReminderPerson implements IReminderPerson {
    person!: Person;
    personId!: number;
    fieldId!: string | undefined;
    subjectId!: string | undefined;
    message!: string | undefined;
    rememberDate!: DateTime | undefined;
    statusId!: string | undefined;
    sendReminderEmailToResponsible!: boolean;
    emailReminderSent!: boolean;
    sentDate!: DateTime | undefined;
    documentLinks!: DocumentLinkReminder[] | undefined;
    pendences!: PendenceLinkReminder[] | undefined;
    discriminator!: ReminderType;
    isDeleted!: boolean;
    deleterUser!: User;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    creatorUser!: User;
    lastModifierUser!: User;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IReminderPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.personId = _data["personId"];
            this.fieldId = _data["fieldId"];
            this.subjectId = _data["subjectId"];
            this.message = _data["message"];
            this.rememberDate = _data["rememberDate"] ? DateTime.fromISO(_data["rememberDate"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.sendReminderEmailToResponsible = _data["sendReminderEmailToResponsible"];
            this.emailReminderSent = _data["emailReminderSent"];
            this.sentDate = _data["sentDate"] ? DateTime.fromISO(_data["sentDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkReminder.fromJS(item));
            }
            if (Array.isArray(_data["pendences"])) {
                this.pendences = [] as any;
                for (let item of _data["pendences"])
                    this.pendences!.push(PendenceLinkReminder.fromJS(item));
            }
            this.discriminator = _data["discriminator"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReminderPerson {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["fieldId"] = this.fieldId;
        data["subjectId"] = this.subjectId;
        data["message"] = this.message;
        data["rememberDate"] = this.rememberDate ? this.rememberDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["statusId"] = this.statusId;
        data["sendReminderEmailToResponsible"] = this.sendReminderEmailToResponsible;
        data["emailReminderSent"] = this.emailReminderSent;
        data["sentDate"] = this.sentDate ? this.sentDate.toString() : <any>undefined;
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.pendences)) {
            data["pendences"] = [];
            for (let item of this.pendences)
                data["pendences"].push(item.toJSON());
        }
        data["discriminator"] = this.discriminator;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IReminderPerson {
    person: Person;
    personId: number;
    fieldId: string | undefined;
    subjectId: string | undefined;
    message: string | undefined;
    rememberDate: DateTime | undefined;
    statusId: string | undefined;
    sendReminderEmailToResponsible: boolean;
    emailReminderSent: boolean;
    sentDate: DateTime | undefined;
    documentLinks: DocumentLinkReminder[] | undefined;
    pendences: PendenceLinkReminder[] | undefined;
    discriminator: ReminderType;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ReminderSponsorship implements IReminderSponsorship {
    sponsorship!: Sponsorship;
    sponsorshipId!: number;
    fieldId!: string | undefined;
    subjectId!: string | undefined;
    message!: string | undefined;
    rememberDate!: DateTime | undefined;
    statusId!: string | undefined;
    sendReminderEmailToResponsible!: boolean;
    emailReminderSent!: boolean;
    sentDate!: DateTime | undefined;
    documentLinks!: DocumentLinkReminder[] | undefined;
    pendences!: PendenceLinkReminder[] | undefined;
    discriminator!: ReminderType;
    isDeleted!: boolean;
    deleterUser!: User;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    creatorUser!: User;
    lastModifierUser!: User;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IReminderSponsorship) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorship = _data["sponsorship"] ? Sponsorship.fromJS(_data["sponsorship"]) : <any>undefined;
            this.sponsorshipId = _data["sponsorshipId"];
            this.fieldId = _data["fieldId"];
            this.subjectId = _data["subjectId"];
            this.message = _data["message"];
            this.rememberDate = _data["rememberDate"] ? DateTime.fromISO(_data["rememberDate"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.sendReminderEmailToResponsible = _data["sendReminderEmailToResponsible"];
            this.emailReminderSent = _data["emailReminderSent"];
            this.sentDate = _data["sentDate"] ? DateTime.fromISO(_data["sentDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkReminder.fromJS(item));
            }
            if (Array.isArray(_data["pendences"])) {
                this.pendences = [] as any;
                for (let item of _data["pendences"])
                    this.pendences!.push(PendenceLinkReminder.fromJS(item));
            }
            this.discriminator = _data["discriminator"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReminderSponsorship {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderSponsorship();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        data["sponsorshipId"] = this.sponsorshipId;
        data["fieldId"] = this.fieldId;
        data["subjectId"] = this.subjectId;
        data["message"] = this.message;
        data["rememberDate"] = this.rememberDate ? this.rememberDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["statusId"] = this.statusId;
        data["sendReminderEmailToResponsible"] = this.sendReminderEmailToResponsible;
        data["emailReminderSent"] = this.emailReminderSent;
        data["sentDate"] = this.sentDate ? this.sentDate.toString() : <any>undefined;
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.pendences)) {
            data["pendences"] = [];
            for (let item of this.pendences)
                data["pendences"].push(item.toJSON());
        }
        data["discriminator"] = this.discriminator;
        data["isDeleted"] = this.isDeleted;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IReminderSponsorship {
    sponsorship: Sponsorship;
    sponsorshipId: number;
    fieldId: string | undefined;
    subjectId: string | undefined;
    message: string | undefined;
    rememberDate: DateTime | undefined;
    statusId: string | undefined;
    sendReminderEmailToResponsible: boolean;
    emailReminderSent: boolean;
    sentDate: DateTime | undefined;
    documentLinks: DocumentLinkReminder[] | undefined;
    pendences: PendenceLinkReminder[] | undefined;
    discriminator: ReminderType;
    isDeleted: boolean;
    deleterUser: User;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    creatorUser: User;
    lastModifierUser: User;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CreateOrUpdateRlaAcademicTitleInput implements ICreateOrUpdateRlaAcademicTitleInput {
    caseId!: string;
    rlaAcademicTitles!: RlaAcademicTitleDto[];

    constructor(data?: ICreateOrUpdateRlaAcademicTitleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rlaAcademicTitles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["rlaAcademicTitles"])) {
                this.rlaAcademicTitles = [] as any;
                for (let item of _data["rlaAcademicTitles"])
                    this.rlaAcademicTitles!.push(RlaAcademicTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRlaAcademicTitleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRlaAcademicTitleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.rlaAcademicTitles)) {
            data["rlaAcademicTitles"] = [];
            for (let item of this.rlaAcademicTitles)
                data["rlaAcademicTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateRlaAcademicTitleInput {
    caseId: string;
    rlaAcademicTitles: RlaAcademicTitleDto[];
}

export class CreateOrUpdateRlaAcademicTitleOutput implements ICreateOrUpdateRlaAcademicTitleOutput {
    status!: RlaStatus;
    rlaAcademicTitles!: RlaAcademicTitleDto[] | undefined;

    constructor(data?: ICreateOrUpdateRlaAcademicTitleOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["rlaAcademicTitles"])) {
                this.rlaAcademicTitles = [] as any;
                for (let item of _data["rlaAcademicTitles"])
                    this.rlaAcademicTitles!.push(RlaAcademicTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRlaAcademicTitleOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRlaAcademicTitleOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.rlaAcademicTitles)) {
            data["rlaAcademicTitles"] = [];
            for (let item of this.rlaAcademicTitles)
                data["rlaAcademicTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateRlaAcademicTitleOutput {
    status: RlaStatus;
    rlaAcademicTitles: RlaAcademicTitleDto[] | undefined;
}

export class CreateOrUpdateRlaApplicantContact implements ICreateOrUpdateRlaApplicantContact {
    caseId!: string;
    contact!: RlaApplicantContactDto;

    constructor(data?: ICreateOrUpdateRlaApplicantContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contact = new RlaApplicantContactDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.contact = _data["contact"] ? RlaApplicantContactDto.fromJS(_data["contact"]) : new RlaApplicantContactDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateRlaApplicantContact {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRlaApplicantContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateRlaApplicantContact {
    caseId: string;
    contact: RlaApplicantContactDto;
}

export class CreateOrUpdateRlaMedicalFieldDirector implements ICreateOrUpdateRlaMedicalFieldDirector {
    caseId!: string;
    medicalFieldDirector!: RlaMedicalFieldDirectorDto;

    constructor(data?: ICreateOrUpdateRlaMedicalFieldDirector) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medicalFieldDirector = new RlaMedicalFieldDirectorDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.medicalFieldDirector = _data["medicalFieldDirector"] ? RlaMedicalFieldDirectorDto.fromJS(_data["medicalFieldDirector"]) : new RlaMedicalFieldDirectorDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateRlaMedicalFieldDirector {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRlaMedicalFieldDirector();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["medicalFieldDirector"] = this.medicalFieldDirector ? this.medicalFieldDirector.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateRlaMedicalFieldDirector {
    caseId: string;
    medicalFieldDirector: RlaMedicalFieldDirectorDto;
}

export class CreateOrUpdateRlaPerson implements ICreateOrUpdateRlaPerson {
    caseId!: string;
    person!: RlaPersonDto;

    constructor(data?: ICreateOrUpdateRlaPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.person = new RlaPersonDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.person = _data["person"] ? RlaPersonDto.fromJS(_data["person"]) : new RlaPersonDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateRlaPerson {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRlaPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateRlaPerson {
    caseId: string;
    person: RlaPersonDto;
}

export class CreateOrUpdateRlaRestrictionsInput implements ICreateOrUpdateRlaRestrictionsInput {
    caseId!: string;
    rlaRestrictions!: RlaRestrictionDto[];
    rlaRestrictionGeneralInformation!: RlaRestrictionGeneralInformationDto;

    constructor(data?: ICreateOrUpdateRlaRestrictionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rlaRestrictions = [];
            this.rlaRestrictionGeneralInformation = new RlaRestrictionGeneralInformationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["rlaRestrictions"])) {
                this.rlaRestrictions = [] as any;
                for (let item of _data["rlaRestrictions"])
                    this.rlaRestrictions!.push(RlaRestrictionDto.fromJS(item));
            }
            this.rlaRestrictionGeneralInformation = _data["rlaRestrictionGeneralInformation"] ? RlaRestrictionGeneralInformationDto.fromJS(_data["rlaRestrictionGeneralInformation"]) : new RlaRestrictionGeneralInformationDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateRlaRestrictionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRlaRestrictionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.rlaRestrictions)) {
            data["rlaRestrictions"] = [];
            for (let item of this.rlaRestrictions)
                data["rlaRestrictions"].push(item.toJSON());
        }
        data["rlaRestrictionGeneralInformation"] = this.rlaRestrictionGeneralInformation ? this.rlaRestrictionGeneralInformation.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateRlaRestrictionsInput {
    caseId: string;
    rlaRestrictions: RlaRestrictionDto[];
    rlaRestrictionGeneralInformation: RlaRestrictionGeneralInformationDto;
}

export class CreateRlaInput implements ICreateRlaInput {
    applicationType!: ApplicationType;
    legitimationId!: number | undefined;
    professionId!: string | undefined;

    constructor(data?: ICreateRlaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationType = _data["applicationType"];
            this.legitimationId = _data["legitimationId"];
            this.professionId = _data["professionId"];
        }
    }

    static fromJS(data: any): CreateRlaInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRlaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationType"] = this.applicationType;
        data["legitimationId"] = this.legitimationId;
        data["professionId"] = this.professionId;
        return data;
    }
}

export interface ICreateRlaInput {
    applicationType: ApplicationType;
    legitimationId: number | undefined;
    professionId: string | undefined;
}

export class CreateRlaOutput implements ICreateRlaOutput {
    caseId!: string | undefined;

    constructor(data?: ICreateRlaOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): CreateRlaOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRlaOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface ICreateRlaOutput {
    caseId: string | undefined;
}

export class GetRlaDocumentsInput implements IGetRlaDocumentsInput {
    caseId!: string;
    step!: RlaStatus;
    hasImmigratedLastFiveYearsId!: string | undefined;
    hasLicenceInThisCanton!: boolean | undefined;

    constructor(data?: IGetRlaDocumentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.hasImmigratedLastFiveYearsId = _data["hasImmigratedLastFiveYearsId"];
            this.hasLicenceInThisCanton = _data["hasLicenceInThisCanton"];
        }
    }

    static fromJS(data: any): GetRlaDocumentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRlaDocumentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["hasImmigratedLastFiveYearsId"] = this.hasImmigratedLastFiveYearsId;
        data["hasLicenceInThisCanton"] = this.hasLicenceInThisCanton;
        return data;
    }
}

export interface IGetRlaDocumentsInput {
    caseId: string;
    step: RlaStatus;
    hasImmigratedLastFiveYearsId: string | undefined;
    hasLicenceInThisCanton: boolean | undefined;
}

export class GetRlaFileInput implements IGetRlaFileInput {
    caseId!: string;
    step!: RlaStatus;
    id!: number;

    constructor(data?: IGetRlaFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetRlaFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRlaFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetRlaFileInput {
    caseId: string;
    step: RlaStatus;
    id: number;
}

export class GetRlaInvoiceAddressOutput implements IGetRlaInvoiceAddressOutput {
    invoiceAddress!: RlaInvoiceAddressDto;
    contact!: InvoiceAddressDetailDto;
    employments!: RlaBusinessDto[] | undefined;
    onlyPrivateAddressAllowed!: boolean;
    selectedInvoiceAddressDetail!: InvoiceAddressDetailDto;

    constructor(data?: IGetRlaInvoiceAddressOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceAddress = _data["invoiceAddress"] ? RlaInvoiceAddressDto.fromJS(_data["invoiceAddress"]) : <any>undefined;
            this.contact = _data["contact"] ? InvoiceAddressDetailDto.fromJS(_data["contact"]) : <any>undefined;
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(RlaBusinessDto.fromJS(item));
            }
            this.onlyPrivateAddressAllowed = _data["onlyPrivateAddressAllowed"];
            this.selectedInvoiceAddressDetail = _data["selectedInvoiceAddressDetail"] ? InvoiceAddressDetailDto.fromJS(_data["selectedInvoiceAddressDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRlaInvoiceAddressOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRlaInvoiceAddressOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceAddress"] = this.invoiceAddress ? this.invoiceAddress.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        data["onlyPrivateAddressAllowed"] = this.onlyPrivateAddressAllowed;
        data["selectedInvoiceAddressDetail"] = this.selectedInvoiceAddressDetail ? this.selectedInvoiceAddressDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRlaInvoiceAddressOutput {
    invoiceAddress: RlaInvoiceAddressDto;
    contact: InvoiceAddressDetailDto;
    employments: RlaBusinessDto[] | undefined;
    onlyPrivateAddressAllowed: boolean;
    selectedInvoiceAddressDetail: InvoiceAddressDetailDto;
}

export class GetRlaOutput implements IGetRlaOutput {
    rla!: RlaDto;

    constructor(data?: IGetRlaOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rla = _data["rla"] ? RlaDto.fromJS(_data["rla"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRlaOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRlaOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rla"] = this.rla ? this.rla.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRlaOutput {
    rla: RlaDto;
}

export class RlaAcademicTitleDto implements IRlaAcademicTitleDto {
    id!: string;
    rlaApplicationId!: number;
    title!: string | undefined;
    bodyOfIssue!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;

    constructor(data?: IRlaAcademicTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rlaApplicationId = _data["rlaApplicationId"];
            this.title = _data["title"];
            this.bodyOfIssue = _data["bodyOfIssue"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RlaAcademicTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaAcademicTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rlaApplicationId"] = this.rlaApplicationId;
        data["title"] = this.title;
        data["bodyOfIssue"] = this.bodyOfIssue;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IRlaAcademicTitleDto {
    id: string;
    rlaApplicationId: number;
    title: string | undefined;
    bodyOfIssue: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
}

export class RlaAcademicTitlesOutput implements IRlaAcademicTitlesOutput {
    titles!: RlaAcademicTitleDto[] | undefined;
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IRlaAcademicTitlesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(RlaAcademicTitleDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RlaAcademicTitlesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RlaAcademicTitlesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRlaAcademicTitlesOutput {
    titles: RlaAcademicTitleDto[] | undefined;
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class RlaApplicantContactDto implements IRlaApplicantContactDto {
    titleId!: string;
    languageOfCorrespondenceId!: string | undefined;
    street!: string;
    streetNr!: string | undefined;
    postCode!: string;
    city!: string;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    email!: string;
    phone1!: string;
    phone2!: string | undefined;
    titleAddressSwiss!: string | undefined;
    streetSwiss!: string | undefined;
    streetNrSwiss!: string | undefined;
    postCodeSwiss!: string | undefined;
    citySwiss!: string | undefined;
    postOfficeBoxSwiss!: string | undefined;
    addressAdditionSwiss!: string | undefined;

    constructor(data?: IRlaApplicantContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.titleAddressSwiss = _data["titleAddressSwiss"];
            this.streetSwiss = _data["streetSwiss"];
            this.streetNrSwiss = _data["streetNrSwiss"];
            this.postCodeSwiss = _data["postCodeSwiss"];
            this.citySwiss = _data["citySwiss"];
            this.postOfficeBoxSwiss = _data["postOfficeBoxSwiss"];
            this.addressAdditionSwiss = _data["addressAdditionSwiss"];
        }
    }

    static fromJS(data: any): RlaApplicantContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaApplicantContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["titleAddressSwiss"] = this.titleAddressSwiss;
        data["streetSwiss"] = this.streetSwiss;
        data["streetNrSwiss"] = this.streetNrSwiss;
        data["postCodeSwiss"] = this.postCodeSwiss;
        data["citySwiss"] = this.citySwiss;
        data["postOfficeBoxSwiss"] = this.postOfficeBoxSwiss;
        data["addressAdditionSwiss"] = this.addressAdditionSwiss;
        return data;
    }
}

export interface IRlaApplicantContactDto {
    titleId: string;
    languageOfCorrespondenceId: string | undefined;
    street: string;
    streetNr: string | undefined;
    postCode: string;
    city: string;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    email: string;
    phone1: string;
    phone2: string | undefined;
    titleAddressSwiss: string | undefined;
    streetSwiss: string | undefined;
    streetNrSwiss: string | undefined;
    postCodeSwiss: string | undefined;
    citySwiss: string | undefined;
    postOfficeBoxSwiss: string | undefined;
    addressAdditionSwiss: string | undefined;
}

export class RlaApplicantPersonDto implements IRlaApplicantPersonDto {
    gln!: string | undefined;
    healthRegisterResult!: HealthRegisterIdentificationStatus;
    hasConfirmedData!: boolean;

    constructor(data?: IRlaApplicantPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.healthRegisterResult = _data["healthRegisterResult"];
            this.hasConfirmedData = _data["hasConfirmedData"];
        }
    }

    static fromJS(data: any): RlaApplicantPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaApplicantPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["healthRegisterResult"] = this.healthRegisterResult;
        data["hasConfirmedData"] = this.hasConfirmedData;
        return data;
    }
}

export interface IRlaApplicantPersonDto {
    gln: string | undefined;
    healthRegisterResult: HealthRegisterIdentificationStatus;
    hasConfirmedData: boolean;
}

export class RlaBusinessDto implements IRlaBusinessDto {
    employmentId!: number | undefined;
    businessId!: number | undefined;
    isReplacementEmployment!: boolean;
    isMobileEmployment!: boolean;
    name!: string | undefined;
    legalFormId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    countryId!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    id!: number;

    constructor(data?: IRlaBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employmentId = _data["employmentId"];
            this.businessId = _data["businessId"];
            this.isReplacementEmployment = _data["isReplacementEmployment"];
            this.isMobileEmployment = _data["isMobileEmployment"];
            this.name = _data["name"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.countryId = _data["countryId"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RlaBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employmentId"] = this.employmentId;
        data["businessId"] = this.businessId;
        data["isReplacementEmployment"] = this.isReplacementEmployment;
        data["isMobileEmployment"] = this.isMobileEmployment;
        data["name"] = this.name;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["countryId"] = this.countryId;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["id"] = this.id;
        return data;
    }
}

export interface IRlaBusinessDto {
    employmentId: number | undefined;
    businessId: number | undefined;
    isReplacementEmployment: boolean;
    isMobileEmployment: boolean;
    name: string | undefined;
    legalFormId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    countryId: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    dateOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    id: number;
}

export class RlaDocumentsOutput implements IRlaDocumentsOutput {
    caseId!: string;
    documents!: GeneralDocumentGroupDto[];

    constructor(data?: IRlaDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RlaDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RlaDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRlaDocumentsOutput {
    caseId: string;
    documents: GeneralDocumentGroupDto[];
}

export class RlaDto implements IRlaDto {
    application!: ApplicationDto;
    professionId!: string | undefined;
    currentStep!: RlaStatus;
    status!: RlaStatus;
    documents!: GeneralDocumentGroupDto[] | undefined;
    rlaAcademicTitles!: RlaAcademicTitlesOutput;
    rlaRestrictionGeneralInformationDto!: RlaRestrictionGeneralInformationDto;
    rlaRestrictions!: RlaRestrictionDto[] | undefined;
    rlaEmployment!: RlaEmploymentDto;

    constructor(data?: IRlaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.professionId = _data["professionId"];
            this.currentStep = _data["currentStep"];
            this.status = _data["status"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
            this.rlaAcademicTitles = _data["rlaAcademicTitles"] ? RlaAcademicTitlesOutput.fromJS(_data["rlaAcademicTitles"]) : <any>undefined;
            this.rlaRestrictionGeneralInformationDto = _data["rlaRestrictionGeneralInformationDto"] ? RlaRestrictionGeneralInformationDto.fromJS(_data["rlaRestrictionGeneralInformationDto"]) : <any>undefined;
            if (Array.isArray(_data["rlaRestrictions"])) {
                this.rlaRestrictions = [] as any;
                for (let item of _data["rlaRestrictions"])
                    this.rlaRestrictions!.push(RlaRestrictionDto.fromJS(item));
            }
            this.rlaEmployment = _data["rlaEmployment"] ? RlaEmploymentDto.fromJS(_data["rlaEmployment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RlaDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["professionId"] = this.professionId;
        data["currentStep"] = this.currentStep;
        data["status"] = this.status;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["rlaAcademicTitles"] = this.rlaAcademicTitles ? this.rlaAcademicTitles.toJSON() : <any>undefined;
        data["rlaRestrictionGeneralInformationDto"] = this.rlaRestrictionGeneralInformationDto ? this.rlaRestrictionGeneralInformationDto.toJSON() : <any>undefined;
        if (Array.isArray(this.rlaRestrictions)) {
            data["rlaRestrictions"] = [];
            for (let item of this.rlaRestrictions)
                data["rlaRestrictions"].push(item.toJSON());
        }
        data["rlaEmployment"] = this.rlaEmployment ? this.rlaEmployment.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRlaDto {
    application: ApplicationDto;
    professionId: string | undefined;
    currentStep: RlaStatus;
    status: RlaStatus;
    documents: GeneralDocumentGroupDto[] | undefined;
    rlaAcademicTitles: RlaAcademicTitlesOutput;
    rlaRestrictionGeneralInformationDto: RlaRestrictionGeneralInformationDto;
    rlaRestrictions: RlaRestrictionDto[] | undefined;
    rlaEmployment: RlaEmploymentDto;
}

export class RlaEmploymentDto implements IRlaEmploymentDto {
    dateOfEmployment!: DateTime | undefined;
    inBusinessSince!: DateTime | undefined;
    role!: string | undefined;
    levelOfEmployment!: number | undefined;
    startOfContinuingEducation!: DateTime | undefined;
    remark!: string | undefined;
    businessName!: string;
    legalFormId!: string | undefined;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;

    constructor(data?: IRlaEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.inBusinessSince = _data["inBusinessSince"] ? DateTime.fromISO(_data["inBusinessSince"].toString()) : <any>undefined;
            this.role = _data["role"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.startOfContinuingEducation = _data["startOfContinuingEducation"] ? DateTime.fromISO(_data["startOfContinuingEducation"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.businessName = _data["businessName"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
        }
    }

    static fromJS(data: any): RlaEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["inBusinessSince"] = this.inBusinessSince ? this.inBusinessSince.toFormat('yyyy-MM-dd') : <any>undefined;
        data["role"] = this.role;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["startOfContinuingEducation"] = this.startOfContinuingEducation ? this.startOfContinuingEducation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["businessName"] = this.businessName;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        return data;
    }
}

export interface IRlaEmploymentDto {
    dateOfEmployment: DateTime | undefined;
    inBusinessSince: DateTime | undefined;
    role: string | undefined;
    levelOfEmployment: number | undefined;
    startOfContinuingEducation: DateTime | undefined;
    remark: string | undefined;
    businessName: string;
    legalFormId: string | undefined;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
}

export class RlaInvoiceAddressDto implements IRlaInvoiceAddressDto {
    typeOfAddressId!: string;
    employmentId!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;

    constructor(data?: IRlaInvoiceAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeOfAddressId = _data["typeOfAddressId"];
            this.employmentId = _data["employmentId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): RlaInvoiceAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaInvoiceAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOfAddressId"] = this.typeOfAddressId;
        data["employmentId"] = this.employmentId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        return data;
    }
}

export interface IRlaInvoiceAddressDto {
    typeOfAddressId: string;
    employmentId: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
}

export class RlaMedicalFieldDirectorDto implements IRlaMedicalFieldDirectorDto {
    gln!: string;
    professionId!: string;
    levelOfEmployment!: number;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IRlaMedicalFieldDirectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RlaMedicalFieldDirectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaMedicalFieldDirectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRlaMedicalFieldDirectorDto {
    gln: string;
    professionId: string;
    levelOfEmployment: number;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class RlaPersonDto implements IRlaPersonDto {
    gln!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IRlaPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RlaPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRlaPersonDto {
    gln: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    dateOfBirth: DateTime | undefined;
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class RlaReplacementDto implements IRlaReplacementDto {
    dateOfStart!: DateTime;
    dateOfEnd!: DateTime | undefined;
    comments!: string | undefined;
    levelOfEmployment!: number | undefined;

    constructor(data?: IRlaReplacementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfStart = _data["dateOfStart"] ? DateTime.fromISO(_data["dateOfStart"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.levelOfEmployment = _data["levelOfEmployment"];
        }
    }

    static fromJS(data: any): RlaReplacementDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaReplacementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfStart"] = this.dateOfStart ? this.dateOfStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["comments"] = this.comments;
        data["levelOfEmployment"] = this.levelOfEmployment;
        return data;
    }
}

export interface IRlaReplacementDto {
    dateOfStart: DateTime;
    dateOfEnd: DateTime | undefined;
    comments: string | undefined;
    levelOfEmployment: number | undefined;
}

export class RlaRestrictionDto implements IRlaRestrictionDto {
    cantonId!: string;
    reason!: string | undefined;
    type!: RlaRestrictionType;

    constructor(data?: IRlaRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantonId = _data["cantonId"];
            this.reason = _data["reason"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): RlaRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantonId"] = this.cantonId;
        data["reason"] = this.reason;
        data["type"] = this.type;
        return data;
    }
}

export interface IRlaRestrictionDto {
    cantonId: string;
    reason: string | undefined;
    type: RlaRestrictionType;
}

export class RlaRestrictionGeneralInformationDto implements IRlaRestrictionGeneralInformationDto {
    hasRestrictionsId!: string | undefined;
    hasOngoingRestrictionProcedureId!: string | undefined;
    hasOngoingRlaRequestInAnotherCantonId!: string | undefined;
    hasAnyImpairmentRelatedToPracticeId!: string | undefined;
    hasJudgementInSwissCriminalRecordId!: string | undefined;

    constructor(data?: IRlaRestrictionGeneralInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasRestrictionsId = _data["hasRestrictionsId"];
            this.hasOngoingRestrictionProcedureId = _data["hasOngoingRestrictionProcedureId"];
            this.hasOngoingRlaRequestInAnotherCantonId = _data["hasOngoingRlaRequestInAnotherCantonId"];
            this.hasAnyImpairmentRelatedToPracticeId = _data["hasAnyImpairmentRelatedToPracticeId"];
            this.hasJudgementInSwissCriminalRecordId = _data["hasJudgementInSwissCriminalRecordId"];
        }
    }

    static fromJS(data: any): RlaRestrictionGeneralInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaRestrictionGeneralInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasRestrictionsId"] = this.hasRestrictionsId;
        data["hasOngoingRestrictionProcedureId"] = this.hasOngoingRestrictionProcedureId;
        data["hasOngoingRlaRequestInAnotherCantonId"] = this.hasOngoingRlaRequestInAnotherCantonId;
        data["hasAnyImpairmentRelatedToPracticeId"] = this.hasAnyImpairmentRelatedToPracticeId;
        data["hasJudgementInSwissCriminalRecordId"] = this.hasJudgementInSwissCriminalRecordId;
        return data;
    }
}

export interface IRlaRestrictionGeneralInformationDto {
    hasRestrictionsId: string | undefined;
    hasOngoingRestrictionProcedureId: string | undefined;
    hasOngoingRlaRequestInAnotherCantonId: string | undefined;
    hasAnyImpairmentRelatedToPracticeId: string | undefined;
    hasJudgementInSwissCriminalRecordId: string | undefined;
}

export enum RlaRestrictionType {
    CantonalRestriction = 0,
    CantonalOngoingLegalProceedings = 1,
}

export enum RlaStatus {
    ApplicantPerson = 0,
    ApplicantContact = 1,
    Business = 2,
    Person = 3,
    Replacement = 4,
    InvoiceAddress = 5,
    AcademicTitle = 6,
    MedicalFieldDirector = 7,
    Restriction = 8,
    Employment = 9,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export class AlapStatusWizardStepDto implements IAlapStatusWizardStepDto {
    order!: number;
    step!: AlaStatus;
    applicationType!: ApplicationType;
    id!: string | undefined;

    constructor(data?: IAlapStatusWizardStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.step = _data["step"];
            this.applicationType = _data["applicationType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AlapStatusWizardStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlapStatusWizardStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["step"] = this.step;
        data["applicationType"] = this.applicationType;
        data["id"] = this.id;
        return data;
    }
}

export interface IAlapStatusWizardStepDto {
    order: number;
    step: AlaStatus;
    applicationType: ApplicationType;
    id: string | undefined;
}

export enum AtLeastOneEmploymentDefined {
    MobileEmployment = 0,
    StationaryEmployment = 1,
    MobileOrStationaryEmployment = 2,
}

export enum AtLeastOnePresent {
    ProfessionalLicence = 0,
    PostgraduateTitle = 1,
    ProfessionalLicenceInThisCanton = 2,
    Professional90DaysLicence = 3,
    DiplomaForProfession = 4,
}

export class ClaStatusWizardStepDto implements IClaStatusWizardStepDto {
    order!: number;
    step!: ClaStatus;
    id!: string | undefined;

    constructor(data?: IClaStatusWizardStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.step = _data["step"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClaStatusWizardStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaStatusWizardStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["step"] = this.step;
        data["id"] = this.id;
        return data;
    }
}

export interface IClaStatusWizardStepDto {
    order: number;
    step: ClaStatus;
    id: string | undefined;
}

export class CreateAlapStatusWizardStepInput implements ICreateAlapStatusWizardStepInput {
    step!: AlaStatus;
    professionId!: string;
    applicationType!: ApplicationType;

    constructor(data?: ICreateAlapStatusWizardStepInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.step = _data["step"];
            this.professionId = _data["professionId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): CreateAlapStatusWizardStepInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAlapStatusWizardStepInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step;
        data["professionId"] = this.professionId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface ICreateAlapStatusWizardStepInput {
    step: AlaStatus;
    professionId: string;
    applicationType: ApplicationType;
}

export class CreateClaStatusWizardStepInput implements ICreateClaStatusWizardStepInput {
    step!: ClaStatus;
    sponsorshipTypeId!: string;
    applicationType!: ApplicationType;

    constructor(data?: ICreateClaStatusWizardStepInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.step = _data["step"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): CreateClaStatusWizardStepInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClaStatusWizardStepInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface ICreateClaStatusWizardStepInput {
    step: ClaStatus;
    sponsorshipTypeId: string;
    applicationType: ApplicationType;
}

export class CreateEhcStatusWizardStepInput implements ICreateEhcStatusWizardStepInput {
    step!: EhcStatus;
    professionId!: string;
    applicationType!: ApplicationType;

    constructor(data?: ICreateEhcStatusWizardStepInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.step = _data["step"];
            this.professionId = _data["professionId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): CreateEhcStatusWizardStepInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEhcStatusWizardStepInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step;
        data["professionId"] = this.professionId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface ICreateEhcStatusWizardStepInput {
    step: EhcStatus;
    professionId: string;
    applicationType: ApplicationType;
}

export class CreateLiaStatusWizardStepInput implements ICreateLiaStatusWizardStepInput {
    step!: LiaStatus;
    professionId!: string;
    applicationType!: ApplicationType;

    constructor(data?: ICreateLiaStatusWizardStepInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.step = _data["step"];
            this.professionId = _data["professionId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): CreateLiaStatusWizardStepInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLiaStatusWizardStepInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step;
        data["professionId"] = this.professionId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface ICreateLiaStatusWizardStepInput {
    step: LiaStatus;
    professionId: string;
    applicationType: ApplicationType;
}

export class CreateOrUpdateEhcPracticeConfigurationInput implements ICreateOrUpdateEhcPracticeConfigurationInput {
    ehcPracticeConfiguration!: EhcPracticeConfigurationDto;

    constructor(data?: ICreateOrUpdateEhcPracticeConfigurationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ehcPracticeConfiguration = _data["ehcPracticeConfiguration"] ? EhcPracticeConfigurationDto.fromJS(_data["ehcPracticeConfiguration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcPracticeConfigurationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcPracticeConfigurationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ehcPracticeConfiguration"] = this.ehcPracticeConfiguration ? this.ehcPracticeConfiguration.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcPracticeConfigurationInput {
    ehcPracticeConfiguration: EhcPracticeConfigurationDto;
}

export class CreateOrUpdateProfessionRequirementInput implements ICreateOrUpdateProfessionRequirementInput {
    requirementType!: RequirementType;
    value!: string | undefined;
    parentId!: number | undefined;
    requirementAlternativeId!: number;
    id!: number;

    constructor(data?: ICreateOrUpdateProfessionRequirementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requirementType = _data["requirementType"];
            this.value = _data["value"];
            this.parentId = _data["parentId"];
            this.requirementAlternativeId = _data["requirementAlternativeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateProfessionRequirementInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateProfessionRequirementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requirementType"] = this.requirementType;
        data["value"] = this.value;
        data["parentId"] = this.parentId;
        data["requirementAlternativeId"] = this.requirementAlternativeId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrUpdateProfessionRequirementInput {
    requirementType: RequirementType;
    value: string | undefined;
    parentId: number | undefined;
    requirementAlternativeId: number;
    id: number;
}

export class CreateRequirementGroupDto implements ICreateRequirementGroupDto {
    discriminator!: RequirementGroupDiscriminator;
    professionIdOrSponsorshipTypeId!: string;
    description!: string;
    step!: number;
    applicationType!: ApplicationType;

    constructor(data?: ICreateRequirementGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.professionIdOrSponsorshipTypeId = _data["professionIdOrSponsorshipTypeId"];
            this.description = _data["description"];
            this.step = _data["step"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): CreateRequirementGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRequirementGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["professionIdOrSponsorshipTypeId"] = this.professionIdOrSponsorshipTypeId;
        data["description"] = this.description;
        data["step"] = this.step;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface ICreateRequirementGroupDto {
    discriminator: RequirementGroupDiscriminator;
    professionIdOrSponsorshipTypeId: string;
    description: string;
    step: number;
    applicationType: ApplicationType;
}

export class CreateSlapStatusWizardStepInput implements ICreateSlapStatusWizardStepInput {
    step!: SlapStatus;
    professionId!: string;
    applicationType!: ApplicationType;

    constructor(data?: ICreateSlapStatusWizardStepInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.step = _data["step"];
            this.professionId = _data["professionId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): CreateSlapStatusWizardStepInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSlapStatusWizardStepInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step;
        data["professionId"] = this.professionId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface ICreateSlapStatusWizardStepInput {
    step: SlapStatus;
    professionId: string;
    applicationType: ApplicationType;
}

export class EhcPracticeConfigurationDto implements IEhcPracticeConfigurationDto {
    professionId!: string | undefined;
    minimumDurationInDays!: number;
    ignoreMinimumDurationInDays!: boolean;
    ehcPracticeDescriptionPreLabel1!: string | undefined;
    ehcPracticeDescription1Id!: string | undefined;
    ehcPracticeDescriptionPreLabel2!: string | undefined;
    ehcPracticeDescription2Id!: string | undefined;
    ehcPracticeDescriptionPreLabel3!: string | undefined;
    ehcPracticeDescription3Id!: string | undefined;
    ehcPracticeDescriptionPreLabel4!: string | undefined;
    ehcPracticeDescription4Id!: string | undefined;
    ehcPracticeDescriptionPreLabel5!: string | undefined;
    ehcPracticeDescription5Id!: string | undefined;
    ehcPracticeRecordDescriptionPreLabel1!: string | undefined;
    ehcPracticeRecordDescription1Id!: string | undefined;
    ehcPracticeRecordDescriptionPreLabel2!: string | undefined;
    ehcPracticeRecordDescription2Id!: string | undefined;
    ehcPracticeRecordDescriptionPreLabel3!: string | undefined;
    ehcPracticeRecordDescription3Id!: string | undefined;
    ehcPracticeRecordDescriptionPreLabel4!: string | undefined;
    ehcPracticeRecordDescription4Id!: string | undefined;
    ehcPracticeRecordDescriptionPreLabel5!: string | undefined;
    ehcPracticeRecordDescription5Id!: string | undefined;

    constructor(data?: IEhcPracticeConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.minimumDurationInDays = _data["minimumDurationInDays"];
            this.ignoreMinimumDurationInDays = _data["ignoreMinimumDurationInDays"];
            this.ehcPracticeDescriptionPreLabel1 = _data["ehcPracticeDescriptionPreLabel1"];
            this.ehcPracticeDescription1Id = _data["ehcPracticeDescription1Id"];
            this.ehcPracticeDescriptionPreLabel2 = _data["ehcPracticeDescriptionPreLabel2"];
            this.ehcPracticeDescription2Id = _data["ehcPracticeDescription2Id"];
            this.ehcPracticeDescriptionPreLabel3 = _data["ehcPracticeDescriptionPreLabel3"];
            this.ehcPracticeDescription3Id = _data["ehcPracticeDescription3Id"];
            this.ehcPracticeDescriptionPreLabel4 = _data["ehcPracticeDescriptionPreLabel4"];
            this.ehcPracticeDescription4Id = _data["ehcPracticeDescription4Id"];
            this.ehcPracticeDescriptionPreLabel5 = _data["ehcPracticeDescriptionPreLabel5"];
            this.ehcPracticeDescription5Id = _data["ehcPracticeDescription5Id"];
            this.ehcPracticeRecordDescriptionPreLabel1 = _data["ehcPracticeRecordDescriptionPreLabel1"];
            this.ehcPracticeRecordDescription1Id = _data["ehcPracticeRecordDescription1Id"];
            this.ehcPracticeRecordDescriptionPreLabel2 = _data["ehcPracticeRecordDescriptionPreLabel2"];
            this.ehcPracticeRecordDescription2Id = _data["ehcPracticeRecordDescription2Id"];
            this.ehcPracticeRecordDescriptionPreLabel3 = _data["ehcPracticeRecordDescriptionPreLabel3"];
            this.ehcPracticeRecordDescription3Id = _data["ehcPracticeRecordDescription3Id"];
            this.ehcPracticeRecordDescriptionPreLabel4 = _data["ehcPracticeRecordDescriptionPreLabel4"];
            this.ehcPracticeRecordDescription4Id = _data["ehcPracticeRecordDescription4Id"];
            this.ehcPracticeRecordDescriptionPreLabel5 = _data["ehcPracticeRecordDescriptionPreLabel5"];
            this.ehcPracticeRecordDescription5Id = _data["ehcPracticeRecordDescription5Id"];
        }
    }

    static fromJS(data: any): EhcPracticeConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcPracticeConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["minimumDurationInDays"] = this.minimumDurationInDays;
        data["ignoreMinimumDurationInDays"] = this.ignoreMinimumDurationInDays;
        data["ehcPracticeDescriptionPreLabel1"] = this.ehcPracticeDescriptionPreLabel1;
        data["ehcPracticeDescription1Id"] = this.ehcPracticeDescription1Id;
        data["ehcPracticeDescriptionPreLabel2"] = this.ehcPracticeDescriptionPreLabel2;
        data["ehcPracticeDescription2Id"] = this.ehcPracticeDescription2Id;
        data["ehcPracticeDescriptionPreLabel3"] = this.ehcPracticeDescriptionPreLabel3;
        data["ehcPracticeDescription3Id"] = this.ehcPracticeDescription3Id;
        data["ehcPracticeDescriptionPreLabel4"] = this.ehcPracticeDescriptionPreLabel4;
        data["ehcPracticeDescription4Id"] = this.ehcPracticeDescription4Id;
        data["ehcPracticeDescriptionPreLabel5"] = this.ehcPracticeDescriptionPreLabel5;
        data["ehcPracticeDescription5Id"] = this.ehcPracticeDescription5Id;
        data["ehcPracticeRecordDescriptionPreLabel1"] = this.ehcPracticeRecordDescriptionPreLabel1;
        data["ehcPracticeRecordDescription1Id"] = this.ehcPracticeRecordDescription1Id;
        data["ehcPracticeRecordDescriptionPreLabel2"] = this.ehcPracticeRecordDescriptionPreLabel2;
        data["ehcPracticeRecordDescription2Id"] = this.ehcPracticeRecordDescription2Id;
        data["ehcPracticeRecordDescriptionPreLabel3"] = this.ehcPracticeRecordDescriptionPreLabel3;
        data["ehcPracticeRecordDescription3Id"] = this.ehcPracticeRecordDescription3Id;
        data["ehcPracticeRecordDescriptionPreLabel4"] = this.ehcPracticeRecordDescriptionPreLabel4;
        data["ehcPracticeRecordDescription4Id"] = this.ehcPracticeRecordDescription4Id;
        data["ehcPracticeRecordDescriptionPreLabel5"] = this.ehcPracticeRecordDescriptionPreLabel5;
        data["ehcPracticeRecordDescription5Id"] = this.ehcPracticeRecordDescription5Id;
        return data;
    }
}

export interface IEhcPracticeConfigurationDto {
    professionId: string | undefined;
    minimumDurationInDays: number;
    ignoreMinimumDurationInDays: boolean;
    ehcPracticeDescriptionPreLabel1: string | undefined;
    ehcPracticeDescription1Id: string | undefined;
    ehcPracticeDescriptionPreLabel2: string | undefined;
    ehcPracticeDescription2Id: string | undefined;
    ehcPracticeDescriptionPreLabel3: string | undefined;
    ehcPracticeDescription3Id: string | undefined;
    ehcPracticeDescriptionPreLabel4: string | undefined;
    ehcPracticeDescription4Id: string | undefined;
    ehcPracticeDescriptionPreLabel5: string | undefined;
    ehcPracticeDescription5Id: string | undefined;
    ehcPracticeRecordDescriptionPreLabel1: string | undefined;
    ehcPracticeRecordDescription1Id: string | undefined;
    ehcPracticeRecordDescriptionPreLabel2: string | undefined;
    ehcPracticeRecordDescription2Id: string | undefined;
    ehcPracticeRecordDescriptionPreLabel3: string | undefined;
    ehcPracticeRecordDescription3Id: string | undefined;
    ehcPracticeRecordDescriptionPreLabel4: string | undefined;
    ehcPracticeRecordDescription4Id: string | undefined;
    ehcPracticeRecordDescriptionPreLabel5: string | undefined;
    ehcPracticeRecordDescription5Id: string | undefined;
}

export class EhcStatusWizardStepDto implements IEhcStatusWizardStepDto {
    order!: number;
    step!: EhcStatus;
    applicationType!: ApplicationType;
    id!: string | undefined;

    constructor(data?: IEhcStatusWizardStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.step = _data["step"];
            this.applicationType = _data["applicationType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EhcStatusWizardStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcStatusWizardStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["step"] = this.step;
        data["applicationType"] = this.applicationType;
        data["id"] = this.id;
        return data;
    }
}

export interface IEhcStatusWizardStepDto {
    order: number;
    step: EhcStatus;
    applicationType: ApplicationType;
    id: string | undefined;
}

export class GetRequirementGroupDto implements IGetRequirementGroupDto {
    description!: string | undefined;
    professionId!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    step!: number;
    applicationType!: ApplicationType;
    requirementAlternatives!: RequirementAlternativeDto[] | undefined;
    id!: number;

    constructor(data?: IGetRequirementGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.professionId = _data["professionId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.step = _data["step"];
            this.applicationType = _data["applicationType"];
            if (Array.isArray(_data["requirementAlternatives"])) {
                this.requirementAlternatives = [] as any;
                for (let item of _data["requirementAlternatives"])
                    this.requirementAlternatives!.push(RequirementAlternativeDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetRequirementGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequirementGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["professionId"] = this.professionId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["step"] = this.step;
        data["applicationType"] = this.applicationType;
        if (Array.isArray(this.requirementAlternatives)) {
            data["requirementAlternatives"] = [];
            for (let item of this.requirementAlternatives)
                data["requirementAlternatives"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGetRequirementGroupDto {
    description: string | undefined;
    professionId: string | undefined;
    sponsorshipTypeId: string | undefined;
    step: number;
    applicationType: ApplicationType;
    requirementAlternatives: RequirementAlternativeDto[] | undefined;
    id: number;
}

export enum HealthRegisterIdentificationStatus {
    None = 0,
    Ok = 1,
    NotFound = 2,
    NoDiploma = 4,
    HasLicenceInThisCanton = 8,
    HasLicenceInAnotherCanton = 16,
    HasNoLanguageSkill = 32,
    HasNoLicenceInThisCanton = 64,
    NoDiplomaType = 128,
    NoPostgraduateTitle = 256,
}

export class LiaStatusWizardStepDto implements ILiaStatusWizardStepDto {
    order!: number;
    step!: LiaStatus;
    applicationType!: ApplicationType;
    id!: string | undefined;

    constructor(data?: ILiaStatusWizardStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.step = _data["step"];
            this.applicationType = _data["applicationType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaStatusWizardStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaStatusWizardStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["step"] = this.step;
        data["applicationType"] = this.applicationType;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaStatusWizardStepDto {
    order: number;
    step: LiaStatus;
    applicationType: ApplicationType;
    id: string | undefined;
}

export enum ProfessionLiaEmploymentRequirementType {
    AtLeastOneLiaEmploymentDefined = 100,
}

export enum ProfessionLiaInvoiceAddressRequirementType {
    OnlyPrivateAddressAllowed = 200,
}

export class ProfessionRegisterAffiliationDto implements IProfessionRegisterAffiliationDto {
    id!: string;
    externalSystem!: ExternalSystemEnum;
    eligibleForLiaId!: string | undefined;
    eligibleForLia90DaysId!: string | undefined;
    eligibleForEhcId!: string | undefined;
    eligibleForEhc90DaysId!: string | undefined;
    eligibleForAlapId!: string | undefined;
    eligibleForSlapId!: string | undefined;
    eligibleForCogsId!: string | undefined;
    eligibleForRlaId!: string | undefined;
    professionRequirementGroups!: GetRequirementGroupDto[] | undefined;
    liaWizardSteps!: LiaStatusWizardStepDto[] | undefined;
    ehcWizardSteps!: EhcStatusWizardStepDto[] | undefined;
    ehcPracticeConfiguration!: EhcPracticeConfigurationDto;
    alapWizardSteps!: AlapStatusWizardStepDto[] | undefined;
    slapWizardSteps!: SlapStatusWizardStepDto[] | undefined;

    constructor(data?: IProfessionRegisterAffiliationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalSystem = _data["externalSystem"];
            this.eligibleForLiaId = _data["eligibleForLiaId"];
            this.eligibleForLia90DaysId = _data["eligibleForLia90DaysId"];
            this.eligibleForEhcId = _data["eligibleForEhcId"];
            this.eligibleForEhc90DaysId = _data["eligibleForEhc90DaysId"];
            this.eligibleForAlapId = _data["eligibleForAlapId"];
            this.eligibleForSlapId = _data["eligibleForSlapId"];
            this.eligibleForCogsId = _data["eligibleForCogsId"];
            this.eligibleForRlaId = _data["eligibleForRlaId"];
            if (Array.isArray(_data["professionRequirementGroups"])) {
                this.professionRequirementGroups = [] as any;
                for (let item of _data["professionRequirementGroups"])
                    this.professionRequirementGroups!.push(GetRequirementGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["liaWizardSteps"])) {
                this.liaWizardSteps = [] as any;
                for (let item of _data["liaWizardSteps"])
                    this.liaWizardSteps!.push(LiaStatusWizardStepDto.fromJS(item));
            }
            if (Array.isArray(_data["ehcWizardSteps"])) {
                this.ehcWizardSteps = [] as any;
                for (let item of _data["ehcWizardSteps"])
                    this.ehcWizardSteps!.push(EhcStatusWizardStepDto.fromJS(item));
            }
            this.ehcPracticeConfiguration = _data["ehcPracticeConfiguration"] ? EhcPracticeConfigurationDto.fromJS(_data["ehcPracticeConfiguration"]) : <any>undefined;
            if (Array.isArray(_data["alapWizardSteps"])) {
                this.alapWizardSteps = [] as any;
                for (let item of _data["alapWizardSteps"])
                    this.alapWizardSteps!.push(AlapStatusWizardStepDto.fromJS(item));
            }
            if (Array.isArray(_data["slapWizardSteps"])) {
                this.slapWizardSteps = [] as any;
                for (let item of _data["slapWizardSteps"])
                    this.slapWizardSteps!.push(SlapStatusWizardStepDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfessionRegisterAffiliationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionRegisterAffiliationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalSystem"] = this.externalSystem;
        data["eligibleForLiaId"] = this.eligibleForLiaId;
        data["eligibleForLia90DaysId"] = this.eligibleForLia90DaysId;
        data["eligibleForEhcId"] = this.eligibleForEhcId;
        data["eligibleForEhc90DaysId"] = this.eligibleForEhc90DaysId;
        data["eligibleForAlapId"] = this.eligibleForAlapId;
        data["eligibleForSlapId"] = this.eligibleForSlapId;
        data["eligibleForCogsId"] = this.eligibleForCogsId;
        data["eligibleForRlaId"] = this.eligibleForRlaId;
        if (Array.isArray(this.professionRequirementGroups)) {
            data["professionRequirementGroups"] = [];
            for (let item of this.professionRequirementGroups)
                data["professionRequirementGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.liaWizardSteps)) {
            data["liaWizardSteps"] = [];
            for (let item of this.liaWizardSteps)
                data["liaWizardSteps"].push(item.toJSON());
        }
        if (Array.isArray(this.ehcWizardSteps)) {
            data["ehcWizardSteps"] = [];
            for (let item of this.ehcWizardSteps)
                data["ehcWizardSteps"].push(item.toJSON());
        }
        data["ehcPracticeConfiguration"] = this.ehcPracticeConfiguration ? this.ehcPracticeConfiguration.toJSON() : <any>undefined;
        if (Array.isArray(this.alapWizardSteps)) {
            data["alapWizardSteps"] = [];
            for (let item of this.alapWizardSteps)
                data["alapWizardSteps"].push(item.toJSON());
        }
        if (Array.isArray(this.slapWizardSteps)) {
            data["slapWizardSteps"] = [];
            for (let item of this.slapWizardSteps)
                data["slapWizardSteps"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProfessionRegisterAffiliationDto {
    id: string;
    externalSystem: ExternalSystemEnum;
    eligibleForLiaId: string | undefined;
    eligibleForLia90DaysId: string | undefined;
    eligibleForEhcId: string | undefined;
    eligibleForEhc90DaysId: string | undefined;
    eligibleForAlapId: string | undefined;
    eligibleForSlapId: string | undefined;
    eligibleForCogsId: string | undefined;
    eligibleForRlaId: string | undefined;
    professionRequirementGroups: GetRequirementGroupDto[] | undefined;
    liaWizardSteps: LiaStatusWizardStepDto[] | undefined;
    ehcWizardSteps: EhcStatusWizardStepDto[] | undefined;
    ehcPracticeConfiguration: EhcPracticeConfigurationDto;
    alapWizardSteps: AlapStatusWizardStepDto[] | undefined;
    slapWizardSteps: SlapStatusWizardStepDto[] | undefined;
}

export class RequirementAlternativeDto implements IRequirementAlternativeDto {
    requirements!: RequirementDto[] | undefined;
    id!: number;

    constructor(data?: IRequirementAlternativeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["requirements"])) {
                this.requirements = [] as any;
                for (let item of _data["requirements"])
                    this.requirements!.push(RequirementDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RequirementAlternativeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementAlternativeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requirements)) {
            data["requirements"] = [];
            for (let item of this.requirements)
                data["requirements"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IRequirementAlternativeDto {
    requirements: RequirementDto[] | undefined;
    id: number;
}

export class RequirementDto implements IRequirementDto {
    requirementType!: RequirementType;
    value!: string | undefined;
    requirementAlternativeId!: number;
    id!: number;

    constructor(data?: IRequirementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requirementType = _data["requirementType"];
            this.value = _data["value"];
            this.requirementAlternativeId = _data["requirementAlternativeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RequirementDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requirementType"] = this.requirementType;
        data["value"] = this.value;
        data["requirementAlternativeId"] = this.requirementAlternativeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRequirementDto {
    requirementType: RequirementType;
    value: string | undefined;
    requirementAlternativeId: number;
    id: number;
}

export class SlapStatusWizardStepDto implements ISlapStatusWizardStepDto {
    order!: number;
    step!: SlapStatus;
    id!: string | undefined;

    constructor(data?: ISlapStatusWizardStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.step = _data["step"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SlapStatusWizardStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlapStatusWizardStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["step"] = this.step;
        data["id"] = this.id;
        return data;
    }
}

export interface ISlapStatusWizardStepDto {
    order: number;
    step: SlapStatus;
    id: string | undefined;
}

export class SponsorshipTypeRegisterAffiliationDto implements ISponsorshipTypeRegisterAffiliationDto {
    id!: string;
    externalSystem!: ExternalSystemEnum;
    eligibleForClaId!: string;
    eligibleForEhcId!: string;
    eligibleForOlaId!: string;
    eligibleForSlasId!: string;
    eligibleForNlaId!: string;
    eligibleForBlaId!: string;
    eligibleForAlasId!: string;

    constructor(data?: ISponsorshipTypeRegisterAffiliationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalSystem = _data["externalSystem"];
            this.eligibleForClaId = _data["eligibleForClaId"];
            this.eligibleForEhcId = _data["eligibleForEhcId"];
            this.eligibleForOlaId = _data["eligibleForOlaId"];
            this.eligibleForSlasId = _data["eligibleForSlasId"];
            this.eligibleForNlaId = _data["eligibleForNlaId"];
            this.eligibleForBlaId = _data["eligibleForBlaId"];
            this.eligibleForAlasId = _data["eligibleForAlasId"];
        }
    }

    static fromJS(data: any): SponsorshipTypeRegisterAffiliationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorshipTypeRegisterAffiliationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalSystem"] = this.externalSystem;
        data["eligibleForClaId"] = this.eligibleForClaId;
        data["eligibleForEhcId"] = this.eligibleForEhcId;
        data["eligibleForOlaId"] = this.eligibleForOlaId;
        data["eligibleForSlasId"] = this.eligibleForSlasId;
        data["eligibleForNlaId"] = this.eligibleForNlaId;
        data["eligibleForBlaId"] = this.eligibleForBlaId;
        data["eligibleForAlasId"] = this.eligibleForAlasId;
        return data;
    }
}

export interface ISponsorshipTypeRegisterAffiliationDto {
    id: string;
    externalSystem: ExternalSystemEnum;
    eligibleForClaId: string;
    eligibleForEhcId: string;
    eligibleForOlaId: string;
    eligibleForSlasId: string;
    eligibleForNlaId: string;
    eligibleForBlaId: string;
    eligibleForAlasId: string;
}

export class UpdateAlapStatusWizardStepsInput implements IUpdateAlapStatusWizardStepsInput {
    alapWizardSteps!: AlapStatusWizardStepDto[];
    professionId!: string;
    applicationType!: ApplicationType;

    constructor(data?: IUpdateAlapStatusWizardStepsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.alapWizardSteps = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["alapWizardSteps"])) {
                this.alapWizardSteps = [] as any;
                for (let item of _data["alapWizardSteps"])
                    this.alapWizardSteps!.push(AlapStatusWizardStepDto.fromJS(item));
            }
            this.professionId = _data["professionId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): UpdateAlapStatusWizardStepsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAlapStatusWizardStepsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.alapWizardSteps)) {
            data["alapWizardSteps"] = [];
            for (let item of this.alapWizardSteps)
                data["alapWizardSteps"].push(item.toJSON());
        }
        data["professionId"] = this.professionId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface IUpdateAlapStatusWizardStepsInput {
    alapWizardSteps: AlapStatusWizardStepDto[];
    professionId: string;
    applicationType: ApplicationType;
}

export class UpdateClaStatusWizardStepsInput implements IUpdateClaStatusWizardStepsInput {
    claWizardSteps!: ClaStatusWizardStepDto[];
    sponsorshipTypeId!: string;
    applicationType!: ApplicationType;

    constructor(data?: IUpdateClaStatusWizardStepsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.claWizardSteps = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["claWizardSteps"])) {
                this.claWizardSteps = [] as any;
                for (let item of _data["claWizardSteps"])
                    this.claWizardSteps!.push(ClaStatusWizardStepDto.fromJS(item));
            }
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): UpdateClaStatusWizardStepsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaStatusWizardStepsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.claWizardSteps)) {
            data["claWizardSteps"] = [];
            for (let item of this.claWizardSteps)
                data["claWizardSteps"].push(item.toJSON());
        }
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface IUpdateClaStatusWizardStepsInput {
    claWizardSteps: ClaStatusWizardStepDto[];
    sponsorshipTypeId: string;
    applicationType: ApplicationType;
}

export class UpdateEhcStatusWizardStepsInput implements IUpdateEhcStatusWizardStepsInput {
    ehcWizardSteps!: EhcStatusWizardStepDto[];
    professionId!: string;
    applicationType!: ApplicationType;

    constructor(data?: IUpdateEhcStatusWizardStepsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcWizardSteps = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ehcWizardSteps"])) {
                this.ehcWizardSteps = [] as any;
                for (let item of _data["ehcWizardSteps"])
                    this.ehcWizardSteps!.push(EhcStatusWizardStepDto.fromJS(item));
            }
            this.professionId = _data["professionId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): UpdateEhcStatusWizardStepsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEhcStatusWizardStepsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ehcWizardSteps)) {
            data["ehcWizardSteps"] = [];
            for (let item of this.ehcWizardSteps)
                data["ehcWizardSteps"].push(item.toJSON());
        }
        data["professionId"] = this.professionId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface IUpdateEhcStatusWizardStepsInput {
    ehcWizardSteps: EhcStatusWizardStepDto[];
    professionId: string;
    applicationType: ApplicationType;
}

export class UpdateLiaStatusWizardStepsInput implements IUpdateLiaStatusWizardStepsInput {
    liaWizardSteps!: LiaStatusWizardStepDto[];
    professionId!: string;
    applicationType!: ApplicationType;

    constructor(data?: IUpdateLiaStatusWizardStepsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaWizardSteps = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["liaWizardSteps"])) {
                this.liaWizardSteps = [] as any;
                for (let item of _data["liaWizardSteps"])
                    this.liaWizardSteps!.push(LiaStatusWizardStepDto.fromJS(item));
            }
            this.professionId = _data["professionId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): UpdateLiaStatusWizardStepsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLiaStatusWizardStepsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.liaWizardSteps)) {
            data["liaWizardSteps"] = [];
            for (let item of this.liaWizardSteps)
                data["liaWizardSteps"].push(item.toJSON());
        }
        data["professionId"] = this.professionId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface IUpdateLiaStatusWizardStepsInput {
    liaWizardSteps: LiaStatusWizardStepDto[];
    professionId: string;
    applicationType: ApplicationType;
}

export class UpdateRequirementGroupDto implements IUpdateRequirementGroupDto {
    description!: string;
    step!: number;
    applicationType!: ApplicationType;

    constructor(data?: IUpdateRequirementGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.step = _data["step"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): UpdateRequirementGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequirementGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["step"] = this.step;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface IUpdateRequirementGroupDto {
    description: string;
    step: number;
    applicationType: ApplicationType;
}

export class UpdateSlapStatusWizardStepsInput implements IUpdateSlapStatusWizardStepsInput {
    slapWizardSteps!: SlapStatusWizardStepDto[];
    professionId!: string;
    applicationType!: ApplicationType;

    constructor(data?: IUpdateSlapStatusWizardStepsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.slapWizardSteps = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["slapWizardSteps"])) {
                this.slapWizardSteps = [] as any;
                for (let item of _data["slapWizardSteps"])
                    this.slapWizardSteps!.push(SlapStatusWizardStepDto.fromJS(item));
            }
            this.professionId = _data["professionId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): UpdateSlapStatusWizardStepsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlapStatusWizardStepsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.slapWizardSteps)) {
            data["slapWizardSteps"] = [];
            for (let item of this.slapWizardSteps)
                data["slapWizardSteps"].push(item.toJSON());
        }
        data["professionId"] = this.professionId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface IUpdateSlapStatusWizardStepsInput {
    slapWizardSteps: SlapStatusWizardStepDto[];
    professionId: string;
    applicationType: ApplicationType;
}

export class CreateCorporateLicenceRestrictionDto implements ICreateCorporateLicenceRestrictionDto {
    licenceId!: number;
    typeId!: string;
    dateOfIssue!: DateTime;
    dateOfEnd!: DateTime | undefined;
    dateOfCompliance!: DateTime | undefined;
    remark!: string | undefined;

    constructor(data?: ICreateCorporateLicenceRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceId = _data["licenceId"];
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfCompliance = _data["dateOfCompliance"] ? DateTime.fromISO(_data["dateOfCompliance"].toString()) : <any>undefined;
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): CreateCorporateLicenceRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCorporateLicenceRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceId"] = this.licenceId;
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCompliance"] = this.dateOfCompliance ? this.dateOfCompliance.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        return data;
    }
}

export interface ICreateCorporateLicenceRestrictionDto {
    licenceId: number;
    typeId: string;
    dateOfIssue: DateTime;
    dateOfEnd: DateTime | undefined;
    dateOfCompliance: DateTime | undefined;
    remark: string | undefined;
}

export class CreateRestrictionDto implements ICreateRestrictionDto {
    personLicenceId!: number | undefined;
    typeId!: string;
    dateOfIssue!: DateTime;
    dateOfEnd!: DateTime | undefined;
    dateOfCompliance!: DateTime | undefined;
    remark!: string | undefined;
    healthRegisterTransfer!: boolean;

    constructor(data?: ICreateRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personLicenceId = _data["personLicenceId"];
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfCompliance = _data["dateOfCompliance"] ? DateTime.fromISO(_data["dateOfCompliance"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
        }
    }

    static fromJS(data: any): CreateRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personLicenceId"] = this.personLicenceId;
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCompliance"] = this.dateOfCompliance ? this.dateOfCompliance.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        return data;
    }
}

export interface ICreateRestrictionDto {
    personLicenceId: number | undefined;
    typeId: string;
    dateOfIssue: DateTime;
    dateOfEnd: DateTime | undefined;
    dateOfCompliance: DateTime | undefined;
    remark: string | undefined;
    healthRegisterTransfer: boolean;
}

export class GetRestrictionDto implements IGetRestrictionDto {
    healthRegisterSync!: DateTime | undefined;
    typeId!: string;
    dateOfIssue!: DateTime;
    dateOfEnd!: DateTime | undefined;
    dateOfCompliance!: DateTime | undefined;
    remark!: string | undefined;
    healthRegisterTransfer!: boolean;

    constructor(data?: IGetRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRegisterSync = _data["healthRegisterSync"] ? DateTime.fromISO(_data["healthRegisterSync"].toString()) : <any>undefined;
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfCompliance = _data["dateOfCompliance"] ? DateTime.fromISO(_data["dateOfCompliance"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
        }
    }

    static fromJS(data: any): GetRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRegisterSync"] = this.healthRegisterSync ? this.healthRegisterSync.toString() : <any>undefined;
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCompliance"] = this.dateOfCompliance ? this.dateOfCompliance.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        return data;
    }
}

export interface IGetRestrictionDto {
    healthRegisterSync: DateTime | undefined;
    typeId: string;
    dateOfIssue: DateTime;
    dateOfEnd: DateTime | undefined;
    dateOfCompliance: DateTime | undefined;
    remark: string | undefined;
    healthRegisterTransfer: boolean;
}

export class UpdateRestrictionDto implements IUpdateRestrictionDto {
    typeId!: string;
    dateOfIssue!: DateTime;
    dateOfEnd!: DateTime | undefined;
    dateOfCompliance!: DateTime | undefined;
    remark!: string | undefined;
    healthRegisterTransfer!: boolean;

    constructor(data?: IUpdateRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfCompliance = _data["dateOfCompliance"] ? DateTime.fromISO(_data["dateOfCompliance"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
        }
    }

    static fromJS(data: any): UpdateRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCompliance"] = this.dateOfCompliance ? this.dateOfCompliance.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        return data;
    }
}

export interface IUpdateRestrictionDto {
    typeId: string;
    dateOfIssue: DateTime;
    dateOfEnd: DateTime | undefined;
    dateOfCompliance: DateTime | undefined;
    remark: string | undefined;
    healthRegisterTransfer: boolean;
}

export class CreateOrUpdateSapInvoiceDto implements ICreateOrUpdateSapInvoiceDto {
    orderingPersonId!: number | undefined;
    orderingSponsorshipId!: number | undefined;
    debitorSponsorshipId!: number | undefined;
    debitorBusinessId!: number | undefined;
    addressTypeId!: string;
    headerInformation!: string | undefined;
    footerInformation!: string | undefined;
    cantonalDepartmentId!: string;
    costCenterId!: string;
    contactPersonId!: number | undefined;
    dateOfBilling!: DateTime | undefined;
    invoiceItems!: SapInvoiceItemDto[] | undefined;

    constructor(data?: ICreateOrUpdateSapInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderingPersonId = _data["orderingPersonId"];
            this.orderingSponsorshipId = _data["orderingSponsorshipId"];
            this.debitorSponsorshipId = _data["debitorSponsorshipId"];
            this.debitorBusinessId = _data["debitorBusinessId"];
            this.addressTypeId = _data["addressTypeId"];
            this.headerInformation = _data["headerInformation"];
            this.footerInformation = _data["footerInformation"];
            this.cantonalDepartmentId = _data["cantonalDepartmentId"];
            this.costCenterId = _data["costCenterId"];
            this.contactPersonId = _data["contactPersonId"];
            this.dateOfBilling = _data["dateOfBilling"] ? DateTime.fromISO(_data["dateOfBilling"].toString()) : <any>undefined;
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(SapInvoiceItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateSapInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSapInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderingPersonId"] = this.orderingPersonId;
        data["orderingSponsorshipId"] = this.orderingSponsorshipId;
        data["debitorSponsorshipId"] = this.debitorSponsorshipId;
        data["debitorBusinessId"] = this.debitorBusinessId;
        data["addressTypeId"] = this.addressTypeId;
        data["headerInformation"] = this.headerInformation;
        data["footerInformation"] = this.footerInformation;
        data["cantonalDepartmentId"] = this.cantonalDepartmentId;
        data["costCenterId"] = this.costCenterId;
        data["contactPersonId"] = this.contactPersonId;
        data["dateOfBilling"] = this.dateOfBilling ? this.dateOfBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateSapInvoiceDto {
    orderingPersonId: number | undefined;
    orderingSponsorshipId: number | undefined;
    debitorSponsorshipId: number | undefined;
    debitorBusinessId: number | undefined;
    addressTypeId: string;
    headerInformation: string | undefined;
    footerInformation: string | undefined;
    cantonalDepartmentId: string;
    costCenterId: string;
    contactPersonId: number | undefined;
    dateOfBilling: DateTime | undefined;
    invoiceItems: SapInvoiceItemDto[] | undefined;
}

export class SapBusinessDto implements ISapBusinessDto {
    legalFormId!: string | undefined;
    name!: string | undefined;
    additionalName!: string | undefined;
    gln!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    id!: number;

    constructor(data?: ISapBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalFormId = _data["legalFormId"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.gln = _data["gln"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalFormId"] = this.legalFormId;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["gln"] = this.gln;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["id"] = this.id;
        return data;
    }
}

export interface ISapBusinessDto {
    legalFormId: string | undefined;
    name: string | undefined;
    additionalName: string | undefined;
    gln: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    id: number;
}

export class SapCancellationReason implements ISapCancellationReason {
    sapId!: string | undefined;
    sapDescription!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISapCancellationReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sapId = _data["sapId"];
            this.sapDescription = _data["sapDescription"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapCancellationReason {
        data = typeof data === 'object' ? data : {};
        let result = new SapCancellationReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sapId"] = this.sapId;
        data["sapDescription"] = this.sapDescription;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISapCancellationReason {
    sapId: string | undefined;
    sapDescription: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class SapCancellationReasonDto implements ISapCancellationReasonDto {
    sapId!: string;
    sapDescription!: string;
    id!: number;

    constructor(data?: ISapCancellationReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sapId = _data["sapId"];
            this.sapDescription = _data["sapDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapCancellationReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapCancellationReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sapId"] = this.sapId;
        data["sapDescription"] = this.sapDescription;
        data["id"] = this.id;
        return data;
    }
}

export interface ISapCancellationReasonDto {
    sapId: string;
    sapDescription: string;
    id: number;
}

export class SapContactPerson implements ISapContactPerson {
    cantonalDepartmentId!: string | undefined;
    costCenterId!: string | undefined;
    abbreviation!: string | undefined;
    description!: string | undefined;
    validFrom!: DateTime;
    validTo!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISapContactPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantonalDepartmentId = _data["cantonalDepartmentId"];
            this.costCenterId = _data["costCenterId"];
            this.abbreviation = _data["abbreviation"];
            this.description = _data["description"];
            this.validFrom = _data["validFrom"] ? DateTime.fromISO(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? DateTime.fromISO(_data["validTo"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapContactPerson {
        data = typeof data === 'object' ? data : {};
        let result = new SapContactPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantonalDepartmentId"] = this.cantonalDepartmentId;
        data["costCenterId"] = this.costCenterId;
        data["abbreviation"] = this.abbreviation;
        data["description"] = this.description;
        data["validFrom"] = this.validFrom ? this.validFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toFormat('yyyy-MM-dd') : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISapContactPerson {
    cantonalDepartmentId: string | undefined;
    costCenterId: string | undefined;
    abbreviation: string | undefined;
    description: string | undefined;
    validFrom: DateTime;
    validTo: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class SapContactPersonDto implements ISapContactPersonDto {
    cantonalDepartmentId!: string;
    costCenterId!: string;
    abbreviation!: string;
    description!: string;
    validFrom!: DateTime;
    validTo!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISapContactPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantonalDepartmentId = _data["cantonalDepartmentId"];
            this.costCenterId = _data["costCenterId"];
            this.abbreviation = _data["abbreviation"];
            this.description = _data["description"];
            this.validFrom = _data["validFrom"] ? DateTime.fromISO(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? DateTime.fromISO(_data["validTo"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapContactPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapContactPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantonalDepartmentId"] = this.cantonalDepartmentId;
        data["costCenterId"] = this.costCenterId;
        data["abbreviation"] = this.abbreviation;
        data["description"] = this.description;
        data["validFrom"] = this.validFrom ? this.validFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toFormat('yyyy-MM-dd') : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISapContactPersonDto {
    cantonalDepartmentId: string;
    costCenterId: string;
    abbreviation: string;
    description: string;
    validFrom: DateTime;
    validTo: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class SapInvoice implements ISapInvoice {
    sironaId!: string | undefined;
    sapId!: string | undefined;
    sapErrorMessage!: string | undefined;
    orderingPerson!: Person;
    orderingPersonId!: number | undefined;
    orderingSponsorship!: Sponsorship;
    orderingSponsorshipId!: number | undefined;
    debitorSponsorship!: Sponsorship;
    debitorSponsorshipId!: number | undefined;
    debitorBusiness!: Business;
    debitorBusinessId!: number | undefined;
    addressTypeId!: string | undefined;
    statusId!: string | undefined;
    headerInformation!: string | undefined;
    footerInformation!: string | undefined;
    cantonalDepartmentId!: string | undefined;
    costCenterId!: string | undefined;
    dateOfBilling!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    cancellationReason!: SapCancellationReason;
    cancellationReasonId!: number | undefined;
    cancellationSapId!: string | undefined;
    contactPerson!: SapContactPerson;
    contactPersonId!: number | undefined;
    invoiceItems!: SapInvoiceItem[] | undefined;
    documentLinks!: DocumentLinkSapInvoice[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISapInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sironaId = _data["sironaId"];
            this.sapId = _data["sapId"];
            this.sapErrorMessage = _data["sapErrorMessage"];
            this.orderingPerson = _data["orderingPerson"] ? Person.fromJS(_data["orderingPerson"]) : <any>undefined;
            this.orderingPersonId = _data["orderingPersonId"];
            this.orderingSponsorship = _data["orderingSponsorship"] ? Sponsorship.fromJS(_data["orderingSponsorship"]) : <any>undefined;
            this.orderingSponsorshipId = _data["orderingSponsorshipId"];
            this.debitorSponsorship = _data["debitorSponsorship"] ? Sponsorship.fromJS(_data["debitorSponsorship"]) : <any>undefined;
            this.debitorSponsorshipId = _data["debitorSponsorshipId"];
            this.debitorBusiness = _data["debitorBusiness"] ? Business.fromJS(_data["debitorBusiness"]) : <any>undefined;
            this.debitorBusinessId = _data["debitorBusinessId"];
            this.addressTypeId = _data["addressTypeId"];
            this.statusId = _data["statusId"];
            this.headerInformation = _data["headerInformation"];
            this.footerInformation = _data["footerInformation"];
            this.cantonalDepartmentId = _data["cantonalDepartmentId"];
            this.costCenterId = _data["costCenterId"];
            this.dateOfBilling = _data["dateOfBilling"] ? DateTime.fromISO(_data["dateOfBilling"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.cancellationReason = _data["cancellationReason"] ? SapCancellationReason.fromJS(_data["cancellationReason"]) : <any>undefined;
            this.cancellationReasonId = _data["cancellationReasonId"];
            this.cancellationSapId = _data["cancellationSapId"];
            this.contactPerson = _data["contactPerson"] ? SapContactPerson.fromJS(_data["contactPerson"]) : <any>undefined;
            this.contactPersonId = _data["contactPersonId"];
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(SapInvoiceItem.fromJS(item));
            }
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkSapInvoice.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new SapInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sironaId"] = this.sironaId;
        data["sapId"] = this.sapId;
        data["sapErrorMessage"] = this.sapErrorMessage;
        data["orderingPerson"] = this.orderingPerson ? this.orderingPerson.toJSON() : <any>undefined;
        data["orderingPersonId"] = this.orderingPersonId;
        data["orderingSponsorship"] = this.orderingSponsorship ? this.orderingSponsorship.toJSON() : <any>undefined;
        data["orderingSponsorshipId"] = this.orderingSponsorshipId;
        data["debitorSponsorship"] = this.debitorSponsorship ? this.debitorSponsorship.toJSON() : <any>undefined;
        data["debitorSponsorshipId"] = this.debitorSponsorshipId;
        data["debitorBusiness"] = this.debitorBusiness ? this.debitorBusiness.toJSON() : <any>undefined;
        data["debitorBusinessId"] = this.debitorBusinessId;
        data["addressTypeId"] = this.addressTypeId;
        data["statusId"] = this.statusId;
        data["headerInformation"] = this.headerInformation;
        data["footerInformation"] = this.footerInformation;
        data["cantonalDepartmentId"] = this.cantonalDepartmentId;
        data["costCenterId"] = this.costCenterId;
        data["dateOfBilling"] = this.dateOfBilling ? this.dateOfBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["cancellationReason"] = this.cancellationReason ? this.cancellationReason.toJSON() : <any>undefined;
        data["cancellationReasonId"] = this.cancellationReasonId;
        data["cancellationSapId"] = this.cancellationSapId;
        data["contactPerson"] = this.contactPerson ? this.contactPerson.toJSON() : <any>undefined;
        data["contactPersonId"] = this.contactPersonId;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item.toJSON());
        }
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISapInvoice {
    sironaId: string | undefined;
    sapId: string | undefined;
    sapErrorMessage: string | undefined;
    orderingPerson: Person;
    orderingPersonId: number | undefined;
    orderingSponsorship: Sponsorship;
    orderingSponsorshipId: number | undefined;
    debitorSponsorship: Sponsorship;
    debitorSponsorshipId: number | undefined;
    debitorBusiness: Business;
    debitorBusinessId: number | undefined;
    addressTypeId: string | undefined;
    statusId: string | undefined;
    headerInformation: string | undefined;
    footerInformation: string | undefined;
    cantonalDepartmentId: string | undefined;
    costCenterId: string | undefined;
    dateOfBilling: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    cancellationReason: SapCancellationReason;
    cancellationReasonId: number | undefined;
    cancellationSapId: string | undefined;
    contactPerson: SapContactPerson;
    contactPersonId: number | undefined;
    invoiceItems: SapInvoiceItem[] | undefined;
    documentLinks: DocumentLinkSapInvoice[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class SapInvoiceDto implements ISapInvoiceDto {
    sironaId!: string | undefined;
    sapId!: string | undefined;
    orderingPerson!: SapPersonDto;
    orderingPersonId!: number | undefined;
    orderingSponsorship!: SapSponsorshipDto;
    orderingSponsorshipId!: number | undefined;
    ordererDescription!: string | undefined;
    debitorSponsorship!: SapSponsorshipDto;
    debitorSponsorshipId!: number | undefined;
    debitorBusiness!: SapBusinessDto;
    debitorBusinessId!: number | undefined;
    addressTypeId!: string | undefined;
    statusId!: string | undefined;
    headerInformation!: string | undefined;
    footerInformation!: string | undefined;
    cantonalDepartmentId!: string | undefined;
    costCenterId!: string | undefined;
    contactPersonId!: number | undefined;
    dateOfBilling!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    cancellationReasonId!: number | undefined;
    cancellationSapId!: string | undefined;
    isDebitorNameTooLong!: boolean;
    sapErrorMessage!: string | undefined;
    invoiceItems!: SapInvoiceItemDto[] | undefined;
    id!: number;

    constructor(data?: ISapInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sironaId = _data["sironaId"];
            this.sapId = _data["sapId"];
            this.orderingPerson = _data["orderingPerson"] ? SapPersonDto.fromJS(_data["orderingPerson"]) : <any>undefined;
            this.orderingPersonId = _data["orderingPersonId"];
            this.orderingSponsorship = _data["orderingSponsorship"] ? SapSponsorshipDto.fromJS(_data["orderingSponsorship"]) : <any>undefined;
            this.orderingSponsorshipId = _data["orderingSponsorshipId"];
            this.ordererDescription = _data["ordererDescription"];
            this.debitorSponsorship = _data["debitorSponsorship"] ? SapSponsorshipDto.fromJS(_data["debitorSponsorship"]) : <any>undefined;
            this.debitorSponsorshipId = _data["debitorSponsorshipId"];
            this.debitorBusiness = _data["debitorBusiness"] ? SapBusinessDto.fromJS(_data["debitorBusiness"]) : <any>undefined;
            this.debitorBusinessId = _data["debitorBusinessId"];
            this.addressTypeId = _data["addressTypeId"];
            this.statusId = _data["statusId"];
            this.headerInformation = _data["headerInformation"];
            this.footerInformation = _data["footerInformation"];
            this.cantonalDepartmentId = _data["cantonalDepartmentId"];
            this.costCenterId = _data["costCenterId"];
            this.contactPersonId = _data["contactPersonId"];
            this.dateOfBilling = _data["dateOfBilling"] ? DateTime.fromISO(_data["dateOfBilling"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.cancellationReasonId = _data["cancellationReasonId"];
            this.cancellationSapId = _data["cancellationSapId"];
            this.isDebitorNameTooLong = _data["isDebitorNameTooLong"];
            this.sapErrorMessage = _data["sapErrorMessage"];
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(SapInvoiceItemDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sironaId"] = this.sironaId;
        data["sapId"] = this.sapId;
        data["orderingPerson"] = this.orderingPerson ? this.orderingPerson.toJSON() : <any>undefined;
        data["orderingPersonId"] = this.orderingPersonId;
        data["orderingSponsorship"] = this.orderingSponsorship ? this.orderingSponsorship.toJSON() : <any>undefined;
        data["orderingSponsorshipId"] = this.orderingSponsorshipId;
        data["ordererDescription"] = this.ordererDescription;
        data["debitorSponsorship"] = this.debitorSponsorship ? this.debitorSponsorship.toJSON() : <any>undefined;
        data["debitorSponsorshipId"] = this.debitorSponsorshipId;
        data["debitorBusiness"] = this.debitorBusiness ? this.debitorBusiness.toJSON() : <any>undefined;
        data["debitorBusinessId"] = this.debitorBusinessId;
        data["addressTypeId"] = this.addressTypeId;
        data["statusId"] = this.statusId;
        data["headerInformation"] = this.headerInformation;
        data["footerInformation"] = this.footerInformation;
        data["cantonalDepartmentId"] = this.cantonalDepartmentId;
        data["costCenterId"] = this.costCenterId;
        data["contactPersonId"] = this.contactPersonId;
        data["dateOfBilling"] = this.dateOfBilling ? this.dateOfBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["cancellationReasonId"] = this.cancellationReasonId;
        data["cancellationSapId"] = this.cancellationSapId;
        data["isDebitorNameTooLong"] = this.isDebitorNameTooLong;
        data["sapErrorMessage"] = this.sapErrorMessage;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ISapInvoiceDto {
    sironaId: string | undefined;
    sapId: string | undefined;
    orderingPerson: SapPersonDto;
    orderingPersonId: number | undefined;
    orderingSponsorship: SapSponsorshipDto;
    orderingSponsorshipId: number | undefined;
    ordererDescription: string | undefined;
    debitorSponsorship: SapSponsorshipDto;
    debitorSponsorshipId: number | undefined;
    debitorBusiness: SapBusinessDto;
    debitorBusinessId: number | undefined;
    addressTypeId: string | undefined;
    statusId: string | undefined;
    headerInformation: string | undefined;
    footerInformation: string | undefined;
    cantonalDepartmentId: string | undefined;
    costCenterId: string | undefined;
    contactPersonId: number | undefined;
    dateOfBilling: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    cancellationReasonId: number | undefined;
    cancellationSapId: string | undefined;
    isDebitorNameTooLong: boolean;
    sapErrorMessage: string | undefined;
    invoiceItems: SapInvoiceItemDto[] | undefined;
    id: number;
}

export class SapInvoiceItem implements ISapInvoiceItem {
    sapInvoiceId!: number;
    productId!: number;
    product!: SapProduct;
    sapDescription!: string | undefined;
    additionalInformation!: string | undefined;
    quantity!: number;
    pricePerUnit!: number;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISapInvoiceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sapInvoiceId = _data["sapInvoiceId"];
            this.productId = _data["productId"];
            this.product = _data["product"] ? SapProduct.fromJS(_data["product"]) : <any>undefined;
            this.sapDescription = _data["sapDescription"];
            this.additionalInformation = _data["additionalInformation"];
            this.quantity = _data["quantity"];
            this.pricePerUnit = _data["pricePerUnit"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapInvoiceItem {
        data = typeof data === 'object' ? data : {};
        let result = new SapInvoiceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sapInvoiceId"] = this.sapInvoiceId;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["sapDescription"] = this.sapDescription;
        data["additionalInformation"] = this.additionalInformation;
        data["quantity"] = this.quantity;
        data["pricePerUnit"] = this.pricePerUnit;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISapInvoiceItem {
    sapInvoiceId: number;
    productId: number;
    product: SapProduct;
    sapDescription: string | undefined;
    additionalInformation: string | undefined;
    quantity: number;
    pricePerUnit: number;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class SapInvoiceItemDto implements ISapInvoiceItemDto {
    productId!: number;
    sapDescription!: string;
    additionalInformation!: string | undefined;
    quantity!: number;
    pricePerUnit!: number;
    id!: number;

    constructor(data?: ISapInvoiceItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.sapDescription = _data["sapDescription"];
            this.additionalInformation = _data["additionalInformation"];
            this.quantity = _data["quantity"];
            this.pricePerUnit = _data["pricePerUnit"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapInvoiceItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapInvoiceItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["sapDescription"] = this.sapDescription;
        data["additionalInformation"] = this.additionalInformation;
        data["quantity"] = this.quantity;
        data["pricePerUnit"] = this.pricePerUnit;
        data["id"] = this.id;
        return data;
    }
}

export interface ISapInvoiceItemDto {
    productId: number;
    sapDescription: string;
    additionalInformation: string | undefined;
    quantity: number;
    pricePerUnit: number;
    id: number;
}

export class SapInvoiceSearchDto implements ISapInvoiceSearchDto {
    sapId!: string | undefined;
    sapErrorMessage!: string | undefined;
    orderingPersonId!: number | undefined;
    orderingSponsorshipId!: number | undefined;
    orderer!: string | undefined;
    debitorSponsorshipId!: number | undefined;
    debitorBusinessId!: number | undefined;
    debitor!: string | undefined;
    statusId!: string | undefined;
    amount!: number;
    headerInformation!: string | undefined;
    cantonalDepartmentId!: string | undefined;
    costCenterId!: string | undefined;
    contactPerson!: string | undefined;
    dateOfBilling!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    cancellationReason!: string | undefined;
    cancellationSapId!: string | undefined;
    id!: number;

    constructor(data?: ISapInvoiceSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sapId = _data["sapId"];
            this.sapErrorMessage = _data["sapErrorMessage"];
            this.orderingPersonId = _data["orderingPersonId"];
            this.orderingSponsorshipId = _data["orderingSponsorshipId"];
            this.orderer = _data["orderer"];
            this.debitorSponsorshipId = _data["debitorSponsorshipId"];
            this.debitorBusinessId = _data["debitorBusinessId"];
            this.debitor = _data["debitor"];
            this.statusId = _data["statusId"];
            this.amount = _data["amount"];
            this.headerInformation = _data["headerInformation"];
            this.cantonalDepartmentId = _data["cantonalDepartmentId"];
            this.costCenterId = _data["costCenterId"];
            this.contactPerson = _data["contactPerson"];
            this.dateOfBilling = _data["dateOfBilling"] ? DateTime.fromISO(_data["dateOfBilling"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.cancellationReason = _data["cancellationReason"];
            this.cancellationSapId = _data["cancellationSapId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapInvoiceSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapInvoiceSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sapId"] = this.sapId;
        data["sapErrorMessage"] = this.sapErrorMessage;
        data["orderingPersonId"] = this.orderingPersonId;
        data["orderingSponsorshipId"] = this.orderingSponsorshipId;
        data["orderer"] = this.orderer;
        data["debitorSponsorshipId"] = this.debitorSponsorshipId;
        data["debitorBusinessId"] = this.debitorBusinessId;
        data["debitor"] = this.debitor;
        data["statusId"] = this.statusId;
        data["amount"] = this.amount;
        data["headerInformation"] = this.headerInformation;
        data["cantonalDepartmentId"] = this.cantonalDepartmentId;
        data["costCenterId"] = this.costCenterId;
        data["contactPerson"] = this.contactPerson;
        data["dateOfBilling"] = this.dateOfBilling ? this.dateOfBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["cancellationReason"] = this.cancellationReason;
        data["cancellationSapId"] = this.cancellationSapId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISapInvoiceSearchDto {
    sapId: string | undefined;
    sapErrorMessage: string | undefined;
    orderingPersonId: number | undefined;
    orderingSponsorshipId: number | undefined;
    orderer: string | undefined;
    debitorSponsorshipId: number | undefined;
    debitorBusinessId: number | undefined;
    debitor: string | undefined;
    statusId: string | undefined;
    amount: number;
    headerInformation: string | undefined;
    cantonalDepartmentId: string | undefined;
    costCenterId: string | undefined;
    contactPerson: string | undefined;
    dateOfBilling: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    cancellationReason: string | undefined;
    cancellationSapId: string | undefined;
    id: number;
}

export class SapPersonDto implements ISapPersonDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    gln!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    contact!: ContactDto;
    invoiceAddress!: InvoiceAddressDto;
    employments!: GetEmploymentDto[] | undefined;
    id!: number;

    constructor(data?: ISapPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gln = _data["gln"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.contact = _data["contact"] ? ContactDto.fromJS(_data["contact"]) : <any>undefined;
            this.invoiceAddress = _data["invoiceAddress"] ? InvoiceAddressDto.fromJS(_data["invoiceAddress"]) : <any>undefined;
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(GetEmploymentDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["gln"] = this.gln;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["invoiceAddress"] = this.invoiceAddress ? this.invoiceAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ISapPersonDto {
    firstName: string | undefined;
    lastName: string | undefined;
    dateOfBirth: DateTime | undefined;
    gln: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    contact: ContactDto;
    invoiceAddress: InvoiceAddressDto;
    employments: GetEmploymentDto[] | undefined;
    id: number;
}

export class SapProduct implements ISapProduct {
    sapId!: string | undefined;
    sapDescription!: string | undefined;
    detailedDescription!: string | undefined;
    pricePerUnit!: number | undefined;
    cantonalDepartmentId!: string | undefined;
    costCenterId!: string | undefined;
    costElementId!: string | undefined;
    internalOrderId!: string | undefined;
    contextId!: string | undefined;
    personLicenceType!: PersonLicenceType;
    corporateLicenceType!: CorporateLicenceType;
    professionId!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    isForRenewal!: boolean;
    isForTimeLimitedLicences!: boolean;
    validFrom!: DateTime;
    validTo!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISapProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sapId = _data["sapId"];
            this.sapDescription = _data["sapDescription"];
            this.detailedDescription = _data["detailedDescription"];
            this.pricePerUnit = _data["pricePerUnit"];
            this.cantonalDepartmentId = _data["cantonalDepartmentId"];
            this.costCenterId = _data["costCenterId"];
            this.costElementId = _data["costElementId"];
            this.internalOrderId = _data["internalOrderId"];
            this.contextId = _data["contextId"];
            this.personLicenceType = _data["personLicenceType"];
            this.corporateLicenceType = _data["corporateLicenceType"];
            this.professionId = _data["professionId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.isForRenewal = _data["isForRenewal"];
            this.isForTimeLimitedLicences = _data["isForTimeLimitedLicences"];
            this.validFrom = _data["validFrom"] ? DateTime.fromISO(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? DateTime.fromISO(_data["validTo"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapProduct {
        data = typeof data === 'object' ? data : {};
        let result = new SapProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sapId"] = this.sapId;
        data["sapDescription"] = this.sapDescription;
        data["detailedDescription"] = this.detailedDescription;
        data["pricePerUnit"] = this.pricePerUnit;
        data["cantonalDepartmentId"] = this.cantonalDepartmentId;
        data["costCenterId"] = this.costCenterId;
        data["costElementId"] = this.costElementId;
        data["internalOrderId"] = this.internalOrderId;
        data["contextId"] = this.contextId;
        data["personLicenceType"] = this.personLicenceType;
        data["corporateLicenceType"] = this.corporateLicenceType;
        data["professionId"] = this.professionId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["isForRenewal"] = this.isForRenewal;
        data["isForTimeLimitedLicences"] = this.isForTimeLimitedLicences;
        data["validFrom"] = this.validFrom ? this.validFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toFormat('yyyy-MM-dd') : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISapProduct {
    sapId: string | undefined;
    sapDescription: string | undefined;
    detailedDescription: string | undefined;
    pricePerUnit: number | undefined;
    cantonalDepartmentId: string | undefined;
    costCenterId: string | undefined;
    costElementId: string | undefined;
    internalOrderId: string | undefined;
    contextId: string | undefined;
    personLicenceType: PersonLicenceType;
    corporateLicenceType: CorporateLicenceType;
    professionId: string | undefined;
    sponsorshipTypeId: string | undefined;
    isForRenewal: boolean;
    isForTimeLimitedLicences: boolean;
    validFrom: DateTime;
    validTo: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class SapProductDto implements ISapProductDto {
    sapId!: string;
    sapDescription!: string;
    detailedDescription!: string | undefined;
    pricePerUnit!: number | undefined;
    cantonalDepartmentId!: string;
    costCenterId!: string;
    costElementId!: string;
    internalOrderId!: string;
    contextId!: string;
    personLicenceType!: PersonLicenceType;
    professionId!: string | undefined;
    corporateLicenceType!: CorporateLicenceType;
    sponsorshipTypeId!: string | undefined;
    isForTimeLimitedLicences!: boolean;
    isForRenewal!: boolean;
    validFrom!: DateTime;
    validTo!: DateTime | undefined;
    id!: number;

    constructor(data?: ISapProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sapId = _data["sapId"];
            this.sapDescription = _data["sapDescription"];
            this.detailedDescription = _data["detailedDescription"];
            this.pricePerUnit = _data["pricePerUnit"];
            this.cantonalDepartmentId = _data["cantonalDepartmentId"];
            this.costCenterId = _data["costCenterId"];
            this.costElementId = _data["costElementId"];
            this.internalOrderId = _data["internalOrderId"];
            this.contextId = _data["contextId"];
            this.personLicenceType = _data["personLicenceType"];
            this.professionId = _data["professionId"];
            this.corporateLicenceType = _data["corporateLicenceType"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.isForTimeLimitedLicences = _data["isForTimeLimitedLicences"];
            this.isForRenewal = _data["isForRenewal"];
            this.validFrom = _data["validFrom"] ? DateTime.fromISO(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? DateTime.fromISO(_data["validTo"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sapId"] = this.sapId;
        data["sapDescription"] = this.sapDescription;
        data["detailedDescription"] = this.detailedDescription;
        data["pricePerUnit"] = this.pricePerUnit;
        data["cantonalDepartmentId"] = this.cantonalDepartmentId;
        data["costCenterId"] = this.costCenterId;
        data["costElementId"] = this.costElementId;
        data["internalOrderId"] = this.internalOrderId;
        data["contextId"] = this.contextId;
        data["personLicenceType"] = this.personLicenceType;
        data["professionId"] = this.professionId;
        data["corporateLicenceType"] = this.corporateLicenceType;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["isForTimeLimitedLicences"] = this.isForTimeLimitedLicences;
        data["isForRenewal"] = this.isForRenewal;
        data["validFrom"] = this.validFrom ? this.validFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toFormat('yyyy-MM-dd') : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ISapProductDto {
    sapId: string;
    sapDescription: string;
    detailedDescription: string | undefined;
    pricePerUnit: number | undefined;
    cantonalDepartmentId: string;
    costCenterId: string;
    costElementId: string;
    internalOrderId: string;
    contextId: string;
    personLicenceType: PersonLicenceType;
    professionId: string | undefined;
    corporateLicenceType: CorporateLicenceType;
    sponsorshipTypeId: string | undefined;
    isForTimeLimitedLicences: boolean;
    isForRenewal: boolean;
    validFrom: DateTime;
    validTo: DateTime | undefined;
    id: number;
}

export class SapSponsorshipDto implements ISapSponsorshipDto {
    name!: string | undefined;
    additionalName!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    invoiceAddress!: SponsorshipInvoiceAddressDto;
    businesses!: SapBusinessDto[] | undefined;
    id!: number;

    constructor(data?: ISapSponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.invoiceAddress = _data["invoiceAddress"] ? SponsorshipInvoiceAddressDto.fromJS(_data["invoiceAddress"]) : <any>undefined;
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(SapBusinessDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapSponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapSponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["invoiceAddress"] = this.invoiceAddress ? this.invoiceAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ISapSponsorshipDto {
    name: string | undefined;
    additionalName: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    invoiceAddress: SponsorshipInvoiceAddressDto;
    businesses: SapBusinessDto[] | undefined;
    id: number;
}

export class SearchCancellationReasonsInput implements ISearchCancellationReasonsInput {
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: ISearchCancellationReasonsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): SearchCancellationReasonsInput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCancellationReasonsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface ISearchCancellationReasonsInput {
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class SearchCancellationReasonsOutput implements ISearchCancellationReasonsOutput {
    totalCount!: number;
    items!: SapCancellationReasonDto[] | undefined;

    constructor(data?: ISearchCancellationReasonsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SapCancellationReasonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchCancellationReasonsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCancellationReasonsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchCancellationReasonsOutput {
    totalCount: number;
    items: SapCancellationReasonDto[] | undefined;
}

export class SearchContactPersonsInput implements ISearchContactPersonsInput {
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: ISearchContactPersonsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): SearchContactPersonsInput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchContactPersonsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface ISearchContactPersonsInput {
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class SearchContactPersonsOutput implements ISearchContactPersonsOutput {
    totalCount!: number;
    items!: SapContactPersonDto[] | undefined;

    constructor(data?: ISearchContactPersonsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SapContactPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchContactPersonsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchContactPersonsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchContactPersonsOutput {
    totalCount: number;
    items: SapContactPersonDto[] | undefined;
}

export class SearchInvoicesInput implements ISearchInvoicesInput {
    personId!: number | undefined;
    sponsorshipId!: number | undefined;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: ISearchInvoicesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): SearchInvoicesInput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchInvoicesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["sponsorshipId"] = this.sponsorshipId;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface ISearchInvoicesInput {
    personId: number | undefined;
    sponsorshipId: number | undefined;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class SearchInvoicesOutput implements ISearchInvoicesOutput {
    totalCount!: number;
    items!: SapInvoiceSearchDto[] | undefined;

    constructor(data?: ISearchInvoicesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SapInvoiceSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchInvoicesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchInvoicesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchInvoicesOutput {
    totalCount: number;
    items: SapInvoiceSearchDto[] | undefined;
}

export class SearchProductsInput implements ISearchProductsInput {
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: ISearchProductsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): SearchProductsInput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchProductsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface ISearchProductsInput {
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class SearchProductsOutput implements ISearchProductsOutput {
    totalCount!: number;
    items!: SapProductDto[] | undefined;

    constructor(data?: ISearchProductsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SapProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchProductsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchProductsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchProductsOutput {
    totalCount: number;
    items: SapProductDto[] | undefined;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    readonly allowedMinimumLength!: number;
    requireDigit!: boolean;
    requireLowercase!: boolean;
    requireNonAlphanumeric!: boolean;
    requireUppercase!: boolean;
    requiredLength!: number;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).allowedMinimumLength = _data["allowedMinimumLength"];
            this.requireDigit = _data["requireDigit"];
            this.requireLowercase = _data["requireLowercase"];
            this.requireNonAlphanumeric = _data["requireNonAlphanumeric"];
            this.requireUppercase = _data["requireUppercase"];
            this.requiredLength = _data["requiredLength"];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowedMinimumLength"] = this.allowedMinimumLength;
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data;
    }
}

export interface IPasswordComplexitySetting {
    allowedMinimumLength: number;
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;
}

export class GetSensitiveDataDto implements IGetSensitiveDataDto {
    ongoingLegalProceeding!: boolean;
    finishedLegalProceeding!: boolean;
    remark!: string | undefined;
    records!: GetSensitiveDataRecordDto[] | undefined;
    id!: number;

    constructor(data?: IGetSensitiveDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ongoingLegalProceeding = _data["ongoingLegalProceeding"];
            this.finishedLegalProceeding = _data["finishedLegalProceeding"];
            this.remark = _data["remark"];
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(GetSensitiveDataRecordDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetSensitiveDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSensitiveDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ongoingLegalProceeding"] = this.ongoingLegalProceeding;
        data["finishedLegalProceeding"] = this.finishedLegalProceeding;
        data["remark"] = this.remark;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGetSensitiveDataDto {
    ongoingLegalProceeding: boolean;
    finishedLegalProceeding: boolean;
    remark: string | undefined;
    records: GetSensitiveDataRecordDto[] | undefined;
    id: number;
}

export class UpdateSensitiveDataDto implements IUpdateSensitiveDataDto {
    ongoingLegalProceeding!: boolean;
    finishedLegalProceeding!: boolean;
    remark!: string | undefined;

    constructor(data?: IUpdateSensitiveDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ongoingLegalProceeding = _data["ongoingLegalProceeding"];
            this.finishedLegalProceeding = _data["finishedLegalProceeding"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): UpdateSensitiveDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSensitiveDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ongoingLegalProceeding"] = this.ongoingLegalProceeding;
        data["finishedLegalProceeding"] = this.finishedLegalProceeding;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IUpdateSensitiveDataDto {
    ongoingLegalProceeding: boolean;
    finishedLegalProceeding: boolean;
    remark: string | undefined;
}

export class CreateSensitiveDataRecordDto implements ICreateSensitiveDataRecordDto {
    discriminator!: SensitiveDataRecordDiscriminator;
    legalBasisId!: string | undefined;
    typeId!: string | undefined;
    context!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfEffectivness!: DateTime | undefined;
    dateOfLegalForce!: DateTime | undefined;
    isDeletedOrRepealed!: boolean;
    dateOfIsDeletedOrRepealed!: DateTime | undefined;
    reason!: string | undefined;
    remark!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    sapInvoiceStatusId!: string | undefined;
    dateOfSapInvoiceBilling!: DateTime | undefined;
    personLicenceId!: number | undefined;
    financialPenalty!: number | undefined;
    deleteReason!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    corporateLicenceId!: number | undefined;
    businessIds!: number[] | undefined;

    constructor(data?: ICreateSensitiveDataRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.legalBasisId = _data["legalBasisId"];
            this.typeId = _data["typeId"];
            this.context = _data["context"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfEffectivness = _data["dateOfEffectivness"] ? DateTime.fromISO(_data["dateOfEffectivness"].toString()) : <any>undefined;
            this.dateOfLegalForce = _data["dateOfLegalForce"] ? DateTime.fromISO(_data["dateOfLegalForce"].toString()) : <any>undefined;
            this.isDeletedOrRepealed = _data["isDeletedOrRepealed"];
            this.dateOfIsDeletedOrRepealed = _data["dateOfIsDeletedOrRepealed"] ? DateTime.fromISO(_data["dateOfIsDeletedOrRepealed"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.remark = _data["remark"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.sapInvoiceStatusId = _data["sapInvoiceStatusId"];
            this.dateOfSapInvoiceBilling = _data["dateOfSapInvoiceBilling"] ? DateTime.fromISO(_data["dateOfSapInvoiceBilling"].toString()) : <any>undefined;
            this.personLicenceId = _data["personLicenceId"];
            this.financialPenalty = _data["financialPenalty"];
            this.deleteReason = _data["deleteReason"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            if (Array.isArray(_data["businessIds"])) {
                this.businessIds = [] as any;
                for (let item of _data["businessIds"])
                    this.businessIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateSensitiveDataRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSensitiveDataRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["legalBasisId"] = this.legalBasisId;
        data["typeId"] = this.typeId;
        data["context"] = this.context;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEffectivness"] = this.dateOfEffectivness ? this.dateOfEffectivness.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfLegalForce"] = this.dateOfLegalForce ? this.dateOfLegalForce.toFormat('yyyy-MM-dd') : <any>undefined;
        data["isDeletedOrRepealed"] = this.isDeletedOrRepealed;
        data["dateOfIsDeletedOrRepealed"] = this.dateOfIsDeletedOrRepealed ? this.dateOfIsDeletedOrRepealed.toFormat('yyyy-MM-dd') : <any>undefined;
        data["reason"] = this.reason;
        data["remark"] = this.remark;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["sapInvoiceStatusId"] = this.sapInvoiceStatusId;
        data["dateOfSapInvoiceBilling"] = this.dateOfSapInvoiceBilling ? this.dateOfSapInvoiceBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["personLicenceId"] = this.personLicenceId;
        data["financialPenalty"] = this.financialPenalty;
        data["deleteReason"] = this.deleteReason;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["corporateLicenceId"] = this.corporateLicenceId;
        if (Array.isArray(this.businessIds)) {
            data["businessIds"] = [];
            for (let item of this.businessIds)
                data["businessIds"].push(item);
        }
        return data;
    }
}

export interface ICreateSensitiveDataRecordDto {
    discriminator: SensitiveDataRecordDiscriminator;
    legalBasisId: string | undefined;
    typeId: string | undefined;
    context: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfEffectivness: DateTime | undefined;
    dateOfLegalForce: DateTime | undefined;
    isDeletedOrRepealed: boolean;
    dateOfIsDeletedOrRepealed: DateTime | undefined;
    reason: string | undefined;
    remark: string | undefined;
    dateOfApplication: DateTime | undefined;
    sapInvoiceStatusId: string | undefined;
    dateOfSapInvoiceBilling: DateTime | undefined;
    personLicenceId: number | undefined;
    financialPenalty: number | undefined;
    deleteReason: string | undefined;
    sponsorshipTypeId: string | undefined;
    corporateLicenceId: number | undefined;
    businessIds: number[] | undefined;
}

export class GetSensitiveDataRecordDto implements IGetSensitiveDataRecordDto {
    id!: number;
    discriminator!: SensitiveDataRecordDiscriminator;
    legalBasisId!: string | undefined;
    typeId!: string | undefined;
    context!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfEffectivness!: DateTime | undefined;
    dateOfLegalForce!: DateTime | undefined;
    isDeletedOrRepealed!: boolean;
    dateOfIsDeletedOrRepealed!: DateTime | undefined;
    reason!: string | undefined;
    remark!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    sapInvoiceStatusId!: string | undefined;
    dateOfSapInvoiceBilling!: DateTime | undefined;
    personLicenceId!: number | undefined;
    financialPenalty!: number | undefined;
    deleteReason!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    corporateLicenceId!: number | undefined;
    businessIds!: number[] | undefined;

    constructor(data?: IGetSensitiveDataRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.discriminator = _data["discriminator"];
            this.legalBasisId = _data["legalBasisId"];
            this.typeId = _data["typeId"];
            this.context = _data["context"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfEffectivness = _data["dateOfEffectivness"] ? DateTime.fromISO(_data["dateOfEffectivness"].toString()) : <any>undefined;
            this.dateOfLegalForce = _data["dateOfLegalForce"] ? DateTime.fromISO(_data["dateOfLegalForce"].toString()) : <any>undefined;
            this.isDeletedOrRepealed = _data["isDeletedOrRepealed"];
            this.dateOfIsDeletedOrRepealed = _data["dateOfIsDeletedOrRepealed"] ? DateTime.fromISO(_data["dateOfIsDeletedOrRepealed"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.remark = _data["remark"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.sapInvoiceStatusId = _data["sapInvoiceStatusId"];
            this.dateOfSapInvoiceBilling = _data["dateOfSapInvoiceBilling"] ? DateTime.fromISO(_data["dateOfSapInvoiceBilling"].toString()) : <any>undefined;
            this.personLicenceId = _data["personLicenceId"];
            this.financialPenalty = _data["financialPenalty"];
            this.deleteReason = _data["deleteReason"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            if (Array.isArray(_data["businessIds"])) {
                this.businessIds = [] as any;
                for (let item of _data["businessIds"])
                    this.businessIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetSensitiveDataRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSensitiveDataRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["discriminator"] = this.discriminator;
        data["legalBasisId"] = this.legalBasisId;
        data["typeId"] = this.typeId;
        data["context"] = this.context;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEffectivness"] = this.dateOfEffectivness ? this.dateOfEffectivness.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfLegalForce"] = this.dateOfLegalForce ? this.dateOfLegalForce.toFormat('yyyy-MM-dd') : <any>undefined;
        data["isDeletedOrRepealed"] = this.isDeletedOrRepealed;
        data["dateOfIsDeletedOrRepealed"] = this.dateOfIsDeletedOrRepealed ? this.dateOfIsDeletedOrRepealed.toFormat('yyyy-MM-dd') : <any>undefined;
        data["reason"] = this.reason;
        data["remark"] = this.remark;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["sapInvoiceStatusId"] = this.sapInvoiceStatusId;
        data["dateOfSapInvoiceBilling"] = this.dateOfSapInvoiceBilling ? this.dateOfSapInvoiceBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["personLicenceId"] = this.personLicenceId;
        data["financialPenalty"] = this.financialPenalty;
        data["deleteReason"] = this.deleteReason;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["corporateLicenceId"] = this.corporateLicenceId;
        if (Array.isArray(this.businessIds)) {
            data["businessIds"] = [];
            for (let item of this.businessIds)
                data["businessIds"].push(item);
        }
        return data;
    }
}

export interface IGetSensitiveDataRecordDto {
    id: number;
    discriminator: SensitiveDataRecordDiscriminator;
    legalBasisId: string | undefined;
    typeId: string | undefined;
    context: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfEffectivness: DateTime | undefined;
    dateOfLegalForce: DateTime | undefined;
    isDeletedOrRepealed: boolean;
    dateOfIsDeletedOrRepealed: DateTime | undefined;
    reason: string | undefined;
    remark: string | undefined;
    dateOfApplication: DateTime | undefined;
    sapInvoiceStatusId: string | undefined;
    dateOfSapInvoiceBilling: DateTime | undefined;
    personLicenceId: number | undefined;
    financialPenalty: number | undefined;
    deleteReason: string | undefined;
    sponsorshipTypeId: string | undefined;
    corporateLicenceId: number | undefined;
    businessIds: number[] | undefined;
}

export class GetSensitiveDataSearchOutputDto implements IGetSensitiveDataSearchOutputDto {
    totalCount!: number;
    items!: GetSensitiveDataRecordDto[] | undefined;

    constructor(data?: IGetSensitiveDataSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSensitiveDataRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSensitiveDataSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSensitiveDataSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSensitiveDataSearchOutputDto {
    totalCount: number;
    items: GetSensitiveDataRecordDto[] | undefined;
}

export class UpdateSensitiveDataRecordDto implements IUpdateSensitiveDataRecordDto {
    legalBasisId!: string | undefined;
    typeId!: string | undefined;
    context!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfEffectivness!: DateTime | undefined;
    dateOfLegalForce!: DateTime | undefined;
    isDeletedOrRepealed!: boolean;
    dateOfIsDeletedOrRepealed!: DateTime | undefined;
    reason!: string | undefined;
    remark!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    sapInvoiceStatusId!: string | undefined;
    dateOfSapInvoiceBilling!: DateTime | undefined;
    personLicenceId!: number | undefined;
    financialPenalty!: number | undefined;
    deleteReason!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    corporateLicenceId!: number | undefined;
    businessIds!: number[] | undefined;

    constructor(data?: IUpdateSensitiveDataRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalBasisId = _data["legalBasisId"];
            this.typeId = _data["typeId"];
            this.context = _data["context"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfEffectivness = _data["dateOfEffectivness"] ? DateTime.fromISO(_data["dateOfEffectivness"].toString()) : <any>undefined;
            this.dateOfLegalForce = _data["dateOfLegalForce"] ? DateTime.fromISO(_data["dateOfLegalForce"].toString()) : <any>undefined;
            this.isDeletedOrRepealed = _data["isDeletedOrRepealed"];
            this.dateOfIsDeletedOrRepealed = _data["dateOfIsDeletedOrRepealed"] ? DateTime.fromISO(_data["dateOfIsDeletedOrRepealed"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.remark = _data["remark"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.sapInvoiceStatusId = _data["sapInvoiceStatusId"];
            this.dateOfSapInvoiceBilling = _data["dateOfSapInvoiceBilling"] ? DateTime.fromISO(_data["dateOfSapInvoiceBilling"].toString()) : <any>undefined;
            this.personLicenceId = _data["personLicenceId"];
            this.financialPenalty = _data["financialPenalty"];
            this.deleteReason = _data["deleteReason"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            if (Array.isArray(_data["businessIds"])) {
                this.businessIds = [] as any;
                for (let item of _data["businessIds"])
                    this.businessIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateSensitiveDataRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSensitiveDataRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalBasisId"] = this.legalBasisId;
        data["typeId"] = this.typeId;
        data["context"] = this.context;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEffectivness"] = this.dateOfEffectivness ? this.dateOfEffectivness.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfLegalForce"] = this.dateOfLegalForce ? this.dateOfLegalForce.toFormat('yyyy-MM-dd') : <any>undefined;
        data["isDeletedOrRepealed"] = this.isDeletedOrRepealed;
        data["dateOfIsDeletedOrRepealed"] = this.dateOfIsDeletedOrRepealed ? this.dateOfIsDeletedOrRepealed.toFormat('yyyy-MM-dd') : <any>undefined;
        data["reason"] = this.reason;
        data["remark"] = this.remark;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["sapInvoiceStatusId"] = this.sapInvoiceStatusId;
        data["dateOfSapInvoiceBilling"] = this.dateOfSapInvoiceBilling ? this.dateOfSapInvoiceBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["personLicenceId"] = this.personLicenceId;
        data["financialPenalty"] = this.financialPenalty;
        data["deleteReason"] = this.deleteReason;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["corporateLicenceId"] = this.corporateLicenceId;
        if (Array.isArray(this.businessIds)) {
            data["businessIds"] = [];
            for (let item of this.businessIds)
                data["businessIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateSensitiveDataRecordDto {
    legalBasisId: string | undefined;
    typeId: string | undefined;
    context: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfEffectivness: DateTime | undefined;
    dateOfLegalForce: DateTime | undefined;
    isDeletedOrRepealed: boolean;
    dateOfIsDeletedOrRepealed: DateTime | undefined;
    reason: string | undefined;
    remark: string | undefined;
    dateOfApplication: DateTime | undefined;
    sapInvoiceStatusId: string | undefined;
    dateOfSapInvoiceBilling: DateTime | undefined;
    personLicenceId: number | undefined;
    financialPenalty: number | undefined;
    deleteReason: string | undefined;
    sponsorshipTypeId: string | undefined;
    corporateLicenceId: number | undefined;
    businessIds: number[] | undefined;
}

export class SensitiveDataRecord implements ISensitiveDataRecord {
    discriminator!: SensitiveDataRecordDiscriminator;
    sensitiveData!: SensitiveData;
    sensitiveDataId!: number;
    legalBasisId!: string | undefined;
    typeId!: string | undefined;
    context!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfEffectivness!: DateTime | undefined;
    dateOfLegalForce!: DateTime | undefined;
    isDeletedOrRepealed!: boolean;
    dateOfIsDeletedOrRepealed!: DateTime | undefined;
    reason!: string | undefined;
    remark!: string | undefined;
    sapInvoice!: SapInvoice;
    sapInvoiceId!: number | undefined;
    documentLinks!: DocumentLinkSensitiveDataRecord[] | undefined;
    businesses!: SensitiveDataRecordBusiness[] | undefined;
    migrationData!: MigrationData[] | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISensitiveDataRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.sensitiveData = _data["sensitiveData"] ? SensitiveData.fromJS(_data["sensitiveData"]) : <any>undefined;
            this.sensitiveDataId = _data["sensitiveDataId"];
            this.legalBasisId = _data["legalBasisId"];
            this.typeId = _data["typeId"];
            this.context = _data["context"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfEffectivness = _data["dateOfEffectivness"] ? DateTime.fromISO(_data["dateOfEffectivness"].toString()) : <any>undefined;
            this.dateOfLegalForce = _data["dateOfLegalForce"] ? DateTime.fromISO(_data["dateOfLegalForce"].toString()) : <any>undefined;
            this.isDeletedOrRepealed = _data["isDeletedOrRepealed"];
            this.dateOfIsDeletedOrRepealed = _data["dateOfIsDeletedOrRepealed"] ? DateTime.fromISO(_data["dateOfIsDeletedOrRepealed"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.remark = _data["remark"];
            this.sapInvoice = _data["sapInvoice"] ? SapInvoice.fromJS(_data["sapInvoice"]) : <any>undefined;
            this.sapInvoiceId = _data["sapInvoiceId"];
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkSensitiveDataRecord.fromJS(item));
            }
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(SensitiveDataRecordBusiness.fromJS(item));
            }
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SensitiveDataRecord {
        data = typeof data === 'object' ? data : {};
        let result = new SensitiveDataRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["sensitiveData"] = this.sensitiveData ? this.sensitiveData.toJSON() : <any>undefined;
        data["sensitiveDataId"] = this.sensitiveDataId;
        data["legalBasisId"] = this.legalBasisId;
        data["typeId"] = this.typeId;
        data["context"] = this.context;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEffectivness"] = this.dateOfEffectivness ? this.dateOfEffectivness.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfLegalForce"] = this.dateOfLegalForce ? this.dateOfLegalForce.toFormat('yyyy-MM-dd') : <any>undefined;
        data["isDeletedOrRepealed"] = this.isDeletedOrRepealed;
        data["dateOfIsDeletedOrRepealed"] = this.dateOfIsDeletedOrRepealed ? this.dateOfIsDeletedOrRepealed.toFormat('yyyy-MM-dd') : <any>undefined;
        data["reason"] = this.reason;
        data["remark"] = this.remark;
        data["sapInvoice"] = this.sapInvoice ? this.sapInvoice.toJSON() : <any>undefined;
        data["sapInvoiceId"] = this.sapInvoiceId;
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISensitiveDataRecord {
    discriminator: SensitiveDataRecordDiscriminator;
    sensitiveData: SensitiveData;
    sensitiveDataId: number;
    legalBasisId: string | undefined;
    typeId: string | undefined;
    context: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfEffectivness: DateTime | undefined;
    dateOfLegalForce: DateTime | undefined;
    isDeletedOrRepealed: boolean;
    dateOfIsDeletedOrRepealed: DateTime | undefined;
    reason: string | undefined;
    remark: string | undefined;
    sapInvoice: SapInvoice;
    sapInvoiceId: number | undefined;
    documentLinks: DocumentLinkSensitiveDataRecord[] | undefined;
    businesses: SensitiveDataRecordBusiness[] | undefined;
    migrationData: MigrationData[] | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class SensitiveDataRecordBusiness implements ISensitiveDataRecordBusiness {
    sensitiveDataRecordId!: number;
    sensitiveDataRecord!: SensitiveDataRecord;
    businessId!: number;
    business!: Business;

    constructor(data?: ISensitiveDataRecordBusiness) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sensitiveDataRecordId = _data["sensitiveDataRecordId"];
            this.sensitiveDataRecord = _data["sensitiveDataRecord"] ? SensitiveDataRecord.fromJS(_data["sensitiveDataRecord"]) : <any>undefined;
            this.businessId = _data["businessId"];
            this.business = _data["business"] ? Business.fromJS(_data["business"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SensitiveDataRecordBusiness {
        data = typeof data === 'object' ? data : {};
        let result = new SensitiveDataRecordBusiness();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sensitiveDataRecordId"] = this.sensitiveDataRecordId;
        data["sensitiveDataRecord"] = this.sensitiveDataRecord ? this.sensitiveDataRecord.toJSON() : <any>undefined;
        data["businessId"] = this.businessId;
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISensitiveDataRecordBusiness {
    sensitiveDataRecordId: number;
    sensitiveDataRecord: SensitiveDataRecord;
    businessId: number;
    business: Business;
}

export class SensitiveData implements ISensitiveData {
    discriminator!: SensitiveDataDiscriminator;
    ongoingLegalProceeding!: boolean;
    finishedLegalProceeding!: boolean;
    remark!: string | undefined;
    records!: SensitiveDataRecord[] | undefined;
    documentLinks!: DocumentLinkSensitiveData[] | undefined;
    migrationData!: MigrationData[] | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISensitiveData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.ongoingLegalProceeding = _data["ongoingLegalProceeding"];
            this.finishedLegalProceeding = _data["finishedLegalProceeding"];
            this.remark = _data["remark"];
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(SensitiveDataRecord.fromJS(item));
            }
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkSensitiveData.fromJS(item));
            }
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SensitiveData {
        data = typeof data === 'object' ? data : {};
        let result = new SensitiveData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["ongoingLegalProceeding"] = this.ongoingLegalProceeding;
        data["finishedLegalProceeding"] = this.finishedLegalProceeding;
        data["remark"] = this.remark;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISensitiveData {
    discriminator: SensitiveDataDiscriminator;
    ongoingLegalProceeding: boolean;
    finishedLegalProceeding: boolean;
    remark: string | undefined;
    records: SensitiveDataRecord[] | undefined;
    documentLinks: DocumentLinkSensitiveData[] | undefined;
    migrationData: MigrationData[] | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum SensitiveDataRecordDiscriminator {
    PersonRestriction = 0,
    PersonRequirement = 1,
    PersonPrecautionaryMeasures = 2,
    PersonDisciplinaryMeasures = 3,
    PersonRejection = 4,
    PersonWithdrawal = 5,
    SponsorshipRestriction = 100,
    SponsorshipRequirement = 101,
    SponsorshipPrecautionaryMeasures = 102,
    SponsorshipRejection = 103,
    SponsorshipWithdrawal = 104,
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: DateTime;
    currency!: string | undefined;
    currencySign!: string | undefined;
    allowTenantsToChangeEmailSettings!: boolean;
    userDelegationIsEnabled!: boolean;
    twoFactorCodeExpireSeconds!: number;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? DateTime.fromISO(_data["releaseDate"].toString()) : <any>undefined;
            this.currency = _data["currency"];
            this.currencySign = _data["currencySign"];
            this.allowTenantsToChangeEmailSettings = _data["allowTenantsToChangeEmailSettings"];
            this.userDelegationIsEnabled = _data["userDelegationIsEnabled"];
            this.twoFactorCodeExpireSeconds = _data["twoFactorCodeExpireSeconds"];
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toString() : <any>undefined;
        data["currency"] = this.currency;
        data["currencySign"] = this.currencySign;
        data["allowTenantsToChangeEmailSettings"] = this.allowTenantsToChangeEmailSettings;
        data["userDelegationIsEnabled"] = this.userDelegationIsEnabled;
        data["twoFactorCodeExpireSeconds"] = this.twoFactorCodeExpireSeconds;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: DateTime;
    currency: string | undefined;
    currencySign: string | undefined;
    allowTenantsToChangeEmailSettings: boolean;
    userDelegationIsEnabled: boolean;
    twoFactorCodeExpireSeconds: number;
    features: { [key: string]: boolean; } | undefined;
}

export class EditionInfoDto implements IEditionInfoDto {
    displayName!: string | undefined;
    trialDayCount!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    isHighestEdition!: boolean;
    isFree!: boolean;
    id!: number;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.trialDayCount = _data["trialDayCount"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.isHighestEdition = _data["isHighestEdition"];
            this.isFree = _data["isFree"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionInfoDto {
    displayName: string | undefined;
    trialDayCount: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    isHighestEdition: boolean;
    isFree: boolean;
    id: number;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user!: UserLoginInfoDto;
    impersonatorUser!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;
    impersonatorTenant!: TenantLoginInfoDto;
    application!: ApplicationInfoDto;
    theme!: UiCustomizationSettingsDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.impersonatorUser = _data["impersonatorUser"] ? UserLoginInfoDto.fromJS(_data["impersonatorUser"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
            this.impersonatorTenant = _data["impersonatorTenant"] ? TenantLoginInfoDto.fromJS(_data["impersonatorTenant"]) : <any>undefined;
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.theme = _data["theme"] ? UiCustomizationSettingsDto.fromJS(_data["theme"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["impersonatorUser"] = this.impersonatorUser ? this.impersonatorUser.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["impersonatorTenant"] = this.impersonatorTenant ? this.impersonatorTenant.toJSON() : <any>undefined;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["theme"] = this.theme ? this.theme.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    impersonatorUser: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    impersonatorTenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;
    theme: UiCustomizationSettingsDto;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    darkLogoId!: string | undefined;
    darkLogoFileType!: string | undefined;
    lightLogoId!: string | undefined;
    lightLogoFileType!: string | undefined;
    customCssId!: string | undefined;
    emailLogoId!: string | undefined;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;
    subscriptionPaymentType!: SubscriptionPaymentType;
    edition!: EditionInfoDto;
    featureValues!: NameValueDto[] | undefined;
    creationTime!: DateTime;
    paymentPeriodType!: PaymentPeriodType;
    subscriptionDateString!: string | undefined;
    creationTimeString!: string | undefined;
    id!: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.darkLogoId = _data["darkLogoId"];
            this.darkLogoFileType = _data["darkLogoFileType"];
            this.lightLogoId = _data["lightLogoId"];
            this.lightLogoFileType = _data["lightLogoFileType"];
            this.customCssId = _data["customCssId"];
            this.emailLogoId = _data["emailLogoId"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.subscriptionPaymentType = _data["subscriptionPaymentType"];
            this.edition = _data["edition"] ? EditionInfoDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.subscriptionDateString = _data["subscriptionDateString"];
            this.creationTimeString = _data["creationTimeString"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["darkLogoId"] = this.darkLogoId;
        data["darkLogoFileType"] = this.darkLogoFileType;
        data["lightLogoId"] = this.lightLogoId;
        data["lightLogoFileType"] = this.lightLogoFileType;
        data["customCssId"] = this.customCssId;
        data["emailLogoId"] = this.emailLogoId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    darkLogoId: string | undefined;
    darkLogoFileType: string | undefined;
    lightLogoId: string | undefined;
    lightLogoFileType: string | undefined;
    customCssId: string | undefined;
    emailLogoId: string | undefined;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
    subscriptionPaymentType: SubscriptionPaymentType;
    edition: EditionInfoDto;
    featureValues: NameValueDto[] | undefined;
    creationTime: DateTime;
    paymentPeriodType: PaymentPeriodType;
    subscriptionDateString: string | undefined;
    creationTimeString: string | undefined;
    id: number;
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken!: string | undefined;
    encodedUserId!: string | undefined;
    encodedTenantId!: string | undefined;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signInToken = _data["signInToken"];
            this.encodedUserId = _data["encodedUserId"];
            this.encodedTenantId = _data["encodedTenantId"];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data;
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    id!: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    id: number;
}

export class CreateOrUpdateSplPostgraduateTitlesInput implements ICreateOrUpdateSplPostgraduateTitlesInput {
    postgraduateTitles!: SplPostgraduateTitleDto[] | undefined;

    constructor(data?: ICreateOrUpdateSplPostgraduateTitlesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["postgraduateTitles"])) {
                this.postgraduateTitles = [] as any;
                for (let item of _data["postgraduateTitles"])
                    this.postgraduateTitles!.push(SplPostgraduateTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateSplPostgraduateTitlesInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSplPostgraduateTitlesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.postgraduateTitles)) {
            data["postgraduateTitles"] = [];
            for (let item of this.postgraduateTitles)
                data["postgraduateTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateSplPostgraduateTitlesInput {
    postgraduateTitles: SplPostgraduateTitleDto[] | undefined;
}

export class CreateSplInput implements ICreateSplInput {
    applicationTypeId!: ApplicationType;

    constructor(data?: ICreateSplInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationTypeId = _data["applicationTypeId"];
        }
    }

    static fromJS(data: any): CreateSplInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSplInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationTypeId"] = this.applicationTypeId;
        return data;
    }
}

export interface ICreateSplInput {
    applicationTypeId: ApplicationType;
}

export class CreateSplOutput implements ICreateSplOutput {
    caseId!: string | undefined;

    constructor(data?: ICreateSplOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): CreateSplOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSplOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface ICreateSplOutput {
    caseId: string | undefined;
}

export class GetSplDocumentsInput implements IGetSplDocumentsInput {
    caseId!: string;
    step!: SplStatus;

    constructor(data?: IGetSplDocumentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
        }
    }

    static fromJS(data: any): GetSplDocumentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSplDocumentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        return data;
    }
}

export interface IGetSplDocumentsInput {
    caseId: string;
    step: SplStatus;
}

export class GetSplFileInput implements IGetSplFileInput {
    caseId!: string;
    step!: SplStatus;
    id!: number;

    constructor(data?: IGetSplFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetSplFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSplFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetSplFileInput {
    caseId: string;
    step: SplStatus;
    id: number;
}

export class GetSplOutput implements IGetSplOutput {
    spl!: SplDto;

    constructor(data?: IGetSplOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spl = _data["spl"] ? SplDto.fromJS(_data["spl"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSplOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSplOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spl"] = this.spl ? this.spl.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSplOutput {
    spl: SplDto;
}

export class SplDocumentsOutput implements ISplDocumentsOutput {
    caseId!: string;
    documents!: GeneralDocumentGroupDto[];

    constructor(data?: ISplDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SplDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SplDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISplDocumentsOutput {
    caseId: string;
    documents: GeneralDocumentGroupDto[];
}

export class SplDto implements ISplDto {
    application!: ApplicationDto;
    statusId!: SplStatus;
    person!: SplPersonDto;
    narcoticKnowledge!: SplNarcoticKnowledgeDto;
    postgraduateTitles!: SplPostgraduateTitleDto[] | undefined;
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ISplDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.statusId = _data["statusId"];
            this.person = _data["person"] ? SplPersonDto.fromJS(_data["person"]) : <any>undefined;
            this.narcoticKnowledge = _data["narcoticKnowledge"] ? SplNarcoticKnowledgeDto.fromJS(_data["narcoticKnowledge"]) : <any>undefined;
            if (Array.isArray(_data["postgraduateTitles"])) {
                this.postgraduateTitles = [] as any;
                for (let item of _data["postgraduateTitles"])
                    this.postgraduateTitles!.push(SplPostgraduateTitleDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SplDto {
        data = typeof data === 'object' ? data : {};
        let result = new SplDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["statusId"] = this.statusId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["narcoticKnowledge"] = this.narcoticKnowledge ? this.narcoticKnowledge.toJSON() : <any>undefined;
        if (Array.isArray(this.postgraduateTitles)) {
            data["postgraduateTitles"] = [];
            for (let item of this.postgraduateTitles)
                data["postgraduateTitles"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISplDto {
    application: ApplicationDto;
    statusId: SplStatus;
    person: SplPersonDto;
    narcoticKnowledge: SplNarcoticKnowledgeDto;
    postgraduateTitles: SplPostgraduateTitleDto[] | undefined;
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class SplNarcoticKnowledgeDto implements ISplNarcoticKnowledgeDto {
    id!: number | undefined;
    hasAttendedBasicCourseOfNarcosticsTreatment!: string | undefined;
    courseDetails!: string | undefined;
    otherDetails!: string | undefined;

    constructor(data?: ISplNarcoticKnowledgeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hasAttendedBasicCourseOfNarcosticsTreatment = _data["hasAttendedBasicCourseOfNarcosticsTreatment"];
            this.courseDetails = _data["courseDetails"];
            this.otherDetails = _data["otherDetails"];
        }
    }

    static fromJS(data: any): SplNarcoticKnowledgeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SplNarcoticKnowledgeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hasAttendedBasicCourseOfNarcosticsTreatment"] = this.hasAttendedBasicCourseOfNarcosticsTreatment;
        data["courseDetails"] = this.courseDetails;
        data["otherDetails"] = this.otherDetails;
        return data;
    }
}

export interface ISplNarcoticKnowledgeDto {
    id: number | undefined;
    hasAttendedBasicCourseOfNarcosticsTreatment: string | undefined;
    courseDetails: string | undefined;
    otherDetails: string | undefined;
}

export class SplPersonDto implements ISplPersonDto {
    id!: number | undefined;
    firstName!: string;
    lastName!: string;
    gln!: string;
    licenceTypeId!: string | undefined;
    licenceCantonId!: string | undefined;
    licenceStatusId!: string | undefined;
    activityStatusId!: string | undefined;
    hasAppliedForProfessionalLicenceId!: string | undefined;

    constructor(data?: ISplPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gln = _data["gln"];
            this.licenceTypeId = _data["licenceTypeId"];
            this.licenceCantonId = _data["licenceCantonId"];
            this.licenceStatusId = _data["licenceStatusId"];
            this.activityStatusId = _data["activityStatusId"];
            this.hasAppliedForProfessionalLicenceId = _data["hasAppliedForProfessionalLicenceId"];
        }
    }

    static fromJS(data: any): SplPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new SplPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gln"] = this.gln;
        data["licenceTypeId"] = this.licenceTypeId;
        data["licenceCantonId"] = this.licenceCantonId;
        data["licenceStatusId"] = this.licenceStatusId;
        data["activityStatusId"] = this.activityStatusId;
        data["hasAppliedForProfessionalLicenceId"] = this.hasAppliedForProfessionalLicenceId;
        return data;
    }
}

export interface ISplPersonDto {
    id: number | undefined;
    firstName: string;
    lastName: string;
    gln: string;
    licenceTypeId: string | undefined;
    licenceCantonId: string | undefined;
    licenceStatusId: string | undefined;
    activityStatusId: string | undefined;
    hasAppliedForProfessionalLicenceId: string | undefined;
}

export class SplPostgraduateTitleDto implements ISplPostgraduateTitleDto {
    id!: number | undefined;
    titleId!: string | undefined;
    typeId!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;

    constructor(data?: ISplPostgraduateTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titleId = _data["titleId"];
            this.typeId = _data["typeId"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SplPostgraduateTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SplPostgraduateTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titleId"] = this.titleId;
        data["typeId"] = this.typeId;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface ISplPostgraduateTitleDto {
    id: number | undefined;
    titleId: string | undefined;
    typeId: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
}

export enum SplStatus {
    Person = 0,
    PostgraduateTitle = 1,
    NarcoticKnowledge = 2,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export class CreateOrUpdateSponsorshipDto implements ICreateOrUpdateSponsorshipDto {
    id!: number | undefined;
    name!: string;
    additionalName!: string | undefined;
    legalFormId!: string;
    postCode!: string;
    city!: string;
    municipalityId!: string | undefined;
    regionId!: string | undefined;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    cantonId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    email2!: string | undefined;
    fax!: string | undefined;
    website!: string | undefined;
    uid!: string | undefined;
    comments!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;

    constructor(data?: ICreateOrUpdateSponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.municipalityId = _data["municipalityId"];
            this.regionId = _data["regionId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.cantonId = _data["cantonId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.uid = _data["uid"];
            this.comments = _data["comments"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
        }
    }

    static fromJS(data: any): CreateOrUpdateSponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["municipalityId"] = this.municipalityId;
        data["regionId"] = this.regionId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["cantonId"] = this.cantonId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["uid"] = this.uid;
        data["comments"] = this.comments;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        return data;
    }
}

export interface ICreateOrUpdateSponsorshipDto {
    id: number | undefined;
    name: string;
    additionalName: string | undefined;
    legalFormId: string;
    postCode: string;
    city: string;
    municipalityId: string | undefined;
    regionId: string | undefined;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    cantonId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    email2: string | undefined;
    fax: string | undefined;
    website: string | undefined;
    uid: string | undefined;
    comments: string | undefined;
    languageOfCorrespondenceId: string | undefined;
}

export class GetSponsorshipDossierSearchOutput implements IGetSponsorshipDossierSearchOutput {
    totalCount!: number;
    items!: SponsorshipDossierSearchDto[] | undefined;

    constructor(data?: IGetSponsorshipDossierSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SponsorshipDossierSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSponsorshipDossierSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSponsorshipDossierSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSponsorshipDossierSearchOutput {
    totalCount: number;
    items: SponsorshipDossierSearchDto[] | undefined;
}

export class GetSponsorshipDto implements IGetSponsorshipDto {
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    isPublicPharmacy!: boolean;
    isArchived!: boolean;
    businesses!: GetBusinessDto[] | undefined;
    id!: number | undefined;
    name!: string;
    additionalName!: string | undefined;
    legalFormId!: string;
    postCode!: string;
    city!: string;
    municipalityId!: string | undefined;
    regionId!: string | undefined;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    cantonId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    email2!: string | undefined;
    fax!: string | undefined;
    website!: string | undefined;
    uid!: string | undefined;
    comments!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;

    constructor(data?: IGetSponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.isPublicPharmacy = _data["isPublicPharmacy"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(GetBusinessDto.fromJS(item));
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.municipalityId = _data["municipalityId"];
            this.regionId = _data["regionId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.cantonId = _data["cantonId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.uid = _data["uid"];
            this.comments = _data["comments"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
        }
    }

    static fromJS(data: any): GetSponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["isPublicPharmacy"] = this.isPublicPharmacy;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["municipalityId"] = this.municipalityId;
        data["regionId"] = this.regionId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["cantonId"] = this.cantonId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["uid"] = this.uid;
        data["comments"] = this.comments;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        return data;
    }
}

export interface IGetSponsorshipDto {
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    isPublicPharmacy: boolean;
    isArchived: boolean;
    businesses: GetBusinessDto[] | undefined;
    id: number | undefined;
    name: string;
    additionalName: string | undefined;
    legalFormId: string;
    postCode: string;
    city: string;
    municipalityId: string | undefined;
    regionId: string | undefined;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    cantonId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    email2: string | undefined;
    fax: string | undefined;
    website: string | undefined;
    uid: string | undefined;
    comments: string | undefined;
    languageOfCorrespondenceId: string | undefined;
}

export class Sponsorship implements ISponsorship {
    name!: string | undefined;
    additionalName!: string | undefined;
    legalFormId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    cantonId!: string | undefined;
    municipalityId!: string | undefined;
    regionId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    email2!: string | undefined;
    fax!: string | undefined;
    website!: string | undefined;
    uid!: string | undefined;
    comments!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    medRegId!: number | undefined;
    isArchived!: boolean;
    invoiceAddress!: SponsorshipInvoiceAddress;
    orderedSapInvoices!: SapInvoice[] | undefined;
    debitedSapInvoices!: SapInvoice[] | undefined;
    businesses!: Business[] | undefined;
    employments!: Employment[] | undefined;
    corporateLicences!: CorporateLicence[] | undefined;
    sponsorshipUsers!: SponsorshipUser[] | undefined;
    documentLinks!: DocumentLinkSponsorship[] | undefined;
    pendences!: PendenceLinkSponsorship[] | undefined;
    additionalInformations!: AdditionalInformationSponsorship[] | undefined;
    legitimations!: LegitimationSponsorship[] | undefined;
    logbooks!: LogbookSponsorship[] | undefined;
    reminders!: ReminderSponsorship[] | undefined;
    bankDetails!: BankDetailsSponsorship;
    readonly hasValidInvoiceAddress!: boolean;
    migrationData!: MigrationData[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISponsorship) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.cantonId = _data["cantonId"];
            this.municipalityId = _data["municipalityId"];
            this.regionId = _data["regionId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.uid = _data["uid"];
            this.comments = _data["comments"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.medRegId = _data["medRegId"];
            this.isArchived = _data["isArchived"];
            this.invoiceAddress = _data["invoiceAddress"] ? SponsorshipInvoiceAddress.fromJS(_data["invoiceAddress"]) : <any>undefined;
            if (Array.isArray(_data["orderedSapInvoices"])) {
                this.orderedSapInvoices = [] as any;
                for (let item of _data["orderedSapInvoices"])
                    this.orderedSapInvoices!.push(SapInvoice.fromJS(item));
            }
            if (Array.isArray(_data["debitedSapInvoices"])) {
                this.debitedSapInvoices = [] as any;
                for (let item of _data["debitedSapInvoices"])
                    this.debitedSapInvoices!.push(SapInvoice.fromJS(item));
            }
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(Business.fromJS(item));
            }
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(Employment.fromJS(item));
            }
            if (Array.isArray(_data["corporateLicences"])) {
                this.corporateLicences = [] as any;
                for (let item of _data["corporateLicences"])
                    this.corporateLicences!.push(CorporateLicence.fromJS(item));
            }
            if (Array.isArray(_data["sponsorshipUsers"])) {
                this.sponsorshipUsers = [] as any;
                for (let item of _data["sponsorshipUsers"])
                    this.sponsorshipUsers!.push(SponsorshipUser.fromJS(item));
            }
            if (Array.isArray(_data["documentLinks"])) {
                this.documentLinks = [] as any;
                for (let item of _data["documentLinks"])
                    this.documentLinks!.push(DocumentLinkSponsorship.fromJS(item));
            }
            if (Array.isArray(_data["pendences"])) {
                this.pendences = [] as any;
                for (let item of _data["pendences"])
                    this.pendences!.push(PendenceLinkSponsorship.fromJS(item));
            }
            if (Array.isArray(_data["additionalInformations"])) {
                this.additionalInformations = [] as any;
                for (let item of _data["additionalInformations"])
                    this.additionalInformations!.push(AdditionalInformationSponsorship.fromJS(item));
            }
            if (Array.isArray(_data["legitimations"])) {
                this.legitimations = [] as any;
                for (let item of _data["legitimations"])
                    this.legitimations!.push(LegitimationSponsorship.fromJS(item));
            }
            if (Array.isArray(_data["logbooks"])) {
                this.logbooks = [] as any;
                for (let item of _data["logbooks"])
                    this.logbooks!.push(LogbookSponsorship.fromJS(item));
            }
            if (Array.isArray(_data["reminders"])) {
                this.reminders = [] as any;
                for (let item of _data["reminders"])
                    this.reminders!.push(ReminderSponsorship.fromJS(item));
            }
            this.bankDetails = _data["bankDetails"] ? BankDetailsSponsorship.fromJS(_data["bankDetails"]) : <any>undefined;
            (<any>this).hasValidInvoiceAddress = _data["hasValidInvoiceAddress"];
            if (Array.isArray(_data["migrationData"])) {
                this.migrationData = [] as any;
                for (let item of _data["migrationData"])
                    this.migrationData!.push(MigrationData.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Sponsorship {
        data = typeof data === 'object' ? data : {};
        let result = new Sponsorship();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["cantonId"] = this.cantonId;
        data["municipalityId"] = this.municipalityId;
        data["regionId"] = this.regionId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["uid"] = this.uid;
        data["comments"] = this.comments;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["medRegId"] = this.medRegId;
        data["isArchived"] = this.isArchived;
        data["invoiceAddress"] = this.invoiceAddress ? this.invoiceAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.orderedSapInvoices)) {
            data["orderedSapInvoices"] = [];
            for (let item of this.orderedSapInvoices)
                data["orderedSapInvoices"].push(item.toJSON());
        }
        if (Array.isArray(this.debitedSapInvoices)) {
            data["debitedSapInvoices"] = [];
            for (let item of this.debitedSapInvoices)
                data["debitedSapInvoices"].push(item.toJSON());
        }
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        if (Array.isArray(this.corporateLicences)) {
            data["corporateLicences"] = [];
            for (let item of this.corporateLicences)
                data["corporateLicences"].push(item.toJSON());
        }
        if (Array.isArray(this.sponsorshipUsers)) {
            data["sponsorshipUsers"] = [];
            for (let item of this.sponsorshipUsers)
                data["sponsorshipUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.documentLinks)) {
            data["documentLinks"] = [];
            for (let item of this.documentLinks)
                data["documentLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.pendences)) {
            data["pendences"] = [];
            for (let item of this.pendences)
                data["pendences"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalInformations)) {
            data["additionalInformations"] = [];
            for (let item of this.additionalInformations)
                data["additionalInformations"].push(item.toJSON());
        }
        if (Array.isArray(this.legitimations)) {
            data["legitimations"] = [];
            for (let item of this.legitimations)
                data["legitimations"].push(item.toJSON());
        }
        if (Array.isArray(this.logbooks)) {
            data["logbooks"] = [];
            for (let item of this.logbooks)
                data["logbooks"].push(item.toJSON());
        }
        if (Array.isArray(this.reminders)) {
            data["reminders"] = [];
            for (let item of this.reminders)
                data["reminders"].push(item.toJSON());
        }
        data["bankDetails"] = this.bankDetails ? this.bankDetails.toJSON() : <any>undefined;
        data["hasValidInvoiceAddress"] = this.hasValidInvoiceAddress;
        if (Array.isArray(this.migrationData)) {
            data["migrationData"] = [];
            for (let item of this.migrationData)
                data["migrationData"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISponsorship {
    name: string | undefined;
    additionalName: string | undefined;
    legalFormId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    cantonId: string | undefined;
    municipalityId: string | undefined;
    regionId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    email2: string | undefined;
    fax: string | undefined;
    website: string | undefined;
    uid: string | undefined;
    comments: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    medRegId: number | undefined;
    isArchived: boolean;
    invoiceAddress: SponsorshipInvoiceAddress;
    orderedSapInvoices: SapInvoice[] | undefined;
    debitedSapInvoices: SapInvoice[] | undefined;
    businesses: Business[] | undefined;
    employments: Employment[] | undefined;
    corporateLicences: CorporateLicence[] | undefined;
    sponsorshipUsers: SponsorshipUser[] | undefined;
    documentLinks: DocumentLinkSponsorship[] | undefined;
    pendences: PendenceLinkSponsorship[] | undefined;
    additionalInformations: AdditionalInformationSponsorship[] | undefined;
    legitimations: LegitimationSponsorship[] | undefined;
    logbooks: LogbookSponsorship[] | undefined;
    reminders: ReminderSponsorship[] | undefined;
    bankDetails: BankDetailsSponsorship;
    hasValidInvoiceAddress: boolean;
    migrationData: MigrationData[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class SponsorshipDossierSearchDto implements ISponsorshipDossierSearchDto {
    name!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    uid!: string | undefined;
    legalFormId!: string | undefined;
    id!: number;

    constructor(data?: ISponsorshipDossierSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.uid = _data["uid"];
            this.legalFormId = _data["legalFormId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SponsorshipDossierSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorshipDossierSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["uid"] = this.uid;
        data["legalFormId"] = this.legalFormId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISponsorshipDossierSearchDto {
    name: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    uid: string | undefined;
    legalFormId: string | undefined;
    id: number;
}

export class SponsorshipDto implements ISponsorshipDto {
    name!: string;
    additionalName!: string | undefined;
    legalFormId!: string;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    cantonId!: string;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    email2!: string | undefined;
    fax!: string | undefined;
    website!: string | undefined;
    uid!: string | undefined;
    comments!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    id!: number;

    constructor(data?: ISponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.cantonId = _data["cantonId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.uid = _data["uid"];
            this.comments = _data["comments"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["cantonId"] = this.cantonId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["uid"] = this.uid;
        data["comments"] = this.comments;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISponsorshipDto {
    name: string;
    additionalName: string | undefined;
    legalFormId: string;
    postCode: string;
    city: string;
    street: string;
    streetNr: string;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    cantonId: string;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    email2: string | undefined;
    fax: string | undefined;
    website: string | undefined;
    uid: string | undefined;
    comments: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    id: number;
}

export class SponsorshipInvoiceAddress implements ISponsorshipInvoiceAddress {
    sponsorship!: Sponsorship;
    name!: string | undefined;
    title!: Code;
    titleId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    readonly isValid!: boolean;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISponsorshipInvoiceAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorship = _data["sponsorship"] ? Sponsorship.fromJS(_data["sponsorship"]) : <any>undefined;
            this.name = _data["name"];
            this.title = _data["title"] ? Code.fromJS(_data["title"]) : <any>undefined;
            this.titleId = _data["titleId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            (<any>this).isValid = _data["isValid"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SponsorshipInvoiceAddress {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorshipInvoiceAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["titleId"] = this.titleId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["isValid"] = this.isValid;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISponsorshipInvoiceAddress {
    sponsorship: Sponsorship;
    name: string | undefined;
    title: Code;
    titleId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    isValid: boolean;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class SponsorshipInvoiceAddressDto implements ISponsorshipInvoiceAddressDto {
    name!: string | undefined;
    titleId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    addressAddition!: string | undefined;
    postOfficeBox!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;

    constructor(data?: ISponsorshipInvoiceAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.titleId = _data["titleId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.addressAddition = _data["addressAddition"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SponsorshipInvoiceAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorshipInvoiceAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["titleId"] = this.titleId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["addressAddition"] = this.addressAddition;
        data["postOfficeBox"] = this.postOfficeBox;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        return data;
    }
}

export interface ISponsorshipInvoiceAddressDto {
    name: string | undefined;
    titleId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    addressAddition: string | undefined;
    postOfficeBox: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
}

export enum SponsorshipPermission {
    None = 0,
    User = 1,
    Admin = 2,
}

export class SponsorshipUser implements ISponsorshipUser {
    user!: User;
    userId!: number | undefined;
    invitationEmail!: string | undefined;
    sponsorship!: Sponsorship;
    sponsorshipId!: number;
    sponsorshipPermission!: SponsorshipPermission;
    adminRequest!: DateTime | undefined;
    invitedBy!: User;
    invitedById!: number | undefined;
    invitationSent!: DateTime | undefined;
    invitationAccepted!: DateTime | undefined;
    isDeleted!: boolean;
    fullName!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISponsorshipUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            this.invitationEmail = _data["invitationEmail"];
            this.sponsorship = _data["sponsorship"] ? Sponsorship.fromJS(_data["sponsorship"]) : <any>undefined;
            this.sponsorshipId = _data["sponsorshipId"];
            this.sponsorshipPermission = _data["sponsorshipPermission"];
            this.adminRequest = _data["adminRequest"] ? DateTime.fromISO(_data["adminRequest"].toString()) : <any>undefined;
            this.invitedBy = _data["invitedBy"] ? User.fromJS(_data["invitedBy"]) : <any>undefined;
            this.invitedById = _data["invitedById"];
            this.invitationSent = _data["invitationSent"] ? DateTime.fromISO(_data["invitationSent"].toString()) : <any>undefined;
            this.invitationAccepted = _data["invitationAccepted"] ? DateTime.fromISO(_data["invitationAccepted"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.fullName = _data["fullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SponsorshipUser {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorshipUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["invitationEmail"] = this.invitationEmail;
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        data["sponsorshipId"] = this.sponsorshipId;
        data["sponsorshipPermission"] = this.sponsorshipPermission;
        data["adminRequest"] = this.adminRequest ? this.adminRequest.toString() : <any>undefined;
        data["invitedBy"] = this.invitedBy ? this.invitedBy.toJSON() : <any>undefined;
        data["invitedById"] = this.invitedById;
        data["invitationSent"] = this.invitationSent ? this.invitationSent.toString() : <any>undefined;
        data["invitationAccepted"] = this.invitationAccepted ? this.invitationAccepted.toString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["fullName"] = this.fullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISponsorshipUser {
    user: User;
    userId: number | undefined;
    invitationEmail: string | undefined;
    sponsorship: Sponsorship;
    sponsorshipId: number;
    sponsorshipPermission: SponsorshipPermission;
    adminRequest: DateTime | undefined;
    invitedBy: User;
    invitedById: number | undefined;
    invitationSent: DateTime | undefined;
    invitationAccepted: DateTime | undefined;
    isDeleted: boolean;
    fullName: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class GetSponsorshipApplicationsOutput implements IGetSponsorshipApplicationsOutput {
    totalCount!: number;
    items!: SponsorshipApplicationSearchDto[] | undefined;

    constructor(data?: IGetSponsorshipApplicationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SponsorshipApplicationSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSponsorshipApplicationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSponsorshipApplicationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSponsorshipApplicationsOutput {
    totalCount: number;
    items: SponsorshipApplicationSearchDto[] | undefined;
}

export class SponsorshipApplicationSearchDto implements ISponsorshipApplicationSearchDto {
    id!: number;
    responsibleId!: number | undefined;
    responsibleFullName!: string | undefined;
    iAmResponsible!: boolean;
    caseId!: string | undefined;
    caseIdSearchable!: string | undefined;
    corporateLicenceType!: CorporateLicenceType;
    userFullName!: string | undefined;
    userEmail!: string | undefined;
    sponsorshipName!: string | undefined;
    businessName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    type!: number;
    status!: ApplicationStatus;
    dateOfStatusChange!: DateTime;
    submittedCount!: number;
    submittedDate!: DateTime | undefined;
    lastSubmittedDate!: DateTime | undefined;
    isRenewal!: boolean | undefined;

    constructor(data?: ISponsorshipApplicationSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.responsibleId = _data["responsibleId"];
            this.responsibleFullName = _data["responsibleFullName"];
            this.iAmResponsible = _data["iAmResponsible"];
            this.caseId = _data["caseId"];
            this.caseIdSearchable = _data["caseIdSearchable"];
            this.corporateLicenceType = _data["corporateLicenceType"];
            this.userFullName = _data["userFullName"];
            this.userEmail = _data["userEmail"];
            this.sponsorshipName = _data["sponsorshipName"];
            this.businessName = _data["businessName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.submittedCount = _data["submittedCount"];
            this.submittedDate = _data["submittedDate"] ? DateTime.fromISO(_data["submittedDate"].toString()) : <any>undefined;
            this.lastSubmittedDate = _data["lastSubmittedDate"] ? DateTime.fromISO(_data["lastSubmittedDate"].toString()) : <any>undefined;
            this.isRenewal = _data["isRenewal"];
        }
    }

    static fromJS(data: any): SponsorshipApplicationSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorshipApplicationSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["responsibleId"] = this.responsibleId;
        data["responsibleFullName"] = this.responsibleFullName;
        data["iAmResponsible"] = this.iAmResponsible;
        data["caseId"] = this.caseId;
        data["caseIdSearchable"] = this.caseIdSearchable;
        data["corporateLicenceType"] = this.corporateLicenceType;
        data["userFullName"] = this.userFullName;
        data["userEmail"] = this.userEmail;
        data["sponsorshipName"] = this.sponsorshipName;
        data["businessName"] = this.businessName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["type"] = this.type;
        data["status"] = this.status;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toString() : <any>undefined;
        data["submittedCount"] = this.submittedCount;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toString() : <any>undefined;
        data["lastSubmittedDate"] = this.lastSubmittedDate ? this.lastSubmittedDate.toString() : <any>undefined;
        data["isRenewal"] = this.isRenewal;
        return data;
    }
}

export interface ISponsorshipApplicationSearchDto {
    id: number;
    responsibleId: number | undefined;
    responsibleFullName: string | undefined;
    iAmResponsible: boolean;
    caseId: string | undefined;
    caseIdSearchable: string | undefined;
    corporateLicenceType: CorporateLicenceType;
    userFullName: string | undefined;
    userEmail: string | undefined;
    sponsorshipName: string | undefined;
    businessName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    sponsorshipTypeId: string | undefined;
    type: number;
    status: ApplicationStatus;
    dateOfStatusChange: DateTime;
    submittedCount: number;
    submittedDate: DateTime | undefined;
    lastSubmittedDate: DateTime | undefined;
    isRenewal: boolean | undefined;
}

export class SponsorshipApplicationSummaryDto implements ISponsorshipApplicationSummaryDto {
    applicationType!: ApplicationType;
    applicationStatus!: ApplicationStatus;
    dateOfStatusChange!: DateTime;
    caseId!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    name!: string | undefined;
    uid!: string | undefined;

    constructor(data?: ISponsorshipApplicationSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationType = _data["applicationType"];
            this.applicationStatus = _data["applicationStatus"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.caseId = _data["caseId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.name = _data["name"];
            this.uid = _data["uid"];
        }
    }

    static fromJS(data: any): SponsorshipApplicationSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorshipApplicationSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationType"] = this.applicationType;
        data["applicationStatus"] = this.applicationStatus;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toString() : <any>undefined;
        data["caseId"] = this.caseId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["name"] = this.name;
        data["uid"] = this.uid;
        return data;
    }
}

export interface ISponsorshipApplicationSummaryDto {
    applicationType: ApplicationType;
    applicationStatus: ApplicationStatus;
    dateOfStatusChange: DateTime;
    caseId: string | undefined;
    sponsorshipTypeId: string | undefined;
    name: string | undefined;
    uid: string | undefined;
}

export class GetSqlQueryDto implements IGetSqlQueryDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    categoryId!: string | undefined;
    query!: string | undefined;
    parameters!: SqlQueryParameterDto[] | undefined;

    constructor(data?: IGetSqlQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.categoryId = _data["categoryId"];
            this.query = _data["query"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(SqlQueryParameterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSqlQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSqlQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["categoryId"] = this.categoryId;
        data["query"] = this.query;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSqlQueryDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    categoryId: string | undefined;
    query: string | undefined;
    parameters: SqlQueryParameterDto[] | undefined;
}

export class GetSqlQuerySearchInput implements IGetSqlQuerySearchInput {
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IGetSqlQuerySearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetSqlQuerySearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSqlQuerySearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IGetSqlQuerySearchInput {
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class GetSqlQuerySearchOutput implements IGetSqlQuerySearchOutput {
    totalCount!: number;
    items!: SqlQuerySearchResultDto[] | undefined;

    constructor(data?: IGetSqlQuerySearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SqlQuerySearchResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSqlQuerySearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSqlQuerySearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSqlQuerySearchOutput {
    totalCount: number;
    items: SqlQuerySearchResultDto[] | undefined;
}

export class RunSqlQueryResultDto implements IRunSqlQueryResultDto {
    columns!: SqlColumnMetaDto[] | undefined;
    rows!: { [key: string]: any; }[] | undefined;

    constructor(data?: IRunSqlQueryResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(SqlColumnMetaDto.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
        }
    }

    static fromJS(data: any): RunSqlQueryResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RunSqlQueryResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        return data;
    }
}

export interface IRunSqlQueryResultDto {
    columns: SqlColumnMetaDto[] | undefined;
    rows: { [key: string]: any; }[] | undefined;
}

export class SqlColumnMetaDto implements ISqlColumnMetaDto {
    name!: string | undefined;
    ordinal!: number;
    size!: number;
    dataType!: string | undefined;
    dbDataType!: string | undefined;
    isCode!: boolean;

    constructor(data?: ISqlColumnMetaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.ordinal = _data["ordinal"];
            this.size = _data["size"];
            this.dataType = _data["dataType"];
            this.dbDataType = _data["dbDataType"];
            this.isCode = _data["isCode"];
        }
    }

    static fromJS(data: any): SqlColumnMetaDto {
        data = typeof data === 'object' ? data : {};
        let result = new SqlColumnMetaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ordinal"] = this.ordinal;
        data["size"] = this.size;
        data["dataType"] = this.dataType;
        data["dbDataType"] = this.dbDataType;
        data["isCode"] = this.isCode;
        return data;
    }
}

export interface ISqlColumnMetaDto {
    name: string | undefined;
    ordinal: number;
    size: number;
    dataType: string | undefined;
    dbDataType: string | undefined;
    isCode: boolean;
}

export class SqlQueryAnalyseResultDto implements ISqlQueryAnalyseResultDto {
    validSqlStatement!: boolean;
    errors!: string[] | undefined;
    onlySelectStatements!: boolean | undefined;
    parameters!: string[] | undefined;

    constructor(data?: ISqlQueryAnalyseResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validSqlStatement = _data["validSqlStatement"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.onlySelectStatements = _data["onlySelectStatements"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(item);
            }
        }
    }

    static fromJS(data: any): SqlQueryAnalyseResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SqlQueryAnalyseResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validSqlStatement"] = this.validSqlStatement;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["onlySelectStatements"] = this.onlySelectStatements;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item);
        }
        return data;
    }
}

export interface ISqlQueryAnalyseResultDto {
    validSqlStatement: boolean;
    errors: string[] | undefined;
    onlySelectStatements: boolean | undefined;
    parameters: string[] | undefined;
}

export class SqlQueryDto implements ISqlQueryDto {
    name!: string;
    description!: string | undefined;
    categoryId!: string;
    query!: string;
    cron!: string | undefined;
    outputPath!: string | undefined;
    roles!: number[] | undefined;
    parameters!: SqlQueryParameterDto[] | undefined;

    constructor(data?: ISqlQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.categoryId = _data["categoryId"];
            this.query = _data["query"];
            this.cron = _data["cron"];
            this.outputPath = _data["outputPath"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(SqlQueryParameterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SqlQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SqlQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["categoryId"] = this.categoryId;
        data["query"] = this.query;
        data["cron"] = this.cron;
        data["outputPath"] = this.outputPath;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISqlQueryDto {
    name: string;
    description: string | undefined;
    categoryId: string;
    query: string;
    cron: string | undefined;
    outputPath: string | undefined;
    roles: number[] | undefined;
    parameters: SqlQueryParameterDto[] | undefined;
}

export class SqlQueryEnumDto implements ISqlQueryEnumDto {
    fullName!: string | undefined;
    displayName!: string | undefined;
    valueNameMapping!: { [key: string]: string; } | undefined;

    constructor(data?: ISqlQueryEnumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.displayName = _data["displayName"];
            if (_data["valueNameMapping"]) {
                this.valueNameMapping = {} as any;
                for (let key in _data["valueNameMapping"]) {
                    if (_data["valueNameMapping"].hasOwnProperty(key))
                        (<any>this.valueNameMapping)![key] = _data["valueNameMapping"][key];
                }
            }
        }
    }

    static fromJS(data: any): SqlQueryEnumDto {
        data = typeof data === 'object' ? data : {};
        let result = new SqlQueryEnumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["displayName"] = this.displayName;
        if (this.valueNameMapping) {
            data["valueNameMapping"] = {};
            for (let key in this.valueNameMapping) {
                if (this.valueNameMapping.hasOwnProperty(key))
                    (<any>data["valueNameMapping"])[key] = (<any>this.valueNameMapping)[key];
            }
        }
        return data;
    }
}

export interface ISqlQueryEnumDto {
    fullName: string | undefined;
    displayName: string | undefined;
    valueNameMapping: { [key: string]: string; } | undefined;
}

export class SqlQueryParameterDto implements ISqlQueryParameterDto {
    name!: string;
    displayName!: string;
    type!: SqlParameterType;
    codeCategoryId!: CodeCategory;
    enumFullName!: string | undefined;
    isRequired!: boolean;
    isMultiselect!: boolean;
    defaultValue!: string | undefined;

    constructor(data?: ISqlQueryParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.type = _data["type"];
            this.codeCategoryId = _data["codeCategoryId"];
            this.enumFullName = _data["enumFullName"];
            this.isRequired = _data["isRequired"];
            this.isMultiselect = _data["isMultiselect"];
            this.defaultValue = _data["defaultValue"];
        }
    }

    static fromJS(data: any): SqlQueryParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new SqlQueryParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        data["codeCategoryId"] = this.codeCategoryId;
        data["enumFullName"] = this.enumFullName;
        data["isRequired"] = this.isRequired;
        data["isMultiselect"] = this.isMultiselect;
        data["defaultValue"] = this.defaultValue;
        return data;
    }
}

export interface ISqlQueryParameterDto {
    name: string;
    displayName: string;
    type: SqlParameterType;
    codeCategoryId: CodeCategory;
    enumFullName: string | undefined;
    isRequired: boolean;
    isMultiselect: boolean;
    defaultValue: string | undefined;
}

export class SqlQuerySearchResultDto implements ISqlQuerySearchResultDto {
    name!: string | undefined;
    description!: string | undefined;
    categoryId!: string | undefined;
    query!: string | undefined;
    cron!: string | undefined;
    outputPath!: string | undefined;
    id!: number;

    constructor(data?: ISqlQuerySearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.categoryId = _data["categoryId"];
            this.query = _data["query"];
            this.cron = _data["cron"];
            this.outputPath = _data["outputPath"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SqlQuerySearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SqlQuerySearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["categoryId"] = this.categoryId;
        data["query"] = this.query;
        data["cron"] = this.cron;
        data["outputPath"] = this.outputPath;
        data["id"] = this.id;
        return data;
    }
}

export interface ISqlQuerySearchResultDto {
    name: string | undefined;
    description: string | undefined;
    categoryId: string | undefined;
    query: string | undefined;
    cron: string | undefined;
    outputPath: string | undefined;
    id: number;
}

export class BinaryObject implements IBinaryObject {
    tenantId!: number | undefined;
    description!: string | undefined;
    bytes!: string;
    fileExtension!: string | undefined;
    id!: string;

    constructor(data?: IBinaryObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.description = _data["description"];
            this.bytes = _data["bytes"];
            this.fileExtension = _data["fileExtension"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BinaryObject {
        data = typeof data === 'object' ? data : {};
        let result = new BinaryObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["description"] = this.description;
        data["bytes"] = this.bytes;
        data["fileExtension"] = this.fileExtension;
        data["id"] = this.id;
        return data;
    }
}

export interface IBinaryObject {
    tenantId: number | undefined;
    description: string | undefined;
    bytes: string;
    fileExtension: string | undefined;
    id: string;
}

export class DocumentDto implements IDocumentDto {
    typeId!: string | undefined;
    name!: string | undefined;
    mimeHeader!: string | undefined;
    file!: string | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.name = _data["name"];
            this.mimeHeader = _data["mimeHeader"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["name"] = this.name;
        data["mimeHeader"] = this.mimeHeader;
        data["file"] = this.file;
        return data;
    }
}

export interface IDocumentDto {
    typeId: string | undefined;
    name: string | undefined;
    mimeHeader: string | undefined;
    file: string | undefined;
}

export class UiCustomizationSettingsDto implements IUiCustomizationSettingsDto {
    baseSettings!: ThemeSettingsDto;
    isLeftMenuUsed!: boolean;
    isTopMenuUsed!: boolean;
    isTabMenuUsed!: boolean;
    allowMenuScroll!: boolean;

    constructor(data?: IUiCustomizationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseSettings = _data["baseSettings"] ? ThemeSettingsDto.fromJS(_data["baseSettings"]) : <any>undefined;
            this.isLeftMenuUsed = _data["isLeftMenuUsed"];
            this.isTopMenuUsed = _data["isTopMenuUsed"];
            this.isTabMenuUsed = _data["isTabMenuUsed"];
            this.allowMenuScroll = _data["allowMenuScroll"];
        }
    }

    static fromJS(data: any): UiCustomizationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSettings"] = this.baseSettings ? this.baseSettings.toJSON() : <any>undefined;
        data["isLeftMenuUsed"] = this.isLeftMenuUsed;
        data["isTopMenuUsed"] = this.isTopMenuUsed;
        data["isTabMenuUsed"] = this.isTabMenuUsed;
        data["allowMenuScroll"] = this.allowMenuScroll;
        return data;
    }
}

export interface IUiCustomizationSettingsDto {
    baseSettings: ThemeSettingsDto;
    isLeftMenuUsed: boolean;
    isTopMenuUsed: boolean;
    isTabMenuUsed: boolean;
    allowMenuScroll: boolean;
}

export enum EnumUidStatus {
    Provisorisch = 0,
    InReaktivierung = 1,
    Definitiv = 2,
    InMutation = 3,
    Geloescht = 4,
    DefinitivGeloescht = 5,
    Annulliert = 6,
}

export class UidEntityDto implements IUidEntityDto {
    uid!: string | undefined;
    organisationName!: string | undefined;
    additionalName!: string | undefined;
    legalFormId!: string | undefined;
    street!: string | undefined;
    houseNumber!: string | undefined;
    zipCode!: string | undefined;
    town!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    cantonId!: string | undefined;
    countryId!: string | undefined;
    status!: EnumUidStatus;
    rating!: number;

    constructor(data?: IUidEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.organisationName = _data["organisationName"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.zipCode = _data["zipCode"];
            this.town = _data["town"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.cantonId = _data["cantonId"];
            this.countryId = _data["countryId"];
            this.status = _data["status"];
            this.rating = _data["rating"];
        }
    }

    static fromJS(data: any): UidEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new UidEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["organisationName"] = this.organisationName;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["zipCode"] = this.zipCode;
        data["town"] = this.town;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["cantonId"] = this.cantonId;
        data["countryId"] = this.countryId;
        data["status"] = this.status;
        data["rating"] = this.rating;
        return data;
    }
}

export interface IUidEntityDto {
    uid: string | undefined;
    organisationName: string | undefined;
    additionalName: string | undefined;
    legalFormId: string | undefined;
    street: string | undefined;
    houseNumber: string | undefined;
    zipCode: string | undefined;
    town: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    cantonId: string | undefined;
    countryId: string | undefined;
    status: EnumUidStatus;
    rating: number;
}

export class GetVisibilityOutput implements IGetVisibilityOutput {
    items!: StatusVisibility[] | undefined;
    currentStatus!: number;

    constructor(data?: IGetVisibilityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StatusVisibility.fromJS(item));
            }
            this.currentStatus = _data["currentStatus"];
        }
    }

    static fromJS(data: any): GetVisibilityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetVisibilityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["currentStatus"] = this.currentStatus;
        return data;
    }
}

export interface IGetVisibilityOutput {
    items: StatusVisibility[] | undefined;
    currentStatus: number;
}

export enum TabVisibility {
    Hidden = 0,
    NonNavigable = 1,
    Read = 2,
    Write = 3,
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    twoFactorVerificationCode!: string | undefined;
    rememberClient!: boolean;
    twoFactorRememberClientToken!: string | undefined;
    singleSignIn!: boolean | undefined;
    returnUrl!: string | undefined;
    captchaResponse!: string | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.twoFactorVerificationCode = _data["twoFactorVerificationCode"];
            this.rememberClient = _data["rememberClient"];
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.singleSignIn = _data["singleSignIn"];
            this.returnUrl = _data["returnUrl"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string | undefined;
    rememberClient: boolean;
    twoFactorRememberClientToken: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;
    captchaResponse: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    shouldResetPassword!: boolean;
    passwordResetCode!: string | undefined;
    userId!: number;
    requiresTwoFactorVerification!: boolean;
    twoFactorAuthProviders!: string[] | undefined;
    twoFactorRememberClientToken!: string | undefined;
    returnUrl!: string | undefined;
    c!: string | undefined;
    waitingForActivation!: boolean;
    resetGoogleAuthenticatorTwoFactor!: boolean;
    email!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shouldResetPassword = _data["shouldResetPassword"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.userId = _data["userId"];
            this.requiresTwoFactorVerification = _data["requiresTwoFactorVerification"];
            if (Array.isArray(_data["twoFactorAuthProviders"])) {
                this.twoFactorAuthProviders = [] as any;
                for (let item of _data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders!.push(item);
            }
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.returnUrl = _data["returnUrl"];
            this.c = _data["c"];
            this.waitingForActivation = _data["waitingForActivation"];
            this.resetGoogleAuthenticatorTwoFactor = _data["resetGoogleAuthenticatorTwoFactor"];
            this.email = _data["email"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (Array.isArray(this.twoFactorAuthProviders)) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["c"] = this.c;
        data["waitingForActivation"] = this.waitingForActivation;
        data["resetGoogleAuthenticatorTwoFactor"] = this.resetGoogleAuthenticatorTwoFactor;
        data["email"] = this.email;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IAuthenticateResultModel {
    shouldResetPassword: boolean;
    passwordResetCode: string | undefined;
    userId: number;
    requiresTwoFactorVerification: boolean;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;
    c: string | undefined;
    waitingForActivation: boolean;
    resetGoogleAuthenticatorTwoFactor: boolean;
    email: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;
    returnUrl!: string | undefined;
    singleSignIn!: boolean | undefined;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl: string | undefined;
    singleSignIn: boolean | undefined;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    waitingForActivation!: boolean;
    returnUrl!: string | undefined;
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.waitingForActivation = _data["waitingForActivation"];
            this.returnUrl = _data["returnUrl"];
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        return data;
    }
}

export interface IExternalAuthenticateResultModel {
    waitingForActivation: boolean;
    returnUrl: string | undefined;
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;
    additionalParams!: { [key: string]: string; } | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            if (_data["additionalParams"]) {
                this.additionalParams = {} as any;
                for (let key in _data["additionalParams"]) {
                    if (_data["additionalParams"].hasOwnProperty(key))
                        (<any>this.additionalParams)![key] = _data["additionalParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        if (this.additionalParams) {
            data["additionalParams"] = {};
            for (let key in this.additionalParams) {
                if (this.additionalParams.hasOwnProperty(key))
                    (<any>data["additionalParams"])[key] = (<any>this.additionalParams)[key];
            }
        }
        return data;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
    additionalParams: { [key: string]: string; } | undefined;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
    userId!: number;
    provider!: string;

    constructor(data?: ISendTwoFactorAuthCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): SendTwoFactorAuthCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data;
    }
}

export interface ISendTwoFactorAuthCodeModel {
    userId: number;
    provider: string;
}

export class ValueTupleOfStringStringString implements IValueTupleOfStringStringString {
    item1!: string | undefined;
    item2!: string | undefined;
    item3!: string | undefined;

    constructor(data?: IValueTupleOfStringStringString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item1 = _data["item1"];
            this.item2 = _data["item2"];
            this.item3 = _data["item3"];
        }
    }

    static fromJS(data: any): ValueTupleOfStringStringString {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfStringStringString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        data["item2"] = this.item2;
        data["item3"] = this.item3;
        return data;
    }
}

export interface IValueTupleOfStringStringString {
    item1: string | undefined;
    item2: string | undefined;
    item3: string | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
